
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecb1e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecb1e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $72b03fdf46effee2$export$8cdaa4703948c5e9, (v) => $72b03fdf46effee2$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $72b03fdf46effee2$export$87c99536b1b8cdd8, (v) => $72b03fdf46effee2$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$8cdaa4703948c5e9;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$87c99536b1b8cdd8;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$startTransition(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
}
function $72b03fdf46effee2$var$addTransitionType(type) {
    var transition = $72b03fdf46effee2$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $72b03fdf46effee2$var$startTransition($72b03fdf46effee2$var$addTransitionType.bind(null, type));
}
var $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$8cdaa4703948c5e9 = $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$87c99536b1b8cdd8 = $72b03fdf46effee2$var$addTransitionType;
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = $72b03fdf46effee2$var$startTransition;
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $dca0ddb82b882518$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(559));
    }
}
var $dca0ddb82b882518$var$searchTarget = null, $dca0ddb82b882518$var$searchBoundary = null;
function $dca0ddb82b882518$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($dca0ddb82b882518$var$searchTarget = child, !0) : !1;
}
function $dca0ddb82b882518$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($dca0ddb82b882518$var$searchBoundary = child, !1) : child === target ? (null !== $dca0ddb82b882518$var$searchBoundary && ($dca0ddb82b882518$var$searchTarget = child), !0) : !1;
}
function $dca0ddb82b882518$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($dca0ddb82b882518$var$HostTransitionContext._currentValue = stateHook.memoizedState, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber));
    stateHook = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalLoadPendingKey = "__reactLoad$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
function $dca0ddb82b882518$var$clearPendingLoadOnNode(node) {
    node[$dca0ddb82b882518$var$internalLoadPendingKey] = void 0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
function $dca0ddb82b882518$var$pushMutationContext() {
    var prev = $dca0ddb82b882518$var$viewTransitionMutationContext;
    $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
    return prev;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(element.value)) : $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName), $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$SubmitEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    submitter: 0
}), $dca0ddb82b882518$var$SyntheticSubmitEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$SubmitEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_474) {
            var $dca0ddb82b882518$var$element$jscomp$inline_475 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_475.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = $dca0ddb82b882518$var$isSupported$jscomp$inline_474;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$globalClientIdCounter$1 = 0;
function $dca0ddb82b882518$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $dca0ddb82b882518$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $dca0ddb82b882518$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $dca0ddb82b882518$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $dca0ddb82b882518$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $dca0ddb82b882518$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $dca0ddb82b882518$var$getClassNameByType(defaultClass);
    eventClass = $dca0ddb82b882518$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $dca0ddb82b882518$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE:
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $dca0ddb82b882518$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $dca0ddb82b882518$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $dca0ddb82b882518$var$entangledTransitionTypes = null;
function $dca0ddb82b882518$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && ($dca0ddb82b882518$var$entangledTransitionTypes = null, null !== $dca0ddb82b882518$var$currentEntangledListeners)) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    if (null !== $dca0ddb82b882518$var$entangledTransitionTypes) for(var root$28 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$28;)$dca0ddb82b882518$var$queueTransitionTypes(root$28, $dca0ddb82b882518$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$29;)$dca0ddb82b882518$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $dca0ddb82b882518$var$currentEntangledLane) {
            root$29 = $dca0ddb82b882518$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $dca0ddb82b882518$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $dca0ddb82b882518$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushSuspenseListContext(fiber, newContext) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newContext);
}
function $dca0ddb82b882518$var$popSuspenseListContext(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
}
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && 0 !== ($dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1);
    $dca0ddb82b882518$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$70);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 106) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$73 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$73, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffectEvent: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack());
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            if (null === $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) {
                nextProps = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
                $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $dca0ddb82b882518$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $dca0ddb82b882518$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER;
        return $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
    }
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($dca0ddb82b882518$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $dca0ddb82b882518$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($dca0ddb82b882518$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $dca0ddb82b882518$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
        $dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(suspenseInstance.nextSibling);
    $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
    $dca0ddb82b882518$var$isHydrating = !0;
    $dca0ddb82b882518$var$hydrationErrors = null;
    $dca0ddb82b882518$var$rootOrSingletonContext = !1;
    null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $dca0ddb82b882518$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($dca0ddb82b882518$var$reverseChildren(current), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $dca0ddb82b882518$var$reverseChildren(current)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $dca0ddb82b882518$var$reverseChildren(workInProgress));
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $dca0ddb82b882518$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (workInProgress.stateNode = $dca0ddb82b882518$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $dca0ddb82b882518$var$maySuspendCommit(type, newProps) : $dca0ddb82b882518$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $dca0ddb82b882518$var$now();
                current.sibling = null;
                nextResource = $dca0ddb82b882518$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, workInProgress), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, renderLanes), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = workInProgress));
                $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $dca0ddb82b882518$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $dca0ddb82b882518$var$FragmentInstance(current);
                        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $dca0ddb82b882518$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $dca0ddb82b882518$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1)), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$shouldStartViewTransition = !1, $dca0ddb82b882518$var$appearingViewTransitions = null;
function $dca0ddb82b882518$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $dca0ddb82b882518$var$shouldStartViewTransition = !0;
}
var $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
function $dca0ddb82b882518$var$pushViewTransitionCancelableScope() {
    var prevChildren = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
    $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
function $dca0ddb82b882518$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
    return $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $dca0ddb82b882518$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $dca0ddb82b882518$var$measureInstance(instance).view && (inViewport = !0);
            $dca0ddb82b882518$var$shouldStartViewTransition = !0;
            $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? name : name + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $dca0ddb82b882518$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
}
function $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $dca0ddb82b882518$var$appearingViewTransitions && 0 !== $dca0ddb82b882518$var$appearingViewTransitions.size) {
        var pairs = $dca0ddb82b882518$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $dca0ddb82b882518$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $dca0ddb82b882518$var$appearingViewTransitions ? $dca0ddb82b882518$var$appearingViewTransitions.get(name) : void 0, className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$appearingViewTransitions.delete(name), $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onExit) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$dca0ddb82b882518$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
}
function $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, changedParent.stateNode);
            props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $dca0ddb82b882518$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $dca0ddb82b882518$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
}
function $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $dca0ddb82b882518$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$dca0ddb82b882518$var$viewTransitionHostInstanceIdx], nextMeasurement = $dca0ddb82b882518$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $dca0ddb82b882518$var$viewTransitionCancelableChildren && ($dca0ddb82b882518$var$viewTransitionCancelableChildren = []), $dca0ddb82b882518$var$viewTransitionCancelableChildren.push(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($dca0ddb82b882518$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
            name = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$viewTransitionContextChanged = !1, $dca0ddb82b882518$var$inUpdateViewTransition = !1, $dca0ddb82b882518$var$rootViewTransitionAffected = !1, $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $dca0ddb82b882518$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $dca0ddb82b882518$var$nextEffect;){
        root = $dca0ddb82b882518$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $dca0ddb82b882518$var$nextEffect = JSCompiler_temp) : (committedLanes && $dca0ddb82b882518$var$commitNestedViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $dca0ddb82b882518$var$appearingViewTransitions = null;
}
function $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $dca0ddb82b882518$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $dca0ddb82b882518$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $dca0ddb82b882518$var$nextEffect = current;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = fiber.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                current = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = current;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$dca0ddb82b882518$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($dca0ddb82b882518$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $dca0ddb82b882518$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$dca0ddb82b882518$var$internalHoistableMarker] || current[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                            $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                    $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(root, ""), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            $dca0ddb82b882518$var$tagCaches = null;
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            current = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext && $dca0ddb82b882518$var$inUpdateViewTransition && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionMutationContext = current;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, lanes = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, current = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, $dca0ddb82b882518$var$offscreenSubtreeIsHidden = ii || $dca0ddb82b882518$var$offscreenSubtreeIsHidden, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = root, $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $dca0ddb82b882518$var$offscreenSubtreeIsHidden = lanes, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = current), !ii && $dca0ddb82b882518$var$offscreenDirectParentIsHidden || $dca0ddb82b882518$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $dca0ddb82b882518$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $dca0ddb82b882518$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $dca0ddb82b882518$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $dca0ddb82b882518$var$inUpdateViewTransition = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($dca0ddb82b882518$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $dca0ddb82b882518$var$_enabled = !0, fiber.reset(), $dca0ddb82b882518$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $dca0ddb82b882518$var$measureNestedViewTransitions(parentFiber, !1);
}
function $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $dca0ddb82b882518$var$rootViewTransitionNameCanceled = $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$dca0ddb82b882518$var$viewTransitionContextChanged && !$dca0ddb82b882518$var$rootViewTransitionAffected) {
                finishedWork = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $dca0ddb82b882518$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !0;
            }
            $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1) : $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            oldName = $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $dca0ddb82b882518$var$getViewTransitionName(props, state);
            state = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, state);
            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0, root = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $dca0ddb82b882518$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($dca0ddb82b882518$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $dca0ddb82b882518$var$viewTransitionCancelableChildren), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName);
            $dca0ddb82b882518$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable($dca0ddb82b882518$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $dca0ddb82b882518$var$restoreNestedViewTransitions(parentFiber);
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $dca0ddb82b882518$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $dca0ddb82b882518$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(flags.child, !0), $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $dca0ddb82b882518$var$appearingViewTransitions && ($dca0ddb82b882518$var$appearingViewTransitions = new Map());
                $dca0ddb82b882518$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$pendingViewTransition = null, $dca0ddb82b882518$var$pendingViewTransitionEvents = null, $dca0ddb82b882518$var$pendingTransitionTypes = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $dca0ddb82b882518$var$createViewTransitionInstance($dca0ddb82b882518$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $dca0ddb82b882518$var$pendingViewTransitionEvents && ($dca0ddb82b882518$var$pendingViewTransitionEvents = []);
        $dca0ddb82b882518$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$completeRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        }, $dca0ddb82b882518$var$appearingViewTransitions = null, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $dca0ddb82b882518$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0, subtreeFlags = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($dca0ddb82b882518$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $dca0ddb82b882518$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$getEntangledLanes(root, lanes);
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $dca0ddb82b882518$var$hydrationParentFiber && ($dca0ddb82b882518$var$isHydrating ? ($dca0ddb82b882518$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($dca0ddb82b882518$var$nextHydratableInstance = fiber.stateNode)) : ($dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0));
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $dca0ddb82b882518$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($dca0ddb82b882518$var$pendingTransitionTypes = $dca0ddb82b882518$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($dca0ddb82b882518$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $dca0ddb82b882518$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $dca0ddb82b882518$var$ReactSharedInternals.T;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        updatedLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        try {
            $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $dca0ddb82b882518$var$executionContext = suspendedRetryLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = updatedLanes, $dca0ddb82b882518$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $dca0ddb82b882518$var$pendingEffectsStatus = 1;
    $dca0ddb82b882518$var$shouldStartViewTransition ? $dca0ddb82b882518$var$pendingViewTransition = $dca0ddb82b882518$var$startViewTransition(suspendedState, root.containerInfo, $dca0ddb82b882518$var$pendingTransitionTypes, $dca0ddb82b882518$var$flushMutationEffects, $dca0ddb82b882518$var$flushLayoutEffects, $dca0ddb82b882518$var$flushAfterMutationEffects, $dca0ddb82b882518$var$flushSpawnedWork, $dca0ddb82b882518$var$flushPassiveEffects, $dca0ddb82b882518$var$reportViewTransitionError, null, null) : ($dca0ddb82b882518$var$flushMutationEffects(), $dca0ddb82b882518$var$flushLayoutEffects(), $dca0ddb82b882518$var$flushSpawnedWork());
}
function $dca0ddb82b882518$var$reportViewTransitionError(error) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus) {
        var onRecoverableError = $dca0ddb82b882518$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $dca0ddb82b882518$var$flushAfterMutationEffects() {
    3 === $dca0ddb82b882518$var$pendingEffectsStatus && ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber($dca0ddb82b882518$var$pendingFinishedWork, $dca0ddb82b882518$var$pendingEffectsRoot), $dca0ddb82b882518$var$pendingEffectsStatus = 4);
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$inUpdateViewTransition = $dca0ddb82b882518$var$rootViewTransitionAffected = !1;
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $dca0ddb82b882518$var$selectionInformation;
                var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var committedViewTransition = $dca0ddb82b882518$var$pendingViewTransition;
        $dca0ddb82b882518$var$pendingViewTransition = null;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            passiveSubtreeMask = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $dca0ddb82b882518$var$pendingViewTransitionEvents;
        onRecoverableError = $dca0ddb82b882518$var$pendingTransitionTypes;
        $dca0ddb82b882518$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($dca0ddb82b882518$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null);
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    null !== $dca0ddb82b882518$var$pendingViewTransition && ($dca0ddb82b882518$var$pendingViewTransition.skipTransition(), $dca0ddb82b882518$var$pendingViewTransition = null);
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) ? $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$190, root$190 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL(actionProp);
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1667 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1667 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1667++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1668 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1667], $dca0ddb82b882518$var$domEventName$jscomp$inline_1669 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1668.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1669, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $dca0ddb82b882518$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $dca0ddb82b882518$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $dca0ddb82b882518$var$getParent) : null;
                        null !== reactName && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $dca0ddb82b882518$var$emptyProps = {};
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$dca0ddb82b882518$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$dca0ddb82b882518$var$internalPropsKey] = props;
    $dca0ddb82b882518$var$setInitialProperties(rootContainerInstance, type, props);
    $dca0ddb82b882518$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $dca0ddb82b882518$var$scheduleTimeout, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $dca0ddb82b882518$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $dca0ddb82b882518$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, instance);
}
function $dca0ddb82b882518$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $dca0ddb82b882518$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $dca0ddb82b882518$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $dca0ddb82b882518$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($dca0ddb82b882518$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $dca0ddb82b882518$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($dca0ddb82b882518$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $dca0ddb82b882518$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $dca0ddb82b882518$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $dca0ddb82b882518$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("old", name),
        new: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("new", name)
    };
}
function $dca0ddb82b882518$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $dca0ddb82b882518$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $dca0ddb82b882518$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $dca0ddb82b882518$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $dca0ddb82b882518$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $dca0ddb82b882518$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $dca0ddb82b882518$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $dca0ddb82b882518$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $dca0ddb82b882518$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $dca0ddb82b882518$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $dca0ddb82b882518$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber);
    return $dca0ddb82b882518$var$setFocusIfFocusable(fiber, focusOptions);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$dca0ddb82b882518$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $dca0ddb82b882518$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $dca0ddb82b882518$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$observeChild, observer, void 0, void 0);
};
function $dca0ddb82b882518$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $dca0ddb82b882518$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $dca0ddb82b882518$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $dca0ddb82b882518$var$pendingIntersectionUnobserves = [], $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
function $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $dca0ddb82b882518$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $dca0ddb82b882518$var$intersectionUnobserveScheduled || ($dca0ddb82b882518$var$intersectionUnobserveScheduled = !0, $dca0ddb82b882518$var$requestPostPaintCallback(function() {
        $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
        var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves;
        $dca0ddb82b882518$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $dca0ddb82b882518$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $dca0ddb82b882518$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[0]);
    result = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $dca0ddb82b882518$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchBoundary = $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $dca0ddb82b882518$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(566));
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
            $dca0ddb82b882518$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), $dca0ddb82b882518$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $dca0ddb82b882518$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $dca0ddb82b882518$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    $dca0ddb82b882518$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $dca0ddb82b882518$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $dca0ddb82b882518$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $dca0ddb82b882518$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $dca0ddb82b882518$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $dca0ddb82b882518$var$requestPostPaintCallback(callback) {
    $dca0ddb82b882518$var$localRequestAnimationFrame(function() {
        $dca0ddb82b882518$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $dca0ddb82b882518$var$setProp(instance, type, propKey, null, $dca0ddb82b882518$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $dca0ddb82b882518$var$noop$1 && (instance.onclick = null);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
function $dca0ddb82b882518$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!($dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $dca0ddb82b882518$var$clearPendingLoadOnNode(instance);
            });
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$268 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $dca0ddb82b882518$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, styles$268)), $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$dca0ddb82b882518$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $dca0ddb82b882518$var$clearPendingLoadOnNode.bind(null, key), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $dca0ddb82b882518$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$274)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $dca0ddb82b882518$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $dca0ddb82b882518$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $dca0ddb82b882518$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
function $dca0ddb82b882518$var$onUnsuspendImg() {
    this.imgCount--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $acw62.version;
if ("19.3.1" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2587.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2587.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2587.inject($dca0ddb82b882518$var$internals$jscomp$inline_2586), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $4433d39f12c5883f$export$3f2684e5d7cb1006, (v) => $4433d39f12c5883f$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$3f2684e5d7cb1006;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY ? $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.3.1";

});



parcelRegister("l0hT7", function(module, exports) {
/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.9
 * Copyright (C) 2020 Oliver Nightingale
 * @license MIT
 */ (function() {
    /**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */ var lunr = function(config) {
        var builder = new lunr.Builder;
        builder.pipeline.add(lunr.trimmer, lunr.stopWordFilter, lunr.stemmer);
        builder.searchPipeline.add(lunr.stemmer);
        config.call(builder, builder);
        return builder.build();
    };
    lunr.version = "2.3.9";
    /*!
 * lunr.utils
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */ lunr.utils = {};
    /**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */ lunr.utils.warn = function(global) {
        /* eslint-disable no-console */ return function(message) {
            if (global.console && console.warn) console.warn(message);
        };
    /* eslint-enable no-console */ }(this);
    /**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */ lunr.utils.asString = function(obj) {
        if (obj === void 0 || obj === null) return "";
        else return obj.toString();
    };
    /**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */ lunr.utils.clone = function(obj) {
        if (obj === null || obj === undefined) return obj;
        var clone = Object.create(null), keys = Object.keys(obj);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i], val = obj[key];
            if (Array.isArray(val)) {
                clone[key] = val.slice();
                continue;
            }
            if (typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean') {
                clone[key] = val;
                continue;
            }
            throw new TypeError("clone is not deep and does not support nested objects");
        }
        return clone;
    };
    lunr.FieldRef = function(docRef, fieldName, stringValue) {
        this.docRef = docRef;
        this.fieldName = fieldName;
        this._stringValue = stringValue;
    };
    lunr.FieldRef.joiner = "/";
    lunr.FieldRef.fromString = function(s) {
        var n = s.indexOf(lunr.FieldRef.joiner);
        if (n === -1) throw "malformed field ref string";
        var fieldRef = s.slice(0, n), docRef = s.slice(n + 1);
        return new lunr.FieldRef(docRef, fieldRef, s);
    };
    lunr.FieldRef.prototype.toString = function() {
        if (this._stringValue == undefined) this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef;
        return this._stringValue;
    };
    /*!
 * lunr.Set
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * A lunr set.
 *
 * @constructor
 */ lunr.Set = function(elements) {
        this.elements = Object.create(null);
        if (elements) {
            this.length = elements.length;
            for(var i = 0; i < this.length; i++)this.elements[elements[i]] = true;
        } else this.length = 0;
    };
    /**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */ lunr.Set.complete = {
        intersect: function(other) {
            return other;
        },
        union: function() {
            return this;
        },
        contains: function() {
            return true;
        }
    };
    /**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */ lunr.Set.empty = {
        intersect: function() {
            return this;
        },
        union: function(other) {
            return other;
        },
        contains: function() {
            return false;
        }
    };
    /**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */ lunr.Set.prototype.contains = function(object) {
        return !!this.elements[object];
    };
    /**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */ lunr.Set.prototype.intersect = function(other) {
        var a, b, elements, intersection = [];
        if (other === lunr.Set.complete) return this;
        if (other === lunr.Set.empty) return other;
        if (this.length < other.length) {
            a = this;
            b = other;
        } else {
            a = other;
            b = this;
        }
        elements = Object.keys(a.elements);
        for(var i = 0; i < elements.length; i++){
            var element = elements[i];
            if (element in b.elements) intersection.push(element);
        }
        return new lunr.Set(intersection);
    };
    /**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */ lunr.Set.prototype.union = function(other) {
        if (other === lunr.Set.complete) return lunr.Set.complete;
        if (other === lunr.Set.empty) return this;
        return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)));
    };
    /**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */ lunr.idf = function(posting, documentCount) {
        var documentsWithTerm = 0;
        for(var fieldName in posting){
            if (fieldName == '_index') continue; // Ignore the term index, its not a field
            documentsWithTerm += Object.keys(posting[fieldName]).length;
        }
        var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5);
        return Math.log(1 + Math.abs(x));
    };
    /**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */ lunr.Token = function(str, metadata) {
        this.str = str || "";
        this.metadata = metadata || {};
    };
    /**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */ lunr.Token.prototype.toString = function() {
        return this.str;
    };
    /**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */ /**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */ lunr.Token.prototype.update = function(fn) {
        this.str = fn(this.str, this.metadata);
        return this;
    };
    /**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */ lunr.Token.prototype.clone = function(fn) {
        fn = fn || function(s) {
            return s;
        };
        return new lunr.Token(fn(this.str, this.metadata), this.metadata);
    };
    /*!
 * lunr.tokenizer
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */ lunr.tokenizer = function(obj, metadata) {
        if (obj == null || obj == undefined) return [];
        if (Array.isArray(obj)) return obj.map(function(t) {
            return new lunr.Token(lunr.utils.asString(t).toLowerCase(), lunr.utils.clone(metadata));
        });
        var str = obj.toString().toLowerCase(), len = str.length, tokens = [];
        for(var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++){
            var char = str.charAt(sliceEnd), sliceLength = sliceEnd - sliceStart;
            if (char.match(lunr.tokenizer.separator) || sliceEnd == len) {
                if (sliceLength > 0) {
                    var tokenMetadata = lunr.utils.clone(metadata) || {};
                    tokenMetadata["position"] = [
                        sliceStart,
                        sliceLength
                    ];
                    tokenMetadata["index"] = tokens.length;
                    tokens.push(new lunr.Token(str.slice(sliceStart, sliceEnd), tokenMetadata));
                }
                sliceStart = sliceEnd + 1;
            }
        }
        return tokens;
    };
    /**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */ lunr.tokenizer.separator = /[\s\-]+/;
    /*!
 * lunr.Pipeline
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */ lunr.Pipeline = function() {
        this._stack = [];
    };
    lunr.Pipeline.registeredFunctions = Object.create(null);
    /**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */ /**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */ lunr.Pipeline.registerFunction = function(fn, label) {
        if (label in this.registeredFunctions) lunr.utils.warn('Overwriting existing registered function: ' + label);
        fn.label = label;
        lunr.Pipeline.registeredFunctions[fn.label] = fn;
    };
    /**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */ lunr.Pipeline.warnIfFunctionNotRegistered = function(fn) {
        var isRegistered = fn.label && fn.label in this.registeredFunctions;
        if (!isRegistered) lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn);
    };
    /**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */ lunr.Pipeline.load = function(serialised) {
        var pipeline = new lunr.Pipeline;
        serialised.forEach(function(fnName) {
            var fn = lunr.Pipeline.registeredFunctions[fnName];
            if (fn) pipeline.add(fn);
            else throw new Error('Cannot load unregistered function: ' + fnName);
        });
        return pipeline;
    };
    /**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */ lunr.Pipeline.prototype.add = function() {
        var fns = Array.prototype.slice.call(arguments);
        fns.forEach(function(fn) {
            lunr.Pipeline.warnIfFunctionNotRegistered(fn);
            this._stack.push(fn);
        }, this);
    };
    /**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */ lunr.Pipeline.prototype.after = function(existingFn, newFn) {
        lunr.Pipeline.warnIfFunctionNotRegistered(newFn);
        var pos = this._stack.indexOf(existingFn);
        if (pos == -1) throw new Error('Cannot find existingFn');
        pos = pos + 1;
        this._stack.splice(pos, 0, newFn);
    };
    /**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */ lunr.Pipeline.prototype.before = function(existingFn, newFn) {
        lunr.Pipeline.warnIfFunctionNotRegistered(newFn);
        var pos = this._stack.indexOf(existingFn);
        if (pos == -1) throw new Error('Cannot find existingFn');
        this._stack.splice(pos, 0, newFn);
    };
    /**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */ lunr.Pipeline.prototype.remove = function(fn) {
        var pos = this._stack.indexOf(fn);
        if (pos == -1) return;
        this._stack.splice(pos, 1);
    };
    /**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */ lunr.Pipeline.prototype.run = function(tokens) {
        var stackLength = this._stack.length;
        for(var i = 0; i < stackLength; i++){
            var fn = this._stack[i];
            var memo = [];
            for(var j = 0; j < tokens.length; j++){
                var result = fn(tokens[j], j, tokens);
                if (result === null || result === void 0 || result === '') continue;
                if (Array.isArray(result)) for(var k = 0; k < result.length; k++)memo.push(result[k]);
                else memo.push(result);
            }
            tokens = memo;
        }
        return tokens;
    };
    /**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */ lunr.Pipeline.prototype.runString = function(str, metadata) {
        var token = new lunr.Token(str, metadata);
        return this.run([
            token
        ]).map(function(t) {
            return t.toString();
        });
    };
    /**
 * Resets the pipeline by removing any existing processors.
 *
 */ lunr.Pipeline.prototype.reset = function() {
        this._stack = [];
    };
    /**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */ lunr.Pipeline.prototype.toJSON = function() {
        return this._stack.map(function(fn) {
            lunr.Pipeline.warnIfFunctionNotRegistered(fn);
            return fn.label;
        });
    };
    /*!
 * lunr.Vector
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */ lunr.Vector = function(elements) {
        this._magnitude = 0;
        this.elements = elements || [];
    };
    /**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */ lunr.Vector.prototype.positionForIndex = function(index) {
        // For an empty vector the tuple can be inserted at the beginning
        if (this.elements.length == 0) return 0;
        var start = 0, end = this.elements.length / 2, sliceLength = end - start, pivotPoint = Math.floor(sliceLength / 2), pivotIndex = this.elements[pivotPoint * 2];
        while(sliceLength > 1){
            if (pivotIndex < index) start = pivotPoint;
            if (pivotIndex > index) end = pivotPoint;
            if (pivotIndex == index) break;
            sliceLength = end - start;
            pivotPoint = start + Math.floor(sliceLength / 2);
            pivotIndex = this.elements[pivotPoint * 2];
        }
        if (pivotIndex == index) return pivotPoint * 2;
        if (pivotIndex > index) return pivotPoint * 2;
        if (pivotIndex < index) return (pivotPoint + 1) * 2;
    };
    /**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */ lunr.Vector.prototype.insert = function(insertIdx, val) {
        this.upsert(insertIdx, val, function() {
            throw "duplicate index";
        });
    };
    /**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */ lunr.Vector.prototype.upsert = function(insertIdx, val, fn) {
        this._magnitude = 0;
        var position = this.positionForIndex(insertIdx);
        if (this.elements[position] == insertIdx) this.elements[position + 1] = fn(this.elements[position + 1], val);
        else this.elements.splice(position, 0, insertIdx, val);
    };
    /**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */ lunr.Vector.prototype.magnitude = function() {
        if (this._magnitude) return this._magnitude;
        var sumOfSquares = 0, elementsLength = this.elements.length;
        for(var i = 1; i < elementsLength; i += 2){
            var val = this.elements[i];
            sumOfSquares += val * val;
        }
        return this._magnitude = Math.sqrt(sumOfSquares);
    };
    /**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */ lunr.Vector.prototype.dot = function(otherVector) {
        var dotProduct = 0, a = this.elements, b = otherVector.elements, aLen = a.length, bLen = b.length, aVal = 0, bVal = 0, i = 0, j = 0;
        while(i < aLen && j < bLen){
            aVal = a[i], bVal = b[j];
            if (aVal < bVal) i += 2;
            else if (aVal > bVal) j += 2;
            else if (aVal == bVal) {
                dotProduct += a[i + 1] * b[j + 1];
                i += 2;
                j += 2;
            }
        }
        return dotProduct;
    };
    /**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */ lunr.Vector.prototype.similarity = function(otherVector) {
        return this.dot(otherVector) / this.magnitude() || 0;
    };
    /**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */ lunr.Vector.prototype.toArray = function() {
        var output = new Array(this.elements.length / 2);
        for(var i = 1, j = 0; i < this.elements.length; i += 2, j++)output[j] = this.elements[i];
        return output;
    };
    /**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */ lunr.Vector.prototype.toJSON = function() {
        return this.elements;
    };
    /* eslint-disable */ /*!
 * lunr.stemmer
 * Copyright (C) 2020 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */ /**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */ lunr.stemmer = function() {
        var step2list = {
            "ational": "ate",
            "tional": "tion",
            "enci": "ence",
            "anci": "ance",
            "izer": "ize",
            "bli": "ble",
            "alli": "al",
            "entli": "ent",
            "eli": "e",
            "ousli": "ous",
            "ization": "ize",
            "ation": "ate",
            "ator": "ate",
            "alism": "al",
            "iveness": "ive",
            "fulness": "ful",
            "ousness": "ous",
            "aliti": "al",
            "iviti": "ive",
            "biliti": "ble",
            "logi": "log"
        }, step3list = {
            "icate": "ic",
            "ative": "",
            "alize": "al",
            "iciti": "ic",
            "ical": "ic",
            "ful": "",
            "ness": ""
        }, c = "[^aeiou]", v = "[aeiouy]", C = c + "[^aeiouy]*", V = v + "[aeiou]*", mgr0 = "^(" + C + ")?" + V + C, meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$", mgr1 = "^(" + C + ")?" + V + C + V + C, s_v = "^(" + C + ")?" + v; // vowel in stem
        var re_mgr0 = new RegExp(mgr0);
        var re_mgr1 = new RegExp(mgr1);
        var re_meq1 = new RegExp(meq1);
        var re_s_v = new RegExp(s_v);
        var re_1a = /^(.+?)(ss|i)es$/;
        var re2_1a = /^(.+?)([^s])s$/;
        var re_1b = /^(.+?)eed$/;
        var re2_1b = /^(.+?)(ed|ing)$/;
        var re_1b_2 = /.$/;
        var re2_1b_2 = /(at|bl|iz)$/;
        var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
        var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");
        var re_1c = /^(.+?[^aeiou])y$/;
        var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;
        var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;
        var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
        var re2_4 = /^(.+?)(s|t)(ion)$/;
        var re_5 = /^(.+?)e$/;
        var re_5_1 = /ll$/;
        var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");
        var porterStemmer = function porterStemmer(w) {
            var stem, suffix, firstch, re, re2, re3, re4;
            if (w.length < 3) return w;
            firstch = w.substr(0, 1);
            if (firstch == "y") w = firstch.toUpperCase() + w.substr(1);
            // Step 1a
            re = re_1a;
            re2 = re2_1a;
            if (re.test(w)) w = w.replace(re, "$1$2");
            else if (re2.test(w)) w = w.replace(re2, "$1$2");
            // Step 1b
            re = re_1b;
            re2 = re2_1b;
            if (re.test(w)) {
                var fp = re.exec(w);
                re = re_mgr0;
                if (re.test(fp[1])) {
                    re = re_1b_2;
                    w = w.replace(re, "");
                }
            } else if (re2.test(w)) {
                var fp = re2.exec(w);
                stem = fp[1];
                re2 = re_s_v;
                if (re2.test(stem)) {
                    w = stem;
                    re2 = re2_1b_2;
                    re3 = re3_1b_2;
                    re4 = re4_1b_2;
                    if (re2.test(w)) w = w + "e";
                    else if (re3.test(w)) {
                        re = re_1b_2;
                        w = w.replace(re, "");
                    } else if (re4.test(w)) w = w + "e";
                }
            }
            // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
            re = re_1c;
            if (re.test(w)) {
                var fp = re.exec(w);
                stem = fp[1];
                w = stem + "i";
            }
            // Step 2
            re = re_2;
            if (re.test(w)) {
                var fp = re.exec(w);
                stem = fp[1];
                suffix = fp[2];
                re = re_mgr0;
                if (re.test(stem)) w = stem + step2list[suffix];
            }
            // Step 3
            re = re_3;
            if (re.test(w)) {
                var fp = re.exec(w);
                stem = fp[1];
                suffix = fp[2];
                re = re_mgr0;
                if (re.test(stem)) w = stem + step3list[suffix];
            }
            // Step 4
            re = re_4;
            re2 = re2_4;
            if (re.test(w)) {
                var fp = re.exec(w);
                stem = fp[1];
                re = re_mgr1;
                if (re.test(stem)) w = stem;
            } else if (re2.test(w)) {
                var fp = re2.exec(w);
                stem = fp[1] + fp[2];
                re2 = re_mgr1;
                if (re2.test(stem)) w = stem;
            }
            // Step 5
            re = re_5;
            if (re.test(w)) {
                var fp = re.exec(w);
                stem = fp[1];
                re = re_mgr1;
                re2 = re_meq1;
                re3 = re3_5;
                if (re.test(stem) || re2.test(stem) && !re3.test(stem)) w = stem;
            }
            re = re_5_1;
            re2 = re_mgr1;
            if (re.test(w) && re2.test(w)) {
                re = re_1b_2;
                w = w.replace(re, "");
            }
            // and turn initial Y back to y
            if (firstch == "y") w = firstch.toLowerCase() + w.substr(1);
            return w;
        };
        return function(token) {
            return token.update(porterStemmer);
        };
    }();
    lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer');
    /*!
 * lunr.stopWordFilter
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */ lunr.generateStopWordFilter = function(stopWords) {
        var words = stopWords.reduce(function(memo, stopWord) {
            memo[stopWord] = stopWord;
            return memo;
        }, {});
        return function(token) {
            if (token && words[token.toString()] !== token.toString()) return token;
        };
    };
    /**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */ lunr.stopWordFilter = lunr.generateStopWordFilter([
        'a',
        'able',
        'about',
        'across',
        'after',
        'all',
        'almost',
        'also',
        'am',
        'among',
        'an',
        'and',
        'any',
        'are',
        'as',
        'at',
        'be',
        'because',
        'been',
        'but',
        'by',
        'can',
        'cannot',
        'could',
        'dear',
        'did',
        'do',
        'does',
        'either',
        'else',
        'ever',
        'every',
        'for',
        'from',
        'get',
        'got',
        'had',
        'has',
        'have',
        'he',
        'her',
        'hers',
        'him',
        'his',
        'how',
        'however',
        'i',
        'if',
        'in',
        'into',
        'is',
        'it',
        'its',
        'just',
        'least',
        'let',
        'like',
        'likely',
        'may',
        'me',
        'might',
        'most',
        'must',
        'my',
        'neither',
        'no',
        'nor',
        'not',
        'of',
        'off',
        'often',
        'on',
        'only',
        'or',
        'other',
        'our',
        'own',
        'rather',
        'said',
        'say',
        'says',
        'she',
        'should',
        'since',
        'so',
        'some',
        'than',
        'that',
        'the',
        'their',
        'them',
        'then',
        'there',
        'these',
        'they',
        'this',
        'tis',
        'to',
        'too',
        'twas',
        'us',
        'wants',
        'was',
        'we',
        'were',
        'what',
        'when',
        'where',
        'which',
        'while',
        'who',
        'whom',
        'why',
        'will',
        'with',
        'would',
        'yet',
        'you',
        'your'
    ]);
    lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter');
    /*!
 * lunr.trimmer
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */ lunr.trimmer = function(token) {
        return token.update(function(s) {
            return s.replace(/^\W+/, '').replace(/\W+$/, '');
        });
    };
    lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer');
    /*!
 * lunr.TokenSet
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */ lunr.TokenSet = function() {
        this.final = false;
        this.edges = {};
        this.id = lunr.TokenSet._nextId;
        lunr.TokenSet._nextId += 1;
    };
    /**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */ lunr.TokenSet._nextId = 1;
    /**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */ lunr.TokenSet.fromArray = function(arr) {
        var builder = new lunr.TokenSet.Builder;
        for(var i = 0, len = arr.length; i < len; i++)builder.insert(arr[i]);
        builder.finish();
        return builder.root;
    };
    /**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */ lunr.TokenSet.fromClause = function(clause) {
        if ('editDistance' in clause) return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance);
        else return lunr.TokenSet.fromString(clause.term);
    };
    /**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */ lunr.TokenSet.fromFuzzyString = function(str, editDistance) {
        var root = new lunr.TokenSet;
        var stack = [
            {
                node: root,
                editsRemaining: editDistance,
                str: str
            }
        ];
        while(stack.length){
            var frame = stack.pop();
            // no edit
            if (frame.str.length > 0) {
                var char = frame.str.charAt(0), noEditNode;
                if (char in frame.node.edges) noEditNode = frame.node.edges[char];
                else {
                    noEditNode = new lunr.TokenSet;
                    frame.node.edges[char] = noEditNode;
                }
                if (frame.str.length == 1) noEditNode.final = true;
                stack.push({
                    node: noEditNode,
                    editsRemaining: frame.editsRemaining,
                    str: frame.str.slice(1)
                });
            }
            if (frame.editsRemaining == 0) continue;
            // insertion
            if ("*" in frame.node.edges) var insertionNode = frame.node.edges["*"];
            else {
                var insertionNode = new lunr.TokenSet;
                frame.node.edges["*"] = insertionNode;
            }
            if (frame.str.length == 0) insertionNode.final = true;
            stack.push({
                node: insertionNode,
                editsRemaining: frame.editsRemaining - 1,
                str: frame.str
            });
            // deletion
            // can only do a deletion if we have enough edits remaining
            // and if there are characters left to delete in the string
            if (frame.str.length > 1) stack.push({
                node: frame.node,
                editsRemaining: frame.editsRemaining - 1,
                str: frame.str.slice(1)
            });
            // deletion
            // just removing the last character from the str
            if (frame.str.length == 1) frame.node.final = true;
            // substitution
            // can only do a substitution if we have enough edits remaining
            // and if there are characters left to substitute
            if (frame.str.length >= 1) {
                if ("*" in frame.node.edges) var substitutionNode = frame.node.edges["*"];
                else {
                    var substitutionNode = new lunr.TokenSet;
                    frame.node.edges["*"] = substitutionNode;
                }
                if (frame.str.length == 1) substitutionNode.final = true;
                stack.push({
                    node: substitutionNode,
                    editsRemaining: frame.editsRemaining - 1,
                    str: frame.str.slice(1)
                });
            }
            // transposition
            // can only do a transposition if there are edits remaining
            // and there are enough characters to transpose
            if (frame.str.length > 1) {
                var charA = frame.str.charAt(0), charB = frame.str.charAt(1), transposeNode;
                if (charB in frame.node.edges) transposeNode = frame.node.edges[charB];
                else {
                    transposeNode = new lunr.TokenSet;
                    frame.node.edges[charB] = transposeNode;
                }
                if (frame.str.length == 1) transposeNode.final = true;
                stack.push({
                    node: transposeNode,
                    editsRemaining: frame.editsRemaining - 1,
                    str: charA + frame.str.slice(2)
                });
            }
        }
        return root;
    };
    /**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */ lunr.TokenSet.fromString = function(str) {
        var node = new lunr.TokenSet, root = node;
        /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */ for(var i = 0, len = str.length; i < len; i++){
            var char = str[i], final = i == len - 1;
            if (char == "*") {
                node.edges[char] = node;
                node.final = final;
            } else {
                var next = new lunr.TokenSet;
                next.final = final;
                node.edges[char] = next;
                node = next;
            }
        }
        return root;
    };
    /**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */ lunr.TokenSet.prototype.toArray = function() {
        var words = [];
        var stack = [
            {
                prefix: "",
                node: this
            }
        ];
        while(stack.length){
            var frame = stack.pop(), edges = Object.keys(frame.node.edges), len = edges.length;
            if (frame.node.final) {
                /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */ frame.prefix.charAt(0);
                words.push(frame.prefix);
            }
            for(var i = 0; i < len; i++){
                var edge = edges[i];
                stack.push({
                    prefix: frame.prefix.concat(edge),
                    node: frame.node.edges[edge]
                });
            }
        }
        return words;
    };
    /**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */ lunr.TokenSet.prototype.toString = function() {
        // NOTE: Using Object.keys here as this.edges is very likely
        // to enter 'hash-mode' with many keys being added
        //
        // avoiding a for-in loop here as it leads to the function
        // being de-optimised (at least in V8). From some simple
        // benchmarks the performance is comparable, but allowing
        // V8 to optimize may mean easy performance wins in the future.
        if (this._str) return this._str;
        var str = this.final ? '1' : '0', labels = Object.keys(this.edges).sort(), len = labels.length;
        for(var i = 0; i < len; i++){
            var label = labels[i], node = this.edges[label];
            str = str + label + node.id;
        }
        return str;
    };
    /**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */ lunr.TokenSet.prototype.intersect = function(b) {
        var output = new lunr.TokenSet, frame = undefined;
        var stack = [
            {
                qNode: b,
                output: output,
                node: this
            }
        ];
        while(stack.length){
            frame = stack.pop();
            // NOTE: As with the #toString method, we are using
            // Object.keys and a for loop instead of a for-in loop
            // as both of these objects enter 'hash' mode, causing
            // the function to be de-optimised in V8
            var qEdges = Object.keys(frame.qNode.edges), qLen = qEdges.length, nEdges = Object.keys(frame.node.edges), nLen = nEdges.length;
            for(var q = 0; q < qLen; q++){
                var qEdge = qEdges[q];
                for(var n = 0; n < nLen; n++){
                    var nEdge = nEdges[n];
                    if (nEdge == qEdge || qEdge == '*') {
                        var node = frame.node.edges[nEdge], qNode = frame.qNode.edges[qEdge], final = node.final && qNode.final, next = undefined;
                        if (nEdge in frame.output.edges) {
                            // an edge already exists for this character
                            // no need to create a new node, just set the finality
                            // bit unless this node is already final
                            next = frame.output.edges[nEdge];
                            next.final = next.final || final;
                        } else {
                            // no edge exists yet, must create one
                            // set the finality bit and insert it
                            // into the output
                            next = new lunr.TokenSet;
                            next.final = final;
                            frame.output.edges[nEdge] = next;
                        }
                        stack.push({
                            qNode: qNode,
                            output: next,
                            node: node
                        });
                    }
                }
            }
        }
        return output;
    };
    lunr.TokenSet.Builder = function() {
        this.previousWord = "";
        this.root = new lunr.TokenSet;
        this.uncheckedNodes = [];
        this.minimizedNodes = {};
    };
    lunr.TokenSet.Builder.prototype.insert = function(word) {
        var node, commonPrefix = 0;
        if (word < this.previousWord) throw new Error("Out of order word insertion");
        for(var i = 0; i < word.length && i < this.previousWord.length; i++){
            if (word[i] != this.previousWord[i]) break;
            commonPrefix++;
        }
        this.minimize(commonPrefix);
        if (this.uncheckedNodes.length == 0) node = this.root;
        else node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child;
        for(var i = commonPrefix; i < word.length; i++){
            var nextNode = new lunr.TokenSet, char = word[i];
            node.edges[char] = nextNode;
            this.uncheckedNodes.push({
                parent: node,
                char: char,
                child: nextNode
            });
            node = nextNode;
        }
        node.final = true;
        this.previousWord = word;
    };
    lunr.TokenSet.Builder.prototype.finish = function() {
        this.minimize(0);
    };
    lunr.TokenSet.Builder.prototype.minimize = function(downTo) {
        for(var i = this.uncheckedNodes.length - 1; i >= downTo; i--){
            var node = this.uncheckedNodes[i], childKey = node.child.toString();
            if (childKey in this.minimizedNodes) node.parent.edges[node.char] = this.minimizedNodes[childKey];
            else {
                // Cache the key for this node since
                // we know it can't change anymore
                node.child._str = childKey;
                this.minimizedNodes[childKey] = node.child;
            }
            this.uncheckedNodes.pop();
        }
    };
    /*!
 * lunr.Index
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */ lunr.Index = function(attrs) {
        this.invertedIndex = attrs.invertedIndex;
        this.fieldVectors = attrs.fieldVectors;
        this.tokenSet = attrs.tokenSet;
        this.fields = attrs.fields;
        this.pipeline = attrs.pipeline;
    };
    /**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */ /**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */ /**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */ lunr.Index.prototype.search = function(queryString) {
        return this.query(function(query) {
            var parser = new lunr.QueryParser(queryString, query);
            parser.parse();
        });
    };
    /**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */ /**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */ lunr.Index.prototype.query = function(fn) {
        // for each query clause
        // * process terms
        // * expand terms from token set
        // * find matching documents and metadata
        // * get document vectors
        // * score documents
        var query = new lunr.Query(this.fields), matchingFields = Object.create(null), queryVectors = Object.create(null), termFieldCache = Object.create(null), requiredMatches = Object.create(null), prohibitedMatches = Object.create(null);
        /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */ for(var i = 0; i < this.fields.length; i++)queryVectors[this.fields[i]] = new lunr.Vector;
        fn.call(query, query);
        for(var i = 0; i < query.clauses.length; i++){
            /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */ var clause = query.clauses[i], terms = null, clauseMatches = lunr.Set.empty;
            if (clause.usePipeline) terms = this.pipeline.runString(clause.term, {
                fields: clause.fields
            });
            else terms = [
                clause.term
            ];
            for(var m = 0; m < terms.length; m++){
                var term = terms[m];
                /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */ clause.term = term;
                /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */ var termTokenSet = lunr.TokenSet.fromClause(clause), expandedTerms = this.tokenSet.intersect(termTokenSet).toArray();
                /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */ if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
                    for(var k = 0; k < clause.fields.length; k++){
                        var field = clause.fields[k];
                        requiredMatches[field] = lunr.Set.empty;
                    }
                    break;
                }
                for(var j = 0; j < expandedTerms.length; j++){
                    /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */ var expandedTerm = expandedTerms[j], posting = this.invertedIndex[expandedTerm], termIndex = posting._index;
                    for(var k = 0; k < clause.fields.length; k++){
                        /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */ var field = clause.fields[k], fieldPosting = posting[field], matchingDocumentRefs = Object.keys(fieldPosting), termField = expandedTerm + "/" + field, matchingDocumentsSet = new lunr.Set(matchingDocumentRefs);
                        /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */ if (clause.presence == lunr.Query.presence.REQUIRED) {
                            clauseMatches = clauseMatches.union(matchingDocumentsSet);
                            if (requiredMatches[field] === undefined) requiredMatches[field] = lunr.Set.complete;
                        }
                        /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */ if (clause.presence == lunr.Query.presence.PROHIBITED) {
                            if (prohibitedMatches[field] === undefined) prohibitedMatches[field] = lunr.Set.empty;
                            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet);
                            continue;
                        }
                        /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */ queryVectors[field].upsert(termIndex, clause.boost, function(a, b) {
                            return a + b;
                        });
                        /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */ if (termFieldCache[termField]) continue;
                        for(var l = 0; l < matchingDocumentRefs.length; l++){
                            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */ var matchingDocumentRef = matchingDocumentRefs[l], matchingFieldRef = new lunr.FieldRef(matchingDocumentRef, field), metadata = fieldPosting[matchingDocumentRef], fieldMatch;
                            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) matchingFields[matchingFieldRef] = new lunr.MatchData(expandedTerm, field, metadata);
                            else fieldMatch.add(expandedTerm, field, metadata);
                        }
                        termFieldCache[termField] = true;
                    }
                }
            }
            /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */ if (clause.presence === lunr.Query.presence.REQUIRED) for(var k = 0; k < clause.fields.length; k++){
                var field = clause.fields[k];
                requiredMatches[field] = requiredMatches[field].intersect(clauseMatches);
            }
        }
        /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */ var allRequiredMatches = lunr.Set.complete, allProhibitedMatches = lunr.Set.empty;
        for(var i = 0; i < this.fields.length; i++){
            var field = this.fields[i];
            if (requiredMatches[field]) allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field]);
            if (prohibitedMatches[field]) allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field]);
        }
        var matchingFieldRefs = Object.keys(matchingFields), results = [], matches = Object.create(null);
        /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */ if (query.isNegated()) {
            matchingFieldRefs = Object.keys(this.fieldVectors);
            for(var i = 0; i < matchingFieldRefs.length; i++){
                var matchingFieldRef = matchingFieldRefs[i];
                var fieldRef = lunr.FieldRef.fromString(matchingFieldRef);
                matchingFields[matchingFieldRef] = new lunr.MatchData;
            }
        }
        for(var i = 0; i < matchingFieldRefs.length; i++){
            /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */ var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]), docRef = fieldRef.docRef;
            if (!allRequiredMatches.contains(docRef)) continue;
            if (allProhibitedMatches.contains(docRef)) continue;
            var fieldVector = this.fieldVectors[fieldRef], score = queryVectors[fieldRef.fieldName].similarity(fieldVector), docMatch;
            if ((docMatch = matches[docRef]) !== undefined) {
                docMatch.score += score;
                docMatch.matchData.combine(matchingFields[fieldRef]);
            } else {
                var match = {
                    ref: docRef,
                    score: score,
                    matchData: matchingFields[fieldRef]
                };
                matches[docRef] = match;
                results.push(match);
            }
        }
        /*
   * Sort the results objects by score, highest first.
   */ return results.sort(function(a, b) {
            return b.score - a.score;
        });
    };
    /**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */ lunr.Index.prototype.toJSON = function() {
        var invertedIndex = Object.keys(this.invertedIndex).sort().map(function(term) {
            return [
                term,
                this.invertedIndex[term]
            ];
        }, this);
        var fieldVectors = Object.keys(this.fieldVectors).map(function(ref) {
            return [
                ref,
                this.fieldVectors[ref].toJSON()
            ];
        }, this);
        return {
            version: lunr.version,
            fields: this.fields,
            fieldVectors: fieldVectors,
            invertedIndex: invertedIndex,
            pipeline: this.pipeline.toJSON()
        };
    };
    /**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */ lunr.Index.load = function(serializedIndex) {
        var attrs = {}, fieldVectors = {}, serializedVectors = serializedIndex.fieldVectors, invertedIndex = Object.create(null), serializedInvertedIndex = serializedIndex.invertedIndex, tokenSetBuilder = new lunr.TokenSet.Builder, pipeline = lunr.Pipeline.load(serializedIndex.pipeline);
        if (serializedIndex.version != lunr.version) lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'");
        for(var i = 0; i < serializedVectors.length; i++){
            var tuple = serializedVectors[i], ref = tuple[0], elements = tuple[1];
            fieldVectors[ref] = new lunr.Vector(elements);
        }
        for(var i = 0; i < serializedInvertedIndex.length; i++){
            var tuple = serializedInvertedIndex[i], term = tuple[0], posting = tuple[1];
            tokenSetBuilder.insert(term);
            invertedIndex[term] = posting;
        }
        tokenSetBuilder.finish();
        attrs.fields = serializedIndex.fields;
        attrs.fieldVectors = fieldVectors;
        attrs.invertedIndex = invertedIndex;
        attrs.tokenSet = tokenSetBuilder.root;
        attrs.pipeline = pipeline;
        return new lunr.Index(attrs);
    };
    /*!
 * lunr.Builder
 * Copyright (C) 2020 Oliver Nightingale
 */ /**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */ lunr.Builder = function() {
        this._ref = "id";
        this._fields = Object.create(null);
        this._documents = Object.create(null);
        this.invertedIndex = Object.create(null);
        this.fieldTermFrequencies = {};
        this.fieldLengths = {};
        this.tokenizer = lunr.tokenizer;
        this.pipeline = new lunr.Pipeline;
        this.searchPipeline = new lunr.Pipeline;
        this.documentCount = 0;
        this._b = 0.75;
        this._k1 = 1.2;
        this.termIndex = 0;
        this.metadataWhitelist = [];
    };
    /**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */ lunr.Builder.prototype.ref = function(ref) {
        this._ref = ref;
    };
    /**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */ /**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */ lunr.Builder.prototype.field = function(fieldName, attributes) {
        if (/\//.test(fieldName)) throw new RangeError("Field '" + fieldName + "' contains illegal character '/'");
        this._fields[fieldName] = attributes || {};
    };
    /**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */ lunr.Builder.prototype.b = function(number) {
        if (number < 0) this._b = 0;
        else if (number > 1) this._b = 1;
        else this._b = number;
    };
    /**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */ lunr.Builder.prototype.k1 = function(number) {
        this._k1 = number;
    };
    /**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */ lunr.Builder.prototype.add = function(doc, attributes) {
        var docRef = doc[this._ref], fields = Object.keys(this._fields);
        this._documents[docRef] = attributes || {};
        this.documentCount += 1;
        for(var i = 0; i < fields.length; i++){
            var fieldName = fields[i], extractor = this._fields[fieldName].extractor, field = extractor ? extractor(doc) : doc[fieldName], tokens = this.tokenizer(field, {
                fields: [
                    fieldName
                ]
            }), terms = this.pipeline.run(tokens), fieldRef = new lunr.FieldRef(docRef, fieldName), fieldTerms = Object.create(null);
            this.fieldTermFrequencies[fieldRef] = fieldTerms;
            this.fieldLengths[fieldRef] = 0;
            // store the length of this field for this document
            this.fieldLengths[fieldRef] += terms.length;
            // calculate term frequencies for this field
            for(var j = 0; j < terms.length; j++){
                var term = terms[j];
                if (fieldTerms[term] == undefined) fieldTerms[term] = 0;
                fieldTerms[term] += 1;
                // add to inverted index
                // create an initial posting if one doesn't exist
                if (this.invertedIndex[term] == undefined) {
                    var posting = Object.create(null);
                    posting["_index"] = this.termIndex;
                    this.termIndex += 1;
                    for(var k = 0; k < fields.length; k++)posting[fields[k]] = Object.create(null);
                    this.invertedIndex[term] = posting;
                }
                // add an entry for this term/fieldName/docRef to the invertedIndex
                if (this.invertedIndex[term][fieldName][docRef] == undefined) this.invertedIndex[term][fieldName][docRef] = Object.create(null);
                // store all whitelisted metadata about this token in the
                // inverted index
                for(var l = 0; l < this.metadataWhitelist.length; l++){
                    var metadataKey = this.metadataWhitelist[l], metadata = term.metadata[metadataKey];
                    if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) this.invertedIndex[term][fieldName][docRef][metadataKey] = [];
                    this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata);
                }
            }
        }
    };
    /**
 * Calculates the average document length for this index
 *
 * @private
 */ lunr.Builder.prototype.calculateAverageFieldLengths = function() {
        var fieldRefs = Object.keys(this.fieldLengths), numberOfFields = fieldRefs.length, accumulator = {}, documentsWithField = {};
        for(var i = 0; i < numberOfFields; i++){
            var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]), field = fieldRef.fieldName;
            documentsWithField[field] || (documentsWithField[field] = 0);
            documentsWithField[field] += 1;
            accumulator[field] || (accumulator[field] = 0);
            accumulator[field] += this.fieldLengths[fieldRef];
        }
        var fields = Object.keys(this._fields);
        for(var i = 0; i < fields.length; i++){
            var fieldName = fields[i];
            accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName];
        }
        this.averageFieldLength = accumulator;
    };
    /**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */ lunr.Builder.prototype.createFieldVectors = function() {
        var fieldVectors = {}, fieldRefs = Object.keys(this.fieldTermFrequencies), fieldRefsLength = fieldRefs.length, termIdfCache = Object.create(null);
        for(var i = 0; i < fieldRefsLength; i++){
            var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]), fieldName = fieldRef.fieldName, fieldLength = this.fieldLengths[fieldRef], fieldVector = new lunr.Vector, termFrequencies = this.fieldTermFrequencies[fieldRef], terms = Object.keys(termFrequencies), termsLength = terms.length;
            var fieldBoost = this._fields[fieldName].boost || 1, docBoost = this._documents[fieldRef.docRef].boost || 1;
            for(var j = 0; j < termsLength; j++){
                var term = terms[j], tf = termFrequencies[term], termIndex = this.invertedIndex[term]._index, idf, score, scoreWithPrecision;
                if (termIdfCache[term] === undefined) {
                    idf = lunr.idf(this.invertedIndex[term], this.documentCount);
                    termIdfCache[term] = idf;
                } else idf = termIdfCache[term];
                score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf);
                score *= fieldBoost;
                score *= docBoost;
                scoreWithPrecision = Math.round(score * 1000) / 1000;
                // Converts 1.23456789 to 1.234.
                // Reducing the precision so that the vectors take up less
                // space when serialised. Doing it now so that they behave
                // the same before and after serialisation. Also, this is
                // the fastest approach to reducing a number's precision in
                // JavaScript.
                fieldVector.insert(termIndex, scoreWithPrecision);
            }
            fieldVectors[fieldRef] = fieldVector;
        }
        this.fieldVectors = fieldVectors;
    };
    /**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */ lunr.Builder.prototype.createTokenSet = function() {
        this.tokenSet = lunr.TokenSet.fromArray(Object.keys(this.invertedIndex).sort());
    };
    /**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */ lunr.Builder.prototype.build = function() {
        this.calculateAverageFieldLengths();
        this.createFieldVectors();
        this.createTokenSet();
        return new lunr.Index({
            invertedIndex: this.invertedIndex,
            fieldVectors: this.fieldVectors,
            tokenSet: this.tokenSet,
            fields: Object.keys(this._fields),
            pipeline: this.searchPipeline
        });
    };
    /**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */ lunr.Builder.prototype.use = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        args.unshift(this);
        fn.apply(this, args);
    };
    /**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */ lunr.MatchData = function(term, field, metadata) {
        var clonedMetadata = Object.create(null), metadataKeys = Object.keys(metadata || {});
        // Cloning the metadata to prevent the original
        // being mutated during match data combination.
        // Metadata is kept in an array within the inverted
        // index so cloning the data can be done with
        // Array#slice
        for(var i = 0; i < metadataKeys.length; i++){
            var key = metadataKeys[i];
            clonedMetadata[key] = metadata[key].slice();
        }
        this.metadata = Object.create(null);
        if (term !== undefined) {
            this.metadata[term] = Object.create(null);
            this.metadata[term][field] = clonedMetadata;
        }
    };
    /**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */ lunr.MatchData.prototype.combine = function(otherMatchData) {
        var terms = Object.keys(otherMatchData.metadata);
        for(var i = 0; i < terms.length; i++){
            var term = terms[i], fields = Object.keys(otherMatchData.metadata[term]);
            if (this.metadata[term] == undefined) this.metadata[term] = Object.create(null);
            for(var j = 0; j < fields.length; j++){
                var field = fields[j], keys = Object.keys(otherMatchData.metadata[term][field]);
                if (this.metadata[term][field] == undefined) this.metadata[term][field] = Object.create(null);
                for(var k = 0; k < keys.length; k++){
                    var key = keys[k];
                    if (this.metadata[term][field][key] == undefined) this.metadata[term][field][key] = otherMatchData.metadata[term][field][key];
                    else this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key]);
                }
            }
        }
    };
    /**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */ lunr.MatchData.prototype.add = function(term, field, metadata) {
        if (!(term in this.metadata)) {
            this.metadata[term] = Object.create(null);
            this.metadata[term][field] = metadata;
            return;
        }
        if (!(field in this.metadata[term])) {
            this.metadata[term][field] = metadata;
            return;
        }
        var metadataKeys = Object.keys(metadata);
        for(var i = 0; i < metadataKeys.length; i++){
            var key = metadataKeys[i];
            if (key in this.metadata[term][field]) this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key]);
            else this.metadata[term][field][key] = metadata[key];
        }
    };
    /**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */ lunr.Query = function(allFields) {
        this.clauses = [];
        this.allFields = allFields;
    };
    /**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */ lunr.Query.wildcard = new String("*");
    lunr.Query.wildcard.NONE = 0;
    lunr.Query.wildcard.LEADING = 1;
    lunr.Query.wildcard.TRAILING = 2;
    /**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */ lunr.Query.presence = {
        /**
   * Term's presence in a document is optional, this is the default value.
   */ OPTIONAL: 1,
        /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */ REQUIRED: 2,
        /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */ PROHIBITED: 3
    };
    /**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */ /**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */ lunr.Query.prototype.clause = function(clause) {
        if (!('fields' in clause)) clause.fields = this.allFields;
        if (!('boost' in clause)) clause.boost = 1;
        if (!('usePipeline' in clause)) clause.usePipeline = true;
        if (!('wildcard' in clause)) clause.wildcard = lunr.Query.wildcard.NONE;
        if (clause.wildcard & lunr.Query.wildcard.LEADING && clause.term.charAt(0) != lunr.Query.wildcard) clause.term = "*" + clause.term;
        if (clause.wildcard & lunr.Query.wildcard.TRAILING && clause.term.slice(-1) != lunr.Query.wildcard) clause.term = "" + clause.term + "*";
        if (!('presence' in clause)) clause.presence = lunr.Query.presence.OPTIONAL;
        this.clauses.push(clause);
        return this;
    };
    /**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */ lunr.Query.prototype.isNegated = function() {
        for(var i = 0; i < this.clauses.length; i++){
            if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) return false;
        }
        return true;
    };
    /**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */ lunr.Query.prototype.term = function(term, options) {
        if (Array.isArray(term)) {
            term.forEach(function(t) {
                this.term(t, lunr.utils.clone(options));
            }, this);
            return this;
        }
        var clause = options || {};
        clause.term = term.toString();
        this.clause(clause);
        return this;
    };
    lunr.QueryParseError = function(message, start, end) {
        this.name = "QueryParseError";
        this.message = message;
        this.start = start;
        this.end = end;
    };
    lunr.QueryParseError.prototype = new Error;
    lunr.QueryLexer = function(str) {
        this.lexemes = [];
        this.str = str;
        this.length = str.length;
        this.pos = 0;
        this.start = 0;
        this.escapeCharPositions = [];
    };
    lunr.QueryLexer.prototype.run = function() {
        var state = lunr.QueryLexer.lexText;
        while(state)state = state(this);
    };
    lunr.QueryLexer.prototype.sliceString = function() {
        var subSlices = [], sliceStart = this.start, sliceEnd = this.pos;
        for(var i = 0; i < this.escapeCharPositions.length; i++){
            sliceEnd = this.escapeCharPositions[i];
            subSlices.push(this.str.slice(sliceStart, sliceEnd));
            sliceStart = sliceEnd + 1;
        }
        subSlices.push(this.str.slice(sliceStart, this.pos));
        this.escapeCharPositions.length = 0;
        return subSlices.join('');
    };
    lunr.QueryLexer.prototype.emit = function(type) {
        this.lexemes.push({
            type: type,
            str: this.sliceString(),
            start: this.start,
            end: this.pos
        });
        this.start = this.pos;
    };
    lunr.QueryLexer.prototype.escapeCharacter = function() {
        this.escapeCharPositions.push(this.pos - 1);
        this.pos += 1;
    };
    lunr.QueryLexer.prototype.next = function() {
        if (this.pos >= this.length) return lunr.QueryLexer.EOS;
        var char = this.str.charAt(this.pos);
        this.pos += 1;
        return char;
    };
    lunr.QueryLexer.prototype.width = function() {
        return this.pos - this.start;
    };
    lunr.QueryLexer.prototype.ignore = function() {
        if (this.start == this.pos) this.pos += 1;
        this.start = this.pos;
    };
    lunr.QueryLexer.prototype.backup = function() {
        this.pos -= 1;
    };
    lunr.QueryLexer.prototype.acceptDigitRun = function() {
        var char, charCode;
        do {
            char = this.next();
            charCode = char.charCodeAt(0);
        }while (charCode > 47 && charCode < 58);
        if (char != lunr.QueryLexer.EOS) this.backup();
    };
    lunr.QueryLexer.prototype.more = function() {
        return this.pos < this.length;
    };
    lunr.QueryLexer.EOS = 'EOS';
    lunr.QueryLexer.FIELD = 'FIELD';
    lunr.QueryLexer.TERM = 'TERM';
    lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE';
    lunr.QueryLexer.BOOST = 'BOOST';
    lunr.QueryLexer.PRESENCE = 'PRESENCE';
    lunr.QueryLexer.lexField = function(lexer) {
        lexer.backup();
        lexer.emit(lunr.QueryLexer.FIELD);
        lexer.ignore();
        return lunr.QueryLexer.lexText;
    };
    lunr.QueryLexer.lexTerm = function(lexer) {
        if (lexer.width() > 1) {
            lexer.backup();
            lexer.emit(lunr.QueryLexer.TERM);
        }
        lexer.ignore();
        if (lexer.more()) return lunr.QueryLexer.lexText;
    };
    lunr.QueryLexer.lexEditDistance = function(lexer) {
        lexer.ignore();
        lexer.acceptDigitRun();
        lexer.emit(lunr.QueryLexer.EDIT_DISTANCE);
        return lunr.QueryLexer.lexText;
    };
    lunr.QueryLexer.lexBoost = function(lexer) {
        lexer.ignore();
        lexer.acceptDigitRun();
        lexer.emit(lunr.QueryLexer.BOOST);
        return lunr.QueryLexer.lexText;
    };
    lunr.QueryLexer.lexEOS = function(lexer) {
        if (lexer.width() > 0) lexer.emit(lunr.QueryLexer.TERM);
    };
    // This matches the separator used when tokenising fields
    // within a document. These should match otherwise it is
    // not possible to search for some tokens within a document.
    //
    // It is possible for the user to change the separator on the
    // tokenizer so it _might_ clash with any other of the special
    // characters already used within the search string, e.g. :.
    //
    // This means that it is possible to change the separator in
    // such a way that makes some words unsearchable using a search
    // string.
    lunr.QueryLexer.termSeparator = lunr.tokenizer.separator;
    lunr.QueryLexer.lexText = function(lexer) {
        while(true){
            var char = lexer.next();
            if (char == lunr.QueryLexer.EOS) return lunr.QueryLexer.lexEOS;
            // Escape character is '\'
            if (char.charCodeAt(0) == 92) {
                lexer.escapeCharacter();
                continue;
            }
            if (char == ":") return lunr.QueryLexer.lexField;
            if (char == "~") {
                lexer.backup();
                if (lexer.width() > 0) lexer.emit(lunr.QueryLexer.TERM);
                return lunr.QueryLexer.lexEditDistance;
            }
            if (char == "^") {
                lexer.backup();
                if (lexer.width() > 0) lexer.emit(lunr.QueryLexer.TERM);
                return lunr.QueryLexer.lexBoost;
            }
            // "+" indicates term presence is required
            // checking for length to ensure that only
            // leading "+" are considered
            if (char == "+" && lexer.width() === 1) {
                lexer.emit(lunr.QueryLexer.PRESENCE);
                return lunr.QueryLexer.lexText;
            }
            // "-" indicates term presence is prohibited
            // checking for length to ensure that only
            // leading "-" are considered
            if (char == "-" && lexer.width() === 1) {
                lexer.emit(lunr.QueryLexer.PRESENCE);
                return lunr.QueryLexer.lexText;
            }
            if (char.match(lunr.QueryLexer.termSeparator)) return lunr.QueryLexer.lexTerm;
        }
    };
    lunr.QueryParser = function(str, query) {
        this.lexer = new lunr.QueryLexer(str);
        this.query = query;
        this.currentClause = {};
        this.lexemeIdx = 0;
    };
    lunr.QueryParser.prototype.parse = function() {
        this.lexer.run();
        this.lexemes = this.lexer.lexemes;
        var state = lunr.QueryParser.parseClause;
        while(state)state = state(this);
        return this.query;
    };
    lunr.QueryParser.prototype.peekLexeme = function() {
        return this.lexemes[this.lexemeIdx];
    };
    lunr.QueryParser.prototype.consumeLexeme = function() {
        var lexeme = this.peekLexeme();
        this.lexemeIdx += 1;
        return lexeme;
    };
    lunr.QueryParser.prototype.nextClause = function() {
        var completedClause = this.currentClause;
        this.query.clause(completedClause);
        this.currentClause = {};
    };
    lunr.QueryParser.parseClause = function(parser) {
        var lexeme = parser.peekLexeme();
        if (lexeme == undefined) return;
        switch(lexeme.type){
            case lunr.QueryLexer.PRESENCE:
                return lunr.QueryParser.parsePresence;
            case lunr.QueryLexer.FIELD:
                return lunr.QueryParser.parseField;
            case lunr.QueryLexer.TERM:
                return lunr.QueryParser.parseTerm;
            default:
                var errorMessage = "expected either a field or a term, found " + lexeme.type;
                if (lexeme.str.length >= 1) errorMessage += " with value '" + lexeme.str + "'";
                throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
    };
    lunr.QueryParser.parsePresence = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == undefined) return;
        switch(lexeme.str){
            case "-":
                parser.currentClause.presence = lunr.Query.presence.PROHIBITED;
                break;
            case "+":
                parser.currentClause.presence = lunr.Query.presence.REQUIRED;
                break;
            default:
                var errorMessage = "unrecognised presence operator'" + lexeme.str + "'";
                throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == undefined) {
            var errorMessage = "expecting term or field, found nothing";
            throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        switch(nextLexeme.type){
            case lunr.QueryLexer.FIELD:
                return lunr.QueryParser.parseField;
            case lunr.QueryLexer.TERM:
                return lunr.QueryParser.parseTerm;
            default:
                var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'";
                throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
    };
    lunr.QueryParser.parseField = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == undefined) return;
        if (parser.query.allFields.indexOf(lexeme.str) == -1) {
            var possibleFields = parser.query.allFields.map(function(f) {
                return "'" + f + "'";
            }).join(', '), errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields;
            throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.fields = [
            lexeme.str
        ];
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == undefined) {
            var errorMessage = "expecting term, found nothing";
            throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        switch(nextLexeme.type){
            case lunr.QueryLexer.TERM:
                return lunr.QueryParser.parseTerm;
            default:
                var errorMessage = "expecting term, found '" + nextLexeme.type + "'";
                throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
    };
    lunr.QueryParser.parseTerm = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == undefined) return;
        parser.currentClause.term = lexeme.str.toLowerCase();
        if (lexeme.str.indexOf("*") != -1) parser.currentClause.usePipeline = false;
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == undefined) {
            parser.nextClause();
            return;
        }
        switch(nextLexeme.type){
            case lunr.QueryLexer.TERM:
                parser.nextClause();
                return lunr.QueryParser.parseTerm;
            case lunr.QueryLexer.FIELD:
                parser.nextClause();
                return lunr.QueryParser.parseField;
            case lunr.QueryLexer.EDIT_DISTANCE:
                return lunr.QueryParser.parseEditDistance;
            case lunr.QueryLexer.BOOST:
                return lunr.QueryParser.parseBoost;
            case lunr.QueryLexer.PRESENCE:
                parser.nextClause();
                return lunr.QueryParser.parsePresence;
            default:
                var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
                throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
    };
    lunr.QueryParser.parseEditDistance = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == undefined) return;
        var editDistance = parseInt(lexeme.str, 10);
        if (isNaN(editDistance)) {
            var errorMessage = "edit distance must be numeric";
            throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.editDistance = editDistance;
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == undefined) {
            parser.nextClause();
            return;
        }
        switch(nextLexeme.type){
            case lunr.QueryLexer.TERM:
                parser.nextClause();
                return lunr.QueryParser.parseTerm;
            case lunr.QueryLexer.FIELD:
                parser.nextClause();
                return lunr.QueryParser.parseField;
            case lunr.QueryLexer.EDIT_DISTANCE:
                return lunr.QueryParser.parseEditDistance;
            case lunr.QueryLexer.BOOST:
                return lunr.QueryParser.parseBoost;
            case lunr.QueryLexer.PRESENCE:
                parser.nextClause();
                return lunr.QueryParser.parsePresence;
            default:
                var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
                throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
    };
    lunr.QueryParser.parseBoost = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == undefined) return;
        var boost = parseInt(lexeme.str, 10);
        if (isNaN(boost)) {
            var errorMessage = "boost must be numeric";
            throw new lunr.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.boost = boost;
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == undefined) {
            parser.nextClause();
            return;
        }
        switch(nextLexeme.type){
            case lunr.QueryLexer.TERM:
                parser.nextClause();
                return lunr.QueryParser.parseTerm;
            case lunr.QueryLexer.FIELD:
                parser.nextClause();
                return lunr.QueryParser.parseField;
            case lunr.QueryLexer.EDIT_DISTANCE:
                return lunr.QueryParser.parseEditDistance;
            case lunr.QueryLexer.BOOST:
                return lunr.QueryParser.parseBoost;
            case lunr.QueryLexer.PRESENCE:
                parser.nextClause();
                return lunr.QueryParser.parsePresence;
            default:
                var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
                throw new lunr.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
    };
    (function(root, factory) {
        if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
        define(factory);
        else /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */ module.exports = factory();
    })(this, function() {
        /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */ return lunr;
    });
})();

});

parcelRegister("exLvJ", function(module, exports) {
"use strict";

var $2p3J5 = parcelRequire("2p3J5");
module.exports = function maybe(cb, promise) {
    if (cb) {
        promise.then(function(result) {
            $2p3J5(function() {
                cb(null, result);
            });
        }, function(err) {
            $2p3J5(function() {
                cb(err);
            });
        });
        return undefined;
    } else return promise;
};

});
parcelRegister("2p3J5", function(module, exports) {
'use strict';
function $1c00ce819d850a11$var$makeNext() {
    if (typeof setImmediate === 'function') return setImmediate;
    else return function next(f) {
        setTimeout(f, 0);
    };
}
module.exports = $1c00ce819d850a11$var$makeNext();

});


parcelRegister("hgGe6", function(module, exports) {
module.exports = $c924af90aa582a4d$var$stringify;
$c924af90aa582a4d$var$stringify.default = $c924af90aa582a4d$var$stringify;
$c924af90aa582a4d$var$stringify.stable = $c924af90aa582a4d$var$deterministicStringify;
$c924af90aa582a4d$var$stringify.stableStringify = $c924af90aa582a4d$var$deterministicStringify;
var $c924af90aa582a4d$var$LIMIT_REPLACE_NODE = '[...]';
var $c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE = '[Circular]';
var $c924af90aa582a4d$var$arr = [];
var $c924af90aa582a4d$var$replacerStack = [];
function $c924af90aa582a4d$var$defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function $c924af90aa582a4d$var$stringify(obj, replacer, spacer, options) {
    if (typeof options === 'undefined') options = $c924af90aa582a4d$var$defaultOptions();
    $c924af90aa582a4d$var$decirc(obj, '', 0, [], undefined, 0, options);
    var res;
    try {
        if ($c924af90aa582a4d$var$replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, $c924af90aa582a4d$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]');
    } finally{
        while($c924af90aa582a4d$var$arr.length !== 0){
            var part = $c924af90aa582a4d$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $c924af90aa582a4d$var$setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            $c924af90aa582a4d$var$arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else $c924af90aa582a4d$var$replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        $c924af90aa582a4d$var$arr.push([
            parent,
            k,
            val
        ]);
    }
}
function $c924af90aa582a4d$var$decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === 'object' && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== 'undefined' && depth > options.depthLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== 'undefined' && edgeIndex + 1 > options.edgesLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$c924af90aa582a4d$var$decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $c924af90aa582a4d$var$decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function $c924af90aa582a4d$var$compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $c924af90aa582a4d$var$deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === 'undefined') options = $c924af90aa582a4d$var$defaultOptions();
    var tmp = $c924af90aa582a4d$var$deterministicDecirc(obj, '', 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if ($c924af90aa582a4d$var$replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, $c924af90aa582a4d$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]');
    } finally{
        // Ensure that we restore the object as it was.
        while($c924af90aa582a4d$var$arr.length !== 0){
            var part = $c924af90aa582a4d$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $c924af90aa582a4d$var$deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === 'object' && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === 'function') return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== 'undefined' && depth > options.depthLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== 'undefined' && edgeIndex + 1 > options.edgesLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$c924af90aa582a4d$var$deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort($c924af90aa582a4d$var$compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $c924af90aa582a4d$var$deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== 'undefined') {
                $c924af90aa582a4d$var$arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function $c924af90aa582a4d$var$replaceGetterValues(replacer) {
    replacer = typeof replacer !== 'undefined' ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if ($c924af90aa582a4d$var$replacerStack.length > 0) for(var i = 0; i < $c924af90aa582a4d$var$replacerStack.length; i++){
            var part = $c924af90aa582a4d$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                $c924af90aa582a4d$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}

});

parcelRegister("i6sfg", function(module, exports) {
/*!
 * Stickyfill -- `position: sticky` polyfill
 * v. 1.1.1 | https://github.com/wilddeer/stickyfill
 * Copyright Oleg Korsunsky | http://wd.dizaina.net/
 *
 * MIT License
 */ module.exports = function(doc, win) {
    if (!doc) doc = document;
    if (!win) win = window;
    var watchArray = [], scroll, initialized = false, html = doc.documentElement, noop = function() {}, checkTimer, //visibility API strings
    hiddenPropertyName = 'hidden', visibilityChangeEventName = 'visibilitychange';
    //fallback to prefixed names in old webkit browsers
    if (doc.webkitHidden !== undefined) {
        hiddenPropertyName = 'webkitHidden';
        visibilityChangeEventName = 'webkitvisibilitychange';
    }
    //test getComputedStyle
    if (!win.getComputedStyle) seppuku();
    //test for native support
    var prefixes = [
        '',
        '-webkit-',
        '-moz-',
        '-ms-'
    ], block = document.createElement('div');
    for(var i = prefixes.length - 1; i >= 0; i--){
        try {
            block.style.position = prefixes[i] + 'sticky';
        } catch (e) {}
        if (block.style.position != '') seppuku();
    }
    updateScrollPos();
    //commit seppuku!
    function seppuku() {
        init = add = rebuild = pause = stop = kill = noop;
    }
    function mergeObjects(targetObj, sourceObject) {
        for(key in sourceObject)if (sourceObject.hasOwnProperty(key)) targetObj[key] = sourceObject[key];
    }
    function parseNumeric(val) {
        return parseFloat(val) || 0;
    }
    function updateScrollPos() {
        scroll = {
            top: win.pageYOffset,
            left: win.pageXOffset
        };
    }
    function onScroll() {
        if (win.pageXOffset != scroll.left) {
            updateScrollPos();
            rebuild();
            return;
        }
        if (win.pageYOffset != scroll.top) {
            updateScrollPos();
            recalcAllPos();
        }
    }
    //fixes flickering
    function onWheel(event) {
        setTimeout(function() {
            if (win.pageYOffset != scroll.top) {
                scroll.top = win.pageYOffset;
                recalcAllPos();
            }
        }, 0);
    }
    function recalcAllPos() {
        for(var i = watchArray.length - 1; i >= 0; i--)recalcElementPos(watchArray[i]);
    }
    function recalcElementPos(el) {
        if (!el.inited) return;
        var currentMode = scroll.top <= el.limit.start ? 0 : scroll.top >= el.limit.end ? 2 : 1;
        if (el.mode != currentMode) switchElementMode(el, currentMode);
    }
    //checks whether stickies start or stop positions have changed
    function fastCheck() {
        for(var i = watchArray.length - 1; i >= 0; i--){
            if (!watchArray[i].inited) continue;
            var deltaTop = Math.abs(getDocOffsetTop(watchArray[i].clone) - watchArray[i].docOffsetTop), deltaHeight = Math.abs(watchArray[i].parent.node.offsetHeight - watchArray[i].parent.height);
            if (deltaTop >= 2 || deltaHeight >= 2) return false;
        }
        return true;
    }
    function initElement(el) {
        if (isNaN(parseFloat(el.computed.top)) || el.isCell) return;
        el.inited = true;
        if (!el.clone) clone(el);
        if (el.parent.computed.position != 'absolute' && el.parent.computed.position != 'relative') el.parent.node.style.position = 'relative';
        recalcElementPos(el);
        el.parent.height = el.parent.node.offsetHeight;
        el.docOffsetTop = getDocOffsetTop(el.clone);
    }
    function deinitElement(el) {
        var deinitParent = true;
        el.clone && killClone(el);
        mergeObjects(el.node.style, el.css);
        //check whether element's parent is used by other stickies
        for(var i = watchArray.length - 1; i >= 0; i--)if (watchArray[i].node !== el.node && watchArray[i].parent.node === el.parent.node) {
            deinitParent = false;
            break;
        }
        if (deinitParent) el.parent.node.style.position = el.parent.css.position;
        el.mode = -1;
    }
    function initAll() {
        for(var i = watchArray.length - 1; i >= 0; i--)initElement(watchArray[i]);
    }
    function deinitAll() {
        for(var i = watchArray.length - 1; i >= 0; i--)deinitElement(watchArray[i]);
    }
    function switchElementMode(el, mode) {
        var nodeStyle = el.node.style;
        switch(mode){
            case 0:
                nodeStyle.position = 'absolute';
                nodeStyle.left = el.offset.left + 'px';
                nodeStyle.right = el.offset.right + 'px';
                nodeStyle.top = el.offset.top + 'px';
                nodeStyle.bottom = 'auto';
                nodeStyle.width = 'auto';
                nodeStyle.marginLeft = 0;
                nodeStyle.marginRight = 0;
                nodeStyle.marginTop = 0;
                break;
            case 1:
                nodeStyle.position = 'fixed';
                nodeStyle.left = el.box.left + 'px';
                nodeStyle.right = el.box.right + 'px';
                nodeStyle.top = el.css.top;
                nodeStyle.bottom = 'auto';
                nodeStyle.width = 'auto';
                nodeStyle.marginLeft = 0;
                nodeStyle.marginRight = 0;
                nodeStyle.marginTop = 0;
                break;
            case 2:
                nodeStyle.position = 'absolute';
                nodeStyle.left = el.offset.left + 'px';
                nodeStyle.right = el.offset.right + 'px';
                nodeStyle.top = 'auto';
                nodeStyle.bottom = 0;
                nodeStyle.width = 'auto';
                nodeStyle.marginLeft = 0;
                nodeStyle.marginRight = 0;
                break;
        }
        el.mode = mode;
    }
    function clone(el) {
        el.clone = document.createElement('div');
        var refElement = el.node.nextSibling || el.node, cloneStyle = el.clone.style;
        cloneStyle.height = el.height + 'px';
        cloneStyle.width = el.width + 'px';
        cloneStyle.marginTop = el.computed.marginTop;
        cloneStyle.marginBottom = el.computed.marginBottom;
        cloneStyle.marginLeft = el.computed.marginLeft;
        cloneStyle.marginRight = el.computed.marginRight;
        cloneStyle.padding = cloneStyle.border = cloneStyle.borderSpacing = 0;
        cloneStyle.fontSize = '1em';
        cloneStyle.position = 'static';
        cloneStyle.cssFloat = el.computed.cssFloat;
        el.node.parentNode.insertBefore(el.clone, refElement);
    }
    function killClone(el) {
        el.clone.parentNode.removeChild(el.clone);
        el.clone = undefined;
    }
    function getElementParams(node) {
        var computedStyle = getComputedStyle(node), parentNode = node.parentNode, parentComputedStyle = getComputedStyle(parentNode), cachedPosition = node.style.position;
        node.style.position = 'relative';
        var computed = {
            top: computedStyle.top,
            marginTop: computedStyle.marginTop,
            marginBottom: computedStyle.marginBottom,
            marginLeft: computedStyle.marginLeft,
            marginRight: computedStyle.marginRight,
            cssFloat: computedStyle.cssFloat
        }, numeric = {
            top: parseNumeric(computedStyle.top),
            marginBottom: parseNumeric(computedStyle.marginBottom),
            paddingLeft: parseNumeric(computedStyle.paddingLeft),
            paddingRight: parseNumeric(computedStyle.paddingRight),
            borderLeftWidth: parseNumeric(computedStyle.borderLeftWidth),
            borderRightWidth: parseNumeric(computedStyle.borderRightWidth)
        };
        node.style.position = cachedPosition;
        var css = {
            position: node.style.position,
            top: node.style.top,
            bottom: node.style.bottom,
            left: node.style.left,
            right: node.style.right,
            width: node.style.width,
            marginTop: node.style.marginTop,
            marginLeft: node.style.marginLeft,
            marginRight: node.style.marginRight
        }, nodeOffset = getElementOffset(node), parentOffset = getElementOffset(parentNode), parent = {
            node: parentNode,
            css: {
                position: parentNode.style.position
            },
            computed: {
                position: parentComputedStyle.position
            },
            numeric: {
                borderLeftWidth: parseNumeric(parentComputedStyle.borderLeftWidth),
                borderRightWidth: parseNumeric(parentComputedStyle.borderRightWidth),
                borderTopWidth: parseNumeric(parentComputedStyle.borderTopWidth),
                borderBottomWidth: parseNumeric(parentComputedStyle.borderBottomWidth)
            }
        }, el = {
            node: node,
            box: {
                left: nodeOffset.win.left,
                right: html.clientWidth - nodeOffset.win.right
            },
            offset: {
                top: nodeOffset.win.top - parentOffset.win.top - parent.numeric.borderTopWidth,
                left: nodeOffset.win.left - parentOffset.win.left - parent.numeric.borderLeftWidth,
                right: -nodeOffset.win.right + parentOffset.win.right - parent.numeric.borderRightWidth
            },
            css: css,
            isCell: computedStyle.display == 'table-cell',
            computed: computed,
            numeric: numeric,
            width: nodeOffset.win.right - nodeOffset.win.left,
            height: nodeOffset.win.bottom - nodeOffset.win.top,
            mode: -1,
            inited: false,
            parent: parent,
            limit: {
                start: nodeOffset.doc.top - numeric.top,
                end: parentOffset.doc.top + parentNode.offsetHeight - parent.numeric.borderBottomWidth - node.offsetHeight - numeric.top - numeric.marginBottom
            }
        };
        return el;
    }
    function getDocOffsetTop(node) {
        var docOffsetTop = 0;
        while(node){
            docOffsetTop += node.offsetTop;
            node = node.offsetParent;
        }
        return docOffsetTop;
    }
    function getElementOffset(node) {
        var box = node.getBoundingClientRect();
        return {
            doc: {
                top: box.top + win.pageYOffset,
                left: box.left + win.pageXOffset
            },
            win: box
        };
    }
    function startFastCheckTimer() {
        checkTimer = setInterval(function() {
            !fastCheck() && rebuild();
        }, 500);
    }
    function stopFastCheckTimer() {
        clearInterval(checkTimer);
    }
    function handlePageVisibilityChange() {
        if (!initialized) return;
        if (document[hiddenPropertyName]) stopFastCheckTimer();
        else startFastCheckTimer();
    }
    function init() {
        if (initialized) return;
        updateScrollPos();
        initAll();
        win.addEventListener('scroll', onScroll);
        win.addEventListener('wheel', onWheel);
        //watch for width changes
        win.addEventListener('resize', rebuild);
        win.addEventListener('orientationchange', rebuild);
        //watch for page visibility
        doc.addEventListener(visibilityChangeEventName, handlePageVisibilityChange);
        startFastCheckTimer();
        initialized = true;
    }
    function rebuild() {
        if (!initialized) return;
        deinitAll();
        for(var i = watchArray.length - 1; i >= 0; i--)watchArray[i] = getElementParams(watchArray[i].node);
        initAll();
    }
    function pause() {
        win.removeEventListener('scroll', onScroll);
        win.removeEventListener('wheel', onWheel);
        win.removeEventListener('resize', rebuild);
        win.removeEventListener('orientationchange', rebuild);
        doc.removeEventListener(visibilityChangeEventName, handlePageVisibilityChange);
        stopFastCheckTimer();
        initialized = false;
    }
    function stop() {
        pause();
        deinitAll();
    }
    function kill() {
        stop();
        //empty the array without loosing the references,
        //the most performant method according to http://jsperf.com/empty-javascript-array
        while(watchArray.length)watchArray.pop();
    }
    function add(node) {
        //check if Stickyfill is already applied to the node
        for(var i = watchArray.length - 1; i >= 0; i--){
            if (watchArray[i].node === node) return;
        }
        var el = getElementParams(node);
        watchArray.push(el);
        if (!initialized) init();
        else initElement(el);
    }
    function remove(node) {
        for(var i = watchArray.length - 1; i >= 0; i--)if (watchArray[i].node === node) {
            deinitElement(watchArray[i]);
            watchArray.splice(i, 1);
        }
    }
    //expose Stickyfill
    return {
        stickies: watchArray,
        add: add,
        remove: remove,
        init: init,
        rebuild: rebuild,
        pause: pause,
        stop: stop,
        kill: kill
    };
};

});

parcelRegister("2sxTc", function(module, exports) {

module.exports = (parcelRequire("914k8")).YAML;

});
parcelRegister("914k8", function(module, exports) {

$parcel$export(module.exports, "YAML", () => $69078fac725591aa$export$866dfa75bd13a786);

var $ggmYK = parcelRequire("ggmYK");

var $10eVG = parcelRequire("10eVG");

var $fPQpe = parcelRequire("fPQpe");

var $fy1aE = parcelRequire("fy1aE");

var $9fMDQ = parcelRequire("9fMDQ");
const $69078fac725591aa$var$defaultOptions = {
    anchorPrefix: 'a',
    customTags: null,
    indent: 2,
    indentSeq: true,
    keepCstNodes: false,
    keepNodeTypes: true,
    keepBlobsInJSON: true,
    mapAsMap: false,
    maxAliasCount: 100,
    prettyErrors: false,
    // TODO Set true in v2
    simpleKeys: false,
    version: '1.2'
};
const $69078fac725591aa$var$scalarOptions = {
    get binary () {
        return 0, $fPQpe.b;
    },
    set binary (opt){
        Object.assign((0, $fPQpe.b), opt);
    },
    get bool () {
        return 0, $fPQpe.a;
    },
    set bool (opt){
        Object.assign((0, $fPQpe.a), opt);
    },
    get int () {
        return 0, $fPQpe.i;
    },
    set int (opt){
        Object.assign((0, $fPQpe.i), opt);
    },
    get null () {
        return 0, $fPQpe.n;
    },
    set null (opt){
        Object.assign((0, $fPQpe.n), opt);
    },
    get str () {
        return 0, $fPQpe.s;
    },
    set str (opt){
        Object.assign((0, $fPQpe.s), opt);
    }
};
const $69078fac725591aa$var$documentOptions = {
    '1.0': {
        schema: 'yaml-1.1',
        merge: true,
        tagPrefixes: [
            {
                handle: '!',
                prefix: (0, $10eVG.d)
            },
            {
                handle: '!!',
                prefix: 'tag:private.yaml.org,2002:'
            }
        ]
    },
    1.1: {
        schema: 'yaml-1.1',
        merge: true,
        tagPrefixes: [
            {
                handle: '!',
                prefix: '!'
            },
            {
                handle: '!!',
                prefix: (0, $10eVG.d)
            }
        ]
    },
    1.2: {
        schema: 'core',
        merge: false,
        tagPrefixes: [
            {
                handle: '!',
                prefix: '!'
            },
            {
                handle: '!!',
                prefix: (0, $10eVG.d)
            }
        ]
    }
};
function $69078fac725591aa$var$stringifyTag(doc, tag) {
    if ((doc.version || doc.options.version) === '1.0') {
        const priv = tag.match(/^tag:private\.yaml\.org,2002:([^:/]+)$/);
        if (priv) return '!' + priv[1];
        const vocab = tag.match(/^tag:([a-zA-Z0-9-]+)\.yaml\.org,2002:(.*)/);
        return vocab ? `!${vocab[1]}/${vocab[2]}` : `!${tag.replace(/^tag:/, '')}`;
    }
    let p = doc.tagPrefixes.find((p)=>tag.indexOf(p.prefix) === 0);
    if (!p) {
        const dtp = doc.getDefaults().tagPrefixes;
        p = dtp && dtp.find((p)=>tag.indexOf(p.prefix) === 0);
    }
    if (!p) return tag[0] === '!' ? tag : `!<${tag}>`;
    const suffix = tag.substr(p.prefix.length).replace(/[!,[\]{}]/g, (ch)=>({
            '!': '%21',
            ',': '%2C',
            '[': '%5B',
            ']': '%5D',
            '{': '%7B',
            '}': '%7D'
        })[ch]);
    return p.handle + suffix;
}
function $69078fac725591aa$var$getTagObject(tags, item) {
    if (item instanceof (0, $fPQpe.A)) return 0, $fPQpe.A;
    if (item.tag) {
        const match = tags.filter((t)=>t.tag === item.tag);
        if (match.length > 0) return match.find((t)=>t.format === item.format) || match[0];
    }
    let tagObj, obj;
    if (item instanceof (0, $fPQpe.S)) {
        obj = item.value;
        // TODO: deprecate/remove class check
        const match = tags.filter((t)=>t.identify && t.identify(obj) || t.class && obj instanceof t.class);
        tagObj = match.find((t)=>t.format === item.format) || match.find((t)=>!t.format);
    } else {
        obj = item;
        tagObj = tags.find((t)=>t.nodeClass && obj instanceof t.nodeClass);
    }
    if (!tagObj) {
        const name = obj && obj.constructor ? obj.constructor.name : typeof obj;
        throw new Error(`Tag not resolved for ${name} value`);
    }
    return tagObj;
}
// needs to be called before value stringifier to allow for circular anchor refs
function $69078fac725591aa$var$stringifyProps(node, tagObj, { anchors: anchors, doc: doc }) {
    const props = [];
    const anchor = doc.anchors.getName(node);
    if (anchor) {
        anchors[anchor] = node;
        props.push(`&${anchor}`);
    }
    if (node.tag) props.push($69078fac725591aa$var$stringifyTag(doc, node.tag));
    else if (!tagObj.default) props.push($69078fac725591aa$var$stringifyTag(doc, tagObj.tag));
    return props.join(' ');
}
function $69078fac725591aa$var$stringify$1(item, ctx, onComment, onChompKeep) {
    const { anchors: anchors, schema: schema } = ctx.doc;
    let tagObj;
    if (!(item instanceof (0, $fPQpe.N))) {
        const createCtx = {
            aliasNodes: [],
            onTagObj: (o)=>tagObj = o,
            prevObjects: new Map()
        };
        item = schema.createNode(item, true, null, createCtx);
        for (const alias of createCtx.aliasNodes){
            alias.source = alias.source.node;
            let name = anchors.getName(alias.source);
            if (!name) {
                name = anchors.newName();
                anchors.map[name] = alias.source;
            }
        }
    }
    if (item instanceof (0, $fPQpe.P)) return item.toString(ctx, onComment, onChompKeep);
    if (!tagObj) tagObj = $69078fac725591aa$var$getTagObject(schema.tags, item);
    const props = $69078fac725591aa$var$stringifyProps(item, tagObj, ctx);
    if (props.length > 0) ctx.indentAtStart = (ctx.indentAtStart || 0) + props.length + 1;
    const str = typeof tagObj.stringify === 'function' ? tagObj.stringify(item, ctx, onComment, onChompKeep) : item instanceof (0, $fPQpe.S) ? (0, $fPQpe.c)(item, ctx, onComment, onChompKeep) : item.toString(ctx, onComment, onChompKeep);
    if (!props) return str;
    return item instanceof (0, $fPQpe.S) || str[0] === '{' || str[0] === '[' ? `${props} ${str}` : `${props}\n${ctx.indent}${str}`;
}
class $69078fac725591aa$var$Anchors {
    static validAnchorNode(node) {
        return node instanceof (0, $fPQpe.S) || node instanceof (0, $fPQpe.Y) || node instanceof (0, $fPQpe.d);
    }
    constructor(prefix){
        (0, $10eVG._)(this, "map", Object.create(null));
        this.prefix = prefix;
    }
    createAlias(node, name) {
        this.setAnchor(node, name);
        return new (0, $fPQpe.A)(node);
    }
    createMergePair(...sources) {
        const merge = new (0, $fPQpe.M)();
        merge.value.items = sources.map((s)=>{
            if (s instanceof (0, $fPQpe.A)) {
                if (s.source instanceof (0, $fPQpe.d)) return s;
            } else if (s instanceof (0, $fPQpe.d)) return this.createAlias(s);
            throw new Error('Merge sources must be Map nodes or their Aliases');
        });
        return merge;
    }
    getName(node) {
        const { map: map } = this;
        return Object.keys(map).find((a)=>map[a] === node);
    }
    getNames() {
        return Object.keys(this.map);
    }
    getNode(name) {
        return this.map[name];
    }
    newName(prefix) {
        if (!prefix) prefix = this.prefix;
        const names = Object.keys(this.map);
        for(let i = 1;; ++i){
            const name = `${prefix}${i}`;
            if (!names.includes(name)) return name;
        }
    }
    // During parsing, map & aliases contain CST nodes
    resolveNodes() {
        const { map: map, _cstAliases: _cstAliases } = this;
        Object.keys(map).forEach((a)=>{
            map[a] = map[a].resolved;
        });
        _cstAliases.forEach((a)=>{
            a.source = a.source.resolved;
        });
        delete this._cstAliases;
    }
    setAnchor(node, name) {
        if (node != null && !$69078fac725591aa$var$Anchors.validAnchorNode(node)) throw new Error('Anchors may only be set for Scalar, Seq and Map nodes');
        if (name && /[\x00-\x19\s,[\]{}]/.test(name)) throw new Error('Anchor names must not contain whitespace or control characters');
        const { map: map } = this;
        const prev = node && Object.keys(map).find((a)=>map[a] === node);
        if (prev) {
            if (!name) return prev;
            else if (prev !== name) {
                delete map[prev];
                map[name] = node;
            }
        } else {
            if (!name) {
                if (!node) return null;
                name = this.newName();
            }
            map[name] = node;
        }
        return name;
    }
}
const $69078fac725591aa$var$visit = (node, tags)=>{
    if (node && typeof node === 'object') {
        const { tag: tag } = node;
        if (node instanceof (0, $fPQpe.C)) {
            if (tag) tags[tag] = true;
            node.items.forEach((n)=>$69078fac725591aa$var$visit(n, tags));
        } else if (node instanceof (0, $fPQpe.P)) {
            $69078fac725591aa$var$visit(node.key, tags);
            $69078fac725591aa$var$visit(node.value, tags);
        } else if (node instanceof (0, $fPQpe.S)) {
            if (tag) tags[tag] = true;
        }
    }
    return tags;
};
const $69078fac725591aa$var$listTagNames = (node)=>Object.keys($69078fac725591aa$var$visit(node, {}));
function $69078fac725591aa$var$parseContents(doc, contents) {
    const comments = {
        before: [],
        after: []
    };
    let body = undefined;
    let spaceBefore = false;
    for (const node of contents){
        if (node.valueRange) {
            if (body !== undefined) {
                const msg = 'Document contains trailing content not separated by a ... or --- line';
                doc.errors.push(new (0, $10eVG.Y)(node, msg));
                break;
            }
            const res = (0, $fPQpe.r)(doc, node);
            if (spaceBefore) {
                res.spaceBefore = true;
                spaceBefore = false;
            }
            body = res;
        } else if (node.comment !== null) {
            const cc = body === undefined ? comments.before : comments.after;
            cc.push(node.comment);
        } else if (node.type === (0, $10eVG.T).BLANK_LINE) {
            spaceBefore = true;
            if (body === undefined && comments.before.length > 0 && !doc.commentBefore) {
                // space-separated comments at start are parsed as document comments
                doc.commentBefore = comments.before.join('\n');
                comments.before = [];
            }
        }
    }
    doc.contents = body || null;
    if (!body) doc.comment = comments.before.concat(comments.after).join('\n') || null;
    else {
        const cb = comments.before.join('\n');
        if (cb) {
            const cbNode = body instanceof (0, $fPQpe.C) && body.items[0] ? body.items[0] : body;
            cbNode.commentBefore = cbNode.commentBefore ? `${cb}\n${cbNode.commentBefore}` : cb;
        }
        doc.comment = comments.after.join('\n') || null;
    }
}
function $69078fac725591aa$var$resolveTagDirective({ tagPrefixes: tagPrefixes }, directive) {
    const [handle, prefix] = directive.parameters;
    if (!handle || !prefix) {
        const msg = 'Insufficient parameters given for %TAG directive';
        throw new (0, $10eVG.b)(directive, msg);
    }
    if (tagPrefixes.some((p)=>p.handle === handle)) {
        const msg = 'The %TAG directive must only be given at most once per handle in the same document.';
        throw new (0, $10eVG.b)(directive, msg);
    }
    return {
        handle: handle,
        prefix: prefix
    };
}
function $69078fac725591aa$var$resolveYamlDirective(doc, directive) {
    let [version] = directive.parameters;
    if (directive.name === 'YAML:1.0') version = '1.0';
    if (!version) {
        const msg = 'Insufficient parameters given for %YAML directive';
        throw new (0, $10eVG.b)(directive, msg);
    }
    if (!$69078fac725591aa$var$documentOptions[version]) {
        const v0 = doc.version || doc.options.version;
        const msg = `Document will be parsed as YAML ${v0} rather than YAML ${version}`;
        doc.warnings.push(new (0, $10eVG.a)(directive, msg));
    }
    return version;
}
function $69078fac725591aa$var$parseDirectives(doc, directives, prevDoc) {
    const directiveComments = [];
    let hasDirectives = false;
    for (const directive of directives){
        const { comment: comment, name: name } = directive;
        switch(name){
            case 'TAG':
                try {
                    doc.tagPrefixes.push($69078fac725591aa$var$resolveTagDirective(doc, directive));
                } catch (error) {
                    doc.errors.push(error);
                }
                hasDirectives = true;
                break;
            case 'YAML':
            case 'YAML:1.0':
                if (doc.version) {
                    const msg = 'The %YAML directive must only be given at most once per document.';
                    doc.errors.push(new (0, $10eVG.b)(directive, msg));
                }
                try {
                    doc.version = $69078fac725591aa$var$resolveYamlDirective(doc, directive);
                } catch (error) {
                    doc.errors.push(error);
                }
                hasDirectives = true;
                break;
            default:
                if (name) {
                    const msg = `YAML only supports %TAG and %YAML directives, and not %${name}`;
                    doc.warnings.push(new (0, $10eVG.a)(directive, msg));
                }
        }
        if (comment) directiveComments.push(comment);
    }
    if (prevDoc && !hasDirectives && '1.1' === (doc.version || prevDoc.version || doc.options.version)) {
        const copyTagPrefix = ({ handle: handle, prefix: prefix })=>({
                handle: handle,
                prefix: prefix
            });
        doc.tagPrefixes = prevDoc.tagPrefixes.map(copyTagPrefix);
        doc.version = prevDoc.version;
    }
    doc.commentBefore = directiveComments.join('\n') || null;
}
function $69078fac725591aa$var$assertCollection(contents) {
    if (contents instanceof (0, $fPQpe.C)) return true;
    throw new Error('Expected a YAML collection as document contents');
}
class $69078fac725591aa$var$Document$1 {
    constructor(options){
        this.anchors = new $69078fac725591aa$var$Anchors(options.anchorPrefix);
        this.commentBefore = null;
        this.comment = null;
        this.contents = null;
        this.directivesEndMarker = null;
        this.errors = [];
        this.options = options;
        this.schema = null;
        this.tagPrefixes = [];
        this.version = null;
        this.warnings = [];
    }
    add(value) {
        $69078fac725591aa$var$assertCollection(this.contents);
        return this.contents.add(value);
    }
    addIn(path, value) {
        $69078fac725591aa$var$assertCollection(this.contents);
        this.contents.addIn(path, value);
    }
    delete(key) {
        $69078fac725591aa$var$assertCollection(this.contents);
        return this.contents.delete(key);
    }
    deleteIn(path) {
        if ((0, $fPQpe.e)(path)) {
            if (this.contents == null) return false;
            this.contents = null;
            return true;
        }
        $69078fac725591aa$var$assertCollection(this.contents);
        return this.contents.deleteIn(path);
    }
    getDefaults() {
        return $69078fac725591aa$var$Document$1.defaults[this.version] || $69078fac725591aa$var$Document$1.defaults[this.options.version] || {};
    }
    get(key, keepScalar) {
        return this.contents instanceof (0, $fPQpe.C) ? this.contents.get(key, keepScalar) : undefined;
    }
    getIn(path, keepScalar) {
        if ((0, $fPQpe.e)(path)) return !keepScalar && this.contents instanceof (0, $fPQpe.S) ? this.contents.value : this.contents;
        return this.contents instanceof (0, $fPQpe.C) ? this.contents.getIn(path, keepScalar) : undefined;
    }
    has(key) {
        return this.contents instanceof (0, $fPQpe.C) ? this.contents.has(key) : false;
    }
    hasIn(path) {
        if ((0, $fPQpe.e)(path)) return this.contents !== undefined;
        return this.contents instanceof (0, $fPQpe.C) ? this.contents.hasIn(path) : false;
    }
    set(key, value) {
        $69078fac725591aa$var$assertCollection(this.contents);
        this.contents.set(key, value);
    }
    setIn(path, value) {
        if ((0, $fPQpe.e)(path)) this.contents = value;
        else {
            $69078fac725591aa$var$assertCollection(this.contents);
            this.contents.setIn(path, value);
        }
    }
    setSchema(id, customTags) {
        if (!id && !customTags && this.schema) return;
        if (typeof id === 'number') id = id.toFixed(1);
        if (id === '1.0' || id === '1.1' || id === '1.2') {
            if (this.version) this.version = id;
            else this.options.version = id;
            delete this.options.schema;
        } else if (id && typeof id === 'string') this.options.schema = id;
        if (Array.isArray(customTags)) this.options.customTags = customTags;
        const opt1 = Object.assign({}, this.getDefaults(), this.options);
        this.schema = new (0, $fy1aE.S)(opt1);
    }
    parse(node, prevDoc) {
        if (this.options.keepCstNodes) this.cstNode = node;
        if (this.options.keepNodeTypes) this.type = 'DOCUMENT';
        const { directives: directives = [], contents: contents = [], directivesEndMarker: directivesEndMarker, error: error, valueRange: valueRange } = node;
        if (error) {
            if (!error.source) error.source = this;
            this.errors.push(error);
        }
        $69078fac725591aa$var$parseDirectives(this, directives, prevDoc);
        if (directivesEndMarker) this.directivesEndMarker = true;
        this.range = valueRange ? [
            valueRange.start,
            valueRange.end
        ] : null;
        this.setSchema();
        this.anchors._cstAliases = [];
        $69078fac725591aa$var$parseContents(this, contents);
        this.anchors.resolveNodes();
        if (this.options.prettyErrors) {
            for (const error of this.errors)if (error instanceof (0, $10eVG.c)) error.makePretty();
            for (const warn of this.warnings)if (warn instanceof (0, $10eVG.c)) warn.makePretty();
        }
        return this;
    }
    listNonDefaultTags() {
        return $69078fac725591aa$var$listTagNames(this.contents).filter((t)=>t.indexOf((0, $fy1aE.S).defaultPrefix) !== 0);
    }
    setTagPrefix(handle, prefix) {
        if (handle[0] !== '!' || handle[handle.length - 1] !== '!') throw new Error('Handle must start and end with !');
        if (prefix) {
            const prev = this.tagPrefixes.find((p)=>p.handle === handle);
            if (prev) prev.prefix = prefix;
            else this.tagPrefixes.push({
                handle: handle,
                prefix: prefix
            });
        } else this.tagPrefixes = this.tagPrefixes.filter((p)=>p.handle !== handle);
    }
    toJSON(arg, onAnchor) {
        const { keepBlobsInJSON: keepBlobsInJSON, mapAsMap: mapAsMap, maxAliasCount: maxAliasCount } = this.options;
        const keep = keepBlobsInJSON && (typeof arg !== 'string' || !(this.contents instanceof (0, $fPQpe.S)));
        const ctx = {
            doc: this,
            indentStep: '  ',
            keep: keep,
            mapAsMap: keep && !!mapAsMap,
            maxAliasCount: maxAliasCount,
            stringify: $69078fac725591aa$var$stringify$1 // Requiring directly in Pair would create circular dependencies
        };
        const anchorNames = Object.keys(this.anchors.map);
        if (anchorNames.length > 0) ctx.anchors = new Map(anchorNames.map((name)=>[
                this.anchors.map[name],
                {
                    alias: [],
                    aliasCount: 0,
                    count: 1
                }
            ]));
        const res = (0, $fPQpe.t)(this.contents, arg, ctx);
        if (typeof onAnchor === 'function' && ctx.anchors) for (const { count: count, res: res } of ctx.anchors.values())onAnchor(res, count);
        return res;
    }
    toString() {
        if (this.errors.length > 0) throw new Error('Document with errors cannot be stringified');
        const indentSize = this.options.indent;
        if (!Number.isInteger(indentSize) || indentSize <= 0) {
            const s = JSON.stringify(indentSize);
            throw new Error(`"indent" option must be a positive integer, not ${s}`);
        }
        this.setSchema();
        const lines = [];
        let hasDirectives = false;
        if (this.version) {
            let vd = '%YAML 1.2';
            if (this.schema.name === 'yaml-1.1') {
                if (this.version === '1.0') vd = '%YAML:1.0';
                else if (this.version === '1.1') vd = '%YAML 1.1';
            }
            lines.push(vd);
            hasDirectives = true;
        }
        const tagNames = this.listNonDefaultTags();
        this.tagPrefixes.forEach(({ handle: handle, prefix: prefix })=>{
            if (tagNames.some((t)=>t.indexOf(prefix) === 0)) {
                lines.push(`%TAG ${handle} ${prefix}`);
                hasDirectives = true;
            }
        });
        if (hasDirectives || this.directivesEndMarker) lines.push('---');
        if (this.commentBefore) {
            if (hasDirectives || !this.directivesEndMarker) lines.unshift('');
            lines.unshift(this.commentBefore.replace(/^/gm, '#'));
        }
        const ctx = {
            anchors: Object.create(null),
            doc: this,
            indent: '',
            indentStep: ' '.repeat(indentSize),
            stringify: $69078fac725591aa$var$stringify$1 // Requiring directly in nodes would create circular dependencies
        };
        let chompKeep = false;
        let contentComment = null;
        if (this.contents) {
            if (this.contents instanceof (0, $fPQpe.N)) {
                if (this.contents.spaceBefore && (hasDirectives || this.directivesEndMarker)) lines.push('');
                if (this.contents.commentBefore) lines.push(this.contents.commentBefore.replace(/^/gm, '#'));
                // top-level block scalars need to be indented if followed by a comment
                ctx.forceBlockIndent = !!this.comment;
                contentComment = this.contents.comment;
            }
            const onChompKeep = contentComment ? null : ()=>chompKeep = true;
            const body = $69078fac725591aa$var$stringify$1(this.contents, ctx, ()=>contentComment = null, onChompKeep);
            lines.push((0, $fPQpe.f)(body, '', contentComment));
        } else if (this.contents !== undefined) lines.push($69078fac725591aa$var$stringify$1(this.contents, ctx));
        if (this.comment) {
            if ((!chompKeep || contentComment) && lines[lines.length - 1] !== '') lines.push('');
            lines.push(this.comment.replace(/^/gm, '#'));
        }
        return lines.join('\n') + '\n';
    }
}
(0, $10eVG._)($69078fac725591aa$var$Document$1, "defaults", $69078fac725591aa$var$documentOptions);
function $69078fac725591aa$var$createNode(value, wrapScalars = true, tag) {
    if (tag === undefined && typeof wrapScalars === 'string') {
        tag = wrapScalars;
        wrapScalars = true;
    }
    const options = Object.assign({}, $69078fac725591aa$var$Document$1.defaults[$69078fac725591aa$var$defaultOptions.version], $69078fac725591aa$var$defaultOptions);
    const schema = new (0, $fy1aE.S)(options);
    return schema.createNode(value, wrapScalars, tag);
}
class $69078fac725591aa$var$Document extends $69078fac725591aa$var$Document$1 {
    constructor(options){
        super(Object.assign({}, $69078fac725591aa$var$defaultOptions, options));
    }
}
function $69078fac725591aa$var$parseAllDocuments(src, options) {
    const stream = [];
    let prev;
    for (const cstDoc of (0, $ggmYK.parse)(src)){
        const doc = new $69078fac725591aa$var$Document(options);
        doc.parse(cstDoc, prev);
        stream.push(doc);
        prev = doc;
    }
    return stream;
}
function $69078fac725591aa$var$parseDocument(src, options) {
    const cst = (0, $ggmYK.parse)(src);
    const doc = new $69078fac725591aa$var$Document(options).parse(cst[0]);
    if (cst.length > 1) {
        const errMsg = 'Source contains multiple documents; please use YAML.parseAllDocuments()';
        doc.errors.unshift(new (0, $10eVG.b)(cst[1], errMsg));
    }
    return doc;
}
function $69078fac725591aa$var$parse(src, options) {
    const doc = $69078fac725591aa$var$parseDocument(src, options);
    doc.warnings.forEach((warning)=>(0, $9fMDQ.w)(warning));
    if (doc.errors.length > 0) throw doc.errors[0];
    return doc.toJSON();
}
function $69078fac725591aa$var$stringify(value, options) {
    const doc = new $69078fac725591aa$var$Document(options);
    doc.contents = value;
    return String(doc);
}
const $69078fac725591aa$export$866dfa75bd13a786 = {
    createNode: $69078fac725591aa$var$createNode,
    defaultOptions: $69078fac725591aa$var$defaultOptions,
    Document: $69078fac725591aa$var$Document,
    parse: $69078fac725591aa$var$parse,
    parseAllDocuments: $69078fac725591aa$var$parseAllDocuments,
    parseCST: (0, $ggmYK.parse),
    parseDocument: $69078fac725591aa$var$parseDocument,
    scalarOptions: $69078fac725591aa$var$scalarOptions,
    stringify: $69078fac725591aa$var$stringify
};

});
parcelRegister("ggmYK", function(module, exports) {

$parcel$export(module.exports, "parse", () => $bd6ff712eb378c79$export$98e6a39c04603d36);

var $10eVG = parcelRequire("10eVG");
class $bd6ff712eb378c79$var$BlankLine extends (0, $10eVG.N) {
    constructor(){
        super((0, $10eVG.T).BLANK_LINE);
    }
    /* istanbul ignore next */ get includesTrailingLines() {
        // This is never called from anywhere, but if it were,
        // this is the value it should return.
        return true;
    }
    /**
   * Parses a blank line from the source
   *
   * @param {ParseContext} context
   * @param {number} start - Index of first \n character
   * @returns {number} - Index of the character after this
   */ parse(context, start) {
        this.context = context;
        this.range = new (0, $10eVG.R)(start, start + 1);
        return start + 1;
    }
}
class $bd6ff712eb378c79$var$CollectionItem extends (0, $10eVG.N) {
    constructor(type, props){
        super(type, props);
        this.node = null;
    }
    get includesTrailingLines() {
        return !!this.node && this.node.includesTrailingLines;
    }
    /**
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this
   */ parse(context, start) {
        this.context = context;
        const { parseNode: parseNode, src: src } = context;
        let { atLineStart: atLineStart, lineStart: lineStart } = context;
        if (!atLineStart && this.type === (0, $10eVG.T).SEQ_ITEM) this.error = new (0, $10eVG.b)(this, 'Sequence items must not have preceding content on the same line');
        const indent = atLineStart ? start - lineStart : context.indent;
        let offset = (0, $10eVG.N).endOfWhiteSpace(src, start + 1);
        let ch = src[offset];
        const inlineComment = ch === '#';
        const comments = [];
        let blankLine = null;
        while(ch === '\n' || ch === '#'){
            if (ch === '#') {
                const end = (0, $10eVG.N).endOfLine(src, offset + 1);
                comments.push(new (0, $10eVG.R)(offset, end));
                offset = end;
            } else {
                atLineStart = true;
                lineStart = offset + 1;
                const wsEnd = (0, $10eVG.N).endOfWhiteSpace(src, lineStart);
                if (src[wsEnd] === '\n' && comments.length === 0) {
                    blankLine = new $bd6ff712eb378c79$var$BlankLine();
                    lineStart = blankLine.parse({
                        src: src
                    }, lineStart);
                }
                offset = (0, $10eVG.N).endOfIndent(src, lineStart);
            }
            ch = src[offset];
        }
        if ((0, $10eVG.N).nextNodeIsIndented(ch, offset - (lineStart + indent), this.type !== (0, $10eVG.T).SEQ_ITEM)) this.node = parseNode({
            atLineStart: atLineStart,
            inCollection: false,
            indent: indent,
            lineStart: lineStart,
            parent: this
        }, offset);
        else if (ch && lineStart > start + 1) offset = lineStart - 1;
        if (this.node) {
            if (blankLine) {
                // Only blank lines preceding non-empty nodes are captured. Note that
                // this means that collection item range start indices do not always
                // increase monotonically. -- eemeli/yaml#126
                const items = context.parent.items || context.parent.contents;
                if (items) items.push(blankLine);
            }
            if (comments.length) Array.prototype.push.apply(this.props, comments);
            offset = this.node.range.end;
        } else if (inlineComment) {
            const c = comments[0];
            this.props.push(c);
            offset = c.end;
        } else offset = (0, $10eVG.N).endOfLine(src, start + 1);
        const end = this.node ? this.node.valueRange.end : offset;
        this.valueRange = new (0, $10eVG.R)(start, end);
        return offset;
    }
    setOrigRanges(cr, offset) {
        offset = super.setOrigRanges(cr, offset);
        return this.node ? this.node.setOrigRanges(cr, offset) : offset;
    }
    toString() {
        const { context: { src: src }, node: node, range: range, value: value } = this;
        if (value != null) return value;
        const str = node ? src.slice(range.start, node.range.start) + String(node) : src.slice(range.start, range.end);
        return (0, $10eVG.N).addStringTerminator(src, range.end, str);
    }
}
class $bd6ff712eb378c79$var$Comment extends (0, $10eVG.N) {
    constructor(){
        super((0, $10eVG.T).COMMENT);
    }
    /**
   * Parses a comment line from the source
   *
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this scalar
   */ parse(context, start) {
        this.context = context;
        const offset = this.parseComment(start);
        this.range = new (0, $10eVG.R)(start, offset);
        return offset;
    }
}
function $bd6ff712eb378c79$var$grabCollectionEndComments(node) {
    let cnode = node;
    while(cnode instanceof $bd6ff712eb378c79$var$CollectionItem)cnode = cnode.node;
    if (!(cnode instanceof $bd6ff712eb378c79$var$Collection)) return null;
    const len = cnode.items.length;
    let ci = -1;
    for(let i = len - 1; i >= 0; --i){
        const n = cnode.items[i];
        if (n.type === (0, $10eVG.T).COMMENT) {
            // Keep sufficiently indented comments with preceding node
            const { indent: indent, lineStart: lineStart } = n.context;
            if (indent > 0 && n.range.start >= lineStart + indent) break;
            ci = i;
        } else if (n.type === (0, $10eVG.T).BLANK_LINE) ci = i;
        else break;
    }
    if (ci === -1) return null;
    const ca = cnode.items.splice(ci, len - ci);
    const prevEnd = ca[0].range.start;
    while(true){
        cnode.range.end = prevEnd;
        if (cnode.valueRange && cnode.valueRange.end > prevEnd) cnode.valueRange.end = prevEnd;
        if (cnode === node) break;
        cnode = cnode.context.parent;
    }
    return ca;
}
class $bd6ff712eb378c79$var$Collection extends (0, $10eVG.N) {
    static nextContentHasIndent(src, offset, indent) {
        const lineStart = (0, $10eVG.N).endOfLine(src, offset) + 1;
        offset = (0, $10eVG.N).endOfWhiteSpace(src, lineStart);
        const ch = src[offset];
        if (!ch) return false;
        if (offset >= lineStart + indent) return true;
        if (ch !== '#' && ch !== '\n') return false;
        return $bd6ff712eb378c79$var$Collection.nextContentHasIndent(src, offset, indent);
    }
    constructor(firstItem){
        super(firstItem.type === (0, $10eVG.T).SEQ_ITEM ? (0, $10eVG.T).SEQ : (0, $10eVG.T).MAP);
        for(let i = firstItem.props.length - 1; i >= 0; --i)if (firstItem.props[i].start < firstItem.context.lineStart) {
            // props on previous line are assumed by the collection
            this.props = firstItem.props.slice(0, i + 1);
            firstItem.props = firstItem.props.slice(i + 1);
            const itemRange = firstItem.props[0] || firstItem.valueRange;
            firstItem.range.start = itemRange.start;
            break;
        }
        this.items = [
            firstItem
        ];
        const ec = $bd6ff712eb378c79$var$grabCollectionEndComments(firstItem);
        if (ec) Array.prototype.push.apply(this.items, ec);
    }
    get includesTrailingLines() {
        return this.items.length > 0;
    }
    /**
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this
   */ parse(context, start) {
        this.context = context;
        const { parseNode: parseNode, src: src } = context;
        // It's easier to recalculate lineStart here rather than tracking down the
        // last context from which to read it -- eemeli/yaml#2
        let lineStart = (0, $10eVG.N).startOfLine(src, start);
        const firstItem = this.items[0];
        // First-item context needs to be correct for later comment handling
        // -- eemeli/yaml#17
        firstItem.context.parent = this;
        this.valueRange = (0, $10eVG.R).copy(firstItem.valueRange);
        const indent = firstItem.range.start - firstItem.context.lineStart;
        let offset = start;
        offset = (0, $10eVG.N).normalizeOffset(src, offset);
        let ch = src[offset];
        let atLineStart = (0, $10eVG.N).endOfWhiteSpace(src, lineStart) === offset;
        let prevIncludesTrailingLines = false;
        while(ch){
            while(ch === '\n' || ch === '#'){
                if (atLineStart && ch === '\n' && !prevIncludesTrailingLines) {
                    const blankLine = new $bd6ff712eb378c79$var$BlankLine();
                    offset = blankLine.parse({
                        src: src
                    }, offset);
                    this.valueRange.end = offset;
                    if (offset >= src.length) {
                        ch = null;
                        break;
                    }
                    this.items.push(blankLine);
                    offset -= 1; // blankLine.parse() consumes terminal newline
                } else if (ch === '#') {
                    if (offset < lineStart + indent && !$bd6ff712eb378c79$var$Collection.nextContentHasIndent(src, offset, indent)) return offset;
                    const comment = new $bd6ff712eb378c79$var$Comment();
                    offset = comment.parse({
                        indent: indent,
                        lineStart: lineStart,
                        src: src
                    }, offset);
                    this.items.push(comment);
                    this.valueRange.end = offset;
                    if (offset >= src.length) {
                        ch = null;
                        break;
                    }
                }
                lineStart = offset + 1;
                offset = (0, $10eVG.N).endOfIndent(src, lineStart);
                if ((0, $10eVG.N).atBlank(src, offset)) {
                    const wsEnd = (0, $10eVG.N).endOfWhiteSpace(src, offset);
                    const next = src[wsEnd];
                    if (!next || next === '\n' || next === '#') offset = wsEnd;
                }
                ch = src[offset];
                atLineStart = true;
            }
            if (!ch) break;
            if (offset !== lineStart + indent && (atLineStart || ch !== ':')) {
                if (offset < lineStart + indent) {
                    if (lineStart > start) offset = lineStart;
                    break;
                } else if (!this.error) {
                    const msg = 'All collection items must start at the same column';
                    this.error = new (0, $10eVG.Y)(this, msg);
                }
            }
            if (firstItem.type === (0, $10eVG.T).SEQ_ITEM) {
                if (ch !== '-') {
                    if (lineStart > start) offset = lineStart;
                    break;
                }
            } else if (ch === '-' && !this.error) {
                // map key may start with -, as long as it's followed by a non-whitespace char
                const next = src[offset + 1];
                if (!next || next === '\n' || next === '\t' || next === ' ') {
                    const msg = 'A collection cannot be both a mapping and a sequence';
                    this.error = new (0, $10eVG.Y)(this, msg);
                }
            }
            const node = parseNode({
                atLineStart: atLineStart,
                inCollection: true,
                indent: indent,
                lineStart: lineStart,
                parent: this
            }, offset);
            if (!node) return offset; // at next document start
            this.items.push(node);
            this.valueRange.end = node.valueRange.end;
            offset = (0, $10eVG.N).normalizeOffset(src, node.range.end);
            ch = src[offset];
            atLineStart = false;
            prevIncludesTrailingLines = node.includesTrailingLines;
            // Need to reset lineStart and atLineStart here if preceding node's range
            // has advanced to check the current line's indentation level
            // -- eemeli/yaml#10 & eemeli/yaml#38
            if (ch) {
                let ls = offset - 1;
                let prev = src[ls];
                while(prev === ' ' || prev === '\t')prev = src[--ls];
                if (prev === '\n') {
                    lineStart = ls + 1;
                    atLineStart = true;
                }
            }
            const ec = $bd6ff712eb378c79$var$grabCollectionEndComments(node);
            if (ec) Array.prototype.push.apply(this.items, ec);
        }
        return offset;
    }
    setOrigRanges(cr, offset) {
        offset = super.setOrigRanges(cr, offset);
        this.items.forEach((node)=>{
            offset = node.setOrigRanges(cr, offset);
        });
        return offset;
    }
    toString() {
        const { context: { src: src }, items: items, range: range, value: value } = this;
        if (value != null) return value;
        let str = src.slice(range.start, items[0].range.start) + String(items[0]);
        for(let i = 1; i < items.length; ++i){
            const item = items[i];
            const { atLineStart: atLineStart, indent: indent } = item.context;
            if (atLineStart) for(let i = 0; i < indent; ++i)str += ' ';
            str += String(item);
        }
        return (0, $10eVG.N).addStringTerminator(src, range.end, str);
    }
}
class $bd6ff712eb378c79$var$Directive extends (0, $10eVG.N) {
    constructor(){
        super((0, $10eVG.T).DIRECTIVE);
        this.name = null;
    }
    get parameters() {
        const raw = this.rawValue;
        return raw ? raw.trim().split(/[ \t]+/) : [];
    }
    parseName(start) {
        const { src: src } = this.context;
        let offset = start;
        let ch = src[offset];
        while(ch && ch !== '\n' && ch !== '\t' && ch !== ' ')ch = src[offset += 1];
        this.name = src.slice(start, offset);
        return offset;
    }
    parseParameters(start) {
        const { src: src } = this.context;
        let offset = start;
        let ch = src[offset];
        while(ch && ch !== '\n' && ch !== '#')ch = src[offset += 1];
        this.valueRange = new (0, $10eVG.R)(start, offset);
        return offset;
    }
    parse(context, start) {
        this.context = context;
        let offset = this.parseName(start + 1);
        offset = this.parseParameters(offset);
        offset = this.parseComment(offset);
        this.range = new (0, $10eVG.R)(start, offset);
        return offset;
    }
}
class $bd6ff712eb378c79$var$Document extends (0, $10eVG.N) {
    static startCommentOrEndBlankLine(src, start) {
        const offset = (0, $10eVG.N).endOfWhiteSpace(src, start);
        const ch = src[offset];
        return ch === '#' || ch === '\n' ? offset : start;
    }
    constructor(){
        super((0, $10eVG.T).DOCUMENT);
        this.directives = null;
        this.contents = null;
        this.directivesEndMarker = null;
        this.documentEndMarker = null;
    }
    parseDirectives(start) {
        const { src: src } = this.context;
        this.directives = [];
        let atLineStart = true;
        let hasDirectives = false;
        let offset = start;
        while(!(0, $10eVG.N).atDocumentBoundary(src, offset, (0, $10eVG.C).DIRECTIVES_END)){
            offset = $bd6ff712eb378c79$var$Document.startCommentOrEndBlankLine(src, offset);
            switch(src[offset]){
                case '\n':
                    if (atLineStart) {
                        const blankLine = new $bd6ff712eb378c79$var$BlankLine();
                        offset = blankLine.parse({
                            src: src
                        }, offset);
                        if (offset < src.length) this.directives.push(blankLine);
                    } else {
                        offset += 1;
                        atLineStart = true;
                    }
                    break;
                case '#':
                    {
                        const comment = new $bd6ff712eb378c79$var$Comment();
                        offset = comment.parse({
                            src: src
                        }, offset);
                        this.directives.push(comment);
                        atLineStart = false;
                    }
                    break;
                case '%':
                    {
                        const directive = new $bd6ff712eb378c79$var$Directive();
                        offset = directive.parse({
                            parent: this,
                            src: src
                        }, offset);
                        this.directives.push(directive);
                        hasDirectives = true;
                        atLineStart = false;
                    }
                    break;
                default:
                    if (hasDirectives) this.error = new (0, $10eVG.b)(this, 'Missing directives-end indicator line');
                    else if (this.directives.length > 0) {
                        this.contents = this.directives;
                        this.directives = [];
                    }
                    return offset;
            }
        }
        if (src[offset]) {
            this.directivesEndMarker = new (0, $10eVG.R)(offset, offset + 3);
            return offset + 3;
        }
        if (hasDirectives) this.error = new (0, $10eVG.b)(this, 'Missing directives-end indicator line');
        else if (this.directives.length > 0) {
            this.contents = this.directives;
            this.directives = [];
        }
        return offset;
    }
    parseContents(start) {
        const { parseNode: parseNode, src: src } = this.context;
        if (!this.contents) this.contents = [];
        let lineStart = start;
        while(src[lineStart - 1] === '-')lineStart -= 1;
        let offset = (0, $10eVG.N).endOfWhiteSpace(src, start);
        let atLineStart = lineStart === start;
        this.valueRange = new (0, $10eVG.R)(offset);
        while(!(0, $10eVG.N).atDocumentBoundary(src, offset, (0, $10eVG.C).DOCUMENT_END)){
            switch(src[offset]){
                case '\n':
                    if (atLineStart) {
                        const blankLine = new $bd6ff712eb378c79$var$BlankLine();
                        offset = blankLine.parse({
                            src: src
                        }, offset);
                        if (offset < src.length) this.contents.push(blankLine);
                    } else {
                        offset += 1;
                        atLineStart = true;
                    }
                    lineStart = offset;
                    break;
                case '#':
                    {
                        const comment = new $bd6ff712eb378c79$var$Comment();
                        offset = comment.parse({
                            src: src
                        }, offset);
                        this.contents.push(comment);
                        atLineStart = false;
                    }
                    break;
                default:
                    {
                        const iEnd = (0, $10eVG.N).endOfIndent(src, offset);
                        const context = {
                            atLineStart: atLineStart,
                            indent: -1,
                            inFlow: false,
                            inCollection: false,
                            lineStart: lineStart,
                            parent: this
                        };
                        const node = parseNode(context, iEnd);
                        if (!node) return this.valueRange.end = iEnd; // at next document start
                        this.contents.push(node);
                        offset = node.range.end;
                        atLineStart = false;
                        const ec = $bd6ff712eb378c79$var$grabCollectionEndComments(node);
                        if (ec) Array.prototype.push.apply(this.contents, ec);
                    }
            }
            offset = $bd6ff712eb378c79$var$Document.startCommentOrEndBlankLine(src, offset);
        }
        this.valueRange.end = offset;
        if (src[offset]) {
            this.documentEndMarker = new (0, $10eVG.R)(offset, offset + 3);
            offset += 3;
            if (src[offset]) {
                offset = (0, $10eVG.N).endOfWhiteSpace(src, offset);
                if (src[offset] === '#') {
                    const comment = new $bd6ff712eb378c79$var$Comment();
                    offset = comment.parse({
                        src: src
                    }, offset);
                    this.contents.push(comment);
                }
                switch(src[offset]){
                    case '\n':
                        offset += 1;
                        break;
                    case undefined:
                        break;
                    default:
                        this.error = new (0, $10eVG.Y)(this, 'Document end marker line cannot have a non-comment suffix');
                }
            }
        }
        return offset;
    }
    /**
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this
   */ parse(context, start) {
        context.root = this;
        this.context = context;
        const { src: src } = context;
        let offset = src.charCodeAt(start) === 0xfeff ? start + 1 : start; // skip BOM
        offset = this.parseDirectives(offset);
        offset = this.parseContents(offset);
        return offset;
    }
    setOrigRanges(cr, offset) {
        offset = super.setOrigRanges(cr, offset);
        this.directives.forEach((node)=>{
            offset = node.setOrigRanges(cr, offset);
        });
        if (this.directivesEndMarker) offset = this.directivesEndMarker.setOrigRange(cr, offset);
        this.contents.forEach((node)=>{
            offset = node.setOrigRanges(cr, offset);
        });
        if (this.documentEndMarker) offset = this.documentEndMarker.setOrigRange(cr, offset);
        return offset;
    }
    toString() {
        const { contents: contents, directives: directives, value: value } = this;
        if (value != null) return value;
        let str = directives.join('');
        if (contents.length > 0) {
            if (directives.length > 0 || contents[0].type === (0, $10eVG.T).COMMENT) str += '---\n';
            str += contents.join('');
        }
        if (str[str.length - 1] !== '\n') str += '\n';
        return str;
    }
}
class $bd6ff712eb378c79$var$Alias extends (0, $10eVG.N) {
    /**
   * Parses an *alias from the source
   *
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this scalar
   */ parse(context, start) {
        this.context = context;
        const { src: src } = context;
        let offset = (0, $10eVG.N).endOfIdentifier(src, start + 1);
        this.valueRange = new (0, $10eVG.R)(start + 1, offset);
        offset = (0, $10eVG.N).endOfWhiteSpace(src, offset);
        offset = this.parseComment(offset);
        return offset;
    }
}
const $bd6ff712eb378c79$var$Chomp = {
    CLIP: 'CLIP',
    KEEP: 'KEEP',
    STRIP: 'STRIP'
};
class $bd6ff712eb378c79$var$BlockValue extends (0, $10eVG.N) {
    constructor(type, props){
        super(type, props);
        this.blockIndent = null;
        this.chomping = $bd6ff712eb378c79$var$Chomp.CLIP;
        this.header = null;
    }
    get includesTrailingLines() {
        return this.chomping === $bd6ff712eb378c79$var$Chomp.KEEP;
    }
    get strValue() {
        if (!this.valueRange || !this.context) return null;
        let { start: start, end: end } = this.valueRange;
        const { indent: indent, src: src } = this.context;
        if (this.valueRange.isEmpty()) return '';
        let lastNewLine = null;
        let ch = src[end - 1];
        while(ch === '\n' || ch === '\t' || ch === ' '){
            end -= 1;
            if (end <= start) {
                if (this.chomping === $bd6ff712eb378c79$var$Chomp.KEEP) break;
                else return ''; // probably never happens
            }
            if (ch === '\n') lastNewLine = end;
            ch = src[end - 1];
        }
        let keepStart = end + 1;
        if (lastNewLine) {
            if (this.chomping === $bd6ff712eb378c79$var$Chomp.KEEP) {
                keepStart = lastNewLine;
                end = this.valueRange.end;
            } else end = lastNewLine;
        }
        const bi = indent + this.blockIndent;
        const folded = this.type === (0, $10eVG.T).BLOCK_FOLDED;
        let atStart = true;
        let str = '';
        let sep = '';
        let prevMoreIndented = false;
        for(let i = start; i < end; ++i){
            for(let j = 0; j < bi; ++j){
                if (src[i] !== ' ') break;
                i += 1;
            }
            const ch = src[i];
            if (ch === '\n') {
                if (sep === '\n') str += '\n';
                else sep = '\n';
            } else {
                const lineEnd = (0, $10eVG.N).endOfLine(src, i);
                const line = src.slice(i, lineEnd);
                i = lineEnd;
                if (folded && (ch === ' ' || ch === '\t') && i < keepStart) {
                    if (sep === ' ') sep = '\n';
                    else if (!prevMoreIndented && !atStart && sep === '\n') sep = '\n\n';
                    str += sep + line; //+ ((lineEnd < end && src[lineEnd]) || '')
                    sep = lineEnd < end && src[lineEnd] || '';
                    prevMoreIndented = true;
                } else {
                    str += sep + line;
                    sep = folded && i < keepStart ? ' ' : '\n';
                    prevMoreIndented = false;
                }
                if (atStart && line !== '') atStart = false;
            }
        }
        return this.chomping === $bd6ff712eb378c79$var$Chomp.STRIP ? str : str + '\n';
    }
    parseBlockHeader(start) {
        const { src: src } = this.context;
        let offset = start + 1;
        let bi = '';
        while(true){
            const ch = src[offset];
            switch(ch){
                case '-':
                    this.chomping = $bd6ff712eb378c79$var$Chomp.STRIP;
                    break;
                case '+':
                    this.chomping = $bd6ff712eb378c79$var$Chomp.KEEP;
                    break;
                case '0':
                case '1':
                case '2':
                case '3':
                case '4':
                case '5':
                case '6':
                case '7':
                case '8':
                case '9':
                    bi += ch;
                    break;
                default:
                    this.blockIndent = Number(bi) || null;
                    this.header = new (0, $10eVG.R)(start, offset);
                    return offset;
            }
            offset += 1;
        }
    }
    parseBlockValue(start) {
        const { indent: indent, src: src } = this.context;
        const explicit = !!this.blockIndent;
        let offset = start;
        let valueEnd = start;
        let minBlockIndent = 1;
        for(let ch = src[offset]; ch === '\n'; ch = src[offset]){
            offset += 1;
            if ((0, $10eVG.N).atDocumentBoundary(src, offset)) break;
            const end = (0, $10eVG.N).endOfBlockIndent(src, indent, offset); // should not include tab?
            if (end === null) break;
            const ch = src[end];
            const lineIndent = end - (offset + indent);
            if (!this.blockIndent) {
                // no explicit block indent, none yet detected
                if (src[end] !== '\n') {
                    // first line with non-whitespace content
                    if (lineIndent < minBlockIndent) {
                        const msg = 'Block scalars with more-indented leading empty lines must use an explicit indentation indicator';
                        this.error = new (0, $10eVG.b)(this, msg);
                    }
                    this.blockIndent = lineIndent;
                } else if (lineIndent > minBlockIndent) // empty line with more whitespace
                minBlockIndent = lineIndent;
            } else if (ch && ch !== '\n' && lineIndent < this.blockIndent) {
                if (src[end] === '#') break;
                if (!this.error) {
                    const src = explicit ? 'explicit indentation indicator' : 'first line';
                    const msg = `Block scalars must not be less indented than their ${src}`;
                    this.error = new (0, $10eVG.b)(this, msg);
                }
            }
            if (src[end] === '\n') offset = end;
            else offset = valueEnd = (0, $10eVG.N).endOfLine(src, end);
        }
        if (this.chomping !== $bd6ff712eb378c79$var$Chomp.KEEP) offset = src[valueEnd] ? valueEnd + 1 : valueEnd;
        this.valueRange = new (0, $10eVG.R)(start + 1, offset);
        return offset;
    }
    /**
   * Parses a block value from the source
   *
   * Accepted forms are:
   * ```
   * BS
   * block
   * lines
   *
   * BS #comment
   * block
   * lines
   * ```
   * where the block style BS matches the regexp `[|>][-+1-9]*` and block lines
   * are empty or have an indent level greater than `indent`.
   *
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this block
   */ parse(context, start) {
        this.context = context;
        const { src: src } = context;
        let offset = this.parseBlockHeader(start);
        offset = (0, $10eVG.N).endOfWhiteSpace(src, offset);
        offset = this.parseComment(offset);
        offset = this.parseBlockValue(offset);
        return offset;
    }
    setOrigRanges(cr, offset) {
        offset = super.setOrigRanges(cr, offset);
        return this.header ? this.header.setOrigRange(cr, offset) : offset;
    }
}
class $bd6ff712eb378c79$var$FlowCollection extends (0, $10eVG.N) {
    constructor(type, props){
        super(type, props);
        this.items = null;
    }
    prevNodeIsJsonLike(idx = this.items.length) {
        const node = this.items[idx - 1];
        return !!node && (node.jsonLike || node.type === (0, $10eVG.T).COMMENT && this.prevNodeIsJsonLike(idx - 1));
    }
    /**
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this
   */ parse(context, start) {
        this.context = context;
        const { parseNode: parseNode, src: src } = context;
        let { indent: indent, lineStart: lineStart } = context;
        let char = src[start]; // { or [
        this.items = [
            {
                char: char,
                offset: start
            }
        ];
        let offset = (0, $10eVG.N).endOfWhiteSpace(src, start + 1);
        char = src[offset];
        while(char && char !== ']' && char !== '}'){
            switch(char){
                case '\n':
                    {
                        lineStart = offset + 1;
                        const wsEnd = (0, $10eVG.N).endOfWhiteSpace(src, lineStart);
                        if (src[wsEnd] === '\n') {
                            const blankLine = new $bd6ff712eb378c79$var$BlankLine();
                            lineStart = blankLine.parse({
                                src: src
                            }, lineStart);
                            this.items.push(blankLine);
                        }
                        offset = (0, $10eVG.N).endOfIndent(src, lineStart);
                        if (offset <= lineStart + indent) {
                            char = src[offset];
                            if (offset < lineStart + indent || char !== ']' && char !== '}') {
                                const msg = 'Insufficient indentation in flow collection';
                                this.error = new (0, $10eVG.b)(this, msg);
                            }
                        }
                    }
                    break;
                case ',':
                    this.items.push({
                        char: char,
                        offset: offset
                    });
                    offset += 1;
                    break;
                case '#':
                    {
                        const comment = new $bd6ff712eb378c79$var$Comment();
                        offset = comment.parse({
                            src: src
                        }, offset);
                        this.items.push(comment);
                    }
                    break;
                case '?':
                case ':':
                    {
                        const next = src[offset + 1];
                        if (next === '\n' || next === '\t' || next === ' ' || next === ',' || // in-flow : after JSON-like key does not need to be followed by whitespace
                        char === ':' && this.prevNodeIsJsonLike()) {
                            this.items.push({
                                char: char,
                                offset: offset
                            });
                            offset += 1;
                            break;
                        }
                    }
                // fallthrough
                default:
                    {
                        const node = parseNode({
                            atLineStart: false,
                            inCollection: false,
                            inFlow: true,
                            indent: -1,
                            lineStart: lineStart,
                            parent: this
                        }, offset);
                        if (!node) {
                            // at next document start
                            this.valueRange = new (0, $10eVG.R)(start, offset);
                            return offset;
                        }
                        this.items.push(node);
                        offset = (0, $10eVG.N).normalizeOffset(src, node.range.end);
                    }
            }
            offset = (0, $10eVG.N).endOfWhiteSpace(src, offset);
            char = src[offset];
        }
        this.valueRange = new (0, $10eVG.R)(start, offset + 1);
        if (char) {
            this.items.push({
                char: char,
                offset: offset
            });
            offset = (0, $10eVG.N).endOfWhiteSpace(src, offset + 1);
            offset = this.parseComment(offset);
        }
        return offset;
    }
    setOrigRanges(cr, offset) {
        offset = super.setOrigRanges(cr, offset);
        this.items.forEach((node)=>{
            if (node instanceof (0, $10eVG.N)) offset = node.setOrigRanges(cr, offset);
            else if (cr.length === 0) node.origOffset = node.offset;
            else {
                let i = offset;
                while(i < cr.length){
                    if (cr[i] > node.offset) break;
                    else ++i;
                }
                node.origOffset = node.offset + i;
                offset = i;
            }
        });
        return offset;
    }
    toString() {
        const { context: { src: src }, items: items, range: range, value: value } = this;
        if (value != null) return value;
        const nodes = items.filter((item)=>item instanceof (0, $10eVG.N));
        let str = '';
        let prevEnd = range.start;
        nodes.forEach((node)=>{
            const prefix = src.slice(prevEnd, node.range.start);
            prevEnd = node.range.end;
            str += prefix + String(node);
            if (str[str.length - 1] === '\n' && src[prevEnd - 1] !== '\n' && src[prevEnd] === '\n') // Comment range does not include the terminal newline, but its
            // stringified value does. Without this fix, newlines at comment ends
            // get duplicated.
            prevEnd += 1;
        });
        str += src.slice(prevEnd, range.end);
        return (0, $10eVG.N).addStringTerminator(src, range.end, str);
    }
}
class $bd6ff712eb378c79$var$QuoteDouble extends (0, $10eVG.N) {
    static endOfQuote(src, offset) {
        let ch = src[offset];
        while(ch && ch !== '"'){
            offset += ch === '\\' ? 2 : 1;
            ch = src[offset];
        }
        return offset + 1;
    }
    /**
   * @returns {string | { str: string, errors: YAMLSyntaxError[] }}
   */ get strValue() {
        if (!this.valueRange || !this.context) return null;
        const errors = [];
        const { start: start, end: end } = this.valueRange;
        const { indent: indent, src: src } = this.context;
        if (src[end - 1] !== '"') errors.push(new (0, $10eVG.Y)(this, 'Missing closing "quote'));
        // Using String#replace is too painful with escaped newlines preceded by
        // escaped backslashes; also, this should be faster.
        let str = '';
        for(let i = start + 1; i < end - 1; ++i){
            const ch = src[i];
            if (ch === '\n') {
                if ((0, $10eVG.N).atDocumentBoundary(src, i + 1)) errors.push(new (0, $10eVG.b)(this, 'Document boundary indicators are not allowed within string values'));
                const { fold: fold, offset: offset, error: error } = (0, $10eVG.N).foldNewline(src, i, indent);
                str += fold;
                i = offset;
                if (error) errors.push(new (0, $10eVG.b)(this, 'Multi-line double-quoted string needs to be sufficiently indented'));
            } else if (ch === '\\') {
                i += 1;
                switch(src[i]){
                    case '0':
                        str += '\0';
                        break;
                    // null character
                    case 'a':
                        str += '\x07';
                        break;
                    // bell character
                    case 'b':
                        str += '\b';
                        break;
                    // backspace
                    case 'e':
                        str += '\x1b';
                        break;
                    // escape character
                    case 'f':
                        str += '\f';
                        break;
                    // form feed
                    case 'n':
                        str += '\n';
                        break;
                    // line feed
                    case 'r':
                        str += '\r';
                        break;
                    // carriage return
                    case 't':
                        str += '\t';
                        break;
                    // horizontal tab
                    case 'v':
                        str += '\v';
                        break;
                    // vertical tab
                    case 'N':
                        str += '\u0085';
                        break;
                    // Unicode next line
                    case '_':
                        str += '\u00a0';
                        break;
                    // Unicode non-breaking space
                    case 'L':
                        str += '\u2028';
                        break;
                    // Unicode line separator
                    case 'P':
                        str += '\u2029';
                        break;
                    // Unicode paragraph separator
                    case ' ':
                        str += ' ';
                        break;
                    case '"':
                        str += '"';
                        break;
                    case '/':
                        str += '/';
                        break;
                    case '\\':
                        str += '\\';
                        break;
                    case '\t':
                        str += '\t';
                        break;
                    case 'x':
                        str += this.parseCharCode(i + 1, 2, errors);
                        i += 2;
                        break;
                    case 'u':
                        str += this.parseCharCode(i + 1, 4, errors);
                        i += 4;
                        break;
                    case 'U':
                        str += this.parseCharCode(i + 1, 8, errors);
                        i += 8;
                        break;
                    case '\n':
                        // skip escaped newlines, but still trim the following line
                        while(src[i + 1] === ' ' || src[i + 1] === '\t')i += 1;
                        break;
                    default:
                        errors.push(new (0, $10eVG.Y)(this, `Invalid escape sequence ${src.substr(i - 1, 2)}`));
                        str += '\\' + src[i];
                }
            } else if (ch === ' ' || ch === '\t') {
                // trim trailing whitespace
                const wsStart = i;
                let next = src[i + 1];
                while(next === ' ' || next === '\t'){
                    i += 1;
                    next = src[i + 1];
                }
                if (next !== '\n') str += i > wsStart ? src.slice(wsStart, i + 1) : ch;
            } else str += ch;
        }
        return errors.length > 0 ? {
            errors: errors,
            str: str
        } : str;
    }
    parseCharCode(offset, length, errors) {
        const { src: src } = this.context;
        const cc = src.substr(offset, length);
        const ok = cc.length === length && /^[0-9a-fA-F]+$/.test(cc);
        const code = ok ? parseInt(cc, 16) : NaN;
        if (isNaN(code)) {
            errors.push(new (0, $10eVG.Y)(this, `Invalid escape sequence ${src.substr(offset - 2, length + 2)}`));
            return src.substr(offset - 2, length + 2);
        }
        return String.fromCodePoint(code);
    }
    /**
   * Parses a "double quoted" value from the source
   *
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this scalar
   */ parse(context, start) {
        this.context = context;
        const { src: src } = context;
        let offset = $bd6ff712eb378c79$var$QuoteDouble.endOfQuote(src, start + 1);
        this.valueRange = new (0, $10eVG.R)(start, offset);
        offset = (0, $10eVG.N).endOfWhiteSpace(src, offset);
        offset = this.parseComment(offset);
        return offset;
    }
}
class $bd6ff712eb378c79$var$QuoteSingle extends (0, $10eVG.N) {
    static endOfQuote(src, offset) {
        let ch = src[offset];
        while(ch)if (ch === "'") {
            if (src[offset + 1] !== "'") break;
            ch = src[offset += 2];
        } else ch = src[offset += 1];
        return offset + 1;
    }
    /**
   * @returns {string | { str: string, errors: YAMLSyntaxError[] }}
   */ get strValue() {
        if (!this.valueRange || !this.context) return null;
        const errors = [];
        const { start: start, end: end } = this.valueRange;
        const { indent: indent, src: src } = this.context;
        if (src[end - 1] !== "'") errors.push(new (0, $10eVG.Y)(this, "Missing closing 'quote"));
        let str = '';
        for(let i = start + 1; i < end - 1; ++i){
            const ch = src[i];
            if (ch === '\n') {
                if ((0, $10eVG.N).atDocumentBoundary(src, i + 1)) errors.push(new (0, $10eVG.b)(this, 'Document boundary indicators are not allowed within string values'));
                const { fold: fold, offset: offset, error: error } = (0, $10eVG.N).foldNewline(src, i, indent);
                str += fold;
                i = offset;
                if (error) errors.push(new (0, $10eVG.b)(this, 'Multi-line single-quoted string needs to be sufficiently indented'));
            } else if (ch === "'") {
                str += ch;
                i += 1;
                if (src[i] !== "'") errors.push(new (0, $10eVG.Y)(this, 'Unescaped single quote? This should not happen.'));
            } else if (ch === ' ' || ch === '\t') {
                // trim trailing whitespace
                const wsStart = i;
                let next = src[i + 1];
                while(next === ' ' || next === '\t'){
                    i += 1;
                    next = src[i + 1];
                }
                if (next !== '\n') str += i > wsStart ? src.slice(wsStart, i + 1) : ch;
            } else str += ch;
        }
        return errors.length > 0 ? {
            errors: errors,
            str: str
        } : str;
    }
    /**
   * Parses a 'single quoted' value from the source
   *
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this scalar
   */ parse(context, start) {
        this.context = context;
        const { src: src } = context;
        let offset = $bd6ff712eb378c79$var$QuoteSingle.endOfQuote(src, start + 1);
        this.valueRange = new (0, $10eVG.R)(start, offset);
        offset = (0, $10eVG.N).endOfWhiteSpace(src, offset);
        offset = this.parseComment(offset);
        return offset;
    }
}
function $bd6ff712eb378c79$var$createNewNode(type, props) {
    switch(type){
        case (0, $10eVG.T).ALIAS:
            return new $bd6ff712eb378c79$var$Alias(type, props);
        case (0, $10eVG.T).BLOCK_FOLDED:
        case (0, $10eVG.T).BLOCK_LITERAL:
            return new $bd6ff712eb378c79$var$BlockValue(type, props);
        case (0, $10eVG.T).FLOW_MAP:
        case (0, $10eVG.T).FLOW_SEQ:
            return new $bd6ff712eb378c79$var$FlowCollection(type, props);
        case (0, $10eVG.T).MAP_KEY:
        case (0, $10eVG.T).MAP_VALUE:
        case (0, $10eVG.T).SEQ_ITEM:
            return new $bd6ff712eb378c79$var$CollectionItem(type, props);
        case (0, $10eVG.T).COMMENT:
        case (0, $10eVG.T).PLAIN:
            return new (0, $10eVG.P)(type, props);
        case (0, $10eVG.T).QUOTE_DOUBLE:
            return new $bd6ff712eb378c79$var$QuoteDouble(type, props);
        case (0, $10eVG.T).QUOTE_SINGLE:
            return new $bd6ff712eb378c79$var$QuoteSingle(type, props);
        /* istanbul ignore next */ default:
            return null;
    }
}
/**
 * @param {boolean} atLineStart - Node starts at beginning of line
 * @param {boolean} inFlow - true if currently in a flow context
 * @param {boolean} inCollection - true if currently in a collection context
 * @param {number} indent - Current level of indentation
 * @param {number} lineStart - Start of the current line
 * @param {Node} parent - The parent of the node
 * @param {string} src - Source of the YAML document
 */ class $bd6ff712eb378c79$var$ParseContext {
    static parseType(src, offset, inFlow) {
        switch(src[offset]){
            case '*':
                return (0, $10eVG.T).ALIAS;
            case '>':
                return (0, $10eVG.T).BLOCK_FOLDED;
            case '|':
                return (0, $10eVG.T).BLOCK_LITERAL;
            case '{':
                return (0, $10eVG.T).FLOW_MAP;
            case '[':
                return (0, $10eVG.T).FLOW_SEQ;
            case '?':
                return !inFlow && (0, $10eVG.N).atBlank(src, offset + 1, true) ? (0, $10eVG.T).MAP_KEY : (0, $10eVG.T).PLAIN;
            case ':':
                return !inFlow && (0, $10eVG.N).atBlank(src, offset + 1, true) ? (0, $10eVG.T).MAP_VALUE : (0, $10eVG.T).PLAIN;
            case '-':
                return !inFlow && (0, $10eVG.N).atBlank(src, offset + 1, true) ? (0, $10eVG.T).SEQ_ITEM : (0, $10eVG.T).PLAIN;
            case '"':
                return (0, $10eVG.T).QUOTE_DOUBLE;
            case "'":
                return (0, $10eVG.T).QUOTE_SINGLE;
            default:
                return (0, $10eVG.T).PLAIN;
        }
    }
    constructor(orig = {}, { atLineStart: atLineStart, inCollection: inCollection, inFlow: inFlow, indent: indent, lineStart: lineStart, parent: parent } = {}){
        /**
     * Parses a node from the source
     * @param {ParseContext} overlay
     * @param {number} start - Index of first non-whitespace character for the node
     * @returns {?Node} - null if at a document boundary
     */ (0, $10eVG._)(this, "parseNode", (overlay, start)=>{
            if ((0, $10eVG.N).atDocumentBoundary(this.src, start)) return null;
            const context = new $bd6ff712eb378c79$var$ParseContext(this, overlay);
            const { props: props, type: type, valueStart: valueStart } = context.parseProps(start);
            const node = $bd6ff712eb378c79$var$createNewNode(type, props);
            let offset = start;
            try {
                offset = node.parse(context, valueStart);
            } catch (error) {
                const msg = error instanceof Error ? error.message : String(error);
                if (!node.error) node.error = new (0, $10eVG.Y)(node, msg);
            }
            node.range = new (0, $10eVG.R)(start, offset);
            /* istanbul ignore if */ if (offset <= start) {
                // This should never happen, but if it does, let's make sure to at least
                // step one character forward to avoid a busy loop.
                if (!node.error) node.error = new Error(`Node#parse consumed no characters`);
                node.error.parseEnd = offset;
                node.error.source = node;
                node.range.end = start + 1;
            }
            if (context.nodeStartsCollection(node)) {
                if (!node.error && !context.atLineStart && context.parent.type === (0, $10eVG.T).DOCUMENT) node.error = new (0, $10eVG.Y)(node, 'Block collection must not have preceding content here (e.g. directives-end indicator)');
                const collection = new $bd6ff712eb378c79$var$Collection(node);
                offset = collection.parse(new $bd6ff712eb378c79$var$ParseContext(context), offset);
                collection.range = new (0, $10eVG.R)(start, offset);
                return collection;
            }
            return node;
        });
        this.atLineStart = atLineStart != null ? atLineStart : orig.atLineStart || false;
        this.inCollection = inCollection != null ? inCollection : orig.inCollection || false;
        this.inFlow = inFlow != null ? inFlow : orig.inFlow || false;
        this.indent = indent != null ? indent : orig.indent;
        this.lineStart = lineStart != null ? lineStart : orig.lineStart;
        this.parent = parent != null ? parent : orig.parent || {};
        this.root = orig.root;
        this.src = orig.src;
    }
    nodeStartsCollection(node) {
        const { inCollection: inCollection, inFlow: inFlow, src: src } = this;
        if (inCollection || inFlow) return false;
        if (node instanceof $bd6ff712eb378c79$var$CollectionItem) return true;
        // check for implicit key
        let offset = node.range.end;
        if (src[offset] === '\n' || src[offset - 1] === '\n') return false;
        offset = (0, $10eVG.N).endOfWhiteSpace(src, offset);
        return src[offset] === ':';
    }
    // Anchor and tag are before type, which determines the node implementation
    // class; hence this intermediate step.
    parseProps(offset) {
        const { inFlow: inFlow, parent: parent, src: src } = this;
        const props = [];
        let lineHasProps = false;
        offset = this.atLineStart ? (0, $10eVG.N).endOfIndent(src, offset) : (0, $10eVG.N).endOfWhiteSpace(src, offset);
        let ch = src[offset];
        while(ch === (0, $10eVG.C).ANCHOR || ch === (0, $10eVG.C).COMMENT || ch === (0, $10eVG.C).TAG || ch === '\n'){
            if (ch === '\n') {
                let inEnd = offset;
                let lineStart;
                do {
                    lineStart = inEnd + 1;
                    inEnd = (0, $10eVG.N).endOfIndent(src, lineStart);
                }while (src[inEnd] === '\n');
                const indentDiff = inEnd - (lineStart + this.indent);
                const noIndicatorAsIndent = parent.type === (0, $10eVG.T).SEQ_ITEM && parent.context.atLineStart;
                if (src[inEnd] !== '#' && !(0, $10eVG.N).nextNodeIsIndented(src[inEnd], indentDiff, !noIndicatorAsIndent)) break;
                this.atLineStart = true;
                this.lineStart = lineStart;
                lineHasProps = false;
                offset = inEnd;
            } else if (ch === (0, $10eVG.C).COMMENT) {
                const end = (0, $10eVG.N).endOfLine(src, offset + 1);
                props.push(new (0, $10eVG.R)(offset, end));
                offset = end;
            } else {
                let end = (0, $10eVG.N).endOfIdentifier(src, offset + 1);
                if (ch === (0, $10eVG.C).TAG && src[end] === ',' && /^[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+,\d\d\d\d(-\d\d){0,2}\/\S/.test(src.slice(offset + 1, end + 13))) // Let's presume we're dealing with a YAML 1.0 domain tag here, rather
                // than an empty but 'foo.bar' private-tagged node in a flow collection
                // followed without whitespace by a plain string starting with a year
                // or date divided by something.
                end = (0, $10eVG.N).endOfIdentifier(src, end + 5);
                props.push(new (0, $10eVG.R)(offset, end));
                lineHasProps = true;
                offset = (0, $10eVG.N).endOfWhiteSpace(src, end);
            }
            ch = src[offset];
        }
        // '- &a : b' has an anchor on an empty node
        if (lineHasProps && ch === ':' && (0, $10eVG.N).atBlank(src, offset + 1, true)) offset -= 1;
        const type = $bd6ff712eb378c79$var$ParseContext.parseType(src, offset, inFlow);
        return {
            props: props,
            type: type,
            valueStart: offset
        };
    }
}
// Published as 'yaml/parse-cst'
function $bd6ff712eb378c79$export$98e6a39c04603d36(src) {
    const cr = [];
    if (src.indexOf('\r') !== -1) src = src.replace(/\r\n?/g, (match, offset)=>{
        if (match.length > 1) cr.push(offset);
        return '\n';
    });
    const documents = [];
    let offset = 0;
    do {
        const doc = new $bd6ff712eb378c79$var$Document();
        const context = new $bd6ff712eb378c79$var$ParseContext({
            src: src
        });
        offset = doc.parse(context, offset);
        documents.push(doc);
    }while (offset < src.length);
    documents.setOrigRanges = ()=>{
        if (cr.length === 0) return false;
        for(let i = 1; i < cr.length; ++i)cr[i] -= i;
        let crOffset = 0;
        for(let i = 0; i < documents.length; ++i)crOffset = documents[i].setOrigRanges(cr, crOffset);
        cr.splice(0, cr.length);
        return true;
    };
    documents.toString = ()=>documents.join('...\n');
    return documents;
}

});
parcelRegister("10eVG", function(module, exports) {

$parcel$export(module.exports, "C", () => $0bb15f34ef9d96b3$export$e7094788287c5e9b);
$parcel$export(module.exports, "T", () => $0bb15f34ef9d96b3$export$971d5caa766a69d7);
$parcel$export(module.exports, "d", () => $0bb15f34ef9d96b3$export$4368d992c4eafac0);
$parcel$export(module.exports, "e", () => $0bb15f34ef9d96b3$export$f1e1789686576879);
$parcel$export(module.exports, "R", () => $0bb15f34ef9d96b3$export$db202ddc8be9136);
$parcel$export(module.exports, "N", () => $0bb15f34ef9d96b3$export$a07804094c3ecf2d);
$parcel$export(module.exports, "c", () => $0bb15f34ef9d96b3$export$db3b6bfb95261072);
$parcel$export(module.exports, "f", () => $0bb15f34ef9d96b3$export$2d1720544b23b823);
$parcel$export(module.exports, "b", () => $0bb15f34ef9d96b3$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "Y", () => $0bb15f34ef9d96b3$export$8743009a87fcb00f);
$parcel$export(module.exports, "a", () => $0bb15f34ef9d96b3$export$407448d2b89b1813);
$parcel$export(module.exports, "_", () => $0bb15f34ef9d96b3$export$71511d61b312f219);
$parcel$export(module.exports, "P", () => $0bb15f34ef9d96b3$export$56c0d5a1e737357d);
const $0bb15f34ef9d96b3$export$e7094788287c5e9b = {
    ANCHOR: '&',
    COMMENT: '#',
    TAG: '!',
    DIRECTIVES_END: '-',
    DOCUMENT_END: '.'
};
const $0bb15f34ef9d96b3$export$971d5caa766a69d7 = {
    ALIAS: 'ALIAS',
    BLANK_LINE: 'BLANK_LINE',
    BLOCK_FOLDED: 'BLOCK_FOLDED',
    BLOCK_LITERAL: 'BLOCK_LITERAL',
    COMMENT: 'COMMENT',
    DIRECTIVE: 'DIRECTIVE',
    DOCUMENT: 'DOCUMENT',
    FLOW_MAP: 'FLOW_MAP',
    FLOW_SEQ: 'FLOW_SEQ',
    MAP: 'MAP',
    MAP_KEY: 'MAP_KEY',
    MAP_VALUE: 'MAP_VALUE',
    PLAIN: 'PLAIN',
    QUOTE_DOUBLE: 'QUOTE_DOUBLE',
    QUOTE_SINGLE: 'QUOTE_SINGLE',
    SEQ: 'SEQ',
    SEQ_ITEM: 'SEQ_ITEM'
};
const $0bb15f34ef9d96b3$export$4368d992c4eafac0 = 'tag:yaml.org,2002:';
const $0bb15f34ef9d96b3$export$f1e1789686576879 = {
    MAP: 'tag:yaml.org,2002:map',
    SEQ: 'tag:yaml.org,2002:seq',
    STR: 'tag:yaml.org,2002:str'
};
function $0bb15f34ef9d96b3$var$findLineStarts(src) {
    const ls = [
        0
    ];
    let offset = src.indexOf('\n');
    while(offset !== -1){
        offset += 1;
        ls.push(offset);
        offset = src.indexOf('\n', offset);
    }
    return ls;
}
function $0bb15f34ef9d96b3$var$getSrcInfo(cst) {
    let lineStarts, src;
    if (typeof cst === 'string') {
        lineStarts = $0bb15f34ef9d96b3$var$findLineStarts(cst);
        src = cst;
    } else {
        if (Array.isArray(cst)) cst = cst[0];
        if (cst && cst.context) {
            if (!cst.lineStarts) cst.lineStarts = $0bb15f34ef9d96b3$var$findLineStarts(cst.context.src);
            lineStarts = cst.lineStarts;
            src = cst.context.src;
        }
    }
    return {
        lineStarts: lineStarts,
        src: src
    };
}
/**
 * @typedef {Object} LinePos - One-indexed position in the source
 * @property {number} line
 * @property {number} col
 */ /**
 * Determine the line/col position matching a character offset.
 *
 * Accepts a source string or a CST document as the second parameter. With
 * the latter, starting indices for lines are cached in the document as
 * `lineStarts: number[]`.
 *
 * Returns a one-indexed `{ line, col }` location if found, or
 * `undefined` otherwise.
 *
 * @param {number} offset
 * @param {string|Document|Document[]} cst
 * @returns {?LinePos}
 */ function $0bb15f34ef9d96b3$var$getLinePos(offset, cst) {
    if (typeof offset !== 'number' || offset < 0) return null;
    const { lineStarts: lineStarts, src: src } = $0bb15f34ef9d96b3$var$getSrcInfo(cst);
    if (!lineStarts || !src || offset > src.length) return null;
    for(let i = 0; i < lineStarts.length; ++i){
        const start = lineStarts[i];
        if (offset < start) return {
            line: i,
            col: offset - lineStarts[i - 1] + 1
        };
        if (offset === start) return {
            line: i + 1,
            col: 1
        };
    }
    const line = lineStarts.length;
    return {
        line: line,
        col: offset - lineStarts[line - 1] + 1
    };
}
/**
 * Get a specified line from the source.
 *
 * Accepts a source string or a CST document as the second parameter. With
 * the latter, starting indices for lines are cached in the document as
 * `lineStarts: number[]`.
 *
 * Returns the line as a string if found, or `null` otherwise.
 *
 * @param {number} line One-indexed line number
 * @param {string|Document|Document[]} cst
 * @returns {?string}
 */ function $0bb15f34ef9d96b3$var$getLine(line, cst) {
    const { lineStarts: lineStarts, src: src } = $0bb15f34ef9d96b3$var$getSrcInfo(cst);
    if (!lineStarts || !(line >= 1) || line > lineStarts.length) return null;
    const start = lineStarts[line - 1];
    let end = lineStarts[line]; // undefined for last line; that's ok for slice()
    while(end && end > start && src[end - 1] === '\n')--end;
    return src.slice(start, end);
}
/**
 * Pretty-print the starting line from the source indicated by the range `pos`
 *
 * Trims output to `maxWidth` chars while keeping the starting column visible,
 * using `…` at either end to indicate dropped characters.
 *
 * Returns a two-line string (or `null`) with `\n` as separator; the second line
 * will hold appropriately indented `^` marks indicating the column range.
 *
 * @param {Object} pos
 * @param {LinePos} pos.start
 * @param {LinePos} [pos.end]
 * @param {string|Document|Document[]*} cst
 * @param {number} [maxWidth=80]
 * @returns {?string}
 */ function $0bb15f34ef9d96b3$var$getPrettyContext({ start: start, end: end }, cst, maxWidth = 80) {
    let src = $0bb15f34ef9d96b3$var$getLine(start.line, cst);
    if (!src) return null;
    let { col: col } = start;
    if (src.length > maxWidth) {
        if (col <= maxWidth - 10) src = src.substr(0, maxWidth - 1) + "\u2026";
        else {
            const halfWidth = Math.round(maxWidth / 2);
            if (src.length > col + halfWidth) src = src.substr(0, col + halfWidth - 1) + "\u2026";
            col -= src.length - maxWidth;
            src = "\u2026" + src.substr(1 - maxWidth);
        }
    }
    let errLen = 1;
    let errEnd = '';
    if (end) {
        if (end.line === start.line && col + (end.col - start.col) <= maxWidth + 1) errLen = end.col - start.col;
        else {
            errLen = Math.min(src.length + 1, maxWidth) - col;
            errEnd = "\u2026";
        }
    }
    const offset = col > 1 ? ' '.repeat(col - 1) : '';
    const err = '^'.repeat(errLen);
    return `${src}\n${offset}${err}${errEnd}`;
}
class $0bb15f34ef9d96b3$export$db202ddc8be9136 {
    static copy(orig) {
        return new $0bb15f34ef9d96b3$export$db202ddc8be9136(orig.start, orig.end);
    }
    constructor(start, end){
        this.start = start;
        this.end = end || start;
    }
    isEmpty() {
        return typeof this.start !== 'number' || !this.end || this.end <= this.start;
    }
    /**
   * Set `origStart` and `origEnd` to point to the original source range for
   * this node, which may differ due to dropped CR characters.
   *
   * @param {number[]} cr - Positions of dropped CR characters
   * @param {number} offset - Starting index of `cr` from the last call
   * @returns {number} - The next offset, matching the one found for `origStart`
   */ setOrigRange(cr, offset) {
        const { start: start, end: end } = this;
        if (cr.length === 0 || end <= cr[0]) {
            this.origStart = start;
            this.origEnd = end;
            return offset;
        }
        let i = offset;
        while(i < cr.length){
            if (cr[i] > start) break;
            else ++i;
        }
        this.origStart = start + i;
        const nextOffset = i;
        while(i < cr.length){
            // if end was at \n, it should now be at \r
            if (cr[i] >= end) break;
            else ++i;
        }
        this.origEnd = end + i;
        return nextOffset;
    }
}
/** Root class of all nodes */ class $0bb15f34ef9d96b3$export$a07804094c3ecf2d {
    static addStringTerminator(src, offset, str) {
        if (str[str.length - 1] === '\n') return str;
        const next = $0bb15f34ef9d96b3$export$a07804094c3ecf2d.endOfWhiteSpace(src, offset);
        return next >= src.length || src[next] === '\n' ? str + '\n' : str;
    }
    // ^(---|...)
    static atDocumentBoundary(src, offset, sep) {
        const ch0 = src[offset];
        if (!ch0) return true;
        const prev = src[offset - 1];
        if (prev && prev !== '\n') return false;
        if (sep) {
            if (ch0 !== sep) return false;
        } else {
            if (ch0 !== $0bb15f34ef9d96b3$export$e7094788287c5e9b.DIRECTIVES_END && ch0 !== $0bb15f34ef9d96b3$export$e7094788287c5e9b.DOCUMENT_END) return false;
        }
        const ch1 = src[offset + 1];
        const ch2 = src[offset + 2];
        if (ch1 !== ch0 || ch2 !== ch0) return false;
        const ch3 = src[offset + 3];
        return !ch3 || ch3 === '\n' || ch3 === '\t' || ch3 === ' ';
    }
    static endOfIdentifier(src, offset) {
        let ch = src[offset];
        const isVerbatim = ch === '<';
        const notOk = isVerbatim ? [
            '\n',
            '\t',
            ' ',
            '>'
        ] : [
            '\n',
            '\t',
            ' ',
            '[',
            ']',
            '{',
            '}',
            ','
        ];
        while(ch && notOk.indexOf(ch) === -1)ch = src[offset += 1];
        if (isVerbatim && ch === '>') offset += 1;
        return offset;
    }
    static endOfIndent(src, offset) {
        let ch = src[offset];
        while(ch === ' ')ch = src[offset += 1];
        return offset;
    }
    static endOfLine(src, offset) {
        let ch = src[offset];
        while(ch && ch !== '\n')ch = src[offset += 1];
        return offset;
    }
    static endOfWhiteSpace(src, offset) {
        let ch = src[offset];
        while(ch === '\t' || ch === ' ')ch = src[offset += 1];
        return offset;
    }
    static startOfLine(src, offset) {
        let ch = src[offset - 1];
        if (ch === '\n') return offset;
        while(ch && ch !== '\n')ch = src[offset -= 1];
        return offset + 1;
    }
    /**
   * End of indentation, or null if the line's indent level is not more
   * than `indent`
   *
   * @param {string} src
   * @param {number} indent
   * @param {number} lineStart
   * @returns {?number}
   */ static endOfBlockIndent(src, indent, lineStart) {
        const inEnd = $0bb15f34ef9d96b3$export$a07804094c3ecf2d.endOfIndent(src, lineStart);
        if (inEnd > lineStart + indent) return inEnd;
        else {
            const wsEnd = $0bb15f34ef9d96b3$export$a07804094c3ecf2d.endOfWhiteSpace(src, inEnd);
            const ch = src[wsEnd];
            if (!ch || ch === '\n') return wsEnd;
        }
        return null;
    }
    static atBlank(src, offset, endAsBlank) {
        const ch = src[offset];
        return ch === '\n' || ch === '\t' || ch === ' ' || endAsBlank && !ch;
    }
    static nextNodeIsIndented(ch, indentDiff, indicatorAsIndent) {
        if (!ch || indentDiff < 0) return false;
        if (indentDiff > 0) return true;
        return indicatorAsIndent && ch === '-';
    }
    // should be at line or string end, or at next non-whitespace char
    static normalizeOffset(src, offset) {
        const ch = src[offset];
        return !ch ? offset : ch !== '\n' && src[offset - 1] === '\n' ? offset - 1 : $0bb15f34ef9d96b3$export$a07804094c3ecf2d.endOfWhiteSpace(src, offset);
    }
    // fold single newline into space, multiple newlines to N - 1 newlines
    // presumes src[offset] === '\n'
    static foldNewline(src, offset, indent) {
        let inCount = 0;
        let error = false;
        let fold = '';
        let ch = src[offset + 1];
        while(ch === ' ' || ch === '\t' || ch === '\n'){
            switch(ch){
                case '\n':
                    inCount = 0;
                    offset += 1;
                    fold += '\n';
                    break;
                case '\t':
                    if (inCount <= indent) error = true;
                    offset = $0bb15f34ef9d96b3$export$a07804094c3ecf2d.endOfWhiteSpace(src, offset + 2) - 1;
                    break;
                case ' ':
                    inCount += 1;
                    offset += 1;
                    break;
            }
            ch = src[offset + 1];
        }
        if (!fold) fold = ' ';
        if (ch && inCount <= indent) error = true;
        return {
            fold: fold,
            offset: offset,
            error: error
        };
    }
    constructor(type, props, context){
        Object.defineProperty(this, 'context', {
            value: context || null,
            writable: true
        });
        this.error = null;
        this.range = null;
        this.valueRange = null;
        this.props = props || [];
        this.type = type;
        this.value = null;
    }
    getPropValue(idx, key, skipKey) {
        if (!this.context) return null;
        const { src: src } = this.context;
        const prop = this.props[idx];
        return prop && src[prop.start] === key ? src.slice(prop.start + (skipKey ? 1 : 0), prop.end) : null;
    }
    get anchor() {
        for(let i = 0; i < this.props.length; ++i){
            const anchor = this.getPropValue(i, $0bb15f34ef9d96b3$export$e7094788287c5e9b.ANCHOR, true);
            if (anchor != null) return anchor;
        }
        return null;
    }
    get comment() {
        const comments = [];
        for(let i = 0; i < this.props.length; ++i){
            const comment = this.getPropValue(i, $0bb15f34ef9d96b3$export$e7094788287c5e9b.COMMENT, true);
            if (comment != null) comments.push(comment);
        }
        return comments.length > 0 ? comments.join('\n') : null;
    }
    commentHasRequiredWhitespace(start) {
        const { src: src } = this.context;
        if (this.header && start === this.header.end) return false;
        if (!this.valueRange) return false;
        const { end: end } = this.valueRange;
        return start !== end || $0bb15f34ef9d96b3$export$a07804094c3ecf2d.atBlank(src, end - 1);
    }
    get hasComment() {
        if (this.context) {
            const { src: src } = this.context;
            for(let i = 0; i < this.props.length; ++i){
                if (src[this.props[i].start] === $0bb15f34ef9d96b3$export$e7094788287c5e9b.COMMENT) return true;
            }
        }
        return false;
    }
    get hasProps() {
        if (this.context) {
            const { src: src } = this.context;
            for(let i = 0; i < this.props.length; ++i){
                if (src[this.props[i].start] !== $0bb15f34ef9d96b3$export$e7094788287c5e9b.COMMENT) return true;
            }
        }
        return false;
    }
    get includesTrailingLines() {
        return false;
    }
    get jsonLike() {
        const jsonLikeTypes = [
            $0bb15f34ef9d96b3$export$971d5caa766a69d7.FLOW_MAP,
            $0bb15f34ef9d96b3$export$971d5caa766a69d7.FLOW_SEQ,
            $0bb15f34ef9d96b3$export$971d5caa766a69d7.QUOTE_DOUBLE,
            $0bb15f34ef9d96b3$export$971d5caa766a69d7.QUOTE_SINGLE
        ];
        return jsonLikeTypes.indexOf(this.type) !== -1;
    }
    get rangeAsLinePos() {
        if (!this.range || !this.context) return undefined;
        const start = $0bb15f34ef9d96b3$var$getLinePos(this.range.start, this.context.root);
        if (!start) return undefined;
        const end = $0bb15f34ef9d96b3$var$getLinePos(this.range.end, this.context.root);
        return {
            start: start,
            end: end
        };
    }
    get rawValue() {
        if (!this.valueRange || !this.context) return null;
        const { start: start, end: end } = this.valueRange;
        return this.context.src.slice(start, end);
    }
    get tag() {
        for(let i = 0; i < this.props.length; ++i){
            const tag = this.getPropValue(i, $0bb15f34ef9d96b3$export$e7094788287c5e9b.TAG, false);
            if (tag != null) {
                if (tag[1] === '<') return {
                    verbatim: tag.slice(2, -1)
                };
                else {
                    // eslint-disable-next-line no-unused-vars
                    const [_, handle, suffix] = tag.match(/^(.*!)([^!]*)$/);
                    return {
                        handle: handle,
                        suffix: suffix
                    };
                }
            }
        }
        return null;
    }
    get valueRangeContainsNewline() {
        if (!this.valueRange || !this.context) return false;
        const { start: start, end: end } = this.valueRange;
        const { src: src } = this.context;
        for(let i = start; i < end; ++i){
            if (src[i] === '\n') return true;
        }
        return false;
    }
    parseComment(start) {
        const { src: src } = this.context;
        if (src[start] === $0bb15f34ef9d96b3$export$e7094788287c5e9b.COMMENT) {
            const end = $0bb15f34ef9d96b3$export$a07804094c3ecf2d.endOfLine(src, start + 1);
            const commentRange = new $0bb15f34ef9d96b3$export$db202ddc8be9136(start, end);
            this.props.push(commentRange);
            return end;
        }
        return start;
    }
    /**
   * Populates the `origStart` and `origEnd` values of all ranges for this
   * node. Extended by child classes to handle descendant nodes.
   *
   * @param {number[]} cr - Positions of dropped CR characters
   * @param {number} offset - Starting index of `cr` from the last call
   * @returns {number} - The next offset, matching the one found for `origStart`
   */ setOrigRanges(cr, offset) {
        if (this.range) offset = this.range.setOrigRange(cr, offset);
        if (this.valueRange) this.valueRange.setOrigRange(cr, offset);
        this.props.forEach((prop)=>prop.setOrigRange(cr, offset));
        return offset;
    }
    toString() {
        const { context: { src: src }, range: range, value: value } = this;
        if (value != null) return value;
        const str = src.slice(range.start, range.end);
        return $0bb15f34ef9d96b3$export$a07804094c3ecf2d.addStringTerminator(src, range.end, str);
    }
}
class $0bb15f34ef9d96b3$export$db3b6bfb95261072 extends Error {
    constructor(name, source, message){
        if (!message || !(source instanceof $0bb15f34ef9d96b3$export$a07804094c3ecf2d)) throw new Error(`Invalid arguments for new ${name}`);
        super();
        this.name = name;
        this.message = message;
        this.source = source;
    }
    makePretty() {
        if (!this.source) return;
        this.nodeType = this.source.type;
        const cst = this.source.context && this.source.context.root;
        if (typeof this.offset === 'number') {
            this.range = new $0bb15f34ef9d96b3$export$db202ddc8be9136(this.offset, this.offset + 1);
            const start = cst && $0bb15f34ef9d96b3$var$getLinePos(this.offset, cst);
            if (start) {
                const end = {
                    line: start.line,
                    col: start.col + 1
                };
                this.linePos = {
                    start: start,
                    end: end
                };
            }
            delete this.offset;
        } else {
            this.range = this.source.range;
            this.linePos = this.source.rangeAsLinePos;
        }
        if (this.linePos) {
            const { line: line, col: col } = this.linePos.start;
            this.message += ` at line ${line}, column ${col}`;
            const ctx = cst && $0bb15f34ef9d96b3$var$getPrettyContext(this.linePos, cst);
            if (ctx) this.message += `:\n\n${ctx}\n`;
        }
        delete this.source;
    }
}
class $0bb15f34ef9d96b3$export$2d1720544b23b823 extends $0bb15f34ef9d96b3$export$db3b6bfb95261072 {
    constructor(source, message){
        super('YAMLReferenceError', source, message);
    }
}
class $0bb15f34ef9d96b3$export$8b22cf2602fb60ce extends $0bb15f34ef9d96b3$export$db3b6bfb95261072 {
    constructor(source, message){
        super('YAMLSemanticError', source, message);
    }
}
class $0bb15f34ef9d96b3$export$8743009a87fcb00f extends $0bb15f34ef9d96b3$export$db3b6bfb95261072 {
    constructor(source, message){
        super('YAMLSyntaxError', source, message);
    }
}
class $0bb15f34ef9d96b3$export$407448d2b89b1813 extends $0bb15f34ef9d96b3$export$db3b6bfb95261072 {
    constructor(source, message){
        super('YAMLWarning', source, message);
    }
}
function $0bb15f34ef9d96b3$export$71511d61b312f219(e, r, t) {
    return (r = $0bb15f34ef9d96b3$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0bb15f34ef9d96b3$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0bb15f34ef9d96b3$var$_toPropertyKey(t) {
    var i = $0bb15f34ef9d96b3$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
class $0bb15f34ef9d96b3$export$56c0d5a1e737357d extends $0bb15f34ef9d96b3$export$a07804094c3ecf2d {
    static endOfLine(src, start, inFlow) {
        let ch = src[start];
        let offset = start;
        while(ch && ch !== '\n'){
            if (inFlow && (ch === '[' || ch === ']' || ch === '{' || ch === '}' || ch === ',')) break;
            const next = src[offset + 1];
            if (ch === ':' && (!next || next === '\n' || next === '\t' || next === ' ' || inFlow && next === ',')) break;
            if ((ch === ' ' || ch === '\t') && next === '#') break;
            offset += 1;
            ch = next;
        }
        return offset;
    }
    get strValue() {
        if (!this.valueRange || !this.context) return null;
        let { start: start, end: end } = this.valueRange;
        const { src: src } = this.context;
        let ch = src[end - 1];
        while(start < end && (ch === '\n' || ch === '\t' || ch === ' '))ch = src[--end - 1];
        let str = '';
        for(let i = start; i < end; ++i){
            const ch = src[i];
            if (ch === '\n') {
                const { fold: fold, offset: offset } = $0bb15f34ef9d96b3$export$a07804094c3ecf2d.foldNewline(src, i, -1);
                str += fold;
                i = offset;
            } else if (ch === ' ' || ch === '\t') {
                // trim trailing whitespace
                const wsStart = i;
                let next = src[i + 1];
                while(i < end && (next === ' ' || next === '\t')){
                    i += 1;
                    next = src[i + 1];
                }
                if (next !== '\n') str += i > wsStart ? src.slice(wsStart, i + 1) : ch;
            } else str += ch;
        }
        const ch0 = src[start];
        switch(ch0){
            case '\t':
                {
                    const msg = 'Plain value cannot start with a tab character';
                    const errors = [
                        new $0bb15f34ef9d96b3$export$8b22cf2602fb60ce(this, msg)
                    ];
                    return {
                        errors: errors,
                        str: str
                    };
                }
            case '@':
            case '`':
                {
                    const msg = `Plain value cannot start with reserved character ${ch0}`;
                    const errors = [
                        new $0bb15f34ef9d96b3$export$8b22cf2602fb60ce(this, msg)
                    ];
                    return {
                        errors: errors,
                        str: str
                    };
                }
            default:
                return str;
        }
    }
    parseBlockValue(start) {
        const { indent: indent, inFlow: inFlow, src: src } = this.context;
        let offset = start;
        let valueEnd = start;
        for(let ch = src[offset]; ch === '\n'; ch = src[offset]){
            if ($0bb15f34ef9d96b3$export$a07804094c3ecf2d.atDocumentBoundary(src, offset + 1)) break;
            const end = $0bb15f34ef9d96b3$export$a07804094c3ecf2d.endOfBlockIndent(src, indent, offset + 1);
            if (end === null || src[end] === '#') break;
            if (src[end] === '\n') offset = end;
            else {
                valueEnd = $0bb15f34ef9d96b3$export$56c0d5a1e737357d.endOfLine(src, end, inFlow);
                offset = valueEnd;
            }
        }
        if (this.valueRange.isEmpty()) this.valueRange.start = start;
        this.valueRange.end = valueEnd;
        return valueEnd;
    }
    /**
   * Parses a plain value from the source
   *
   * Accepted forms are:
   * ```
   * #comment
   *
   * first line
   *
   * first line #comment
   *
   * first line
   * block
   * lines
   *
   * #comment
   * block
   * lines
   * ```
   * where block lines are empty or have an indent level greater than `indent`.
   *
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this scalar, may be `\n`
   */ parse(context, start) {
        this.context = context;
        const { inFlow: inFlow, src: src } = context;
        let offset = start;
        const ch = src[offset];
        if (ch && ch !== '#' && ch !== '\n') offset = $0bb15f34ef9d96b3$export$56c0d5a1e737357d.endOfLine(src, start, inFlow);
        this.valueRange = new $0bb15f34ef9d96b3$export$db202ddc8be9136(start, offset);
        offset = $0bb15f34ef9d96b3$export$a07804094c3ecf2d.endOfWhiteSpace(src, offset);
        offset = this.parseComment(offset);
        if (!this.hasComment || this.valueRange.isEmpty()) offset = this.parseBlockValue(offset);
        return offset;
    }
}

});


parcelRegister("fPQpe", function(module, exports) {

$parcel$export(module.exports, "f", () => $b874452e1b501c71$export$2d1720544b23b823);
$parcel$export(module.exports, "N", () => $b874452e1b501c71$export$a07804094c3ecf2d);
$parcel$export(module.exports, "t", () => $b874452e1b501c71$export$625550452a3fa3ec);
$parcel$export(module.exports, "S", () => $b874452e1b501c71$export$25ce5a424b770e84);
$parcel$export(module.exports, "e", () => $b874452e1b501c71$export$f1e1789686576879);
$parcel$export(module.exports, "C", () => $b874452e1b501c71$export$e7094788287c5e9b);
$parcel$export(module.exports, "Y", () => $b874452e1b501c71$export$8743009a87fcb00f);
$parcel$export(module.exports, "P", () => $b874452e1b501c71$export$56c0d5a1e737357d);
$parcel$export(module.exports, "A", () => $b874452e1b501c71$export$ebd11618f299a286);
$parcel$export(module.exports, "l", () => $b874452e1b501c71$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $b874452e1b501c71$export$4368d992c4eafac0);
$parcel$export(module.exports, "M", () => $b874452e1b501c71$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "b", () => $b874452e1b501c71$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "a", () => $b874452e1b501c71$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $b874452e1b501c71$export$23f2a1d2818174ef);
$parcel$export(module.exports, "n", () => $b874452e1b501c71$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "s", () => $b874452e1b501c71$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "c", () => $b874452e1b501c71$export$db3b6bfb95261072);
$parcel$export(module.exports, "k", () => $b874452e1b501c71$export$342063e11d6c3cad);
$parcel$export(module.exports, "j", () => $b874452e1b501c71$export$35e795649ee09318);
$parcel$export(module.exports, "r", () => $b874452e1b501c71$export$43caf9889c228507);
$parcel$export(module.exports, "g", () => $b874452e1b501c71$export$39b482c5e57630a8);
$parcel$export(module.exports, "h", () => $b874452e1b501c71$export$dda1d9f60106f0e9);

var $10eVG = parcelRequire("10eVG");
function $b874452e1b501c71$var$addCommentBefore(str, indent, comment) {
    if (!comment) return str;
    const cc = comment.replace(/[\s\S]^/gm, `$&${indent}#`);
    return `#${cc}\n${indent}${str}`;
}
function $b874452e1b501c71$export$2d1720544b23b823(str, indent, comment) {
    return !comment ? str : comment.indexOf('\n') === -1 ? `${str} #${comment}` : `${str}\n` + comment.replace(/^/gm, `${indent || ''}#`);
}
class $b874452e1b501c71$export$a07804094c3ecf2d {
}
function $b874452e1b501c71$export$625550452a3fa3ec(value, arg, ctx) {
    if (Array.isArray(value)) return value.map((v, i)=>$b874452e1b501c71$export$625550452a3fa3ec(v, String(i), ctx));
    if (value && typeof value.toJSON === 'function') {
        const anchor = ctx && ctx.anchors && ctx.anchors.get(value);
        if (anchor) ctx.onCreate = (res)=>{
            anchor.res = res;
            delete ctx.onCreate;
        };
        const res = value.toJSON(arg, ctx);
        if (anchor && ctx.onCreate) ctx.onCreate(res);
        return res;
    }
    if ((!ctx || !ctx.keep) && typeof value === 'bigint') return Number(value);
    return value;
}
class $b874452e1b501c71$export$25ce5a424b770e84 extends $b874452e1b501c71$export$a07804094c3ecf2d {
    constructor(value){
        super();
        this.value = value;
    }
    toJSON(arg, ctx) {
        return ctx && ctx.keep ? this.value : $b874452e1b501c71$export$625550452a3fa3ec(this.value, arg, ctx);
    }
    toString() {
        return String(this.value);
    }
}
function $b874452e1b501c71$var$collectionFromPath(schema, path, value) {
    let v = value;
    for(let i = path.length - 1; i >= 0; --i){
        const k = path[i];
        if (Number.isInteger(k) && k >= 0) {
            const a = [];
            a[k] = v;
            v = a;
        } else {
            const o = {};
            Object.defineProperty(o, k, {
                value: v,
                writable: true,
                enumerable: true,
                configurable: true
            });
            v = o;
        }
    }
    return schema.createNode(v, false);
}
// null, undefined, or an empty non-string iterable (e.g. [])
const $b874452e1b501c71$export$f1e1789686576879 = (path)=>path == null || typeof path === 'object' && path[Symbol.iterator]().next().done;
class $b874452e1b501c71$export$e7094788287c5e9b extends $b874452e1b501c71$export$a07804094c3ecf2d {
    constructor(schema){
        super();
        (0, $10eVG._)(this, "items", []);
        this.schema = schema;
    }
    addIn(path, value) {
        if ($b874452e1b501c71$export$f1e1789686576879(path)) this.add(value);
        else {
            const [key, ...rest] = path;
            const node = this.get(key, true);
            if (node instanceof $b874452e1b501c71$export$e7094788287c5e9b) node.addIn(rest, value);
            else if (node === undefined && this.schema) this.set(key, $b874452e1b501c71$var$collectionFromPath(this.schema, rest, value));
            else throw new Error(`Expected YAML collection at ${key}. Remaining path: ${rest}`);
        }
    }
    deleteIn([key, ...rest]) {
        if (rest.length === 0) return this.delete(key);
        const node = this.get(key, true);
        if (node instanceof $b874452e1b501c71$export$e7094788287c5e9b) return node.deleteIn(rest);
        else throw new Error(`Expected YAML collection at ${key}. Remaining path: ${rest}`);
    }
    getIn([key, ...rest], keepScalar) {
        const node = this.get(key, true);
        if (rest.length === 0) return !keepScalar && node instanceof $b874452e1b501c71$export$25ce5a424b770e84 ? node.value : node;
        else return node instanceof $b874452e1b501c71$export$e7094788287c5e9b ? node.getIn(rest, keepScalar) : undefined;
    }
    hasAllNullValues() {
        return this.items.every((node)=>{
            if (!node || node.type !== 'PAIR') return false;
            const n = node.value;
            return n == null || n instanceof $b874452e1b501c71$export$25ce5a424b770e84 && n.value == null && !n.commentBefore && !n.comment && !n.tag;
        });
    }
    hasIn([key, ...rest]) {
        if (rest.length === 0) return this.has(key);
        const node = this.get(key, true);
        return node instanceof $b874452e1b501c71$export$e7094788287c5e9b ? node.hasIn(rest) : false;
    }
    setIn([key, ...rest], value) {
        if (rest.length === 0) this.set(key, value);
        else {
            const node = this.get(key, true);
            if (node instanceof $b874452e1b501c71$export$e7094788287c5e9b) node.setIn(rest, value);
            else if (node === undefined && this.schema) this.set(key, $b874452e1b501c71$var$collectionFromPath(this.schema, rest, value));
            else throw new Error(`Expected YAML collection at ${key}. Remaining path: ${rest}`);
        }
    }
    // overridden in implementations
    /* istanbul ignore next */ toJSON() {
        return null;
    }
    toString(ctx, { blockItem: blockItem, flowChars: flowChars, isMap: isMap, itemIndent: itemIndent }, onComment, onChompKeep) {
        const { indent: indent, indentStep: indentStep, stringify: stringify } = ctx;
        const inFlow = this.type === (0, $10eVG.T).FLOW_MAP || this.type === (0, $10eVG.T).FLOW_SEQ || ctx.inFlow;
        if (inFlow) itemIndent += indentStep;
        const allNullValues = isMap && this.hasAllNullValues();
        ctx = Object.assign({}, ctx, {
            allNullValues: allNullValues,
            indent: itemIndent,
            inFlow: inFlow,
            type: null
        });
        let chompKeep = false;
        let hasItemWithNewLine = false;
        const nodes = this.items.reduce((nodes, item, i)=>{
            let comment;
            if (item) {
                if (!chompKeep && item.spaceBefore) nodes.push({
                    type: 'comment',
                    str: ''
                });
                if (item.commentBefore) item.commentBefore.match(/^.*$/gm).forEach((line)=>{
                    nodes.push({
                        type: 'comment',
                        str: `#${line}`
                    });
                });
                if (item.comment) comment = item.comment;
                if (inFlow && (!chompKeep && item.spaceBefore || item.commentBefore || item.comment || item.key && (item.key.commentBefore || item.key.comment) || item.value && (item.value.commentBefore || item.value.comment))) hasItemWithNewLine = true;
            }
            chompKeep = false;
            let str = stringify(item, ctx, ()=>comment = null, ()=>chompKeep = true);
            if (inFlow && !hasItemWithNewLine && str.includes('\n')) hasItemWithNewLine = true;
            if (inFlow && i < this.items.length - 1) str += ',';
            str = $b874452e1b501c71$export$2d1720544b23b823(str, itemIndent, comment);
            if (chompKeep && (comment || inFlow)) chompKeep = false;
            nodes.push({
                type: 'item',
                str: str
            });
            return nodes;
        }, []);
        let str;
        if (nodes.length === 0) str = flowChars.start + flowChars.end;
        else if (inFlow) {
            const { start: start, end: end } = flowChars;
            const strings = nodes.map((n)=>n.str);
            if (hasItemWithNewLine || strings.reduce((sum, str)=>sum + str.length + 2, 2) > $b874452e1b501c71$export$e7094788287c5e9b.maxFlowStringSingleLineLength) {
                str = start;
                for (const s of strings)str += s ? `\n${indentStep}${indent}${s}` : '\n';
                str += `\n${indent}${end}`;
            } else str = `${start} ${strings.join(' ')} ${end}`;
        } else {
            const strings = nodes.map(blockItem);
            str = strings.shift();
            for (const s of strings)str += s ? `\n${indent}${s}` : '\n';
        }
        if (this.comment) {
            str += '\n' + this.comment.replace(/^/gm, `${indent}#`);
            if (onComment) onComment();
        } else if (chompKeep && onChompKeep) onChompKeep();
        return str;
    }
}
(0, $10eVG._)($b874452e1b501c71$export$e7094788287c5e9b, "maxFlowStringSingleLineLength", 60);
function $b874452e1b501c71$var$asItemIndex(key) {
    let idx = key instanceof $b874452e1b501c71$export$25ce5a424b770e84 ? key.value : key;
    if (idx && typeof idx === 'string') idx = Number(idx);
    return Number.isInteger(idx) && idx >= 0 ? idx : null;
}
class $b874452e1b501c71$export$8743009a87fcb00f extends $b874452e1b501c71$export$e7094788287c5e9b {
    add(value) {
        this.items.push(value);
    }
    delete(key) {
        const idx = $b874452e1b501c71$var$asItemIndex(key);
        if (typeof idx !== 'number') return false;
        const del = this.items.splice(idx, 1);
        return del.length > 0;
    }
    get(key, keepScalar) {
        const idx = $b874452e1b501c71$var$asItemIndex(key);
        if (typeof idx !== 'number') return undefined;
        const it = this.items[idx];
        return !keepScalar && it instanceof $b874452e1b501c71$export$25ce5a424b770e84 ? it.value : it;
    }
    has(key) {
        const idx = $b874452e1b501c71$var$asItemIndex(key);
        return typeof idx === 'number' && idx < this.items.length;
    }
    set(key, value) {
        const idx = $b874452e1b501c71$var$asItemIndex(key);
        if (typeof idx !== 'number') throw new Error(`Expected a valid index, not ${key}.`);
        this.items[idx] = value;
    }
    toJSON(_, ctx) {
        const seq = [];
        if (ctx && ctx.onCreate) ctx.onCreate(seq);
        let i = 0;
        for (const item of this.items)seq.push($b874452e1b501c71$export$625550452a3fa3ec(item, String(i++), ctx));
        return seq;
    }
    toString(ctx, onComment, onChompKeep) {
        if (!ctx) return JSON.stringify(this);
        return super.toString(ctx, {
            blockItem: (n)=>n.type === 'comment' ? n.str : `- ${n.str}`,
            flowChars: {
                start: '[',
                end: ']'
            },
            isMap: false,
            itemIndent: (ctx.indent || '') + '  '
        }, onComment, onChompKeep);
    }
}
const $b874452e1b501c71$var$stringifyKey = (key, jsKey, ctx)=>{
    if (jsKey === null) return '';
    if (typeof jsKey !== 'object') return String(jsKey);
    if (key instanceof $b874452e1b501c71$export$a07804094c3ecf2d && ctx && ctx.doc) return key.toString({
        anchors: Object.create(null),
        doc: ctx.doc,
        indent: '',
        indentStep: ctx.indentStep,
        inFlow: true,
        inStringifyKey: true,
        stringify: ctx.stringify
    });
    return JSON.stringify(jsKey);
};
class $b874452e1b501c71$export$56c0d5a1e737357d extends $b874452e1b501c71$export$a07804094c3ecf2d {
    constructor(key, value = null){
        super();
        this.key = key;
        this.value = value;
        this.type = $b874452e1b501c71$export$56c0d5a1e737357d.Type.PAIR;
    }
    get commentBefore() {
        return this.key instanceof $b874452e1b501c71$export$a07804094c3ecf2d ? this.key.commentBefore : undefined;
    }
    set commentBefore(cb) {
        if (this.key == null) this.key = new $b874452e1b501c71$export$25ce5a424b770e84(null);
        if (this.key instanceof $b874452e1b501c71$export$a07804094c3ecf2d) this.key.commentBefore = cb;
        else {
            const msg = 'Pair.commentBefore is an alias for Pair.key.commentBefore. To set it, the key must be a Node.';
            throw new Error(msg);
        }
    }
    addToJSMap(ctx, map) {
        const key = $b874452e1b501c71$export$625550452a3fa3ec(this.key, '', ctx);
        if (map instanceof Map) {
            const value = $b874452e1b501c71$export$625550452a3fa3ec(this.value, key, ctx);
            map.set(key, value);
        } else if (map instanceof Set) map.add(key);
        else {
            const stringKey = $b874452e1b501c71$var$stringifyKey(this.key, key, ctx);
            const value = $b874452e1b501c71$export$625550452a3fa3ec(this.value, stringKey, ctx);
            if (stringKey in map) Object.defineProperty(map, stringKey, {
                value: value,
                writable: true,
                enumerable: true,
                configurable: true
            });
            else map[stringKey] = value;
        }
        return map;
    }
    toJSON(_, ctx) {
        const pair = ctx && ctx.mapAsMap ? new Map() : {};
        return this.addToJSMap(ctx, pair);
    }
    toString(ctx, onComment, onChompKeep) {
        if (!ctx || !ctx.doc) return JSON.stringify(this);
        const { indent: indentSize, indentSeq: indentSeq, simpleKeys: simpleKeys } = ctx.doc.options;
        let { key: key, value: value } = this;
        let keyComment = key instanceof $b874452e1b501c71$export$a07804094c3ecf2d && key.comment;
        if (simpleKeys) {
            if (keyComment) throw new Error('With simple keys, key nodes cannot have comments');
            if (key instanceof $b874452e1b501c71$export$e7094788287c5e9b) {
                const msg = 'With simple keys, collection cannot be used as a key value';
                throw new Error(msg);
            }
        }
        let explicitKey = !simpleKeys && (!key || keyComment || (key instanceof $b874452e1b501c71$export$a07804094c3ecf2d ? key instanceof $b874452e1b501c71$export$e7094788287c5e9b || key.type === (0, $10eVG.T).BLOCK_FOLDED || key.type === (0, $10eVG.T).BLOCK_LITERAL : typeof key === 'object'));
        const { doc: doc, indent: indent, indentStep: indentStep, stringify: stringify } = ctx;
        ctx = Object.assign({}, ctx, {
            implicitKey: !explicitKey,
            indent: indent + indentStep
        });
        let chompKeep = false;
        let str = stringify(key, ctx, ()=>keyComment = null, ()=>chompKeep = true);
        str = $b874452e1b501c71$export$2d1720544b23b823(str, ctx.indent, keyComment);
        if (!explicitKey && str.length > 1024) {
            if (simpleKeys) throw new Error('With simple keys, single line scalar must not span more than 1024 characters');
            explicitKey = true;
        }
        if (ctx.allNullValues && !simpleKeys) {
            if (this.comment) {
                str = $b874452e1b501c71$export$2d1720544b23b823(str, ctx.indent, this.comment);
                if (onComment) onComment();
            } else if (chompKeep && !keyComment && onChompKeep) onChompKeep();
            return ctx.inFlow && !explicitKey ? str : `? ${str}`;
        }
        str = explicitKey ? `? ${str}\n${indent}:` : `${str}:`;
        if (this.comment) {
            // expected (but not strictly required) to be a single-line comment
            str = $b874452e1b501c71$export$2d1720544b23b823(str, ctx.indent, this.comment);
            if (onComment) onComment();
        }
        let vcb = '';
        let valueComment = null;
        if (value instanceof $b874452e1b501c71$export$a07804094c3ecf2d) {
            if (value.spaceBefore) vcb = '\n';
            if (value.commentBefore) {
                const cs = value.commentBefore.replace(/^/gm, `${ctx.indent}#`);
                vcb += `\n${cs}`;
            }
            valueComment = value.comment;
        } else if (value && typeof value === 'object') value = doc.schema.createNode(value, true);
        ctx.implicitKey = false;
        if (!explicitKey && !this.comment && value instanceof $b874452e1b501c71$export$25ce5a424b770e84) ctx.indentAtStart = str.length + 1;
        chompKeep = false;
        if (!indentSeq && indentSize >= 2 && !ctx.inFlow && !explicitKey && value instanceof $b874452e1b501c71$export$8743009a87fcb00f && value.type !== (0, $10eVG.T).FLOW_SEQ && !value.tag && !doc.anchors.getName(value)) // If indentSeq === false, consider '- ' as part of indentation where possible
        ctx.indent = ctx.indent.substr(2);
        const valueStr = stringify(value, ctx, ()=>valueComment = null, ()=>chompKeep = true);
        let ws = ' ';
        if (vcb || this.comment) ws = `${vcb}\n${ctx.indent}`;
        else if (!explicitKey && value instanceof $b874452e1b501c71$export$e7094788287c5e9b) {
            const flow = valueStr[0] === '[' || valueStr[0] === '{';
            if (!flow || valueStr.includes('\n')) ws = `\n${ctx.indent}`;
        } else if (valueStr[0] === '\n') ws = '';
        if (chompKeep && !valueComment && onChompKeep) onChompKeep();
        return $b874452e1b501c71$export$2d1720544b23b823(str + ws + valueStr, ctx.indent, valueComment);
    }
}
(0, $10eVG._)($b874452e1b501c71$export$56c0d5a1e737357d, "Type", {
    PAIR: 'PAIR',
    MERGE_PAIR: 'MERGE_PAIR'
});
const $b874452e1b501c71$var$getAliasCount = (node, anchors)=>{
    if (node instanceof $b874452e1b501c71$export$ebd11618f299a286) {
        const anchor = anchors.get(node.source);
        return anchor.count * anchor.aliasCount;
    } else if (node instanceof $b874452e1b501c71$export$e7094788287c5e9b) {
        let count = 0;
        for (const item of node.items){
            const c = $b874452e1b501c71$var$getAliasCount(item, anchors);
            if (c > count) count = c;
        }
        return count;
    } else if (node instanceof $b874452e1b501c71$export$56c0d5a1e737357d) {
        const kc = $b874452e1b501c71$var$getAliasCount(node.key, anchors);
        const vc = $b874452e1b501c71$var$getAliasCount(node.value, anchors);
        return Math.max(kc, vc);
    }
    return 1;
};
class $b874452e1b501c71$export$ebd11618f299a286 extends $b874452e1b501c71$export$a07804094c3ecf2d {
    static stringify({ range: range, source: source }, { anchors: anchors, doc: doc, implicitKey: implicitKey, inStringifyKey: inStringifyKey }) {
        let anchor = Object.keys(anchors).find((a)=>anchors[a] === source);
        if (!anchor && inStringifyKey) anchor = doc.anchors.getName(source) || doc.anchors.newName();
        if (anchor) return `*${anchor}${implicitKey ? ' ' : ''}`;
        const msg = doc.anchors.getName(source) ? 'Alias node must be after source node' : 'Source node not found for alias node';
        throw new Error(`${msg} [${range}]`);
    }
    constructor(source){
        super();
        this.source = source;
        this.type = (0, $10eVG.T).ALIAS;
    }
    set tag(t) {
        throw new Error('Alias nodes cannot have tags');
    }
    toJSON(arg, ctx) {
        if (!ctx) return $b874452e1b501c71$export$625550452a3fa3ec(this.source, arg, ctx);
        const { anchors: anchors, maxAliasCount: maxAliasCount } = ctx;
        const anchor = anchors.get(this.source);
        /* istanbul ignore if */ if (!anchor || anchor.res === undefined) {
            const msg = 'This should not happen: Alias anchor was not resolved?';
            if (this.cstNode) throw new (0, $10eVG.f)(this.cstNode, msg);
            else throw new ReferenceError(msg);
        }
        if (maxAliasCount >= 0) {
            anchor.count += 1;
            if (anchor.aliasCount === 0) anchor.aliasCount = $b874452e1b501c71$var$getAliasCount(this.source, anchors);
            if (anchor.count * anchor.aliasCount > maxAliasCount) {
                const msg = 'Excessive alias count indicates a resource exhaustion attack';
                if (this.cstNode) throw new (0, $10eVG.f)(this.cstNode, msg);
                else throw new ReferenceError(msg);
            }
        }
        return anchor.res;
    }
    // Only called when stringifying an alias mapping key while constructing
    // Object output.
    toString(ctx) {
        return $b874452e1b501c71$export$ebd11618f299a286.stringify(this, ctx);
    }
}
(0, $10eVG._)($b874452e1b501c71$export$ebd11618f299a286, "default", true);
function $b874452e1b501c71$export$882b5998b3b9117c(items, key) {
    const k = key instanceof $b874452e1b501c71$export$25ce5a424b770e84 ? key.value : key;
    for (const it of items)if (it instanceof $b874452e1b501c71$export$56c0d5a1e737357d) {
        if (it.key === key || it.key === k) return it;
        if (it.key && it.key.value === k) return it;
    }
    return undefined;
}
class $b874452e1b501c71$export$4368d992c4eafac0 extends $b874452e1b501c71$export$e7094788287c5e9b {
    add(pair, overwrite) {
        if (!pair) pair = new $b874452e1b501c71$export$56c0d5a1e737357d(pair);
        else if (!(pair instanceof $b874452e1b501c71$export$56c0d5a1e737357d)) pair = new $b874452e1b501c71$export$56c0d5a1e737357d(pair.key || pair, pair.value);
        const prev = $b874452e1b501c71$export$882b5998b3b9117c(this.items, pair.key);
        const sortEntries = this.schema && this.schema.sortMapEntries;
        if (prev) {
            if (overwrite) prev.value = pair.value;
            else throw new Error(`Key ${pair.key} already set`);
        } else if (sortEntries) {
            const i = this.items.findIndex((item)=>sortEntries(pair, item) < 0);
            if (i === -1) this.items.push(pair);
            else this.items.splice(i, 0, pair);
        } else this.items.push(pair);
    }
    delete(key) {
        const it = $b874452e1b501c71$export$882b5998b3b9117c(this.items, key);
        if (!it) return false;
        const del = this.items.splice(this.items.indexOf(it), 1);
        return del.length > 0;
    }
    get(key, keepScalar) {
        const it = $b874452e1b501c71$export$882b5998b3b9117c(this.items, key);
        const node = it && it.value;
        return !keepScalar && node instanceof $b874452e1b501c71$export$25ce5a424b770e84 ? node.value : node;
    }
    has(key) {
        return !!$b874452e1b501c71$export$882b5998b3b9117c(this.items, key);
    }
    set(key, value) {
        this.add(new $b874452e1b501c71$export$56c0d5a1e737357d(key, value), true);
    }
    /**
   * @param {*} arg ignored
   * @param {*} ctx Conversion context, originally set in Document#toJSON()
   * @param {Class} Type If set, forces the returned collection type
   * @returns {*} Instance of Type, Map, or Object
   */ toJSON(_, ctx, Type) {
        const map = Type ? new Type() : ctx && ctx.mapAsMap ? new Map() : {};
        if (ctx && ctx.onCreate) ctx.onCreate(map);
        for (const item of this.items)item.addToJSMap(ctx, map);
        return map;
    }
    toString(ctx, onComment, onChompKeep) {
        if (!ctx) return JSON.stringify(this);
        for (const item of this.items){
            if (!(item instanceof $b874452e1b501c71$export$56c0d5a1e737357d)) throw new Error(`Map items must all be pairs; found ${JSON.stringify(item)} instead`);
        }
        return super.toString(ctx, {
            blockItem: (n)=>n.str,
            flowChars: {
                start: '{',
                end: '}'
            },
            isMap: true,
            itemIndent: ctx.indent || ''
        }, onComment, onChompKeep);
    }
}
const $b874452e1b501c71$var$MERGE_KEY = '<<';
class $b874452e1b501c71$export$3a1a48c8f6ef640e extends $b874452e1b501c71$export$56c0d5a1e737357d {
    constructor(pair){
        if (pair instanceof $b874452e1b501c71$export$56c0d5a1e737357d) {
            let seq = pair.value;
            if (!(seq instanceof $b874452e1b501c71$export$8743009a87fcb00f)) {
                seq = new $b874452e1b501c71$export$8743009a87fcb00f();
                seq.items.push(pair.value);
                seq.range = pair.value.range;
            }
            super(pair.key, seq);
            this.range = pair.range;
        } else super(new $b874452e1b501c71$export$25ce5a424b770e84($b874452e1b501c71$var$MERGE_KEY), new $b874452e1b501c71$export$8743009a87fcb00f());
        this.type = $b874452e1b501c71$export$56c0d5a1e737357d.Type.MERGE_PAIR;
    }
    // If the value associated with a merge key is a single mapping node, each of
    // its key/value pairs is inserted into the current mapping, unless the key
    // already exists in it. If the value associated with the merge key is a
    // sequence, then this sequence is expected to contain mapping nodes and each
    // of these nodes is merged in turn according to its order in the sequence.
    // Keys in mapping nodes earlier in the sequence override keys specified in
    // later mapping nodes. -- http://yaml.org/type/merge.html
    addToJSMap(ctx, map) {
        for (const { source: source } of this.value.items){
            if (!(source instanceof $b874452e1b501c71$export$4368d992c4eafac0)) throw new Error('Merge sources must be maps');
            const srcMap = source.toJSON(null, ctx, Map);
            for (const [key, value] of srcMap){
                if (map instanceof Map) {
                    if (!map.has(key)) map.set(key, value);
                } else if (map instanceof Set) map.add(key);
                else if (!Object.prototype.hasOwnProperty.call(map, key)) Object.defineProperty(map, key, {
                    value: value,
                    writable: true,
                    enumerable: true,
                    configurable: true
                });
            }
        }
        return map;
    }
    toString(ctx, onComment) {
        const seq = this.value;
        if (seq.items.length > 1) return super.toString(ctx, onComment);
        this.value = seq.items[0];
        const str = super.toString(ctx, onComment);
        this.value = seq;
        return str;
    }
}
const $b874452e1b501c71$export$8b22cf2602fb60ce = {
    defaultType: (0, $10eVG.T).BLOCK_LITERAL,
    lineWidth: 76
};
const $b874452e1b501c71$export$407448d2b89b1813 = {
    trueStr: 'true',
    falseStr: 'false'
};
const $b874452e1b501c71$export$23f2a1d2818174ef = {
    asBigInt: false
};
const $b874452e1b501c71$export$7ccc53e8f1e7dfc5 = {
    nullStr: 'null'
};
const $b874452e1b501c71$export$2408f22a0fab9ae5 = {
    defaultType: (0, $10eVG.T).PLAIN,
    doubleQuoted: {
        jsonEncoding: false,
        minMultiLineLength: 40
    },
    fold: {
        lineWidth: 80,
        minContentWidth: 20
    }
};
// falls back to string on no match
function $b874452e1b501c71$var$resolveScalar(str, tags, scalarFallback) {
    for (const { format: format, test: test, resolve: resolve } of tags)if (test) {
        const match = str.match(test);
        if (match) {
            let res = resolve.apply(null, match);
            if (!(res instanceof $b874452e1b501c71$export$25ce5a424b770e84)) res = new $b874452e1b501c71$export$25ce5a424b770e84(res);
            if (format) res.format = format;
            return res;
        }
    }
    if (scalarFallback) str = scalarFallback(str);
    return new $b874452e1b501c71$export$25ce5a424b770e84(str);
}
const $b874452e1b501c71$var$FOLD_FLOW = 'flow';
const $b874452e1b501c71$var$FOLD_BLOCK = 'block';
const $b874452e1b501c71$var$FOLD_QUOTED = 'quoted';
// presumes i+1 is at the start of a line
// returns index of last newline in more-indented block
const $b874452e1b501c71$var$consumeMoreIndentedLines = (text, i)=>{
    let ch = text[i + 1];
    while(ch === ' ' || ch === '\t'){
        do ch = text[i += 1];
        while (ch && ch !== '\n');
        ch = text[i + 1];
    }
    return i;
};
/**
 * Tries to keep input at up to `lineWidth` characters, splitting only on spaces
 * not followed by newlines or spaces unless `mode` is `'quoted'`. Lines are
 * terminated with `\n` and started with `indent`.
 *
 * @param {string} text
 * @param {string} indent
 * @param {string} [mode='flow'] `'block'` prevents more-indented lines
 *   from being folded; `'quoted'` allows for `\` escapes, including escaped
 *   newlines
 * @param {Object} options
 * @param {number} [options.indentAtStart] Accounts for leading contents on
 *   the first line, defaulting to `indent.length`
 * @param {number} [options.lineWidth=80]
 * @param {number} [options.minContentWidth=20] Allow highly indented lines to
 *   stretch the line width or indent content from the start
 * @param {function} options.onFold Called once if the text is folded
 * @param {function} options.onFold Called once if any line of text exceeds
 *   lineWidth characters
 */ function $b874452e1b501c71$var$foldFlowLines(text, indent, mode, { indentAtStart: indentAtStart, lineWidth: lineWidth = 80, minContentWidth: minContentWidth = 20, onFold: onFold, onOverflow: onOverflow }) {
    if (!lineWidth || lineWidth < 0) return text;
    const endStep = Math.max(1 + minContentWidth, 1 + lineWidth - indent.length);
    if (text.length <= endStep) return text;
    const folds = [];
    const escapedFolds = {};
    let end = lineWidth - indent.length;
    if (typeof indentAtStart === 'number') {
        if (indentAtStart > lineWidth - Math.max(2, minContentWidth)) folds.push(0);
        else end = lineWidth - indentAtStart;
    }
    let split = undefined;
    let prev = undefined;
    let overflow = false;
    let i = -1;
    let escStart = -1;
    let escEnd = -1;
    if (mode === $b874452e1b501c71$var$FOLD_BLOCK) {
        i = $b874452e1b501c71$var$consumeMoreIndentedLines(text, i);
        if (i !== -1) end = i + endStep;
    }
    for(let ch; ch = text[i += 1];){
        if (mode === $b874452e1b501c71$var$FOLD_QUOTED && ch === '\\') {
            escStart = i;
            switch(text[i + 1]){
                case 'x':
                    i += 3;
                    break;
                case 'u':
                    i += 5;
                    break;
                case 'U':
                    i += 9;
                    break;
                default:
                    i += 1;
            }
            escEnd = i;
        }
        if (ch === '\n') {
            if (mode === $b874452e1b501c71$var$FOLD_BLOCK) i = $b874452e1b501c71$var$consumeMoreIndentedLines(text, i);
            end = i + endStep;
            split = undefined;
        } else {
            if (ch === ' ' && prev && prev !== ' ' && prev !== '\n' && prev !== '\t') {
                // space surrounded by non-space can be replaced with newline + indent
                const next = text[i + 1];
                if (next && next !== ' ' && next !== '\n' && next !== '\t') split = i;
            }
            if (i >= end) {
                if (split) {
                    folds.push(split);
                    end = split + endStep;
                    split = undefined;
                } else if (mode === $b874452e1b501c71$var$FOLD_QUOTED) {
                    // white-space collected at end may stretch past lineWidth
                    while(prev === ' ' || prev === '\t'){
                        prev = ch;
                        ch = text[i += 1];
                        overflow = true;
                    }
                    // Account for newline escape, but don't break preceding escape
                    const j = i > escEnd + 1 ? i - 2 : escStart - 1;
                    // Bail out if lineWidth & minContentWidth are shorter than an escape string
                    if (escapedFolds[j]) return text;
                    folds.push(j);
                    escapedFolds[j] = true;
                    end = j + endStep;
                    split = undefined;
                } else overflow = true;
            }
        }
        prev = ch;
    }
    if (overflow && onOverflow) onOverflow();
    if (folds.length === 0) return text;
    if (onFold) onFold();
    let res = text.slice(0, folds[0]);
    for(let i = 0; i < folds.length; ++i){
        const fold = folds[i];
        const end = folds[i + 1] || text.length;
        if (fold === 0) res = `\n${indent}${text.slice(0, end)}`;
        else {
            if (mode === $b874452e1b501c71$var$FOLD_QUOTED && escapedFolds[fold]) res += `${text[fold]}\\`;
            res += `\n${indent}${text.slice(fold + 1, end)}`;
        }
    }
    return res;
}
const $b874452e1b501c71$var$getFoldOptions = ({ indentAtStart: indentAtStart })=>indentAtStart ? Object.assign({
        indentAtStart: indentAtStart
    }, $b874452e1b501c71$export$2408f22a0fab9ae5.fold) : $b874452e1b501c71$export$2408f22a0fab9ae5.fold;
// Also checks for lines starting with %, as parsing the output as YAML 1.1 will
// presume that's starting a new document.
const $b874452e1b501c71$var$containsDocumentMarker = (str)=>/^(%|---|\.\.\.)/m.test(str);
function $b874452e1b501c71$var$lineLengthOverLimit(str, lineWidth, indentLength) {
    if (!lineWidth || lineWidth < 0) return false;
    const limit = lineWidth - indentLength;
    const strLen = str.length;
    if (strLen <= limit) return false;
    for(let i = 0, start = 0; i < strLen; ++i)if (str[i] === '\n') {
        if (i - start > limit) return true;
        start = i + 1;
        if (strLen - start <= limit) return false;
    }
    return true;
}
function $b874452e1b501c71$var$doubleQuotedString(value, ctx) {
    const { implicitKey: implicitKey } = ctx;
    const { jsonEncoding: jsonEncoding, minMultiLineLength: minMultiLineLength } = $b874452e1b501c71$export$2408f22a0fab9ae5.doubleQuoted;
    const json = JSON.stringify(value);
    if (jsonEncoding) return json;
    const indent = ctx.indent || ($b874452e1b501c71$var$containsDocumentMarker(value) ? '  ' : '');
    let str = '';
    let start = 0;
    for(let i = 0, ch = json[i]; ch; ch = json[++i]){
        if (ch === ' ' && json[i + 1] === '\\' && json[i + 2] === 'n') {
            // space before newline needs to be escaped to not be folded
            str += json.slice(start, i) + '\\ ';
            i += 1;
            start = i;
            ch = '\\';
        }
        if (ch === '\\') switch(json[i + 1]){
            case 'u':
                {
                    str += json.slice(start, i);
                    const code = json.substr(i + 2, 4);
                    switch(code){
                        case '0000':
                            str += '\\0';
                            break;
                        case '0007':
                            str += '\\a';
                            break;
                        case '000b':
                            str += '\\v';
                            break;
                        case '001b':
                            str += '\\e';
                            break;
                        case '0085':
                            str += '\\N';
                            break;
                        case '00a0':
                            str += '\\_';
                            break;
                        case '2028':
                            str += '\\L';
                            break;
                        case '2029':
                            str += '\\P';
                            break;
                        default:
                            if (code.substr(0, 2) === '00') str += '\\x' + code.substr(2);
                            else str += json.substr(i, 6);
                    }
                    i += 5;
                    start = i + 1;
                }
                break;
            case 'n':
                if (implicitKey || json[i + 2] === '"' || json.length < minMultiLineLength) i += 1;
                else {
                    // folding will eat first newline
                    str += json.slice(start, i) + '\n\n';
                    while(json[i + 2] === '\\' && json[i + 3] === 'n' && json[i + 4] !== '"'){
                        str += '\n';
                        i += 2;
                    }
                    str += indent;
                    // space after newline needs to be escaped to not be folded
                    if (json[i + 2] === ' ') str += '\\';
                    i += 1;
                    start = i + 1;
                }
                break;
            default:
                i += 1;
        }
    }
    str = start ? str + json.slice(start) : json;
    return implicitKey ? str : $b874452e1b501c71$var$foldFlowLines(str, indent, $b874452e1b501c71$var$FOLD_QUOTED, $b874452e1b501c71$var$getFoldOptions(ctx));
}
function $b874452e1b501c71$var$singleQuotedString(value, ctx) {
    if (ctx.implicitKey) {
        if (/\n/.test(value)) return $b874452e1b501c71$var$doubleQuotedString(value, ctx);
    } else {
        // single quoted string can't have leading or trailing whitespace around newline
        if (/[ \t]\n|\n[ \t]/.test(value)) return $b874452e1b501c71$var$doubleQuotedString(value, ctx);
    }
    const indent = ctx.indent || ($b874452e1b501c71$var$containsDocumentMarker(value) ? '  ' : '');
    const res = "'" + value.replace(/'/g, "''").replace(/\n+/g, `$&\n${indent}`) + "'";
    return ctx.implicitKey ? res : $b874452e1b501c71$var$foldFlowLines(res, indent, $b874452e1b501c71$var$FOLD_FLOW, $b874452e1b501c71$var$getFoldOptions(ctx));
}
function $b874452e1b501c71$var$blockString({ comment: comment, type: type, value: value }, ctx, onComment, onChompKeep) {
    // 1. Block can't end in whitespace unless the last line is non-empty.
    // 2. Strings consisting of only whitespace are best rendered explicitly.
    if (/\n[\t ]+$/.test(value) || /^\s*$/.test(value)) return $b874452e1b501c71$var$doubleQuotedString(value, ctx);
    const indent = ctx.indent || (ctx.forceBlockIndent || $b874452e1b501c71$var$containsDocumentMarker(value) ? '  ' : '');
    const indentSize = indent ? '2' : '1'; // root is at -1
    const literal = type === (0, $10eVG.T).BLOCK_FOLDED ? false : type === (0, $10eVG.T).BLOCK_LITERAL ? true : !$b874452e1b501c71$var$lineLengthOverLimit(value, $b874452e1b501c71$export$2408f22a0fab9ae5.fold.lineWidth, indent.length);
    let header = literal ? '|' : '>';
    if (!value) return header + '\n';
    let wsStart = '';
    let wsEnd = '';
    value = value.replace(/[\n\t ]*$/, (ws)=>{
        const n = ws.indexOf('\n');
        if (n === -1) header += '-'; // strip
        else if (value === ws || n !== ws.length - 1) {
            header += '+'; // keep
            if (onChompKeep) onChompKeep();
        }
        wsEnd = ws.replace(/\n$/, '');
        return '';
    }).replace(/^[\n ]*/, (ws)=>{
        if (ws.indexOf(' ') !== -1) header += indentSize;
        const m = ws.match(/ +$/);
        if (m) {
            wsStart = ws.slice(0, -m[0].length);
            return m[0];
        } else {
            wsStart = ws;
            return '';
        }
    });
    if (wsEnd) wsEnd = wsEnd.replace(/\n+(?!\n|$)/g, `$&${indent}`);
    if (wsStart) wsStart = wsStart.replace(/\n+/g, `$&${indent}`);
    if (comment) {
        header += ' #' + comment.replace(/ ?[\r\n]+/g, ' ');
        if (onComment) onComment();
    }
    if (!value) return `${header}${indentSize}\n${indent}${wsEnd}`;
    if (literal) {
        value = value.replace(/\n+/g, `$&${indent}`);
        return `${header}\n${indent}${wsStart}${value}${wsEnd}`;
    }
    value = value.replace(/\n+/g, '\n$&').replace(/(?:^|\n)([\t ].*)(?:([\n\t ]*)\n(?![\n\t ]))?/g, '$1$2') // more-indented lines aren't folded
    //         ^ ind.line  ^ empty     ^ capture next empty lines only at end of indent
    .replace(/\n+/g, `$&${indent}`);
    const body = $b874452e1b501c71$var$foldFlowLines(`${wsStart}${value}${wsEnd}`, indent, $b874452e1b501c71$var$FOLD_BLOCK, $b874452e1b501c71$export$2408f22a0fab9ae5.fold);
    return `${header}\n${indent}${body}`;
}
function $b874452e1b501c71$var$plainString(item, ctx, onComment, onChompKeep) {
    const { comment: comment, type: type, value: value } = item;
    const { actualString: actualString, implicitKey: implicitKey, indent: indent, inFlow: inFlow } = ctx;
    if (implicitKey && /[\n[\]{},]/.test(value) || inFlow && /[[\]{},]/.test(value)) return $b874452e1b501c71$var$doubleQuotedString(value, ctx);
    if (!value || /^[\n\t ,[\]{}#&*!|>'"%@`]|^[?-]$|^[?-][ \t]|[\n:][ \t]|[ \t]\n|[\n\t ]#|[\n\t :]$/.test(value)) // not allowed:
    // - empty string, '-' or '?'
    // - start with an indicator character (except [?:-]) or /[?-] /
    // - '\n ', ': ' or ' \n' anywhere
    // - '#' not preceded by a non-space char
    // - end with ' ' or ':'
    return implicitKey || inFlow || value.indexOf('\n') === -1 ? value.indexOf('"') !== -1 && value.indexOf("'") === -1 ? $b874452e1b501c71$var$singleQuotedString(value, ctx) : $b874452e1b501c71$var$doubleQuotedString(value, ctx) : $b874452e1b501c71$var$blockString(item, ctx, onComment, onChompKeep);
    if (!implicitKey && !inFlow && type !== (0, $10eVG.T).PLAIN && value.indexOf('\n') !== -1) // Where allowed & type not set explicitly, prefer block style for multiline strings
    return $b874452e1b501c71$var$blockString(item, ctx, onComment, onChompKeep);
    if (indent === '' && $b874452e1b501c71$var$containsDocumentMarker(value)) {
        ctx.forceBlockIndent = true;
        return $b874452e1b501c71$var$blockString(item, ctx, onComment, onChompKeep);
    }
    const str = value.replace(/\n+/g, `$&\n${indent}`);
    // Verify that output will be parsed as a string, as e.g. plain numbers and
    // booleans get parsed with those types in v1.2 (e.g. '42', 'true' & '0.9e-3'),
    // and others in v1.1.
    if (actualString) {
        const { tags: tags } = ctx.doc.schema;
        const resolved = $b874452e1b501c71$var$resolveScalar(str, tags, tags.scalarFallback).value;
        if (typeof resolved !== 'string') return $b874452e1b501c71$var$doubleQuotedString(value, ctx);
    }
    const body = implicitKey ? str : $b874452e1b501c71$var$foldFlowLines(str, indent, $b874452e1b501c71$var$FOLD_FLOW, $b874452e1b501c71$var$getFoldOptions(ctx));
    if (comment && !inFlow && (body.indexOf('\n') !== -1 || comment.indexOf('\n') !== -1)) {
        if (onComment) onComment();
        return $b874452e1b501c71$var$addCommentBefore(body, indent, comment);
    }
    return body;
}
function $b874452e1b501c71$export$db3b6bfb95261072(item, ctx, onComment, onChompKeep) {
    const { defaultType: defaultType } = $b874452e1b501c71$export$2408f22a0fab9ae5;
    const { implicitKey: implicitKey, inFlow: inFlow } = ctx;
    let { type: type, value: value } = item;
    if (typeof value !== 'string') {
        value = String(value);
        item = Object.assign({}, item, {
            value: value
        });
    }
    const _stringify = (_type)=>{
        switch(_type){
            case (0, $10eVG.T).BLOCK_FOLDED:
            case (0, $10eVG.T).BLOCK_LITERAL:
                return $b874452e1b501c71$var$blockString(item, ctx, onComment, onChompKeep);
            case (0, $10eVG.T).QUOTE_DOUBLE:
                return $b874452e1b501c71$var$doubleQuotedString(value, ctx);
            case (0, $10eVG.T).QUOTE_SINGLE:
                return $b874452e1b501c71$var$singleQuotedString(value, ctx);
            case (0, $10eVG.T).PLAIN:
                return $b874452e1b501c71$var$plainString(item, ctx, onComment, onChompKeep);
            default:
                return null;
        }
    };
    if (type !== (0, $10eVG.T).QUOTE_DOUBLE && /[\x00-\x08\x0b-\x1f\x7f-\x9f]/.test(value)) // force double quotes on control characters
    type = (0, $10eVG.T).QUOTE_DOUBLE;
    else if ((implicitKey || inFlow) && (type === (0, $10eVG.T).BLOCK_FOLDED || type === (0, $10eVG.T).BLOCK_LITERAL)) // should not happen; blocks are not valid inside flow containers
    type = (0, $10eVG.T).QUOTE_DOUBLE;
    let res = _stringify(type);
    if (res === null) {
        res = _stringify(defaultType);
        if (res === null) throw new Error(`Unsupported default string type ${defaultType}`);
    }
    return res;
}
function $b874452e1b501c71$export$342063e11d6c3cad({ format: format, minFractionDigits: minFractionDigits, tag: tag, value: value }) {
    if (typeof value === 'bigint') return String(value);
    if (!isFinite(value)) return isNaN(value) ? '.nan' : value < 0 ? '-.inf' : '.inf';
    let n = JSON.stringify(value);
    if (!format && minFractionDigits && (!tag || tag === 'tag:yaml.org,2002:float') && /^\d/.test(n)) {
        let i = n.indexOf('.');
        if (i < 0) {
            i = n.length;
            n += '.';
        }
        let d = minFractionDigits - (n.length - i - 1);
        while(d-- > 0)n += '0';
    }
    return n;
}
function $b874452e1b501c71$var$checkFlowCollectionEnd(errors, cst) {
    let char, name;
    switch(cst.type){
        case (0, $10eVG.T).FLOW_MAP:
            char = '}';
            name = 'flow map';
            break;
        case (0, $10eVG.T).FLOW_SEQ:
            char = ']';
            name = 'flow sequence';
            break;
        default:
            errors.push(new (0, $10eVG.b)(cst, 'Not a flow collection!?'));
            return;
    }
    let lastItem;
    for(let i = cst.items.length - 1; i >= 0; --i){
        const item = cst.items[i];
        if (!item || item.type !== (0, $10eVG.T).COMMENT) {
            lastItem = item;
            break;
        }
    }
    if (lastItem && lastItem.char !== char) {
        const msg = `Expected ${name} to end with ${char}`;
        let err;
        if (typeof lastItem.offset === 'number') {
            err = new (0, $10eVG.b)(cst, msg);
            err.offset = lastItem.offset + 1;
        } else {
            err = new (0, $10eVG.b)(lastItem, msg);
            if (lastItem.range && lastItem.range.end) err.offset = lastItem.range.end - lastItem.range.start;
        }
        errors.push(err);
    }
}
function $b874452e1b501c71$var$checkFlowCommentSpace(errors, comment) {
    const prev = comment.context.src[comment.range.start - 1];
    if (prev !== '\n' && prev !== '\t' && prev !== ' ') {
        const msg = 'Comments must be separated from other tokens by white space characters';
        errors.push(new (0, $10eVG.b)(comment, msg));
    }
}
function $b874452e1b501c71$var$getLongKeyError(source, key) {
    const sk = String(key);
    const k = sk.substr(0, 8) + '...' + sk.substr(-8);
    return new (0, $10eVG.b)(source, `The "${k}" key is too long`);
}
function $b874452e1b501c71$var$resolveComments(collection, comments) {
    for (const { afterKey: afterKey, before: before, comment: comment } of comments){
        let item = collection.items[before];
        if (!item) {
            if (comment !== undefined) {
                if (collection.comment) collection.comment += '\n' + comment;
                else collection.comment = comment;
            }
        } else {
            if (afterKey && item.value) item = item.value;
            if (comment === undefined) {
                if (afterKey || !item.commentBefore) item.spaceBefore = true;
            } else if (item.commentBefore) item.commentBefore += '\n' + comment;
            else item.commentBefore = comment;
        }
    }
}
// on error, will return { str: string, errors: Error[] }
function $b874452e1b501c71$export$35e795649ee09318(doc, node) {
    const res = node.strValue;
    if (!res) return '';
    if (typeof res === 'string') return res;
    res.errors.forEach((error)=>{
        if (!error.source) error.source = node;
        doc.errors.push(error);
    });
    return res.str;
}
function $b874452e1b501c71$var$resolveTagHandle(doc, node) {
    const { handle: handle, suffix: suffix } = node.tag;
    let prefix = doc.tagPrefixes.find((p)=>p.handle === handle);
    if (!prefix) {
        const dtp = doc.getDefaults().tagPrefixes;
        if (dtp) prefix = dtp.find((p)=>p.handle === handle);
        if (!prefix) throw new (0, $10eVG.b)(node, `The ${handle} tag handle is non-default and was not declared.`);
    }
    if (!suffix) throw new (0, $10eVG.b)(node, `The ${handle} tag has no suffix.`);
    if (handle === '!' && (doc.version || doc.options.version) === '1.0') {
        if (suffix[0] === '^') {
            doc.warnings.push(new (0, $10eVG.a)(node, 'YAML 1.0 ^ tag expansion is not supported'));
            return suffix;
        }
        if (/[:/]/.test(suffix)) {
            // word/foo -> tag:word.yaml.org,2002:foo
            const vocab = suffix.match(/^([a-z0-9-]+)\/(.*)/i);
            return vocab ? `tag:${vocab[1]}.yaml.org,2002:${vocab[2]}` : `tag:${suffix}`;
        }
    }
    return prefix.prefix + decodeURIComponent(suffix);
}
function $b874452e1b501c71$var$resolveTagName(doc, node) {
    const { tag: tag, type: type } = node;
    let nonSpecific = false;
    if (tag) {
        const { handle: handle, suffix: suffix, verbatim: verbatim } = tag;
        if (verbatim) {
            if (verbatim !== '!' && verbatim !== '!!') return verbatim;
            const msg = `Verbatim tags aren't resolved, so ${verbatim} is invalid.`;
            doc.errors.push(new (0, $10eVG.b)(node, msg));
        } else if (handle === '!' && !suffix) nonSpecific = true;
        else try {
            return $b874452e1b501c71$var$resolveTagHandle(doc, node);
        } catch (error) {
            doc.errors.push(error);
        }
    }
    switch(type){
        case (0, $10eVG.T).BLOCK_FOLDED:
        case (0, $10eVG.T).BLOCK_LITERAL:
        case (0, $10eVG.T).QUOTE_DOUBLE:
        case (0, $10eVG.T).QUOTE_SINGLE:
            return (0, $10eVG.e).STR;
        case (0, $10eVG.T).FLOW_MAP:
        case (0, $10eVG.T).MAP:
            return (0, $10eVG.e).MAP;
        case (0, $10eVG.T).FLOW_SEQ:
        case (0, $10eVG.T).SEQ:
            return (0, $10eVG.e).SEQ;
        case (0, $10eVG.T).PLAIN:
            return nonSpecific ? (0, $10eVG.e).STR : null;
        default:
            return null;
    }
}
function $b874452e1b501c71$var$resolveByTagName(doc, node, tagName) {
    const { tags: tags } = doc.schema;
    const matchWithTest = [];
    for (const tag of tags)if (tag.tag === tagName) {
        if (tag.test) matchWithTest.push(tag);
        else {
            const res = tag.resolve(doc, node);
            return res instanceof $b874452e1b501c71$export$e7094788287c5e9b ? res : new $b874452e1b501c71$export$25ce5a424b770e84(res);
        }
    }
    const str = $b874452e1b501c71$export$35e795649ee09318(doc, node);
    if (typeof str === 'string' && matchWithTest.length > 0) return $b874452e1b501c71$var$resolveScalar(str, matchWithTest, tags.scalarFallback);
    return null;
}
function $b874452e1b501c71$var$getFallbackTagName({ type: type }) {
    switch(type){
        case (0, $10eVG.T).FLOW_MAP:
        case (0, $10eVG.T).MAP:
            return (0, $10eVG.e).MAP;
        case (0, $10eVG.T).FLOW_SEQ:
        case (0, $10eVG.T).SEQ:
            return (0, $10eVG.e).SEQ;
        default:
            return (0, $10eVG.e).STR;
    }
}
function $b874452e1b501c71$var$resolveTag(doc, node, tagName) {
    try {
        const res = $b874452e1b501c71$var$resolveByTagName(doc, node, tagName);
        if (res) {
            if (tagName && node.tag) res.tag = tagName;
            return res;
        }
    } catch (error) {
        if (error instanceof (0, $10eVG.c)) {
            if (!error.source) error.source = node;
            doc.errors.push(error);
        } else {
            const msg = error instanceof Error ? error.message : String(error);
            doc.errors.push(new (0, $10eVG.b)(node, msg));
        }
        return null;
    }
    try {
        const fallback = $b874452e1b501c71$var$getFallbackTagName(node);
        if (!fallback) throw new Error(`The tag ${tagName} is unavailable`);
        const msg = `The tag ${tagName} is unavailable, falling back to ${fallback}`;
        doc.warnings.push(new (0, $10eVG.a)(node, msg));
        const res = $b874452e1b501c71$var$resolveByTagName(doc, node, fallback);
        res.tag = tagName;
        return res;
    } catch (error) {
        const refError = new (0, $10eVG.f)(node, error.message);
        refError.stack = error.stack;
        doc.errors.push(refError);
        return null;
    }
}
const $b874452e1b501c71$var$isCollectionItem = (node)=>{
    if (!node) return false;
    const { type: type } = node;
    return type === (0, $10eVG.T).MAP_KEY || type === (0, $10eVG.T).MAP_VALUE || type === (0, $10eVG.T).SEQ_ITEM;
};
function $b874452e1b501c71$var$resolveNodeProps(errors, node) {
    const comments = {
        before: [],
        after: []
    };
    let hasAnchor = false;
    let hasTag = false;
    const props = $b874452e1b501c71$var$isCollectionItem(node.context.parent) ? node.context.parent.props.concat(node.props) : node.props;
    for (const { start: start, end: end } of props)switch(node.context.src[start]){
        case (0, $10eVG.C).COMMENT:
            {
                if (!node.commentHasRequiredWhitespace(start)) {
                    const msg = 'Comments must be separated from other tokens by white space characters';
                    errors.push(new (0, $10eVG.b)(node, msg));
                }
                const { header: header, valueRange: valueRange } = node;
                const cc = valueRange && (start > valueRange.start || header && start > header.start) ? comments.after : comments.before;
                cc.push(node.context.src.slice(start + 1, end));
                break;
            }
        // Actual anchor & tag resolution is handled by schema, here we just complain
        case (0, $10eVG.C).ANCHOR:
            if (hasAnchor) {
                const msg = 'A node can have at most one anchor';
                errors.push(new (0, $10eVG.b)(node, msg));
            }
            hasAnchor = true;
            break;
        case (0, $10eVG.C).TAG:
            if (hasTag) {
                const msg = 'A node can have at most one tag';
                errors.push(new (0, $10eVG.b)(node, msg));
            }
            hasTag = true;
            break;
    }
    return {
        comments: comments,
        hasAnchor: hasAnchor,
        hasTag: hasTag
    };
}
function $b874452e1b501c71$var$resolveNodeValue(doc, node) {
    const { anchors: anchors, errors: errors, schema: schema } = doc;
    if (node.type === (0, $10eVG.T).ALIAS) {
        const name = node.rawValue;
        const src = anchors.getNode(name);
        if (!src) {
            const msg = `Aliased anchor not found: ${name}`;
            errors.push(new (0, $10eVG.f)(node, msg));
            return null;
        }
        // Lazy resolution for circular references
        const res = new $b874452e1b501c71$export$ebd11618f299a286(src);
        anchors._cstAliases.push(res);
        return res;
    }
    const tagName = $b874452e1b501c71$var$resolveTagName(doc, node);
    if (tagName) return $b874452e1b501c71$var$resolveTag(doc, node, tagName);
    if (node.type !== (0, $10eVG.T).PLAIN) {
        const msg = `Failed to resolve ${node.type} node here`;
        errors.push(new (0, $10eVG.Y)(node, msg));
        return null;
    }
    try {
        const str = $b874452e1b501c71$export$35e795649ee09318(doc, node);
        return $b874452e1b501c71$var$resolveScalar(str, schema.tags, schema.tags.scalarFallback);
    } catch (error) {
        if (!error.source) error.source = node;
        errors.push(error);
        return null;
    }
}
// sets node.resolved on success
function $b874452e1b501c71$export$43caf9889c228507(doc, node) {
    if (!node) return null;
    if (node.error) doc.errors.push(node.error);
    const { comments: comments, hasAnchor: hasAnchor, hasTag: hasTag } = $b874452e1b501c71$var$resolveNodeProps(doc.errors, node);
    if (hasAnchor) {
        const { anchors: anchors } = doc;
        const name = node.anchor;
        const prev = anchors.getNode(name);
        // At this point, aliases for any preceding node with the same anchor
        // name have already been resolved, so it may safely be renamed.
        if (prev) anchors.map[anchors.newName(name)] = prev;
        // During parsing, we need to store the CST node in anchors.map as
        // anchors need to be available during resolution to allow for
        // circular references.
        anchors.map[name] = node;
    }
    if (node.type === (0, $10eVG.T).ALIAS && (hasAnchor || hasTag)) {
        const msg = 'An alias node must not specify any properties';
        doc.errors.push(new (0, $10eVG.b)(node, msg));
    }
    const res = $b874452e1b501c71$var$resolveNodeValue(doc, node);
    if (res) {
        res.range = [
            node.range.start,
            node.range.end
        ];
        if (doc.options.keepCstNodes) res.cstNode = node;
        if (doc.options.keepNodeTypes) res.type = node.type;
        const cb = comments.before.join('\n');
        if (cb) res.commentBefore = res.commentBefore ? `${res.commentBefore}\n${cb}` : cb;
        const ca = comments.after.join('\n');
        if (ca) res.comment = res.comment ? `${res.comment}\n${ca}` : ca;
    }
    return node.resolved = res;
}
function $b874452e1b501c71$export$39b482c5e57630a8(doc, cst) {
    if (cst.type !== (0, $10eVG.T).MAP && cst.type !== (0, $10eVG.T).FLOW_MAP) {
        const msg = `A ${cst.type} node cannot be resolved as a mapping`;
        doc.errors.push(new (0, $10eVG.Y)(cst, msg));
        return null;
    }
    const { comments: comments, items: items } = cst.type === (0, $10eVG.T).FLOW_MAP ? $b874452e1b501c71$var$resolveFlowMapItems(doc, cst) : $b874452e1b501c71$var$resolveBlockMapItems(doc, cst);
    const map = new $b874452e1b501c71$export$4368d992c4eafac0();
    map.items = items;
    $b874452e1b501c71$var$resolveComments(map, comments);
    let hasCollectionKey = false;
    for(let i = 0; i < items.length; ++i){
        const { key: iKey } = items[i];
        if (iKey instanceof $b874452e1b501c71$export$e7094788287c5e9b) hasCollectionKey = true;
        if (doc.schema.merge && iKey && iKey.value === $b874452e1b501c71$var$MERGE_KEY) {
            items[i] = new $b874452e1b501c71$export$3a1a48c8f6ef640e(items[i]);
            const sources = items[i].value.items;
            let error = null;
            sources.some((node)=>{
                if (node instanceof $b874452e1b501c71$export$ebd11618f299a286) {
                    // During parsing, alias sources are CST nodes; to account for
                    // circular references their resolved values can't be used here.
                    const { type: type } = node.source;
                    if (type === (0, $10eVG.T).MAP || type === (0, $10eVG.T).FLOW_MAP) return false;
                    return error = 'Merge nodes aliases can only point to maps';
                }
                return error = 'Merge nodes can only have Alias nodes as values';
            });
            if (error) doc.errors.push(new (0, $10eVG.b)(cst, error));
        } else for(let j = i + 1; j < items.length; ++j){
            const { key: jKey } = items[j];
            if (iKey === jKey || iKey && jKey && Object.prototype.hasOwnProperty.call(iKey, 'value') && iKey.value === jKey.value) {
                const msg = `Map keys must be unique; "${iKey}" is repeated`;
                doc.errors.push(new (0, $10eVG.b)(cst, msg));
                break;
            }
        }
    }
    if (hasCollectionKey && !doc.options.mapAsMap) {
        const warn = 'Keys with collection values will be stringified as YAML due to JS Object restrictions. Use mapAsMap: true to avoid this.';
        doc.warnings.push(new (0, $10eVG.a)(cst, warn));
    }
    cst.resolved = map;
    return map;
}
const $b874452e1b501c71$var$valueHasPairComment = ({ context: { lineStart: lineStart, node: node, src: src }, props: props })=>{
    if (props.length === 0) return false;
    const { start: start } = props[0];
    if (node && start > node.valueRange.start) return false;
    if (src[start] !== (0, $10eVG.C).COMMENT) return false;
    for(let i = lineStart; i < start; ++i)if (src[i] === '\n') return false;
    return true;
};
function $b874452e1b501c71$var$resolvePairComment(item, pair) {
    if (!$b874452e1b501c71$var$valueHasPairComment(item)) return;
    const comment = item.getPropValue(0, (0, $10eVG.C).COMMENT, true);
    let found = false;
    const cb = pair.value.commentBefore;
    if (cb && cb.startsWith(comment)) {
        pair.value.commentBefore = cb.substr(comment.length + 1);
        found = true;
    } else {
        const cc = pair.value.comment;
        if (!item.node && cc && cc.startsWith(comment)) {
            pair.value.comment = cc.substr(comment.length + 1);
            found = true;
        }
    }
    if (found) pair.comment = comment;
}
function $b874452e1b501c71$var$resolveBlockMapItems(doc, cst) {
    const comments = [];
    const items = [];
    let key = undefined;
    let keyStart = null;
    for(let i = 0; i < cst.items.length; ++i){
        const item = cst.items[i];
        switch(item.type){
            case (0, $10eVG.T).BLANK_LINE:
                comments.push({
                    afterKey: !!key,
                    before: items.length
                });
                break;
            case (0, $10eVG.T).COMMENT:
                comments.push({
                    afterKey: !!key,
                    before: items.length,
                    comment: item.comment
                });
                break;
            case (0, $10eVG.T).MAP_KEY:
                if (key !== undefined) items.push(new $b874452e1b501c71$export$56c0d5a1e737357d(key));
                if (item.error) doc.errors.push(item.error);
                key = $b874452e1b501c71$export$43caf9889c228507(doc, item.node);
                keyStart = null;
                break;
            case (0, $10eVG.T).MAP_VALUE:
                {
                    if (key === undefined) key = null;
                    if (item.error) doc.errors.push(item.error);
                    if (!item.context.atLineStart && item.node && item.node.type === (0, $10eVG.T).MAP && !item.node.context.atLineStart) {
                        const msg = 'Nested mappings are not allowed in compact mappings';
                        doc.errors.push(new (0, $10eVG.b)(item.node, msg));
                    }
                    let valueNode = item.node;
                    if (!valueNode && item.props.length > 0) {
                        // Comments on an empty mapping value need to be preserved, so we
                        // need to construct a minimal empty node here to use instead of the
                        // missing `item.node`. -- eemeli/yaml#19
                        valueNode = new (0, $10eVG.P)((0, $10eVG.T).PLAIN, []);
                        valueNode.context = {
                            parent: item,
                            src: item.context.src
                        };
                        const pos = item.range.start + 1;
                        valueNode.range = {
                            start: pos,
                            end: pos
                        };
                        valueNode.valueRange = {
                            start: pos,
                            end: pos
                        };
                        if (typeof item.range.origStart === 'number') {
                            const origPos = item.range.origStart + 1;
                            valueNode.range.origStart = valueNode.range.origEnd = origPos;
                            valueNode.valueRange.origStart = valueNode.valueRange.origEnd = origPos;
                        }
                    }
                    const pair = new $b874452e1b501c71$export$56c0d5a1e737357d(key, $b874452e1b501c71$export$43caf9889c228507(doc, valueNode));
                    $b874452e1b501c71$var$resolvePairComment(item, pair);
                    items.push(pair);
                    if (key && typeof keyStart === 'number') {
                        if (item.range.start > keyStart + 1024) doc.errors.push($b874452e1b501c71$var$getLongKeyError(cst, key));
                    }
                    key = undefined;
                    keyStart = null;
                }
                break;
            default:
                if (key !== undefined) items.push(new $b874452e1b501c71$export$56c0d5a1e737357d(key));
                key = $b874452e1b501c71$export$43caf9889c228507(doc, item);
                keyStart = item.range.start;
                if (item.error) doc.errors.push(item.error);
                next: for(let j = i + 1;; ++j){
                    const nextItem = cst.items[j];
                    switch(nextItem && nextItem.type){
                        case (0, $10eVG.T).BLANK_LINE:
                        case (0, $10eVG.T).COMMENT:
                            continue next;
                        case (0, $10eVG.T).MAP_VALUE:
                            break next;
                        default:
                            {
                                const msg = 'Implicit map keys need to be followed by map values';
                                doc.errors.push(new (0, $10eVG.b)(item, msg));
                                break next;
                            }
                    }
                }
                if (item.valueRangeContainsNewline) {
                    const msg = 'Implicit map keys need to be on a single line';
                    doc.errors.push(new (0, $10eVG.b)(item, msg));
                }
        }
    }
    if (key !== undefined) items.push(new $b874452e1b501c71$export$56c0d5a1e737357d(key));
    return {
        comments: comments,
        items: items
    };
}
function $b874452e1b501c71$var$resolveFlowMapItems(doc, cst) {
    const comments = [];
    const items = [];
    let key = undefined;
    let explicitKey = false;
    let next = '{';
    for(let i = 0; i < cst.items.length; ++i){
        const item = cst.items[i];
        if (typeof item.char === 'string') {
            const { char: char, offset: offset } = item;
            if (char === '?' && key === undefined && !explicitKey) {
                explicitKey = true;
                next = ':';
                continue;
            }
            if (char === ':') {
                if (key === undefined) key = null;
                if (next === ':') {
                    next = ',';
                    continue;
                }
            } else {
                if (explicitKey) {
                    if (key === undefined && char !== ',') key = null;
                    explicitKey = false;
                }
                if (key !== undefined) {
                    items.push(new $b874452e1b501c71$export$56c0d5a1e737357d(key));
                    key = undefined;
                    if (char === ',') {
                        next = ':';
                        continue;
                    }
                }
            }
            if (char === '}') {
                if (i === cst.items.length - 1) continue;
            } else if (char === next) {
                next = ':';
                continue;
            }
            const msg = `Flow map contains an unexpected ${char}`;
            const err = new (0, $10eVG.Y)(cst, msg);
            err.offset = offset;
            doc.errors.push(err);
        } else if (item.type === (0, $10eVG.T).BLANK_LINE) comments.push({
            afterKey: !!key,
            before: items.length
        });
        else if (item.type === (0, $10eVG.T).COMMENT) {
            $b874452e1b501c71$var$checkFlowCommentSpace(doc.errors, item);
            comments.push({
                afterKey: !!key,
                before: items.length,
                comment: item.comment
            });
        } else if (key === undefined) {
            if (next === ',') doc.errors.push(new (0, $10eVG.b)(item, 'Separator , missing in flow map'));
            key = $b874452e1b501c71$export$43caf9889c228507(doc, item);
        } else {
            if (next !== ',') doc.errors.push(new (0, $10eVG.b)(item, 'Indicator : missing in flow map entry'));
            items.push(new $b874452e1b501c71$export$56c0d5a1e737357d(key, $b874452e1b501c71$export$43caf9889c228507(doc, item)));
            key = undefined;
            explicitKey = false;
        }
    }
    $b874452e1b501c71$var$checkFlowCollectionEnd(doc.errors, cst);
    if (key !== undefined) items.push(new $b874452e1b501c71$export$56c0d5a1e737357d(key));
    return {
        comments: comments,
        items: items
    };
}
function $b874452e1b501c71$export$dda1d9f60106f0e9(doc, cst) {
    if (cst.type !== (0, $10eVG.T).SEQ && cst.type !== (0, $10eVG.T).FLOW_SEQ) {
        const msg = `A ${cst.type} node cannot be resolved as a sequence`;
        doc.errors.push(new (0, $10eVG.Y)(cst, msg));
        return null;
    }
    const { comments: comments, items: items } = cst.type === (0, $10eVG.T).FLOW_SEQ ? $b874452e1b501c71$var$resolveFlowSeqItems(doc, cst) : $b874452e1b501c71$var$resolveBlockSeqItems(doc, cst);
    const seq = new $b874452e1b501c71$export$8743009a87fcb00f();
    seq.items = items;
    $b874452e1b501c71$var$resolveComments(seq, comments);
    if (!doc.options.mapAsMap && items.some((it)=>it instanceof $b874452e1b501c71$export$56c0d5a1e737357d && it.key instanceof $b874452e1b501c71$export$e7094788287c5e9b)) {
        const warn = 'Keys with collection values will be stringified as YAML due to JS Object restrictions. Use mapAsMap: true to avoid this.';
        doc.warnings.push(new (0, $10eVG.a)(cst, warn));
    }
    cst.resolved = seq;
    return seq;
}
function $b874452e1b501c71$var$resolveBlockSeqItems(doc, cst) {
    const comments = [];
    const items = [];
    for(let i = 0; i < cst.items.length; ++i){
        const item = cst.items[i];
        switch(item.type){
            case (0, $10eVG.T).BLANK_LINE:
                comments.push({
                    before: items.length
                });
                break;
            case (0, $10eVG.T).COMMENT:
                comments.push({
                    comment: item.comment,
                    before: items.length
                });
                break;
            case (0, $10eVG.T).SEQ_ITEM:
                if (item.error) doc.errors.push(item.error);
                items.push($b874452e1b501c71$export$43caf9889c228507(doc, item.node));
                if (item.hasProps) {
                    const msg = 'Sequence items cannot have tags or anchors before the - indicator';
                    doc.errors.push(new (0, $10eVG.b)(item, msg));
                }
                break;
            default:
                if (item.error) doc.errors.push(item.error);
                doc.errors.push(new (0, $10eVG.Y)(item, `Unexpected ${item.type} node in sequence`));
        }
    }
    return {
        comments: comments,
        items: items
    };
}
function $b874452e1b501c71$var$resolveFlowSeqItems(doc, cst) {
    const comments = [];
    const items = [];
    let explicitKey = false;
    let key = undefined;
    let keyStart = null;
    let next = '[';
    let prevItem = null;
    for(let i = 0; i < cst.items.length; ++i){
        const item = cst.items[i];
        if (typeof item.char === 'string') {
            const { char: char, offset: offset } = item;
            if (char !== ':' && (explicitKey || key !== undefined)) {
                if (explicitKey && key === undefined) key = next ? items.pop() : null;
                items.push(new $b874452e1b501c71$export$56c0d5a1e737357d(key));
                explicitKey = false;
                key = undefined;
                keyStart = null;
            }
            if (char === next) next = null;
            else if (!next && char === '?') explicitKey = true;
            else if (next !== '[' && char === ':' && key === undefined) {
                if (next === ',') {
                    key = items.pop();
                    if (key instanceof $b874452e1b501c71$export$56c0d5a1e737357d) {
                        const msg = 'Chaining flow sequence pairs is invalid';
                        const err = new (0, $10eVG.b)(cst, msg);
                        err.offset = offset;
                        doc.errors.push(err);
                    }
                    if (!explicitKey && typeof keyStart === 'number') {
                        const keyEnd = item.range ? item.range.start : item.offset;
                        if (keyEnd > keyStart + 1024) doc.errors.push($b874452e1b501c71$var$getLongKeyError(cst, key));
                        const { src: src } = prevItem.context;
                        for(let i = keyStart; i < keyEnd; ++i)if (src[i] === '\n') {
                            const msg = 'Implicit keys of flow sequence pairs need to be on a single line';
                            doc.errors.push(new (0, $10eVG.b)(prevItem, msg));
                            break;
                        }
                    }
                } else key = null;
                keyStart = null;
                explicitKey = false;
                next = null;
            } else if (next === '[' || char !== ']' || i < cst.items.length - 1) {
                const msg = `Flow sequence contains an unexpected ${char}`;
                const err = new (0, $10eVG.Y)(cst, msg);
                err.offset = offset;
                doc.errors.push(err);
            }
        } else if (item.type === (0, $10eVG.T).BLANK_LINE) comments.push({
            before: items.length
        });
        else if (item.type === (0, $10eVG.T).COMMENT) {
            $b874452e1b501c71$var$checkFlowCommentSpace(doc.errors, item);
            comments.push({
                comment: item.comment,
                before: items.length
            });
        } else {
            if (next) {
                const msg = `Expected a ${next} in flow sequence`;
                doc.errors.push(new (0, $10eVG.b)(item, msg));
            }
            const value = $b874452e1b501c71$export$43caf9889c228507(doc, item);
            if (key === undefined) {
                items.push(value);
                prevItem = item;
            } else {
                items.push(new $b874452e1b501c71$export$56c0d5a1e737357d(key, value));
                key = undefined;
            }
            keyStart = item.range.start;
            next = ',';
        }
    }
    $b874452e1b501c71$var$checkFlowCollectionEnd(doc.errors, cst);
    if (key !== undefined) items.push(new $b874452e1b501c71$export$56c0d5a1e737357d(key));
    return {
        comments: comments,
        items: items
    };
}

});

parcelRegister("fy1aE", function(module, exports) {

$parcel$export(module.exports, "S", () => $b51af07a0cd30a4f$export$25ce5a424b770e84);

var $10eVG = parcelRequire("10eVG");

var $fPQpe = parcelRequire("fPQpe");

var $9fMDQ = parcelRequire("9fMDQ");
function $b51af07a0cd30a4f$var$createMap(schema, obj, ctx) {
    const map = new (0, $fPQpe.d)(schema);
    if (obj instanceof Map) for (const [key, value] of obj)map.items.push(schema.createPair(key, value, ctx));
    else if (obj && typeof obj === 'object') for (const key of Object.keys(obj))map.items.push(schema.createPair(key, obj[key], ctx));
    if (typeof schema.sortMapEntries === 'function') map.items.sort(schema.sortMapEntries);
    return map;
}
const $b51af07a0cd30a4f$var$map = {
    createNode: $b51af07a0cd30a4f$var$createMap,
    default: true,
    nodeClass: (0, $fPQpe.d),
    tag: 'tag:yaml.org,2002:map',
    resolve: (0, $fPQpe.g)
};
function $b51af07a0cd30a4f$var$createSeq(schema, obj, ctx) {
    const seq = new (0, $fPQpe.Y)(schema);
    if (obj && obj[Symbol.iterator]) for (const it of obj){
        const v = schema.createNode(it, ctx.wrapScalars, null, ctx);
        seq.items.push(v);
    }
    return seq;
}
const $b51af07a0cd30a4f$var$seq = {
    createNode: $b51af07a0cd30a4f$var$createSeq,
    default: true,
    nodeClass: (0, $fPQpe.Y),
    tag: 'tag:yaml.org,2002:seq',
    resolve: (0, $fPQpe.h)
};
const $b51af07a0cd30a4f$var$string = {
    identify: (value)=>typeof value === 'string',
    default: true,
    tag: 'tag:yaml.org,2002:str',
    resolve: (0, $fPQpe.j),
    stringify (item, ctx, onComment, onChompKeep) {
        ctx = Object.assign({
            actualString: true
        }, ctx);
        return (0, $fPQpe.c)(item, ctx, onComment, onChompKeep);
    },
    options: (0, $fPQpe.s)
};
const $b51af07a0cd30a4f$var$failsafe = [
    $b51af07a0cd30a4f$var$map,
    $b51af07a0cd30a4f$var$seq,
    $b51af07a0cd30a4f$var$string
];
/* global BigInt */ const $b51af07a0cd30a4f$var$intIdentify$2 = (value)=>typeof value === 'bigint' || Number.isInteger(value);
const $b51af07a0cd30a4f$var$intResolve$1 = (src, part, radix)=>(0, $fPQpe.i).asBigInt ? BigInt(src) : parseInt(part, radix);
function $b51af07a0cd30a4f$var$intStringify$1(node, radix, prefix) {
    const { value: value } = node;
    if ($b51af07a0cd30a4f$var$intIdentify$2(value) && value >= 0) return prefix + value.toString(radix);
    return (0, $fPQpe.k)(node);
}
const $b51af07a0cd30a4f$var$nullObj = {
    identify: (value)=>value == null,
    createNode: (schema, value, ctx)=>ctx.wrapScalars ? new (0, $fPQpe.S)(null) : null,
    default: true,
    tag: 'tag:yaml.org,2002:null',
    test: /^(?:~|[Nn]ull|NULL)?$/,
    resolve: ()=>null,
    options: (0, $fPQpe.n),
    stringify: ()=>(0, $fPQpe.n).nullStr
};
const $b51af07a0cd30a4f$var$boolObj = {
    identify: (value)=>typeof value === 'boolean',
    default: true,
    tag: 'tag:yaml.org,2002:bool',
    test: /^(?:[Tt]rue|TRUE|[Ff]alse|FALSE)$/,
    resolve: (str)=>str[0] === 't' || str[0] === 'T',
    options: (0, $fPQpe.a),
    stringify: ({ value: value })=>value ? (0, $fPQpe.a).trueStr : (0, $fPQpe.a).falseStr
};
const $b51af07a0cd30a4f$var$octObj = {
    identify: (value)=>$b51af07a0cd30a4f$var$intIdentify$2(value) && value >= 0,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'OCT',
    test: /^0o([0-7]+)$/,
    resolve: (str, oct)=>$b51af07a0cd30a4f$var$intResolve$1(str, oct, 8),
    options: (0, $fPQpe.i),
    stringify: (node)=>$b51af07a0cd30a4f$var$intStringify$1(node, 8, '0o')
};
const $b51af07a0cd30a4f$var$intObj = {
    identify: $b51af07a0cd30a4f$var$intIdentify$2,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    test: /^[-+]?[0-9]+$/,
    resolve: (str)=>$b51af07a0cd30a4f$var$intResolve$1(str, str, 10),
    options: (0, $fPQpe.i),
    stringify: (0, $fPQpe.k)
};
const $b51af07a0cd30a4f$var$hexObj = {
    identify: (value)=>$b51af07a0cd30a4f$var$intIdentify$2(value) && value >= 0,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'HEX',
    test: /^0x([0-9a-fA-F]+)$/,
    resolve: (str, hex)=>$b51af07a0cd30a4f$var$intResolve$1(str, hex, 16),
    options: (0, $fPQpe.i),
    stringify: (node)=>$b51af07a0cd30a4f$var$intStringify$1(node, 16, '0x')
};
const $b51af07a0cd30a4f$var$nanObj = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:float',
    test: /^(?:[-+]?\.inf|(\.nan))$/i,
    resolve: (str, nan)=>nan ? NaN : str[0] === '-' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY,
    stringify: (0, $fPQpe.k)
};
const $b51af07a0cd30a4f$var$expObj = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:float',
    format: 'EXP',
    test: /^[-+]?(?:\.[0-9]+|[0-9]+(?:\.[0-9]*)?)[eE][-+]?[0-9]+$/,
    resolve: (str)=>parseFloat(str),
    stringify: ({ value: value })=>Number(value).toExponential()
};
const $b51af07a0cd30a4f$var$floatObj = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:float',
    test: /^[-+]?(?:\.([0-9]+)|[0-9]+\.([0-9]*))$/,
    resolve (str, frac1, frac2) {
        const frac = frac1 || frac2;
        const node = new (0, $fPQpe.S)(parseFloat(str));
        if (frac && frac[frac.length - 1] === '0') node.minFractionDigits = frac.length;
        return node;
    },
    stringify: (0, $fPQpe.k)
};
const $b51af07a0cd30a4f$var$core = $b51af07a0cd30a4f$var$failsafe.concat([
    $b51af07a0cd30a4f$var$nullObj,
    $b51af07a0cd30a4f$var$boolObj,
    $b51af07a0cd30a4f$var$octObj,
    $b51af07a0cd30a4f$var$intObj,
    $b51af07a0cd30a4f$var$hexObj,
    $b51af07a0cd30a4f$var$nanObj,
    $b51af07a0cd30a4f$var$expObj,
    $b51af07a0cd30a4f$var$floatObj
]);
/* global BigInt */ const $b51af07a0cd30a4f$var$intIdentify$1 = (value)=>typeof value === 'bigint' || Number.isInteger(value);
const $b51af07a0cd30a4f$var$stringifyJSON = ({ value: value })=>JSON.stringify(value);
const $b51af07a0cd30a4f$var$json = [
    $b51af07a0cd30a4f$var$map,
    $b51af07a0cd30a4f$var$seq,
    {
        identify: (value)=>typeof value === 'string',
        default: true,
        tag: 'tag:yaml.org,2002:str',
        resolve: (0, $fPQpe.j),
        stringify: $b51af07a0cd30a4f$var$stringifyJSON
    },
    {
        identify: (value)=>value == null,
        createNode: (schema, value, ctx)=>ctx.wrapScalars ? new (0, $fPQpe.S)(null) : null,
        default: true,
        tag: 'tag:yaml.org,2002:null',
        test: /^null$/,
        resolve: ()=>null,
        stringify: $b51af07a0cd30a4f$var$stringifyJSON
    },
    {
        identify: (value)=>typeof value === 'boolean',
        default: true,
        tag: 'tag:yaml.org,2002:bool',
        test: /^true|false$/,
        resolve: (str)=>str === 'true',
        stringify: $b51af07a0cd30a4f$var$stringifyJSON
    },
    {
        identify: $b51af07a0cd30a4f$var$intIdentify$1,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        test: /^-?(?:0|[1-9][0-9]*)$/,
        resolve: (str)=>(0, $fPQpe.i).asBigInt ? BigInt(str) : parseInt(str, 10),
        stringify: ({ value: value })=>$b51af07a0cd30a4f$var$intIdentify$1(value) ? value.toString() : JSON.stringify(value)
    },
    {
        identify: (value)=>typeof value === 'number',
        default: true,
        tag: 'tag:yaml.org,2002:float',
        test: /^-?(?:0|[1-9][0-9]*)(?:\.[0-9]*)?(?:[eE][-+]?[0-9]+)?$/,
        resolve: (str)=>parseFloat(str),
        stringify: $b51af07a0cd30a4f$var$stringifyJSON
    }
];
$b51af07a0cd30a4f$var$json.scalarFallback = (str)=>{
    throw new SyntaxError(`Unresolved plain scalar ${JSON.stringify(str)}`);
};
/* global BigInt */ const $b51af07a0cd30a4f$var$boolStringify = ({ value: value })=>value ? (0, $fPQpe.a).trueStr : (0, $fPQpe.a).falseStr;
const $b51af07a0cd30a4f$var$intIdentify = (value)=>typeof value === 'bigint' || Number.isInteger(value);
function $b51af07a0cd30a4f$var$intResolve(sign, src, radix) {
    let str = src.replace(/_/g, '');
    if ((0, $fPQpe.i).asBigInt) {
        switch(radix){
            case 2:
                str = `0b${str}`;
                break;
            case 8:
                str = `0o${str}`;
                break;
            case 16:
                str = `0x${str}`;
                break;
        }
        const n = BigInt(str);
        return sign === '-' ? BigInt(-1) * n : n;
    }
    const n = parseInt(str, radix);
    return sign === '-' ? -1 * n : n;
}
function $b51af07a0cd30a4f$var$intStringify(node, radix, prefix) {
    const { value: value } = node;
    if ($b51af07a0cd30a4f$var$intIdentify(value)) {
        const str = value.toString(radix);
        return value < 0 ? '-' + prefix + str.substr(1) : prefix + str;
    }
    return (0, $fPQpe.k)(node);
}
const $b51af07a0cd30a4f$var$yaml11 = $b51af07a0cd30a4f$var$failsafe.concat([
    {
        identify: (value)=>value == null,
        createNode: (schema, value, ctx)=>ctx.wrapScalars ? new (0, $fPQpe.S)(null) : null,
        default: true,
        tag: 'tag:yaml.org,2002:null',
        test: /^(?:~|[Nn]ull|NULL)?$/,
        resolve: ()=>null,
        options: (0, $fPQpe.n),
        stringify: ()=>(0, $fPQpe.n).nullStr
    },
    {
        identify: (value)=>typeof value === 'boolean',
        default: true,
        tag: 'tag:yaml.org,2002:bool',
        test: /^(?:Y|y|[Yy]es|YES|[Tt]rue|TRUE|[Oo]n|ON)$/,
        resolve: ()=>true,
        options: (0, $fPQpe.a),
        stringify: $b51af07a0cd30a4f$var$boolStringify
    },
    {
        identify: (value)=>typeof value === 'boolean',
        default: true,
        tag: 'tag:yaml.org,2002:bool',
        test: /^(?:N|n|[Nn]o|NO|[Ff]alse|FALSE|[Oo]ff|OFF)$/i,
        resolve: ()=>false,
        options: (0, $fPQpe.a),
        stringify: $b51af07a0cd30a4f$var$boolStringify
    },
    {
        identify: $b51af07a0cd30a4f$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        format: 'BIN',
        test: /^([-+]?)0b([0-1_]+)$/,
        resolve: (str, sign, bin)=>$b51af07a0cd30a4f$var$intResolve(sign, bin, 2),
        stringify: (node)=>$b51af07a0cd30a4f$var$intStringify(node, 2, '0b')
    },
    {
        identify: $b51af07a0cd30a4f$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        format: 'OCT',
        test: /^([-+]?)0([0-7_]+)$/,
        resolve: (str, sign, oct)=>$b51af07a0cd30a4f$var$intResolve(sign, oct, 8),
        stringify: (node)=>$b51af07a0cd30a4f$var$intStringify(node, 8, '0')
    },
    {
        identify: $b51af07a0cd30a4f$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        test: /^([-+]?)([0-9][0-9_]*)$/,
        resolve: (str, sign, abs)=>$b51af07a0cd30a4f$var$intResolve(sign, abs, 10),
        stringify: (0, $fPQpe.k)
    },
    {
        identify: $b51af07a0cd30a4f$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        format: 'HEX',
        test: /^([-+]?)0x([0-9a-fA-F_]+)$/,
        resolve: (str, sign, hex)=>$b51af07a0cd30a4f$var$intResolve(sign, hex, 16),
        stringify: (node)=>$b51af07a0cd30a4f$var$intStringify(node, 16, '0x')
    },
    {
        identify: (value)=>typeof value === 'number',
        default: true,
        tag: 'tag:yaml.org,2002:float',
        test: /^(?:[-+]?\.inf|(\.nan))$/i,
        resolve: (str, nan)=>nan ? NaN : str[0] === '-' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY,
        stringify: (0, $fPQpe.k)
    },
    {
        identify: (value)=>typeof value === 'number',
        default: true,
        tag: 'tag:yaml.org,2002:float',
        format: 'EXP',
        test: /^[-+]?([0-9][0-9_]*)?(\.[0-9_]*)?[eE][-+]?[0-9]+$/,
        resolve: (str)=>parseFloat(str.replace(/_/g, '')),
        stringify: ({ value: value })=>Number(value).toExponential()
    },
    {
        identify: (value)=>typeof value === 'number',
        default: true,
        tag: 'tag:yaml.org,2002:float',
        test: /^[-+]?(?:[0-9][0-9_]*)?\.([0-9_]*)$/,
        resolve (str, frac) {
            const node = new (0, $fPQpe.S)(parseFloat(str.replace(/_/g, '')));
            if (frac) {
                const f = frac.replace(/_/g, '');
                if (f[f.length - 1] === '0') node.minFractionDigits = f.length;
            }
            return node;
        },
        stringify: (0, $fPQpe.k)
    }
], (0, $9fMDQ.b), (0, $9fMDQ.o), (0, $9fMDQ.p), (0, $9fMDQ.s), (0, $9fMDQ.i), (0, $9fMDQ.f), (0, $9fMDQ.t));
const $b51af07a0cd30a4f$var$schemas = {
    core: $b51af07a0cd30a4f$var$core,
    failsafe: $b51af07a0cd30a4f$var$failsafe,
    json: $b51af07a0cd30a4f$var$json,
    yaml11: $b51af07a0cd30a4f$var$yaml11
};
const $b51af07a0cd30a4f$var$tags = {
    binary: $9fMDQ.b,
    bool: $b51af07a0cd30a4f$var$boolObj,
    float: $b51af07a0cd30a4f$var$floatObj,
    floatExp: $b51af07a0cd30a4f$var$expObj,
    floatNaN: $b51af07a0cd30a4f$var$nanObj,
    floatTime: $9fMDQ.f,
    int: $b51af07a0cd30a4f$var$intObj,
    intHex: $b51af07a0cd30a4f$var$hexObj,
    intOct: $b51af07a0cd30a4f$var$octObj,
    intTime: $9fMDQ.i,
    map: $b51af07a0cd30a4f$var$map,
    null: $b51af07a0cd30a4f$var$nullObj,
    omap: $9fMDQ.o,
    pairs: $9fMDQ.p,
    seq: $b51af07a0cd30a4f$var$seq,
    set: $9fMDQ.s,
    timestamp: $9fMDQ.t
};
function $b51af07a0cd30a4f$var$findTagObject(value, tagName, tags) {
    if (tagName) {
        const match = tags.filter((t)=>t.tag === tagName);
        const tagObj = match.find((t)=>!t.format) || match[0];
        if (!tagObj) throw new Error(`Tag ${tagName} not found`);
        return tagObj;
    }
    // TODO: deprecate/remove class check
    return tags.find((t)=>(t.identify && t.identify(value) || t.class && value instanceof t.class) && !t.format);
}
function $b51af07a0cd30a4f$var$createNode(value, tagName, ctx) {
    if (value instanceof (0, $fPQpe.N)) return value;
    const { defaultPrefix: defaultPrefix, onTagObj: onTagObj, prevObjects: prevObjects, schema: schema, wrapScalars: wrapScalars } = ctx;
    if (tagName && tagName.startsWith('!!')) tagName = defaultPrefix + tagName.slice(2);
    let tagObj = $b51af07a0cd30a4f$var$findTagObject(value, tagName, schema.tags);
    if (!tagObj) {
        if (typeof value.toJSON === 'function') value = value.toJSON();
        if (!value || typeof value !== 'object') return wrapScalars ? new (0, $fPQpe.S)(value) : value;
        tagObj = value instanceof Map ? $b51af07a0cd30a4f$var$map : value[Symbol.iterator] ? $b51af07a0cd30a4f$var$seq : $b51af07a0cd30a4f$var$map;
    }
    if (onTagObj) {
        onTagObj(tagObj);
        delete ctx.onTagObj;
    }
    // Detect duplicate references to the same object & use Alias nodes for all
    // after first. The `obj` wrapper allows for circular references to resolve.
    const obj = {
        value: undefined,
        node: undefined
    };
    if (value && typeof value === 'object' && prevObjects) {
        const prev = prevObjects.get(value);
        if (prev) {
            const alias = new (0, $fPQpe.A)(prev); // leaves source dirty; must be cleaned by caller
            ctx.aliasNodes.push(alias); // defined along with prevObjects
            return alias;
        }
        obj.value = value;
        prevObjects.set(value, obj);
    }
    obj.node = tagObj.createNode ? tagObj.createNode(ctx.schema, value, ctx) : wrapScalars ? new (0, $fPQpe.S)(value) : value;
    if (tagName && obj.node instanceof (0, $fPQpe.N)) obj.node.tag = tagName;
    return obj.node;
}
function $b51af07a0cd30a4f$var$getSchemaTags(schemas, knownTags, customTags, schemaId) {
    let tags = schemas[schemaId.replace(/\W/g, '')]; // 'yaml-1.1' -> 'yaml11'
    if (!tags) {
        const keys = Object.keys(schemas).map((key)=>JSON.stringify(key)).join(', ');
        throw new Error(`Unknown schema "${schemaId}"; use one of ${keys}`);
    }
    if (Array.isArray(customTags)) for (const tag of customTags)tags = tags.concat(tag);
    else if (typeof customTags === 'function') tags = customTags(tags.slice());
    for(let i = 0; i < tags.length; ++i){
        const tag = tags[i];
        if (typeof tag === 'string') {
            const tagObj = knownTags[tag];
            if (!tagObj) {
                const keys = Object.keys(knownTags).map((key)=>JSON.stringify(key)).join(', ');
                throw new Error(`Unknown custom tag "${tag}"; use one of ${keys}`);
            }
            tags[i] = tagObj;
        }
    }
    return tags;
}
const $b51af07a0cd30a4f$var$sortMapEntriesByKey = (a, b)=>a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
class $b51af07a0cd30a4f$export$25ce5a424b770e84 {
    // TODO: remove in v2
    constructor({ customTags: customTags, merge: merge, schema: schema, sortMapEntries: sortMapEntries, tags: deprecatedCustomTags }){
        this.merge = !!merge;
        this.name = schema;
        this.sortMapEntries = sortMapEntries === true ? $b51af07a0cd30a4f$var$sortMapEntriesByKey : sortMapEntries || null;
        if (!customTags && deprecatedCustomTags) (0, $9fMDQ.a)('tags', 'customTags');
        this.tags = $b51af07a0cd30a4f$var$getSchemaTags($b51af07a0cd30a4f$var$schemas, $b51af07a0cd30a4f$var$tags, customTags || deprecatedCustomTags, schema);
    }
    createNode(value, wrapScalars, tagName, ctx) {
        const baseCtx = {
            defaultPrefix: $b51af07a0cd30a4f$export$25ce5a424b770e84.defaultPrefix,
            schema: this,
            wrapScalars: wrapScalars
        };
        const createCtx = ctx ? Object.assign(ctx, baseCtx) : baseCtx;
        return $b51af07a0cd30a4f$var$createNode(value, tagName, createCtx);
    }
    createPair(key, value, ctx) {
        if (!ctx) ctx = {
            wrapScalars: true
        };
        const k = this.createNode(key, ctx.wrapScalars, null, ctx);
        const v = this.createNode(value, ctx.wrapScalars, null, ctx);
        return new (0, $fPQpe.P)(k, v);
    }
}
(0, $10eVG._)($b51af07a0cd30a4f$export$25ce5a424b770e84, "defaultPrefix", (0, $10eVG.d));
// TODO: remove in v2
(0, $10eVG._)($b51af07a0cd30a4f$export$25ce5a424b770e84, "defaultTags", (0, $10eVG.e));

});
parcelRegister("9fMDQ", function(module, exports) {

$parcel$export(module.exports, "b", () => $6bcb3efcf226493a$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "p", () => $6bcb3efcf226493a$export$ffb5f4729a158638);
$parcel$export(module.exports, "o", () => $6bcb3efcf226493a$export$ae1af26003f05816);
$parcel$export(module.exports, "s", () => $6bcb3efcf226493a$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "i", () => $6bcb3efcf226493a$export$23f2a1d2818174ef);
$parcel$export(module.exports, "f", () => $6bcb3efcf226493a$export$2d1720544b23b823);
$parcel$export(module.exports, "t", () => $6bcb3efcf226493a$export$625550452a3fa3ec);
$parcel$export(module.exports, "w", () => $6bcb3efcf226493a$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "a", () => $6bcb3efcf226493a$export$407448d2b89b1813);

var $10eVG = parcelRequire("10eVG");

var $fPQpe = parcelRequire("fPQpe");

var $6ZWSX = parcelRequire("6ZWSX");
var $6bcb3efcf226493a$require$Buffer = $6ZWSX.Buffer;
/* global atob, btoa, Buffer */ const $6bcb3efcf226493a$export$8b22cf2602fb60ce = {
    identify: (value)=>value instanceof Uint8Array,
    // Buffer inherits from Uint8Array
    default: false,
    tag: 'tag:yaml.org,2002:binary',
    /**
   * Returns a Buffer in node and an Uint8Array in browsers
   *
   * To use the resulting buffer as an image, you'll want to do something like:
   *
   *   const blob = new Blob([buffer], { type: 'image/jpeg' })
   *   document.querySelector('#photo').src = URL.createObjectURL(blob)
   */ resolve: (doc, node)=>{
        const src = (0, $fPQpe.j)(doc, node);
        if (typeof $6bcb3efcf226493a$require$Buffer === 'function') return $6bcb3efcf226493a$require$Buffer.from(src, 'base64');
        else if (typeof atob === 'function') {
            // On IE 11, atob() can't handle newlines
            const str = atob(src.replace(/[\n\r]/g, ''));
            const buffer = new Uint8Array(str.length);
            for(let i = 0; i < str.length; ++i)buffer[i] = str.charCodeAt(i);
            return buffer;
        } else {
            const msg = 'This environment does not support reading binary tags; either Buffer or atob is required';
            doc.errors.push(new (0, $10eVG.f)(node, msg));
            return null;
        }
    },
    options: (0, $fPQpe.b),
    stringify: ({ comment: comment, type: type, value: value }, ctx, onComment, onChompKeep)=>{
        let src;
        if (typeof $6bcb3efcf226493a$require$Buffer === 'function') src = value instanceof $6bcb3efcf226493a$require$Buffer ? value.toString('base64') : $6bcb3efcf226493a$require$Buffer.from(value.buffer).toString('base64');
        else if (typeof btoa === 'function') {
            let s = '';
            for(let i = 0; i < value.length; ++i)s += String.fromCharCode(value[i]);
            src = btoa(s);
        } else throw new Error('This environment does not support writing binary tags; either Buffer or btoa is required');
        if (!type) type = (0, $fPQpe.b).defaultType;
        if (type === (0, $10eVG.T).QUOTE_DOUBLE) value = src;
        else {
            const { lineWidth: lineWidth } = (0, $fPQpe.b);
            const n = Math.ceil(src.length / lineWidth);
            const lines = new Array(n);
            for(let i = 0, o = 0; i < n; ++i, o += lineWidth)lines[i] = src.substr(o, lineWidth);
            value = lines.join(type === (0, $10eVG.T).BLOCK_LITERAL ? '\n' : ' ');
        }
        return (0, $fPQpe.c)({
            comment: comment,
            type: type,
            value: value
        }, ctx, onComment, onChompKeep);
    }
};
function $6bcb3efcf226493a$var$parsePairs(doc, cst) {
    const seq = (0, $fPQpe.h)(doc, cst);
    for(let i = 0; i < seq.items.length; ++i){
        let item = seq.items[i];
        if (item instanceof (0, $fPQpe.P)) continue;
        else if (item instanceof (0, $fPQpe.d)) {
            if (item.items.length > 1) {
                const msg = 'Each pair must have its own sequence indicator';
                throw new (0, $10eVG.b)(cst, msg);
            }
            const pair = item.items[0] || new (0, $fPQpe.P)();
            if (item.commentBefore) pair.commentBefore = pair.commentBefore ? `${item.commentBefore}\n${pair.commentBefore}` : item.commentBefore;
            if (item.comment) pair.comment = pair.comment ? `${item.comment}\n${pair.comment}` : item.comment;
            item = pair;
        }
        seq.items[i] = item instanceof (0, $fPQpe.P) ? item : new (0, $fPQpe.P)(item);
    }
    return seq;
}
function $6bcb3efcf226493a$var$createPairs(schema, iterable, ctx) {
    const pairs = new (0, $fPQpe.Y)(schema);
    pairs.tag = 'tag:yaml.org,2002:pairs';
    for (const it of iterable){
        let key, value;
        if (Array.isArray(it)) {
            if (it.length === 2) {
                key = it[0];
                value = it[1];
            } else throw new TypeError(`Expected [key, value] tuple: ${it}`);
        } else if (it && it instanceof Object) {
            const keys = Object.keys(it);
            if (keys.length === 1) {
                key = keys[0];
                value = it[key];
            } else throw new TypeError(`Expected { key: value } tuple: ${it}`);
        } else key = it;
        const pair = schema.createPair(key, value, ctx);
        pairs.items.push(pair);
    }
    return pairs;
}
const $6bcb3efcf226493a$export$ffb5f4729a158638 = {
    default: false,
    tag: 'tag:yaml.org,2002:pairs',
    resolve: $6bcb3efcf226493a$var$parsePairs,
    createNode: $6bcb3efcf226493a$var$createPairs
};
class $6bcb3efcf226493a$var$YAMLOMap extends (0, $fPQpe.Y) {
    constructor(){
        super();
        (0, $10eVG._)(this, "add", (0, $fPQpe.d).prototype.add.bind(this));
        (0, $10eVG._)(this, "delete", (0, $fPQpe.d).prototype.delete.bind(this));
        (0, $10eVG._)(this, "get", (0, $fPQpe.d).prototype.get.bind(this));
        (0, $10eVG._)(this, "has", (0, $fPQpe.d).prototype.has.bind(this));
        (0, $10eVG._)(this, "set", (0, $fPQpe.d).prototype.set.bind(this));
        this.tag = $6bcb3efcf226493a$var$YAMLOMap.tag;
    }
    toJSON(_, ctx) {
        const map = new Map();
        if (ctx && ctx.onCreate) ctx.onCreate(map);
        for (const pair of this.items){
            let key, value;
            if (pair instanceof (0, $fPQpe.P)) {
                key = (0, $fPQpe.t)(pair.key, '', ctx);
                value = (0, $fPQpe.t)(pair.value, key, ctx);
            } else key = (0, $fPQpe.t)(pair, '', ctx);
            if (map.has(key)) throw new Error('Ordered maps must not include duplicate keys');
            map.set(key, value);
        }
        return map;
    }
}
(0, $10eVG._)($6bcb3efcf226493a$var$YAMLOMap, "tag", 'tag:yaml.org,2002:omap');
function $6bcb3efcf226493a$var$parseOMap(doc, cst) {
    const pairs = $6bcb3efcf226493a$var$parsePairs(doc, cst);
    const seenKeys = [];
    for (const { key: key } of pairs.items)if (key instanceof (0, $fPQpe.S)) {
        if (seenKeys.includes(key.value)) {
            const msg = 'Ordered maps must not include duplicate keys';
            throw new (0, $10eVG.b)(cst, msg);
        } else seenKeys.push(key.value);
    }
    return Object.assign(new $6bcb3efcf226493a$var$YAMLOMap(), pairs);
}
function $6bcb3efcf226493a$var$createOMap(schema, iterable, ctx) {
    const pairs = $6bcb3efcf226493a$var$createPairs(schema, iterable, ctx);
    const omap = new $6bcb3efcf226493a$var$YAMLOMap();
    omap.items = pairs.items;
    return omap;
}
const $6bcb3efcf226493a$export$ae1af26003f05816 = {
    identify: (value)=>value instanceof Map,
    nodeClass: $6bcb3efcf226493a$var$YAMLOMap,
    default: false,
    tag: 'tag:yaml.org,2002:omap',
    resolve: $6bcb3efcf226493a$var$parseOMap,
    createNode: $6bcb3efcf226493a$var$createOMap
};
class $6bcb3efcf226493a$var$YAMLSet extends (0, $fPQpe.d) {
    constructor(){
        super();
        this.tag = $6bcb3efcf226493a$var$YAMLSet.tag;
    }
    add(key) {
        const pair = key instanceof (0, $fPQpe.P) ? key : new (0, $fPQpe.P)(key);
        const prev = (0, $fPQpe.l)(this.items, pair.key);
        if (!prev) this.items.push(pair);
    }
    get(key, keepPair) {
        const pair = (0, $fPQpe.l)(this.items, key);
        return !keepPair && pair instanceof (0, $fPQpe.P) ? pair.key instanceof (0, $fPQpe.S) ? pair.key.value : pair.key : pair;
    }
    set(key, value) {
        if (typeof value !== 'boolean') throw new Error(`Expected boolean value for set(key, value) in a YAML set, not ${typeof value}`);
        const prev = (0, $fPQpe.l)(this.items, key);
        if (prev && !value) this.items.splice(this.items.indexOf(prev), 1);
        else if (!prev && value) this.items.push(new (0, $fPQpe.P)(key));
    }
    toJSON(_, ctx) {
        return super.toJSON(_, ctx, Set);
    }
    toString(ctx, onComment, onChompKeep) {
        if (!ctx) return JSON.stringify(this);
        if (this.hasAllNullValues()) return super.toString(ctx, onComment, onChompKeep);
        else throw new Error('Set items must all have null values');
    }
}
(0, $10eVG._)($6bcb3efcf226493a$var$YAMLSet, "tag", 'tag:yaml.org,2002:set');
function $6bcb3efcf226493a$var$parseSet(doc, cst) {
    const map = (0, $fPQpe.g)(doc, cst);
    if (!map.hasAllNullValues()) throw new (0, $10eVG.b)(cst, 'Set items must all have null values');
    return Object.assign(new $6bcb3efcf226493a$var$YAMLSet(), map);
}
function $6bcb3efcf226493a$var$createSet(schema, iterable, ctx) {
    const set = new $6bcb3efcf226493a$var$YAMLSet();
    for (const value of iterable)set.items.push(schema.createPair(value, null, ctx));
    return set;
}
const $6bcb3efcf226493a$export$2408f22a0fab9ae5 = {
    identify: (value)=>value instanceof Set,
    nodeClass: $6bcb3efcf226493a$var$YAMLSet,
    default: false,
    tag: 'tag:yaml.org,2002:set',
    resolve: $6bcb3efcf226493a$var$parseSet,
    createNode: $6bcb3efcf226493a$var$createSet
};
const $6bcb3efcf226493a$var$parseSexagesimal = (sign, parts)=>{
    const n = parts.split(':').reduce((n, p)=>n * 60 + Number(p), 0);
    return sign === '-' ? -n : n;
};
// hhhh:mm:ss.sss
const $6bcb3efcf226493a$var$stringifySexagesimal = ({ value: value })=>{
    if (isNaN(value) || !isFinite(value)) return (0, $fPQpe.k)(value);
    let sign = '';
    if (value < 0) {
        sign = '-';
        value = Math.abs(value);
    }
    const parts = [
        value % 60
    ]; // seconds, including ms
    if (value < 60) parts.unshift(0); // at least one : is required
    else {
        value = Math.round((value - parts[0]) / 60);
        parts.unshift(value % 60); // minutes
        if (value >= 60) {
            value = Math.round((value - parts[0]) / 60);
            parts.unshift(value); // hours
        }
    }
    return sign + parts.map((n)=>n < 10 ? '0' + String(n) : String(n)).join(':').replace(/000000\d*$/, '') // % 60 may introduce error
    ;
};
const $6bcb3efcf226493a$export$23f2a1d2818174ef = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'TIME',
    test: /^([-+]?)([0-9][0-9_]*(?::[0-5]?[0-9])+)$/,
    resolve: (str, sign, parts)=>$6bcb3efcf226493a$var$parseSexagesimal(sign, parts.replace(/_/g, '')),
    stringify: $6bcb3efcf226493a$var$stringifySexagesimal
};
const $6bcb3efcf226493a$export$2d1720544b23b823 = {
    identify: (value)=>typeof value === 'number',
    default: true,
    tag: 'tag:yaml.org,2002:float',
    format: 'TIME',
    test: /^([-+]?)([0-9][0-9_]*(?::[0-5]?[0-9])+\.[0-9_]*)$/,
    resolve: (str, sign, parts)=>$6bcb3efcf226493a$var$parseSexagesimal(sign, parts.replace(/_/g, '')),
    stringify: $6bcb3efcf226493a$var$stringifySexagesimal
};
const $6bcb3efcf226493a$export$625550452a3fa3ec = {
    identify: (value)=>value instanceof Date,
    default: true,
    tag: 'tag:yaml.org,2002:timestamp',
    // If the time zone is omitted, the timestamp is assumed to be specified in UTC. The time part
    // may be omitted altogether, resulting in a date format. In such a case, the time part is
    // assumed to be 00:00:00Z (start of day, UTC).
    test: RegExp("^(?:([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})(?:(?:t|T|[ \\t]+)([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2}(\\.[0-9]+)?)(?:[ \\t]*(Z|[-+][012]?[0-9](?::[0-9]{2})?))?)?)$"),
    resolve: (str, year, month, day, hour, minute, second, millisec, tz)=>{
        if (millisec) millisec = (millisec + '00').substr(1, 3);
        let date = Date.UTC(year, month - 1, day, hour || 0, minute || 0, second || 0, millisec || 0);
        if (tz && tz !== 'Z') {
            let d = $6bcb3efcf226493a$var$parseSexagesimal(tz[0], tz.slice(1));
            if (Math.abs(d) < 30) d *= 60;
            date -= 60000 * d;
        }
        return new Date(date);
    },
    stringify: ({ value: value })=>value.toISOString().replace(/((T00:00)?:00)?\.000Z$/, '')
};
/* global console, process, YAML_SILENCE_DEPRECATION_WARNINGS, YAML_SILENCE_WARNINGS */ function $6bcb3efcf226493a$var$shouldWarn(deprecation) {
    const env = {};
    if (deprecation) {
        if (typeof YAML_SILENCE_DEPRECATION_WARNINGS !== 'undefined') return !YAML_SILENCE_DEPRECATION_WARNINGS;
        return !env.YAML_SILENCE_DEPRECATION_WARNINGS;
    }
    if (typeof YAML_SILENCE_WARNINGS !== 'undefined') return !YAML_SILENCE_WARNINGS;
    return !env.YAML_SILENCE_WARNINGS;
}
function $6bcb3efcf226493a$export$efccba1c4a2ef57b(warning, type) {
    if ($6bcb3efcf226493a$var$shouldWarn(false)) {
        const emit = false;
        // This will throw in Jest if `warning` is an Error instance due to
        // https://github.com/facebook/jest/issues/2549
        if (emit) emit(warning, type);
        else // eslint-disable-next-line no-console
        console.warn(type ? `${type}: ${warning}` : warning);
    }
}
function $6bcb3efcf226493a$export$db3b6bfb95261072(filename) {
    if ($6bcb3efcf226493a$var$shouldWarn(true)) {
        const path = filename.replace(/.*yaml[/\\]/i, '').replace(/\.js$/, '').replace(/\\/g, '/');
        $6bcb3efcf226493a$export$efccba1c4a2ef57b(`The endpoint 'yaml/${path}' will be removed in a future release.`, 'DeprecationWarning');
    }
}
const $6bcb3efcf226493a$var$warned = {};
function $6bcb3efcf226493a$export$407448d2b89b1813(name, alternative) {
    if (!$6bcb3efcf226493a$var$warned[name] && $6bcb3efcf226493a$var$shouldWarn(true)) {
        $6bcb3efcf226493a$var$warned[name] = true;
        let msg = `The option '${name}' will be removed in a future release`;
        msg += alternative ? `, use '${alternative}' instead.` : '.';
        $6bcb3efcf226493a$export$efccba1c4a2ef57b(msg, 'DeprecationWarning');
    }
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});






parcelRegister("gUqIv", function(module, exports) {

$parcel$export(module.exports, "math", () => $c4f699b4a01e0372$export$1c891a3202c0ba6a);
$parcel$export(module.exports, "cssVar", () => $c4f699b4a01e0372$export$8b4981022bd80a4e);
$parcel$export(module.exports, "directionalProperty", () => $c4f699b4a01e0372$export$4fc00c04dd60af95);
$parcel$export(module.exports, "stripUnit", () => $c4f699b4a01e0372$export$ef04e38dc423904);
$parcel$export(module.exports, "em", () => $c4f699b4a01e0372$export$c63c6f932822f543);
$parcel$export(module.exports, "getValueAndUnit", () => $c4f699b4a01e0372$export$feec6b849ef388ab);
$parcel$export(module.exports, "important", () => $c4f699b4a01e0372$export$929888ab0c9f043c);
$parcel$export(module.exports, "modularScale", () => $c4f699b4a01e0372$export$c82a8a23c9e8bdb6);
$parcel$export(module.exports, "rem", () => $c4f699b4a01e0372$export$fb1897a40d146f7f);
$parcel$export(module.exports, "remToPx", () => $c4f699b4a01e0372$export$7e5d3caf0359a67a);
$parcel$export(module.exports, "easeIn", () => $c4f699b4a01e0372$export$929e5a82286172a6);
$parcel$export(module.exports, "easeInOut", () => $c4f699b4a01e0372$export$c07234257a03d5e9);
$parcel$export(module.exports, "easeOut", () => $c4f699b4a01e0372$export$57636bb43b1ccbb0);
$parcel$export(module.exports, "between", () => $c4f699b4a01e0372$export$cf95c51b03f10bae);
$parcel$export(module.exports, "clearFix", () => $c4f699b4a01e0372$export$8c467e8859fdef13);
$parcel$export(module.exports, "cover", () => $c4f699b4a01e0372$export$4bdbf921f0c0fd8c);
$parcel$export(module.exports, "ellipsis", () => $c4f699b4a01e0372$export$a5b94313d6908893);
$parcel$export(module.exports, "fluidRange", () => $c4f699b4a01e0372$export$de4c2ac00f6121cf);
$parcel$export(module.exports, "fontFace", () => $c4f699b4a01e0372$export$566c6c2ff0443c7);
$parcel$export(module.exports, "hideText", () => $c4f699b4a01e0372$export$27bef6389954e24d);
$parcel$export(module.exports, "hideVisually", () => $c4f699b4a01e0372$export$36e2157ae4e3cbdd);
$parcel$export(module.exports, "hiDPI", () => $c4f699b4a01e0372$export$e79006618d7c6cc3);
$parcel$export(module.exports, "linearGradient", () => $c4f699b4a01e0372$export$46def8197cf4dd4c);
$parcel$export(module.exports, "normalize", () => $c4f699b4a01e0372$export$a3295358bff77e);
$parcel$export(module.exports, "radialGradient", () => $c4f699b4a01e0372$export$3922d1ccb8631cd8);
$parcel$export(module.exports, "retinaImage", () => $c4f699b4a01e0372$export$19389033401d366a);
$parcel$export(module.exports, "timingFunctions", () => $c4f699b4a01e0372$export$61210fa83792a81);
$parcel$export(module.exports, "triangle", () => $c4f699b4a01e0372$export$9eed783d03e0135c);
$parcel$export(module.exports, "wordWrap", () => $c4f699b4a01e0372$export$dca3d8ad656c34d2);
$parcel$export(module.exports, "parseToRgb", () => $c4f699b4a01e0372$export$2f48baff6995707a);
$parcel$export(module.exports, "parseToHsl", () => $c4f699b4a01e0372$export$1286688e1b3fde9c);
$parcel$export(module.exports, "hsl", () => $c4f699b4a01e0372$export$8f4a7c0bb78e6ea8);
$parcel$export(module.exports, "hsla", () => $c4f699b4a01e0372$export$810b04175080204c);
$parcel$export(module.exports, "rgb", () => $c4f699b4a01e0372$export$8972dc0e6ad9238f);
$parcel$export(module.exports, "rgba", () => $c4f699b4a01e0372$export$4e46ac54fc82cf3b);
$parcel$export(module.exports, "toColorString", () => $c4f699b4a01e0372$export$42fe740cdf79b2df);
$parcel$export(module.exports, "adjustHue", () => $c4f699b4a01e0372$export$2b372a09365374d6);
$parcel$export(module.exports, "complement", () => $c4f699b4a01e0372$export$bd4f6f7e1823bc9e);
$parcel$export(module.exports, "darken", () => $c4f699b4a01e0372$export$4b073707ff63303);
$parcel$export(module.exports, "desaturate", () => $c4f699b4a01e0372$export$fb75607d98509d9);
$parcel$export(module.exports, "getLuminance", () => $c4f699b4a01e0372$export$c852d90bf7403b62);
$parcel$export(module.exports, "getContrast", () => $c4f699b4a01e0372$export$850ce485a60d103b);
$parcel$export(module.exports, "grayscale", () => $c4f699b4a01e0372$export$6f416a6db2dfcd5c);
$parcel$export(module.exports, "hslToColorString", () => $c4f699b4a01e0372$export$97fc773b219a4ae);
$parcel$export(module.exports, "invert", () => $c4f699b4a01e0372$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "lighten", () => $c4f699b4a01e0372$export$c0816ed86df316af);
$parcel$export(module.exports, "meetsContrastGuidelines", () => $c4f699b4a01e0372$export$bc0d548020bc5a2);
$parcel$export(module.exports, "mix", () => $c4f699b4a01e0372$export$2c9e8a9632a706b2);
$parcel$export(module.exports, "opacify", () => $c4f699b4a01e0372$export$f4f50e3877dd0530);
$parcel$export(module.exports, "readableColor", () => $c4f699b4a01e0372$export$61654c1796c44811);
$parcel$export(module.exports, "rgbToColorString", () => $c4f699b4a01e0372$export$34b0917fcca19deb);
$parcel$export(module.exports, "saturate", () => $c4f699b4a01e0372$export$5fcac96f5a87e3db);
$parcel$export(module.exports, "setHue", () => $c4f699b4a01e0372$export$3bf58ce3e497a846);
$parcel$export(module.exports, "setLightness", () => $c4f699b4a01e0372$export$7ef5d725337b805d);
$parcel$export(module.exports, "setSaturation", () => $c4f699b4a01e0372$export$b40fe421ea7a4f7e);
$parcel$export(module.exports, "shade", () => $c4f699b4a01e0372$export$3e32adda0df4ef5d);
$parcel$export(module.exports, "tint", () => $c4f699b4a01e0372$export$fc176dd65a27d98b);
$parcel$export(module.exports, "transparentize", () => $c4f699b4a01e0372$export$d11da87e55cc498f);
$parcel$export(module.exports, "animation", () => $c4f699b4a01e0372$export$ecad260a8a5fef4f);
$parcel$export(module.exports, "backgroundImages", () => $c4f699b4a01e0372$export$c7de706fee81cfb4);
$parcel$export(module.exports, "backgrounds", () => $c4f699b4a01e0372$export$d041fef2b78b7906);
$parcel$export(module.exports, "border", () => $c4f699b4a01e0372$export$1edee58a52776cd9);
$parcel$export(module.exports, "borderColor", () => $c4f699b4a01e0372$export$e7fb0694ba2404fc);
$parcel$export(module.exports, "borderRadius", () => $c4f699b4a01e0372$export$7a57f79000377ca2);
$parcel$export(module.exports, "borderStyle", () => $c4f699b4a01e0372$export$4d0a7f76ad443516);
$parcel$export(module.exports, "borderWidth", () => $c4f699b4a01e0372$export$12879c7697ed953d);
$parcel$export(module.exports, "buttons", () => $c4f699b4a01e0372$export$bbea856fdb3e3c5f);
$parcel$export(module.exports, "margin", () => $c4f699b4a01e0372$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $c4f699b4a01e0372$export$6f98e8eaf0be1996);
$parcel$export(module.exports, "position", () => $c4f699b4a01e0372$export$5880b8b5730aff45);
$parcel$export(module.exports, "size", () => $c4f699b4a01e0372$export$346677f925de839c);
$parcel$export(module.exports, "textInputs", () => $c4f699b4a01e0372$export$baad927ee93ccf9c);
$parcel$export(module.exports, "transitions", () => $c4f699b4a01e0372$export$622eca585e740ed5);

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $fGnq2 = parcelRequire("fGnq2");

var $gZblc = parcelRequire("gZblc");
function $c4f699b4a01e0372$var$last() {
    var _ref;
    return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function $c4f699b4a01e0372$var$negation(a) {
    return -a;
}
function $c4f699b4a01e0372$var$addition(a, b) {
    return a + b;
}
function $c4f699b4a01e0372$var$subtraction(a, b) {
    return a - b;
}
function $c4f699b4a01e0372$var$multiplication(a, b) {
    return a * b;
}
function $c4f699b4a01e0372$var$division(a, b) {
    return a / b;
}
function $c4f699b4a01e0372$var$max() {
    return Math.max.apply(Math, arguments);
}
function $c4f699b4a01e0372$var$min() {
    return Math.min.apply(Math, arguments);
}
function $c4f699b4a01e0372$var$comma() {
    return Array.of.apply(Array, arguments);
}
var $c4f699b4a01e0372$var$defaultSymbols = {
    symbols: {
        '*': {
            infix: {
                symbol: '*',
                f: $c4f699b4a01e0372$var$multiplication,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '*',
            regSymbol: '\\*'
        },
        '/': {
            infix: {
                symbol: '/',
                f: $c4f699b4a01e0372$var$division,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '/',
            regSymbol: '/'
        },
        '+': {
            infix: {
                symbol: '+',
                f: $c4f699b4a01e0372$var$addition,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '+',
                f: $c4f699b4a01e0372$var$last,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '+',
            regSymbol: '\\+'
        },
        '-': {
            infix: {
                symbol: '-',
                f: $c4f699b4a01e0372$var$subtraction,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '-',
                f: $c4f699b4a01e0372$var$negation,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '-',
            regSymbol: '-'
        },
        ',': {
            infix: {
                symbol: ',',
                f: $c4f699b4a01e0372$var$comma,
                notation: 'infix',
                precedence: 1,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: ',',
            regSymbol: ','
        },
        '(': {
            prefix: {
                symbol: '(',
                f: $c4f699b4a01e0372$var$last,
                notation: 'prefix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '(',
            regSymbol: '\\('
        },
        ')': {
            postfix: {
                symbol: ')',
                f: undefined,
                notation: 'postfix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: ')',
            regSymbol: '\\)'
        },
        min: {
            func: {
                symbol: 'min',
                f: $c4f699b4a01e0372$var$min,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'min',
            regSymbol: 'min\\b'
        },
        max: {
            func: {
                symbol: 'max',
                f: $c4f699b4a01e0372$var$max,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'max',
            regSymbol: 'max\\b'
        }
    }
};
var $c4f699b4a01e0372$var$defaultSymbolMap = $c4f699b4a01e0372$var$defaultSymbols;
// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */ var $c4f699b4a01e0372$var$ERRORS = {
    "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
    "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
    "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
    "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
    "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
    "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
    "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
    "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
    "9": "Please provide a number of steps to the modularScale helper.\n\n",
    "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
    "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
    "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
    "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "16": "You must provide a template to this method.\n\n",
    "17": "You passed an unsupported selector state to this method.\n\n",
    "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "23": "fontFace expects a name of a font-family.\n\n",
    "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "25": "fontFace expects localFonts to be an array.\n\n",
    "26": "fontFace expects fileFormats to be an array.\n\n",
    "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
    "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
    "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
    "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "36": "Property must be a string value.\n\n",
    "37": "Syntax Error at %s.\n\n",
    "38": "Formula contains a function that needs parentheses at %s.\n\n",
    "39": "Formula is missing closing parenthesis at %s.\n\n",
    "40": "Formula has too many closing parentheses at %s.\n\n",
    "41": "All values in a formula must have the same unit or be unitless.\n\n",
    "42": "Please provide a number of steps to the modularScale helper.\n\n",
    "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
    "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
    "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
    "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
    "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
    "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "53": "fontFace expects localFonts to be an array.\n\n",
    "54": "fontFace expects fileFormats to be an array.\n\n",
    "55": "fontFace expects a name of a font-family.\n\n",
    "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
    "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "61": "Property must be a string value.\n\n",
    "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
    "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
    "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
    "67": "You must provide a template to this method.\n\n",
    "68": "You passed an unsupported selector state to this method.\n\n",
    "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
    "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
    "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "73": "Please provide a valid CSS variable.\n\n",
    "74": "CSS variable not found and no default was provided.\n\n",
    "75": "important requires a valid style object, got a %s instead.\n\n",
    "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
    "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
    "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */ function $c4f699b4a01e0372$var$format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var $c4f699b4a01e0372$var$PolishedError = /*#__PURE__*/ function(_Error) {
    (0, $g7ajw.default)(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        var _len2, args, _key2;
        _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
        return (0, $hDpcU.default)(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ (0, $fGnq2.default)(Error));
var $c4f699b4a01e0372$var$unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;
// Merges additional math functionality into the defaults.
function $c4f699b4a01e0372$var$mergeSymbolMaps(additionalSymbols) {
    var symbolMap = {};
    symbolMap.symbols = additionalSymbols ? (0, $8nd05.default)({}, $c4f699b4a01e0372$var$defaultSymbolMap.symbols, additionalSymbols.symbols) : (0, $8nd05.default)({}, $c4f699b4a01e0372$var$defaultSymbolMap.symbols);
    return symbolMap;
}
function $c4f699b4a01e0372$var$exec(operators, values) {
    var _ref;
    var op = operators.pop();
    values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
    return op.precedence;
}
function $c4f699b4a01e0372$var$calculate(expression, additionalSymbols) {
    var symbolMap = $c4f699b4a01e0372$var$mergeSymbolMaps(additionalSymbols);
    var match;
    var operators = [
        symbolMap.symbols['('].prefix
    ];
    var values = [];
    var pattern = new RegExp("\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
    Object.keys(symbolMap.symbols).map(function(key) {
        return symbolMap.symbols[key];
    })// longer symbols should be listed first
    // $FlowFixMe
    .sort(function(a, b) {
        return b.symbol.length - a.symbol.length;
    })// $FlowFixMe
    .map(function(val) {
        return val.regSymbol;
    }).join('|') + "|(\\S)", 'g');
    pattern.lastIndex = 0; // Reset regular expression object
    var afterValue = false;
    do {
        match = pattern.exec(expression);
        var _ref2 = match || [
            ')',
            undefined
        ], token = _ref2[0], bad = _ref2[1];
        var notNumber = symbolMap.symbols[token];
        var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix;
        // Check for syntax errors:
        if (bad || (afterValue ? notAfterValue : notNewValue)) throw new $c4f699b4a01e0372$var$PolishedError(37, match ? match.index : expression.length, expression);
        if (afterValue) {
            // We either have an infix or postfix operator (they should be mutually exclusive)
            var curr = notNumber.postfix || notNumber.infix;
            do {
                var prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break;
            // Apply previous operator, since it has precedence over current one
            }while ($c4f699b4a01e0372$var$exec(operators, values)); // Exit loop after executing an opening parenthesis or function
            afterValue = curr.notation === 'postfix';
            if (curr.symbol !== ')') {
                operators.push(curr);
                // Postfix always has precedence over any operator that follows after it
                if (afterValue) $c4f699b4a01e0372$var$exec(operators, values);
            }
        } else if (notNumber) {
            // prefix operator or function
            operators.push(notNumber.prefix || notNumber.func);
            if (notNumber.func) {
                // Require an opening parenthesis
                match = pattern.exec(expression);
                if (!match || match[0] !== '(') throw new $c4f699b4a01e0372$var$PolishedError(38, match ? match.index : expression.length, expression);
            }
        } else {
            // number
            values.push(+token);
            afterValue = true;
        }
    }while (match && operators.length);
    if (operators.length) throw new $c4f699b4a01e0372$var$PolishedError(39, match ? match.index : expression.length, expression);
    else if (match) throw new $c4f699b4a01e0372$var$PolishedError(40, match ? match.index : expression.length, expression);
    else return values.pop();
}
function $c4f699b4a01e0372$var$reverseString(str) {
    return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */ function $c4f699b4a01e0372$export$1c891a3202c0ba6a(formula, additionalSymbols) {
    var reversedFormula = $c4f699b4a01e0372$var$reverseString(formula);
    var formulaMatch = reversedFormula.match($c4f699b4a01e0372$var$unitRegExp);
    // Check that all units are the same
    if (formulaMatch && !formulaMatch.every(function(unit) {
        return unit === formulaMatch[0];
    })) throw new $c4f699b4a01e0372$var$PolishedError(41);
    var cleanFormula = $c4f699b4a01e0372$var$reverseString(reversedFormula.replace($c4f699b4a01e0372$var$unitRegExp, ''));
    return "" + $c4f699b4a01e0372$var$calculate(cleanFormula, additionalSymbols) + (formulaMatch ? $c4f699b4a01e0372$var$reverseString(formulaMatch[0]) : '');
}
var $c4f699b4a01e0372$var$cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */ function $c4f699b4a01e0372$export$8b4981022bd80a4e(cssVariable, defaultValue) {
    if (!cssVariable || !cssVariable.match($c4f699b4a01e0372$var$cssVariableRegex)) throw new $c4f699b4a01e0372$var$PolishedError(73);
    var variableValue;
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
    /* eslint-enable */ if (variableValue) return variableValue.trim();
    else if (defaultValue) return defaultValue;
    throw new $c4f699b4a01e0372$var$PolishedError(74);
}
// @private
function $c4f699b4a01e0372$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $c4f699b4a01e0372$var$positionMap$1 = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $c4f699b4a01e0372$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $c4f699b4a01e0372$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $c4f699b4a01e0372$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$c4f699b4a01e0372$var$generateProperty(property, $c4f699b4a01e0372$var$positionMap$1[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $c4f699b4a01e0372$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $c4f699b4a01e0372$var$generateStyles(property, valuesWithDefaults);
}
/**
 * Check if a string ends with something
 * @private
 */ function $c4f699b4a01e0372$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
var $c4f699b4a01e0372$var$cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $c4f699b4a01e0372$export$ef04e38dc423904(value) {
    if (typeof value !== 'string') return value;
    var matchedValue = value.match($c4f699b4a01e0372$var$cssRegex$1);
    return matchedValue ? parseFloat(value) : value;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $c4f699b4a01e0372$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$c4f699b4a01e0372$var$endsWith(pxval, 'px')) throw new $c4f699b4a01e0372$var$PolishedError(69, to, pxval);
            newPxval = $c4f699b4a01e0372$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$c4f699b4a01e0372$var$endsWith(base, 'px')) throw new $c4f699b4a01e0372$var$PolishedError(70, to, base);
            newBase = $c4f699b4a01e0372$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new $c4f699b4a01e0372$var$PolishedError(71, pxval, to);
        if (typeof newBase === 'string') throw new $c4f699b4a01e0372$var$PolishedError(72, base, to);
        return "" + newPxval / newBase + to;
    };
};
var $c4f699b4a01e0372$var$pixelsto = $c4f699b4a01e0372$var$pxtoFactory;
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $c4f699b4a01e0372$var$em = $c4f699b4a01e0372$var$pixelsto('em');
var $c4f699b4a01e0372$export$c63c6f932822f543 = $c4f699b4a01e0372$var$em;
var $c4f699b4a01e0372$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */ function $c4f699b4a01e0372$export$feec6b849ef388ab(value) {
    if (typeof value !== 'string') return [
        value,
        ''
    ];
    var matchedValue = value.match($c4f699b4a01e0372$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */ function $c4f699b4a01e0372$export$929888ab0c9f043c(styleBlock, rules) {
    if (typeof styleBlock !== 'object' || styleBlock === null) throw new $c4f699b4a01e0372$var$PolishedError(75, typeof styleBlock);
    var newStyleBlock = {};
    Object.keys(styleBlock).forEach(function(key) {
        if (typeof styleBlock[key] === 'object' && styleBlock[key] !== null) newStyleBlock[key] = $c4f699b4a01e0372$export$929888ab0c9f043c(styleBlock[key], rules);
        else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) newStyleBlock[key] = styleBlock[key] + " !important";
        else newStyleBlock[key] = styleBlock[key];
    });
    return newStyleBlock;
}
var $c4f699b4a01e0372$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $c4f699b4a01e0372$var$getRatio(ratioName) {
    return $c4f699b4a01e0372$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $c4f699b4a01e0372$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = '1em';
    if (ratio === void 0) ratio = 1.333;
    if (typeof steps !== 'number') throw new $c4f699b4a01e0372$var$PolishedError(42);
    if (typeof ratio === 'string' && !$c4f699b4a01e0372$var$ratioNames[ratio]) throw new $c4f699b4a01e0372$var$PolishedError(43);
    var _ref = typeof base === 'string' ? $c4f699b4a01e0372$export$feec6b849ef388ab(base) : [
        base,
        ''
    ], realBase = _ref[0], unit = _ref[1];
    var realRatio = typeof ratio === 'string' ? $c4f699b4a01e0372$var$getRatio(ratio) : ratio;
    if (typeof realBase === 'string') throw new $c4f699b4a01e0372$var$PolishedError(44, base);
    return "" + realBase * Math.pow(realRatio, steps) + (unit || '');
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $c4f699b4a01e0372$var$rem = $c4f699b4a01e0372$var$pixelsto('rem');
var $c4f699b4a01e0372$export$fb1897a40d146f7f = $c4f699b4a01e0372$var$rem;
var $c4f699b4a01e0372$var$defaultFontSize = 16;
function $c4f699b4a01e0372$var$convertBase(base) {
    var deconstructedValue = $c4f699b4a01e0372$export$feec6b849ef388ab(base);
    if (deconstructedValue[1] === 'px') return parseFloat(base);
    if (deconstructedValue[1] === '%') return parseFloat(base) / 100 * $c4f699b4a01e0372$var$defaultFontSize;
    throw new $c4f699b4a01e0372$var$PolishedError(78, deconstructedValue[1]);
}
function $c4f699b4a01e0372$var$getBaseFromDoc() {
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) {
        var rootFontSize = getComputedStyle(document.documentElement).fontSize;
        return rootFontSize ? $c4f699b4a01e0372$var$convertBase(rootFontSize) : $c4f699b4a01e0372$var$defaultFontSize;
    }
    /* eslint-enable */ /* istanbul ignore next */ return $c4f699b4a01e0372$var$defaultFontSize;
}
/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */ function $c4f699b4a01e0372$export$7e5d3caf0359a67a(value, base) {
    var deconstructedValue = $c4f699b4a01e0372$export$feec6b849ef388ab(value);
    if (deconstructedValue[1] !== 'rem' && deconstructedValue[1] !== '') throw new $c4f699b4a01e0372$var$PolishedError(77, deconstructedValue[1]);
    var newBase = base ? $c4f699b4a01e0372$var$convertBase(base) : $c4f699b4a01e0372$var$getBaseFromDoc();
    return deconstructedValue[0] * newBase + "px";
}
var $c4f699b4a01e0372$var$functionsMap$3 = {
    back: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    circ: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    cubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    expo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    quad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    quart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    quint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    sine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $c4f699b4a01e0372$export$929e5a82286172a6(functionName) {
    return $c4f699b4a01e0372$var$functionsMap$3[functionName.toLowerCase().trim()];
}
var $c4f699b4a01e0372$var$functionsMap$2 = {
    back: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    circ: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    cubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    expo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    quad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    quart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    quint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    sine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */ function $c4f699b4a01e0372$export$c07234257a03d5e9(functionName) {
    return $c4f699b4a01e0372$var$functionsMap$2[functionName.toLowerCase().trim()];
}
var $c4f699b4a01e0372$var$functionsMap$1 = {
    back: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    cubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    circ: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    expo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    quad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    quart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    quint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    sine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */ function $c4f699b4a01e0372$export$57636bb43b1ccbb0(functionName) {
    return $c4f699b4a01e0372$var$functionsMap$1[functionName.toLowerCase().trim()];
}
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $c4f699b4a01e0372$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    var _getValueAndUnit = $c4f699b4a01e0372$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $c4f699b4a01e0372$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $c4f699b4a01e0372$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $c4f699b4a01e0372$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new $c4f699b4a01e0372$var$PolishedError(47);
    if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) throw new $c4f699b4a01e0372$var$PolishedError(48);
    if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) throw new $c4f699b4a01e0372$var$PolishedError(76);
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $c4f699b4a01e0372$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $c4f699b4a01e0372$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $c4f699b4a01e0372$export$a5b94313d6908893(width, lines) {
    if (lines === void 0) lines = 1;
    var styles = {
        display: 'inline-block',
        maxWidth: width || '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
    return lines > 1 ? (0, $8nd05.default)({}, styles, {
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: lines,
        display: '-webkit-box',
        whiteSpace: 'normal'
    }) : styles;
}
function $c4f699b4a01e0372$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $c4f699b4a01e0372$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c4f699b4a01e0372$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c4f699b4a01e0372$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c4f699b4a01e0372$var$_arrayLikeToArray(o, minLen);
}
function $c4f699b4a01e0372$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $c4f699b4a01e0372$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) throw new $c4f699b4a01e0372$var$PolishedError(49);
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = $c4f699b4a01e0372$var$_createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;){
            var _extends2, _extends3;
            var obj = _step.value;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new $c4f699b4a01e0372$var$PolishedError(50);
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $8nd05.default)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $c4f699b4a01e0372$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $8nd05.default)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $8nd05.default)({}, fallbacks, mediaQueries);
    } else {
        var _ref, _ref2, _ref3;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new $c4f699b4a01e0372$var$PolishedError(51);
        return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = $c4f699b4a01e0372$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
    }
}
var $c4f699b4a01e0372$var$dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var $c4f699b4a01e0372$var$formatHintMap = {
    woff: 'woff',
    woff2: 'woff2',
    ttf: 'truetype',
    otf: 'opentype',
    eot: 'embedded-opentype',
    svg: 'svg',
    svgz: 'svg'
};
function $c4f699b4a01e0372$var$generateFormatHint(format, formatHint) {
    if (!formatHint) return '';
    return " format(\"" + $c4f699b4a01e0372$var$formatHintMap[format] + "\")";
}
function $c4f699b4a01e0372$var$isDataURI(fontFilePath) {
    return !!fontFilePath.replace(/\s+/g, ' ').match($c4f699b4a01e0372$var$dataURIRegex);
}
function $c4f699b4a01e0372$var$generateFileReferences(fontFilePath, fileFormats, formatHint) {
    if ($c4f699b4a01e0372$var$isDataURI(fontFilePath)) return "url(\"" + fontFilePath + "\")" + $c4f699b4a01e0372$var$generateFormatHint(fileFormats[0], formatHint);
    var fileFontReferences = fileFormats.map(function(format) {
        return "url(\"" + fontFilePath + "." + format + "\")" + $c4f699b4a01e0372$var$generateFormatHint(format, formatHint);
    });
    return fileFontReferences.join(', ');
}
function $c4f699b4a01e0372$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return "local(\"" + font + "\")";
    });
    return localFontReferences.join(', ');
}
function $c4f699b4a01e0372$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($c4f699b4a01e0372$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($c4f699b4a01e0372$var$generateFileReferences(fontFilePath, fileFormats, formatHint));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $c4f699b4a01e0372$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, _ref$formatHint = _ref.formatHint, formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint, _ref$localFonts = _ref.localFonts, localFonts = _ref$localFonts === void 0 ? [
        fontFamily
    ] : _ref$localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new $c4f699b4a01e0372$var$PolishedError(55);
    if (!fontFilePath && !localFonts) throw new $c4f699b4a01e0372$var$PolishedError(52);
    if (localFonts && !Array.isArray(localFonts)) throw new $c4f699b4a01e0372$var$PolishedError(53);
    if (!Array.isArray(fileFormats)) throw new $c4f699b4a01e0372$var$PolishedError(54);
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $c4f699b4a01e0372$var$generateSources(fontFilePath, localFonts, fileFormats, formatHint),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        }
    };
    // Removes undefined fields for cleaner css object.
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $c4f699b4a01e0372$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $c4f699b4a01e0372$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $c4f699b4a01e0372$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
function $c4f699b4a01e0372$var$constructGradientValue(literals) {
    var template = '';
    for(var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)substitutions[_key - 1] = arguments[_key];
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        if (i === substitutions.length - 1 && substitutions[i]) {
            var definedValues = substitutions.filter(function(substitute) {
                return !!substitute;
            });
            // Adds leading coma if properties preceed color-stops
            if (definedValues.length > 1) {
                template = template.slice(0, -1);
                template += ", " + substitutions[i];
            // No trailing space if color-stops is the only param provided
            } else if (definedValues.length === 1) template += "" + substitutions[i];
        } else if (substitutions[i]) template += substitutions[i] + " ";
    }
    return template.trim();
}
var $c4f699b4a01e0372$var$_templateObject$1;
/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $c4f699b4a01e0372$export$46def8197cf4dd4c(_ref) {
    var colorStops = _ref.colorStops, fallback = _ref.fallback, _ref$toDirection = _ref.toDirection, toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;
    if (!colorStops || colorStops.length < 2) throw new $c4f699b4a01e0372$var$PolishedError(56);
    return {
        backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ',').split(' ')[0].replace(/,(?=\S)/g, ', '),
        backgroundImage: $c4f699b4a01e0372$var$constructGradientValue($c4f699b4a01e0372$var$_templateObject$1 || ($c4f699b4a01e0372$var$_templateObject$1 = (0, $gZblc.default)([
            "linear-gradient(",
            "",
            ")"
        ])), toDirection, colorStops.join(', ').replace(/,(?=\S)/g, ', '))
    };
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $c4f699b4a01e0372$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%'
            },
            body: {
                margin: '0'
            },
            main: {
                display: 'block'
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0'
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible'
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em'
            },
            a: {
                backgroundColor: 'transparent'
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline'
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: 'bolder'
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em'
        }, _ref.small = {
            fontSize: '80%'
        }, _ref["sub,\n    sup"] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline'
        }, _ref.sub = {
            bottom: '-0.25em'
        }, _ref.sup = {
            top: '-0.5em'
        }, _ref.img = {
            borderStyle: 'none'
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0'
        }, _ref["button,\n    input"] = {
            overflow: 'visible'
        }, _ref["button,\n    select"] = {
            textTransform: 'none'
        }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
            WebkitAppearance: 'button'
        }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
            borderStyle: 'none',
            padding: '0'
        }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
            outline: '1px dotted ButtonText'
        }, _ref.fieldset = {
            padding: '0.35em 0.625em 0.75em'
        }, _ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal'
        }, _ref.progress = {
            verticalAlign: 'baseline'
        }, _ref.textarea = {
            overflow: 'auto'
        }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
            boxSizing: 'border-box',
            padding: '0'
        }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
            height: 'auto'
        }, _ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px'
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none'
        }, _ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit'
        }, _ref.details = {
            display: 'block'
        }, _ref.summary = {
            display: 'list-item'
        }, _ref.template = {
            display: 'none'
        }, _ref['[hidden]'] = {
            display: 'none'
        }, _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted'
            }
        }
    ];
}
var $c4f699b4a01e0372$var$_templateObject;
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $c4f699b4a01e0372$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, _ref$extent = _ref.extent, extent = _ref$extent === void 0 ? '' : _ref$extent, fallback = _ref.fallback, _ref$position = _ref.position, position = _ref$position === void 0 ? '' : _ref$position, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? '' : _ref$shape;
    if (!colorStops || colorStops.length < 2) throw new $c4f699b4a01e0372$var$PolishedError(57);
    return {
        backgroundColor: fallback || colorStops[0].split(' ')[0],
        backgroundImage: $c4f699b4a01e0372$var$constructGradientValue($c4f699b4a01e0372$var$_templateObject || ($c4f699b4a01e0372$var$_templateObject = (0, $gZblc.default)([
            "radial-gradient(",
            "",
            "",
            "",
            ")"
        ])), position, shape, extent, colorStops.join(', '))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $c4f699b4a01e0372$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = 'png';
    if (retinaSuffix === void 0) retinaSuffix = '_2x';
    if (!filename) throw new $c4f699b4a01e0372$var$PolishedError(58);
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$c4f699b4a01e0372$export$e79006618d7c6cc3()] = (0, $8nd05.default)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/* eslint-disable key-spacing */ var $c4f699b4a01e0372$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */ function $c4f699b4a01e0372$var$getTimingFunction(functionName) {
    return $c4f699b4a01e0372$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $c4f699b4a01e0372$export$61210fa83792a81(timingFunction) {
    return $c4f699b4a01e0372$var$getTimingFunction(timingFunction);
}
var $c4f699b4a01e0372$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    var fullWidth = "" + width[0] + (width[1] || '');
    var halfWidth = "" + width[0] / 2 + (width[1] || '');
    var fullHeight = "" + height[0] + (height[1] || '');
    var halfHeight = "" + height[0] / 2 + (height[1] || '');
    switch(pointingDirection){
        case 'top':
            return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;
        case 'topLeft':
            return fullWidth + " " + fullHeight + " 0 0";
        case 'left':
            return halfHeight + " " + fullWidth + " " + halfHeight + " 0";
        case 'bottomLeft':
            return fullWidth + " 0 0 " + fullHeight;
        case 'bottom':
            return fullHeight + " " + halfWidth + " 0 " + halfWidth;
        case 'bottomRight':
            return "0 0 " + fullWidth + " " + fullHeight;
        case 'right':
            return halfHeight + " 0 " + halfHeight + " " + fullWidth;
        case 'topRight':
        default:
            return "0 " + fullWidth + " " + fullHeight + " 0";
    }
};
var $c4f699b4a01e0372$var$getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
    switch(pointingDirection){
        case 'top':
        case 'bottomRight':
            return {
                borderBottomColor: foregroundColor
            };
        case 'right':
        case 'bottomLeft':
            return {
                borderLeftColor: foregroundColor
            };
        case 'bottom':
        case 'topLeft':
            return {
                borderTopColor: foregroundColor
            };
        case 'left':
        case 'topRight':
            return {
                borderRightColor: foregroundColor
            };
        default:
            throw new $c4f699b4a01e0372$var$PolishedError(59);
    }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $c4f699b4a01e0372$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    var widthAndUnit = $c4f699b4a01e0372$export$feec6b849ef388ab(width);
    var heightAndUnit = $c4f699b4a01e0372$export$feec6b849ef388ab(height);
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new $c4f699b4a01e0372$var$PolishedError(60);
    return (0, $8nd05.default)({
        width: '0',
        height: '0',
        borderColor: backgroundColor
    }, $c4f699b4a01e0372$var$getBorderColor(pointingDirection, foregroundColor), {
        borderStyle: 'solid',
        borderWidth: $c4f699b4a01e0372$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
    });
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $c4f699b4a01e0372$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $c4f699b4a01e0372$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $c4f699b4a01e0372$var$convertToInt(red, green, blue) {
    return $c4f699b4a01e0372$var$colorToInt(red) + "," + $c4f699b4a01e0372$var$colorToInt(green) + "," + $c4f699b4a01e0372$var$colorToInt(blue);
}
function $c4f699b4a01e0372$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $c4f699b4a01e0372$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $c4f699b4a01e0372$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function $c4f699b4a01e0372$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $c4f699b4a01e0372$var$namedColorMap[normalizedColorName] ? "#" + $c4f699b4a01e0372$var$namedColorMap[normalizedColorName] : color;
}
var $c4f699b4a01e0372$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $c4f699b4a01e0372$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $c4f699b4a01e0372$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $c4f699b4a01e0372$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $c4f699b4a01e0372$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var $c4f699b4a01e0372$var$rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var $c4f699b4a01e0372$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var $c4f699b4a01e0372$var$hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $c4f699b4a01e0372$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new $c4f699b4a01e0372$var$PolishedError(3);
    var normalizedColor = $c4f699b4a01e0372$var$nameToHex(color);
    if (normalizedColor.match($c4f699b4a01e0372$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($c4f699b4a01e0372$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($c4f699b4a01e0372$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($c4f699b4a01e0372$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $c4f699b4a01e0372$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $c4f699b4a01e0372$var$rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $c4f699b4a01e0372$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $c4f699b4a01e0372$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $c4f699b4a01e0372$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new $c4f699b4a01e0372$var$PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $c4f699b4a01e0372$var$hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $c4f699b4a01e0372$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $c4f699b4a01e0372$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new $c4f699b4a01e0372$var$PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new $c4f699b4a01e0372$var$PolishedError(5);
}
function $c4f699b4a01e0372$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $c4f699b4a01e0372$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $c4f699b4a01e0372$var$rgbToHsl($c4f699b4a01e0372$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $c4f699b4a01e0372$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
var $c4f699b4a01e0372$var$reduceHexValue$1 = $c4f699b4a01e0372$var$reduceHexValue;
function $c4f699b4a01e0372$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $c4f699b4a01e0372$var$colorToHex(color) {
    return $c4f699b4a01e0372$var$numberToHex(Math.round(color * 255));
}
function $c4f699b4a01e0372$var$convertToHex(red, green, blue) {
    return $c4f699b4a01e0372$var$reduceHexValue$1("#" + $c4f699b4a01e0372$var$colorToHex(red) + $c4f699b4a01e0372$var$colorToHex(green) + $c4f699b4a01e0372$var$colorToHex(blue));
}
function $c4f699b4a01e0372$var$hslToHex(hue, saturation, lightness) {
    return $c4f699b4a01e0372$var$hslToRgb(hue, saturation, lightness, $c4f699b4a01e0372$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $c4f699b4a01e0372$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $c4f699b4a01e0372$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $c4f699b4a01e0372$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new $c4f699b4a01e0372$var$PolishedError(1);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $c4f699b4a01e0372$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $c4f699b4a01e0372$var$hslToHex(value, saturation, lightness) : "rgba(" + $c4f699b4a01e0372$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $c4f699b4a01e0372$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $c4f699b4a01e0372$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new $c4f699b4a01e0372$var$PolishedError(2);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $c4f699b4a01e0372$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $c4f699b4a01e0372$var$reduceHexValue$1("#" + $c4f699b4a01e0372$var$numberToHex(value) + $c4f699b4a01e0372$var$numberToHex(green) + $c4f699b4a01e0372$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $c4f699b4a01e0372$var$reduceHexValue$1("#" + $c4f699b4a01e0372$var$numberToHex(value.red) + $c4f699b4a01e0372$var$numberToHex(value.green) + $c4f699b4a01e0372$var$numberToHex(value.blue));
    throw new $c4f699b4a01e0372$var$PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $c4f699b4a01e0372$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $c4f699b4a01e0372$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $c4f699b4a01e0372$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new $c4f699b4a01e0372$var$PolishedError(7);
}
var $c4f699b4a01e0372$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $c4f699b4a01e0372$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $c4f699b4a01e0372$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $c4f699b4a01e0372$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $c4f699b4a01e0372$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new $c4f699b4a01e0372$var$PolishedError(8);
    if ($c4f699b4a01e0372$var$isRgba(color)) return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(color);
    if ($c4f699b4a01e0372$var$isRgb(color)) return $c4f699b4a01e0372$export$8972dc0e6ad9238f(color);
    if ($c4f699b4a01e0372$var$isHsla(color)) return $c4f699b4a01e0372$export$810b04175080204c(color);
    if ($c4f699b4a01e0372$var$isHsl(color)) return $c4f699b4a01e0372$export$8f4a7c0bb78e6ea8(color);
    throw new $c4f699b4a01e0372$var$PolishedError(8);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $c4f699b4a01e0372$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $c4f699b4a01e0372$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $c4f699b4a01e0372$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $c4f699b4a01e0372$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$adjustHue(degree, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $8nd05.default)({}, hslColor, {
        hue: hslColor.hue + parseFloat(degree)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedAdjustHue = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$adjustHue);
var $c4f699b4a01e0372$export$2b372a09365374d6 = $c4f699b4a01e0372$var$curriedAdjustHue;
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$bd4f6f7e1823bc9e(color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $8nd05.default)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $c4f699b4a01e0372$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$darken(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $8nd05.default)({}, hslColor, {
        lightness: $c4f699b4a01e0372$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedDarken = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$darken);
var $c4f699b4a01e0372$export$4b073707ff63303 = $c4f699b4a01e0372$var$curriedDarken;
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$desaturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $8nd05.default)({}, hslColor, {
        saturation: $c4f699b4a01e0372$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedDesaturate = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$desaturate);
var $c4f699b4a01e0372$export$fb75607d98509d9 = $c4f699b4a01e0372$var$curriedDesaturate;
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $c4f699b4a01e0372$export$c852d90bf7403b62(color) {
    if (color === 'transparent') return 0;
    var rgbColor = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */ function $c4f699b4a01e0372$export$850ce485a60d103b(color1, color2) {
    var luminance1 = $c4f699b4a01e0372$export$c852d90bf7403b62(color1);
    var luminance2 = $c4f699b4a01e0372$export$c852d90bf7403b62(color2);
    return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$6f416a6db2dfcd5c(color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $8nd05.default)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $c4f699b4a01e0372$export$97fc773b219a4ae(color) {
    if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
        if (color.alpha && typeof color.alpha === 'number') return $c4f699b4a01e0372$export$810b04175080204c({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness,
            alpha: color.alpha
        });
        return $c4f699b4a01e0372$export$8f4a7c0bb78e6ea8({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness
        });
    }
    throw new $c4f699b4a01e0372$var$PolishedError(45);
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $c4f699b4a01e0372$export$6897c284b6f9f4dc(color) {
    if (color === 'transparent') return color;
    // parse color string to rgb
    var value = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $8nd05.default)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$lighten(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $8nd05.default)({}, hslColor, {
        lightness: $c4f699b4a01e0372$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedLighten = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$lighten);
var $c4f699b4a01e0372$export$c0816ed86df316af = $c4f699b4a01e0372$var$curriedLighten;
/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */ function $c4f699b4a01e0372$export$bc0d548020bc5a2(color1, color2) {
    var contrastRatio = $c4f699b4a01e0372$export$850ce485a60d103b(color1, color2);
    return {
        AA: contrastRatio >= 4.5,
        AALarge: contrastRatio >= 3,
        AAA: contrastRatio >= 7,
        AAALarge: contrastRatio >= 4.5
    };
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $c4f699b4a01e0372$var$mix(weight, color, otherColor) {
    if (color === 'transparent') return otherColor;
    if (otherColor === 'transparent') return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var color1 = (0, $8nd05.default)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $c4f699b4a01e0372$export$2f48baff6995707a(otherColor);
    var color2 = (0, $8nd05.default)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    });
    // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
    };
    return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(mixedColor);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedMix = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string, string> */ ($c4f699b4a01e0372$var$mix);
var $c4f699b4a01e0372$export$2c9e8a9632a706b2 = $c4f699b4a01e0372$var$curriedMix;
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$opacify(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $8nd05.default)({}, parsedColor, {
        alpha: $c4f699b4a01e0372$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedOpacify = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$opacify);
var $c4f699b4a01e0372$export$f4f50e3877dd0530 = $c4f699b4a01e0372$var$curriedOpacify;
var $c4f699b4a01e0372$var$defaultReturnIfLightColor = '#000';
var $c4f699b4a01e0372$var$defaultReturnIfDarkColor = '#fff';
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */ function $c4f699b4a01e0372$export$61654c1796c44811(color, returnIfLightColor, returnIfDarkColor, strict) {
    if (returnIfLightColor === void 0) returnIfLightColor = $c4f699b4a01e0372$var$defaultReturnIfLightColor;
    if (returnIfDarkColor === void 0) returnIfDarkColor = $c4f699b4a01e0372$var$defaultReturnIfDarkColor;
    if (strict === void 0) strict = true;
    var isColorLight = $c4f699b4a01e0372$export$c852d90bf7403b62(color) > 0.179;
    var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
    if (!strict || $c4f699b4a01e0372$export$850ce485a60d103b(color, preferredReturnColor) >= 4.5) return preferredReturnColor;
    return isColorLight ? $c4f699b4a01e0372$var$defaultReturnIfLightColor : $c4f699b4a01e0372$var$defaultReturnIfDarkColor;
}
/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */ function $c4f699b4a01e0372$export$34b0917fcca19deb(color) {
    if (typeof color === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
        if (typeof color.alpha === 'number') return $c4f699b4a01e0372$export$4e46ac54fc82cf3b({
            red: color.red,
            green: color.green,
            blue: color.blue,
            alpha: color.alpha
        });
        return $c4f699b4a01e0372$export$8972dc0e6ad9238f({
            red: color.red,
            green: color.green,
            blue: color.blue
        });
    }
    throw new $c4f699b4a01e0372$var$PolishedError(46);
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$saturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = $c4f699b4a01e0372$export$1286688e1b3fde9c(color);
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $8nd05.default)({}, hslColor, {
        saturation: $c4f699b4a01e0372$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSaturate = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$saturate);
var $c4f699b4a01e0372$export$5fcac96f5a87e3db = $c4f699b4a01e0372$var$curriedSaturate;
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$setHue(hue, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $8nd05.default)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSetHue = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$setHue);
var $c4f699b4a01e0372$export$3bf58ce3e497a846 = $c4f699b4a01e0372$var$curriedSetHue;
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$setLightness(lightness, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $8nd05.default)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSetLightness = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$setLightness);
var $c4f699b4a01e0372$export$7ef5d725337b805d = $c4f699b4a01e0372$var$curriedSetLightness;
/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $c4f699b4a01e0372$var$setSaturation(saturation, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$42fe740cdf79b2df((0, $8nd05.default)({}, $c4f699b4a01e0372$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedSetSaturation = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$setSaturation);
var $c4f699b4a01e0372$export$b40fe421ea7a4f7e = $c4f699b4a01e0372$var$curriedSetSaturation;
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $c4f699b4a01e0372$var$shade(percentage, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(0, 0, 0)', color);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedShade = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$shade);
var $c4f699b4a01e0372$export$3e32adda0df4ef5d = $c4f699b4a01e0372$var$curriedShade;
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $c4f699b4a01e0372$var$tint(percentage, color) {
    if (color === 'transparent') return color;
    return $c4f699b4a01e0372$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(255, 255, 255)', color);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedTint = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$tint);
var $c4f699b4a01e0372$export$fc176dd65a27d98b = $c4f699b4a01e0372$var$curriedTint;
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $c4f699b4a01e0372$var$transparentize(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = $c4f699b4a01e0372$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $8nd05.default)({}, parsedColor, {
        alpha: $c4f699b4a01e0372$var$guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return $c4f699b4a01e0372$export$4e46ac54fc82cf3b(colorWithAlpha);
}
// prettier-ignore
var $c4f699b4a01e0372$var$curriedTransparentize = $c4f699b4a01e0372$var$curry /* ::<number | string, string, string> */ ($c4f699b4a01e0372$var$transparentize);
var $c4f699b4a01e0372$export$d11da87e55cc498f = $c4f699b4a01e0372$var$curriedTransparentize;
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $c4f699b4a01e0372$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new $c4f699b4a01e0372$var$PolishedError(64);
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new $c4f699b4a01e0372$var$PolishedError(65);
        if (Array.isArray(arg) && arg.length > 8) throw new $c4f699b4a01e0372$var$PolishedError(66);
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $c4f699b4a01e0372$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $c4f699b4a01e0372$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
var $c4f699b4a01e0372$var$sideMap = [
    'top',
    'right',
    'bottom',
    'left'
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $c4f699b4a01e0372$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === 'string' && $c4f699b4a01e0372$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $c4f699b4a01e0372$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $c4f699b4a01e0372$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $c4f699b4a01e0372$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $c4f699b4a01e0372$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'borderColor'
    ].concat(values));
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $c4f699b4a01e0372$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $c4f699b4a01e0372$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new $c4f699b4a01e0372$var$PolishedError(62);
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new $c4f699b4a01e0372$var$PolishedError(63);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $c4f699b4a01e0372$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'borderStyle'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $c4f699b4a01e0372$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'borderWidth'
    ].concat(values));
}
function $c4f699b4a01e0372$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $c4f699b4a01e0372$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new $c4f699b4a01e0372$var$PolishedError(67);
    if (states.length === 0) return $c4f699b4a01e0372$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new $c4f699b4a01e0372$var$PolishedError(68);
        selectors.push($c4f699b4a01e0372$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
var $c4f699b4a01e0372$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $c4f699b4a01e0372$var$template$1(state) {
    return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $c4f699b4a01e0372$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $c4f699b4a01e0372$var$statefulSelectors(states, $c4f699b4a01e0372$var$template$1, $c4f699b4a01e0372$var$stateMap$1);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $c4f699b4a01e0372$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'margin'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $c4f699b4a01e0372$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        'padding'
    ].concat(values));
}
var $c4f699b4a01e0372$var$positionMap = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $c4f699b4a01e0372$export$5880b8b5730aff45(firstValue) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($c4f699b4a01e0372$var$positionMap.indexOf(firstValue) >= 0 && firstValue) return (0, $8nd05.default)({}, $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        ''
    ].concat(values)), {
        position: firstValue
    });
    else return $c4f699b4a01e0372$export$4fc00c04dd60af95.apply(void 0, [
        '',
        firstValue
    ].concat(values));
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $c4f699b4a01e0372$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $c4f699b4a01e0372$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $c4f699b4a01e0372$var$template(state) {
    return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $c4f699b4a01e0372$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $c4f699b4a01e0372$var$statefulSelectors(states, $c4f699b4a01e0372$var$template, $c4f699b4a01e0372$var$stateMap);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $c4f699b4a01e0372$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== 'string') throw new $c4f699b4a01e0372$var$PolishedError(61);
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(', ');
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(', ')
    };
}

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("fGnq2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6acf1c5cac9dbb2$export$2e2bcd8739ae039);

var $jDKKo = parcelRequire("jDKKo");

var $VFVve = parcelRequire("VFVve");

var $aY9as = parcelRequire("aY9as");

var $dKk2r = parcelRequire("dKk2r");
function $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $b6acf1c5cac9dbb2$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $aY9as.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $dKk2r.default)(t, arguments, (0, $jDKKo.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $VFVve.default)(Wrapper, t);
    }, $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t);
}

});
parcelRegister("jDKKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c5ebe502337db0$export$2e2bcd8739ae039);
function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}

});

parcelRegister("aY9as", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fc69e80a314c4c3$export$2e2bcd8739ae039);
function $7fc69e80a314c4c3$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("dKk2r", function(module, exports) {

$parcel$export(module.exports, "default", () => $a01f1d6c8bd49d36$export$2e2bcd8739ae039);

var $fhGLX = parcelRequire("fhGLX");

var $VFVve = parcelRequire("VFVve");
function $a01f1d6c8bd49d36$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $fhGLX.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $VFVve.default)(p, r.prototype), p;
}

});
parcelRegister("fhGLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2099f49db83e2df$export$2e2bcd8739ae039);
function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});



parcelRegister("gZblc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5db23e5823ab236$export$2e2bcd8739ae039);
function $c5db23e5823ab236$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}

});


parcelRegister("1Df9f", function(module, exports) {
(function(name, root, factory) {
    module.exports = factory();
    module.exports['default'] = factory();
})('slugify', module.exports, function() {
    var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","\xa2":"cent","\xa3":"pound","\xa4":"currency","\xa5":"yen","\xa9":"(c)","\xaa":"a","\xae":"(r)","\xba":"o","\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xc6":"AE","\xc7":"C","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xd0":"D","\xd1":"N","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xdd":"Y","\xde":"TH","\xdf":"ss","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xe6":"ae","\xe7":"c","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xf0":"d","\xf1":"n","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xfd":"y","\xfe":"th","\xff":"y","\u0100":"A","\u0101":"a","\u0102":"A","\u0103":"a","\u0104":"A","\u0105":"a","\u0106":"C","\u0107":"c","\u010C":"C","\u010D":"c","\u010E":"D","\u010F":"d","\u0110":"DJ","\u0111":"dj","\u0112":"E","\u0113":"e","\u0116":"E","\u0117":"e","\u0118":"e","\u0119":"e","\u011A":"E","\u011B":"e","\u011E":"G","\u011F":"g","\u0122":"G","\u0123":"g","\u0128":"I","\u0129":"i","\u012A":"i","\u012B":"i","\u012E":"I","\u012F":"i","\u0130":"I","\u0131":"i","\u0136":"k","\u0137":"k","\u013B":"L","\u013C":"l","\u013D":"L","\u013E":"l","\u0141":"L","\u0142":"l","\u0143":"N","\u0144":"n","\u0145":"N","\u0146":"n","\u0147":"N","\u0148":"n","\u014C":"O","\u014D":"o","\u0150":"O","\u0151":"o","\u0152":"OE","\u0153":"oe","\u0154":"R","\u0155":"r","\u0158":"R","\u0159":"r","\u015A":"S","\u015B":"s","\u015E":"S","\u015F":"s","\u0160":"S","\u0161":"s","\u0162":"T","\u0163":"t","\u0164":"T","\u0165":"t","\u0168":"U","\u0169":"u","\u016A":"u","\u016B":"u","\u016E":"U","\u016F":"u","\u0170":"U","\u0171":"u","\u0172":"U","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017A":"z","\u017B":"Z","\u017C":"z","\u017D":"Z","\u017E":"z","\u018F":"E","\u0192":"f","\u01A0":"O","\u01A1":"o","\u01AF":"U","\u01B0":"u","\u01C8":"LJ","\u01C9":"lj","\u01CB":"NJ","\u01CC":"nj","\u0218":"S","\u0219":"s","\u021A":"T","\u021B":"t","\u0259":"e","\u02DA":"o","\u0386":"A","\u0388":"E","\u0389":"H","\u038A":"I","\u038C":"O","\u038E":"Y","\u038F":"W","\u0390":"i","\u0391":"A","\u0392":"B","\u0393":"G","\u0394":"D","\u0395":"E","\u0396":"Z","\u0397":"H","\u0398":"8","\u0399":"I","\u039A":"K","\u039B":"L","\u039C":"M","\u039D":"N","\u039E":"3","\u039F":"O","\u03A0":"P","\u03A1":"R","\u03A3":"S","\u03A4":"T","\u03A5":"Y","\u03A6":"F","\u03A7":"X","\u03A8":"PS","\u03A9":"W","\u03AA":"I","\u03AB":"Y","\u03AC":"a","\u03AD":"e","\u03AE":"h","\u03AF":"i","\u03B0":"y","\u03B1":"a","\u03B2":"b","\u03B3":"g","\u03B4":"d","\u03B5":"e","\u03B6":"z","\u03B7":"h","\u03B8":"8","\u03B9":"i","\u03BA":"k","\u03BB":"l","\u03BC":"m","\u03BD":"n","\u03BE":"3","\u03BF":"o","\u03C0":"p","\u03C1":"r","\u03C2":"s","\u03C3":"s","\u03C4":"t","\u03C5":"y","\u03C6":"f","\u03C7":"x","\u03C8":"ps","\u03C9":"w","\u03CA":"i","\u03CB":"y","\u03CC":"o","\u03CD":"y","\u03CE":"w","\u0401":"Yo","\u0402":"DJ","\u0404":"Ye","\u0406":"I","\u0407":"Yi","\u0408":"J","\u0409":"LJ","\u040A":"NJ","\u040B":"C","\u040F":"DZ","\u0410":"A","\u0411":"B","\u0412":"V","\u0413":"G","\u0414":"D","\u0415":"E","\u0416":"Zh","\u0417":"Z","\u0418":"I","\u0419":"J","\u041A":"K","\u041B":"L","\u041C":"M","\u041D":"N","\u041E":"O","\u041F":"P","\u0420":"R","\u0421":"S","\u0422":"T","\u0423":"U","\u0424":"F","\u0425":"H","\u0426":"C","\u0427":"Ch","\u0428":"Sh","\u0429":"Sh","\u042A":"U","\u042B":"Y","\u042C":"","\u042D":"E","\u042E":"Yu","\u042F":"Ya","\u0430":"a","\u0431":"b","\u0432":"v","\u0433":"g","\u0434":"d","\u0435":"e","\u0436":"zh","\u0437":"z","\u0438":"i","\u0439":"j","\u043A":"k","\u043B":"l","\u043C":"m","\u043D":"n","\u043E":"o","\u043F":"p","\u0440":"r","\u0441":"s","\u0442":"t","\u0443":"u","\u0444":"f","\u0445":"h","\u0446":"c","\u0447":"ch","\u0448":"sh","\u0449":"sh","\u044A":"u","\u044B":"y","\u044C":"","\u044D":"e","\u044E":"yu","\u044F":"ya","\u0451":"yo","\u0452":"dj","\u0454":"ye","\u0456":"i","\u0457":"yi","\u0458":"j","\u0459":"lj","\u045A":"nj","\u045B":"c","\u045D":"u","\u045F":"dz","\u0490":"G","\u0491":"g","\u0492":"GH","\u0493":"gh","\u049A":"KH","\u049B":"kh","\u04A2":"NG","\u04A3":"ng","\u04AE":"UE","\u04AF":"ue","\u04B0":"U","\u04B1":"u","\u04BA":"H","\u04BB":"h","\u04D8":"AE","\u04D9":"ae","\u04E8":"OE","\u04E9":"oe","\u0E3F":"baht","\u10D0":"a","\u10D1":"b","\u10D2":"g","\u10D3":"d","\u10D4":"e","\u10D5":"v","\u10D6":"z","\u10D7":"t","\u10D8":"i","\u10D9":"k","\u10DA":"l","\u10DB":"m","\u10DC":"n","\u10DD":"o","\u10DE":"p","\u10DF":"zh","\u10E0":"r","\u10E1":"s","\u10E2":"t","\u10E3":"u","\u10E4":"f","\u10E5":"k","\u10E6":"gh","\u10E7":"q","\u10E8":"sh","\u10E9":"ch","\u10EA":"ts","\u10EB":"dz","\u10EC":"ts","\u10ED":"ch","\u10EE":"kh","\u10EF":"j","\u10F0":"h","\u1E80":"W","\u1E81":"w","\u1E82":"W","\u1E83":"w","\u1E84":"W","\u1E85":"w","\u1E9E":"SS","\u1EA0":"A","\u1EA1":"a","\u1EA2":"A","\u1EA3":"a","\u1EA4":"A","\u1EA5":"a","\u1EA6":"A","\u1EA7":"a","\u1EA8":"A","\u1EA9":"a","\u1EAA":"A","\u1EAB":"a","\u1EAC":"A","\u1EAD":"a","\u1EAE":"A","\u1EAF":"a","\u1EB0":"A","\u1EB1":"a","\u1EB2":"A","\u1EB3":"a","\u1EB4":"A","\u1EB5":"a","\u1EB6":"A","\u1EB7":"a","\u1EB8":"E","\u1EB9":"e","\u1EBA":"E","\u1EBB":"e","\u1EBC":"E","\u1EBD":"e","\u1EBE":"E","\u1EBF":"e","\u1EC0":"E","\u1EC1":"e","\u1EC2":"E","\u1EC3":"e","\u1EC4":"E","\u1EC5":"e","\u1EC6":"E","\u1EC7":"e","\u1EC8":"I","\u1EC9":"i","\u1ECA":"I","\u1ECB":"i","\u1ECC":"O","\u1ECD":"o","\u1ECE":"O","\u1ECF":"o","\u1ED0":"O","\u1ED1":"o","\u1ED2":"O","\u1ED3":"o","\u1ED4":"O","\u1ED5":"o","\u1ED6":"O","\u1ED7":"o","\u1ED8":"O","\u1ED9":"o","\u1EDA":"O","\u1EDB":"o","\u1EDC":"O","\u1EDD":"o","\u1EDE":"O","\u1EDF":"o","\u1EE0":"O","\u1EE1":"o","\u1EE2":"O","\u1EE3":"o","\u1EE4":"U","\u1EE5":"u","\u1EE6":"U","\u1EE7":"u","\u1EE8":"U","\u1EE9":"u","\u1EEA":"U","\u1EEB":"u","\u1EEC":"U","\u1EED":"u","\u1EEE":"U","\u1EEF":"u","\u1EF0":"U","\u1EF1":"u","\u1EF2":"Y","\u1EF3":"y","\u1EF4":"Y","\u1EF5":"y","\u1EF6":"Y","\u1EF7":"y","\u1EF8":"Y","\u1EF9":"y","\u2018":"\'","\u2019":"\'","\u201C":"\\"","\u201D":"\\"","\u2020":"+","\u2022":"*","\u2026":"...","\u20A0":"ecu","\u20A2":"cruzeiro","\u20A3":"french franc","\u20A4":"lira","\u20A5":"mill","\u20A6":"naira","\u20A7":"peseta","\u20A8":"rupee","\u20A9":"won","\u20AA":"new shequel","\u20AB":"dong","\u20AC":"euro","\u20AD":"kip","\u20AE":"tugrik","\u20AF":"drachma","\u20B0":"penny","\u20B1":"peso","\u20B2":"guarani","\u20B3":"austral","\u20B4":"hryvnia","\u20B5":"cedi","\u20B8":"kazakhstani tenge","\u20B9":"indian rupee","\u20BA":"turkish lira","\u20BD":"russian ruble","\u20BF":"bitcoin","\u2120":"sm","\u2122":"tm","\u2202":"d","\u2206":"delta","\u2211":"sum","\u221E":"infinity","\u2665":"love","\u5143":"yuan","\u5186":"yen","\uFDFC":"rial"}');
    var locales = JSON.parse('{"de":{"\xc4":"AE","\xe4":"ae","\xd6":"OE","\xf6":"oe","\xdc":"UE","\xfc":"ue","%":"prozent","&":"und","|":"oder","\u2211":"summe","\u221E":"unendlich","\u2665":"liebe"},"vi":{"\u0110":"D","\u0111":"d"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","\xa2":"centime","\xa3":"livre","\xa4":"devise","\u20A3":"franc","\u2211":"somme","\u221E":"infini","\u2665":"amour"}}');
    function replace(string, options) {
        if (typeof string !== 'string') throw new Error('slugify: string argument expected');
        options = typeof options === 'string' ? {
            replacement: options
        } : options || {};
        var locale = locales[options.locale] || {};
        var replacement = options.replacement === undefined ? '-' : options.replacement;
        var slug = string.split('')// replace characters based on charMap
        .reduce(function(result, ch) {
            return result + (locale[ch] || charMap[ch] || ch)// remove not allowed characters
            .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '');
        }, '')// trim leading/trailing spaces
        .trim()// convert spaces to replacement character
        // also remove duplicates of the replacement character
        .replace(new RegExp('[\\s' + replacement + ']+', 'g'), replacement);
        if (options.lower) slug = slug.toLowerCase();
        if (options.strict) // remove anything besides letters, numbers, and the replacement char
        slug = slug.replace(new RegExp('[^a-zA-Z0-9' + replacement + ']', 'g'), '')// remove duplicates of the replacement character
        .replace(new RegExp('[\\s' + replacement + ']+', 'g'), replacement);
        return slug;
    }
    replace.extend = function(customMap) {
        for(var key in customMap)charMap[key] = customMap[key];
    };
    return replace;
});

});

parcelRegister("lmFrL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "version", () => $f8dbcd8598db1f0b$export$83d89fbfd8236492);
$parcel$export(module.exports, "isStyledComponent", () => $f8dbcd8598db1f0b$export$7ba318d8d2f06c76);
$parcel$export(module.exports, "StyleSheetContext", () => $f8dbcd8598db1f0b$export$8c190ef828af4c86);
$parcel$export(module.exports, "StyleSheetConsumer", () => $f8dbcd8598db1f0b$export$91317688fc694efa);
$parcel$export(module.exports, "StyleSheetManager", () => $f8dbcd8598db1f0b$export$a473771da2f0ff7c);
$parcel$export(module.exports, "ThemeContext", () => $f8dbcd8598db1f0b$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeConsumer", () => $f8dbcd8598db1f0b$export$b631efc24e9d5e2f);
$parcel$export(module.exports, "useTheme", () => $f8dbcd8598db1f0b$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeProvider", () => $f8dbcd8598db1f0b$export$d8964aec282183a3);
$parcel$export(module.exports, "css", () => $f8dbcd8598db1f0b$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $f8dbcd8598db1f0b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "createGlobalStyle", () => $f8dbcd8598db1f0b$export$f0f03736edb61697);
$parcel$export(module.exports, "createTheme", () => $f8dbcd8598db1f0b$export$25d302a5b900a763);
$parcel$export(module.exports, "keyframes", () => $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "withTheme", () => $f8dbcd8598db1f0b$export$e8748c6a27b910dc);
$parcel$export(module.exports, "ServerStyleSheet", () => $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20);
$parcel$export(module.exports, "__PRIVATE__", () => $f8dbcd8598db1f0b$export$5c87cfe6c475f500);
$parcel$export(module.exports, "stylisPluginRSC", () => $f8dbcd8598db1f0b$export$337461d98bd2ad54);
$parcel$export(module.exports, "styled", () => $f8dbcd8598db1f0b$export$2e2bcd8739ae039);
parcelRequire("gd942");

var $acw62 = parcelRequire("acw62");

var $fm8kz = parcelRequire("fm8kz");
const $f8dbcd8598db1f0b$var$r = {};
function $f8dbcd8598db1f0b$var$i(e, ...t) {
    return new Error(`An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#${e} for more information.${t.length > 0 ? ` Args: ${t.join(", ")}` : ""}`);
}
var $f8dbcd8598db1f0b$var$a, $f8dbcd8598db1f0b$var$c;
const $f8dbcd8598db1f0b$var$l = "data-styled", $f8dbcd8598db1f0b$var$u = "active", $f8dbcd8598db1f0b$var$d = "data-styled-version", $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "6.6.0", $f8dbcd8598db1f0b$var$p = "/*!sc*/\n", $f8dbcd8598db1f0b$var$f = "undefined" != typeof window && "undefined" != typeof document;
if (!(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext) throw $f8dbcd8598db1f0b$var$i(19);
function $f8dbcd8598db1f0b$var$m(e) {}
const $f8dbcd8598db1f0b$var$y = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : null !== ($f8dbcd8598db1f0b$var$c = null !== ($f8dbcd8598db1f0b$var$a = $f8dbcd8598db1f0b$var$m("REACT_APP_SC_DISABLE_SPEEDY")) && void 0 !== $f8dbcd8598db1f0b$var$a ? $f8dbcd8598db1f0b$var$a : $f8dbcd8598db1f0b$var$m("SC_DISABLE_SPEEDY")) && void 0 !== $f8dbcd8598db1f0b$var$c ? $f8dbcd8598db1f0b$var$c : false), $f8dbcd8598db1f0b$var$g = "sc-keyframes-", $f8dbcd8598db1f0b$var$v = {}, $f8dbcd8598db1f0b$var$S = 1073741824;
let $f8dbcd8598db1f0b$var$b = new Map, $f8dbcd8598db1f0b$var$w = new Map, $f8dbcd8598db1f0b$var$N = 1;
const $f8dbcd8598db1f0b$var$C = (e)=>{
    if ($f8dbcd8598db1f0b$var$b.has(e)) return $f8dbcd8598db1f0b$var$b.get(e);
    for(; $f8dbcd8598db1f0b$var$w.has($f8dbcd8598db1f0b$var$N);)$f8dbcd8598db1f0b$var$N++;
    const t = $f8dbcd8598db1f0b$var$N++;
    return $f8dbcd8598db1f0b$var$b.set(e, t), $f8dbcd8598db1f0b$var$w.set(t, e), t;
}, $f8dbcd8598db1f0b$var$O = (e)=>$f8dbcd8598db1f0b$var$w.get(e), $f8dbcd8598db1f0b$var$E = (e, t)=>{
    $f8dbcd8598db1f0b$var$N = t + 1, $f8dbcd8598db1f0b$var$b.set(e, t), $f8dbcd8598db1f0b$var$w.set(t, e);
}, $f8dbcd8598db1f0b$var$A = /invalid hook call/i, $f8dbcd8598db1f0b$var$P = new Set, $f8dbcd8598db1f0b$var$_ = (e, n)=>{
    var t, n1, e1;
}, $f8dbcd8598db1f0b$var$$ = Object.freeze([]), $f8dbcd8598db1f0b$var$I = Object.freeze({});
function $f8dbcd8598db1f0b$var$x(e, t, n = $f8dbcd8598db1f0b$var$I) {
    return e.theme !== n.theme && e.theme || t || n.theme;
}
const $f8dbcd8598db1f0b$var$R = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$j = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$k(e) {
    return e.replace($f8dbcd8598db1f0b$var$R, "-").replace($f8dbcd8598db1f0b$var$j, "");
}
const $f8dbcd8598db1f0b$var$T = /(a)(d)/gi, $f8dbcd8598db1f0b$var$D = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97));
function $f8dbcd8598db1f0b$var$V(e) {
    let t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$D(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$D(t % 52) + n).replace($f8dbcd8598db1f0b$var$T, "$1-$2");
}
const $f8dbcd8598db1f0b$var$M = 5381, $f8dbcd8598db1f0b$var$G = (e, t)=>{
    let n = t.length;
    for(; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$F = (e)=>$f8dbcd8598db1f0b$var$G($f8dbcd8598db1f0b$var$M, e);
function $f8dbcd8598db1f0b$var$z(e) {
    return $f8dbcd8598db1f0b$var$V($f8dbcd8598db1f0b$var$F(e) >>> 0);
}
function $f8dbcd8598db1f0b$var$W(e) {
    return e.displayName || e.name || "Component";
}
function $f8dbcd8598db1f0b$var$L(e) {
    return "string" == typeof e && true;
}
function $f8dbcd8598db1f0b$var$B(e) {
    return $f8dbcd8598db1f0b$var$L(e) ? `styled.${e}` : `Styled(${$f8dbcd8598db1f0b$var$W(e)})`;
}
const $f8dbcd8598db1f0b$var$q = Symbol.for("react.memo"), $f8dbcd8598db1f0b$var$H = Symbol.for("react.forward_ref"), $f8dbcd8598db1f0b$var$Y = {
    contextType: !0,
    defaultProps: !0,
    displayName: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f8dbcd8598db1f0b$var$J = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$X = {
    [$f8dbcd8598db1f0b$var$H]: {
        $$typeof: !0,
        render: !0,
        defaultProps: !0,
        displayName: !0,
        propTypes: !0
    },
    [$f8dbcd8598db1f0b$var$q]: $f8dbcd8598db1f0b$var$J
};
function $f8dbcd8598db1f0b$var$K(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f8dbcd8598db1f0b$var$q ? $f8dbcd8598db1f0b$var$J : "$$typeof" in e ? $f8dbcd8598db1f0b$var$X[e.$$typeof] : $f8dbcd8598db1f0b$var$Y;
}
const $f8dbcd8598db1f0b$var$Q = Object.defineProperty, $f8dbcd8598db1f0b$var$Z = Object.getOwnPropertyNames, $f8dbcd8598db1f0b$var$ee = Object.getOwnPropertySymbols, $f8dbcd8598db1f0b$var$te = Object.getOwnPropertyDescriptor, $f8dbcd8598db1f0b$var$ne = Object.getPrototypeOf, $f8dbcd8598db1f0b$var$oe = Object.prototype;
function $f8dbcd8598db1f0b$var$se(e, t, n) {
    if ("string" != typeof t) {
        const o = $f8dbcd8598db1f0b$var$ne(t);
        o && o !== $f8dbcd8598db1f0b$var$oe && $f8dbcd8598db1f0b$var$se(e, o, n);
        const s = $f8dbcd8598db1f0b$var$Z(t).concat($f8dbcd8598db1f0b$var$ee(t)), r = $f8dbcd8598db1f0b$var$K(e), i = $f8dbcd8598db1f0b$var$K(t);
        for(let o = 0; o < s.length; ++o){
            const a = s[o];
            if (!(a in $f8dbcd8598db1f0b$var$U || n && n[a] || i && a in i || r && a in r)) {
                const n = $f8dbcd8598db1f0b$var$te(t, a);
                try {
                    $f8dbcd8598db1f0b$var$Q(e, a, n);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f8dbcd8598db1f0b$var$re(e) {
    return "function" == typeof e;
}
const $f8dbcd8598db1f0b$var$ie = Symbol.for("react.forward_ref");
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return null != e && ("object" == typeof e || "function" == typeof e) && e.$$typeof === $f8dbcd8598db1f0b$var$ie && "styledComponentId" in e;
}
function $f8dbcd8598db1f0b$var$ce(e, t) {
    return e && t ? e + " " + t : e || t || "";
}
function $f8dbcd8598db1f0b$var$le(e, t) {
    return e.join(t || "");
}
function $f8dbcd8598db1f0b$var$ue(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f8dbcd8598db1f0b$var$de(e, t, n = !1) {
    if (!n && !$f8dbcd8598db1f0b$var$ue(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(let n = 0; n < t.length; n++)e[n] = $f8dbcd8598db1f0b$var$de(e[n], t[n]);
    else if ($f8dbcd8598db1f0b$var$ue(t)) for(const n in t)e[n] = $f8dbcd8598db1f0b$var$de(e[n], t[n]);
    return e;
}
function $f8dbcd8598db1f0b$var$he(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
const $f8dbcd8598db1f0b$var$pe = class {
    constructor(e){
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e, this._cGroup = 0, this._cIndex = 0;
    }
    indexOfGroup(e) {
        if (e === this._cGroup) return this._cIndex;
        let t = this._cIndex;
        if (e > this._cGroup) for(let n = this._cGroup; n < e; n++)t += this.groupSizes[n];
        else for(let n = this._cGroup - 1; n >= e; n--)t -= this.groupSizes[n];
        return this._cGroup = e, this._cIndex = t, t;
    }
    insertRules(e, t) {
        if (e >= this.groupSizes.length) {
            const t = this.groupSizes, n = t.length;
            let o = n;
            for(; e >= o;)if (o <<= 1, o < 0) throw $f8dbcd8598db1f0b$var$i(16, `${e}`);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(t), this.length = o;
            for(let e = n; e < o; e++)this.groupSizes[e] = 0;
        }
        let n = this.indexOfGroup(e + 1), o = 0;
        for(let s = 0, r = t.length; s < r; s++)this.tag.insertRule(n, t[s]) && (this.groupSizes[e]++, n++, o++);
        o > 0 && this._cGroup > e && (this._cIndex += o);
    }
    clearGroup(e) {
        if (e < this.length) {
            const t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(let e = n; e < o; e++)this.tag.deleteRule(n);
            t > 0 && this._cGroup > e && (this._cIndex -= t);
        }
    }
    getGroup(e) {
        let t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        const n = this.groupSizes[e], o = this.indexOfGroup(e), s = o + n;
        for(let e = o; e < s; e++)t += this.tag.getRule(e) + $f8dbcd8598db1f0b$var$p;
        return t;
    }
}, $f8dbcd8598db1f0b$var$fe = `style[${$f8dbcd8598db1f0b$var$l}][${$f8dbcd8598db1f0b$var$d}="${$f8dbcd8598db1f0b$export$83d89fbfd8236492}"]`, $f8dbcd8598db1f0b$var$me = new RegExp(`^${$f8dbcd8598db1f0b$var$l}\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)`);
let $f8dbcd8598db1f0b$var$ye = !1;
const $f8dbcd8598db1f0b$var$ge = (e)=>"undefined" != typeof ShadowRoot && e instanceof ShadowRoot || "host" in e && 11 === e.nodeType, $f8dbcd8598db1f0b$var$ve = (e)=>{
    if (!e) return document;
    if ($f8dbcd8598db1f0b$var$ge(e)) return e;
    if ("getRootNode" in e) {
        const t = e.getRootNode();
        if ($f8dbcd8598db1f0b$var$ge(t)) return t;
    }
    return document;
}, $f8dbcd8598db1f0b$var$Se = (e, t, n)=>{
    const o = n.split(",");
    let s;
    for(let n = 0, r = o.length; n < r; n++)(s = o[n]) && e.registerName(t, s);
}, $f8dbcd8598db1f0b$var$be = (e, t)=>{
    var n;
    const o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($f8dbcd8598db1f0b$var$p), s = [];
    for(let t = 0, n = o.length; t < n; t++){
        const n = o[t].trim();
        if (!n) continue;
        const r = n.match($f8dbcd8598db1f0b$var$me);
        if (r) {
            const t = 0 | parseInt(r[1], 10), n = r[2];
            0 !== t && ($f8dbcd8598db1f0b$var$E(n, t), $f8dbcd8598db1f0b$var$Se(e, n, r[3]), e.getTag().insertRules(t, s)), s.length = 0;
        } else s.push(n);
    }
}, $f8dbcd8598db1f0b$var$we = (e)=>{
    const t = $f8dbcd8598db1f0b$var$ve(e.options.target);
    ((e)=>{})(t);
    const n = t.querySelectorAll($f8dbcd8598db1f0b$var$fe);
    for(let t = 0, o = n.length; t < o; t++){
        const o = n[t];
        o && o.getAttribute($f8dbcd8598db1f0b$var$l) !== $f8dbcd8598db1f0b$var$u && ($f8dbcd8598db1f0b$var$be(e, o), o.parentNode && o.parentNode.removeChild(o));
    }
};
let $f8dbcd8598db1f0b$var$Ne = !1;
function $f8dbcd8598db1f0b$var$Ce() {
    if (!1 !== $f8dbcd8598db1f0b$var$Ne) return $f8dbcd8598db1f0b$var$Ne;
    if ("undefined" != typeof document) {
        const e = document.head.querySelector('meta[property="csp-nonce"]');
        if (e) return $f8dbcd8598db1f0b$var$Ne = e.nonce || e.getAttribute("content") || void 0;
        const t = document.head.querySelector('meta[name="sc-nonce"]');
        if (t) return $f8dbcd8598db1f0b$var$Ne = t.getAttribute("content") || void 0;
    }
    return $f8dbcd8598db1f0b$var$Ne = "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0;
}
const $f8dbcd8598db1f0b$var$Oe = (e, t)=>{
    if ("undefined" == typeof document) throw $f8dbcd8598db1f0b$var$i(20);
    const n = document.head, o = e || n, s = document.createElement("style"), r = ((e)=>{
        const t = Array.from(e.querySelectorAll(`style[${$f8dbcd8598db1f0b$var$l}]`));
        return t[t.length - 1];
    })(o), a = void 0 !== r ? r.nextSibling : null;
    s.setAttribute($f8dbcd8598db1f0b$var$l, $f8dbcd8598db1f0b$var$u), s.setAttribute($f8dbcd8598db1f0b$var$d, $f8dbcd8598db1f0b$export$83d89fbfd8236492);
    const c = t || $f8dbcd8598db1f0b$var$Ce();
    return c && s.setAttribute("nonce", c), o.insertBefore(s, a), s;
}, $f8dbcd8598db1f0b$var$Ee = class {
    constructor(e, t){
        this.element = $f8dbcd8598db1f0b$var$Oe(e, t), this.element.appendChild(document.createTextNode("")), this.sheet = ((e)=>{
            var t;
            if (e.sheet) return e.sheet;
            const n = null !== (t = e.getRootNode().styleSheets) && void 0 !== t ? t : document.styleSheets;
            for(let t = 0, o = n.length; t < o; t++){
                const o = n[t];
                if (o.ownerNode === e) return o;
            }
            throw $f8dbcd8598db1f0b$var$i(17);
        })(this.element), this.length = 0;
    }
    insertRule(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }
    deleteRule(e) {
        this.sheet.deleteRule(e), this.length--;
    }
    getRule(e) {
        const t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }
}, $f8dbcd8598db1f0b$var$Ae = class {
    constructor(e, t){
        this.element = $f8dbcd8598db1f0b$var$Oe(e, t), this.nodes = this.element.childNodes, this.length = 0;
    }
    insertRule(e, t) {
        if (e <= this.length && e >= 0) {
            const n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }
    deleteRule(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }
    getRule(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }
};
let $f8dbcd8598db1f0b$var$Pe = $f8dbcd8598db1f0b$var$f;
const $f8dbcd8598db1f0b$var$_e = {
    isServer: !$f8dbcd8598db1f0b$var$f,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$y
};
class $f8dbcd8598db1f0b$var$$e {
    static registerId(e) {
        return $f8dbcd8598db1f0b$var$C(e);
    }
    constructor(e = $f8dbcd8598db1f0b$var$I, t = {}, n){
        this.options = Object.assign(Object.assign({}, $f8dbcd8598db1f0b$var$_e), e), this.gs = t, this.keyframeIds = new Set, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$f && $f8dbcd8598db1f0b$var$Pe && ($f8dbcd8598db1f0b$var$Pe = !1, $f8dbcd8598db1f0b$var$we(this)), $f8dbcd8598db1f0b$var$he(this, ()=>((e)=>{
                const t = e.getTag(), { length: n } = t;
                let o = "";
                for(let s = 0; s < n; s++){
                    const n = $f8dbcd8598db1f0b$var$O(s);
                    if (void 0 === n) continue;
                    const r = e.names.get(n);
                    if (void 0 === r || !r.size) continue;
                    const i = t.getGroup(s);
                    if (0 === i.length) continue;
                    const a = $f8dbcd8598db1f0b$var$l + ".g" + s + '[id="' + n + '"]';
                    let c = "";
                    for (const e of r)e.length > 0 && (c += e + ",");
                    o += i + a + '{content:"' + c + '"}' + $f8dbcd8598db1f0b$var$p;
                }
                return o;
            })(this));
    }
    rehydrate() {
        !this.server && $f8dbcd8598db1f0b$var$f && $f8dbcd8598db1f0b$var$we(this);
    }
    reconstructWithOptions(e, t = !0) {
        const n = new $f8dbcd8598db1f0b$var$$e(Object.assign(Object.assign({}, this.options), e), this.gs, t && this.names || void 0);
        return n.keyframeIds = new Set(this.keyframeIds), !this.server && $f8dbcd8598db1f0b$var$f && e.target !== this.options.target && $f8dbcd8598db1f0b$var$ve(this.options.target) !== $f8dbcd8598db1f0b$var$ve(e.target) && $f8dbcd8598db1f0b$var$we(n), n;
    }
    allocateGSInstance(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }
    getTag() {
        var e;
        return this.tag || (this.tag = (e = (({ useCSSOMInjection: e, target: t, nonce: n })=>e ? new $f8dbcd8598db1f0b$var$Ee(t, n) : new $f8dbcd8598db1f0b$var$Ae(t, n))(this.options), new $f8dbcd8598db1f0b$var$pe(e)));
    }
    hasNameForId(e, t) {
        var n, o;
        return null !== (o = null === (n = this.names.get(e)) || void 0 === n ? void 0 : n.has(t)) && void 0 !== o && o;
    }
    registerName(e, t) {
        $f8dbcd8598db1f0b$var$C(e), e.startsWith($f8dbcd8598db1f0b$var$g) && this.keyframeIds.add(e);
        const n = this.names.get(e);
        n ? n.add(t) : this.names.set(e, new Set([
            t
        ]));
    }
    insertRules(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$C(e), n);
    }
    clearNames(e) {
        this.names.has(e) && this.names.get(e).clear();
    }
    clearRules(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$C(e)), this.clearNames(e);
    }
    clearTag() {
        this.tag = void 0;
    }
}
const $f8dbcd8598db1f0b$var$Ie = new WeakSet, $f8dbcd8598db1f0b$var$xe = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexShrink: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
function $f8dbcd8598db1f0b$var$Re(e, t) {
    return null == t || "boolean" == typeof t || "" === t ? "" : "number" != typeof t || 0 === t || e in $f8dbcd8598db1f0b$var$xe || e.startsWith("--") ? String(t).trim() : t + "px";
}
const $f8dbcd8598db1f0b$var$je = 47;
function $f8dbcd8598db1f0b$var$ke(e) {
    if (45 === e.charCodeAt(0) && 45 === e.charCodeAt(1)) return e;
    let t = "";
    for(let n = 0; n < e.length; n++){
        const o = e.charCodeAt(n);
        t += o >= 65 && o <= 90 ? "-" + String.fromCharCode(o + 32) : e[n];
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
const $f8dbcd8598db1f0b$var$Te = Symbol.for("sc-keyframes");
function $f8dbcd8598db1f0b$var$De(e) {
    return "object" == typeof e && null !== e && $f8dbcd8598db1f0b$var$Te in e;
}
function $f8dbcd8598db1f0b$var$Ve(e) {
    return $f8dbcd8598db1f0b$var$re(e) && !(e.prototype && e.prototype.isReactComponent);
}
const $f8dbcd8598db1f0b$var$Me = (e)=>null == e || !1 === e || "" === e, $f8dbcd8598db1f0b$var$Ge = Symbol.for("react.client.reference");
function $f8dbcd8598db1f0b$var$Fe(e) {
    return e.$$typeof === $f8dbcd8598db1f0b$var$Ge;
}
function $f8dbcd8598db1f0b$var$ze(e) {
    const t = e.$$id, n = (t && t.includes("#") ? t.split("#").pop() : t) || e.name || "unknown";
    console.warn(`Interpolating a client component (${n}) as a selector is not supported in server components. The component selector pattern requires access to the component's internal class name, which is not available across the server/client boundary. Use a plain CSS class selector instead.`);
}
function $f8dbcd8598db1f0b$var$We(e, t) {
    for(const n in e){
        const o = e[n];
        e.hasOwnProperty(n) && !$f8dbcd8598db1f0b$var$Me(o) && (Array.isArray(o) && $f8dbcd8598db1f0b$var$Ie.has(o) || $f8dbcd8598db1f0b$var$re(o) ? t.push($f8dbcd8598db1f0b$var$ke(n) + ":", o, ";") : $f8dbcd8598db1f0b$var$ue(o) ? (t.push(n + " {"), $f8dbcd8598db1f0b$var$We(o, t), t.push("}")) : t.push($f8dbcd8598db1f0b$var$ke(n) + ": " + $f8dbcd8598db1f0b$var$Re(n, o) + ";"));
    }
}
function $f8dbcd8598db1f0b$var$Le(e, t, n, o, s = []) {
    if ($f8dbcd8598db1f0b$var$Me(e)) return s;
    const r = typeof e;
    if ("string" === r) return s.push(e), s;
    if ("function" === r) {
        if ($f8dbcd8598db1f0b$var$Fe(e)) return s;
        if ($f8dbcd8598db1f0b$var$Ve(e) && t) {
            const r = e(t);
            return $f8dbcd8598db1f0b$var$Le(r, t, n, o, s);
        }
        return s.push(e), s;
    }
    if (Array.isArray(e)) {
        for(let r = 0; r < e.length; r++)$f8dbcd8598db1f0b$var$Le(e[r], t, n, o, s);
        return s;
    }
    return $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) ? (s.push(`.${e.styledComponentId}`), s) : $f8dbcd8598db1f0b$var$De(e) ? (n ? (e.inject(n, o), s.push(e.getName(o))) : s.push(e), s) : $f8dbcd8598db1f0b$var$Fe(e) ? s : $f8dbcd8598db1f0b$var$ue(e) ? e.toString !== Object.prototype.toString ? (s.push(e.toString()), s) : ($f8dbcd8598db1f0b$var$We(e, s), s) : (s.push(e.toString()), s);
}
const $f8dbcd8598db1f0b$var$Be = $f8dbcd8598db1f0b$var$F($f8dbcd8598db1f0b$export$83d89fbfd8236492);
class $f8dbcd8598db1f0b$var$qe {
    constructor(e, t, n){
        this.rules = e, this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$G($f8dbcd8598db1f0b$var$Be, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$$e.registerId(t);
    }
    generateAndInjectStyles(e, t, n) {
        let o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        {
            let s = "";
            for(let o = 0; o < this.rules.length; o++){
                const r = this.rules[o];
                if ("string" == typeof r) s += r;
                else if (r) {
                    if ($f8dbcd8598db1f0b$var$Ve(r)) {
                        const o = r(e);
                        "string" == typeof o ? s += o : null != o && !1 !== o && (s += $f8dbcd8598db1f0b$var$le($f8dbcd8598db1f0b$var$Le(o, e, t, n)));
                    } else s += $f8dbcd8598db1f0b$var$le($f8dbcd8598db1f0b$var$Le(r, e, t, n));
                }
            }
            if (s) {
                this.dynamicNameCache || (this.dynamicNameCache = new Map);
                const e = n.hash ? n.hash + s : s;
                let r = this.dynamicNameCache.get(e);
                if (!r) {
                    if (r = $f8dbcd8598db1f0b$var$V($f8dbcd8598db1f0b$var$G($f8dbcd8598db1f0b$var$G(this.baseHash, n.hash), s) >>> 0), this.dynamicNameCache.size >= 200) {
                        const e = this.dynamicNameCache.keys().next().value;
                        void 0 !== e && this.dynamicNameCache.delete(e);
                    }
                    this.dynamicNameCache.set(e, r);
                }
                if (!t.hasNameForId(this.componentId, r)) {
                    const e = n(s, "." + r, void 0, this.componentId);
                    t.insertRules(this.componentId, r, e);
                }
                o = $f8dbcd8598db1f0b$var$ce(o, r);
            }
        }
        return o;
    }
}
const $f8dbcd8598db1f0b$var$He = /&/g;
function $f8dbcd8598db1f0b$var$Ye(e, t) {
    let n = 0;
    for(; --t >= 0 && 92 === e.charCodeAt(t);)n++;
    return !(1 & ~n);
}
function $f8dbcd8598db1f0b$var$Ue(e) {
    const t = e.length;
    let n = "", o = 0, s = 0, r = 0, i = !1, a = !1;
    for(let c = 0; c < t; c++){
        const l = e.charCodeAt(c);
        if (0 !== r || i || l !== $f8dbcd8598db1f0b$var$je || 42 !== e.charCodeAt(c + 1)) {
            if (i) 42 === l && e.charCodeAt(c + 1) === $f8dbcd8598db1f0b$var$je && (i = !1, c++);
            else if (34 !== l && 39 !== l || $f8dbcd8598db1f0b$var$Ye(e, c)) {
                if (0 === r) {
                    if (123 === l) s++;
                    else if (125 === l) {
                        if (s--, s < 0) {
                            a = !0;
                            let n = c + 1;
                            for(; n < t;){
                                const t = e.charCodeAt(n);
                                if (59 === t || 10 === t) break;
                                n++;
                            }
                            n < t && 59 === e.charCodeAt(n) && n++, s = 0, c = n - 1, o = n;
                            continue;
                        }
                        0 === s && (n += e.substring(o, c + 1), o = c + 1);
                    } else 59 === l && 0 === s && (n += e.substring(o, c + 1), o = c + 1);
                }
            } else 0 === r ? r = l : r === l && (r = 0);
        } else i = !0, c++;
    }
    return a || 0 !== s || 0 !== r ? (o < t && 0 === s && 0 === r && (n += e.substring(o)), n) : e;
}
function $f8dbcd8598db1f0b$var$Je(e, t) {
    const n = t + " ", o = "," + n;
    for(let s = 0; s < e.length; s++){
        const r = e[s];
        if ("rule" === r.type) {
            r.value = (n + r.value).replaceAll(",", o);
            const e = r.props, t = [];
            for(let o = 0; o < e.length; o++)t[o] = n + e[o];
            r.props = t;
        }
        Array.isArray(r.children) && "@keyframes" !== r.type && $f8dbcd8598db1f0b$var$Je(r.children, t);
    }
    return e;
}
function $f8dbcd8598db1f0b$var$Xe({ options: e = $f8dbcd8598db1f0b$var$I, plugins: t = $f8dbcd8598db1f0b$var$$ } = $f8dbcd8598db1f0b$var$I) {
    let n, s, r;
    const a = (e, t, o)=>o.startsWith(s) && o.endsWith(s) && o.replaceAll(s, "").length > 0 ? `.${n}` : e, c = t.slice();
    c.push((e)=>{
        e.type === $fm8kz.RULESET && e.value.includes("&") && (r || (r = new RegExp(`\\${s}\\b`, "g")), e.props[0] = e.props[0].replace($f8dbcd8598db1f0b$var$He, s).replace(r, a));
    }), e.prefix && c.push($fm8kz.prefixer), c.push($fm8kz.stringify);
    let l = [];
    const u = $fm8kz.middleware(c.concat($fm8kz.rulesheet((e)=>l.push(e)))), d = (t, i = "", a = "", c = "&")=>{
        n = c, s = i, r = void 0;
        const d = function(e) {
            const t = -1 !== e.indexOf("//"), n = -1 !== e.indexOf("}");
            if (!t && !n) return e;
            if (!t) return $f8dbcd8598db1f0b$var$Ue(e);
            const o = e.length;
            let s = "", r = 0, i = 0, a = 0, c = 0, l = 0, u = !1;
            for(; i < o;){
                const t = e.charCodeAt(i);
                if (34 !== t && 39 !== t || $f8dbcd8598db1f0b$var$Ye(e, i)) {
                    if (0 === a) {
                        if (t === $f8dbcd8598db1f0b$var$je && i + 1 < o && 42 === e.charCodeAt(i + 1)) {
                            for(i += 2; i + 1 < o && (42 !== e.charCodeAt(i) || e.charCodeAt(i + 1) !== $f8dbcd8598db1f0b$var$je);)i++;
                            i += 2;
                        } else if (40 !== t) {
                            if (41 !== t) {
                                if (c > 0) i++;
                                else if (42 === t && i + 1 < o && e.charCodeAt(i + 1) === $f8dbcd8598db1f0b$var$je) s += e.substring(r, i), i += 2, r = i, u = !0;
                                else if (t === $f8dbcd8598db1f0b$var$je && i + 1 < o && e.charCodeAt(i + 1) === $f8dbcd8598db1f0b$var$je) {
                                    for(s += e.substring(r, i); i < o && 10 !== e.charCodeAt(i);)i++;
                                    r = i, u = !0;
                                } else 123 === t ? l++ : 125 === t && l--, i++;
                            } else c > 0 && c--, i++;
                        } else c++, i++;
                    } else i++;
                } else 0 === a ? a = t : a === t && (a = 0), i++;
            }
            return u ? (r < o && (s += e.substring(r)), 0 === l ? s : $f8dbcd8598db1f0b$var$Ue(s)) : 0 === l ? e : $f8dbcd8598db1f0b$var$Ue(e);
        }(t);
        let h = $fm8kz.compile(a || i ? a + " " + i + " { " + d + " }" : d);
        return e.namespace && (h = $f8dbcd8598db1f0b$var$Je(h, e.namespace)), l = [], $fm8kz.serialize(h, u), l;
    }, h = e;
    let p = $f8dbcd8598db1f0b$var$M;
    for(let e = 0; e < t.length; e++)t[e].name || $f8dbcd8598db1f0b$var$i(15), p = $f8dbcd8598db1f0b$var$G(p, t[e].name);
    return (null == h ? void 0 : h.namespace) && (p = $f8dbcd8598db1f0b$var$G(p, h.namespace)), (null == h ? void 0 : h.prefix) && (p = $f8dbcd8598db1f0b$var$G(p, "p")), d.hash = p !== $f8dbcd8598db1f0b$var$M ? p.toString() : "", d;
}
const $f8dbcd8598db1f0b$var$Ke = new $f8dbcd8598db1f0b$var$$e, $f8dbcd8598db1f0b$var$Qe = $f8dbcd8598db1f0b$var$Xe(), $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f8dbcd8598db1f0b$var$Ke,
    stylis: $f8dbcd8598db1f0b$var$Qe,
    stylisPlugins: void 0
}), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer;
function $f8dbcd8598db1f0b$var$tt() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$8c190ef828af4c86);
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var n;
    const o = $f8dbcd8598db1f0b$var$tt(), { styleSheet: s } = o, r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        let t = s;
        return e.sheet ? t = e.sheet : e.target ? t = t.reconstructWithOptions(void 0 !== e.nonce ? {
            target: e.target,
            nonce: e.nonce
        } : {
            target: e.target
        }, !1) : void 0 !== e.nonce && (t = t.reconstructWithOptions({
            nonce: e.nonce
        })), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.nonce,
        e.sheet,
        e.target,
        s
    ]), i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        var t;
        return void 0 === e.stylisPlugins && void 0 === e.namespace && void 0 === e.enableVendorPrefixes ? o.stylis : $f8dbcd8598db1f0b$var$Xe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: null !== (t = e.stylisPlugins) && void 0 !== t ? t : o.stylisPlugins
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        e.stylisPlugins,
        o.stylis,
        o.stylisPlugins
    ]), a = "shouldForwardProp" in e ? e.shouldForwardProp : o.shouldForwardProp, c = null !== (n = e.stylisPlugins) && void 0 !== n ? n : o.stylisPlugins, l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            shouldForwardProp: a,
            styleSheet: r,
            stylis: i,
            stylisPlugins: c
        }), [
        a,
        r,
        i,
        c
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: l
    }, e.children);
}
const $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$93d4e7f90805808f() {
    const e = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6);
    if (!e) throw $f8dbcd8598db1f0b$var$i(18);
    return e;
}
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), o = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>(function(e, t) {
            if (!e) throw $f8dbcd8598db1f0b$var$i(14);
            if ($f8dbcd8598db1f0b$var$re(e)) {
                const n = e(t);
                return n;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f8dbcd8598db1f0b$var$i(8);
            return t ? Object.assign(Object.assign({}, t), e) : e;
        })(e.theme, n), [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: o
    }, e.children) : null;
}
const $f8dbcd8598db1f0b$var$at = {};
function $f8dbcd8598db1f0b$var$ct(e, t) {
    const n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$k(e);
    $f8dbcd8598db1f0b$var$at[n] = ($f8dbcd8598db1f0b$var$at[n] || 0) + 1;
    const o = n + "-" + $f8dbcd8598db1f0b$var$z($f8dbcd8598db1f0b$export$83d89fbfd8236492 + n + $f8dbcd8598db1f0b$var$at[n]);
    return t ? t + "-" + o : o;
}
let $f8dbcd8598db1f0b$var$lt;
function $f8dbcd8598db1f0b$var$ut(o, s, r) {
    const i = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(o), a = o, c = !$f8dbcd8598db1f0b$var$L(o), { attrs: l = $f8dbcd8598db1f0b$var$$, componentId: u = $f8dbcd8598db1f0b$var$ct(s.displayName, s.parentComponentId), displayName: d = $f8dbcd8598db1f0b$var$B(o) } = s, h = s.displayName && s.componentId ? $f8dbcd8598db1f0b$var$k(s.displayName) + "-" + s.componentId : s.componentId || u, p = i && a.attrs ? a.attrs.concat(l).filter(Boolean) : l;
    let { shouldForwardProp: f } = s;
    if (i && a.shouldForwardProp) {
        const e = a.shouldForwardProp;
        if (s.shouldForwardProp) {
            const t = s.shouldForwardProp;
            f = (n, o)=>e(n, o) && t(n, o);
        } else f = e;
    }
    const m = new $f8dbcd8598db1f0b$var$qe(r, h, i ? a.componentStyle : void 0);
    function y(o, s) {
        return function(o, s, r) {
            const { attrs: i, componentStyle: a, defaultProps: c, foldedComponentIds: l, styledComponentId: u, target: d } = o, h = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), p = $f8dbcd8598db1f0b$var$tt(), f = o.shouldForwardProp || p.shouldForwardProp;
            const m = $f8dbcd8598db1f0b$var$x(s, h, c) || $f8dbcd8598db1f0b$var$I, [y, g] = function(e, t, n) {
                const o = Object.assign(Object.assign({}, t), {
                    className: void 0,
                    theme: n
                });
                let s = null;
                const r = e.length > 1;
                for(let t = 0; t < e.length; t++){
                    const n = e[t], i = $f8dbcd8598db1f0b$var$re(n) ? n(r ? Object.assign({}, o) : o) : n;
                    for(const e in i)"className" === e ? o.className = $f8dbcd8598db1f0b$var$ce(o.className, i[e]) : "style" === e ? o.style = Object.assign(Object.assign({}, o.style), i[e]) : void 0 === i[e] ? e in o && (void 0 !== o[e] && (s || (s = [])).push(e), o[e] = void 0) : o[e] = i[e];
                }
                return "className" in t && "string" == typeof t.className && (o.className = $f8dbcd8598db1f0b$var$ce(o.className, t.className)), [
                    o,
                    s
                ];
            }(i, s, m), v = a.generateAndInjectStyles(y, p.styleSheet, p.stylis);
            const S = y.as || d, b = $f8dbcd8598db1f0b$var$L(S), w = function(t, n, o, s, r, i) {
                const a = {};
                for(const c in t)"$" === c[0] || "as" === c || "theme" === c && t.theme === o || ("forwardedAs" === c ? void 0 !== t.forwardedAs && (a.as = t.forwardedAs) : void 0 === t[c] ? "className" === c || r || null !== i && -1 !== i.indexOf(c) || s && !s(c, n) || (a[c] = void 0) : s && !s(c, n) || (a[c] = t[c], s));
                return a;
            }(y, S, m, f, b, g);
            let N = $f8dbcd8598db1f0b$var$ce(l, u);
            return v && (N += " " + v), y.className && (N += " " + y.className), w[b && S.includes("-") ? "class" : "className"] = N, r && (w.ref = r), (0, $acw62.createElement)(S, w);
        }(g, o, s);
    }
    y.displayName = d;
    let g = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(y);
    return g.attrs = p, g.componentStyle = m, g.displayName = d, g.shouldForwardProp = f, g.foldedComponentIds = i ? $f8dbcd8598db1f0b$var$ce(a.foldedComponentIds, a.styledComponentId) : "", g.styledComponentId = h, g.target = i ? a.target : o, Object.defineProperty(g, "defaultProps", {
        get () {
            return this._foldedDefaultProps;
        },
        set (e) {
            this._foldedDefaultProps = i ? function(e, ...t) {
                for (const n of t)$f8dbcd8598db1f0b$var$de(e, n, !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $f8dbcd8598db1f0b$var$he(g, ()=>`.${g.styledComponentId}`), c && $f8dbcd8598db1f0b$var$se(g, o, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), g;
}
var $f8dbcd8598db1f0b$var$dt = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "button",
    "br",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "menu",
    "meter",
    "nav",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "search",
    "section",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tspan",
    "use"
]);
function $f8dbcd8598db1f0b$var$ht(e, t) {
    const n = [
        e[0]
    ];
    for(let o = 0, s = t.length; o < s; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
const $f8dbcd8598db1f0b$var$pt = (e)=>($f8dbcd8598db1f0b$var$Ie.add(e), e);
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(e, ...t) {
    if ($f8dbcd8598db1f0b$var$re(e) || $f8dbcd8598db1f0b$var$ue(e)) return $f8dbcd8598db1f0b$var$pt($f8dbcd8598db1f0b$var$Le($f8dbcd8598db1f0b$var$ht($f8dbcd8598db1f0b$var$$, [
        e,
        ...t
    ])));
    const n = e;
    return 0 === t.length && 1 === n.length && "string" == typeof n[0] ? $f8dbcd8598db1f0b$var$Le(n) : $f8dbcd8598db1f0b$var$pt($f8dbcd8598db1f0b$var$Le($f8dbcd8598db1f0b$var$ht(n, t)));
}
function $f8dbcd8598db1f0b$var$mt(e, t, n = $f8dbcd8598db1f0b$var$I) {
    if (!t) throw $f8dbcd8598db1f0b$var$i(1, t);
    const o = (o, ...s)=>e(t, n, $f8dbcd8598db1f0b$export$dbf350e5966cf602(o, ...s));
    return o.attrs = (o)=>$f8dbcd8598db1f0b$var$mt(e, t, Object.assign(Object.assign({}, n), {
            attrs: Array.prototype.concat(n.attrs, o).filter(Boolean)
        })), o.withConfig = (o)=>$f8dbcd8598db1f0b$var$mt(e, t, Object.assign(Object.assign({}, n), o)), o;
}
const $f8dbcd8598db1f0b$var$yt = (e)=>$f8dbcd8598db1f0b$var$mt($f8dbcd8598db1f0b$var$ut, e), $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$yt;
$f8dbcd8598db1f0b$var$dt.forEach((e)=>{
    $f8dbcd8598db1f0b$export$2e2bcd8739ae039[e] = $f8dbcd8598db1f0b$var$yt(e);
});
class $f8dbcd8598db1f0b$var$vt {
    constructor(e, t){
        this.instanceRules = new Map, this.rules = e, this.componentId = t, this.isStatic = function(e) {
            for(let t = 0; t < e.length; t += 1){
                const n = e[t];
                if ($f8dbcd8598db1f0b$var$re(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
            }
            return !0;
        }(e), $f8dbcd8598db1f0b$var$$e.registerId(this.componentId);
    }
    removeStyles(e, t) {
        this.instanceRules.delete(e), this.rebuildGroup(t);
    }
    renderStyles(e, t, n, o) {
        const s = this.componentId;
        if (this.isStatic) {
            if (n.hasNameForId(s, s + e)) this.instanceRules.has(e) || this.computeRules(e, t, n, o);
            else {
                const r = this.computeRules(e, t, n, o);
                n.insertRules(s, r.name, r.rules);
            }
            return;
        }
        const r = this.instanceRules.get(e);
        if (this.computeRules(e, t, n, o), !n.server && r) {
            const t = r.rules, n = this.instanceRules.get(e).rules;
            if (t.length === n.length) {
                let e = !0;
                for(let o = 0; o < t.length; o++)if (t[o] !== n[o]) {
                    e = !1;
                    break;
                }
                if (e) return;
            }
        }
        this.rebuildGroup(n);
    }
    computeRules(e, t, n, o) {
        const s = $f8dbcd8598db1f0b$var$le($f8dbcd8598db1f0b$var$Le(this.rules, t, n, o)), r = {
            name: this.componentId + e,
            rules: o(s, "")
        };
        return this.instanceRules.set(e, r), r;
    }
    rebuildGroup(e) {
        const t = this.componentId;
        e.clearRules(t);
        for (const n of this.instanceRules.values())e.insertRules(t, n.name, n.rules);
    }
}
function $f8dbcd8598db1f0b$export$f0f03736edb61697(e, ...n) {
    const o = $f8dbcd8598db1f0b$export$dbf350e5966cf602(e, ...n), s = `sc-global-${$f8dbcd8598db1f0b$var$z(JSON.stringify(o))}`, r = new $f8dbcd8598db1f0b$var$vt(o, s);
    const i = (e)=>{
        const n = $f8dbcd8598db1f0b$var$tt(), i = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6);
        let c;
        {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
            null === e.current && (e.current = n.styleSheet.allocateGSInstance(s)), c = e.current;
        }
        n.styleSheet.server && a(c, e, n.styleSheet, i, n.stylis);
        {
            const o = r.isStatic ? [
                c,
                n.styleSheet,
                r
            ] : [
                c,
                e,
                n.styleSheet,
                i,
                n.stylis,
                r
            ], l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(r);
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
                n.styleSheet.server || (l.current !== r && (n.styleSheet.clearRules(s), l.current = r), a(c, e, n.styleSheet, i, n.stylis));
            }, o), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>()=>{
                    n.styleSheet.server || r.removeStyles(c, n.styleSheet);
                }, [
                c,
                n.styleSheet,
                r
            ]);
        }
        return n.styleSheet.server && r.instanceRules.delete(c), null;
    };
    function a(e, t, n, o, s) {
        if (r.isStatic) r.renderStyles(e, $f8dbcd8598db1f0b$var$v, n, s);
        else {
            const a = Object.assign(Object.assign({}, t), {
                theme: $f8dbcd8598db1f0b$var$x(t, o, i.defaultProps)
            });
            r.renderStyles(e, a, n, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(i);
}
function $f8dbcd8598db1f0b$var$bt(e, t, n, o, s) {
    for(const r in e){
        const i = e[r], a = s ? s + "-" + r : r;
        if ("object" == typeof i && null !== i) {
            const e = {};
            $f8dbcd8598db1f0b$var$bt(i, t, e, o, a), n[r] = e;
        } else n[r] = o(a, i, r);
    }
}
function $f8dbcd8598db1f0b$var$wt(e, t, n, o) {
    let s = "";
    for(const r in e){
        const i = e[r], a = t[r], c = o ? o + "-" + r : r;
        "object" == typeof i && null !== i ? "object" == typeof a && null !== a && (s += $f8dbcd8598db1f0b$var$wt(i, a, n, c)) : void 0 !== a && "function" != typeof a && (s += "--" + n + c + ":" + a + ";");
    }
    return s;
}
function $f8dbcd8598db1f0b$export$25d302a5b900a763(e, t) {
    var n, o;
    const s = (null !== (n = null == t ? void 0 : t.prefix) && void 0 !== n ? n : "sc") + "-", r = null !== (o = null == t ? void 0 : t.selector) && void 0 !== o ? o : ":root", i = function(e, t) {
        const n = {};
        return $f8dbcd8598db1f0b$var$bt(e, t, n, (e)=>"--" + t + e), n;
    }(e, s), a = function(e, t) {
        const n = {};
        return $f8dbcd8598db1f0b$var$bt(e, t, n, (e, n)=>{
            return "var(--" + t + e + ", " + n + ")";
        }), n;
    }(e, s), c = $f8dbcd8598db1f0b$export$f0f03736edb61697`
    ${r} {
      ${(t)=>$f8dbcd8598db1f0b$var$wt(e, t.theme, s)}
    }
  `;
    return Object.assign(a, {
        GlobalStyle: c,
        raw: e,
        vars: i,
        resolve (t) {
            if (!$f8dbcd8598db1f0b$var$f) throw new Error("createTheme.resolve() is client-only");
            const n = null != t ? t : document.documentElement;
            return function(e, t, n) {
                const o = {};
                return $f8dbcd8598db1f0b$var$bt(e, t, o, (e, o)=>n.getPropertyValue("--" + t + e).trim() || o), o;
            }(e, s, getComputedStyle(n));
        }
    });
}
var $f8dbcd8598db1f0b$var$Ct;
class $f8dbcd8598db1f0b$var$Ot {
    constructor(e, t){
        this[$f8dbcd8598db1f0b$var$Ct] = !0, this.inject = (e, t = $f8dbcd8598db1f0b$var$Qe)=>{
            const n = this.getName(t);
            if (!e.hasNameForId(this.id, n)) {
                const o = t(this.rules, n, "@keyframes");
                e.insertRules(this.id, n, o);
            }
        }, this.name = e, this.id = $f8dbcd8598db1f0b$var$g + e, this.rules = t, $f8dbcd8598db1f0b$var$C(this.id), $f8dbcd8598db1f0b$var$he(this, ()=>{
            throw $f8dbcd8598db1f0b$var$i(12, String(this.name));
        });
    }
    getName(e = $f8dbcd8598db1f0b$var$Qe) {
        return e.hash ? this.name + $f8dbcd8598db1f0b$var$V(+e.hash >>> 0) : this.name;
    }
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(e, ...t) {
    const n = $f8dbcd8598db1f0b$var$le($f8dbcd8598db1f0b$export$dbf350e5966cf602(e, ...t)), o = $f8dbcd8598db1f0b$var$z(n);
    return new $f8dbcd8598db1f0b$var$Ot(o, n);
}
function $f8dbcd8598db1f0b$export$e8748c6a27b910dc(e) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((n, o)=>{
        const s = $f8dbcd8598db1f0b$var$x(n, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, Object.assign(Object.assign({}, n), {
            theme: s,
            ref: o
        }));
    });
    return n.displayName = `WithTheme(${$f8dbcd8598db1f0b$var$W(e)})`, $f8dbcd8598db1f0b$var$se(n, e);
}
$f8dbcd8598db1f0b$var$Ct = $f8dbcd8598db1f0b$var$Te;
class $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 {
    constructor({ nonce: e } = {}){
        this._emitSheetCSS = ()=>{
            const e = this.instance.toString();
            if (!e) return "";
            const t = this.instance.options.nonce || $f8dbcd8598db1f0b$var$Ce();
            return `<style ${$f8dbcd8598db1f0b$var$le([
                t && `nonce="${t}"`,
                `${$f8dbcd8598db1f0b$var$l}="true"`,
                `${$f8dbcd8598db1f0b$var$d}="${$f8dbcd8598db1f0b$export$83d89fbfd8236492}"`
            ].filter(Boolean), " ")}>${e}</style>`;
        }, this.getStyleTags = ()=>{
            if (this.sealed) throw $f8dbcd8598db1f0b$var$i(2);
            return this._emitSheetCSS();
        }, this.getStyleElement = ()=>{
            if (this.sealed) throw $f8dbcd8598db1f0b$var$i(2);
            const e = this.instance.toString();
            if (!e) return [];
            const n = {
                [$f8dbcd8598db1f0b$var$l]: "",
                [$f8dbcd8598db1f0b$var$d]: $f8dbcd8598db1f0b$export$83d89fbfd8236492,
                dangerouslySetInnerHTML: {
                    __html: e
                }
            }, o = this.instance.options.nonce || $f8dbcd8598db1f0b$var$Ce();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", Object.assign({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = ()=>{
            this.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$$e({
            isServer: !0,
            nonce: e
        }), this.sealed = !1;
    }
    collectStyles(e) {
        if (this.sealed) throw $f8dbcd8598db1f0b$var$i(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }
    interleaveWithNodeStream(e) {
        throw $f8dbcd8598db1f0b$var$i(3);
    }
}
const $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$$e,
    mainSheet: $f8dbcd8598db1f0b$var$Ke
};
const $f8dbcd8598db1f0b$var$$t = `__sc-${$f8dbcd8598db1f0b$var$l}__`;
const $f8dbcd8598db1f0b$var$It = /:(?:(first)-child|(last)-child|(only)-child|(nth-child)\(([^()]+)\)|(nth-last-child)\(([^()]+)\))/g, $f8dbcd8598db1f0b$var$xt = `:not(style[${$f8dbcd8598db1f0b$var$l}])`, $f8dbcd8598db1f0b$var$Rt = `style[${$f8dbcd8598db1f0b$var$l}]`;
function $f8dbcd8598db1f0b$var$jt(e) {
    return -1 === e.indexOf("-child") ? e : ($f8dbcd8598db1f0b$var$It.lastIndex = 0, e.replace($f8dbcd8598db1f0b$var$It, (e, t, n, o, s, r, i, a)=>t ? `:nth-child(1 of ${$f8dbcd8598db1f0b$var$xt})` : n ? `:nth-last-child(1 of ${$f8dbcd8598db1f0b$var$xt})` : o ? `:nth-child(1 of ${$f8dbcd8598db1f0b$var$xt}):nth-last-child(1 of ${$f8dbcd8598db1f0b$var$xt})` : s ? -1 !== r.indexOf(" of ") ? e : `:nth-child(${r} of ${$f8dbcd8598db1f0b$var$xt})` : -1 !== a.indexOf(" of ") ? e : `:nth-last-child(${a} of ${$f8dbcd8598db1f0b$var$xt})`));
}
function $f8dbcd8598db1f0b$var$kt(e, t) {
    if (-1 === e.indexOf("+")) return;
    let n = 0, o = 0;
    for(let s = 0; s < e.length; s++){
        const r = e.charCodeAt(s);
        if (40 === r) n++;
        else if (41 === r) n--;
        else if (91 === r) o++;
        else if (93 === r) o--;
        else if (43 === r && 0 === n && 0 === o && !$f8dbcd8598db1f0b$var$Ye(e, s)) {
            const n = e.substring(0, s), o = e.substring(s + 1);
            t.push(n + "+" + $f8dbcd8598db1f0b$var$Rt + "+" + o), t.push(n + "+" + $f8dbcd8598db1f0b$var$Rt + "+" + $f8dbcd8598db1f0b$var$Rt + "+" + o);
        }
    }
}
function $f8dbcd8598db1f0b$export$337461d98bd2ad54(e) {
    if (e.type === (0, $fm8kz.RULESET)) {
        const t = e.props, n = [];
        for(let e = 0; e < t.length; e++){
            const o = $f8dbcd8598db1f0b$var$jt(t[e]);
            n.push(o), $f8dbcd8598db1f0b$var$kt(o, n);
        }
        e.props = n;
    }
}

});
parcelRegister("gd942", function(module, exports) {

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
$parcel$export(module.exports, "prefixer", () => $298fb931ed4fbf8b$export$e08c7d021b829b7a);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$1c5a554c78c0cd12 = "@scope";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $298fb931ed4fbf8b$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r);
    });
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$590e8b2c435046d9(e) {
    while(e.root)e = $298fb931ed4fbf8b$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $298fb931ed4fbf8b$export$10d8903dec122b9d(e, e.siblings);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = n;
    var y = s;
    var j = c;
    var z = k;
    while(w)switch(b = g, g = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(z += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $298fb931ed4fbf8b$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $298fb931ed4fbf8b$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($298fb931ed4fbf8b$export$9e1725a4cfeada27(b || 1) == 5 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e() || 1) == 5) && $298fb931ed4fbf8b$export$36776f635604f274(z) && $298fb931ed4fbf8b$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($298fb931ed4fbf8b$export$36776f635604f274(z) - l || h === 0 && b === 47)) $298fb931ed4fbf8b$export$10d8903dec122b9d(v > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(j = $298fb931ed4fbf8b$export$3307ffa7023ede1e(z, r, a, f, o, n, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $298fb931ed4fbf8b$export$98e6a39c04603d36(e, j, j, c && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, k, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $298fb931ed4fbf8b$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) z += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    p = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(k = z += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $298fb931ed4fbf8b$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, g = 0; w < c; ++w)for(var k = 0, m = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(d = u[w])), x = e; k < h; ++k)if (x = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(d > 0 ? b[k] + " " + m : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(m, /&\f/g, b[k]))) f[g++] = x;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, c, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, c), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(c, n, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(c, n)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c + (s = s[n].value), "span", 0) ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span", 0) ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(c) - 1 - n > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c, "stretch", 0) ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, $298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$6aad947bda0f3f46:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            if (!$298fb931ed4fbf8b$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                c.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (c.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});


parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("4f362", function(module, exports) {

$parcel$export(module.exports, "$mobx", () => $316af70a850315f9$export$f246528900dd4467);
$parcel$export(module.exports, "createAtom", () => $316af70a850315f9$export$2e17fe64ec9a826e);
$parcel$export(module.exports, "compareIdentity", () => $316af70a850315f9$export$3de73ed166baf608);
$parcel$export(module.exports, "compareStructural", () => $316af70a850315f9$export$8a67fbe40c3dd8c1);
$parcel$export(module.exports, "compareShallow", () => $316af70a850315f9$export$202cfbbbce69d3c4);
$parcel$export(module.exports, "compareDefault", () => $316af70a850315f9$export$700812e5ccfdbb1d);
$parcel$export(module.exports, "isObservable", () => $316af70a850315f9$export$5cd057a6046189f9);
$parcel$export(module.exports, "observable", () => $316af70a850315f9$export$5ab46cbf6120b33a);
$parcel$export(module.exports, "isAction", () => $316af70a850315f9$export$b956e38827fca970);
$parcel$export(module.exports, "isFlow", () => $316af70a850315f9$export$8c23365ce94ba925);
$parcel$export(module.exports, "flow", () => $316af70a850315f9$export$ccc7b0636abaffc3);
$parcel$export(module.exports, "_autoAction", () => $316af70a850315f9$export$b8aa795084cbf86b);
$parcel$export(module.exports, "isObservableObject", () => $316af70a850315f9$export$31960fb081a18155);
$parcel$export(module.exports, "isObservableArray", () => $316af70a850315f9$export$f5afceff386badf9);
$parcel$export(module.exports, "isObservableMap", () => $316af70a850315f9$export$27a7faddcfd44960);
$parcel$export(module.exports, "isObservableSet", () => $316af70a850315f9$export$da6b063694cb52c1);
$parcel$export(module.exports, "override", () => $316af70a850315f9$export$a46fbcd73382caa5);
$parcel$export(module.exports, "computed", () => $316af70a850315f9$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "flowBound", () => $316af70a850315f9$export$d41c06fa934cc67e);
$parcel$export(module.exports, "_autoActionBound", () => $316af70a850315f9$export$4dd0b06162f181e);
$parcel$export(module.exports, "observableRef", () => $316af70a850315f9$export$431518ad42ffb7bd);
$parcel$export(module.exports, "ObservableMap", () => $316af70a850315f9$export$db1c0901f08fc6fd);
$parcel$export(module.exports, "ObservableSet", () => $316af70a850315f9$export$2235f602a7a77c81);
$parcel$export(module.exports, "extendObservable", () => $316af70a850315f9$export$59d8134e963031bd);
$parcel$export(module.exports, "observableShallow", () => $316af70a850315f9$export$d618cc4ca9414c13);
$parcel$export(module.exports, "observableDeep", () => $316af70a850315f9$export$36408c859af67d57);
$parcel$export(module.exports, "observableStruct", () => $316af70a850315f9$export$716593212ba381a0);
$parcel$export(module.exports, "computedStruct", () => $316af70a850315f9$export$356bab705a4abec5);
$parcel$export(module.exports, "_startAction", () => $316af70a850315f9$export$42f76bef54cf1cd3);
$parcel$export(module.exports, "_endAction", () => $316af70a850315f9$export$9d569d1d4d631c2d);
$parcel$export(module.exports, "_allowStateReadsStart", () => $316af70a850315f9$export$84c93b6404d77e6f);
$parcel$export(module.exports, "_allowStateReadsEnd", () => $316af70a850315f9$export$c7b7fb1b2b410642);
$parcel$export(module.exports, "_allowStateChanges", () => $316af70a850315f9$export$e510c5d1ea4358b1);
$parcel$export(module.exports, "isBoxedObservable", () => $316af70a850315f9$export$fafbc00dbefd1aef);
$parcel$export(module.exports, "_isComputingDerivation", () => $316af70a850315f9$export$34c53f8cb85e26c1);
$parcel$export(module.exports, "untracked", () => $316af70a850315f9$export$8c437e4d572e2f99);
$parcel$export(module.exports, "_getGlobalState", () => $316af70a850315f9$export$c78907783e606401);
$parcel$export(module.exports, "_resetGlobalState", () => $316af70a850315f9$export$5c18e491c80b9ab4);
$parcel$export(module.exports, "Reaction", () => $316af70a850315f9$export$d2ae4167a30cf6bb);
$parcel$export(module.exports, "onReactionError", () => $316af70a850315f9$export$d7203a53b5e117e4);
$parcel$export(module.exports, "spy", () => $316af70a850315f9$export$fcc0cd19e9fb2b4c);
$parcel$export(module.exports, "action", () => $316af70a850315f9$export$31eb53bd5b582a97);
$parcel$export(module.exports, "actionBound", () => $316af70a850315f9$export$3720eced4297d10c);
$parcel$export(module.exports, "_allowStateChangesInsideComputed", () => $316af70a850315f9$export$832370e58be26204);
$parcel$export(module.exports, "autorun", () => $316af70a850315f9$export$4abd31caebb0bb24);
$parcel$export(module.exports, "reaction", () => $316af70a850315f9$export$7203b476385689ae);
$parcel$export(module.exports, "onBecomeObserved", () => $316af70a850315f9$export$24d7f9cdf0de2679);
$parcel$export(module.exports, "onBecomeUnobserved", () => $316af70a850315f9$export$f8586f6f22b9cba9);
$parcel$export(module.exports, "getAtom", () => $316af70a850315f9$export$25fc416d10fa1afa);
$parcel$export(module.exports, "configure", () => $316af70a850315f9$export$8d21e34596265fa2);
$parcel$export(module.exports, "getDependencyTree", () => $316af70a850315f9$export$23fbf90e5d80a5ee);
$parcel$export(module.exports, "getObserverTree", () => $316af70a850315f9$export$3b1621dddf5aeacd);
$parcel$export(module.exports, "FlowCancellationError", () => $316af70a850315f9$export$134218f44485f691);
$parcel$export(module.exports, "isFlowCancellationError", () => $316af70a850315f9$export$e01c2a57c655302d);
$parcel$export(module.exports, "flowResult", () => $316af70a850315f9$export$b1b0dfc8def25964);
$parcel$export(module.exports, "_interceptReads", () => $316af70a850315f9$export$bf4da824ef9b40d0);
$parcel$export(module.exports, "_getAdministration", () => $316af70a850315f9$export$71ff639cb8b2a36e);
$parcel$export(module.exports, "intercept", () => $316af70a850315f9$export$ab0f802c05dd969b);
$parcel$export(module.exports, "isComputed", () => $316af70a850315f9$export$21bb8b7af2417cc3);
$parcel$export(module.exports, "isComputedProp", () => $316af70a850315f9$export$3cf701ab9f66d86a);
$parcel$export(module.exports, "isObservableProp", () => $316af70a850315f9$export$7ad7acc949ba3cc7);
$parcel$export(module.exports, "keys", () => $316af70a850315f9$export$ed97f33186d4b816);
$parcel$export(module.exports, "values", () => $316af70a850315f9$export$68c286be0e7e55b7);
$parcel$export(module.exports, "entries", () => $316af70a850315f9$export$3e9f948b41964866);
$parcel$export(module.exports, "set", () => $316af70a850315f9$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "remove", () => $316af70a850315f9$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "has", () => $316af70a850315f9$export$a4f4bb6b1453fff5);
$parcel$export(module.exports, "get", () => $316af70a850315f9$export$3988ae62b71be9a3);
$parcel$export(module.exports, "defineProperty", () => $316af70a850315f9$export$fdab3c20aae16ddf);
$parcel$export(module.exports, "ownKeys", () => $316af70a850315f9$export$6aa2094d45f88f20);
$parcel$export(module.exports, "observe", () => $316af70a850315f9$export$d1203567a167490e);
$parcel$export(module.exports, "toJS", () => $316af70a850315f9$export$f08965dd1304d490);
$parcel$export(module.exports, "transaction", () => $316af70a850315f9$export$2d62d2646dd2fb3c);
$parcel$export(module.exports, "when", () => $316af70a850315f9$export$a55877ca9db47377);
$parcel$export(module.exports, "makeObservable", () => $316af70a850315f9$export$885e6ca7a4dc4b3e);
$parcel$export(module.exports, "makeAutoObservable", () => $316af70a850315f9$export$1cfaca5abb185fe7);
$parcel$export(module.exports, "getDebugName", () => $316af70a850315f9$export$c48237bbccf30144);
$parcel$export(module.exports, "runInAction", () => $316af70a850315f9$export$832370e58be26204);
const $316af70a850315f9$var$__MOBX_DEV__ = false;
const $316af70a850315f9$var$niceErrors = {
    0: `Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'`,
    1 (annotationType, key) {
        return `Cannot apply '${annotationType}' to '${key.toString()}': Field not found.`;
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: `Invalid annotation`,
    13: `Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)`,
    14: "Intercept handlers should return nothing or a change object",
    15: `Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)`,
    16: `Modification exception: the internal structure of an observable array was changed.`,
    19 (other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20 (other) {
        return "Cannot initialize map from " + other;
    },
    21 (dataStructure) {
        return `Cannot convert to map from '${dataStructure}'`;
    },
    23: "It is not possible to get index atoms from arrays",
    24 (thing) {
        return "Cannot obtain administration from " + thing;
    },
    25 (property, name) {
        return `the entry '${property}' does not exist in the observable map '${name}'`;
    },
    26: "please specify a property",
    27 (property, name) {
        return `no observable property '${property.toString()}' found on the observable object '${name}'`;
    },
    28 (thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32 (name, derivation) {
        return `Cycle detected in computation ${name}: ${derivation}`;
    },
    33 (name) {
        return `The setter of computed value '${name}' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?`;
    },
    34 (name) {
        return `[ComputedValue '${name}'] It is not possible to assign a new value to a computed value.`;
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37 (method) {
        return `[mobx] \`observableArray.${method}()\` mutates the array in-place, which is not allowed inside a derivation. Use \`array.slice().${method}()\` instead`;
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects",
    40 (length) {
        return "Out of range: " + length;
    },
    41 (other) {
        return "Cannot initialize set from " + other;
    },
    42 (key) {
        return `Invalid index: '${key}'`;
    },
    43 (annotationType, name, kind) {
        return `Cannot apply '${annotationType}' to '${name}' (kind: ${kind}):` + `\n'${annotationType}' can only be used on properties with a function value.`;
    },
    44 (annotationType) {
        return `'${annotationType}' can only be used with 'makeObservable'`;
    }
};
const $316af70a850315f9$var$errors = $316af70a850315f9$var$__MOBX_DEV__ ? $316af70a850315f9$var$niceErrors : {};
function $316af70a850315f9$var$die(error, ...args) {
    if ($316af70a850315f9$var$__MOBX_DEV__) {
        let e = typeof error === "string" ? error : $316af70a850315f9$var$errors[error];
        if (typeof e === "function") e = e.apply(null, args);
        throw new Error(`[MobX] ${e}`);
    }
    throw new Error(`[MobX] minified error nr: ${error}${args.length ? " " + args.map(String).join(",") : ""}. See mobx.js.org/errors`);
}
// We shorten anything used > 5 times
const $316af70a850315f9$var$assign = Object.assign;
const $316af70a850315f9$var$getDescriptor = Object.getOwnPropertyDescriptor;
const $316af70a850315f9$var$defineProperty = Object.defineProperty;
const $316af70a850315f9$var$objectPrototype = Object.prototype;
const $316af70a850315f9$var$EMPTY_ARRAY = [];
Object.freeze($316af70a850315f9$var$EMPTY_ARRAY);
const $316af70a850315f9$var$EMPTY_OBJECT = {};
Object.freeze($316af70a850315f9$var$EMPTY_OBJECT);
const $316af70a850315f9$var$plainObjectString = /*#__PURE__*/ Object.toString();
function $316af70a850315f9$var$getNextId() {
    return ++$316af70a850315f9$var$globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function $316af70a850315f9$var$once(func) {
    let invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
const $316af70a850315f9$var$noop = ()=>{};
function $316af70a850315f9$var$isFunction(fn) {
    return typeof fn === "function";
}
function $316af70a850315f9$var$isStringish(value) {
    const t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function $316af70a850315f9$var$isObject(value) {
    return value !== null && typeof value === "object";
}
function $316af70a850315f9$var$isPlainObject(value) {
    if (!$316af70a850315f9$var$isObject(value)) return false;
    const proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    const protoConstructor = $316af70a850315f9$var$hasProp(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === $316af70a850315f9$var$plainObjectString;
}
// https://stackoverflow.com/a/37865170
function $316af70a850315f9$var$isGenerator(obj) {
    const constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function $316af70a850315f9$var$addHiddenProp(object, propName, value) {
    $316af70a850315f9$var$defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function $316af70a850315f9$var$addHiddenFinalProp(object, propName, value) {
    $316af70a850315f9$var$defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function $316af70a850315f9$var$createInstanceofPredicate(name, theClass) {
    const propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return $316af70a850315f9$var$isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function $316af70a850315f9$var$isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function $316af70a850315f9$var$isPlainES6Map(thing) {
    const mapProto = Object.getPrototypeOf(thing);
    const objectProto = Object.getPrototypeOf(mapProto);
    const nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function $316af70a850315f9$var$isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
/**
 * Returns the following: own enumerable keys and symbols.
 */ function $316af70a850315f9$var$getPlainObjectKeys(object) {
    const keys = Object.keys(object);
    const symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [
        ...keys,
        ...symbols.filter((s)=>$316af70a850315f9$var$objectPrototype.propertyIsEnumerable.call(object, s))
    ];
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
const $316af70a850315f9$var$ownKeys = Reflect.ownKeys;
function $316af70a850315f9$var$stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function $316af70a850315f9$var$toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function $316af70a850315f9$var$hasProp(target, prop) {
    return $316af70a850315f9$var$objectPrototype.hasOwnProperty.call(target, prop);
}
const $316af70a850315f9$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors;
function $316af70a850315f9$var$getFlag(flags, mask) {
    return !!(flags & mask);
}
function $316af70a850315f9$var$setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function $316af70a850315f9$var$assert20223DecoratorType(context, types) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && !types.includes(context.kind)) $316af70a850315f9$var$die(`The decorator applied to '${String(context.name)}' cannot be used on a ${context.kind} element`);
}
const $316af70a850315f9$export$f246528900dd4467 = /*#__PURE__*/ Symbol("mobx administration");
class $316af70a850315f9$var$Atom {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ constructor(name_ = $316af70a850315f9$var$__MOBX_DEV__ ? "Atom@" + $316af70a850315f9$var$getNextId() : "Atom"){
        this.name_ = void 0;
        this.flags_ = 0;
        // Allocated lazily on first observer to save memory.
        this.observers_ = null;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    get isBeingObserved() {
        return $316af70a850315f9$var$getFlag(this.flags_, 1 /* AtomFlags.isBeingObserved */ );
    }
    set isBeingObserved(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 1 /* AtomFlags.isBeingObserved */ , newValue);
    }
    get isPendingUnobservation() {
        return $316af70a850315f9$var$getFlag(this.flags_, 2 /* AtomFlags.isPendingUnobservation */ );
    }
    set isPendingUnobservation(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 2 /* AtomFlags.isPendingUnobservation */ , newValue);
    }
    get diffValue() {
        return $316af70a850315f9$var$getFlag(this.flags_, 4 /* AtomFlags.diffValue */ ) ? 1 : 0;
    }
    set diffValue(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 4 /* AtomFlags.diffValue */ , newValue === 1 ? true : false);
    }
    onBO() {
        if (this.onBOL) this.onBOL.forEach((listener)=>listener());
    }
    onBUO() {
        if (this.onBUOL) this.onBUOL.forEach((listener)=>listener());
    }
    /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ reportObserved() {
        return $316af70a850315f9$var$reportObserved(this);
    }
    /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ reportChanged() {
        $316af70a850315f9$var$startBatch();
        $316af70a850315f9$var$propagateChanged(this);
        $316af70a850315f9$var$endBatch();
    }
    toString() {
        return this.name_;
    }
}
const $316af70a850315f9$var$isAtom = /*#__PURE__*/ $316af70a850315f9$var$createInstanceofPredicate("Atom", $316af70a850315f9$var$Atom);
function $316af70a850315f9$export$2e17fe64ec9a826e(name, onBecomeObservedHandler = $316af70a850315f9$var$noop, onBecomeUnobservedHandler = $316af70a850315f9$var$noop) {
    const atom = new $316af70a850315f9$var$Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== $316af70a850315f9$var$noop) atom.onBOL = new Set([
        onBecomeObservedHandler
    ]);
    if (onBecomeUnobservedHandler !== $316af70a850315f9$var$noop) atom.onBUOL = new Set([
        onBecomeUnobservedHandler
    ]);
    return atom;
}
function $316af70a850315f9$export$3de73ed166baf608(a, b) {
    return a === b;
}
function $316af70a850315f9$export$8a67fbe40c3dd8c1(a, b) {
    return $316af70a850315f9$var$deepEqual(a, b);
}
function $316af70a850315f9$export$202cfbbbce69d3c4(a, b) {
    return $316af70a850315f9$var$deepEqual(a, b, 1);
}
const $316af70a850315f9$export$700812e5ccfdbb1d = Object.is;
function $316af70a850315f9$var$deepEnhancer(v, _, name) {
    // primitives can never be made observable; skip the type checks below
    if (v === null || typeof v !== "object" && typeof v !== "function") return v;
    // it is an observable already, done
    if ($316af70a850315f9$export$5cd057a6046189f9(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.array(v, {
        name: name
    });
    if ($316af70a850315f9$var$isPlainObject(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.object(v, undefined, {
        name: name
    });
    if ($316af70a850315f9$var$isES6Map(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.map(v, {
        name: name
    });
    if ($316af70a850315f9$var$isES6Set(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.set(v, {
        name: name
    });
    if (typeof v === "function" && !$316af70a850315f9$export$b956e38827fca970(v) && !$316af70a850315f9$export$8c23365ce94ba925(v)) {
        if ($316af70a850315f9$var$isGenerator(v)) return $316af70a850315f9$export$ccc7b0636abaffc3(v);
        else return $316af70a850315f9$export$b8aa795084cbf86b(name, v);
    }
    return v;
}
function $316af70a850315f9$var$shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if ($316af70a850315f9$export$31960fb081a18155(v) || $316af70a850315f9$export$f5afceff386badf9(v) || $316af70a850315f9$export$27a7faddcfd44960(v) || $316af70a850315f9$export$da6b063694cb52c1(v)) return v;
    if (Array.isArray(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.array(v, {
        name: name,
        deep: false
    });
    if ($316af70a850315f9$var$isPlainObject(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.object(v, undefined, {
        name: name,
        deep: false
    });
    if ($316af70a850315f9$var$isES6Map(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.map(v, {
        name: name,
        deep: false
    });
    if ($316af70a850315f9$var$isES6Set(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.set(v, {
        name: name,
        deep: false
    });
    if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$die("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function $316af70a850315f9$var$referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function $316af70a850315f9$var$refStructEnhancer(v, oldValue) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$export$5cd057a6046189f9(v)) $316af70a850315f9$var$die(`observableStruct should not be used with observable values`);
    if ($316af70a850315f9$var$deepEqual(v, oldValue)) return oldValue;
    return v;
}
const $316af70a850315f9$var$OVERRIDE = "override";
const $316af70a850315f9$export$a46fbcd73382caa5 = {
    annotationType_: $316af70a850315f9$var$OVERRIDE,
    make_: $316af70a850315f9$var$make_$6,
    extend_: $316af70a850315f9$var$extend_$5
};
function $316af70a850315f9$var$isOverride(annotation) {
    return annotation.annotationType_ === $316af70a850315f9$var$OVERRIDE;
}
function $316af70a850315f9$var$make_$6(adm, key) {
    // Must not be plain object
    if ($316af70a850315f9$var$__MOBX_DEV__ && adm.isPlainObject_) $316af70a850315f9$var$die(`Cannot apply '${this.annotationType_}' to '${adm.name_}.${key.toString()}':` + `\n'${this.annotationType_}' cannot be used on plain objects.`);
    // Must override something
    if ($316af70a850315f9$var$__MOBX_DEV__ && !$316af70a850315f9$var$hasProp(adm.appliedAnnotations_, key)) $316af70a850315f9$var$die(`'${adm.name_}.${key.toString()}' is annotated with '${this.annotationType_}', ` + `but no such annotated member was found on prototype.`);
    return 0 /* MakeResult.Cancel */ ;
}
function $316af70a850315f9$var$extend_$5(adm, key, descriptor, proxyTrap) {
    $316af70a850315f9$var$die(44, this.annotationType_);
}
function $316af70a850315f9$var$createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $316af70a850315f9$var$make_$5,
        extend_: $316af70a850315f9$var$extend_$4
    };
}
function $316af70a850315f9$var$make_$5(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if ($316af70a850315f9$export$b956e38827fca970(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    const actionDescriptor = $316af70a850315f9$var$createActionDescriptor(adm, this, key, descriptor, false);
    $316af70a850315f9$var$defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function $316af70a850315f9$var$extend_$4(adm, key, descriptor, proxyTrap) {
    const actionDescriptor = $316af70a850315f9$var$createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function $316af70a850315f9$var$decorateAction20223_(annotation, mthd, context) {
    if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$assert20223DecoratorType(context, [
        "method",
        "field"
    ]);
    const { kind: kind, name: name, addInitializer: addInitializer } = context;
    const ann = annotation;
    const _createAction = (m)=>{
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return $316af70a850315f9$var$createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        let mthd = initMthd;
        if (!$316af70a850315f9$export$b956e38827fca970(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _ann$options_4;
        if (!$316af70a850315f9$export$b956e38827fca970(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_4 = ann.options_) != null && _ann$options_4.bound) addInitializer(function() {
            const self = this;
            const bound = self[name].bind(self);
            bound.isMobxAction = true;
            self[name] = bound;
        });
        return mthd;
    }
    $316af70a850315f9$var$die(43, ann.annotationType_, String(name), kind);
}
function $316af70a850315f9$var$assertActionDescriptor(adm, { annotationType_: annotationType_ }, key, { value: value }) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && !$316af70a850315f9$var$isFunction(value)) $316af70a850315f9$var$die(`Cannot apply '${annotationType_}' to '${adm.name_}.${key.toString()}':` + `\n'${annotationType_}' can only be used on properties with a function value.`);
}
function $316af70a850315f9$var$createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors = $316af70a850315f9$var$globalState.safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    $316af70a850315f9$var$assertActionDescriptor(adm, annotation, key, descriptor);
    let { value: value } = descriptor;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: $316af70a850315f9$var$createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function $316af70a850315f9$var$createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $316af70a850315f9$var$make_$4,
        extend_: $316af70a850315f9$var$extend_$3
    };
}
function $316af70a850315f9$var$make_$4(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!$316af70a850315f9$var$hasProp(adm.target_, key) || !$316af70a850315f9$export$8c23365ce94ba925(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if ($316af70a850315f9$export$8c23365ce94ba925(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    const flowDescriptor = $316af70a850315f9$var$createFlowDescriptor(adm, this, key, descriptor, false, false);
    $316af70a850315f9$var$defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function $316af70a850315f9$var$extend_$3(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    const flowDescriptor = $316af70a850315f9$var$createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function $316af70a850315f9$var$decorateFlow20223_(annotation, mthd, context) {
    var _annotation$options_;
    if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$assert20223DecoratorType(context, [
        "method"
    ]);
    const { name: name, addInitializer: addInitializer } = context;
    if (!$316af70a850315f9$export$8c23365ce94ba925(mthd)) mthd = $316af70a850315f9$export$ccc7b0636abaffc3(mthd);
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) addInitializer(function() {
        const self = this;
        const bound = self[name].bind(self);
        bound.isMobXFlow = true;
        self[name] = bound;
    });
    return mthd;
}
function $316af70a850315f9$var$assertFlowDescriptor(adm, { annotationType_: annotationType_ }, key, { value: value }) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && !$316af70a850315f9$var$isFunction(value)) $316af70a850315f9$var$die(`Cannot apply '${annotationType_}' to '${adm.name_}.${key.toString()}':` + `\n'${annotationType_}' can only be used on properties with a generator function value.`);
}
function $316af70a850315f9$var$createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors = $316af70a850315f9$var$globalState.safeDescriptors) {
    $316af70a850315f9$var$assertFlowDescriptor(adm, annotation, key, descriptor);
    let { value: value } = descriptor;
    // In case of flowBound, the descriptor can be from already annotated prototype
    if (!$316af70a850315f9$export$8c23365ce94ba925(value)) value = $316af70a850315f9$export$ccc7b0636abaffc3(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function $316af70a850315f9$var$createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $316af70a850315f9$var$make_$3,
        extend_: $316af70a850315f9$var$extend_$2
    };
}
function $316af70a850315f9$var$make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function $316af70a850315f9$var$extend_$2(adm, key, descriptor, proxyTrap) {
    $316af70a850315f9$var$assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, $316af70a850315f9$var$assign({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function $316af70a850315f9$var$decorateComputed20223_(annotation, get, context) {
    if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$assert20223DecoratorType(context, [
        "getter"
    ]);
    const ann = annotation;
    const { name: key, addInitializer: addInitializer } = context;
    let computedValues;
    // Defer ComputedValue creation until first access — avoids allocating
    // ComputedValues for getters that are never read on a given instance.
    // The factory is materialised by ObservableObjectAdministration on demand.
    function createComputedValue(target, adm) {
        const options = $316af70a850315f9$var$assign({}, ann.options_, {
            get: get,
            context: target
        });
        options.name || (options.name = $316af70a850315f9$var$__MOBX_DEV__ ? `${adm.name_}.${key.toString()}` : `ObservableObject.${key.toString()}`);
        return new $316af70a850315f9$var$ComputedValue(options);
    }
    addInitializer(function() {
        var _adm$lazyComputedKeys;
        const adm = $316af70a850315f9$var$asObservableObject(this)[$316af70a850315f9$export$f246528900dd4467];
        const target = this;
        // An override is not lazy: a super read would materialize it in place of the parent (#4660)
        if (adm.values_.has(key) || (_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.delete(key)) adm.values_.set(key, createComputedValue(target, adm));
        else {
            var _adm$lazyComputedKeys2;
            ((_adm$lazyComputedKeys2 = adm.lazyComputedKeys_) != null ? _adm$lazyComputedKeys2 : adm.lazyComputedKeys_ = new Map()).set(key, ()=>createComputedValue(target, adm));
        }
    });
    return function() {
        const adm = this[$316af70a850315f9$export$f246528900dd4467];
        const observable = adm.values_.get(key);
        if (observable instanceof $316af70a850315f9$var$ComputedValue && observable.derivation !== get) {
            var _computedValues;
            let computed = (_computedValues = computedValues) == null ? void 0 : _computedValues.get(this);
            if (!computed) {
                var _computedValues2;
                computed = createComputedValue(this, adm);
                ((_computedValues2 = computedValues) != null ? _computedValues2 : computedValues = new WeakMap()).set(this, computed);
            }
            return computed.get();
        }
        return adm.getObservablePropValue_(key);
    };
}
function $316af70a850315f9$var$assertComputedDescriptor(adm, { annotationType_: annotationType_ }, key, { get: get }) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && !get) $316af70a850315f9$var$die(`Cannot apply '${annotationType_}' to '${adm.name_}.${key.toString()}':` + `\n'${annotationType_}' can only be used on getter(+setter) properties.`);
}
function $316af70a850315f9$var$createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: $316af70a850315f9$var$make_$2,
        extend_: $316af70a850315f9$var$extend_$1
    };
}
function $316af70a850315f9$var$make_$2(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function $316af70a850315f9$var$extend_$1(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    $316af70a850315f9$var$assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer_) != null ? _this$options_$enhanc : $316af70a850315f9$var$deepEnhancer, proxyTrap);
}
function $316af70a850315f9$var$decorateObservable20223_(annotation, desc, context) {
    if ($316af70a850315f9$var$__MOBX_DEV__) {
        if (context.kind === "field") throw $316af70a850315f9$var$die(`Please use \`@observable accessor ${String(context.name)}\` instead of \`@observable ${String(context.name)}\``);
        $316af70a850315f9$var$assert20223DecoratorType(context, [
            "accessor"
        ]);
    }
    const ann = annotation;
    const { kind: kind, name: name } = context;
    if (kind !== "accessor") return;
    // Defer ObservableValue construction until first access. The factory is
    // materialised by ObservableObjectAdministration on demand, so unused
    // fields on wide classes never pay the per-instance allocation cost.
    function registerLazy(target, value) {
        var _adm$lazyObservableKe;
        const adm = $316af70a850315f9$var$asObservableObject(target)[$316af70a850315f9$export$f246528900dd4467];
        ((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null ? _adm$lazyObservableKe : adm.lazyObservableKeys_ = new Map()).set(name, ()=>{
            var _ann$options_$enhance, _ann$options_;
            return new $316af70a850315f9$var$ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer_) != null ? _ann$options_$enhance : $316af70a850315f9$var$deepEnhancer, $316af70a850315f9$var$__MOBX_DEV__ ? `${adm.name_}.${name.toString()}` : `ObservableObject.${name.toString()}`, false);
        });
        return adm;
    }
    return {
        get () {
            var _this$$mobx;
            const adm = (_this$$mobx = this[$316af70a850315f9$export$f246528900dd4467]) != null ? _this$$mobx : registerLazy(this, desc.get.call(this));
            return adm.getObservablePropValue_(name);
        },
        set (value) {
            var _this$$mobx2;
            const adm = (_this$$mobx2 = this[$316af70a850315f9$export$f246528900dd4467]) != null ? _this$$mobx2 : registerLazy(this, value);
            return adm.setObservablePropValue_(name, value);
        },
        init (value) {
            registerLazy(this, value);
            return value;
        }
    };
}
function $316af70a850315f9$var$assertObservableDescriptor(adm, { annotationType_: annotationType_ }, key, descriptor) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && !("value" in descriptor)) $316af70a850315f9$var$die(`Cannot apply '${annotationType_}' to '${adm.name_}.${key.toString()}':` + `\n'${annotationType_}' cannot be used on getter/setter properties`);
}
const $316af70a850315f9$var$AUTO = "true";
const $316af70a850315f9$var$autoAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createAutoAnnotation();
function $316af70a850315f9$var$createAutoAnnotation(options) {
    return {
        annotationType_: $316af70a850315f9$var$AUTO,
        options_: options,
        make_: $316af70a850315f9$var$make_$1,
        extend_: $316af70a850315f9$var$extend_
    };
}
// The auto annotation only depends on `deep` and `autoBind`, so share one instance per combination
// instead of allocating one for every object created with options
const $316af70a850315f9$var$autoAnnotations = [
    $316af70a850315f9$var$autoAnnotation
];
function $316af70a850315f9$var$getAutoAnnotation(options) {
    var _autoAnnotations$idx;
    const deep = options.deep !== false;
    const autoBind = !!options.autoBind;
    const idx = (deep ? 0 : 1) | (autoBind ? 2 : 0);
    return (_autoAnnotations$idx = $316af70a850315f9$var$autoAnnotations[idx]) != null ? _autoAnnotations$idx : $316af70a850315f9$var$autoAnnotations[idx] = $316af70a850315f9$var$createAutoAnnotation({
        deep: deep,
        autoBind: autoBind
    });
}
function $316af70a850315f9$var$make_$1(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return $316af70a850315f9$export$2983e091f1a1e8e2.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        const set = $316af70a850315f9$export$b956e38827fca970(descriptor.set) ? descriptor.set // See #4553
         : $316af70a850315f9$var$createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: $316af70a850315f9$var$globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        $316af70a850315f9$var$defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if ($316af70a850315f9$var$isGenerator(descriptor.value)) {
            var _this$options_;
            const flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? $316af70a850315f9$export$d41c06fa934cc67e : $316af70a850315f9$export$ccc7b0636abaffc3;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        const actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? $316af70a850315f9$export$4dd0b06162f181e : $316af70a850315f9$export$b8aa795084cbf86b;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    let observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? $316af70a850315f9$export$431518ad42ffb7bd : $316af70a850315f9$export$5ab46cbf6120b33a;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function $316af70a850315f9$var$extend_(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return $316af70a850315f9$export$2983e091f1a1e8e2.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: $316af70a850315f9$var$globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: $316af70a850315f9$var$createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    let observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? $316af70a850315f9$export$431518ad42ffb7bd : $316af70a850315f9$export$5ab46cbf6120b33a;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function $316af70a850315f9$var$createDecoratorAnnotation(annotation, decorate) {
    return $316af70a850315f9$var$assign(function decoratorAnnotation(value, context) {
        if (context && typeof context.kind === "string") return decorate(annotation, value, context);
        if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$die(`Invalid arguments for \`${annotation.annotationType_}\``);
        return undefined;
    }, annotation);
}
const $316af70a850315f9$var$OBSERVABLE = "observable";
const $316af70a850315f9$var$OBSERVABLE_REF = "observableRef";
const $316af70a850315f9$var$OBSERVABLE_SHALLOW = "observableShallow";
const $316af70a850315f9$var$OBSERVABLE_STRUCT = "observableStruct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
const $316af70a850315f9$var$defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined
};
Object.freeze($316af70a850315f9$var$defaultCreateObservableOptions);
function $316af70a850315f9$var$asCreateObservableOptions(thing) {
    return thing || $316af70a850315f9$var$defaultCreateObservableOptions;
}
const $316af70a850315f9$var$observableAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createObservableAnnotation($316af70a850315f9$var$OBSERVABLE);
const $316af70a850315f9$var$observableRefAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createObservableAnnotation($316af70a850315f9$var$OBSERVABLE_REF, {
    enhancer_: $316af70a850315f9$var$referenceEnhancer
});
const $316af70a850315f9$var$observableShallowAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createObservableAnnotation($316af70a850315f9$var$OBSERVABLE_SHALLOW, {
    enhancer_: $316af70a850315f9$var$shallowEnhancer
});
const $316af70a850315f9$var$observableStructAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createObservableAnnotation($316af70a850315f9$var$OBSERVABLE_STRUCT, {
    enhancer_: $316af70a850315f9$var$refStructEnhancer
});
function $316af70a850315f9$var$createObservableDecoratorAnnotation(annotation) {
    return $316af70a850315f9$var$createDecoratorAnnotation(annotation, $316af70a850315f9$var$decorateObservable20223_);
}
function $316af70a850315f9$var$getEnhancerFromOptions(options) {
    return options.deep === true ? $316af70a850315f9$var$deepEnhancer : options.deep === false ? $316af70a850315f9$var$referenceEnhancer : $316af70a850315f9$var$getEnhancerFromAnnotation(options.defaultDecorator);
}
function $316af70a850315f9$var$getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : $316af70a850315f9$var$getAutoAnnotation(options) : undefined;
}
function $316af70a850315f9$var$getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? $316af70a850315f9$var$deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer_) != null ? _annotation$options_$ : $316af70a850315f9$var$deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function $316af70a850315f9$var$createObservable(v, arg2, arg3) {
    if (arg2 && typeof arg2.kind === "string") return $316af70a850315f9$var$decorateObservable20223_($316af70a850315f9$var$observableAnnotation, v, arg2);
    // already observable - ignore
    if ($316af70a850315f9$export$5cd057a6046189f9(v)) return v;
    // plain object
    if ($316af70a850315f9$var$isPlainObject(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.array(v, arg2);
    // Map
    if ($316af70a850315f9$var$isES6Map(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.map(v, arg2);
    // Set
    if ($316af70a850315f9$var$isES6Set(v)) return $316af70a850315f9$export$5ab46cbf6120b33a.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return $316af70a850315f9$export$5ab46cbf6120b33a.box(v, arg2);
}
const $316af70a850315f9$var$observableFactories = {
    box (value, options) {
        const o = $316af70a850315f9$var$asCreateObservableOptions(options);
        return new $316af70a850315f9$var$ObservableValue(value, $316af70a850315f9$var$getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array (initialValues, options) {
        const o = $316af70a850315f9$var$asCreateObservableOptions(options);
        return $316af70a850315f9$var$createObservableArray(initialValues, $316af70a850315f9$var$getEnhancerFromOptions(o), o.name);
    },
    map (initialValues, options) {
        const o = $316af70a850315f9$var$asCreateObservableOptions(options);
        return new $316af70a850315f9$export$db1c0901f08fc6fd(initialValues, $316af70a850315f9$var$getEnhancerFromOptions(o), o.name);
    },
    set (initialValues, options) {
        const o = $316af70a850315f9$var$asCreateObservableOptions(options);
        return new $316af70a850315f9$export$2235f602a7a77c81(initialValues, $316af70a850315f9$var$getEnhancerFromOptions(o), o.name);
    },
    object (props, annotations, options) {
        return $316af70a850315f9$var$initObservable(()=>$316af70a850315f9$export$59d8134e963031bd($316af70a850315f9$var$asDynamicObservableObject({}, options), props, annotations));
    }
};
const $316af70a850315f9$export$431518ad42ffb7bd = /*#__PURE__*/ $316af70a850315f9$var$createObservableDecoratorAnnotation($316af70a850315f9$var$observableRefAnnotation);
const $316af70a850315f9$export$d618cc4ca9414c13 = /*#__PURE__*/ $316af70a850315f9$var$createObservableDecoratorAnnotation($316af70a850315f9$var$observableShallowAnnotation);
const $316af70a850315f9$export$36408c859af67d57 = /*#__PURE__*/ $316af70a850315f9$var$createObservableDecoratorAnnotation($316af70a850315f9$var$observableAnnotation);
const $316af70a850315f9$export$716593212ba381a0 = /*#__PURE__*/ $316af70a850315f9$var$createObservableDecoratorAnnotation($316af70a850315f9$var$observableStructAnnotation);
// eslint-disable-next-line
var $316af70a850315f9$export$5ab46cbf6120b33a = /*#__PURE__*/ $316af70a850315f9$var$assign($316af70a850315f9$var$createObservable, $316af70a850315f9$var$observableAnnotation, $316af70a850315f9$var$observableFactories);
const $316af70a850315f9$var$COMPUTED = "computed";
const $316af70a850315f9$var$COMPUTED_STRUCT = "computedStruct";
function $316af70a850315f9$var$createComputedDecoratorAnnotation(annotation) {
    return $316af70a850315f9$var$createDecoratorAnnotation(annotation, $316af70a850315f9$var$decorateComputed20223_);
}
const $316af70a850315f9$var$computedAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createComputedAnnotation($316af70a850315f9$var$COMPUTED);
const $316af70a850315f9$var$computedStructAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createComputedAnnotation($316af70a850315f9$var$COMPUTED_STRUCT, {
    equals: $316af70a850315f9$export$8a67fbe40c3dd8c1
});
const $316af70a850315f9$export$356bab705a4abec5 = /*#__PURE__*/ $316af70a850315f9$var$createComputedDecoratorAnnotation($316af70a850315f9$var$computedStructAnnotation);
const $316af70a850315f9$export$2983e091f1a1e8e2 = function computed(arg1, arg2) {
    if (arg2 && typeof arg2.kind === "string") return $316af70a850315f9$var$decorateComputed20223_($316af70a850315f9$var$computedAnnotation, arg1, arg2);
    if ($316af70a850315f9$var$isPlainObject(arg1)) // computed annotation with options
    return $316af70a850315f9$var$createComputedDecoratorAnnotation($316af70a850315f9$var$createComputedAnnotation($316af70a850315f9$var$COMPUTED, arg1));
    // computed(expr, options?)
    if ($316af70a850315f9$var$__MOBX_DEV__) {
        if (!$316af70a850315f9$var$isFunction(arg1)) $316af70a850315f9$var$die("First argument to `computed` should be an expression.");
        if ($316af70a850315f9$var$isFunction(arg2)) $316af70a850315f9$var$die("A setter as second argument is no longer supported, use `{ set: fn }` option instead");
    }
    const opts = $316af70a850315f9$var$isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new $316af70a850315f9$var$ComputedValue(opts);
};
$316af70a850315f9$var$assign($316af70a850315f9$export$2983e091f1a1e8e2, $316af70a850315f9$var$computedAnnotation);
var $316af70a850315f9$var$_getDescriptor$config, $316af70a850315f9$var$_getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
let $316af70a850315f9$var$currentActionId = 0;
let $316af70a850315f9$var$nextActionId = 1;
const $316af70a850315f9$var$isFunctionNameConfigurable = ($316af70a850315f9$var$_getDescriptor$config = ($316af70a850315f9$var$_getDescriptor = /*#__PURE__*/ $316af70a850315f9$var$getDescriptor(()=>{}, "name")) == null ? void 0 : $316af70a850315f9$var$_getDescriptor.configurable) != null ? $316af70a850315f9$var$_getDescriptor$config : false;
// we can safely recycle this object
const $316af70a850315f9$var$tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function $316af70a850315f9$var$createAction(actionName, fn, autoAction = false, ref) {
    if ($316af70a850315f9$var$__MOBX_DEV__) {
        if (!$316af70a850315f9$var$isFunction(fn)) $316af70a850315f9$var$die("`action` can only be invoked on functions");
        if (typeof actionName !== "string" || !actionName) $316af70a850315f9$var$die(`actions should have valid names, got: '${actionName}'`);
    }
    function res() {
        return $316af70a850315f9$var$executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = ()=>fn.toString();
    if ($316af70a850315f9$var$isFunctionNameConfigurable) {
        $316af70a850315f9$var$tmpNameDescriptor.value = actionName;
        $316af70a850315f9$var$defineProperty(res, "name", $316af70a850315f9$var$tmpNameDescriptor);
    }
    return res;
}
function $316af70a850315f9$var$executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    const runInfo = $316af70a850315f9$export$42f76bef54cf1cd3(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        $316af70a850315f9$export$9d569d1d4d631c2d(runInfo);
    }
}
function $316af70a850315f9$export$42f76bef54cf1cd3(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    const notifySpy_ = $316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled() && !!actionName;
    let startTime_ = 0;
    if (notifySpy_) {
        startTime_ = Date.now();
        const flattenedArgs = args ? Array.from(args) : $316af70a850315f9$var$EMPTY_ARRAY;
        $316af70a850315f9$var$spyReportStart({
            type: $316af70a850315f9$var$ACTION,
            name: actionName,
            object: scope,
            arguments: flattenedArgs
        });
    }
    const prevDerivation_ = $316af70a850315f9$var$globalState.trackingDerivation;
    const runAsAction = !canRunAsDerivation || !prevDerivation_;
    $316af70a850315f9$var$startBatch();
    let prevAllowStateChanges_ = $316af70a850315f9$var$globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        $316af70a850315f9$var$untrackedStart();
        if ($316af70a850315f9$var$__MOBX_DEV__) prevAllowStateChanges_ = $316af70a850315f9$var$allowStateChangesStart(true);
    }
    const prevAllowStateReads_ = $316af70a850315f9$var$globalState.allowStateReads;
    if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$export$84c93b6404d77e6f(true);
    const runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: $316af70a850315f9$var$nextActionId++,
        parentActionId_: $316af70a850315f9$var$currentActionId
    };
    $316af70a850315f9$var$currentActionId = runInfo.actionId_;
    return runInfo;
}
function $316af70a850315f9$export$9d569d1d4d631c2d(runInfo) {
    if ($316af70a850315f9$var$currentActionId !== runInfo.actionId_) $316af70a850315f9$var$die(30);
    $316af70a850315f9$var$currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) $316af70a850315f9$var$globalState.suppressReactionErrors = true;
    if ($316af70a850315f9$var$__MOBX_DEV__) {
        $316af70a850315f9$var$allowStateChangesEnd(runInfo.prevAllowStateChanges_);
        $316af70a850315f9$export$c7b7fb1b2b410642(runInfo.prevAllowStateReads_);
    }
    $316af70a850315f9$var$endBatch();
    if (runInfo.runAsAction_) $316af70a850315f9$var$untrackedEnd(runInfo.prevDerivation_);
    if ($316af70a850315f9$var$__MOBX_DEV__ && runInfo.notifySpy_) $316af70a850315f9$var$spyReportEnd({
        time: Date.now() - runInfo.startTime_
    });
    $316af70a850315f9$var$globalState.suppressReactionErrors = false;
}
function $316af70a850315f9$export$e510c5d1ea4358b1(allowStateChanges, func) {
    const prev = $316af70a850315f9$var$allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        $316af70a850315f9$var$allowStateChangesEnd(prev);
    }
}
function $316af70a850315f9$var$allowStateChangesStart(allowStateChanges) {
    const prev = $316af70a850315f9$var$globalState.allowStateChanges;
    $316af70a850315f9$var$globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function $316af70a850315f9$var$allowStateChangesEnd(prev) {
    $316af70a850315f9$var$globalState.allowStateChanges = prev;
}
const $316af70a850315f9$var$CREATE = "create";
class $316af70a850315f9$var$ObservableValue extends $316af70a850315f9$var$Atom {
    constructor(value, enhancer_, name_ = $316af70a850315f9$var$__MOBX_DEV__ ? "ObservableValue@" + $316af70a850315f9$var$getNextId() : "ObservableValue", notifySpy = true, equals_ = $316af70a850315f9$export$700812e5ccfdbb1d){
        super(name_);
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this.equals_ = void 0;
        this.hasUnreportedChange_ = false;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.value_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        this.equals_ = equals_;
        this.value_ = enhancer_(value, undefined, name_);
        if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy && $316af70a850315f9$var$isSpyEnabled()) // only notify spy if this is a stand-alone observable
        $316af70a850315f9$var$spyReport({
            type: $316af70a850315f9$var$CREATE,
            object: this,
            observableKind: "value",
            debugObjectName: this.name_,
            newValue: this.value_
        });
    }
    dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    set(newValue) {
        const oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== $316af70a850315f9$var$globalState.UNCHANGED) {
            const notifySpy = $316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled();
            if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportStart({
                type: $316af70a850315f9$var$UPDATE,
                object: this,
                observableKind: "value",
                debugObjectName: this.name_,
                newValue: newValue,
                oldValue: oldValue
            });
            this.setNewValue_(newValue);
            if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportEnd();
        }
    }
    prepareNewValue_(newValue) {
        $316af70a850315f9$var$checkIfStateModificationsAreAllowed(this);
        if ($316af70a850315f9$var$hasInterceptors(this)) {
            const change = $316af70a850315f9$var$interceptChange(this, {
                object: this,
                type: $316af70a850315f9$var$UPDATE,
                newValue: newValue
            });
            if (!change) return $316af70a850315f9$var$globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer_(newValue, this.value_, this.name_);
        return this.equals_(this.value_, newValue) ? $316af70a850315f9$var$globalState.UNCHANGED : newValue;
    }
    setNewValue_(newValue) {
        const oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if ($316af70a850315f9$var$hasListeners(this)) $316af70a850315f9$var$notifyListeners(this, {
            observableKind: "value",
            debugObjectName: this.name_,
            type: $316af70a850315f9$var$UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    }
    get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    }
    raw() {
        // used by MST ot get undehanced value
        return this.value_;
    }
    toJSON() {
        return this.get();
    }
    toString() {
        return `${this.name_}[${this.value_}]`;
    }
    valueOf() {
        return $316af70a850315f9$var$toPrimitive(this.get());
    }
    [Symbol.toPrimitive]() {
        return this.valueOf();
    }
}
const $316af70a850315f9$export$fafbc00dbefd1aef = /*#__PURE__*/ $316af70a850315f9$var$createInstanceofPredicate("ObservableValue", $316af70a850315f9$var$ObservableValue);
class $316af70a850315f9$var$ComputedValue {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function used to determine if a newly produced
   * value differs from the previous value. Structural comparison can be convenient if you always
   * produce a new aggregated object and don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ constructor(options){
        this.dependenciesState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        // Lazily allocated on first observer - see Atom.observers_.
        this.observers_ = null;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
        this.unboundDepsCount_ = 0;
        this.value_ = new $316af70a850315f9$var$CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) $316af70a850315f9$var$die(31);
        this.derivation = options.get;
        this.name_ = options.name || ($316af70a850315f9$var$__MOBX_DEV__ ? "ComputedValue@" + $316af70a850315f9$var$getNextId() : "ComputedValue");
        if (options.set) this.setter_ = $316af70a850315f9$var$createAction($316af70a850315f9$var$__MOBX_DEV__ ? this.name_ + "-setter" : "ComputedValue-setter", options.set);
        this.equals_ = options.equals || $316af70a850315f9$export$700812e5ccfdbb1d;
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    onBecomeStale_() {
        $316af70a850315f9$var$propagateMaybeChanged(this);
    }
    onBO() {
        if (this.onBOL) this.onBOL.forEach((listener)=>listener());
    }
    onBUO() {
        if (this.onBUOL) this.onBUOL.forEach((listener)=>listener());
    }
    // to check for cycles
    get isComputing() {
        return $316af70a850315f9$var$getFlag(this.flags_, 1 /* ComputedValueFlags.isComputing */ );
    }
    set isComputing(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 1 /* ComputedValueFlags.isComputing */ , newValue);
    }
    get isRunningSetter() {
        return $316af70a850315f9$var$getFlag(this.flags_, 2 /* ComputedValueFlags.isRunningSetter */ );
    }
    set isRunningSetter(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 2 /* ComputedValueFlags.isRunningSetter */ , newValue);
    }
    get isBeingObserved() {
        return $316af70a850315f9$var$getFlag(this.flags_, 4 /* ComputedValueFlags.isBeingObserved */ );
    }
    set isBeingObserved(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 4 /* ComputedValueFlags.isBeingObserved */ , newValue);
    }
    get isPendingUnobservation() {
        return $316af70a850315f9$var$getFlag(this.flags_, 8 /* ComputedValueFlags.isPendingUnobservation */ );
    }
    set isPendingUnobservation(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 8 /* ComputedValueFlags.isPendingUnobservation */ , newValue);
    }
    get diffValue() {
        return $316af70a850315f9$var$getFlag(this.flags_, 16 /* ComputedValueFlags.diffValue */ ) ? 1 : 0;
    }
    set diffValue(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 16 /* ComputedValueFlags.diffValue */ , newValue === 1 ? true : false);
    }
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ get() {
        if (this.isComputing) $316af70a850315f9$var$die(32, this.name_, this.derivation);
        if ($316af70a850315f9$var$globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        (!this.observers_ || this.observers_.size === 0) && !this.keepAlive_) {
            if ($316af70a850315f9$var$shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                $316af70a850315f9$var$startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                $316af70a850315f9$var$endBatch();
            }
        } else {
            const wasBeingObserved = this.isBeingObserved;
            $316af70a850315f9$var$reportObserved(this);
            if ($316af70a850315f9$var$shouldCompute(this)) {
                let prevTrackingContext = $316af70a850315f9$var$globalState.trackingContext;
                if (!prevTrackingContext && (this.keepAlive_ || this.isBeingObserved)) // An observed or keep-alive computed can be recomputed by an untracked
                // read, for example from inside an action. Its dependencies are still
                // transitively observed and must fire their lifecycle hooks
                $316af70a850315f9$var$globalState.trackingContext = this;
                if (this.trackAndCompute()) $316af70a850315f9$var$propagateChangeConfirmed(this);
                $316af70a850315f9$var$globalState.trackingContext = prevTrackingContext;
            } else if (!wasBeingObserved && this.isBeingObserved) // We just became observed while serving a cached value, so the getter
            // won't run and won't re-report our dependencies. Cascade to them. #4547
            this.observing_.forEach($316af70a850315f9$var$markObserved);
        }
        const result = this.value_;
        if ($316af70a850315f9$var$isCaughtException(result)) throw result.cause;
        return result;
    }
    set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) $316af70a850315f9$var$die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else $316af70a850315f9$var$die(34, this.name_);
    }
    trackAndCompute() {
        // N.B: unminified as it is used by MST
        const oldValue = this.value_;
        const wasSuspended = /* see #1208 */ this.dependenciesState_ === -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        const newValue = this.computeValue_(true);
        const changed = wasSuspended || $316af70a850315f9$var$isCaughtException(oldValue) || $316af70a850315f9$var$isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) {
            this.value_ = newValue;
            if ($316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled()) $316af70a850315f9$var$spyReport({
                observableKind: "computed",
                debugObjectName: this.name_,
                object: this.scope_,
                type: "update",
                oldValue: oldValue,
                newValue: newValue
            });
        }
        return changed;
    }
    computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        const prev = $316af70a850315f9$var$__MOBX_DEV__ ? $316af70a850315f9$var$allowStateChangesStart(false) : false;
        let res;
        if (track) res = $316af70a850315f9$var$trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if ($316af70a850315f9$var$globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new $316af70a850315f9$var$CaughtException(e);
            }
        }
        if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    }
    suspend_() {
        if (!this.keepAlive_) {
            $316af70a850315f9$var$clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    }
    warnAboutUntrackedRead_() {
        if (!$316af70a850315f9$var$__MOBX_DEV__) return;
        if (typeof this.requiresReaction_ === "boolean" ? this.requiresReaction_ : $316af70a850315f9$var$globalState.computedRequiresReaction) console.warn(`[mobx] Computed value '${this.name_}' is being read outside a reactive context. Doing a full recompute.`);
    }
    toString() {
        return `${this.name_}[${this.derivation.toString()}]`;
    }
    valueOf() {
        return $316af70a850315f9$var$toPrimitive(this.get());
    }
    [Symbol.toPrimitive]() {
        return this.valueOf();
    }
}
const $316af70a850315f9$var$isComputedValue = /*#__PURE__*/ $316af70a850315f9$var$createInstanceofPredicate("ComputedValue", $316af70a850315f9$var$ComputedValue);
class $316af70a850315f9$var$CaughtException {
    constructor(cause){
        this.cause = void 0;
        this.cause = cause;
    // Empty
    }
}
function $316af70a850315f9$var$isCaughtException(e) {
    return e instanceof $316af70a850315f9$var$CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function $316af70a850315f9$var$shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case 0 /* IDerivationState_.UP_TO_DATE_ */ :
            return false;
        case -1 /* IDerivationState_.NOT_TRACKING_ */ :
        case 2 /* IDerivationState_.STALE_ */ :
            return true;
        case 1 /* IDerivationState_.POSSIBLY_STALE_ */ :
            {
                // state propagation can occur outside of action/reactive context #2195
                const prevAllowStateReads = $316af70a850315f9$var$__MOBX_DEV__ ? $316af70a850315f9$export$84c93b6404d77e6f(true) : true;
                const prevUntracked = $316af70a850315f9$var$untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
                const obs = derivation.observing_, l = obs.length;
                for(let i = 0; i < l; i++){
                    const obj = obs[i];
                    if ($316af70a850315f9$var$isComputedValue(obj)) {
                        if ($316af70a850315f9$var$globalState.disableErrorBoundaries) obj.get();
                        else try {
                            obj.get();
                        } catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            $316af70a850315f9$var$untrackedEnd(prevUntracked);
                            if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$export$c7b7fb1b2b410642(prevAllowStateReads);
                            return true;
                        }
                        // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                        // and `derivation` is an observer of `obj`
                        // invariantShouldCompute(derivation)
                        if (derivation.dependenciesState_ === 2 /* IDerivationState_.STALE_ */ ) {
                            $316af70a850315f9$var$untrackedEnd(prevUntracked);
                            if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$export$c7b7fb1b2b410642(prevAllowStateReads);
                            return true;
                        }
                    }
                }
                $316af70a850315f9$var$changeDependenciesStateTo0(derivation);
                $316af70a850315f9$var$untrackedEnd(prevUntracked);
                if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$export$c7b7fb1b2b410642(prevAllowStateReads);
                return false;
            }
    }
}
function $316af70a850315f9$export$34c53f8cb85e26c1() {
    return $316af70a850315f9$var$globalState.trackingDerivation !== null; // filter out actions inside computations
}
function $316af70a850315f9$var$checkIfStateModificationsAreAllowed(atom) {
    if (!$316af70a850315f9$var$__MOBX_DEV__) return;
    const hasObservers = !!atom.observers_ && atom.observers_.size > 0;
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!$316af70a850315f9$var$globalState.allowStateChanges && (hasObservers || $316af70a850315f9$var$globalState.enforceActions === "always")) console.warn("[MobX] " + ($316af70a850315f9$var$globalState.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + atom.name_);
}
function $316af70a850315f9$var$checkIfStateReadsAreAllowed(observable) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && !$316af70a850315f9$var$globalState.allowStateReads && $316af70a850315f9$var$globalState.observableRequiresReaction) console.warn(`[mobx] Observable '${observable.name_}' being read outside a reactive context.`);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function $316af70a850315f9$var$trackDerivedFunction(derivation, f, context) {
    const prevAllowStateReads = $316af70a850315f9$var$__MOBX_DEV__ ? $316af70a850315f9$export$84c93b6404d77e6f(true) : true;
    $316af70a850315f9$var$changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++$316af70a850315f9$var$globalState.runId;
    const prevTracking = $316af70a850315f9$var$globalState.trackingDerivation;
    $316af70a850315f9$var$globalState.trackingDerivation = derivation;
    $316af70a850315f9$var$globalState.inBatch++;
    let result;
    if ($316af70a850315f9$var$globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new $316af70a850315f9$var$CaughtException(e);
    }
    $316af70a850315f9$var$globalState.inBatch--;
    $316af70a850315f9$var$globalState.trackingDerivation = prevTracking;
    $316af70a850315f9$var$bindDependencies(derivation);
    $316af70a850315f9$var$warnAboutDerivationWithoutDependencies(derivation);
    if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$export$c7b7fb1b2b410642(prevAllowStateReads);
    return result;
}
function $316af70a850315f9$var$warnAboutDerivationWithoutDependencies(derivation) {
    if (!$316af70a850315f9$var$__MOBX_DEV__) return;
    if (derivation.observing_.length !== 0) return;
    if (typeof derivation.requiresObservable_ === "boolean" ? derivation.requiresObservable_ : $316af70a850315f9$var$globalState.reactionRequiresObservable) console.warn(`[mobx] Derivation '${derivation.name_}' is created/updated without reading any observable value.`);
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function $316af70a850315f9$var$bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    const prevObserving = derivation.observing_;
    const observing = derivation.observing_ = derivation.newObserving_;
    let lowestNewObservingDerivationState = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    let i0 = 0, l = derivation.unboundDepsCount_;
    for(let i = 0; i < l; i++){
        const dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        const dep = prevObserving[l];
        if (dep.diffValue === 0) $316af70a850315f9$var$removeObserver(dep, derivation);
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        const dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            $316af70a850315f9$var$addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== 0 /* IDerivationState_.UP_TO_DATE_ */ ) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function $316af70a850315f9$var$clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    const obs = derivation.observing_;
    derivation.observing_ = [];
    let i = obs.length;
    while(i--)$316af70a850315f9$var$removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
}
function $316af70a850315f9$export$8c437e4d572e2f99(action) {
    const prev = $316af70a850315f9$var$untrackedStart();
    try {
        return action();
    } finally{
        $316af70a850315f9$var$untrackedEnd(prev);
    }
}
function $316af70a850315f9$var$untrackedStart() {
    const prev = $316af70a850315f9$var$globalState.trackingDerivation;
    $316af70a850315f9$var$globalState.trackingDerivation = null;
    return prev;
}
function $316af70a850315f9$var$untrackedEnd(prev) {
    $316af70a850315f9$var$globalState.trackingDerivation = prev;
}
function $316af70a850315f9$export$84c93b6404d77e6f(allowStateReads) {
    const prev = $316af70a850315f9$var$globalState.allowStateReads;
    $316af70a850315f9$var$globalState.allowStateReads = allowStateReads;
    return prev;
}
function $316af70a850315f9$export$c7b7fb1b2b410642(prev) {
    $316af70a850315f9$var$globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function $316af70a850315f9$var$changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */ ) return;
    derivation.dependenciesState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
    const obs = derivation.observing_;
    let i = obs.length;
    while(i--)obs[i].lowestObserverState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
}
const $316af70a850315f9$var$MOBX_GLOBALS_VERSION = 7;
/**
 * These values will persist if global state is reset
 */ const $316af70a850315f9$var$persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED"
];
class $316af70a850315f9$var$MobXGlobals {
    constructor(){
        /**
     * MobXGlobals version.
     * MobX compatiblity with other versions loaded in memory as long as this version matches.
     * It indicates that the global state still stores similar information
     *
     * N.B: this version is unrelated to the package version of MobX, and is only the version of the
     * internal state storage of MobX, and can be the same across many different package versions
     */ this.version = $316af70a850315f9$var$MOBX_GLOBALS_VERSION;
        /**
     * globally unique token to signal unchanged
     */ this.UNCHANGED = {};
        /**
     * Currently running derivation
     */ this.trackingDerivation = null;
        /**
     * Currently running reaction. This determines if we currently have a reactive context.
     * (Tracking derivation is also set for temporal tracking of computed values inside actions,
     * but trackingReaction can only be set by a form of Reaction)
     */ this.trackingContext = null;
        /**
     * Each time a derivation is tracked, it is assigned a unique run-id
     */ this.runId = 0;
        /**
     * 'guid' for general purpose. Will be persisted amongst resets.
     */ this.mobxGuid = 0;
        /**
     * Are we in a batch block? (and how many of them)
     */ this.inBatch = 0;
        /**
     * Observables that don't have observers anymore, and are about to be
     * suspended, unless somebody else accesses it in the same batch
     *
     * @type {IObservable[]}
     */ this.pendingUnobservations = [];
        /**
     * List of scheduled, not yet executed, reactions.
     */ this.pendingReactions = [];
        /**
     * Are we currently processing reactions?
     */ this.isRunningReactions = false;
        /**
     * Are we currently draining pendingUnobservations in endBatch?
     * An onBecomeUnobserved handler can dispose a Reaction, which calls
     * startBatch/endBatch again; this guards against re-entering the same
     * drain loop recursively (see endBatch in observable.ts).
     */ this.isRunningUnobservations = false;
        /**
     * Is it allowed to change observables at this point?
     * In general, MobX doesn't allow that when running computations and React.render.
     * To ensure that those functions stay pure.
     */ this.allowStateChanges = false;
        /**
     * Is it allowed to read observables at this point?
     * Used to hold the state needed for `observableRequiresReaction`
     */ this.allowStateReads = true;
        /**
     * If strict mode is enabled, state changes are by default not allowed
     */ this.enforceActions = true;
        /**
     * Spy callbacks
     */ this.spyListeners = [];
        /**
     * Globally attached error handlers that react specifically to errors in reactions
     */ this.globalReactionErrorHandlers = [];
        /**
     * Warn if computed values are accessed outside a reactive context
     */ this.computedRequiresReaction = false;
        /**
     * (Experimental)
     * Warn if you try to create to derivation / reactive context without accessing any observable.
     */ this.reactionRequiresObservable = false;
        /**
     * (Experimental)
     * Warn if observables are accessed outside a reactive context
     */ this.observableRequiresReaction = false;
        /*
     * Don't catch and rethrow exceptions. This is useful for inspecting the state of
     * the stack when an exception occurs while debugging.
     */ this.disableErrorBoundaries = false;
        /*
     * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
     * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
     */ this.suppressReactionErrors = false;
        /**
     * False forces all object's descriptors to
     * writable: true
     * configurable: true
     */ this.safeDescriptors = true;
    }
}
let $316af70a850315f9$var$canMergeGlobalState = true;
let $316af70a850315f9$var$isolateCalled = false;
let $316af70a850315f9$var$globalState = /*#__PURE__*/ function() {
    let global = globalThis;
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals) $316af70a850315f9$var$canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== $316af70a850315f9$var$MOBX_GLOBALS_VERSION) $316af70a850315f9$var$canMergeGlobalState = false;
    if (!$316af70a850315f9$var$canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(()=>{
            if (!$316af70a850315f9$var$isolateCalled) $316af70a850315f9$var$die(35);
        }, 1);
        return new $316af70a850315f9$var$MobXGlobals();
    } else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        if (!global.__mobxGlobals.UNCHANGED) global.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global.__mobxGlobals;
    } else {
        global.__mobxInstanceCount = 1;
        return global.__mobxGlobals = /*#__PURE__*/ new $316af70a850315f9$var$MobXGlobals();
    }
}();
function $316af70a850315f9$var$isolateGlobalState() {
    if ($316af70a850315f9$var$globalState.pendingReactions.length || $316af70a850315f9$var$globalState.inBatch || $316af70a850315f9$var$globalState.isRunningReactions) $316af70a850315f9$var$die(36);
    $316af70a850315f9$var$isolateCalled = true;
    if ($316af70a850315f9$var$canMergeGlobalState) {
        let global = globalThis;
        if (--global.__mobxInstanceCount === 0) global.__mobxGlobals = undefined;
        $316af70a850315f9$var$globalState = new $316af70a850315f9$var$MobXGlobals();
    }
}
function $316af70a850315f9$export$c78907783e606401() {
    return $316af70a850315f9$var$globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function $316af70a850315f9$export$5c18e491c80b9ab4() {
    const defaultGlobals = new $316af70a850315f9$var$MobXGlobals();
    for(let key in defaultGlobals)if ($316af70a850315f9$var$persistentKeys.indexOf(key) === -1) $316af70a850315f9$var$globalState[key] = defaultGlobals[key];
    $316af70a850315f9$var$globalState.allowStateChanges = !$316af70a850315f9$var$globalState.enforceActions;
}
function $316af70a850315f9$var$hasObservers(observable) {
    return !!observable.observers_ && observable.observers_.size > 0;
}
function $316af70a850315f9$var$getObservers(observable) {
    var _observable$observers;
    return (_observable$observers = observable.observers_) != null ? _observable$observers : new Set();
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function $316af70a850315f9$var$addObserver(observable, node) {
    var _observable$observers2;
    ((_observable$observers2 = observable.observers_) != null ? _observable$observers2 : observable.observers_ = new Set()).add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function $316af70a850315f9$var$removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    const observers = observable.observers_;
    if (!observers) return;
    observers.delete(node);
    if (observers.size === 0) // deleting last observer
    $316af70a850315f9$var$queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function $316af70a850315f9$var$queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        $316af70a850315f9$var$globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function $316af70a850315f9$var$startBatch() {
    $316af70a850315f9$var$globalState.inBatch++;
}
function $316af70a850315f9$var$endBatch() {
    if (--$316af70a850315f9$var$globalState.inBatch === 0) {
        $316af70a850315f9$var$runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        // Guard against re-entering this loop: an onBUO handler can dispose a Reaction,
        // which calls startBatch/endBatch again while we're still iterating. Bail out of
        // the nested call instead of recursing; the outer loop re-reads list.length on
        // every iteration, so it picks up anything the nested dispose() pushes onto the
        // same pendingUnobservations array.
        if (!$316af70a850315f9$var$globalState.isRunningUnobservations && $316af70a850315f9$var$globalState.pendingUnobservations.length > 0) $316af70a850315f9$var$runPendingUnobservations();
    }
}
// Only called when there is something to unobserve, so the common endBatch() skips the
// try/finally and the pendingUnobservations reallocation entirely
function $316af70a850315f9$var$runPendingUnobservations() {
    $316af70a850315f9$var$globalState.isRunningUnobservations = true;
    try {
        const list = $316af70a850315f9$var$globalState.pendingUnobservations;
        for(let i = 0; i < list.length; i++){
            const observable = list[i];
            observable.isPendingUnobservation = false;
            if (!observable.observers_ || observable.observers_.size === 0) {
                // release the empty Set so unobserved atoms don't keep paying for it
                observable.observers_ = null;
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof $316af70a850315f9$var$ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        $316af70a850315f9$var$globalState.pendingUnobservations = [];
    } finally{
        // Always release the guard, even if an onBUO handler (user code) threw,
        // otherwise every future endBatch() would see isRunningUnobservations
        // stuck true and silently stop draining pendingUnobservations forever.
        $316af70a850315f9$var$globalState.isRunningUnobservations = false;
    }
}
/**
 * Marks an observable as observed, cascading into the dependencies of a ComputedValue.
 * Unobservation already cascades (`suspend_` -> `clearObserving`), observation normally
 * only does so by accident: a newly observed computed usually recomputes and re-reports
 * its dependencies. When it serves a cached value instead nothing re-reports them, so the
 * transition has to be propagated by hand. See #4547.
 */ function $316af70a850315f9$var$markObserved(observable) {
    var _observable$observing;
    if (observable.isBeingObserved) return;
    observable.isBeingObserved = true;
    observable.onBO();
    // No queueForUnobservation here: the observer links already exist, so the regular
    // suspend_ -> clearObserving -> removeObserver teardown still delivers the onBUO.
    (_observable$observing = observable.observing_) == null || _observable$observing.forEach($316af70a850315f9$var$markObserved);
}
function $316af70a850315f9$var$reportObserved(observable) {
    $316af70a850315f9$var$checkIfStateReadsAreAllowed(observable);
    const derivation = $316af70a850315f9$var$globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && $316af70a850315f9$var$globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if ((!observable.observers_ || observable.observers_.size === 0) && $316af70a850315f9$var$globalState.inBatch > 0) $316af70a850315f9$var$queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function $316af70a850315f9$var$propagateChanged(observable) {
    var _observable$observers3;
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === 2 /* IDerivationState_.STALE_ */ ) return;
    observable.lowestObserverState_ = 2 /* IDerivationState_.STALE_ */ ;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    (_observable$observers3 = observable.observers_) == null || _observable$observers3.forEach((d)=>{
        if (d.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */ ) d.onBecomeStale_();
        d.dependenciesState_ = 2 /* IDerivationState_.STALE_ */ ;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function $316af70a850315f9$var$propagateChangeConfirmed(observable) {
    var _observable$observers4;
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === 2 /* IDerivationState_.STALE_ */ ) return;
    observable.lowestObserverState_ = 2 /* IDerivationState_.STALE_ */ ;
    (_observable$observers4 = observable.observers_) == null || _observable$observers4.forEach((d)=>{
        if (d.dependenciesState_ === 1 /* IDerivationState_.POSSIBLY_STALE_ */ ) d.dependenciesState_ = 2 /* IDerivationState_.STALE_ */ ;
        else if (d.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */  // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = 0 /* IDerivationState_.UP_TO_DATE_ */ ;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function $316af70a850315f9$var$propagateMaybeChanged(observable) {
    var _observable$observers5;
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== 0 /* IDerivationState_.UP_TO_DATE_ */ ) return;
    observable.lowestObserverState_ = 1 /* IDerivationState_.POSSIBLY_STALE_ */ ;
    (_observable$observers5 = observable.observers_) == null || _observable$observers5.forEach((d)=>{
        if (d.dependenciesState_ === 0 /* IDerivationState_.UP_TO_DATE_ */ ) {
            d.dependenciesState_ = 1 /* IDerivationState_.POSSIBLY_STALE_ */ ;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
class $316af70a850315f9$export$d2ae4167a30cf6bb {
    constructor(name_ = $316af70a850315f9$var$__MOBX_DEV__ ? "Reaction@" + $316af70a850315f9$var$getNextId() : "Reaction", onInvalidate_, errorHandler_, requiresObservable_){
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = -1 /* IDerivationState_.NOT_TRACKING_ */ ;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.removeAbortListener_ = undefined;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    get isDisposed() {
        return $316af70a850315f9$var$getFlag(this.flags_, 1 /* ReactionFlags.isDisposed */ );
    }
    set isDisposed(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 1 /* ReactionFlags.isDisposed */ , newValue);
    }
    get isScheduled() {
        return $316af70a850315f9$var$getFlag(this.flags_, 2 /* ReactionFlags.isScheduled */ );
    }
    set isScheduled(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 2 /* ReactionFlags.isScheduled */ , newValue);
    }
    get isTrackPending() {
        return $316af70a850315f9$var$getFlag(this.flags_, 4 /* ReactionFlags.isTrackPending */ );
    }
    set isTrackPending(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 4 /* ReactionFlags.isTrackPending */ , newValue);
    }
    get isRunning() {
        return $316af70a850315f9$var$getFlag(this.flags_, 8 /* ReactionFlags.isRunning */ );
    }
    set isRunning(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 8 /* ReactionFlags.isRunning */ , newValue);
    }
    get diffValue() {
        return $316af70a850315f9$var$getFlag(this.flags_, 16 /* ReactionFlags.diffValue */ ) ? 1 : 0;
    }
    set diffValue(newValue) {
        this.flags_ = $316af70a850315f9$var$setFlag(this.flags_, 16 /* ReactionFlags.diffValue */ , newValue === 1 ? true : false);
    }
    onBecomeStale_() {
        this.schedule_();
    }
    schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            $316af70a850315f9$var$globalState.pendingReactions.push(this);
            $316af70a850315f9$var$runReactions();
        }
    }
    /**
   * internal, use schedule() if you intend to kick off a reaction
   */ runReaction_() {
        if (!this.isDisposed) {
            $316af70a850315f9$var$startBatch();
            this.isScheduled = false;
            const prev = $316af70a850315f9$var$globalState.trackingContext;
            $316af70a850315f9$var$globalState.trackingContext = this;
            if ($316af70a850315f9$var$shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                    if ($316af70a850315f9$var$__MOBX_DEV__ && this.isTrackPending && $316af70a850315f9$var$isSpyEnabled()) // onInvalidate didn't trigger track right away..
                    $316af70a850315f9$var$spyReport({
                        name: this.name_,
                        type: "scheduled-reaction"
                    });
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            $316af70a850315f9$var$globalState.trackingContext = prev;
            $316af70a850315f9$var$endBatch();
        }
    }
    track(fn) {
        if (this.isDisposed) return;
        $316af70a850315f9$var$startBatch();
        const notify = $316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled();
        let startTime;
        if ($316af70a850315f9$var$__MOBX_DEV__ && notify) {
            startTime = Date.now();
            $316af70a850315f9$var$spyReportStart({
                name: this.name_,
                type: "reaction"
            });
        }
        this.isRunning = true;
        const prevReaction = $316af70a850315f9$var$globalState.trackingContext; // reactions could create reactions...
        $316af70a850315f9$var$globalState.trackingContext = this;
        const result = $316af70a850315f9$var$trackDerivedFunction(this, fn, undefined);
        $316af70a850315f9$var$globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        $316af70a850315f9$var$clearObserving(this);
        if ($316af70a850315f9$var$isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        if ($316af70a850315f9$var$__MOBX_DEV__ && notify) $316af70a850315f9$var$spyReportEnd({
            time: Date.now() - startTime
        });
        $316af70a850315f9$var$endBatch();
    }
    reportExceptionInDerivation_(error) {
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if ($316af70a850315f9$var$globalState.disableErrorBoundaries) throw error;
        const message = $316af70a850315f9$var$__MOBX_DEV__ ? `[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '${this}'` : `[mobx] uncaught error in '${this}'`;
        if (!$316af70a850315f9$var$globalState.suppressReactionErrors) console.error(message, error);
        else if ($316af70a850315f9$var$__MOBX_DEV__) console.warn(`[mobx] (error in reaction '${this.name_}' suppressed, fix error of causing action below)`);
         // prettier-ignore
        if ($316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled()) $316af70a850315f9$var$spyReport({
            type: "error",
            name: this.name_,
            message: message,
            error: "" + error
        });
        $316af70a850315f9$var$globalState.globalReactionErrorHandlers.forEach((f)=>f(error, this));
    }
    dispose() {
        if (!this.isDisposed) {
            var _this$removeAbortList;
            this.isDisposed = true;
            // also covers self-disposal (`r.dispose()`, `when`), which bypasses the disposer
            (_this$removeAbortList = this.removeAbortListener_) == null || _this$removeAbortList.call(this);
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                $316af70a850315f9$var$startBatch();
                $316af70a850315f9$var$clearObserving(this);
                $316af70a850315f9$var$endBatch();
            }
        }
    }
    getDisposer_(abortSignal) {
        const dispose = ()=>this.dispose();
        if (abortSignal != null && abortSignal.addEventListener && !this.isDisposed) {
            abortSignal.addEventListener("abort", dispose);
            this.removeAbortListener_ = ()=>abortSignal.removeEventListener == null ? void 0 : abortSignal.removeEventListener("abort", dispose);
        }
        dispose[$316af70a850315f9$export$f246528900dd4467] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    }
    toString() {
        return `Reaction[${this.name_}]`;
    }
}
function $316af70a850315f9$export$d7203a53b5e117e4(handler) {
    $316af70a850315f9$var$globalState.globalReactionErrorHandlers.push(handler);
    return ()=>{
        const idx = $316af70a850315f9$var$globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) $316af70a850315f9$var$globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ const $316af70a850315f9$var$MAX_REACTION_ITERATIONS = 100;
let $316af70a850315f9$var$reactionScheduler = (f)=>f();
function $316af70a850315f9$var$runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if ($316af70a850315f9$var$globalState.inBatch > 0 || $316af70a850315f9$var$globalState.isRunningReactions) return;
    $316af70a850315f9$var$reactionScheduler($316af70a850315f9$var$runReactionsHelper);
}
function $316af70a850315f9$var$runReactionsHelper() {
    $316af70a850315f9$var$globalState.isRunningReactions = true;
    const allReactions = $316af70a850315f9$var$globalState.pendingReactions;
    let iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === $316af70a850315f9$var$MAX_REACTION_ITERATIONS) {
            console.error($316af70a850315f9$var$__MOBX_DEV__ ? `Reaction doesn't converge to a stable state after ${$316af70a850315f9$var$MAX_REACTION_ITERATIONS} iterations.` + ` Probably there is a cycle in the reactive function: ${allReactions[0]}` : `[mobx] cycle in reaction: ${allReactions[0]}`);
            allReactions.splice(0); // clear reactions
        }
        let remainingReactions = allReactions.splice(0);
        for(let i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    $316af70a850315f9$var$globalState.isRunningReactions = false;
}
const $316af70a850315f9$var$isReaction = /*#__PURE__*/ $316af70a850315f9$var$createInstanceofPredicate("Reaction", $316af70a850315f9$export$d2ae4167a30cf6bb);
function $316af70a850315f9$var$setReactionScheduler(fn) {
    const baseScheduler = $316af70a850315f9$var$reactionScheduler;
    $316af70a850315f9$var$reactionScheduler = (f)=>fn(()=>baseScheduler(f));
}
function $316af70a850315f9$var$isSpyEnabled() {
    return $316af70a850315f9$var$__MOBX_DEV__ && !!$316af70a850315f9$var$globalState.spyListeners.length;
}
function $316af70a850315f9$var$spyReport(event) {
    if (!$316af70a850315f9$var$__MOBX_DEV__) return;
     // dead code elimination can do the rest
    if (!$316af70a850315f9$var$globalState.spyListeners.length) return;
    const listeners = $316af70a850315f9$var$globalState.spyListeners;
    for(let i = 0, l = listeners.length; i < l; i++)listeners[i](event);
}
function $316af70a850315f9$var$spyReportStart(event) {
    if (!$316af70a850315f9$var$__MOBX_DEV__) return;
    const change = $316af70a850315f9$var$assign({}, event, {
        spyReportStart: true
    });
    $316af70a850315f9$var$spyReport(change);
}
const $316af70a850315f9$var$END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function $316af70a850315f9$var$spyReportEnd(change) {
    if (!$316af70a850315f9$var$__MOBX_DEV__) return;
    if (change) $316af70a850315f9$var$spyReport($316af70a850315f9$var$assign({}, change, {
        type: "report-end",
        spyReportEnd: true
    }));
    else $316af70a850315f9$var$spyReport($316af70a850315f9$var$END_EVENT);
}
function $316af70a850315f9$export$fcc0cd19e9fb2b4c(listener) {
    if (!$316af70a850315f9$var$__MOBX_DEV__) {
        console.warn(`[mobx.spy] Is a no-op in production builds`);
        return function() {};
    } else {
        $316af70a850315f9$var$globalState.spyListeners.push(listener);
        return $316af70a850315f9$var$once(()=>{
            $316af70a850315f9$var$globalState.spyListeners = $316af70a850315f9$var$globalState.spyListeners.filter((l)=>l !== listener);
        });
    }
}
const $316af70a850315f9$var$ACTION = "action";
const $316af70a850315f9$var$ACTION_BOUND = "actionBound";
const $316af70a850315f9$var$AUTOACTION = "autoAction";
const $316af70a850315f9$var$AUTOACTION_BOUND = "autoActionBound";
const $316af70a850315f9$var$DEFAULT_ACTION_NAME = "<unnamed action>";
const $316af70a850315f9$var$actionAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createActionAnnotation($316af70a850315f9$var$ACTION);
const $316af70a850315f9$var$actionBoundAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createActionAnnotation($316af70a850315f9$var$ACTION_BOUND, {
    bound: true
});
const $316af70a850315f9$var$autoActionAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createActionAnnotation($316af70a850315f9$var$AUTOACTION, {
    autoAction: true
});
const $316af70a850315f9$var$autoActionBoundAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createActionAnnotation($316af70a850315f9$var$AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function $316af70a850315f9$var$createActionDecoratorAnnotation(annotation) {
    return $316af70a850315f9$var$createDecoratorAnnotation(annotation, $316af70a850315f9$var$decorateAction20223_);
}
function $316af70a850315f9$var$createActionFactory(autoAction) {
    const res = function action(arg1, arg2) {
        if (arg2 && typeof arg2.kind === "string") return $316af70a850315f9$var$decorateAction20223_(autoAction ? $316af70a850315f9$var$autoActionAnnotation : $316af70a850315f9$var$actionAnnotation, arg1, arg2);
        // action(fn() {})
        if ($316af70a850315f9$var$isFunction(arg1)) return $316af70a850315f9$var$createAction(arg1.name || $316af70a850315f9$var$DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if ($316af70a850315f9$var$isFunction(arg2)) return $316af70a850315f9$var$createAction(arg1, arg2, autoAction);
        // action("name") annotation
        if ($316af70a850315f9$var$isStringish(arg1)) return $316af70a850315f9$var$createActionDecoratorAnnotation($316af70a850315f9$var$createActionAnnotation(autoAction ? $316af70a850315f9$var$AUTOACTION : $316af70a850315f9$var$ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
        if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$die("Invalid arguments for `action`");
    };
    return res;
}
const $316af70a850315f9$export$31eb53bd5b582a97 = /*#__PURE__*/ $316af70a850315f9$var$createActionFactory(false);
$316af70a850315f9$var$assign($316af70a850315f9$export$31eb53bd5b582a97, $316af70a850315f9$var$actionAnnotation);
const $316af70a850315f9$export$b8aa795084cbf86b = /*#__PURE__*/ $316af70a850315f9$var$createActionFactory(true);
$316af70a850315f9$var$assign($316af70a850315f9$export$b8aa795084cbf86b, $316af70a850315f9$var$autoActionAnnotation);
const $316af70a850315f9$export$3720eced4297d10c = /*#__PURE__*/ $316af70a850315f9$var$createActionDecoratorAnnotation($316af70a850315f9$var$actionBoundAnnotation);
const $316af70a850315f9$export$4dd0b06162f181e = /*#__PURE__*/ $316af70a850315f9$var$createActionDecoratorAnnotation($316af70a850315f9$var$autoActionBoundAnnotation);
function $316af70a850315f9$export$832370e58be26204(fn) {
    return $316af70a850315f9$var$executeAction(fn.name || $316af70a850315f9$var$DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function $316af70a850315f9$export$b956e38827fca970(thing) {
    return $316af70a850315f9$var$isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function $316af70a850315f9$export$4abd31caebb0bb24(view, opts = $316af70a850315f9$var$EMPTY_OBJECT) {
    var _opts$name, _opts$signal;
    if ($316af70a850315f9$var$__MOBX_DEV__) {
        if (!$316af70a850315f9$var$isFunction(view)) $316af70a850315f9$var$die("Autorun expects a function as first argument");
        if ($316af70a850315f9$export$b956e38827fca970(view)) $316af70a850315f9$var$die("Autorun does not accept actions since actions are untrackable");
    }
    const name = (_opts$name = opts == null ? void 0 : opts.name) != null ? _opts$name : $316af70a850315f9$var$__MOBX_DEV__ ? view.name || "Autorun@" + $316af70a850315f9$var$getNextId() : "Autorun";
    const runSync = !opts.scheduler && !opts.delay;
    let reaction;
    if (runSync) // normal autorun
    reaction = new $316af70a850315f9$export$d2ae4167a30cf6bb(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        const scheduler = $316af70a850315f9$var$createSchedulerFromOptions(opts);
        // debounced autorun
        let isScheduled = false;
        reaction = new $316af70a850315f9$export$d2ae4167a30cf6bb(name, ()=>{
            if (!isScheduled) {
                isScheduled = true;
                scheduler(()=>{
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!(opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted)) reaction.schedule_();
    return reaction.getDisposer_(opts == null ? void 0 : opts.signal);
}
const $316af70a850315f9$var$run = (f)=>f();
function $316af70a850315f9$var$createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? (f)=>setTimeout(f, opts.delay) : $316af70a850315f9$var$run;
}
function $316af70a850315f9$export$7203b476385689ae(expression, effect, opts = $316af70a850315f9$var$EMPTY_OBJECT) {
    var _opts$name2, _opts$signal2;
    if ($316af70a850315f9$var$__MOBX_DEV__) {
        if (!$316af70a850315f9$var$isFunction(expression) || !$316af70a850315f9$var$isFunction(effect)) $316af70a850315f9$var$die("First and second argument to reaction should be functions");
        if (!$316af70a850315f9$var$isPlainObject(opts)) $316af70a850315f9$var$die("Third argument of reactions should be an object");
    }
    const name = (_opts$name2 = opts.name) != null ? _opts$name2 : $316af70a850315f9$var$__MOBX_DEV__ ? "Reaction@" + $316af70a850315f9$var$getNextId() : "Reaction";
    const effectAction = $316af70a850315f9$export$31eb53bd5b582a97(name, opts.onError ? $316af70a850315f9$var$wrapErrorHandler(opts.onError, effect) : effect);
    const runSync = !opts.scheduler && !opts.delay;
    const scheduler = $316af70a850315f9$var$createSchedulerFromOptions(opts);
    let firstTime = true;
    let isScheduled = false;
    let value;
    const equals = opts.equals || $316af70a850315f9$export$700812e5ccfdbb1d;
    const r = new $316af70a850315f9$export$d2ae4167a30cf6bb(name, ()=>{
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        let changed = false;
        const oldValue = value;
        r.track(()=>{
            const nextValue = $316af70a850315f9$export$e510c5d1ea4358b1(false, ()=>expression(r));
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!(opts != null && (_opts$signal2 = opts.signal) != null && _opts$signal2.aborted)) r.schedule_();
    return r.getDisposer_(opts == null ? void 0 : opts.signal);
}
function $316af70a850315f9$var$wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
const $316af70a850315f9$var$ON_BECOME_OBSERVED = "onBO";
const $316af70a850315f9$var$ON_BECOME_UNOBSERVED = "onBUO";
function $316af70a850315f9$export$24d7f9cdf0de2679(thing, arg2, arg3) {
    return $316af70a850315f9$var$interceptHook($316af70a850315f9$var$ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function $316af70a850315f9$export$f8586f6f22b9cba9(thing, arg2, arg3) {
    return $316af70a850315f9$var$interceptHook($316af70a850315f9$var$ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function $316af70a850315f9$var$interceptHook(hook, thing, arg2, arg3) {
    const atom = typeof arg3 === "function" ? $316af70a850315f9$export$25fc416d10fa1afa(thing, arg2) : $316af70a850315f9$export$25fc416d10fa1afa(thing);
    const cb = $316af70a850315f9$var$isFunction(arg3) ? arg3 : arg2;
    const listenersKey = `${hook}L`;
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        const hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners.delete(cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
const $316af70a850315f9$var$ALWAYS = "always";
const $316af70a850315f9$var$OBSERVED = "observed";
function $316af70a850315f9$export$8d21e34596265fa2(options) {
    if (options.isolateGlobalState === true) $316af70a850315f9$var$isolateGlobalState();
    const { enforceActions: enforceActions } = options;
    if (enforceActions !== undefined) {
        const ea = enforceActions === $316af70a850315f9$var$ALWAYS ? $316af70a850315f9$var$ALWAYS : enforceActions === $316af70a850315f9$var$OBSERVED;
        $316af70a850315f9$var$globalState.enforceActions = ea;
        $316af70a850315f9$var$globalState.allowStateChanges = ea === true || ea === $316af70a850315f9$var$ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach((key)=>{
        if (key in options) $316af70a850315f9$var$globalState[key] = !!options[key];
    });
    $316af70a850315f9$var$globalState.allowStateReads = !$316af70a850315f9$var$globalState.observableRequiresReaction;
    if ($316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$globalState.disableErrorBoundaries === true) console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
    if (options.reactionScheduler) $316af70a850315f9$var$setReactionScheduler(options.reactionScheduler);
}
function $316af70a850315f9$export$59d8134e963031bd(target, properties, annotations, options) {
    if ($316af70a850315f9$var$__MOBX_DEV__) {
        if (arguments.length > 4) $316af70a850315f9$var$die("'extendObservable' expected 2-4 arguments");
        if (typeof target !== "object") $316af70a850315f9$var$die("'extendObservable' expects an object as first argument");
        if ($316af70a850315f9$export$27a7faddcfd44960(target)) $316af70a850315f9$var$die("'extendObservable' should not be used on maps, use map.merge instead");
        if (!$316af70a850315f9$var$isPlainObject(properties)) $316af70a850315f9$var$die(`'extendObservable' only accepts plain objects as second argument`);
        if ($316af70a850315f9$export$5cd057a6046189f9(properties) || $316af70a850315f9$export$5cd057a6046189f9(annotations)) $316af70a850315f9$var$die(`Extending an object with another observable (object) is not supported`);
    }
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    const descriptors = $316af70a850315f9$var$getOwnPropertyDescriptors(properties);
    $316af70a850315f9$var$initObservable(()=>{
        const adm = $316af70a850315f9$var$asObservableObject(target, options)[$316af70a850315f9$export$f246528900dd4467];
        $316af70a850315f9$var$ownKeys(descriptors).forEach((key)=>{
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : $316af70a850315f9$var$hasProp(annotations, key) ? annotations[key] : true);
        });
    });
    return target;
}
function $316af70a850315f9$export$23fbf90e5d80a5ee(thing, property) {
    return $316af70a850315f9$var$nodeToDependencyTree($316af70a850315f9$export$25fc416d10fa1afa(thing, property));
}
function $316af70a850315f9$var$nodeToDependencyTree(node) {
    const result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = $316af70a850315f9$var$unique(node.observing_).map($316af70a850315f9$var$nodeToDependencyTree);
    return result;
}
function $316af70a850315f9$export$3b1621dddf5aeacd(thing, property) {
    return $316af70a850315f9$var$nodeToObserverTree($316af70a850315f9$export$25fc416d10fa1afa(thing, property));
}
function $316af70a850315f9$var$nodeToObserverTree(node) {
    const result = {
        name: node.name_
    };
    if ($316af70a850315f9$var$hasObservers(node)) result.observers = Array.from($316af70a850315f9$var$getObservers(node), $316af70a850315f9$var$nodeToObserverTree);
    return result;
}
function $316af70a850315f9$var$unique(list) {
    return Array.from(new Set(list));
}
let $316af70a850315f9$var$generatorId = 0;
class $316af70a850315f9$export$134218f44485f691 extends Error {
    constructor(){
        super("FLOW_CANCELLED");
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = "FlowCancellationError";
    }
    toString() {
        return `Error: ${this.message}`;
    }
}
function $316af70a850315f9$export$e01c2a57c655302d(error) {
    return error instanceof $316af70a850315f9$export$134218f44485f691;
}
function $316af70a850315f9$var$createFlowDecoratorAnnotation(annotation) {
    return $316af70a850315f9$var$createDecoratorAnnotation(annotation, $316af70a850315f9$var$decorateFlow20223_);
}
const $316af70a850315f9$var$flowAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createFlowAnnotation("flow");
const $316af70a850315f9$var$flowBoundAnnotation = /*#__PURE__*/ $316af70a850315f9$var$createFlowAnnotation("flowBound", {
    bound: true
});
const $316af70a850315f9$export$ccc7b0636abaffc3 = /*#__PURE__*/ $316af70a850315f9$var$assign(function flow(arg1, arg2) {
    if (arg2 && typeof arg2.kind === "string") return $316af70a850315f9$var$decorateFlow20223_($316af70a850315f9$var$flowAnnotation, arg1, arg2);
    // flow(fn)
    if ($316af70a850315f9$var$__MOBX_DEV__ && arguments.length !== 1) $316af70a850315f9$var$die(`Flow expects single argument with generator function`);
    const generator = arg1;
    const name = generator.name || ($316af70a850315f9$var$__MOBX_DEV__ ? "<unnamed flow>" : "flow");
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    const res = function res() {
        const ctx = this;
        const args = arguments;
        const runId = $316af70a850315f9$var$__MOBX_DEV__ ? ++$316af70a850315f9$var$generatorId : 0;
        const gen = $316af70a850315f9$export$31eb53bd5b582a97($316af70a850315f9$var$__MOBX_DEV__ ? `${name} - runid: ${runId} - init` : name, generator).apply(ctx, args);
        let rejector;
        let pendingPromise = undefined;
        const promise = new Promise(function(resolve, reject) {
            let stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                let ret;
                try {
                    ret = $316af70a850315f9$export$31eb53bd5b582a97($316af70a850315f9$var$__MOBX_DEV__ ? `${name} - runid: ${runId} - yield ${stepId++}` : name, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                let ret;
                try {
                    ret = $316af70a850315f9$export$31eb53bd5b582a97($316af70a850315f9$var$__MOBX_DEV__ ? `${name} - runid: ${runId} - yield ${stepId++}` : name, gen.throw).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if ($316af70a850315f9$var$isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        const cancelActionName = $316af70a850315f9$var$__MOBX_DEV__ ? `${name} - runid: ${runId} - cancel` : name;
        promise.cancel = $316af70a850315f9$export$31eb53bd5b582a97(cancelActionName, function() {
            try {
                if (pendingPromise) $316af70a850315f9$var$cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                const res = gen.return(undefined);
                // eat anything that promise would do, it's cancelled!
                const yieldedPromise = Promise.resolve(res.value);
                yieldedPromise.then($316af70a850315f9$var$noop, $316af70a850315f9$var$noop);
                $316af70a850315f9$var$cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new $316af70a850315f9$export$134218f44485f691());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, $316af70a850315f9$var$flowAnnotation);
const $316af70a850315f9$export$d41c06fa934cc67e = /*#__PURE__*/ $316af70a850315f9$var$createFlowDecoratorAnnotation($316af70a850315f9$var$flowBoundAnnotation);
function $316af70a850315f9$var$cancelPromise(promise) {
    if ($316af70a850315f9$var$isFunction(promise.cancel)) promise.cancel();
}
function $316af70a850315f9$export$b1b0dfc8def25964(result) {
    return result; // just tricking TypeScript :)
}
function $316af70a850315f9$export$8c23365ce94ba925(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function $316af70a850315f9$export$bf4da824ef9b40d0(thing, propOrHandler, handler) {
    let target;
    if ($316af70a850315f9$export$27a7faddcfd44960(thing) || $316af70a850315f9$export$f5afceff386badf9(thing) || $316af70a850315f9$export$fafbc00dbefd1aef(thing)) target = $316af70a850315f9$export$71ff639cb8b2a36e(thing);
    else if ($316af70a850315f9$export$31960fb081a18155(thing)) {
        if ($316af70a850315f9$var$__MOBX_DEV__ && !$316af70a850315f9$var$isStringish(propOrHandler)) return $316af70a850315f9$var$die(`InterceptReads can only be used with a specific property, not with an object in general`);
        target = $316af70a850315f9$export$71ff639cb8b2a36e(thing, propOrHandler);
    } else if ($316af70a850315f9$var$__MOBX_DEV__) return $316af70a850315f9$var$die(`Expected observable map, object or array as first array`);
    if ($316af70a850315f9$var$__MOBX_DEV__ && target.dehancer !== undefined) return $316af70a850315f9$var$die(`An intercept reader was already established`);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return ()=>{
        target.dehancer = undefined;
    };
}
function $316af70a850315f9$export$ab0f802c05dd969b(thing, propOrHandler, handler) {
    if ($316af70a850315f9$var$isFunction(handler)) return $316af70a850315f9$var$interceptProperty(thing, propOrHandler, handler);
    else return $316af70a850315f9$var$interceptInterceptable(thing, propOrHandler);
}
function $316af70a850315f9$var$interceptInterceptable(thing, handler) {
    return $316af70a850315f9$var$registerInterceptor($316af70a850315f9$export$71ff639cb8b2a36e(thing), handler);
}
function $316af70a850315f9$var$interceptProperty(thing, property, handler) {
    return $316af70a850315f9$var$registerInterceptor($316af70a850315f9$export$71ff639cb8b2a36e(thing, property), handler);
}
function $316af70a850315f9$var$_isComputed(value, property) {
    var _adm$lazyComputedKeys;
    if (property === undefined) return $316af70a850315f9$var$isComputedValue(value);
    if ($316af70a850315f9$export$31960fb081a18155(value) === false) return false;
    const adm = value[$316af70a850315f9$export$f246528900dd4467];
    if ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) return true;
    if (!adm.values_.has(property)) return false;
    const atom = $316af70a850315f9$export$25fc416d10fa1afa(value, property);
    return $316af70a850315f9$var$isComputedValue(atom);
}
function $316af70a850315f9$export$21bb8b7af2417cc3(value) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && arguments.length > 1) return $316af70a850315f9$var$die(`isComputed expects only 1 argument. Use isComputedProp to inspect the observability of a property`);
    return $316af70a850315f9$var$_isComputed(value);
}
function $316af70a850315f9$export$3cf701ab9f66d86a(value, propName) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && !$316af70a850315f9$var$isStringish(propName)) return $316af70a850315f9$var$die(`isComputed expected a property name as second argument`);
    return $316af70a850315f9$var$_isComputed(value, propName);
}
function $316af70a850315f9$var$_isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if ($316af70a850315f9$var$__MOBX_DEV__ && ($316af70a850315f9$export$27a7faddcfd44960(value) || $316af70a850315f9$export$f5afceff386badf9(value))) return $316af70a850315f9$var$die("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if ($316af70a850315f9$export$31960fb081a18155(value)) {
            var _adm$lazyComputedKeys, _adm$lazyObservableKe;
            const adm = value[$316af70a850315f9$export$f246528900dd4467];
            return adm.values_.has(property) || !!((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) || !!((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null && _adm$lazyObservableKe.has(property));
        }
        return false;
    }
    // For first check, see #701
    return $316af70a850315f9$export$31960fb081a18155(value) || !!value[$316af70a850315f9$export$f246528900dd4467] || $316af70a850315f9$var$isAtom(value) || $316af70a850315f9$var$isReaction(value) || $316af70a850315f9$var$isComputedValue(value);
}
function $316af70a850315f9$export$5cd057a6046189f9(value) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && arguments.length !== 1) $316af70a850315f9$var$die(`isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property`);
    return $316af70a850315f9$var$_isObservable(value);
}
function $316af70a850315f9$export$7ad7acc949ba3cc7(value, propName) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && !$316af70a850315f9$var$isStringish(propName)) return $316af70a850315f9$var$die(`expected a property name as second argument`);
    return $316af70a850315f9$var$_isObservable(value, propName);
}
function $316af70a850315f9$export$ed97f33186d4b816(obj) {
    if ($316af70a850315f9$export$31960fb081a18155(obj)) return obj[$316af70a850315f9$export$f246528900dd4467].keys_();
    if ($316af70a850315f9$export$27a7faddcfd44960(obj) || $316af70a850315f9$export$da6b063694cb52c1(obj)) return Array.from(obj.keys());
    if ($316af70a850315f9$export$f5afceff386badf9(obj)) return obj.map((_, index)=>index);
    $316af70a850315f9$var$die(5);
}
function $316af70a850315f9$export$68c286be0e7e55b7(obj) {
    if ($316af70a850315f9$export$31960fb081a18155(obj)) return $316af70a850315f9$export$ed97f33186d4b816(obj).map((key)=>obj[key]);
    if ($316af70a850315f9$export$27a7faddcfd44960(obj)) return $316af70a850315f9$export$ed97f33186d4b816(obj).map((key)=>obj.get(key));
    if ($316af70a850315f9$export$da6b063694cb52c1(obj)) return Array.from(obj.values());
    if ($316af70a850315f9$export$f5afceff386badf9(obj)) return obj.slice();
    $316af70a850315f9$var$die(6);
}
function $316af70a850315f9$export$3e9f948b41964866(obj) {
    if ($316af70a850315f9$export$31960fb081a18155(obj)) return $316af70a850315f9$export$ed97f33186d4b816(obj).map((key)=>[
            key,
            obj[key]
        ]);
    if ($316af70a850315f9$export$27a7faddcfd44960(obj)) return $316af70a850315f9$export$ed97f33186d4b816(obj).map((key)=>[
            key,
            obj.get(key)
        ]);
    if ($316af70a850315f9$export$da6b063694cb52c1(obj)) return Array.from(obj.entries());
    if ($316af70a850315f9$export$f5afceff386badf9(obj)) return obj.map((key, index)=>[
            index,
            key
        ]);
    $316af70a850315f9$var$die(7);
}
function $316af70a850315f9$export$adaa4cf7ef1b65be(obj, key, value) {
    if (arguments.length === 2 && !$316af70a850315f9$export$da6b063694cb52c1(obj)) {
        $316af70a850315f9$var$startBatch();
        const values = key;
        try {
            for(let _key in values)$316af70a850315f9$export$adaa4cf7ef1b65be(obj, _key, values[_key]);
        } finally{
            $316af70a850315f9$var$endBatch();
        }
        return;
    }
    if ($316af70a850315f9$export$31960fb081a18155(obj)) obj[$316af70a850315f9$export$f246528900dd4467].set_(key, value);
    else if ($316af70a850315f9$export$27a7faddcfd44960(obj)) obj.set(key, value);
    else if ($316af70a850315f9$export$da6b063694cb52c1(obj)) obj.add(key);
    else if ($316af70a850315f9$export$f5afceff386badf9(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) $316af70a850315f9$var$die(42, key);
        $316af70a850315f9$var$startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        $316af70a850315f9$var$endBatch();
    } else $316af70a850315f9$var$die(8);
}
function $316af70a850315f9$export$cd7f480d6b8286c3(obj, key) {
    if ($316af70a850315f9$export$31960fb081a18155(obj)) obj[$316af70a850315f9$export$f246528900dd4467].delete_(key);
    else if ($316af70a850315f9$export$27a7faddcfd44960(obj)) obj.delete(key);
    else if ($316af70a850315f9$export$da6b063694cb52c1(obj)) obj.delete(key);
    else if ($316af70a850315f9$export$f5afceff386badf9(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else $316af70a850315f9$var$die(9);
}
function $316af70a850315f9$export$a4f4bb6b1453fff5(obj, key) {
    if ($316af70a850315f9$export$31960fb081a18155(obj)) return obj[$316af70a850315f9$export$f246528900dd4467].has_(key);
    else if ($316af70a850315f9$export$27a7faddcfd44960(obj)) return obj.has(key);
    else if ($316af70a850315f9$export$da6b063694cb52c1(obj)) return obj.has(key);
    else if ($316af70a850315f9$export$f5afceff386badf9(obj)) return key >= 0 && key < obj.length;
    $316af70a850315f9$var$die(10);
}
function $316af70a850315f9$export$3988ae62b71be9a3(obj, key) {
    if (!$316af70a850315f9$export$a4f4bb6b1453fff5(obj, key)) return undefined;
    if ($316af70a850315f9$export$31960fb081a18155(obj)) return obj[$316af70a850315f9$export$f246528900dd4467].get_(key);
    else if ($316af70a850315f9$export$27a7faddcfd44960(obj)) return obj.get(key);
    else if ($316af70a850315f9$export$f5afceff386badf9(obj)) return obj[key];
    $316af70a850315f9$var$die(11);
}
function $316af70a850315f9$export$fdab3c20aae16ddf(obj, key, descriptor) {
    if ($316af70a850315f9$export$31960fb081a18155(obj)) return obj[$316af70a850315f9$export$f246528900dd4467].defineProperty_(key, descriptor);
    $316af70a850315f9$var$die(39);
}
function $316af70a850315f9$export$6aa2094d45f88f20(obj) {
    if ($316af70a850315f9$export$31960fb081a18155(obj)) return obj[$316af70a850315f9$export$f246528900dd4467].ownKeys_();
    $316af70a850315f9$var$die(38);
}
function $316af70a850315f9$export$d1203567a167490e(thing, propOrCb, cbOrFire, fireImmediately) {
    if ($316af70a850315f9$var$isFunction(cbOrFire)) return $316af70a850315f9$var$observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return $316af70a850315f9$var$observeObservable(thing, propOrCb, cbOrFire);
}
function $316af70a850315f9$var$observeObservable(thing, listener, fireImmediately) {
    const adm = $316af70a850315f9$export$71ff639cb8b2a36e(thing);
    if ($316af70a850315f9$export$f5afceff386badf9(thing)) {
        if (fireImmediately) listener({
            observableKind: "array",
            object: adm.proxy_,
            debugObjectName: adm.atom_.name_,
            type: "splice",
            index: 0,
            added: adm.values_.slice(),
            addedCount: adm.values_.length,
            removed: [],
            removedCount: 0
        });
    } else if ($316af70a850315f9$export$27a7faddcfd44960(thing)) {
        if ($316af70a850315f9$var$__MOBX_DEV__ && fireImmediately === true) $316af70a850315f9$var$die("`observe` doesn't support fireImmediately=true in combination with maps.");
    } else if ($316af70a850315f9$export$da6b063694cb52c1(thing)) {
        if ($316af70a850315f9$var$__MOBX_DEV__ && fireImmediately === true) $316af70a850315f9$var$die("`observe` doesn't support fireImmediately=true in combination with sets.");
    } else if ($316af70a850315f9$export$31960fb081a18155(thing)) {
        if ($316af70a850315f9$var$__MOBX_DEV__ && fireImmediately === true) $316af70a850315f9$var$die("`observe` doesn't support the fire immediately property for observable objects.");
    } else return $316af70a850315f9$var$observeValue(adm, listener, fireImmediately);
    return $316af70a850315f9$var$registerListener(adm, listener);
}
function $316af70a850315f9$var$observeObservableProperty(thing, property, listener, fireImmediately) {
    return $316af70a850315f9$var$observeValue($316af70a850315f9$export$71ff639cb8b2a36e(thing, property), listener, fireImmediately);
}
function $316af70a850315f9$var$observeValue(adm, listener, fireImmediately) {
    if ($316af70a850315f9$var$isComputedValue(adm)) {
        let firstTime = true;
        let prevValue = undefined;
        return $316af70a850315f9$export$4abd31caebb0bb24(()=>{
            const newValue = adm.get();
            if (!firstTime || fireImmediately) {
                const prevU = $316af70a850315f9$var$untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: adm.name_,
                    type: $316af70a850315f9$var$UPDATE,
                    object: adm,
                    newValue: newValue,
                    oldValue: prevValue
                });
                $316af70a850315f9$var$untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    }
    if (fireImmediately) listener({
        observableKind: "value",
        debugObjectName: adm.name_,
        object: adm,
        type: $316af70a850315f9$var$UPDATE,
        newValue: adm.value_,
        oldValue: undefined
    });
    return $316af70a850315f9$var$registerListener(adm, listener);
}
function $316af70a850315f9$var$cache(map, key, value) {
    map.set(key, value);
    return value;
}
function $316af70a850315f9$var$toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !$316af70a850315f9$export$5cd057a6046189f9(source)) return source;
    if ($316af70a850315f9$export$fafbc00dbefd1aef(source) || $316af70a850315f9$var$isComputedValue(source)) return $316af70a850315f9$var$toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if ($316af70a850315f9$export$f5afceff386badf9(source)) {
        const res = $316af70a850315f9$var$cache(__alreadySeen, source, new Array(source.length));
        source.forEach((value, idx)=>{
            res[idx] = $316af70a850315f9$var$toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if ($316af70a850315f9$export$da6b063694cb52c1(source)) {
        const res = $316af70a850315f9$var$cache(__alreadySeen, source, new Set());
        source.forEach((value)=>{
            res.add($316af70a850315f9$var$toJSHelper(value, __alreadySeen));
        });
        return res;
    }
    if ($316af70a850315f9$export$27a7faddcfd44960(source)) {
        const res = $316af70a850315f9$var$cache(__alreadySeen, source, new Map());
        source.forEach((value, key)=>{
            res.set(key, $316af70a850315f9$var$toJSHelper(value, __alreadySeen));
        });
        return res;
    } else {
        // must be observable object
        const res = $316af70a850315f9$var$cache(__alreadySeen, source, {});
        $316af70a850315f9$export$6aa2094d45f88f20(source).forEach((key)=>{
            if ($316af70a850315f9$var$objectPrototype.propertyIsEnumerable.call(source, key)) res[key] = $316af70a850315f9$var$toJSHelper(source[key], __alreadySeen);
        });
        $316af70a850315f9$var$copyObservableAccessors(source, res, __alreadySeen);
        return res;
    }
}
/**
 * Copies `@observable accessor` fields, which are defined on the prototype, so they are neither own nor enumerable.
 * Their values live in the administration: in `values_` once read, and in `lazyObservableKeys_` until then.
 * Computed values and private accessors are left out.
 * Kept here instead of on the administration, so it is tree shaken away when `toJS` is not used.
 */ function $316af70a850315f9$var$copyObservableAccessors(source, res, __alreadySeen) {
    const adm = source[$316af70a850315f9$export$f246528900dd4467];
    if (adm.lazyObservableKeys_ === undefined) // No `@observable accessor` field ever registered (it becomes `null`, not `undefined`, once all were read)
    return;
    const target = adm.target_;
    // Own keys were already copied by `toJSHelper`, and `in` leaves out private `#field` keys
    for (const [key, value] of adm.values_)if (!$316af70a850315f9$var$hasProp(target, key) && !(value instanceof $316af70a850315f9$var$ComputedValue) && key in target) res[key] = $316af70a850315f9$var$toJSHelper(source[key], __alreadySeen);
    // Fields that were never read have no entry in `values_` yet, reading them creates it
    if (adm.lazyObservableKeys_) {
        for (const key of adm.lazyObservableKeys_.keys())if (!adm.values_.has(key) && !$316af70a850315f9$var$hasProp(target, key) && key in target) res[key] = $316af70a850315f9$var$toJSHelper(source[key], __alreadySeen);
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored, except for `@observable accessor` fields.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function $316af70a850315f9$export$f08965dd1304d490(source, options) {
    if ($316af70a850315f9$var$__MOBX_DEV__ && options) $316af70a850315f9$var$die("toJS no longer supports options");
    return $316af70a850315f9$var$toJSHelper(source, new Map());
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function $316af70a850315f9$export$2d62d2646dd2fb3c(action, thisArg) {
    $316af70a850315f9$var$startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        $316af70a850315f9$var$endBatch();
    }
}
function $316af70a850315f9$export$a55877ca9db47377(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return $316af70a850315f9$var$whenPromise(predicate, arg1);
    return $316af70a850315f9$var$_when(predicate, arg1, arg2 || {});
}
function $316af70a850315f9$var$_when(predicate, effect, opts) {
    let timeoutHandle;
    if (typeof opts.timeout === "number") {
        const error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(()=>{
            if (!disposer[$316af70a850315f9$export$f246528900dd4467].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = $316af70a850315f9$var$__MOBX_DEV__ ? opts.name || "When@" + $316af70a850315f9$var$getNextId() : "When";
    const effectAction = $316af70a850315f9$var$createAction($316af70a850315f9$var$__MOBX_DEV__ ? opts.name + "-effect" : "When-effect", effect);
    // eslint-disable-next-line
    var disposer = $316af70a850315f9$export$4abd31caebb0bb24((r)=>{
        // predicate should not change state
        let cond = $316af70a850315f9$export$e510c5d1ea4358b1(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function $316af70a850315f9$var$whenPromise(predicate, opts) {
    var _opts$signal;
    if ($316af70a850315f9$var$__MOBX_DEV__ && opts && opts.onError) return $316af70a850315f9$var$die(`the options 'onError' and 'promise' cannot be combined`);
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return $316af70a850315f9$var$assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: ()=>null
    });
    let cancel;
    let abort;
    const res = new Promise((resolve, reject)=>{
        var _opts$signal2;
        let disposer = $316af70a850315f9$var$_when(predicate, resolve, $316af70a850315f9$var$assign({}, opts, {
            onError: reject
        }));
        cancel = ()=>{
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = ()=>{
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    }).finally(()=>{
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function $316af70a850315f9$var$getAdm(target) {
    return target[$316af70a850315f9$export$f246528900dd4467];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
const $316af70a850315f9$var$objectProxyTraps = {
    has (target, name) {
        return $316af70a850315f9$var$getAdm(target).has_(name);
    },
    get (target, name) {
        return $316af70a850315f9$var$getAdm(target).get_(name);
    },
    set (target, name, value) {
        var _getAdm$set_;
        if (!$316af70a850315f9$var$isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = $316af70a850315f9$var$getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty (target, name) {
        var _getAdm$delete_;
        if (!$316af70a850315f9$var$isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = $316af70a850315f9$var$getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty (target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = $316af70a850315f9$var$getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys (target) {
        return $316af70a850315f9$var$getAdm(target).ownKeys_();
    },
    preventExtensions (target) {
        $316af70a850315f9$var$die(13);
    }
};
function $316af70a850315f9$var$asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    target = $316af70a850315f9$var$asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$316af70a850315f9$export$f246528900dd4467]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, $316af70a850315f9$var$objectProxyTraps);
}
function $316af70a850315f9$var$hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function $316af70a850315f9$var$registerInterceptor(interceptable, handler) {
    let interceptors = interceptable.interceptors_;
    if (interceptors) interceptors.push(handler);
    else // Allocate at the exact size: pushing onto an empty array over-allocates its backing store
    interceptors = interceptable.interceptors_ = [
        handler
    ];
    return $316af70a850315f9$var$once(()=>{
        const idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function $316af70a850315f9$var$interceptChange(interceptable, change) {
    const prevU = $316af70a850315f9$var$untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        const interceptors = [
            ...interceptable.interceptors_ || []
        ];
        for(let i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) $316af70a850315f9$var$die(14);
            if (!change) break;
        }
        return change;
    } finally{
        $316af70a850315f9$var$untrackedEnd(prevU);
    }
}
function $316af70a850315f9$var$hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function $316af70a850315f9$var$registerListener(listenable, handler) {
    let listeners = listenable.changeListeners_;
    if (listeners) listeners.push(handler);
    else // Allocate at the exact size: pushing onto an empty array over-allocates its backing store
    listeners = listenable.changeListeners_ = [
        handler
    ];
    return $316af70a850315f9$var$once(()=>{
        const idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function $316af70a850315f9$var$notifyListeners(listenable, change) {
    const prevU = $316af70a850315f9$var$untrackedStart();
    let listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(let i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    $316af70a850315f9$var$untrackedEnd(prevU);
}
function $316af70a850315f9$export$885e6ca7a4dc4b3e(target, annotations, options) {
    $316af70a850315f9$var$initObservable(()=>{
        const adm = $316af70a850315f9$var$asObservableObject(target, options)[$316af70a850315f9$export$f246528900dd4467];
        // Annotate
        $316af70a850315f9$var$ownKeys(annotations).forEach((key)=>$316af70a850315f9$var$make_(adm, key, annotations[key]));
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
const $316af70a850315f9$var$keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function $316af70a850315f9$export$1cfaca5abb185fe7(target, overrides, options) {
    if ($316af70a850315f9$var$__MOBX_DEV__) {
        if (!$316af70a850315f9$var$isPlainObject(target) && !$316af70a850315f9$var$isPlainObject(Object.getPrototypeOf(target))) $316af70a850315f9$var$die(`'makeAutoObservable' can only be used for classes that don't have a superclass`);
        if ($316af70a850315f9$export$31960fb081a18155(target)) $316af70a850315f9$var$die(`makeAutoObservable can only be used on objects not already made observable`);
    }
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if ($316af70a850315f9$var$isPlainObject(target)) return $316af70a850315f9$export$59d8134e963031bd(target, target, overrides, options);
    $316af70a850315f9$var$initObservable(()=>{
        const adm = $316af70a850315f9$var$asObservableObject(target, options)[$316af70a850315f9$export$f246528900dd4467];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[$316af70a850315f9$var$keysSymbol]) {
            const proto = Object.getPrototypeOf(target);
            const keys = new Set([
                ...$316af70a850315f9$var$ownKeys(target),
                ...$316af70a850315f9$var$ownKeys(proto)
            ]);
            keys.delete("constructor");
            keys.delete($316af70a850315f9$export$f246528900dd4467);
            $316af70a850315f9$var$addHiddenProp(proto, $316af70a850315f9$var$keysSymbol, keys);
        }
        target[$316af70a850315f9$var$keysSymbol].forEach((key)=>$316af70a850315f9$var$make_(adm, key, // must pass "undefined" for { key: undefined }
            !overrides ? true : $316af70a850315f9$var$hasProp(overrides, key) ? overrides[key] : true));
    });
    return target;
}
function $316af70a850315f9$var$make_(adm, key, annotation) {
    if (annotation === true) annotation = adm.defaultAnnotation_;
    if (annotation === false) return;
    $316af70a850315f9$var$assertAnnotable(adm, annotation, key);
    if (!(key in adm.target_)) $316af70a850315f9$var$die(1, annotation.annotationType_, `${adm.name_}.${key.toString()}`);
    let source = adm.target_;
    while(source && source !== $316af70a850315f9$var$objectPrototype){
        const descriptor = $316af70a850315f9$var$getDescriptor(source, key);
        if (descriptor) {
            const outcome = annotation.make_(adm, key, descriptor, source);
            if (outcome === 0 /* MakeResult.Cancel */ ) return;
            if (outcome === 1 /* MakeResult.Break */ ) break;
        }
        source = Object.getPrototypeOf(source);
    }
    $316af70a850315f9$var$recordAnnotationApplied(adm, annotation, key);
}
const $316af70a850315f9$var$SPLICE = "splice";
const $316af70a850315f9$var$UPDATE = "update";
const $316af70a850315f9$var$MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
const $316af70a850315f9$var$arrayTraps = {
    get (target, name) {
        const adm = target[$316af70a850315f9$export$f246528900dd4467];
        if (name === $316af70a850315f9$export$f246528900dd4467) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if ($316af70a850315f9$var$hasProp($316af70a850315f9$var$arrayExtensions, name)) return $316af70a850315f9$var$arrayExtensions[name];
        return target[name];
    },
    set (target, name, value) {
        const adm = target[$316af70a850315f9$export$f246528900dd4467];
        if (name === "length") adm.setArrayLength_(value);
        else if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions () {
        $316af70a850315f9$var$die(15);
    }
};
class $316af70a850315f9$var$ObservableArrayAdministration {
    constructor(name = $316af70a850315f9$var$__MOBX_DEV__ ? "ObservableArray@" + $316af70a850315f9$var$getNextId() : "ObservableArray", enhancer, owned_){
        this.owned_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.atom_ = new $316af70a850315f9$var$Atom(name);
        this.enhancer_ = (newV, oldV)=>enhancer(newV, oldV, $316af70a850315f9$var$__MOBX_DEV__ ? name + "[..]" : "ObservableArray[..]");
    }
    dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    }
    getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    }
    setArrayLength_(newLength) {
        if (!Number.isInteger(newLength) || newLength < 0) $316af70a850315f9$var$die(40, newLength);
        let currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            const newItems = Array.from({
                length: newLength - currentLength
            });
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    }
    updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) $316af70a850315f9$var$die(16);
        this.lastKnownLength_ += delta;
    }
    spliceWithArray_(index, deleteCount, newItems) {
        $316af70a850315f9$var$checkIfStateModificationsAreAllowed(this.atom_);
        const length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = $316af70a850315f9$var$EMPTY_ARRAY;
        if ($316af70a850315f9$var$hasInterceptors(this)) {
            const change = $316af70a850315f9$var$interceptChange(this, {
                object: this.proxy_,
                type: $316af70a850315f9$var$SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return $316af70a850315f9$var$EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map((v)=>this.enhancer_(v, undefined));
        if ($316af70a850315f9$var$__MOBX_DEV__) {
            const lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        const res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    }
    spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < $316af70a850315f9$var$MAX_SPLICE_SIZE) return this.values_.splice(index, deleteCount, ...newItems);
        else {
            // The items removed by the splice
            const res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            let oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(let i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(let i = 0; i < oldItems.length; i++)this.values_[index + newItems.length + i] = oldItems[i];
            return res;
        }
    }
    notifyArrayChildUpdate_(index, newValue, oldValue) {
        const notifySpy = $316af70a850315f9$var$__MOBX_DEV__ && !this.owned_ && $316af70a850315f9$var$isSpyEnabled();
        const notify = $316af70a850315f9$var$hasListeners(this);
        const change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: $316af70a850315f9$var$UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
        if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportStart(change);
        this.atom_.reportChanged();
        if (notify) $316af70a850315f9$var$notifyListeners(this, change);
        if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportEnd();
    }
    notifyArraySplice_(index, added, removed) {
        const notifySpy = $316af70a850315f9$var$__MOBX_DEV__ && !this.owned_ && $316af70a850315f9$var$isSpyEnabled();
        const notify = $316af70a850315f9$var$hasListeners(this);
        const change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: $316af70a850315f9$var$SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportStart(change);
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) $316af70a850315f9$var$notifyListeners(this, change);
        if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportEnd();
    }
    get_(index) {
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    }
    set_(index, newValue) {
        const values = this.values_;
        if (index < values.length) {
            // update at index in range
            $316af70a850315f9$var$checkIfStateModificationsAreAllowed(this.atom_);
            const oldValue = values[index];
            if ($316af70a850315f9$var$hasInterceptors(this)) {
                const change = $316af70a850315f9$var$interceptChange(this, {
                    type: $316af70a850315f9$var$UPDATE,
                    object: this.proxy_,
                    index: // since "this" is the real array we need to pass its proxy
                    index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            const changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            const newItems = Array.from({
                length: index + 1 - values.length
            });
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    }
}
function $316af70a850315f9$var$createObservableArray(initialValues, enhancer, name = $316af70a850315f9$var$__MOBX_DEV__ ? "ObservableArray@" + $316af70a850315f9$var$getNextId() : "ObservableArray", owned = false) {
    return $316af70a850315f9$var$initObservable(()=>{
        const adm = new $316af70a850315f9$var$ObservableArrayAdministration(name, enhancer, owned);
        $316af70a850315f9$var$addHiddenFinalProp(adm.values_, $316af70a850315f9$export$f246528900dd4467, adm);
        const proxy = new Proxy(adm.values_, $316af70a850315f9$var$arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var $316af70a850315f9$var$arrayExtensions = {
    clear () {
        return this.splice(0);
    },
    replace (newItems) {
        const adm = this[$316af70a850315f9$export$f246528900dd4467];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON () {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice (index, deleteCount, ...newItems) {
        const adm = this[$316af70a850315f9$export$f246528900dd4467];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray (index, deleteCount, newItems) {
        return this[$316af70a850315f9$export$f246528900dd4467].spliceWithArray_(index, deleteCount, newItems);
    },
    push (...items) {
        const adm = this[$316af70a850315f9$export$f246528900dd4467];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop () {
        return this.splice(Math.max(this[$316af70a850315f9$export$f246528900dd4467].values_.length - 1, 0), 1)[0];
    },
    shift () {
        return this.splice(0, 1)[0];
    },
    unshift (...items) {
        const adm = this[$316af70a850315f9$export$f246528900dd4467];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if ($316af70a850315f9$var$globalState.trackingDerivation) $316af70a850315f9$var$die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort () {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if ($316af70a850315f9$var$globalState.trackingDerivation) $316af70a850315f9$var$die(37, "sort");
        const copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove (value) {
        const adm = this[$316af70a850315f9$export$f246528900dd4467];
        const idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ $316af70a850315f9$var$addArrayExtension("at", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("concat", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("flat", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("includes", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("indexOf", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("join", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("lastIndexOf", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("slice", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("toString", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("toLocaleString", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("toSorted", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("toSpliced", $316af70a850315f9$var$simpleFunc);
$316af70a850315f9$var$addArrayExtension("with", $316af70a850315f9$var$simpleFunc);
// map
$316af70a850315f9$var$addArrayExtension("every", $316af70a850315f9$var$mapLikeFunc);
$316af70a850315f9$var$addArrayExtension("filter", $316af70a850315f9$var$mapLikeFunc);
$316af70a850315f9$var$addArrayExtension("find", $316af70a850315f9$var$mapLikeFunc);
$316af70a850315f9$var$addArrayExtension("findIndex", $316af70a850315f9$var$mapLikeFunc);
$316af70a850315f9$var$addArrayExtension("findLast", $316af70a850315f9$var$mapLikeFunc);
$316af70a850315f9$var$addArrayExtension("findLastIndex", $316af70a850315f9$var$mapLikeFunc);
$316af70a850315f9$var$addArrayExtension("flatMap", $316af70a850315f9$var$mapLikeFunc);
$316af70a850315f9$var$addArrayExtension("forEach", $316af70a850315f9$var$mapLikeFunc);
$316af70a850315f9$var$addArrayExtension("map", $316af70a850315f9$var$mapLikeFunc);
$316af70a850315f9$var$addArrayExtension("some", $316af70a850315f9$var$mapLikeFunc);
$316af70a850315f9$var$addArrayExtension("toReversed", $316af70a850315f9$var$mapLikeFunc);
// reduce
$316af70a850315f9$var$addArrayExtension("reduce", $316af70a850315f9$var$reduceLikeFunc);
$316af70a850315f9$var$addArrayExtension("reduceRight", $316af70a850315f9$var$reduceLikeFunc);
function $316af70a850315f9$var$addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") $316af70a850315f9$var$arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function $316af70a850315f9$var$simpleFunc(funcName) {
    return function() {
        const adm = this[$316af70a850315f9$export$f246528900dd4467];
        adm.atom_.reportObserved();
        const dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function $316af70a850315f9$var$mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        const adm = this[$316af70a850315f9$export$f246528900dd4467];
        adm.atom_.reportObserved();
        const dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName]((element, index)=>{
            return callback.call(thisArg, element, index, this);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function $316af70a850315f9$var$reduceLikeFunc(funcName) {
    return function() {
        const adm = this[$316af70a850315f9$export$f246528900dd4467];
        adm.atom_.reportObserved();
        const dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        const callback = arguments[0];
        arguments[0] = (accumulator, currentValue, index)=>{
            return callback(accumulator, currentValue, index, this);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
const $316af70a850315f9$var$isObservableArrayAdministration = /*#__PURE__*/ $316af70a850315f9$var$createInstanceofPredicate("ObservableArrayAdministration", $316af70a850315f9$var$ObservableArrayAdministration);
function $316af70a850315f9$export$f5afceff386badf9(thing) {
    return $316af70a850315f9$var$isObject(thing) && $316af70a850315f9$var$isObservableArrayAdministration(thing[$316af70a850315f9$export$f246528900dd4467]);
}
const $316af70a850315f9$var$ObservableMapMarker = {};
const $316af70a850315f9$var$ADD = "add";
const $316af70a850315f9$var$DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
class $316af70a850315f9$export$db1c0901f08fc6fd {
    constructor(initialData, enhancer_ = $316af70a850315f9$var$deepEnhancer, name_ = $316af70a850315f9$var$__MOBX_DEV__ ? "ObservableMap@" + $316af70a850315f9$var$getNextId() : "ObservableMap"){
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$316af70a850315f9$export$f246528900dd4467] = $316af70a850315f9$var$ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        $316af70a850315f9$var$initObservable(()=>{
            this.keysAtom_ = $316af70a850315f9$export$2e17fe64ec9a826e($316af70a850315f9$var$__MOBX_DEV__ ? `${this.name_}.keys()` : "ObservableMap.keys()");
            this.data_ = new Map();
            this.hasMap_ = new Map();
            if (initialData) this.merge(initialData);
        });
    }
    has_(key) {
        return this.data_.has(key);
    }
    has(key) {
        if (!$316af70a850315f9$var$globalState.trackingDerivation) return this.has_(key);
        let entry = this.hasMap_.get(key);
        if (!entry) {
            const newEntry = entry = new $316af70a850315f9$var$ObservableValue(this.has_(key), $316af70a850315f9$var$referenceEnhancer, $316af70a850315f9$var$__MOBX_DEV__ ? `${this.name_}.${$316af70a850315f9$var$stringifyKey(key)}?` : "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            newEntry.onBUOL = new Set([
                ()=>this.hasMap_.delete(key)
            ]);
        }
        return entry.get();
    }
    set(key, value) {
        const hasKey = this.has_(key);
        if ($316af70a850315f9$var$hasInterceptors(this)) {
            const change = $316af70a850315f9$var$interceptChange(this, {
                type: hasKey ? $316af70a850315f9$var$UPDATE : $316af70a850315f9$var$ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    }
    delete(key) {
        $316af70a850315f9$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        if ($316af70a850315f9$var$hasInterceptors(this)) {
            const change = $316af70a850315f9$var$interceptChange(this, {
                type: $316af70a850315f9$var$DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            const notifySpy = $316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled();
            const notify = $316af70a850315f9$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: $316af70a850315f9$var$DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportStart(change);
             // TODO fix type
            $316af70a850315f9$export$2d62d2646dd2fb3c(()=>{
                var _this$hasMap_$get;
                this.keysAtom_.reportChanged();
                (_this$hasMap_$get = this.hasMap_.get(key)) == null || _this$hasMap_$get.set(false);
                const observable = this.data_.get(key);
                observable.setNewValue_(undefined);
                this.data_.delete(key);
            });
            if (notify) $316af70a850315f9$var$notifyListeners(this, change);
            if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportEnd();
            return true;
        }
        return false;
    }
    updateValue_(key, newValue) {
        const observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== $316af70a850315f9$var$globalState.UNCHANGED) {
            const notifySpy = $316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled();
            const notify = $316af70a850315f9$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: $316af70a850315f9$var$UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportStart(change);
             // TODO fix type
            observable.setNewValue_(newValue);
            if (notify) $316af70a850315f9$var$notifyListeners(this, change);
            if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportEnd();
        }
    }
    addValue_(key, newValue) {
        $316af70a850315f9$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        $316af70a850315f9$export$2d62d2646dd2fb3c(()=>{
            var _this$hasMap_$get2;
            const observable = new $316af70a850315f9$var$ObservableValue(newValue, this.enhancer_, $316af70a850315f9$var$__MOBX_DEV__ ? `${this.name_}.${$316af70a850315f9$var$stringifyKey(key)}` : "ObservableMap.key", false);
            this.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this$hasMap_$get2 = this.hasMap_.get(key)) == null || _this$hasMap_$get2.set(true);
            this.keysAtom_.reportChanged();
        });
        const notifySpy = $316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled();
        const notify = $316af70a850315f9$var$hasListeners(this);
        const change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: $316af70a850315f9$var$ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportStart(change);
         // TODO fix type
        if (notify) $316af70a850315f9$var$notifyListeners(this, change);
        if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportEnd();
    }
    get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    }
    getOrInsert(key, value) {
        if (!this.has(key)) this.set(key, value);
        return this.get(key);
    }
    getOrInsertComputed(key, callback) {
        if (!this.has(key)) this.set(key, callback(key));
        return this.get(key);
    }
    dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    }
    values() {
        const self = this;
        const keys = this.keys();
        return $316af70a850315f9$var$makeIterableForMap({
            next () {
                const { done: done, value: value } = keys.next();
                return {
                    done: done,
                    value: done ? undefined : self.get(value)
                };
            }
        });
    }
    entries() {
        const self = this;
        const keys = this.keys();
        return $316af70a850315f9$var$makeIterableForMap({
            next () {
                const { done: done, value: value } = keys.next();
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self.get(value)
                    ]
                };
            }
        });
    }
    [Symbol.iterator]() {
        return this.entries();
    }
    forEach(callback, thisArg) {
        for (const [key, value] of this)callback.call(thisArg, value, key, this);
    }
    /** Merge another object into this object, returns this. */ merge(other) {
        if ($316af70a850315f9$export$27a7faddcfd44960(other)) other = new Map(other);
        $316af70a850315f9$export$2d62d2646dd2fb3c(()=>{
            if ($316af70a850315f9$var$isPlainObject(other)) $316af70a850315f9$var$getPlainObjectKeys(other).forEach((key)=>this.set(key, other[key]));
            else if (Array.isArray(other)) other.forEach(([key, value])=>this.set(key, value));
            else if ($316af70a850315f9$var$isES6Map(other)) {
                if (!$316af70a850315f9$var$isPlainES6Map(other)) $316af70a850315f9$var$die(19, other);
                other.forEach((value, key)=>this.set(key, value));
            } else if (other !== null && other !== undefined) $316af70a850315f9$var$die(20, other);
        });
        return this;
    }
    clear() {
        $316af70a850315f9$export$2d62d2646dd2fb3c(()=>{
            $316af70a850315f9$export$8c437e4d572e2f99(()=>{
                for (const key of this.keys())this.delete(key);
            });
        });
    }
    replace(values) {
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        $316af70a850315f9$export$2d62d2646dd2fb3c(()=>{
            // Convert to map so we can do quick key lookups
            const replacementMap = $316af70a850315f9$var$convertToMap(values);
            const orderedData = new Map();
            // Used for optimization
            let keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for (const key of this.data_.keys())// Concurrently iterating/deleting keys
            // iterator should handle this correctly
            if (!replacementMap.has(key)) {
                const deleted = this.delete(key);
                // Was the key removed?
                if (deleted) // _keysAtom.reportChanged() was already called
                keysReportChangedCalled = true;
                else {
                    // Delete prevented by interceptor
                    const value = this.data_.get(key);
                    orderedData.set(key, value);
                }
            }
            // Merge entries
            for (const [key, value] of replacementMap.entries()){
                // We will want to know whether a new key is added
                const keyExisted = this.data_.has(key);
                // Add or update value
                this.set(key, value);
                // The addition could have been prevent by interceptor
                if (this.data_.has(key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    const _value = this.data_.get(key);
                    orderedData.set(key, _value);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (this.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                this.keysAtom_.reportChanged();
                else {
                    const iter1 = this.data_.keys();
                    const iter2 = orderedData.keys();
                    let next1 = iter1.next();
                    let next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            this.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            this.data_ = orderedData;
        });
        return this;
    }
    get size() {
        this.keysAtom_.reportObserved();
        return this.data_.size;
    }
    toString() {
        return "[object ObservableMap]";
    }
    toJSON() {
        return Array.from(this);
    }
    get [Symbol.toStringTag]() {
        return "Map";
    }
}
// eslint-disable-next-line
var $316af70a850315f9$export$27a7faddcfd44960 = /*#__PURE__*/ $316af70a850315f9$var$createInstanceofPredicate("ObservableMap", $316af70a850315f9$export$db1c0901f08fc6fd);
function $316af70a850315f9$var$makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return $316af70a850315f9$var$makeIterable(iterator);
}
function $316af70a850315f9$var$convertToMap(dataStructure) {
    if ($316af70a850315f9$var$isES6Map(dataStructure) || $316af70a850315f9$export$27a7faddcfd44960(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if ($316af70a850315f9$var$isPlainObject(dataStructure)) {
        const map = new Map();
        for(const key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return $316af70a850315f9$var$die(21, dataStructure);
}
const $316af70a850315f9$var$ObservableSetMarker = {};
class $316af70a850315f9$export$2235f602a7a77c81 {
    constructor(initialData, enhancer = $316af70a850315f9$var$deepEnhancer, name_ = $316af70a850315f9$var$__MOBX_DEV__ ? "ObservableSet@" + $316af70a850315f9$var$getNextId() : "ObservableSet"){
        this.name_ = void 0;
        this[$316af70a850315f9$export$f246528900dd4467] = $316af70a850315f9$var$ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        this.enhancer_ = (newV, oldV)=>enhancer(newV, oldV, name_);
        $316af70a850315f9$var$initObservable(()=>{
            this.atom_ = $316af70a850315f9$export$2e17fe64ec9a826e(this.name_);
            if (initialData) this.replace(initialData);
        });
    }
    dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    }
    clear() {
        $316af70a850315f9$export$2d62d2646dd2fb3c(()=>{
            $316af70a850315f9$export$8c437e4d572e2f99(()=>{
                for (const value of this.data_.values())this.delete(value);
            });
        });
    }
    forEach(callbackFn, thisArg) {
        for (const value of this)callbackFn.call(thisArg, value, value, this);
    }
    get size() {
        this.atom_.reportObserved();
        return this.data_.size;
    }
    add(value) {
        $316af70a850315f9$var$checkIfStateModificationsAreAllowed(this.atom_);
        if ($316af70a850315f9$var$hasInterceptors(this)) {
            const change = $316af70a850315f9$var$interceptChange(this, {
                type: $316af70a850315f9$var$ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            $316af70a850315f9$export$2d62d2646dd2fb3c(()=>{
                value = this.enhancer_(value, undefined); // report the stored value, like map and array
                this.data_.add(value);
                this.atom_.reportChanged();
            });
            const notifySpy = $316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled();
            const notify = $316af70a850315f9$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: $316af70a850315f9$var$ADD,
                object: this,
                newValue: value
            } : null;
            if (notifySpy && $316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$spyReportStart(change);
            if (notify) $316af70a850315f9$var$notifyListeners(this, change);
            if (notifySpy && $316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$spyReportEnd();
        }
        return this;
    }
    delete(value) {
        $316af70a850315f9$var$checkIfStateModificationsAreAllowed(this.atom_);
        if ($316af70a850315f9$var$hasInterceptors(this)) {
            const change = $316af70a850315f9$var$interceptChange(this, {
                type: $316af70a850315f9$var$DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            const notifySpy = $316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled();
            const notify = $316af70a850315f9$var$hasListeners(this);
            const change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: $316af70a850315f9$var$DELETE,
                object: this,
                oldValue: value
            } : null;
            if (notifySpy && $316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$spyReportStart(change);
            $316af70a850315f9$export$2d62d2646dd2fb3c(()=>{
                this.atom_.reportChanged();
                this.data_.delete(value);
            });
            if (notify) $316af70a850315f9$var$notifyListeners(this, change);
            if (notifySpy && $316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$spyReportEnd();
            return true;
        }
        return false;
    }
    has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    }
    entries() {
        const values = this.values();
        return $316af70a850315f9$var$makeIterableForSet({
            next () {
                const { value: value, done: done } = values.next();
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    }
    keys() {
        return this.values();
    }
    values() {
        this.atom_.reportObserved();
        const self = this;
        const values = this.data_.values();
        return $316af70a850315f9$var$makeIterableForSet({
            next () {
                const { value: value, done: done } = values.next();
                return !done ? {
                    value: self.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    }
    intersection(otherSet) {
        return new Set(this).intersection(otherSet);
    }
    union(otherSet) {
        return new Set(this).union(otherSet);
    }
    difference(otherSet) {
        return new Set(this).difference(otherSet);
    }
    symmetricDifference(otherSet) {
        return new Set(this).symmetricDifference(otherSet);
    }
    isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    }
    isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    }
    isDisjointFrom(otherSet) {
        return new Set(this).isDisjointFrom(otherSet);
    }
    replace(other) {
        if ($316af70a850315f9$export$da6b063694cb52c1(other)) other = new Set(other);
        if (Array.isArray(other) || $316af70a850315f9$var$isES6Set(other)) // Only emit `delete`/`add` events (and `reportChanged`) for values that
        // actually change, instead of clearing and re-adding everything. `add` and
        // `delete` are already no-ops for values that are respectively already
        // present or already absent, so we just need to avoid deleting values that
        // are part of the replacement. See #3761.
        $316af70a850315f9$export$2d62d2646dd2fb3c(()=>{
            // Collect the desired values for quick lookup. `other` is already a Set
            // here when it was passed (or snapshotted from an observable set) as one,
            // so reuse it rather than allocating another; arrays are wrapped (which
            // also dedupes them).
            const replacementValues = $316af70a850315f9$var$isES6Set(other) ? other : new Set(other);
            // Short-circuit the trivial cases: an empty replacement is just a clear,
            // and replacing into an empty set only needs the adds.
            if (replacementValues.size === 0) {
                this.clear();
                return;
            }
            if (this.data_.size === 0) {
                replacementValues.forEach((value)=>this.add(value));
                return;
            }
            // Delete values that are not part of the replacement.
            for (const value of this.data_.values())if (!replacementValues.has(this.dehanceValue_(value))) this.delete(value);
            // Add new values; values that are already present are a no-op.
            replacementValues.forEach((value)=>this.add(value));
        });
        else if (other !== null && other !== undefined) $316af70a850315f9$var$die(41, other);
        return this;
    }
    toJSON() {
        return Array.from(this);
    }
    toString() {
        return "[object ObservableSet]";
    }
    [Symbol.iterator]() {
        return this.values();
    }
    get [Symbol.toStringTag]() {
        return "Set";
    }
}
// eslint-disable-next-line
var $316af70a850315f9$export$da6b063694cb52c1 = /*#__PURE__*/ $316af70a850315f9$var$createInstanceofPredicate("ObservableSet", $316af70a850315f9$export$2235f602a7a77c81);
function $316af70a850315f9$var$makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return $316af70a850315f9$var$makeIterable(iterator);
}
const $316af70a850315f9$var$descriptorCache = /*#__PURE__*/ Object.create(null);
const $316af70a850315f9$var$REMOVE = "remove";
class $316af70a850315f9$var$ObservableObjectAdministration {
    constructor(target_, values_ = new Map(), name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_ = $316af70a850315f9$var$autoAnnotation){
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.lazyComputedKeys_ = void 0;
        // `null` once all fields were read, so `toJS` can tell objects with `@observable accessor` fields apart
        this.lazyObservableKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new $316af70a850315f9$var$Atom($316af70a850315f9$var$__MOBX_DEV__ ? `${this.name_}.keys` : "ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = $316af70a850315f9$var$isPlainObject(this.target_);
        if ($316af70a850315f9$var$__MOBX_DEV__ && !$316af70a850315f9$var$isAnnotation(this.defaultAnnotation_)) $316af70a850315f9$var$die(`defaultAnnotation must be valid annotation`);
        if ($316af70a850315f9$var$__MOBX_DEV__) // Prepare structure for tracking which fields were already annotated
        this.appliedAnnotations_ = {};
    }
    getObservablePropValue_(key) {
        var _ref, _this$values_$get;
        // Hot path: single map lookup. Lazy entries (rare) take the materialise branch.
        const observable = (_ref = (_this$values_$get = this.values_.get(key)) != null ? _this$values_$get : this.materializeLazyComputed_(key)) != null ? _ref : this.materializeLazyObservable_(key);
        return observable.get();
    }
    materializeLazyComputed_(key) {
        var _this$lazyComputedKey;
        const factory = (_this$lazyComputedKey = this.lazyComputedKeys_) == null ? void 0 : _this$lazyComputedKey.get(key);
        if (!factory) return undefined;
        this.lazyComputedKeys_.delete(key);
        if (this.lazyComputedKeys_.size === 0) this.lazyComputedKeys_ = undefined;
        const computed = factory();
        this.values_.set(key, computed);
        return computed;
    }
    materializeLazyObservable_(key) {
        var _this$lazyObservableK;
        const factory = (_this$lazyObservableK = this.lazyObservableKeys_) == null ? void 0 : _this$lazyObservableK.get(key);
        if (!factory) return undefined;
        this.lazyObservableKeys_.delete(key);
        if (this.lazyObservableKeys_.size === 0) this.lazyObservableKeys_ = null;
        const observable = factory();
        this.values_.set(key, observable);
        return observable;
    }
    setObservablePropValue_(key, newValue) {
        var _ref2, _this$values_$get2;
        const observable = (_ref2 = (_this$values_$get2 = this.values_.get(key)) != null ? _this$values_$get2 : this.materializeLazyComputed_(key)) != null ? _ref2 : this.materializeLazyObservable_(key);
        if (observable instanceof $316af70a850315f9$var$ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if ($316af70a850315f9$var$hasInterceptors(this)) {
            const change = $316af70a850315f9$var$interceptChange(this, {
                type: $316af70a850315f9$var$UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== $316af70a850315f9$var$globalState.UNCHANGED) {
            const notify = $316af70a850315f9$var$hasListeners(this);
            const notifySpy = $316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled();
            const change = notify || notifySpy ? {
                type: $316af70a850315f9$var$UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportStart(change);
            observable.setNewValue_(newValue);
            if (notify) $316af70a850315f9$var$notifyListeners(this, change);
            if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportEnd();
        }
        return true;
    }
    get_(key) {
        if ($316af70a850315f9$var$globalState.trackingDerivation && !$316af70a850315f9$var$hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    }
    /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ set_(key, value, proxyTrap = false) {
        // Don't use .has(key) - we care about own
        if ($316af70a850315f9$var$hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    }
    // Trap for "in"
    has_(key) {
        if (!$316af70a850315f9$var$globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        let entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new $316af70a850315f9$var$ObservableValue(key in this.target_, $316af70a850315f9$var$referenceEnhancer, $316af70a850315f9$var$__MOBX_DEV__ ? `${this.name_}.${$316af70a850315f9$var$stringifyKey(key)}?` : "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
            entry.onBUOL = new Set([
                ()=>{
                    var _this$pendingKeys_;
                    return (_this$pendingKeys_ = this.pendingKeys_) == null ? void 0 : _this$pendingKeys_.delete(key);
                }
            ]);
        }
        return entry.get();
    }
    /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ extend_(key, descriptor, annotation, proxyTrap = false) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        $316af70a850315f9$var$assertAnnotable(this, annotation, key);
        const outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) $316af70a850315f9$var$recordAnnotationApplied(this, annotation, key);
        return outcome;
    }
    /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ defineProperty_(key, descriptor, proxyTrap = false) {
        $316af70a850315f9$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            $316af70a850315f9$var$startBatch();
            // Delete
            const deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if ($316af70a850315f9$var$hasInterceptors(this)) {
                const change = $316af70a850315f9$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $316af70a850315f9$var$ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                const { newValue: newValue } = change;
                if (descriptor.value !== newValue) descriptor = $316af70a850315f9$var$assign({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $316af70a850315f9$var$defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            $316af70a850315f9$var$endBatch();
        }
        return true;
    }
    // If original descriptor becomes relevant, move this to annotation directly
    defineObservableProperty_(key, value, enhancer, proxyTrap = false) {
        $316af70a850315f9$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            $316af70a850315f9$var$startBatch();
            // Delete
            const deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if ($316af70a850315f9$var$hasInterceptors(this)) {
                const change = $316af70a850315f9$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $316af70a850315f9$var$ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            const cachedDescriptor = $316af70a850315f9$var$getCachedObservablePropDescriptor(key);
            const descriptor = {
                configurable: $316af70a850315f9$var$globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $316af70a850315f9$var$defineProperty(this.target_, key, descriptor);
            const observable = new $316af70a850315f9$var$ObservableValue(value, enhancer, $316af70a850315f9$var$__MOBX_DEV__ ? `${this.name_}.${key.toString()}` : "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            $316af70a850315f9$var$endBatch();
        }
        return true;
    }
    // If original descriptor becomes relevant, move this to annotation directly
    defineComputedProperty_(key, options, proxyTrap = false) {
        $316af70a850315f9$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            $316af70a850315f9$var$startBatch();
            // Delete
            const deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if ($316af70a850315f9$var$hasInterceptors(this)) {
                const change = $316af70a850315f9$var$interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: $316af70a850315f9$var$ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = $316af70a850315f9$var$__MOBX_DEV__ ? `${this.name_}.${key.toString()}` : "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            const cachedDescriptor = $316af70a850315f9$var$getCachedObservablePropDescriptor(key);
            const descriptor = {
                configurable: $316af70a850315f9$var$globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else $316af70a850315f9$var$defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new $316af70a850315f9$var$ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            $316af70a850315f9$var$endBatch();
        }
        return true;
    }
    /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ delete_(key, proxyTrap = false) {
        $316af70a850315f9$var$checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!$316af70a850315f9$var$hasProp(this.target_, key)) return true;
        // Intercept
        if ($316af70a850315f9$var$hasInterceptors(this)) {
            const change = $316af70a850315f9$var$interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: $316af70a850315f9$var$REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_2;
            $316af70a850315f9$var$startBatch();
            const notify = $316af70a850315f9$var$hasListeners(this);
            const notifySpy = $316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled();
            const observable = this.values_.get(key);
            // Value needed for spies/listeners
            let value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = $316af70a850315f9$var$getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Allow re-annotating this field
            if ($316af70a850315f9$var$__MOBX_DEV__) delete this.appliedAnnotations_[key];
            // Clear observable
            if (observable) {
                this.values_.delete(key);
                // for computed, value is undefined
                if (observable instanceof $316af70a850315f9$var$ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                $316af70a850315f9$var$propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                const change = {
                    type: $316af70a850315f9$var$REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportStart(change);
                if (notify) $316af70a850315f9$var$notifyListeners(this, change);
                if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportEnd();
            }
        } finally{
            $316af70a850315f9$var$endBatch();
        }
        return true;
    }
    notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_3;
        const notify = $316af70a850315f9$var$hasListeners(this);
        const notifySpy = $316af70a850315f9$var$__MOBX_DEV__ && $316af70a850315f9$var$isSpyEnabled();
        if (notify || notifySpy) {
            const change = notify || notifySpy ? {
                type: $316af70a850315f9$var$ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportStart(change);
            if (notify) $316af70a850315f9$var$notifyListeners(this, change);
            if ($316af70a850315f9$var$__MOBX_DEV__ && notifySpy) $316af70a850315f9$var$spyReportEnd();
        }
        (_this$pendingKeys_3 = this.pendingKeys_) == null || (_this$pendingKeys_3 = _this$pendingKeys_3.get(key)) == null || _this$pendingKeys_3.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    }
    ownKeys_() {
        this.keysAtom_.reportObserved();
        return $316af70a850315f9$var$ownKeys(this.target_);
    }
    keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    }
}
function $316af70a850315f9$var$asObservableObject(target, options) {
    var _options$name;
    if ($316af70a850315f9$var$__MOBX_DEV__ && options && $316af70a850315f9$export$31960fb081a18155(target)) $316af70a850315f9$var$die(`Options can't be provided for already observable objects.`);
    if ($316af70a850315f9$var$hasProp(target, $316af70a850315f9$export$f246528900dd4467)) {
        if ($316af70a850315f9$var$__MOBX_DEV__ && !($316af70a850315f9$export$71ff639cb8b2a36e(target) instanceof $316af70a850315f9$var$ObservableObjectAdministration)) $316af70a850315f9$var$die(`Cannot convert '${$316af70a850315f9$export$c48237bbccf30144(target)}' into observable object:` + `\nThe target is already observable of different type.` + `\nExtending builtins is not supported.`);
        return target;
    }
    if ($316af70a850315f9$var$__MOBX_DEV__ && !Object.isExtensible(target)) $316af70a850315f9$var$die("Cannot make the designated object observable; it is not extensible");
    const name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : $316af70a850315f9$var$__MOBX_DEV__ ? `${$316af70a850315f9$var$isPlainObject(target) ? "ObservableObject" : target.constructor.name}@${$316af70a850315f9$var$getNextId()}` : "ObservableObject";
    const adm = new $316af70a850315f9$var$ObservableObjectAdministration(target, new Map(), String(name), $316af70a850315f9$var$getAnnotationFromOptions(options));
    $316af70a850315f9$var$addHiddenProp(target, $316af70a850315f9$export$f246528900dd4467, adm);
    return target;
}
const $316af70a850315f9$var$isObservableObjectAdministration = /*#__PURE__*/ $316af70a850315f9$var$createInstanceofPredicate("ObservableObjectAdministration", $316af70a850315f9$var$ObservableObjectAdministration);
function $316af70a850315f9$var$getCachedObservablePropDescriptor(key) {
    return $316af70a850315f9$var$descriptorCache[key] || ($316af70a850315f9$var$descriptorCache[key] = {
        get () {
            return this[$316af70a850315f9$export$f246528900dd4467].getObservablePropValue_(key);
        },
        set (value) {
            return this[$316af70a850315f9$export$f246528900dd4467].setObservablePropValue_(key, value);
        }
    });
}
function $316af70a850315f9$export$31960fb081a18155(thing) {
    if ($316af70a850315f9$var$isObject(thing)) return $316af70a850315f9$var$isObservableObjectAdministration(thing[$316af70a850315f9$export$f246528900dd4467]);
    return false;
}
function $316af70a850315f9$var$recordAnnotationApplied(adm, annotation, key) {
    if ($316af70a850315f9$var$__MOBX_DEV__) adm.appliedAnnotations_[key] = annotation;
}
function $316af70a850315f9$var$assertAnnotable(adm, annotation, key) {
    // Valid annotation
    if ($316af70a850315f9$var$__MOBX_DEV__ && !$316af70a850315f9$var$isAnnotation(annotation)) $316af70a850315f9$var$die(`Cannot annotate '${adm.name_}.${key.toString()}': Invalid annotation.`);
    /*
  // Configurable, not sealed, not frozen
  // Possibly not needed, just a little better error then the one thrown by engine.
  // Cases where this would be useful the most (subclass field initializer) are not interceptable by this.
  if (__MOBX_DEV__) {
      const configurable = getDescriptor(adm.target_, key)?.configurable
      const frozen = Object.isFrozen(adm.target_)
      const sealed = Object.isSealed(adm.target_)
      if (!configurable || frozen || sealed) {
          const fieldName = `${adm.name_}.${key.toString()}`
          const requestedAnnotationType = annotation.annotationType_
          let error = `Cannot apply '${requestedAnnotationType}' to '${fieldName}':`
          if (frozen) {
              error += `\nObject is frozen.`
          }
          if (sealed) {
              error += `\nObject is sealed.`
          }
          if (!configurable) {
              error += `\nproperty is not configurable.`
              // Mention only if caused by us to avoid confusion
              if (hasProp(adm.appliedAnnotations!, key)) {
                  error += `\nTo prevent accidental re-definition of a field by a subclass, `
                  error += `all annotated fields of non-plain objects (classes) are not configurable.`
              }
          }
          die(error)
      }
  }
  */ // Not annotated
    if ($316af70a850315f9$var$__MOBX_DEV__ && !$316af70a850315f9$var$isOverride(annotation) && $316af70a850315f9$var$hasProp(adm.appliedAnnotations_, key)) {
        const fieldName = `${adm.name_}.${key.toString()}`;
        const currentAnnotationType = adm.appliedAnnotations_[key].annotationType_;
        const requestedAnnotationType = annotation.annotationType_;
        $316af70a850315f9$var$die(`Cannot apply '${requestedAnnotationType}' to '${fieldName}':` + `\nThe field is already annotated with '${currentAnnotationType}'.` + `\nRe-annotating fields is not allowed.` + `\nUse 'override' annotation for methods overridden by subclass.`);
    }
}
function $316af70a850315f9$export$25fc416d10fa1afa(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        // objects first: on a proxied object, the set/map checks would subscribe to missing keys
        const adm = thing[$316af70a850315f9$export$f246528900dd4467];
        if ($316af70a850315f9$var$isObservableObjectAdministration(adm)) {
            var _ref, _adm$values_$get;
            if (!property) return $316af70a850315f9$var$die(26);
            const observable = (_ref = (_adm$values_$get = adm.values_.get(property)) != null ? _adm$values_$get : adm.materializeLazyComputed_(property)) != null ? _ref : adm.materializeLazyObservable_(property);
            if (!observable) $316af70a850315f9$var$die(27, property, $316af70a850315f9$export$c48237bbccf30144(thing));
            return observable;
        }
        if ($316af70a850315f9$var$isObservableArrayAdministration(adm)) {
            if (property !== undefined) $316af70a850315f9$var$die(23);
            return adm.atom_;
        }
        if ($316af70a850315f9$export$da6b063694cb52c1(thing)) return thing.atom_;
        if ($316af70a850315f9$export$27a7faddcfd44960(thing)) {
            if (property === undefined) return thing.keysAtom_;
            const observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) $316af70a850315f9$var$die(25, property, $316af70a850315f9$export$c48237bbccf30144(thing));
            return observable;
        }
        if ($316af70a850315f9$export$31960fb081a18155(thing)) return $316af70a850315f9$export$25fc416d10fa1afa(thing, property);
        if ($316af70a850315f9$var$isAtom(thing) || $316af70a850315f9$var$isComputedValue(thing) || $316af70a850315f9$var$isReaction(thing)) return thing;
    } else if ($316af70a850315f9$var$isFunction(thing)) {
        if ($316af70a850315f9$var$isReaction(thing[$316af70a850315f9$export$f246528900dd4467])) // disposer function
        return thing[$316af70a850315f9$export$f246528900dd4467];
    }
    $316af70a850315f9$var$die(28);
}
function $316af70a850315f9$export$71ff639cb8b2a36e(thing, property) {
    if (!thing) $316af70a850315f9$var$die(29);
    if (property !== undefined) return $316af70a850315f9$export$71ff639cb8b2a36e($316af70a850315f9$export$25fc416d10fa1afa(thing, property));
    if ($316af70a850315f9$var$isAtom(thing) || $316af70a850315f9$var$isComputedValue(thing) || $316af70a850315f9$var$isReaction(thing)) return thing;
    if ($316af70a850315f9$export$27a7faddcfd44960(thing) || $316af70a850315f9$export$da6b063694cb52c1(thing)) return thing;
    if (thing[$316af70a850315f9$export$f246528900dd4467]) return thing[$316af70a850315f9$export$f246528900dd4467];
    $316af70a850315f9$var$die(24, thing);
}
function $316af70a850315f9$export$c48237bbccf30144(thing, property) {
    let named;
    if (property !== undefined) named = $316af70a850315f9$export$25fc416d10fa1afa(thing, property);
    else if ($316af70a850315f9$export$b956e38827fca970(thing)) return thing.name;
    else if ($316af70a850315f9$export$31960fb081a18155(thing) || $316af70a850315f9$export$27a7faddcfd44960(thing) || $316af70a850315f9$export$da6b063694cb52c1(thing)) named = $316af70a850315f9$export$71ff639cb8b2a36e(thing);
    else // valid for arrays as well
    named = $316af70a850315f9$export$25fc416d10fa1afa(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function $316af70a850315f9$var$initObservable(cb) {
    const derivation = $316af70a850315f9$var$untrackedStart();
    const allowStateChanges = $316af70a850315f9$var$__MOBX_DEV__ ? $316af70a850315f9$var$allowStateChangesStart(true) : true;
    $316af70a850315f9$var$startBatch();
    try {
        return cb();
    } finally{
        $316af70a850315f9$var$endBatch();
        if ($316af70a850315f9$var$__MOBX_DEV__) $316af70a850315f9$var$allowStateChangesEnd(allowStateChanges);
        $316af70a850315f9$var$untrackedEnd(derivation);
    }
}
const $316af70a850315f9$var$toString = $316af70a850315f9$var$objectPrototype.toString;
function $316af70a850315f9$var$deepEqual(a, b, depth = -1) {
    return $316af70a850315f9$var$eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function $316af70a850315f9$var$eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    const type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    const className = $316af70a850315f9$var$toString.call(a);
    if (className !== $316af70a850315f9$var$toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = $316af70a850315f9$var$unwrap(a);
    b = $316af70a850315f9$var$unwrap(b);
    const areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        const aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !($316af70a850315f9$var$isFunction(aCtor) && aCtor instanceof aCtor && $316af70a850315f9$var$isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    let length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!$316af70a850315f9$var$eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        const keys = Object.keys(a);
        const _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(let i = 0; i < _length; i++){
            // Deep compare each member
            const key = keys[i];
            if (!($316af70a850315f9$var$hasProp(b, key) && $316af70a850315f9$var$eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function $316af70a850315f9$var$unwrap(a) {
    if ($316af70a850315f9$export$f5afceff386badf9(a)) return a.slice();
    if ($316af70a850315f9$var$isES6Map(a) || $316af70a850315f9$export$27a7faddcfd44960(a)) return Array.from(a.entries());
    if ($316af70a850315f9$var$isES6Set(a) || $316af70a850315f9$export$da6b063694cb52c1(a)) return Array.from(a.entries());
    return a;
}
var $316af70a850315f9$var$_globalThis$Iterator;
// safely get iterator prototype if available
const $316af70a850315f9$var$maybeIteratorPrototype = (($316af70a850315f9$var$_globalThis$Iterator = globalThis.Iterator) == null ? void 0 : $316af70a850315f9$var$_globalThis$Iterator.prototype) || {};
function $316af70a850315f9$var$makeIterable(iterator) {
    iterator[Symbol.iterator] = $316af70a850315f9$var$getSelf;
    return $316af70a850315f9$var$assign(Object.create($316af70a850315f9$var$maybeIteratorPrototype), iterator);
}
function $316af70a850315f9$var$getSelf() {
    return this;
}
function $316af70a850315f9$var$isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && $316af70a850315f9$var$isFunction(thing.make_) && $316af70a850315f9$var$isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ if ($316af70a850315f9$var$__MOBX_DEV__) {
    const g = globalThis;
    [
        "Symbol",
        "Map",
        "Set",
        "Proxy"
    ].forEach((m)=>{
        if (typeof g[m] === "undefined") $316af70a850315f9$var$die(`MobX requires global '${m}' to be available or polyfilled`);
    });
}
if ($316af70a850315f9$var$__MOBX_DEV__ && typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: $316af70a850315f9$export$fcc0cd19e9fb2b4c,
    extras: {
        getDebugName: $316af70a850315f9$export$c48237bbccf30144
    },
    $mobx: $316af70a850315f9$export$f246528900dd4467
});

});

parcelRegister("2oNQQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OasVersion = void 0;
module.exports.bundleConfig = $1bf47e15f6c3e936$var$bundleConfig;
module.exports.bundle = $1bf47e15f6c3e936$var$bundle;
module.exports.bundleFromString = $1bf47e15f6c3e936$var$bundleFromString;
module.exports.bundleDocument = $1bf47e15f6c3e936$var$bundleDocument;
module.exports.mapTypeToComponent = $1bf47e15f6c3e936$var$mapTypeToComponent;

var $eWVgr = parcelRequire("eWVgr");

var $7tCfi = parcelRequire("7tCfi");

var $hlZ1o = parcelRequire("hlZ1o");

var $Q56OU = parcelRequire("Q56OU");

var $aSlQf = parcelRequire("aSlQf");

var $3EQkN = parcelRequire("3EQkN");

var $6uQoS = parcelRequire("6uQoS");

var $26kKc = parcelRequire("26kKc");

var $eONiY = parcelRequire("eONiY");

var $5c4Gg = parcelRequire("5c4Gg");

var $9DSmF = parcelRequire("9DSmF");

var $gTJQv = parcelRequire("gTJQv");

var $5sK27 = parcelRequire("5sK27");
var $1bf47e15f6c3e936$var$OasVersion;
(function(OasVersion) {
    OasVersion["Version2"] = "oas2";
    OasVersion["Version3_0"] = "oas3_0";
    OasVersion["Version3_1"] = "oas3_1";
})($1bf47e15f6c3e936$var$OasVersion || (module.exports.OasVersion = $1bf47e15f6c3e936$var$OasVersion = {}));
const $1bf47e15f6c3e936$var$bundleVisitor = (0, $7tCfi.normalizeVisitors)([
    {
        severity: 'error',
        ruleId: 'configBundler',
        visitor: {
            ref: {
                leave (node, ctx, resolved) {
                    $1bf47e15f6c3e936$var$replaceRef(node, resolved, ctx);
                }
            }
        }
    }
], $5sK27.NormalizedConfigTypes);
async function $1bf47e15f6c3e936$var$bundleConfig(document, resolvedRefMap) {
    const ctx = {
        problems: [],
        oasVersion: $aSlQf.SpecVersion.OAS3_0,
        refTypes: new Map(),
        visitorsData: {}
    };
    (0, $Q56OU.walkDocument)({
        document: document,
        rootType: $5sK27.NormalizedConfigTypes.ConfigRoot,
        normalizedVisitors: $1bf47e15f6c3e936$var$bundleVisitor,
        resolvedRefMap: resolvedRefMap,
        ctx: ctx
    });
    return document.parsed ?? {};
}
async function $1bf47e15f6c3e936$var$bundle(opts) {
    const { ref: ref, doc: doc, externalRefResolver: externalRefResolver = new $eWVgr.BaseResolver(opts.config.resolve), base: base = null } = opts;
    if (!(ref || doc)) throw new Error('Document or reference is required.\n');
    const document = doc === undefined ? await externalRefResolver.resolveDocument(base, ref, true) : doc;
    if (document instanceof Error) throw document;
    opts.collectSpecData?.(document.parsed);
    return $1bf47e15f6c3e936$var$bundleDocument({
        document: document,
        ...opts,
        config: opts.config.styleguide,
        externalRefResolver: externalRefResolver
    });
}
async function $1bf47e15f6c3e936$var$bundleFromString(opts) {
    const { source: source, absoluteRef: absoluteRef, externalRefResolver: externalRefResolver = new $eWVgr.BaseResolver(opts.config.resolve) } = opts;
    const document = (0, $eWVgr.makeDocumentFromString)(source, absoluteRef || '/');
    return $1bf47e15f6c3e936$var$bundleDocument({
        document: document,
        ...opts,
        externalRefResolver: externalRefResolver,
        config: opts.config.styleguide
    });
}
async function $1bf47e15f6c3e936$var$bundleDocument(opts) {
    const { document: document, config: config, customTypes: customTypes, externalRefResolver: externalRefResolver, dereference: dereference = false, skipRedoclyRegistryRefs: skipRedoclyRegistryRefs = false, removeUnusedComponents: removeUnusedComponents = false, keepUrlRefs: keepUrlRefs = false } = opts;
    const specVersion = (0, $aSlQf.detectSpec)(document.parsed);
    const specMajorVersion = (0, $aSlQf.getMajorSpecVersion)(specVersion);
    const rules = config.getRulesForSpecVersion(specMajorVersion);
    const types = (0, $hlZ1o.normalizeTypes)(config.extendTypes(customTypes ?? (0, $aSlQf.getTypes)(specVersion), specVersion), config);
    const preprocessors = (0, $6uQoS.initRules)(rules, config, 'preprocessors', specVersion);
    const decorators = (0, $6uQoS.initRules)(rules, config, 'decorators', specVersion);
    const ctx = {
        problems: [],
        oasVersion: specVersion,
        refTypes: new Map(),
        visitorsData: {}
    };
    if (removeUnusedComponents) decorators.push({
        severity: 'error',
        ruleId: 'remove-unused-components',
        visitor: specMajorVersion === $aSlQf.SpecMajorVersion.OAS2 ? (0, $9DSmF.RemoveUnusedComponents)({}) : (0, $gTJQv.RemoveUnusedComponents)({})
    });
    let resolvedRefMap = await (0, $eWVgr.resolveDocument)({
        rootDocument: document,
        rootType: types.Root,
        externalRefResolver: externalRefResolver
    });
    if (preprocessors.length > 0) {
        // Make additional pass to resolve refs defined in preprocessors.
        (0, $Q56OU.walkDocument)({
            document: document,
            rootType: types.Root,
            normalizedVisitors: (0, $7tCfi.normalizeVisitors)(preprocessors, types),
            resolvedRefMap: resolvedRefMap,
            ctx: ctx
        });
        resolvedRefMap = await (0, $eWVgr.resolveDocument)({
            rootDocument: document,
            rootType: types.Root,
            externalRefResolver: externalRefResolver
        });
    }
    const bundleVisitor = (0, $7tCfi.normalizeVisitors)([
        {
            severity: 'error',
            ruleId: 'bundler',
            visitor: $1bf47e15f6c3e936$var$makeBundleVisitor(specMajorVersion, dereference, skipRedoclyRegistryRefs, document, resolvedRefMap, keepUrlRefs)
        },
        ...decorators
    ], types);
    (0, $Q56OU.walkDocument)({
        document: document,
        rootType: types.Root,
        normalizedVisitors: bundleVisitor,
        resolvedRefMap: resolvedRefMap,
        ctx: ctx
    });
    return {
        bundle: document,
        problems: ctx.problems.map((problem)=>config.addProblemToIgnore(problem)),
        fileDependencies: externalRefResolver.getFiles(),
        rootType: types.Root,
        refTypes: ctx.refTypes,
        visitorsData: ctx.visitorsData
    };
}
function $1bf47e15f6c3e936$var$mapTypeToComponent(typeName, version) {
    switch(version){
        case $aSlQf.SpecMajorVersion.OAS3:
            switch(typeName){
                case 'Schema':
                    return 'schemas';
                case 'Parameter':
                    return 'parameters';
                case 'Response':
                    return 'responses';
                case 'Example':
                    return 'examples';
                case 'RequestBody':
                    return 'requestBodies';
                case 'Header':
                    return 'headers';
                case 'SecuritySchema':
                    return 'securitySchemes';
                case 'Link':
                    return 'links';
                case 'Callback':
                    return 'callbacks';
                default:
                    return null;
            }
        case $aSlQf.SpecMajorVersion.OAS2:
            switch(typeName){
                case 'Schema':
                    return 'definitions';
                case 'Parameter':
                    return 'parameters';
                case 'Response':
                    return 'responses';
                default:
                    return null;
            }
        case $aSlQf.SpecMajorVersion.Async2:
            switch(typeName){
                case 'Schema':
                    return 'schemas';
                case 'Parameter':
                    return 'parameters';
                default:
                    return null;
            }
        case $aSlQf.SpecMajorVersion.Async3:
            switch(typeName){
                case 'Schema':
                    return 'schemas';
                case 'Parameter':
                    return 'parameters';
                default:
                    return null;
            }
        case $aSlQf.SpecMajorVersion.Arazzo1:
            switch(typeName){
                case 'Root.workflows_items.parameters_items':
                case 'Root.workflows_items.steps_items.parameters_items':
                    return 'parameters';
                default:
                    return null;
            }
        case $aSlQf.SpecMajorVersion.Overlay1:
            typeName;
            return null;
    }
}
function $1bf47e15f6c3e936$var$replaceRef(ref, resolved, ctx) {
    if (!(0, $eONiY.isPlainObject)(resolved.node)) ctx.parent[ctx.key] = resolved.node;
    else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete ref.$ref;
        const obj = Object.assign({}, resolved.node, ref);
        Object.assign(ref, obj); // assign ref itself again so ref fields take precedence
    }
}
// function oas3Move
function $1bf47e15f6c3e936$var$makeBundleVisitor(version, dereference, skipRedoclyRegistryRefs, rootDocument, resolvedRefMap, keepUrlRefs) {
    let components;
    let rootLocation;
    const visitor = {
        ref: {
            leave (node, ctx, resolved) {
                if (!resolved.location || resolved.node === undefined) {
                    (0, $26kKc.reportUnresolvedRef)(resolved, ctx.report, ctx.location);
                    return;
                }
                if (resolved.location.source === rootDocument.source && resolved.location.source === ctx.location.source && ctx.type.name !== 'scalar' && !dereference) return;
                // do not bundle registry URL before push, otherwise we can't record dependencies
                if (skipRedoclyRegistryRefs && (0, $5c4Gg.isRedoclyRegistryURL)(node.$ref)) return;
                if (keepUrlRefs && (0, $3EQkN.isAbsoluteUrl)(node.$ref)) return;
                const componentType = $1bf47e15f6c3e936$var$mapTypeToComponent(ctx.type.name, version);
                if (!componentType) $1bf47e15f6c3e936$var$replaceRef(node, resolved, ctx);
                else if (dereference) {
                    saveComponent(componentType, resolved, ctx);
                    $1bf47e15f6c3e936$var$replaceRef(node, resolved, ctx);
                } else {
                    node.$ref = saveComponent(componentType, resolved, ctx);
                    resolveBundledComponent(node, resolved, ctx);
                }
            }
        },
        Example: {
            leave (node, ctx) {
                if ((0, $3EQkN.isExternalValue)(node) && node.value === undefined) {
                    const resolved = ctx.resolve({
                        $ref: node.externalValue
                    });
                    if (!resolved.location || resolved.node === undefined) {
                        (0, $26kKc.reportUnresolvedRef)(resolved, ctx.report, ctx.location);
                        return;
                    }
                    if (keepUrlRefs && (0, $3EQkN.isAbsoluteUrl)(node.externalValue)) return;
                    node.value = ctx.resolve({
                        $ref: node.externalValue
                    }).node;
                    delete node.externalValue;
                }
            }
        },
        Root: {
            enter (root, ctx) {
                rootLocation = ctx.location;
                if (version === $aSlQf.SpecMajorVersion.OAS3) components = root.components = root.components || {};
                else if (version === $aSlQf.SpecMajorVersion.OAS2) components = root;
                else if (version === $aSlQf.SpecMajorVersion.Async2) components = root.components = root.components || {};
                else if (version === $aSlQf.SpecMajorVersion.Async3) components = root.components = root.components || {};
                else if (version === $aSlQf.SpecMajorVersion.Arazzo1) components = root.components = root.components || {};
            }
        }
    };
    if (version === $aSlQf.SpecMajorVersion.OAS3) visitor.DiscriminatorMapping = {
        leave (mapping, ctx) {
            for (const name of Object.keys(mapping)){
                const $ref = mapping[name];
                const resolved = ctx.resolve({
                    $ref: $ref
                });
                if (!resolved.location || resolved.node === undefined) {
                    (0, $26kKc.reportUnresolvedRef)(resolved, ctx.report, ctx.location.child(name));
                    return;
                }
                const componentType = $1bf47e15f6c3e936$var$mapTypeToComponent('Schema', version);
                mapping[name] = saveComponent(componentType, resolved, ctx);
            }
        }
    };
    function resolveBundledComponent(node, resolved, ctx) {
        const newRefId = (0, $eWVgr.makeRefId)(ctx.location.source.absoluteRef, node.$ref);
        resolvedRefMap.set(newRefId, {
            document: rootDocument,
            isRemote: false,
            node: resolved.node,
            nodePointer: node.$ref,
            resolved: true
        });
    }
    function saveComponent(componentType, target, ctx) {
        components[componentType] = components[componentType] || {};
        const name = getComponentName(target, componentType, ctx);
        components[componentType][name] = target.node;
        if (version === $aSlQf.SpecMajorVersion.OAS3 || version === $aSlQf.SpecMajorVersion.Async2 || version === $aSlQf.SpecMajorVersion.Async3) return `#/components/${componentType}/${name}`;
        else return `#/${componentType}/${name}`;
    }
    function isEqualOrEqualRef(node, target, ctx) {
        if ((0, $3EQkN.isRef)(node) && ctx.resolve(node, rootLocation.absolutePointer).location?.absolutePointer === target.location.absolutePointer) return true;
        return (0, $eONiY.dequal)(node, target.node);
    }
    function getComponentName(target, componentType, ctx) {
        const [fileRef, pointer] = [
            target.location.source.absoluteRef,
            target.location.pointer
        ];
        const componentsGroup = components[componentType];
        let name = '';
        const refParts = pointer.slice(2).split('/').filter($eONiY.isTruthy); // slice(2) removes "#/"
        while(refParts.length > 0){
            name = refParts.pop() + (name ? `-${name}` : '');
            if (!componentsGroup || !componentsGroup[name] || isEqualOrEqualRef(componentsGroup[name], target, ctx)) return name;
        }
        name = (0, $3EQkN.refBaseName)(fileRef) + (name ? `_${name}` : '');
        if (!componentsGroup[name] || isEqualOrEqualRef(componentsGroup[name], target, ctx)) return name;
        const prevName = name;
        let serialId = 2;
        while(componentsGroup[name] && !isEqualOrEqualRef(componentsGroup[name], target, ctx)){
            name = `${prevName}-${serialId}`;
            serialId++;
        }
        if (!componentsGroup[name]) ctx.report({
            message: `Two schemas are referenced with the same name but different content. Renamed ${prevName} to ${name}.`,
            location: ctx.location,
            forceSeverity: 'warn'
        });
        return name;
    }
    return visitor;
}

});
parcelRegister("eWVgr", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseResolver = module.exports.YamlParseError = module.exports.ResolveError = module.exports.Source = void 0;
module.exports.makeRefId = $ae22e6eeca7040ab$var$makeRefId;
module.exports.makeDocumentFromString = $ae22e6eeca7040ab$var$makeDocumentFromString;
module.exports.resolveDocument = $ae22e6eeca7040ab$var$resolveDocument;

var $kjyEk = parcelRequire("kjyEk");

var $59kwG = parcelRequire("59kwG");

var $3EQkN = parcelRequire("3EQkN");

var $hlZ1o = parcelRequire("hlZ1o");

var $eONiY = parcelRequire("eONiY");
class $ae22e6eeca7040ab$var$Source {
    constructor(absoluteRef, body, mimeType){
        this.absoluteRef = absoluteRef;
        this.body = body;
        this.mimeType = mimeType;
    }
    // pass safeLoad as argument to separate it from browser bundle
    getAst(safeLoad) {
        if (this._ast === undefined) {
            this._ast = safeLoad(this.body, {
                filename: this.absoluteRef
            }) ?? undefined;
            // fix ast representation of file with newlines only
            if (this._ast && this._ast.kind === 0 && // KIND.scalar = 0
            this._ast.value === '' && this._ast.startPosition !== 1) {
                this._ast.startPosition = 1;
                this._ast.endPosition = 1;
            }
        }
        return this._ast;
    }
    getLines() {
        if (this._lines === undefined) this._lines = this.body.split(/\r\n|[\n\r]/g);
        return this._lines;
    }
}
module.exports.Source = $ae22e6eeca7040ab$var$Source;
class $ae22e6eeca7040ab$var$ResolveError extends Error {
    constructor(originalError){
        super(originalError.message);
        this.originalError = originalError;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $ae22e6eeca7040ab$var$ResolveError.prototype);
    }
}
module.exports.ResolveError = $ae22e6eeca7040ab$var$ResolveError;
const $ae22e6eeca7040ab$var$jsYamlErrorLineColRegexp = /\((\d+):(\d+)\)$/;
class $ae22e6eeca7040ab$var$YamlParseError extends Error {
    constructor(originalError, source){
        super(originalError.message.split('\n')[0]);
        this.originalError = originalError;
        this.source = source;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $ae22e6eeca7040ab$var$YamlParseError.prototype);
        const [, line, col] = this.message.match($ae22e6eeca7040ab$var$jsYamlErrorLineColRegexp) || [];
        this.line = parseInt(line, 10);
        this.col = parseInt(col, 10);
    }
}
module.exports.YamlParseError = $ae22e6eeca7040ab$var$YamlParseError;
function $ae22e6eeca7040ab$var$makeRefId(absoluteRef, pointer) {
    return absoluteRef + '::' + pointer;
}
function $ae22e6eeca7040ab$var$makeDocumentFromString(sourceString, absoluteRef) {
    const source = new $ae22e6eeca7040ab$var$Source(absoluteRef, sourceString);
    try {
        return {
            source: source,
            parsed: (0, $eONiY.parseYaml)(sourceString, {
                filename: absoluteRef
            })
        };
    } catch (e) {
        throw new $ae22e6eeca7040ab$var$YamlParseError(e, source);
    }
}
class $ae22e6eeca7040ab$var$BaseResolver {
    constructor(config = {
        http: {
            headers: []
        }
    }){
        this.config = config;
        this.cache = new Map();
    }
    getFiles() {
        return new Set(Array.from(this.cache.keys()));
    }
    resolveExternalRef(base, ref) {
        if ((0, $3EQkN.isAbsoluteUrl)(ref)) return ref;
        if (base && (0, $3EQkN.isAbsoluteUrl)(base)) return new URL(ref, base).href;
        return $59kwG.resolve(base ? $59kwG.dirname(base) : $hPtJY.cwd(), ref);
    }
    async loadExternalRef(absoluteRef) {
        try {
            if ((0, $3EQkN.isAbsoluteUrl)(absoluteRef)) {
                const { body: body, mimeType: mimeType } = await (0, $eONiY.readFileFromUrl)(absoluteRef, this.config.http);
                return new $ae22e6eeca7040ab$var$Source(absoluteRef, body, mimeType);
            } else {
                if ($kjyEk.lstatSync(absoluteRef).isDirectory()) throw new Error(`Expected a file but received a folder at ${absoluteRef}.`);
                const content = await $kjyEk.promises.readFile(absoluteRef, 'utf-8');
                // In some cases file have \r\n line delimeters like on windows, we should skip it.
                return new $ae22e6eeca7040ab$var$Source(absoluteRef, content.replace(/\r\n/g, '\n'));
            }
        } catch (error) {
            error.message = error.message.replace(', lstat', '');
            throw new $ae22e6eeca7040ab$var$ResolveError(error);
        }
    }
    parseDocument(source, isRoot = false) {
        const ext = source.absoluteRef.substr(source.absoluteRef.lastIndexOf('.'));
        if (![
            '.json',
            '.json',
            '.yml',
            '.yaml'
        ].includes(ext) && !source.mimeType?.match(/(json|yaml|openapi)/) && !isRoot // always parse root
        ) return {
            source: source,
            parsed: source.body
        };
        try {
            return {
                source: source,
                parsed: (0, $eONiY.parseYaml)(source.body, {
                    filename: source.absoluteRef
                })
            };
        } catch (e) {
            throw new $ae22e6eeca7040ab$var$YamlParseError(e, source);
        }
    }
    async resolveDocument(base, ref, isRoot = false) {
        const absoluteRef = this.resolveExternalRef(base, ref);
        const cachedDocument = this.cache.get(absoluteRef);
        if (cachedDocument) return cachedDocument;
        const doc = this.loadExternalRef(absoluteRef).then((source)=>{
            return this.parseDocument(source, isRoot);
        });
        this.cache.set(absoluteRef, doc);
        return doc;
    }
}
module.exports.BaseResolver = $ae22e6eeca7040ab$var$BaseResolver;
function $ae22e6eeca7040ab$var$pushRef(head, node) {
    return {
        prev: head,
        node: node
    };
}
function $ae22e6eeca7040ab$var$hasRef(head, node) {
    while(head){
        if (head.node === node) return true;
        head = head.prev;
    }
    return false;
}
const $ae22e6eeca7040ab$var$unknownType = {
    name: 'unknown',
    properties: {}
};
const $ae22e6eeca7040ab$var$resolvableScalarType = {
    name: 'scalar',
    properties: {}
};
async function $ae22e6eeca7040ab$var$resolveDocument(opts) {
    const { rootDocument: rootDocument, externalRefResolver: externalRefResolver, rootType: rootType } = opts;
    const resolvedRefMap = new Map();
    const seenNodes = new Set(); // format "${type}::${absoluteRef}${pointer}"
    const resolvePromises = [];
    resolveRefsInParallel(rootDocument.parsed, rootDocument, '#/', rootType);
    let resolved;
    do resolved = await Promise.all(resolvePromises);
    while (resolvePromises.length !== resolved.length);
    return resolvedRefMap;
    function resolveRefsInParallel(rootNode, rootNodeDocument, rootNodePointer, type) {
        const rootNodeDocAbsoluteRef = rootNodeDocument.source.absoluteRef;
        const anchorRefsMap = new Map();
        walk(rootNode, type, rootNodeDocAbsoluteRef + rootNodePointer);
        function walk(node, type, nodeAbsoluteRef) {
            if (typeof node !== 'object' || node === null) return;
            const nodeId = `${type.name}::${nodeAbsoluteRef}`;
            if (seenNodes.has(nodeId)) return;
            seenNodes.add(nodeId);
            const [_, anchor] = Object.entries(node).find(([key])=>key === '$anchor') || [];
            if (anchor) anchorRefsMap.set(`#${anchor}`, node);
            if (Array.isArray(node)) {
                const itemsType = type.items;
                // we continue resolving unknown types, but stop early on known scalars
                if (itemsType === undefined && type !== $ae22e6eeca7040ab$var$unknownType && type !== $hlZ1o.SpecExtension) return;
                const isTypeAFunction = typeof itemsType === 'function';
                for(let i = 0; i < node.length; i++){
                    const itemType = isTypeAFunction ? itemsType(node[i], (0, $3EQkN.joinPointer)(nodeAbsoluteRef, i)) : itemsType;
                    // we continue resolving unknown types, but stop early on known scalars
                    if (itemType === undefined && type !== $ae22e6eeca7040ab$var$unknownType && type !== $hlZ1o.SpecExtension) continue;
                    walk(node[i], (0, $hlZ1o.isNamedType)(itemType) ? itemType : $ae22e6eeca7040ab$var$unknownType, (0, $3EQkN.joinPointer)(nodeAbsoluteRef, i));
                }
                return;
            }
            for (const propName of Object.keys(node)){
                let propValue = node[propName];
                let propType = type.properties[propName];
                if (propType === undefined) propType = type.additionalProperties;
                if (typeof propType === 'function') propType = propType(propValue, propName);
                if (propType === undefined) propType = $ae22e6eeca7040ab$var$unknownType;
                if (type.extensionsPrefix && propName.startsWith(type.extensionsPrefix) && propType === $ae22e6eeca7040ab$var$unknownType) propType = $hlZ1o.SpecExtension;
                if (!(0, $hlZ1o.isNamedType)(propType) && propType?.directResolveAs) {
                    propType = propType.directResolveAs;
                    propValue = {
                        $ref: propValue
                    };
                }
                if (propType && propType.name === undefined && propType.resolvable !== false) propType = $ae22e6eeca7040ab$var$resolvableScalarType;
                if (!(0, $hlZ1o.isNamedType)(propType) || typeof propValue !== 'object') continue;
                walk(propValue, propType, (0, $3EQkN.joinPointer)(nodeAbsoluteRef, (0, $3EQkN.escapePointer)(propName)));
            }
            if ((0, $3EQkN.isRef)(node)) {
                const promise = followRef(rootNodeDocument, node, {
                    prev: null,
                    node: node
                }).then((resolvedRef)=>{
                    if (resolvedRef.resolved) resolveRefsInParallel(resolvedRef.node, resolvedRef.document, resolvedRef.nodePointer, type);
                });
                resolvePromises.push(promise);
            }
            // handle example.externalValue as reference
            if ((0, $3EQkN.isExternalValue)(node)) {
                const promise = followRef(rootNodeDocument, {
                    $ref: node.externalValue
                }, {
                    prev: null,
                    node: node
                }).then((resolvedRef)=>{
                    if (resolvedRef.resolved) resolveRefsInParallel(resolvedRef.node, resolvedRef.document, resolvedRef.nodePointer, type);
                });
                resolvePromises.push(promise);
            }
        }
        async function followRef(document, ref, refStack) {
            if ($ae22e6eeca7040ab$var$hasRef(refStack.prev, ref)) throw new Error('Self-referencing circular pointer');
            if ((0, $3EQkN.isAnchor)(ref.$ref)) {
                // Wait for all anchors in the document to be collected firstly.
                await (0, $eONiY.nextTick)();
                const resolvedRef = {
                    resolved: true,
                    isRemote: false,
                    node: anchorRefsMap.get(ref.$ref),
                    document: document,
                    nodePointer: ref.$ref
                };
                const refId = $ae22e6eeca7040ab$var$makeRefId(document.source.absoluteRef, ref.$ref);
                resolvedRefMap.set(refId, resolvedRef);
                return resolvedRef;
            }
            const { uri: uri, pointer: pointer } = (0, $3EQkN.parseRef)(ref.$ref);
            const isRemote = uri !== null;
            let targetDoc;
            try {
                targetDoc = isRemote ? await externalRefResolver.resolveDocument(document.source.absoluteRef, uri) : document;
            } catch (error) {
                const resolvedRef = {
                    resolved: false,
                    isRemote: isRemote,
                    document: undefined,
                    error: error
                };
                const refId = $ae22e6eeca7040ab$var$makeRefId(document.source.absoluteRef, ref.$ref);
                resolvedRefMap.set(refId, resolvedRef);
                return resolvedRef;
            }
            let resolvedRef = {
                resolved: true,
                document: targetDoc,
                isRemote: isRemote,
                node: document.parsed,
                nodePointer: '#/'
            };
            let target = targetDoc.parsed;
            const segments = pointer;
            for (const segment of segments){
                if (typeof target !== 'object') {
                    target = undefined;
                    break;
                } else if (target[segment] !== undefined) {
                    target = target[segment];
                    resolvedRef.nodePointer = (0, $3EQkN.joinPointer)(resolvedRef.nodePointer, (0, $3EQkN.escapePointer)(segment));
                } else if ((0, $3EQkN.isRef)(target)) {
                    resolvedRef = await followRef(targetDoc, target, $ae22e6eeca7040ab$var$pushRef(refStack, target));
                    targetDoc = resolvedRef.document || targetDoc;
                    if (typeof resolvedRef.node !== 'object') {
                        target = undefined;
                        break;
                    }
                    target = resolvedRef.node[segment];
                    resolvedRef.nodePointer = (0, $3EQkN.joinPointer)(resolvedRef.nodePointer, (0, $3EQkN.escapePointer)(segment));
                } else {
                    target = undefined;
                    break;
                }
            }
            resolvedRef.node = target;
            resolvedRef.document = targetDoc;
            const refId = $ae22e6eeca7040ab$var$makeRefId(document.source.absoluteRef, ref.$ref);
            if (resolvedRef.document && (0, $3EQkN.isRef)(target)) resolvedRef = await followRef(resolvedRef.document, target, $ae22e6eeca7040ab$var$pushRef(refStack, target));
            resolvedRefMap.set(refId, resolvedRef);
            return {
                ...resolvedRef
            };
        }
    }
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("59kwG", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $hPtJY.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return '';
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
module.exports = $3bfdb7183e8721d6$var$posix;

});

parcelRegister("3EQkN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Location = void 0;
module.exports.joinPointer = $2a9db40f929f3b79$var$joinPointer;
module.exports.isRef = $2a9db40f929f3b79$var$isRef;
module.exports.isExternalValue = $2a9db40f929f3b79$var$isExternalValue;
module.exports.unescapePointer = $2a9db40f929f3b79$var$unescapePointer;
module.exports.escapePointer = $2a9db40f929f3b79$var$escapePointer;
module.exports.parseRef = $2a9db40f929f3b79$var$parseRef;
module.exports.parsePointer = $2a9db40f929f3b79$var$parsePointer;
module.exports.pointerBaseName = $2a9db40f929f3b79$var$pointerBaseName;
module.exports.refBaseName = $2a9db40f929f3b79$var$refBaseName;
module.exports.isAbsoluteUrl = $2a9db40f929f3b79$var$isAbsoluteUrl;
module.exports.isMappingRef = $2a9db40f929f3b79$var$isMappingRef;
module.exports.isAnchor = $2a9db40f929f3b79$var$isAnchor;

var $eONiY = parcelRequire("eONiY");
function $2a9db40f929f3b79$var$joinPointer(base, key) {
    if (base === '') base = '#/';
    return base[base.length - 1] === '/' ? base + key : base + '/' + key;
}
function $2a9db40f929f3b79$var$isRef(node) {
    return (0, $eONiY.isPlainObject)(node) && typeof node.$ref === 'string';
}
function $2a9db40f929f3b79$var$isExternalValue(node) {
    return (0, $eONiY.isPlainObject)(node) && typeof node.externalValue === 'string';
}
class $2a9db40f929f3b79$var$Location {
    constructor(source, pointer){
        this.source = source;
        this.pointer = pointer;
    }
    child(components) {
        return new $2a9db40f929f3b79$var$Location(this.source, $2a9db40f929f3b79$var$joinPointer(this.pointer, (Array.isArray(components) ? components : [
            components
        ]).map($2a9db40f929f3b79$var$escapePointer).join('/')));
    }
    key() {
        return {
            ...this,
            reportOnKey: true
        };
    }
    get absolutePointer() {
        return this.source.absoluteRef + (this.pointer === '#/' ? '' : this.pointer);
    }
}
module.exports.Location = $2a9db40f929f3b79$var$Location;
function $2a9db40f929f3b79$var$unescapePointer(fragment) {
    return decodeURIComponent(fragment.replace(/~1/g, '/').replace(/~0/g, '~'));
}
function $2a9db40f929f3b79$var$escapePointer(fragment) {
    if (typeof fragment === 'number') return fragment;
    return fragment.replace(/~/g, '~0').replace(/\//g, '~1');
}
function $2a9db40f929f3b79$var$parseRef(ref) {
    const [uri, pointer = ''] = ref.split('#/');
    return {
        uri: (uri.endsWith('#') ? uri.slice(0, -1) : uri) || null,
        pointer: $2a9db40f929f3b79$var$parsePointer(pointer)
    };
}
function $2a9db40f929f3b79$var$parsePointer(pointer) {
    return pointer.split('/').map($2a9db40f929f3b79$var$unescapePointer).filter($eONiY.isTruthy);
}
function $2a9db40f929f3b79$var$pointerBaseName(pointer) {
    const parts = pointer.split('/');
    return parts[parts.length - 1];
}
function $2a9db40f929f3b79$var$refBaseName(ref) {
    // eslint-disable-next-line no-useless-escape
    const parts = ref.split(/[\/\\]/); // split by '\' and '/'
    return parts[parts.length - 1].replace(/\.[^.]+$/, ''); // replace extension with empty string
}
function $2a9db40f929f3b79$var$isAbsoluteUrl(ref) {
    return ref.startsWith('http://') || ref.startsWith('https://');
}
function $2a9db40f929f3b79$var$isMappingRef(mapping) {
    // TODO: proper detection of mapping refs
    return mapping.startsWith('#') || mapping.startsWith('https://') || mapping.startsWith('http://') || mapping.startsWith('./') || mapping.startsWith('../') || mapping.indexOf('/') > -1;
}
function $2a9db40f929f3b79$var$isAnchor(ref) {
    return /^#[A-Za-z][A-Za-z0-9\-_:.]*$/.test(ref);
}

});
parcelRegister("eONiY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignConfig = module.exports.stringifyYaml = module.exports.parseYaml = void 0;
module.exports.pushStack = $ac9bfb26c54b5c5c$var$pushStack;
module.exports.pluralize = $ac9bfb26c54b5c5c$var$pluralize;
module.exports.popStack = $ac9bfb26c54b5c5c$var$popStack;
module.exports.loadYaml = $ac9bfb26c54b5c5c$var$loadYaml;
module.exports.isDefined = $ac9bfb26c54b5c5c$var$isDefined;
module.exports.isPlainObject = $ac9bfb26c54b5c5c$var$isPlainObject;
module.exports.isEmptyObject = $ac9bfb26c54b5c5c$var$isEmptyObject;
module.exports.isNotEmptyObject = $ac9bfb26c54b5c5c$var$isNotEmptyObject;
module.exports.isEmptyArray = $ac9bfb26c54b5c5c$var$isEmptyArray;
module.exports.isNotEmptyArray = $ac9bfb26c54b5c5c$var$isNotEmptyArray;
module.exports.readFileFromUrl = $ac9bfb26c54b5c5c$var$readFileFromUrl;
module.exports.pickObjectProps = $ac9bfb26c54b5c5c$var$pickObjectProps;
module.exports.omitObjectProps = $ac9bfb26c54b5c5c$var$omitObjectProps;
module.exports.splitCamelCaseIntoWords = $ac9bfb26c54b5c5c$var$splitCamelCaseIntoWords;
module.exports.validateMimeType = $ac9bfb26c54b5c5c$var$validateMimeType;
module.exports.validateMimeTypeOAS3 = $ac9bfb26c54b5c5c$var$validateMimeTypeOAS3;
module.exports.readFileAsStringSync = $ac9bfb26c54b5c5c$var$readFileAsStringSync;
module.exports.yamlAndJsonSyncReader = $ac9bfb26c54b5c5c$var$yamlAndJsonSyncReader;
module.exports.isPathParameter = $ac9bfb26c54b5c5c$var$isPathParameter;
module.exports.slash = $ac9bfb26c54b5c5c$var$slash;
module.exports.isString = $ac9bfb26c54b5c5c$var$isString;
module.exports.isNotString = $ac9bfb26c54b5c5c$var$isNotString;
module.exports.assignOnlyExistingConfig = $ac9bfb26c54b5c5c$var$assignOnlyExistingConfig;
module.exports.getMatchingStatusCodeRange = $ac9bfb26c54b5c5c$var$getMatchingStatusCodeRange;
module.exports.isCustomRuleId = $ac9bfb26c54b5c5c$var$isCustomRuleId;
module.exports.doesYamlFileExist = $ac9bfb26c54b5c5c$var$doesYamlFileExist;
module.exports.showWarningForDeprecatedField = $ac9bfb26c54b5c5c$var$showWarningForDeprecatedField;
module.exports.showErrorForDeprecatedField = $ac9bfb26c54b5c5c$var$showErrorForDeprecatedField;
module.exports.isTruthy = $ac9bfb26c54b5c5c$var$isTruthy;
module.exports.identity = $ac9bfb26c54b5c5c$var$identity;
module.exports.keysOf = $ac9bfb26c54b5c5c$var$keysOf;
module.exports.pickDefined = $ac9bfb26c54b5c5c$var$pickDefined;
module.exports.nextTick = $ac9bfb26c54b5c5c$var$nextTick;
module.exports.pause = $ac9bfb26c54b5c5c$var$pause;
module.exports.getProxyAgent = $ac9bfb26c54b5c5c$var$getProxyAgent;
module.exports.dequal = $ac9bfb26c54b5c5c$var$dequal;

var $kjyEk = parcelRequire("kjyEk");

var $59kwG = parcelRequire("59kwG");

var $d9mF6 = parcelRequire("d9mF6");

var $64y7M = parcelRequire("64y7M");

var $3fhVa = parcelRequire("3fhVa");

var $lX2nX = parcelRequire("lX2nX");

var $kjyEk = parcelRequire("kjyEk");

var $b3nWb = parcelRequire("b3nWb");

var $64y7M = parcelRequire("64y7M");
Object.defineProperty(module.exports, "parseYaml", {
    enumerable: true,
    get: function() {
        return $64y7M.parseYaml;
    }
});
Object.defineProperty(module.exports, "stringifyYaml", {
    enumerable: true,
    get: function() {
        return $64y7M.stringifyYaml;
    }
});
function $ac9bfb26c54b5c5c$var$pushStack(head, value) {
    return {
        prev: head,
        value: value
    };
}
function $ac9bfb26c54b5c5c$var$pluralize(sentence, count, inclusive) {
    return sentence.split(' ').map((word)=>$b3nWb(word, count, inclusive)).join(' ');
}
function $ac9bfb26c54b5c5c$var$popStack(head) {
    return head?.prev ?? null;
}
async function $ac9bfb26c54b5c5c$var$loadYaml(filename) {
    const contents = await $kjyEk.promises.readFile(filename, 'utf-8');
    return (0, $64y7M.parseYaml)(contents);
}
function $ac9bfb26c54b5c5c$var$isDefined(x) {
    return x !== undefined;
}
function $ac9bfb26c54b5c5c$var$isPlainObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
function $ac9bfb26c54b5c5c$var$isEmptyObject(value) {
    return $ac9bfb26c54b5c5c$var$isPlainObject(value) && Object.keys(value).length === 0;
}
function $ac9bfb26c54b5c5c$var$isNotEmptyObject(obj) {
    return $ac9bfb26c54b5c5c$var$isPlainObject(obj) && !$ac9bfb26c54b5c5c$var$isEmptyObject(obj);
}
function $ac9bfb26c54b5c5c$var$isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
}
function $ac9bfb26c54b5c5c$var$isNotEmptyArray(args) {
    return !!args && Array.isArray(args) && !!args.length;
}
async function $ac9bfb26c54b5c5c$var$readFileFromUrl(url, config) {
    const headers = {};
    for (const header of config.headers)if ($ac9bfb26c54b5c5c$var$match(url, header.matches)) headers[header.name] = header.envVariable !== undefined ? $3fhVa.env[header.envVariable] || '' : header.value;
    const req = await (config.customFetch || fetch)(url, {
        headers: headers
    });
    if (!req.ok) throw new Error(`Failed to load ${url}: ${req.status} ${req.statusText}`);
    return {
        body: await req.text(),
        mimeType: req.headers.get('content-type')
    };
}
function $ac9bfb26c54b5c5c$var$match(url, pattern) {
    if (!pattern.match(/^https?:\/\//)) // if pattern doesn't specify protocol directly, do not match against it
    url = url.replace(/^https?:\/\//, '');
    return $d9mF6(url, pattern);
}
function $ac9bfb26c54b5c5c$var$pickObjectProps(object, keys) {
    return Object.fromEntries(keys.filter((key)=>key in object).map((key)=>[
            key,
            object[key]
        ]));
}
function $ac9bfb26c54b5c5c$var$omitObjectProps(object, keys) {
    return Object.fromEntries(Object.entries(object).filter(([key])=>!keys.includes(key)));
}
function $ac9bfb26c54b5c5c$var$splitCamelCaseIntoWords(str) {
    const camel = str.split(/(?:[-._])|([A-Z][a-z]+)/).filter($ac9bfb26c54b5c5c$var$isTruthy).map((item)=>item.toLocaleLowerCase());
    const caps = str.split(/([A-Z]{2,})/).filter((e)=>e && e === e.toUpperCase()).map((item)=>item.toLocaleLowerCase());
    return new Set([
        ...camel,
        ...caps
    ]);
}
function $ac9bfb26c54b5c5c$var$validateMimeType({ type: type, value: value }, { report: report, location: location }, allowedValues) {
    const ruleType = type === 'consumes' ? 'request' : 'response';
    if (!allowedValues) throw new Error(`Parameter "allowedValues" is not provided for "${ruleType}-mime-type" rule`);
    if (!value[type]) return;
    for (const mime of value[type])if (!allowedValues.includes(mime)) report({
        message: `Mime type "${mime}" is not allowed`,
        location: location.child(value[type].indexOf(mime)).key()
    });
}
function $ac9bfb26c54b5c5c$var$validateMimeTypeOAS3({ type: type, value: value }, { report: report, location: location }, allowedValues) {
    const ruleType = type === 'consumes' ? 'request' : 'response';
    if (!allowedValues) throw new Error(`Parameter "allowedValues" is not provided for "${ruleType}-mime-type" rule`);
    if (!value.content) return;
    for (const mime of Object.keys(value.content))if (!allowedValues.includes(mime)) report({
        message: `Mime type "${mime}" is not allowed`,
        location: location.child('content').child(mime).key()
    });
}
function $ac9bfb26c54b5c5c$var$readFileAsStringSync(filePath) {
    return $kjyEk.readFileSync(filePath, 'utf-8');
}
function $ac9bfb26c54b5c5c$var$yamlAndJsonSyncReader(filePath) {
    const content = $kjyEk.readFileSync(filePath, 'utf-8');
    return (0, $64y7M.parseYaml)(content);
}
function $ac9bfb26c54b5c5c$var$isPathParameter(pathSegment) {
    return pathSegment.startsWith('{') && pathSegment.endsWith('}');
}
/**
 * Convert Windows backslash paths to slash paths: foo\\bar ➔ foo/bar
 */ function $ac9bfb26c54b5c5c$var$slash(path) {
    const isExtendedLengthPath = /^\\\\\?\\/.test(path);
    if (isExtendedLengthPath) return path;
    return path.replace(/\\/g, '/');
}
// TODO: use it everywhere
function $ac9bfb26c54b5c5c$var$isString(value) {
    return typeof value === 'string';
}
function $ac9bfb26c54b5c5c$var$isNotString(value) {
    return !$ac9bfb26c54b5c5c$var$isString(value);
}
const $ac9bfb26c54b5c5c$var$assignConfig = (target, obj)=>{
    if (!obj) return;
    for (const k of Object.keys(obj))if ($ac9bfb26c54b5c5c$var$isPlainObject(target[k]) && typeof obj[k] === 'string') target[k].severity = obj[k];
    else target[k] = obj[k];
};
module.exports.assignConfig = $ac9bfb26c54b5c5c$var$assignConfig;
function $ac9bfb26c54b5c5c$var$assignOnlyExistingConfig(target, obj) {
    if (!obj) return;
    for (const k of Object.keys(obj)){
        if (!target.hasOwnProperty(k)) continue;
        if ($ac9bfb26c54b5c5c$var$isPlainObject(target[k]) && typeof obj[k] === 'string') target[k].severity = obj[k];
        else target[k] = obj[k];
    }
}
function $ac9bfb26c54b5c5c$var$getMatchingStatusCodeRange(code) {
    return `${code}`.replace(/^(\d)\d\d$/, (_, firstDigit)=>`${firstDigit}XX`);
}
function $ac9bfb26c54b5c5c$var$isCustomRuleId(id) {
    return id.includes('/');
}
function $ac9bfb26c54b5c5c$var$doesYamlFileExist(filePath) {
    return ((0, $59kwG.extname)(filePath) === '.yaml' || (0, $59kwG.extname)(filePath) === '.yml') && $kjyEk?.hasOwnProperty?.('existsSync') && $kjyEk.existsSync(filePath);
}
function $ac9bfb26c54b5c5c$var$showWarningForDeprecatedField(deprecatedField, updatedField, updatedObject, link) {
    const readMoreText = link ? `Read more about this change: ${link}` : '';
    $lX2nX.logger.warn(`The '${$lX2nX.colorize.red(deprecatedField)}' field is deprecated. ${updatedField ? `Use ${$lX2nX.colorize.green($ac9bfb26c54b5c5c$var$getUpdatedFieldName(updatedField, updatedObject))} instead. ` : ''}${readMoreText}\n`);
}
function $ac9bfb26c54b5c5c$var$showErrorForDeprecatedField(deprecatedField, updatedField, updatedObject) {
    throw new Error(`Do not use '${deprecatedField}' field. ${updatedField ? `Use '${$ac9bfb26c54b5c5c$var$getUpdatedFieldName(updatedField, updatedObject)}' instead. ` : ''}\n`);
}
function $ac9bfb26c54b5c5c$var$isTruthy(value) {
    return !!value;
}
function $ac9bfb26c54b5c5c$var$identity(value) {
    return value;
}
function $ac9bfb26c54b5c5c$var$keysOf(obj) {
    if (!obj) return [];
    return Object.keys(obj);
}
function $ac9bfb26c54b5c5c$var$pickDefined(obj) {
    if (!obj) return undefined;
    const res = {};
    for(const key in obj)if (obj[key] !== undefined) res[key] = obj[key];
    return res;
}
function $ac9bfb26c54b5c5c$var$nextTick() {
    return new Promise((resolve)=>{
        setTimeout(resolve);
    });
}
async function $ac9bfb26c54b5c5c$var$pause(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
function $ac9bfb26c54b5c5c$var$getUpdatedFieldName(updatedField, updatedObject) {
    return `${typeof updatedObject !== 'undefined' ? `${updatedObject}.` : ''}${updatedField}`;
}
function $ac9bfb26c54b5c5c$var$getProxyAgent() {
    const proxy = undefined;
    return proxy ? new $kjyEk.HttpsProxyAgent(proxy) : undefined;
}
/**
 * Checks if two objects are deeply equal.
 * Borrowed the source code from https://github.com/lukeed/dequal.
 */ function $ac9bfb26c54b5c5c$var$dequal(foo, bar) {
    let ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $ac9bfb26c54b5c5c$var$dequal(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if (Object.prototype.hasOwnProperty.call(foo, ctor) && ++len && !Object.prototype.hasOwnProperty.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$ac9bfb26c54b5c5c$var$dequal(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});
parcelRegister("d9mF6", function(module, exports) {
const $992db1cf985a9b65$var$minimatch = module.exports = (p, pattern, options = {})=>{
    $992db1cf985a9b65$var$assertValidPattern(pattern);
    // shortcut: comments match nothing.
    if (!options.nocomment && pattern.charAt(0) === '#') return false;
    return new $992db1cf985a9b65$var$Minimatch(pattern, options).match(p);
};
module.exports = $992db1cf985a9b65$var$minimatch;

var $35RcV = parcelRequire("35RcV");
$992db1cf985a9b65$var$minimatch.sep = $35RcV.sep;
const $992db1cf985a9b65$var$GLOBSTAR = Symbol('globstar **');
$992db1cf985a9b65$var$minimatch.GLOBSTAR = $992db1cf985a9b65$var$GLOBSTAR;

var $86arc = parcelRequire("86arc");
const $992db1cf985a9b65$var$plTypes = {
    '!': {
        open: '(?:(?!(?:',
        close: '))[^/]*?)'
    },
    '?': {
        open: '(?:',
        close: ')?'
    },
    '+': {
        open: '(?:',
        close: ')+'
    },
    '*': {
        open: '(?:',
        close: ')*'
    },
    '@': {
        open: '(?:',
        close: ')'
    }
};
// any single thing other than /
// don't need to escape / when using new RegExp()
const $992db1cf985a9b65$var$qmark = '[^/]';
// * => any number of characters
const $992db1cf985a9b65$var$star = $992db1cf985a9b65$var$qmark + '*?';
// ** when dots are allowed.  Anything goes, except .. and .
// not (^ or / followed by one or two dots followed by $ or /),
// followed by anything, any number of times.
const $992db1cf985a9b65$var$twoStarDot = '(?:(?!(?:\\\/|^)(?:\\.{1,2})($|\\\/)).)*?';
// not a ^ or / followed by a dot,
// followed by anything, any number of times.
const $992db1cf985a9b65$var$twoStarNoDot = '(?:(?!(?:\\\/|^)\\.).)*?';
// "abc" -> { a:true, b:true, c:true }
const $992db1cf985a9b65$var$charSet = (s)=>s.split('').reduce((set, c)=>{
        set[c] = true;
        return set;
    }, {});
// characters that need to be escaped in RegExp.
const $992db1cf985a9b65$var$reSpecials = $992db1cf985a9b65$var$charSet('().*{}+?[]^$\\!');
// characters that indicate we have to add the pattern start
const $992db1cf985a9b65$var$addPatternStartSet = $992db1cf985a9b65$var$charSet('[.(');
// normalizes slashes.
const $992db1cf985a9b65$var$slashSplit = /\/+/;
$992db1cf985a9b65$var$minimatch.filter = (pattern, options = {})=>(p, i, list)=>$992db1cf985a9b65$var$minimatch(p, pattern, options);
const $992db1cf985a9b65$var$ext = (a, b = {})=>{
    const t = {};
    Object.keys(a).forEach((k)=>t[k] = a[k]);
    Object.keys(b).forEach((k)=>t[k] = b[k]);
    return t;
};
$992db1cf985a9b65$var$minimatch.defaults = (def)=>{
    if (!def || typeof def !== 'object' || !Object.keys(def).length) return $992db1cf985a9b65$var$minimatch;
    const orig = $992db1cf985a9b65$var$minimatch;
    const m = (p, pattern, options)=>orig(p, pattern, $992db1cf985a9b65$var$ext(def, options));
    m.Minimatch = class Minimatch extends orig.Minimatch {
        constructor(pattern, options){
            super(pattern, $992db1cf985a9b65$var$ext(def, options));
        }
    };
    m.Minimatch.defaults = (options)=>orig.defaults($992db1cf985a9b65$var$ext(def, options)).Minimatch;
    m.filter = (pattern, options)=>orig.filter(pattern, $992db1cf985a9b65$var$ext(def, options));
    m.defaults = (options)=>orig.defaults($992db1cf985a9b65$var$ext(def, options));
    m.makeRe = (pattern, options)=>orig.makeRe(pattern, $992db1cf985a9b65$var$ext(def, options));
    m.braceExpand = (pattern, options)=>orig.braceExpand(pattern, $992db1cf985a9b65$var$ext(def, options));
    m.match = (list, pattern, options)=>orig.match(list, pattern, $992db1cf985a9b65$var$ext(def, options));
    return m;
};
// Brace expansion:
// a{b,c}d -> abd acd
// a{b,}c -> abc ac
// a{0..3}d -> a0d a1d a2d a3d
// a{b,c{d,e}f}g -> abg acdfg acefg
// a{b,c}d{e,f}g -> abdeg acdeg abdeg abdfg
//
// Invalid sets are not expanded.
// a{2..}b -> a{2..}b
// a{b}c -> a{b}c
$992db1cf985a9b65$var$minimatch.braceExpand = (pattern, options)=>$992db1cf985a9b65$var$braceExpand(pattern, options);
const $992db1cf985a9b65$var$braceExpand = (pattern, options = {})=>{
    $992db1cf985a9b65$var$assertValidPattern(pattern);
    // Thanks to Yeting Li <https://github.com/yetingli> for
    // improving this regexp to avoid a ReDOS vulnerability.
    if (options.nobrace || !/\{(?:(?!\{).)*\}/.test(pattern)) // shortcut. no need to expand.
    return [
        pattern
    ];
    return $86arc(pattern);
};
const $992db1cf985a9b65$var$MAX_PATTERN_LENGTH = 65536;
const $992db1cf985a9b65$var$assertValidPattern = (pattern)=>{
    if (typeof pattern !== 'string') throw new TypeError('invalid pattern');
    if (pattern.length > $992db1cf985a9b65$var$MAX_PATTERN_LENGTH) throw new TypeError('pattern is too long');
};
// parse a component of the expanded set.
// At this point, no pattern may contain "/" in it
// so we're going to return a 2d array, where each entry is the full
// pattern, split on '/', and then turned into a regular expression.
// A regexp is made at the end which joins each array with an
// escaped /, and another full one which joins each regexp with |.
//
// Following the lead of Bash 4.1, note that "**" only has special meaning
// when it is the *only* thing in a path portion.  Otherwise, any series
// of * is equivalent to a single *.  Globstar behavior is enabled by
// default, and can be disabled by setting options.noglobstar.
const $992db1cf985a9b65$var$SUBPARSE = Symbol('subparse');
$992db1cf985a9b65$var$minimatch.makeRe = (pattern, options)=>new $992db1cf985a9b65$var$Minimatch(pattern, options || {}).makeRe();
$992db1cf985a9b65$var$minimatch.match = (list, pattern, options = {})=>{
    const mm = new $992db1cf985a9b65$var$Minimatch(pattern, options);
    list = list.filter((f)=>mm.match(f));
    if (mm.options.nonull && !list.length) list.push(pattern);
    return list;
};
// replace stuff like \* with *
const $992db1cf985a9b65$var$globUnescape = (s)=>s.replace(/\\(.)/g, '$1');
const $992db1cf985a9b65$var$charUnescape = (s)=>s.replace(/\\([^-\]])/g, '$1');
const $992db1cf985a9b65$var$regExpEscape = (s)=>s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
const $992db1cf985a9b65$var$braExpEscape = (s)=>s.replace(/[[\]\\]/g, '\\$&');
class $992db1cf985a9b65$var$Minimatch {
    constructor(pattern, options){
        $992db1cf985a9b65$var$assertValidPattern(pattern);
        if (!options) options = {};
        this.options = options;
        this.maxGlobstarRecursion = options.maxGlobstarRecursion !== undefined ? options.maxGlobstarRecursion : 200;
        this.set = [];
        this.pattern = pattern;
        this.windowsPathsNoEscape = !!options.windowsPathsNoEscape || options.allowWindowsEscape === false;
        if (this.windowsPathsNoEscape) this.pattern = this.pattern.replace(/\\/g, '/');
        this.regexp = null;
        this.negate = false;
        this.comment = false;
        this.empty = false;
        this.partial = !!options.partial;
        // make the set of regexps etc.
        this.make();
    }
    debug() {}
    make() {
        const pattern = this.pattern;
        const options = this.options;
        // empty patterns and comments match nothing.
        if (!options.nocomment && pattern.charAt(0) === '#') {
            this.comment = true;
            return;
        }
        if (!pattern) {
            this.empty = true;
            return;
        }
        // step 1: figure out negation, etc.
        this.parseNegate();
        // step 2: expand braces
        let set = this.globSet = this.braceExpand();
        if (options.debug) this.debug = (...args)=>console.error(...args);
        this.debug(this.pattern, set);
        // step 3: now we have a set, so turn each one into a series of path-portion
        // matching patterns.
        // These will be regexps, except in the case of "**", which is
        // set to the GLOBSTAR object for globstar behavior,
        // and will not contain any / characters
        set = this.globParts = set.map((s)=>s.split($992db1cf985a9b65$var$slashSplit));
        this.debug(this.pattern, set);
        // glob --> regexps
        set = set.map((s, si, set)=>s.map(this.parse, this));
        this.debug(this.pattern, set);
        // filter out everything that didn't compile properly.
        set = set.filter((s)=>s.indexOf(false) === -1);
        this.debug(this.pattern, set);
        this.set = set;
    }
    parseNegate() {
        if (this.options.nonegate) return;
        const pattern = this.pattern;
        let negate = false;
        let negateOffset = 0;
        for(let i = 0; i < pattern.length && pattern.charAt(i) === '!'; i++){
            negate = !negate;
            negateOffset++;
        }
        if (negateOffset) this.pattern = pattern.slice(negateOffset);
        this.negate = negate;
    }
    // set partial to true to test if, for example,
    // "/a/b" matches the start of "/*/b/*/d"
    // Partial means, if you run out of file before you run
    // out of pattern, then that's fine, as long as all
    // the parts match.
    matchOne(file, pattern, partial) {
        if (pattern.indexOf($992db1cf985a9b65$var$GLOBSTAR) !== -1) return this._matchGlobstar(file, pattern, partial, 0, 0);
        return this._matchOne(file, pattern, partial, 0, 0);
    }
    _matchGlobstar(file, pattern, partial, fileIndex, patternIndex) {
        // find first globstar from patternIndex
        let firstgs = -1;
        for(let i = patternIndex; i < pattern.length; i++)if (pattern[i] === $992db1cf985a9b65$var$GLOBSTAR) {
            firstgs = i;
            break;
        }
        // find last globstar
        let lastgs = -1;
        for(let i = pattern.length - 1; i >= 0; i--)if (pattern[i] === $992db1cf985a9b65$var$GLOBSTAR) {
            lastgs = i;
            break;
        }
        const head = pattern.slice(patternIndex, firstgs);
        const body = partial ? pattern.slice(firstgs + 1) : pattern.slice(firstgs + 1, lastgs);
        const tail = partial ? [] : pattern.slice(lastgs + 1);
        // check the head
        if (head.length) {
            const fileHead = file.slice(fileIndex, fileIndex + head.length);
            if (!this._matchOne(fileHead, head, partial, 0, 0)) return false;
            fileIndex += head.length;
        }
        // check the tail
        let fileTailMatch = 0;
        if (tail.length) {
            if (tail.length + fileIndex > file.length) return false;
            const tailStart = file.length - tail.length;
            if (this._matchOne(file, tail, partial, tailStart, 0)) fileTailMatch = tail.length;
            else {
                // affordance for stuff like a/**/* matching a/b/
                if (file[file.length - 1] !== '' || fileIndex + tail.length === file.length) return false;
                if (!this._matchOne(file, tail, partial, tailStart - 1, 0)) return false;
                fileTailMatch = tail.length + 1;
            }
        }
        // if body is empty (single ** between head and tail)
        if (!body.length) {
            let sawSome = !!fileTailMatch;
            for(let i = fileIndex; i < file.length - fileTailMatch; i++){
                const f = String(file[i]);
                sawSome = true;
                if (f === '.' || f === '..' || !this.options.dot && f.charAt(0) === '.') return false;
            }
            return partial || sawSome;
        }
        // split body into segments at each GLOBSTAR
        const bodySegments = [
            [
                [],
                0
            ]
        ];
        let currentBody = bodySegments[0];
        let nonGsParts = 0;
        const nonGsPartsSums = [
            0
        ];
        for (const b of body)if (b === $992db1cf985a9b65$var$GLOBSTAR) {
            nonGsPartsSums.push(nonGsParts);
            currentBody = [
                [],
                0
            ];
            bodySegments.push(currentBody);
        } else {
            currentBody[0].push(b);
            nonGsParts++;
        }
        let idx = bodySegments.length - 1;
        const fileLength = file.length - fileTailMatch;
        for (const b of bodySegments)b[1] = fileLength - (nonGsPartsSums[idx--] + b[0].length);
        return !!this._matchGlobStarBodySections(file, bodySegments, fileIndex, 0, partial, 0, !!fileTailMatch);
    }
    // return false for "nope, not matching"
    // return null for "not matching, cannot keep trying"
    _matchGlobStarBodySections(file, bodySegments, fileIndex, bodyIndex, partial, globStarDepth, sawTail) {
        const bs = bodySegments[bodyIndex];
        if (!bs) {
            // just make sure there are no bad dots
            for(let i = fileIndex; i < file.length; i++){
                sawTail = true;
                const f = file[i];
                if (f === '.' || f === '..' || !this.options.dot && f.charAt(0) === '.') return false;
            }
            return sawTail;
        }
        const [body, after] = bs;
        while(fileIndex <= after){
            const m = this._matchOne(file.slice(0, fileIndex + body.length), body, partial, fileIndex, 0);
            // if limit exceeded, no match. intentional false negative,
            // acceptable break in correctness for security.
            if (m && globStarDepth < this.maxGlobstarRecursion) {
                const sub = this._matchGlobStarBodySections(file, bodySegments, fileIndex + body.length, bodyIndex + 1, partial, globStarDepth + 1, sawTail);
                if (sub !== false) return sub;
            }
            const f = file[fileIndex];
            if (f === '.' || f === '..' || !this.options.dot && f.charAt(0) === '.') return false;
            fileIndex++;
        }
        return partial || null;
    }
    _matchOne(file, pattern, partial, fileIndex, patternIndex) {
        let fi, pi, fl, pl;
        for(fi = fileIndex, pi = patternIndex, fl = file.length, pl = pattern.length; fi < fl && pi < pl; fi++, pi++){
            this.debug('matchOne loop');
            const p = pattern[pi];
            const f = file[fi];
            this.debug(pattern, p, f);
            // should be impossible.
            // some invalid regexp stuff in the set.
            /* istanbul ignore if */ if (p === false || p === $992db1cf985a9b65$var$GLOBSTAR) return false;
            // something other than **
            // non-magic patterns just have to match exactly
            // patterns with magic have been turned into regexps.
            let hit;
            if (typeof p === 'string') {
                hit = f === p;
                this.debug('string match', p, f, hit);
            } else {
                hit = f.match(p);
                this.debug('pattern match', p, f, hit);
            }
            if (!hit) return false;
        }
        // now either we fell off the end of the pattern, or we're done.
        if (fi === fl && pi === pl) // ran out of pattern and filename at the same time.
        // an exact hit!
        return true;
        else if (fi === fl) // ran out of file, but still had pattern left.
        // this is ok if we're doing the match as part of
        // a glob fs traversal.
        return partial;
        else /* istanbul ignore else */ if (pi === pl) // ran out of pattern, still have file left.
        // this is only acceptable if we're on the very last
        // empty segment of a file with a trailing slash.
        // a/* should match a/b/
        return fi === fl - 1 && file[fi] === '';
        // should be unreachable.
        /* istanbul ignore next */ throw new Error('wtf?');
    }
    braceExpand() {
        return $992db1cf985a9b65$var$braceExpand(this.pattern, this.options);
    }
    parse(pattern, isSub) {
        $992db1cf985a9b65$var$assertValidPattern(pattern);
        const options = this.options;
        // shortcuts
        if (pattern === '**') {
            if (!options.noglobstar) return $992db1cf985a9b65$var$GLOBSTAR;
            else pattern = '*';
        }
        if (pattern === '') return '';
        let re = '';
        let hasMagic = false;
        let escaping = false;
        // ? => one single character
        const patternListStack = [];
        const negativeLists = [];
        let stateChar;
        let inClass = false;
        let reClassStart = -1;
        let classStart = -1;
        let cs;
        let pl;
        let sp;
        // . and .. never match anything that doesn't start with .,
        // even when options.dot is set.  However, if the pattern
        // starts with ., then traversal patterns can match.
        let dotTravAllowed = pattern.charAt(0) === '.';
        let dotFileAllowed = options.dot || dotTravAllowed;
        const patternStart = ()=>dotTravAllowed ? '' : dotFileAllowed ? '(?!(?:^|\\/)\\.{1,2}(?:$|\\/))' : '(?!\\.)';
        const subPatternStart = (p)=>p.charAt(0) === '.' ? '' : options.dot ? '(?!(?:^|\\/)\\.{1,2}(?:$|\\/))' : '(?!\\.)';
        const clearStateChar = ()=>{
            if (stateChar) {
                // we had some state-tracking character
                // that wasn't consumed by this pass.
                switch(stateChar){
                    case '*':
                        re += $992db1cf985a9b65$var$star;
                        hasMagic = true;
                        break;
                    case '?':
                        re += $992db1cf985a9b65$var$qmark;
                        hasMagic = true;
                        break;
                    default:
                        re += '\\' + stateChar;
                        break;
                }
                this.debug('clearStateChar %j %j', stateChar, re);
                stateChar = false;
            }
        };
        for(let i = 0, c; i < pattern.length && (c = pattern.charAt(i)); i++){
            this.debug('%s\t%s %s %j', pattern, i, re, c);
            // skip over any that are escaped.
            if (escaping) {
                /* istanbul ignore next - completely not allowed, even escaped. */ if (c === '/') return false;
                if ($992db1cf985a9b65$var$reSpecials[c]) re += '\\';
                re += c;
                escaping = false;
                continue;
            }
            switch(c){
                /* istanbul ignore next */ case '/':
                    // Should already be path-split by now.
                    return false;
                case '\\':
                    if (inClass && pattern.charAt(i + 1) === '-') {
                        re += c;
                        continue;
                    }
                    clearStateChar();
                    escaping = true;
                    continue;
                // the various stateChar values
                // for the "extglob" stuff.
                case '?':
                case '*':
                case '+':
                case '@':
                case '!':
                    this.debug('%s\t%s %s %j <-- stateChar', pattern, i, re, c);
                    // all of those are literals inside a class, except that
                    // the glob [!a] means [^a] in regexp
                    if (inClass) {
                        this.debug('  in class');
                        if (c === '!' && i === classStart + 1) c = '^';
                        re += c;
                        continue;
                    }
                    // coalesce consecutive non-globstar * characters
                    if (c === '*' && stateChar === '*') continue;
                    // if we already have a stateChar, then it means
                    // that there was something like ** or +? in there.
                    // Handle the stateChar, then proceed with this one.
                    this.debug('call clearStateChar %j', stateChar);
                    clearStateChar();
                    stateChar = c;
                    // if extglob is disabled, then +(asdf|foo) isn't a thing.
                    // just clear the statechar *now*, rather than even diving into
                    // the patternList stuff.
                    if (options.noext) clearStateChar();
                    continue;
                case '(':
                    {
                        if (inClass) {
                            re += '(';
                            continue;
                        }
                        if (!stateChar) {
                            re += '\\(';
                            continue;
                        }
                        const plEntry = {
                            type: stateChar,
                            start: i - 1,
                            reStart: re.length,
                            open: $992db1cf985a9b65$var$plTypes[stateChar].open,
                            close: $992db1cf985a9b65$var$plTypes[stateChar].close
                        };
                        this.debug(this.pattern, '\t', plEntry);
                        patternListStack.push(plEntry);
                        // negation is (?:(?!(?:js)(?:<rest>))[^/]*)
                        re += plEntry.open;
                        // next entry starts with a dot maybe?
                        if (plEntry.start === 0 && plEntry.type !== '!') {
                            dotTravAllowed = true;
                            re += subPatternStart(pattern.slice(i + 1));
                        }
                        this.debug('plType %j %j', stateChar, re);
                        stateChar = false;
                        continue;
                    }
                case ')':
                    {
                        const plEntry = patternListStack[patternListStack.length - 1];
                        if (inClass || !plEntry) {
                            re += '\\)';
                            continue;
                        }
                        patternListStack.pop();
                        // closing an extglob
                        clearStateChar();
                        hasMagic = true;
                        pl = plEntry;
                        // negation is (?:(?!js)[^/]*)
                        // The others are (?:<pattern>)<type>
                        re += pl.close;
                        if (pl.type === '!') negativeLists.push(Object.assign(pl, {
                            reEnd: re.length
                        }));
                        continue;
                    }
                case '|':
                    {
                        const plEntry = patternListStack[patternListStack.length - 1];
                        if (inClass || !plEntry) {
                            re += '\\|';
                            continue;
                        }
                        clearStateChar();
                        re += '|';
                        // next subpattern can start with a dot?
                        if (plEntry.start === 0 && plEntry.type !== '!') {
                            dotTravAllowed = true;
                            re += subPatternStart(pattern.slice(i + 1));
                        }
                        continue;
                    }
                // these are mostly the same in regexp and glob
                case '[':
                    // swallow any state-tracking char before the [
                    clearStateChar();
                    if (inClass) {
                        re += '\\' + c;
                        continue;
                    }
                    inClass = true;
                    classStart = i;
                    reClassStart = re.length;
                    re += c;
                    continue;
                case ']':
                    //  a right bracket shall lose its special
                    //  meaning and represent itself in
                    //  a bracket expression if it occurs
                    //  first in the list.  -- POSIX.2 2.8.3.2
                    if (i === classStart + 1 || !inClass) {
                        re += '\\' + c;
                        continue;
                    }
                    // split where the last [ was, make sure we don't have
                    // an invalid re. if so, re-walk the contents of the
                    // would-be class to re-translate any characters that
                    // were passed through as-is
                    // TODO: It would probably be faster to determine this
                    // without a try/catch and a new RegExp, but it's tricky
                    // to do safely.  For now, this is safe and works.
                    cs = pattern.substring(classStart + 1, i);
                    try {
                        RegExp('[' + $992db1cf985a9b65$var$braExpEscape($992db1cf985a9b65$var$charUnescape(cs)) + ']');
                        // looks good, finish up the class.
                        re += c;
                    } catch (er) {
                        // out of order ranges in JS are errors, but in glob syntax,
                        // they're just a range that matches nothing.
                        re = re.substring(0, reClassStart) + '(?:$.)' // match nothing ever
                        ;
                    }
                    hasMagic = true;
                    inClass = false;
                    continue;
                default:
                    // swallow any state char that wasn't consumed
                    clearStateChar();
                    if ($992db1cf985a9b65$var$reSpecials[c] && !(c === '^' && inClass)) re += '\\';
                    re += c;
                    break;
            } // switch
        } // for
        // handle the case where we left a class open.
        // "[abc" is valid, equivalent to "\[abc"
        if (inClass) {
            // split where the last [ was, and escape it
            // this is a huge pita.  We now have to re-walk
            // the contents of the would-be class to re-translate
            // any characters that were passed through as-is
            cs = pattern.slice(classStart + 1);
            sp = this.parse(cs, $992db1cf985a9b65$var$SUBPARSE);
            re = re.substring(0, reClassStart) + '\\[' + sp[0];
            hasMagic = hasMagic || sp[1];
        }
        // handle the case where we had a +( thing at the *end*
        // of the pattern.
        // each pattern list stack adds 3 chars, and we need to go through
        // and escape any | chars that were passed through as-is for the regexp.
        // Go through and escape them, taking care not to double-escape any
        // | chars that were already escaped.
        for(pl = patternListStack.pop(); pl; pl = patternListStack.pop()){
            let tail;
            tail = re.slice(pl.reStart + pl.open.length);
            this.debug('setting tail', re, pl);
            // maybe some even number of \, then maybe 1 \, followed by a |
            tail = tail.replace(/((?:\\{2}){0,64})(\\?)\|/g, (_, $1, $2)=>{
                /* istanbul ignore else - should already be done */ if (!$2) // the | isn't already escaped, so escape it.
                $2 = '\\';
                // need to escape all those slashes *again*, without escaping the
                // one that we need for escaping the | character.  As it works out,
                // escaping an even number of slashes can be done by simply repeating
                // it exactly after itself.  That's why this trick works.
                //
                // I am sorry that you have to see this.
                return $1 + $1 + $2 + '|';
            });
            this.debug('tail=%j\n   %s', tail, tail, pl, re);
            const t = pl.type === '*' ? $992db1cf985a9b65$var$star : pl.type === '?' ? $992db1cf985a9b65$var$qmark : '\\' + pl.type;
            hasMagic = true;
            re = re.slice(0, pl.reStart) + t + '\\(' + tail;
        }
        // handle trailing things that only matter at the very end.
        clearStateChar();
        if (escaping) // trailing \\
        re += '\\\\';
        // only need to apply the nodot start if the re starts with
        // something that could conceivably capture a dot
        const addPatternStart = $992db1cf985a9b65$var$addPatternStartSet[re.charAt(0)];
        // Hack to work around lack of negative lookbehind in JS
        // A pattern like: *.!(x).!(y|z) needs to ensure that a name
        // like 'a.xyz.yz' doesn't match.  So, the first negative
        // lookahead, has to look ALL the way ahead, to the end of
        // the pattern.
        for(let n = negativeLists.length - 1; n > -1; n--){
            const nl = negativeLists[n];
            const nlBefore = re.slice(0, nl.reStart);
            const nlFirst = re.slice(nl.reStart, nl.reEnd - 8);
            let nlAfter = re.slice(nl.reEnd);
            const nlLast = re.slice(nl.reEnd - 8, nl.reEnd) + nlAfter;
            // Handle nested stuff like *(*.js|!(*.json)), where open parens
            // mean that we should *not* include the ) in the bit that is considered
            // "after" the negated section.
            const closeParensBefore = nlBefore.split(')').length;
            const openParensBefore = nlBefore.split('(').length - closeParensBefore;
            let cleanAfter = nlAfter;
            for(let i = 0; i < openParensBefore; i++)cleanAfter = cleanAfter.replace(/\)[+*?]?/, '');
            nlAfter = cleanAfter;
            const dollar = nlAfter === '' && isSub !== $992db1cf985a9b65$var$SUBPARSE ? '(?:$|\\/)' : '';
            re = nlBefore + nlFirst + nlAfter + dollar + nlLast;
        }
        // if the re is not "" at this point, then we need to make sure
        // it doesn't match against an empty path part.
        // Otherwise a/* will match a/, which it should not.
        if (re !== '' && hasMagic) re = '(?=.)' + re;
        if (addPatternStart) re = patternStart() + re;
        // parsing just a piece of a larger pattern.
        if (isSub === $992db1cf985a9b65$var$SUBPARSE) return [
            re,
            hasMagic
        ];
        // if it's nocase, and the lcase/uppercase don't match, it's magic
        if (options.nocase && !hasMagic) hasMagic = pattern.toUpperCase() !== pattern.toLowerCase();
        // skip the regexp for non-magical patterns
        // unescape anything in it, though, so that it'll be
        // an exact match against a file etc.
        if (!hasMagic) return $992db1cf985a9b65$var$globUnescape(pattern);
        const flags = options.nocase ? 'i' : '';
        try {
            return Object.assign(new RegExp('^' + re + '$', flags), {
                _glob: pattern,
                _src: re
            });
        } catch (er) /* istanbul ignore next - should be impossible */ {
            // If it was an invalid regular expression, then it can't match
            // anything.  This trick looks for a character after the end of
            // the string, which is of course impossible, except in multi-line
            // mode, but it's not a /m regex.
            return new RegExp('$.');
        }
    }
    makeRe() {
        if (this.regexp || this.regexp === false) return this.regexp;
        // at this point, this.set is a 2d array of partial
        // pattern strings, or "**".
        //
        // It's better to use .match().  This function shouldn't
        // be used, really, but it's pretty convenient sometimes,
        // when you just want to work with a regex.
        const set = this.set;
        if (!set.length) {
            this.regexp = false;
            return this.regexp;
        }
        const options = this.options;
        const twoStar = options.noglobstar ? $992db1cf985a9b65$var$star : options.dot ? $992db1cf985a9b65$var$twoStarDot : $992db1cf985a9b65$var$twoStarNoDot;
        const flags = options.nocase ? 'i' : '';
        // coalesce globstars and regexpify non-globstar patterns
        // if it's the only item, then we just do one twoStar
        // if it's the first, and there are more, prepend (\/|twoStar\/)? to next
        // if it's the last, append (\/twoStar|) to previous
        // if it's in the middle, append (\/|\/twoStar\/) to previous
        // then filter out GLOBSTAR symbols
        let re = set.map((pattern)=>{
            pattern = pattern.map((p)=>typeof p === 'string' ? $992db1cf985a9b65$var$regExpEscape(p) : p === $992db1cf985a9b65$var$GLOBSTAR ? $992db1cf985a9b65$var$GLOBSTAR : p._src).reduce((set, p)=>{
                if (!(set[set.length - 1] === $992db1cf985a9b65$var$GLOBSTAR && p === $992db1cf985a9b65$var$GLOBSTAR)) set.push(p);
                return set;
            }, []);
            pattern.forEach((p, i)=>{
                if (p !== $992db1cf985a9b65$var$GLOBSTAR || pattern[i - 1] === $992db1cf985a9b65$var$GLOBSTAR) return;
                if (i === 0) {
                    if (pattern.length > 1) pattern[i + 1] = '(?:\\\/|' + twoStar + '\\\/)?' + pattern[i + 1];
                    else pattern[i] = twoStar;
                } else if (i === pattern.length - 1) pattern[i - 1] += '(?:\\\/|' + twoStar + ')?';
                else {
                    pattern[i - 1] += '(?:\\\/|\\\/' + twoStar + '\\\/)' + pattern[i + 1];
                    pattern[i + 1] = $992db1cf985a9b65$var$GLOBSTAR;
                }
            });
            return pattern.filter((p)=>p !== $992db1cf985a9b65$var$GLOBSTAR).join('/');
        }).join('|');
        // must match entire pattern
        // ending in a * or ** will make it less strict.
        re = '^(?:' + re + ')$';
        // can match anything, as long as it's not this.
        if (this.negate) re = '^(?!' + re + ').*$';
        try {
            this.regexp = new RegExp(re, flags);
        } catch (ex) /* istanbul ignore next - should be impossible */ {
            this.regexp = false;
        }
        return this.regexp;
    }
    match(f, partial = this.partial) {
        this.debug('match', f, this.pattern);
        // short-circuit in the case of busted things.
        // comments, etc.
        if (this.comment) return false;
        if (this.empty) return f === '';
        if (f === '/' && partial) return true;
        const options = this.options;
        // windows: need to use /, not \
        if ($35RcV.sep !== '/') f = f.split($35RcV.sep).join('/');
        // treat the test path as a set of pathparts.
        f = f.split($992db1cf985a9b65$var$slashSplit);
        this.debug(this.pattern, 'split', f);
        // just ONE of the pattern sets in this.set needs to match
        // in order for it to be valid.  If negating, then just one
        // match means that we have failed.
        // Either way, return on the first hit.
        const set = this.set;
        this.debug(this.pattern, 'set', set);
        // Find the basename of the path by looking for the last non-empty segment
        let filename;
        for(let i = f.length - 1; i >= 0; i--){
            filename = f[i];
            if (filename) break;
        }
        for(let i = 0; i < set.length; i++){
            const pattern = set[i];
            let file = f;
            if (options.matchBase && pattern.length === 1) file = [
                filename
            ];
            const hit = this.matchOne(file, pattern, partial);
            if (hit) {
                if (options.flipNegate) return true;
                return !this.negate;
            }
        }
        // didn't get any hits.  this is success if it's a negative
        // pattern, failure otherwise.
        if (options.flipNegate) return false;
        return this.negate;
    }
    static defaults(def) {
        return $992db1cf985a9b65$var$minimatch.defaults(def).Minimatch;
    }
}
$992db1cf985a9b65$var$minimatch.Minimatch = $992db1cf985a9b65$var$Minimatch;

});
parcelRegister("35RcV", function(module, exports) {
const $240b1ca502c3abfd$var$isWindows = false;
module.exports = $240b1ca502c3abfd$var$isWindows ? {
    sep: '\\'
} : {
    sep: '/'
};

});

parcelRegister("86arc", function(module, exports) {

var $4ayZn = parcelRequire("4ayZn");
module.exports = $5e56fafb49515894$var$expandTop;
var $5e56fafb49515894$var$escSlash = '\0SLASH' + Math.random() + '\0';
var $5e56fafb49515894$var$escOpen = '\0OPEN' + Math.random() + '\0';
var $5e56fafb49515894$var$escClose = '\0CLOSE' + Math.random() + '\0';
var $5e56fafb49515894$var$escComma = '\0COMMA' + Math.random() + '\0';
var $5e56fafb49515894$var$escPeriod = '\0PERIOD' + Math.random() + '\0';
function $5e56fafb49515894$var$numeric(str) {
    return parseInt(str, 10) == str ? parseInt(str, 10) : str.charCodeAt(0);
}
function $5e56fafb49515894$var$escapeBraces(str) {
    return str.split('\\\\').join($5e56fafb49515894$var$escSlash).split('\\{').join($5e56fafb49515894$var$escOpen).split('\\}').join($5e56fafb49515894$var$escClose).split('\\,').join($5e56fafb49515894$var$escComma).split('\\.').join($5e56fafb49515894$var$escPeriod);
}
function $5e56fafb49515894$var$unescapeBraces(str) {
    return str.split($5e56fafb49515894$var$escSlash).join('\\').split($5e56fafb49515894$var$escOpen).join('{').split($5e56fafb49515894$var$escClose).join('}').split($5e56fafb49515894$var$escComma).join(',').split($5e56fafb49515894$var$escPeriod).join('.');
}
// Basically just str.split(","), but handling cases
// where we have nested braced sections, which should be
// treated as individual members, like {a,{b,c},d}
function $5e56fafb49515894$var$parseCommaParts(str) {
    if (!str) return [
        ''
    ];
    var parts = [];
    var m = $4ayZn('{', '}', str);
    if (!m) return str.split(',');
    var pre = m.pre;
    var body = m.body;
    var post = m.post;
    var p = pre.split(',');
    p[p.length - 1] += '{' + body + '}';
    var postParts = $5e56fafb49515894$var$parseCommaParts(post);
    if (post.length) {
        p[p.length - 1] += postParts.shift();
        p.push.apply(p, postParts);
    }
    parts.push.apply(parts, p);
    return parts;
}
function $5e56fafb49515894$var$expandTop(str) {
    if (!str) return [];
    // I don't know why Bash 4.3 does this, but it does.
    // Anything starting with {} will have the first two bytes preserved
    // but *only* at the top level, so {},a}b will not expand to anything,
    // but a{},b}c will be expanded to [a}c,abc].
    // One could argue that this is a bug in Bash, but since the goal of
    // this module is to match Bash's rules, we escape a leading {}
    if (str.substr(0, 2) === '{}') str = '\\{\\}' + str.substr(2);
    return $5e56fafb49515894$var$expand($5e56fafb49515894$var$escapeBraces(str), true).map($5e56fafb49515894$var$unescapeBraces);
}
function $5e56fafb49515894$var$embrace(str) {
    return '{' + str + '}';
}
function $5e56fafb49515894$var$isPadded(el) {
    return /^-?0\d/.test(el);
}
function $5e56fafb49515894$var$lte(i, y) {
    return i <= y;
}
function $5e56fafb49515894$var$gte(i, y) {
    return i >= y;
}
function $5e56fafb49515894$var$expand(str, isTop) {
    var expansions = [];
    var m = $4ayZn('{', '}', str);
    if (!m) return [
        str
    ];
    // no need to expand pre, since it is guaranteed to be free of brace-sets
    var pre = m.pre;
    var post = m.post.length ? $5e56fafb49515894$var$expand(m.post, false) : [
        ''
    ];
    if (/\$$/.test(m.pre)) for(var k = 0; k < post.length; k++){
        var expansion = pre + '{' + m.body + '}' + post[k];
        expansions.push(expansion);
    }
    else {
        var isNumericSequence = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(m.body);
        var isAlphaSequence = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(m.body);
        var isSequence = isNumericSequence || isAlphaSequence;
        var isOptions = m.body.indexOf(',') >= 0;
        if (!isSequence && !isOptions) {
            // {a},b}
            if (m.post.match(/,.*\}/)) {
                str = m.pre + '{' + m.body + $5e56fafb49515894$var$escClose + m.post;
                return $5e56fafb49515894$var$expand(str);
            }
            return [
                str
            ];
        }
        var n;
        if (isSequence) n = m.body.split(/\.\./);
        else {
            n = $5e56fafb49515894$var$parseCommaParts(m.body);
            if (n.length === 1) {
                // x{{a,b}}y ==> x{a}y x{b}y
                n = $5e56fafb49515894$var$expand(n[0], false).map($5e56fafb49515894$var$embrace);
                if (n.length === 1) return post.map(function(p) {
                    return m.pre + n[0] + p;
                });
            }
        }
        // at this point, n is the parts, and we know it's not a comma set
        // with a single entry.
        var N;
        if (isSequence) {
            var x = $5e56fafb49515894$var$numeric(n[0]);
            var y = $5e56fafb49515894$var$numeric(n[1]);
            var width = Math.max(n[0].length, n[1].length);
            var incr = n.length == 3 ? Math.abs($5e56fafb49515894$var$numeric(n[2])) : 1;
            var test = $5e56fafb49515894$var$lte;
            var reverse = y < x;
            if (reverse) {
                incr *= -1;
                test = $5e56fafb49515894$var$gte;
            }
            var pad = n.some($5e56fafb49515894$var$isPadded);
            N = [];
            for(var i = x; test(i, y); i += incr){
                var c;
                if (isAlphaSequence) {
                    c = String.fromCharCode(i);
                    if (c === '\\') c = '';
                } else {
                    c = String(i);
                    if (pad) {
                        var need = width - c.length;
                        if (need > 0) {
                            var z = new Array(need + 1).join('0');
                            if (i < 0) c = '-' + z + c.slice(1);
                            else c = z + c;
                        }
                    }
                }
                N.push(c);
            }
        } else {
            N = [];
            for(var j = 0; j < n.length; j++)N.push.apply(N, $5e56fafb49515894$var$expand(n[j], false));
        }
        for(var j = 0; j < N.length; j++)for(var k = 0; k < post.length; k++){
            var expansion = pre + N[j] + post[k];
            if (!isTop || isSequence || expansion) expansions.push(expansion);
        }
    }
    return expansions;
}

});
parcelRegister("4ayZn", function(module, exports) {
'use strict';
module.exports = $30933cb119085804$var$balanced;
function $30933cb119085804$var$balanced(a, b, str) {
    if (a instanceof RegExp) a = $30933cb119085804$var$maybeMatch(a, str);
    if (b instanceof RegExp) b = $30933cb119085804$var$maybeMatch(b, str);
    var r = $30933cb119085804$var$range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}
function $30933cb119085804$var$maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}
$30933cb119085804$var$balanced.range = $30933cb119085804$var$range;
function $30933cb119085804$var$range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        if (a === b) return [
            ai,
            bi
        ];
        begs = [];
        left = str.length;
        while(i >= 0 && !result){
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) result = [
                begs.pop(),
                bi
            ];
            else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) result = [
            left,
            right
        ];
    }
    return result;
}

});



parcelRegister("64y7M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringifyYaml = module.exports.parseYaml = void 0;

var $a3ZbN = parcelRequire("a3ZbN");
const $46bd96377e036998$var$DEFAULT_SCHEMA_WITHOUT_TIMESTAMP = $a3ZbN.JSON_SCHEMA.extend({
    implicit: [
        $a3ZbN.types.merge
    ],
    explicit: [
        $a3ZbN.types.binary,
        $a3ZbN.types.omap,
        $a3ZbN.types.pairs,
        $a3ZbN.types.set
    ]
});
const $46bd96377e036998$var$parseYaml = (str, opts)=>(0, $a3ZbN.load)(str, {
        schema: $46bd96377e036998$var$DEFAULT_SCHEMA_WITHOUT_TIMESTAMP,
        ...opts
    });
module.exports.parseYaml = $46bd96377e036998$var$parseYaml;
const $46bd96377e036998$var$stringifyYaml = (obj, opts)=>(0, $a3ZbN.dump)(obj, opts);
module.exports.stringifyYaml = $46bd96377e036998$var$stringifyYaml;

});
parcelRegister("a3ZbN", function(module, exports) {

$parcel$export(module.exports, "JSON_SCHEMA", () => $4d12843bbf345537$export$3f5573a59aee743);
$parcel$export(module.exports, "load", () => $4d12843bbf345537$export$11e63f7b0f3d9900);
$parcel$export(module.exports, "dump", () => $4d12843bbf345537$export$2069a8a5a76faa2);
$parcel$export(module.exports, "types", () => $4d12843bbf345537$export$b14ad400b1d09e0f);
/*! js-yaml 4.1.1 https://github.com/nodeca/js-yaml @license MIT */ function $4d12843bbf345537$var$isNothing(subject) {
    return typeof subject === 'undefined' || subject === null;
}
function $4d12843bbf345537$var$isObject(subject) {
    return typeof subject === 'object' && subject !== null;
}
function $4d12843bbf345537$var$toArray(sequence) {
    if (Array.isArray(sequence)) return sequence;
    else if ($4d12843bbf345537$var$isNothing(sequence)) return [];
    return [
        sequence
    ];
}
function $4d12843bbf345537$var$extend(target, source) {
    var index, length, key, sourceKeys;
    if (source) {
        sourceKeys = Object.keys(source);
        for(index = 0, length = sourceKeys.length; index < length; index += 1){
            key = sourceKeys[index];
            target[key] = source[key];
        }
    }
    return target;
}
function $4d12843bbf345537$var$repeat(string, count) {
    var result = '', cycle;
    for(cycle = 0; cycle < count; cycle += 1)result += string;
    return result;
}
function $4d12843bbf345537$var$isNegativeZero(number) {
    return number === 0 && Number.NEGATIVE_INFINITY === 1 / number;
}
var $4d12843bbf345537$var$isNothing_1 = $4d12843bbf345537$var$isNothing;
var $4d12843bbf345537$var$isObject_1 = $4d12843bbf345537$var$isObject;
var $4d12843bbf345537$var$toArray_1 = $4d12843bbf345537$var$toArray;
var $4d12843bbf345537$var$repeat_1 = $4d12843bbf345537$var$repeat;
var $4d12843bbf345537$var$isNegativeZero_1 = $4d12843bbf345537$var$isNegativeZero;
var $4d12843bbf345537$var$extend_1 = $4d12843bbf345537$var$extend;
var $4d12843bbf345537$var$common = {
    isNothing: $4d12843bbf345537$var$isNothing_1,
    isObject: $4d12843bbf345537$var$isObject_1,
    toArray: $4d12843bbf345537$var$toArray_1,
    repeat: $4d12843bbf345537$var$repeat_1,
    isNegativeZero: $4d12843bbf345537$var$isNegativeZero_1,
    extend: $4d12843bbf345537$var$extend_1
};
// YAML error class. http://stackoverflow.com/questions/8458984
function $4d12843bbf345537$var$formatError(exception, compact) {
    var where = '', message = exception.reason || '(unknown reason)';
    if (!exception.mark) return message;
    if (exception.mark.name) where += 'in "' + exception.mark.name + '" ';
    where += '(' + (exception.mark.line + 1) + ':' + (exception.mark.column + 1) + ')';
    if (!compact && exception.mark.snippet) where += '\n\n' + exception.mark.snippet;
    return message + ' ' + where;
}
function $4d12843bbf345537$var$YAMLException$1(reason, mark) {
    // Super constructor
    Error.call(this);
    this.name = 'YAMLException';
    this.reason = reason;
    this.mark = mark;
    this.message = $4d12843bbf345537$var$formatError(this, false);
    // Include stack trace in error object
    if (Error.captureStackTrace) // Chrome and NodeJS
    Error.captureStackTrace(this, this.constructor);
    else // FF, IE 10+ and Safari 6+. Fallback for others
    this.stack = new Error().stack || '';
}
// Inherit from Error
$4d12843bbf345537$var$YAMLException$1.prototype = Object.create(Error.prototype);
$4d12843bbf345537$var$YAMLException$1.prototype.constructor = $4d12843bbf345537$var$YAMLException$1;
$4d12843bbf345537$var$YAMLException$1.prototype.toString = function toString(compact) {
    return this.name + ': ' + $4d12843bbf345537$var$formatError(this, compact);
};
var $4d12843bbf345537$var$exception = $4d12843bbf345537$var$YAMLException$1;
// get snippet for a single line, respecting maxLength
function $4d12843bbf345537$var$getLine(buffer, lineStart, lineEnd, position, maxLineLength) {
    var head = '';
    var tail = '';
    var maxHalfLength = Math.floor(maxLineLength / 2) - 1;
    if (position - lineStart > maxHalfLength) {
        head = ' ... ';
        lineStart = position - maxHalfLength + head.length;
    }
    if (lineEnd - position > maxHalfLength) {
        tail = ' ...';
        lineEnd = position + maxHalfLength - tail.length;
    }
    return {
        str: head + buffer.slice(lineStart, lineEnd).replace(/\t/g, "\u2192") + tail,
        pos: position - lineStart + head.length // relative position
    };
}
function $4d12843bbf345537$var$padStart(string, max) {
    return $4d12843bbf345537$var$common.repeat(' ', max - string.length) + string;
}
function $4d12843bbf345537$var$makeSnippet(mark, options) {
    options = Object.create(options || null);
    if (!mark.buffer) return null;
    if (!options.maxLength) options.maxLength = 79;
    if (typeof options.indent !== 'number') options.indent = 1;
    if (typeof options.linesBefore !== 'number') options.linesBefore = 3;
    if (typeof options.linesAfter !== 'number') options.linesAfter = 2;
    var re = /\r?\n|\r|\0/g;
    var lineStarts = [
        0
    ];
    var lineEnds = [];
    var match;
    var foundLineNo = -1;
    while(match = re.exec(mark.buffer)){
        lineEnds.push(match.index);
        lineStarts.push(match.index + match[0].length);
        if (mark.position <= match.index && foundLineNo < 0) foundLineNo = lineStarts.length - 2;
    }
    if (foundLineNo < 0) foundLineNo = lineStarts.length - 1;
    var result = '', i, line;
    var lineNoLength = Math.min(mark.line + options.linesAfter, lineEnds.length).toString().length;
    var maxLineLength = options.maxLength - (options.indent + lineNoLength + 3);
    for(i = 1; i <= options.linesBefore; i++){
        if (foundLineNo - i < 0) break;
        line = $4d12843bbf345537$var$getLine(mark.buffer, lineStarts[foundLineNo - i], lineEnds[foundLineNo - i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo - i]), maxLineLength);
        result = $4d12843bbf345537$var$common.repeat(' ', options.indent) + $4d12843bbf345537$var$padStart((mark.line - i + 1).toString(), lineNoLength) + ' | ' + line.str + '\n' + result;
    }
    line = $4d12843bbf345537$var$getLine(mark.buffer, lineStarts[foundLineNo], lineEnds[foundLineNo], mark.position, maxLineLength);
    result += $4d12843bbf345537$var$common.repeat(' ', options.indent) + $4d12843bbf345537$var$padStart((mark.line + 1).toString(), lineNoLength) + ' | ' + line.str + '\n';
    result += $4d12843bbf345537$var$common.repeat('-', options.indent + lineNoLength + 3 + line.pos) + '^' + '\n';
    for(i = 1; i <= options.linesAfter; i++){
        if (foundLineNo + i >= lineEnds.length) break;
        line = $4d12843bbf345537$var$getLine(mark.buffer, lineStarts[foundLineNo + i], lineEnds[foundLineNo + i], mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo + i]), maxLineLength);
        result += $4d12843bbf345537$var$common.repeat(' ', options.indent) + $4d12843bbf345537$var$padStart((mark.line + i + 1).toString(), lineNoLength) + ' | ' + line.str + '\n';
    }
    return result.replace(/\n$/, '');
}
var $4d12843bbf345537$var$snippet = $4d12843bbf345537$var$makeSnippet;
var $4d12843bbf345537$var$TYPE_CONSTRUCTOR_OPTIONS = [
    'kind',
    'multi',
    'resolve',
    'construct',
    'instanceOf',
    'predicate',
    'represent',
    'representName',
    'defaultStyle',
    'styleAliases'
];
var $4d12843bbf345537$var$YAML_NODE_KINDS = [
    'scalar',
    'sequence',
    'mapping'
];
function $4d12843bbf345537$var$compileStyleAliases(map) {
    var result = {};
    if (map !== null) Object.keys(map).forEach(function(style) {
        map[style].forEach(function(alias) {
            result[String(alias)] = style;
        });
    });
    return result;
}
function $4d12843bbf345537$var$Type$1(tag, options) {
    options = options || {};
    Object.keys(options).forEach(function(name) {
        if ($4d12843bbf345537$var$TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) throw new $4d12843bbf345537$var$exception('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
    });
    // TODO: Add tag format check.
    this.options = options; // keep original options in case user wants to extend this type later
    this.tag = tag;
    this.kind = options['kind'] || null;
    this.resolve = options['resolve'] || function() {
        return true;
    };
    this.construct = options['construct'] || function(data) {
        return data;
    };
    this.instanceOf = options['instanceOf'] || null;
    this.predicate = options['predicate'] || null;
    this.represent = options['represent'] || null;
    this.representName = options['representName'] || null;
    this.defaultStyle = options['defaultStyle'] || null;
    this.multi = options['multi'] || false;
    this.styleAliases = $4d12843bbf345537$var$compileStyleAliases(options['styleAliases'] || null);
    if ($4d12843bbf345537$var$YAML_NODE_KINDS.indexOf(this.kind) === -1) throw new $4d12843bbf345537$var$exception('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
}
var $4d12843bbf345537$var$type = $4d12843bbf345537$var$Type$1;
/*eslint-disable max-len*/ function $4d12843bbf345537$var$compileList(schema, name) {
    var result = [];
    schema[name].forEach(function(currentType) {
        var newIndex = result.length;
        result.forEach(function(previousType, previousIndex) {
            if (previousType.tag === currentType.tag && previousType.kind === currentType.kind && previousType.multi === currentType.multi) newIndex = previousIndex;
        });
        result[newIndex] = currentType;
    });
    return result;
}
function $4d12843bbf345537$var$compileMap() {
    var result = {
        scalar: {},
        sequence: {},
        mapping: {},
        fallback: {},
        multi: {
            scalar: [],
            sequence: [],
            mapping: [],
            fallback: []
        }
    }, index, length;
    function collectType(type) {
        if (type.multi) {
            result.multi[type.kind].push(type);
            result.multi['fallback'].push(type);
        } else result[type.kind][type.tag] = result['fallback'][type.tag] = type;
    }
    for(index = 0, length = arguments.length; index < length; index += 1)arguments[index].forEach(collectType);
    return result;
}
function $4d12843bbf345537$var$Schema$1(definition) {
    return this.extend(definition);
}
$4d12843bbf345537$var$Schema$1.prototype.extend = function extend(definition) {
    var implicit = [];
    var explicit = [];
    if (definition instanceof $4d12843bbf345537$var$type) // Schema.extend(type)
    explicit.push(definition);
    else if (Array.isArray(definition)) // Schema.extend([ type1, type2, ... ])
    explicit = explicit.concat(definition);
    else if (definition && (Array.isArray(definition.implicit) || Array.isArray(definition.explicit))) {
        // Schema.extend({ explicit: [ type1, type2, ... ], implicit: [ type1, type2, ... ] })
        if (definition.implicit) implicit = implicit.concat(definition.implicit);
        if (definition.explicit) explicit = explicit.concat(definition.explicit);
    } else throw new $4d12843bbf345537$var$exception("Schema.extend argument should be a Type, [ Type ], or a schema definition ({ implicit: [...], explicit: [...] })");
    implicit.forEach(function(type$1) {
        if (!(type$1 instanceof $4d12843bbf345537$var$type)) throw new $4d12843bbf345537$var$exception('Specified list of YAML types (or a single Type object) contains a non-Type object.');
        if (type$1.loadKind && type$1.loadKind !== 'scalar') throw new $4d12843bbf345537$var$exception('There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.');
        if (type$1.multi) throw new $4d12843bbf345537$var$exception('There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.');
    });
    explicit.forEach(function(type$1) {
        if (!(type$1 instanceof $4d12843bbf345537$var$type)) throw new $4d12843bbf345537$var$exception('Specified list of YAML types (or a single Type object) contains a non-Type object.');
    });
    var result = Object.create($4d12843bbf345537$var$Schema$1.prototype);
    result.implicit = (this.implicit || []).concat(implicit);
    result.explicit = (this.explicit || []).concat(explicit);
    result.compiledImplicit = $4d12843bbf345537$var$compileList(result, 'implicit');
    result.compiledExplicit = $4d12843bbf345537$var$compileList(result, 'explicit');
    result.compiledTypeMap = $4d12843bbf345537$var$compileMap(result.compiledImplicit, result.compiledExplicit);
    return result;
};
var $4d12843bbf345537$var$schema = $4d12843bbf345537$var$Schema$1;
var $4d12843bbf345537$var$str = new $4d12843bbf345537$var$type('tag:yaml.org,2002:str', {
    kind: 'scalar',
    construct: function(data) {
        return data !== null ? data : '';
    }
});
var $4d12843bbf345537$var$seq = new $4d12843bbf345537$var$type('tag:yaml.org,2002:seq', {
    kind: 'sequence',
    construct: function(data) {
        return data !== null ? data : [];
    }
});
var $4d12843bbf345537$var$map = new $4d12843bbf345537$var$type('tag:yaml.org,2002:map', {
    kind: 'mapping',
    construct: function(data) {
        return data !== null ? data : {};
    }
});
var $4d12843bbf345537$var$failsafe = new $4d12843bbf345537$var$schema({
    explicit: [
        $4d12843bbf345537$var$str,
        $4d12843bbf345537$var$seq,
        $4d12843bbf345537$var$map
    ]
});
function $4d12843bbf345537$var$resolveYamlNull(data) {
    if (data === null) return true;
    var max = data.length;
    return max === 1 && data === '~' || max === 4 && (data === 'null' || data === 'Null' || data === 'NULL');
}
function $4d12843bbf345537$var$constructYamlNull() {
    return null;
}
function $4d12843bbf345537$var$isNull(object) {
    return object === null;
}
var $4d12843bbf345537$var$_null = new $4d12843bbf345537$var$type('tag:yaml.org,2002:null', {
    kind: 'scalar',
    resolve: $4d12843bbf345537$var$resolveYamlNull,
    construct: $4d12843bbf345537$var$constructYamlNull,
    predicate: $4d12843bbf345537$var$isNull,
    represent: {
        canonical: function() {
            return '~';
        },
        lowercase: function() {
            return 'null';
        },
        uppercase: function() {
            return 'NULL';
        },
        camelcase: function() {
            return 'Null';
        },
        empty: function() {
            return '';
        }
    },
    defaultStyle: 'lowercase'
});
function $4d12843bbf345537$var$resolveYamlBoolean(data) {
    if (data === null) return false;
    var max = data.length;
    return max === 4 && (data === 'true' || data === 'True' || data === 'TRUE') || max === 5 && (data === 'false' || data === 'False' || data === 'FALSE');
}
function $4d12843bbf345537$var$constructYamlBoolean(data) {
    return data === 'true' || data === 'True' || data === 'TRUE';
}
function $4d12843bbf345537$var$isBoolean(object) {
    return Object.prototype.toString.call(object) === '[object Boolean]';
}
var $4d12843bbf345537$var$bool = new $4d12843bbf345537$var$type('tag:yaml.org,2002:bool', {
    kind: 'scalar',
    resolve: $4d12843bbf345537$var$resolveYamlBoolean,
    construct: $4d12843bbf345537$var$constructYamlBoolean,
    predicate: $4d12843bbf345537$var$isBoolean,
    represent: {
        lowercase: function(object) {
            return object ? 'true' : 'false';
        },
        uppercase: function(object) {
            return object ? 'TRUE' : 'FALSE';
        },
        camelcase: function(object) {
            return object ? 'True' : 'False';
        }
    },
    defaultStyle: 'lowercase'
});
function $4d12843bbf345537$var$isHexCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */  || 0x41 /* A */  <= c && c <= 0x46 /* F */  || 0x61 /* a */  <= c && c <= 0x66 /* f */ ;
}
function $4d12843bbf345537$var$isOctCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x37 /* 7 */ ;
}
function $4d12843bbf345537$var$isDecCode(c) {
    return 0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ;
}
function $4d12843bbf345537$var$resolveYamlInteger(data) {
    if (data === null) return false;
    var max = data.length, index = 0, hasDigits = false, ch;
    if (!max) return false;
    ch = data[index];
    // sign
    if (ch === '-' || ch === '+') ch = data[++index];
    if (ch === '0') {
        // 0
        if (index + 1 === max) return true;
        ch = data[++index];
        // base 2, base 8, base 16
        if (ch === 'b') {
            // base 2
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (ch !== '0' && ch !== '1') return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
        if (ch === 'x') {
            // base 16
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (!$4d12843bbf345537$var$isHexCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
        if (ch === 'o') {
            // base 8
            index++;
            for(; index < max; index++){
                ch = data[index];
                if (ch === '_') continue;
                if (!$4d12843bbf345537$var$isOctCode(data.charCodeAt(index))) return false;
                hasDigits = true;
            }
            return hasDigits && ch !== '_';
        }
    }
    // base 10 (except 0)
    // value should not start with `_`;
    if (ch === '_') return false;
    for(; index < max; index++){
        ch = data[index];
        if (ch === '_') continue;
        if (!$4d12843bbf345537$var$isDecCode(data.charCodeAt(index))) return false;
        hasDigits = true;
    }
    // Should have digits and should not end with `_`
    if (!hasDigits || ch === '_') return false;
    return true;
}
function $4d12843bbf345537$var$constructYamlInteger(data) {
    var value = data, sign = 1, ch;
    if (value.indexOf('_') !== -1) value = value.replace(/_/g, '');
    ch = value[0];
    if (ch === '-' || ch === '+') {
        if (ch === '-') sign = -1;
        value = value.slice(1);
        ch = value[0];
    }
    if (value === '0') return 0;
    if (ch === '0') {
        if (value[1] === 'b') return sign * parseInt(value.slice(2), 2);
        if (value[1] === 'x') return sign * parseInt(value.slice(2), 16);
        if (value[1] === 'o') return sign * parseInt(value.slice(2), 8);
    }
    return sign * parseInt(value, 10);
}
function $4d12843bbf345537$var$isInteger(object) {
    return Object.prototype.toString.call(object) === '[object Number]' && object % 1 === 0 && !$4d12843bbf345537$var$common.isNegativeZero(object);
}
var $4d12843bbf345537$var$int = new $4d12843bbf345537$var$type('tag:yaml.org,2002:int', {
    kind: 'scalar',
    resolve: $4d12843bbf345537$var$resolveYamlInteger,
    construct: $4d12843bbf345537$var$constructYamlInteger,
    predicate: $4d12843bbf345537$var$isInteger,
    represent: {
        binary: function(obj) {
            return obj >= 0 ? '0b' + obj.toString(2) : '-0b' + obj.toString(2).slice(1);
        },
        octal: function(obj) {
            return obj >= 0 ? '0o' + obj.toString(8) : '-0o' + obj.toString(8).slice(1);
        },
        decimal: function(obj) {
            return obj.toString(10);
        },
        /* eslint-disable max-len */ hexadecimal: function(obj) {
            return obj >= 0 ? '0x' + obj.toString(16).toUpperCase() : '-0x' + obj.toString(16).toUpperCase().slice(1);
        }
    },
    defaultStyle: 'decimal',
    styleAliases: {
        binary: [
            2,
            'bin'
        ],
        octal: [
            8,
            'oct'
        ],
        decimal: [
            10,
            'dec'
        ],
        hexadecimal: [
            16,
            'hex'
        ]
    }
});
var $4d12843bbf345537$var$YAML_FLOAT_PATTERN = new RegExp(// 2.5e4, 2.5 and integers
"^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?|[-+]?\\.(?:inf|Inf|INF)|\\.(?:nan|NaN|NAN))$");
function $4d12843bbf345537$var$resolveYamlFloat(data) {
    if (data === null) return false;
    if (!$4d12843bbf345537$var$YAML_FLOAT_PATTERN.test(data) || // Quick hack to not allow integers end with `_`
    // Probably should update regexp & check speed
    data[data.length - 1] === '_') return false;
    return true;
}
function $4d12843bbf345537$var$constructYamlFloat(data) {
    var value, sign;
    value = data.replace(/_/g, '').toLowerCase();
    sign = value[0] === '-' ? -1 : 1;
    if ('+-'.indexOf(value[0]) >= 0) value = value.slice(1);
    if (value === '.inf') return sign === 1 ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;
    else if (value === '.nan') return NaN;
    return sign * parseFloat(value, 10);
}
var $4d12843bbf345537$var$SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;
function $4d12843bbf345537$var$representYamlFloat(object, style) {
    var res;
    if (isNaN(object)) switch(style){
        case 'lowercase':
            return '.nan';
        case 'uppercase':
            return '.NAN';
        case 'camelcase':
            return '.NaN';
    }
    else if (Number.POSITIVE_INFINITY === object) switch(style){
        case 'lowercase':
            return '.inf';
        case 'uppercase':
            return '.INF';
        case 'camelcase':
            return '.Inf';
    }
    else if (Number.NEGATIVE_INFINITY === object) switch(style){
        case 'lowercase':
            return '-.inf';
        case 'uppercase':
            return '-.INF';
        case 'camelcase':
            return '-.Inf';
    }
    else if ($4d12843bbf345537$var$common.isNegativeZero(object)) return '-0.0';
    res = object.toString(10);
    // JS stringifier can build scientific format without dots: 5e-100,
    // while YAML requres dot: 5.e-100. Fix it with simple hack
    return $4d12843bbf345537$var$SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace('e', '.e') : res;
}
function $4d12843bbf345537$var$isFloat(object) {
    return Object.prototype.toString.call(object) === '[object Number]' && (object % 1 !== 0 || $4d12843bbf345537$var$common.isNegativeZero(object));
}
var $4d12843bbf345537$var$float = new $4d12843bbf345537$var$type('tag:yaml.org,2002:float', {
    kind: 'scalar',
    resolve: $4d12843bbf345537$var$resolveYamlFloat,
    construct: $4d12843bbf345537$var$constructYamlFloat,
    predicate: $4d12843bbf345537$var$isFloat,
    represent: $4d12843bbf345537$var$representYamlFloat,
    defaultStyle: 'lowercase'
});
var $4d12843bbf345537$var$json = $4d12843bbf345537$var$failsafe.extend({
    implicit: [
        $4d12843bbf345537$var$_null,
        $4d12843bbf345537$var$bool,
        $4d12843bbf345537$var$int,
        $4d12843bbf345537$var$float
    ]
});
var $4d12843bbf345537$var$core = $4d12843bbf345537$var$json;
var $4d12843bbf345537$var$YAML_DATE_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9])-([0-9][0-9])$"); // [3] day
var $4d12843bbf345537$var$YAML_TIMESTAMP_REGEXP = new RegExp("^([0-9][0-9][0-9][0-9])-([0-9][0-9]?)-([0-9][0-9]?)(?:[Tt]|[ \\t]+)([0-9][0-9]?):([0-9][0-9]):([0-9][0-9])(?:\\.([0-9]*))?(?:[ \\t]*(Z|([-+])([0-9][0-9]?)(?::([0-9][0-9]))?))?$"); // [11] tz_minute
function $4d12843bbf345537$var$resolveYamlTimestamp(data) {
    if (data === null) return false;
    if ($4d12843bbf345537$var$YAML_DATE_REGEXP.exec(data) !== null) return true;
    if ($4d12843bbf345537$var$YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
    return false;
}
function $4d12843bbf345537$var$constructYamlTimestamp(data) {
    var match, year, month, day, hour, minute, second, fraction = 0, delta = null, tz_hour, tz_minute, date;
    match = $4d12843bbf345537$var$YAML_DATE_REGEXP.exec(data);
    if (match === null) match = $4d12843bbf345537$var$YAML_TIMESTAMP_REGEXP.exec(data);
    if (match === null) throw new Error('Date resolve error');
    // match: [1] year [2] month [3] day
    year = +match[1];
    month = +match[2] - 1; // JS month starts with 0
    day = +match[3];
    if (!match[4]) return new Date(Date.UTC(year, month, day));
    // match: [4] hour [5] minute [6] second [7] fraction
    hour = +match[4];
    minute = +match[5];
    second = +match[6];
    if (match[7]) {
        fraction = match[7].slice(0, 3);
        while(fraction.length < 3)fraction += '0';
        fraction = +fraction;
    }
    // match: [8] tz [9] tz_sign [10] tz_hour [11] tz_minute
    if (match[9]) {
        tz_hour = +match[10];
        tz_minute = +(match[11] || 0);
        delta = (tz_hour * 60 + tz_minute) * 60000; // delta in mili-seconds
        if (match[9] === '-') delta = -delta;
    }
    date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));
    if (delta) date.setTime(date.getTime() - delta);
    return date;
}
function $4d12843bbf345537$var$representYamlTimestamp(object /*, style*/ ) {
    return object.toISOString();
}
var $4d12843bbf345537$var$timestamp = new $4d12843bbf345537$var$type('tag:yaml.org,2002:timestamp', {
    kind: 'scalar',
    resolve: $4d12843bbf345537$var$resolveYamlTimestamp,
    construct: $4d12843bbf345537$var$constructYamlTimestamp,
    instanceOf: Date,
    represent: $4d12843bbf345537$var$representYamlTimestamp
});
function $4d12843bbf345537$var$resolveYamlMerge(data) {
    return data === '<<' || data === null;
}
var $4d12843bbf345537$var$merge = new $4d12843bbf345537$var$type('tag:yaml.org,2002:merge', {
    kind: 'scalar',
    resolve: $4d12843bbf345537$var$resolveYamlMerge
});
/*eslint-disable no-bitwise*/ // [ 64, 65, 66 ] -> [ padding, CR, LF ]
var $4d12843bbf345537$var$BASE64_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r';
function $4d12843bbf345537$var$resolveYamlBinary(data) {
    if (data === null) return false;
    var code, idx, bitlen = 0, max = data.length, map = $4d12843bbf345537$var$BASE64_MAP;
    // Convert one by one.
    for(idx = 0; idx < max; idx++){
        code = map.indexOf(data.charAt(idx));
        // Skip CR/LF
        if (code > 64) continue;
        // Fail on illegal characters
        if (code < 0) return false;
        bitlen += 6;
    }
    // If there are any bits left, source was corrupted
    return bitlen % 8 === 0;
}
function $4d12843bbf345537$var$constructYamlBinary(data) {
    var idx, tailbits, input = data.replace(/[\r\n=]/g, ''), max = input.length, map = $4d12843bbf345537$var$BASE64_MAP, bits = 0, result = [];
    // Collect by 6*4 bits (3 bytes)
    for(idx = 0; idx < max; idx++){
        if (idx % 4 === 0 && idx) {
            result.push(bits >> 16 & 0xFF);
            result.push(bits >> 8 & 0xFF);
            result.push(bits & 0xFF);
        }
        bits = bits << 6 | map.indexOf(input.charAt(idx));
    }
    // Dump tail
    tailbits = max % 4 * 6;
    if (tailbits === 0) {
        result.push(bits >> 16 & 0xFF);
        result.push(bits >> 8 & 0xFF);
        result.push(bits & 0xFF);
    } else if (tailbits === 18) {
        result.push(bits >> 10 & 0xFF);
        result.push(bits >> 2 & 0xFF);
    } else if (tailbits === 12) result.push(bits >> 4 & 0xFF);
    return new Uint8Array(result);
}
function $4d12843bbf345537$var$representYamlBinary(object /*, style*/ ) {
    var result = '', bits = 0, idx, tail, max = object.length, map = $4d12843bbf345537$var$BASE64_MAP;
    // Convert every three bytes to 4 ASCII characters.
    for(idx = 0; idx < max; idx++){
        if (idx % 3 === 0 && idx) {
            result += map[bits >> 18 & 0x3F];
            result += map[bits >> 12 & 0x3F];
            result += map[bits >> 6 & 0x3F];
            result += map[bits & 0x3F];
        }
        bits = (bits << 8) + object[idx];
    }
    // Dump tail
    tail = max % 3;
    if (tail === 0) {
        result += map[bits >> 18 & 0x3F];
        result += map[bits >> 12 & 0x3F];
        result += map[bits >> 6 & 0x3F];
        result += map[bits & 0x3F];
    } else if (tail === 2) {
        result += map[bits >> 10 & 0x3F];
        result += map[bits >> 4 & 0x3F];
        result += map[bits << 2 & 0x3F];
        result += map[64];
    } else if (tail === 1) {
        result += map[bits >> 2 & 0x3F];
        result += map[bits << 4 & 0x3F];
        result += map[64];
        result += map[64];
    }
    return result;
}
function $4d12843bbf345537$var$isBinary(obj) {
    return Object.prototype.toString.call(obj) === '[object Uint8Array]';
}
var $4d12843bbf345537$var$binary = new $4d12843bbf345537$var$type('tag:yaml.org,2002:binary', {
    kind: 'scalar',
    resolve: $4d12843bbf345537$var$resolveYamlBinary,
    construct: $4d12843bbf345537$var$constructYamlBinary,
    predicate: $4d12843bbf345537$var$isBinary,
    represent: $4d12843bbf345537$var$representYamlBinary
});
var $4d12843bbf345537$var$_hasOwnProperty$3 = Object.prototype.hasOwnProperty;
var $4d12843bbf345537$var$_toString$2 = Object.prototype.toString;
function $4d12843bbf345537$var$resolveYamlOmap(data) {
    if (data === null) return true;
    var objectKeys = [], index, length, pair, pairKey, pairHasKey, object = data;
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        pairHasKey = false;
        if ($4d12843bbf345537$var$_toString$2.call(pair) !== '[object Object]') return false;
        for(pairKey in pair)if ($4d12843bbf345537$var$_hasOwnProperty$3.call(pair, pairKey)) {
            if (!pairHasKey) pairHasKey = true;
            else return false;
        }
        if (!pairHasKey) return false;
        if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);
        else return false;
    }
    return true;
}
function $4d12843bbf345537$var$constructYamlOmap(data) {
    return data !== null ? data : [];
}
var $4d12843bbf345537$var$omap = new $4d12843bbf345537$var$type('tag:yaml.org,2002:omap', {
    kind: 'sequence',
    resolve: $4d12843bbf345537$var$resolveYamlOmap,
    construct: $4d12843bbf345537$var$constructYamlOmap
});
var $4d12843bbf345537$var$_toString$1 = Object.prototype.toString;
function $4d12843bbf345537$var$resolveYamlPairs(data) {
    if (data === null) return true;
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        if ($4d12843bbf345537$var$_toString$1.call(pair) !== '[object Object]') return false;
        keys = Object.keys(pair);
        if (keys.length !== 1) return false;
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return true;
}
function $4d12843bbf345537$var$constructYamlPairs(data) {
    if (data === null) return [];
    var index, length, pair, keys, result, object = data;
    result = new Array(object.length);
    for(index = 0, length = object.length; index < length; index += 1){
        pair = object[index];
        keys = Object.keys(pair);
        result[index] = [
            keys[0],
            pair[keys[0]]
        ];
    }
    return result;
}
var $4d12843bbf345537$var$pairs = new $4d12843bbf345537$var$type('tag:yaml.org,2002:pairs', {
    kind: 'sequence',
    resolve: $4d12843bbf345537$var$resolveYamlPairs,
    construct: $4d12843bbf345537$var$constructYamlPairs
});
var $4d12843bbf345537$var$_hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function $4d12843bbf345537$var$resolveYamlSet(data) {
    if (data === null) return true;
    var key, object = data;
    for(key in object)if ($4d12843bbf345537$var$_hasOwnProperty$2.call(object, key)) {
        if (object[key] !== null) return false;
    }
    return true;
}
function $4d12843bbf345537$var$constructYamlSet(data) {
    return data !== null ? data : {};
}
var $4d12843bbf345537$var$set = new $4d12843bbf345537$var$type('tag:yaml.org,2002:set', {
    kind: 'mapping',
    resolve: $4d12843bbf345537$var$resolveYamlSet,
    construct: $4d12843bbf345537$var$constructYamlSet
});
var $4d12843bbf345537$var$_default = $4d12843bbf345537$var$core.extend({
    implicit: [
        $4d12843bbf345537$var$timestamp,
        $4d12843bbf345537$var$merge
    ],
    explicit: [
        $4d12843bbf345537$var$binary,
        $4d12843bbf345537$var$omap,
        $4d12843bbf345537$var$pairs,
        $4d12843bbf345537$var$set
    ]
});
/*eslint-disable max-len,no-use-before-define*/ var $4d12843bbf345537$var$_hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var $4d12843bbf345537$var$CONTEXT_FLOW_IN = 1;
var $4d12843bbf345537$var$CONTEXT_FLOW_OUT = 2;
var $4d12843bbf345537$var$CONTEXT_BLOCK_IN = 3;
var $4d12843bbf345537$var$CONTEXT_BLOCK_OUT = 4;
var $4d12843bbf345537$var$CHOMPING_CLIP = 1;
var $4d12843bbf345537$var$CHOMPING_STRIP = 2;
var $4d12843bbf345537$var$CHOMPING_KEEP = 3;
var $4d12843bbf345537$var$PATTERN_NON_PRINTABLE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
var $4d12843bbf345537$var$PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
var $4d12843bbf345537$var$PATTERN_FLOW_INDICATORS = /[,\[\]\{\}]/;
var $4d12843bbf345537$var$PATTERN_TAG_HANDLE = /^(?:!|!!|![a-z\-]+!)$/i;
var $4d12843bbf345537$var$PATTERN_TAG_URI = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;
function $4d12843bbf345537$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $4d12843bbf345537$var$is_EOL(c) {
    return c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function $4d12843bbf345537$var$is_WHITE_SPACE(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */ ;
}
function $4d12843bbf345537$var$is_WS_OR_EOL(c) {
    return c === 0x09 /* Tab */  || c === 0x20 /* Space */  || c === 0x0A /* LF */  || c === 0x0D /* CR */ ;
}
function $4d12843bbf345537$var$is_FLOW_INDICATOR(c) {
    return c === 0x2C /* , */  || c === 0x5B /* [ */  || c === 0x5D /* ] */  || c === 0x7B /* { */  || c === 0x7D /* } */ ;
}
function $4d12843bbf345537$var$fromHexCode(c) {
    var lc;
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    /*eslint-disable no-bitwise*/ lc = c | 0x20;
    if (0x61 /* a */  <= lc && lc <= 0x66 /* f */ ) return lc - 0x61 + 10;
    return -1;
}
function $4d12843bbf345537$var$escapedHexLen(c) {
    if (c === 0x78 /* x */ ) return 2;
    if (c === 0x75 /* u */ ) return 4;
    if (c === 0x55 /* U */ ) return 8;
    return 0;
}
function $4d12843bbf345537$var$fromDecimalCode(c) {
    if (0x30 /* 0 */  <= c && c <= 0x39 /* 9 */ ) return c - 0x30;
    return -1;
}
function $4d12843bbf345537$var$simpleEscapeSequence(c) {
    /* eslint-disable indent */ return c === 0x30 /* 0 */  ? '\x00' : c === 0x61 /* a */  ? '\x07' : c === 0x62 /* b */  ? '\x08' : c === 0x74 /* t */  ? '\x09' : c === 0x09 /* Tab */  ? '\x09' : c === 0x6E /* n */  ? '\x0A' : c === 0x76 /* v */  ? '\x0B' : c === 0x66 /* f */  ? '\x0C' : c === 0x72 /* r */  ? '\x0D' : c === 0x65 /* e */  ? '\x1B' : c === 0x20 /* Space */  ? ' ' : c === 0x22 /* " */  ? '\x22' : c === 0x2F /* / */  ? '/' : c === 0x5C /* \ */  ? '\x5C' : c === 0x4E /* N */  ? '\x85' : c === 0x5F /* _ */  ? '\xA0' : c === 0x4C /* L */  ? '\u2028' : c === 0x50 /* P */  ? '\u2029' : '';
}
function $4d12843bbf345537$var$charFromCodepoint(c) {
    if (c <= 0xFFFF) return String.fromCharCode(c);
    // Encode UTF-16 surrogate pair
    // https://en.wikipedia.org/wiki/UTF-16#Code_points_U.2B010000_to_U.2B10FFFF
    return String.fromCharCode((c - 0x010000 >> 10) + 0xD800, (c - 0x010000 & 0x03FF) + 0xDC00);
}
// set a property of a literal object, while protecting against prototype pollution,
// see https://github.com/nodeca/js-yaml/issues/164 for more details
function $4d12843bbf345537$var$setProperty(object, key, value) {
    // used for this specific key only because Object.defineProperty is slow
    if (key === '__proto__') Object.defineProperty(object, key, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
    else object[key] = value;
}
var $4d12843bbf345537$var$simpleEscapeCheck = new Array(256); // integer, for fast access
var $4d12843bbf345537$var$simpleEscapeMap = new Array(256);
for(var $4d12843bbf345537$var$i = 0; $4d12843bbf345537$var$i < 256; $4d12843bbf345537$var$i++){
    $4d12843bbf345537$var$simpleEscapeCheck[$4d12843bbf345537$var$i] = $4d12843bbf345537$var$simpleEscapeSequence($4d12843bbf345537$var$i) ? 1 : 0;
    $4d12843bbf345537$var$simpleEscapeMap[$4d12843bbf345537$var$i] = $4d12843bbf345537$var$simpleEscapeSequence($4d12843bbf345537$var$i);
}
function $4d12843bbf345537$var$State$1(input, options) {
    this.input = input;
    this.filename = options['filename'] || null;
    this.schema = options['schema'] || $4d12843bbf345537$var$_default;
    this.onWarning = options['onWarning'] || null;
    // (Hidden) Remove? makes the loader to expect YAML 1.1 documents
    // if such documents have no explicit %YAML directive
    this.legacy = options['legacy'] || false;
    this.json = options['json'] || false;
    this.listener = options['listener'] || null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.typeMap = this.schema.compiledTypeMap;
    this.length = input.length;
    this.position = 0;
    this.line = 0;
    this.lineStart = 0;
    this.lineIndent = 0;
    // position of first leading tab in the current line,
    // used to make sure there are no tabs in the indentation
    this.firstTabInLine = -1;
    this.documents = [];
/*
  this.version;
  this.checkLineBreaks;
  this.tagMap;
  this.anchorMap;
  this.tag;
  this.anchor;
  this.kind;
  this.result;*/ }
function $4d12843bbf345537$var$generateError(state, message) {
    var mark = {
        name: state.filename,
        buffer: state.input.slice(0, -1),
        position: state.position,
        line: state.line,
        column: state.position - state.lineStart
    };
    mark.snippet = $4d12843bbf345537$var$snippet(mark);
    return new $4d12843bbf345537$var$exception(message, mark);
}
function $4d12843bbf345537$var$throwError(state, message) {
    throw $4d12843bbf345537$var$generateError(state, message);
}
function $4d12843bbf345537$var$throwWarning(state, message) {
    if (state.onWarning) state.onWarning.call(null, $4d12843bbf345537$var$generateError(state, message));
}
var $4d12843bbf345537$var$directiveHandlers = {
    YAML: function handleYamlDirective(state, name, args) {
        var match, major, minor;
        if (state.version !== null) $4d12843bbf345537$var$throwError(state, 'duplication of %YAML directive');
        if (args.length !== 1) $4d12843bbf345537$var$throwError(state, 'YAML directive accepts exactly one argument');
        match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);
        if (match === null) $4d12843bbf345537$var$throwError(state, 'ill-formed argument of the YAML directive');
        major = parseInt(match[1], 10);
        minor = parseInt(match[2], 10);
        if (major !== 1) $4d12843bbf345537$var$throwError(state, 'unacceptable YAML version of the document');
        state.version = args[0];
        state.checkLineBreaks = minor < 2;
        if (minor !== 1 && minor !== 2) $4d12843bbf345537$var$throwWarning(state, 'unsupported YAML version of the document');
    },
    TAG: function handleTagDirective(state, name, args) {
        var handle, prefix;
        if (args.length !== 2) $4d12843bbf345537$var$throwError(state, 'TAG directive accepts exactly two arguments');
        handle = args[0];
        prefix = args[1];
        if (!$4d12843bbf345537$var$PATTERN_TAG_HANDLE.test(handle)) $4d12843bbf345537$var$throwError(state, 'ill-formed tag handle (first argument) of the TAG directive');
        if ($4d12843bbf345537$var$_hasOwnProperty$1.call(state.tagMap, handle)) $4d12843bbf345537$var$throwError(state, 'there is a previously declared suffix for "' + handle + '" tag handle');
        if (!$4d12843bbf345537$var$PATTERN_TAG_URI.test(prefix)) $4d12843bbf345537$var$throwError(state, 'ill-formed tag prefix (second argument) of the TAG directive');
        try {
            prefix = decodeURIComponent(prefix);
        } catch (err) {
            $4d12843bbf345537$var$throwError(state, 'tag prefix is malformed: ' + prefix);
        }
        state.tagMap[handle] = prefix;
    }
};
function $4d12843bbf345537$var$captureSegment(state, start, end, checkJson) {
    var _position, _length, _character, _result;
    if (start < end) {
        _result = state.input.slice(start, end);
        if (checkJson) for(_position = 0, _length = _result.length; _position < _length; _position += 1){
            _character = _result.charCodeAt(_position);
            if (!(_character === 0x09 || 0x20 <= _character && _character <= 0x10FFFF)) $4d12843bbf345537$var$throwError(state, 'expected valid JSON character');
        }
        else if ($4d12843bbf345537$var$PATTERN_NON_PRINTABLE.test(_result)) $4d12843bbf345537$var$throwError(state, 'the stream contains non-printable characters');
        state.result += _result;
    }
}
function $4d12843bbf345537$var$mergeMappings(state, destination, source, overridableKeys) {
    var sourceKeys, key, index, quantity;
    if (!$4d12843bbf345537$var$common.isObject(source)) $4d12843bbf345537$var$throwError(state, 'cannot merge mappings; the provided source object is unacceptable');
    sourceKeys = Object.keys(source);
    for(index = 0, quantity = sourceKeys.length; index < quantity; index += 1){
        key = sourceKeys[index];
        if (!$4d12843bbf345537$var$_hasOwnProperty$1.call(destination, key)) {
            $4d12843bbf345537$var$setProperty(destination, key, source[key]);
            overridableKeys[key] = true;
        }
    }
}
function $4d12843bbf345537$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, startLine, startLineStart, startPos) {
    var index, quantity;
    // The output is a plain object here, so keys can only be strings.
    // We need to convert keyNode to a string, but doing so can hang the process
    // (deeply nested arrays that explode exponentially using aliases).
    if (Array.isArray(keyNode)) {
        keyNode = Array.prototype.slice.call(keyNode);
        for(index = 0, quantity = keyNode.length; index < quantity; index += 1){
            if (Array.isArray(keyNode[index])) $4d12843bbf345537$var$throwError(state, 'nested arrays are not supported inside keys');
            if (typeof keyNode === 'object' && $4d12843bbf345537$var$_class(keyNode[index]) === '[object Object]') keyNode[index] = '[object Object]';
        }
    }
    // Avoid code execution in load() via toString property
    // (still use its own toString for arrays, timestamps,
    // and whatever user schema extensions happen to have @@toStringTag)
    if (typeof keyNode === 'object' && $4d12843bbf345537$var$_class(keyNode) === '[object Object]') keyNode = '[object Object]';
    keyNode = String(keyNode);
    if (_result === null) _result = {};
    if (keyTag === 'tag:yaml.org,2002:merge') {
        if (Array.isArray(valueNode)) for(index = 0, quantity = valueNode.length; index < quantity; index += 1)$4d12843bbf345537$var$mergeMappings(state, _result, valueNode[index], overridableKeys);
        else $4d12843bbf345537$var$mergeMappings(state, _result, valueNode, overridableKeys);
    } else {
        if (!state.json && !$4d12843bbf345537$var$_hasOwnProperty$1.call(overridableKeys, keyNode) && $4d12843bbf345537$var$_hasOwnProperty$1.call(_result, keyNode)) {
            state.line = startLine || state.line;
            state.lineStart = startLineStart || state.lineStart;
            state.position = startPos || state.position;
            $4d12843bbf345537$var$throwError(state, 'duplicated mapping key');
        }
        $4d12843bbf345537$var$setProperty(_result, keyNode, valueNode);
        delete overridableKeys[keyNode];
    }
    return _result;
}
function $4d12843bbf345537$var$readLineBreak(state) {
    var ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x0A /* LF */ ) state.position++;
    else if (ch === 0x0D /* CR */ ) {
        state.position++;
        if (state.input.charCodeAt(state.position) === 0x0A /* LF */ ) state.position++;
    } else $4d12843bbf345537$var$throwError(state, 'a line break is expected');
    state.line += 1;
    state.lineStart = state.position;
    state.firstTabInLine = -1;
}
function $4d12843bbf345537$var$skipSeparationSpace(state, allowComments, checkIndent) {
    var lineBreaks = 0, ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        while($4d12843bbf345537$var$is_WHITE_SPACE(ch)){
            if (ch === 0x09 /* Tab */  && state.firstTabInLine === -1) state.firstTabInLine = state.position;
            ch = state.input.charCodeAt(++state.position);
        }
        if (allowComments && ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0x0A /* LF */  && ch !== 0x0D /* CR */  && ch !== 0);
        if ($4d12843bbf345537$var$is_EOL(ch)) {
            $4d12843bbf345537$var$readLineBreak(state);
            ch = state.input.charCodeAt(state.position);
            lineBreaks++;
            state.lineIndent = 0;
            while(ch === 0x20 /* Space */ ){
                state.lineIndent++;
                ch = state.input.charCodeAt(++state.position);
            }
        } else break;
    }
    if (checkIndent !== -1 && lineBreaks !== 0 && state.lineIndent < checkIndent) $4d12843bbf345537$var$throwWarning(state, 'deficient indentation');
    return lineBreaks;
}
function $4d12843bbf345537$var$testDocumentSeparator(state) {
    var _position = state.position, ch;
    ch = state.input.charCodeAt(_position);
    // Condition state.position === state.lineStart is tested
    // in parent on each call, for efficiency. No needs to test here again.
    if ((ch === 0x2D /* - */  || ch === 0x2E /* . */ ) && ch === state.input.charCodeAt(_position + 1) && ch === state.input.charCodeAt(_position + 2)) {
        _position += 3;
        ch = state.input.charCodeAt(_position);
        if (ch === 0 || $4d12843bbf345537$var$is_WS_OR_EOL(ch)) return true;
    }
    return false;
}
function $4d12843bbf345537$var$writeFoldedLines(state, count) {
    if (count === 1) state.result += ' ';
    else if (count > 1) state.result += $4d12843bbf345537$var$common.repeat('\n', count - 1);
}
function $4d12843bbf345537$var$readPlainScalar(state, nodeIndent, withinFlowCollection) {
    var preceding, following, captureStart, captureEnd, hasPendingContent, _line, _lineStart, _lineIndent, _kind = state.kind, _result = state.result, ch;
    ch = state.input.charCodeAt(state.position);
    if ($4d12843bbf345537$var$is_WS_OR_EOL(ch) || $4d12843bbf345537$var$is_FLOW_INDICATOR(ch) || ch === 0x23 /* # */  || ch === 0x26 /* & */  || ch === 0x2A /* * */  || ch === 0x21 /* ! */  || ch === 0x7C /* | */  || ch === 0x3E /* > */  || ch === 0x27 /* ' */  || ch === 0x22 /* " */  || ch === 0x25 /* % */  || ch === 0x40 /* @ */  || ch === 0x60 /* ` */ ) return false;
    if (ch === 0x3F /* ? */  || ch === 0x2D /* - */ ) {
        following = state.input.charCodeAt(state.position + 1);
        if ($4d12843bbf345537$var$is_WS_OR_EOL(following) || withinFlowCollection && $4d12843bbf345537$var$is_FLOW_INDICATOR(following)) return false;
    }
    state.kind = 'scalar';
    state.result = '';
    captureStart = captureEnd = state.position;
    hasPendingContent = false;
    while(ch !== 0){
        if (ch === 0x3A /* : */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if ($4d12843bbf345537$var$is_WS_OR_EOL(following) || withinFlowCollection && $4d12843bbf345537$var$is_FLOW_INDICATOR(following)) break;
        } else if (ch === 0x23 /* # */ ) {
            preceding = state.input.charCodeAt(state.position - 1);
            if ($4d12843bbf345537$var$is_WS_OR_EOL(preceding)) break;
        } else if (state.position === state.lineStart && $4d12843bbf345537$var$testDocumentSeparator(state) || withinFlowCollection && $4d12843bbf345537$var$is_FLOW_INDICATOR(ch)) break;
        else if ($4d12843bbf345537$var$is_EOL(ch)) {
            _line = state.line;
            _lineStart = state.lineStart;
            _lineIndent = state.lineIndent;
            $4d12843bbf345537$var$skipSeparationSpace(state, false, -1);
            if (state.lineIndent >= nodeIndent) {
                hasPendingContent = true;
                ch = state.input.charCodeAt(state.position);
                continue;
            } else {
                state.position = captureEnd;
                state.line = _line;
                state.lineStart = _lineStart;
                state.lineIndent = _lineIndent;
                break;
            }
        }
        if (hasPendingContent) {
            $4d12843bbf345537$var$captureSegment(state, captureStart, captureEnd, false);
            $4d12843bbf345537$var$writeFoldedLines(state, state.line - _line);
            captureStart = captureEnd = state.position;
            hasPendingContent = false;
        }
        if (!$4d12843bbf345537$var$is_WHITE_SPACE(ch)) captureEnd = state.position + 1;
        ch = state.input.charCodeAt(++state.position);
    }
    $4d12843bbf345537$var$captureSegment(state, captureStart, captureEnd, false);
    if (state.result) return true;
    state.kind = _kind;
    state.result = _result;
    return false;
}
function $4d12843bbf345537$var$readSingleQuotedScalar(state, nodeIndent) {
    var ch, captureStart, captureEnd;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x27 /* ' */ ) return false;
    state.kind = 'scalar';
    state.result = '';
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x27 /* ' */ ) {
            $4d12843bbf345537$var$captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if (ch === 0x27 /* ' */ ) {
                captureStart = state.position;
                state.position++;
                captureEnd = state.position;
            } else return true;
        } else if ($4d12843bbf345537$var$is_EOL(ch)) {
            $4d12843bbf345537$var$captureSegment(state, captureStart, captureEnd, true);
            $4d12843bbf345537$var$writeFoldedLines(state, $4d12843bbf345537$var$skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && $4d12843bbf345537$var$testDocumentSeparator(state)) $4d12843bbf345537$var$throwError(state, 'unexpected end of the document within a single quoted scalar');
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    $4d12843bbf345537$var$throwError(state, 'unexpected end of the stream within a single quoted scalar');
}
function $4d12843bbf345537$var$readDoubleQuotedScalar(state, nodeIndent) {
    var captureStart, captureEnd, hexLength, hexResult, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x22 /* " */ ) return false;
    state.kind = 'scalar';
    state.result = '';
    state.position++;
    captureStart = captureEnd = state.position;
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        if (ch === 0x22 /* " */ ) {
            $4d12843bbf345537$var$captureSegment(state, captureStart, state.position, true);
            state.position++;
            return true;
        } else if (ch === 0x5C /* \ */ ) {
            $4d12843bbf345537$var$captureSegment(state, captureStart, state.position, true);
            ch = state.input.charCodeAt(++state.position);
            if ($4d12843bbf345537$var$is_EOL(ch)) $4d12843bbf345537$var$skipSeparationSpace(state, false, nodeIndent);
            else if (ch < 256 && $4d12843bbf345537$var$simpleEscapeCheck[ch]) {
                state.result += $4d12843bbf345537$var$simpleEscapeMap[ch];
                state.position++;
            } else if ((tmp = $4d12843bbf345537$var$escapedHexLen(ch)) > 0) {
                hexLength = tmp;
                hexResult = 0;
                for(; hexLength > 0; hexLength--){
                    ch = state.input.charCodeAt(++state.position);
                    if ((tmp = $4d12843bbf345537$var$fromHexCode(ch)) >= 0) hexResult = (hexResult << 4) + tmp;
                    else $4d12843bbf345537$var$throwError(state, 'expected hexadecimal character');
                }
                state.result += $4d12843bbf345537$var$charFromCodepoint(hexResult);
                state.position++;
            } else $4d12843bbf345537$var$throwError(state, 'unknown escape sequence');
            captureStart = captureEnd = state.position;
        } else if ($4d12843bbf345537$var$is_EOL(ch)) {
            $4d12843bbf345537$var$captureSegment(state, captureStart, captureEnd, true);
            $4d12843bbf345537$var$writeFoldedLines(state, $4d12843bbf345537$var$skipSeparationSpace(state, false, nodeIndent));
            captureStart = captureEnd = state.position;
        } else if (state.position === state.lineStart && $4d12843bbf345537$var$testDocumentSeparator(state)) $4d12843bbf345537$var$throwError(state, 'unexpected end of the document within a double quoted scalar');
        else {
            state.position++;
            captureEnd = state.position;
        }
    }
    $4d12843bbf345537$var$throwError(state, 'unexpected end of the stream within a double quoted scalar');
}
function $4d12843bbf345537$var$readFlowCollection(state, nodeIndent) {
    var readNext = true, _line, _lineStart, _pos, _tag = state.tag, _result, _anchor = state.anchor, following, terminator, isPair, isExplicitPair, isMapping, overridableKeys = Object.create(null), keyNode, keyTag, valueNode, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x5B /* [ */ ) {
        terminator = 0x5D; /* ] */ 
        isMapping = false;
        _result = [];
    } else if (ch === 0x7B /* { */ ) {
        terminator = 0x7D; /* } */ 
        isMapping = true;
        _result = {};
    } else return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(++state.position);
    while(ch !== 0){
        $4d12843bbf345537$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === terminator) {
            state.position++;
            state.tag = _tag;
            state.anchor = _anchor;
            state.kind = isMapping ? 'mapping' : 'sequence';
            state.result = _result;
            return true;
        } else if (!readNext) $4d12843bbf345537$var$throwError(state, 'missed comma between flow collection entries');
        else if (ch === 0x2C /* , */ ) // "flow collection entries can never be completely empty", as per YAML 1.2, section 7.4
        $4d12843bbf345537$var$throwError(state, "expected the node content, but found ','");
        keyTag = keyNode = valueNode = null;
        isPair = isExplicitPair = false;
        if (ch === 0x3F /* ? */ ) {
            following = state.input.charCodeAt(state.position + 1);
            if ($4d12843bbf345537$var$is_WS_OR_EOL(following)) {
                isPair = isExplicitPair = true;
                state.position++;
                $4d12843bbf345537$var$skipSeparationSpace(state, true, nodeIndent);
            }
        }
        _line = state.line; // Save the current line.
        _lineStart = state.lineStart;
        _pos = state.position;
        $4d12843bbf345537$var$composeNode(state, nodeIndent, $4d12843bbf345537$var$CONTEXT_FLOW_IN, false, true);
        keyTag = state.tag;
        keyNode = state.result;
        $4d12843bbf345537$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if ((isExplicitPair || state.line === _line) && ch === 0x3A /* : */ ) {
            isPair = true;
            ch = state.input.charCodeAt(++state.position);
            $4d12843bbf345537$var$skipSeparationSpace(state, true, nodeIndent);
            $4d12843bbf345537$var$composeNode(state, nodeIndent, $4d12843bbf345537$var$CONTEXT_FLOW_IN, false, true);
            valueNode = state.result;
        }
        if (isMapping) $4d12843bbf345537$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos);
        else if (isPair) _result.push($4d12843bbf345537$var$storeMappingPair(state, null, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos));
        else _result.push(keyNode);
        $4d12843bbf345537$var$skipSeparationSpace(state, true, nodeIndent);
        ch = state.input.charCodeAt(state.position);
        if (ch === 0x2C /* , */ ) {
            readNext = true;
            ch = state.input.charCodeAt(++state.position);
        } else readNext = false;
    }
    $4d12843bbf345537$var$throwError(state, 'unexpected end of the stream within a flow collection');
}
function $4d12843bbf345537$var$readBlockScalar(state, nodeIndent) {
    var captureStart, folding, chomping = $4d12843bbf345537$var$CHOMPING_CLIP, didReadContent = false, detectedIndent = false, textIndent = nodeIndent, emptyLines = 0, atMoreIndented = false, tmp, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch === 0x7C /* | */ ) folding = false;
    else if (ch === 0x3E /* > */ ) folding = true;
    else return false;
    state.kind = 'scalar';
    state.result = '';
    while(ch !== 0){
        ch = state.input.charCodeAt(++state.position);
        if (ch === 0x2B /* + */  || ch === 0x2D /* - */ ) {
            if ($4d12843bbf345537$var$CHOMPING_CLIP === chomping) chomping = ch === 0x2B /* + */  ? $4d12843bbf345537$var$CHOMPING_KEEP : $4d12843bbf345537$var$CHOMPING_STRIP;
            else $4d12843bbf345537$var$throwError(state, 'repeat of a chomping mode identifier');
        } else if ((tmp = $4d12843bbf345537$var$fromDecimalCode(ch)) >= 0) {
            if (tmp === 0) $4d12843bbf345537$var$throwError(state, 'bad explicit indentation width of a block scalar; it cannot be less than one');
            else if (!detectedIndent) {
                textIndent = nodeIndent + tmp - 1;
                detectedIndent = true;
            } else $4d12843bbf345537$var$throwError(state, 'repeat of an indentation width identifier');
        } else break;
    }
    if ($4d12843bbf345537$var$is_WHITE_SPACE(ch)) {
        do ch = state.input.charCodeAt(++state.position);
        while ($4d12843bbf345537$var$is_WHITE_SPACE(ch));
        if (ch === 0x23 /* # */ ) do ch = state.input.charCodeAt(++state.position);
        while (!$4d12843bbf345537$var$is_EOL(ch) && ch !== 0);
    }
    while(ch !== 0){
        $4d12843bbf345537$var$readLineBreak(state);
        state.lineIndent = 0;
        ch = state.input.charCodeAt(state.position);
        while((!detectedIndent || state.lineIndent < textIndent) && ch === 0x20 /* Space */ ){
            state.lineIndent++;
            ch = state.input.charCodeAt(++state.position);
        }
        if (!detectedIndent && state.lineIndent > textIndent) textIndent = state.lineIndent;
        if ($4d12843bbf345537$var$is_EOL(ch)) {
            emptyLines++;
            continue;
        }
        // End of the scalar.
        if (state.lineIndent < textIndent) {
            // Perform the chomping.
            if (chomping === $4d12843bbf345537$var$CHOMPING_KEEP) state.result += $4d12843bbf345537$var$common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
            else if (chomping === $4d12843bbf345537$var$CHOMPING_CLIP) {
                if (didReadContent) state.result += '\n';
            }
            break;
        }
        // Folded style: use fancy rules to handle line breaks.
        if (folding) {
            // Lines starting with white space characters (more-indented lines) are not folded.
            if ($4d12843bbf345537$var$is_WHITE_SPACE(ch)) {
                atMoreIndented = true;
                // except for the first content line (cf. Example 8.1)
                state.result += $4d12843bbf345537$var$common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
            // End of more-indented block.
            } else if (atMoreIndented) {
                atMoreIndented = false;
                state.result += $4d12843bbf345537$var$common.repeat('\n', emptyLines + 1);
            // Just one line break - perceive as the same line.
            } else if (emptyLines === 0) {
                if (didReadContent) state.result += ' ';
            } else state.result += $4d12843bbf345537$var$common.repeat('\n', emptyLines);
        // Literal style: just add exact number of line breaks between content lines.
        } else // Keep all line breaks except the header line break.
        state.result += $4d12843bbf345537$var$common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
        didReadContent = true;
        detectedIndent = true;
        emptyLines = 0;
        captureStart = state.position;
        while(!$4d12843bbf345537$var$is_EOL(ch) && ch !== 0)ch = state.input.charCodeAt(++state.position);
        $4d12843bbf345537$var$captureSegment(state, captureStart, state.position, false);
    }
    return true;
}
function $4d12843bbf345537$var$readBlockSequence(state, nodeIndent) {
    var _line, _tag = state.tag, _anchor = state.anchor, _result = [], following, detected = false, ch;
    // there is a leading tab before this token, so it can't be a block sequence/mapping;
    // it can still be flow sequence/mapping or a scalar
    if (state.firstTabInLine !== -1) return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        if (state.firstTabInLine !== -1) {
            state.position = state.firstTabInLine;
            $4d12843bbf345537$var$throwError(state, 'tab characters must not be used in indentation');
        }
        if (ch !== 0x2D /* - */ ) break;
        following = state.input.charCodeAt(state.position + 1);
        if (!$4d12843bbf345537$var$is_WS_OR_EOL(following)) break;
        detected = true;
        state.position++;
        if ($4d12843bbf345537$var$skipSeparationSpace(state, true, -1)) {
            if (state.lineIndent <= nodeIndent) {
                _result.push(null);
                ch = state.input.charCodeAt(state.position);
                continue;
            }
        }
        _line = state.line;
        $4d12843bbf345537$var$composeNode(state, nodeIndent, $4d12843bbf345537$var$CONTEXT_BLOCK_IN, false, true);
        _result.push(state.result);
        $4d12843bbf345537$var$skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) $4d12843bbf345537$var$throwError(state, 'bad indentation of a sequence entry');
        else if (state.lineIndent < nodeIndent) break;
    }
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = 'sequence';
        state.result = _result;
        return true;
    }
    return false;
}
function $4d12843bbf345537$var$readBlockMapping(state, nodeIndent, flowIndent) {
    var following, allowCompact, _line, _keyLine, _keyLineStart, _keyPos, _tag = state.tag, _anchor = state.anchor, _result = {}, overridableKeys = Object.create(null), keyTag = null, keyNode = null, valueNode = null, atExplicitKey = false, detected = false, ch;
    // there is a leading tab before this token, so it can't be a block sequence/mapping;
    // it can still be flow sequence/mapping or a scalar
    if (state.firstTabInLine !== -1) return false;
    if (state.anchor !== null) state.anchorMap[state.anchor] = _result;
    ch = state.input.charCodeAt(state.position);
    while(ch !== 0){
        if (!atExplicitKey && state.firstTabInLine !== -1) {
            state.position = state.firstTabInLine;
            $4d12843bbf345537$var$throwError(state, 'tab characters must not be used in indentation');
        }
        following = state.input.charCodeAt(state.position + 1);
        _line = state.line; // Save the current line.
        //
        // Explicit notation case. There are two separate blocks:
        // first for the key (denoted by "?") and second for the value (denoted by ":")
        //
        if ((ch === 0x3F /* ? */  || ch === 0x3A /* : */ ) && $4d12843bbf345537$var$is_WS_OR_EOL(following)) {
            if (ch === 0x3F /* ? */ ) {
                if (atExplicitKey) {
                    $4d12843bbf345537$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                    keyTag = keyNode = valueNode = null;
                }
                detected = true;
                atExplicitKey = true;
                allowCompact = true;
            } else if (atExplicitKey) {
                // i.e. 0x3A/* : */ === character after the explicit key.
                atExplicitKey = false;
                allowCompact = true;
            } else $4d12843bbf345537$var$throwError(state, 'incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line');
            state.position += 1;
            ch = following;
        //
        // Implicit notation case. Flow-style node as the key first, then ":", and the value.
        //
        } else {
            _keyLine = state.line;
            _keyLineStart = state.lineStart;
            _keyPos = state.position;
            if (!$4d12843bbf345537$var$composeNode(state, flowIndent, $4d12843bbf345537$var$CONTEXT_FLOW_OUT, false, true)) break;
            if (state.line === _line) {
                ch = state.input.charCodeAt(state.position);
                while($4d12843bbf345537$var$is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
                if (ch === 0x3A /* : */ ) {
                    ch = state.input.charCodeAt(++state.position);
                    if (!$4d12843bbf345537$var$is_WS_OR_EOL(ch)) $4d12843bbf345537$var$throwError(state, 'a whitespace character is expected after the key-value separator within a block mapping');
                    if (atExplicitKey) {
                        $4d12843bbf345537$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
                        keyTag = keyNode = valueNode = null;
                    }
                    detected = true;
                    atExplicitKey = false;
                    allowCompact = false;
                    keyTag = state.tag;
                    keyNode = state.result;
                } else if (detected) $4d12843bbf345537$var$throwError(state, 'can not read an implicit mapping pair; a colon is missed');
                else {
                    state.tag = _tag;
                    state.anchor = _anchor;
                    return true; // Keep the result of `composeNode`.
                }
            } else if (detected) $4d12843bbf345537$var$throwError(state, 'can not read a block mapping entry; a multiline key may not be an implicit key');
            else {
                state.tag = _tag;
                state.anchor = _anchor;
                return true; // Keep the result of `composeNode`.
            }
        }
        //
        // Common reading code for both explicit and implicit notations.
        //
        if (state.line === _line || state.lineIndent > nodeIndent) {
            if (atExplicitKey) {
                _keyLine = state.line;
                _keyLineStart = state.lineStart;
                _keyPos = state.position;
            }
            if ($4d12843bbf345537$var$composeNode(state, nodeIndent, $4d12843bbf345537$var$CONTEXT_BLOCK_OUT, true, allowCompact)) {
                if (atExplicitKey) keyNode = state.result;
                else valueNode = state.result;
            }
            if (!atExplicitKey) {
                $4d12843bbf345537$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _keyLine, _keyLineStart, _keyPos);
                keyTag = keyNode = valueNode = null;
            }
            $4d12843bbf345537$var$skipSeparationSpace(state, true, -1);
            ch = state.input.charCodeAt(state.position);
        }
        if ((state.line === _line || state.lineIndent > nodeIndent) && ch !== 0) $4d12843bbf345537$var$throwError(state, 'bad indentation of a mapping entry');
        else if (state.lineIndent < nodeIndent) break;
    }
    //
    // Epilogue.
    //
    // Special case: last mapping's node contains only the key in explicit notation.
    if (atExplicitKey) $4d12843bbf345537$var$storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
    // Expose the resulting mapping.
    if (detected) {
        state.tag = _tag;
        state.anchor = _anchor;
        state.kind = 'mapping';
        state.result = _result;
    }
    return detected;
}
function $4d12843bbf345537$var$readTagProperty(state) {
    var _position, isVerbatim = false, isNamed = false, tagHandle, tagName, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x21 /* ! */ ) return false;
    if (state.tag !== null) $4d12843bbf345537$var$throwError(state, 'duplication of a tag property');
    ch = state.input.charCodeAt(++state.position);
    if (ch === 0x3C /* < */ ) {
        isVerbatim = true;
        ch = state.input.charCodeAt(++state.position);
    } else if (ch === 0x21 /* ! */ ) {
        isNamed = true;
        tagHandle = '!!';
        ch = state.input.charCodeAt(++state.position);
    } else tagHandle = '!';
    _position = state.position;
    if (isVerbatim) {
        do ch = state.input.charCodeAt(++state.position);
        while (ch !== 0 && ch !== 0x3E /* > */ );
        if (state.position < state.length) {
            tagName = state.input.slice(_position, state.position);
            ch = state.input.charCodeAt(++state.position);
        } else $4d12843bbf345537$var$throwError(state, 'unexpected end of the stream within a verbatim tag');
    } else {
        while(ch !== 0 && !$4d12843bbf345537$var$is_WS_OR_EOL(ch)){
            if (ch === 0x21 /* ! */ ) {
                if (!isNamed) {
                    tagHandle = state.input.slice(_position - 1, state.position + 1);
                    if (!$4d12843bbf345537$var$PATTERN_TAG_HANDLE.test(tagHandle)) $4d12843bbf345537$var$throwError(state, 'named tag handle cannot contain such characters');
                    isNamed = true;
                    _position = state.position + 1;
                } else $4d12843bbf345537$var$throwError(state, 'tag suffix cannot contain exclamation marks');
            }
            ch = state.input.charCodeAt(++state.position);
        }
        tagName = state.input.slice(_position, state.position);
        if ($4d12843bbf345537$var$PATTERN_FLOW_INDICATORS.test(tagName)) $4d12843bbf345537$var$throwError(state, 'tag suffix cannot contain flow indicator characters');
    }
    if (tagName && !$4d12843bbf345537$var$PATTERN_TAG_URI.test(tagName)) $4d12843bbf345537$var$throwError(state, 'tag name cannot contain such characters: ' + tagName);
    try {
        tagName = decodeURIComponent(tagName);
    } catch (err) {
        $4d12843bbf345537$var$throwError(state, 'tag name is malformed: ' + tagName);
    }
    if (isVerbatim) state.tag = tagName;
    else if ($4d12843bbf345537$var$_hasOwnProperty$1.call(state.tagMap, tagHandle)) state.tag = state.tagMap[tagHandle] + tagName;
    else if (tagHandle === '!') state.tag = '!' + tagName;
    else if (tagHandle === '!!') state.tag = 'tag:yaml.org,2002:' + tagName;
    else $4d12843bbf345537$var$throwError(state, 'undeclared tag handle "' + tagHandle + '"');
    return true;
}
function $4d12843bbf345537$var$readAnchorProperty(state) {
    var _position, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x26 /* & */ ) return false;
    if (state.anchor !== null) $4d12843bbf345537$var$throwError(state, 'duplication of an anchor property');
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !$4d12843bbf345537$var$is_WS_OR_EOL(ch) && !$4d12843bbf345537$var$is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) $4d12843bbf345537$var$throwError(state, 'name of an anchor node must contain at least one character');
    state.anchor = state.input.slice(_position, state.position);
    return true;
}
function $4d12843bbf345537$var$readAlias(state) {
    var _position, alias, ch;
    ch = state.input.charCodeAt(state.position);
    if (ch !== 0x2A /* * */ ) return false;
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;
    while(ch !== 0 && !$4d12843bbf345537$var$is_WS_OR_EOL(ch) && !$4d12843bbf345537$var$is_FLOW_INDICATOR(ch))ch = state.input.charCodeAt(++state.position);
    if (state.position === _position) $4d12843bbf345537$var$throwError(state, 'name of an alias node must contain at least one character');
    alias = state.input.slice(_position, state.position);
    if (!$4d12843bbf345537$var$_hasOwnProperty$1.call(state.anchorMap, alias)) $4d12843bbf345537$var$throwError(state, 'unidentified alias "' + alias + '"');
    state.result = state.anchorMap[alias];
    $4d12843bbf345537$var$skipSeparationSpace(state, true, -1);
    return true;
}
function $4d12843bbf345537$var$composeNode(state, parentIndent, nodeContext, allowToSeek, allowCompact) {
    var allowBlockStyles, allowBlockScalars, allowBlockCollections, indentStatus = 1, atNewLine = false, hasContent = false, typeIndex, typeQuantity, typeList, type, flowIndent, blockIndent;
    if (state.listener !== null) state.listener('open', state);
    state.tag = null;
    state.anchor = null;
    state.kind = null;
    state.result = null;
    allowBlockStyles = allowBlockScalars = allowBlockCollections = $4d12843bbf345537$var$CONTEXT_BLOCK_OUT === nodeContext || $4d12843bbf345537$var$CONTEXT_BLOCK_IN === nodeContext;
    if (allowToSeek) {
        if ($4d12843bbf345537$var$skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        }
    }
    if (indentStatus === 1) {
        while($4d12843bbf345537$var$readTagProperty(state) || $4d12843bbf345537$var$readAnchorProperty(state))if ($4d12843bbf345537$var$skipSeparationSpace(state, true, -1)) {
            atNewLine = true;
            allowBlockCollections = allowBlockStyles;
            if (state.lineIndent > parentIndent) indentStatus = 1;
            else if (state.lineIndent === parentIndent) indentStatus = 0;
            else if (state.lineIndent < parentIndent) indentStatus = -1;
        } else allowBlockCollections = false;
    }
    if (allowBlockCollections) allowBlockCollections = atNewLine || allowCompact;
    if (indentStatus === 1 || $4d12843bbf345537$var$CONTEXT_BLOCK_OUT === nodeContext) {
        if ($4d12843bbf345537$var$CONTEXT_FLOW_IN === nodeContext || $4d12843bbf345537$var$CONTEXT_FLOW_OUT === nodeContext) flowIndent = parentIndent;
        else flowIndent = parentIndent + 1;
        blockIndent = state.position - state.lineStart;
        if (indentStatus === 1) {
            if (allowBlockCollections && ($4d12843bbf345537$var$readBlockSequence(state, blockIndent) || $4d12843bbf345537$var$readBlockMapping(state, blockIndent, flowIndent)) || $4d12843bbf345537$var$readFlowCollection(state, flowIndent)) hasContent = true;
            else {
                if (allowBlockScalars && $4d12843bbf345537$var$readBlockScalar(state, flowIndent) || $4d12843bbf345537$var$readSingleQuotedScalar(state, flowIndent) || $4d12843bbf345537$var$readDoubleQuotedScalar(state, flowIndent)) hasContent = true;
                else if ($4d12843bbf345537$var$readAlias(state)) {
                    hasContent = true;
                    if (state.tag !== null || state.anchor !== null) $4d12843bbf345537$var$throwError(state, 'alias node should not have any properties');
                } else if ($4d12843bbf345537$var$readPlainScalar(state, flowIndent, $4d12843bbf345537$var$CONTEXT_FLOW_IN === nodeContext)) {
                    hasContent = true;
                    if (state.tag === null) state.tag = '?';
                }
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
            }
        } else if (indentStatus === 0) // Special case: block sequences are allowed to have same indentation level as the parent.
        // http://www.yaml.org/spec/1.2/spec.html#id2799784
        hasContent = allowBlockCollections && $4d12843bbf345537$var$readBlockSequence(state, blockIndent);
    }
    if (state.tag === null) {
        if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
    } else if (state.tag === '?') {
        // Implicit resolving is not allowed for non-scalar types, and '?'
        // non-specific tag is only automatically assigned to plain scalars.
        //
        // We only need to check kind conformity in case user explicitly assigns '?'
        // tag, for example like this: "!<?> [0]"
        //
        if (state.result !== null && state.kind !== 'scalar') $4d12843bbf345537$var$throwError(state, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state.kind + '"');
        for(typeIndex = 0, typeQuantity = state.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1){
            type = state.implicitTypes[typeIndex];
            if (type.resolve(state.result)) {
                state.result = type.construct(state.result);
                state.tag = type.tag;
                if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
                break;
            }
        }
    } else if (state.tag !== '!') {
        if ($4d12843bbf345537$var$_hasOwnProperty$1.call(state.typeMap[state.kind || 'fallback'], state.tag)) type = state.typeMap[state.kind || 'fallback'][state.tag];
        else {
            // looking for multi type
            type = null;
            typeList = state.typeMap.multi[state.kind || 'fallback'];
            for(typeIndex = 0, typeQuantity = typeList.length; typeIndex < typeQuantity; typeIndex += 1)if (state.tag.slice(0, typeList[typeIndex].tag.length) === typeList[typeIndex].tag) {
                type = typeList[typeIndex];
                break;
            }
        }
        if (!type) $4d12843bbf345537$var$throwError(state, 'unknown tag !<' + state.tag + '>');
        if (state.result !== null && type.kind !== state.kind) $4d12843bbf345537$var$throwError(state, 'unacceptable node kind for !<' + state.tag + '> tag; it should be "' + type.kind + '", not "' + state.kind + '"');
        if (!type.resolve(state.result, state.tag)) $4d12843bbf345537$var$throwError(state, 'cannot resolve a node with !<' + state.tag + '> explicit tag');
        else {
            state.result = type.construct(state.result, state.tag);
            if (state.anchor !== null) state.anchorMap[state.anchor] = state.result;
        }
    }
    if (state.listener !== null) state.listener('close', state);
    return state.tag !== null || state.anchor !== null || hasContent;
}
function $4d12843bbf345537$var$readDocument(state) {
    var documentStart = state.position, _position, directiveName, directiveArgs, hasDirectives = false, ch;
    state.version = null;
    state.checkLineBreaks = state.legacy;
    state.tagMap = Object.create(null);
    state.anchorMap = Object.create(null);
    while((ch = state.input.charCodeAt(state.position)) !== 0){
        $4d12843bbf345537$var$skipSeparationSpace(state, true, -1);
        ch = state.input.charCodeAt(state.position);
        if (state.lineIndent > 0 || ch !== 0x25 /* % */ ) break;
        hasDirectives = true;
        ch = state.input.charCodeAt(++state.position);
        _position = state.position;
        while(ch !== 0 && !$4d12843bbf345537$var$is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
        directiveName = state.input.slice(_position, state.position);
        directiveArgs = [];
        if (directiveName.length < 1) $4d12843bbf345537$var$throwError(state, 'directive name must not be less than one character in length');
        while(ch !== 0){
            while($4d12843bbf345537$var$is_WHITE_SPACE(ch))ch = state.input.charCodeAt(++state.position);
            if (ch === 0x23 /* # */ ) {
                do ch = state.input.charCodeAt(++state.position);
                while (ch !== 0 && !$4d12843bbf345537$var$is_EOL(ch));
                break;
            }
            if ($4d12843bbf345537$var$is_EOL(ch)) break;
            _position = state.position;
            while(ch !== 0 && !$4d12843bbf345537$var$is_WS_OR_EOL(ch))ch = state.input.charCodeAt(++state.position);
            directiveArgs.push(state.input.slice(_position, state.position));
        }
        if (ch !== 0) $4d12843bbf345537$var$readLineBreak(state);
        if ($4d12843bbf345537$var$_hasOwnProperty$1.call($4d12843bbf345537$var$directiveHandlers, directiveName)) $4d12843bbf345537$var$directiveHandlers[directiveName](state, directiveName, directiveArgs);
        else $4d12843bbf345537$var$throwWarning(state, 'unknown document directive "' + directiveName + '"');
    }
    $4d12843bbf345537$var$skipSeparationSpace(state, true, -1);
    if (state.lineIndent === 0 && state.input.charCodeAt(state.position) === 0x2D /* - */  && state.input.charCodeAt(state.position + 1) === 0x2D /* - */  && state.input.charCodeAt(state.position + 2) === 0x2D /* - */ ) {
        state.position += 3;
        $4d12843bbf345537$var$skipSeparationSpace(state, true, -1);
    } else if (hasDirectives) $4d12843bbf345537$var$throwError(state, 'directives end mark is expected');
    $4d12843bbf345537$var$composeNode(state, state.lineIndent - 1, $4d12843bbf345537$var$CONTEXT_BLOCK_OUT, false, true);
    $4d12843bbf345537$var$skipSeparationSpace(state, true, -1);
    if (state.checkLineBreaks && $4d12843bbf345537$var$PATTERN_NON_ASCII_LINE_BREAKS.test(state.input.slice(documentStart, state.position))) $4d12843bbf345537$var$throwWarning(state, 'non-ASCII line breaks are interpreted as content');
    state.documents.push(state.result);
    if (state.position === state.lineStart && $4d12843bbf345537$var$testDocumentSeparator(state)) {
        if (state.input.charCodeAt(state.position) === 0x2E /* . */ ) {
            state.position += 3;
            $4d12843bbf345537$var$skipSeparationSpace(state, true, -1);
        }
        return;
    }
    if (state.position < state.length - 1) $4d12843bbf345537$var$throwError(state, 'end of the stream or a document separator is expected');
    else return;
}
function $4d12843bbf345537$var$loadDocuments(input, options) {
    input = String(input);
    options = options || {};
    if (input.length !== 0) {
        // Add tailing `\n` if not exists
        if (input.charCodeAt(input.length - 1) !== 0x0A /* LF */  && input.charCodeAt(input.length - 1) !== 0x0D /* CR */ ) input += '\n';
        // Strip BOM
        if (input.charCodeAt(0) === 0xFEFF) input = input.slice(1);
    }
    var state = new $4d12843bbf345537$var$State$1(input, options);
    var nullpos = input.indexOf('\0');
    if (nullpos !== -1) {
        state.position = nullpos;
        $4d12843bbf345537$var$throwError(state, 'null byte is not allowed in input');
    }
    // Use 0 as string terminator. That significantly simplifies bounds check.
    state.input += '\0';
    while(state.input.charCodeAt(state.position) === 0x20 /* Space */ ){
        state.lineIndent += 1;
        state.position += 1;
    }
    while(state.position < state.length - 1)$4d12843bbf345537$var$readDocument(state);
    return state.documents;
}
function $4d12843bbf345537$var$loadAll$1(input, iterator, options) {
    if (iterator !== null && typeof iterator === 'object' && typeof options === 'undefined') {
        options = iterator;
        iterator = null;
    }
    var documents = $4d12843bbf345537$var$loadDocuments(input, options);
    if (typeof iterator !== 'function') return documents;
    for(var index = 0, length = documents.length; index < length; index += 1)iterator(documents[index]);
}
function $4d12843bbf345537$var$load$1(input, options) {
    var documents = $4d12843bbf345537$var$loadDocuments(input, options);
    if (documents.length === 0) /*eslint-disable no-undefined*/ return undefined;
    else if (documents.length === 1) return documents[0];
    throw new $4d12843bbf345537$var$exception('expected a single document in the stream, but found more');
}
var $4d12843bbf345537$var$loadAll_1 = $4d12843bbf345537$var$loadAll$1;
var $4d12843bbf345537$var$load_1 = $4d12843bbf345537$var$load$1;
var $4d12843bbf345537$var$loader = {
    loadAll: $4d12843bbf345537$var$loadAll_1,
    load: $4d12843bbf345537$var$load_1
};
/*eslint-disable no-use-before-define*/ var $4d12843bbf345537$var$_toString = Object.prototype.toString;
var $4d12843bbf345537$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
var $4d12843bbf345537$var$CHAR_BOM = 0xFEFF;
var $4d12843bbf345537$var$CHAR_TAB = 0x09; /* Tab */ 
var $4d12843bbf345537$var$CHAR_LINE_FEED = 0x0A; /* LF */ 
var $4d12843bbf345537$var$CHAR_CARRIAGE_RETURN = 0x0D; /* CR */ 
var $4d12843bbf345537$var$CHAR_SPACE = 0x20; /* Space */ 
var $4d12843bbf345537$var$CHAR_EXCLAMATION = 0x21; /* ! */ 
var $4d12843bbf345537$var$CHAR_DOUBLE_QUOTE = 0x22; /* " */ 
var $4d12843bbf345537$var$CHAR_SHARP = 0x23; /* # */ 
var $4d12843bbf345537$var$CHAR_PERCENT = 0x25; /* % */ 
var $4d12843bbf345537$var$CHAR_AMPERSAND = 0x26; /* & */ 
var $4d12843bbf345537$var$CHAR_SINGLE_QUOTE = 0x27; /* ' */ 
var $4d12843bbf345537$var$CHAR_ASTERISK = 0x2A; /* * */ 
var $4d12843bbf345537$var$CHAR_COMMA = 0x2C; /* , */ 
var $4d12843bbf345537$var$CHAR_MINUS = 0x2D; /* - */ 
var $4d12843bbf345537$var$CHAR_COLON = 0x3A; /* : */ 
var $4d12843bbf345537$var$CHAR_EQUALS = 0x3D; /* = */ 
var $4d12843bbf345537$var$CHAR_GREATER_THAN = 0x3E; /* > */ 
var $4d12843bbf345537$var$CHAR_QUESTION = 0x3F; /* ? */ 
var $4d12843bbf345537$var$CHAR_COMMERCIAL_AT = 0x40; /* @ */ 
var $4d12843bbf345537$var$CHAR_LEFT_SQUARE_BRACKET = 0x5B; /* [ */ 
var $4d12843bbf345537$var$CHAR_RIGHT_SQUARE_BRACKET = 0x5D; /* ] */ 
var $4d12843bbf345537$var$CHAR_GRAVE_ACCENT = 0x60; /* ` */ 
var $4d12843bbf345537$var$CHAR_LEFT_CURLY_BRACKET = 0x7B; /* { */ 
var $4d12843bbf345537$var$CHAR_VERTICAL_LINE = 0x7C; /* | */ 
var $4d12843bbf345537$var$CHAR_RIGHT_CURLY_BRACKET = 0x7D; /* } */ 
var $4d12843bbf345537$var$ESCAPE_SEQUENCES = {};
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x00] = '\\0';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x07] = '\\a';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x08] = '\\b';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x09] = '\\t';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x0A] = '\\n';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x0B] = '\\v';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x0C] = '\\f';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x0D] = '\\r';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x1B] = '\\e';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x22] = '\\"';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x5C] = '\\\\';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x85] = '\\N';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0xA0] = '\\_';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x2028] = '\\L';
$4d12843bbf345537$var$ESCAPE_SEQUENCES[0x2029] = '\\P';
var $4d12843bbf345537$var$DEPRECATED_BOOLEANS_SYNTAX = [
    'y',
    'Y',
    'yes',
    'Yes',
    'YES',
    'on',
    'On',
    'ON',
    'n',
    'N',
    'no',
    'No',
    'NO',
    'off',
    'Off',
    'OFF'
];
var $4d12843bbf345537$var$DEPRECATED_BASE60_SYNTAX = /^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;
function $4d12843bbf345537$var$compileStyleMap(schema, map) {
    var result, keys, index, length, tag, style, type;
    if (map === null) return {};
    result = {};
    keys = Object.keys(map);
    for(index = 0, length = keys.length; index < length; index += 1){
        tag = keys[index];
        style = String(map[tag]);
        if (tag.slice(0, 2) === '!!') tag = 'tag:yaml.org,2002:' + tag.slice(2);
        type = schema.compiledTypeMap['fallback'][tag];
        if (type && $4d12843bbf345537$var$_hasOwnProperty.call(type.styleAliases, style)) style = type.styleAliases[style];
        result[tag] = style;
    }
    return result;
}
function $4d12843bbf345537$var$encodeHex(character) {
    var string, handle, length;
    string = character.toString(16).toUpperCase();
    if (character <= 0xFF) {
        handle = 'x';
        length = 2;
    } else if (character <= 0xFFFF) {
        handle = 'u';
        length = 4;
    } else if (character <= 0xFFFFFFFF) {
        handle = 'U';
        length = 8;
    } else throw new $4d12843bbf345537$var$exception('code point within a string may not be greater than 0xFFFFFFFF');
    return '\\' + handle + $4d12843bbf345537$var$common.repeat('0', length - string.length) + string;
}
var $4d12843bbf345537$var$QUOTING_TYPE_SINGLE = 1, $4d12843bbf345537$var$QUOTING_TYPE_DOUBLE = 2;
function $4d12843bbf345537$var$State(options) {
    this.schema = options['schema'] || $4d12843bbf345537$var$_default;
    this.indent = Math.max(1, options['indent'] || 2);
    this.noArrayIndent = options['noArrayIndent'] || false;
    this.skipInvalid = options['skipInvalid'] || false;
    this.flowLevel = $4d12843bbf345537$var$common.isNothing(options['flowLevel']) ? -1 : options['flowLevel'];
    this.styleMap = $4d12843bbf345537$var$compileStyleMap(this.schema, options['styles'] || null);
    this.sortKeys = options['sortKeys'] || false;
    this.lineWidth = options['lineWidth'] || 80;
    this.noRefs = options['noRefs'] || false;
    this.noCompatMode = options['noCompatMode'] || false;
    this.condenseFlow = options['condenseFlow'] || false;
    this.quotingType = options['quotingType'] === '"' ? $4d12843bbf345537$var$QUOTING_TYPE_DOUBLE : $4d12843bbf345537$var$QUOTING_TYPE_SINGLE;
    this.forceQuotes = options['forceQuotes'] || false;
    this.replacer = typeof options['replacer'] === 'function' ? options['replacer'] : null;
    this.implicitTypes = this.schema.compiledImplicit;
    this.explicitTypes = this.schema.compiledExplicit;
    this.tag = null;
    this.result = '';
    this.duplicates = [];
    this.usedDuplicates = null;
}
// Indents every line in a string. Empty lines (\n only) are not indented.
function $4d12843bbf345537$var$indentString(string, spaces) {
    var ind = $4d12843bbf345537$var$common.repeat(' ', spaces), position = 0, next = -1, result = '', line, length = string.length;
    while(position < length){
        next = string.indexOf('\n', position);
        if (next === -1) {
            line = string.slice(position);
            position = length;
        } else {
            line = string.slice(position, next + 1);
            position = next + 1;
        }
        if (line.length && line !== '\n') result += ind;
        result += line;
    }
    return result;
}
function $4d12843bbf345537$var$generateNextLine(state, level) {
    return '\n' + $4d12843bbf345537$var$common.repeat(' ', state.indent * level);
}
function $4d12843bbf345537$var$testImplicitResolving(state, str) {
    var index, length, type;
    for(index = 0, length = state.implicitTypes.length; index < length; index += 1){
        type = state.implicitTypes[index];
        if (type.resolve(str)) return true;
    }
    return false;
}
// [33] s-white ::= s-space | s-tab
function $4d12843bbf345537$var$isWhitespace(c) {
    return c === $4d12843bbf345537$var$CHAR_SPACE || c === $4d12843bbf345537$var$CHAR_TAB;
}
// Returns true if the character can be printed without escaping.
// From YAML 1.2: "any allowed characters known to be non-printable
// should also be escaped. [However,] This isn’t mandatory"
// Derived from nb-char - \t - #x85 - #xA0 - #x2028 - #x2029.
function $4d12843bbf345537$var$isPrintable(c) {
    return 0x00020 <= c && c <= 0x00007E || 0x000A1 <= c && c <= 0x00D7FF && c !== 0x2028 && c !== 0x2029 || 0x0E000 <= c && c <= 0x00FFFD && c !== $4d12843bbf345537$var$CHAR_BOM || 0x10000 <= c && c <= 0x10FFFF;
}
// [34] ns-char ::= nb-char - s-white
// [27] nb-char ::= c-printable - b-char - c-byte-order-mark
// [26] b-char  ::= b-line-feed | b-carriage-return
// Including s-white (for some reason, examples doesn't match specs in this aspect)
// ns-char ::= c-printable - b-line-feed - b-carriage-return - c-byte-order-mark
function $4d12843bbf345537$var$isNsCharOrWhitespace(c) {
    return $4d12843bbf345537$var$isPrintable(c) && c !== $4d12843bbf345537$var$CHAR_BOM && c !== $4d12843bbf345537$var$CHAR_CARRIAGE_RETURN && c !== $4d12843bbf345537$var$CHAR_LINE_FEED;
}
// [127]  ns-plain-safe(c) ::= c = flow-out  ⇒ ns-plain-safe-out
//                             c = flow-in   ⇒ ns-plain-safe-in
//                             c = block-key ⇒ ns-plain-safe-out
//                             c = flow-key  ⇒ ns-plain-safe-in
// [128] ns-plain-safe-out ::= ns-char
// [129]  ns-plain-safe-in ::= ns-char - c-flow-indicator
// [130]  ns-plain-char(c) ::=  ( ns-plain-safe(c) - “:” - “#” )
//                            | ( /* An ns-char preceding */ “#” )
//                            | ( “:” /* Followed by an ns-plain-safe(c) */ )
function $4d12843bbf345537$var$isPlainSafe(c, prev, inblock) {
    var cIsNsCharOrWhitespace = $4d12843bbf345537$var$isNsCharOrWhitespace(c);
    var cIsNsChar = cIsNsCharOrWhitespace && !$4d12843bbf345537$var$isWhitespace(c);
    return(// ns-plain-safe
    (inblock ? cIsNsCharOrWhitespace : cIsNsCharOrWhitespace && c !== $4d12843bbf345537$var$CHAR_COMMA && c !== $4d12843bbf345537$var$CHAR_LEFT_SQUARE_BRACKET && c !== $4d12843bbf345537$var$CHAR_RIGHT_SQUARE_BRACKET && c !== $4d12843bbf345537$var$CHAR_LEFT_CURLY_BRACKET && c !== $4d12843bbf345537$var$CHAR_RIGHT_CURLY_BRACKET) && c !== $4d12843bbf345537$var$CHAR_SHARP // false on '#'
     && !(prev === $4d12843bbf345537$var$CHAR_COLON && !cIsNsChar // false on ': '
    ) || $4d12843bbf345537$var$isNsCharOrWhitespace(prev) && !$4d12843bbf345537$var$isWhitespace(prev) && c === $4d12843bbf345537$var$CHAR_SHARP // change to true on '[^ ]#'
     || prev === $4d12843bbf345537$var$CHAR_COLON && cIsNsChar); // change to true on ':[^ ]'
}
// Simplified test for values allowed as the first character in plain style.
function $4d12843bbf345537$var$isPlainSafeFirst(c) {
    // Uses a subset of ns-char - c-indicator
    // where ns-char = nb-char - s-white.
    // No support of ( ( “?” | “:” | “-” ) /* Followed by an ns-plain-safe(c)) */ ) part
    return $4d12843bbf345537$var$isPrintable(c) && c !== $4d12843bbf345537$var$CHAR_BOM && !$4d12843bbf345537$var$isWhitespace(c) // - s-white
     && c !== $4d12843bbf345537$var$CHAR_MINUS && c !== $4d12843bbf345537$var$CHAR_QUESTION && c !== $4d12843bbf345537$var$CHAR_COLON && c !== $4d12843bbf345537$var$CHAR_COMMA && c !== $4d12843bbf345537$var$CHAR_LEFT_SQUARE_BRACKET && c !== $4d12843bbf345537$var$CHAR_RIGHT_SQUARE_BRACKET && c !== $4d12843bbf345537$var$CHAR_LEFT_CURLY_BRACKET && c !== $4d12843bbf345537$var$CHAR_RIGHT_CURLY_BRACKET && c !== $4d12843bbf345537$var$CHAR_SHARP && c !== $4d12843bbf345537$var$CHAR_AMPERSAND && c !== $4d12843bbf345537$var$CHAR_ASTERISK && c !== $4d12843bbf345537$var$CHAR_EXCLAMATION && c !== $4d12843bbf345537$var$CHAR_VERTICAL_LINE && c !== $4d12843bbf345537$var$CHAR_EQUALS && c !== $4d12843bbf345537$var$CHAR_GREATER_THAN && c !== $4d12843bbf345537$var$CHAR_SINGLE_QUOTE && c !== $4d12843bbf345537$var$CHAR_DOUBLE_QUOTE && c !== $4d12843bbf345537$var$CHAR_PERCENT && c !== $4d12843bbf345537$var$CHAR_COMMERCIAL_AT && c !== $4d12843bbf345537$var$CHAR_GRAVE_ACCENT;
}
// Simplified test for values allowed as the last character in plain style.
function $4d12843bbf345537$var$isPlainSafeLast(c) {
    // just not whitespace or colon, it will be checked to be plain character later
    return !$4d12843bbf345537$var$isWhitespace(c) && c !== $4d12843bbf345537$var$CHAR_COLON;
}
// Same as 'string'.codePointAt(pos), but works in older browsers.
function $4d12843bbf345537$var$codePointAt(string, pos) {
    var first = string.charCodeAt(pos), second;
    if (first >= 0xD800 && first <= 0xDBFF && pos + 1 < string.length) {
        second = string.charCodeAt(pos + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
// Determines whether block indentation indicator is required.
function $4d12843bbf345537$var$needIndentIndicator(string) {
    var leadingSpaceRe = /^\n* /;
    return leadingSpaceRe.test(string);
}
var $4d12843bbf345537$var$STYLE_PLAIN = 1, $4d12843bbf345537$var$STYLE_SINGLE = 2, $4d12843bbf345537$var$STYLE_LITERAL = 3, $4d12843bbf345537$var$STYLE_FOLDED = 4, $4d12843bbf345537$var$STYLE_DOUBLE = 5;
// Determines which scalar styles are possible and returns the preferred style.
// lineWidth = -1 => no limit.
// Pre-conditions: str.length > 0.
// Post-conditions:
//    STYLE_PLAIN or STYLE_SINGLE => no \n are in the string.
//    STYLE_LITERAL => no lines are suitable for folding (or lineWidth is -1).
//    STYLE_FOLDED => a line > lineWidth and can be folded (and lineWidth != -1).
function $4d12843bbf345537$var$chooseScalarStyle(string, singleLineOnly, indentPerLevel, lineWidth, testAmbiguousType, quotingType, forceQuotes, inblock) {
    var i;
    var char = 0;
    var prevChar = null;
    var hasLineBreak = false;
    var hasFoldableLine = false; // only checked if shouldTrackWidth
    var shouldTrackWidth = lineWidth !== -1;
    var previousLineBreak = -1; // count the first line correctly
    var plain = $4d12843bbf345537$var$isPlainSafeFirst($4d12843bbf345537$var$codePointAt(string, 0)) && $4d12843bbf345537$var$isPlainSafeLast($4d12843bbf345537$var$codePointAt(string, string.length - 1));
    if (singleLineOnly || forceQuotes) // Case: no block styles.
    // Check for disallowed characters to rule out plain and single.
    for(i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
        char = $4d12843bbf345537$var$codePointAt(string, i);
        if (!$4d12843bbf345537$var$isPrintable(char)) return $4d12843bbf345537$var$STYLE_DOUBLE;
        plain = plain && $4d12843bbf345537$var$isPlainSafe(char, prevChar, inblock);
        prevChar = char;
    }
    else {
        // Case: block styles permitted.
        for(i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
            char = $4d12843bbf345537$var$codePointAt(string, i);
            if (char === $4d12843bbf345537$var$CHAR_LINE_FEED) {
                hasLineBreak = true;
                // Check if any line can be folded.
                if (shouldTrackWidth) {
                    hasFoldableLine = hasFoldableLine || // Foldable line = too long, and not more-indented.
                    i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
                    previousLineBreak = i;
                }
            } else if (!$4d12843bbf345537$var$isPrintable(char)) return $4d12843bbf345537$var$STYLE_DOUBLE;
            plain = plain && $4d12843bbf345537$var$isPlainSafe(char, prevChar, inblock);
            prevChar = char;
        }
        // in case the end is missing a \n
        hasFoldableLine = hasFoldableLine || shouldTrackWidth && i - previousLineBreak - 1 > lineWidth && string[previousLineBreak + 1] !== ' ';
    }
    // Although every style can represent \n without escaping, prefer block styles
    // for multiline, since they're more readable and they don't add empty lines.
    // Also prefer folding a super-long line.
    if (!hasLineBreak && !hasFoldableLine) {
        // Strings interpretable as another type have to be quoted;
        // e.g. the string 'true' vs. the boolean true.
        if (plain && !forceQuotes && !testAmbiguousType(string)) return $4d12843bbf345537$var$STYLE_PLAIN;
        return quotingType === $4d12843bbf345537$var$QUOTING_TYPE_DOUBLE ? $4d12843bbf345537$var$STYLE_DOUBLE : $4d12843bbf345537$var$STYLE_SINGLE;
    }
    // Edge case: block indentation indicator can only have one digit.
    if (indentPerLevel > 9 && $4d12843bbf345537$var$needIndentIndicator(string)) return $4d12843bbf345537$var$STYLE_DOUBLE;
    // At this point we know block styles are valid.
    // Prefer literal style unless we want to fold.
    if (!forceQuotes) return hasFoldableLine ? $4d12843bbf345537$var$STYLE_FOLDED : $4d12843bbf345537$var$STYLE_LITERAL;
    return quotingType === $4d12843bbf345537$var$QUOTING_TYPE_DOUBLE ? $4d12843bbf345537$var$STYLE_DOUBLE : $4d12843bbf345537$var$STYLE_SINGLE;
}
// Note: line breaking/folding is implemented for only the folded style.
// NB. We drop the last trailing newline (if any) of a returned block scalar
//  since the dumper adds its own newline. This always works:
//    • No ending newline => unaffected; already using strip "-" chomping.
//    • Ending newline    => removed then restored.
//  Importantly, this keeps the "+" chomp indicator from gaining an extra line.
function $4d12843bbf345537$var$writeScalar(state, string, level, iskey, inblock) {
    state.dump = function() {
        if (string.length === 0) return state.quotingType === $4d12843bbf345537$var$QUOTING_TYPE_DOUBLE ? '""' : "''";
        if (!state.noCompatMode) {
            if ($4d12843bbf345537$var$DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1 || $4d12843bbf345537$var$DEPRECATED_BASE60_SYNTAX.test(string)) return state.quotingType === $4d12843bbf345537$var$QUOTING_TYPE_DOUBLE ? '"' + string + '"' : "'" + string + "'";
        }
        var indent = state.indent * Math.max(1, level); // no 0-indent scalars
        // As indentation gets deeper, let the width decrease monotonically
        // to the lower bound min(state.lineWidth, 40).
        // Note that this implies
        //  state.lineWidth ≤ 40 + state.indent: width is fixed at the lower bound.
        //  state.lineWidth > 40 + state.indent: width decreases until the lower bound.
        // This behaves better than a constant minimum width which disallows narrower options,
        // or an indent threshold which causes the width to suddenly increase.
        var lineWidth = state.lineWidth === -1 ? -1 : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent);
        // Without knowing if keys are implicit/explicit, assume implicit for safety.
        var singleLineOnly = iskey || state.flowLevel > -1 && level >= state.flowLevel;
        function testAmbiguity(string) {
            return $4d12843bbf345537$var$testImplicitResolving(state, string);
        }
        switch($4d12843bbf345537$var$chooseScalarStyle(string, singleLineOnly, state.indent, lineWidth, testAmbiguity, state.quotingType, state.forceQuotes && !iskey, inblock)){
            case $4d12843bbf345537$var$STYLE_PLAIN:
                return string;
            case $4d12843bbf345537$var$STYLE_SINGLE:
                return "'" + string.replace(/'/g, "''") + "'";
            case $4d12843bbf345537$var$STYLE_LITERAL:
                return '|' + $4d12843bbf345537$var$blockHeader(string, state.indent) + $4d12843bbf345537$var$dropEndingNewline($4d12843bbf345537$var$indentString(string, indent));
            case $4d12843bbf345537$var$STYLE_FOLDED:
                return '>' + $4d12843bbf345537$var$blockHeader(string, state.indent) + $4d12843bbf345537$var$dropEndingNewline($4d12843bbf345537$var$indentString($4d12843bbf345537$var$foldString(string, lineWidth), indent));
            case $4d12843bbf345537$var$STYLE_DOUBLE:
                return '"' + $4d12843bbf345537$var$escapeString(string) + '"';
            default:
                throw new $4d12843bbf345537$var$exception('impossible error: invalid scalar style');
        }
    }();
}
// Pre-conditions: string is valid for a block scalar, 1 <= indentPerLevel <= 9.
function $4d12843bbf345537$var$blockHeader(string, indentPerLevel) {
    var indentIndicator = $4d12843bbf345537$var$needIndentIndicator(string) ? String(indentPerLevel) : '';
    // note the special case: the string '\n' counts as a "trailing" empty line.
    var clip = string[string.length - 1] === '\n';
    var keep = clip && (string[string.length - 2] === '\n' || string === '\n');
    var chomp = keep ? '+' : clip ? '' : '-';
    return indentIndicator + chomp + '\n';
}
// (See the note for writeScalar.)
function $4d12843bbf345537$var$dropEndingNewline(string) {
    return string[string.length - 1] === '\n' ? string.slice(0, -1) : string;
}
// Note: a long line without a suitable break point will exceed the width limit.
// Pre-conditions: every char in str isPrintable, str.length > 0, width > 0.
function $4d12843bbf345537$var$foldString(string, width) {
    // In folded style, $k$ consecutive newlines output as $k+1$ newlines—
    // unless they're before or after a more-indented line, or at the very
    // beginning or end, in which case $k$ maps to $k$.
    // Therefore, parse each chunk as newline(s) followed by a content line.
    var lineRe = /(\n+)([^\n]*)/g;
    // first line (possibly an empty line)
    var result = function() {
        var nextLF = string.indexOf('\n');
        nextLF = nextLF !== -1 ? nextLF : string.length;
        lineRe.lastIndex = nextLF;
        return $4d12843bbf345537$var$foldLine(string.slice(0, nextLF), width);
    }();
    // If we haven't reached the first content line yet, don't add an extra \n.
    var prevMoreIndented = string[0] === '\n' || string[0] === ' ';
    var moreIndented;
    // rest of the lines
    var match;
    while(match = lineRe.exec(string)){
        var prefix = match[1], line = match[2];
        moreIndented = line[0] === ' ';
        result += prefix + (!prevMoreIndented && !moreIndented && line !== '' ? '\n' : '') + $4d12843bbf345537$var$foldLine(line, width);
        prevMoreIndented = moreIndented;
    }
    return result;
}
// Greedy line breaking.
// Picks the longest line under the limit each time,
// otherwise settles for the shortest line over the limit.
// NB. More-indented lines *cannot* be folded, as that would add an extra \n.
function $4d12843bbf345537$var$foldLine(line, width) {
    if (line === '' || line[0] === ' ') return line;
    // Since a more-indented line adds a \n, breaks can't be followed by a space.
    var breakRe = / [^ ]/g; // note: the match index will always be <= length-2.
    var match;
    // start is an inclusive index. end, curr, and next are exclusive.
    var start = 0, end, curr = 0, next = 0;
    var result = '';
    // Invariants: 0 <= start <= length-1.
    //   0 <= curr <= next <= max(0, length-2). curr - start <= width.
    // Inside the loop:
    //   A match implies length >= 2, so curr and next are <= length-2.
    while(match = breakRe.exec(line)){
        next = match.index;
        // maintain invariant: curr - start <= width
        if (next - start > width) {
            end = curr > start ? curr : next; // derive end <= length-2
            result += '\n' + line.slice(start, end);
            // skip the space that was output as \n
            start = end + 1; // derive start <= length-1
        }
        curr = next;
    }
    // By the invariants, start <= length-1, so there is something left over.
    // It is either the whole string or a part starting from non-whitespace.
    result += '\n';
    // Insert a break if the remainder is too long and there is a break available.
    if (line.length - start > width && curr > start) result += line.slice(start, curr) + '\n' + line.slice(curr + 1);
    else result += line.slice(start);
    return result.slice(1); // drop extra \n joiner
}
// Escapes a double-quoted string.
function $4d12843bbf345537$var$escapeString(string) {
    var result = '';
    var char = 0;
    var escapeSeq;
    for(var i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++){
        char = $4d12843bbf345537$var$codePointAt(string, i);
        escapeSeq = $4d12843bbf345537$var$ESCAPE_SEQUENCES[char];
        if (!escapeSeq && $4d12843bbf345537$var$isPrintable(char)) {
            result += string[i];
            if (char >= 0x10000) result += string[i + 1];
        } else result += escapeSeq || $4d12843bbf345537$var$encodeHex(char);
    }
    return result;
}
function $4d12843bbf345537$var$writeFlowSequence(state, level, object) {
    var _result = '', _tag = state.tag, index, length, value;
    for(index = 0, length = object.length; index < length; index += 1){
        value = object[index];
        if (state.replacer) value = state.replacer.call(object, String(index), value);
        // Write only valid elements, put null instead of invalid elements.
        if ($4d12843bbf345537$var$writeNode(state, level, value, false, false) || typeof value === 'undefined' && $4d12843bbf345537$var$writeNode(state, level, null, false, false)) {
            if (_result !== '') _result += ',' + (!state.condenseFlow ? ' ' : '');
            _result += state.dump;
        }
    }
    state.tag = _tag;
    state.dump = '[' + _result + ']';
}
function $4d12843bbf345537$var$writeBlockSequence(state, level, object, compact) {
    var _result = '', _tag = state.tag, index, length, value;
    for(index = 0, length = object.length; index < length; index += 1){
        value = object[index];
        if (state.replacer) value = state.replacer.call(object, String(index), value);
        // Write only valid elements, put null instead of invalid elements.
        if ($4d12843bbf345537$var$writeNode(state, level + 1, value, true, true, false, true) || typeof value === 'undefined' && $4d12843bbf345537$var$writeNode(state, level + 1, null, true, true, false, true)) {
            if (!compact || _result !== '') _result += $4d12843bbf345537$var$generateNextLine(state, level);
            if (state.dump && $4d12843bbf345537$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) _result += '-';
            else _result += '- ';
            _result += state.dump;
        }
    }
    state.tag = _tag;
    state.dump = _result || '[]'; // Empty sequence if no valid values.
}
function $4d12843bbf345537$var$writeFlowMapping(state, level, object) {
    var _result = '', _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, pairBuffer;
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = '';
        if (_result !== '') pairBuffer += ', ';
        if (state.condenseFlow) pairBuffer += '"';
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (state.replacer) objectValue = state.replacer.call(object, objectKey, objectValue);
        if (!$4d12843bbf345537$var$writeNode(state, level, objectKey, false, false)) continue; // Skip this pair because of invalid key;
        if (state.dump.length > 1024) pairBuffer += '? ';
        pairBuffer += state.dump + (state.condenseFlow ? '"' : '') + ':' + (state.condenseFlow ? '' : ' ');
        if (!$4d12843bbf345537$var$writeNode(state, level, objectValue, false, false)) continue; // Skip this pair because of invalid value.
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = '{' + _result + '}';
}
function $4d12843bbf345537$var$writeBlockMapping(state, level, object, compact) {
    var _result = '', _tag = state.tag, objectKeyList = Object.keys(object), index, length, objectKey, objectValue, explicitPair, pairBuffer;
    // Allow sorting keys so that the output file is deterministic
    if (state.sortKeys === true) // Default sorting
    objectKeyList.sort();
    else if (typeof state.sortKeys === 'function') // Custom sort function
    objectKeyList.sort(state.sortKeys);
    else if (state.sortKeys) // Something is wrong
    throw new $4d12843bbf345537$var$exception('sortKeys must be a boolean or a function');
    for(index = 0, length = objectKeyList.length; index < length; index += 1){
        pairBuffer = '';
        if (!compact || _result !== '') pairBuffer += $4d12843bbf345537$var$generateNextLine(state, level);
        objectKey = objectKeyList[index];
        objectValue = object[objectKey];
        if (state.replacer) objectValue = state.replacer.call(object, objectKey, objectValue);
        if (!$4d12843bbf345537$var$writeNode(state, level + 1, objectKey, true, true, true)) continue; // Skip this pair because of invalid key.
        explicitPair = state.tag !== null && state.tag !== '?' || state.dump && state.dump.length > 1024;
        if (explicitPair) {
            if (state.dump && $4d12843bbf345537$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += '?';
            else pairBuffer += '? ';
        }
        pairBuffer += state.dump;
        if (explicitPair) pairBuffer += $4d12843bbf345537$var$generateNextLine(state, level);
        if (!$4d12843bbf345537$var$writeNode(state, level + 1, objectValue, true, explicitPair)) continue; // Skip this pair because of invalid value.
        if (state.dump && $4d12843bbf345537$var$CHAR_LINE_FEED === state.dump.charCodeAt(0)) pairBuffer += ':';
        else pairBuffer += ': ';
        pairBuffer += state.dump;
        // Both key and value are valid.
        _result += pairBuffer;
    }
    state.tag = _tag;
    state.dump = _result || '{}'; // Empty mapping if no valid pairs.
}
function $4d12843bbf345537$var$detectType(state, object, explicit) {
    var _result, typeList, index, length, type, style;
    typeList = explicit ? state.explicitTypes : state.implicitTypes;
    for(index = 0, length = typeList.length; index < length; index += 1){
        type = typeList[index];
        if ((type.instanceOf || type.predicate) && (!type.instanceOf || typeof object === 'object' && object instanceof type.instanceOf) && (!type.predicate || type.predicate(object))) {
            if (explicit) {
                if (type.multi && type.representName) state.tag = type.representName(object);
                else state.tag = type.tag;
            } else state.tag = '?';
            if (type.represent) {
                style = state.styleMap[type.tag] || type.defaultStyle;
                if ($4d12843bbf345537$var$_toString.call(type.represent) === '[object Function]') _result = type.represent(object, style);
                else if ($4d12843bbf345537$var$_hasOwnProperty.call(type.represent, style)) _result = type.represent[style](object, style);
                else throw new $4d12843bbf345537$var$exception('!<' + type.tag + '> tag resolver accepts not "' + style + '" style');
                state.dump = _result;
            }
            return true;
        }
    }
    return false;
}
// Serializes `object` and writes it to global `result`.
// Returns true on success, or false on invalid object.
//
function $4d12843bbf345537$var$writeNode(state, level, object, block, compact, iskey, isblockseq) {
    state.tag = null;
    state.dump = object;
    if (!$4d12843bbf345537$var$detectType(state, object, false)) $4d12843bbf345537$var$detectType(state, object, true);
    var type = $4d12843bbf345537$var$_toString.call(state.dump);
    var inblock = block;
    var tagStr;
    if (block) block = state.flowLevel < 0 || state.flowLevel > level;
    var objectOrArray = type === '[object Object]' || type === '[object Array]', duplicateIndex, duplicate;
    if (objectOrArray) {
        duplicateIndex = state.duplicates.indexOf(object);
        duplicate = duplicateIndex !== -1;
    }
    if (state.tag !== null && state.tag !== '?' || duplicate || state.indent !== 2 && level > 0) compact = false;
    if (duplicate && state.usedDuplicates[duplicateIndex]) state.dump = '*ref_' + duplicateIndex;
    else {
        if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) state.usedDuplicates[duplicateIndex] = true;
        if (type === '[object Object]') {
            if (block && Object.keys(state.dump).length !== 0) {
                $4d12843bbf345537$var$writeBlockMapping(state, level, state.dump, compact);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + state.dump;
            } else {
                $4d12843bbf345537$var$writeFlowMapping(state, level, state.dump);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
            }
        } else if (type === '[object Array]') {
            if (block && state.dump.length !== 0) {
                if (state.noArrayIndent && !isblockseq && level > 0) $4d12843bbf345537$var$writeBlockSequence(state, level - 1, state.dump, compact);
                else $4d12843bbf345537$var$writeBlockSequence(state, level, state.dump, compact);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + state.dump;
            } else {
                $4d12843bbf345537$var$writeFlowSequence(state, level, state.dump);
                if (duplicate) state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
            }
        } else if (type === '[object String]') {
            if (state.tag !== '?') $4d12843bbf345537$var$writeScalar(state, state.dump, level, iskey, inblock);
        } else if (type === '[object Undefined]') return false;
        else {
            if (state.skipInvalid) return false;
            throw new $4d12843bbf345537$var$exception('unacceptable kind of an object to dump ' + type);
        }
        if (state.tag !== null && state.tag !== '?') {
            // Need to encode all characters except those allowed by the spec:
            //
            // [35] ns-dec-digit    ::=  [#x30-#x39] /* 0-9 */
            // [36] ns-hex-digit    ::=  ns-dec-digit
            //                         | [#x41-#x46] /* A-F */ | [#x61-#x66] /* a-f */
            // [37] ns-ascii-letter ::=  [#x41-#x5A] /* A-Z */ | [#x61-#x7A] /* a-z */
            // [38] ns-word-char    ::=  ns-dec-digit | ns-ascii-letter | “-”
            // [39] ns-uri-char     ::=  “%” ns-hex-digit ns-hex-digit | ns-word-char | “#”
            //                         | “;” | “/” | “?” | “:” | “@” | “&” | “=” | “+” | “$” | “,”
            //                         | “_” | “.” | “!” | “~” | “*” | “'” | “(” | “)” | “[” | “]”
            //
            // Also need to encode '!' because it has special meaning (end of tag prefix).
            //
            tagStr = encodeURI(state.tag[0] === '!' ? state.tag.slice(1) : state.tag).replace(/!/g, '%21');
            if (state.tag[0] === '!') tagStr = '!' + tagStr;
            else if (tagStr.slice(0, 18) === 'tag:yaml.org,2002:') tagStr = '!!' + tagStr.slice(18);
            else tagStr = '!<' + tagStr + '>';
            state.dump = tagStr + ' ' + state.dump;
        }
    }
    return true;
}
function $4d12843bbf345537$var$getDuplicateReferences(object, state) {
    var objects = [], duplicatesIndexes = [], index, length;
    $4d12843bbf345537$var$inspectNode(object, objects, duplicatesIndexes);
    for(index = 0, length = duplicatesIndexes.length; index < length; index += 1)state.duplicates.push(objects[duplicatesIndexes[index]]);
    state.usedDuplicates = new Array(length);
}
function $4d12843bbf345537$var$inspectNode(object, objects, duplicatesIndexes) {
    var objectKeyList, index, length;
    if (object !== null && typeof object === 'object') {
        index = objects.indexOf(object);
        if (index !== -1) {
            if (duplicatesIndexes.indexOf(index) === -1) duplicatesIndexes.push(index);
        } else {
            objects.push(object);
            if (Array.isArray(object)) for(index = 0, length = object.length; index < length; index += 1)$4d12843bbf345537$var$inspectNode(object[index], objects, duplicatesIndexes);
            else {
                objectKeyList = Object.keys(object);
                for(index = 0, length = objectKeyList.length; index < length; index += 1)$4d12843bbf345537$var$inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes);
            }
        }
    }
}
function $4d12843bbf345537$var$dump$1(input, options) {
    options = options || {};
    var state = new $4d12843bbf345537$var$State(options);
    if (!state.noRefs) $4d12843bbf345537$var$getDuplicateReferences(input, state);
    var value = input;
    if (state.replacer) value = state.replacer.call({
        '': value
    }, '', value);
    if ($4d12843bbf345537$var$writeNode(state, 0, value, true, true)) return state.dump + '\n';
    return '';
}
var $4d12843bbf345537$var$dump_1 = $4d12843bbf345537$var$dump$1;
var $4d12843bbf345537$var$dumper = {
    dump: $4d12843bbf345537$var$dump_1
};
function $4d12843bbf345537$var$renamed(from, to) {
    return function() {
        throw new Error('Function yaml.' + from + ' is removed in js-yaml 4. ' + 'Use yaml.' + to + ' instead, which is now safe by default.');
    };
}
var $4d12843bbf345537$export$92738401e1603719 = $4d12843bbf345537$var$type;
var $4d12843bbf345537$export$19342e026b58ebb7 = $4d12843bbf345537$var$schema;
var $4d12843bbf345537$export$aefe34bace55c48e = $4d12843bbf345537$var$failsafe;
var $4d12843bbf345537$export$3f5573a59aee743 = $4d12843bbf345537$var$json;
var $4d12843bbf345537$export$cb27b7e9f9bc8fa8 = $4d12843bbf345537$var$core;
var $4d12843bbf345537$export$54192bc17d2d9e2a = $4d12843bbf345537$var$_default;
var $4d12843bbf345537$export$11e63f7b0f3d9900 = $4d12843bbf345537$var$loader.load;
var $4d12843bbf345537$export$7aabae09a30b04c2 = $4d12843bbf345537$var$loader.loadAll;
var $4d12843bbf345537$export$2069a8a5a76faa2 = $4d12843bbf345537$var$dumper.dump;
var $4d12843bbf345537$export$28af3d4da69ed747 = $4d12843bbf345537$var$exception;
// Re-export all types in case user wants to create custom schema
var $4d12843bbf345537$export$b14ad400b1d09e0f = {
    binary: $4d12843bbf345537$var$binary,
    float: $4d12843bbf345537$var$float,
    map: $4d12843bbf345537$var$map,
    null: $4d12843bbf345537$var$_null,
    pairs: $4d12843bbf345537$var$pairs,
    set: $4d12843bbf345537$var$set,
    timestamp: $4d12843bbf345537$var$timestamp,
    bool: $4d12843bbf345537$var$bool,
    int: $4d12843bbf345537$var$int,
    merge: $4d12843bbf345537$var$merge,
    omap: $4d12843bbf345537$var$omap,
    seq: $4d12843bbf345537$var$seq,
    str: $4d12843bbf345537$var$str
};
// Removed functions from JS-YAML 3.0.x
var $4d12843bbf345537$export$ecc08907c0e2af9b = $4d12843bbf345537$var$renamed('safeLoad', 'load');
var $4d12843bbf345537$export$c2cc0f4fb6d29644 = $4d12843bbf345537$var$renamed('safeLoadAll', 'loadAll');
var $4d12843bbf345537$export$befffea07f2abcf0 = $4d12843bbf345537$var$renamed('safeDump', 'dump');
var $4d12843bbf345537$export$2e2bcd8739ae039 = {
    Type: $4d12843bbf345537$export$92738401e1603719,
    Schema: $4d12843bbf345537$export$19342e026b58ebb7,
    FAILSAFE_SCHEMA: $4d12843bbf345537$export$aefe34bace55c48e,
    JSON_SCHEMA: $4d12843bbf345537$export$3f5573a59aee743,
    CORE_SCHEMA: $4d12843bbf345537$export$cb27b7e9f9bc8fa8,
    DEFAULT_SCHEMA: $4d12843bbf345537$export$54192bc17d2d9e2a,
    load: $4d12843bbf345537$export$11e63f7b0f3d9900,
    loadAll: $4d12843bbf345537$export$7aabae09a30b04c2,
    dump: $4d12843bbf345537$export$2069a8a5a76faa2,
    YAMLException: $4d12843bbf345537$export$28af3d4da69ed747,
    types: $4d12843bbf345537$export$b14ad400b1d09e0f,
    safeLoad: $4d12843bbf345537$export$ecc08907c0e2af9b,
    safeLoadAll: $4d12843bbf345537$export$c2cc0f4fb6d29644,
    safeDump: $4d12843bbf345537$export$befffea07f2abcf0
};

});


parcelRegister("3fhVa", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.env = module.exports.isBrowser = void 0;
module.exports.isBrowser = typeof window !== 'undefined' || true; // main and worker thread
module.exports.env = module.exports.isBrowser ? {} : $hPtJY.env || {};

});

parcelRegister("lX2nX", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logger = module.exports.colorize = module.exports.colorOptions = void 0;

var $kjyEk = parcelRequire("kjyEk");

var $3fhVa = parcelRequire("3fhVa");

var $eONiY = parcelRequire("eONiY");
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore this works but some types are not working
module.exports.colorOptions = $kjyEk.options;
module.exports.colorize = new Proxy($kjyEk, {
    get (target, prop) {
        if ($3fhVa.isBrowser) return $eONiY.identity;
        return target[prop];
    }
});
class $ffb0f56083743613$var$Logger {
    stderr(str) {
        return $hPtJY.stderr.write(str);
    }
    info(str) {
        return $3fhVa.isBrowser ? console.log(str) : this.stderr(str);
    }
    warn(str) {
        return $3fhVa.isBrowser ? console.warn(str) : this.stderr(module.exports.colorize.yellow(str));
    }
    error(str) {
        return $3fhVa.isBrowser ? console.error(str) : this.stderr(module.exports.colorize.red(str));
    }
}
module.exports.logger = new $ffb0f56083743613$var$Logger();

});

parcelRegister("b3nWb", function(module, exports) {
/* global define */ (function(root, pluralize) {
    // Node.
    module.exports = pluralize();
})(module.exports, function() {
    // Rule storage - pluralize and singularize need to be run sequentially,
    // while other rules can be optimized using an object for instant lookups.
    var pluralRules = [];
    var singularRules = [];
    var uncountables = {};
    var irregularPlurals = {};
    var irregularSingles = {};
    /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */ function sanitizeRule(rule) {
        if (typeof rule === 'string') return new RegExp('^' + rule + '$', 'i');
        return rule;
    }
    /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */ function restoreCase(word, token) {
        // Tokens are an exact match.
        if (word === token) return token;
        // Lower cased words. E.g. "hello".
        if (word === word.toLowerCase()) return token.toLowerCase();
        // Upper cased words. E.g. "WHISKY".
        if (word === word.toUpperCase()) return token.toUpperCase();
        // Title cased words. E.g. "Title".
        if (word[0] === word[0].toUpperCase()) return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
        // Lower cased words. E.g. "test".
        return token.toLowerCase();
    }
    /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */ function interpolate(str, args) {
        return str.replace(/\$(\d{1,2})/g, function(match, index) {
            return args[index] || '';
        });
    }
    /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */ function replace(word, rule) {
        return word.replace(rule[0], function(match, index) {
            var result = interpolate(rule[1], arguments);
            if (match === '') return restoreCase(word[index - 1], result);
            return restoreCase(match, result);
        });
    }
    /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */ function sanitizeWord(token, word, rules) {
        // Empty string or doesn't need fixing.
        if (!token.length || uncountables.hasOwnProperty(token)) return word;
        var len = rules.length;
        // Iterate over the sanitization rules and use the first one to match.
        while(len--){
            var rule = rules[len];
            if (rule[0].test(word)) return replace(word, rule);
        }
        return word;
    }
    /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */ function replaceWord(replaceMap, keepMap, rules) {
        return function(word) {
            // Get the correct token and case restoration functions.
            var token = word.toLowerCase();
            // Check against the keep object map.
            if (keepMap.hasOwnProperty(token)) return restoreCase(word, token);
            // Check against the replacement map for a direct word replacement.
            if (replaceMap.hasOwnProperty(token)) return restoreCase(word, replaceMap[token]);
            // Run all the rules against the word.
            return sanitizeWord(token, word, rules);
        };
    }
    /**
   * Check if a word is part of the map.
   */ function checkWord(replaceMap, keepMap, rules, bool) {
        return function(word) {
            var token = word.toLowerCase();
            if (keepMap.hasOwnProperty(token)) return true;
            if (replaceMap.hasOwnProperty(token)) return false;
            return sanitizeWord(token, token, rules) === token;
        };
    }
    /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */ function pluralize(word, count, inclusive) {
        var pluralized = count === 1 ? pluralize.singular(word) : pluralize.plural(word);
        return (inclusive ? count + ' ' : '') + pluralized;
    }
    /**
   * Pluralize a word.
   *
   * @type {Function}
   */ pluralize.plural = replaceWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Check if a word is plural.
   *
   * @type {Function}
   */ pluralize.isPlural = checkWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Singularize a word.
   *
   * @type {Function}
   */ pluralize.singular = replaceWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Check if a word is singular.
   *
   * @type {Function}
   */ pluralize.isSingular = checkWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addPluralRule = function(rule, replacement) {
        pluralRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addSingularRule = function(rule, replacement) {
        singularRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */ pluralize.addUncountableRule = function(word) {
        if (typeof word === 'string') {
            uncountables[word.toLowerCase()] = true;
            return;
        }
        // Set singular and plural references for the word.
        pluralize.addPluralRule(word, '$0');
        pluralize.addSingularRule(word, '$0');
    };
    /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */ pluralize.addIrregularRule = function(single, plural) {
        plural = plural.toLowerCase();
        single = single.toLowerCase();
        irregularSingles[single] = plural;
        irregularPlurals[plural] = single;
    };
    /**
   * Irregular rules.
   */ [
        // Pronouns.
        [
            'I',
            'we'
        ],
        [
            'me',
            'us'
        ],
        [
            'he',
            'they'
        ],
        [
            'she',
            'they'
        ],
        [
            'them',
            'them'
        ],
        [
            'myself',
            'ourselves'
        ],
        [
            'yourself',
            'yourselves'
        ],
        [
            'itself',
            'themselves'
        ],
        [
            'herself',
            'themselves'
        ],
        [
            'himself',
            'themselves'
        ],
        [
            'themself',
            'themselves'
        ],
        [
            'is',
            'are'
        ],
        [
            'was',
            'were'
        ],
        [
            'has',
            'have'
        ],
        [
            'this',
            'these'
        ],
        [
            'that',
            'those'
        ],
        // Words ending in with a consonant and `o`.
        [
            'echo',
            'echoes'
        ],
        [
            'dingo',
            'dingoes'
        ],
        [
            'volcano',
            'volcanoes'
        ],
        [
            'tornado',
            'tornadoes'
        ],
        [
            'torpedo',
            'torpedoes'
        ],
        // Ends with `us`.
        [
            'genus',
            'genera'
        ],
        [
            'viscus',
            'viscera'
        ],
        // Ends with `ma`.
        [
            'stigma',
            'stigmata'
        ],
        [
            'stoma',
            'stomata'
        ],
        [
            'dogma',
            'dogmata'
        ],
        [
            'lemma',
            'lemmata'
        ],
        [
            'schema',
            'schemata'
        ],
        [
            'anathema',
            'anathemata'
        ],
        // Other irregular rules.
        [
            'ox',
            'oxen'
        ],
        [
            'axe',
            'axes'
        ],
        [
            'die',
            'dice'
        ],
        [
            'yes',
            'yeses'
        ],
        [
            'foot',
            'feet'
        ],
        [
            'eave',
            'eaves'
        ],
        [
            'goose',
            'geese'
        ],
        [
            'tooth',
            'teeth'
        ],
        [
            'quiz',
            'quizzes'
        ],
        [
            'human',
            'humans'
        ],
        [
            'proof',
            'proofs'
        ],
        [
            'carve',
            'carves'
        ],
        [
            'valve',
            'valves'
        ],
        [
            'looey',
            'looies'
        ],
        [
            'thief',
            'thieves'
        ],
        [
            'groove',
            'grooves'
        ],
        [
            'pickaxe',
            'pickaxes'
        ],
        [
            'passerby',
            'passersby'
        ]
    ].forEach(function(rule) {
        return pluralize.addIrregularRule(rule[0], rule[1]);
    });
    /**
   * Pluralization rules.
   */ [
        [
            /s?$/i,
            's'
        ],
        [
            /[^\u0000-\u007F]$/i,
            '$0'
        ],
        [
            /([^aeiou]ese)$/i,
            '$1'
        ],
        [
            /(ax|test)is$/i,
            '$1es'
        ],
        [
            /(alias|[^aou]us|t[lm]as|gas|ris)$/i,
            '$1es'
        ],
        [
            /(e[mn]u)s?$/i,
            '$1s'
        ],
        [
            /([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i,
            '$1'
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            '$1i'
        ],
        [
            /(alumn|alg|vertebr)(?:a|ae)$/i,
            '$1ae'
        ],
        [
            /(seraph|cherub)(?:im)?$/i,
            '$1im'
        ],
        [
            /(her|at|gr)o$/i,
            '$1oes'
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i,
            '$1a'
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i,
            '$1a'
        ],
        [
            /sis$/i,
            'ses'
        ],
        [
            /(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i,
            '$1$2ves'
        ],
        [
            /([^aeiouy]|qu)y$/i,
            '$1ies'
        ],
        [
            /([^ch][ieo][ln])ey$/i,
            '$1ies'
        ],
        [
            /(x|ch|ss|sh|zz)$/i,
            '$1es'
        ],
        [
            /(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i,
            '$1ices'
        ],
        [
            /\b((?:tit)?m|l)(?:ice|ouse)$/i,
            '$1ice'
        ],
        [
            /(pe)(?:rson|ople)$/i,
            '$1ople'
        ],
        [
            /(child)(?:ren)?$/i,
            '$1ren'
        ],
        [
            /eaux$/i,
            '$0'
        ],
        [
            /m[ae]n$/i,
            'men'
        ],
        [
            'thou',
            'you'
        ]
    ].forEach(function(rule) {
        return pluralize.addPluralRule(rule[0], rule[1]);
    });
    /**
   * Singularization rules.
   */ [
        [
            /s$/i,
            ''
        ],
        [
            /(ss)$/i,
            '$1'
        ],
        [
            /(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i,
            '$1fe'
        ],
        [
            /(ar|(?:wo|[ae])l|[eo][ao])ves$/i,
            '$1f'
        ],
        [
            /ies$/i,
            'y'
        ],
        [
            /\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i,
            '$1ie'
        ],
        [
            /\b(mon|smil)ies$/i,
            '$1ey'
        ],
        [
            /\b((?:tit)?m|l)ice$/i,
            '$1ouse'
        ],
        [
            /(seraph|cherub)im$/i,
            '$1'
        ],
        [
            /(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i,
            '$1'
        ],
        [
            /(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i,
            '$1sis'
        ],
        [
            /(movie|twelve|abuse|e[mn]u)s$/i,
            '$1'
        ],
        [
            /(test)(?:is|es)$/i,
            '$1is'
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            '$1us'
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i,
            '$1um'
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i,
            '$1on'
        ],
        [
            /(alumn|alg|vertebr)ae$/i,
            '$1a'
        ],
        [
            /(cod|mur|sil|vert|ind)ices$/i,
            '$1ex'
        ],
        [
            /(matr|append)ices$/i,
            '$1ix'
        ],
        [
            /(pe)(rson|ople)$/i,
            '$1rson'
        ],
        [
            /(child)ren$/i,
            '$1'
        ],
        [
            /(eau)x?$/i,
            '$1'
        ],
        [
            /men$/i,
            'man'
        ]
    ].forEach(function(rule) {
        return pluralize.addSingularRule(rule[0], rule[1]);
    });
    /**
   * Uncountable rules.
   */ [
        // Singular words with no plurals.
        'adulthood',
        'advice',
        'agenda',
        'aid',
        'aircraft',
        'alcohol',
        'ammo',
        'analytics',
        'anime',
        'athletics',
        'audio',
        'bison',
        'blood',
        'bream',
        'buffalo',
        'butter',
        'carp',
        'cash',
        'chassis',
        'chess',
        'clothing',
        'cod',
        'commerce',
        'cooperation',
        'corps',
        'debris',
        'diabetes',
        'digestion',
        'elk',
        'energy',
        'equipment',
        'excretion',
        'expertise',
        'firmware',
        'flounder',
        'fun',
        'gallows',
        'garbage',
        'graffiti',
        'hardware',
        'headquarters',
        'health',
        'herpes',
        'highjinks',
        'homework',
        'housework',
        'information',
        'jeans',
        'justice',
        'kudos',
        'labour',
        'literature',
        'machinery',
        'mackerel',
        'mail',
        'media',
        'mews',
        'moose',
        'music',
        'mud',
        'manga',
        'news',
        'only',
        'personnel',
        'pike',
        'plankton',
        'pliers',
        'police',
        'pollution',
        'premises',
        'rain',
        'research',
        'rice',
        'salmon',
        'scissors',
        'series',
        'sewage',
        'shambles',
        'shrimp',
        'software',
        'species',
        'staff',
        'swine',
        'tennis',
        'traffic',
        'transportation',
        'trout',
        'tuna',
        'wealth',
        'welfare',
        'whiting',
        'wildebeest',
        'wildlife',
        'you',
        /pok[eé]mon$/i,
        // Regexes.
        /[^aeiou]ese$/i,
        /deer$/i,
        /fish$/i,
        /measles$/i,
        /o[iu]s$/i,
        /pox$/i,
        /sheep$/i
    ].forEach(pluralize.addUncountableRule);
    return pluralize;
});

});



parcelRegister("hlZ1o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpecExtension = void 0;
module.exports.listOf = $ca23bb6c4fb0cd6a$var$listOf;
module.exports.mapOf = $ca23bb6c4fb0cd6a$var$mapOf;
module.exports.normalizeTypes = $ca23bb6c4fb0cd6a$var$normalizeTypes;
module.exports.isNamedType = $ca23bb6c4fb0cd6a$var$isNamedType;
function $ca23bb6c4fb0cd6a$var$listOf(typeName) {
    return {
        name: `${typeName}List`,
        properties: {},
        items: typeName
    };
}
function $ca23bb6c4fb0cd6a$var$mapOf(typeName) {
    return {
        name: `${typeName}Map`,
        properties: {},
        additionalProperties: ()=>typeName
    };
}
module.exports.SpecExtension = {
    name: 'SpecExtension',
    properties: {},
    // skip validation of additional properties for unknown extensions
    additionalProperties: {
        resolvable: true
    }
};
function $ca23bb6c4fb0cd6a$var$normalizeTypes(types, options = {}) {
    const normalizedTypes = {};
    for (const typeName of Object.keys(types))normalizedTypes[typeName] = {
        ...types[typeName],
        name: typeName
    };
    for (const type of Object.values(normalizedTypes))normalizeType(type);
    // all type trees have a SpecExtension type by default
    normalizedTypes['SpecExtension'] = module.exports.SpecExtension;
    return normalizedTypes;
    function normalizeType(type) {
        if (type.additionalProperties) type.additionalProperties = resolveType(type.additionalProperties);
        if (type.items) type.items = resolveType(type.items);
        if (type.properties) {
            const mappedProps = {};
            for (const [propName, prop] of Object.entries(type.properties)){
                mappedProps[propName] = resolveType(prop);
                if (options.doNotResolveExamples && prop && prop.isExample) mappedProps[propName] = {
                    ...prop,
                    resolvable: false
                };
            }
            type.properties = mappedProps;
        }
    }
    // typings are painful here...
    function resolveType(type) {
        if (typeof type === 'string') {
            if (!normalizedTypes[type]) throw new Error(`Unknown type name found: ${type}`);
            return normalizedTypes[type];
        } else if (typeof type === 'function') return (value, key)=>{
            return resolveType(type(value, key));
        };
        else if (type && type.name) {
            type = {
                ...type
            };
            normalizeType(type);
            return type;
        } else if (type && type.directResolveAs) return {
            ...type,
            directResolveAs: resolveType(type.directResolveAs)
        };
        else return type;
    }
}
function $ca23bb6c4fb0cd6a$var$isNamedType(t) {
    return typeof t?.name === 'string';
}

});


parcelRegister("7tCfi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalizeVisitors = $5718e8a8d1fa3cf1$var$normalizeVisitors;

var $hlZ1o = parcelRequire("hlZ1o");
const $5718e8a8d1fa3cf1$var$legacyTypesMap = {
    Root: 'DefinitionRoot',
    ServerVariablesMap: 'ServerVariableMap',
    Paths: [
        'PathMap',
        'PathsMap'
    ],
    CallbacksMap: 'CallbackMap',
    MediaTypesMap: 'MediaTypeMap',
    ExamplesMap: 'ExampleMap',
    EncodingMap: 'EncodingsMap',
    HeadersMap: 'HeaderMap',
    LinksMap: 'LinkMap',
    OAuth2Flows: 'SecuritySchemeFlows',
    Responses: 'ResponsesMap'
};
function $5718e8a8d1fa3cf1$var$normalizeVisitors(visitorsConfig, types) {
    const normalizedVisitors = {};
    normalizedVisitors.any = {
        enter: [],
        leave: []
    };
    for (const typeName of Object.keys(types))normalizedVisitors[typeName] = {
        enter: [],
        leave: []
    };
    normalizedVisitors.ref = {
        enter: [],
        leave: []
    };
    for (const { ruleId: ruleId, severity: severity, message: message, visitor: visitor } of visitorsConfig)normalizeVisitorLevel({
        ruleId: ruleId,
        severity: severity,
        message: message
    }, visitor, null);
    for (const v of Object.keys(normalizedVisitors)){
        normalizedVisitors[v].enter.sort((a, b)=>b.depth - a.depth);
        normalizedVisitors[v].leave.sort((a, b)=>a.depth - b.depth);
    }
    return normalizedVisitors;
    function addWeakNodes(ruleConf, from, to, parentContext, stack = []) {
        if (stack.includes(from)) return;
        stack = [
            ...stack,
            from
        ];
        const possibleChildren = new Set();
        for (const type of Object.values(from.properties)){
            if (type === to) {
                addWeakFromStack(ruleConf, stack);
                continue;
            }
            if (typeof type === 'object' && type !== null && type.name) possibleChildren.add(type);
        }
        if (from.additionalProperties && typeof from.additionalProperties !== 'function') {
            if (from.additionalProperties === to) addWeakFromStack(ruleConf, stack);
            else if (from.additionalProperties.name !== undefined) possibleChildren.add(from.additionalProperties);
        }
        if (from.items && typeof from.items !== 'function') {
            if (from.items === to) addWeakFromStack(ruleConf, stack);
            else if (from.items.name !== undefined) possibleChildren.add(from.items);
        }
        if (from.extensionsPrefix) possibleChildren.add($hlZ1o.SpecExtension);
        for (const fromType of Array.from(possibleChildren.values()))addWeakNodes(ruleConf, fromType, to, parentContext, stack);
        function addWeakFromStack(ruleConf, stack) {
            for (const interType of stack.slice(1)){
                normalizedVisitors[interType.name] = normalizedVisitors[interType.name] || {
                    enter: [],
                    leave: []
                };
                normalizedVisitors[interType.name].enter.push({
                    ...ruleConf,
                    visit: ()=>undefined,
                    depth: 0,
                    context: {
                        isSkippedLevel: true,
                        seen: new Set(),
                        parent: parentContext
                    }
                });
            }
        }
    }
    function findLegacyVisitorNode(visitor, typeName) {
        if (Array.isArray(typeName)) {
            const name = typeName.find((name)=>visitor[name]) || undefined;
            return name && visitor[name];
        }
        return visitor[typeName];
    }
    function normalizeVisitorLevel(ruleConf, visitor, parentContext, depth = 0) {
        const visitorKeys = Object.keys(types);
        if (depth === 0) {
            visitorKeys.push('any');
            visitorKeys.push('ref');
        } else {
            if (visitor.any) throw new Error('any() is allowed only on top level');
            if (visitor.ref) throw new Error('ref() is allowed only on top level');
        }
        for (const typeName of visitorKeys){
            const typeVisitor = visitor[typeName] || findLegacyVisitorNode(visitor, $5718e8a8d1fa3cf1$var$legacyTypesMap[typeName]);
            const normalizedTypeVisitor = normalizedVisitors[typeName];
            if (!typeVisitor) continue;
            let visitorEnter;
            let visitorLeave;
            let visitorSkip;
            const isObjectVisitor = typeof typeVisitor === 'object';
            if (typeName === 'ref' && isObjectVisitor && typeVisitor.skip) throw new Error('ref() visitor does not support skip');
            if (typeof typeVisitor === 'function') visitorEnter = typeVisitor;
            else if (isObjectVisitor) {
                visitorEnter = typeVisitor.enter;
                visitorLeave = typeVisitor.leave;
                visitorSkip = typeVisitor.skip;
            }
            const context = {
                activatedOn: null,
                type: types[typeName],
                parent: parentContext,
                isSkippedLevel: false
            };
            if (typeof typeVisitor === 'object') normalizeVisitorLevel(ruleConf, typeVisitor, context, depth + 1);
            if (parentContext) addWeakNodes(ruleConf, parentContext.type, types[typeName], parentContext);
            if (visitorEnter || isObjectVisitor) {
                if (visitorEnter && typeof visitorEnter !== 'function') throw new Error('DEV: should be function');
                normalizedTypeVisitor.enter.push({
                    ...ruleConf,
                    visit: visitorEnter || (()=>undefined),
                    skip: visitorSkip,
                    depth: depth,
                    context: context
                });
            }
            if (visitorLeave) {
                if (typeof visitorLeave !== 'function') throw new Error('DEV: should be function');
                normalizedTypeVisitor.leave.push({
                    ...ruleConf,
                    visit: visitorLeave,
                    depth: depth,
                    context: context
                });
            }
        }
    }
}

});

parcelRegister("Q56OU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.walkDocument = $09c8d1fc340dc85d$var$walkDocument;

var $3EQkN = parcelRequire("3EQkN");

var $eONiY = parcelRequire("eONiY");

var $eWVgr = parcelRequire("eWVgr");

var $hlZ1o = parcelRequire("hlZ1o");
function $09c8d1fc340dc85d$var$collectParents(ctx) {
    const parents = {};
    while(ctx.parent){
        parents[ctx.parent.type.name] = ctx.parent.activatedOn?.value.node;
        ctx = ctx.parent;
    }
    return parents;
}
function $09c8d1fc340dc85d$var$collectParentsLocations(ctx) {
    const locations = {};
    while(ctx.parent){
        if (ctx.parent.activatedOn?.value.location) locations[ctx.parent.type.name] = ctx.parent.activatedOn?.value.location;
        ctx = ctx.parent;
    }
    return locations;
}
function $09c8d1fc340dc85d$var$walkDocument(opts) {
    const { document: document, rootType: rootType, normalizedVisitors: normalizedVisitors, resolvedRefMap: resolvedRefMap, ctx: ctx } = opts;
    const seenNodesPerType = {};
    const ignoredNodes = new Set();
    walkNode(document.parsed, rootType, new $3EQkN.Location(document.source, '#/'), undefined, '');
    function walkNode(node, type, location, parent, key) {
        const resolve = (ref, from = currentLocation.source.absoluteRef)=>{
            if (!(0, $3EQkN.isRef)(ref)) return {
                location: location,
                node: ref
            };
            const refId = (0, $eWVgr.makeRefId)(from, ref.$ref);
            const resolvedRef = resolvedRefMap.get(refId);
            if (!resolvedRef) return {
                location: undefined,
                node: undefined
            };
            const { resolved: resolved, node: node, document: document, nodePointer: nodePointer, error: error } = resolvedRef;
            const newLocation = resolved ? new $3EQkN.Location(document.source, nodePointer) : error instanceof $eWVgr.YamlParseError ? new $3EQkN.Location(error.source, '') : undefined;
            return {
                location: newLocation,
                node: node,
                error: error
            };
        };
        const rawLocation = location;
        let currentLocation = location;
        const { node: resolvedNode, location: resolvedLocation, error: error } = resolve(node);
        const enteredContexts = new Set();
        if ((0, $3EQkN.isRef)(node)) {
            const refEnterVisitors = normalizedVisitors.ref.enter;
            for (const { visit: visitor, ruleId: ruleId, severity: severity, message: message, context: context } of refEnterVisitors){
                enteredContexts.add(context);
                const report = reportFn.bind(undefined, ruleId, severity, message);
                visitor(node, {
                    report: report,
                    resolve: resolve,
                    rawNode: node,
                    rawLocation: rawLocation,
                    location: location,
                    type: type,
                    parent: parent,
                    key: key,
                    parentLocations: {},
                    oasVersion: ctx.oasVersion,
                    getVisitorData: getVisitorDataFn.bind(undefined, ruleId)
                }, {
                    node: resolvedNode,
                    location: resolvedLocation,
                    error: error
                });
                if (resolvedLocation?.source.absoluteRef && ctx.refTypes) ctx.refTypes.set(resolvedLocation?.source.absoluteRef, type);
            }
        }
        if (resolvedNode !== undefined && resolvedLocation && type.name !== 'scalar') {
            currentLocation = resolvedLocation;
            const isNodeSeen = seenNodesPerType[type.name]?.has?.(resolvedNode);
            let visitedBySome = false;
            const anyEnterVisitors = normalizedVisitors.any.enter;
            const currentEnterVisitors = anyEnterVisitors.concat(normalizedVisitors[type.name]?.enter || []);
            const activatedContexts = [];
            for (const { context: context, visit: visit, skip: skip, ruleId: ruleId, severity: severity, message: message } of currentEnterVisitors){
                if (ignoredNodes.has(`${currentLocation.absolutePointer}${currentLocation.pointer}`)) break;
                if (context.isSkippedLevel) {
                    if (context.parent.activatedOn && !context.parent.activatedOn.value.nextLevelTypeActivated && !context.seen.has(node)) {
                        // TODO: test for walk through duplicated $ref-ed node
                        context.seen.add(node);
                        visitedBySome = true;
                        activatedContexts.push(context);
                    }
                } else if (context.parent && // if nested
                context.parent.activatedOn && context.activatedOn?.value.withParentNode !== context.parent.activatedOn.value.node && // do not enter if visited by parent children (it works thanks because deeper visitors are sorted before)
                context.parent.activatedOn.value.nextLevelTypeActivated?.value !== type || !context.parent && !isNodeSeen // if top-level visit each node just once
                ) {
                    activatedContexts.push(context);
                    const activatedOn = {
                        node: resolvedNode,
                        location: resolvedLocation,
                        nextLevelTypeActivated: null,
                        withParentNode: context.parent?.activatedOn?.value.node,
                        skipped: (context.parent?.activatedOn?.value.skipped || skip?.(resolvedNode, key, {
                            location: location,
                            rawLocation: rawLocation,
                            resolve: resolve,
                            rawNode: node
                        })) ?? false
                    };
                    context.activatedOn = (0, $eONiY.pushStack)(context.activatedOn, activatedOn);
                    let ctx = context.parent;
                    while(ctx){
                        ctx.activatedOn.value.nextLevelTypeActivated = (0, $eONiY.pushStack)(ctx.activatedOn.value.nextLevelTypeActivated, type);
                        ctx = ctx.parent;
                    }
                    if (!activatedOn.skipped) {
                        visitedBySome = true;
                        enteredContexts.add(context);
                        visitWithContext(visit, resolvedNode, node, context, ruleId, severity, message);
                    }
                }
            }
            if (visitedBySome || !isNodeSeen) {
                seenNodesPerType[type.name] = seenNodesPerType[type.name] || new Set();
                seenNodesPerType[type.name].add(resolvedNode);
                if (Array.isArray(resolvedNode)) {
                    const itemsType = type.items;
                    if (itemsType !== undefined) {
                        const isTypeAFunction = typeof itemsType === 'function';
                        for(let i = 0; i < resolvedNode.length; i++){
                            const itemType = isTypeAFunction ? itemsType(resolvedNode[i], resolvedLocation.child([
                                i
                            ]).absolutePointer) : itemsType;
                            if ((0, $hlZ1o.isNamedType)(itemType)) walkNode(resolvedNode[i], itemType, resolvedLocation.child([
                                i
                            ]), resolvedNode, i);
                        }
                    }
                } else if (typeof resolvedNode === 'object' && resolvedNode !== null) {
                    // visit in order from type-tree first
                    const props = Object.keys(type.properties);
                    if (type.additionalProperties) props.push(...Object.keys(resolvedNode).filter((k)=>!props.includes(k)));
                    else if (type.extensionsPrefix) props.push(...Object.keys(resolvedNode).filter((k)=>k.startsWith(type.extensionsPrefix)));
                    if ((0, $3EQkN.isRef)(node)) props.push(...Object.keys(node).filter((k)=>k !== '$ref' && !props.includes(k))); // properties on the same level as $ref
                    for (const propName of props){
                        let value = resolvedNode[propName];
                        let loc = resolvedLocation;
                        if (value === undefined) {
                            value = node[propName];
                            loc = location; // properties on the same level as $ref should resolve against original location, not target
                        }
                        let propType = type.properties[propName];
                        if (propType === undefined) propType = type.additionalProperties;
                        if (typeof propType === 'function') propType = propType(value, propName);
                        if (propType === undefined && type.extensionsPrefix && propName.startsWith(type.extensionsPrefix)) propType = $hlZ1o.SpecExtension;
                        if (!(0, $hlZ1o.isNamedType)(propType) && propType?.directResolveAs) {
                            propType = propType.directResolveAs;
                            value = {
                                $ref: value
                            };
                        }
                        if (propType && propType.name === undefined && propType.resolvable !== false) propType = {
                            name: 'scalar',
                            properties: {}
                        };
                        if (!(0, $hlZ1o.isNamedType)(propType) || propType.name === 'scalar' && !(0, $3EQkN.isRef)(value)) continue;
                        walkNode(value, propType, loc.child([
                            propName
                        ]), resolvedNode, propName);
                    }
                }
            }
            const anyLeaveVisitors = normalizedVisitors.any.leave;
            const currentLeaveVisitors = (normalizedVisitors[type.name]?.leave || []).concat(anyLeaveVisitors);
            for (const context of activatedContexts.reverse())if (context.isSkippedLevel) context.seen.delete(resolvedNode);
            else {
                context.activatedOn = (0, $eONiY.popStack)(context.activatedOn);
                if (context.parent) {
                    let ctx = context.parent;
                    while(ctx){
                        ctx.activatedOn.value.nextLevelTypeActivated = (0, $eONiY.popStack)(ctx.activatedOn.value.nextLevelTypeActivated);
                        ctx = ctx.parent;
                    }
                }
            }
            for (const { context: context, visit: visit, ruleId: ruleId, severity: severity, message: message } of currentLeaveVisitors)if (!context.isSkippedLevel && enteredContexts.has(context)) visitWithContext(visit, resolvedNode, node, context, ruleId, severity, message);
        }
        currentLocation = location;
        if ((0, $3EQkN.isRef)(node)) {
            const refLeaveVisitors = normalizedVisitors.ref.leave;
            for (const { visit: visitor, ruleId: ruleId, severity: severity, context: context, message: message } of refLeaveVisitors)if (enteredContexts.has(context)) {
                const report = reportFn.bind(undefined, ruleId, severity, message);
                visitor(node, {
                    report: report,
                    resolve: resolve,
                    rawNode: node,
                    rawLocation: rawLocation,
                    location: location,
                    type: type,
                    parent: parent,
                    key: key,
                    parentLocations: {},
                    oasVersion: ctx.oasVersion,
                    getVisitorData: getVisitorDataFn.bind(undefined, ruleId)
                }, {
                    node: resolvedNode,
                    location: resolvedLocation,
                    error: error
                });
            }
        }
        // returns true ignores all the next visitors on the specific node
        function visitWithContext(visit, resolvedNode, node, context, ruleId, severity, customMessage) {
            const report = reportFn.bind(undefined, ruleId, severity, customMessage);
            visit(resolvedNode, {
                report: report,
                resolve: resolve,
                rawNode: node,
                location: currentLocation,
                rawLocation: rawLocation,
                type: type,
                parent: parent,
                key: key,
                parentLocations: $09c8d1fc340dc85d$var$collectParentsLocations(context),
                oasVersion: ctx.oasVersion,
                ignoreNextVisitorsOnNode: ()=>{
                    ignoredNodes.add(`${currentLocation.absolutePointer}${currentLocation.pointer}`);
                },
                getVisitorData: getVisitorDataFn.bind(undefined, ruleId)
            }, $09c8d1fc340dc85d$var$collectParents(context), context);
        }
        function reportFn(ruleId, severity, customMessage, opts) {
            const normalizedLocation = opts.location ? Array.isArray(opts.location) ? opts.location : [
                opts.location
            ] : [
                {
                    ...currentLocation,
                    reportOnKey: false
                }
            ];
            const location = normalizedLocation.map((l)=>({
                    ...currentLocation,
                    reportOnKey: false,
                    ...l
                }));
            const ruleSeverity = opts.forceSeverity || severity;
            if (ruleSeverity !== 'off') ctx.problems.push({
                ruleId: opts.ruleId || ruleId,
                severity: ruleSeverity,
                ...opts,
                message: customMessage ? customMessage.replace('{{message}}', opts.message) : opts.message,
                suggest: opts.suggest || [],
                location: location
            });
        }
        function getVisitorDataFn(ruleId) {
            ctx.visitorsData[ruleId] = ctx.visitorsData[ruleId] || {};
            return ctx.visitorsData[ruleId];
        }
    }
}

});

parcelRegister("aSlQf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SpecMajorVersion = module.exports.SpecVersion = void 0;
module.exports.detectSpec = $7eafe3d0ef56b271$var$detectSpec;
module.exports.getMajorSpecVersion = $7eafe3d0ef56b271$var$getMajorSpecVersion;
module.exports.getTypes = $7eafe3d0ef56b271$var$getTypes;

var $ighVh = parcelRequire("ighVh");

var $d7QLh = parcelRequire("d7QLh");

var $juqjK = parcelRequire("juqjK");

var $aBdFo = parcelRequire("aBdFo");

var $1SNrj = parcelRequire("1SNrj");

var $7oO5W = parcelRequire("7oO5W");

var $acgKy = parcelRequire("acgKy");

var $eONiY = parcelRequire("eONiY");

var $NKVWi = parcelRequire("NKVWi");
var $7eafe3d0ef56b271$var$SpecVersion;
(function(SpecVersion) {
    SpecVersion["OAS2"] = "oas2";
    SpecVersion["OAS3_0"] = "oas3_0";
    SpecVersion["OAS3_1"] = "oas3_1";
    SpecVersion["Async2"] = "async2";
    SpecVersion["Async3"] = "async3";
    SpecVersion["Arazzo1"] = "arazzo1";
    SpecVersion["Overlay1"] = "overlay1";
})($7eafe3d0ef56b271$var$SpecVersion || (module.exports.SpecVersion = $7eafe3d0ef56b271$var$SpecVersion = {}));
var $7eafe3d0ef56b271$var$SpecMajorVersion;
(function(SpecMajorVersion) {
    SpecMajorVersion["OAS2"] = "oas2";
    SpecMajorVersion["OAS3"] = "oas3";
    SpecMajorVersion["Async2"] = "async2";
    SpecMajorVersion["Async3"] = "async3";
    SpecMajorVersion["Arazzo1"] = "arazzo1";
    SpecMajorVersion["Overlay1"] = "overlay1";
})($7eafe3d0ef56b271$var$SpecMajorVersion || (module.exports.SpecMajorVersion = $7eafe3d0ef56b271$var$SpecMajorVersion = {}));
const $7eafe3d0ef56b271$var$typesMap = {
    [$7eafe3d0ef56b271$var$SpecVersion.OAS2]: $ighVh.Oas2Types,
    [$7eafe3d0ef56b271$var$SpecVersion.OAS3_0]: $d7QLh.Oas3Types,
    [$7eafe3d0ef56b271$var$SpecVersion.OAS3_1]: $juqjK.Oas3_1Types,
    [$7eafe3d0ef56b271$var$SpecVersion.Async2]: $aBdFo.AsyncApi2Types,
    [$7eafe3d0ef56b271$var$SpecVersion.Async3]: $1SNrj.AsyncApi3Types,
    [$7eafe3d0ef56b271$var$SpecVersion.Arazzo1]: $7oO5W.Arazzo1Types,
    [$7eafe3d0ef56b271$var$SpecVersion.Overlay1]: $acgKy.Overlay1Types
};
function $7eafe3d0ef56b271$var$detectSpec(root) {
    if (!(0, $eONiY.isPlainObject)(root)) throw new Error(`Document must be JSON object, got ${typeof root}`);
    if (root.openapi && typeof root.openapi !== 'string') throw new Error(`Invalid OpenAPI version: should be a string but got "${typeof root.openapi}"`);
    if (typeof root.openapi === 'string' && root.openapi.startsWith('3.0')) return $7eafe3d0ef56b271$var$SpecVersion.OAS3_0;
    if (typeof root.openapi === 'string' && (root.openapi.startsWith('3.1') || root.openapi.startsWith('3.2') // temporary support for 3.2
    )) return $7eafe3d0ef56b271$var$SpecVersion.OAS3_1;
    if (root.swagger && root.swagger === '2.0') return $7eafe3d0ef56b271$var$SpecVersion.OAS2;
    if (root.openapi || root.swagger) throw new Error(`Unsupported OpenAPI version: ${root.openapi || root.swagger}`);
    if (typeof root.asyncapi === 'string' && root.asyncapi.startsWith('2.')) return $7eafe3d0ef56b271$var$SpecVersion.Async2;
    if (typeof root.asyncapi === 'string' && root.asyncapi.startsWith('3.')) return $7eafe3d0ef56b271$var$SpecVersion.Async3;
    if (root.asyncapi) throw new Error(`Unsupported AsyncAPI version: ${root.asyncapi}`);
    if (typeof root.arazzo === 'string' && $NKVWi.VERSION_PATTERN.test(root.arazzo)) return $7eafe3d0ef56b271$var$SpecVersion.Arazzo1;
    if (typeof root.overlay === 'string' && $NKVWi.VERSION_PATTERN.test(root.overlay)) return $7eafe3d0ef56b271$var$SpecVersion.Overlay1;
    throw new Error(`Unsupported specification`);
}
function $7eafe3d0ef56b271$var$getMajorSpecVersion(version) {
    if (version === $7eafe3d0ef56b271$var$SpecVersion.OAS2) return $7eafe3d0ef56b271$var$SpecMajorVersion.OAS2;
    else if (version === $7eafe3d0ef56b271$var$SpecVersion.Async2) return $7eafe3d0ef56b271$var$SpecMajorVersion.Async2;
    else if (version === $7eafe3d0ef56b271$var$SpecVersion.Async3) return $7eafe3d0ef56b271$var$SpecMajorVersion.Async3;
    else if (version === $7eafe3d0ef56b271$var$SpecVersion.Arazzo1) return $7eafe3d0ef56b271$var$SpecMajorVersion.Arazzo1;
    else if (version === $7eafe3d0ef56b271$var$SpecVersion.Overlay1) return $7eafe3d0ef56b271$var$SpecMajorVersion.Overlay1;
    else return $7eafe3d0ef56b271$var$SpecMajorVersion.OAS3;
}
function $7eafe3d0ef56b271$var$getTypes(spec) {
    return $7eafe3d0ef56b271$var$typesMap[spec];
}

});
parcelRegister("ighVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Oas2Types = void 0;

var $hlZ1o = parcelRequire("hlZ1o");
const $d4b79fb713498c08$var$responseCodeRegexp = /^[0-9][0-9Xx]{2}$/;
const $d4b79fb713498c08$var$Root = {
    properties: {
        swagger: {
            type: 'string'
        },
        info: 'Info',
        host: {
            type: 'string'
        },
        basePath: {
            type: 'string'
        },
        schemes: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        consumes: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        produces: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        paths: 'Paths',
        definitions: 'NamedSchemas',
        parameters: 'NamedParameters',
        responses: 'NamedResponses',
        securityDefinitions: 'NamedSecuritySchemes',
        security: 'SecurityRequirementList',
        tags: 'TagList',
        externalDocs: 'ExternalDocs',
        'x-servers': 'XServerList',
        'x-tagGroups': 'TagGroups',
        'x-ignoredHeaderParameters': {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: [
        'swagger',
        'paths',
        'info'
    ],
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$Info = {
    properties: {
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        termsOfService: {
            type: 'string'
        },
        contact: 'Contact',
        license: 'License',
        version: {
            type: 'string'
        },
        'x-logo': 'Logo'
    },
    required: [
        'title',
        'version'
    ],
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$Logo = {
    properties: {
        url: {
            type: 'string'
        },
        altText: {
            type: 'string'
        },
        backgroundColor: {
            type: 'string'
        },
        href: {
            type: 'string'
        }
    },
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$Contact = {
    properties: {
        name: {
            type: 'string'
        },
        url: {
            type: 'string'
        },
        email: {
            type: 'string'
        }
    },
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$License = {
    properties: {
        name: {
            type: 'string'
        },
        url: {
            type: 'string'
        }
    },
    required: [
        'name'
    ],
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$Paths = {
    properties: {},
    additionalProperties: (_value, key)=>key.startsWith('/') ? 'PathItem' : undefined
};
const $d4b79fb713498c08$var$PathItem = {
    properties: {
        $ref: {
            type: 'string'
        },
        parameters: 'ParameterList',
        get: 'Operation',
        put: 'Operation',
        post: 'Operation',
        delete: 'Operation',
        options: 'Operation',
        head: 'Operation',
        patch: 'Operation'
    },
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$Operation = {
    properties: {
        tags: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalDocs: 'ExternalDocs',
        operationId: {
            type: 'string'
        },
        consumes: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        produces: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        parameters: 'ParameterList',
        responses: 'Responses',
        schemes: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        deprecated: {
            type: 'boolean'
        },
        security: 'SecurityRequirementList',
        'x-codeSamples': 'XCodeSampleList',
        'x-code-samples': 'XCodeSampleList',
        'x-hideTryItPanel': {
            type: 'boolean'
        }
    },
    required: [
        'responses'
    ],
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$XCodeSample = {
    properties: {
        lang: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        source: {
            type: 'string'
        }
    }
};
const $d4b79fb713498c08$var$XServer = {
    properties: {
        url: {
            type: 'string'
        },
        description: {
            type: 'string'
        }
    },
    required: [
        'url'
    ]
};
const $d4b79fb713498c08$var$ExternalDocs = {
    properties: {
        description: {
            type: 'string'
        },
        url: {
            type: 'string'
        }
    },
    required: [
        'url'
    ],
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$Parameter = {
    properties: {
        name: {
            type: 'string'
        },
        in: {
            type: 'string',
            enum: [
                'query',
                'header',
                'path',
                'formData',
                'body'
            ]
        },
        description: {
            type: 'string'
        },
        required: {
            type: 'boolean'
        },
        schema: 'Schema',
        type: {
            type: 'string',
            enum: [
                'string',
                'number',
                'integer',
                'boolean',
                'array',
                'file'
            ]
        },
        format: {
            type: 'string'
        },
        allowEmptyValue: {
            type: 'boolean'
        },
        items: 'ParameterItems',
        collectionFormat: {
            type: 'string',
            enum: [
                'csv',
                'ssv',
                'tsv',
                'pipes',
                'multi'
            ]
        },
        default: null,
        maximum: {
            type: 'integer'
        },
        exclusiveMaximum: {
            type: 'boolean'
        },
        minimum: {
            type: 'integer'
        },
        exclusiveMinimum: {
            type: 'boolean'
        },
        maxLength: {
            type: 'integer'
        },
        minLength: {
            type: 'integer'
        },
        pattern: {
            type: 'string'
        },
        maxItems: {
            type: 'integer'
        },
        minItems: {
            type: 'integer'
        },
        uniqueItems: {
            type: 'boolean'
        },
        enum: {
            type: 'array'
        },
        multipleOf: {
            type: 'number'
        },
        'x-example': {},
        'x-examples': 'ExamplesMap'
    },
    required (value) {
        if (!value || !value.in) return [
            'name',
            'in'
        ];
        if (value.in === 'body') return [
            'name',
            'in',
            'schema'
        ];
        else {
            if (value.type === 'array') return [
                'name',
                'in',
                'type',
                'items'
            ];
            else return [
                'name',
                'in',
                'type'
            ];
        }
    },
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$ParameterItems = {
    properties: {
        type: {
            type: 'string',
            enum: [
                'string',
                'number',
                'integer',
                'boolean',
                'array'
            ]
        },
        format: {
            type: 'string'
        },
        items: 'ParameterItems',
        collectionFormat: {
            type: 'string',
            enum: [
                'csv',
                'ssv',
                'tsv',
                'pipes',
                'multi'
            ]
        },
        default: null,
        maximum: {
            type: 'integer'
        },
        exclusiveMaximum: {
            type: 'boolean'
        },
        minimum: {
            type: 'integer'
        },
        exclusiveMinimum: {
            type: 'boolean'
        },
        maxLength: {
            type: 'integer'
        },
        minLength: {
            type: 'integer'
        },
        pattern: {
            type: 'string'
        },
        maxItems: {
            type: 'integer'
        },
        minItems: {
            type: 'integer'
        },
        uniqueItems: {
            type: 'boolean'
        },
        enum: {
            type: 'array'
        },
        multipleOf: {
            type: 'number'
        }
    },
    required (value) {
        if (value && value.type === 'array') return [
            'type',
            'items'
        ];
        else return [
            'type'
        ];
    },
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$Responses = {
    properties: {
        default: 'Response'
    },
    additionalProperties: (_v, key)=>$d4b79fb713498c08$var$responseCodeRegexp.test(key) ? 'Response' : undefined
};
const $d4b79fb713498c08$var$Response = {
    properties: {
        description: {
            type: 'string'
        },
        schema: 'Schema',
        headers: (0, $hlZ1o.mapOf)('Header'),
        examples: 'Examples',
        'x-summary': {
            type: 'string'
        }
    },
    required: [
        'description'
    ],
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$Examples = {
    properties: {},
    additionalProperties: {
        isExample: true
    }
};
const $d4b79fb713498c08$var$Header = {
    properties: {
        description: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: [
                'string',
                'number',
                'integer',
                'boolean',
                'array'
            ]
        },
        format: {
            type: 'string'
        },
        items: 'ParameterItems',
        collectionFormat: {
            type: 'string',
            enum: [
                'csv',
                'ssv',
                'tsv',
                'pipes',
                'multi'
            ]
        },
        default: null,
        maximum: {
            type: 'integer'
        },
        exclusiveMaximum: {
            type: 'boolean'
        },
        minimum: {
            type: 'integer'
        },
        exclusiveMinimum: {
            type: 'boolean'
        },
        maxLength: {
            type: 'integer'
        },
        minLength: {
            type: 'integer'
        },
        pattern: {
            type: 'string'
        },
        maxItems: {
            type: 'integer'
        },
        minItems: {
            type: 'integer'
        },
        uniqueItems: {
            type: 'boolean'
        },
        enum: {
            type: 'array'
        },
        multipleOf: {
            type: 'number'
        }
    },
    required (value) {
        if (value && value.type === 'array') return [
            'type',
            'items'
        ];
        else return [
            'type'
        ];
    },
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$Tag = {
    properties: {
        name: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalDocs: 'ExternalDocs',
        'x-traitTag': {
            type: 'boolean'
        },
        'x-displayName': {
            type: 'string'
        }
    },
    required: [
        'name'
    ],
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$TagGroup = {
    properties: {
        name: {
            type: 'string'
        },
        tags: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    }
};
const $d4b79fb713498c08$var$Schema = {
    properties: {
        format: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        default: null,
        multipleOf: {
            type: 'number'
        },
        maximum: {
            type: 'number'
        },
        minimum: {
            type: 'number'
        },
        exclusiveMaximum: {
            type: 'boolean'
        },
        exclusiveMinimum: {
            type: 'boolean'
        },
        maxLength: {
            type: 'number'
        },
        minLength: {
            type: 'number'
        },
        pattern: {
            type: 'string'
        },
        maxItems: {
            type: 'number'
        },
        minItems: {
            type: 'number'
        },
        uniqueItems: {
            type: 'boolean'
        },
        maxProperties: {
            type: 'number'
        },
        minProperties: {
            type: 'number'
        },
        required: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        enum: {
            type: 'array'
        },
        type: {
            type: 'string',
            enum: [
                'object',
                'array',
                'string',
                'number',
                'integer',
                'boolean',
                'null'
            ]
        },
        items: (value)=>{
            if (Array.isArray(value)) return (0, $hlZ1o.listOf)('Schema');
            else return 'Schema';
        },
        allOf: (0, $hlZ1o.listOf)('Schema'),
        properties: 'SchemaProperties',
        additionalProperties: (value)=>{
            if (typeof value === 'boolean') return {
                type: 'boolean'
            };
            else return 'Schema';
        },
        discriminator: {
            type: 'string'
        },
        readOnly: {
            type: 'boolean'
        },
        xml: 'Xml',
        externalDocs: 'ExternalDocs',
        example: {
            isExample: true
        },
        'x-tags': {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        'x-nullable': {
            type: 'boolean'
        },
        'x-extendedDiscriminator': {
            type: 'string'
        },
        'x-additionalPropertiesName': {
            type: 'string'
        },
        'x-explicitMappingOnly': {
            type: 'boolean'
        },
        'x-enumDescriptions': 'EnumDescriptions'
    },
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$EnumDescriptions = {
    properties: {},
    additionalProperties: {
        type: 'string'
    }
};
const $d4b79fb713498c08$var$SchemaProperties = {
    properties: {},
    additionalProperties: 'Schema'
};
const $d4b79fb713498c08$var$Xml = {
    properties: {
        name: {
            type: 'string'
        },
        namespace: {
            type: 'string'
        },
        prefix: {
            type: 'string'
        },
        attribute: {
            type: 'boolean'
        },
        wrapped: {
            type: 'boolean'
        }
    },
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$SecurityScheme = {
    properties: {
        type: {
            enum: [
                'basic',
                'apiKey',
                'oauth2'
            ]
        },
        description: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        in: {
            type: 'string',
            enum: [
                'query',
                'header'
            ]
        },
        flow: {
            enum: [
                'implicit',
                'password',
                'application',
                'accessCode'
            ]
        },
        authorizationUrl: {
            type: 'string'
        },
        tokenUrl: {
            type: 'string'
        },
        scopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        'x-defaultClientId': {
            type: 'string'
        }
    },
    required (value) {
        switch(value?.type){
            case 'apiKey':
                return [
                    'type',
                    'name',
                    'in'
                ];
            case 'oauth2':
                switch(value?.flow){
                    case 'implicit':
                        return [
                            'type',
                            'flow',
                            'authorizationUrl',
                            'scopes'
                        ];
                    case 'accessCode':
                        return [
                            'type',
                            'flow',
                            'authorizationUrl',
                            'tokenUrl',
                            'scopes'
                        ];
                    case 'application':
                    case 'password':
                        return [
                            'type',
                            'flow',
                            'tokenUrl',
                            'scopes'
                        ];
                    default:
                        return [
                            'type',
                            'flow',
                            'scopes'
                        ];
                }
            default:
                return [
                    'type'
                ];
        }
    },
    allowed (value) {
        switch(value?.type){
            case 'basic':
                return [
                    'type',
                    'description'
                ];
            case 'apiKey':
                return [
                    'type',
                    'name',
                    'in',
                    'description'
                ];
            case 'oauth2':
                switch(value?.flow){
                    case 'implicit':
                        return [
                            'type',
                            'flow',
                            'authorizationUrl',
                            'description',
                            'scopes'
                        ];
                    case 'accessCode':
                        return [
                            'type',
                            'flow',
                            'authorizationUrl',
                            'tokenUrl',
                            'description',
                            'scopes'
                        ];
                    case 'application':
                    case 'password':
                        return [
                            'type',
                            'flow',
                            'tokenUrl',
                            'description',
                            'scopes'
                        ];
                    default:
                        return [
                            'type',
                            'flow',
                            'tokenUrl',
                            'authorizationUrl',
                            'description',
                            'scopes'
                        ];
                }
            default:
                return [
                    'type',
                    'description'
                ];
        }
    },
    extensionsPrefix: 'x-'
};
const $d4b79fb713498c08$var$SecurityRequirement = {
    properties: {},
    additionalProperties: {
        type: 'array',
        items: {
            type: 'string'
        }
    }
};
const $d4b79fb713498c08$var$Example = {
    properties: {
        value: {
            isExample: true
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalValue: {
            type: 'string'
        }
    },
    extensionsPrefix: 'x-'
};
module.exports.Oas2Types = {
    Root: $d4b79fb713498c08$var$Root,
    Tag: $d4b79fb713498c08$var$Tag,
    TagList: (0, $hlZ1o.listOf)('Tag'),
    TagGroups: (0, $hlZ1o.listOf)('TagGroup'),
    TagGroup: $d4b79fb713498c08$var$TagGroup,
    ExternalDocs: $d4b79fb713498c08$var$ExternalDocs,
    Example: $d4b79fb713498c08$var$Example,
    ExamplesMap: (0, $hlZ1o.mapOf)('Example'),
    EnumDescriptions: $d4b79fb713498c08$var$EnumDescriptions,
    SecurityRequirement: $d4b79fb713498c08$var$SecurityRequirement,
    SecurityRequirementList: (0, $hlZ1o.listOf)('SecurityRequirement'),
    Info: $d4b79fb713498c08$var$Info,
    Contact: $d4b79fb713498c08$var$Contact,
    License: $d4b79fb713498c08$var$License,
    Logo: $d4b79fb713498c08$var$Logo,
    Paths: $d4b79fb713498c08$var$Paths,
    PathItem: $d4b79fb713498c08$var$PathItem,
    Parameter: $d4b79fb713498c08$var$Parameter,
    ParameterItems: $d4b79fb713498c08$var$ParameterItems,
    ParameterList: (0, $hlZ1o.listOf)('Parameter'),
    Operation: $d4b79fb713498c08$var$Operation,
    Examples: $d4b79fb713498c08$var$Examples,
    Header: $d4b79fb713498c08$var$Header,
    Responses: $d4b79fb713498c08$var$Responses,
    Response: $d4b79fb713498c08$var$Response,
    Schema: $d4b79fb713498c08$var$Schema,
    Xml: $d4b79fb713498c08$var$Xml,
    SchemaProperties: $d4b79fb713498c08$var$SchemaProperties,
    NamedSchemas: (0, $hlZ1o.mapOf)('Schema'),
    NamedResponses: (0, $hlZ1o.mapOf)('Response'),
    NamedParameters: (0, $hlZ1o.mapOf)('Parameter'),
    NamedSecuritySchemes: (0, $hlZ1o.mapOf)('SecurityScheme'),
    SecurityScheme: $d4b79fb713498c08$var$SecurityScheme,
    XCodeSample: $d4b79fb713498c08$var$XCodeSample,
    XCodeSampleList: (0, $hlZ1o.listOf)('XCodeSample'),
    XServerList: (0, $hlZ1o.listOf)('XServer'),
    XServer: $d4b79fb713498c08$var$XServer
};

});

parcelRegister("d7QLh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Oas3Types = module.exports.Discriminator = module.exports.DiscriminatorMapping = module.exports.Xml = module.exports.ExternalDocs = void 0;

var $hlZ1o = parcelRequire("hlZ1o");

var $3EQkN = parcelRequire("3EQkN");
const $98e4db249f7aeea8$var$responseCodeRegexp = /^[0-9][0-9Xx]{2}$/;
const $98e4db249f7aeea8$var$Root = {
    properties: {
        openapi: null,
        info: 'Info',
        servers: 'ServerList',
        security: 'SecurityRequirementList',
        tags: 'TagList',
        externalDocs: 'ExternalDocs',
        paths: 'Paths',
        components: 'Components',
        'x-webhooks': 'WebhooksMap',
        'x-tagGroups': 'TagGroups',
        'x-ignoredHeaderParameters': {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: [
        'openapi',
        'paths',
        'info'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Tag = {
    properties: {
        name: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalDocs: 'ExternalDocs',
        'x-traitTag': {
            type: 'boolean'
        },
        'x-displayName': {
            type: 'string'
        }
    },
    required: [
        'name'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$TagGroup = {
    properties: {
        name: {
            type: 'string'
        },
        tags: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    extensionsPrefix: 'x-'
};
module.exports.ExternalDocs = {
    properties: {
        description: {
            type: 'string'
        },
        url: {
            type: 'string'
        }
    },
    required: [
        'url'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Server = {
    properties: {
        url: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        variables: 'ServerVariablesMap'
    },
    required: [
        'url'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$ServerVariable = {
    properties: {
        enum: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        default: {
            type: 'string'
        },
        description: {
            type: 'string'
        }
    },
    required: [
        'default'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$SecurityRequirement = {
    properties: {},
    additionalProperties: {
        type: 'array',
        items: {
            type: 'string'
        }
    }
};
const $98e4db249f7aeea8$var$Info = {
    properties: {
        title: {
            type: 'string'
        },
        version: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        termsOfService: {
            type: 'string'
        },
        contact: 'Contact',
        license: 'License',
        'x-logo': 'Logo'
    },
    required: [
        'title',
        'version'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Logo = {
    properties: {
        url: {
            type: 'string'
        },
        altText: {
            type: 'string'
        },
        backgroundColor: {
            type: 'string'
        },
        href: {
            type: 'string'
        }
    }
};
const $98e4db249f7aeea8$var$Contact = {
    properties: {
        name: {
            type: 'string'
        },
        url: {
            type: 'string'
        },
        email: {
            type: 'string'
        }
    },
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$License = {
    properties: {
        name: {
            type: 'string'
        },
        url: {
            type: 'string'
        }
    },
    required: [
        'name'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Paths = {
    properties: {},
    additionalProperties: (_value, key)=>key.startsWith('/') ? 'PathItem' : undefined
};
const $98e4db249f7aeea8$var$WebhooksMap = {
    properties: {},
    additionalProperties: ()=>'PathItem'
};
const $98e4db249f7aeea8$var$PathItem = {
    properties: {
        $ref: {
            type: 'string'
        },
        servers: 'ServerList',
        parameters: 'ParameterList',
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        get: 'Operation',
        put: 'Operation',
        post: 'Operation',
        delete: 'Operation',
        options: 'Operation',
        head: 'Operation',
        patch: 'Operation',
        trace: 'Operation'
    },
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Parameter = {
    properties: {
        name: {
            type: 'string'
        },
        in: {
            enum: [
                'query',
                'header',
                'path',
                'cookie'
            ]
        },
        description: {
            type: 'string'
        },
        required: {
            type: 'boolean'
        },
        deprecated: {
            type: 'boolean'
        },
        allowEmptyValue: {
            type: 'boolean'
        },
        style: {
            enum: [
                'form',
                'simple',
                'label',
                'matrix',
                'spaceDelimited',
                'pipeDelimited',
                'deepObject'
            ]
        },
        explode: {
            type: 'boolean'
        },
        allowReserved: {
            type: 'boolean'
        },
        schema: 'Schema',
        example: {
            isExample: true
        },
        examples: 'ExamplesMap',
        content: 'MediaTypesMap'
    },
    required: [
        'name',
        'in'
    ],
    requiredOneOf: [
        'schema',
        'content'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Operation = {
    properties: {
        tags: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalDocs: 'ExternalDocs',
        operationId: {
            type: 'string'
        },
        parameters: 'ParameterList',
        security: 'SecurityRequirementList',
        servers: 'ServerList',
        requestBody: 'RequestBody',
        responses: 'Responses',
        deprecated: {
            type: 'boolean'
        },
        callbacks: 'CallbacksMap',
        'x-codeSamples': 'XCodeSampleList',
        'x-code-samples': 'XCodeSampleList',
        'x-hideTryItPanel': {
            type: 'boolean'
        }
    },
    required: [
        'responses'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$XCodeSample = {
    properties: {
        lang: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        source: {
            type: 'string'
        }
    }
};
const $98e4db249f7aeea8$var$RequestBody = {
    properties: {
        description: {
            type: 'string'
        },
        required: {
            type: 'boolean'
        },
        content: 'MediaTypesMap'
    },
    required: [
        'content'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$MediaTypesMap = {
    properties: {},
    additionalProperties: 'MediaType'
};
const $98e4db249f7aeea8$var$MediaType = {
    properties: {
        schema: 'Schema',
        example: {
            isExample: true
        },
        examples: 'ExamplesMap',
        encoding: 'EncodingMap'
    },
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Example = {
    properties: {
        value: {
            isExample: true
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalValue: {
            type: 'string'
        }
    },
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Encoding = {
    properties: {
        contentType: {
            type: 'string'
        },
        headers: 'HeadersMap',
        style: {
            enum: [
                'form',
                'simple',
                'label',
                'matrix',
                'spaceDelimited',
                'pipeDelimited',
                'deepObject'
            ]
        },
        explode: {
            type: 'boolean'
        },
        allowReserved: {
            type: 'boolean'
        }
    },
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$EnumDescriptions = {
    properties: {},
    additionalProperties: {
        type: 'string'
    }
};
const $98e4db249f7aeea8$var$Header = {
    properties: {
        description: {
            type: 'string'
        },
        required: {
            type: 'boolean'
        },
        deprecated: {
            type: 'boolean'
        },
        allowEmptyValue: {
            type: 'boolean'
        },
        style: {
            enum: [
                'form',
                'simple',
                'label',
                'matrix',
                'spaceDelimited',
                'pipeDelimited',
                'deepObject'
            ]
        },
        explode: {
            type: 'boolean'
        },
        allowReserved: {
            type: 'boolean'
        },
        schema: 'Schema',
        example: {
            isExample: true
        },
        examples: 'ExamplesMap',
        content: 'MediaTypesMap'
    },
    requiredOneOf: [
        'schema',
        'content'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Responses = {
    properties: {
        default: 'Response'
    },
    additionalProperties: (_v, key)=>$98e4db249f7aeea8$var$responseCodeRegexp.test(key) ? 'Response' : undefined
};
const $98e4db249f7aeea8$var$Response = {
    properties: {
        description: {
            type: 'string'
        },
        headers: 'HeadersMap',
        content: 'MediaTypesMap',
        links: 'LinksMap',
        'x-summary': {
            type: 'string'
        }
    },
    required: [
        'description'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Link = {
    properties: {
        operationRef: {
            type: 'string'
        },
        operationId: {
            type: 'string'
        },
        parameters: null,
        requestBody: null,
        description: {
            type: 'string'
        },
        server: 'Server'
    },
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Schema = {
    properties: {
        externalDocs: 'ExternalDocs',
        discriminator: 'Discriminator',
        title: {
            type: 'string'
        },
        multipleOf: {
            type: 'number',
            minimum: 0
        },
        maximum: {
            type: 'number'
        },
        minimum: {
            type: 'number'
        },
        exclusiveMaximum: {
            type: 'boolean'
        },
        exclusiveMinimum: {
            type: 'boolean'
        },
        maxLength: {
            type: 'integer',
            minimum: 0
        },
        minLength: {
            type: 'integer',
            minimum: 0
        },
        pattern: {
            type: 'string'
        },
        maxItems: {
            type: 'integer',
            minimum: 0
        },
        minItems: {
            type: 'integer',
            minimum: 0
        },
        uniqueItems: {
            type: 'boolean'
        },
        maxProperties: {
            type: 'integer',
            minimum: 0
        },
        minProperties: {
            type: 'integer',
            minimum: 0
        },
        required: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        enum: {
            type: 'array'
        },
        type: {
            enum: [
                'object',
                'array',
                'string',
                'number',
                'integer',
                'boolean'
            ]
        },
        allOf: (0, $hlZ1o.listOf)('Schema'),
        anyOf: (0, $hlZ1o.listOf)('Schema'),
        oneOf: (0, $hlZ1o.listOf)('Schema'),
        not: 'Schema',
        properties: 'SchemaProperties',
        items: (value)=>{
            if (Array.isArray(value)) return (0, $hlZ1o.listOf)('Schema');
            else return 'Schema';
        },
        additionalProperties: (value)=>{
            if (typeof value === 'boolean') return {
                type: 'boolean'
            };
            else return 'Schema';
        },
        description: {
            type: 'string'
        },
        format: {
            type: 'string'
        },
        default: null,
        nullable: {
            type: 'boolean'
        },
        readOnly: {
            type: 'boolean'
        },
        writeOnly: {
            type: 'boolean'
        },
        xml: 'Xml',
        example: {
            isExample: true
        },
        deprecated: {
            type: 'boolean'
        },
        'x-tags': {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        'x-additionalPropertiesName': {
            type: 'string'
        },
        'x-explicitMappingOnly': {
            type: 'boolean'
        }
    },
    extensionsPrefix: 'x-'
};
module.exports.Xml = {
    properties: {
        name: {
            type: 'string'
        },
        namespace: {
            type: 'string'
        },
        prefix: {
            type: 'string'
        },
        attribute: {
            type: 'boolean'
        },
        wrapped: {
            type: 'boolean'
        }
    },
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$SchemaProperties = {
    properties: {},
    additionalProperties: 'Schema'
};
module.exports.DiscriminatorMapping = {
    properties: {},
    additionalProperties: (value)=>{
        if ((0, $3EQkN.isMappingRef)(value)) return {
            type: 'string',
            directResolveAs: 'Schema'
        };
        else return {
            type: 'string'
        };
    }
};
module.exports.Discriminator = {
    properties: {
        propertyName: {
            type: 'string'
        },
        mapping: 'DiscriminatorMapping'
    },
    required: [
        'propertyName'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$Components = {
    properties: {
        parameters: 'NamedParameters',
        schemas: 'NamedSchemas',
        responses: 'NamedResponses',
        examples: 'NamedExamples',
        requestBodies: 'NamedRequestBodies',
        headers: 'NamedHeaders',
        securitySchemes: 'NamedSecuritySchemes',
        links: 'NamedLinks',
        callbacks: 'NamedCallbacks'
    },
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$ImplicitFlow = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        scopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        authorizationUrl: {
            type: 'string'
        }
    },
    required: [
        'authorizationUrl',
        'scopes'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$PasswordFlow = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        scopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        tokenUrl: {
            type: 'string'
        }
    },
    required: [
        'tokenUrl',
        'scopes'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$ClientCredentials = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        scopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        tokenUrl: {
            type: 'string'
        }
    },
    required: [
        'tokenUrl',
        'scopes'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$AuthorizationCode = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        authorizationUrl: {
            type: 'string'
        },
        scopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        tokenUrl: {
            type: 'string'
        },
        'x-usePkce': (value)=>{
            if (typeof value === 'boolean') return {
                type: 'boolean'
            };
            else return 'XUsePkce';
        }
    },
    required: [
        'authorizationUrl',
        'tokenUrl',
        'scopes'
    ],
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$OAuth2Flows = {
    properties: {
        implicit: 'ImplicitFlow',
        password: 'PasswordFlow',
        clientCredentials: 'ClientCredentials',
        authorizationCode: 'AuthorizationCode'
    },
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$SecurityScheme = {
    properties: {
        type: {
            enum: [
                'apiKey',
                'http',
                'oauth2',
                'openIdConnect'
            ]
        },
        description: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        in: {
            type: 'string',
            enum: [
                'query',
                'header',
                'cookie'
            ]
        },
        scheme: {
            type: 'string'
        },
        bearerFormat: {
            type: 'string'
        },
        flows: 'OAuth2Flows',
        openIdConnectUrl: {
            type: 'string'
        },
        'x-defaultClientId': {
            type: 'string'
        }
    },
    required (value) {
        switch(value?.type){
            case 'apiKey':
                return [
                    'type',
                    'name',
                    'in'
                ];
            case 'http':
                return [
                    'type',
                    'scheme'
                ];
            case 'oauth2':
                return [
                    'type',
                    'flows'
                ];
            case 'openIdConnect':
                return [
                    'type',
                    'openIdConnectUrl'
                ];
            default:
                return [
                    'type'
                ];
        }
    },
    allowed (value) {
        switch(value?.type){
            case 'apiKey':
                return [
                    'type',
                    'name',
                    'in',
                    'description'
                ];
            case 'http':
                return [
                    'type',
                    'scheme',
                    'bearerFormat',
                    'description'
                ];
            case 'oauth2':
                return [
                    'type',
                    'flows',
                    'description'
                ];
            case 'openIdConnect':
                return [
                    'type',
                    'openIdConnectUrl',
                    'description'
                ];
            default:
                return [
                    'type',
                    'description'
                ];
        }
    },
    extensionsPrefix: 'x-'
};
const $98e4db249f7aeea8$var$XUsePkce = {
    properties: {
        disableManualConfiguration: {
            type: 'boolean'
        },
        hideClientSecretInput: {
            type: 'boolean'
        }
    }
};
module.exports.Oas3Types = {
    Root: $98e4db249f7aeea8$var$Root,
    Tag: $98e4db249f7aeea8$var$Tag,
    TagList: (0, $hlZ1o.listOf)('Tag'),
    TagGroups: (0, $hlZ1o.listOf)('TagGroup'),
    TagGroup: $98e4db249f7aeea8$var$TagGroup,
    ExternalDocs: module.exports.ExternalDocs,
    Server: $98e4db249f7aeea8$var$Server,
    ServerList: (0, $hlZ1o.listOf)('Server'),
    ServerVariable: $98e4db249f7aeea8$var$ServerVariable,
    ServerVariablesMap: (0, $hlZ1o.mapOf)('ServerVariable'),
    SecurityRequirement: $98e4db249f7aeea8$var$SecurityRequirement,
    SecurityRequirementList: (0, $hlZ1o.listOf)('SecurityRequirement'),
    Info: $98e4db249f7aeea8$var$Info,
    Contact: $98e4db249f7aeea8$var$Contact,
    License: $98e4db249f7aeea8$var$License,
    Paths: $98e4db249f7aeea8$var$Paths,
    PathItem: $98e4db249f7aeea8$var$PathItem,
    Parameter: $98e4db249f7aeea8$var$Parameter,
    ParameterList: (0, $hlZ1o.listOf)('Parameter'),
    Operation: $98e4db249f7aeea8$var$Operation,
    Callback: (0, $hlZ1o.mapOf)('PathItem'),
    CallbacksMap: (0, $hlZ1o.mapOf)('Callback'),
    RequestBody: $98e4db249f7aeea8$var$RequestBody,
    MediaTypesMap: $98e4db249f7aeea8$var$MediaTypesMap,
    MediaType: $98e4db249f7aeea8$var$MediaType,
    Example: $98e4db249f7aeea8$var$Example,
    ExamplesMap: (0, $hlZ1o.mapOf)('Example'),
    Encoding: $98e4db249f7aeea8$var$Encoding,
    EncodingMap: (0, $hlZ1o.mapOf)('Encoding'),
    EnumDescriptions: $98e4db249f7aeea8$var$EnumDescriptions,
    Header: $98e4db249f7aeea8$var$Header,
    HeadersMap: (0, $hlZ1o.mapOf)('Header'),
    Responses: $98e4db249f7aeea8$var$Responses,
    Response: $98e4db249f7aeea8$var$Response,
    Link: $98e4db249f7aeea8$var$Link,
    Logo: $98e4db249f7aeea8$var$Logo,
    Schema: $98e4db249f7aeea8$var$Schema,
    Xml: module.exports.Xml,
    SchemaProperties: $98e4db249f7aeea8$var$SchemaProperties,
    DiscriminatorMapping: module.exports.DiscriminatorMapping,
    Discriminator: module.exports.Discriminator,
    Components: $98e4db249f7aeea8$var$Components,
    LinksMap: (0, $hlZ1o.mapOf)('Link'),
    NamedSchemas: (0, $hlZ1o.mapOf)('Schema'),
    NamedResponses: (0, $hlZ1o.mapOf)('Response'),
    NamedParameters: (0, $hlZ1o.mapOf)('Parameter'),
    NamedExamples: (0, $hlZ1o.mapOf)('Example'),
    NamedRequestBodies: (0, $hlZ1o.mapOf)('RequestBody'),
    NamedHeaders: (0, $hlZ1o.mapOf)('Header'),
    NamedSecuritySchemes: (0, $hlZ1o.mapOf)('SecurityScheme'),
    NamedLinks: (0, $hlZ1o.mapOf)('Link'),
    NamedCallbacks: (0, $hlZ1o.mapOf)('Callback'),
    ImplicitFlow: $98e4db249f7aeea8$var$ImplicitFlow,
    PasswordFlow: $98e4db249f7aeea8$var$PasswordFlow,
    ClientCredentials: $98e4db249f7aeea8$var$ClientCredentials,
    AuthorizationCode: $98e4db249f7aeea8$var$AuthorizationCode,
    OAuth2Flows: $98e4db249f7aeea8$var$OAuth2Flows,
    SecurityScheme: $98e4db249f7aeea8$var$SecurityScheme,
    XCodeSample: $98e4db249f7aeea8$var$XCodeSample,
    XCodeSampleList: (0, $hlZ1o.listOf)('XCodeSample'),
    XUsePkce: $98e4db249f7aeea8$var$XUsePkce,
    WebhooksMap: $98e4db249f7aeea8$var$WebhooksMap
};

});

parcelRegister("juqjK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Oas3_1Types = module.exports.DependentRequired = module.exports.SchemaProperties = module.exports.Schema = void 0;

var $hlZ1o = parcelRequire("hlZ1o");

var $d7QLh = parcelRequire("d7QLh");
const $e3053bca1b063045$var$Root = {
    properties: {
        openapi: null,
        info: 'Info',
        servers: 'ServerList',
        security: 'SecurityRequirementList',
        tags: 'TagList',
        externalDocs: 'ExternalDocs',
        paths: 'Paths',
        webhooks: 'WebhooksMap',
        components: 'Components',
        jsonSchemaDialect: {
            type: 'string'
        }
    },
    required: [
        'openapi',
        'info'
    ],
    requiredOneOf: [
        'paths',
        'components',
        'webhooks'
    ],
    extensionsPrefix: 'x-'
};
const $e3053bca1b063045$var$License = {
    properties: {
        name: {
            type: 'string'
        },
        url: {
            type: 'string'
        },
        identifier: {
            type: 'string'
        }
    },
    required: [
        'name'
    ],
    extensionsPrefix: 'x-'
};
const $e3053bca1b063045$var$Info = {
    properties: {
        title: {
            type: 'string'
        },
        version: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        termsOfService: {
            type: 'string'
        },
        summary: {
            type: 'string'
        },
        contact: 'Contact',
        license: 'License',
        'x-logo': 'Logo'
    },
    required: [
        'title',
        'version'
    ],
    extensionsPrefix: 'x-'
};
const $e3053bca1b063045$var$Components = {
    properties: {
        parameters: 'NamedParameters',
        schemas: 'NamedSchemas',
        responses: 'NamedResponses',
        examples: 'NamedExamples',
        requestBodies: 'NamedRequestBodies',
        headers: 'NamedHeaders',
        securitySchemes: 'NamedSecuritySchemes',
        links: 'NamedLinks',
        callbacks: 'NamedCallbacks',
        pathItems: 'NamedPathItems'
    },
    extensionsPrefix: 'x-'
};
const $e3053bca1b063045$var$Operation = {
    properties: {
        tags: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalDocs: 'ExternalDocs',
        operationId: {
            type: 'string'
        },
        parameters: 'ParameterList',
        security: 'SecurityRequirementList',
        servers: 'ServerList',
        requestBody: 'RequestBody',
        responses: 'Responses',
        deprecated: {
            type: 'boolean'
        },
        callbacks: 'CallbacksMap',
        'x-codeSamples': 'XCodeSampleList',
        'x-code-samples': 'XCodeSampleList',
        'x-hideTryItPanel': {
            type: 'boolean'
        }
    },
    extensionsPrefix: 'x-'
};
module.exports.Schema = {
    properties: {
        $id: {
            type: 'string'
        },
        $anchor: {
            type: 'string'
        },
        id: {
            type: 'string'
        },
        $schema: {
            type: 'string'
        },
        definitions: 'NamedSchemas',
        $defs: 'NamedSchemas',
        $vocabulary: {
            type: 'string'
        },
        externalDocs: 'ExternalDocs',
        discriminator: 'Discriminator',
        title: {
            type: 'string'
        },
        multipleOf: {
            type: 'number',
            minimum: 0
        },
        maximum: {
            type: 'number'
        },
        minimum: {
            type: 'number'
        },
        exclusiveMaximum: {
            type: 'number'
        },
        exclusiveMinimum: {
            type: 'number'
        },
        maxLength: {
            type: 'integer',
            minimum: 0
        },
        minLength: {
            type: 'integer',
            minimum: 0
        },
        pattern: {
            type: 'string'
        },
        maxItems: {
            type: 'integer',
            minimum: 0
        },
        minItems: {
            type: 'integer',
            minimum: 0
        },
        uniqueItems: {
            type: 'boolean'
        },
        maxProperties: {
            type: 'integer',
            minimum: 0
        },
        minProperties: {
            type: 'integer',
            minimum: 0
        },
        required: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        enum: {
            type: 'array'
        },
        type: (value)=>{
            if (Array.isArray(value)) return {
                type: 'array',
                items: {
                    enum: [
                        'object',
                        'array',
                        'string',
                        'number',
                        'integer',
                        'boolean',
                        'null'
                    ]
                }
            };
            else return {
                enum: [
                    'object',
                    'array',
                    'string',
                    'number',
                    'integer',
                    'boolean',
                    'null'
                ]
            };
        },
        allOf: (0, $hlZ1o.listOf)('Schema'),
        anyOf: (0, $hlZ1o.listOf)('Schema'),
        oneOf: (0, $hlZ1o.listOf)('Schema'),
        not: 'Schema',
        if: 'Schema',
        then: 'Schema',
        else: 'Schema',
        dependentSchemas: (0, $hlZ1o.mapOf)('Schema'),
        dependentRequired: 'DependentRequired',
        prefixItems: (0, $hlZ1o.listOf)('Schema'),
        contains: 'Schema',
        minContains: {
            type: 'integer',
            minimum: 0
        },
        maxContains: {
            type: 'integer',
            minimum: 0
        },
        patternProperties: 'PatternProperties',
        propertyNames: 'Schema',
        unevaluatedItems: (value)=>{
            if (typeof value === 'boolean') return {
                type: 'boolean'
            };
            else return 'Schema';
        },
        unevaluatedProperties: (value)=>{
            if (typeof value === 'boolean') return {
                type: 'boolean'
            };
            else return 'Schema';
        },
        summary: {
            type: 'string'
        },
        properties: 'SchemaProperties',
        items: (value)=>{
            if (typeof value === 'boolean') return {
                type: 'boolean'
            };
            else return 'Schema';
        },
        additionalProperties: (value)=>{
            return typeof value === 'boolean' ? {
                type: 'boolean'
            } : 'Schema';
        },
        description: {
            type: 'string'
        },
        format: {
            type: 'string'
        },
        contentEncoding: {
            type: 'string'
        },
        contentMediaType: {
            type: 'string'
        },
        contentSchema: 'Schema',
        default: null,
        readOnly: {
            type: 'boolean'
        },
        writeOnly: {
            type: 'boolean'
        },
        xml: 'Xml',
        examples: {
            type: 'array'
        },
        example: {
            isExample: true
        },
        deprecated: {
            type: 'boolean'
        },
        const: null,
        $comment: {
            type: 'string'
        },
        'x-tags': {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        $dynamicAnchor: {
            type: 'string'
        },
        $dynamicRef: {
            type: 'string'
        }
    },
    extensionsPrefix: 'x-'
};
module.exports.SchemaProperties = {
    properties: {},
    additionalProperties: (value)=>{
        if (typeof value === 'boolean') return {
            type: 'boolean'
        };
        else return 'Schema';
    }
};
const $e3053bca1b063045$var$SecurityScheme = {
    properties: {
        type: {
            enum: [
                'apiKey',
                'http',
                'oauth2',
                'openIdConnect',
                'mutualTLS'
            ]
        },
        description: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        in: {
            type: 'string',
            enum: [
                'query',
                'header',
                'cookie'
            ]
        },
        scheme: {
            type: 'string'
        },
        bearerFormat: {
            type: 'string'
        },
        flows: 'OAuth2Flows',
        openIdConnectUrl: {
            type: 'string'
        }
    },
    required (value) {
        switch(value?.type){
            case 'apiKey':
                return [
                    'type',
                    'name',
                    'in'
                ];
            case 'http':
                return [
                    'type',
                    'scheme'
                ];
            case 'oauth2':
                return [
                    'type',
                    'flows'
                ];
            case 'openIdConnect':
                return [
                    'type',
                    'openIdConnectUrl'
                ];
            default:
                return [
                    'type'
                ];
        }
    },
    allowed (value) {
        switch(value?.type){
            case 'apiKey':
                return [
                    'type',
                    'name',
                    'in',
                    'description'
                ];
            case 'http':
                return [
                    'type',
                    'scheme',
                    'bearerFormat',
                    'description'
                ];
            case 'oauth2':
                switch(value?.flows){
                    case 'implicit':
                        return [
                            'type',
                            'flows',
                            'authorizationUrl',
                            'refreshUrl',
                            'description',
                            'scopes'
                        ];
                    case 'password':
                    case 'clientCredentials':
                        return [
                            'type',
                            'flows',
                            'tokenUrl',
                            'refreshUrl',
                            'description',
                            'scopes'
                        ];
                    case 'authorizationCode':
                        return [
                            'type',
                            'flows',
                            'authorizationUrl',
                            'refreshUrl',
                            'tokenUrl',
                            'description',
                            'scopes'
                        ];
                    default:
                        return [
                            'type',
                            'flows',
                            'authorizationUrl',
                            'refreshUrl',
                            'tokenUrl',
                            'description',
                            'scopes'
                        ];
                }
            case 'openIdConnect':
                return [
                    'type',
                    'openIdConnectUrl',
                    'description'
                ];
            case 'mutualTLS':
                return [
                    'type',
                    'description'
                ];
            default:
                return [
                    'type',
                    'description'
                ];
        }
    },
    extensionsPrefix: 'x-'
};
module.exports.DependentRequired = {
    properties: {},
    additionalProperties: {
        type: 'array',
        items: {
            type: 'string'
        }
    }
};
module.exports.Oas3_1Types = {
    ...$d7QLh.Oas3Types,
    Info: $e3053bca1b063045$var$Info,
    Root: $e3053bca1b063045$var$Root,
    Schema: module.exports.Schema,
    SchemaProperties: module.exports.SchemaProperties,
    PatternProperties: module.exports.SchemaProperties,
    License: $e3053bca1b063045$var$License,
    Components: $e3053bca1b063045$var$Components,
    NamedPathItems: (0, $hlZ1o.mapOf)('PathItem'),
    SecurityScheme: $e3053bca1b063045$var$SecurityScheme,
    Operation: $e3053bca1b063045$var$Operation,
    DependentRequired: module.exports.DependentRequired
};

});

parcelRegister("aBdFo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AsyncApi2Types = module.exports.AsyncApi2Bindings = module.exports.Dependencies = module.exports.SecuritySchemeFlows = module.exports.Discriminator = module.exports.DiscriminatorMapping = module.exports.SchemaProperties = module.exports.Schema = module.exports.MessageExample = module.exports.CorrelationId = module.exports.License = module.exports.Contact = module.exports.ServerVariable = module.exports.ServerMap = module.exports.ExternalDocs = module.exports.Tag = void 0;

var $hlZ1o = parcelRequire("hlZ1o");

var $3EQkN = parcelRequire("3EQkN");
const $7b77f604788f50a9$var$Root = {
    properties: {
        asyncapi: null,
        info: 'Info',
        id: {
            type: 'string'
        },
        servers: 'ServerMap',
        channels: 'ChannelMap',
        components: 'Components',
        tags: 'TagList',
        externalDocs: 'ExternalDocs',
        defaultContentType: {
            type: 'string'
        }
    },
    required: [
        'asyncapi',
        'channels',
        'info'
    ]
};
const $7b77f604788f50a9$var$Channel = {
    properties: {
        description: {
            type: 'string'
        },
        subscribe: 'Operation',
        publish: 'Operation',
        parameters: 'ParametersMap',
        bindings: 'ChannelBindings',
        servers: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    }
};
const $7b77f604788f50a9$var$ChannelMap = {
    properties: {},
    additionalProperties: 'Channel'
};
const $7b77f604788f50a9$var$ChannelBindings = {
    properties: {},
    allowed () {
        // allow all supported values, not all have deep linting
        return [
            'http',
            'ws',
            'kafka',
            'anypointmq',
            'amqp',
            'amqp1',
            'mqtt',
            'mqtt5',
            'nats',
            'jms',
            'sns',
            'solace',
            'sqs',
            'stomp',
            'redis',
            'mercure',
            'ibmmq',
            'googlepubsub',
            'pulsar'
        ];
    },
    additionalProperties: {
        type: 'object'
    }
};
module.exports.Tag = {
    properties: {
        name: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalDocs: 'ExternalDocs'
    },
    required: [
        'name'
    ]
};
module.exports.ExternalDocs = {
    properties: {
        description: {
            type: 'string'
        },
        url: {
            type: 'string'
        }
    },
    required: [
        'url'
    ]
};
const $7b77f604788f50a9$var$SecurityRequirement = {
    properties: {},
    additionalProperties: {
        type: 'array',
        items: {
            type: 'string'
        }
    }
};
const $7b77f604788f50a9$var$ServerBindings = {
    properties: {},
    allowed () {
        // allow all supported values, not all have deep linting
        return [
            'http',
            'ws',
            'kafka',
            'anypointmq',
            'amqp',
            'amqp1',
            'mqtt',
            'mqtt5',
            'nats',
            'jms',
            'sns',
            'solace',
            'sqs',
            'stomp',
            'redis',
            'mercure',
            'ibmmq',
            'googlepubsub',
            'pulsar'
        ];
    },
    additionalProperties: {
        type: 'object'
    }
};
const $7b77f604788f50a9$var$Server = {
    properties: {
        url: {
            type: 'string'
        },
        protocol: {
            type: 'string'
        },
        protocolVersion: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        variables: 'ServerVariablesMap',
        security: 'SecurityRequirementList',
        bindings: 'ServerBindings',
        tags: 'TagList'
    },
    required: [
        'url',
        'protocol'
    ]
};
module.exports.ServerMap = {
    properties: {},
    additionalProperties: (_value, key)=>// eslint-disable-next-line no-useless-escape
        key.match(/^[A-Za-z0-9_\-]+$/) ? 'Server' : undefined
};
module.exports.ServerVariable = {
    properties: {
        enum: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        default: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        examples: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: []
};
const $7b77f604788f50a9$var$Info = {
    properties: {
        title: {
            type: 'string'
        },
        version: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        termsOfService: {
            type: 'string'
        },
        contact: 'Contact',
        license: 'License'
    },
    required: [
        'title',
        'version'
    ]
};
module.exports.Contact = {
    properties: {
        name: {
            type: 'string'
        },
        url: {
            type: 'string'
        },
        email: {
            type: 'string'
        }
    }
};
module.exports.License = {
    properties: {
        name: {
            type: 'string'
        },
        url: {
            type: 'string'
        }
    },
    required: [
        'name'
    ]
};
const $7b77f604788f50a9$var$Parameter = {
    properties: {
        description: {
            type: 'string'
        },
        schema: 'Schema',
        location: {
            type: 'string'
        }
    }
};
module.exports.CorrelationId = {
    properties: {
        description: {
            type: 'string'
        },
        location: {
            type: 'string'
        }
    },
    required: [
        'location'
    ]
};
const $7b77f604788f50a9$var$Message = {
    properties: {
        messageId: {
            type: 'string'
        },
        headers: 'Schema',
        payload: 'Schema',
        correlationId: 'CorrelationId',
        schemaFormat: {
            type: 'string'
        },
        contentType: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        tags: 'TagList',
        externalDocs: 'ExternalDocs',
        bindings: 'MessageBindings',
        examples: 'MessageExampleList',
        traits: 'MessageTraitList'
    },
    additionalProperties: {}
};
const $7b77f604788f50a9$var$MessageBindings = {
    properties: {},
    allowed () {
        // allow all supported values, not all have deep linting
        return [
            'http',
            'ws',
            'kafka',
            'anypointmq',
            'amqp',
            'amqp1',
            'mqtt',
            'mqtt5',
            'nats',
            'jms',
            'sns',
            'solace',
            'sqs',
            'stomp',
            'redis',
            'mercure',
            'ibmmq',
            'googlepubsub',
            'pulsar'
        ];
    },
    additionalProperties: {
        type: 'object'
    }
};
const $7b77f604788f50a9$var$OperationBindings = {
    properties: {},
    allowed () {
        // allow all supported values, not all have deep linting
        return [
            'http',
            'ws',
            'kafka',
            'anypointmq',
            'amqp',
            'amqp1',
            'mqtt',
            'mqtt5',
            'nats',
            'jms',
            'sns',
            'solace',
            'sqs',
            'stomp',
            'redis',
            'mercure',
            'ibmmq',
            'googlepubsub',
            'pulsar'
        ];
    },
    additionalProperties: {
        type: 'object'
    }
};
const $7b77f604788f50a9$var$OperationTrait = {
    properties: {
        tags: 'TagList',
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalDocs: 'ExternalDocs',
        operationId: {
            type: 'string'
        },
        security: 'SecurityRequirementList',
        bindings: 'OperationBindings'
    },
    required: []
};
const $7b77f604788f50a9$var$MessageTrait = {
    properties: {
        messageId: {
            type: 'string'
        },
        headers: 'Schema',
        correlationId: 'CorrelationId',
        schemaFormat: {
            type: 'string'
        },
        contentType: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        tags: 'TagList',
        externalDocs: 'ExternalDocs',
        bindings: 'MessageBindings',
        examples: 'MessageExampleList'
    },
    additionalProperties: {}
};
const $7b77f604788f50a9$var$Operation = {
    properties: {
        tags: 'TagList',
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalDocs: 'ExternalDocs',
        operationId: {
            type: 'string'
        },
        security: 'SecurityRequirementList',
        bindings: 'OperationBindings',
        traits: 'OperationTraitList',
        message: 'Message'
    },
    required: []
};
module.exports.MessageExample = {
    properties: {
        payload: {
            isExample: true
        },
        summary: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        headers: {
            type: 'object'
        }
    }
};
module.exports.Schema = {
    properties: {
        $id: {
            type: 'string'
        },
        $schema: {
            type: 'string'
        },
        definitions: 'NamedSchemas',
        externalDocs: 'ExternalDocs',
        discriminator: 'Discriminator',
        myArbitraryKeyword: {
            type: 'boolean'
        },
        title: {
            type: 'string'
        },
        multipleOf: {
            type: 'number',
            minimum: 0
        },
        maximum: {
            type: 'number'
        },
        minimum: {
            type: 'number'
        },
        exclusiveMaximum: {
            type: 'number'
        },
        exclusiveMinimum: {
            type: 'number'
        },
        maxLength: {
            type: 'integer',
            minimum: 0
        },
        minLength: {
            type: 'integer',
            minimum: 0
        },
        pattern: {
            type: 'string'
        },
        maxItems: {
            type: 'integer',
            minimum: 0
        },
        minItems: {
            type: 'integer',
            minimum: 0
        },
        uniqueItems: {
            type: 'boolean'
        },
        maxProperties: {
            type: 'integer',
            minimum: 0
        },
        minProperties: {
            type: 'integer',
            minimum: 0
        },
        required: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        enum: {
            type: 'array'
        },
        type: (value)=>{
            return Array.isArray(value) ? {
                type: 'array',
                items: {
                    enum: [
                        'object',
                        'array',
                        'string',
                        'number',
                        'integer',
                        'boolean',
                        'null'
                    ]
                }
            } : {
                enum: [
                    'object',
                    'array',
                    'string',
                    'number',
                    'integer',
                    'boolean',
                    'null'
                ]
            };
        },
        allOf: (0, $hlZ1o.listOf)('Schema'),
        anyOf: (0, $hlZ1o.listOf)('Schema'),
        oneOf: (0, $hlZ1o.listOf)('Schema'),
        not: 'Schema',
        if: 'Schema',
        then: 'Schema',
        else: 'Schema',
        contains: 'Schema',
        patternProperties: {
            type: 'object'
        },
        propertyNames: 'Schema',
        properties: 'SchemaProperties',
        items: (value)=>{
            return Array.isArray(value) ? (0, $hlZ1o.listOf)('Schema') : 'Schema';
        },
        additionalProperties: (value)=>{
            return typeof value === 'boolean' ? {
                type: 'boolean'
            } : 'Schema';
        },
        description: {
            type: 'string'
        },
        format: {
            type: 'string'
        },
        contentEncoding: {
            type: 'string'
        },
        contentMediaType: {
            type: 'string'
        },
        default: null,
        readOnly: {
            type: 'boolean'
        },
        writeOnly: {
            type: 'boolean'
        },
        examples: {
            type: 'array'
        },
        example: {
            isExample: true
        },
        deprecated: {
            type: 'boolean'
        },
        const: null,
        $comment: {
            type: 'string'
        },
        additionalItems: (value)=>{
            return typeof value === 'boolean' ? {
                type: 'boolean'
            } : 'Schema';
        },
        dependencies: 'Dependencies'
    }
};
module.exports.SchemaProperties = {
    properties: {},
    additionalProperties: (value)=>{
        return typeof value === 'boolean' ? {
            type: 'boolean'
        } : 'Schema';
    }
};
module.exports.DiscriminatorMapping = {
    properties: {},
    additionalProperties: (value)=>{
        if ((0, $3EQkN.isMappingRef)(value)) return {
            type: 'string',
            directResolveAs: 'Schema'
        };
        else return {
            type: 'string'
        };
    }
};
module.exports.Discriminator = {
    properties: {
        propertyName: {
            type: 'string'
        },
        mapping: 'DiscriminatorMapping'
    },
    required: [
        'propertyName'
    ]
};
const $7b77f604788f50a9$var$Components = {
    properties: {
        messages: 'NamedMessages',
        parameters: 'NamedParameters',
        schemas: 'NamedSchemas',
        correlationIds: 'NamedCorrelationIds',
        messageTraits: 'NamedMessageTraits',
        operationTraits: 'NamedOperationTraits',
        securitySchemes: 'NamedSecuritySchemes',
        servers: 'ServerMap',
        serverVariables: 'ServerVariablesMap',
        channels: 'ChannelMap',
        serverBindings: 'ServerBindings',
        channelBindings: 'ChannelBindings',
        operationBindings: 'OperationBindings',
        messageBindings: 'MessageBindings'
    }
};
const $7b77f604788f50a9$var$ImplicitFlow = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        scopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        authorizationUrl: {
            type: 'string'
        }
    },
    required: [
        'authorizationUrl',
        'scopes'
    ]
};
const $7b77f604788f50a9$var$PasswordFlow = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        scopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        tokenUrl: {
            type: 'string'
        }
    },
    required: [
        'tokenUrl',
        'scopes'
    ]
};
const $7b77f604788f50a9$var$ClientCredentials = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        scopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        tokenUrl: {
            type: 'string'
        }
    },
    required: [
        'tokenUrl',
        'scopes'
    ]
};
const $7b77f604788f50a9$var$AuthorizationCode = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        authorizationUrl: {
            type: 'string'
        },
        scopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        tokenUrl: {
            type: 'string'
        }
    },
    required: [
        'authorizationUrl',
        'tokenUrl',
        'scopes'
    ]
};
module.exports.SecuritySchemeFlows = {
    properties: {
        implicit: 'ImplicitFlow',
        password: 'PasswordFlow',
        clientCredentials: 'ClientCredentials',
        authorizationCode: 'AuthorizationCode'
    }
};
const $7b77f604788f50a9$var$SecurityScheme = {
    properties: {
        type: {
            enum: [
                'userPassword',
                'apiKey',
                'X509',
                'symmetricEncryption',
                'asymmetricEncryption',
                'httpApiKey',
                'http',
                'oauth2',
                'openIdConnect',
                'plain',
                'scramSha256',
                'scramSha512',
                'gssapi'
            ]
        },
        description: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        in: {
            type: 'string',
            enum: [
                'query',
                'header',
                'cookie',
                'user',
                'password'
            ]
        },
        scheme: {
            type: 'string'
        },
        bearerFormat: {
            type: 'string'
        },
        flows: 'SecuritySchemeFlows',
        openIdConnectUrl: {
            type: 'string'
        }
    },
    required (value) {
        switch(value?.type){
            case 'apiKey':
                return [
                    'type',
                    'in'
                ];
            case 'httpApiKey':
                return [
                    'type',
                    'name',
                    'in'
                ];
            case 'http':
                return [
                    'type',
                    'scheme'
                ];
            case 'oauth2':
                return [
                    'type',
                    'flows'
                ];
            case 'openIdConnect':
                return [
                    'type',
                    'openIdConnectUrl'
                ];
            default:
                return [
                    'type'
                ];
        }
    },
    allowed (value) {
        switch(value?.type){
            case 'apiKey':
                return [
                    'type',
                    'in',
                    'description'
                ];
            case 'httpApiKey':
                return [
                    'type',
                    'name',
                    'in',
                    'description'
                ];
            case 'http':
                return [
                    'type',
                    'scheme',
                    'bearerFormat',
                    'description'
                ];
            case 'oauth2':
                return [
                    'type',
                    'flows',
                    'description'
                ];
            case 'openIdConnect':
                return [
                    'type',
                    'openIdConnectUrl',
                    'description'
                ];
            default:
                return [
                    'type',
                    'description'
                ];
        }
    },
    extensionsPrefix: 'x-'
};
module.exports.Dependencies = {
    properties: {},
    additionalProperties: (value)=>{
        return Array.isArray(value) ? {
            type: 'array',
            items: {
                type: 'string'
            }
        } : 'Schema';
    }
};
// --- Per-protocol node types
// http
const $7b77f604788f50a9$var$HttpChannelBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ChannelBindings.properties.http = $7b77f604788f50a9$var$HttpChannelBinding;
const $7b77f604788f50a9$var$HttpServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.http = $7b77f604788f50a9$var$HttpServerBinding;
const $7b77f604788f50a9$var$HttpMessageBinding = {
    properties: {
        headers: 'Schema',
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$MessageBindings.properties.http = $7b77f604788f50a9$var$HttpMessageBinding;
const $7b77f604788f50a9$var$HttpOperationBinding = {
    properties: {
        type: {
            type: 'string'
        },
        method: {
            type: 'string',
            enum: [
                'GET',
                'POST',
                'PUT',
                'PATCH',
                'DELETE',
                'HEAD',
                'OPTIONS',
                'CONNECT',
                'TRACE'
            ]
        },
        headers: 'Schema',
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$OperationBindings.properties.http = $7b77f604788f50a9$var$HttpOperationBinding;
// ws
const $7b77f604788f50a9$var$WsChannelBinding = {
    properties: {
        method: {
            type: 'string'
        },
        query: 'Schema',
        headers: 'Schema',
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$ChannelBindings.properties.ws = $7b77f604788f50a9$var$WsChannelBinding;
const $7b77f604788f50a9$var$WsServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.ws = $7b77f604788f50a9$var$WsServerBinding;
const $7b77f604788f50a9$var$WsMessageBinding = {
    properties: {}
};
$7b77f604788f50a9$var$MessageBindings.properties.ws = $7b77f604788f50a9$var$WsMessageBinding;
const $7b77f604788f50a9$var$WsOperationBinding = {
    properties: {}
};
$7b77f604788f50a9$var$OperationBindings.properties.ws = $7b77f604788f50a9$var$WsOperationBinding;
// kafka
const $7b77f604788f50a9$var$KafkaTopicConfiguration = {
    properties: {
        'cleanup.policy': {
            type: 'array',
            items: {
                enum: [
                    'delete',
                    'compact'
                ]
            }
        },
        'retention.ms': {
            type: 'integer'
        },
        'retention.bytes': {
            type: 'integer'
        },
        'delete.retention.ms': {
            type: 'integer'
        },
        'max.message.bytes': {
            type: 'integer'
        }
    }
};
const $7b77f604788f50a9$var$KafkaChannelBinding = {
    properties: {
        topic: {
            type: 'string'
        },
        partitions: {
            type: 'integer'
        },
        replicas: {
            type: 'integer'
        },
        topicConfiguration: 'KafkaTopicConfiguration',
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$ChannelBindings.properties.kafka = $7b77f604788f50a9$var$KafkaChannelBinding;
const $7b77f604788f50a9$var$KafkaServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.kafka = $7b77f604788f50a9$var$KafkaServerBinding;
const $7b77f604788f50a9$var$KafkaMessageBinding = {
    properties: {
        key: 'Schema',
        schemaIdLocation: {
            type: 'string'
        },
        schemaIdPayloadEncoding: {
            type: 'string'
        },
        schemaLookupStrategy: {
            type: 'string'
        },
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$MessageBindings.properties.kafka = $7b77f604788f50a9$var$KafkaMessageBinding;
const $7b77f604788f50a9$var$KafkaOperationBinding = {
    properties: {
        groupId: 'Schema',
        clientId: 'Schema',
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$OperationBindings.properties.kafka = $7b77f604788f50a9$var$KafkaOperationBinding;
// anypointmq
const $7b77f604788f50a9$var$AnypointmqChannelBinding = {
    properties: {
        destination: {
            type: 'string'
        },
        destinationType: {
            type: 'string'
        },
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$ChannelBindings.properties.anypointmq = $7b77f604788f50a9$var$AnypointmqChannelBinding;
const $7b77f604788f50a9$var$AnypointmqServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.anypointmq = $7b77f604788f50a9$var$AnypointmqServerBinding;
const $7b77f604788f50a9$var$AnypointmqMessageBinding = {
    properties: {
        headers: 'Schema',
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$MessageBindings.properties.anypointmq = $7b77f604788f50a9$var$AnypointmqMessageBinding;
const $7b77f604788f50a9$var$AnypointmqOperationBinding = {
    properties: {}
};
$7b77f604788f50a9$var$OperationBindings.properties.anypointmq = $7b77f604788f50a9$var$AnypointmqOperationBinding;
// amqp
const $7b77f604788f50a9$var$AmqpChannelBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ChannelBindings.properties.amqp = $7b77f604788f50a9$var$AmqpChannelBinding;
const $7b77f604788f50a9$var$AmqpServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.amqp = $7b77f604788f50a9$var$AmqpServerBinding;
const $7b77f604788f50a9$var$AmqpMessageBinding = {
    properties: {
        contentEncoding: {
            type: 'string'
        },
        messageType: {
            type: 'string'
        },
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$MessageBindings.properties.amqp = $7b77f604788f50a9$var$AmqpMessageBinding;
const $7b77f604788f50a9$var$AmqpOperationBinding = {
    // TODO: some fields are subscribe only
    properties: {
        expiration: {
            type: 'integer'
        },
        userId: {
            type: 'string'
        },
        cc: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        priority: {
            type: 'integer'
        },
        deliveryMode: {
            type: 'integer'
        },
        mandatory: {
            type: 'boolean'
        },
        bcc: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        replyTo: {
            type: 'string'
        },
        timestamp: {
            type: 'boolean'
        },
        ack: {
            type: 'boolean'
        },
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$OperationBindings.properties.amqp = $7b77f604788f50a9$var$AmqpOperationBinding;
// amqp1
const $7b77f604788f50a9$var$Amqp1ChannelBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ChannelBindings.properties.amqp1 = $7b77f604788f50a9$var$Amqp1ChannelBinding;
const $7b77f604788f50a9$var$Amqp1ServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.amqp1 = $7b77f604788f50a9$var$Amqp1ServerBinding;
const $7b77f604788f50a9$var$Amqp1MessageBinding = {
    properties: {}
};
$7b77f604788f50a9$var$MessageBindings.properties.amqp1 = $7b77f604788f50a9$var$Amqp1MessageBinding;
const $7b77f604788f50a9$var$Amqp1OperationBinding = {
    properties: {}
};
$7b77f604788f50a9$var$OperationBindings.properties.amqp1 = $7b77f604788f50a9$var$Amqp1OperationBinding;
// mqtt
const $7b77f604788f50a9$var$MqttChannelBinding = {
    properties: {
        qos: {
            type: 'integer'
        },
        retain: {
            type: 'boolean'
        },
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$ChannelBindings.properties.mqtt = $7b77f604788f50a9$var$MqttChannelBinding;
const $7b77f604788f50a9$var$MqttServerBindingLastWill = {
    properties: {
        topic: {
            type: 'string'
        },
        qos: {
            type: 'integer'
        },
        message: {
            type: 'string'
        },
        retain: {
            type: 'boolean'
        }
    }
};
const $7b77f604788f50a9$var$MqttServerBinding = {
    properties: {
        clientId: {
            type: 'string'
        },
        cleanSession: {
            type: 'boolean'
        },
        lastWill: 'MqttServerBindingLastWill',
        keepAlive: {
            type: 'integer'
        },
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$ServerBindings.properties.mqtt = $7b77f604788f50a9$var$MqttServerBinding;
const $7b77f604788f50a9$var$MqttMessageBinding = {
    properties: {
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$MessageBindings.properties.mqtt = $7b77f604788f50a9$var$MqttMessageBinding;
const $7b77f604788f50a9$var$MqttOperationBinding = {
    properties: {
        qos: {
            type: 'integer'
        },
        retain: {
            type: 'boolean'
        },
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$OperationBindings.properties.mqtt = $7b77f604788f50a9$var$MqttOperationBinding;
// mqtt5
const $7b77f604788f50a9$var$Mqtt5ChannelBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ChannelBindings.properties.mqtt5 = $7b77f604788f50a9$var$Mqtt5ChannelBinding;
const $7b77f604788f50a9$var$Mqtt5ServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.mqtt5 = $7b77f604788f50a9$var$Mqtt5ServerBinding;
const $7b77f604788f50a9$var$Mqtt5MessageBinding = {
    properties: {}
};
$7b77f604788f50a9$var$MessageBindings.properties.mqtt5 = $7b77f604788f50a9$var$Mqtt5MessageBinding;
const $7b77f604788f50a9$var$Mqtt5OperationBinding = {
    properties: {}
};
$7b77f604788f50a9$var$OperationBindings.properties.mqtt5 = $7b77f604788f50a9$var$Mqtt5OperationBinding;
// nats
const $7b77f604788f50a9$var$NatsChannelBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ChannelBindings.properties.nats = $7b77f604788f50a9$var$NatsChannelBinding;
const $7b77f604788f50a9$var$NatsServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.nats = $7b77f604788f50a9$var$NatsServerBinding;
const $7b77f604788f50a9$var$NatsMessageBinding = {
    properties: {}
};
$7b77f604788f50a9$var$MessageBindings.properties.nats = $7b77f604788f50a9$var$NatsMessageBinding;
const $7b77f604788f50a9$var$NatsOperationBinding = {
    properties: {
        queue: {
            type: 'string'
        },
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$OperationBindings.properties.nats = $7b77f604788f50a9$var$NatsOperationBinding;
// jms
const $7b77f604788f50a9$var$JmsChannelBinding = {
    properties: {
        destination: {
            type: 'string'
        },
        destinationType: {
            type: 'string'
        },
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$ChannelBindings.properties.jms = $7b77f604788f50a9$var$JmsChannelBinding;
const $7b77f604788f50a9$var$JmsServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.jms = $7b77f604788f50a9$var$JmsServerBinding;
const $7b77f604788f50a9$var$JmsMessageBinding = {
    properties: {
        headers: 'Schema',
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$MessageBindings.properties.jms = $7b77f604788f50a9$var$JmsMessageBinding;
const $7b77f604788f50a9$var$JmsOperationBinding = {
    properties: {
        headers: 'Schema',
        bindingVersion: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$OperationBindings.properties.jms = $7b77f604788f50a9$var$JmsOperationBinding;
// sns
// solace
const $7b77f604788f50a9$var$SolaceChannelBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ChannelBindings.properties.solace = $7b77f604788f50a9$var$SolaceChannelBinding;
const $7b77f604788f50a9$var$SolaceServerBinding = {
    properties: {
        bindingVersion: {
            type: 'string'
        },
        msgVpn: {
            type: 'string'
        }
    }
};
$7b77f604788f50a9$var$ServerBindings.properties.solace = $7b77f604788f50a9$var$SolaceServerBinding;
const $7b77f604788f50a9$var$SolaceMessageBinding = {
    properties: {}
};
$7b77f604788f50a9$var$MessageBindings.properties.solace = $7b77f604788f50a9$var$SolaceMessageBinding;
const $7b77f604788f50a9$var$SolaceDestination = {
    properties: {
        destinationType: {
            type: 'string',
            enum: [
                'queue',
                'topic'
            ]
        },
        deliveryMode: {
            type: 'string',
            enum: [
                'direct',
                'persistent'
            ]
        },
        'queue.name': {
            type: 'string'
        },
        'queue.topicSubscriptions': {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        'queue.accessType': {
            type: 'string',
            enum: [
                'exclusive',
                'nonexclusive'
            ]
        },
        'queue.maxMsgSpoolSize': {
            type: 'string'
        },
        'queue.maxTtl': {
            type: 'string'
        },
        'topic.topicSubscriptions': {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    }
};
const $7b77f604788f50a9$var$SolaceOperationBinding = {
    properties: {
        bindingVersion: {
            type: 'string'
        },
        destinations: (0, $hlZ1o.listOf)('SolaceDestination')
    }
};
$7b77f604788f50a9$var$OperationBindings.properties.solace = $7b77f604788f50a9$var$SolaceOperationBinding;
// sqs
// stomp
const $7b77f604788f50a9$var$StompChannelBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ChannelBindings.properties.stomp = $7b77f604788f50a9$var$StompChannelBinding;
const $7b77f604788f50a9$var$StompServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.stomp = $7b77f604788f50a9$var$StompServerBinding;
const $7b77f604788f50a9$var$StompMessageBinding = {
    properties: {}
};
$7b77f604788f50a9$var$MessageBindings.properties.stomp = $7b77f604788f50a9$var$StompMessageBinding;
const $7b77f604788f50a9$var$StompOperationBinding = {
    properties: {}
};
$7b77f604788f50a9$var$OperationBindings.properties.stomp = $7b77f604788f50a9$var$StompOperationBinding;
// redis
const $7b77f604788f50a9$var$RedisChannelBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ChannelBindings.properties.redis = $7b77f604788f50a9$var$RedisChannelBinding;
const $7b77f604788f50a9$var$RedisServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.redis = $7b77f604788f50a9$var$RedisServerBinding;
const $7b77f604788f50a9$var$RedisMessageBinding = {
    properties: {}
};
$7b77f604788f50a9$var$MessageBindings.properties.redis = $7b77f604788f50a9$var$RedisMessageBinding;
const $7b77f604788f50a9$var$RedisOperationBinding = {
    properties: {}
};
$7b77f604788f50a9$var$OperationBindings.properties.redis = $7b77f604788f50a9$var$RedisOperationBinding;
// mercure
const $7b77f604788f50a9$var$MercureChannelBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ChannelBindings.properties.mercure = $7b77f604788f50a9$var$MercureChannelBinding;
const $7b77f604788f50a9$var$MercureServerBinding = {
    properties: {}
};
$7b77f604788f50a9$var$ServerBindings.properties.mercure = $7b77f604788f50a9$var$MercureServerBinding;
const $7b77f604788f50a9$var$MercureMessageBinding = {
    properties: {}
};
$7b77f604788f50a9$var$MessageBindings.properties.mercure = $7b77f604788f50a9$var$MercureMessageBinding;
const $7b77f604788f50a9$var$MercureOperationBinding = {
    properties: {}
};
$7b77f604788f50a9$var$OperationBindings.properties.mercure = $7b77f604788f50a9$var$MercureOperationBinding;
// ibmmq
// googlepubsub
// pulsar
// --- End per-protocol node types
module.exports.AsyncApi2Bindings = {
    HttpServerBinding: $7b77f604788f50a9$var$HttpServerBinding,
    HttpChannelBinding: $7b77f604788f50a9$var$HttpChannelBinding,
    HttpMessageBinding: $7b77f604788f50a9$var$HttpMessageBinding,
    HttpOperationBinding: $7b77f604788f50a9$var$HttpOperationBinding,
    WsServerBinding: $7b77f604788f50a9$var$WsServerBinding,
    WsChannelBinding: $7b77f604788f50a9$var$WsChannelBinding,
    WsMessageBinding: $7b77f604788f50a9$var$WsMessageBinding,
    WsOperationBinding: $7b77f604788f50a9$var$WsOperationBinding,
    KafkaServerBinding: $7b77f604788f50a9$var$KafkaServerBinding,
    KafkaTopicConfiguration: $7b77f604788f50a9$var$KafkaTopicConfiguration,
    KafkaChannelBinding: $7b77f604788f50a9$var$KafkaChannelBinding,
    KafkaMessageBinding: $7b77f604788f50a9$var$KafkaMessageBinding,
    KafkaOperationBinding: $7b77f604788f50a9$var$KafkaOperationBinding,
    AnypointmqServerBinding: $7b77f604788f50a9$var$AnypointmqServerBinding,
    AnypointmqChannelBinding: $7b77f604788f50a9$var$AnypointmqChannelBinding,
    AnypointmqMessageBinding: $7b77f604788f50a9$var$AnypointmqMessageBinding,
    AnypointmqOperationBinding: $7b77f604788f50a9$var$AnypointmqOperationBinding,
    AmqpServerBinding: $7b77f604788f50a9$var$AmqpServerBinding,
    AmqpChannelBinding: $7b77f604788f50a9$var$AmqpChannelBinding,
    AmqpMessageBinding: $7b77f604788f50a9$var$AmqpMessageBinding,
    AmqpOperationBinding: $7b77f604788f50a9$var$AmqpOperationBinding,
    Amqp1ServerBinding: $7b77f604788f50a9$var$Amqp1ServerBinding,
    Amqp1ChannelBinding: $7b77f604788f50a9$var$Amqp1ChannelBinding,
    Amqp1MessageBinding: $7b77f604788f50a9$var$Amqp1MessageBinding,
    Amqp1OperationBinding: $7b77f604788f50a9$var$Amqp1OperationBinding,
    MqttServerBindingLastWill: $7b77f604788f50a9$var$MqttServerBindingLastWill,
    MqttServerBinding: $7b77f604788f50a9$var$MqttServerBinding,
    MqttChannelBinding: $7b77f604788f50a9$var$MqttChannelBinding,
    MqttMessageBinding: $7b77f604788f50a9$var$MqttMessageBinding,
    MqttOperationBinding: $7b77f604788f50a9$var$MqttOperationBinding,
    Mqtt5ServerBinding: $7b77f604788f50a9$var$Mqtt5ServerBinding,
    Mqtt5ChannelBinding: $7b77f604788f50a9$var$Mqtt5ChannelBinding,
    Mqtt5MessageBinding: $7b77f604788f50a9$var$Mqtt5MessageBinding,
    Mqtt5OperationBinding: $7b77f604788f50a9$var$Mqtt5OperationBinding,
    NatsServerBinding: $7b77f604788f50a9$var$NatsServerBinding,
    NatsChannelBinding: $7b77f604788f50a9$var$NatsChannelBinding,
    NatsMessageBinding: $7b77f604788f50a9$var$NatsMessageBinding,
    NatsOperationBinding: $7b77f604788f50a9$var$NatsOperationBinding,
    JmsServerBinding: $7b77f604788f50a9$var$JmsServerBinding,
    JmsChannelBinding: $7b77f604788f50a9$var$JmsChannelBinding,
    JmsMessageBinding: $7b77f604788f50a9$var$JmsMessageBinding,
    JmsOperationBinding: $7b77f604788f50a9$var$JmsOperationBinding,
    SolaceServerBinding: $7b77f604788f50a9$var$SolaceServerBinding,
    SolaceChannelBinding: $7b77f604788f50a9$var$SolaceChannelBinding,
    SolaceMessageBinding: $7b77f604788f50a9$var$SolaceMessageBinding,
    SolaceDestination: $7b77f604788f50a9$var$SolaceDestination,
    SolaceOperationBinding: $7b77f604788f50a9$var$SolaceOperationBinding,
    StompServerBinding: $7b77f604788f50a9$var$StompServerBinding,
    StompChannelBinding: $7b77f604788f50a9$var$StompChannelBinding,
    StompMessageBinding: $7b77f604788f50a9$var$StompMessageBinding,
    StompOperationBinding: $7b77f604788f50a9$var$StompOperationBinding,
    RedisServerBinding: $7b77f604788f50a9$var$RedisServerBinding,
    RedisChannelBinding: $7b77f604788f50a9$var$RedisChannelBinding,
    RedisMessageBinding: $7b77f604788f50a9$var$RedisMessageBinding,
    RedisOperationBinding: $7b77f604788f50a9$var$RedisOperationBinding,
    MercureServerBinding: $7b77f604788f50a9$var$MercureServerBinding,
    MercureChannelBinding: $7b77f604788f50a9$var$MercureChannelBinding,
    MercureMessageBinding: $7b77f604788f50a9$var$MercureMessageBinding,
    MercureOperationBinding: $7b77f604788f50a9$var$MercureOperationBinding,
    ServerBindings: $7b77f604788f50a9$var$ServerBindings,
    ChannelBindings: $7b77f604788f50a9$var$ChannelBindings,
    MessageBindings: $7b77f604788f50a9$var$MessageBindings,
    OperationBindings: $7b77f604788f50a9$var$OperationBindings
};
module.exports.AsyncApi2Types = {
    ...module.exports.AsyncApi2Bindings,
    Root: $7b77f604788f50a9$var$Root,
    Tag: module.exports.Tag,
    TagList: (0, $hlZ1o.listOf)('Tag'),
    ServerMap: module.exports.ServerMap,
    ExternalDocs: module.exports.ExternalDocs,
    Server: $7b77f604788f50a9$var$Server,
    ServerVariable: module.exports.ServerVariable,
    ServerVariablesMap: (0, $hlZ1o.mapOf)('ServerVariable'),
    SecurityRequirement: $7b77f604788f50a9$var$SecurityRequirement,
    SecurityRequirementList: (0, $hlZ1o.listOf)('SecurityRequirement'),
    Info: $7b77f604788f50a9$var$Info,
    Contact: module.exports.Contact,
    License: module.exports.License,
    ChannelMap: $7b77f604788f50a9$var$ChannelMap,
    Channel: $7b77f604788f50a9$var$Channel,
    Parameter: $7b77f604788f50a9$var$Parameter,
    ParametersMap: (0, $hlZ1o.mapOf)('Parameter'),
    Operation: $7b77f604788f50a9$var$Operation,
    Schema: module.exports.Schema,
    MessageExample: module.exports.MessageExample,
    SchemaProperties: module.exports.SchemaProperties,
    DiscriminatorMapping: module.exports.DiscriminatorMapping,
    Discriminator: module.exports.Discriminator,
    Components: $7b77f604788f50a9$var$Components,
    NamedSchemas: (0, $hlZ1o.mapOf)('Schema'),
    NamedMessages: (0, $hlZ1o.mapOf)('Message'),
    NamedMessageTraits: (0, $hlZ1o.mapOf)('MessageTrait'),
    NamedOperationTraits: (0, $hlZ1o.mapOf)('OperationTrait'),
    NamedParameters: (0, $hlZ1o.mapOf)('Parameter'),
    NamedSecuritySchemes: (0, $hlZ1o.mapOf)('SecurityScheme'),
    NamedCorrelationIds: (0, $hlZ1o.mapOf)('CorrelationId'),
    ImplicitFlow: $7b77f604788f50a9$var$ImplicitFlow,
    PasswordFlow: $7b77f604788f50a9$var$PasswordFlow,
    ClientCredentials: $7b77f604788f50a9$var$ClientCredentials,
    AuthorizationCode: $7b77f604788f50a9$var$AuthorizationCode,
    SecuritySchemeFlows: module.exports.SecuritySchemeFlows,
    SecurityScheme: $7b77f604788f50a9$var$SecurityScheme,
    Message: $7b77f604788f50a9$var$Message,
    MessageBindings: $7b77f604788f50a9$var$MessageBindings,
    OperationBindings: $7b77f604788f50a9$var$OperationBindings,
    OperationTrait: $7b77f604788f50a9$var$OperationTrait,
    OperationTraitList: (0, $hlZ1o.listOf)('OperationTrait'),
    MessageTrait: $7b77f604788f50a9$var$MessageTrait,
    MessageTraitList: (0, $hlZ1o.listOf)('MessageTrait'),
    MessageExampleList: (0, $hlZ1o.listOf)('MessageExample'),
    CorrelationId: module.exports.CorrelationId,
    Dependencies: module.exports.Dependencies
};

});

parcelRegister("1SNrj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AsyncApi3Types = void 0;

var $hlZ1o = parcelRequire("hlZ1o");

var $aBdFo = parcelRequire("aBdFo");
const $15f12f46465ef895$var$Root = {
    properties: {
        asyncapi: {
            type: 'string',
            enum: [
                '3.0.0'
            ]
        },
        info: 'Info',
        id: {
            type: 'string'
        },
        servers: 'ServerMap',
        channels: 'NamedChannels',
        components: 'Components',
        operations: 'NamedOperations',
        defaultContentType: {
            type: 'string'
        }
    },
    required: [
        'asyncapi',
        'info'
    ]
};
const $15f12f46465ef895$var$Channel = {
    properties: {
        address: {
            type: 'string'
        },
        messages: 'NamedMessages',
        title: {
            type: 'string'
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        servers: 'ServerList',
        parameters: 'ParametersMap',
        bindings: 'ChannelBindings',
        tags: 'TagList',
        externalDocs: 'ExternalDocs'
    }
};
const $15f12f46465ef895$var$Server = {
    properties: {
        host: {
            type: 'string'
        },
        pathname: {
            type: 'string'
        },
        protocol: {
            type: 'string'
        },
        protocolVersion: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        variables: 'ServerVariablesMap',
        security: 'SecuritySchemeList',
        bindings: 'ServerBindings',
        externalDocs: 'ExternalDocs',
        tags: 'TagList'
    },
    required: [
        'host',
        'protocol'
    ]
};
const $15f12f46465ef895$var$Info = {
    properties: {
        title: {
            type: 'string'
        },
        version: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        termsOfService: {
            type: 'string'
        },
        contact: 'Contact',
        license: 'License',
        tags: 'TagList',
        externalDocs: 'ExternalDocs'
    },
    required: [
        'title',
        'version'
    ]
};
const $15f12f46465ef895$var$Parameter = {
    properties: {
        description: {
            type: 'string'
        },
        enum: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        default: {
            type: 'string'
        },
        examples: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        location: {
            type: 'string'
        }
    }
};
const $15f12f46465ef895$var$Message = {
    properties: {
        headers: 'Schema',
        payload: (value)=>{
            if (!!value && value?.['schemaFormat']) return {
                properties: {
                    schema: 'Schema',
                    schemaFormat: {
                        type: 'string'
                    }
                },
                required: [
                    'schema',
                    'schemaFormat'
                ]
            };
            else return 'Schema';
        },
        correlationId: 'CorrelationId',
        contentType: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        tags: 'TagList',
        externalDocs: 'ExternalDocs',
        bindings: 'MessageBindings',
        examples: 'MessageExampleList',
        traits: 'MessageTraitList'
    },
    additionalProperties: {}
};
const $15f12f46465ef895$var$OperationTrait = {
    properties: {
        tags: 'TagList',
        title: {
            type: 'string'
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalDocs: 'ExternalDocs',
        security: 'SecuritySchemeList',
        bindings: 'OperationBindings'
    },
    required: []
};
const $15f12f46465ef895$var$MessageTrait = {
    properties: {
        headers: (value)=>{
            if (typeof value === 'function' || typeof value === 'object' && !!value) return {
                properties: {
                    schema: 'Schema',
                    schemaFormat: {
                        type: 'string'
                    }
                }
            };
            else return 'Schema';
        },
        correlationId: 'CorrelationId',
        contentType: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        title: {
            type: 'string'
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        tags: 'TagList',
        externalDocs: 'ExternalDocs',
        bindings: 'MessageBindings',
        examples: 'MessageExampleList'
    },
    additionalProperties: {}
};
const $15f12f46465ef895$var$Operation = {
    properties: {
        action: {
            type: 'string',
            enum: [
                'send',
                'receive'
            ]
        },
        channel: 'Channel',
        title: {
            type: 'string'
        },
        tags: 'TagList',
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        externalDocs: 'ExternalDocs',
        operationId: {
            type: 'string'
        },
        security: 'SecuritySchemeList',
        bindings: 'OperationBindings',
        traits: 'OperationTraitList',
        messages: 'MessageList',
        reply: 'OperationReply'
    },
    required: [
        'action',
        'channel'
    ]
};
const $15f12f46465ef895$var$OperationReply = {
    properties: {
        channel: 'Channel',
        messages: 'MessageList',
        address: 'OperationReplyAddress'
    }
};
const $15f12f46465ef895$var$OperationReplyAddress = {
    properties: {
        location: {
            type: 'string'
        },
        description: {
            type: 'string'
        }
    },
    required: [
        'location'
    ]
};
const $15f12f46465ef895$var$Components = {
    properties: {
        messages: 'NamedMessages',
        parameters: 'NamedParameters',
        schemas: 'NamedSchemas',
        replies: 'NamedOperationReplies',
        replyAddresses: 'NamedOperationRelyAddresses',
        correlationIds: 'NamedCorrelationIds',
        messageTraits: 'NamedMessageTraits',
        operationTraits: 'NamedOperationTraits',
        tags: 'NamedTags',
        externalDocs: 'NamedExternalDocs',
        securitySchemes: 'NamedSecuritySchemes',
        servers: 'ServerMap',
        serverVariables: 'ServerVariablesMap',
        channels: 'NamedChannels',
        operations: 'NamedOperations',
        serverBindings: 'ServerBindings',
        channelBindings: 'ChannelBindings',
        operationBindings: 'OperationBindings',
        messageBindings: 'MessageBindings'
    }
};
const $15f12f46465ef895$var$ImplicitFlow = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        availableScopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        authorizationUrl: {
            type: 'string'
        }
    },
    required: [
        'authorizationUrl',
        'availableScopes'
    ]
};
const $15f12f46465ef895$var$PasswordFlow = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        availableScopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        tokenUrl: {
            type: 'string'
        }
    },
    required: [
        'tokenUrl',
        'availableScopes'
    ]
};
const $15f12f46465ef895$var$ClientCredentials = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        availableScopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        tokenUrl: {
            type: 'string'
        }
    },
    required: [
        'tokenUrl',
        'availableScopes'
    ]
};
const $15f12f46465ef895$var$AuthorizationCode = {
    properties: {
        refreshUrl: {
            type: 'string'
        },
        authorizationUrl: {
            type: 'string'
        },
        availableScopes: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        tokenUrl: {
            type: 'string'
        }
    },
    required: [
        'authorizationUrl',
        'tokenUrl',
        'availableScopes'
    ]
};
const $15f12f46465ef895$var$SecurityScheme = {
    properties: {
        type: {
            enum: [
                'userPassword',
                'apiKey',
                'X509',
                'symmetricEncryption',
                'asymmetricEncryption',
                'httpApiKey',
                'http',
                'oauth2',
                'openIdConnect',
                'plain',
                'scramSha256',
                'scramSha512',
                'gssapi'
            ]
        },
        description: {
            type: 'string'
        },
        name: {
            type: 'string'
        },
        in: {
            type: 'string',
            enum: [
                'query',
                'header',
                'cookie',
                'user',
                'password'
            ]
        },
        scheme: {
            type: 'string'
        },
        bearerFormat: {
            type: 'string'
        },
        flows: 'SecuritySchemeFlows',
        openIdConnectUrl: {
            type: 'string'
        },
        scopes: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required (value) {
        switch(value?.type){
            case 'apiKey':
                return [
                    'type',
                    'in'
                ];
            case 'httpApiKey':
                return [
                    'type',
                    'name',
                    'in'
                ];
            case 'http':
                return [
                    'type',
                    'scheme'
                ];
            case 'oauth2':
                return [
                    'type',
                    'flows'
                ];
            case 'openIdConnect':
                return [
                    'type',
                    'openIdConnectUrl'
                ];
            default:
                return [
                    'type'
                ];
        }
    },
    allowed (value) {
        switch(value?.type){
            case 'apiKey':
                return [
                    'type',
                    'in',
                    'description'
                ];
            case 'httpApiKey':
                return [
                    'type',
                    'name',
                    'in',
                    'description'
                ];
            case 'http':
                return [
                    'type',
                    'scheme',
                    'bearerFormat',
                    'description'
                ];
            case 'oauth2':
                return [
                    'type',
                    'flows',
                    'description',
                    'scopes'
                ];
            case 'openIdConnect':
                return [
                    'type',
                    'openIdConnectUrl',
                    'description',
                    'scopes'
                ];
            default:
                return [
                    'type',
                    'description'
                ];
        }
    },
    extensionsPrefix: 'x-'
};
module.exports.AsyncApi3Types = {
    // from asyncapi2
    ...$aBdFo.AsyncApi2Bindings,
    CorrelationId: $aBdFo.CorrelationId,
    SecuritySchemeFlows: $aBdFo.SecuritySchemeFlows,
    ServerVariable: $aBdFo.ServerVariable,
    Contact: $aBdFo.Contact,
    License: $aBdFo.License,
    MessageExample: $aBdFo.MessageExample,
    Tag: $aBdFo.Tag,
    Dependencies: $aBdFo.Dependencies,
    Schema: $aBdFo.Schema,
    Discriminator: $aBdFo.Discriminator,
    DiscriminatorMapping: $aBdFo.DiscriminatorMapping,
    SchemaProperties: $aBdFo.SchemaProperties,
    ServerMap: $aBdFo.ServerMap,
    ExternalDocs: $aBdFo.ExternalDocs,
    Root: $15f12f46465ef895$var$Root,
    Channel: $15f12f46465ef895$var$Channel,
    Parameter: $15f12f46465ef895$var$Parameter,
    Info: $15f12f46465ef895$var$Info,
    Server: $15f12f46465ef895$var$Server,
    MessageTrait: $15f12f46465ef895$var$MessageTrait,
    Operation: $15f12f46465ef895$var$Operation,
    OperationReply: $15f12f46465ef895$var$OperationReply,
    OperationReplyAddress: $15f12f46465ef895$var$OperationReplyAddress,
    Components: $15f12f46465ef895$var$Components,
    ImplicitFlow: $15f12f46465ef895$var$ImplicitFlow,
    PasswordFlow: $15f12f46465ef895$var$PasswordFlow,
    ClientCredentials: $15f12f46465ef895$var$ClientCredentials,
    AuthorizationCode: $15f12f46465ef895$var$AuthorizationCode,
    SecurityScheme: $15f12f46465ef895$var$SecurityScheme,
    Message: $15f12f46465ef895$var$Message,
    OperationTrait: $15f12f46465ef895$var$OperationTrait,
    ServerVariablesMap: (0, $hlZ1o.mapOf)('ServerVariable'),
    NamedTags: (0, $hlZ1o.mapOf)('Tag'),
    NamedExternalDocs: (0, $hlZ1o.mapOf)('ExternalDocs'),
    NamedChannels: (0, $hlZ1o.mapOf)('Channel'),
    ParametersMap: (0, $hlZ1o.mapOf)('Parameter'),
    NamedOperations: (0, $hlZ1o.mapOf)('Operation'),
    NamedOperationReplies: (0, $hlZ1o.mapOf)('OperationReply'),
    NamedOperationRelyAddresses: (0, $hlZ1o.mapOf)('OperationReplyAddress'),
    NamedSchemas: (0, $hlZ1o.mapOf)('Schema'),
    NamedMessages: (0, $hlZ1o.mapOf)('Message'),
    NamedMessageTraits: (0, $hlZ1o.mapOf)('MessageTrait'),
    NamedOperationTraits: (0, $hlZ1o.mapOf)('OperationTrait'),
    NamedParameters: (0, $hlZ1o.mapOf)('Parameter'),
    NamedSecuritySchemes: (0, $hlZ1o.mapOf)('SecurityScheme'),
    NamedCorrelationIds: (0, $hlZ1o.mapOf)('CorrelationId'),
    ServerList: (0, $hlZ1o.listOf)('Server'),
    SecuritySchemeList: (0, $hlZ1o.listOf)('SecurityScheme'),
    MessageList: (0, $hlZ1o.listOf)('Message'),
    OperationTraitList: (0, $hlZ1o.listOf)('OperationTrait'),
    MessageTraitList: (0, $hlZ1o.listOf)('MessageTrait'),
    MessageExampleList: (0, $hlZ1o.listOf)('MessageExample'),
    TagList: (0, $hlZ1o.listOf)('Tag')
};

});

parcelRegister("7oO5W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Arazzo1Types = void 0;

var $hlZ1o = parcelRequire("hlZ1o");

var $juqjK = parcelRequire("juqjK");

var $d7QLh = parcelRequire("d7QLh");
const $5631a211bb181da1$var$Root = {
    properties: {
        arazzo: {
            type: 'string'
        },
        info: 'Info',
        sourceDescriptions: 'SourceDescriptions',
        workflows: 'Workflows',
        components: 'Components'
    },
    required: [
        'arazzo',
        'info',
        'sourceDescriptions',
        'workflows'
    ],
    extensionsPrefix: 'x-'
};
const $5631a211bb181da1$var$NamedParameters = {
    properties: {},
    additionalProperties: 'Parameter'
};
const $5631a211bb181da1$var$NamedSuccessActions = {
    properties: {},
    additionalProperties: 'SuccessActionObject'
};
const $5631a211bb181da1$var$NamedFailureActions = {
    properties: {},
    additionalProperties: 'FailureActionObject'
};
const $5631a211bb181da1$var$Components = {
    properties: {
        inputs: 'NamedInputs',
        parameters: 'NamedParameters',
        successActions: 'NamedSuccessActions',
        failureActions: 'NamedFailureActions'
    },
    extensionsPrefix: 'x-'
};
const $5631a211bb181da1$var$NamedInputs = (0, $hlZ1o.mapOf)('Schema');
const $5631a211bb181da1$var$Info = {
    properties: {
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        summary: {
            type: 'string'
        },
        version: {
            type: 'string'
        }
    },
    required: [
        'title',
        'version'
    ],
    extensionsPrefix: 'x-'
};
const $5631a211bb181da1$var$SourceDescriptions = {
    properties: {},
    items: (value)=>{
        if (value?.type === 'openapi') return 'OpenAPISourceDescription';
        else return 'ArazzoSourceDescription';
    }
};
const $5631a211bb181da1$var$OpenAPISourceDescription = {
    properties: {
        name: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: [
                'openapi'
            ]
        },
        url: {
            type: 'string'
        },
        'x-serverUrl': {
            type: 'string'
        }
    },
    required: [
        'name',
        'type',
        'url'
    ],
    extensionsPrefix: 'x-'
};
const $5631a211bb181da1$var$ArazzoSourceDescription = {
    properties: {
        name: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: [
                'arazzo'
            ]
        },
        url: {
            type: 'string'
        }
    },
    required: [
        'name',
        'type',
        'url'
    ],
    extensionsPrefix: 'x-'
};
const $5631a211bb181da1$var$ReusableObject = {
    properties: {
        reference: {
            type: 'string'
        },
        value: {}
    },
    required: [
        'reference'
    ],
    extensionsPrefix: 'x-'
};
const $5631a211bb181da1$var$Parameter = {
    properties: {
        in: {
            type: 'string',
            enum: [
                'header',
                'query',
                'path',
                'cookie'
            ]
        },
        name: {
            type: 'string'
        },
        value: {}
    },
    required: [
        'name',
        'value'
    ],
    extensionsPrefix: 'x-'
};
const $5631a211bb181da1$var$Parameters = {
    properties: {},
    items: (value)=>{
        if (value?.reference) return 'ReusableObject';
        else return 'Parameter';
    }
};
const $5631a211bb181da1$var$Workflow = {
    properties: {
        workflowId: {
            type: 'string'
        },
        summary: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        parameters: 'Parameters',
        dependsOn: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        inputs: 'Schema',
        outputs: 'Outputs',
        steps: 'Steps',
        successActions: 'OnSuccessActionList',
        failureActions: 'OnFailureActionList'
    },
    required: [
        'workflowId',
        'steps'
    ],
    extensionsPrefix: 'x-'
};
const $5631a211bb181da1$var$Workflows = (0, $hlZ1o.listOf)('Workflow');
const $5631a211bb181da1$var$Steps = (0, $hlZ1o.listOf)('Step');
const $5631a211bb181da1$var$Step = {
    properties: {
        stepId: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        operationId: {
            type: 'string'
        },
        operationPath: {
            type: 'string'
        },
        workflowId: {
            type: 'string'
        },
        parameters: 'Parameters',
        successCriteria: (0, $hlZ1o.listOf)('CriterionObject'),
        onSuccess: 'OnSuccessActionList',
        onFailure: 'OnFailureActionList',
        outputs: 'Outputs',
        'x-operation': 'ExtendedOperation',
        requestBody: 'RequestBody'
    },
    required: [
        'stepId'
    ],
    requiredOneOf: [
        'x-operation',
        'operationId',
        'operationPath',
        'workflowId'
    ],
    extensionsPrefix: 'x-'
};
const $5631a211bb181da1$var$Outputs = {
    properties: {},
    additionalProperties: {
        type: 'string'
    }
};
const $5631a211bb181da1$var$RequestBody = {
    properties: {
        contentType: {
            type: 'string'
        },
        payload: {},
        replacements: (0, $hlZ1o.listOf)('Replacement')
    },
    required: [
        'payload'
    ],
    extensionsPrefix: 'x-'
};
const $5631a211bb181da1$var$Replacement = {
    properties: {
        target: {
            type: 'string'
        },
        value: {}
    },
    required: [
        'target',
        'value'
    ],
    extensionsPrefix: 'x-'
};
const $5631a211bb181da1$var$ExtendedOperation = {
    properties: {
        url: {
            type: 'string'
        },
        method: {
            enum: [
                'get',
                'post',
                'put',
                'delete',
                'patch',
                'head',
                'options',
                'trace',
                'connect',
                'query',
                'GET',
                'POST',
                'PUT',
                'DELETE',
                'PATCH',
                'OPTIONS',
                'HEAD',
                'TRACE',
                'CONNECT',
                'QUERY'
            ]
        }
    },
    required: [
        'url',
        'method'
    ]
};
const $5631a211bb181da1$var$CriterionObject = {
    properties: {
        condition: {
            type: 'string'
        },
        context: {
            type: 'string'
        },
        type: (value)=>{
            if (!value) return undefined;
            else if (typeof value === 'string') return {
                enum: [
                    'regex',
                    'jsonpath',
                    'simple',
                    'xpath'
                ]
            };
            else if (value?.type === 'jsonpath') return 'JSONPathCriterion';
            else return 'XPathCriterion';
        }
    },
    required: [
        'condition'
    ]
};
const $5631a211bb181da1$var$JSONPathCriterion = {
    properties: {
        type: {
            type: 'string',
            enum: [
                'jsonpath'
            ]
        },
        version: {
            type: 'string',
            enum: [
                'draft-goessner-dispatch-jsonpath-00'
            ]
        }
    }
};
const $5631a211bb181da1$var$XPathCriterion = {
    properties: {
        type: {
            type: 'string',
            enum: [
                'xpath'
            ]
        },
        version: {
            type: 'string',
            enum: [
                'xpath-30',
                'xpath-20',
                'xpath-10'
            ]
        }
    }
};
const $5631a211bb181da1$var$SuccessActionObject = {
    properties: {
        name: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: [
                'goto',
                'end'
            ]
        },
        stepId: {
            type: 'string'
        },
        workflowId: {
            type: 'string'
        },
        criteria: (0, $hlZ1o.listOf)('CriterionObject')
    },
    required: [
        'type',
        'name'
    ]
};
const $5631a211bb181da1$var$OnSuccessActionList = {
    properties: {},
    items: (value)=>{
        if (value?.type && value?.name) return 'SuccessActionObject';
        else return 'ReusableObject';
    }
};
const $5631a211bb181da1$var$FailureActionObject = {
    properties: {
        name: {
            type: 'string'
        },
        type: {
            type: 'string',
            enum: [
                'goto',
                'retry',
                'end'
            ]
        },
        workflowId: {
            type: 'string'
        },
        stepId: {
            type: 'string'
        },
        retryAfter: {
            type: 'number'
        },
        retryLimit: {
            type: 'number'
        },
        criteria: (0, $hlZ1o.listOf)('CriterionObject')
    },
    required: [
        'type',
        'name'
    ]
};
const $5631a211bb181da1$var$OnFailureActionList = {
    properties: {},
    items: (value)=>{
        if (value?.type && value?.name) return 'FailureActionObject';
        else return 'ReusableObject';
    }
};
module.exports.Arazzo1Types = {
    Root: $5631a211bb181da1$var$Root,
    Info: $5631a211bb181da1$var$Info,
    SourceDescriptions: $5631a211bb181da1$var$SourceDescriptions,
    OpenAPISourceDescription: $5631a211bb181da1$var$OpenAPISourceDescription,
    ArazzoSourceDescription: $5631a211bb181da1$var$ArazzoSourceDescription,
    Parameters: $5631a211bb181da1$var$Parameters,
    Parameter: $5631a211bb181da1$var$Parameter,
    ReusableObject: $5631a211bb181da1$var$ReusableObject,
    Workflows: $5631a211bb181da1$var$Workflows,
    Workflow: $5631a211bb181da1$var$Workflow,
    Steps: $5631a211bb181da1$var$Steps,
    Step: $5631a211bb181da1$var$Step,
    RequestBody: $5631a211bb181da1$var$RequestBody,
    Replacement: $5631a211bb181da1$var$Replacement,
    ExtendedOperation: $5631a211bb181da1$var$ExtendedOperation,
    Outputs: $5631a211bb181da1$var$Outputs,
    CriterionObject: $5631a211bb181da1$var$CriterionObject,
    XPathCriterion: $5631a211bb181da1$var$XPathCriterion,
    JSONPathCriterion: $5631a211bb181da1$var$JSONPathCriterion,
    SuccessActionObject: $5631a211bb181da1$var$SuccessActionObject,
    OnSuccessActionList: $5631a211bb181da1$var$OnSuccessActionList,
    FailureActionObject: $5631a211bb181da1$var$FailureActionObject,
    OnFailureActionList: $5631a211bb181da1$var$OnFailureActionList,
    Schema: $juqjK.Schema,
    NamedSchemas: (0, $hlZ1o.mapOf)('Schema'),
    ExternalDocs: $d7QLh.ExternalDocs,
    DiscriminatorMapping: $d7QLh.DiscriminatorMapping,
    Discriminator: $d7QLh.Discriminator,
    DependentRequired: $juqjK.DependentRequired,
    SchemaProperties: $juqjK.SchemaProperties,
    PatternProperties: $juqjK.SchemaProperties,
    Components: $5631a211bb181da1$var$Components,
    NamedInputs: $5631a211bb181da1$var$NamedInputs,
    NamedParameters: $5631a211bb181da1$var$NamedParameters,
    NamedSuccessActions: $5631a211bb181da1$var$NamedSuccessActions,
    NamedFailureActions: $5631a211bb181da1$var$NamedFailureActions,
    Xml: $d7QLh.Xml
};

});

parcelRegister("acgKy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Overlay1Types = void 0;

var $hlZ1o = parcelRequire("hlZ1o");
const $76c8048a434d900d$var$Root = {
    properties: {
        overlay: {
            type: 'string'
        },
        info: 'Info',
        extends: {
            type: 'string'
        },
        actions: 'Actions'
    },
    required: [
        'overlay',
        'info',
        'actions'
    ],
    extensionsPrefix: 'x-'
};
const $76c8048a434d900d$var$Info = {
    properties: {
        title: {
            type: 'string'
        },
        version: {
            type: 'string'
        }
    },
    required: [
        'title',
        'version'
    ],
    extensionsPrefix: 'x-'
};
const $76c8048a434d900d$var$Actions = (0, $hlZ1o.listOf)('Action');
const $76c8048a434d900d$var$Action = {
    properties: {
        target: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        update: {},
        remove: {
            type: 'boolean'
        }
    },
    required: [
        'target'
    ],
    extensionsPrefix: 'x-'
};
module.exports.Overlay1Types = {
    Root: $76c8048a434d900d$var$Root,
    Info: $76c8048a434d900d$var$Info,
    Actions: $76c8048a434d900d$var$Actions,
    Action: $76c8048a434d900d$var$Action
};

});

parcelRegister("NKVWi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ARAZZO_VERSIONS_SUPPORTED_BY_RESPECT = module.exports.VERSION_PATTERN = void 0;
module.exports.VERSION_PATTERN = /^1\.0\.\d+(-.+)?$/;
module.exports.ARAZZO_VERSIONS_SUPPORTED_BY_RESPECT = [
    '1.0.1'
];

});


parcelRegister("6uQoS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initRules = $4bae30fe89a27ca5$var$initRules;

var $eONiY = parcelRequire("eONiY");
function $4bae30fe89a27ca5$var$initRules(rules, config, type, oasVersion) {
    return rules.flatMap((ruleset)=>Object.keys(ruleset).map((ruleId)=>{
            const rule = ruleset[ruleId];
            const ruleSettings = type === 'rules' ? config.getRuleSettings(ruleId, oasVersion) : type === 'preprocessors' ? config.getPreprocessorSettings(ruleId, oasVersion) : config.getDecoratorSettings(ruleId, oasVersion);
            if (ruleSettings.severity === 'off') return undefined;
            const severity = ruleSettings.severity;
            const message = ruleSettings.message;
            const visitors = rule(ruleSettings);
            if (Array.isArray(visitors)) return visitors.map((visitor)=>({
                    severity: severity,
                    ruleId: ruleId,
                    message: message,
                    visitor: visitor
                }));
            return {
                severity: severity,
                message: message,
                ruleId: ruleId,
                visitor: visitors
            };
        })).flatMap((visitor)=>visitor).filter($eONiY.isDefined);
}

});

parcelRegister("26kKc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoUnresolvedRefs = void 0;
module.exports.reportUnresolvedRef = $187c3ba7aa56a1c6$var$reportUnresolvedRef;

var $eWVgr = parcelRequire("eWVgr");
const $187c3ba7aa56a1c6$var$NoUnresolvedRefs = ()=>{
    return {
        ref: {
            leave (_, { report: report, location: location }, resolved) {
                if (resolved.node !== undefined) return;
                $187c3ba7aa56a1c6$var$reportUnresolvedRef(resolved, report, location);
            }
        },
        DiscriminatorMapping (mapping, { report: report, resolve: resolve, location: location }) {
            for (const mappingName of Object.keys(mapping)){
                const resolved = resolve({
                    $ref: mapping[mappingName]
                });
                if (resolved.node !== undefined) return;
                $187c3ba7aa56a1c6$var$reportUnresolvedRef(resolved, report, location.child(mappingName));
            }
        }
    };
};
module.exports.NoUnresolvedRefs = $187c3ba7aa56a1c6$var$NoUnresolvedRefs;
function $187c3ba7aa56a1c6$var$reportUnresolvedRef(resolved, report, location) {
    const error = resolved.error;
    if (error instanceof $eWVgr.YamlParseError) report({
        message: 'Failed to parse: ' + error.message,
        location: {
            source: error.source,
            pointer: undefined,
            start: {
                col: error.col,
                line: error.line
            }
        }
    });
    const message = resolved.error?.message;
    report({
        location: location,
        message: `Can't resolve $ref${message ? ': ' + message : ''}`
    });
}

});

parcelRegister("5c4Gg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AVAILABLE_REGIONS = module.exports.DOMAINS = module.exports.DEFAULT_REGION = void 0;
module.exports.getDomains = $3c81b43855ed59fa$var$getDomains;
module.exports.setRedoclyDomain = $3c81b43855ed59fa$var$setRedoclyDomain;
module.exports.getRedoclyDomain = $3c81b43855ed59fa$var$getRedoclyDomain;
module.exports.isRedoclyRegistryURL = $3c81b43855ed59fa$var$isRedoclyRegistryURL;
let $3c81b43855ed59fa$var$redoclyDomain = 'redocly.com';
module.exports.DEFAULT_REGION = 'us';
module.exports.DOMAINS = $3c81b43855ed59fa$var$getDomains();
module.exports.AVAILABLE_REGIONS = Object.keys(module.exports.DOMAINS);
function $3c81b43855ed59fa$var$getDomains() {
    const domains = {
        us: 'redocly.com',
        eu: 'eu.redocly.com'
    };
    // FIXME: temporary fix for our lab environments
    const domain = $3c81b43855ed59fa$var$redoclyDomain;
    if (domain?.endsWith('.redocly.host')) domains[domain.split('.')[0]] = domain;
    if (domain === 'redoc.online') domains[domain] = domain;
    return domains;
}
function $3c81b43855ed59fa$var$setRedoclyDomain(domain) {
    $3c81b43855ed59fa$var$redoclyDomain = domain;
}
function $3c81b43855ed59fa$var$getRedoclyDomain() {
    return $3c81b43855ed59fa$var$redoclyDomain;
}
function $3c81b43855ed59fa$var$isRedoclyRegistryURL(link) {
    const domain = $3c81b43855ed59fa$var$getRedoclyDomain() || module.exports.DOMAINS[module.exports.DEFAULT_REGION];
    const legacyDomain = domain === 'redocly.com' ? 'redoc.ly' : domain;
    if (!link.startsWith(`https://api.${domain}/registry/`) && !link.startsWith(`https://api.${legacyDomain}/registry/`)) return false;
    return true;
}

});

parcelRegister("9DSmF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RemoveUnusedComponents = void 0;

var $eONiY = parcelRequire("eONiY");
const $7051ed4435e4ec24$var$RemoveUnusedComponents = ()=>{
    const components = new Map();
    function registerComponent(location, componentType, name) {
        components.set(location.absolutePointer, {
            usedIn: components.get(location.absolutePointer)?.usedIn ?? [],
            componentType: componentType,
            name: name
        });
    }
    function removeUnusedComponents(root, removedPaths) {
        const removedLengthStart = removedPaths.length;
        for (const [path, { usedIn: usedIn, name: name, componentType: componentType }] of components){
            const used = usedIn.some((location)=>!removedPaths.some((removed)=>// Check if the current location's absolute pointer starts with the 'removed' path
                    // and either its length matches exactly with 'removed' or the character after the 'removed' path is a '/'
                    location.absolutePointer.startsWith(removed) && (location.absolutePointer.length === removed.length || location.absolutePointer[removed.length] === '/')));
            if (!used && componentType) {
                removedPaths.push(path);
                delete root[componentType][name];
                components.delete(path);
                if ((0, $eONiY.isEmptyObject)(root[componentType])) delete root[componentType];
            }
        }
        return removedPaths.length > removedLengthStart ? removeUnusedComponents(root, removedPaths) : removedPaths.length;
    }
    return {
        ref: {
            leave (ref, { location: location, type: type, resolve: resolve, key: key }) {
                if ([
                    'Schema',
                    'Parameter',
                    'Response',
                    'SecurityScheme'
                ].includes(type.name)) {
                    const resolvedRef = resolve(ref);
                    if (!resolvedRef.location) return;
                    const [fileLocation, localPointer] = resolvedRef.location.absolutePointer.split('#', 2);
                    const componentLevelLocalPointer = localPointer.split('/').slice(0, 3).join('/');
                    const pointer = `${fileLocation}#${componentLevelLocalPointer}`;
                    const registered = components.get(pointer);
                    if (registered) registered.usedIn.push(location);
                    else components.set(pointer, {
                        usedIn: [
                            location
                        ],
                        name: key.toString()
                    });
                }
            }
        },
        Root: {
            leave (root, ctx) {
                const data = ctx.getVisitorData();
                data.removedCount = removeUnusedComponents(root, []);
            }
        },
        NamedSchemas: {
            Schema (schema, { location: location, key: key }) {
                if (!schema.allOf) registerComponent(location, 'definitions', key.toString());
            }
        },
        NamedParameters: {
            Parameter (_parameter, { location: location, key: key }) {
                registerComponent(location, 'parameters', key.toString());
            }
        },
        NamedResponses: {
            Response (_response, { location: location, key: key }) {
                registerComponent(location, 'responses', key.toString());
            }
        },
        NamedSecuritySchemes: {
            SecurityScheme (_securityScheme, { location: location, key: key }) {
                registerComponent(location, 'securityDefinitions', key.toString());
            }
        }
    };
};
module.exports.RemoveUnusedComponents = $7051ed4435e4ec24$var$RemoveUnusedComponents;

});

parcelRegister("gTJQv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RemoveUnusedComponents = void 0;

var $eONiY = parcelRequire("eONiY");
const $c4d5586ec6799d3f$var$RemoveUnusedComponents = ()=>{
    const components = new Map();
    function registerComponent(location, componentType, name) {
        components.set(location.absolutePointer, {
            usedIn: components.get(location.absolutePointer)?.usedIn ?? [],
            componentType: componentType,
            name: name
        });
    }
    function removeUnusedComponents(root, removedPaths) {
        const removedLengthStart = removedPaths.length;
        for (const [path, { usedIn: usedIn, name: name, componentType: componentType }] of components){
            const used = usedIn.some((location)=>!removedPaths.some((removed)=>location.absolutePointer.startsWith(removed) && (location.absolutePointer.length === removed.length || location.absolutePointer[removed.length] === '/')));
            if (!used && componentType && root.components) {
                removedPaths.push(path);
                const componentChild = root.components[componentType];
                delete componentChild[name];
                components.delete(path);
                if ((0, $eONiY.isEmptyObject)(componentChild)) delete root.components[componentType];
            }
        }
        return removedPaths.length > removedLengthStart ? removeUnusedComponents(root, removedPaths) : removedPaths.length;
    }
    return {
        ref: {
            leave (ref, { location: location, type: type, resolve: resolve, key: key }) {
                if ([
                    'Schema',
                    'Header',
                    'Parameter',
                    'Response',
                    'Example',
                    'RequestBody'
                ].includes(type.name)) {
                    const resolvedRef = resolve(ref);
                    if (!resolvedRef.location) return;
                    const [fileLocation, localPointer] = resolvedRef.location.absolutePointer.split('#', 2);
                    const componentLevelLocalPointer = localPointer.split('/').slice(0, 4).join('/');
                    const pointer = `${fileLocation}#${componentLevelLocalPointer}`;
                    const registered = components.get(pointer);
                    if (registered) registered.usedIn.push(location);
                    else components.set(pointer, {
                        usedIn: [
                            location
                        ],
                        name: key.toString()
                    });
                }
            }
        },
        Root: {
            leave (root, ctx) {
                const data = ctx.getVisitorData();
                data.removedCount = removeUnusedComponents(root, []);
                if ((0, $eONiY.isEmptyObject)(root.components)) delete root.components;
            }
        },
        NamedSchemas: {
            Schema (schema, { location: location, key: key }) {
                if (!schema.allOf) registerComponent(location, 'schemas', key.toString());
            }
        },
        NamedParameters: {
            Parameter (_parameter, { location: location, key: key }) {
                registerComponent(location, 'parameters', key.toString());
            }
        },
        NamedResponses: {
            Response (_response, { location: location, key: key }) {
                registerComponent(location, 'responses', key.toString());
            }
        },
        NamedExamples: {
            Example (_example, { location: location, key: key }) {
                registerComponent(location, 'examples', key.toString());
            }
        },
        NamedRequestBodies: {
            RequestBody (_requestBody, { location: location, key: key }) {
                registerComponent(location, 'requestBodies', key.toString());
            }
        },
        NamedHeaders: {
            Header (_header, { location: location, key: key }) {
                registerComponent(location, 'headers', key.toString());
            }
        }
    };
};
module.exports.RemoveUnusedComponents = $c4d5586ec6799d3f$var$RemoveUnusedComponents;

});

parcelRegister("5sK27", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NormalizedConfigTypes = module.exports.ConfigTypes = void 0;
module.exports.createConfigTypes = $3fa3467f6e1cb10b$var$createConfigTypes;
parcelRequire("6AwPe");
var $ldL1o = parcelRequire("ldL1o");

var $hlZ1o = parcelRequire("hlZ1o");

var $aSlQf = parcelRequire("aSlQf");

var $eONiY = parcelRequire("eONiY");

var $7SgPX = parcelRequire("7SgPX");

var $hlZ1o = parcelRequire("hlZ1o");
const $3fa3467f6e1cb10b$var$builtInOAS2Rules = [
    'info-contact',
    'operation-operationId',
    'tag-description',
    'tags-alphabetical',
    'info-license-url',
    'info-license-strict',
    'info-license',
    'no-ambiguous-paths',
    'no-enum-type-mismatch',
    'no-http-verbs-in-paths',
    'no-identical-paths',
    'no-invalid-parameter-examples',
    'no-invalid-schema-examples',
    'no-path-trailing-slash',
    'operation-2xx-response',
    'operation-4xx-response',
    'operation-description',
    'operation-operationId-unique',
    'operation-operationId-url-safe',
    'operation-parameters-unique',
    'operation-singular-tag',
    'operation-summary',
    'operation-tag-defined',
    'parameter-description',
    'path-declaration-must-exist',
    'path-excludes-patterns',
    'path-http-verbs-order',
    'path-not-include-query',
    'path-params-defined',
    'path-parameters-defined',
    'path-segment-plural',
    'paths-kebab-case',
    'required-string-property-missing-min-length',
    'response-contains-header',
    'scalar-property-missing-example',
    'security-defined',
    'spec-strict-refs',
    'no-unresolved-refs',
    'no-required-schema-properties-undefined',
    'no-schema-type-mismatch',
    'boolean-parameter-prefixes',
    'request-mime-type',
    'response-contains-property',
    'response-mime-type'
];
const $3fa3467f6e1cb10b$var$builtInOAS3Rules = [
    'info-contact',
    'operation-operationId',
    'tag-description',
    'tags-alphabetical',
    'info-license-url',
    'info-license-strict',
    'info-license',
    'no-ambiguous-paths',
    'no-enum-type-mismatch',
    'no-http-verbs-in-paths',
    'no-identical-paths',
    'no-invalid-parameter-examples',
    'no-invalid-schema-examples',
    'no-path-trailing-slash',
    'operation-2xx-response',
    'operation-4xx-response',
    'operation-description',
    'operation-operationId-unique',
    'operation-operationId-url-safe',
    'operation-parameters-unique',
    'operation-singular-tag',
    'operation-summary',
    'operation-tag-defined',
    'parameter-description',
    'path-declaration-must-exist',
    'path-excludes-patterns',
    'path-http-verbs-order',
    'path-not-include-query',
    'path-params-defined',
    'path-parameters-defined',
    'path-segment-plural',
    'paths-kebab-case',
    'required-string-property-missing-min-length',
    'response-contains-header',
    'scalar-property-missing-example',
    'security-defined',
    'spec-strict-refs',
    'no-unresolved-refs',
    'no-required-schema-properties-undefined',
    'no-schema-type-mismatch',
    'boolean-parameter-prefixes',
    'component-name-unique',
    'no-empty-servers',
    'no-example-value-and-externalValue',
    'no-invalid-media-type-examples',
    'no-server-example.com',
    'no-server-trailing-slash',
    'no-server-variables-empty-enum',
    'no-undefined-server-variable',
    'no-unused-components',
    'operation-4xx-problem-details-rfc7807',
    'request-mime-type',
    'response-contains-property',
    'response-mime-type',
    'spec-components-invalid-map-name',
    'array-parameter-serialization'
];
const $3fa3467f6e1cb10b$var$builtInAsync2Rules = [
    'info-contact',
    'info-license-strict',
    'operation-operationId',
    'tag-description',
    'tags-alphabetical',
    'channels-kebab-case',
    'no-channel-trailing-slash'
];
const $3fa3467f6e1cb10b$var$builtInAsync3Rules = [
    'info-contact',
    'info-license-strict',
    'operation-operationId',
    'tag-description',
    'tags-alphabetical',
    'channels-kebab-case',
    'no-channel-trailing-slash'
];
const $3fa3467f6e1cb10b$var$builtInArazzo1Rules = [
    'sourceDescription-type',
    'workflowId-unique',
    'stepId-unique',
    'sourceDescription-name-unique',
    'sourceDescriptions-not-empty',
    'workflow-dependsOn',
    'parameters-unique',
    'step-onSuccess-unique',
    'step-onFailure-unique',
    'respect-supported-versions',
    'requestBody-replacements-unique',
    'no-criteria-xpath',
    'criteria-unique'
];
const $3fa3467f6e1cb10b$var$builtInOverlay1Rules = [
    'info-contact'
];
const $3fa3467f6e1cb10b$var$builtInRules = [
    ...$3fa3467f6e1cb10b$var$builtInOAS2Rules,
    ...$3fa3467f6e1cb10b$var$builtInOAS3Rules,
    ...$3fa3467f6e1cb10b$var$builtInAsync2Rules,
    ...$3fa3467f6e1cb10b$var$builtInAsync3Rules,
    ...$3fa3467f6e1cb10b$var$builtInArazzo1Rules,
    ...$3fa3467f6e1cb10b$var$builtInOverlay1Rules,
    'spec',
    'struct'
];
const $3fa3467f6e1cb10b$var$oas2NodeTypesList = [
    'Root',
    'Tag',
    'TagList',
    'ExternalDocs',
    'SecurityRequirement',
    'SecurityRequirementList',
    'Info',
    'Contact',
    'License',
    'Paths',
    'PathItem',
    'Parameter',
    'ParameterList',
    'ParameterItems',
    'Operation',
    'Example',
    'ExamplesMap',
    'Examples',
    'Header',
    'Responses',
    'Response',
    'Schema',
    'Xml',
    'SchemaProperties',
    'NamedSchemas',
    'NamedResponses',
    'NamedParameters',
    'NamedSecuritySchemes',
    'SecurityScheme',
    'TagGroup',
    'TagGroups',
    'EnumDescriptions',
    'Logo',
    'XCodeSample',
    'XCodeSampleList',
    'XServer',
    'XServerList'
];
const $3fa3467f6e1cb10b$var$oas3NodeTypesList = [
    'Root',
    'Tag',
    'TagList',
    'ExternalDocs',
    'Server',
    'ServerList',
    'ServerVariable',
    'ServerVariablesMap',
    'SecurityRequirement',
    'SecurityRequirementList',
    'Info',
    'Contact',
    'License',
    'Paths',
    'PathItem',
    'Parameter',
    'ParameterList',
    'Operation',
    'Callback',
    'CallbacksMap',
    'RequestBody',
    'MediaTypesMap',
    'MediaType',
    'Example',
    'ExamplesMap',
    'Encoding',
    'EncodingMap',
    'Header',
    'HeadersMap',
    'Responses',
    'Response',
    'Link',
    'LinksMap',
    'Schema',
    'Xml',
    'SchemaProperties',
    'DiscriminatorMapping',
    'Discriminator',
    'Components',
    'NamedSchemas',
    'NamedResponses',
    'NamedParameters',
    'NamedExamples',
    'NamedRequestBodies',
    'NamedHeaders',
    'NamedSecuritySchemes',
    'NamedLinks',
    'NamedCallbacks',
    'ImplicitFlow',
    'PasswordFlow',
    'ClientCredentials',
    'AuthorizationCode',
    'OAuth2Flows',
    'SecurityScheme',
    'TagGroup',
    'TagGroups',
    'EnumDescriptions',
    'Logo',
    'XCodeSample',
    'XCodeSampleList',
    'XUsePkce',
    'WebhooksMap'
];
const $3fa3467f6e1cb10b$var$oas3_1NodeTypesList = [
    'Root',
    'Schema',
    'SchemaProperties',
    'PatternProperties',
    'Info',
    'License',
    'Components',
    'NamedPathItems',
    'SecurityScheme',
    'Operation',
    'DependentRequired'
];
const $3fa3467f6e1cb10b$var$ConfigStyleguide = {
    properties: {
        extends: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        rules: 'Rules',
        oas2Rules: 'Rules',
        oas3_0Rules: 'Rules',
        oas3_1Rules: 'Rules',
        async2Rules: 'Rules',
        arazzo1Rules: 'Rules',
        preprocessors: {
            type: 'object'
        },
        oas2Preprocessors: {
            type: 'object'
        },
        oas3_0Preprocessors: {
            type: 'object'
        },
        oas3_1Preprocessors: {
            type: 'object'
        },
        async2Preprocessors: {
            type: 'object'
        },
        arazzoPreprocessors: {
            type: 'object'
        },
        decorators: {
            type: 'object'
        },
        oas2Decorators: {
            type: 'object'
        },
        oas3_0Decorators: {
            type: 'object'
        },
        oas3_1Decorators: {
            type: 'object'
        },
        async2Decorators: {
            type: 'object'
        },
        arazzo1Decorators: {
            type: 'object'
        }
    }
};
const $3fa3467f6e1cb10b$var$createConfigRoot = (nodeTypes)=>({
        ...nodeTypes.rootRedoclyConfigSchema,
        properties: {
            ...nodeTypes.rootRedoclyConfigSchema.properties,
            ...$3fa3467f6e1cb10b$var$ConfigStyleguide.properties,
            apis: 'ConfigApis',
            'features.openapi': 'ConfigReferenceDocs',
            'features.mockServer': 'ConfigMockServer',
            organization: {
                type: 'string'
            },
            region: {
                enum: [
                    'us',
                    'eu'
                ]
            },
            telemetry: {
                enum: [
                    'on',
                    'off'
                ]
            },
            resolve: {
                properties: {
                    http: 'ConfigHTTP',
                    doNotResolveExamples: {
                        type: 'boolean'
                    }
                }
            },
            files: {
                type: 'array',
                items: {
                    type: 'string'
                }
            }
        }
    });
const $3fa3467f6e1cb10b$var$ConfigApis = {
    properties: {},
    additionalProperties: 'ConfigApisProperties'
};
const $3fa3467f6e1cb10b$var$createConfigApisProperties = (nodeTypes)=>({
        ...nodeTypes['rootRedoclyConfigSchema.apis_additionalProperties'],
        properties: {
            ...nodeTypes['rootRedoclyConfigSchema.apis_additionalProperties']?.properties,
            labels: {
                type: 'array',
                items: {
                    type: 'string'
                }
            },
            ...$3fa3467f6e1cb10b$var$ConfigStyleguide.properties,
            'features.openapi': 'ConfigReferenceDocs',
            'features.mockServer': 'ConfigMockServer',
            files: {
                type: 'array',
                items: {
                    type: 'string'
                }
            }
        }
    });
const $3fa3467f6e1cb10b$var$ConfigHTTP = {
    properties: {
        headers: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    }
};
const $3fa3467f6e1cb10b$var$Rules = {
    properties: {},
    additionalProperties: (value, key)=>{
        if (key.startsWith('rule/')) {
            if (typeof value === 'string') return {
                enum: [
                    'error',
                    'warn',
                    'off'
                ]
            };
            else return 'Assert';
        } else if (key.startsWith('assert/')) {
            // keep the old assert/ prefix as an alias
            if (typeof value === 'string') return {
                enum: [
                    'error',
                    'warn',
                    'off'
                ]
            };
            else return 'Assert';
        } else if ($3fa3467f6e1cb10b$var$builtInRules.includes(key) || (0, $eONiY.isCustomRuleId)(key)) {
            if (typeof value === 'string') return {
                enum: [
                    'error',
                    'warn',
                    'off'
                ]
            };
            else return 'ObjectRule';
        } else if (key === 'metadata-schema' || key === 'custom-fields-schema') return 'Schema';
        // Otherwise is considered as invalid
        return;
    }
};
const $3fa3467f6e1cb10b$var$ObjectRule = {
    properties: {
        severity: {
            enum: [
                'error',
                'warn',
                'off'
            ]
        }
    },
    additionalProperties: {},
    required: [
        'severity'
    ]
};
// TODO: add better type tree for this
const $3fa3467f6e1cb10b$var$Schema = {
    properties: {},
    additionalProperties: {}
};
function $3fa3467f6e1cb10b$var$createAssertionDefinitionSubject(nodeNames) {
    return {
        properties: {
            type: {
                enum: [
                    ...new Set([
                        'any',
                        ...nodeNames,
                        'SpecExtension'
                    ])
                ]
            },
            property: (value)=>{
                if (Array.isArray(value)) return {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                };
                else if (value === null) return null;
                else return {
                    type: 'string'
                };
            },
            filterInParentKeys: {
                type: 'array',
                items: {
                    type: 'string'
                }
            },
            filterOutParentKeys: {
                type: 'array',
                items: {
                    type: 'string'
                }
            },
            matchParentKeys: {
                type: 'string'
            }
        },
        required: [
            'type'
        ]
    };
}
const $3fa3467f6e1cb10b$var$AssertionDefinitionAssertions = {
    properties: {
        enum: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        pattern: {
            type: 'string'
        },
        notPattern: {
            type: 'string'
        },
        casing: {
            enum: [
                'camelCase',
                'kebab-case',
                'snake_case',
                'PascalCase',
                'MACRO_CASE',
                'COBOL-CASE',
                'flatcase'
            ]
        },
        mutuallyExclusive: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        mutuallyRequired: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        required: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        requireAny: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        disallowed: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        defined: {
            type: 'boolean'
        },
        // undefined: { type: 'boolean' }, // TODO: Remove `undefined` assertion from codebase overall
        nonEmpty: {
            type: 'boolean'
        },
        minLength: {
            type: 'integer'
        },
        maxLength: {
            type: 'integer'
        },
        ref: (value)=>typeof value === 'string' ? {
                type: 'string'
            } : {
                type: 'boolean'
            },
        const: (value)=>{
            if (typeof value === 'string') return {
                type: 'string'
            };
            if (typeof value === 'number') return {
                type: 'number'
            };
            if (typeof value === 'boolean') return {
                type: 'boolean'
            };
            else return;
        }
    },
    additionalProperties: (_value, key)=>{
        if (/^\w+\/\w+$/.test(key)) return {
            type: 'object'
        };
        return;
    }
};
const $3fa3467f6e1cb10b$var$AssertDefinition = {
    properties: {
        subject: 'AssertionDefinitionSubject',
        assertions: 'AssertionDefinitionAssertions'
    },
    required: [
        'subject',
        'assertions'
    ]
};
const $3fa3467f6e1cb10b$var$Assert = {
    properties: {
        subject: 'AssertionDefinitionSubject',
        assertions: 'AssertionDefinitionAssertions',
        where: (0, $hlZ1o.listOf)('AssertDefinition'),
        message: {
            type: 'string'
        },
        suggest: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        severity: {
            enum: [
                'error',
                'warn',
                'off'
            ]
        }
    },
    required: [
        'subject',
        'assertions'
    ]
};
const $3fa3467f6e1cb10b$var$ConfigLanguage = {
    properties: {
        label: {
            type: 'string'
        },
        lang: {
            enum: [
                'curl',
                'C#',
                'Go',
                'Java',
                'Java8+Apache',
                'JavaScript',
                'Node.js',
                'PHP',
                'Python',
                'R',
                'Ruby'
            ]
        }
    },
    required: [
        'lang'
    ]
};
const $3fa3467f6e1cb10b$var$ConfigLabels = {
    properties: {
        enum: {
            type: 'string'
        },
        enumSingleValue: {
            type: 'string'
        },
        enumArray: {
            type: 'string'
        },
        default: {
            type: 'string'
        },
        deprecated: {
            type: 'string'
        },
        example: {
            type: 'string'
        },
        examples: {
            type: 'string'
        },
        nullable: {
            type: 'string'
        },
        recursive: {
            type: 'string'
        },
        arrayOf: {
            type: 'string'
        },
        webhook: {
            type: 'string'
        },
        authorizations: {
            type: 'string'
        },
        tryItAuthBasicUsername: {
            type: 'string'
        },
        tryItAuthBasicPassword: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$ConfigSidebarLinks = {
    properties: {
        beforeInfo: (0, $hlZ1o.listOf)('CommonConfigSidebarLinks'),
        end: (0, $hlZ1o.listOf)('CommonConfigSidebarLinks')
    }
};
const $3fa3467f6e1cb10b$var$CommonConfigSidebarLinks = {
    properties: {
        label: {
            type: 'string'
        },
        link: {
            type: 'string'
        },
        target: {
            type: 'string'
        }
    },
    required: [
        'label',
        'link'
    ]
};
const $3fa3467f6e1cb10b$var$CommonThemeColors = {
    properties: {
        main: {
            type: 'string'
        },
        light: {
            type: 'string'
        },
        dark: {
            type: 'string'
        },
        contrastText: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$CommonColorProps = {
    properties: {
        backgroundColor: {
            type: 'string'
        },
        borderColor: {
            type: 'string'
        },
        color: {
            type: 'string'
        },
        tabTextColor: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$BorderThemeColors = {
    properties: (0, $eONiY.pickObjectProps)($3fa3467f6e1cb10b$var$CommonThemeColors.properties, [
        'light',
        'dark'
    ])
};
const $3fa3467f6e1cb10b$var$HttpColors = {
    properties: {
        basic: {
            type: 'string'
        },
        delete: {
            type: 'string'
        },
        get: {
            type: 'string'
        },
        head: {
            type: 'string'
        },
        link: {
            type: 'string'
        },
        options: {
            type: 'string'
        },
        patch: {
            type: 'string'
        },
        post: {
            type: 'string'
        },
        put: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$ResponseColors = {
    properties: {
        error: 'CommonColorProps',
        info: 'CommonColorProps',
        redirect: 'CommonColorProps',
        success: 'CommonColorProps'
    }
};
const $3fa3467f6e1cb10b$var$SecondaryColors = {
    properties: (0, $eONiY.omitObjectProps)($3fa3467f6e1cb10b$var$CommonThemeColors.properties, [
        'dark'
    ])
};
const $3fa3467f6e1cb10b$var$TextThemeColors = {
    properties: {
        primary: {
            type: 'string'
        },
        secondary: {
            type: 'string'
        },
        light: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$ThemeColors = {
    properties: {
        accent: 'CommonThemeColors',
        border: 'BorderThemeColors',
        error: 'CommonThemeColors',
        http: 'HttpColors',
        primary: 'CommonThemeColors',
        responses: 'ResponseColors',
        secondary: 'SecondaryColors',
        success: 'CommonThemeColors',
        text: 'TextThemeColors',
        tonalOffset: {
            type: 'number'
        },
        warning: 'CommonThemeColors'
    }
};
const $3fa3467f6e1cb10b$var$SizeProps = {
    properties: {
        fontSize: {
            type: 'string'
        },
        padding: {
            type: 'string'
        },
        minWidth: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$Sizes = {
    properties: {
        small: 'SizeProps',
        medium: 'SizeProps',
        large: 'SizeProps',
        xlarge: 'SizeProps'
    }
};
const $3fa3467f6e1cb10b$var$FontConfig = {
    properties: {
        fontFamily: {
            type: 'string'
        },
        fontSize: {
            type: 'string'
        },
        fontWeight: {
            type: 'string'
        },
        lineHeight: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$ButtonsConfig = {
    properties: {
        ...(0, $eONiY.omitObjectProps)($3fa3467f6e1cb10b$var$FontConfig.properties, [
            'fontSize',
            'lineHeight'
        ]),
        borderRadius: {
            type: 'string'
        },
        hoverStyle: {
            type: 'string'
        },
        boxShadow: {
            type: 'string'
        },
        hoverBoxShadow: {
            type: 'string'
        },
        sizes: 'Sizes'
    }
};
const $3fa3467f6e1cb10b$var$BadgeFontConfig = {
    properties: (0, $eONiY.pickObjectProps)($3fa3467f6e1cb10b$var$FontConfig.properties, [
        'fontSize',
        'lineHeight'
    ])
};
const $3fa3467f6e1cb10b$var$BadgeSizes = {
    properties: {
        medium: 'BadgeFontConfig',
        small: 'BadgeFontConfig'
    }
};
const $3fa3467f6e1cb10b$var$HttpBadgesConfig = {
    properties: {
        ...(0, $eONiY.omitObjectProps)($3fa3467f6e1cb10b$var$FontConfig.properties, [
            'fontSize',
            'lineHeight'
        ]),
        borderRadius: {
            type: 'string'
        },
        color: {
            type: 'string'
        },
        sizes: 'BadgeSizes'
    }
};
const $3fa3467f6e1cb10b$var$LabelControls = {
    properties: {
        top: {
            type: 'string'
        },
        width: {
            type: 'string'
        },
        height: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$Panels = {
    properties: {
        borderRadius: {
            type: 'string'
        },
        backgroundColor: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$TryItButton = {
    properties: {
        fullWidth: {
            type: 'boolean'
        }
    }
};
const $3fa3467f6e1cb10b$var$ConfigThemeComponents = {
    properties: {
        buttons: 'ButtonsConfig',
        httpBadges: 'HttpBadgesConfig',
        layoutControls: 'LabelControls',
        panels: 'Panels',
        tryItButton: 'TryItButton',
        tryItSendButton: 'TryItButton'
    }
};
const $3fa3467f6e1cb10b$var$Breakpoints = {
    properties: {
        small: {
            type: 'string'
        },
        medium: {
            type: 'string'
        },
        large: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$StackedConfig = {
    properties: {
        maxWidth: 'Breakpoints'
    }
};
const $3fa3467f6e1cb10b$var$ThreePanelConfig = {
    properties: {
        maxWidth: 'Breakpoints',
        middlePanelMaxWidth: 'Breakpoints'
    }
};
const $3fa3467f6e1cb10b$var$Layout = {
    properties: {
        showDarkRightPanel: {
            type: 'boolean'
        },
        stacked: 'StackedConfig',
        'three-panel': 'ThreePanelConfig'
    }
};
const $3fa3467f6e1cb10b$var$SchemaColorsConfig = {
    properties: {
        backgroundColor: {
            type: 'string'
        },
        border: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$ConfigThemeSchema = {
    properties: {
        breakFieldNames: {
            type: 'boolean'
        },
        caretColor: {
            type: 'string'
        },
        caretSize: {
            type: 'string'
        },
        constraints: 'SchemaColorsConfig',
        defaultDetailsWidth: {
            type: 'string'
        },
        examples: 'SchemaColorsConfig',
        labelsTextSize: {
            type: 'string'
        },
        linesColor: {
            type: 'string'
        },
        nestedBackground: {
            type: 'string'
        },
        nestingSpacing: {
            type: 'string'
        },
        requireLabelColor: {
            type: 'string'
        },
        typeNameColor: {
            type: 'string'
        },
        typeTitleColor: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$GroupItemsConfig = {
    properties: {
        subItemsColor: {
            type: 'string'
        },
        textTransform: {
            type: 'string'
        },
        fontWeight: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$Level1Items = {
    properties: (0, $eONiY.pickObjectProps)($3fa3467f6e1cb10b$var$GroupItemsConfig.properties, [
        'textTransform'
    ])
};
const $3fa3467f6e1cb10b$var$SpacingConfig = {
    properties: {
        unit: {
            type: 'number'
        },
        paddingHorizontal: {
            type: 'string'
        },
        paddingVertical: {
            type: 'string'
        },
        offsetTop: {
            type: 'string'
        },
        offsetLeft: {
            type: 'string'
        },
        offsetNesting: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$Sidebar = {
    properties: {
        ...(0, $eONiY.omitObjectProps)($3fa3467f6e1cb10b$var$FontConfig.properties, [
            'fontWeight',
            'lineHeight'
        ]),
        activeBgColor: {
            type: 'string'
        },
        activeTextColor: {
            type: 'string'
        },
        backgroundColor: {
            type: 'string'
        },
        borderRadius: {
            type: 'string'
        },
        breakPath: {
            type: 'boolean'
        },
        caretColor: {
            type: 'string'
        },
        caretSize: {
            type: 'string'
        },
        groupItems: 'GroupItemsConfig',
        level1items: 'Level1Items',
        rightLineColor: {
            type: 'string'
        },
        separatorLabelColor: {
            type: 'string'
        },
        showAtBreakpoint: {
            type: 'string'
        },
        spacing: 'SpacingConfig',
        textColor: {
            type: 'string'
        },
        width: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$Heading = {
    properties: {
        ...$3fa3467f6e1cb10b$var$FontConfig.properties,
        color: {
            type: 'string'
        },
        transform: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$CodeConfig = {
    properties: {
        ...$3fa3467f6e1cb10b$var$FontConfig.properties,
        backgroundColor: {
            type: 'string'
        },
        color: {
            type: 'string'
        },
        wordBreak: {
            enum: [
                'break-all',
                'break-word',
                'keep-all',
                'normal',
                'revert',
                'unset',
                'inherit',
                'initial'
            ]
        },
        wrap: {
            type: 'boolean'
        }
    }
};
const $3fa3467f6e1cb10b$var$HeadingsConfig = {
    properties: (0, $eONiY.omitObjectProps)($3fa3467f6e1cb10b$var$FontConfig.properties, [
        'fontSize'
    ])
};
const $3fa3467f6e1cb10b$var$LinksConfig = {
    properties: {
        color: {
            type: 'string'
        },
        hover: {
            type: 'string'
        },
        textDecoration: {
            type: 'string'
        },
        hoverTextDecoration: {
            type: 'string'
        },
        visited: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$Typography = {
    properties: {
        code: 'CodeConfig',
        fieldName: 'FontConfig',
        ...(0, $eONiY.pickObjectProps)($3fa3467f6e1cb10b$var$FontConfig.properties, [
            'fontSize',
            'fontFamily'
        ]),
        fontWeightBold: {
            type: 'string'
        },
        fontWeightLight: {
            type: 'string'
        },
        fontWeightRegular: {
            type: 'string'
        },
        heading1: 'Heading',
        heading2: 'Heading',
        heading3: 'Heading',
        headings: 'HeadingsConfig',
        lineHeight: {
            type: 'string'
        },
        links: 'LinksConfig',
        optimizeSpeed: {
            type: 'boolean'
        },
        rightPanelHeading: 'Heading',
        smoothing: {
            enum: [
                'auto',
                'none',
                'antialiased',
                'subpixel-antialiased',
                'grayscale'
            ]
        }
    }
};
const $3fa3467f6e1cb10b$var$TokenProps = {
    properties: {
        color: {
            type: 'string'
        },
        ...(0, $eONiY.omitObjectProps)($3fa3467f6e1cb10b$var$FontConfig.properties, [
            'fontWeight'
        ])
    }
};
const $3fa3467f6e1cb10b$var$CodeBlock = {
    properties: {
        backgroundColor: {
            type: 'string'
        },
        borderRadius: {
            type: 'string'
        },
        tokens: 'TokenProps'
    }
};
const $3fa3467f6e1cb10b$var$ConfigThemeLogo = {
    properties: {
        gutter: {
            type: 'string'
        },
        maxHeight: {
            type: 'string'
        },
        maxWidth: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$Fab = {
    properties: {
        backgroundColor: {
            type: 'string'
        },
        color: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$ButtonOverrides = {
    properties: {
        custom: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$Overrides = {
    properties: {
        DownloadButton: 'ButtonOverrides',
        NextSectionButton: 'ButtonOverrides'
    }
};
const $3fa3467f6e1cb10b$var$RightPanel = {
    properties: {
        backgroundColor: {
            type: 'string'
        },
        panelBackgroundColor: {
            type: 'string'
        },
        panelControlsBackgroundColor: {
            type: 'string'
        },
        showAtBreakpoint: {
            type: 'string'
        },
        textColor: {
            type: 'string'
        },
        width: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$Shape = {
    properties: {
        borderRadius: {
            type: 'string'
        }
    }
};
const $3fa3467f6e1cb10b$var$ThemeSpacing = {
    properties: {
        sectionHorizontal: {
            type: 'number'
        },
        sectionVertical: {
            type: 'number'
        },
        unit: {
            type: 'number'
        }
    }
};
const $3fa3467f6e1cb10b$var$ConfigTheme = {
    properties: {
        breakpoints: 'Breakpoints',
        codeBlock: 'CodeBlock',
        colors: 'ThemeColors',
        components: 'ConfigThemeComponents',
        layout: 'Layout',
        logo: 'ConfigThemeLogo',
        fab: 'Fab',
        overrides: 'Overrides',
        rightPanel: 'RightPanel',
        schema: 'ConfigThemeSchema',
        shape: 'Shape',
        sidebar: 'Sidebar',
        spacing: 'ThemeSpacing',
        typography: 'Typography',
        links: {
            properties: {
                color: {
                    type: 'string'
                }
            }
        },
        codeSample: {
            properties: {
                backgroundColor: {
                    type: 'string'
                }
            }
        }
    }
};
const $3fa3467f6e1cb10b$var$GenerateCodeSamples = {
    properties: {
        skipOptionalParameters: {
            type: 'boolean'
        },
        languages: (0, $hlZ1o.listOf)('ConfigLanguage')
    },
    required: [
        'languages'
    ]
};
// TODO: deprecated
const $3fa3467f6e1cb10b$var$ConfigReferenceDocs = {
    properties: {
        theme: 'ConfigTheme',
        corsProxyUrl: {
            type: 'string'
        },
        ctrlFHijack: {
            type: 'boolean'
        },
        defaultSampleLanguage: {
            type: 'string'
        },
        disableDeepLinks: {
            type: 'boolean'
        },
        disableSearch: {
            type: 'boolean'
        },
        disableSidebar: {
            type: 'boolean'
        },
        downloadDefinitionUrl: {
            type: 'string'
        },
        expandDefaultServerVariables: {
            type: 'boolean'
        },
        enumSkipQuotes: {
            type: 'boolean'
        },
        expandDefaultRequest: {
            type: 'boolean'
        },
        expandDefaultResponse: {
            type: 'boolean'
        },
        expandResponses: {
            type: 'string'
        },
        expandSingleSchemaField: {
            type: 'boolean'
        },
        generateCodeSamples: 'GenerateCodeSamples',
        generatedPayloadSamplesMaxDepth: {
            type: 'number'
        },
        hideDownloadButton: {
            type: 'boolean'
        },
        hideHostname: {
            type: 'boolean'
        },
        hideInfoSection: {
            type: 'boolean'
        },
        hideLoading: {
            type: 'boolean'
        },
        hideLogo: {
            type: 'boolean'
        },
        hideRequestPayloadSample: {
            type: 'boolean'
        },
        hideRightPanel: {
            type: 'boolean'
        },
        hideSchemaPattern: {
            type: 'boolean'
        },
        hideSchemaTitles: {
            type: 'boolean'
        },
        hideSingleRequestSampleTab: {
            type: 'boolean'
        },
        hideSecuritySection: {
            type: 'boolean'
        },
        hideTryItPanel: {
            type: 'boolean'
        },
        hideFab: {
            type: 'boolean'
        },
        hideOneOfDescription: {
            type: 'boolean'
        },
        htmlTemplate: {
            type: 'string'
        },
        jsonSampleExpandLevel: (value)=>{
            if (typeof value === 'number') return {
                type: 'number',
                minimum: 1
            };
            else return {
                type: 'string'
            };
        },
        labels: 'ConfigLabels',
        layout: {
            enum: [
                'stacked',
                'three-panel'
            ]
        },
        maxDisplayedEnumValues: {
            type: 'number'
        },
        menuToggle: {
            type: 'boolean'
        },
        nativeScrollbars: {
            type: 'boolean'
        },
        noAutoAuth: {
            type: 'boolean'
        },
        oAuth2RedirectURI: {
            type: 'string'
        },
        onDeepLinkClick: {
            type: 'object'
        },
        onlyRequiredInSamples: {
            type: 'boolean'
        },
        pagination: {
            enum: [
                'none',
                'section',
                'item'
            ]
        },
        pathInMiddlePanel: {
            type: 'boolean'
        },
        payloadSampleIdx: {
            type: 'number',
            minimum: 0
        },
        requestInterceptor: {
            type: 'object'
        },
        requiredPropsFirst: {
            type: 'boolean'
        },
        routingBasePath: {
            type: 'string'
        },
        routingStrategy: {
            type: 'string'
        },
        samplesTabsMaxCount: {
            type: 'number'
        },
        schemaExpansionLevel: (value)=>{
            if (typeof value === 'number') return {
                type: 'number',
                minimum: 0
            };
            else return {
                type: 'string'
            };
        },
        schemaDefinitionsTagName: {
            type: 'string'
        },
        minCharacterLengthToInitSearch: {
            type: 'number',
            minimum: 1
        },
        maxResponseHeadersToShowInTryIt: {
            type: 'number',
            minimum: 0
        },
        scrollYOffset: (value)=>{
            if (typeof value === 'number') return {
                type: 'number'
            };
            else return {
                type: 'string'
            };
        },
        searchAutoExpand: {
            type: 'boolean'
        },
        searchFieldLevelBoost: {
            type: 'number',
            minimum: 0
        },
        searchMaxDepth: {
            type: 'number',
            minimum: 1
        },
        searchMode: {
            enum: [
                'default',
                'path-only'
            ]
        },
        searchOperationTitleBoost: {
            type: 'number'
        },
        searchTagTitleBoost: {
            type: 'number'
        },
        sendXUserAgentInTryIt: {
            type: 'boolean'
        },
        showChangeLayoutButton: {
            type: 'boolean'
        },
        showConsole: {
            type: 'boolean'
        },
        showExtensions: (value)=>{
            if (typeof value === 'boolean') return {
                type: 'boolean'
            };
            else return {
                type: 'array',
                items: {
                    type: 'string'
                }
            };
        },
        showNextButton: {
            type: 'boolean'
        },
        showRightPanelToggle: {
            type: 'boolean'
        },
        showSecuritySchemeType: {
            type: 'boolean'
        },
        showWebhookVerb: {
            type: 'boolean'
        },
        showObjectSchemaExamples: {
            type: 'boolean'
        },
        disableTryItRequestUrlEncoding: {
            type: 'boolean'
        },
        sidebarLinks: 'ConfigSidebarLinks',
        sideNavStyle: {
            enum: [
                'summary-only',
                'path-first',
                'id-only',
                'path-only'
            ]
        },
        simpleOneOfTypeLabel: {
            type: 'boolean'
        },
        sortEnumValuesAlphabetically: {
            type: 'boolean'
        },
        sortOperationsAlphabetically: {
            type: 'boolean'
        },
        sortPropsAlphabetically: {
            type: 'boolean'
        },
        sortTagsAlphabetically: {
            type: 'boolean'
        },
        suppressWarnings: {
            type: 'boolean'
        },
        unstable_externalDescription: {
            type: 'boolean'
        },
        unstable_ignoreMimeParameters: {
            type: 'boolean'
        },
        untrustedDefinition: {
            type: 'boolean'
        },
        mockServer: {
            properties: {
                url: {
                    type: 'string'
                },
                position: {
                    enum: [
                        'first',
                        'last',
                        'replace',
                        'off'
                    ]
                },
                description: {
                    type: 'string'
                }
            }
        },
        showAccessMode: {
            type: 'boolean'
        },
        preserveOriginalExtensionsName: {
            type: 'boolean'
        },
        markdownHeadingsAnchorLevel: {
            type: 'number'
        }
    },
    additionalProperties: {}
};
const $3fa3467f6e1cb10b$var$ConfigMockServer = {
    properties: {
        strictExamples: {
            type: 'boolean'
        },
        errorIfForcedExampleNotFound: {
            type: 'boolean'
        }
    }
};
function $3fa3467f6e1cb10b$var$createConfigTypes(extraSchemas, config) {
    const nodeNames = Object.values($aSlQf.SpecVersion).flatMap((version)=>{
        const types = config?.styleguide ? config.styleguide.extendTypes((0, $aSlQf.getTypes)(version), version) : (0, $aSlQf.getTypes)(version);
        return Object.keys(types);
    });
    // Create types based on external schemas
    const nodeTypes = (0, $7SgPX.getNodeTypesFromJSONSchema)('rootRedoclyConfigSchema', extraSchemas);
    return {
        ...$3fa3467f6e1cb10b$var$CoreConfigTypes,
        ConfigRoot: $3fa3467f6e1cb10b$var$createConfigRoot(nodeTypes),
        ConfigApisProperties: $3fa3467f6e1cb10b$var$createConfigApisProperties(nodeTypes),
        AssertionDefinitionSubject: $3fa3467f6e1cb10b$var$createAssertionDefinitionSubject(nodeNames),
        ...nodeTypes
    };
}
const $3fa3467f6e1cb10b$var$CoreConfigTypes = {
    Assert: $3fa3467f6e1cb10b$var$Assert,
    ConfigApis: $3fa3467f6e1cb10b$var$ConfigApis,
    ConfigStyleguide: $3fa3467f6e1cb10b$var$ConfigStyleguide,
    ConfigReferenceDocs: $3fa3467f6e1cb10b$var$ConfigReferenceDocs,
    ConfigMockServer: $3fa3467f6e1cb10b$var$ConfigMockServer,
    ConfigHTTP: $3fa3467f6e1cb10b$var$ConfigHTTP,
    ConfigLanguage: $3fa3467f6e1cb10b$var$ConfigLanguage,
    ConfigLabels: $3fa3467f6e1cb10b$var$ConfigLabels,
    ConfigSidebarLinks: $3fa3467f6e1cb10b$var$ConfigSidebarLinks,
    CommonConfigSidebarLinks: $3fa3467f6e1cb10b$var$CommonConfigSidebarLinks,
    ConfigTheme: $3fa3467f6e1cb10b$var$ConfigTheme,
    AssertDefinition: $3fa3467f6e1cb10b$var$AssertDefinition,
    ThemeColors: $3fa3467f6e1cb10b$var$ThemeColors,
    CommonThemeColors: $3fa3467f6e1cb10b$var$CommonThemeColors,
    BorderThemeColors: $3fa3467f6e1cb10b$var$BorderThemeColors,
    HttpColors: $3fa3467f6e1cb10b$var$HttpColors,
    ResponseColors: $3fa3467f6e1cb10b$var$ResponseColors,
    SecondaryColors: $3fa3467f6e1cb10b$var$SecondaryColors,
    TextThemeColors: $3fa3467f6e1cb10b$var$TextThemeColors,
    Sizes: $3fa3467f6e1cb10b$var$Sizes,
    ButtonsConfig: $3fa3467f6e1cb10b$var$ButtonsConfig,
    CommonColorProps: $3fa3467f6e1cb10b$var$CommonColorProps,
    BadgeFontConfig: $3fa3467f6e1cb10b$var$BadgeFontConfig,
    BadgeSizes: $3fa3467f6e1cb10b$var$BadgeSizes,
    HttpBadgesConfig: $3fa3467f6e1cb10b$var$HttpBadgesConfig,
    LabelControls: $3fa3467f6e1cb10b$var$LabelControls,
    Panels: $3fa3467f6e1cb10b$var$Panels,
    TryItButton: $3fa3467f6e1cb10b$var$TryItButton,
    Breakpoints: $3fa3467f6e1cb10b$var$Breakpoints,
    StackedConfig: $3fa3467f6e1cb10b$var$StackedConfig,
    ThreePanelConfig: $3fa3467f6e1cb10b$var$ThreePanelConfig,
    SchemaColorsConfig: $3fa3467f6e1cb10b$var$SchemaColorsConfig,
    SizeProps: $3fa3467f6e1cb10b$var$SizeProps,
    Level1Items: $3fa3467f6e1cb10b$var$Level1Items,
    SpacingConfig: $3fa3467f6e1cb10b$var$SpacingConfig,
    FontConfig: $3fa3467f6e1cb10b$var$FontConfig,
    CodeConfig: $3fa3467f6e1cb10b$var$CodeConfig,
    HeadingsConfig: $3fa3467f6e1cb10b$var$HeadingsConfig,
    LinksConfig: $3fa3467f6e1cb10b$var$LinksConfig,
    TokenProps: $3fa3467f6e1cb10b$var$TokenProps,
    CodeBlock: $3fa3467f6e1cb10b$var$CodeBlock,
    ConfigThemeLogo: $3fa3467f6e1cb10b$var$ConfigThemeLogo,
    Fab: $3fa3467f6e1cb10b$var$Fab,
    ButtonOverrides: $3fa3467f6e1cb10b$var$ButtonOverrides,
    Overrides: $3fa3467f6e1cb10b$var$Overrides,
    ObjectRule: $3fa3467f6e1cb10b$var$ObjectRule,
    Schema: $3fa3467f6e1cb10b$var$Schema,
    RightPanel: $3fa3467f6e1cb10b$var$RightPanel,
    Rules: $3fa3467f6e1cb10b$var$Rules,
    Shape: $3fa3467f6e1cb10b$var$Shape,
    ThemeSpacing: $3fa3467f6e1cb10b$var$ThemeSpacing,
    GenerateCodeSamples: $3fa3467f6e1cb10b$var$GenerateCodeSamples,
    GroupItemsConfig: $3fa3467f6e1cb10b$var$GroupItemsConfig,
    ConfigThemeComponents: $3fa3467f6e1cb10b$var$ConfigThemeComponents,
    Layout: $3fa3467f6e1cb10b$var$Layout,
    ConfigThemeSchema: $3fa3467f6e1cb10b$var$ConfigThemeSchema,
    Sidebar: $3fa3467f6e1cb10b$var$Sidebar,
    Heading: $3fa3467f6e1cb10b$var$Heading,
    Typography: $3fa3467f6e1cb10b$var$Typography,
    AssertionDefinitionAssertions: $3fa3467f6e1cb10b$var$AssertionDefinitionAssertions
};
module.exports.ConfigTypes = $3fa3467f6e1cb10b$var$createConfigTypes($ldL1o.rootRedoclyConfigSchema);
module.exports.NormalizedConfigTypes = (0, $hlZ1o.normalizeTypes)(module.exports.ConfigTypes);

});
parcelRegister("6AwPe", function(module, exports) {

$parcel$export(module.exports, "rootRedoclyConfigSchema", () => (parcelRequire("ldL1o")).rootRedoclyConfigSchema);

var $aZWgX = parcelRequire("aZWgX");

var $ldL1o = parcelRequire("ldL1o");

var $bMP38 = parcelRequire("bMP38");
parcelRequire("apyaI");

var $8ZW2y = parcelRequire("8ZW2y");
 //# sourceMappingURL=index.js.map

});
parcelRegister("aZWgX", function(module, exports) {

var $hhbfh = parcelRequire("hhbfh");

var $9sHi2 = parcelRequire("9sHi2");

var $ldL1o = parcelRequire("ldL1o");
const $801ccd958f14323a$export$c65ec58ae53ff0c9 = {
    type: 'object',
    properties: {
        logo: (0, $hhbfh.themeConfigSchema).properties.logo,
        navbar: (0, $hhbfh.themeConfigSchema).properties.navbar,
        footer: (0, $hhbfh.themeConfigSchema).properties.footer,
        sidebar: (0, $hhbfh.themeConfigSchema).properties.sidebar,
        search: (0, $hhbfh.themeConfigSchema).properties.search,
        codeSnippet: (0, $hhbfh.themeConfigSchema).properties.codeSnippet,
        breadcrumbs: (0, $hhbfh.themeConfigSchema).properties.breadcrumbs,
        openapi: (0, $hhbfh.themeConfigSchema).properties.openapi,
        feedback: (0, $hhbfh.themeConfigSchema).properties.feedback,
        analytics: {
            type: 'object',
            properties: {
                ga: (0, $9sHi2.productGoogleAnalyticsConfigSchema)
            }
        }
    },
    additionalProperties: true,
    default: {}
};
const $801ccd958f14323a$export$e96cdef1ad6463fe = {
    $id: 'product-config-override',
    type: 'object',
    properties: Object.assign(Object.assign({}, $801ccd958f14323a$export$c65ec58ae53ff0c9.properties), {
        apis: {
            type: 'object',
            additionalProperties: (0, $ldL1o.apiConfigSchema)
        },
        /**
         * @deprecated left for backwards compatibility
         */ theme: $801ccd958f14323a$export$c65ec58ae53ff0c9
    }),
    additionalProperties: false
}; //# sourceMappingURL=product-override-schema.js.map

});
parcelRegister("hhbfh", function(module, exports) {

$parcel$export(module.exports, "themeConfigSchema", () => $c93cbf4a202c58bf$export$64b23d670803edd8);

var $8Sr13 = parcelRequire("8Sr13");

var $2cu8k = parcelRequire("2cu8k");

var $9sHi2 = parcelRequire("9sHi2");
const $c93cbf4a202c58bf$export$64b23d670803edd8 = {
    type: 'object',
    properties: {
        /**
         * @deprecated Should use `plugins` instead
         */ imports: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        logo: (0, $9sHi2.logoConfigSchema),
        navbar: (0, $9sHi2.navbarConfigSchema),
        products: (0, $9sHi2.productsConfigSchema),
        footer: (0, $9sHi2.footerConfigSchema),
        sidebar: (0, $9sHi2.sidebarConfigSchema),
        scripts: (0, $9sHi2.scriptsConfigSchema),
        links: (0, $9sHi2.linksConfigSchema),
        feedback: (0, $2cu8k.feedbackConfigSchema),
        search: (0, $9sHi2.searchConfigSchema),
        colorMode: (0, $9sHi2.colorModeConfigSchema),
        navigation: (0, $9sHi2.navigationConfigSchema),
        codeSnippet: (0, $9sHi2.codeSnippetConfigSchema),
        markdown: (0, $9sHi2.markdownConfigSchema),
        openapi: (0, $9sHi2.openapiConfigSchema),
        graphql: (0, $8Sr13.graphqlConfigSchema),
        analytics: (0, $9sHi2.analyticsConfigSchema),
        userMenu: (0, $9sHi2.userMenuConfigSchema),
        versionPicker: (0, $9sHi2.versionPickerConfigSchema),
        breadcrumbs: (0, $9sHi2.breadcrumbsConfigSchema),
        catalog: (0, $9sHi2.catalogsConfigSchema),
        scorecard: (0, $9sHi2.scorecardConfigSchema)
    },
    additionalProperties: true
};
const $c93cbf4a202c58bf$export$6dcfc01c50281aea = Object.assign(Object.assign({}, $c93cbf4a202c58bf$export$64b23d670803edd8), {
    additionalProperties: false
}); //# sourceMappingURL=default-theme-config-schema.js.map

});
parcelRegister("8Sr13", function(module, exports) {

$parcel$export(module.exports, "graphqlConfigSchema", () => $676852b588151e03$export$f4aa6417cffab8e4);

var $2cu8k = parcelRequire("2cu8k");
const $676852b588151e03$var$typeGroupConfig = {
    type: 'object',
    properties: {
        includeByName: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        excludeByName: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    additionalProperties: false
};
const $676852b588151e03$var$menuGroupConfig = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        items: $676852b588151e03$var$typeGroupConfig,
        queries: $676852b588151e03$var$typeGroupConfig,
        mutations: $676852b588151e03$var$typeGroupConfig,
        subscriptions: $676852b588151e03$var$typeGroupConfig,
        types: $676852b588151e03$var$typeGroupConfig,
        directives: $676852b588151e03$var$typeGroupConfig
    },
    required: [
        'name'
    ],
    additionalProperties: false
};
const $676852b588151e03$var$menuGroupingConfig = {
    type: 'object',
    properties: {
        requireExactGroups: {
            type: 'boolean'
        },
        groups: {
            type: 'array',
            items: $676852b588151e03$var$menuGroupConfig
        },
        otherItemsGroupName: {
            type: 'string'
        }
    },
    required: [
        'requireExactGroups',
        'groups',
        'otherItemsGroupName'
    ],
    additionalProperties: false
};
const $676852b588151e03$export$f4aa6417cffab8e4 = {
    type: 'object',
    properties: {
        hidePaginationButtons: {
            type: 'boolean'
        },
        menu: {
            type: 'object',
            properties: Object.assign({}, $676852b588151e03$var$menuGroupingConfig.properties),
            additionalProperties: false
        },
        sidebar: {
            type: 'object',
            properties: {
                hide: {
                    type: 'boolean'
                }
            }
        },
        apiLogo: {
            type: 'object',
            properties: {
                imageUrl: {
                    type: 'string'
                },
                href: {
                    type: 'string'
                },
                altText: {
                    type: 'string'
                },
                backgroundColor: {
                    type: 'string'
                }
            }
        },
        jsonSamplesDepth: {
            type: 'number'
        },
        samplesMaxInlineArgs: {
            type: 'number'
        },
        licenseKey: {
            type: 'string'
        },
        fieldExpandLevel: {
            type: 'number'
        },
        baseUrlPath: {
            type: 'string'
        },
        feedback: (0, $2cu8k.feedbackConfigSchema)
    },
    additionalProperties: false
}; //# sourceMappingURL=graphql-config-schema.js.map

});
parcelRegister("2cu8k", function(module, exports) {

$parcel$export(module.exports, "feedbackConfigSchema", () => $19a4139b722a148f$export$eca4227512b2e3ea);
const $19a4139b722a148f$var$reasonsBaseProperties = {
    hide: {
        type: 'boolean',
        default: false
    },
    component: {
        type: 'string',
        enum: [
            'radio',
            'checkbox'
        ],
        default: 'checkbox'
    },
    label: {
        type: 'string'
    },
    items: {
        type: 'array',
        items: {
            type: 'string'
        }
    }
};
const $19a4139b722a148f$export$4c3f3fd21f89d77b = {
    type: 'object',
    properties: $19a4139b722a148f$var$reasonsBaseProperties,
    additionalProperties: false
};
const $19a4139b722a148f$export$e77660e48cec47a5 = {
    type: 'object',
    properties: {
        hide: {
            type: 'boolean',
            default: false
        },
        label: {
            type: 'string'
        },
        placeholder: {
            type: 'string'
        }
    },
    additionalProperties: false
};
const $19a4139b722a148f$export$eca4227512b2e3ea = {
    type: 'object',
    properties: {
        hide: {
            type: 'boolean',
            default: false
        },
        type: {
            type: 'string',
            enum: [
                'rating',
                'sentiment',
                'comment',
                'reasons',
                'mood',
                'scale'
            ],
            default: 'sentiment'
        },
        settings: {
            type: 'object',
            properties: {
                label: {
                    type: 'string'
                },
                submitText: {
                    type: 'string'
                },
                buttonText: {
                    type: 'string'
                },
                component: {
                    type: 'string',
                    enum: [
                        'radio',
                        'checkbox'
                    ],
                    default: 'checkbox'
                },
                items: {
                    type: 'array',
                    items: {
                        type: 'string'
                    },
                    minItems: 1
                },
                leftScaleLabel: {
                    type: 'string'
                },
                rightScaleLabel: {
                    type: 'string'
                },
                reasons: {
                    type: 'object',
                    properties: Object.assign(Object.assign({}, $19a4139b722a148f$var$reasonsBaseProperties), {
                        like: $19a4139b722a148f$export$4c3f3fd21f89d77b,
                        dislike: $19a4139b722a148f$export$4c3f3fd21f89d77b,
                        satisfied: $19a4139b722a148f$export$4c3f3fd21f89d77b,
                        neutral: $19a4139b722a148f$export$4c3f3fd21f89d77b,
                        dissatisfied: $19a4139b722a148f$export$4c3f3fd21f89d77b
                    }),
                    additionalProperties: false
                },
                comment: {
                    type: 'object',
                    properties: {
                        hide: {
                            type: 'boolean',
                            default: false
                        },
                        label: {
                            type: 'string'
                        },
                        likeLabel: {
                            type: 'string'
                        },
                        dislikeLabel: {
                            type: 'string'
                        },
                        satisfiedLabel: {
                            type: 'string'
                        },
                        neutralLabel: {
                            type: 'string'
                        },
                        dissatisfiedLabel: {
                            type: 'string'
                        }
                    },
                    additionalProperties: false
                },
                optionalEmail: $19a4139b722a148f$export$e77660e48cec47a5
            },
            additionalProperties: false
        }
    },
    additionalProperties: false
}; //# sourceMappingURL=feedback-config-schema.js.map

});


parcelRegister("9sHi2", function(module, exports) {

$parcel$export(module.exports, "logoConfigSchema", () => $6e384f12a8427acf$export$e32a86963a5c8aa9);
$parcel$export(module.exports, "navbarConfigSchema", () => $6e384f12a8427acf$export$7937e47d476bdf8a);
$parcel$export(module.exports, "productsConfigSchema", () => $6e384f12a8427acf$export$5cfe2484c7f7434d);
$parcel$export(module.exports, "footerConfigSchema", () => $6e384f12a8427acf$export$ed07f423122d04bd);
$parcel$export(module.exports, "sidebarConfigSchema", () => $6e384f12a8427acf$export$4f85eaa5d25411a7);
$parcel$export(module.exports, "scriptsConfigSchema", () => $6e384f12a8427acf$export$7ce9b10c37f4eb15);
$parcel$export(module.exports, "linksConfigSchema", () => $6e384f12a8427acf$export$3d42f20929e85e4d);
$parcel$export(module.exports, "searchConfigSchema", () => $6e384f12a8427acf$export$a53a194c5a7cb9fd);
$parcel$export(module.exports, "colorModeConfigSchema", () => $6e384f12a8427acf$export$e7000bca2e3fcfda);
$parcel$export(module.exports, "navigationConfigSchema", () => $6e384f12a8427acf$export$f8c957037266d4ed);
$parcel$export(module.exports, "codeSnippetConfigSchema", () => $6e384f12a8427acf$export$f3a4f3810bd133c5);
$parcel$export(module.exports, "markdownConfigSchema", () => $6e384f12a8427acf$export$9354a8d799e67fd3);
$parcel$export(module.exports, "openapiConfigSchema", () => $6e384f12a8427acf$export$cff38da5e514b77a);
$parcel$export(module.exports, "productGoogleAnalyticsConfigSchema", () => $6e384f12a8427acf$export$ac13ece58df667ce);
$parcel$export(module.exports, "analyticsConfigSchema", () => $6e384f12a8427acf$export$8851414dd9bbfffa);
$parcel$export(module.exports, "userMenuConfigSchema", () => $6e384f12a8427acf$export$4753f9c841dd2f6f);
$parcel$export(module.exports, "versionPickerConfigSchema", () => $6e384f12a8427acf$export$95ca9e94d91404ae);
$parcel$export(module.exports, "breadcrumbsConfigSchema", () => $6e384f12a8427acf$export$388cf72df88010b8);
$parcel$export(module.exports, "catalogsConfigSchema", () => $6e384f12a8427acf$export$d1946c1b8e696200);
$parcel$export(module.exports, "scorecardConfigSchema", () => $6e384f12a8427acf$export$efa19447e0364b4f);

var $bMP38 = parcelRequire("bMP38");

var $bLYzY = parcelRequire("bLYzY");
const $6e384f12a8427acf$var$hideConfigSchema = {
    type: 'object',
    properties: {
        hide: {
            type: 'boolean'
        }
    },
    additionalProperties: false
};
const $6e384f12a8427acf$var$scriptConfigSchema = {
    type: 'object',
    properties: {
        src: {
            type: 'string'
        },
        async: {
            type: 'boolean'
        },
        crossorigin: {
            type: 'string'
        },
        defer: {
            type: 'boolean'
        },
        fetchpriority: {
            type: 'string'
        },
        integrity: {
            type: 'string'
        },
        module: {
            type: 'boolean'
        },
        nomodule: {
            type: 'boolean'
        },
        nonce: {
            type: 'string'
        },
        referrerpolicy: {
            type: 'string'
        },
        type: {
            type: 'string'
        }
    },
    required: [
        'src'
    ],
    additionalProperties: true
};
const $6e384f12a8427acf$var$navItemSchema = {
    type: 'object',
    properties: {
        page: {
            type: 'string'
        },
        directory: {
            type: 'string'
        },
        disconnect: {
            type: 'boolean',
            default: false
        },
        group: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        href: {
            type: 'string'
        },
        external: {
            type: 'boolean'
        },
        labelTranslationKey: {
            type: 'string'
        },
        groupTranslationKey: {
            type: 'string'
        },
        icon: {
            oneOf: [
                {
                    type: 'string'
                },
                {
                    type: 'object',
                    properties: {
                        srcSet: {
                            type: 'string'
                        }
                    },
                    required: [
                        'srcSet'
                    ]
                }
            ]
        },
        separator: {
            type: 'string'
        },
        separatorLine: {
            type: 'boolean'
        },
        linePosition: {
            type: 'string',
            enum: [
                'top',
                'bottom'
            ],
            default: 'top'
        },
        version: {
            type: 'string'
        },
        menuStyle: {
            type: 'string',
            enum: [
                'drilldown'
            ]
        },
        expanded: {
            type: 'string',
            const: 'always'
        },
        selectFirstItemOnExpand: {
            type: 'boolean'
        },
        flatten: {
            type: 'boolean'
        },
        linkedSidebars: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        // Allow users to eject the navbar and implement additional levels of nesting
        items: {
            type: 'array',
            items: {
                type: 'object',
                additionalProperties: true
            }
        }
    }
};
const $6e384f12a8427acf$export$f91686a25c128808 = {
    type: 'array',
    items: Object.assign(Object.assign({}, $6e384f12a8427acf$var$navItemSchema), {
        properties: Object.assign(Object.assign({}, $6e384f12a8427acf$var$navItemSchema.properties), {
            items: {
                type: 'array',
                items: $6e384f12a8427acf$var$navItemSchema
            }
        })
    })
};
const $6e384f12a8427acf$export$cccc39a032053f3e = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        icon: {
            type: 'string'
        },
        folder: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'folder'
    ]
};
const $6e384f12a8427acf$export$9c13d12c466e484e = {
    type: 'object',
    properties: {
        hide: {
            type: 'boolean',
            default: false
        },
        suggestions: {
            default: [],
            type: 'array',
            items: {
                type: 'string'
            }
        },
        prompt: {
            type: 'string'
        }
    },
    additionalProperties: false
};
const $6e384f12a8427acf$export$166c7a686ec00ce1 = {
    type: 'array',
    items: {
        type: 'object',
        required: [
            'name',
            'field',
            'type'
        ],
        properties: {
            name: {
                type: 'string'
            },
            field: {
                type: 'string'
            },
            type: {
                type: 'string',
                enum: [
                    'multi-select',
                    'select',
                    'tags'
                ]
            }
        },
        additionalProperties: false
    }
};
const $6e384f12a8427acf$export$990b58ddc4b2d0cc = {
    type: 'object',
    properties: Object.assign({
        facets: $6e384f12a8427acf$export$166c7a686ec00ce1
    }, $6e384f12a8427acf$var$hideConfigSchema.properties),
    additionalProperties: false
};
const $6e384f12a8427acf$var$searchSuggestedPageSchema = {
    type: 'object',
    properties: {
        page: {
            type: 'string'
        },
        label: {
            type: 'string'
        },
        labelTranslationKey: {
            type: 'string'
        }
    },
    required: [
        'page'
    ]
};
const $6e384f12a8427acf$export$e32a86963a5c8aa9 = {
    type: 'object',
    properties: {
        image: {
            type: 'string'
        },
        srcSet: {
            type: 'string'
        },
        altText: {
            type: 'string'
        },
        link: {
            type: 'string'
        },
        favicon: {
            type: 'string'
        }
    },
    additionalProperties: false
};
const $6e384f12a8427acf$export$7937e47d476bdf8a = {
    type: 'object',
    properties: Object.assign({
        items: $6e384f12a8427acf$export$f91686a25c128808
    }, $6e384f12a8427acf$var$hideConfigSchema.properties),
    additionalProperties: false
};
const $6e384f12a8427acf$export$5cfe2484c7f7434d = {
    type: 'object',
    additionalProperties: $6e384f12a8427acf$export$cccc39a032053f3e
};
const $6e384f12a8427acf$export$ed07f423122d04bd = {
    type: 'object',
    properties: Object.assign({
        items: $6e384f12a8427acf$export$f91686a25c128808,
        copyrightText: {
            type: 'string'
        },
        logo: $6e384f12a8427acf$var$hideConfigSchema
    }, $6e384f12a8427acf$var$hideConfigSchema.properties),
    additionalProperties: false
};
const $6e384f12a8427acf$export$4f85eaa5d25411a7 = {
    type: 'object',
    properties: Object.assign({
        separatorLine: {
            type: 'boolean'
        },
        linePosition: {
            type: 'string',
            enum: [
                'top',
                'bottom'
            ],
            default: 'bottom'
        }
    }, $6e384f12a8427acf$var$hideConfigSchema.properties),
    additionalProperties: false
};
const $6e384f12a8427acf$export$7ce9b10c37f4eb15 = {
    type: 'object',
    properties: {
        head: {
            type: 'array',
            items: $6e384f12a8427acf$var$scriptConfigSchema
        },
        body: {
            type: 'array',
            items: $6e384f12a8427acf$var$scriptConfigSchema
        }
    },
    additionalProperties: false
};
const $6e384f12a8427acf$export$3d42f20929e85e4d = {
    type: 'array',
    items: {
        type: 'object',
        properties: {
            href: {
                type: 'string'
            },
            as: {
                type: 'string'
            },
            crossorigin: {
                type: 'string'
            },
            fetchpriority: {
                type: 'string'
            },
            hreflang: {
                type: 'string'
            },
            imagesizes: {
                type: 'string'
            },
            imagesrcset: {
                type: 'string'
            },
            integrity: {
                type: 'string'
            },
            media: {
                type: 'string'
            },
            prefetch: {
                type: 'string'
            },
            referrerpolicy: {
                type: 'string'
            },
            rel: {
                type: 'string'
            },
            sizes: {
                type: 'string'
            },
            title: {
                type: 'string'
            },
            type: {
                type: 'string'
            }
        },
        required: [
            'href'
        ],
        additionalProperties: true
    }
};
const $6e384f12a8427acf$export$a53a194c5a7cb9fd = {
    type: 'object',
    properties: Object.assign({
        engine: {
            type: 'string',
            enum: [
                'flexsearch',
                'typesense'
            ],
            default: 'flexsearch'
        },
        ai: $6e384f12a8427acf$export$9c13d12c466e484e,
        filters: $6e384f12a8427acf$export$990b58ddc4b2d0cc,
        placement: {
            type: 'string',
            default: 'navbar'
        },
        shortcuts: {
            type: 'array',
            items: {
                type: 'string'
            },
            default: [
                '/'
            ]
        },
        suggestedPages: {
            type: 'array',
            items: $6e384f12a8427acf$var$searchSuggestedPageSchema
        }
    }, $6e384f12a8427acf$var$hideConfigSchema.properties),
    additionalProperties: false
};
const $6e384f12a8427acf$export$e7000bca2e3fcfda = {
    type: 'object',
    properties: Object.assign({
        ignoreDetection: {
            type: 'boolean'
        },
        modes: {
            type: 'array',
            items: {
                type: 'string'
            },
            default: [
                'light',
                'dark'
            ]
        }
    }, $6e384f12a8427acf$var$hideConfigSchema.properties),
    additionalProperties: false
};
const $6e384f12a8427acf$export$f8c957037266d4ed = {
    type: 'object',
    properties: {
        nextButton: {
            type: 'object',
            properties: Object.assign({
                text: {
                    type: 'string',
                    default: 'Next page'
                }
            }, $6e384f12a8427acf$var$hideConfigSchema.properties),
            additionalProperties: false,
            default: {}
        },
        previousButton: {
            type: 'object',
            properties: Object.assign({
                text: {
                    type: 'string',
                    default: 'Previous page'
                }
            }, $6e384f12a8427acf$var$hideConfigSchema.properties),
            additionalProperties: false,
            default: {}
        }
    },
    additionalProperties: false
};
const $6e384f12a8427acf$export$f3a4f3810bd133c5 = {
    type: 'object',
    properties: {
        elementFormat: {
            type: 'string',
            default: 'icon'
        },
        copy: {
            type: 'object',
            properties: Object.assign({}, $6e384f12a8427acf$var$hideConfigSchema.properties),
            additionalProperties: false,
            default: {
                hide: false
            }
        },
        report: {
            type: 'object',
            properties: Object.assign({
                tooltipText: {
                    type: 'string'
                },
                buttonText: {
                    type: 'string'
                },
                label: {
                    type: 'string'
                }
            }, $6e384f12a8427acf$var$hideConfigSchema.properties),
            additionalProperties: false,
            default: {
                hide: false
            }
        },
        expand: {
            type: 'object',
            properties: Object.assign({}, $6e384f12a8427acf$var$hideConfigSchema.properties),
            additionalProperties: false,
            default: {
                hide: false
            }
        },
        collapse: {
            type: 'object',
            properties: Object.assign({}, $6e384f12a8427acf$var$hideConfigSchema.properties),
            additionalProperties: false,
            default: {
                hide: false
            }
        }
    },
    additionalProperties: false
};
const $6e384f12a8427acf$export$9354a8d799e67fd3 = {
    type: 'object',
    properties: {
        frontMatterKeysToResolve: {
            type: 'array',
            items: {
                type: 'string'
            },
            default: [
                'image',
                'links'
            ]
        },
        partialsFolders: {
            type: 'array',
            items: {
                type: 'string'
            },
            default: [
                '_partials'
            ]
        },
        lastUpdatedBlock: {
            type: 'object',
            properties: Object.assign({
                format: {
                    type: 'string',
                    enum: [
                        'timeago',
                        'iso',
                        'long',
                        'short'
                    ],
                    default: 'timeago'
                },
                locale: {
                    type: 'string'
                }
            }, $6e384f12a8427acf$var$hideConfigSchema.properties),
            additionalProperties: false,
            default: {}
        },
        toc: {
            type: 'object',
            properties: Object.assign({
                header: {
                    type: 'string',
                    default: 'On this page'
                },
                depth: {
                    type: 'integer',
                    default: 3,
                    minimum: 1
                }
            }, $6e384f12a8427acf$var$hideConfigSchema.properties),
            additionalProperties: false,
            default: {}
        },
        editPage: {
            type: 'object',
            properties: Object.assign({
                baseUrl: {
                    type: 'string'
                }
            }, $6e384f12a8427acf$var$hideConfigSchema.properties),
            additionalProperties: false,
            default: {}
        }
    },
    additionalProperties: false,
    default: {}
};
const $6e384f12a8427acf$export$cff38da5e514b77a = Object.assign(Object.assign({}, (0, $bMP38.redocConfigSchema)), {
    properties: Object.assign(Object.assign({}, (0, $bMP38.redocConfigSchema).properties), (0, $bLYzY.deprecatedRefDocsSchema).properties)
});
const $6e384f12a8427acf$var$adobeAnalyticsConfigSchema = {
    type: 'object',
    properties: {
        includeInDevelopment: {
            type: 'boolean'
        },
        scriptUrl: {
            type: 'string'
        },
        pageViewEventName: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'scriptUrl'
    ]
};
const $6e384f12a8427acf$export$26979ba33160e9dc = {
    type: 'object',
    properties: {
        includeInDevelopment: {
            type: 'boolean'
        },
        apiKey: {
            type: 'string'
        },
        head: {
            type: 'boolean'
        },
        respectDNT: {
            type: 'boolean'
        },
        exclude: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        outboundClickEventName: {
            type: 'string'
        },
        pageViewEventName: {
            type: 'string'
        },
        amplitudeConfig: {
            type: 'object',
            additionalProperties: true
        }
    },
    additionalProperties: false,
    required: [
        'apiKey'
    ]
};
const $6e384f12a8427acf$export$e9c91a5e797e6d39 = {
    type: 'object',
    properties: {
        includeInDevelopment: {
            type: 'boolean'
        },
        orgId: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'orgId'
    ]
};
const $6e384f12a8427acf$export$574042c16b172be = {
    type: 'object',
    properties: {
        includeInDevelopment: {
            type: 'boolean'
        },
        appId: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'appId'
    ]
};
const $6e384f12a8427acf$export$a6130a6cf231d174 = {
    type: 'object',
    properties: {
        includeInDevelopment: {
            type: 'boolean'
        },
        writeKey: {
            type: 'string',
            minLength: 10
        },
        trackPage: {
            type: 'boolean'
        },
        dataPlaneUrl: {
            type: 'string'
        },
        controlPlaneUrl: {
            type: 'string'
        },
        sdkUrl: {
            type: 'string'
        },
        loadOptions: {
            type: 'object',
            additionalProperties: true
        }
    },
    additionalProperties: false,
    required: [
        'writeKey'
    ]
};
const $6e384f12a8427acf$export$fbb2505462c39cfe = {
    type: 'object',
    properties: {
        includeInDevelopment: {
            type: 'boolean'
        },
        writeKey: {
            type: 'string',
            minLength: 10
        },
        trackPage: {
            type: 'boolean'
        },
        includeTitleInPageCall: {
            type: 'boolean'
        },
        host: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'writeKey'
    ]
};
const $6e384f12a8427acf$export$b9b4d7c81ef8c701 = {
    type: 'object',
    properties: {
        includeInDevelopment: {
            type: 'boolean'
        },
        trackingId: {
            type: 'string'
        },
        gtmAuth: {
            type: 'string'
        },
        gtmPreview: {
            type: 'string'
        },
        defaultDataLayer: {},
        dataLayerName: {
            type: 'string'
        },
        enableWebVitalsTracking: {
            type: 'boolean'
        },
        selfHostedOrigin: {
            type: 'string'
        },
        pageViewEventName: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'trackingId'
    ]
};
const $6e384f12a8427acf$export$ac13ece58df667ce = {
    type: 'object',
    properties: {
        includeInDevelopment: {
            type: 'boolean'
        },
        trackingId: {
            type: 'string'
        },
        conversionId: {
            type: 'string'
        },
        floodlightId: {
            type: 'string'
        },
        optimizeId: {
            type: 'string'
        },
        exclude: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    additionalProperties: false,
    required: [
        'trackingId'
    ]
};
const $6e384f12a8427acf$export$442b217ab1b4deba = {
    type: 'object',
    properties: {
        includeInDevelopment: {
            type: 'boolean'
        },
        trackingId: {
            type: 'string'
        },
        conversionId: {
            type: 'string'
        },
        floodlightId: {
            type: 'string'
        },
        head: {
            type: 'boolean'
        },
        respectDNT: {
            type: 'boolean'
        },
        exclude: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        optimizeId: {
            type: 'string'
        },
        anonymizeIp: {
            type: 'boolean'
        },
        cookieExpires: {
            type: 'number'
        },
        // All enabled tracking configs
        trackers: {
            type: 'object',
            additionalProperties: $6e384f12a8427acf$export$ac13ece58df667ce
        }
    },
    additionalProperties: false,
    required: [
        'trackingId'
    ]
};
const $6e384f12a8427acf$export$8851414dd9bbfffa = {
    type: 'object',
    properties: {
        adobe: $6e384f12a8427acf$var$adobeAnalyticsConfigSchema,
        amplitude: $6e384f12a8427acf$export$26979ba33160e9dc,
        fullstory: $6e384f12a8427acf$export$e9c91a5e797e6d39,
        heap: $6e384f12a8427acf$export$574042c16b172be,
        rudderstack: $6e384f12a8427acf$export$a6130a6cf231d174,
        segment: $6e384f12a8427acf$export$fbb2505462c39cfe,
        gtm: $6e384f12a8427acf$export$b9b4d7c81ef8c701,
        ga: $6e384f12a8427acf$export$442b217ab1b4deba
    }
};
const $6e384f12a8427acf$export$4753f9c841dd2f6f = {
    type: 'object',
    properties: Object.assign({
        items: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    label: {
                        type: 'string'
                    },
                    external: {
                        type: 'boolean'
                    },
                    link: {
                        type: 'string'
                    },
                    separatorLine: {
                        type: 'boolean'
                    }
                },
                additionalProperties: true
            },
            default: []
        },
        hideLoginButton: {
            type: 'boolean'
        }
    }, $6e384f12a8427acf$var$hideConfigSchema.properties),
    additionalProperties: false
};
const $6e384f12a8427acf$export$95ca9e94d91404ae = {
    type: 'object',
    properties: {
        hide: {
            type: 'boolean'
        },
        showForUnversioned: {
            type: 'boolean'
        }
    }
};
const $6e384f12a8427acf$export$388cf72df88010b8 = {
    type: 'object',
    properties: {
        hide: {
            type: 'boolean'
        },
        prefixItems: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    label: {
                        type: 'string'
                    },
                    labelTranslationKey: {
                        type: 'string'
                    },
                    page: {
                        type: 'string'
                    }
                },
                additionalProperties: false,
                default: {}
            }
        }
    },
    additionalProperties: false
};
const $6e384f12a8427acf$export$38b3897e452bb3fd = {
    type: 'object',
    additionalProperties: false,
    required: [
        'title',
        'property'
    ],
    properties: {
        type: {
            type: 'string',
            enum: [
                'select',
                'checkboxes',
                'date-range'
            ],
            default: 'checkboxes'
        },
        title: {
            type: 'string'
        },
        titleTranslationKey: {
            type: 'string'
        },
        property: {
            type: 'string'
        },
        parentFilter: {
            type: 'string'
        },
        valuesMapping: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        missingCategoryName: {
            type: 'string'
        },
        missingCategoryNameTranslationKey: {
            type: 'string'
        },
        options: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    }
};
const $6e384f12a8427acf$export$b4806802a48ad473 = {
    type: 'object',
    additionalProperties: true,
    required: [
        'slug',
        'items'
    ],
    properties: {
        slug: {
            type: 'string'
        },
        filters: {
            type: 'array',
            items: $6e384f12a8427acf$export$38b3897e452bb3fd
        },
        groupByFirstFilter: {
            type: 'boolean'
        },
        filterValuesCasing: {
            type: 'string',
            enum: [
                'sentence',
                'original',
                'lowercase',
                'uppercase'
            ]
        },
        items: $6e384f12a8427acf$export$f91686a25c128808,
        requiredPermission: {
            type: 'string'
        },
        separateVersions: {
            type: 'boolean'
        },
        title: {
            type: 'string'
        },
        titleTranslationKey: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        descriptionTranslationKey: {
            type: 'string'
        }
    }
};
const $6e384f12a8427acf$export$d1946c1b8e696200 = {
    type: 'object',
    patternProperties: {
        '.*': $6e384f12a8427acf$export$b4806802a48ad473
    }
};
const $6e384f12a8427acf$export$efa19447e0364b4f = {
    type: 'object',
    additionalProperties: true,
    required: [],
    properties: {
        /**
         * @deprecated Should use `reunite.ignoreLint` instead
         */ ignoreNonCompliant: {
            type: 'boolean',
            default: false
        },
        teamMetadataProperty: {
            type: 'object',
            properties: {
                property: {
                    type: 'string'
                },
                label: {
                    type: 'string'
                },
                default: {
                    type: 'string'
                }
            }
        },
        levels: {
            type: 'array',
            items: {
                type: 'object',
                required: [
                    'name'
                ],
                properties: {
                    name: {
                        type: 'string'
                    },
                    color: {
                        type: 'string'
                    },
                    extends: {
                        type: 'array',
                        items: {
                            type: 'string'
                        }
                    },
                    rules: {
                        type: 'object',
                        additionalProperties: {
                            oneOf: [
                                {
                                    type: 'string'
                                },
                                {
                                    type: 'object'
                                }
                            ]
                        }
                    }
                },
                additionalProperties: false
            }
        },
        targets: {
            type: 'array',
            items: {
                type: 'object',
                required: [
                    'where'
                ],
                properties: {
                    minimumLevel: {
                        type: 'string'
                    },
                    rules: {
                        type: 'object',
                        additionalProperties: true
                    },
                    where: {
                        type: 'object',
                        required: [
                            'metadata'
                        ],
                        properties: {
                            metadata: {
                                type: 'object',
                                additionalProperties: {
                                    type: 'string'
                                }
                            }
                        },
                        additionalProperties: false
                    }
                },
                additionalProperties: false
            }
        },
        ignore: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    }
}; //# sourceMappingURL=ex-theme-config-schemas.js.map

});
parcelRegister("bMP38", function(module, exports) {

$parcel$export(module.exports, "redocConfigSchema", () => $894bc6c3ff139530$export$8a7c349dca92653);

var $2cu8k = parcelRequire("2cu8k");
const $894bc6c3ff139530$var$codeSamplesConfigSchema = {
    type: 'object',
    properties: {
        languages: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    lang: {
                        type: 'string',
                        enum: [
                            'curl',
                            'JavaScript',
                            'Node.js',
                            'Python',
                            'Java8+Apache',
                            'Java',
                            'C#',
                            'C#+Newtonsoft',
                            'PHP',
                            'Go',
                            'Ruby',
                            'R',
                            'Payload'
                        ]
                    },
                    label: {
                        type: 'string'
                    },
                    options: {
                        type: 'object',
                        properties: {
                            indent: {
                                type: 'string'
                            },
                            withImports: {
                                type: 'boolean'
                            },
                            withComments: {
                                type: 'boolean'
                            },
                            binary: {
                                type: 'boolean'
                            },
                            credentials: {
                                type: 'string',
                                enum: [
                                    'omit',
                                    'same-origin',
                                    'include'
                                ]
                            }
                        },
                        additionalProperties: false
                    }
                },
                required: [
                    'lang'
                ],
                additionalProperties: false
            }
        },
        skipOptionalParameters: {
            type: 'boolean'
        },
        withOAuth2Call: {
            type: 'boolean'
        }
    },
    required: [
        'languages'
    ],
    additionalProperties: false
};
const $894bc6c3ff139530$var$downloadUrlsSchema = {
    type: 'array',
    items: {
        type: 'object',
        properties: {
            title: {
                type: 'string'
            },
            url: {
                type: 'string'
            }
        },
        required: [
            'url'
        ],
        additionalProperties: false
    }
};
const $894bc6c3ff139530$export$8a7c349dca92653 = {
    type: 'object',
    properties: {
        licenseKey: {
            type: 'string'
        },
        hideLoading: {
            type: 'boolean'
        },
        disableRouter: {
            type: 'boolean'
        },
        hideSidebar: {
            type: 'boolean'
        },
        feedback: (0, $2cu8k.feedbackConfigSchema),
        hideReplay: {
            type: 'boolean'
        },
        oAuth2RedirectURI: {
            type: 'string',
            nullable: true
        },
        corsProxyUrl: {
            type: 'string'
        },
        sortRequiredPropsFirst: {
            type: 'boolean'
        },
        sanitize: {
            type: 'boolean'
        },
        hideDownloadButtons: {
            type: 'boolean'
        },
        downloadUrls: $894bc6c3ff139530$var$downloadUrlsSchema,
        onlyRequiredInSamples: {
            type: 'boolean'
        },
        generatedSamplesMaxDepth: {
            oneOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ]
        },
        showExtensions: {
            oneOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'string'
                },
                {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                }
            ]
        },
        hideSchemaTitles: {
            type: 'boolean'
        },
        jsonSamplesExpandLevel: {
            oneOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ]
        },
        schemasExpansionLevel: {
            oneOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ]
        },
        mockServer: {
            type: 'object',
            properties: {
                url: {
                    type: 'string'
                },
                position: {
                    type: 'string',
                    enum: [
                        'first',
                        'last',
                        'replace',
                        'off'
                    ]
                },
                description: {
                    type: 'string'
                }
            }
        },
        maxDisplayedEnumValues: {
            type: 'number'
        },
        schemaDefinitionsTagName: {
            type: 'string'
        },
        layout: {
            type: 'string',
            enum: [
                'stacked',
                'three-panel'
            ]
        },
        hideInfoMetadata: {
            type: 'boolean'
        },
        events: {
            type: 'object'
        },
        skipBundle: {
            type: 'boolean'
        },
        routingBasePath: {
            type: 'string'
        },
        codeSamples: $894bc6c3ff139530$var$codeSamplesConfigSchema,
        ignoreNamedSchemas: {
            oneOf: [
                {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                },
                {
                    type: 'string'
                }
            ]
        },
        hidePropertiesPrefix: {
            type: 'boolean'
        },
        excludeFromSearch: {
            type: 'boolean'
        }
    },
    additionalProperties: false
}; //# sourceMappingURL=redoc-config-schema.js.map

});

parcelRegister("bLYzY", function(module, exports) {

$parcel$export(module.exports, "deprecatedRefDocsSchema", () => $89231342ddbbf0db$export$abccb877ab0c9c14);
// Needed for supporting deprecated Reference Docs config options
// Transferred from https://github.com/Redocly/redocly-cli/blob/main/packages/core/src/types/redocly-yaml.ts
const $89231342ddbbf0db$var$ConfigLanguage = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        lang: {
            enum: [
                'curl',
                'C#',
                'Go',
                'Java',
                'Java8+Apache',
                'JavaScript',
                'Node.js',
                'PHP',
                'Python',
                'R',
                'Ruby'
            ]
        }
    },
    required: [
        'lang'
    ]
};
const $89231342ddbbf0db$var$ConfigLabels = {
    type: 'object',
    properties: {
        enum: {
            type: 'string'
        },
        enumSingleValue: {
            type: 'string'
        },
        enumArray: {
            type: 'string'
        },
        default: {
            type: 'string'
        },
        deprecated: {
            type: 'string'
        },
        example: {
            type: 'string'
        },
        examples: {
            type: 'string'
        },
        nullable: {
            type: 'string'
        },
        recursive: {
            type: 'string'
        },
        arrayOf: {
            type: 'string'
        },
        webhook: {
            type: 'string'
        },
        authorizations: {
            type: 'string'
        },
        tryItAuthBasicUsername: {
            type: 'string'
        },
        tryItAuthBasicPassword: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$CommonConfigSidebarLinks = {
    type: 'object',
    properties: {
        label: {
            type: 'string'
        },
        link: {
            type: 'string'
        },
        target: {
            type: 'string'
        }
    },
    required: [
        'label',
        'link'
    ]
};
const $89231342ddbbf0db$var$ConfigSidebarLinks = {
    type: 'object',
    properties: {
        beforeInfo: {
            type: 'array',
            items: $89231342ddbbf0db$var$CommonConfigSidebarLinks
        },
        end: {
            type: 'array',
            items: $89231342ddbbf0db$var$CommonConfigSidebarLinks
        }
    }
};
const $89231342ddbbf0db$var$CommonThemeColors = {
    type: 'object',
    properties: {
        main: {
            type: 'string'
        },
        light: {
            type: 'string'
        },
        dark: {
            type: 'string'
        },
        contrastText: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$CommonColorProps = {
    type: 'object',
    properties: {
        backgroundColor: {
            type: 'string'
        },
        borderColor: {
            type: 'string'
        },
        color: {
            type: 'string'
        },
        tabTextColor: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$BorderThemeColors = {
    type: 'object',
    properties: $89231342ddbbf0db$var$pickObjectProps($89231342ddbbf0db$var$CommonThemeColors.properties, [
        'light',
        'dark'
    ])
};
const $89231342ddbbf0db$var$HttpColors = {
    type: 'object',
    properties: {
        basic: {
            type: 'string'
        },
        delete: {
            type: 'string'
        },
        get: {
            type: 'string'
        },
        head: {
            type: 'string'
        },
        link: {
            type: 'string'
        },
        options: {
            type: 'string'
        },
        patch: {
            type: 'string'
        },
        post: {
            type: 'string'
        },
        put: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$ResponseColors = {
    type: 'object',
    properties: {
        error: $89231342ddbbf0db$var$CommonColorProps,
        info: $89231342ddbbf0db$var$CommonColorProps,
        redirect: $89231342ddbbf0db$var$CommonColorProps,
        success: $89231342ddbbf0db$var$CommonColorProps
    }
};
const $89231342ddbbf0db$var$SecondaryColors = {
    type: 'object',
    properties: $89231342ddbbf0db$var$omitObjectProps($89231342ddbbf0db$var$CommonThemeColors.properties, [
        'dark'
    ])
};
const $89231342ddbbf0db$var$TextThemeColors = {
    type: 'object',
    properties: {
        primary: {
            type: 'string'
        },
        secondary: {
            type: 'string'
        },
        light: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$ThemeColors = {
    type: 'object',
    properties: {
        accent: $89231342ddbbf0db$var$CommonThemeColors,
        border: $89231342ddbbf0db$var$BorderThemeColors,
        error: $89231342ddbbf0db$var$CommonThemeColors,
        http: $89231342ddbbf0db$var$HttpColors,
        primary: $89231342ddbbf0db$var$CommonThemeColors,
        responses: $89231342ddbbf0db$var$ResponseColors,
        secondary: $89231342ddbbf0db$var$SecondaryColors,
        success: $89231342ddbbf0db$var$CommonThemeColors,
        text: $89231342ddbbf0db$var$TextThemeColors,
        tonalOffset: {
            type: 'number'
        },
        warning: $89231342ddbbf0db$var$CommonThemeColors
    }
};
const $89231342ddbbf0db$var$SizeProps = {
    type: 'object',
    properties: {
        fontSize: {
            type: 'string'
        },
        padding: {
            type: 'string'
        },
        minWidth: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$Sizes = {
    type: 'object',
    properties: {
        small: $89231342ddbbf0db$var$SizeProps,
        medium: $89231342ddbbf0db$var$SizeProps,
        large: $89231342ddbbf0db$var$SizeProps,
        xlarge: $89231342ddbbf0db$var$SizeProps
    }
};
const $89231342ddbbf0db$var$FontConfig = {
    type: 'object',
    properties: {
        fontFamily: {
            type: 'string'
        },
        fontSize: {
            type: 'string'
        },
        fontWeight: {
            type: 'string'
        },
        lineHeight: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$ButtonsConfig = {
    type: 'object',
    properties: Object.assign(Object.assign({}, $89231342ddbbf0db$var$omitObjectProps($89231342ddbbf0db$var$FontConfig.properties, [
        'fontSize',
        'lineHeight'
    ])), {
        borderRadius: {
            type: 'string'
        },
        hoverStyle: {
            type: 'string'
        },
        boxShadow: {
            type: 'string'
        },
        hoverBoxShadow: {
            type: 'string'
        },
        sizes: $89231342ddbbf0db$var$Sizes
    })
};
const $89231342ddbbf0db$var$BadgeFontConfig = {
    type: 'object',
    properties: $89231342ddbbf0db$var$pickObjectProps($89231342ddbbf0db$var$FontConfig.properties, [
        'fontSize',
        'lineHeight'
    ])
};
const $89231342ddbbf0db$var$BadgeSizes = {
    type: 'object',
    properties: {
        medium: $89231342ddbbf0db$var$BadgeFontConfig,
        small: $89231342ddbbf0db$var$BadgeFontConfig
    }
};
const $89231342ddbbf0db$var$HttpBadgesConfig = {
    type: 'object',
    properties: Object.assign(Object.assign({}, $89231342ddbbf0db$var$omitObjectProps($89231342ddbbf0db$var$FontConfig.properties, [
        'fontSize',
        'lineHeight'
    ])), {
        borderRadius: {
            type: 'string'
        },
        color: {
            type: 'string'
        },
        sizes: $89231342ddbbf0db$var$BadgeSizes
    })
};
const $89231342ddbbf0db$var$LabelControls = {
    type: 'object',
    properties: {
        top: {
            type: 'string'
        },
        width: {
            type: 'string'
        },
        height: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$Panels = {
    type: 'object',
    properties: {
        borderRadius: {
            type: 'string'
        },
        backgroundColor: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$TryItButton = {
    type: 'object',
    properties: {
        fullWidth: {
            type: 'boolean'
        }
    }
};
const $89231342ddbbf0db$var$ConfigThemeComponents = {
    type: 'object',
    properties: {
        buttons: $89231342ddbbf0db$var$ButtonsConfig,
        httpBadges: $89231342ddbbf0db$var$HttpBadgesConfig,
        layoutControls: $89231342ddbbf0db$var$LabelControls,
        panels: $89231342ddbbf0db$var$Panels,
        tryItButton: $89231342ddbbf0db$var$TryItButton,
        tryItSendButton: $89231342ddbbf0db$var$TryItButton
    }
};
const $89231342ddbbf0db$var$Breakpoints = {
    type: 'object',
    properties: {
        small: {
            type: 'string'
        },
        medium: {
            type: 'string'
        },
        large: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$StackedConfig = {
    type: 'object',
    properties: {
        maxWidth: $89231342ddbbf0db$var$Breakpoints
    }
};
const $89231342ddbbf0db$var$ThreePanelConfig = {
    type: 'object',
    properties: {
        maxWidth: $89231342ddbbf0db$var$Breakpoints,
        middlePanelMaxWidth: $89231342ddbbf0db$var$Breakpoints
    }
};
const $89231342ddbbf0db$var$Layout = {
    type: 'object',
    properties: {
        showDarkRightPanel: {
            type: 'boolean'
        },
        stacked: $89231342ddbbf0db$var$StackedConfig,
        'three-panel': $89231342ddbbf0db$var$ThreePanelConfig
    }
};
const $89231342ddbbf0db$var$SchemaColorsConfig = {
    type: 'object',
    properties: {
        backgroundColor: {
            type: 'string'
        },
        border: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$ConfigThemeSchema = {
    type: 'object',
    properties: {
        breakFieldNames: {
            type: 'boolean'
        },
        caretColor: {
            type: 'string'
        },
        caretSize: {
            type: 'string'
        },
        constraints: $89231342ddbbf0db$var$SchemaColorsConfig,
        defaultDetailsWidth: {
            type: 'string'
        },
        examples: $89231342ddbbf0db$var$SchemaColorsConfig,
        labelsTextSize: {
            type: 'string'
        },
        linesColor: {
            type: 'string'
        },
        nestedBackground: {
            type: 'string'
        },
        nestingSpacing: {
            type: 'string'
        },
        requireLabelColor: {
            type: 'string'
        },
        typeNameColor: {
            type: 'string'
        },
        typeTitleColor: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$GroupItemsConfig = {
    type: 'object',
    properties: {
        subItemsColor: {
            type: 'string'
        },
        textTransform: {
            type: 'string'
        },
        fontWeight: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$Level1Items = {
    type: 'object',
    properties: $89231342ddbbf0db$var$pickObjectProps($89231342ddbbf0db$var$GroupItemsConfig.properties, [
        'textTransform'
    ])
};
const $89231342ddbbf0db$var$SpacingConfig = {
    type: 'object',
    properties: {
        unit: {
            type: 'number'
        },
        paddingHorizontal: {
            type: 'string'
        },
        paddingVertical: {
            type: 'string'
        },
        offsetTop: {
            type: 'string'
        },
        offsetLeft: {
            type: 'string'
        },
        offsetNesting: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$Sidebar = {
    type: 'object',
    properties: Object.assign(Object.assign({}, $89231342ddbbf0db$var$omitObjectProps($89231342ddbbf0db$var$FontConfig.properties, [
        'fontWeight',
        'lineHeight'
    ])), {
        activeBgColor: {
            type: 'string'
        },
        activeTextColor: {
            type: 'string'
        },
        backgroundColor: {
            type: 'string'
        },
        borderRadius: {
            type: 'string'
        },
        breakPath: {
            type: 'boolean'
        },
        caretColor: {
            type: 'string'
        },
        caretSize: {
            type: 'string'
        },
        groupItems: $89231342ddbbf0db$var$GroupItemsConfig,
        level1items: $89231342ddbbf0db$var$Level1Items,
        rightLineColor: {
            type: 'string'
        },
        separatorLabelColor: {
            type: 'string'
        },
        showAtBreakpoint: {
            type: 'string'
        },
        spacing: $89231342ddbbf0db$var$SpacingConfig,
        textColor: {
            type: 'string'
        },
        width: {
            type: 'string'
        }
    })
};
const $89231342ddbbf0db$var$Heading = {
    type: 'object',
    properties: Object.assign(Object.assign({}, $89231342ddbbf0db$var$FontConfig.properties), {
        color: {
            type: 'string'
        },
        transform: {
            type: 'string'
        }
    })
};
const $89231342ddbbf0db$var$CodeConfig = {
    type: 'object',
    properties: Object.assign(Object.assign({}, $89231342ddbbf0db$var$FontConfig.properties), {
        backgroundColor: {
            type: 'string'
        },
        color: {
            type: 'string'
        },
        wordBreak: {
            type: 'string',
            enum: [
                'break-all',
                'break-word',
                'keep-all',
                'normal',
                'revert',
                'unset',
                'inherit',
                'initial'
            ]
        },
        wrap: {
            type: 'boolean'
        }
    })
};
const $89231342ddbbf0db$var$HeadingsConfig = {
    type: 'object',
    properties: $89231342ddbbf0db$var$omitObjectProps($89231342ddbbf0db$var$FontConfig.properties, [
        'fontSize'
    ])
};
const $89231342ddbbf0db$var$LinksConfig = {
    type: 'object',
    properties: {
        color: {
            type: 'string'
        },
        hover: {
            type: 'string'
        },
        textDecoration: {
            type: 'string'
        },
        hoverTextDecoration: {
            type: 'string'
        },
        visited: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$Typography = {
    type: 'object',
    properties: Object.assign(Object.assign({
        code: $89231342ddbbf0db$var$CodeConfig,
        fieldName: $89231342ddbbf0db$var$FontConfig
    }, $89231342ddbbf0db$var$pickObjectProps($89231342ddbbf0db$var$FontConfig.properties, [
        'fontSize',
        'fontFamily'
    ])), {
        fontWeightBold: {
            type: 'string'
        },
        fontWeightLight: {
            type: 'string'
        },
        fontWeightRegular: {
            type: 'string'
        },
        heading1: $89231342ddbbf0db$var$Heading,
        heading2: $89231342ddbbf0db$var$Heading,
        heading3: $89231342ddbbf0db$var$Heading,
        headings: $89231342ddbbf0db$var$HeadingsConfig,
        lineHeight: {
            type: 'string'
        },
        links: $89231342ddbbf0db$var$LinksConfig,
        optimizeSpeed: {
            type: 'boolean'
        },
        rightPanelHeading: $89231342ddbbf0db$var$Heading,
        smoothing: {
            type: 'string',
            enum: [
                'auto',
                'none',
                'antialiased',
                'subpixel-antialiased',
                'grayscale'
            ]
        }
    })
};
const $89231342ddbbf0db$var$TokenProps = {
    type: 'object',
    properties: Object.assign({
        color: {
            type: 'string'
        }
    }, $89231342ddbbf0db$var$omitObjectProps($89231342ddbbf0db$var$FontConfig.properties, [
        'fontWeight'
    ]))
};
const $89231342ddbbf0db$var$CodeBlock = {
    type: 'object',
    properties: {
        backgroundColor: {
            type: 'string'
        },
        borderRadius: {
            type: 'string'
        },
        tokens: $89231342ddbbf0db$var$TokenProps
    }
};
const $89231342ddbbf0db$var$ConfigThemeLogo = {
    type: 'object',
    properties: {
        gutter: {
            type: 'string'
        },
        maxHeight: {
            type: 'string'
        },
        maxWidth: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$Fab = {
    type: 'object',
    properties: {
        backgroundColor: {
            type: 'string'
        },
        color: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$ButtonOverrides = {
    type: 'object',
    properties: {
        custom: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$Overrides = {
    type: 'object',
    properties: {
        DownloadButton: $89231342ddbbf0db$var$ButtonOverrides,
        NextSectionButton: $89231342ddbbf0db$var$ButtonOverrides
    }
};
const $89231342ddbbf0db$var$RightPanel = {
    type: 'object',
    properties: {
        backgroundColor: {
            type: 'string'
        },
        panelBackgroundColor: {
            type: 'string'
        },
        panelControlsBackgroundColor: {
            type: 'string'
        },
        showAtBreakpoint: {
            type: 'string'
        },
        textColor: {
            type: 'string'
        },
        width: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$Shape = {
    type: 'object',
    properties: {
        borderRadius: {
            type: 'string'
        }
    }
};
const $89231342ddbbf0db$var$ThemeSpacing = {
    type: 'object',
    properties: {
        sectionHorizontal: {
            type: 'number'
        },
        sectionVertical: {
            type: 'number'
        },
        unit: {
            type: 'number'
        }
    }
};
const $89231342ddbbf0db$var$ConfigTheme = {
    type: 'object',
    properties: {
        breakpoints: $89231342ddbbf0db$var$Breakpoints,
        codeBlock: $89231342ddbbf0db$var$CodeBlock,
        colors: $89231342ddbbf0db$var$ThemeColors,
        components: $89231342ddbbf0db$var$ConfigThemeComponents,
        layout: $89231342ddbbf0db$var$Layout,
        logo: $89231342ddbbf0db$var$ConfigThemeLogo,
        fab: $89231342ddbbf0db$var$Fab,
        overrides: $89231342ddbbf0db$var$Overrides,
        rightPanel: $89231342ddbbf0db$var$RightPanel,
        schema: $89231342ddbbf0db$var$ConfigThemeSchema,
        shape: $89231342ddbbf0db$var$Shape,
        sidebar: $89231342ddbbf0db$var$Sidebar,
        spacing: $89231342ddbbf0db$var$ThemeSpacing,
        typography: $89231342ddbbf0db$var$Typography,
        links: {
            properties: {
                color: {
                    type: 'string'
                }
            }
        },
        codeSample: {
            properties: {
                backgroundColor: {
                    type: 'string'
                }
            }
        }
    }
};
const $89231342ddbbf0db$var$GenerateCodeSamples = {
    type: 'object',
    properties: {
        skipOptionalParameters: {
            type: 'boolean'
        },
        languages: {
            type: 'array',
            items: $89231342ddbbf0db$var$ConfigLanguage
        }
    },
    required: [
        'languages'
    ]
};
const $89231342ddbbf0db$export$abccb877ab0c9c14 = {
    type: 'object',
    properties: {
        theme: $89231342ddbbf0db$var$ConfigTheme,
        ctrlFHijack: {
            type: 'boolean'
        },
        defaultSampleLanguage: {
            type: 'string'
        },
        disableDeepLinks: {
            type: 'boolean'
        },
        disableSearch: {
            type: 'boolean'
        },
        disableSidebar: {
            type: 'boolean'
        },
        downloadDefinitionUrl: {
            type: 'string'
        },
        expandDefaultServerVariables: {
            type: 'boolean'
        },
        enumSkipQuotes: {
            type: 'boolean'
        },
        expandDefaultRequest: {
            type: 'boolean'
        },
        expandDefaultResponse: {
            type: 'boolean'
        },
        expandResponses: {
            type: 'string'
        },
        expandSingleSchemaField: {
            type: 'boolean'
        },
        generateCodeSamples: $89231342ddbbf0db$var$GenerateCodeSamples,
        generatedPayloadSamplesMaxDepth: {
            type: 'number'
        },
        hideDownloadButton: {
            type: 'boolean'
        },
        hideHostname: {
            type: 'boolean'
        },
        hideInfoSection: {
            type: 'boolean'
        },
        hideLogo: {
            type: 'boolean'
        },
        hideRequestPayloadSample: {
            type: 'boolean'
        },
        hideRightPanel: {
            type: 'boolean'
        },
        hideSchemaPattern: {
            type: 'boolean'
        },
        hideSingleRequestSampleTab: {
            type: 'boolean'
        },
        hideSecuritySection: {
            type: 'boolean'
        },
        hideTryItPanel: {
            type: 'boolean'
        },
        hideFab: {
            type: 'boolean'
        },
        hideOneOfDescription: {
            type: 'boolean'
        },
        htmlTemplate: {
            type: 'string'
        },
        jsonSampleExpandLevel: {
            oneOf: [
                {
                    type: 'number',
                    minimum: 1
                },
                {
                    type: 'string'
                }
            ]
        },
        labels: $89231342ddbbf0db$var$ConfigLabels,
        menuToggle: {
            type: 'boolean'
        },
        nativeScrollbars: {
            type: 'boolean'
        },
        noAutoAuth: {
            type: 'boolean'
        },
        onDeepLinkClick: {
            type: 'object'
        },
        pagination: {
            enum: [
                'none',
                'section',
                'item'
            ]
        },
        pathInMiddlePanel: {
            type: 'boolean'
        },
        payloadSampleIdx: {
            type: 'number',
            minimum: 0
        },
        requestInterceptor: {
            type: 'object'
        },
        requiredPropsFirst: {
            type: 'boolean'
        },
        routingStrategy: {
            type: 'string'
        },
        samplesTabsMaxCount: {
            type: 'number'
        },
        schemaExpansionLevel: {
            oneOf: [
                {
                    type: 'number',
                    minimum: 0
                },
                {
                    type: 'string'
                }
            ]
        },
        minCharacterLengthToInitSearch: {
            type: 'number',
            minimum: 1
        },
        maxResponseHeadersToShowInTryIt: {
            type: 'number',
            minimum: 0
        },
        scrollYOffset: {
            oneOf: [
                {
                    type: 'number'
                },
                {
                    type: 'string'
                }
            ]
        },
        searchAutoExpand: {
            type: 'boolean'
        },
        searchFieldLevelBoost: {
            type: 'number',
            minimum: 0
        },
        searchMaxDepth: {
            type: 'number',
            minimum: 1
        },
        searchMode: {
            type: 'string',
            enum: [
                'default',
                'path-only'
            ]
        },
        searchOperationTitleBoost: {
            type: 'number'
        },
        searchTagTitleBoost: {
            type: 'number'
        },
        sendXUserAgentInTryIt: {
            type: 'boolean'
        },
        showChangeLayoutButton: {
            type: 'boolean'
        },
        showConsole: {
            type: 'boolean'
        },
        showNextButton: {
            type: 'boolean'
        },
        showRightPanelToggle: {
            type: 'boolean'
        },
        showSecuritySchemeType: {
            type: 'boolean'
        },
        showWebhookVerb: {
            type: 'boolean'
        },
        showObjectSchemaExamples: {
            type: 'boolean'
        },
        disableTryItRequestUrlEncoding: {
            type: 'boolean'
        },
        sidebarLinks: $89231342ddbbf0db$var$ConfigSidebarLinks,
        sideNavStyle: {
            type: 'string',
            enum: [
                'summary-only',
                'path-first',
                'id-only',
                'path-only'
            ]
        },
        simpleOneOfTypeLabel: {
            type: 'boolean'
        },
        sortEnumValuesAlphabetically: {
            type: 'boolean'
        },
        sortOperationsAlphabetically: {
            type: 'boolean'
        },
        sortPropsAlphabetically: {
            type: 'boolean'
        },
        sortTagsAlphabetically: {
            type: 'boolean'
        },
        suppressWarnings: {
            type: 'boolean'
        },
        unstable_externalDescription: {
            type: 'boolean'
        },
        unstable_ignoreMimeParameters: {
            type: 'boolean'
        },
        untrustedDefinition: {
            type: 'boolean'
        },
        showAccessMode: {
            type: 'boolean'
        },
        preserveOriginalExtensionsName: {
            type: 'boolean'
        },
        markdownHeadingsAnchorLevel: {
            type: 'number'
        }
    },
    additionalProperties: false
};
function $89231342ddbbf0db$var$pickObjectProps(object, keys) {
    return Object.fromEntries(keys.filter((key)=>key in object).map((key)=>[
            key,
            object[key]
        ]));
}
function $89231342ddbbf0db$var$omitObjectProps(object, keys) {
    return Object.fromEntries(Object.entries(object).filter(([key])=>!keys.includes(key)));
} //# sourceMappingURL=reference-docs-config-schema.js.map

});



parcelRegister("ldL1o", function(module, exports) {

$parcel$export(module.exports, "apiConfigSchema", () => $f72f495c08343d81$export$b35d9f13a2dd854b);
$parcel$export(module.exports, "rootRedoclyConfigSchema", () => $f72f495c08343d81$export$f58b9e159bf16887);

var $8ZW2y = parcelRequire("8ZW2y");

var $hhbfh = parcelRequire("hhbfh");

var $2cu8k = parcelRequire("2cu8k");

var $8Sr13 = parcelRequire("8Sr13");

var $ahh5v = parcelRequire("ahh5v");

var $jFpdm = parcelRequire("jFpdm");

var $9sHi2 = parcelRequire("9sHi2");
const $f72f495c08343d81$export$750c238cfc6308de = {
    type: 'object',
    properties: {
        end_session_endpoint: {
            type: 'string'
        },
        token_endpoint: {
            type: 'string'
        },
        authorization_endpoint: {
            type: 'string'
        },
        jwks_uri: {
            type: 'string'
        }
    },
    required: [
        'token_endpoint',
        'authorization_endpoint'
    ],
    additionalProperties: true
};
const $f72f495c08343d81$export$f0df9ae0503e796c = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            const: (0, $8ZW2y.AuthProviderType).OIDC
        },
        title: {
            type: 'string'
        },
        pkce: {
            type: 'boolean',
            default: false
        },
        configurationUrl: {
            type: 'string',
            minLength: 1
        },
        configuration: $f72f495c08343d81$export$750c238cfc6308de,
        clientId: {
            type: 'string',
            minLength: 1
        },
        clientSecret: {
            type: 'string',
            minLength: 0
        },
        teamsClaimName: {
            type: 'string'
        },
        teamsClaimMap: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        defaultTeams: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        scopes: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        tokenExpirationTime: {
            type: 'number'
        },
        authorizationRequestCustomParams: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        tokenRequestCustomParams: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        audience: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    required: [
        'type',
        'clientId'
    ],
    oneOf: [
        {
            required: [
                'configurationUrl'
            ]
        },
        {
            required: [
                'configuration'
            ]
        }
    ],
    additionalProperties: false
};
const $f72f495c08343d81$export$f4e77862974b4a52 = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            const: (0, $8ZW2y.AuthProviderType).SAML2
        },
        title: {
            type: 'string'
        },
        issuerId: {
            type: 'string'
        },
        entityId: {
            type: 'string'
        },
        ssoUrl: {
            type: 'string'
        },
        x509PublicCert: {
            type: 'string'
        },
        teamsAttributeName: {
            type: 'string',
            default: (0, $8ZW2y.DEFAULT_TEAM_CLAIM_NAME)
        },
        teamsAttributeMap: {
            type: 'object',
            additionalProperties: {
                type: 'string'
            }
        },
        defaultTeams: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    additionalProperties: false,
    required: [
        'type',
        'issuerId',
        'ssoUrl',
        'x509PublicCert'
    ]
};
const $f72f495c08343d81$export$cd69c3a3ef551684 = {
    oneOf: [
        $f72f495c08343d81$export$f0df9ae0503e796c,
        $f72f495c08343d81$export$f4e77862974b4a52
    ],
    discriminator: {
        propertyName: 'type'
    }
};
const $f72f495c08343d81$export$63f91f18eeff8b80 = {
    type: 'object',
    additionalProperties: $f72f495c08343d81$export$cd69c3a3ef551684
};
const $f72f495c08343d81$export$6791ab58f2bf1432 = {
    oneOf: [
        {
            type: 'array',
            items: {
                type: 'string',
                enum: [
                    'REDOCLY',
                    'CORPORATE',
                    'GUEST'
                ]
            },
            uniqueItems: true
        },
        {
            type: 'string',
            enum: [
                'REDOCLY',
                'CORPORATE',
                'GUEST'
            ]
        }
    ]
};
const $f72f495c08343d81$export$5c41fb9a4a4b2d15 = {
    type: 'object',
    properties: {
        to: {
            type: 'string'
        },
        type: {
            type: 'number',
            default: 301
        }
    },
    additionalProperties: false
};
const $f72f495c08343d81$export$5f550d1d5130bb1a = {
    type: 'object',
    additionalProperties: $f72f495c08343d81$export$5c41fb9a4a4b2d15,
    default: {}
};
const $f72f495c08343d81$var$rulesSchema = {
    type: 'object',
    additionalProperties: {
        oneOf: [
            {
                type: 'string'
            },
            {
                type: 'object'
            }
        ]
    }
};
const $f72f495c08343d81$export$b35d9f13a2dd854b = {
    type: 'object',
    properties: {
        root: {
            type: 'string'
        },
        output: {
            type: 'string',
            pattern: '(.ya?ml|.json)$'
        },
        rbac: {
            type: 'object',
            additionalProperties: true
        },
        openapi: (0, $9sHi2.openapiConfigSchema),
        graphql: (0, $8Sr13.graphqlConfigSchema),
        /**
         * @deprecated left for backwards compatibility
         */ theme: {
            type: 'object',
            properties: {
                openapi: (0, $9sHi2.openapiConfigSchema),
                graphql: (0, $8Sr13.graphqlConfigSchema)
            },
            additionalProperties: false
        },
        title: {
            type: 'string'
        },
        metadata: {
            type: 'object',
            additionalProperties: true
        },
        rules: $f72f495c08343d81$var$rulesSchema,
        decorators: {
            type: 'object',
            additionalProperties: true
        },
        preprocessors: {
            type: 'object',
            additionalProperties: true
        }
    },
    required: [
        'root'
    ]
};
const $f72f495c08343d81$var$metadataConfigSchema = {
    type: 'object',
    additionalProperties: true
};
const $f72f495c08343d81$var$metadataGlobsConfigSchema = {
    type: 'object',
    additionalProperties: {
        type: 'object',
        additionalProperties: true
    }
};
const $f72f495c08343d81$export$9254f5f2af3e5e55 = {
    type: 'object',
    properties: {
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        siteUrl: {
            type: 'string'
        },
        image: {
            type: 'string'
        },
        keywords: {
            oneOf: [
                {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                },
                {
                    type: 'string'
                }
            ]
        },
        lang: {
            type: 'string'
        },
        jsonLd: {
            type: 'object'
        },
        meta: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    name: {
                        type: 'string'
                    },
                    content: {
                        type: 'string'
                    }
                },
                required: [
                    'name',
                    'content'
                ],
                additionalProperties: false
            }
        }
    },
    additionalProperties: false
};
const $f72f495c08343d81$export$ff1547b5ef9ef5f4 = {
    type: 'object',
    properties: {
        folders: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    },
    additionalProperties: false
};
const $f72f495c08343d81$export$1379b0d147e655ef = {
    type: 'object',
    additionalProperties: {
        type: 'string'
    }
};
const $f72f495c08343d81$export$3596e1377a10912e = {
    type: 'object',
    properties: {
        teamNamePatterns: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        teamFolders: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        teamFoldersBaseRoles: $f72f495c08343d81$export$1379b0d147e655ef,
        cms: $f72f495c08343d81$export$1379b0d147e655ef,
        reunite: $f72f495c08343d81$export$1379b0d147e655ef,
        features: {
            type: 'object',
            properties: {
                aiSearch: $f72f495c08343d81$export$1379b0d147e655ef
            },
            additionalProperties: false
        },
        content: {
            type: 'object',
            properties: {
                '**': $f72f495c08343d81$export$1379b0d147e655ef
            },
            additionalProperties: $f72f495c08343d81$export$1379b0d147e655ef
        }
    },
    additionalProperties: $f72f495c08343d81$export$1379b0d147e655ef
};
const $f72f495c08343d81$export$75df0cf2b399b387 = {
    type: 'object',
    properties: {
        static: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'static'
    ]
};
const $f72f495c08343d81$export$dfb03e7d5cdd8232 = {
    type: 'object',
    properties: {
        idp: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'idp'
    ]
};
const $f72f495c08343d81$export$d41d06cf9b48651d = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            const: 'GRAVITEE'
        },
        apiBaseUrl: {
            type: 'string'
        },
        env: {
            type: 'string'
        },
        allowApiProductsOutsideCatalog: {
            type: 'boolean',
            default: false
        },
        stage: {
            type: 'string',
            default: 'non-production'
        },
        auth: {
            oneOf: [
                $f72f495c08343d81$export$75df0cf2b399b387,
                $f72f495c08343d81$export$dfb03e7d5cdd8232
            ]
        }
    },
    additionalProperties: false,
    required: [
        'type',
        'apiBaseUrl'
    ]
};
const $f72f495c08343d81$export$f1199439dbe4dd6e = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            const: (0, $8ZW2y.ApigeeDevOnboardingIntegrationAuthType).OAUTH2
        },
        tokenEndpoint: {
            type: 'string'
        },
        clientId: {
            type: 'string'
        },
        clientSecret: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'type',
        'tokenEndpoint',
        'clientId',
        'clientSecret'
    ]
};
const $f72f495c08343d81$export$ace32d575c6bcf33 = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            const: (0, $8ZW2y.ApigeeDevOnboardingIntegrationAuthType).SERVICE_ACCOUNT
        },
        serviceAccountEmail: {
            type: 'string'
        },
        serviceAccountPrivateKey: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'type',
        'serviceAccountEmail',
        'serviceAccountPrivateKey'
    ]
};
const $f72f495c08343d81$export$aa576b7aca3c7b88 = {
    type: 'object',
    properties: {
        type: {
            type: 'string',
            const: 'APIGEE_X'
        },
        apiUrl: {
            type: 'string'
        },
        stage: {
            type: 'string',
            default: 'non-production'
        },
        organizationName: {
            type: 'string'
        },
        ignoreApiProducts: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        allowApiProductsOutsideCatalog: {
            type: 'boolean',
            default: false
        },
        auth: {
            type: 'object',
            oneOf: [
                $f72f495c08343d81$export$f1199439dbe4dd6e,
                $f72f495c08343d81$export$ace32d575c6bcf33
            ],
            discriminator: {
                propertyName: 'type'
            }
        }
    },
    additionalProperties: false,
    required: [
        'type',
        'organizationName',
        'auth'
    ]
};
const $f72f495c08343d81$export$30c7670336bc02f8 = Object.assign(Object.assign({}, $f72f495c08343d81$export$aa576b7aca3c7b88), {
    properties: Object.assign(Object.assign({}, $f72f495c08343d81$export$aa576b7aca3c7b88.properties), {
        type: {
            type: 'string',
            const: 'APIGEE_EDGE'
        }
    })
});
const $f72f495c08343d81$export$57fef7e12c14d4c5 = {
    type: 'object',
    oneOf: [
        $f72f495c08343d81$export$aa576b7aca3c7b88,
        $f72f495c08343d81$export$30c7670336bc02f8,
        $f72f495c08343d81$export$d41d06cf9b48651d
    ],
    discriminator: {
        propertyName: 'type'
    }
};
const $f72f495c08343d81$var$devOnboardingConfigSchema = {
    type: 'object',
    required: [
        'adapters'
    ],
    additionalProperties: false,
    properties: {
        adapters: {
            type: 'array',
            items: $f72f495c08343d81$export$57fef7e12c14d4c5
        }
    }
};
const $f72f495c08343d81$export$939d5e799d7e797f = {
    type: 'object',
    properties: {
        defaultLocale: {
            type: 'string'
        },
        locales: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    code: {
                        type: 'string'
                    },
                    name: {
                        type: 'string'
                    }
                },
                required: [
                    'code'
                ]
            }
        }
    },
    additionalProperties: false,
    required: [
        'defaultLocale'
    ]
};
const $f72f495c08343d81$var$responseHeaderSchema = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        value: {
            type: 'string'
        }
    },
    additionalProperties: false,
    required: [
        'name',
        'value'
    ]
};
const $f72f495c08343d81$export$72665e0e4bf90c34 = {
    type: 'object',
    properties: {
        /**
         * @deprecated Should use `plugins` instead
         */ imports: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        licenseKey: {
            type: 'string'
        },
        redirects: $f72f495c08343d81$export$5f550d1d5130bb1a,
        seo: $f72f495c08343d81$export$9254f5f2af3e5e55,
        rbac: $f72f495c08343d81$export$3596e1377a10912e,
        apiFunctions: $f72f495c08343d81$export$ff1547b5ef9ef5f4,
        requiresLogin: {
            type: 'boolean'
        },
        responseHeaders: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: $f72f495c08343d81$var$responseHeaderSchema
            }
        },
        mockServer: {
            type: 'object',
            properties: {
                off: {
                    type: 'boolean',
                    default: false
                },
                position: {
                    type: 'string',
                    enum: [
                        'first',
                        'last',
                        'replace',
                        'off'
                    ],
                    default: 'first'
                },
                strictExamples: {
                    type: 'boolean',
                    default: false
                },
                errorIfForcedExampleNotFound: {
                    type: 'boolean',
                    default: false
                },
                description: {
                    type: 'string'
                }
            }
        },
        apis: {
            type: 'object',
            additionalProperties: $f72f495c08343d81$export$b35d9f13a2dd854b
        },
        rules: $f72f495c08343d81$var$rulesSchema,
        decorators: {
            type: 'object',
            additionalProperties: true
        },
        preprocessors: {
            type: 'object',
            additionalProperties: true
        },
        ssoDirect: $f72f495c08343d81$export$63f91f18eeff8b80,
        sso: $f72f495c08343d81$export$6791ab58f2bf1432,
        residency: {
            type: 'string'
        },
        developerOnboarding: $f72f495c08343d81$var$devOnboardingConfigSchema,
        removeAttribution: {
            type: 'boolean'
        },
        i18n: $f72f495c08343d81$export$939d5e799d7e797f,
        l10n: $f72f495c08343d81$export$939d5e799d7e797f,
        metadata: $f72f495c08343d81$var$metadataConfigSchema,
        metadataGlobs: $f72f495c08343d81$var$metadataGlobsConfigSchema,
        ignore: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        /**
         * @deprecated properties moved to the root of the config
         */ theme: (0, $hhbfh.themeConfigSchema),
        reunite: (0, $jFpdm.reuniteConfigSchema),
        // Ex theme properties
        logo: (0, $9sHi2.logoConfigSchema),
        navbar: (0, $9sHi2.navbarConfigSchema),
        products: (0, $9sHi2.productsConfigSchema),
        footer: (0, $9sHi2.footerConfigSchema),
        sidebar: (0, $9sHi2.sidebarConfigSchema),
        scripts: (0, $9sHi2.scriptsConfigSchema),
        links: (0, $9sHi2.linksConfigSchema),
        feedback: (0, $2cu8k.feedbackConfigSchema),
        search: (0, $9sHi2.searchConfigSchema),
        colorMode: (0, $9sHi2.colorModeConfigSchema),
        navigation: (0, $9sHi2.navigationConfigSchema),
        codeSnippet: (0, $9sHi2.codeSnippetConfigSchema),
        markdown: (0, $9sHi2.markdownConfigSchema),
        openapi: (0, $9sHi2.openapiConfigSchema),
        graphql: (0, $8Sr13.graphqlConfigSchema),
        analytics: (0, $9sHi2.analyticsConfigSchema),
        userMenu: (0, $9sHi2.userMenuConfigSchema),
        versionPicker: (0, $9sHi2.versionPickerConfigSchema),
        breadcrumbs: (0, $9sHi2.breadcrumbsConfigSchema),
        catalog: (0, $9sHi2.catalogsConfigSchema),
        scorecard: (0, $9sHi2.scorecardConfigSchema)
    },
    default: {
        redirects: {}
    },
    additionalProperties: true
};
const $f72f495c08343d81$var$environmentSchema = Object.assign(Object.assign({}, (0, $ahh5v.removePropertyRecursively)($f72f495c08343d81$export$72665e0e4bf90c34, 'default')), {
    additionalProperties: false
});
const $f72f495c08343d81$export$f58b9e159bf16887 = Object.assign(Object.assign({
    $id: 'root-redocly-config'
}, $f72f495c08343d81$export$72665e0e4bf90c34), {
    properties: Object.assign(Object.assign({
        plugins: {
            type: 'array',
            items: {
                type: 'string'
            }
        }
    }, $f72f495c08343d81$export$72665e0e4bf90c34.properties), {
        env: {
            type: 'object',
            additionalProperties: $f72f495c08343d81$var$environmentSchema
        }
    }),
    default: {},
    additionalProperties: false
}); //# sourceMappingURL=root-config-schema.js.map

});
parcelRegister("8ZW2y", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TEAM_CLAIM_NAME", () => $68d10ad48e64b8e8$export$2186289315f6e46a);
$parcel$export(module.exports, "AuthProviderType", () => $68d10ad48e64b8e8$export$530013691e54e4d6);
$parcel$export(module.exports, "ApigeeDevOnboardingIntegrationAuthType", () => $68d10ad48e64b8e8$export$31a7be9cb37b7a2d);
const $68d10ad48e64b8e8$export$2186289315f6e46a = 'https://redocly.com/sso/teams';
var $68d10ad48e64b8e8$export$530013691e54e4d6;
(function(AuthProviderType) {
    AuthProviderType["OIDC"] = "OIDC";
    AuthProviderType["SAML2"] = "SAML2";
})($68d10ad48e64b8e8$export$530013691e54e4d6 || ($68d10ad48e64b8e8$export$530013691e54e4d6 = {}));
var $68d10ad48e64b8e8$export$31a7be9cb37b7a2d;
(function(ApigeeDevOnboardingIntegrationAuthType) {
    ApigeeDevOnboardingIntegrationAuthType["SERVICE_ACCOUNT"] = "SERVICE_ACCOUNT";
    ApigeeDevOnboardingIntegrationAuthType["OAUTH2"] = "OAUTH2";
})($68d10ad48e64b8e8$export$31a7be9cb37b7a2d || ($68d10ad48e64b8e8$export$31a7be9cb37b7a2d = {}));
const $68d10ad48e64b8e8$export$2325ef7027d9ad01 = 'redocly::teams-rbac';
const $68d10ad48e64b8e8$export$a6f78a260ad0465f = 'redocly::route-rbac';
var $68d10ad48e64b8e8$export$f95dd523b86f7f6f;
(function(LayoutVariant) {
    LayoutVariant["STACKED"] = "stacked";
    LayoutVariant["THREE_PANEL"] = "three-panel";
})($68d10ad48e64b8e8$export$f95dd523b86f7f6f || ($68d10ad48e64b8e8$export$f95dd523b86f7f6f = {})); //# sourceMappingURL=constants.js.map

});

parcelRegister("ahh5v", function(module, exports) {

$parcel$export(module.exports, "removePropertyRecursively", () => $77b8bf383d0ca729$export$b4a7295d7cb23670);
function $77b8bf383d0ca729$export$b4a7295d7cb23670(object, propToRemove) {
    return Object.fromEntries(Object.entries(object).map(([key, value])=>{
        if (key === propToRemove) return undefined;
        if (typeof value !== 'object' || !value) return [
            key,
            value
        ];
        if (Array.isArray(value)) return [
            key,
            value.map((arrayItem)=>typeof arrayItem === 'object' ? $77b8bf383d0ca729$export$b4a7295d7cb23670(arrayItem, propToRemove) : arrayItem)
        ];
        return [
            key,
            $77b8bf383d0ca729$export$b4a7295d7cb23670(value, propToRemove)
        ];
    }).filter(Boolean));
} //# sourceMappingURL=remove-property-recursively.js.map

});

parcelRegister("jFpdm", function(module, exports) {

$parcel$export(module.exports, "reuniteConfigSchema", () => $e51567bb27ae474a$export$98ae90af28db838c);
const $e51567bb27ae474a$var$jobInputsSchema = {
    type: 'object',
    additionalProperties: {
        type: 'string'
    }
};
const $e51567bb27ae474a$var$jobServersSchema = {
    type: 'object',
    additionalProperties: false,
    patternProperties: {
        '^[a-zA-Z0-9_-]+$': {
            type: 'string',
            pattern: '^https?://[^\\s/$.?#].[^\\s]*$'
        }
    }
};
const $e51567bb27ae474a$var$severitySchema = {
    type: 'string',
    enum: [
        'error',
        'warn',
        'off'
    ]
};
const $e51567bb27ae474a$var$jobSeveritySchema = {
    type: 'object',
    additionalProperties: false,
    properties: {
        schemaCheck: $e51567bb27ae474a$var$severitySchema,
        statusCodeCheck: $e51567bb27ae474a$var$severitySchema,
        contentTypeCheck: $e51567bb27ae474a$var$severitySchema,
        successCriteriaCheck: $e51567bb27ae474a$var$severitySchema
    }
};
const $e51567bb27ae474a$var$jobTriggerSchema = {
    type: 'object',
    additionalProperties: false,
    properties: {
        event: {
            type: 'string',
            enum: [
                'schedule'
            ]
        },
        interval: {
            type: 'string',
            pattern: '^[1-9]\\d*[mhdw]$'
        }
    },
    required: [
        'event'
    ]
};
const $e51567bb27ae474a$export$98ae90af28db838c = {
    type: 'object',
    properties: {
        ignoreLint: {
            oneOf: [
                {
                    type: 'boolean',
                    default: false
                },
                {
                    type: 'object',
                    additionalProperties: {
                        type: 'boolean'
                    }
                }
            ]
        },
        ignoreLinkChecker: {
            type: 'boolean'
        },
        ignoreMarkdocErrors: {
            type: 'boolean'
        },
        jobs: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    path: {
                        type: 'string',
                        pattern: '^(?!\\.\\./)(/[a-zA-Z0-9_\\-\\./]+|./[a-zA-Z0-9_\\-\\./]+|[a-zA-Z0-9_\\-\\./]+)$'
                    },
                    agent: {
                        type: 'string',
                        enum: [
                            'respect'
                        ]
                    },
                    trigger: $e51567bb27ae474a$var$jobTriggerSchema,
                    inputs: $e51567bb27ae474a$var$jobInputsSchema,
                    servers: $e51567bb27ae474a$var$jobServersSchema,
                    severity: $e51567bb27ae474a$var$jobSeveritySchema
                },
                required: [
                    'path',
                    'trigger',
                    'agent'
                ],
                additionalProperties: false
            }
        }
    },
    additionalProperties: false
}; //# sourceMappingURL=reunite-config-schema.js.map

});



parcelRegister("apyaI", function(module, exports) {
parcelRequire("ac1Wn");
parcelRequire("5EBlK");
parcelRequire("4LvjG");
 //# sourceMappingURL=index.js.map

});
parcelRegister("ac1Wn", function(module, exports) {
 //# sourceMappingURL=api-functions-types.js.map

});

parcelRegister("5EBlK", function(module, exports) {
 //# sourceMappingURL=config-types.js.map

});

parcelRegister("4LvjG", function(module, exports) {
parcelRequire("idtO0");
 //# sourceMappingURL=portal-shared-types.js.map

});
parcelRegister("idtO0", function(module, exports) {
 //# sourceMappingURL=code-walkthrough-types.js.map

});




parcelRegister("7SgPX", function(module, exports) {
"use strict";
// For internal usage only
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNodeTypesFromJSONSchema = $5bbaa30d61443ceb$var$getNodeTypesFromJSONSchema;

var $5Esp7 = parcelRequire("5Esp7");

var $eONiY = parcelRequire("eONiY");
const $5bbaa30d61443ceb$var$ajv = new $5Esp7.default({
    strictSchema: false,
    allowUnionTypes: true,
    useDefaults: true,
    allErrors: true,
    discriminator: true,
    strictTypes: false,
    verbose: true
});
function $5bbaa30d61443ceb$var$findOneOf(schemaOneOf, oneOfs) {
    if (oneOfs.some((option)=>typeof option === 'function')) throw new Error('Unexpected oneOf inside oneOf.');
    return (value)=>{
        let index = schemaOneOf.findIndex((option)=>$5bbaa30d61443ceb$var$ajv.validate(option, value));
        if (index === -1) index = 0;
        return oneOfs[index];
    };
}
function $5bbaa30d61443ceb$var$transformJSONSchemaToNodeType(propertyName, schema, ctx) {
    if (!schema || typeof schema === 'boolean') throw new Error(`Unexpected schema in ${propertyName}.`);
    if (schema instanceof Array) throw new Error(`Unexpected array schema in ${propertyName}. Try using oneOf instead.`);
    if (schema.type === 'null') throw new Error(`Unexpected null schema type in ${propertyName} schema.`);
    if (schema.type instanceof Array) throw new Error(`Unexpected array schema type in ${propertyName} schema. Try using oneOf instead.`);
    if (schema.type === 'string' || schema.type === 'number' || schema.type === 'integer' || schema.type === 'boolean') {
        const { default: _, format: _format, ...rest } = schema;
        return rest;
    }
    if (schema.type === 'object' && !schema.properties && !schema.oneOf) {
        if (schema.additionalProperties === undefined || schema.additionalProperties === true) return {
            type: 'object'
        };
        else if (schema.additionalProperties === false) return {
            type: 'object',
            properties: {}
        };
    }
    if (schema.allOf) throw new Error(`Unexpected allOf in ${propertyName}.`);
    if (schema.anyOf) throw new Error(`Unexpected anyOf in ${propertyName}.`);
    if ((0, $eONiY.isPlainObject)(schema.properties) || (0, $eONiY.isPlainObject)(schema.additionalProperties) || (0, $eONiY.isPlainObject)(schema.items) && ((0, $eONiY.isPlainObject)(schema.items.properties) || (0, $eONiY.isPlainObject)(schema.items.additionalProperties) || schema.items.oneOf) // exclude scalar array types
    ) return $5bbaa30d61443ceb$var$extractNodeToContext(propertyName, schema, ctx);
    if (schema.oneOf) {
        if (schema.discriminator) {
            const discriminatedPropertyName = schema.discriminator?.propertyName;
            if (!discriminatedPropertyName) throw new Error(`Unexpected discriminator without a propertyName in ${propertyName}.`);
            const oneOfs = schema.oneOf.map((option, i)=>{
                if (typeof option === 'boolean') throw new Error(`Unexpected boolean schema in ${propertyName} at position ${i} in oneOf.`);
                const discriminatedProperty = option?.properties?.[discriminatedPropertyName];
                if (!discriminatedProperty || typeof discriminatedProperty === 'boolean') throw new Error(`Unexpected property '${discriminatedProperty}' schema in ${propertyName} at position ${i} in oneOf.`);
                const name = discriminatedProperty.const;
                return $5bbaa30d61443ceb$var$transformJSONSchemaToNodeType(name, option, ctx);
            });
            return (value, key)=>{
                if ((0, $eONiY.isPlainObject)(value)) {
                    const discriminatedTypeName = value[discriminatedPropertyName];
                    if (typeof discriminatedTypeName === 'string' && ctx[discriminatedTypeName]) return discriminatedTypeName;
                }
                return $5bbaa30d61443ceb$var$findOneOf(schema.oneOf, oneOfs)(value, key);
            };
        } else {
            const oneOfs = schema.oneOf.map((option, i)=>$5bbaa30d61443ceb$var$transformJSONSchemaToNodeType(propertyName + '_' + i, option, ctx));
            return $5bbaa30d61443ceb$var$findOneOf(schema.oneOf, oneOfs);
        }
    }
    return schema;
}
function $5bbaa30d61443ceb$var$extractNodeToContext(propertyName, schema, ctx) {
    if (!schema || typeof schema === 'boolean') throw new Error(`Unexpected schema in ${propertyName}.`);
    if (schema instanceof Array) throw new Error(`Unexpected array schema in ${propertyName}. Try using oneOf instead.`);
    if (schema.type === 'null') throw new Error(`Unexpected null schema type in ${propertyName} schema.`);
    if (schema.type instanceof Array) throw new Error(`Unexpected array schema type in ${propertyName} schema. Try using oneOf instead.`);
    const properties = {};
    for (const [name, property] of Object.entries(schema.properties || {}))properties[name] = $5bbaa30d61443ceb$var$transformJSONSchemaToNodeType(propertyName + '.' + name, property, ctx);
    let additionalProperties;
    if ((0, $eONiY.isPlainObject)(schema.additionalProperties)) additionalProperties = $5bbaa30d61443ceb$var$transformJSONSchemaToNodeType(propertyName + '_additionalProperties', schema.additionalProperties, ctx);
    if (schema.additionalProperties === true) additionalProperties = {};
    let items;
    if ((0, $eONiY.isPlainObject)(schema.items) && ((0, $eONiY.isPlainObject)(schema.items.properties) || (0, $eONiY.isPlainObject)(schema.items.additionalProperties) || schema.items.oneOf // exclude scalar array types
    )) items = $5bbaa30d61443ceb$var$transformJSONSchemaToNodeType(propertyName + '_items', schema.items, ctx);
    let required = schema.required;
    // Translate required in oneOfs into a ResolveTypeFn.
    if (schema.oneOf && schema.oneOf.every((option)=>!!option.required)) required = (value)=>{
        const requiredList = schema.oneOf.map((option)=>[
                ...schema.required || [],
                ...option.required
            ]);
        let index = requiredList.findIndex((r)=>r.every((requiredProp)=>value[requiredProp] !== undefined));
        if (index === -1) index = 0;
        return requiredList[index];
    };
    ctx[propertyName] = {
        properties: properties,
        additionalProperties: additionalProperties,
        items: items,
        required: required
    };
    return propertyName;
}
function $5bbaa30d61443ceb$var$getNodeTypesFromJSONSchema(schemaName, entrySchema) {
    const ctx = {};
    $5bbaa30d61443ceb$var$transformJSONSchemaToNodeType(schemaName, entrySchema, ctx);
    return ctx;
}

});
parcelRegister("5Esp7", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;

var $jV6eP = parcelRequire("jV6eP");

var $aCqcX = parcelRequire("aCqcX");

var $3yn8Y = parcelRequire("3yn8Y");

var $Tsyvt = parcelRequire("Tsyvt");
const META_SCHEMA_ID = "https://json-schema.org/draft/2020-12/schema";
class Ajv2020 extends $jV6eP.default {
    constructor(opts = {}){
        super({
            ...opts,
            dynamicRef: true,
            next: true,
            unevaluated: true
        });
    }
    _addVocabularies() {
        super._addVocabularies();
        $aCqcX.default.forEach((v)=>this.addVocabulary(v));
        if (this.opts.discriminator) this.addKeyword($3yn8Y.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        const { $data, meta } = this.opts;
        if (!meta) return;
        $Tsyvt.default.call(this, $data);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
}
module.exports = exports = Ajv2020;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv2020;

var $bTGAO = parcelRequire("bTGAO");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $bTGAO.KeywordCxt;
    }
});

var $lohei = parcelRequire("lohei");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return $lohei._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return $lohei.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return $lohei.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return $lohei.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return $lohei.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $lohei.CodeGen;
    }
});

});
parcelRegister("jV6eP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeGen = module.exports.Name = module.exports.nil = module.exports.stringify = module.exports.str = module.exports._ = module.exports.KeywordCxt = void 0;

var $bTGAO = parcelRequire("bTGAO");
Object.defineProperty(module.exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $bTGAO.KeywordCxt;
    }
});

var $lohei = parcelRequire("lohei");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $lohei._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $lohei.str;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $lohei.stringify;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $lohei.nil;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $lohei.Name;
    }
});
Object.defineProperty(module.exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $lohei.CodeGen;
    }
});

var $25XEk = parcelRequire("25XEk");

var $iItJM = parcelRequire("iItJM");

var $2W1qL = parcelRequire("2W1qL");

var $8AeYZ = parcelRequire("8AeYZ");

var $lohei = parcelRequire("lohei");

var $eO3NS = parcelRequire("eO3NS");

var $bvJtX = parcelRequire("bvJtX");

var $8rmX0 = parcelRequire("8rmX0");

var $l7PEn = parcelRequire("l7PEn");

var $dVKTK = parcelRequire("dVKTK");
const $e8082dfaf38787dd$var$defaultRegExp = (str, flags)=>new RegExp(str, flags);
$e8082dfaf38787dd$var$defaultRegExp.code = "new RegExp";
const $e8082dfaf38787dd$var$META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes",
    "defaultUnevaluatedProperties",
    "defaultAdditionalProperties"
];
const $e8082dfaf38787dd$var$EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
const $e8082dfaf38787dd$var$removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
const $e8082dfaf38787dd$var$deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
const $e8082dfaf38787dd$var$MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function $e8082dfaf38787dd$var$requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : $e8082dfaf38787dd$var$defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : $dVKTK.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? {
            ...o.code,
            optimize: optimize,
            regExp: regExp
        } : {
            optimize: optimize,
            regExp: regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : $e8082dfaf38787dd$var$MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : $e8082dfaf38787dd$var$MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
class $e8082dfaf38787dd$var$Ajv {
    constructor(opts = {}){
        this.schemas = {};
        this.refs = {};
        this.formats = {};
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = {
            ...opts,
            ...$e8082dfaf38787dd$var$requiredOptions(opts)
        };
        const { es5: es5, lines: lines } = this.opts.code;
        this.scope = new $lohei.ValueScope({
            scope: {},
            prefixes: $e8082dfaf38787dd$var$EXT_SCOPE_NAMES,
            es5: es5,
            lines: lines
        });
        this.logger = $e8082dfaf38787dd$var$getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, $2W1qL.getRules)();
        $e8082dfaf38787dd$var$checkOptions.call(this, $e8082dfaf38787dd$var$removedOptions, opts, "NOT SUPPORTED");
        $e8082dfaf38787dd$var$checkOptions.call(this, $e8082dfaf38787dd$var$deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = $e8082dfaf38787dd$var$getMetaSchemaOptions.call(this);
        if (opts.formats) $e8082dfaf38787dd$var$addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) $e8082dfaf38787dd$var$addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        $e8082dfaf38787dd$var$addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data: $data, meta: meta, schemaId: schemaId } = this.opts;
        let _dataRefSchema = $l7PEn;
        if (schemaId === "id") {
            _dataRefSchema = {
                ...$l7PEn
            };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta: meta, schemaId: schemaId } = this.opts;
        return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
    }
    validate(schemaKeyRef, data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        } else v = this.compile(schemaKeyRef);
        const valid = v(data);
        if (!("$async" in v)) this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
        const { loadSchema: loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) await runCompileAsync.call(this, {
                $ref: $ref
            }, true);
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            } catch (e) {
                if (!(e instanceof $iItJM.default)) throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef: missingRef }) {
            if (this.refs[ref]) throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref]) await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p) return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            } finally{
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId: schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") throw new Error(`schema ${schemaId} must be string`);
        }
        key = (0, $eO3NS.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean") return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log") this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while(typeof (sch = $e8082dfaf38787dd$var$getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
        if (sch === undefined) {
            const { schemaId: schemaId } = this.opts;
            const root = new $8AeYZ.SchemaEnv({
                schema: {},
                schemaId: schemaId
            });
            sch = $8AeYZ.resolveSchema.call(this, root, keyRef);
            if (!sch) return;
            this.refs[keyRef] = sch;
        }
        return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string":
                {
                    const sch = $e8082dfaf38787dd$var$getSchEnv.call(this, schemaKeyRef);
                    if (typeof sch == "object") this._cache.delete(sch.schema);
                    delete this.schemas[schemaKeyRef];
                    delete this.refs[schemaKeyRef];
                    return this;
                }
            case "object":
                {
                    const cacheKey = schemaKeyRef;
                    this._cache.delete(cacheKey);
                    let id = schemaKeyRef[this.opts.schemaId];
                    if (id) {
                        id = (0, $eO3NS.normalizeId)(id);
                        delete this.schemas[id];
                        delete this.refs[id];
                    }
                    return this;
                }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        } else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
        } else throw new Error("invalid addKeywords parameters");
        $e8082dfaf38787dd$var$checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, $8rmX0.eachItem)(keyword, (kwd)=>$e8082dfaf38787dd$var$addRule.call(this, kwd));
            return this;
        }
        $e8082dfaf38787dd$var$keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, $bvJtX.getJSONTypes)(def.type),
            schemaType: (0, $bvJtX.getJSONTypes)(def.schemaType)
        };
        (0, $8rmX0.eachItem)(keyword, definition.type.length === 0 ? (k)=>$e8082dfaf38787dd$var$addRule.call(this, k, definition) : (k)=>definition.type.forEach((t)=>$e8082dfaf38787dd$var$addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES: RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules){
            const i = group.rules.findIndex((rule)=>rule.keyword === keyword);
            if (i >= 0) group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string") format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, { separator: separator = ", ", dataVar: dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0) return "No errors";
        return errors.map((e)=>`${dataVar}${e.instancePath} ${e.message}`).reduce((text, msg)=>text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers){
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)keywords = keywords[seg];
            for(const key in rules){
                const rule = rules[key];
                if (typeof rule != "object") continue;
                const { $data: $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema) keywords[key] = $e8082dfaf38787dd$var$schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for(const keyRef in schemas){
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") delete schemas[keyRef];
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId: schemaId } = this.opts;
        if (typeof schema == "object") id = schema[schemaId];
        else {
            if (this.opts.jtd) throw new Error("schema must be object");
            else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined) return sch;
        baseId = (0, $eO3NS.normalizeId)(id || baseId);
        const localRefs = $eO3NS.getSchemaRefs.call(this, schema, baseId);
        sch = new $8AeYZ.SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            meta: meta,
            baseId: baseId,
            localRefs: localRefs
        });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId) this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema) this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) throw new Error(`schema with key or id "${id}" already exists`);
    }
    _compileSchemaEnv(sch) {
        if (sch.meta) this._compileMetaSchema(sch);
        else $8AeYZ.compileSchema.call(this, sch);
        /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            $8AeYZ.compileSchema.call(this, sch);
        } finally{
            this.opts = currentOpts;
        }
    }
}
$e8082dfaf38787dd$var$Ajv.ValidationError = $25XEk.default;
$e8082dfaf38787dd$var$Ajv.MissingRefError = $iItJM.default;
module.exports.default = $e8082dfaf38787dd$var$Ajv;
function $e8082dfaf38787dd$var$checkOptions(checkOpts, options, msg, log = "error") {
    for(const key in checkOpts){
        const opt = key;
        if (opt in options) this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function $e8082dfaf38787dd$var$getSchEnv(keyRef) {
    keyRef = (0, $eO3NS.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function $e8082dfaf38787dd$var$addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(const key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function $e8082dfaf38787dd$var$addInitialFormats() {
    for(const name in this.opts.formats){
        const format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function $e8082dfaf38787dd$var$addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(const keyword in defs){
        const def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function $e8082dfaf38787dd$var$getMetaSchemaOptions() {
    const metaOpts = {
        ...this.opts
    };
    for (const opt of $e8082dfaf38787dd$var$META_IGNORE_OPTIONS)delete metaOpts[opt];
    return metaOpts;
}
const $e8082dfaf38787dd$var$noLogs = {
    log () {},
    warn () {},
    error () {}
};
function $e8082dfaf38787dd$var$getLogger(logger) {
    if (logger === false) return $e8082dfaf38787dd$var$noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const $e8082dfaf38787dd$var$KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function $e8082dfaf38787dd$var$checkKeyword(keyword, def) {
    const { RULES: RULES } = this;
    (0, $8rmX0.eachItem)(keyword, (kwd)=>{
        if (RULES.keywords[kwd]) throw new Error(`Keyword ${kwd} is already defined`);
        if (!$e8082dfaf38787dd$var$KEYWORD_NAME.test(kwd)) throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function $e8082dfaf38787dd$var$addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t })=>t === dataType);
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    const rule = {
        keyword: keyword,
        definition: {
            ...definition,
            type: (0, $bvJtX.getJSONTypes)(definition.type),
            schemaType: (0, $bvJtX.getJSONTypes)(definition.schemaType)
        }
    };
    if (definition.before) $e8082dfaf38787dd$var$addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach((kwd)=>this.addKeyword(kwd));
}
function $e8082dfaf38787dd$var$addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule)=>_rule.keyword === before);
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function $e8082dfaf38787dd$var$keywordMetaschema(def) {
    let { metaSchema: metaSchema } = def;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = $e8082dfaf38787dd$var$schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $e8082dfaf38787dd$var$$dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function $e8082dfaf38787dd$var$schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $e8082dfaf38787dd$var$$dataRef
        ]
    };
}

});
parcelRegister("bTGAO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeywordCxt = void 0;
module.exports.validateFunctionCode = $8a95dec96ee950e3$var$validateFunctionCode;
module.exports.getData = $8a95dec96ee950e3$var$getData;

var $4gHJN = parcelRequire("4gHJN");

var $bvJtX = parcelRequire("bvJtX");

var $lRks7 = parcelRequire("lRks7");

var $bvJtX = parcelRequire("bvJtX");

var $HakW6 = parcelRequire("HakW6");

var $aGslB = parcelRequire("aGslB");

var $586RV = parcelRequire("586RV");

var $lohei = parcelRequire("lohei");

var $7CJrC = parcelRequire("7CJrC");

var $eO3NS = parcelRequire("eO3NS");

var $8rmX0 = parcelRequire("8rmX0");

var $gjXtw = parcelRequire("gjXtw");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function $8a95dec96ee950e3$var$validateFunctionCode(it) {
    if ($8a95dec96ee950e3$var$isSchemaObj(it)) {
        $8a95dec96ee950e3$var$checkKeywords(it);
        if ($8a95dec96ee950e3$var$schemaCxtHasRules(it)) {
            $8a95dec96ee950e3$var$topSchemaObjCode(it);
            return;
        }
    }
    $8a95dec96ee950e3$var$validateFunction(it, ()=>(0, $4gHJN.topBoolOrEmptySchema)(it));
}
function $8a95dec96ee950e3$var$validateFunction({ gen: gen, validateName: validateName, schema: schema, schemaEnv: schemaEnv, opts: opts }, body) {
    if (opts.code.es5) gen.func(validateName, (0, $lohei._)`${$7CJrC.default.data}, ${$7CJrC.default.valCxt}`, schemaEnv.$async, ()=>{
        gen.code((0, $lohei._)`"use strict"; ${$8a95dec96ee950e3$var$funcSourceUrl(schema, opts)}`);
        $8a95dec96ee950e3$var$destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, $lohei._)`${$7CJrC.default.data}, ${$8a95dec96ee950e3$var$destructureValCxt(opts)}`, schemaEnv.$async, ()=>gen.code($8a95dec96ee950e3$var$funcSourceUrl(schema, opts)).code(body));
}
function $8a95dec96ee950e3$var$destructureValCxt(opts) {
    return (0, $lohei._)`{${$7CJrC.default.instancePath}="", ${$7CJrC.default.parentData}, ${$7CJrC.default.parentDataProperty}, ${$7CJrC.default.rootData}=${$7CJrC.default.data}${opts.dynamicRef ? (0, $lohei._)`, ${$7CJrC.default.dynamicAnchors}={}` : $lohei.nil}, ${$7CJrC.default.isAllOfVariant} = 0}={}`;
}
function $8a95dec96ee950e3$var$destructureValCxtES5(gen, opts) {
    gen.if($7CJrC.default.valCxt, ()=>{
        gen.var($7CJrC.default.instancePath, (0, $lohei._)`${$7CJrC.default.valCxt}.${$7CJrC.default.instancePath}`);
        gen.var($7CJrC.default.parentData, (0, $lohei._)`${$7CJrC.default.valCxt}.${$7CJrC.default.parentData}`);
        gen.var($7CJrC.default.parentDataProperty, (0, $lohei._)`${$7CJrC.default.valCxt}.${$7CJrC.default.parentDataProperty}`);
        gen.var($7CJrC.default.rootData, (0, $lohei._)`${$7CJrC.default.valCxt}.${$7CJrC.default.rootData}`);
        gen.var($7CJrC.default.isAllOfVariant, (0, $lohei._)`${$7CJrC.default.valCxt}.${$7CJrC.default.isAllOfVariant}`);
        if (opts.dynamicRef) gen.var($7CJrC.default.dynamicAnchors, (0, $lohei._)`${$7CJrC.default.valCxt}.${$7CJrC.default.dynamicAnchors}`);
    }, ()=>{
        gen.var($7CJrC.default.instancePath, (0, $lohei._)`""`);
        gen.var($7CJrC.default.parentData, (0, $lohei._)`undefined`);
        gen.var($7CJrC.default.parentDataProperty, (0, $lohei._)`undefined`);
        gen.var($7CJrC.default.rootData, $7CJrC.default.data);
        gen.var($7CJrC.default.isAllOfVariant, (0, $lohei._)`0`);
        if (opts.dynamicRef) gen.var($7CJrC.default.dynamicAnchors, (0, $lohei._)`{}`);
    });
}
function $8a95dec96ee950e3$var$topSchemaObjCode(it) {
    const { schema: schema, opts: opts, gen: gen } = it;
    $8a95dec96ee950e3$var$validateFunction(it, ()=>{
        if (opts.$comment && schema.$comment) $8a95dec96ee950e3$var$commentKeyword(it);
        $8a95dec96ee950e3$var$checkNoDefault(it);
        gen.let($7CJrC.default.vErrors, null);
        gen.let($7CJrC.default.errors, 0);
        if (opts.unevaluated) $8a95dec96ee950e3$var$resetEvaluated(it);
        $8a95dec96ee950e3$var$typeAndKeywords(it);
        $8a95dec96ee950e3$var$returnResults(it);
    });
    return;
}
function $8a95dec96ee950e3$var$resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen: gen, validateName: validateName } = it;
    it.evaluated = gen.const("evaluated", (0, $lohei._)`${validateName}.evaluated`);
    gen.if((0, $lohei._)`${it.evaluated}.dynamicProps`, ()=>gen.assign((0, $lohei._)`${it.evaluated}.props`, (0, $lohei._)`undefined`));
    gen.if((0, $lohei._)`${it.evaluated}.dynamicItems`, ()=>gen.assign((0, $lohei._)`${it.evaluated}.items`, (0, $lohei._)`undefined`));
}
function $8a95dec96ee950e3$var$funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, $lohei._)`/*# sourceURL=${schId} */` : $lohei.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function $8a95dec96ee950e3$var$subschemaCode(it, valid) {
    if ($8a95dec96ee950e3$var$isSchemaObj(it)) {
        $8a95dec96ee950e3$var$checkKeywords(it);
        if ($8a95dec96ee950e3$var$schemaCxtHasRules(it)) {
            $8a95dec96ee950e3$var$subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, $4gHJN.boolOrEmptySchema)(it, valid);
}
function $8a95dec96ee950e3$var$schemaCxtHasRules({ schema: schema, self: self }) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function $8a95dec96ee950e3$var$isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function $8a95dec96ee950e3$var$subSchemaObjCode(it, valid) {
    const { schema: schema, gen: gen, opts: opts } = it;
    if (opts.$comment && schema.$comment) $8a95dec96ee950e3$var$commentKeyword(it);
    $8a95dec96ee950e3$var$updateContext(it);
    $8a95dec96ee950e3$var$checkAsyncSchema(it);
    const errsCount = gen.const("_errs", $7CJrC.default.errors);
    $8a95dec96ee950e3$var$typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, $lohei._)`${errsCount} === ${$7CJrC.default.errors}`);
}
function $8a95dec96ee950e3$var$checkKeywords(it) {
    (0, $8rmX0.checkUnknownRules)(it);
    $8a95dec96ee950e3$var$checkRefsAndKeywords(it);
}
function $8a95dec96ee950e3$var$typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return $8a95dec96ee950e3$var$schemaKeywords(it, [], false, errsCount);
    const types = (0, $bvJtX.getSchemaTypes)(it.schema);
    const checkedTypes = (0, $bvJtX.coerceAndCheckDataType)(it, types);
    $8a95dec96ee950e3$var$schemaKeywords(it, types, !checkedTypes, errsCount);
}
function $8a95dec96ee950e3$var$checkRefsAndKeywords(it) {
    const { schema: schema, errSchemaPath: errSchemaPath, opts: opts, self: self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, $8rmX0.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
}
function $8a95dec96ee950e3$var$checkNoDefault(it) {
    const { schema: schema, opts: opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, $8rmX0.checkStrictMode)(it, "default is ignored in the schema root");
}
function $8a95dec96ee950e3$var$updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, $eO3NS.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function $8a95dec96ee950e3$var$checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function $8a95dec96ee950e3$var$commentKeyword({ gen: gen, schemaEnv: schemaEnv, schema: schema, errSchemaPath: errSchemaPath, opts: opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, $lohei._)`${$7CJrC.default.self}.logger.log(${msg})`);
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, $lohei.str)`${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, $lohei._)`${$7CJrC.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function $8a95dec96ee950e3$var$returnResults(it) {
    const { gen: gen, schemaEnv: schemaEnv, validateName: validateName, ValidationError: ValidationError, opts: opts } = it;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, $lohei._)`${$7CJrC.default.errors} === 0`, ()=>gen.return($7CJrC.default.data), ()=>gen.throw((0, $lohei._)`new ${ValidationError}(${$7CJrC.default.vErrors})`));
    else {
        gen.assign((0, $lohei._)`${validateName}.errors`, $7CJrC.default.vErrors);
        if (opts.unevaluated) $8a95dec96ee950e3$var$assignEvaluated(it);
        gen.return((0, $lohei._)`${$7CJrC.default.errors} === 0`);
    }
}
function $8a95dec96ee950e3$var$assignEvaluated({ gen: gen, evaluated: evaluated, props: props, items: items }) {
    if (props instanceof $lohei.Name) gen.assign((0, $lohei._)`${evaluated}.props`, props);
    if (items instanceof $lohei.Name) gen.assign((0, $lohei._)`${evaluated}.items`, items);
}
function $8a95dec96ee950e3$var$schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen: gen, schema: schema, data: data, allErrors: allErrors, opts: opts, self: self } = it;
    const { RULES: RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, $8rmX0.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(()=>$8a95dec96ee950e3$var$keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd) $8a95dec96ee950e3$var$checkStrictTypes(it, types);
    gen.block(()=>{
        for (const group of RULES.rules)groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, $lRks7.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, $bvJtX.checkDataType)(group.type, data, opts.strictNumbers));
            $8a95dec96ee950e3$var$iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, $bvJtX.reportTypeError)(it);
            }
            gen.endIf();
        } else $8a95dec96ee950e3$var$iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, $lohei._)`${$7CJrC.default.errors} === ${errsCount || 0}`);
    }
}
function $8a95dec96ee950e3$var$iterateKeywords(it, group) {
    const { gen: gen, schema: schema, opts: { useDefaults: useDefaults } } = it;
    if (useDefaults) (0, $HakW6.assignDefaults)(it, group.type);
    gen.block(()=>{
        for (const rule of group.rules)if ((0, $lRks7.shouldUseRule)(schema, rule) || shouldForceUnevaluatedProperties(schema, rule)) $8a95dec96ee950e3$var$keywordCode(it, rule.keyword, rule.definition, group.type);
    });
    function shouldForceUnevaluatedProperties(schema, rule) {
        return !!(rule.keyword === "unevaluatedProperties" && (schema.properties || schema.patternProperties) && !it.isAllOfVariant && it.opts.defaultUnevaluatedProperties === false);
    }
}
function $8a95dec96ee950e3$var$checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    $8a95dec96ee950e3$var$checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) $8a95dec96ee950e3$var$checkMultipleTypes(it, types);
    $8a95dec96ee950e3$var$checkKeywordTypes(it, it.dataTypes);
}
function $8a95dec96ee950e3$var$checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t)=>{
        if (!$8a95dec96ee950e3$var$includesType(it.dataTypes, t)) $8a95dec96ee950e3$var$strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
    });
    it.dataTypes = it.dataTypes.filter((t)=>$8a95dec96ee950e3$var$includesType(types, t));
}
function $8a95dec96ee950e3$var$checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) $8a95dec96ee950e3$var$strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function $8a95dec96ee950e3$var$checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for(const keyword in rules){
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, $lRks7.shouldUseRule)(it.schema, rule)) {
            const { type: type } = rule.definition;
            if (type.length && !type.some((t)=>$8a95dec96ee950e3$var$hasApplicableType(ts, t))) $8a95dec96ee950e3$var$strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
        }
    }
}
function $8a95dec96ee950e3$var$hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function $8a95dec96ee950e3$var$includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function $8a95dec96ee950e3$var$strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, $8rmX0.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class $8a95dec96ee950e3$var$KeywordCxt {
    constructor(it, def, keyword){
        (0, $aGslB.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, $8rmX0.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", $8a95dec96ee950e3$var$getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, $aGslB.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", $7CJrC.default.errors);
    }
    result(condition, successAction, failAction) {
        this.failResult((0, $lohei.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction) failAction();
        else this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors) this.gen.endIf();
        } else if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    pass(condition, failAction) {
        this.failResult((0, $lohei.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data) return this.fail(condition);
        const { schemaCode: schemaCode } = this;
        this.fail((0, $lohei._)`${schemaCode} !== undefined && (${(0, $lohei.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        (append ? $gjXtw.reportExtraError : $gjXtw.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, $gjXtw.reportError)(this, this.def.$dataError || $gjXtw.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
        (0, $gjXtw.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors) this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign) Object.assign(this.params, obj);
        else this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = $lohei.nil) {
        this.gen.block(()=>{
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = $lohei.nil, $dataValid = $lohei.nil) {
        if (!this.$data) return;
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def } = this;
        gen.if((0, $lohei.or)((0, $lohei._)`${schemaCode} === undefined`, $dataValid));
        if (valid !== $lohei.nil) gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== $lohei.nil) gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def, it: it } = this;
        return (0, $lohei.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */ if (!(schemaCode instanceof $lohei.Name)) throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [
                    schemaType
                ];
                return (0, $lohei._)`${(0, $bvJtX.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, $bvJtX.DataType.Wrong)}`;
            }
            return $lohei.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", {
                    ref: def.validateSchema
                }); // TODO value.code for standalone
                return (0, $lohei._)`!${validateSchemaRef}(${schemaCode})`;
            }
            return $lohei.nil;
        }
    }
    subschema(appl, valid, isAllOfVariant) {
        const subschema = (0, $586RV.getSubschema)(this.it, appl);
        (0, $586RV.extendSubschemaData)(subschema, this.it, appl);
        (0, $586RV.extendSubschemaMode)(subschema, appl);
        const nextContext = {
            ...this.it,
            ...subschema,
            items: undefined,
            props: undefined,
            isAllOfVariant: isAllOfVariant
        };
        $8a95dec96ee950e3$var$subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it: it, gen: gen } = this;
        if (!it.opts.unevaluated) return;
        if (it.props !== true && schemaCxt.props !== undefined) it.props = $8rmX0.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        if (it.items !== true && schemaCxt.items !== undefined) it.items = $8rmX0.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it: it, gen: gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, ()=>this.mergeEvaluated(schemaCxt, $lohei.Name));
            return true;
        }
    }
}
module.exports.KeywordCxt = $8a95dec96ee950e3$var$KeywordCxt;
function $8a95dec96ee950e3$var$keywordCode(it, keyword, def, ruleType) {
    const cxt = new $8a95dec96ee950e3$var$KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, $aGslB.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, $aGslB.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, $aGslB.funcKeywordCode)(cxt, def);
}
const $8a95dec96ee950e3$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const $8a95dec96ee950e3$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $8a95dec96ee950e3$var$getData($data, { dataLevel: dataLevel, dataNames: dataNames, dataPathArr: dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "") return $7CJrC.default.rootData;
    if ($data[0] === "/") {
        if (!$8a95dec96ee950e3$var$JSON_POINTER.test($data)) throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = $7CJrC.default.rootData;
    } else {
        const matches = $8a95dec96ee950e3$var$RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments)if (segment) {
        data = (0, $lohei._)`${data}${(0, $lohei.getProperty)((0, $8rmX0.unescapeJsonPointer)(segment))}`;
        expr = (0, $lohei._)`${expr} && ${data}`;
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}

});
parcelRegister("4gHJN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.topBoolOrEmptySchema = $31ba9572fbe6710b$var$topBoolOrEmptySchema;
module.exports.boolOrEmptySchema = $31ba9572fbe6710b$var$boolOrEmptySchema;

var $gjXtw = parcelRequire("gjXtw");

var $lohei = parcelRequire("lohei");

var $7CJrC = parcelRequire("7CJrC");
const $31ba9572fbe6710b$var$boolError = {
    message: "boolean schema is false"
};
function $31ba9572fbe6710b$var$topBoolOrEmptySchema(it) {
    const { gen: gen, schema: schema, validateName: validateName } = it;
    if (schema === false) $31ba9572fbe6710b$var$falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return($7CJrC.default.data);
    else {
        gen.assign((0, $lohei._)`${validateName}.errors`, null);
        gen.return(true);
    }
}
function $31ba9572fbe6710b$var$boolOrEmptySchema(it, valid) {
    const { gen: gen, schema: schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        $31ba9572fbe6710b$var$falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
function $31ba9572fbe6710b$var$falseSchemaError(it, overrideAllErrors) {
    const { gen: gen, data: data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen: gen,
        keyword: "false schema",
        data: data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it: it
    };
    (0, $gjXtw.reportError)(cxt, $31ba9572fbe6710b$var$boolError, undefined, overrideAllErrors);
}

});
parcelRegister("gjXtw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keyword$DataError = module.exports.keywordError = void 0;
module.exports.reportError = $be1c8e34d2ea963c$var$reportError;
module.exports.reportExtraError = $be1c8e34d2ea963c$var$reportExtraError;
module.exports.resetErrorsCount = $be1c8e34d2ea963c$var$resetErrorsCount;
module.exports.extendErrors = $be1c8e34d2ea963c$var$extendErrors;

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");

var $7CJrC = parcelRequire("7CJrC");
module.exports.keywordError = {
    message: ({ keyword: keyword })=>(0, $lohei.str)`must pass "${keyword}" keyword validation`
};
module.exports.keyword$DataError = {
    message: ({ keyword: keyword, schemaType: schemaType })=>schemaType ? (0, $lohei.str)`"${keyword}" keyword must be ${schemaType} ($data)` : (0, $lohei.str)`"${keyword}" keyword is invalid ($data)`
};
function $be1c8e34d2ea963c$var$reportError(cxt, error = module.exports.keywordError, errorPaths, overrideAllErrors) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $be1c8e34d2ea963c$var$errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) $be1c8e34d2ea963c$var$addError(gen, errObj);
    else $be1c8e34d2ea963c$var$returnErrors(it, (0, $lohei._)`[${errObj}]`);
}
function $be1c8e34d2ea963c$var$reportExtraError(cxt, error = module.exports.keywordError, errorPaths) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $be1c8e34d2ea963c$var$errorObjectCode(cxt, error, errorPaths);
    $be1c8e34d2ea963c$var$addError(gen, errObj);
    if (!(compositeRule || allErrors)) $be1c8e34d2ea963c$var$returnErrors(it, $7CJrC.default.vErrors);
}
function $be1c8e34d2ea963c$var$resetErrorsCount(gen, errsCount) {
    gen.assign($7CJrC.default.errors, errsCount);
    gen.if((0, $lohei._)`${$7CJrC.default.vErrors} !== null`, ()=>gen.if(errsCount, ()=>gen.assign((0, $lohei._)`${$7CJrC.default.vErrors}.length`, errsCount), ()=>gen.assign($7CJrC.default.vErrors, null)));
}
function $be1c8e34d2ea963c$var$extendErrors({ gen: gen, keyword: keyword, schemaValue: schemaValue, data: data, errsCount: errsCount, it: it }) {
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, $7CJrC.default.errors, (i)=>{
        gen.const(err, (0, $lohei._)`${$7CJrC.default.vErrors}[${i}]`);
        gen.if((0, $lohei._)`${err}.instancePath === undefined`, ()=>gen.assign((0, $lohei._)`${err}.instancePath`, (0, $lohei.strConcat)($7CJrC.default.instancePath, it.errorPath)));
        gen.assign((0, $lohei._)`${err}.schemaPath`, (0, $lohei.str)`${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, $lohei._)`${err}.schema`, schemaValue);
            gen.assign((0, $lohei._)`${err}.data`, data);
        }
    });
}
function $be1c8e34d2ea963c$var$addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, $lohei._)`${$7CJrC.default.vErrors} === null`, ()=>gen.assign($7CJrC.default.vErrors, (0, $lohei._)`[${err}]`), (0, $lohei._)`${$7CJrC.default.vErrors}.push(${err})`);
    gen.code((0, $lohei._)`${$7CJrC.default.errors}++`);
}
function $be1c8e34d2ea963c$var$returnErrors(it, errs) {
    const { gen: gen, validateName: validateName, schemaEnv: schemaEnv } = it;
    if (schemaEnv.$async) gen.throw((0, $lohei._)`new ${it.ValidationError}(${errs})`);
    else {
        gen.assign((0, $lohei._)`${validateName}.errors`, errs);
        gen.return(false);
    }
}
const $be1c8e34d2ea963c$var$E = {
    keyword: new $lohei.Name("keyword"),
    schemaPath: new $lohei.Name("schemaPath"),
    params: new $lohei.Name("params"),
    propertyName: new $lohei.Name("propertyName"),
    message: new $lohei.Name("message"),
    schema: new $lohei.Name("schema"),
    parentSchema: new $lohei.Name("parentSchema")
};
function $be1c8e34d2ea963c$var$errorObjectCode(cxt, error, errorPaths) {
    const { createErrors: createErrors } = cxt.it;
    if (createErrors === false) return (0, $lohei._)`{}`;
    return $be1c8e34d2ea963c$var$errorObject(cxt, error, errorPaths);
}
function $be1c8e34d2ea963c$var$errorObject(cxt, error, errorPaths = {}) {
    const { gen: gen, it: it } = cxt;
    const keyValues = [
        $be1c8e34d2ea963c$var$errorInstancePath(it, errorPaths),
        $be1c8e34d2ea963c$var$errorSchemaPath(cxt, errorPaths)
    ];
    $be1c8e34d2ea963c$var$extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function $be1c8e34d2ea963c$var$errorInstancePath({ errorPath: errorPath }, { instancePath: instancePath }) {
    const instPath = instancePath ? (0, $lohei.str)`${errorPath}${(0, $8rmX0.getErrorPath)(instancePath, $8rmX0.Type.Str)}` : errorPath;
    return [
        $7CJrC.default.instancePath,
        (0, $lohei.strConcat)($7CJrC.default.instancePath, instPath)
    ];
}
function $be1c8e34d2ea963c$var$errorSchemaPath({ keyword: keyword, it: { errSchemaPath: errSchemaPath } }, { schemaPath: schemaPath, parentSchema: parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, $lohei.str)`${errSchemaPath}/${keyword}`;
    if (schemaPath) schPath = (0, $lohei.str)`${schPath}${(0, $8rmX0.getErrorPath)(schemaPath, $8rmX0.Type.Str)}`;
    return [
        $be1c8e34d2ea963c$var$E.schemaPath,
        schPath
    ];
}
function $be1c8e34d2ea963c$var$extraErrorProps(cxt, { params: params, message: message }, keyValues) {
    const { keyword: keyword, data: data, schemaValue: schemaValue, it: it } = cxt;
    const { opts: opts, propertyName: propertyName, topSchemaRef: topSchemaRef, schemaPath: schemaPath } = it;
    keyValues.push([
        $be1c8e34d2ea963c$var$E.keyword,
        keyword
    ], [
        $be1c8e34d2ea963c$var$E.params,
        typeof params == "function" ? params(cxt) : params || (0, $lohei._)`{}`
    ]);
    if (opts.messages) keyValues.push([
        $be1c8e34d2ea963c$var$E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        $be1c8e34d2ea963c$var$E.schema,
        schemaValue
    ], [
        $be1c8e34d2ea963c$var$E.parentSchema,
        (0, $lohei._)`${topSchemaRef}${schemaPath}`
    ], [
        $7CJrC.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        $be1c8e34d2ea963c$var$E.propertyName,
        propertyName
    ]);
}

});
parcelRegister("lohei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeGen = module.exports.operators = module.exports.varKinds = module.exports.ValueScopeName = module.exports.ValueScope = module.exports.Scope = module.exports.Name = module.exports.regexpCode = module.exports.stringify = module.exports.getProperty = module.exports.nil = module.exports.strConcat = module.exports.str = module.exports._ = void 0;
module.exports.not = $f929344dc8b95166$var$not;
module.exports.and = $f929344dc8b95166$var$and;
module.exports.or = $f929344dc8b95166$var$or;

var $iIt2o = parcelRequire("iIt2o");

var $gJGHd = parcelRequire("gJGHd");

var $iIt2o = parcelRequire("iIt2o");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $iIt2o._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $iIt2o.str;
    }
});
Object.defineProperty(module.exports, "strConcat", {
    enumerable: true,
    get: function() {
        return $iIt2o.strConcat;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $iIt2o.nil;
    }
});
Object.defineProperty(module.exports, "getProperty", {
    enumerable: true,
    get: function() {
        return $iIt2o.getProperty;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $iIt2o.stringify;
    }
});
Object.defineProperty(module.exports, "regexpCode", {
    enumerable: true,
    get: function() {
        return $iIt2o.regexpCode;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $iIt2o.Name;
    }
});

var $gJGHd = parcelRequire("gJGHd");
Object.defineProperty(module.exports, "Scope", {
    enumerable: true,
    get: function() {
        return $gJGHd.Scope;
    }
});
Object.defineProperty(module.exports, "ValueScope", {
    enumerable: true,
    get: function() {
        return $gJGHd.ValueScope;
    }
});
Object.defineProperty(module.exports, "ValueScopeName", {
    enumerable: true,
    get: function() {
        return $gJGHd.ValueScopeName;
    }
});
Object.defineProperty(module.exports, "varKinds", {
    enumerable: true,
    get: function() {
        return $gJGHd.varKinds;
    }
});
module.exports.operators = {
    GT: new $iIt2o._Code(">"),
    GTE: new $iIt2o._Code(">="),
    LT: new $iIt2o._Code("<"),
    LTE: new $iIt2o._Code("<="),
    EQ: new $iIt2o._Code("==="),
    NEQ: new $iIt2o._Code("!=="),
    NOT: new $iIt2o._Code("!"),
    OR: new $iIt2o._Code("||"),
    AND: new $iIt2o._Code("&&"),
    ADD: new $iIt2o._Code("+")
};
class $f929344dc8b95166$var$Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class $f929344dc8b95166$var$Def extends $f929344dc8b95166$var$Node {
    constructor(varKind, name, rhs){
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5: es5, _n: _n }) {
        const varKind = es5 ? $gJGHd.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str]) return;
        if (this.rhs) this.rhs = $f929344dc8b95166$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof $iIt2o._CodeOrName ? this.rhs.names : {};
    }
}
class $f929344dc8b95166$var$Assign extends $f929344dc8b95166$var$Node {
    constructor(lhs, rhs, sideEffects){
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n: _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof $iIt2o.Name && !names[this.lhs.str] && !this.sideEffects) return;
        this.rhs = $f929344dc8b95166$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof $iIt2o.Name ? {} : {
            ...this.lhs.names
        };
        return $f929344dc8b95166$var$addExprNames(names, this.rhs);
    }
}
class $f929344dc8b95166$var$AssignOp extends $f929344dc8b95166$var$Assign {
    constructor(lhs, op, rhs, sideEffects){
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n: _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class $f929344dc8b95166$var$Label extends $f929344dc8b95166$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        return `${this.label}:` + _n;
    }
}
class $f929344dc8b95166$var$Break extends $f929344dc8b95166$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class $f929344dc8b95166$var$Throw extends $f929344dc8b95166$var$Node {
    constructor(error){
        super();
        this.error = error;
    }
    render({ _n: _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class $f929344dc8b95166$var$AnyCode extends $f929344dc8b95166$var$Node {
    constructor(code){
        super();
        this.code = code;
    }
    render({ _n: _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = $f929344dc8b95166$var$optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof $iIt2o._CodeOrName ? this.code.names : {};
    }
}
class $f929344dc8b95166$var$ParentNode extends $f929344dc8b95166$var$Node {
    constructor(nodes = []){
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n)=>code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n)) nodes.splice(i, 1, ...n);
            else if (n) nodes[i] = n;
            else nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants)) continue;
            $f929344dc8b95166$var$subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n)=>$f929344dc8b95166$var$addNames(names, n.names), {});
    }
}
class $f929344dc8b95166$var$BlockNode extends $f929344dc8b95166$var$ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class $f929344dc8b95166$var$Root extends $f929344dc8b95166$var$ParentNode {
}
class $f929344dc8b95166$var$Else extends $f929344dc8b95166$var$BlockNode {
}
$f929344dc8b95166$var$Else.kind = "else";
class $f929344dc8b95166$var$If extends $f929344dc8b95166$var$BlockNode {
    constructor(condition, nodes){
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else) code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true) return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new $f929344dc8b95166$var$Else(ns) : ns;
        }
        if (e) {
            if (cond === false) return e instanceof $f929344dc8b95166$var$If ? e : e.nodes;
            if (this.nodes.length) return this;
            return new $f929344dc8b95166$var$If($f929344dc8b95166$var$not(cond), e instanceof $f929344dc8b95166$var$If ? [
                e
            ] : e.nodes);
        }
        if (cond === false || !this.nodes.length) return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else)) return;
        this.condition = $f929344dc8b95166$var$optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        $f929344dc8b95166$var$addExprNames(names, this.condition);
        if (this.else) $f929344dc8b95166$var$addNames(names, this.else.names);
        return names;
    }
}
$f929344dc8b95166$var$If.kind = "if";
class $f929344dc8b95166$var$For extends $f929344dc8b95166$var$BlockNode {
}
$f929344dc8b95166$var$For.kind = "for";
class $f929344dc8b95166$var$ForLoop extends $f929344dc8b95166$var$For {
    constructor(iteration){
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iteration = $f929344dc8b95166$var$optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return $f929344dc8b95166$var$addNames(super.names, this.iteration.names);
    }
}
class $f929344dc8b95166$var$ForRange extends $f929344dc8b95166$var$For {
    constructor(varKind, name, from, to){
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? $gJGHd.varKinds.var : this.varKind;
        const { name: name, from: from, to: to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = $f929344dc8b95166$var$addExprNames(super.names, this.from);
        return $f929344dc8b95166$var$addExprNames(names, this.to);
    }
}
class $f929344dc8b95166$var$ForIter extends $f929344dc8b95166$var$For {
    constructor(loop, varKind, name, iterable){
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iterable = $f929344dc8b95166$var$optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return $f929344dc8b95166$var$addNames(super.names, this.iterable.names);
    }
}
class $f929344dc8b95166$var$Func extends $f929344dc8b95166$var$BlockNode {
    constructor(name, args, async){
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
$f929344dc8b95166$var$Func.kind = "func";
class $f929344dc8b95166$var$Return extends $f929344dc8b95166$var$ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
$f929344dc8b95166$var$Return.kind = "return";
class $f929344dc8b95166$var$Try extends $f929344dc8b95166$var$BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch) code += this.catch.render(opts);
        if (this.finally) code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch) $f929344dc8b95166$var$addNames(names, this.catch.names);
        if (this.finally) $f929344dc8b95166$var$addNames(names, this.finally.names);
        return names;
    }
}
class $f929344dc8b95166$var$Catch extends $f929344dc8b95166$var$BlockNode {
    constructor(error){
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
$f929344dc8b95166$var$Catch.kind = "catch";
class $f929344dc8b95166$var$Finally extends $f929344dc8b95166$var$BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
$f929344dc8b95166$var$Finally.kind = "finally";
class $f929344dc8b95166$var$CodeGen {
    constructor(extScope, opts = {}){
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = {
            ...opts,
            _n: opts.lines ? "\n" : ""
        };
        this._extScope = extScope;
        this._scope = new $gJGHd.Scope({
            parent: extScope
        });
        this._nodes = [
            new $f929344dc8b95166$var$Root()
        ];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant) this._constants[name.str] = rhs;
        this._leafNode(new $f929344dc8b95166$var$Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def($gJGHd.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def($gJGHd.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def($gJGHd.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new $f929344dc8b95166$var$Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new $f929344dc8b95166$var$AssignOp(lhs, module.exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function") c();
        else if (c !== $iIt2o.nil) this._leafNode(new $f929344dc8b95166$var$AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = [
            "{"
        ];
        for (const [key, value] of keyValues){
            if (code.length > 1) code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, $iIt2o.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new $iIt2o._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new $f929344dc8b95166$var$If(condition));
        if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
        else if (thenBody) this.code(thenBody).endIf();
        else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new $f929344dc8b95166$var$If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new $f929344dc8b95166$var$Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode($f929344dc8b95166$var$If, $f929344dc8b95166$var$Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody) this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new $f929344dc8b95166$var$ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? $gJGHd.varKinds.var : $gJGHd.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $f929344dc8b95166$var$ForRange(varKind, name, from, to), ()=>forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = $gJGHd.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof $iIt2o.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, $iIt2o._)`${arr}.length`, (i)=>{
                this.var(name, (0, $iIt2o._)`${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new $f929344dc8b95166$var$ForIter("of", varKind, name, iterable), ()=>forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? $gJGHd.varKinds.var : $gJGHd.varKinds.const) {
        if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, $iIt2o._)`Object.keys(${obj})`, forBody);
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $f929344dc8b95166$var$ForIter("in", varKind, name, obj), ()=>forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode($f929344dc8b95166$var$For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new $f929344dc8b95166$var$Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new $f929344dc8b95166$var$Break(label));
    }
    // `return` statement
    return(value) {
        const node = new $f929344dc8b95166$var$Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode($f929344dc8b95166$var$Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new $f929344dc8b95166$var$Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new $f929344dc8b95166$var$Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new $f929344dc8b95166$var$Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode($f929344dc8b95166$var$Catch, $f929344dc8b95166$var$Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new $f929344dc8b95166$var$Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body) this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = $iIt2o.nil, async, funcBody) {
        this._blockNode(new $f929344dc8b95166$var$Func(name, args, async));
        if (funcBody) this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode($f929344dc8b95166$var$Func);
    }
    optimize(n = 1) {
        while(n-- > 0){
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || N2 && n instanceof N2) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof $f929344dc8b95166$var$If)) throw new Error('CodeGen: "else" without "if"');
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
module.exports.CodeGen = $f929344dc8b95166$var$CodeGen;
function $f929344dc8b95166$var$addNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function $f929344dc8b95166$var$addExprNames(names, from) {
    return from instanceof $iIt2o._CodeOrName ? $f929344dc8b95166$var$addNames(names, from.names) : names;
}
function $f929344dc8b95166$var$optimizeExpr(expr, names, constants) {
    if (expr instanceof $iIt2o.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new $iIt2o._Code(expr._items.reduce((items, c)=>{
        if (c instanceof $iIt2o.Name) c = replaceName(c);
        if (c instanceof $iIt2o._Code) items.push(...c._items);
        else items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return e instanceof $iIt2o._Code && e._items.some((c)=>c instanceof $iIt2o.Name && names[c.str] === 1 && constants[c.str] !== undefined);
    }
}
function $f929344dc8b95166$var$subtractNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function $f929344dc8b95166$var$not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, $iIt2o._)`!${$f929344dc8b95166$var$par(x)}`;
}
const $f929344dc8b95166$var$andCode = $f929344dc8b95166$var$mappend(module.exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function $f929344dc8b95166$var$and(...args) {
    return args.reduce($f929344dc8b95166$var$andCode);
}
const $f929344dc8b95166$var$orCode = $f929344dc8b95166$var$mappend(module.exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function $f929344dc8b95166$var$or(...args) {
    return args.reduce($f929344dc8b95166$var$orCode);
}
function $f929344dc8b95166$var$mappend(op) {
    return (x, y)=>x === $iIt2o.nil ? y : y === $iIt2o.nil ? x : (0, $iIt2o._)`${$f929344dc8b95166$var$par(x)} ${op} ${$f929344dc8b95166$var$par(y)}`;
}
function $f929344dc8b95166$var$par(x) {
    return x instanceof $iIt2o.Name ? x : (0, $iIt2o._)`(${x})`;
}

});
parcelRegister("iIt2o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.nil = module.exports._Code = module.exports.Name = module.exports.IDENTIFIER = module.exports._CodeOrName = void 0;
module.exports._ = $da02dc52938576b6$var$_;
module.exports.str = $da02dc52938576b6$var$str;
module.exports.addCodeArg = $da02dc52938576b6$var$addCodeArg;
module.exports.strConcat = $da02dc52938576b6$var$strConcat;
module.exports.stringify = $da02dc52938576b6$var$stringify;
module.exports.safeStringify = $da02dc52938576b6$var$safeStringify;
module.exports.getProperty = $da02dc52938576b6$var$getProperty;
module.exports.getEsmExportName = $da02dc52938576b6$var$getEsmExportName;
module.exports.regexpCode = $da02dc52938576b6$var$regexpCode;
class $da02dc52938576b6$var$_CodeOrName {
}
module.exports._CodeOrName = $da02dc52938576b6$var$_CodeOrName;
module.exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class $da02dc52938576b6$var$Name extends $da02dc52938576b6$var$_CodeOrName {
    constructor(s){
        super();
        if (!module.exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return {
            [this.str]: 1
        };
    }
}
module.exports.Name = $da02dc52938576b6$var$Name;
class $da02dc52938576b6$var$_Code extends $da02dc52938576b6$var$_CodeOrName {
    constructor(code){
        super();
        this._items = typeof code === "string" ? [
            code
        ] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1) return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce((s, c)=>`${s}${c}`, "");
    }
    get names() {
        var _a;
        return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce((names, c)=>{
            if (c instanceof $da02dc52938576b6$var$Name) names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {});
    }
}
module.exports._Code = $da02dc52938576b6$var$_Code;
module.exports.nil = new $da02dc52938576b6$var$_Code("");
function $da02dc52938576b6$var$_(strs, ...args) {
    const code = [
        strs[0]
    ];
    let i = 0;
    while(i < args.length){
        $da02dc52938576b6$var$addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new $da02dc52938576b6$var$_Code(code);
}
const $da02dc52938576b6$var$plus = new $da02dc52938576b6$var$_Code("+");
function $da02dc52938576b6$var$str(strs, ...args) {
    const expr = [
        $da02dc52938576b6$var$safeStringify(strs[0])
    ];
    let i = 0;
    while(i < args.length){
        expr.push($da02dc52938576b6$var$plus);
        $da02dc52938576b6$var$addCodeArg(expr, args[i]);
        expr.push($da02dc52938576b6$var$plus, $da02dc52938576b6$var$safeStringify(strs[++i]));
    }
    $da02dc52938576b6$var$optimize(expr);
    return new $da02dc52938576b6$var$_Code(expr);
}
function $da02dc52938576b6$var$addCodeArg(code, arg) {
    if (arg instanceof $da02dc52938576b6$var$_Code) code.push(...arg._items);
    else if (arg instanceof $da02dc52938576b6$var$Name) code.push(arg);
    else code.push($da02dc52938576b6$var$interpolate(arg));
}
function $da02dc52938576b6$var$optimize(expr) {
    let i = 1;
    while(i < expr.length - 1){
        if (expr[i] === $da02dc52938576b6$var$plus) {
            const res = $da02dc52938576b6$var$mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function $da02dc52938576b6$var$mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof $da02dc52938576b6$var$Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof $da02dc52938576b6$var$Name)) return `"${a}${b.slice(1)}`;
    return;
}
function $da02dc52938576b6$var$strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : $da02dc52938576b6$var$str`${c1}${c2}`;
}
// TODO do not allow arrays here
function $da02dc52938576b6$var$interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : $da02dc52938576b6$var$safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function $da02dc52938576b6$var$stringify(x) {
    return new $da02dc52938576b6$var$_Code($da02dc52938576b6$var$safeStringify(x));
}
function $da02dc52938576b6$var$safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
function $da02dc52938576b6$var$getProperty(key) {
    return typeof key == "string" && module.exports.IDENTIFIER.test(key) ? new $da02dc52938576b6$var$_Code(`.${key}`) : $da02dc52938576b6$var$_`[${key}]`;
}
//Does best effort to format the name properly
function $da02dc52938576b6$var$getEsmExportName(key) {
    if (typeof key == "string" && module.exports.IDENTIFIER.test(key)) return new $da02dc52938576b6$var$_Code(`${key}`);
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
function $da02dc52938576b6$var$regexpCode(rx) {
    return new $da02dc52938576b6$var$_Code(rx.toString());
}

});

parcelRegister("gJGHd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueScope = module.exports.ValueScopeName = module.exports.Scope = module.exports.varKinds = module.exports.UsedValueState = void 0;

var $iIt2o = parcelRequire("iIt2o");
class $c2f1f7d6c3f8b936$var$ValueError extends Error {
    constructor(name){
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var $c2f1f7d6c3f8b936$var$UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})($c2f1f7d6c3f8b936$var$UsedValueState || (module.exports.UsedValueState = $c2f1f7d6c3f8b936$var$UsedValueState = {}));
module.exports.varKinds = {
    const: new $iIt2o.Name("const"),
    let: new $iIt2o.Name("let"),
    var: new $iIt2o.Name("var")
};
class $c2f1f7d6c3f8b936$var$Scope {
    constructor({ prefixes: prefixes, parent: parent } = {}){
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof $iIt2o.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new $iIt2o.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        return this._names[prefix] = {
            prefix: prefix,
            index: 0
        };
    }
}
module.exports.Scope = $c2f1f7d6c3f8b936$var$Scope;
class $c2f1f7d6c3f8b936$var$ValueScopeName extends $iIt2o.Name {
    constructor(prefix, nameStr){
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property: property, itemIndex: itemIndex }) {
        this.value = value;
        this.scopePath = (0, $iIt2o._)`.${new $iIt2o.Name(property)}[${itemIndex}]`;
    }
}
module.exports.ValueScopeName = $c2f1f7d6c3f8b936$var$ValueScopeName;
const $c2f1f7d6c3f8b936$var$line = (0, $iIt2o._)`\n`;
class $c2f1f7d6c3f8b936$var$ValueScope extends $c2f1f7d6c3f8b936$var$Scope {
    constructor(opts){
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = {
            ...opts,
            _n: opts.lines ? $c2f1f7d6c3f8b936$var$line : $iIt2o.nil
        };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new $c2f1f7d6c3f8b936$var$ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix: prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name) return _name;
        } else vs = this._values[prefix] = new Map();
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, {
            property: prefix,
            itemIndex: itemIndex
        });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs) return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name)=>{
            if (name.scopePath === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, $iIt2o._)`${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name)=>{
            if (name.value === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = $iIt2o.nil;
        for(const prefix in values){
            const vs = values[prefix];
            if (!vs) continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
            vs.forEach((name)=>{
                if (nameSet.has(name)) return;
                nameSet.set(name, $c2f1f7d6c3f8b936$var$UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? module.exports.varKinds.var : module.exports.varKinds.const;
                    code = (0, $iIt2o._)`${code}${def} ${name} = ${c};${this.opts._n}`;
                } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, $iIt2o._)`${code}${c}${this.opts._n}`;
                else throw new $c2f1f7d6c3f8b936$var$ValueError(name);
                nameSet.set(name, $c2f1f7d6c3f8b936$var$UsedValueState.Completed);
            });
        }
        return code;
    }
}
module.exports.ValueScope = $c2f1f7d6c3f8b936$var$ValueScope;

});


parcelRegister("8rmX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Type = module.exports.mergeEvaluated = void 0;
module.exports.toHash = $6252a5e5bfa8d653$var$toHash;
module.exports.alwaysValidSchema = $6252a5e5bfa8d653$var$alwaysValidSchema;
module.exports.checkUnknownRules = $6252a5e5bfa8d653$var$checkUnknownRules;
module.exports.schemaHasRules = $6252a5e5bfa8d653$var$schemaHasRules;
module.exports.schemaHasRulesButRef = $6252a5e5bfa8d653$var$schemaHasRulesButRef;
module.exports.schemaRefOrVal = $6252a5e5bfa8d653$var$schemaRefOrVal;
module.exports.unescapeFragment = $6252a5e5bfa8d653$var$unescapeFragment;
module.exports.escapeFragment = $6252a5e5bfa8d653$var$escapeFragment;
module.exports.escapeJsonPointer = $6252a5e5bfa8d653$var$escapeJsonPointer;
module.exports.unescapeJsonPointer = $6252a5e5bfa8d653$var$unescapeJsonPointer;
module.exports.eachItem = $6252a5e5bfa8d653$var$eachItem;
module.exports.evaluatedPropsToName = $6252a5e5bfa8d653$var$evaluatedPropsToName;
module.exports.setEvaluated = $6252a5e5bfa8d653$var$setEvaluated;
module.exports.useFunc = $6252a5e5bfa8d653$var$useFunc;
module.exports.getErrorPath = $6252a5e5bfa8d653$var$getErrorPath;
module.exports.checkStrictMode = $6252a5e5bfa8d653$var$checkStrictMode;

var $lohei = parcelRequire("lohei");

var $iIt2o = parcelRequire("iIt2o");
// TODO refactor to use Set
function $6252a5e5bfa8d653$var$toHash(arr) {
    const hash = {};
    for (const item of arr)hash[item] = true;
    return hash;
}
function $6252a5e5bfa8d653$var$alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    $6252a5e5bfa8d653$var$checkUnknownRules(it, schema);
    return !$6252a5e5bfa8d653$var$schemaHasRules(schema, it.self.RULES.all);
}
function $6252a5e5bfa8d653$var$checkUnknownRules(it, schema = it.schema) {
    const { opts: opts, self: self } = it;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    const rules = self.RULES.keywords;
    for(const key in schema)if (!rules[key]) $6252a5e5bfa8d653$var$checkStrictMode(it, `unknown keyword: "${key}"`);
}
function $6252a5e5bfa8d653$var$schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (rules[key]) return true;
    return false;
}
function $6252a5e5bfa8d653$var$schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
function $6252a5e5bfa8d653$var$schemaRefOrVal({ topSchemaRef: topSchemaRef, schemaPath: schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, $lohei._)`${schema}`;
    }
    return (0, $lohei._)`${topSchemaRef}${schemaPath}${(0, $lohei.getProperty)(keyword)}`;
}
function $6252a5e5bfa8d653$var$unescapeFragment(str) {
    return $6252a5e5bfa8d653$var$unescapeJsonPointer(decodeURIComponent(str));
}
function $6252a5e5bfa8d653$var$escapeFragment(str) {
    return encodeURIComponent($6252a5e5bfa8d653$var$escapeJsonPointer(str));
}
function $6252a5e5bfa8d653$var$escapeJsonPointer(str) {
    if (typeof str == "number") return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
function $6252a5e5bfa8d653$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
function $6252a5e5bfa8d653$var$eachItem(xs, f) {
    if (Array.isArray(xs)) for (const x of xs)f(x);
    else f(xs);
}
function $6252a5e5bfa8d653$var$makeMergeEvaluated({ mergeNames: mergeNames, mergeToName: mergeToName, mergeValues: mergeValues, resultToName: resultToName }) {
    return (gen, from, to, toName)=>{
        const res = to === undefined ? from : to instanceof $lohei.Name ? (from instanceof $lohei.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof $lohei.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === $lohei.Name && !(res instanceof $lohei.Name) ? resultToName(gen, res) : res;
    };
}
module.exports.mergeEvaluated = {
    props: $6252a5e5bfa8d653$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $lohei._)`${to} !== true && ${from} !== undefined`, ()=>{
                gen.if((0, $lohei._)`${from} === true`, ()=>gen.assign(to, true), ()=>gen.assign(to, (0, $lohei._)`${to} || {}`).code((0, $lohei._)`Object.assign(${to}, ${from})`));
            }),
        mergeToName: (gen, from, to)=>gen.if((0, $lohei._)`${to} !== true`, ()=>{
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, $lohei._)`${to} || {}`);
                    $6252a5e5bfa8d653$var$setEvaluated(gen, to, from);
                }
            }),
        mergeValues: (from, to)=>from === true ? true : {
                ...from,
                ...to
            },
        resultToName: $6252a5e5bfa8d653$var$evaluatedPropsToName
    }),
    items: $6252a5e5bfa8d653$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $lohei._)`${to} !== true && ${from} !== undefined`, ()=>gen.assign(to, (0, $lohei._)`${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to)=>gen.if((0, $lohei._)`${to} !== true`, ()=>gen.assign(to, from === true ? true : (0, $lohei._)`${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to)=>from === true ? true : Math.max(from, to),
        resultToName: (gen, items)=>gen.var("items", items)
    })
};
function $6252a5e5bfa8d653$var$evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    const props = gen.var("props", (0, $lohei._)`{}`);
    if (ps !== undefined) $6252a5e5bfa8d653$var$setEvaluated(gen, props, ps);
    return props;
}
function $6252a5e5bfa8d653$var$setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p)=>gen.assign((0, $lohei._)`${props}${(0, $lohei.getProperty)(p)}`, true));
}
const $6252a5e5bfa8d653$var$snippets = {};
function $6252a5e5bfa8d653$var$useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: $6252a5e5bfa8d653$var$snippets[f.code] || ($6252a5e5bfa8d653$var$snippets[f.code] = new $iIt2o._Code(f.code))
    });
}
var $6252a5e5bfa8d653$var$Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})($6252a5e5bfa8d653$var$Type || (module.exports.Type = $6252a5e5bfa8d653$var$Type = {}));
function $6252a5e5bfa8d653$var$getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof $lohei.Name) {
        const isNumber = dataPropType === $6252a5e5bfa8d653$var$Type.Num;
        return jsPropertySyntax ? isNumber ? (0, $lohei._)`"[" + ${dataProp} + "]"` : (0, $lohei._)`"['" + ${dataProp} + "']"` : isNumber ? (0, $lohei._)`"/" + ${dataProp}` : (0, $lohei._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, $lohei.getProperty)(dataProp).toString() : "/" + $6252a5e5bfa8d653$var$escapeJsonPointer(dataProp);
}
function $6252a5e5bfa8d653$var$checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode) return;
    msg = `strict mode: ${msg}`;
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}

});

parcelRegister("7CJrC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");
const $58cf555bce412834$var$names = {
    // validation function arguments
    data: new $lohei.Name("data"),
    // args passed from referencing schema
    valCxt: new $lohei.Name("valCxt"),
    instancePath: new $lohei.Name("instancePath"),
    parentData: new $lohei.Name("parentData"),
    parentDataProperty: new $lohei.Name("parentDataProperty"),
    rootData: new $lohei.Name("rootData"),
    dynamicAnchors: new $lohei.Name("dynamicAnchors"),
    isAllOfVariant: new $lohei.Name("isAllOfVariant"),
    // function scoped variables
    vErrors: new $lohei.Name("vErrors"),
    errors: new $lohei.Name("errors"),
    this: new $lohei.Name("this"),
    // "globals"
    self: new $lohei.Name("self"),
    scope: new $lohei.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new $lohei.Name("json"),
    jsonPos: new $lohei.Name("jsonPos"),
    jsonLen: new $lohei.Name("jsonLen"),
    jsonPart: new $lohei.Name("jsonPart")
};
module.exports.default = $58cf555bce412834$var$names;

});



parcelRegister("bvJtX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataType = void 0;
module.exports.getSchemaTypes = $8615dec9e21f906e$var$getSchemaTypes;
module.exports.getJSONTypes = $8615dec9e21f906e$var$getJSONTypes;
module.exports.coerceAndCheckDataType = $8615dec9e21f906e$var$coerceAndCheckDataType;
module.exports.checkDataType = $8615dec9e21f906e$var$checkDataType;
module.exports.checkDataTypes = $8615dec9e21f906e$var$checkDataTypes;
module.exports.reportTypeError = $8615dec9e21f906e$var$reportTypeError;

var $2W1qL = parcelRequire("2W1qL");

var $lRks7 = parcelRequire("lRks7");

var $gjXtw = parcelRequire("gjXtw");

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");
var $8615dec9e21f906e$var$DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})($8615dec9e21f906e$var$DataType || (module.exports.DataType = $8615dec9e21f906e$var$DataType = {}));
function $8615dec9e21f906e$var$getSchemaTypes(schema) {
    const types = $8615dec9e21f906e$var$getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
function $8615dec9e21f906e$var$getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every($2W1qL.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
function $8615dec9e21f906e$var$coerceAndCheckDataType(it, types) {
    const { gen: gen, data: data, opts: opts } = it;
    const coerceTo = $8615dec9e21f906e$var$coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, $lRks7.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = $8615dec9e21f906e$var$checkDataTypes(types, data, opts.strictNumbers, $8615dec9e21f906e$var$DataType.Wrong);
        gen.if(wrongType, ()=>{
            if (coerceTo.length) $8615dec9e21f906e$var$coerceData(it, types, coerceTo);
            else $8615dec9e21f906e$var$reportTypeError(it);
        });
    }
    return checkTypes;
}
const $8615dec9e21f906e$var$COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function $8615dec9e21f906e$var$coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter((t)=>$8615dec9e21f906e$var$COERCIBLE.has(t) || coerceTypes === "array" && t === "array") : [];
}
function $8615dec9e21f906e$var$coerceData(it, types, coerceTo) {
    const { gen: gen, data: data, opts: opts } = it;
    const dataType = gen.let("dataType", (0, $lohei._)`typeof ${data}`);
    const coerced = gen.let("coerced", (0, $lohei._)`undefined`);
    if (opts.coerceTypes === "array") gen.if((0, $lohei._)`${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, ()=>gen.assign(data, (0, $lohei._)`${data}[0]`).assign(dataType, (0, $lohei._)`typeof ${data}`).if($8615dec9e21f906e$var$checkDataTypes(types, data, opts.strictNumbers), ()=>gen.assign(coerced, data)));
    gen.if((0, $lohei._)`${coerced} !== undefined`);
    for (const t of coerceTo)if ($8615dec9e21f906e$var$COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
    gen.else();
    $8615dec9e21f906e$var$reportTypeError(it);
    gen.endIf();
    gen.if((0, $lohei._)`${coerced} !== undefined`, ()=>{
        gen.assign(data, coerced);
        $8615dec9e21f906e$var$assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, $lohei._)`${dataType} == "number" || ${dataType} == "boolean"`).assign(coerced, (0, $lohei._)`"" + ${data}`).elseIf((0, $lohei._)`${data} === null`).assign(coerced, (0, $lohei._)`""`);
                return;
            case "number":
                gen.elseIf((0, $lohei._)`${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, $lohei._)`+${data}`);
                return;
            case "integer":
                gen.elseIf((0, $lohei._)`${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, $lohei._)`+${data}`);
                return;
            case "boolean":
                gen.elseIf((0, $lohei._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, $lohei._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, $lohei._)`${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, $lohei._)`${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`).assign(coerced, (0, $lohei._)`[${data}]`);
        }
    }
}
function $8615dec9e21f906e$var$assignParentData({ gen: gen, parentData: parentData, parentDataProperty: parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, $lohei._)`${parentData} !== undefined`, ()=>gen.assign((0, $lohei._)`${parentData}[${parentDataProperty}]`, expr));
}
function $8615dec9e21f906e$var$checkDataType(dataType, data, strictNums, correct = $8615dec9e21f906e$var$DataType.Correct) {
    const EQ = correct === $8615dec9e21f906e$var$DataType.Correct ? $lohei.operators.EQ : $lohei.operators.NEQ;
    let cond;
    switch(dataType){
        case "null":
            return (0, $lohei._)`${data} ${EQ} null`;
        case "array":
            cond = (0, $lohei._)`Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, $lohei._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, $lohei._)`!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, $lohei._)`typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === $8615dec9e21f906e$var$DataType.Correct ? cond : (0, $lohei.not)(cond);
    function numCond(_cond = $lohei.nil) {
        return (0, $lohei.and)((0, $lohei._)`typeof ${data} == "number"`, _cond, strictNums ? (0, $lohei._)`isFinite(${data})` : $lohei.nil);
    }
}
function $8615dec9e21f906e$var$checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return $8615dec9e21f906e$var$checkDataType(dataTypes[0], data, strictNums, correct);
    let cond;
    const types = (0, $8rmX0.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, $lohei._)`typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, $lohei._)`!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = $lohei.nil;
    if (types.number) delete types.integer;
    for(const t in types)cond = (0, $lohei.and)(cond, $8615dec9e21f906e$var$checkDataType(t, data, strictNums, correct));
    return cond;
}
const $8615dec9e21f906e$var$typeError = {
    message: ({ schema: schema })=>`must be ${schema}`,
    params: ({ schema: schema, schemaValue: schemaValue })=>typeof schema == "string" ? (0, $lohei._)`{type: ${schema}}` : (0, $lohei._)`{type: ${schemaValue}}`
};
function $8615dec9e21f906e$var$reportTypeError(it) {
    const cxt = $8615dec9e21f906e$var$getTypeErrorContext(it);
    (0, $gjXtw.reportError)(cxt, $8615dec9e21f906e$var$typeError);
}
function $8615dec9e21f906e$var$getTypeErrorContext(it) {
    const { gen: gen, data: data, schema: schema } = it;
    const schemaCode = (0, $8rmX0.schemaRefOrVal)(it, schema, "type");
    return {
        gen: gen,
        keyword: "type",
        data: data,
        schema: schema.type,
        schemaCode: schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it: it
    };
}

});
parcelRegister("2W1qL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isJSONType = $22321ba3dd7d49d9$var$isJSONType;
module.exports.getRules = $22321ba3dd7d49d9$var$getRules;
const $22321ba3dd7d49d9$var$_jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
const $22321ba3dd7d49d9$var$jsonTypes = new Set($22321ba3dd7d49d9$var$_jsonTypes);
function $22321ba3dd7d49d9$var$isJSONType(x) {
    return typeof x == "string" && $22321ba3dd7d49d9$var$jsonTypes.has(x);
}
function $22321ba3dd7d49d9$var$getRules() {
    const groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: {
            ...groups,
            integer: true,
            boolean: true,
            null: true
        },
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}

});

parcelRegister("lRks7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.schemaHasRulesForType = $fe9e69a37995785e$var$schemaHasRulesForType;
module.exports.shouldUseGroup = $fe9e69a37995785e$var$shouldUseGroup;
module.exports.shouldUseRule = $fe9e69a37995785e$var$shouldUseRule;
function $fe9e69a37995785e$var$schemaHasRulesForType({ schema: schema, self: self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && $fe9e69a37995785e$var$shouldUseGroup(schema, group);
}
function $fe9e69a37995785e$var$shouldUseGroup(schema, group) {
    return group.rules.some((rule)=>$fe9e69a37995785e$var$shouldUseRule(schema, rule));
}
function $fe9e69a37995785e$var$shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd)=>schema[kwd] !== undefined));
}

});


parcelRegister("HakW6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignDefaults = $081c08ea9f38c206$var$assignDefaults;

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");
function $081c08ea9f38c206$var$assignDefaults(it, ty) {
    const { properties: properties, items: items } = it.schema;
    if (ty === "object" && properties) for(const key in properties)$081c08ea9f38c206$var$assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach((sch, i)=>$081c08ea9f38c206$var$assignDefault(it, i, sch.default));
}
function $081c08ea9f38c206$var$assignDefault(it, prop, defaultValue) {
    const { gen: gen, compositeRule: compositeRule, data: data, opts: opts } = it;
    if (defaultValue === undefined) return;
    const childData = (0, $lohei._)`${data}${(0, $lohei.getProperty)(prop)}`;
    if (compositeRule) {
        (0, $8rmX0.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, $lohei._)`${childData} === undefined`;
    if (opts.useDefaults === "empty") condition = (0, $lohei._)`${condition} || ${childData} === null || ${childData} === ""`;
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, $lohei._)`${childData} = ${(0, $lohei.stringify)(defaultValue)}`);
}

});

parcelRegister("aGslB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.macroKeywordCode = $7c73d0d23302ac71$var$macroKeywordCode;
module.exports.funcKeywordCode = $7c73d0d23302ac71$var$funcKeywordCode;
module.exports.validSchemaType = $7c73d0d23302ac71$var$validSchemaType;
module.exports.validateKeywordUsage = $7c73d0d23302ac71$var$validateKeywordUsage;

var $lohei = parcelRequire("lohei");

var $7CJrC = parcelRequire("7CJrC");

var $fsS5I = parcelRequire("fsS5I");

var $gjXtw = parcelRequire("gjXtw");
function $7c73d0d23302ac71$var$macroKeywordCode(cxt, def) {
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, it: it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = $7c73d0d23302ac71$var$useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: $lohei.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, ()=>cxt.error(true));
}
function $7c73d0d23302ac71$var$funcKeywordCode(cxt, def) {
    var _a;
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, $data: $data, it: it } = cxt;
    $7c73d0d23302ac71$var$checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = $7c73d0d23302ac71$var$useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) $7c73d0d23302ac71$var$modifyData(cxt);
            reportErrs(()=>cxt.error());
        } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) $7c73d0d23302ac71$var$modifyData(cxt);
            reportErrs(()=>$7c73d0d23302ac71$var$addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(()=>assignValid((0, $lohei._)`await `), (e)=>gen.assign(valid, false).if((0, $lohei._)`${e} instanceof ${it.ValidationError}`, ()=>gen.assign(ruleErrs, (0, $lohei._)`${e}.errors`), ()=>gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, $lohei._)`${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid($lohei.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, $lohei._)`await ` : $lohei.nil) {
        const passCxt = it.opts.passContext ? $7CJrC.default.this : $7CJrC.default.self;
        const passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, $lohei._)`${_await}${(0, $fsS5I.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, $lohei.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
function $7c73d0d23302ac71$var$modifyData(cxt) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if(it.parentData, ()=>gen.assign(data, (0, $lohei._)`${it.parentData}[${it.parentDataProperty}]`));
}
function $7c73d0d23302ac71$var$addErrs(cxt, errs) {
    const { gen: gen } = cxt;
    gen.if((0, $lohei._)`Array.isArray(${errs})`, ()=>{
        gen.assign($7CJrC.default.vErrors, (0, $lohei._)`${$7CJrC.default.vErrors} === null ? ${errs} : ${$7CJrC.default.vErrors}.concat(${errs})`).assign($7CJrC.default.errors, (0, $lohei._)`${$7CJrC.default.vErrors}.length`);
        (0, $gjXtw.extendErrors)(cxt);
    }, ()=>cxt.error());
}
function $7c73d0d23302ac71$var$checkAsyncKeyword({ schemaEnv: schemaEnv }, def) {
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function $7c73d0d23302ac71$var$useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, $lohei.stringify)(result)
    });
}
function $7c73d0d23302ac71$var$validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return !schemaType.length || schemaType.some((st)=>st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
}
function $7c73d0d23302ac71$var$validateKeywordUsage({ schema: schema, opts: opts, self: self, errSchemaPath: errSchemaPath }, def, keyword) {
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd)=>!Object.prototype.hasOwnProperty.call(schema, kwd))) throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}

});
parcelRegister("fsS5I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkReportMissingProp = $b4236dea3b09fb34$var$checkReportMissingProp;
module.exports.checkMissingProp = $b4236dea3b09fb34$var$checkMissingProp;
module.exports.reportMissingProp = $b4236dea3b09fb34$var$reportMissingProp;
module.exports.hasPropFunc = $b4236dea3b09fb34$var$hasPropFunc;
module.exports.isOwnProperty = $b4236dea3b09fb34$var$isOwnProperty;
module.exports.propertyInData = $b4236dea3b09fb34$var$propertyInData;
module.exports.noPropertyInData = $b4236dea3b09fb34$var$noPropertyInData;
module.exports.allSchemaProperties = $b4236dea3b09fb34$var$allSchemaProperties;
module.exports.schemaProperties = $b4236dea3b09fb34$var$schemaProperties;
module.exports.callValidateCode = $b4236dea3b09fb34$var$callValidateCode;
module.exports.usePattern = $b4236dea3b09fb34$var$usePattern;
module.exports.validateArray = $b4236dea3b09fb34$var$validateArray;
module.exports.validateUnion = $b4236dea3b09fb34$var$validateUnion;

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");

var $7CJrC = parcelRequire("7CJrC");

var $8rmX0 = parcelRequire("8rmX0");
function $b4236dea3b09fb34$var$checkReportMissingProp(cxt, prop) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if($b4236dea3b09fb34$var$noPropertyInData(gen, data, prop, it.opts.ownProperties), ()=>{
        cxt.setParams({
            missingProperty: (0, $lohei._)`${prop}`
        }, true);
        cxt.error();
    });
}
function $b4236dea3b09fb34$var$checkMissingProp({ gen: gen, data: data, it: { opts: opts } }, properties, missing) {
    return (0, $lohei.or)(...properties.map((prop)=>(0, $lohei.and)($b4236dea3b09fb34$var$noPropertyInData(gen, data, prop, opts.ownProperties), (0, $lohei._)`${missing} = ${prop}`)));
}
function $b4236dea3b09fb34$var$reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
function $b4236dea3b09fb34$var$hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, $lohei._)`Object.prototype.hasOwnProperty`
    });
}
function $b4236dea3b09fb34$var$isOwnProperty(gen, data, property) {
    return (0, $lohei._)`${$b4236dea3b09fb34$var$hasPropFunc(gen)}.call(${data}, ${property})`;
}
function $b4236dea3b09fb34$var$propertyInData(gen, data, property, ownProperties) {
    const cond = (0, $lohei._)`${data}${(0, $lohei.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, $lohei._)`${cond} && ${$b4236dea3b09fb34$var$isOwnProperty(gen, data, property)}` : cond;
}
function $b4236dea3b09fb34$var$noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, $lohei._)`${data}${(0, $lohei.getProperty)(property)} === undefined`;
    return ownProperties ? (0, $lohei.or)(cond, (0, $lohei.not)($b4236dea3b09fb34$var$isOwnProperty(gen, data, property))) : cond;
}
function $b4236dea3b09fb34$var$allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p)=>p !== "__proto__") : [];
}
function $b4236dea3b09fb34$var$schemaProperties(it, schemaMap) {
    return $b4236dea3b09fb34$var$allSchemaProperties(schemaMap).filter((p)=>!(0, $8rmX0.alwaysValidSchema)(it, schemaMap[p]));
}
function $b4236dea3b09fb34$var$callValidateCode({ schemaCode: schemaCode, data: data, it: { gen: gen, topSchemaRef: topSchemaRef, schemaPath: schemaPath, errorPath: errorPath }, it: it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, $lohei._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [
            $7CJrC.default.instancePath,
            (0, $lohei.strConcat)($7CJrC.default.instancePath, errorPath)
        ],
        [
            $7CJrC.default.parentData,
            it.parentData
        ],
        [
            $7CJrC.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            $7CJrC.default.rootData,
            $7CJrC.default.rootData
        ],
        [
            $7CJrC.default.isAllOfVariant,
            it.isAllOfVariant ? 1 : 0
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        $7CJrC.default.dynamicAnchors,
        $7CJrC.default.dynamicAnchors
    ]);
    const args = (0, $lohei._)`${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== $lohei.nil ? (0, $lohei._)`${func}.call(${context}, ${args})` : (0, $lohei._)`${func}(${args})`;
}
const $b4236dea3b09fb34$var$newRegExp = (0, $lohei._)`new RegExp`;
function $b4236dea3b09fb34$var$usePattern({ gen: gen, it: { opts: opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp: regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, $lohei._)`${regExp.code === "new RegExp" ? $b4236dea3b09fb34$var$newRegExp : (0, $8rmX0.useFunc)(gen, regExp)}(${pattern}, ${u})`
    });
}
function $b4236dea3b09fb34$var$validateArray(cxt) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(()=>gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(()=>gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, $lohei._)`${data}.length`);
        gen.forRange("i", 0, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $8rmX0.Type.Num
            }, valid);
            gen.if((0, $lohei.not)(valid), notValid);
        });
    }
}
function $b4236dea3b09fb34$var$validateUnion(cxt) {
    const { gen: gen, schema: schema, keyword: keyword, parentSchema: parentSchema, it: it } = cxt;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    if (it.opts.discriminator && parentSchema.discriminator) return;
    const alwaysValid = schema.some((sch)=>(0, $8rmX0.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated) return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(()=>schema.forEach((_sch, i)=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, $lohei._)`${valid} || ${schValid}`);
            const merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, $lohei.not)(valid));
        }));
    cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
}

});


parcelRegister("586RV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSubschema = $3bc30717c1b840f1$var$getSubschema;
module.exports.extendSubschemaData = $3bc30717c1b840f1$var$extendSubschemaData;
module.exports.extendSubschemaMode = $3bc30717c1b840f1$var$extendSubschemaMode;

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");
function $3bc30717c1b840f1$var$getSubschema(it, { keyword: keyword, schemaProp: schemaProp, schema: schema, schemaPath: schemaPath, errSchemaPath: errSchemaPath, topSchemaRef: topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, $lohei._)`${it.schemaPath}${(0, $lohei.getProperty)(keyword)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, $lohei._)`${it.schemaPath}${(0, $lohei.getProperty)(keyword)}${(0, $lohei.getProperty)(schemaProp)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, $8rmX0.escapeFragment)(schemaProp)}`
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema: schema,
            schemaPath: schemaPath,
            topSchemaRef: topSchemaRef,
            errSchemaPath: errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
function $3bc30717c1b840f1$var$extendSubschemaData(subschema, it, { dataProp: dataProp, dataPropType: dpType, data: data, dataTypes: dataTypes, propertyName: propertyName }) {
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen: gen } = it;
    if (dataProp !== undefined) {
        const { errorPath: errorPath, dataPathArr: dataPathArr, opts: opts } = it;
        const nextData = gen.let("data", (0, $lohei._)`${it.data}${(0, $lohei.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, $lohei.str)`${errorPath}${(0, $8rmX0.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, $lohei._)`${dataProp}`;
        subschema.dataPathArr = [
            ...dataPathArr,
            subschema.parentDataProperty
        ];
    }
    if (data !== undefined) {
        const nextData = data instanceof $lohei.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [
            ...it.dataNames,
            _nextData
        ];
    }
}
function $3bc30717c1b840f1$var$extendSubschemaMode(subschema, { jtdDiscriminator: jtdDiscriminator, jtdMetadata: jtdMetadata, compositeRule: compositeRule, createErrors: createErrors, allErrors: allErrors }) {
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}

});

parcelRegister("eO3NS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.inlineRef = $ac78af7b13f2d5e0$var$inlineRef;
module.exports.getFullPath = $ac78af7b13f2d5e0$var$getFullPath;
module.exports._getFullPath = $ac78af7b13f2d5e0$var$_getFullPath;
module.exports.normalizeId = $ac78af7b13f2d5e0$var$normalizeId;
module.exports.resolveUrl = $ac78af7b13f2d5e0$var$resolveUrl;
module.exports.getSchemaRefs = $ac78af7b13f2d5e0$var$getSchemaRefs;

var $8rmX0 = parcelRequire("8rmX0");

var $7hFx0 = parcelRequire("7hFx0");

var $7dBhG = parcelRequire("7dBhG");
// TODO refactor to use keyword definitions
const $ac78af7b13f2d5e0$var$SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function $ac78af7b13f2d5e0$var$inlineRef(schema, limit = true) {
    if (typeof schema == "boolean") return true;
    if (limit === true) return !$ac78af7b13f2d5e0$var$hasRef(schema);
    if (!limit) return false;
    return $ac78af7b13f2d5e0$var$countKeys(schema) <= limit;
}
const $ac78af7b13f2d5e0$var$REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function $ac78af7b13f2d5e0$var$hasRef(schema) {
    for(const key in schema){
        if ($ac78af7b13f2d5e0$var$REF_KEYWORDS.has(key)) return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some($ac78af7b13f2d5e0$var$hasRef)) return true;
        if (typeof sch == "object" && $ac78af7b13f2d5e0$var$hasRef(sch)) return true;
    }
    return false;
}
function $ac78af7b13f2d5e0$var$countKeys(schema) {
    let count = 0;
    for(const key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if ($ac78af7b13f2d5e0$var$SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, $8rmX0.eachItem)(schema[key], (sch)=>count += $ac78af7b13f2d5e0$var$countKeys(sch));
        if (count === Infinity) return Infinity;
    }
    return count;
}
function $ac78af7b13f2d5e0$var$getFullPath(resolver, id = "", normalize) {
    if (normalize !== false) id = $ac78af7b13f2d5e0$var$normalizeId(id);
    const p = resolver.parse(id);
    return $ac78af7b13f2d5e0$var$_getFullPath(resolver, p);
}
function $ac78af7b13f2d5e0$var$_getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
const $ac78af7b13f2d5e0$var$TRAILING_SLASH_HASH = /#\/?$/;
function $ac78af7b13f2d5e0$var$normalizeId(id) {
    return id ? id.replace($ac78af7b13f2d5e0$var$TRAILING_SLASH_HASH, "") : "";
}
function $ac78af7b13f2d5e0$var$resolveUrl(resolver, baseId, id) {
    id = $ac78af7b13f2d5e0$var$normalizeId(id);
    return resolver.resolve(baseId, id);
}
const $ac78af7b13f2d5e0$var$ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function $ac78af7b13f2d5e0$var$getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean") return {};
    const { schemaId: schemaId, uriResolver: uriResolver } = this.opts;
    const schId = $ac78af7b13f2d5e0$var$normalizeId(schema[schemaId] || baseId);
    const baseIds = {
        "": schId
    };
    const pathPrefix = $ac78af7b13f2d5e0$var$getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    $7dBhG(schema, {
        allKeys: true
    }, (sch, jsonPtr, _, parentJsonPtr)=>{
        if (parentJsonPtr === undefined) return;
        const fullPath = pathPrefix + jsonPtr;
        let baseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") baseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = baseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = $ac78af7b13f2d5e0$var$normalizeId(baseId ? _resolve(baseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== $ac78af7b13f2d5e0$var$normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!$ac78af7b13f2d5e0$var$ANCHOR.test(anchor)) throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !$7hFx0(sch1, sch2)) throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}

});
parcelRegister("7hFx0", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("7dBhG", function(module, exports) {
'use strict';
var $5416ab2f1394f8d9$var$traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == 'function') {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == 'function' ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $5416ab2f1394f8d9$var$_traverse(opts, pre, post, schema, '', schema);
};
$5416ab2f1394f8d9$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
$5416ab2f1394f8d9$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$5416ab2f1394f8d9$var$traverse.propsKeywords = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$5416ab2f1394f8d9$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $5416ab2f1394f8d9$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $5416ab2f1394f8d9$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $5416ab2f1394f8d9$var$traverse.propsKeywords) {
                if (sch && typeof sch == 'object') for(var prop in sch)$5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + $5416ab2f1394f8d9$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $5416ab2f1394f8d9$var$traverse.keywords || opts.allKeys && !(key in $5416ab2f1394f8d9$var$traverse.skipKeywords)) $5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $5416ab2f1394f8d9$var$escapeJsonPtr(str) {
    return str.replace(/~/g, '~0').replace(/\//g, '~1');
}

});



parcelRegister("25XEk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $186a5186a6be03c5$var$ValidationError extends Error {
    constructor(errors){
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
module.exports.default = $186a5186a6be03c5$var$ValidationError;

});

parcelRegister("iItJM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eO3NS = parcelRequire("eO3NS");
class $da036745a4c5280f$var$MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg){
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, $eO3NS.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, $eO3NS.normalizeId)((0, $eO3NS.getFullPath)(resolver, this.missingRef));
    }
}
module.exports.default = $da036745a4c5280f$var$MissingRefError;

});

parcelRegister("8AeYZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SchemaEnv = void 0;
module.exports.compileSchema = $63fd4ecb83325c77$var$compileSchema;
module.exports.resolveRef = $63fd4ecb83325c77$var$resolveRef;
module.exports.getCompilingSchema = $63fd4ecb83325c77$var$getCompilingSchema;
module.exports.resolveSchema = $63fd4ecb83325c77$var$resolveSchema;

var $lohei = parcelRequire("lohei");

var $25XEk = parcelRequire("25XEk");

var $7CJrC = parcelRequire("7CJrC");

var $eO3NS = parcelRequire("eO3NS");

var $8rmX0 = parcelRequire("8rmX0");

var $bTGAO = parcelRequire("bTGAO");
class $63fd4ecb83325c77$var$SchemaEnv {
    constructor(env){
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object") schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, $eO3NS.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
module.exports.SchemaEnv = $63fd4ecb83325c77$var$SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function $63fd4ecb83325c77$var$compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = $63fd4ecb83325c77$var$getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const rootId = (0, $eO3NS.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5: es5, lines: lines } = this.opts.code;
    const { ownProperties: ownProperties } = this.opts;
    const gen = new $lohei.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    let _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: $25XEk.default,
        code: (0, $lohei._)`require("ajv/dist/runtime/validation_error").default`
    });
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen: gen,
        allErrors: this.opts.allErrors,
        data: $7CJrC.default.data,
        parentData: $7CJrC.default.parentData,
        parentDataProperty: $7CJrC.default.parentDataProperty,
        dataNames: [
            $7CJrC.default.data
        ],
        dataPathArr: [
            $lohei.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, $lohei.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName: validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId: rootId,
        baseId: sch.baseId || rootId,
        schemaPath: $lohei.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, $lohei._)`""`,
        opts: this.opts,
        self: this
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, $bTGAO.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `const visitedNodesForRef = new WeakMap(); ${gen.scopeRefs($7CJrC.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${$7CJrC.default.self}`, `${$7CJrC.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName: validateName,
            validateCode: validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            const { props: props, items: items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof $lohei.Name ? undefined : props,
                items: items instanceof $lohei.Name ? undefined : items,
                dynamicProps: props instanceof $lohei.Name,
                dynamicItems: items instanceof $lohei.Name
            };
            if (validate.source) validate.source.evaluated = (0, $lohei.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
function $63fd4ecb83325c77$var$resolveRef(root, baseId, origRef) {
    var _a;
    const ref = (0, $eO3NS.resolveUrl)(this.opts.uriResolver, baseId, origRef);
    const schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    let _sch = $63fd4ecb83325c77$var$resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId: schemaId } = this.opts;
        if (schema) _sch = new $63fd4ecb83325c77$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    if (_sch === undefined && this.opts.loadSchemaSync) {
        const remoteSchema = this.opts.loadSchemaSync(baseId, origRef, ref);
        if (remoteSchema && !(this.refs[ref] || this.schemas[ref])) {
            this.addSchema(remoteSchema, ref, undefined);
            _sch = $63fd4ecb83325c77$var$resolve.call(this, root, ref);
        }
    }
    if (_sch === undefined) return;
    return root.refs[ref] = $63fd4ecb83325c77$var$inlineOrCompile.call(this, _sch);
}
function $63fd4ecb83325c77$var$inlineOrCompile(sch) {
    if ((0, $eO3NS.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : $63fd4ecb83325c77$var$compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function $63fd4ecb83325c77$var$getCompilingSchema(schEnv) {
    for (const sch of this._compilations){
        if ($63fd4ecb83325c77$var$sameSchemaEnv(sch, schEnv)) return sch;
    }
}
function $63fd4ecb83325c77$var$sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function $63fd4ecb83325c77$var$resolve(root, ref // reference to resolve
) {
    let sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || $63fd4ecb83325c77$var$resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function $63fd4ecb83325c77$var$resolveSchema(root, ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, $eO3NS._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, $eO3NS.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return $63fd4ecb83325c77$var$getJsonPointer.call(this, p, root);
    const id = (0, $eO3NS.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = $63fd4ecb83325c77$var$resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return $63fd4ecb83325c77$var$getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) $63fd4ecb83325c77$var$compileSchema.call(this, schOrRef);
    if (id === (0, $eO3NS.normalizeId)(ref)) {
        const { schema: schema } = schOrRef;
        const { schemaId: schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId) baseId = (0, $eO3NS.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new $63fd4ecb83325c77$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    return $63fd4ecb83325c77$var$getJsonPointer.call(this, p, schOrRef);
}
const $63fd4ecb83325c77$var$PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function $63fd4ecb83325c77$var$getJsonPointer(parsedRef, { baseId: baseId, schema: schema, root: root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    for (const part of parsedRef.fragment.slice(1).split("/")){
        if (typeof schema === "boolean") return;
        const partSchema = schema[(0, $8rmX0.unescapeFragment)(part)];
        if (partSchema === undefined) return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!$63fd4ecb83325c77$var$PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, $eO3NS.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, $8rmX0.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, $eO3NS.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = $63fd4ecb83325c77$var$resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId: schemaId } = this.opts;
    env = env || new $63fd4ecb83325c77$var$SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

});

parcelRegister("l7PEn", function(module, exports) {
module.exports = JSON.parse("{\"$id\":\"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#\",\"description\":\"Meta-schema for $data reference (JSON AnySchema extension proposal)\",\"type\":\"object\",\"required\":[\"$data\"],\"properties\":{\"$data\":{\"type\":\"string\",\"anyOf\":[{\"format\":\"relative-json-pointer\"},{\"format\":\"json-pointer\"}]}},\"additionalProperties\":false}");

});

parcelRegister("dVKTK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $VtWnL = parcelRequire("VtWnL");
$VtWnL.code = 'require("ajv/dist/runtime/uri").default';
module.exports.default = $VtWnL;

});
parcelRegister("VtWnL", function(module, exports) {
"use strict";
var $0acc8c933eba6fc4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0acc8c933eba6fc4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0acc8c933eba6fc4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalize = module.exports.equal = void 0;



$0acc8c933eba6fc4$var$__exportStar((parcelRequire("gxOOE")), module.exports);

$0acc8c933eba6fc4$var$__exportStar((parcelRequire("1euLB")), module.exports);

$0acc8c933eba6fc4$var$__exportStar((parcelRequire("6yy2G")), module.exports);
function $0acc8c933eba6fc4$var$equal(uriA, uriB) {
    let processedA;
    let processedB;
    if (typeof uriA === "string") processedA = (0, (parcelRequire("1euLB")).serialize)((0, (parcelRequire("6yy2G")).parse)(uriA));
    else processedA = (0, (parcelRequire("1euLB")).serialize)(uriA);
    if (typeof uriB === "string") processedB = (0, (parcelRequire("1euLB")).serialize)((0, (parcelRequire("6yy2G")).parse)(uriB));
    else processedB = (0, (parcelRequire("1euLB")).serialize)(uriB);
    return processedA.toLowerCase() === processedB.toLowerCase();
}
module.exports.equal = $0acc8c933eba6fc4$var$equal;
function $0acc8c933eba6fc4$var$normalize(uri) {
    if (typeof uri === "string") return (0, (parcelRequire("1euLB")).serialize)((0, (parcelRequire("6yy2G")).parse)(uri));
    else return (0, (parcelRequire("6yy2G")).parse)((0, (parcelRequire("1euLB")).serialize)(uri));
}
module.exports.normalize = $0acc8c933eba6fc4$var$normalize;

});
parcelRegister("1euLB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serialize = void 0;
function $0e5ef6e065ed1ed0$var$serialize(components) {
    let buildResult = $0e5ef6e065ed1ed0$var$buildStartUrl(components);
    let urlBuilder;
    try {
        urlBuilder = new URL(buildResult.startUrl);
    } catch (error) {
        if (error.message) console.error(error.message + ' ' + buildResult.startUrl);
        return '';
    }
    if (components.scheme !== undefined && !buildResult.temporarySchemeAndHostUsed && !buildResult.temporarySchemeUsed) urlBuilder.protocol = components.scheme.toLowerCase();
    else urlBuilder.protocol = '';
    if (components.host !== undefined && !buildResult.temporarySchemeAndHostUsed && !buildResult.temporaryHostUsed) urlBuilder.host = components.host;
    else urlBuilder.host = '';
    if (components.port) urlBuilder.port = String(components.port);
    if (components.path) urlBuilder.pathname = components.path;
    if (components.userinfo) {
        let parts = components.userinfo.split(':');
        if (parts[0]) urlBuilder.username = parts[0];
        if (parts[1]) urlBuilder.password = parts[1];
    }
    if (components.query) urlBuilder.search = components.query;
    if (components.fragment) urlBuilder.hash = components.fragment;
    let result = urlBuilder.toString();
    if (!components.path && result.endsWith('/')) result = result.slice(0, -1);
    if (buildResult.temporarySchemeAndHostUsed) {
        result = result.replace($0e5ef6e065ed1ed0$var$temporarySchemeAndHost, '');
        if (result.startsWith('/')) result = result.slice(1);
    }
    if (buildResult.temporaryHostUsed) result = result.replace($0e5ef6e065ed1ed0$var$temporaryHost, '');
    if (buildResult.temporarySchemeUsed) result = result.replace($0e5ef6e065ed1ed0$var$temporaryScheme, '');
    return result;
}
module.exports.serialize = $0e5ef6e065ed1ed0$var$serialize;
const $0e5ef6e065ed1ed0$var$temporaryScheme = 'https:';
const $0e5ef6e065ed1ed0$var$temporaryHost = '_remove_me_host_';
const $0e5ef6e065ed1ed0$var$temporarySchemeAndHost = $0e5ef6e065ed1ed0$var$temporaryScheme + '//' + $0e5ef6e065ed1ed0$var$temporaryHost;
function $0e5ef6e065ed1ed0$var$buildStartUrl(components) {
    let result = {
        startUrl: '',
        temporaryHostUsed: false,
        temporarySchemeUsed: false,
        temporarySchemeAndHostUsed: false
    };
    if (components.scheme && components.host) {
        result.startUrl = components.scheme + '://' + components.host;
        return result;
    }
    if (components.host) {
        result.temporarySchemeUsed = true;
        result.startUrl = $0e5ef6e065ed1ed0$var$temporaryScheme + components.host;
        return result;
    }
    if (components.scheme) {
        if (components.path) {
            result.startUrl = components.scheme + ':' + components.path;
            return result;
        }
        result.temporaryHostUsed = true;
        result.startUrl = components.scheme + ':' + $0e5ef6e065ed1ed0$var$temporaryHost;
        return result;
    }
    result.temporarySchemeAndHostUsed = true;
    result.startUrl = $0e5ef6e065ed1ed0$var$temporarySchemeAndHost;
    return result;
}

});

parcelRegister("6yy2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = void 0;
function $4c605324322158fc$var$parse(uriString) {
    let result = {
        path: '',
        fragment: undefined,
        host: undefined,
        port: undefined,
        query: undefined,
        reference: undefined,
        scheme: undefined,
        userinfo: undefined
    };
    if (uriString.includes('#')) result.fragment = '';
    let { parsed: parsed, addedDefaultScheme: addedDefaultScheme, addedTemporaryHost: addedTemporaryHost, error: error } = $4c605324322158fc$var$recognizeUrl(uriString);
    if (error || parsed === undefined) {
        result.error = error;
        return result;
    }
    if ((parsed.protocol, parsed.protocol !== '') && !addedDefaultScheme) result.scheme = String(parsed.protocol).replace(':', '');
    if (parsed.username, parsed.username !== '') {
        let userinfo = parsed.username;
        if (parsed.password) userinfo += ':' + parsed.password;
        result.userinfo = userinfo;
    }
    if ((parsed.hostname, parsed.hostname !== '') && !addedTemporaryHost) {
        result.host = parsed.hostname;
        if (result.host.startsWith('[')) {
            result.host = result.host.substring(1);
            result.host = result.host.slice(0, -1);
        }
    }
    if (parsed.port, parsed.port !== '') result.port = Number(parsed.port);
    if (parsed.pathname, parsed.pathname !== '/') {
        result.path = parsed.pathname;
        if (addedTemporaryHost && result.path.startsWith('/')) result.path = result.path.substring(1);
    }
    if (parsed.search, parsed.search !== '') result.query = parsed.search.replace('?', '');
    if (parsed.hash, parsed.hash !== '') result.fragment = parsed.hash.replace('#', '');
    if (result.scheme === undefined && result.userinfo === undefined && result.host === undefined && result.port === undefined && !result.path && result.query === undefined) result.reference = "same-document";
    else if (result.scheme === undefined) result.reference = "relative";
    else if (result.fragment === undefined) result.reference = "absolute";
    else result.reference = "uri";
    return result;
}
module.exports.parse = $4c605324322158fc$var$parse;
const $4c605324322158fc$var$temporaryHost = '_remove_me_host/';
function $4c605324322158fc$var$recognizeUrl(uriString) {
    let result = {
        parsed: undefined,
        addedDefaultScheme: false,
        addedTemporaryHost: false,
        error: undefined
    };
    let firstError;
    try {
        result.parsed = new URL(uriString);
        return result;
    } catch (error) {
        firstError = error;
    }
    if (uriString.startsWith('//')) try {
        result.parsed = new URL('https:' + uriString);
        result.addedDefaultScheme = true;
        return result;
    } catch (otherError) {
        result.error = firstError.message;
        return result;
    }
    try {
        result.parsed = new URL('https://' + $4c605324322158fc$var$temporaryHost + uriString);
        result.addedDefaultScheme = true;
        result.addedTemporaryHost = true;
        return result;
    } catch (otherError) {}
    result.error = firstError.message;
    return result;
}

});

parcelRegister("gxOOE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveComponents = module.exports.resolve = void 0;

var $6yy2G = parcelRequire("6yy2G");

var $1euLB = parcelRequire("1euLB");
function $031bba68dd3735c1$var$resolve(baseURI, relativeURI, options) {
    const schemeLessOptions = Object.assign({
        scheme: 'null'
    }, options);
    const resolved = $031bba68dd3735c1$var$resolveComponents((0, $6yy2G.parse)(baseURI), (0, $6yy2G.parse)(relativeURI), schemeLessOptions, true);
    return (0, $1euLB.serialize)(resolved);
}
module.exports.resolve = $031bba68dd3735c1$var$resolve;
function $031bba68dd3735c1$var$resolveComponents(base, relative, options, skipNormalization) {
    const target = {};
    if (!skipNormalization) {
        base = (0, $6yy2G.parse)((0, $1euLB.serialize)(base));
        relative = (0, $6yy2G.parse)((0, $1euLB.serialize)(relative));
    }
    options = options || {};
    if (!options.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = $031bba68dd3735c1$var$removeDotSegments(relative.path || '');
        target.query = relative.query;
    } else {
        if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = $031bba68dd3735c1$var$removeDotSegments(relative.path || '');
            target.query = relative.query;
        } else {
            if (!relative.path) {
                target.path = base.path;
                if (relative.query !== undefined) target.query = relative.query;
                else target.query = base.query;
            } else {
                if (relative.path.charAt(0) === '/') target.path = $031bba68dd3735c1$var$removeDotSegments(relative.path);
                else {
                    if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = '/' + relative.path;
                    else if (!base.path) target.path = relative.path;
                    else target.path = base.path.slice(0, base.path.lastIndexOf('/') + 1) + relative.path;
                    target.path = $031bba68dd3735c1$var$removeDotSegments(target.path);
                }
                target.query = relative.query;
            }
            target.userinfo = base.userinfo;
            target.host = base.host;
            target.port = base.port;
        }
        target.scheme = base.scheme;
    }
    target.fragment = relative.fragment;
    return target;
}
module.exports.resolveComponents = $031bba68dd3735c1$var$resolveComponents;
function $031bba68dd3735c1$var$removeDotSegments(input) {
    const RDS1 = /^\.\.?\//u;
    const RDS2 = /^\/\.(?:\/|$)/u;
    const RDS3 = /^\/\.\.(?:\/|$)/u;
    const RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/u;
    const output = [];
    while(input.length){
        if (input.match(RDS1)) input = input.replace(RDS1, '');
        else if (input.match(RDS2)) input = input.replace(RDS2, '/');
        else if (input.match(RDS3)) {
            input = input.replace(RDS3, '/');
            output.pop();
        } else if (input === '.' || input === '..') input = '';
        else {
            const im = input.match(RDS5);
            if (im) {
                const s = im[0];
                input = input.slice(s.length);
                output.push(s);
            } else throw new Error('Unexpected dot segment condition');
        }
    }
    return output.join('');
}

});




parcelRegister("aCqcX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8p6zv = parcelRequire("8p6zv");

var $eLDXX = parcelRequire("eLDXX");

var $adM23 = parcelRequire("adM23");

var $bmxAj = parcelRequire("bmxAj");

var $87JeO = parcelRequire("87JeO");

var $8ESYy = parcelRequire("8ESYy");

var $er107 = parcelRequire("er107");

var $eebnH = parcelRequire("eebnH");
const $7bb1c85f52379b2f$var$draft2020Vocabularies = [
    $bmxAj.default,
    $8p6zv.default,
    $eLDXX.default,
    (0, $adM23.default)(true),
    $er107.default,
    $eebnH.metadataVocabulary,
    $eebnH.contentVocabulary,
    $87JeO.default,
    $8ESYy.default
];
module.exports.default = $7bb1c85f52379b2f$var$draft2020Vocabularies;

});
parcelRegister("8p6zv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iON49 = parcelRequire("iON49");

var $uGCYs = parcelRequire("uGCYs");
const $61e5c18c38e14a8f$var$core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    $iON49.default,
    $uGCYs.default
];
module.exports.default = $61e5c18c38e14a8f$var$core;

});
parcelRegister("iON49", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $db32f4fccb4872ba$var$def = {
    keyword: "id",
    code () {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
module.exports.default = $db32f4fccb4872ba$var$def;

});

parcelRegister("uGCYs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getValidate = $05c3de69aa269bdb$var$getValidate;
module.exports.callRef = $05c3de69aa269bdb$var$callRef;

var $iItJM = parcelRequire("iItJM");

var $fsS5I = parcelRequire("fsS5I");

var $lohei = parcelRequire("lohei");

var $7CJrC = parcelRequire("7CJrC");

var $8AeYZ = parcelRequire("8AeYZ");

var $8rmX0 = parcelRequire("8rmX0");
const $05c3de69aa269bdb$var$def = {
    keyword: "$ref",
    schemaType: "string",
    code (cxt) {
        const { gen: gen, schema: $ref, it: it } = cxt;
        const { baseId: baseId, schemaEnv: env, validateName: validateName, opts: opts, self: self } = it;
        const { root: root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        const schOrEnv = $8AeYZ.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new $iItJM.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof $8AeYZ.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root) return $05c3de69aa269bdb$var$callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", {
                ref: root
            });
            return $05c3de69aa269bdb$var$callRef(cxt, (0, $lohei._)`${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = $05c3de69aa269bdb$var$getValidate(cxt, sch);
            $05c3de69aa269bdb$var$callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, $lohei.stringify)(sch)
            } : {
                ref: sch
            });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: $lohei.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid, it.isAllOfVariant // pass isAllOfVariant into inlined $ref
            );
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    }
};
function $05c3de69aa269bdb$var$getValidate(cxt, sch) {
    const { gen: gen } = cxt;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, $lohei._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.validate`;
}
function $05c3de69aa269bdb$var$callRef(cxt, v, sch, $async) {
    const { gen: gen, it: it } = cxt;
    const { allErrors: allErrors, schemaEnv: env, opts: opts } = it;
    const passCxt = opts.passContext ? $7CJrC.default.this : $lohei.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
    function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(()=>{
            gen.code((0, $lohei._)`await ${(0, $fsS5I.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, (e)=>{
            gen.if((0, $lohei._)`!(${e} instanceof ${it.ValidationError})`, ()=>gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        const visitedNodes = gen.name("visitedNodes");
        gen.code((0, $lohei._)`const ${visitedNodes} = (typeof visitedNodesForRef !== 'undefined') && visitedNodesForRef.get(${v}) || new Set()`);
        gen.if((0, $lohei._)`!${visitedNodes}.has(${cxt.data})`, ()=>{
            gen.code((0, $lohei._)`if (typeof visitedNodesForRef !== 'undefined') visitedNodesForRef.set(${v}, ${visitedNodes})`);
            gen.code((0, $lohei._)`const dataNode = ${cxt.data}`);
            gen.code((0, $lohei._)`if (typeof dataNode === "object" && dataNode !== null) ${visitedNodes}.add(dataNode)`);
            const res = cxt.result((0, $fsS5I.callValidateCode)(cxt, v, passCxt), ()=>addEvaluatedFrom(v), ()=>addErrorsFrom(v));
            gen.code((0, $lohei._)`${visitedNodes}.delete(dataNode)`);
            return res;
        });
    }
    function addErrorsFrom(source) {
        const errs = (0, $lohei._)`${source}.errors`;
        gen.assign($7CJrC.default.vErrors, (0, $lohei._)`${$7CJrC.default.vErrors} === null ? ${errs} : ${$7CJrC.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign($7CJrC.default.errors, (0, $lohei._)`${$7CJrC.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = $8rmX0.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                const props = gen.var("props", (0, $lohei._)`${source}.evaluated.props`);
                it.props = $8rmX0.mergeEvaluated.props(gen, props, it.props, $lohei.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = $8rmX0.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                const items = gen.var("items", (0, $lohei._)`${source}.evaluated.items`);
                it.items = $8rmX0.mergeEvaluated.items(gen, items, it.items, $lohei.Name);
            }
        }
    }
}
module.exports.default = $05c3de69aa269bdb$var$def;

});


parcelRegister("eLDXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $050Lq = parcelRequire("050Lq");

var $gTIb2 = parcelRequire("gTIb2");

var $j0QgX = parcelRequire("j0QgX");

var $aaz9x = parcelRequire("aaz9x");

var $iuX3O = parcelRequire("iuX3O");

var $kDucf = parcelRequire("kDucf");

var $4DCGw = parcelRequire("4DCGw");

var $lzAXs = parcelRequire("lzAXs");

var $fQbGj = parcelRequire("fQbGj");

var $g2Dfm = parcelRequire("g2Dfm");
const $ac0474e8db3ce767$var$validation = [
    // number
    $050Lq.default,
    $gTIb2.default,
    // string
    $j0QgX.default,
    $aaz9x.default,
    // object
    $iuX3O.default,
    $kDucf.default,
    // array
    $4DCGw.default,
    $lzAXs.default,
    // any
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    $fQbGj.default,
    $g2Dfm.default
];
module.exports.default = $ac0474e8db3ce767$var$validation;

});
parcelRegister("050Lq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");
const $00f10f76ffe4f306$var$ops = $lohei.operators;
const $00f10f76ffe4f306$var$KWDs = {
    maximum: {
        okStr: "<=",
        ok: $00f10f76ffe4f306$var$ops.LTE,
        fail: $00f10f76ffe4f306$var$ops.GT
    },
    minimum: {
        okStr: ">=",
        ok: $00f10f76ffe4f306$var$ops.GTE,
        fail: $00f10f76ffe4f306$var$ops.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: $00f10f76ffe4f306$var$ops.LT,
        fail: $00f10f76ffe4f306$var$ops.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: $00f10f76ffe4f306$var$ops.GT,
        fail: $00f10f76ffe4f306$var$ops.LTE
    }
};
const $00f10f76ffe4f306$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $lohei.str)`must be ${$00f10f76ffe4f306$var$KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $lohei._)`{comparison: ${$00f10f76ffe4f306$var$KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
const $00f10f76ffe4f306$var$def = {
    keyword: Object.keys($00f10f76ffe4f306$var$KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error: $00f10f76ffe4f306$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        cxt.fail$data((0, $lohei._)`${data} ${$00f10f76ffe4f306$var$KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
    }
};
module.exports.default = $00f10f76ffe4f306$var$def;

});

parcelRegister("gTIb2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");
const $c4d40d091430cbd6$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $lohei.str)`must be multiple of ${schemaCode}`,
    params: ({ schemaCode: schemaCode })=>(0, $lohei._)`{multipleOf: ${schemaCode}}`
};
const $c4d40d091430cbd6$var$def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error: $c4d40d091430cbd6$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, it: it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec ? (0, $lohei._)`Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}` : (0, $lohei._)`${res} !== parseInt(${res})`;
        cxt.fail$data((0, $lohei._)`(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
    }
};
module.exports.default = $c4d40d091430cbd6$var$def;

});

parcelRegister("j0QgX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");

var $jiFfx = parcelRequire("jiFfx");
const $dd7690a77025bf8a$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, $lohei.str)`must NOT have ${comp} than ${schemaCode} characters`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $lohei._)`{limit: ${schemaCode}}`
};
const $dd7690a77025bf8a$var$def = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: true,
    error: $dd7690a77025bf8a$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode, it: it } = cxt;
        const op = keyword === "maxLength" ? $lohei.operators.GT : $lohei.operators.LT;
        const len = it.opts.unicode === false ? (0, $lohei._)`${data}.length` : (0, $lohei._)`${(0, $8rmX0.useFunc)(cxt.gen, $jiFfx.default)}(${data})`;
        cxt.fail$data((0, $lohei._)`${len} ${op} ${schemaCode}`);
    }
};
module.exports.default = $dd7690a77025bf8a$var$def;

});
parcelRegister("jiFfx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e0cfb216711b5b8a$var$ucs2length;
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function $e0cfb216711b5b8a$var$ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00) pos++; // low surrogate
        }
    }
    return length;
}
$e0cfb216711b5b8a$var$ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';

});


parcelRegister("aaz9x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fsS5I = parcelRequire("fsS5I");

var $lohei = parcelRequire("lohei");
const $76761b26dbb760fe$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $lohei.str)`must match pattern "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $lohei._)`{pattern: ${schemaCode}}`
};
const $76761b26dbb760fe$var$def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error: $76761b26dbb760fe$var$error,
    code (cxt) {
        const { data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        // TODO regexp should be wrapped in try/catchs
        const u = it.opts.unicodeRegExp ? "u" : "";
        const regExp = $data ? (0, $lohei._)`(new RegExp(${schemaCode}, ${u}))` : (0, $fsS5I.usePattern)(cxt, schema);
        cxt.fail$data((0, $lohei._)`!${regExp}.test(${data})`);
    }
};
module.exports.default = $76761b26dbb760fe$var$def;

});

parcelRegister("iuX3O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");
const $d778d786eac51814$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, $lohei.str)`must NOT have ${comp} than ${schemaCode} properties`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $lohei._)`{limit: ${schemaCode}}`
};
const $d778d786eac51814$var$def = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: true,
    error: $d778d786eac51814$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxProperties" ? $lohei.operators.GT : $lohei.operators.LT;
        cxt.fail$data((0, $lohei._)`Object.keys(${data}).length ${op} ${schemaCode}`);
    }
};
module.exports.default = $d778d786eac51814$var$def;

});

parcelRegister("kDucf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fsS5I = parcelRequire("fsS5I");

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");
const $f05edf8dafa6ed5b$var$error = {
    message: ({ params: { missingProperty: missingProperty } })=>(0, $lohei.str)`must have required property '${missingProperty}'`,
    params: ({ params: { missingProperty: missingProperty } })=>(0, $lohei._)`{missingProperty: ${missingProperty}}`
};
const $f05edf8dafa6ed5b$var$def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error: $f05edf8dafa6ed5b$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, schemaCode: schemaCode, data: data, $data: $data, it: it } = cxt;
        const { opts: opts } = it;
        if (!$data && schema.length === 0) return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors) allErrorsMode();
        else exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties: definedProperties } = cxt.it;
            for (const requiredKey of schema)if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                (0, $8rmX0.checkStrictMode)(it, msg, it.opts.strictRequired);
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) cxt.block$data($lohei.nil, loopAllRequired);
            else for (const prop of schema)(0, $fsS5I.checkReportMissingProp)(cxt, prop);
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, ()=>loopUntilMissing(missing, valid));
                cxt.ok(valid);
            } else {
                gen.if((0, $fsS5I.checkMissingProp)(cxt, schema, missing));
                (0, $fsS5I.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop)=>{
                cxt.setParams({
                    missingProperty: prop
                });
                gen.if((0, $fsS5I.noPropertyInData)(gen, data, prop, opts.ownProperties), ()=>cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({
                missingProperty: missing
            });
            gen.forOf(missing, schemaCode, ()=>{
                gen.assign(valid, (0, $fsS5I.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, $lohei.not)(valid), ()=>{
                    cxt.error();
                    gen.break();
                });
            }, $lohei.nil);
        }
    }
};
module.exports.default = $f05edf8dafa6ed5b$var$def;

});

parcelRegister("4DCGw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");
const $3608cff6f539bf91$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, $lohei.str)`must NOT have ${comp} than ${schemaCode} items`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $lohei._)`{limit: ${schemaCode}}`
};
const $3608cff6f539bf91$var$def = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: true,
    error: $3608cff6f539bf91$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxItems" ? $lohei.operators.GT : $lohei.operators.LT;
        cxt.fail$data((0, $lohei._)`${data}.length ${op} ${schemaCode}`);
    }
};
module.exports.default = $3608cff6f539bf91$var$def;

});

parcelRegister("lzAXs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bvJtX = parcelRequire("bvJtX");

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");

var $70W5O = parcelRequire("70W5O");
const $fb4988f6956d1b04$var$error = {
    message: ({ params: { i: i, j: j } })=>(0, $lohei.str)`must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
    params: ({ params: { i: i, j: j } })=>(0, $lohei._)`{i: ${i}, j: ${j}}`
};
const $fb4988f6956d1b04$var$def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error: $fb4988f6956d1b04$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, parentSchema: parentSchema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && !schema) return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, $bvJtX.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, $lohei._)`${schemaCode} === false`);
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, $lohei._)`${data}.length`);
            const j = gen.let("j");
            cxt.setParams({
                i: i,
                j: j
            });
            gen.assign(valid, true);
            gen.if((0, $lohei._)`${i} > 1`, ()=>(canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t)=>t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, $bvJtX.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, $bvJtX.DataType.Wrong);
            const indices = gen.const("indices", (0, $lohei._)`{}`);
            gen.for((0, $lohei._)`;${i}--;`, ()=>{
                gen.let(item, (0, $lohei._)`${data}[${i}]`);
                gen.if(wrongType, (0, $lohei._)`continue`);
                if (itemTypes.length > 1) gen.if((0, $lohei._)`typeof ${item} == "string"`, (0, $lohei._)`${item} += "_"`);
                gen.if((0, $lohei._)`typeof ${indices}[${item}] == "number"`, ()=>{
                    gen.assign(j, (0, $lohei._)`${indices}[${item}]`);
                    cxt.error();
                    gen.assign(valid, false).break();
                }).code((0, $lohei._)`${indices}[${item}] = ${i}`);
            });
        }
        function loopN2(i, j) {
            const eql = (0, $8rmX0.useFunc)(gen, $70W5O.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, $lohei._)`;${i}--;`, ()=>gen.for((0, $lohei._)`${j} = ${i}; ${j}--;`, ()=>gen.if((0, $lohei._)`${eql}(${data}[${i}], ${data}[${j}])`, ()=>{
                        cxt.error();
                        gen.assign(valid, false).break(outer);
                    })));
        }
    }
};
module.exports.default = $fb4988f6956d1b04$var$def;

});
parcelRegister("70W5O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7hFx0 = parcelRequire("7hFx0");
$7hFx0.code = 'require("ajv/dist/runtime/equal").default';
module.exports.default = $7hFx0;

});


parcelRegister("fQbGj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");

var $70W5O = parcelRequire("70W5O");
const $b884c60831cb75af$var$error = {
    message: "must be equal to constant",
    params: ({ schemaCode: schemaCode })=>(0, $lohei._)`{allowedValue: ${schemaCode}}`
};
const $b884c60831cb75af$var$def = {
    keyword: "const",
    $data: true,
    error: $b884c60831cb75af$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schemaCode: schemaCode, schema: schema } = cxt;
        if ($data || schema && typeof schema == "object") cxt.fail$data((0, $lohei._)`!${(0, $8rmX0.useFunc)(gen, $70W5O.default)}(${data}, ${schemaCode})`);
        else cxt.fail((0, $lohei._)`${schema} !== ${data}`);
    }
};
module.exports.default = $b884c60831cb75af$var$def;

});

parcelRegister("g2Dfm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");

var $70W5O = parcelRequire("70W5O");
const $badb46d8fc58e695$var$error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode: schemaCode })=>(0, $lohei._)`{allowedValues: ${schemaCode}}`
};
const $badb46d8fc58e695$var$def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error: $badb46d8fc58e695$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && schema.length === 0) throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = ()=>eql !== null && eql !== void 0 ? eql : eql = (0, $8rmX0.useFunc)(gen, $70W5O.default);
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, $lohei.or)(...schema.map((_x, i)=>equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v)=>gen.if((0, $lohei._)`${getEql()}(${data}, ${v})`, ()=>gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null ? (0, $lohei._)`${getEql()}(${data}, ${vSchema}[${i}])` : (0, $lohei._)`${data} === ${sch}`;
        }
    }
};
module.exports.default = $badb46d8fc58e695$var$def;

});


parcelRegister("adM23", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7710607c69017e12$var$getApplicator;

var $auFQT = parcelRequire("auFQT");

var $e2TRa = parcelRequire("e2TRa");

var $iIlRc = parcelRequire("iIlRc");

var $kRIig = parcelRequire("kRIig");

var $hTvnt = parcelRequire("hTvnt");

var $6vUGl = parcelRequire("6vUGl");

var $gUPE2 = parcelRequire("gUPE2");

var $3nYww = parcelRequire("3nYww");

var $fCjLP = parcelRequire("fCjLP");

var $6GDVN = parcelRequire("6GDVN");

var $it1Xp = parcelRequire("it1Xp");

var $bl1P9 = parcelRequire("bl1P9");

var $h1muu = parcelRequire("h1muu");

var $62TeW = parcelRequire("62TeW");

var $dDstG = parcelRequire("dDstG");

var $hWwdU = parcelRequire("hWwdU");
function $7710607c69017e12$var$getApplicator(draft2020 = false) {
    const applicator = [
        // any
        $it1Xp.default,
        $bl1P9.default,
        $h1muu.default,
        $62TeW.default,
        $dDstG.default,
        $hWwdU.default,
        // object
        $gUPE2.default,
        $3nYww.default,
        $6vUGl.default,
        $fCjLP.default,
        $6GDVN.default
    ];
    // array
    if (draft2020) applicator.push($e2TRa.default, $kRIig.default);
    else applicator.push($auFQT.default, $iIlRc.default);
    applicator.push($hTvnt.default);
    return applicator;
}

});
parcelRegister("auFQT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAdditionalItems = $7a3d2ba8774d945e$var$validateAdditionalItems;

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");
const $7a3d2ba8774d945e$var$error = {
    message: ({ params: { len: len } })=>(0, $lohei.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $lohei._)`{limit: ${len}}`
};
const $7a3d2ba8774d945e$var$def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error: $7a3d2ba8774d945e$var$error,
    code (cxt) {
        const { parentSchema: parentSchema, it: it } = cxt;
        const { items: items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, $8rmX0.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        $7a3d2ba8774d945e$var$validateAdditionalItems(cxt, items);
    }
};
function $7a3d2ba8774d945e$var$validateAdditionalItems(cxt, items) {
    const { gen: gen, schema: schema, data: data, keyword: keyword, it: it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, $lohei._)`${data}.length`);
    if (schema === false) {
        cxt.setParams({
            len: items.length
        });
        cxt.pass((0, $lohei._)`${len} <= ${items.length}`);
    } else if (typeof schema == "object" && !(0, $8rmX0.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, $lohei._)`${len} <= ${items.length}`); // TODO var
        gen.if((0, $lohei.not)(valid), ()=>validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $8rmX0.Type.Num
            }, valid);
            if (!it.allErrors) gen.if((0, $lohei.not)(valid), ()=>gen.break());
        });
    }
}
module.exports.default = $7a3d2ba8774d945e$var$def;

});

parcelRegister("e2TRa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iIlRc = parcelRequire("iIlRc");
const $a39c948348a9a6c7$var$def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: (cxt)=>(0, $iIlRc.validateTuple)(cxt, "items")
};
module.exports.default = $a39c948348a9a6c7$var$def;

});
parcelRegister("iIlRc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTuple = $d9fd4a659583e2a1$var$validateTuple;

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");

var $fsS5I = parcelRequire("fsS5I");
const $d9fd4a659583e2a1$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code (cxt) {
        const { schema: schema, it: it } = cxt;
        if (Array.isArray(schema)) return $d9fd4a659583e2a1$var$validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, $8rmX0.alwaysValidSchema)(it, schema)) return;
        cxt.ok((0, $fsS5I.validateArray)(cxt));
    }
};
function $d9fd4a659583e2a1$var$validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen: gen, parentSchema: parentSchema, data: data, keyword: keyword, it: it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) it.items = $8rmX0.mergeEvaluated.items(gen, schArr.length, it.items);
    const valid = gen.name("valid");
    const len = gen.const("len", (0, $lohei._)`${data}.length`);
    schArr.forEach((sch, i)=>{
        if ((0, $8rmX0.alwaysValidSchema)(it, sch)) return;
        gen.if((0, $lohei._)`${len} > ${i}`, ()=>cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                dataProp: i
            }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts: opts, errSchemaPath: errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, $8rmX0.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
module.exports.default = $d9fd4a659583e2a1$var$def;

});


parcelRegister("kRIig", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");

var $fsS5I = parcelRequire("fsS5I");

var $auFQT = parcelRequire("auFQT");
const $f30b1db0f4e66b0a$var$error = {
    message: ({ params: { len: len } })=>(0, $lohei.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $lohei._)`{limit: ${len}}`
};
const $f30b1db0f4e66b0a$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error: $f30b1db0f4e66b0a$var$error,
    code (cxt) {
        const { schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { prefixItems: prefixItems } = parentSchema;
        it.items = true;
        if ((0, $8rmX0.alwaysValidSchema)(it, schema)) return;
        if (prefixItems) (0, $auFQT.validateAdditionalItems)(cxt, prefixItems);
        else cxt.ok((0, $fsS5I.validateArray)(cxt));
    }
};
module.exports.default = $f30b1db0f4e66b0a$var$def;

});

parcelRegister("hTvnt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");
const $d06fe9acb06ddc21$var$error = {
    message: ({ params: { min: min, max: max } })=>max === undefined ? (0, $lohei.str)`must contain at least ${min} valid item(s)` : (0, $lohei.str)`must contain at least ${min} and no more than ${max} valid item(s)`,
    params: ({ params: { min: min, max: max } })=>max === undefined ? (0, $lohei._)`{minContains: ${min}}` : (0, $lohei._)`{minContains: ${min}, maxContains: ${max}}`
};
const $d06fe9acb06ddc21$var$def = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: true,
    error: $d06fe9acb06ddc21$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        let min;
        let max;
        const { minContains: minContains, maxContains: maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        } else min = 1;
        const len = gen.const("len", (0, $lohei._)`${data}.length`);
        cxt.setParams({
            min: min,
            max: max
        });
        if (max === undefined && min === 0) {
            (0, $8rmX0.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, $8rmX0.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, $8rmX0.alwaysValidSchema)(it, schema)) {
            let cond = (0, $lohei._)`${len} >= ${min}`;
            if (max !== undefined) cond = (0, $lohei._)`${cond} && ${len} <= ${max}`;
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) validateItems(valid, ()=>gen.if(valid, ()=>gen.break()));
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined) gen.if((0, $lohei._)`${data}.length > 0`, validateItemsWithCount);
        } else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, ()=>cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, ()=>gen.if(schValid, ()=>checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i)=>{
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: $8rmX0.Type.Num,
                    compositeRule: true
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, $lohei._)`${count}++`);
            if (max === undefined) gen.if((0, $lohei._)`${count} >= ${min}`, ()=>gen.assign(valid, true).break());
            else {
                gen.if((0, $lohei._)`${count} > ${max}`, ()=>gen.assign(valid, false).break());
                if (min === 1) gen.assign(valid, true);
                else gen.if((0, $lohei._)`${count} >= ${min}`, ()=>gen.assign(valid, true));
            }
        }
    }
};
module.exports.default = $d06fe9acb06ddc21$var$def;

});

parcelRegister("6vUGl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.error = void 0;
module.exports.validatePropertyDeps = $013950f461c97d3d$var$validatePropertyDeps;
module.exports.validateSchemaDeps = $013950f461c97d3d$var$validateSchemaDeps;

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");

var $fsS5I = parcelRequire("fsS5I");
module.exports.error = {
    message: ({ params: { property: property, depsCount: depsCount, deps: deps } })=>{
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, $lohei.str)`must have ${property_ies} ${deps} when property ${property} is present`;
    },
    params: ({ params: { property: property, depsCount: depsCount, deps: deps, missingProperty: missingProperty } })=>(0, $lohei._)`{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`
};
const $013950f461c97d3d$var$def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: module.exports.error,
    code (cxt) {
        const [propDeps, schDeps] = $013950f461c97d3d$var$splitDependencies(cxt);
        $013950f461c97d3d$var$validatePropertyDeps(cxt, propDeps);
        $013950f461c97d3d$var$validateSchemaDeps(cxt, schDeps);
    }
};
function $013950f461c97d3d$var$splitDependencies({ schema: schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for(const key in schema){
        if (key === "__proto__") continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [
        propertyDeps,
        schemaDeps
    ];
}
function $013950f461c97d3d$var$validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen: gen, data: data, it: it } = cxt;
    if (Object.keys(propertyDeps).length === 0) return;
    const missing = gen.let("missing");
    for(const prop in propertyDeps){
        const deps = propertyDeps[prop];
        if (deps.length === 0) continue;
        const hasProperty = (0, $fsS5I.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
        });
        if (it.allErrors) gen.if(hasProperty, ()=>{
            for (const depProp of deps)(0, $fsS5I.checkReportMissingProp)(cxt, depProp);
        });
        else {
            gen.if((0, $lohei._)`${hasProperty} && (${(0, $fsS5I.checkMissingProp)(cxt, deps, missing)})`);
            (0, $fsS5I.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
function $013950f461c97d3d$var$validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    for(const prop in schemaDeps){
        if ((0, $8rmX0.alwaysValidSchema)(it, schemaDeps[prop])) continue;
        gen.if((0, $fsS5I.propertyInData)(gen, data, prop, it.opts.ownProperties), ()=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: prop
            }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, ()=>gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
module.exports.default = $013950f461c97d3d$var$def;

});

parcelRegister("gUPE2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");
const $c509efdb671d5369$var$error = {
    message: "property name must be valid",
    params: ({ params: params })=>(0, $lohei._)`{propertyName: ${params.propertyName}}`
};
const $c509efdb671d5369$var$def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error: $c509efdb671d5369$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, data: data, it: it } = cxt;
        if ((0, $8rmX0.alwaysValidSchema)(it, schema)) return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key)=>{
            cxt.setParams({
                propertyName: key
            });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: [
                    "string"
                ],
                propertyName: key,
                compositeRule: true
            }, valid);
            gen.if((0, $lohei.not)(valid), ()=>{
                cxt.error(true);
                if (!it.allErrors) gen.break();
            });
        });
        cxt.ok(valid);
    }
};
module.exports.default = $c509efdb671d5369$var$def;

});

parcelRegister("3nYww", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fsS5I = parcelRequire("fsS5I");

var $lohei = parcelRequire("lohei");

var $7CJrC = parcelRequire("7CJrC");

var $8rmX0 = parcelRequire("8rmX0");
const $277277c65703f5ae$var$error = {
    message: "must NOT have additional properties",
    params: ({ params: params })=>(0, $lohei._)`{additionalProperty: ${params.additionalProperty}}`
};
const $277277c65703f5ae$var$def = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error: $277277c65703f5ae$var$error,
    code (cxt) {
        const { gen: gen, parentSchema: parentSchema, data: data, errsCount: errsCount, it: it } = cxt;
        const { schema: schema = it.opts.defaultAdditionalProperties } = cxt;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors: allErrors, opts: opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, $8rmX0.alwaysValidSchema)(it, schema)) return;
        const props = (0, $fsS5I.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, $fsS5I.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, $lohei._)`${errsCount} === ${$7CJrC.default.errors}`);
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key)=>{
                if (!props.length && !patProps.length) additionalPropertyCode(key);
                else gen.if(isAdditional(key), ()=>additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, $8rmX0.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, $fsS5I.isOwnProperty)(gen, propsSchema, key);
            } else if (props.length) definedProp = (0, $lohei.or)(...props.map((p)=>(0, $lohei._)`${key} === ${p}`));
            else definedProp = $lohei.nil;
            if (patProps.length) definedProp = (0, $lohei.or)(definedProp, ...patProps.map((p)=>(0, $lohei._)`${(0, $fsS5I.usePattern)(cxt, p)}.test(${key})`));
            return (0, $lohei.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, $lohei._)`delete ${data}[${key}]`);
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({
                    additionalProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, $8rmX0.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, $lohei.not)(valid), ()=>{
                        cxt.reset();
                        deleteAdditional(key);
                    });
                } else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors) gen.if((0, $lohei.not)(valid), ()=>gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: $8rmX0.Type.Str
            };
            if (errors === false) Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
            });
            cxt.subschema(subschema, valid);
        }
    }
};
module.exports.default = $277277c65703f5ae$var$def;

});

parcelRegister("fCjLP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bTGAO = parcelRequire("bTGAO");

var $fsS5I = parcelRequire("fsS5I");

var $8rmX0 = parcelRequire("8rmX0");

var $3nYww = parcelRequire("3nYww");
const $b5e9bd9de9c4ba79$var$def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined || it.opts.defaultAdditionalProperties === false) $3nYww.default.code(new $bTGAO.KeywordCxt(it, $3nYww.default, "additionalProperties"));
        const allProps = (0, $fsS5I.allSchemaProperties)(schema);
        for (const prop of allProps)it.definedProperties.add(prop);
        if (it.opts.unevaluated && allProps.length && it.props !== true) it.props = $8rmX0.mergeEvaluated.props(gen, (0, $8rmX0.toHash)(allProps), it.props);
        const properties = allProps.filter((p)=>!(0, $8rmX0.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0) return;
        const valid = gen.name("valid");
        for (const prop of properties){
            if (hasDefault(prop)) applyPropertySchema(prop);
            else {
                gen.if((0, $fsS5I.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors) gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop
            }, valid);
        }
    }
};
module.exports.default = $b5e9bd9de9c4ba79$var$def;

});

parcelRegister("6GDVN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fsS5I = parcelRequire("fsS5I");

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");

var $8rmX0 = parcelRequire("8rmX0");
const $4de5a3d2a908a474$var$def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, data: data, parentSchema: parentSchema, it: it } = cxt;
        const { opts: opts } = it;
        const patterns = (0, $fsS5I.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p)=>(0, $8rmX0.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) return;
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof $lohei.Name)) it.props = (0, $8rmX0.evaluatedPropsToName)(gen, it.props);
        const { props: props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns){
                if (checkProperties) checkMatchingProperties(pat);
                if (it.allErrors) validateProperties(pat);
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for(const prop in checkProperties)if (new RegExp(pat).test(prop)) (0, $8rmX0.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key)=>{
                gen.if((0, $lohei._)`${(0, $fsS5I.usePattern)(cxt, pat)}.test(${key})`, ()=>{
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) cxt.subschema({
                        keyword: "patternProperties",
                        schemaProp: pat,
                        dataProp: key,
                        dataPropType: $8rmX0.Type.Str
                    }, valid);
                    if (it.opts.unevaluated && props !== true) gen.assign((0, $lohei._)`${props}[${key}]`, true);
                    else if (!alwaysValid && !it.allErrors) // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                    // or if all properties were evaluated (props === true)
                    gen.if((0, $lohei.not)(valid), ()=>gen.break());
                });
            });
        }
    }
};
module.exports.default = $4de5a3d2a908a474$var$def;

});

parcelRegister("it1Xp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8rmX0 = parcelRequire("8rmX0");
const $d71c741a9ebf6c3e$var$def = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        if ((0, $8rmX0.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
        }, valid);
        cxt.failResult(valid, ()=>cxt.reset(), ()=>cxt.error());
    },
    error: {
        message: "must NOT be valid"
    }
};
module.exports.default = $d71c741a9ebf6c3e$var$def;

});

parcelRegister("bl1P9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fsS5I = parcelRequire("fsS5I");
const $8413121935de5583$var$def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: $fsS5I.validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
module.exports.default = $8413121935de5583$var$def;

});

parcelRegister("h1muu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");
const $c643f9e0bf7c0b8f$var$error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params: params })=>(0, $lohei._)`{passingSchemas: ${params.passing}}`
};
const $c643f9e0bf7c0b8f$var$def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error: $c643f9e0bf7c0b8f$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator) return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({
            passing: passing
        });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i)=>{
                let schCxt;
                if ((0, $8rmX0.alwaysValidSchema)(it, sch)) gen.var(schValid, true);
                else schCxt = cxt.subschema({
                    keyword: "oneOf",
                    schemaProp: i,
                    compositeRule: true
                }, schValid);
                if (i > 0) gen.if((0, $lohei._)`${schValid} && ${valid}`).assign(valid, false).assign(passing, (0, $lohei._)`[${passing}, ${i}]`).else();
                gen.if(schValid, ()=>{
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt) cxt.mergeEvaluated(schCxt, $lohei.Name);
                });
            });
        }
    }
};
module.exports.default = $c643f9e0bf7c0b8f$var$def;

});

parcelRegister("62TeW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8rmX0 = parcelRequire("8rmX0");
const $466dc7782bfb77d5$var$def = {
    keyword: "allOf",
    schemaType: "array",
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i)=>{
            if ((0, $8rmX0.alwaysValidSchema)(it, sch)) return;
            const schCxt = cxt.subschema({
                keyword: "allOf",
                schemaProp: i
            }, valid, true);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    }
};
module.exports.default = $466dc7782bfb77d5$var$def;

});

parcelRegister("dDstG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");
const $9ed501fb46ef611d$var$error = {
    message: ({ params: params })=>(0, $lohei.str)`must match "${params.ifClause}" schema`,
    params: ({ params: params })=>(0, $lohei._)`{failingKeyword: ${params.ifClause}}`
};
const $9ed501fb46ef611d$var$def = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    error: $9ed501fb46ef611d$var$error,
    code (cxt) {
        const { gen: gen, parentSchema: parentSchema, it: it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) (0, $8rmX0.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        const hasThen = $9ed501fb46ef611d$var$hasSchema(it, "then");
        const hasElse = $9ed501fb46ef611d$var$hasSchema(it, "else");
        if (!hasThen && !hasElse) return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({
                ifClause: ifClause
            });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        } else if (hasThen) gen.if(schValid, validateClause("then"));
        else gen.if((0, $lohei.not)(schValid), validateClause("else"));
        cxt.pass(valid, ()=>cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return ()=>{
                const schCxt = cxt.subschema({
                    keyword: keyword
                }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause) gen.assign(ifClause, (0, $lohei._)`${keyword}`);
                else cxt.setParams({
                    ifClause: keyword
                });
            };
        }
    }
};
function $9ed501fb46ef611d$var$hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, $8rmX0.alwaysValidSchema)(it, schema);
}
module.exports.default = $9ed501fb46ef611d$var$def;

});

parcelRegister("hWwdU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8rmX0 = parcelRequire("8rmX0");
const $d100d9593bf12bf6$var$def = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code ({ keyword: keyword, parentSchema: parentSchema, it: it }) {
        if (parentSchema.if === undefined) (0, $8rmX0.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    }
};
module.exports.default = $d100d9593bf12bf6$var$def;

});


parcelRegister("bmxAj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cheNm = parcelRequire("cheNm");

var $iBktp = parcelRequire("iBktp");

var $4pYeN = parcelRequire("4pYeN");

var $bgbFR = parcelRequire("bgbFR");
const $845bccfae5cfc816$var$dynamic = [
    $cheNm.default,
    $iBktp.default,
    $4pYeN.default,
    $bgbFR.default
];
module.exports.default = $845bccfae5cfc816$var$dynamic;

});
parcelRegister("cheNm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dynamicAnchor = $8f028c90da84a0b3$var$dynamicAnchor;

var $lohei = parcelRequire("lohei");

var $7CJrC = parcelRequire("7CJrC");

var $8AeYZ = parcelRequire("8AeYZ");

var $uGCYs = parcelRequire("uGCYs");
const $8f028c90da84a0b3$var$def = {
    keyword: "$dynamicAnchor",
    schemaType: "string",
    code: (cxt)=>$8f028c90da84a0b3$var$dynamicAnchor(cxt, cxt.schema)
};
function $8f028c90da84a0b3$var$dynamicAnchor(cxt, anchor) {
    const { gen: gen, it: it } = cxt;
    it.schemaEnv.root.dynamicAnchors[anchor] = true;
    const v = (0, $lohei._)`${$7CJrC.default.dynamicAnchors}${(0, $lohei.getProperty)(anchor)}`;
    const validate = it.errSchemaPath === "#" ? it.validateName : $8f028c90da84a0b3$var$_getValidate(cxt);
    gen.if((0, $lohei._)`!${v}`, ()=>gen.assign(v, validate));
}
function $8f028c90da84a0b3$var$_getValidate(cxt) {
    const { schemaEnv: schemaEnv, schema: schema, self: self } = cxt.it;
    const { root: root, baseId: baseId, localRefs: localRefs, meta: meta } = schemaEnv.root;
    const { schemaId: schemaId } = self.opts;
    const sch = new $8AeYZ.SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId,
        localRefs: localRefs,
        meta: meta
    });
    $8AeYZ.compileSchema.call(self, sch);
    return (0, $uGCYs.getValidate)(cxt, sch);
}
module.exports.default = $8f028c90da84a0b3$var$def;

});

parcelRegister("iBktp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dynamicRef = $d8ab904888427809$var$dynamicRef;

var $lohei = parcelRequire("lohei");

var $7CJrC = parcelRequire("7CJrC");

var $uGCYs = parcelRequire("uGCYs");
const $d8ab904888427809$var$def = {
    keyword: "$dynamicRef",
    schemaType: "string",
    code: (cxt)=>$d8ab904888427809$var$dynamicRef(cxt, cxt.schema)
};
function $d8ab904888427809$var$dynamicRef(cxt, ref) {
    const { gen: gen, keyword: keyword, it: it } = cxt;
    if (ref[0] !== "#") throw new Error(`"${keyword}" only supports hash fragment reference`);
    const anchor = ref.slice(1);
    if (it.allErrors) _dynamicRef();
    else {
        const valid = gen.let("valid", false);
        _dynamicRef(valid);
        cxt.ok(valid);
    }
    function _dynamicRef(valid) {
        // TODO the assumption here is that `recursiveRef: #` always points to the root
        // of the schema object, which is not correct, because there may be $id that
        // makes # point to it, and the target schema may not contain dynamic/recursiveAnchor.
        // Because of that 2 tests in recursiveRef.json fail.
        // This is a similar problem to #815 (`$id` doesn't alter resolution scope for `{ "$ref": "#" }`).
        // (This problem is not tested in JSON-Schema-Test-Suite)
        if (it.schemaEnv.root.dynamicAnchors[anchor]) {
            const v = gen.let("_v", (0, $lohei._)`${$7CJrC.default.dynamicAnchors}${(0, $lohei.getProperty)(anchor)}`);
            gen.if(v, _callRef(v, valid), _callRef(it.validateName, valid));
        } else _callRef(it.validateName, valid)();
    }
    function _callRef(validate, valid) {
        return valid ? ()=>gen.block(()=>{
                (0, $uGCYs.callRef)(cxt, validate);
                gen.let(valid, true);
            }) : ()=>(0, $uGCYs.callRef)(cxt, validate);
    }
}
module.exports.default = $d8ab904888427809$var$def;

});

parcelRegister("4pYeN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cheNm = parcelRequire("cheNm");

var $8rmX0 = parcelRequire("8rmX0");
const $3378392779b5e400$var$def = {
    keyword: "$recursiveAnchor",
    schemaType: "boolean",
    code (cxt) {
        if (cxt.schema) (0, $cheNm.dynamicAnchor)(cxt, "");
        else (0, $8rmX0.checkStrictMode)(cxt.it, "$recursiveAnchor: false is ignored");
    }
};
module.exports.default = $3378392779b5e400$var$def;

});

parcelRegister("bgbFR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iBktp = parcelRequire("iBktp");
const $832a3e975c3f5f57$var$def = {
    keyword: "$recursiveRef",
    schemaType: "string",
    code: (cxt)=>(0, $iBktp.dynamicRef)(cxt, cxt.schema)
};
module.exports.default = $832a3e975c3f5f57$var$def;

});


parcelRegister("87JeO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lU2xe = parcelRequire("lU2xe");

var $6rXiL = parcelRequire("6rXiL");

var $9ShMo = parcelRequire("9ShMo");
const $5ea21179b9e692de$var$next = [
    $lU2xe.default,
    $6rXiL.default,
    $9ShMo.default
];
module.exports.default = $5ea21179b9e692de$var$next;

});
parcelRegister("lU2xe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6vUGl = parcelRequire("6vUGl");
const $ff20cb552567000f$var$def = {
    keyword: "dependentRequired",
    type: "object",
    schemaType: "object",
    error: $6vUGl.error,
    code: (cxt)=>(0, $6vUGl.validatePropertyDeps)(cxt)
};
module.exports.default = $ff20cb552567000f$var$def;

});

parcelRegister("6rXiL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6vUGl = parcelRequire("6vUGl");
const $4b2343c927f4de26$var$def = {
    keyword: "dependentSchemas",
    type: "object",
    schemaType: "object",
    code: (cxt)=>(0, $6vUGl.validateSchemaDeps)(cxt)
};
module.exports.default = $4b2343c927f4de26$var$def;

});

parcelRegister("9ShMo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8rmX0 = parcelRequire("8rmX0");
const $7306f2d63fd9f3dd$var$def = {
    keyword: [
        "maxContains",
        "minContains"
    ],
    type: "array",
    schemaType: "number",
    code ({ keyword: keyword, parentSchema: parentSchema, it: it }) {
        if (parentSchema.contains === undefined) (0, $8rmX0.checkStrictMode)(it, `"${keyword}" without "contains" is ignored`);
    }
};
module.exports.default = $7306f2d63fd9f3dd$var$def;

});


parcelRegister("8ESYy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4W4xh = parcelRequire("4W4xh");

var $3EoZ5 = parcelRequire("3EoZ5");
const $64dcb42d6eecee00$var$unevaluated = [
    $4W4xh.default,
    $3EoZ5.default
];
module.exports.default = $64dcb42d6eecee00$var$unevaluated;

});
parcelRegister("4W4xh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");

var $7CJrC = parcelRequire("7CJrC");
const $398018e4d535382b$var$error = {
    message: "must NOT have unevaluated properties",
    params: ({ params: params })=>(0, $lohei._)`{unevaluatedProperty: ${params.unevaluatedProperty}}`
};
const $398018e4d535382b$var$def = {
    keyword: "unevaluatedProperties",
    type: "object",
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error: $398018e4d535382b$var$error,
    code (cxt) {
        const { gen: gen, schema: schema = cxt.it.opts.defaultUnevaluatedProperties, data: data, errsCount: errsCount, it: it } = cxt;
        const isForced = cxt.schema === undefined && cxt.it.opts.defaultUnevaluatedProperties === false;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors: allErrors, props: props } = it;
        if (props instanceof $lohei.Name) gen.if((0, $lohei._)`${props} !== true`, ()=>gen.forIn("key", data, (key)=>gen.if(unevaluatedDynamic(props, key), ()=>unevaluatedPropCode(key))));
        else if (props !== true) {
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            const staticCheck = ()=>gen.forIn("key", data, (key)=>props === undefined ? unevaluatedPropCode(key) : gen.if(unevaluatedStatic(props, key), ()=>unevaluatedPropCode(key)));
            if (isForced && it.errorPath.emptyStr()) // $refs are compiled into functions
            // We need to check in runtime if function was called from allOf.
            // We need to check only on the top level of the function:
            // it is ensured with `it.errorPath.emptyStr()` check
            gen.if((0, $lohei._)`${$7CJrC.default.isAllOfVariant} === 0`, staticCheck);
            else staticCheck();
        }
        if (!isForced) // disable shot-circut for forced unevaluatedProperties=false
        // we may run or not the check in runtime so we can't short-circuit in compile-time
        it.props = true;
        cxt.ok((0, $lohei._)`${errsCount} === ${$7CJrC.default.errors}`);
        function unevaluatedPropCode(key) {
            if (schema === false) {
                cxt.setParams({
                    unevaluatedProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (!(0, $8rmX0.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                cxt.subschema({
                    keyword: "unevaluatedProperties",
                    dataProp: key,
                    dataPropType: $8rmX0.Type.Str
                }, valid);
                if (!allErrors) gen.if((0, $lohei.not)(valid), ()=>gen.break());
            }
        }
        function unevaluatedDynamic(evaluatedProps, key) {
            return (0, $lohei._)`!${evaluatedProps} || !${evaluatedProps}[${key}]`;
        }
        function unevaluatedStatic(evaluatedProps, key) {
            const ps = [];
            for(const p in evaluatedProps)if (evaluatedProps[p] === true) ps.push((0, $lohei._)`${key} !== ${p}`);
            return (0, $lohei.and)(...ps);
        }
    }
};
module.exports.default = $398018e4d535382b$var$def;

});

parcelRegister("3EoZ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");

var $8rmX0 = parcelRequire("8rmX0");
const $2a887ce0964e4e7b$var$error = {
    message: ({ params: { len: len } })=>(0, $lohei.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $lohei._)`{limit: ${len}}`
};
const $2a887ce0964e4e7b$var$def = {
    keyword: "unevaluatedItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    error: $2a887ce0964e4e7b$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, data: data, it: it } = cxt;
        const items = it.items || 0;
        if (items === true) return;
        const len = gen.const("len", (0, $lohei._)`${data}.length`);
        if (schema === false) {
            cxt.setParams({
                len: items
            });
            cxt.fail((0, $lohei._)`${len} > ${items}`);
        } else if (typeof schema == "object" && !(0, $8rmX0.alwaysValidSchema)(it, schema)) {
            const valid = gen.var("valid", (0, $lohei._)`${len} <= ${items}`);
            gen.if((0, $lohei.not)(valid), ()=>validateItems(valid, items));
            cxt.ok(valid);
        }
        it.items = true;
        function validateItems(valid, from) {
            gen.forRange("i", from, len, (i)=>{
                cxt.subschema({
                    keyword: "unevaluatedItems",
                    dataProp: i,
                    dataPropType: $8rmX0.Type.Num
                }, valid);
                if (!it.allErrors) gen.if((0, $lohei.not)(valid), ()=>gen.break());
            });
        }
    }
};
module.exports.default = $2a887ce0964e4e7b$var$def;

});


parcelRegister("er107", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lpbyK = parcelRequire("lpbyK");
const $a8245d15abd49982$var$format = [
    $lpbyK.default
];
module.exports.default = $a8245d15abd49982$var$format;

});
parcelRegister("lpbyK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");
const $f954e6397190a84c$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $lohei.str)`must match format "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $lohei._)`{format: ${schemaCode}}`
};
const $f954e6397190a84c$var$def = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: true,
    error: $f954e6397190a84c$var$error,
    code (cxt, ruleType) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const { opts: opts, errSchemaPath: errSchemaPath, schemaEnv: schemaEnv, self: self } = it;
        if (!opts.validateFormats) return;
        if ($data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fDef = gen.const("fDef", (0, $lohei._)`${fmts}[${schemaCode}]`);
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, $lohei._)`typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, ()=>gen.assign(fType, (0, $lohei._)`${fDef}.type || "string"`).assign(format, (0, $lohei._)`${fDef}.validate`), ()=>gen.assign(fType, (0, $lohei._)`"string"`).assign(format, fDef));
            cxt.fail$data((0, $lohei.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false) return $lohei.nil;
                return (0, $lohei._)`${schemaCode} && !${format}`;
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async ? (0, $lohei._)`(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))` : (0, $lohei._)`${format}(${data})`;
                const validData = (0, $lohei._)`(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
                return (0, $lohei._)`${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true) return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType) cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp ? (0, $lohei.regexpCode)(fmtDef) : opts.code.formats ? (0, $lohei._)`${opts.code.formats}${(0, $lohei.getProperty)(schema)}` : undefined;
                const fmt = gen.scopeValue("formats", {
                    key: schema,
                    ref: fmtDef,
                    code: code
                });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) return [
                    fmtDef.type || "string",
                    fmtDef.validate,
                    (0, $lohei._)`${fmt}.validate`
                ];
                return [
                    "string",
                    fmtDef,
                    fmt
                ];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async) throw new Error("async format in sync schema");
                    return (0, $lohei._)`await ${fmtRef}(${data})`;
                }
                return typeof format == "function" ? (0, $lohei._)`${fmtRef}(${data})` : (0, $lohei._)`${fmtRef}.test(${data})`;
            }
        }
    }
};
module.exports.default = $f954e6397190a84c$var$def;

});


parcelRegister("eebnH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contentVocabulary = module.exports.metadataVocabulary = void 0;
module.exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
];
module.exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
];

});


parcelRegister("3yn8Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lohei = parcelRequire("lohei");

var $5dfgz = parcelRequire("5dfgz");

var $8AeYZ = parcelRequire("8AeYZ");

var $8rmX0 = parcelRequire("8rmX0");
const $29667ff1b7d55e53$var$error = {
    message: ({ params: { discrError: discrError, tagName: tagName } })=>discrError === $5dfgz.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf or anyOf`,
    params: ({ params: { discrError: discrError, tag: tag, tagName: tagName } })=>(0, $lohei._)`{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`
};
const $29667ff1b7d55e53$var$def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: $29667ff1b7d55e53$var$error,
    code (cxt) {
        const { gen: gen, data: data, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const keyword = parentSchema.oneOf ? "oneOf" : parentSchema.anyOf ? "anyOf" : undefined;
        if (!it.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        const tagName = schema.propertyName;
        if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
        if (!keyword) throw new Error("discriminator: requires oneOf or anyOf composite keyword");
        const parentSchemaVariants = parentSchema[keyword];
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, $lohei._)`${data}${(0, $lohei.getProperty)(tagName)}`);
        gen.if((0, $lohei._)`typeof ${tag} == "string"`, ()=>validateMapping(), ()=>cxt.error(false, {
                discrError: $5dfgz.DiscrError.Tag,
                tag: tag,
                tagName: tagName
            }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for(const tagValue in mapping){
                gen.elseIf((0, $lohei._)`${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, {
                discrError: $5dfgz.DiscrError.Mapping,
                tag: tag,
                tagName: tagName
            });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: schemaProp
            }, _valid);
            cxt.mergeEvaluated(schCxt, $lohei.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const discriminatorMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for(let i = 0; i < parentSchemaVariants.length; i++){
                let sch = parentSchemaVariants[i];
                const schRef = sch === null || sch === void 0 ? void 0 : sch.$ref;
                if (schRef && schema.mapping) {
                    const { mapping: mapping } = schema;
                    const matchedKeys = Object.keys(mapping).filter((key)=>mapping[key] === sch.$ref);
                    if (matchedKeys.length) {
                        for (const key of matchedKeys)addMapping(key, i);
                        continue;
                    }
                }
                if (schRef && !(0, $8rmX0.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    sch = $8AeYZ.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, schRef);
                    if (sch instanceof $8AeYZ.SchemaEnv) sch = sch.schema;
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") throw new Error(`discriminator: ${keyword} subschemas (or referenced schemas) must have "properties/${tagName}" or match mapping`);
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired) throw new Error(`discriminator: "${tagName}" must be required`);
            return discriminatorMapping;
            function hasRequired({ required: required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) addMapping(sch.const, i);
                else if (sch.enum) for (const tagValue of sch.enum)addMapping(tagValue, i);
                else throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in discriminatorMapping) throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                discriminatorMapping[tagValue] = i;
            }
        }
    }
};
module.exports.default = $29667ff1b7d55e53$var$def;

});
parcelRegister("5dfgz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscrError = void 0;
var $3cba0234f874e51b$var$DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})($3cba0234f874e51b$var$DiscrError || (module.exports.DiscrError = $3cba0234f874e51b$var$DiscrError = {}));

});


parcelRegister("Tsyvt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a6b49b53c3a085e$var$addMetaSchema2020;

var $dtTtE = parcelRequire("dtTtE");

var $dFP8h = parcelRequire("dFP8h");

var $6t6hC = parcelRequire("6t6hC");

var $3goOf = parcelRequire("3goOf");

var $dCNyr = parcelRequire("dCNyr");

var $lYetq = parcelRequire("lYetq");

var $kfwoo = parcelRequire("kfwoo");

var $1KY1l = parcelRequire("1KY1l");
const $0a6b49b53c3a085e$var$META_SUPPORT_DATA = [
    "/properties"
];
function $0a6b49b53c3a085e$var$addMetaSchema2020($data) {
    [
        $dtTtE,
        $dFP8h,
        $6t6hC,
        $3goOf,
        $dCNyr,
        with$data(this, $lYetq),
        $kfwoo,
        with$data(this, $1KY1l)
    ].forEach((sch)=>this.addMetaSchema(sch, undefined, false));
    return this;
    function with$data(ajv, sch) {
        return $data ? ajv.$dataMetaSchema(sch, $0a6b49b53c3a085e$var$META_SUPPORT_DATA) : sch;
    }
}

});
parcelRegister("dtTtE", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/schema\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/core\":true,\"https://json-schema.org/draft/2020-12/vocab/applicator\":true,\"https://json-schema.org/draft/2020-12/vocab/unevaluated\":true,\"https://json-schema.org/draft/2020-12/vocab/validation\":true,\"https://json-schema.org/draft/2020-12/vocab/meta-data\":true,\"https://json-schema.org/draft/2020-12/vocab/format-annotation\":true,\"https://json-schema.org/draft/2020-12/vocab/content\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Core and Validation specifications meta-schema\",\"allOf\":[{\"$ref\":\"meta/core\"},{\"$ref\":\"meta/applicator\"},{\"$ref\":\"meta/unevaluated\"},{\"$ref\":\"meta/validation\"},{\"$ref\":\"meta/meta-data\"},{\"$ref\":\"meta/format-annotation\"},{\"$ref\":\"meta/content\"}],\"type\":[\"object\",\"boolean\"],\"$comment\":\"This meta-schema also defines keywords that have appeared in previous drafts in order to prevent incompatible extensions as they remain in common use.\",\"properties\":{\"definitions\":{\"$comment\":\"\\\"definitions\\\" has been replaced by \\\"$defs\\\".\",\"type\":\"object\",\"additionalProperties\":{\"$dynamicRef\":\"#meta\"},\"deprecated\":true,\"default\":{}},\"dependencies\":{\"$comment\":\"\\\"dependencies\\\" has been split and replaced by \\\"dependentSchemas\\\" and \\\"dependentRequired\\\" in order to serve their differing semantics.\",\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$dynamicRef\":\"#meta\"},{\"$ref\":\"meta/validation#/$defs/stringArray\"}]},\"deprecated\":true,\"default\":{}},\"$recursiveAnchor\":{\"$comment\":\"\\\"$recursiveAnchor\\\" has been replaced by \\\"$dynamicAnchor\\\".\",\"$ref\":\"meta/core#/$defs/anchorString\",\"deprecated\":true},\"$recursiveRef\":{\"$comment\":\"\\\"$recursiveRef\\\" has been replaced by \\\"$dynamicRef\\\".\",\"$ref\":\"meta/core#/$defs/uriReferenceString\",\"deprecated\":true}}}");

});

parcelRegister("dFP8h", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/applicator\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/applicator\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Applicator vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"prefixItems\":{\"$ref\":\"#/$defs/schemaArray\"},\"items\":{\"$dynamicRef\":\"#meta\"},\"contains\":{\"$dynamicRef\":\"#meta\"},\"additionalProperties\":{\"$dynamicRef\":\"#meta\"},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$dynamicRef\":\"#meta\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$dynamicRef\":\"#meta\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependentSchemas\":{\"type\":\"object\",\"additionalProperties\":{\"$dynamicRef\":\"#meta\"},\"default\":{}},\"propertyNames\":{\"$dynamicRef\":\"#meta\"},\"if\":{\"$dynamicRef\":\"#meta\"},\"then\":{\"$dynamicRef\":\"#meta\"},\"else\":{\"$dynamicRef\":\"#meta\"},\"allOf\":{\"$ref\":\"#/$defs/schemaArray\"},\"anyOf\":{\"$ref\":\"#/$defs/schemaArray\"},\"oneOf\":{\"$ref\":\"#/$defs/schemaArray\"},\"not\":{\"$dynamicRef\":\"#meta\"}},\"$defs\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$dynamicRef\":\"#meta\"}}}}");

});

parcelRegister("6t6hC", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/unevaluated\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/unevaluated\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Unevaluated applicator vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"unevaluatedItems\":{\"$dynamicRef\":\"#meta\"},\"unevaluatedProperties\":{\"$dynamicRef\":\"#meta\"}}}");

});

parcelRegister("3goOf", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/content\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/content\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Content vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"contentEncoding\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentSchema\":{\"$dynamicRef\":\"#meta\"}}}");

});

parcelRegister("dCNyr", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/core\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/core\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Core vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"$ref\":\"#/$defs/uriReferenceString\",\"$comment\":\"Non-empty fragments not allowed.\",\"pattern\":\"^[^#]*#?$\"},\"$schema\":{\"$ref\":\"#/$defs/uriString\"},\"$ref\":{\"$ref\":\"#/$defs/uriReferenceString\"},\"$anchor\":{\"$ref\":\"#/$defs/anchorString\"},\"$dynamicRef\":{\"$ref\":\"#/$defs/uriReferenceString\"},\"$dynamicAnchor\":{\"$ref\":\"#/$defs/anchorString\"},\"$vocabulary\":{\"type\":\"object\",\"propertyNames\":{\"$ref\":\"#/$defs/uriString\"},\"additionalProperties\":{\"type\":\"boolean\"}},\"$comment\":{\"type\":\"string\"},\"$defs\":{\"type\":\"object\",\"additionalProperties\":{\"$dynamicRef\":\"#meta\"}}},\"$defs\":{\"anchorString\":{\"type\":\"string\",\"pattern\":\"^[A-Za-z_][-A-Za-z0-9._]*$\"},\"uriString\":{\"type\":\"string\",\"format\":\"uri\"},\"uriReferenceString\":{\"type\":\"string\",\"format\":\"uri-reference\"}}}");

});

parcelRegister("lYetq", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/format-annotation\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/format-annotation\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Format vocabulary meta-schema for annotation results\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"format\":{\"type\":\"string\"}}}");

});

parcelRegister("kfwoo", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/meta-data\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/meta-data\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Meta-data vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"deprecated\":{\"type\":\"boolean\",\"default\":false},\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"writeOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true}}}");

});

parcelRegister("1KY1l", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/validation\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/validation\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Validation vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"type\":{\"anyOf\":[{\"$ref\":\"#/$defs/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/$defs/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/$defs/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/$defs/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"maxItems\":{\"$ref\":\"#/$defs/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/$defs/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"maxContains\":{\"$ref\":\"#/$defs/nonNegativeInteger\"},\"minContains\":{\"$ref\":\"#/$defs/nonNegativeInteger\",\"default\":1},\"maxProperties\":{\"$ref\":\"#/$defs/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/$defs/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/$defs/stringArray\"},\"dependentRequired\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/stringArray\"}}},\"$defs\":{\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"$ref\":\"#/$defs/nonNegativeInteger\",\"default\":0},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}}}");

});






parcelRegister("jVI1J", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Config = module.exports.StyleguideConfig = module.exports.IGNORE_FILE = void 0;

var $kjyEk = parcelRequire("kjyEk");

var $59kwG = parcelRequire("59kwG");

var $64y7M = parcelRequire("64y7M");

var $eONiY = parcelRequire("eONiY");

var $aSlQf = parcelRequire("aSlQf");

var $3fhVa = parcelRequire("3fhVa");

var $j0sZx = parcelRequire("j0sZx");

var $3EQkN = parcelRequire("3EQkN");
module.exports.IGNORE_FILE = '.redocly.lint-ignore.yaml';
const $e8257e0874015219$var$IGNORE_BANNER = `# This file instructs Redocly's linter to ignore the rules contained for specific parts of your API.\n` + `# See https://redocly.com/docs/cli/ for more information.\n`;
function $e8257e0874015219$var$getIgnoreFilePath(configFile) {
    if (configFile) return (0, $eONiY.doesYamlFileExist)(configFile) ? $59kwG.join($59kwG.dirname(configFile), module.exports.IGNORE_FILE) : $59kwG.join(configFile, module.exports.IGNORE_FILE);
    else return $3fhVa.isBrowser ? undefined : $59kwG.join($hPtJY.cwd(), module.exports.IGNORE_FILE);
}
class $e8257e0874015219$var$StyleguideConfig {
    constructor(rawConfig, configFile){
        this.rawConfig = rawConfig;
        this.configFile = configFile;
        this.ignore = {};
        this._usedRules = new Set();
        this._usedVersions = new Set();
        this.plugins = rawConfig.plugins || [];
        this.doNotResolveExamples = !!rawConfig.doNotResolveExamples;
        this.recommendedFallback = rawConfig.recommendedFallback || false;
        const ruleGroups = [
            'rules',
            'oas2Rules',
            'oas3_0Rules',
            'oas3_1Rules',
            'async2Rules',
            'async3Rules',
            'arazzo1Rules',
            'overlay1Rules'
        ];
        $e8257e0874015219$var$replaceSpecWithStruct(ruleGroups, rawConfig);
        this.rules = {
            [$aSlQf.SpecVersion.OAS2]: {
                ...rawConfig.rules,
                ...rawConfig.oas2Rules
            },
            [$aSlQf.SpecVersion.OAS3_0]: {
                ...rawConfig.rules,
                ...rawConfig.oas3_0Rules
            },
            [$aSlQf.SpecVersion.OAS3_1]: {
                ...rawConfig.rules,
                ...rawConfig.oas3_1Rules
            },
            [$aSlQf.SpecVersion.Async2]: {
                ...rawConfig.rules,
                ...rawConfig.async2Rules
            },
            [$aSlQf.SpecVersion.Async3]: {
                ...rawConfig.rules,
                ...rawConfig.async3Rules
            },
            [$aSlQf.SpecVersion.Arazzo1]: {
                ...rawConfig.rules,
                ...rawConfig.arazzo1Rules
            },
            [$aSlQf.SpecVersion.Overlay1]: {
                ...rawConfig.rules,
                ...rawConfig.overlay1Rules
            }
        };
        this.preprocessors = {
            [$aSlQf.SpecVersion.OAS2]: {
                ...rawConfig.preprocessors,
                ...rawConfig.oas2Preprocessors
            },
            [$aSlQf.SpecVersion.OAS3_0]: {
                ...rawConfig.preprocessors,
                ...rawConfig.oas3_0Preprocessors
            },
            [$aSlQf.SpecVersion.OAS3_1]: {
                ...rawConfig.preprocessors,
                ...rawConfig.oas3_1Preprocessors
            },
            [$aSlQf.SpecVersion.Async2]: {
                ...rawConfig.preprocessors,
                ...rawConfig.async2Preprocessors
            },
            [$aSlQf.SpecVersion.Async3]: {
                ...rawConfig.preprocessors,
                ...rawConfig.async3Preprocessors
            },
            [$aSlQf.SpecVersion.Arazzo1]: {
                ...rawConfig.arazzo1Preprocessors
            },
            [$aSlQf.SpecVersion.Overlay1]: {
                ...rawConfig.preprocessors,
                ...rawConfig.overlay1Preprocessors
            }
        };
        this.decorators = {
            [$aSlQf.SpecVersion.OAS2]: {
                ...rawConfig.decorators,
                ...rawConfig.oas2Decorators
            },
            [$aSlQf.SpecVersion.OAS3_0]: {
                ...rawConfig.decorators,
                ...rawConfig.oas3_0Decorators
            },
            [$aSlQf.SpecVersion.OAS3_1]: {
                ...rawConfig.decorators,
                ...rawConfig.oas3_1Decorators
            },
            [$aSlQf.SpecVersion.Async2]: {
                ...rawConfig.decorators,
                ...rawConfig.async2Decorators
            },
            [$aSlQf.SpecVersion.Async3]: {
                ...rawConfig.decorators,
                ...rawConfig.async3Decorators
            },
            [$aSlQf.SpecVersion.Arazzo1]: {
                ...rawConfig.arazzo1Decorators
            },
            [$aSlQf.SpecVersion.Overlay1]: {
                ...rawConfig.decorators,
                ...rawConfig.overlay1Decorators
            }
        };
        this.extendPaths = rawConfig.extendPaths || [];
        this.pluginPaths = rawConfig.pluginPaths || [];
        this.resolveIgnore($e8257e0874015219$var$getIgnoreFilePath(configFile));
    }
    resolveIgnore(ignoreFile) {
        if (!ignoreFile || !(0, $eONiY.doesYamlFileExist)(ignoreFile)) return;
        this.ignore = (0, $64y7M.parseYaml)($kjyEk.readFileSync(ignoreFile, 'utf-8')) || {};
        $e8257e0874015219$var$replaceSpecWithStruct(Object.keys(this.ignore), this.ignore);
        // resolve ignore paths
        for (const fileName of Object.keys(this.ignore)){
            this.ignore[(0, $3EQkN.isAbsoluteUrl)(fileName) ? fileName : $59kwG.resolve($59kwG.dirname(ignoreFile), fileName)] = this.ignore[fileName];
            for (const ruleId of Object.keys(this.ignore[fileName]))this.ignore[fileName][ruleId] = new Set(this.ignore[fileName][ruleId]);
            if (!(0, $3EQkN.isAbsoluteUrl)(fileName)) delete this.ignore[fileName];
        }
    }
    saveIgnore() {
        const dir = this.configFile ? $59kwG.dirname(this.configFile) : $hPtJY.cwd();
        const ignoreFile = $59kwG.join(dir, module.exports.IGNORE_FILE);
        const mapped = {};
        for (const absFileName of Object.keys(this.ignore)){
            const mappedDefinitionName = (0, $3EQkN.isAbsoluteUrl)(absFileName) ? absFileName : (0, $eONiY.slash)($59kwG.relative(dir, absFileName));
            const ignoredRules = mapped[mappedDefinitionName] = this.ignore[absFileName];
            for (const ruleId of Object.keys(ignoredRules))ignoredRules[ruleId] = Array.from(ignoredRules[ruleId]);
        }
        $kjyEk.writeFileSync(ignoreFile, $e8257e0874015219$var$IGNORE_BANNER + (0, $64y7M.stringifyYaml)(mapped));
    }
    addIgnore(problem) {
        const ignore = this.ignore;
        const loc = problem.location[0];
        if (loc.pointer === undefined) return;
        const fileIgnore = ignore[loc.source.absoluteRef] = ignore[loc.source.absoluteRef] || {};
        const ruleIgnore = fileIgnore[problem.ruleId] = fileIgnore[problem.ruleId] || new Set();
        ruleIgnore.add(loc.pointer);
    }
    addProblemToIgnore(problem) {
        const loc = problem.location[0];
        if (loc.pointer === undefined) return problem;
        const fileIgnore = this.ignore[loc.source.absoluteRef] || {};
        const ruleIgnore = fileIgnore[problem.ruleId];
        const ignored = ruleIgnore && ruleIgnore.has(loc.pointer);
        return ignored ? {
            ...problem,
            ignored: ignored
        } : problem;
    }
    extendTypes(types, version) {
        let extendedTypes = types;
        for (const plugin of this.plugins)if (plugin.typeExtension !== undefined) switch(version){
            case $aSlQf.SpecVersion.OAS3_0:
            case $aSlQf.SpecVersion.OAS3_1:
                if (!plugin.typeExtension.oas3) continue;
                extendedTypes = plugin.typeExtension.oas3(extendedTypes, version);
                break;
            case $aSlQf.SpecVersion.OAS2:
                if (!plugin.typeExtension.oas2) continue;
                extendedTypes = plugin.typeExtension.oas2(extendedTypes, version);
                break;
            case $aSlQf.SpecVersion.Async2:
                if (!plugin.typeExtension.async2) continue;
                extendedTypes = plugin.typeExtension.async2(extendedTypes, version);
                break;
            case $aSlQf.SpecVersion.Async3:
                if (!plugin.typeExtension.async3) continue;
                extendedTypes = plugin.typeExtension.async3(extendedTypes, version);
                break;
            case $aSlQf.SpecVersion.Arazzo1:
                if (!plugin.typeExtension.arazzo1) continue;
                extendedTypes = plugin.typeExtension.arazzo1(extendedTypes, version);
                break;
            case $aSlQf.SpecVersion.Overlay1:
                if (!plugin.typeExtension.overlay1) continue;
                extendedTypes = plugin.typeExtension.overlay1(extendedTypes, version);
                break;
            default:
                throw new Error('Not implemented');
        }
        return extendedTypes;
    }
    getRuleSettings(ruleId, oasVersion) {
        this._usedRules.add(ruleId);
        this._usedVersions.add(oasVersion);
        const settings = this.rules[oasVersion][ruleId] || 'off';
        if (typeof settings === 'string') return {
            severity: settings
        };
        else return {
            severity: 'error',
            ...settings
        };
    }
    getPreprocessorSettings(ruleId, oasVersion) {
        this._usedRules.add(ruleId);
        this._usedVersions.add(oasVersion);
        const settings = this.preprocessors[oasVersion][ruleId] || 'off';
        if (typeof settings === 'string') return {
            severity: settings === 'on' ? 'error' : settings
        };
        else return {
            severity: 'error',
            ...settings
        };
    }
    getDecoratorSettings(ruleId, oasVersion) {
        this._usedRules.add(ruleId);
        this._usedVersions.add(oasVersion);
        const settings = this.decorators[oasVersion][ruleId] || 'off';
        if (typeof settings === 'string') return {
            severity: settings === 'on' ? 'error' : settings
        };
        else return {
            severity: 'error',
            ...settings
        };
    }
    getUnusedRules() {
        const rules = [];
        const decorators = [];
        const preprocessors = [];
        for (const usedVersion of Array.from(this._usedVersions)){
            rules.push(...Object.keys(this.rules[usedVersion]).filter((name)=>!this._usedRules.has(name)));
            decorators.push(...Object.keys(this.decorators[usedVersion]).filter((name)=>!this._usedRules.has(name)));
            preprocessors.push(...Object.keys(this.preprocessors[usedVersion]).filter((name)=>!this._usedRules.has(name)));
        }
        return {
            rules: rules,
            preprocessors: preprocessors,
            decorators: decorators
        };
    }
    getRulesForSpecVersion(version) {
        switch(version){
            case $aSlQf.SpecMajorVersion.OAS3:
                // eslint-disable-next-line no-case-declarations
                const oas3Rules = [];
                this.plugins.forEach((p)=>p.preprocessors?.oas3 && oas3Rules.push(p.preprocessors.oas3));
                this.plugins.forEach((p)=>p.rules?.oas3 && oas3Rules.push(p.rules.oas3));
                this.plugins.forEach((p)=>p.decorators?.oas3 && oas3Rules.push(p.decorators.oas3));
                return oas3Rules;
            case $aSlQf.SpecMajorVersion.OAS2:
                // eslint-disable-next-line no-case-declarations
                const oas2Rules = [];
                this.plugins.forEach((p)=>p.preprocessors?.oas2 && oas2Rules.push(p.preprocessors.oas2));
                this.plugins.forEach((p)=>p.rules?.oas2 && oas2Rules.push(p.rules.oas2));
                this.plugins.forEach((p)=>p.decorators?.oas2 && oas2Rules.push(p.decorators.oas2));
                return oas2Rules;
            case $aSlQf.SpecMajorVersion.Async2:
                // eslint-disable-next-line no-case-declarations
                const asyncApi2Rules = [];
                this.plugins.forEach((p)=>p.preprocessors?.async2 && asyncApi2Rules.push(p.preprocessors.async2));
                this.plugins.forEach((p)=>p.rules?.async2 && asyncApi2Rules.push(p.rules.async2));
                this.plugins.forEach((p)=>p.decorators?.async2 && asyncApi2Rules.push(p.decorators.async2));
                return asyncApi2Rules;
            case $aSlQf.SpecMajorVersion.Async3:
                // eslint-disable-next-line no-case-declarations
                const asyncApi3Rules = [];
                this.plugins.forEach((p)=>p.preprocessors?.async3 && asyncApi3Rules.push(p.preprocessors.async3));
                this.plugins.forEach((p)=>p.rules?.async3 && asyncApi3Rules.push(p.rules.async3));
                this.plugins.forEach((p)=>p.decorators?.async3 && asyncApi3Rules.push(p.decorators.async3));
                return asyncApi3Rules;
            case $aSlQf.SpecMajorVersion.Arazzo1:
                // eslint-disable-next-line no-case-declarations
                const arazzo1Rules = [];
                this.plugins.forEach((p)=>p.preprocessors?.arazzo1 && arazzo1Rules.push(p.preprocessors.arazzo1));
                this.plugins.forEach((p)=>p.rules?.arazzo1 && arazzo1Rules.push(p.rules.arazzo1));
                this.plugins.forEach((p)=>p.decorators?.arazzo1 && arazzo1Rules.push(p.decorators.arazzo1));
                return arazzo1Rules;
            case $aSlQf.SpecMajorVersion.Overlay1:
                // eslint-disable-next-line no-case-declarations
                const overlay1Rules = [];
                this.plugins.forEach((p)=>p.preprocessors?.overlay1 && overlay1Rules.push(p.preprocessors.overlay1));
                this.plugins.forEach((p)=>p.rules?.overlay1 && overlay1Rules.push(p.rules.overlay1));
                this.plugins.forEach((p)=>p.decorators?.overlay1 && overlay1Rules.push(p.decorators.overlay1));
                return overlay1Rules;
        }
    }
    skipRules(rules) {
        for (const ruleId of rules || [])for (const version of Object.values($aSlQf.SpecVersion)){
            if (this.rules[version][ruleId]) this.rules[version][ruleId] = 'off';
            else if (Array.isArray(this.rules[version].assertions)) {
                // skip assertions
                for (const configurableRule of this.rules[version].assertions)if (configurableRule.assertionId === ruleId) configurableRule.severity = 'off';
            }
        }
    }
    skipPreprocessors(preprocessors) {
        for (const preprocessorId of preprocessors || []){
            for (const version of Object.values($aSlQf.SpecVersion))if (this.preprocessors[version][preprocessorId]) this.preprocessors[version][preprocessorId] = 'off';
        }
    }
    skipDecorators(decorators) {
        for (const decoratorId of decorators || []){
            for (const version of Object.values($aSlQf.SpecVersion))if (this.decorators[version][decoratorId]) this.decorators[version][decoratorId] = 'off';
        }
    }
}
module.exports.StyleguideConfig = $e8257e0874015219$var$StyleguideConfig;
// To support backwards compatibility with the old `spec` key we rename it to `struct`.
function $e8257e0874015219$var$replaceSpecWithStruct(ruleGroups, config) {
    for (const ruleGroup of ruleGroups)if (config[ruleGroup] && (0, $eONiY.isPlainObject)(config[ruleGroup]) && 'spec' in config[ruleGroup]) {
        (0, $eONiY.showWarningForDeprecatedField)('spec', 'struct');
        config[ruleGroup].struct = config[ruleGroup].spec;
        delete config[ruleGroup].spec;
    }
}
class $e8257e0874015219$var$Config {
    constructor(rawConfig, configFile){
        this.rawConfig = rawConfig;
        this.configFile = configFile;
        this.apis = rawConfig.apis || {};
        this.styleguide = new $e8257e0874015219$var$StyleguideConfig(rawConfig.styleguide || {}, configFile);
        this.theme = rawConfig.theme || {};
        this.resolve = (0, $j0sZx.getResolveConfig)(rawConfig?.resolve);
        this.region = rawConfig.region;
        this.organization = rawConfig.organization;
        this.files = rawConfig.files || [];
        this.telemetry = rawConfig.telemetry;
    }
}
module.exports.Config = $e8257e0874015219$var$Config;

});
parcelRegister("j0sZx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigValidationError = void 0;
module.exports.parsePresetName = $dd648182abfd7c50$var$parsePresetName;
module.exports.transformApiDefinitionsToApis = $dd648182abfd7c50$var$transformApiDefinitionsToApis;
module.exports.prefixRules = $dd648182abfd7c50$var$prefixRules;
module.exports.mergeExtends = $dd648182abfd7c50$var$mergeExtends;
module.exports.getMergedConfig = $dd648182abfd7c50$var$getMergedConfig;
module.exports.checkForDeprecatedFields = $dd648182abfd7c50$var$checkForDeprecatedFields;
module.exports.transformConfig = $dd648182abfd7c50$var$transformConfig;
module.exports.getResolveConfig = $dd648182abfd7c50$var$getResolveConfig;
module.exports.getUniquePlugins = $dd648182abfd7c50$var$getUniquePlugins;
module.exports.deepCloneMapWithJSON = $dd648182abfd7c50$var$deepCloneMapWithJSON;
module.exports.isDeprecatedPluginFormat = $dd648182abfd7c50$var$isDeprecatedPluginFormat;
module.exports.isCommonJsPlugin = $dd648182abfd7c50$var$isCommonJsPlugin;

var $eONiY = parcelRequire("eONiY");

var $jVI1J = parcelRequire("jVI1J");

var $lX2nX = parcelRequire("lX2nX");
function $dd648182abfd7c50$var$parsePresetName(presetName) {
    if (presetName.indexOf('/') > -1) {
        const [pluginId, configName] = presetName.split('/');
        return {
            pluginId: pluginId,
            configName: configName
        };
    } else return {
        pluginId: '',
        configName: presetName
    };
}
function $dd648182abfd7c50$var$transformApiDefinitionsToApis(apiDefinitions) {
    if (!apiDefinitions) return undefined;
    const apis = {};
    for (const [apiName, apiPath] of Object.entries(apiDefinitions))apis[apiName] = {
        root: apiPath
    };
    return apis;
}
function $dd648182abfd7c50$var$extractFlatConfig({ plugins: plugins, extends: _extends, rules: rules, oas2Rules: oas2Rules, oas3_0Rules: oas3_0Rules, oas3_1Rules: oas3_1Rules, async2Rules: async2Rules, async3Rules: async3Rules, arazzo1Rules: arazzo1Rules, overlay1Rules: overlay1Rules, preprocessors: preprocessors, oas2Preprocessors: oas2Preprocessors, oas3_0Preprocessors: oas3_0Preprocessors, oas3_1Preprocessors: oas3_1Preprocessors, async2Preprocessors: async2Preprocessors, async3Preprocessors: async3Preprocessors, arazzo1Preprocessors: arazzo1Preprocessors, overlay1Preprocessors: overlay1Preprocessors, decorators: decorators, oas2Decorators: oas2Decorators, oas3_0Decorators: oas3_0Decorators, oas3_1Decorators: oas3_1Decorators, async2Decorators: async2Decorators, async3Decorators: async3Decorators, arazzo1Decorators: arazzo1Decorators, overlay1Decorators: overlay1Decorators, ...rawConfigRest }) {
    const styleguideConfig = {
        plugins: plugins,
        extends: _extends,
        rules: rules,
        oas2Rules: oas2Rules,
        oas3_0Rules: oas3_0Rules,
        oas3_1Rules: oas3_1Rules,
        async2Rules: async2Rules,
        async3Rules: async3Rules,
        arazzo1Rules: arazzo1Rules,
        overlay1Rules: overlay1Rules,
        preprocessors: preprocessors,
        oas2Preprocessors: oas2Preprocessors,
        oas3_0Preprocessors: oas3_0Preprocessors,
        oas3_1Preprocessors: oas3_1Preprocessors,
        async2Preprocessors: async2Preprocessors,
        async3Preprocessors: async3Preprocessors,
        arazzo1Preprocessors: arazzo1Preprocessors,
        overlay1Preprocessors: overlay1Preprocessors,
        decorators: decorators,
        oas2Decorators: oas2Decorators,
        oas3_0Decorators: oas3_0Decorators,
        oas3_1Decorators: oas3_1Decorators,
        async2Decorators: async2Decorators,
        async3Decorators: async3Decorators,
        arazzo1Decorators: arazzo1Decorators,
        overlay1Decorators: overlay1Decorators,
        doNotResolveExamples: rawConfigRest.resolve?.doNotResolveExamples
    };
    if (rawConfigRest.lint && rawConfigRest.styleguide || Object.values(styleguideConfig).some($eONiY.isDefined) && (rawConfigRest.lint || rawConfigRest.styleguide)) throw new Error(`Do not use 'lint', 'styleguide' and flat syntax together. \nSee more about the configuration in the docs: https://redocly.com/docs/cli/configuration/ \n`);
    return {
        styleguideConfig: Object.values(styleguideConfig).some($eONiY.isDefined) ? styleguideConfig : undefined,
        rawConfigRest: rawConfigRest
    };
}
function $dd648182abfd7c50$var$transformApis(legacyApis) {
    if (!legacyApis) return undefined;
    const apis = {};
    for (const [apiName, { lint: lint, ...apiContent }] of Object.entries(legacyApis)){
        const { styleguideConfig: styleguideConfig, rawConfigRest: rawConfigRest } = $dd648182abfd7c50$var$extractFlatConfig(apiContent);
        apis[apiName] = {
            styleguide: styleguideConfig || lint,
            ...rawConfigRest
        };
    }
    return apis;
}
function $dd648182abfd7c50$var$prefixRules(rules, prefix) {
    if (!prefix) return rules;
    const res = {};
    for (const name of Object.keys(rules))res[`${prefix}/${name}`] = rules[name];
    return res;
}
function $dd648182abfd7c50$var$mergeExtends(rulesConfList) {
    const result = {
        rules: {},
        oas2Rules: {},
        oas3_0Rules: {},
        oas3_1Rules: {},
        async2Rules: {},
        async3Rules: {},
        arazzo1Rules: {},
        overlay1Rules: {},
        preprocessors: {},
        oas2Preprocessors: {},
        oas3_0Preprocessors: {},
        oas3_1Preprocessors: {},
        async2Preprocessors: {},
        async3Preprocessors: {},
        arazzo1Preprocessors: {},
        overlay1Preprocessors: {},
        decorators: {},
        oas2Decorators: {},
        oas3_0Decorators: {},
        oas3_1Decorators: {},
        async2Decorators: {},
        async3Decorators: {},
        arazzo1Decorators: {},
        overlay1Decorators: {},
        plugins: [],
        pluginPaths: [],
        extendPaths: []
    };
    for (const rulesConf of rulesConfList){
        if (rulesConf.extends) throw new Error(`'extends' is not supported in shared configs yet:\n${JSON.stringify(rulesConf, null, 2)}`);
        (0, $eONiY.assignConfig)(result.rules, rulesConf.rules);
        (0, $eONiY.assignConfig)(result.oas2Rules, rulesConf.oas2Rules);
        (0, $eONiY.assignOnlyExistingConfig)(result.oas2Rules, rulesConf.rules);
        (0, $eONiY.assignConfig)(result.oas3_0Rules, rulesConf.oas3_0Rules);
        (0, $eONiY.assignOnlyExistingConfig)(result.oas3_0Rules, rulesConf.rules);
        (0, $eONiY.assignConfig)(result.oas3_1Rules, rulesConf.oas3_1Rules);
        (0, $eONiY.assignOnlyExistingConfig)(result.oas3_1Rules, rulesConf.rules);
        (0, $eONiY.assignConfig)(result.async2Rules, rulesConf.async2Rules);
        (0, $eONiY.assignOnlyExistingConfig)(result.async2Rules, rulesConf.rules);
        (0, $eONiY.assignConfig)(result.async3Rules, rulesConf.async3Rules);
        (0, $eONiY.assignOnlyExistingConfig)(result.async3Rules, rulesConf.rules);
        (0, $eONiY.assignConfig)(result.arazzo1Rules, rulesConf.arazzo1Rules);
        (0, $eONiY.assignOnlyExistingConfig)(result.arazzo1Rules, rulesConf.rules);
        (0, $eONiY.assignConfig)(result.overlay1Rules, rulesConf.overlay1Rules);
        (0, $eONiY.assignOnlyExistingConfig)(result.overlay1Rules, rulesConf.rules);
        (0, $eONiY.assignConfig)(result.preprocessors, rulesConf.preprocessors);
        (0, $eONiY.assignConfig)(result.oas2Preprocessors, rulesConf.oas2Preprocessors);
        (0, $eONiY.assignOnlyExistingConfig)(result.oas2Preprocessors, rulesConf.preprocessors);
        (0, $eONiY.assignConfig)(result.oas3_0Preprocessors, rulesConf.oas3_0Preprocessors);
        (0, $eONiY.assignOnlyExistingConfig)(result.oas3_0Preprocessors, rulesConf.preprocessors);
        (0, $eONiY.assignConfig)(result.oas3_1Preprocessors, rulesConf.oas3_1Preprocessors);
        (0, $eONiY.assignOnlyExistingConfig)(result.oas3_1Preprocessors, rulesConf.preprocessors);
        (0, $eONiY.assignConfig)(result.async2Preprocessors, rulesConf.async2Preprocessors);
        (0, $eONiY.assignOnlyExistingConfig)(result.async2Preprocessors, rulesConf.preprocessors);
        (0, $eONiY.assignConfig)(result.async3Preprocessors, rulesConf.async3Preprocessors);
        (0, $eONiY.assignOnlyExistingConfig)(result.async3Preprocessors, rulesConf.preprocessors);
        (0, $eONiY.assignConfig)(result.arazzo1Preprocessors, rulesConf.arazzo1Preprocessors);
        (0, $eONiY.assignOnlyExistingConfig)(result.arazzo1Preprocessors, rulesConf.preprocessors);
        (0, $eONiY.assignConfig)(result.overlay1Preprocessors, rulesConf.overlay1Preprocessors);
        (0, $eONiY.assignOnlyExistingConfig)(result.overlay1Preprocessors, rulesConf.preprocessors);
        (0, $eONiY.assignConfig)(result.decorators, rulesConf.decorators);
        (0, $eONiY.assignConfig)(result.oas2Decorators, rulesConf.oas2Decorators);
        (0, $eONiY.assignOnlyExistingConfig)(result.oas2Decorators, rulesConf.decorators);
        (0, $eONiY.assignConfig)(result.oas3_0Decorators, rulesConf.oas3_0Decorators);
        (0, $eONiY.assignOnlyExistingConfig)(result.oas3_0Decorators, rulesConf.decorators);
        (0, $eONiY.assignConfig)(result.oas3_1Decorators, rulesConf.oas3_1Decorators);
        (0, $eONiY.assignOnlyExistingConfig)(result.oas3_1Decorators, rulesConf.decorators);
        (0, $eONiY.assignConfig)(result.async2Decorators, rulesConf.async2Decorators);
        (0, $eONiY.assignOnlyExistingConfig)(result.async2Decorators, rulesConf.decorators);
        (0, $eONiY.assignConfig)(result.async3Decorators, rulesConf.async3Decorators);
        (0, $eONiY.assignOnlyExistingConfig)(result.async3Decorators, rulesConf.decorators);
        (0, $eONiY.assignConfig)(result.arazzo1Decorators, rulesConf.arazzo1Decorators);
        (0, $eONiY.assignOnlyExistingConfig)(result.arazzo1Decorators, rulesConf.decorators);
        (0, $eONiY.assignConfig)(result.overlay1Decorators, rulesConf.overlay1Decorators);
        (0, $eONiY.assignOnlyExistingConfig)(result.overlay1Decorators, rulesConf.decorators);
        result.plugins.push(...rulesConf.plugins || []);
        result.pluginPaths.push(...rulesConf.pluginPaths || []);
        result.extendPaths.push(...new Set(rulesConf.extendPaths));
    }
    return result;
}
function $dd648182abfd7c50$var$getMergedConfig(config, apiName) {
    const extendPaths = [
        ...Object.values(config.apis).map((api)=>api?.styleguide?.extendPaths),
        config.rawConfig?.styleguide?.extendPaths
    ].flat().filter($eONiY.isTruthy);
    const pluginPaths = [
        ...Object.values(config.apis).map((api)=>api?.styleguide?.pluginPaths),
        config.rawConfig?.styleguide?.pluginPaths
    ].flat().filter($eONiY.isTruthy);
    return apiName ? new $jVI1J.Config({
        ...config.rawConfig,
        styleguide: {
            ...config.apis[apiName] ? config.apis[apiName].styleguide : config.rawConfig.styleguide,
            extendPaths: extendPaths,
            pluginPaths: pluginPaths
        },
        theme: {
            ...config.rawConfig.theme,
            ...config.apis[apiName]?.theme
        },
        files: [
            ...config.files,
            ...config.apis?.[apiName]?.files ?? []
        ]
    }, config.configFile) : config;
}
function $dd648182abfd7c50$var$checkForDeprecatedFields(deprecatedField, updatedField, rawConfig, updatedObject, link) {
    const isDeprecatedFieldInApis = rawConfig.apis && Object.values(rawConfig.apis).some((api)=>api[deprecatedField]);
    if (rawConfig[deprecatedField] && updatedField === null) (0, $eONiY.showWarningForDeprecatedField)(deprecatedField, undefined, updatedObject, link);
    if (rawConfig[deprecatedField] && updatedField && rawConfig[updatedField]) (0, $eONiY.showErrorForDeprecatedField)(deprecatedField, updatedField);
    if (rawConfig[deprecatedField] && updatedObject && rawConfig[updatedObject]) (0, $eONiY.showErrorForDeprecatedField)(deprecatedField, updatedField, updatedObject);
    if (rawConfig[deprecatedField] || isDeprecatedFieldInApis) (0, $eONiY.showWarningForDeprecatedField)(deprecatedField, updatedField, updatedObject, link);
}
function $dd648182abfd7c50$var$transformConfig(rawConfig) {
    const migratedFields = [
        [
            'apiDefinitions',
            'apis',
            undefined,
            undefined
        ],
        [
            'referenceDocs',
            'openapi',
            'theme',
            undefined
        ],
        [
            'lint',
            undefined,
            undefined,
            'https://redocly.com/docs/api-registry/guides/migration-guide-config-file/#changed-properties'
        ],
        [
            'styleguide',
            undefined,
            undefined,
            'https://redocly.com/docs/api-registry/guides/migration-guide-config-file/#changed-properties'
        ],
        [
            'features.openapi',
            'openapi',
            'theme',
            undefined
        ]
    ];
    for (const [deprecatedField, updatedField, updatedObject, link] of migratedFields)$dd648182abfd7c50$var$checkForDeprecatedFields(deprecatedField, updatedField, rawConfig, updatedObject, link);
    const { apis: apis, apiDefinitions: apiDefinitions, referenceDocs: referenceDocs, lint: lint, ...rest } = rawConfig;
    const { styleguideConfig: styleguideConfig, rawConfigRest: rawConfigRest } = $dd648182abfd7c50$var$extractFlatConfig(rest);
    const transformedConfig = {
        theme: {
            openapi: {
                ...referenceDocs,
                ...rawConfig['features.openapi'],
                ...rawConfig.theme?.openapi
            },
            mockServer: {
                ...rawConfig['features.mockServer'],
                ...rawConfig.theme?.mockServer
            }
        },
        apis: $dd648182abfd7c50$var$transformApis(apis) || $dd648182abfd7c50$var$transformApiDefinitionsToApis(apiDefinitions),
        styleguide: styleguideConfig || lint,
        ...rawConfigRest
    };
    $dd648182abfd7c50$var$showDeprecationMessages(transformedConfig);
    return transformedConfig;
}
function $dd648182abfd7c50$var$showDeprecationMessages(config) {
    let allRules = {
        ...config.styleguide?.rules
    };
    for (const api of Object.values(config.apis || {}))allRules = {
        ...allRules,
        ...api?.styleguide?.rules
    };
    for (const ruleKey of Object.keys(allRules))if (ruleKey.startsWith('assert/')) $lX2nX.logger.warn(`\nThe 'assert/' syntax in ${ruleKey} is deprecated. Update your configuration to use 'rule/' instead. Examples and more information: https://redocly.com/docs/cli/rules/configurable-rules/\n`);
}
function $dd648182abfd7c50$var$getResolveConfig(resolve) {
    return {
        http: {
            headers: resolve?.http?.headers ?? [],
            customFetch: undefined
        }
    };
}
function $dd648182abfd7c50$var$getUniquePlugins(plugins) {
    const seen = new Set();
    const results = [];
    for (const p of plugins){
        if (!seen.has(p.id)) {
            results.push(p);
            seen.add(p.id);
        } else if (p.id) $lX2nX.logger.warn(`Duplicate plugin id "${$lX2nX.colorize.red(p.id)}".\n`);
    }
    return results;
}
class $dd648182abfd7c50$var$ConfigValidationError extends Error {
}
module.exports.ConfigValidationError = $dd648182abfd7c50$var$ConfigValidationError;
function $dd648182abfd7c50$var$deepCloneMapWithJSON(originalMap) {
    return new Map(JSON.parse(JSON.stringify([
        ...originalMap
    ])));
}
function $dd648182abfd7c50$var$isDeprecatedPluginFormat(plugin) {
    return plugin !== undefined && typeof plugin === 'object' && 'id' in plugin;
}
function $dd648182abfd7c50$var$isCommonJsPlugin(plugin) {
    return typeof plugin === 'function';
}

});


parcelRegister("8oJhk", function(module, exports) {
(function(global, factory) {
    if (typeof define === 'function' && define.amd) define([
        'exports'
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(module.exports, function(exports1) {
    'use strict';
    exports1.__esModule = true;
    var EMPTY = {};
    var HOP = Object.prototype.hasOwnProperty;
    var fns = {
        memoize: function memoize(fn) {
            var opt = arguments.length <= 1 || arguments[1] === undefined ? EMPTY : arguments[1];
            var cache = opt.cache || {};
            return function() {
                for(var _len = arguments.length, a = Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                var k = String(a[0]);
                if (opt.caseSensitive === false) k = k.toLowerCase();
                return HOP.call(cache, k) ? cache[k] : cache[k] = fn.apply(this, a);
            };
        },
        debounce: function debounce(fn, opts) {
            if (typeof opts === 'function') {
                var p = fn;
                fn = opts;
                opts = p;
            }
            var delay = opts && opts.delay || opts || 0, args = undefined, context = undefined, timer = undefined;
            return function() {
                for(var _len2 = arguments.length, a = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)a[_key2] = arguments[_key2];
                args = a;
                context = this;
                if (!timer) timer = setTimeout(function() {
                    fn.apply(context, args);
                    args = context = timer = null;
                }, delay);
            };
        },
        bind: function bind(target, key, _ref) {
            var fn = _ref.value;
            return {
                configurable: true,
                get: function get() {
                    var value = fn.bind(this);
                    Object.defineProperty(this, key, {
                        value: value,
                        configurable: true,
                        writable: true
                    });
                    return value;
                }
            };
        }
    };
    var memoize = multiMethod(fns.memoize), debounce = multiMethod(fns.debounce), bind = multiMethod(function(f, c) {
        return f.bind(c);
    }, function() {
        return fns.bind;
    });
    exports1.memoize = memoize;
    exports1.debounce = debounce;
    exports1.bind = bind;
    exports1['default'] = {
        memoize: memoize,
        debounce: debounce,
        bind: bind
    };
    function multiMethod(inner, deco) {
        deco = deco || inner.decorate || decorator(inner);
        var d = deco();
        return function() {
            for(var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            var l = args.length;
            return (l < 2 ? deco : l > 2 ? d : inner).apply(undefined, args);
        };
    }
    function decorator(fn) {
        return function(opt) {
            return typeof opt === 'function' ? fn(opt) : function(target, key, desc) {
                desc.value = fn(desc.value, opt, target, key, desc);
            };
        };
    }
});

});

parcelRegister("3vRz3", function(module, exports) {
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});

parcelRegister("jAmc6", function(module, exports) {
'use strict';

var $1n2vj = parcelRequire("1n2vj");
module.exports = $e4229868aa96ce1e$var$api;
/**
 * Convenience wrapper around the api.
 * Calls `.get` when called with an `object` and a `pointer`.
 * Calls `.set` when also called with `value`.
 * If only supplied `object`, returns a partially applied function, mapped to the object.
 *
 * @param {Object} obj
 * @param {String|Array} pointer
 * @param value
 * @returns {*}
 */ function $e4229868aa96ce1e$var$api(obj, pointer, value) {
    // .set()
    if (arguments.length === 3) return $e4229868aa96ce1e$var$api.set(obj, pointer, value);
    // .get()
    if (arguments.length === 2) return $e4229868aa96ce1e$var$api.get(obj, pointer);
    // Return a partially applied function on `obj`.
    var wrapped = $e4229868aa96ce1e$var$api.bind($e4229868aa96ce1e$var$api, obj);
    // Support for oo style
    for(var name in $e4229868aa96ce1e$var$api)if ($e4229868aa96ce1e$var$api.hasOwnProperty(name)) wrapped[name] = $e4229868aa96ce1e$var$api[name].bind(wrapped, obj);
    return wrapped;
}
/**
 * Lookup a json pointer in an object
 *
 * @param {Object} obj
 * @param {String|Array} pointer
 * @returns {*}
 */ $e4229868aa96ce1e$var$api.get = function get(obj, pointer) {
    var refTokens = Array.isArray(pointer) ? pointer : $e4229868aa96ce1e$var$api.parse(pointer);
    for(var i = 0; i < refTokens.length; ++i){
        var tok = refTokens[i];
        if (!(typeof obj == 'object' && tok in obj)) throw new Error('Invalid reference token: ' + tok);
        obj = obj[tok];
    }
    return obj;
};
/**
 * Sets a value on an object
 *
 * @param {Object} obj
 * @param {String|Array} pointer
 * @param value
 */ $e4229868aa96ce1e$var$api.set = function set(obj, pointer, value) {
    var refTokens = Array.isArray(pointer) ? pointer : $e4229868aa96ce1e$var$api.parse(pointer), nextTok = refTokens[0];
    if (refTokens.length === 0) throw Error('Can not set the root object');
    for(var i = 0; i < refTokens.length - 1; ++i){
        var tok = refTokens[i];
        if (typeof tok !== 'string' && typeof tok !== 'number') tok = String(tok);
        if (tok === "__proto__" || tok === "constructor" || tok === "prototype") continue;
        if (tok === '-' && Array.isArray(obj)) tok = obj.length;
        nextTok = refTokens[i + 1];
        if (!(tok in obj)) {
            if (nextTok.match(/^(\d+|-)$/)) obj[tok] = [];
            else obj[tok] = {};
        }
        obj = obj[tok];
    }
    if (nextTok === '-' && Array.isArray(obj)) nextTok = obj.length;
    obj[nextTok] = value;
    return this;
};
/**
 * Removes an attribute
 *
 * @param {Object} obj
 * @param {String|Array} pointer
 */ $e4229868aa96ce1e$var$api.remove = function(obj, pointer) {
    var refTokens = Array.isArray(pointer) ? pointer : $e4229868aa96ce1e$var$api.parse(pointer);
    var finalToken = refTokens[refTokens.length - 1];
    if (finalToken === undefined) throw new Error('Invalid JSON pointer for remove: "' + pointer + '"');
    var parent = $e4229868aa96ce1e$var$api.get(obj, refTokens.slice(0, -1));
    if (Array.isArray(parent)) {
        var index = +finalToken;
        if (finalToken === '' && isNaN(index)) throw new Error('Invalid array index: "' + finalToken + '"');
        Array.prototype.splice.call(parent, index, 1);
    } else delete parent[finalToken];
};
/**
 * Returns a (pointer -> value) dictionary for an object
 *
 * @param obj
 * @param {function} descend
 * @returns {}
 */ $e4229868aa96ce1e$var$api.dict = function dict(obj, descend) {
    var results = {};
    $e4229868aa96ce1e$var$api.walk(obj, function(value, pointer) {
        results[pointer] = value;
    }, descend);
    return results;
};
/**
 * Iterates over an object
 * Iterator: function (value, pointer) {}
 *
 * @param obj
 * @param {function} iterator
 * @param {function} descend
 */ $e4229868aa96ce1e$var$api.walk = function walk(obj, iterator, descend) {
    var refTokens = [];
    descend = descend || function(value) {
        var type = Object.prototype.toString.call(value);
        return type === '[object Object]' || type === '[object Array]';
    };
    (function next(cur) {
        $1n2vj(cur, function(value, key) {
            refTokens.push(String(key));
            if (descend(value)) next(value);
            else iterator(value, $e4229868aa96ce1e$var$api.compile(refTokens));
            refTokens.pop();
        });
    })(obj);
};
/**
 * Tests if an object has a value for a json pointer
 *
 * @param obj
 * @param pointer
 * @returns {boolean}
 */ $e4229868aa96ce1e$var$api.has = function has(obj, pointer) {
    try {
        $e4229868aa96ce1e$var$api.get(obj, pointer);
    } catch (e) {
        return false;
    }
    return true;
};
/**
 * Escapes a reference token
 *
 * @param str
 * @returns {string}
 */ $e4229868aa96ce1e$var$api.escape = function escape(str) {
    return str.toString().replace(/~/g, '~0').replace(/\//g, '~1');
};
/**
 * Unescapes a reference token
 *
 * @param str
 * @returns {string}
 */ $e4229868aa96ce1e$var$api.unescape = function unescape(str) {
    return str.replace(/~1/g, '/').replace(/~0/g, '~');
};
/**
 * Converts a json pointer into a array of reference tokens
 *
 * @param pointer
 * @returns {Array}
 */ $e4229868aa96ce1e$var$api.parse = function parse(pointer) {
    if (pointer === '') return [];
    if (pointer.charAt(0) !== '/') throw new Error('Invalid JSON pointer: ' + pointer);
    return pointer.substring(1).split(/\//).map($e4229868aa96ce1e$var$api.unescape);
};
/**
 * Builds a json pointer from a array of reference tokens
 *
 * @param refTokens
 * @returns {string}
 */ $e4229868aa96ce1e$var$api.compile = function compile(refTokens) {
    if (refTokens.length === 0) return '';
    return '/' + refTokens.map($e4229868aa96ce1e$var$api.escape).join('/');
};

});
parcelRegister("1n2vj", function(module, exports) {
var $0ff9e1aaf16a50e1$var$hasOwn = Object.prototype.hasOwnProperty;
var $0ff9e1aaf16a50e1$var$toString = Object.prototype.toString;
module.exports = function forEach(obj, fn, ctx) {
    if ($0ff9e1aaf16a50e1$var$toString.call(fn) !== '[object Function]') throw new TypeError('iterator must be a function');
    var l = obj.length;
    if (l === +l) for(var i = 0; i < l; i++)fn.call(ctx, obj[i], i, obj);
    else {
        for(var k in obj)if ($0ff9e1aaf16a50e1$var$hasOwn.call(obj, k)) fn.call(ctx, obj[k], k, obj);
    }
};

});


parcelRegister("7GGYV", function(module, exports) {
(function(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    /**
   * @constructor
   */ function UrlTemplate() {}
    /**
   * @private
   * @param {string} str
   * @return {string}
   */ UrlTemplate.prototype.encodeReserved = function(str) {
        return str.split(/(%[0-9A-Fa-f]{2})/g).map(function(part) {
            if (!/%[0-9A-Fa-f]/.test(part)) part = encodeURI(part).replace(/%5B/g, '[').replace(/%5D/g, ']');
            return part;
        }).join('');
    };
    /**
   * @private
   * @param {string} str
   * @return {string}
   */ UrlTemplate.prototype.encodeUnreserved = function(str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    };
    /**
   * @private
   * @param {string} operator
   * @param {string} value
   * @param {string} key
   * @return {string}
   */ UrlTemplate.prototype.encodeValue = function(operator, value, key) {
        value = operator === '+' || operator === '#' ? this.encodeReserved(value) : this.encodeUnreserved(value);
        if (key) return this.encodeUnreserved(key) + '=' + value;
        else return value;
    };
    /**
   * @private
   * @param {*} value
   * @return {boolean}
   */ UrlTemplate.prototype.isDefined = function(value) {
        return value !== undefined && value !== null;
    };
    /**
   * @private
   * @param {string}
   * @return {boolean}
   */ UrlTemplate.prototype.isKeyOperator = function(operator) {
        return operator === ';' || operator === '&' || operator === '?';
    };
    /**
   * @private
   * @param {Object} context
   * @param {string} operator
   * @param {string} key
   * @param {string} modifier
   */ UrlTemplate.prototype.getValues = function(context, operator, key, modifier) {
        var value = context[key], result = [];
        if (this.isDefined(value) && value !== '') {
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                value = value.toString();
                if (modifier && modifier !== '*') value = value.substring(0, parseInt(modifier, 10));
                result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
            } else if (modifier === '*') {
                if (Array.isArray(value)) value.filter(this.isDefined).forEach(function(value) {
                    result.push(this.encodeValue(operator, value, this.isKeyOperator(operator) ? key : null));
                }, this);
                else Object.keys(value).forEach(function(k) {
                    if (this.isDefined(value[k])) result.push(this.encodeValue(operator, value[k], k));
                }, this);
            } else {
                var tmp = [];
                if (Array.isArray(value)) value.filter(this.isDefined).forEach(function(value) {
                    tmp.push(this.encodeValue(operator, value));
                }, this);
                else Object.keys(value).forEach(function(k) {
                    if (this.isDefined(value[k])) {
                        tmp.push(this.encodeUnreserved(k));
                        tmp.push(this.encodeValue(operator, value[k].toString()));
                    }
                }, this);
                if (this.isKeyOperator(operator)) result.push(this.encodeUnreserved(key) + '=' + tmp.join(','));
                else if (tmp.length !== 0) result.push(tmp.join(','));
            }
        } else {
            if (operator === ';') {
                if (this.isDefined(value)) result.push(this.encodeUnreserved(key));
            } else if (value === '' && (operator === '&' || operator === '?')) result.push(this.encodeUnreserved(key) + '=');
            else if (value === '') result.push('');
        }
        return result;
    };
    /**
   * @param {string} template
   * @return {function(Object):string}
   */ UrlTemplate.prototype.parse = function(template) {
        var that = this;
        var operators = [
            '+',
            '#',
            '.',
            '/',
            ';',
            '?',
            '&'
        ];
        return {
            expand: function(context) {
                return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function(_, expression, literal) {
                    if (expression) {
                        var operator = null, values = [];
                        if (operators.indexOf(expression.charAt(0)) !== -1) {
                            operator = expression.charAt(0);
                            expression = expression.substr(1);
                        }
                        expression.split(/,/g).forEach(function(variable) {
                            var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                            values.push.apply(values, that.getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        });
                        if (operator && operator !== '+') {
                            var separator = ',';
                            if (operator === '?') separator = '&';
                            else if (operator !== '#') separator = operator;
                            return (values.length !== 0 ? operator : '') + values.join(separator);
                        } else return values.join(',');
                    } else return that.encodeReserved(literal);
                });
            }
        };
    };
    return new UrlTemplate();
});

});

parcelRegister("bqaFX", function(module, exports) {
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var $850a67666df146a0$var$_self = typeof window !== 'undefined' ? window // if in browser
 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $850a67666df146a0$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === 'undefined') return null;
                if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName('script');
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run('before-all-elements-highlight', env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
            }
            _.hooks.run('before-sanity-check', env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
            if (!env.code) {
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener('message', function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute('data-manual')) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($850a67666df146a0$var$_self);
if (module.exports) module.exports = $850a67666df146a0$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== 'undefined') $parcel$global.Prism = $850a67666df146a0$var$Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ $850a67666df146a0$var$Prism.languages.markup = {
    'comment': {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    'prolog': {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    'doctype': {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            'internal-subset': {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            'string': {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            'punctuation': /^<!|>$|[[\]]/,
            'doctype-tag': /^DOCTYPE/i,
            'name': /[^\s<>'"]+/
        }
    },
    'cdata': {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    'tag': {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            'tag': {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    'punctuation': /^<\/?/,
                    'namespace': /^[^\s>\/:]+:/
                }
            },
            'special-attr': [],
            'attr-value': {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    'punctuation': [
                        {
                            pattern: /^=/,
                            alias: 'attr-equals'
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            'punctuation': /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    'namespace': /^[^\s>\/:]+:/
                }
            }
        }
    },
    'entity': [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: 'named-entity'
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$850a67666df146a0$var$Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = $850a67666df146a0$var$Prism.languages.markup['entity'];
$850a67666df146a0$var$Prism.languages.markup['doctype'].inside['internal-subset'].inside = $850a67666df146a0$var$Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
$850a67666df146a0$var$Prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') env.attributes['title'] = env.content.replace(/&amp;/, '&');
});
Object.defineProperty($850a67666df146a0$var$Prism.languages.markup.tag, 'addInlined', {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside['language-' + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $850a67666df146a0$var$Prism.languages[lang]
        };
        includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            'included-cdata': {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside['language-' + lang] = {
            pattern: /[\s\S]+/,
            inside: $850a67666df146a0$var$Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), 'i'),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $850a67666df146a0$var$Prism.languages.insertBefore('markup', 'cdata', def);
    }
});
Object.defineProperty($850a67666df146a0$var$Prism.languages.markup.tag, 'addAttribute', {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        $850a67666df146a0$var$Prism.languages.markup.tag.inside['special-attr'].push({
            pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
            lookbehind: true,
            inside: {
                'attr-name': /^[^\s=]+/,
                'attr-value': {
                    pattern: /=[\s\S]+/,
                    inside: {
                        'value': {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                'language-' + lang
                            ],
                            inside: $850a67666df146a0$var$Prism.languages[lang]
                        },
                        'punctuation': [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$850a67666df146a0$var$Prism.languages.html = $850a67666df146a0$var$Prism.languages.markup;
$850a67666df146a0$var$Prism.languages.mathml = $850a67666df146a0$var$Prism.languages.markup;
$850a67666df146a0$var$Prism.languages.svg = $850a67666df146a0$var$Prism.languages.markup;
$850a67666df146a0$var$Prism.languages.xml = $850a67666df146a0$var$Prism.languages.extend('markup', {});
$850a67666df146a0$var$Prism.languages.ssml = $850a67666df146a0$var$Prism.languages.xml;
$850a67666df146a0$var$Prism.languages.atom = $850a67666df146a0$var$Prism.languages.xml;
$850a67666df146a0$var$Prism.languages.rss = $850a67666df146a0$var$Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        'comment': /\/\*[\s\S]*?\*\//,
        'atrule': {
            pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
            inside: {
                'rule': /^@[\w-]+/,
                'selector-function-argument': {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: 'selector'
                },
                'keyword': {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        'url': {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
            greedy: true,
            inside: {
                'function': /^url/i,
                'punctuation': /^\(|\)$/,
                'string': {
                    pattern: RegExp('^' + string.source + '$'),
                    alias: 'url'
                }
            }
        },
        'selector': {
            pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
            lookbehind: true
        },
        'string': {
            pattern: string,
            greedy: true
        },
        'property': {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        'important': /!important\b/i,
        'function': {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        'punctuation': /[(){};:,]/
    };
    Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined('style', 'css');
        markup.tag.addAttribute('style', 'css');
    }
})($850a67666df146a0$var$Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ $850a67666df146a0$var$Prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ $850a67666df146a0$var$Prism.languages.javascript = $850a67666df146a0$var$Prism.languages.extend('clike', {
    'class-name': [
        $850a67666df146a0$var$Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$850a67666df146a0$var$Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$850a67666df146a0$var$Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: $850a67666df146a0$var$Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $850a67666df146a0$var$Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $850a67666df146a0$var$Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $850a67666df146a0$var$Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $850a67666df146a0$var$Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$850a67666df146a0$var$Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: $850a67666df146a0$var$Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
$850a67666df146a0$var$Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if ($850a67666df146a0$var$Prism.languages.markup) {
    $850a67666df146a0$var$Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $850a67666df146a0$var$Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
$850a67666df146a0$var$Prism.languages.js = $850a67666df146a0$var$Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof $850a67666df146a0$var$Prism === 'undefined' || typeof document === 'undefined') return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
        return "\u2716 Error " + status + ' while fetching file: ' + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        'js': 'javascript',
        'py': 'python',
        'rb': 'ruby',
        'ps1': 'powershell',
        'psm1': 'powershell',
        'sh': 'bash',
        'bat': 'batch',
        'h': 'c',
        'tex': 'latex'
    };
    var STATUS_ATTR = 'data-src-status';
    var STATUS_LOADING = 'loading';
    var STATUS_LOADED = 'loaded';
    var STATUS_FAILED = 'failed';
    var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    $850a67666df146a0$var$Prism.hooks.add('before-highlightall', function(env) {
        env.selector += ', ' + SELECTOR;
    });
    $850a67666df146a0$var$Prism.hooks.add('before-sanity-check', function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ''; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement('CODE'));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute('data-src');
            var language = env.language;
            if (language === 'none') {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    'none'
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            $850a67666df146a0$var$Prism.util.setLanguage(code, language);
            $850a67666df146a0$var$Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = $850a67666df146a0$var$Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute('data-range'));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join('\n');
                    // add data-start for line numbers
                    if (!pre.hasAttribute('data-start')) pre.setAttribute('data-start', String(start + 1));
                }
                // highlight code
                code.textContent = text;
                $850a67666df146a0$var$Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    $850a67666df146a0$var$Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)$850a67666df146a0$var$Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ $850a67666df146a0$var$Prism.fileHighlight = function() {
        if (!logged) {
            console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
            logged = true;
        }
        $850a67666df146a0$var$Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();

});

parcelRegister("6cZMx", function(module, exports) {
(function(Prism1) {
    // $ set | grep '^[A-Z][^[:space:]]*=' | cut -d= -f1 | tr '\n' '|'
    // + LC_ALL, RANDOM, REPLY, SECONDS.
    // + make sure PS1..4 are here as they are not always set,
    // - some useless things.
    var envVars = '\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b';
    var commandAfterHeredoc = {
        pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
        lookbehind: true,
        alias: 'punctuation',
        inside: null // see below
    };
    var insideString = {
        'bash': commandAfterHeredoc,
        'environment': {
            pattern: RegExp('\\$' + envVars),
            alias: 'constant'
        },
        'variable': [
            // [0]: Arithmetic Environment
            {
                pattern: /\$?\(\([\s\S]+?\)\)/,
                greedy: true,
                inside: {
                    // If there is a $ sign at the beginning highlight $(( and )) as variable
                    'variable': [
                        {
                            pattern: /(^\$\(\([\s\S]+)\)\)/,
                            lookbehind: true
                        },
                        /^\$\(\(/
                    ],
                    'number': /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
                    // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
                    'operator': /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
                    // If there is no $ sign at the beginning highlight (( and )) as punctuation
                    'punctuation': /\(\(?|\)\)?|,|;/
                }
            },
            // [1]: Command Substitution
            {
                pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
                greedy: true,
                inside: {
                    'variable': /^\$\(|^`|\)$|`$/
                }
            },
            // [2]: Brace expansion
            {
                pattern: /\$\{[^}]+\}/,
                greedy: true,
                inside: {
                    'operator': /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
                    'punctuation': /[\[\]]/,
                    'environment': {
                        pattern: RegExp('(\\{)' + envVars),
                        lookbehind: true,
                        alias: 'constant'
                    }
                }
            },
            /\$(?:\w+|[#?*!@$])/
        ],
        // Escape sequences from echo and printf's manuals, and escaped quotes.
        'entity': /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
    };
    Prism1.languages.bash = {
        'shebang': {
            pattern: /^#!\s*\/.*/,
            alias: 'important'
        },
        'comment': {
            pattern: /(^|[^"{\\$])#.*/,
            lookbehind: true
        },
        'function-name': [
            // a) function foo {
            // b) foo() {
            // c) function foo() {
            // but not “foo {”
            {
                // a) and c)
                pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
                lookbehind: true,
                alias: 'function'
            },
            {
                // b)
                pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
                alias: 'function'
            }
        ],
        // Highlight variable names as variables in for and select beginnings.
        'for-or-select': {
            pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
            alias: 'variable',
            lookbehind: true
        },
        // Highlight variable names as variables in the left-hand part
        // of assignments (“=” and “+=”).
        'assign-left': {
            pattern: /(^|[\s;|&]|[<>]\()\w+(?:\.\w+)*(?=\+?=)/,
            inside: {
                'environment': {
                    pattern: RegExp('(^|[\\s;|&]|[<>]\\()' + envVars),
                    lookbehind: true,
                    alias: 'constant'
                }
            },
            alias: 'variable',
            lookbehind: true
        },
        // Highlight parameter names as variables
        'parameter': {
            pattern: /(^|\s)-{1,2}(?:\w+:[+-]?)?\w+(?:\.\w+)*(?=[=\s]|$)/,
            alias: 'variable',
            lookbehind: true
        },
        'string': [
            // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
            {
                pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
                lookbehind: true,
                greedy: true,
                inside: insideString
            },
            // Here-document with quotes around the tag
            // → No expansion (so no “inside”).
            {
                pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
                lookbehind: true,
                greedy: true,
                inside: {
                    'bash': commandAfterHeredoc
                }
            },
            // “Normal” string
            {
                // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
                pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
                lookbehind: true,
                greedy: true,
                inside: insideString
            },
            {
                // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
                pattern: /(^|[^$\\])'[^']*'/,
                lookbehind: true,
                greedy: true
            },
            {
                // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
                pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
                greedy: true,
                inside: {
                    'entity': insideString.entity
                }
            }
        ],
        'environment': {
            pattern: RegExp('\\$?' + envVars),
            alias: 'constant'
        },
        'variable': insideString.variable,
        'function': {
            pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cargo|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|java|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|sysctl|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
            lookbehind: true
        },
        'keyword': {
            pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
            lookbehind: true
        },
        // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
        'builtin': {
            pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
            lookbehind: true,
            // Alias added to make those easier to distinguish from strings.
            alias: 'class-name'
        },
        'boolean': {
            pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
            lookbehind: true
        },
        'file-descriptor': {
            pattern: /\B&\d\b/,
            alias: 'important'
        },
        'operator': {
            // Lots of redirections here, but not just that.
            pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
            inside: {
                'file-descriptor': {
                    pattern: /^\d/,
                    alias: 'important'
                }
            }
        },
        'punctuation': /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
        'number': {
            pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
            lookbehind: true
        }
    };
    commandAfterHeredoc.inside = Prism1.languages.bash;
    /* Patterns in command substitution. */ var toBeCopied = [
        'comment',
        'function-name',
        'for-or-select',
        'assign-left',
        'parameter',
        'string',
        'environment',
        'function',
        'keyword',
        'builtin',
        'boolean',
        'file-descriptor',
        'operator',
        'punctuation',
        'number'
    ];
    var inside = insideString.variable[1].inside;
    for(var i = 0; i < toBeCopied.length; i++)inside[toBeCopied[i]] = Prism1.languages.bash[toBeCopied[i]];
    Prism1.languages.sh = Prism1.languages.bash;
    Prism1.languages.shell = Prism1.languages.bash;
})(Prism);

});

parcelRegister("a2hnG", function(module, exports) {
Prism.languages.c = Prism.languages.extend('clike', {
    'comment': {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    'string': {
        // https://en.cppreference.com/w/c/language/string_literal
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: true
    },
    'keyword': /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    'function': /\b[a-z_]\w*(?=\s*\()/i,
    'number': /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    'operator': />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
});
Prism.languages.insertBefore('c', 'string', {
    'char': {
        // https://en.cppreference.com/w/c/language/character_constant
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: true
    }
});
Prism.languages.insertBefore('c', 'string', {
    'macro': {
        // allow for multiline macro definitions
        // spaces after the # character compile fine with gcc
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: true,
        greedy: true,
        alias: 'property',
        inside: {
            'string': [
                {
                    // highlight the path of the include statement as a string
                    pattern: /^(#\s*include\s*)<[^>]+>/,
                    lookbehind: true
                },
                Prism.languages.c['string']
            ],
            'char': Prism.languages.c['char'],
            'comment': Prism.languages.c['comment'],
            'macro-name': [
                {
                    pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                    lookbehind: true
                },
                {
                    pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                    lookbehind: true,
                    alias: 'function'
                }
            ],
            // highlight macro directives as keywords
            'directive': {
                pattern: /^(#\s*)[a-z]+/,
                lookbehind: true,
                alias: 'keyword'
            },
            'directive-hash': /^#/,
            'punctuation': /##|\\(?=[\r\n])/,
            'expression': {
                pattern: /\S[\s\S]*/,
                inside: Prism.languages.c
            }
        }
    }
});
Prism.languages.insertBefore('c', 'function', {
    // highlight predefined macros as constants
    'constant': /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
});
delete Prism.languages.c['boolean'];

});

parcelRegister("dXjg4", function(module, exports) {
Prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};

});

parcelRegister("2fy1s", function(module, exports) {
(function(Prism1) {
    // Ignore comments starting with { to privilege string interpolation highlighting
    var comment = /#(?!\{).+/;
    var interpolation = {
        pattern: /#\{[^}]+\}/,
        alias: 'variable'
    };
    Prism1.languages.coffeescript = Prism1.languages.extend('javascript', {
        'comment': comment,
        'string': [
            // Strings are multiline
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                greedy: true
            },
            {
                // Strings are multiline
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                greedy: true,
                inside: {
                    'interpolation': interpolation
                }
            }
        ],
        'keyword': /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        'class-member': {
            pattern: /@(?!\d)\w+/,
            alias: 'variable'
        }
    });
    Prism1.languages.insertBefore('coffeescript', 'comment', {
        'multiline-comment': {
            pattern: /###[\s\S]+?###/,
            alias: 'comment'
        },
        // Block regexp can contain comments and interpolation
        'block-regex': {
            pattern: /\/{3}[\s\S]*?\/{3}/,
            alias: 'regex',
            inside: {
                'comment': comment,
                'interpolation': interpolation
            }
        }
    });
    Prism1.languages.insertBefore('coffeescript', 'string', {
        'inline-javascript': {
            pattern: /`(?:\\[\s\S]|[^\\`])*`/,
            inside: {
                'delimiter': {
                    pattern: /^`|`$/,
                    alias: 'punctuation'
                },
                'script': {
                    pattern: /[\s\S]+/,
                    alias: 'language-javascript',
                    inside: Prism1.languages.javascript
                }
            }
        },
        // Block strings
        'multiline-string': [
            {
                pattern: /'''[\s\S]*?'''/,
                greedy: true,
                alias: 'string'
            },
            {
                pattern: /"""[\s\S]*?"""/,
                greedy: true,
                alias: 'string',
                inside: {
                    interpolation: interpolation
                }
            }
        ]
    });
    Prism1.languages.insertBefore('coffeescript', 'keyword', {
        // Object property
        'property': /(?!\d)\w+(?=\s*:(?!:))/
    });
    delete Prism1.languages.coffeescript['template-string'];
    Prism1.languages.coffee = Prism1.languages.coffeescript;
})(Prism);

});

parcelRegister("knNrc", function(module, exports) {
(function(Prism1) {
    var keyword = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/;
    var modName = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
        return keyword.source;
    });
    Prism1.languages.cpp = Prism1.languages.extend('c', {
        'class-name': [
            {
                pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                    return keyword.source;
                })),
                lookbehind: true
            },
            // This is intended to capture the class name of method implementations like:
            //   void foo::bar() const {}
            // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
            // it starts with an uppercase letter. This approximation should give decent results.
            /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
            // This will capture the class name before destructors like:
            //   Foo::~Foo() {}
            /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
            // This also intends to capture the class name of method implementations but here the class has template
            // parameters, so it can't be a namespace (until C++ adds generic namespaces).
            /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        'keyword': keyword,
        'number': {
            pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
            greedy: true
        },
        'operator': />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        'boolean': /\b(?:false|true)\b/
    });
    Prism1.languages.insertBefore('cpp', 'string', {
        'module': {
            // https://en.cppreference.com/w/cpp/language/modules
            pattern: RegExp(/(\b(?:import|module)\s+)/.source + '(?:' + // header-name
            /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + '|' + // module name or partition or both
            /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                return modName;
            }) + ')'),
            lookbehind: true,
            greedy: true,
            inside: {
                'string': /^[<"][\s\S]+/,
                'operator': /:/,
                'punctuation': /\./
            }
        },
        'raw-string': {
            pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
            alias: 'string',
            greedy: true
        }
    });
    Prism1.languages.insertBefore('cpp', 'keyword', {
        'generic-function': {
            pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
            inside: {
                'function': /^\w+/,
                'generic': {
                    pattern: /<[\s\S]+/,
                    alias: 'class-name',
                    inside: Prism1.languages.cpp
                }
            }
        }
    });
    Prism1.languages.insertBefore('cpp', 'operator', {
        'double-colon': {
            pattern: /::/,
            alias: 'punctuation'
        }
    });
    Prism1.languages.insertBefore('cpp', 'class-name', {
        // the base clause is an optional list of parent classes
        // https://en.cppreference.com/w/cpp/language/class
        'base-clause': {
            pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
            lookbehind: true,
            greedy: true,
            inside: Prism1.languages.extend('cpp', {})
        }
    });
    Prism1.languages.insertBefore('inside', 'double-colon', {
        // All untokenized words that are not namespaces should be class names
        'class-name': /\b[a-z_]\w*\b(?!\s*::)/i
    }, Prism1.languages.cpp['base-clause']);
})(Prism);

});

parcelRegister("yEjrf", function(module, exports) {
(function(Prism1) {
    /**
	 * Replaces all placeholders "<<n>>" of given pattern with the n-th replacement (zero based).
	 *
	 * Note: This is a simple text based replacement. Be careful when using backreferences!
	 *
	 * @param {string} pattern the given pattern.
	 * @param {string[]} replacements a list of replacement which can be inserted into the given pattern.
	 * @returns {string} the pattern with all placeholders replaced with their corresponding replacements.
	 * @example replace(/a<<0>>a/.source, [/b+/.source]) === /a(?:b+)a/.source
	 */ function replace(pattern, replacements) {
        return pattern.replace(/<<(\d+)>>/g, function(m, index) {
            return '(?:' + replacements[+index] + ')';
        });
    }
    /**
	 * @param {string} pattern
	 * @param {string[]} replacements
	 * @param {string} [flags]
	 * @returns {RegExp}
	 */ function re(pattern, replacements, flags) {
        return RegExp(replace(pattern, replacements), flags || '');
    }
    /**
	 * Creates a nested pattern where all occurrences of the string `<<self>>` are replaced with the pattern itself.
	 *
	 * @param {string} pattern
	 * @param {number} depthLog2
	 * @returns {string}
	 */ function nested(pattern, depthLog2) {
        for(var i = 0; i < depthLog2; i++)pattern = pattern.replace(/<<self>>/g, function() {
            return '(?:' + pattern + ')';
        });
        return pattern.replace(/<<self>>/g, '[^\\s\\S]');
    }
    // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/keywords/
    var keywordKinds = {
        // keywords which represent a return or variable type
        type: 'bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void',
        // keywords which are used to declare a type
        typeDeclaration: 'class enum interface record struct',
        // contextual keywords
        // ("var" and "dynamic" are missing because they are used like types)
        contextual: 'add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)',
        // all other keywords
        other: 'abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield'
    };
    // keywords
    function keywordsToPattern(words) {
        return '\\b(?:' + words.trim().replace(/ /g, '|') + ')\\b';
    }
    var typeDeclarationKeywords = keywordsToPattern(keywordKinds.typeDeclaration);
    var keywords = RegExp(keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other));
    var nonTypeKeywords = keywordsToPattern(keywordKinds.typeDeclaration + ' ' + keywordKinds.contextual + ' ' + keywordKinds.other);
    var nonContextualKeywords = keywordsToPattern(keywordKinds.type + ' ' + keywordKinds.typeDeclaration + ' ' + keywordKinds.other);
    // types
    var generic = nested(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2); // the idea behind the other forbidden characters is to prevent false positives. Same for tupleElement.
    var nestedRound = nested(/\((?:[^()]|<<self>>)*\)/.source, 2);
    var name = /@?\b[A-Za-z_]\w*\b/.source;
    var genericName = replace(/<<0>>(?:\s*<<1>>)?/.source, [
        name,
        generic
    ]);
    var identifier = replace(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
        nonTypeKeywords,
        genericName
    ]);
    var array = /\[\s*(?:,\s*)*\]/.source;
    var typeExpressionWithoutTuple = replace(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [
        identifier,
        array
    ]);
    var tupleElement = replace(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [
        generic,
        nestedRound,
        array
    ]);
    var tuple = replace(/\(<<0>>+(?:,<<0>>+)+\)/.source, [
        tupleElement
    ]);
    var typeExpression = replace(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [
        tuple,
        identifier,
        array
    ]);
    var typeInside = {
        'keyword': keywords,
        'punctuation': /[<>()?,.:[\]]/
    };
    // strings & characters
    // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#character-literals
    // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#string-literals
    var character = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source; // simplified pattern
    var regularString = /"(?:\\.|[^\\"\r\n])*"/.source;
    var verbatimString = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
    Prism1.languages.csharp = Prism1.languages.extend('clike', {
        'string': [
            {
                pattern: re(/(^|[^$\\])<<0>>/.source, [
                    verbatimString
                ]),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: re(/(^|[^@$\\])<<0>>/.source, [
                    regularString
                ]),
                lookbehind: true,
                greedy: true
            }
        ],
        'class-name': [
            {
                // Using static
                // using static System.Math;
                pattern: re(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [
                    identifier
                ]),
                lookbehind: true,
                inside: typeInside
            },
            {
                // Using alias (type)
                // using Project = PC.MyCompany.Project;
                pattern: re(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
                    name,
                    typeExpression
                ]),
                lookbehind: true,
                inside: typeInside
            },
            {
                // Using alias (alias)
                // using Project = PC.MyCompany.Project;
                pattern: re(/(\busing\s+)<<0>>(?=\s*=)/.source, [
                    name
                ]),
                lookbehind: true
            },
            {
                // Type declarations
                // class Foo<A, B>
                // interface Foo<out A, B>
                pattern: re(/(\b<<0>>\s+)<<1>>/.source, [
                    typeDeclarationKeywords,
                    genericName
                ]),
                lookbehind: true,
                inside: typeInside
            },
            {
                // Single catch exception declaration
                // catch(Foo)
                // (things like catch(Foo e) is covered by variable declaration)
                pattern: re(/(\bcatch\s*\(\s*)<<0>>/.source, [
                    identifier
                ]),
                lookbehind: true,
                inside: typeInside
            },
            {
                // Name of the type parameter of generic constraints
                // where Foo : class
                pattern: re(/(\bwhere\s+)<<0>>/.source, [
                    name
                ]),
                lookbehind: true
            },
            {
                // Casts and checks via as and is.
                // as Foo<A>, is Bar<B>
                // (things like if(a is Foo b) is covered by variable declaration)
                pattern: re(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [
                    typeExpressionWithoutTuple
                ]),
                lookbehind: true,
                inside: typeInside
            },
            {
                // Variable, field and parameter declaration
                // (Foo bar, Bar baz, Foo[,,] bay, Foo<Bar, FooBar<Bar>> bax)
                pattern: re(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [
                    typeExpression,
                    nonContextualKeywords,
                    name
                ]),
                inside: typeInside
            }
        ],
        'keyword': keywords,
        // https://docs.microsoft.com/en-us/dotnet/csharp/language-reference/language-specification/lexical-structure#literals
        'number': /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
        'operator': />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
        'punctuation': /\?\.?|::|[{}[\];(),.:]/
    });
    Prism1.languages.insertBefore('csharp', 'number', {
        'range': {
            pattern: /\.\./,
            alias: 'operator'
        }
    });
    Prism1.languages.insertBefore('csharp', 'punctuation', {
        'named-parameter': {
            pattern: re(/([(,]\s*)<<0>>(?=\s*:)/.source, [
                name
            ]),
            lookbehind: true,
            alias: 'punctuation'
        }
    });
    Prism1.languages.insertBefore('csharp', 'class-name', {
        'namespace': {
            // namespace Foo.Bar {}
            // using Foo.Bar;
            pattern: re(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [
                name
            ]),
            lookbehind: true,
            inside: {
                'punctuation': /\./
            }
        },
        'type-expression': {
            // default(Foo), typeof(Foo<Bar>), sizeof(int)
            pattern: re(/(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [
                nestedRound
            ]),
            lookbehind: true,
            alias: 'class-name',
            inside: typeInside
        },
        'return-type': {
            // Foo<Bar> ForBar(); Foo IFoo.Bar() => 0
            // int this[int index] => 0; T IReadOnlyList<T>.this[int index] => this[index];
            // int Foo => 0; int Foo { get; set } = 0;
            pattern: re(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [
                typeExpression,
                identifier
            ]),
            inside: typeInside,
            alias: 'class-name'
        },
        'constructor-invocation': {
            // new List<Foo<Bar[]>> { }
            pattern: re(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [
                typeExpression
            ]),
            lookbehind: true,
            inside: typeInside,
            alias: 'class-name'
        },
        /*'explicit-implementation': {
			// int IFoo<Foo>.Bar => 0; void IFoo<Foo<Foo>>.Foo<T>();
			pattern: replace(/\b<<0>>(?=\.<<1>>)/, className, methodOrPropertyDeclaration),
			inside: classNameInside,
			alias: 'class-name'
		},*/ 'generic-method': {
            // foo<Bar>()
            pattern: re(/<<0>>\s*<<1>>(?=\s*\()/.source, [
                name,
                generic
            ]),
            inside: {
                'function': re(/^<<0>>/.source, [
                    name
                ]),
                'generic': {
                    pattern: RegExp(generic),
                    alias: 'class-name',
                    inside: typeInside
                }
            }
        },
        'type-list': {
            // The list of types inherited or of generic constraints
            // class Foo<F> : Bar, IList<FooBar>
            // where F : Bar, IList<int>
            pattern: re(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source, [
                typeDeclarationKeywords,
                genericName,
                name,
                typeExpression,
                keywords.source,
                nestedRound,
                /\bnew\s*\(\s*\)/.source
            ]),
            lookbehind: true,
            inside: {
                'record-arguments': {
                    pattern: re(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
                        genericName,
                        nestedRound
                    ]),
                    lookbehind: true,
                    greedy: true,
                    inside: Prism1.languages.csharp
                },
                'keyword': keywords,
                'class-name': {
                    pattern: RegExp(typeExpression),
                    greedy: true,
                    inside: typeInside
                },
                'punctuation': /[,()]/
            }
        },
        'preprocessor': {
            pattern: /(^[\t ]*)#.*/m,
            lookbehind: true,
            alias: 'property',
            inside: {
                // highlight preprocessor directives as keywords
                'directive': {
                    pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
                    lookbehind: true,
                    alias: 'keyword'
                }
            }
        }
    });
    // attributes
    var regularStringOrCharacter = regularString + '|' + character;
    var regularStringCharacterOrComment = replace(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [
        regularStringOrCharacter
    ]);
    var roundExpression = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
        regularStringCharacterOrComment
    ]), 2);
    // https://docs.microsoft.com/en-us/dotnet/csharp/programming-guide/concepts/attributes/#attribute-targets
    var attrTarget = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source;
    var attr = replace(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
        identifier,
        roundExpression
    ]);
    Prism1.languages.insertBefore('csharp', 'class-name', {
        'attribute': {
            // Attributes
            // [Foo], [Foo(1), Bar(2, Prop = "foo")], [return: Foo(1), Bar(2)], [assembly: Foo(Bar)]
            pattern: re(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [
                attrTarget,
                attr
            ]),
            lookbehind: true,
            greedy: true,
            inside: {
                'target': {
                    pattern: re(/^<<0>>(?=\s*:)/.source, [
                        attrTarget
                    ]),
                    alias: 'keyword'
                },
                'attribute-arguments': {
                    pattern: re(/\(<<0>>*\)/.source, [
                        roundExpression
                    ]),
                    inside: Prism1.languages.csharp
                },
                'class-name': {
                    pattern: RegExp(identifier),
                    inside: {
                        'punctuation': /\./
                    }
                },
                'punctuation': /[:,]/
            }
        }
    });
    // string interpolation
    var formatString = /:[^}\r\n]+/.source;
    // multi line
    var mInterpolationRound = nested(replace(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [
        regularStringCharacterOrComment
    ]), 2);
    var mInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
        mInterpolationRound,
        formatString
    ]);
    // single line
    var sInterpolationRound = nested(replace(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [
        regularStringOrCharacter
    ]), 2);
    var sInterpolation = replace(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
        sInterpolationRound,
        formatString
    ]);
    function createInterpolationInside(interpolation, interpolationRound) {
        return {
            'interpolation': {
                pattern: re(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [
                    interpolation
                ]),
                lookbehind: true,
                inside: {
                    'format-string': {
                        pattern: re(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                            interpolationRound,
                            formatString
                        ]),
                        lookbehind: true,
                        inside: {
                            'punctuation': /^:/
                        }
                    },
                    'punctuation': /^\{|\}$/,
                    'expression': {
                        pattern: /[\s\S]+/,
                        alias: 'language-csharp',
                        inside: Prism1.languages.csharp
                    }
                }
            },
            'string': /[\s\S]+/
        };
    }
    Prism1.languages.insertBefore('csharp', 'string', {
        'interpolation-string': [
            {
                pattern: re(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [
                    mInterpolation
                ]),
                lookbehind: true,
                greedy: true,
                inside: createInterpolationInside(mInterpolation, mInterpolationRound)
            },
            {
                pattern: re(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [
                    sInterpolation
                ]),
                lookbehind: true,
                greedy: true,
                inside: createInterpolationInside(sInterpolation, sInterpolationRound)
            }
        ],
        'char': {
            pattern: RegExp(character),
            greedy: true
        }
    });
    Prism1.languages.dotnet = Prism1.languages.cs = Prism1.languages.csharp;
})(Prism);

});

parcelRegister("d8UrQ", function(module, exports) {
Prism.languages.go = Prism.languages.extend('clike', {
    'string': {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: true,
        greedy: true
    },
    'keyword': /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    'boolean': /\b(?:_|false|iota|nil|true)\b/,
    'number': [
        // binary and octal integers
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        // hexadecimal integers and floats
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        // decimal integers and floats
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
    ],
    'operator': /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    'builtin': /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
});
Prism.languages.insertBefore('go', 'string', {
    'char': {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: true
    }
});
delete Prism.languages.go['class-name'];

});

parcelRegister("iTqxp", function(module, exports) {
(function(Prism1) {
    /**
	 * @param {string} name
	 * @returns {RegExp}
	 */ function headerValueOf(name) {
        return RegExp('(^(?:' + name + '):[ \t]*(?![ \t]))[^]+', 'i');
    }
    Prism1.languages.http = {
        'request-line': {
            pattern: /^(?:CONNECT|DELETE|GET|HEAD|OPTIONS|PATCH|POST|PRI|PUT|SEARCH|TRACE)\s(?:https?:\/\/|\/)\S*\sHTTP\/[\d.]+/m,
            inside: {
                // HTTP Method
                'method': {
                    pattern: /^[A-Z]+\b/,
                    alias: 'property'
                },
                // Request Target e.g. http://example.com, /path/to/file
                'request-target': {
                    pattern: /^(\s)(?:https?:\/\/|\/)\S*(?=\s)/,
                    lookbehind: true,
                    alias: 'url',
                    inside: Prism1.languages.uri
                },
                // HTTP Version
                'http-version': {
                    pattern: /^(\s)HTTP\/[\d.]+/,
                    lookbehind: true,
                    alias: 'property'
                }
            }
        },
        'response-status': {
            pattern: /^HTTP\/[\d.]+ \d+ .+/m,
            inside: {
                // HTTP Version
                'http-version': {
                    pattern: /^HTTP\/[\d.]+/,
                    alias: 'property'
                },
                // Status Code
                'status-code': {
                    pattern: /^(\s)\d+(?=\s)/,
                    lookbehind: true,
                    alias: 'number'
                },
                // Reason Phrase
                'reason-phrase': {
                    pattern: /^(\s).+/,
                    lookbehind: true,
                    alias: 'string'
                }
            }
        },
        'header': {
            pattern: /^[\w-]+:.+(?:(?:\r\n?|\n)[ \t].+)*/m,
            inside: {
                'header-value': [
                    {
                        pattern: headerValueOf(/Content-Security-Policy/.source),
                        lookbehind: true,
                        alias: [
                            'csp',
                            'languages-csp'
                        ],
                        inside: Prism1.languages.csp
                    },
                    {
                        pattern: headerValueOf(/Public-Key-Pins(?:-Report-Only)?/.source),
                        lookbehind: true,
                        alias: [
                            'hpkp',
                            'languages-hpkp'
                        ],
                        inside: Prism1.languages.hpkp
                    },
                    {
                        pattern: headerValueOf(/Strict-Transport-Security/.source),
                        lookbehind: true,
                        alias: [
                            'hsts',
                            'languages-hsts'
                        ],
                        inside: Prism1.languages.hsts
                    },
                    {
                        pattern: headerValueOf(/[^:]+/.source),
                        lookbehind: true
                    }
                ],
                'header-name': {
                    pattern: /^[^:]+/,
                    alias: 'keyword'
                },
                'punctuation': /^:/
            }
        }
    };
    // Create a mapping of Content-Type headers to language definitions
    var langs = Prism1.languages;
    var httpLanguages = {
        'application/javascript': langs.javascript,
        'application/json': langs.json || langs.javascript,
        'application/xml': langs.xml,
        'text/xml': langs.xml,
        'text/html': langs.html,
        'text/css': langs.css,
        'text/plain': langs.plain
    };
    // Declare which types can also be suffixes
    var suffixTypes = {
        'application/json': true,
        'application/xml': true
    };
    /**
	 * Returns a pattern for the given content type which matches it and any type which has it as a suffix.
	 *
	 * @param {string} contentType
	 * @returns {string}
	 */ function getSuffixPattern(contentType) {
        var suffix = contentType.replace(/^[a-z]+\//, '');
        var suffixPattern = '\\w+/(?:[\\w.-]+\\+)+' + suffix + '(?![+\\w.-])';
        return '(?:' + contentType + '|' + suffixPattern + ')';
    }
    // Insert each content type parser that has its associated language
    // currently loaded.
    var options;
    for(var contentType in httpLanguages)if (httpLanguages[contentType]) {
        options = options || {};
        var pattern = suffixTypes[contentType] ? getSuffixPattern(contentType) : contentType;
        options[contentType.replace(/\//g, '-')] = {
            pattern: RegExp('(' + /content-type:\s*/.source + pattern + /(?:(?:\r\n?|\n)[\w-].*)*(?:\r(?:\n|(?!\n))|\n)/.source + ')' + // This is a little interesting:
            // The HTTP format spec required 1 empty line before the body to make everything unambiguous.
            // However, when writing code by hand (e.g. to display on a website) people can forget about this,
            // so we want to be liberal here. We will allow the empty line to be omitted if the first line of
            // the body does not start with a [\w-] character (as headers do).
            /[^ \t\w-][\s\S]*/.source, 'i'),
            lookbehind: true,
            inside: httpLanguages[contentType]
        };
    }
    if (options) Prism1.languages.insertBefore('http', 'header', options);
})(Prism);

});

parcelRegister("75LZA", function(module, exports) {
(function(Prism1) {
    var keywords = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/;
    // full package (optional) + parent classes (optional)
    var classNamePrefix = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source;
    // based on the java naming conventions
    var className = {
        pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
        lookbehind: true,
        inside: {
            'namespace': {
                pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
                inside: {
                    'punctuation': /\./
                }
            },
            'punctuation': /\./
        }
    };
    Prism1.languages.java = Prism1.languages.extend('clike', {
        'string': {
            pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
            lookbehind: true,
            greedy: true
        },
        'class-name': [
            className,
            {
                // variables, parameters, and constructor references
                // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                pattern: RegExp(/(^|[^\w.])/.source + classNamePrefix + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
                lookbehind: true,
                inside: className.inside
            },
            {
                // class names based on keyword
                // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
                pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + classNamePrefix + /[A-Z]\w*\b/.source),
                lookbehind: true,
                inside: className.inside
            }
        ],
        'keyword': keywords,
        'function': [
            Prism1.languages.clike.function,
            {
                pattern: /(::\s*)[a-z_]\w*/,
                lookbehind: true
            }
        ],
        'number': /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
        'operator': {
            pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
            lookbehind: true
        },
        'constant': /\b[A-Z][A-Z_\d]+\b/
    });
    Prism1.languages.insertBefore('java', 'string', {
        'triple-quoted-string': {
            // http://openjdk.java.net/jeps/355#Description
            pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
            greedy: true,
            alias: 'string'
        },
        'char': {
            pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
            greedy: true
        }
    });
    Prism1.languages.insertBefore('java', 'class-name', {
        'annotation': {
            pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
            lookbehind: true,
            alias: 'punctuation'
        },
        'generics': {
            pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
            inside: {
                'class-name': className,
                'keyword': keywords,
                'punctuation': /[<>(),.:]/,
                'operator': /[?&|]/
            }
        },
        'import': [
            {
                pattern: RegExp(/(\bimport\s+)/.source + classNamePrefix + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
                lookbehind: true,
                inside: {
                    'namespace': className.inside.namespace,
                    'punctuation': /\./,
                    'operator': /\*/,
                    'class-name': /\w+/
                }
            },
            {
                pattern: RegExp(/(\bimport\s+static\s+)/.source + classNamePrefix + /(?:\w+|\*)(?=\s*;)/.source),
                lookbehind: true,
                alias: 'static',
                inside: {
                    'namespace': className.inside.namespace,
                    'static': /\b\w+$/,
                    'punctuation': /\./,
                    'operator': /\*/,
                    'class-name': /\w+/
                }
            }
        ],
        'namespace': {
            pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
                return keywords.source;
            })),
            lookbehind: true,
            inside: {
                'punctuation': /\./
            }
        }
    });
})(Prism);

});

parcelRegister("jXEdh", function(module, exports) {
Prism.languages.lua = {
    'comment': /^#!.+|--(?:\[(=*)\[[\s\S]*?\]\1\]|.*)/m,
    // \z may be used to skip the following space
    'string': {
        pattern: /(["'])(?:(?!\1)[^\\\r\n]|\\z(?:\r\n|\s)|\\(?:\r\n|[^z]))*\1|\[(=*)\[[\s\S]*?\]\2\]/,
        greedy: true
    },
    'number': /\b0x[a-f\d]+(?:\.[a-f\d]*)?(?:p[+-]?\d+)?\b|\b\d+(?:\.\B|(?:\.\d*)?(?:e[+-]?\d+)?\b)|\B\.\d+(?:e[+-]?\d+)?\b/i,
    'keyword': /\b(?:and|break|do|else|elseif|end|false|for|function|goto|if|in|local|nil|not|or|repeat|return|then|true|until|while)\b/,
    'function': /(?!\d)\w+(?=\s*(?:[({]))/,
    'operator': [
        /[-+*%^&|#]|\/\/?|<[<=]?|>[>=]?|[=~]=?/,
        {
            // Match ".." but don't break "..."
            pattern: /(^|[^.])\.\.(?!\.)/,
            lookbehind: true
        }
    ],
    'punctuation': /[\[\](){},;]|\.+|:+/
};

});

parcelRegister("5V3YG", function(module, exports) {
(function(Prism1) {
    /**
	 * Returns the placeholder for the given language id and index.
	 *
	 * @param {string} language
	 * @param {string|number} index
	 * @returns {string}
	 */ function getPlaceholder(language, index) {
        return '___' + language.toUpperCase() + index + '___';
    }
    Object.defineProperties(Prism1.languages['markup-templating'] = {}, {
        buildPlaceholders: {
            /**
			 * Tokenize all inline templating expressions matching `placeholderPattern`.
			 *
			 * If `replaceFilter` is provided, only matches of `placeholderPattern` for which `replaceFilter` returns
			 * `true` will be replaced.
			 *
			 * @param {object} env The environment of the `before-tokenize` hook.
			 * @param {string} language The language id.
			 * @param {RegExp} placeholderPattern The matches of this pattern will be replaced by placeholders.
			 * @param {(match: string) => boolean} [replaceFilter]
			 */ value: function(env, language, placeholderPattern, replaceFilter) {
                if (env.language !== language) return;
                var tokenStack = env.tokenStack = [];
                env.code = env.code.replace(placeholderPattern, function(match) {
                    if (typeof replaceFilter === 'function' && !replaceFilter(match)) return match;
                    var i = tokenStack.length;
                    var placeholder;
                    // Check for existing strings
                    while(env.code.indexOf(placeholder = getPlaceholder(language, i)) !== -1)++i;
                    // Create a sparse array
                    tokenStack[i] = match;
                    return placeholder;
                });
                // Switch the grammar to markup
                env.grammar = Prism1.languages.markup;
            }
        },
        tokenizePlaceholders: {
            /**
			 * Replace placeholders with proper tokens after tokenizing.
			 *
			 * @param {object} env The environment of the `after-tokenize` hook.
			 * @param {string} language The language id.
			 */ value: function(env, language) {
                if (env.language !== language || !env.tokenStack) return;
                // Switch the grammar back
                env.grammar = Prism1.languages[language];
                var j = 0;
                var keys = Object.keys(env.tokenStack);
                function walkTokens(tokens) {
                    for(var i = 0; i < tokens.length; i++){
                        // all placeholders are replaced already
                        if (j >= keys.length) break;
                        var token = tokens[i];
                        if (typeof token === 'string' || token.content && typeof token.content === 'string') {
                            var k = keys[j];
                            var t = env.tokenStack[k];
                            var s = typeof token === 'string' ? token : token.content;
                            var placeholder = getPlaceholder(language, k);
                            var index = s.indexOf(placeholder);
                            if (index > -1) {
                                ++j;
                                var before = s.substring(0, index);
                                var middle = new Prism1.Token(language, Prism1.tokenize(t, env.grammar), 'language-' + language, t);
                                var after = s.substring(index + placeholder.length);
                                var replacement = [];
                                if (before) replacement.push.apply(replacement, walkTokens([
                                    before
                                ]));
                                replacement.push(middle);
                                if (after) replacement.push.apply(replacement, walkTokens([
                                    after
                                ]));
                                if (typeof token === 'string') tokens.splice.apply(tokens, [
                                    i,
                                    1
                                ].concat(replacement));
                                else token.content = replacement;
                            }
                        } else if (token.content /* && typeof token.content !== 'string' */ ) walkTokens(token.content);
                    }
                    return tokens;
                }
                walkTokens(env.tokens);
            }
        }
    });
})(Prism);

});

parcelRegister("fwhHX", function(module, exports) {
Prism.languages.markup = {
    'comment': {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    'prolog': {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    'doctype': {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            'internal-subset': {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            'string': {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            'punctuation': /^<!|>$|[[\]]/,
            'doctype-tag': /^DOCTYPE/i,
            'name': /[^\s<>'"]+/
        }
    },
    'cdata': {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    'tag': {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            'tag': {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    'punctuation': /^<\/?/,
                    'namespace': /^[^\s>\/:]+:/
                }
            },
            'special-attr': [],
            'attr-value': {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    'punctuation': [
                        {
                            pattern: /^=/,
                            alias: 'attr-equals'
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            'punctuation': /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    'namespace': /^[^\s>\/:]+:/
                }
            }
        }
    },
    'entity': [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: 'named-entity'
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];
Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') env.attributes['title'] = env.content.replace(/&amp;/, '&');
});
Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside['language-' + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: Prism.languages[lang]
        };
        includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            'included-cdata': {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside['language-' + lang] = {
            pattern: /[\s\S]+/,
            inside: Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), 'i'),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        Prism.languages.insertBefore('markup', 'cdata', def);
    }
});
Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        Prism.languages.markup.tag.inside['special-attr'].push({
            pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
            lookbehind: true,
            inside: {
                'attr-name': /^[^\s=]+/,
                'attr-value': {
                    pattern: /=[\s\S]+/,
                    inside: {
                        'value': {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                'language-' + lang
                            ],
                            inside: Prism.languages[lang]
                        },
                        'punctuation': [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;
Prism.languages.xml = Prism.languages.extend('markup', {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;

});

parcelRegister("ggqdh", function(module, exports) {
Prism.languages.objectivec = Prism.languages.extend('c', {
    'string': {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    'keyword': /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    'operator': /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
});
delete Prism.languages.objectivec['class-name'];
Prism.languages.objc = Prism.languages.objectivec;

});

parcelRegister("cTYpt", function(module, exports) {
(function(Prism1) {
    var brackets = /(?:\((?:[^()\\]|\\[\s\S])*\)|\{(?:[^{}\\]|\\[\s\S])*\}|\[(?:[^[\]\\]|\\[\s\S])*\]|<(?:[^<>\\]|\\[\s\S])*>)/.source;
    Prism1.languages.perl = {
        'comment': [
            {
                // POD
                pattern: /(^\s*)=\w[\s\S]*?=cut.*/m,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\$])#.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        // TODO Could be nice to handle Heredoc too.
        'string': [
            {
                pattern: RegExp(/\b(?:q|qq|qw|qx)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                    // q/.../
                    /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                    // q a...a
                    // eslint-disable-next-line regexp/strict
                    /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                    // q(...)
                    // q{...}
                    // q[...]
                    // q<...>
                    brackets
                ].join('|') + ')'),
                greedy: true
            },
            // "...", `...`
            {
                pattern: /("|`)(?:(?!\1)[^\\]|\\[\s\S])*\1/,
                greedy: true
            },
            // '...'
            // FIXME Multi-line single-quoted strings are not supported as they would break variables containing '
            {
                pattern: /'(?:[^'\\\r\n]|\\.)*'/,
                greedy: true
            }
        ],
        'regex': [
            {
                pattern: RegExp(/\b(?:m|qr)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                    // m/.../
                    /([^a-zA-Z0-9\s{(\[<])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
                    // m a...a
                    // eslint-disable-next-line regexp/strict
                    /([a-zA-Z0-9])(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                    // m(...)
                    // m{...}
                    // m[...]
                    // m<...>
                    brackets
                ].join('|') + ')' + /[msixpodualngc]*/.source),
                greedy: true
            },
            // The lookbehinds prevent -s from breaking
            {
                pattern: RegExp(/(^|[^-])\b(?:s|tr|y)(?![a-zA-Z0-9])\s*/.source + '(?:' + [
                    // s/.../.../
                    // eslint-disable-next-line regexp/strict
                    /([^a-zA-Z0-9\s{(\[<])(?:(?!\2)[^\\]|\\[\s\S])*\2(?:(?!\2)[^\\]|\\[\s\S])*\2/.source,
                    // s a...a...a
                    // eslint-disable-next-line regexp/strict
                    /([a-zA-Z0-9])(?:(?!\3)[^\\]|\\[\s\S])*\3(?:(?!\3)[^\\]|\\[\s\S])*\3/.source,
                    // s(...)(...)
                    // s{...}{...}
                    // s[...][...]
                    // s<...><...>
                    // s(...)[...]
                    brackets + /\s*/.source + brackets
                ].join('|') + ')' + /[msixpodualngcer]*/.source),
                lookbehind: true,
                greedy: true
            },
            // /.../
            // The look-ahead tries to prevent two divisions on
            // the same line from being highlighted as regex.
            // This does not support multi-line regex.
            {
                pattern: /\/(?:[^\/\\\r\n]|\\.)*\/[msixpodualngc]*(?=\s*(?:$|[\r\n,.;})&|\-+*~<>!?^]|(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|x|xor)\b))/,
                greedy: true
            }
        ],
        // FIXME Not sure about the handling of ::, ', and #
        'variable': [
            // ${^POSTMATCH}
            /[&*$@%]\{\^[A-Z]+\}/,
            // $^V
            /[&*$@%]\^[A-Z_]/,
            // ${...}
            /[&*$@%]#?(?=\{)/,
            // $foo
            /[&*$@%]#?(?:(?:::)*'?(?!\d)[\w$]+(?![\w$]))+(?:::)*/,
            // $1
            /[&*$@%]\d+/,
            // $_, @_, %!
            // The negative lookahead prevents from breaking the %= operator
            /(?!%=)[$@%][!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~]/
        ],
        'filehandle': {
            // <>, <FOO>, _
            pattern: /<(?![<=])\S*?>|\b_\b/,
            alias: 'symbol'
        },
        'v-string': {
            // v1.2, 1.2.3
            pattern: /v\d+(?:\.\d+)*|\d+(?:\.\d+){2,}/,
            alias: 'string'
        },
        'function': {
            pattern: /(\bsub[ \t]+)\w+/,
            lookbehind: true
        },
        'keyword': /\b(?:any|break|continue|default|delete|die|do|else|elsif|eval|for|foreach|given|goto|if|last|local|my|next|our|package|print|redo|require|return|say|state|sub|switch|undef|unless|until|use|when|while)\b/,
        'number': /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)\b/,
        'operator': /-[rwxoRWXOezsfdlpSbctugkTBMAC]\b|\+[+=]?|-[-=>]?|\*\*?=?|\/\/?=?|=[=~>]?|~[~=]?|\|\|?=?|&&?=?|<(?:=>?|<=?)?|>>?=?|![~=]?|[%^]=?|\.(?:=|\.\.?)?|[\\?]|\bx(?:=|\b)|\b(?:and|cmp|eq|ge|gt|le|lt|ne|not|or|xor)\b/,
        'punctuation': /[{}[\];(),:]/
    };
})(Prism);

});

parcelRegister("lO7mf", function(module, exports) {
/**
 * Original by Aaron Harun: http://aahacreative.com/2012/07/31/php-syntax-highlighting-prism/
 * Modified by Miles Johnson: http://milesj.me
 * Rewritten by Tom Pavelec
 *
 * Supports PHP 5.3 - 8.0
 */ (function(Prism1) {
    var comment = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/;
    var constant = [
        {
            pattern: /\b(?:false|true)\b/i,
            alias: 'boolean'
        },
        {
            pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
            greedy: true,
            lookbehind: true
        },
        {
            pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
            greedy: true,
            lookbehind: true
        },
        /\b(?:null)\b/i,
        /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
    ];
    var number = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i;
    var operator = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/;
    var punctuation = /[{}\[\](),:;]/;
    Prism1.languages.php = {
        'delimiter': {
            pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
            alias: 'important'
        },
        'comment': comment,
        'variable': /\$+(?:\w+\b|(?=\{))/,
        'package': {
            pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
            lookbehind: true,
            inside: {
                'punctuation': /\\/
            }
        },
        'class-name-definition': {
            pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
            lookbehind: true,
            alias: 'class-name'
        },
        'function-definition': {
            pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
            lookbehind: true,
            alias: 'function'
        },
        'keyword': [
            {
                pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
                alias: 'type-casting',
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
                alias: 'type-hint',
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|never|object|self|static|string|void)\b/i,
                alias: 'return-type',
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
                alias: 'type-declaration',
                greedy: true
            },
            {
                pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
                alias: 'type-declaration',
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /\b(?:parent|self|static)(?=\s*::)/i,
                alias: 'static-context',
                greedy: true
            },
            {
                // yield from
                pattern: /(\byield\s+)from\b/i,
                lookbehind: true
            },
            // `class` is always a keyword unlike other keywords
            /\bclass\b/i,
            {
                // https://www.php.net/manual/en/reserved.keywords.php
                //
                // keywords cannot be preceded by "->"
                // the complex lookbehind means `(?<!(?:->|::)\s*)`
                pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|never|new|or|parent|print|private|protected|public|readonly|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
                lookbehind: true
            }
        ],
        'argument-name': {
            pattern: /([(,]\s*)\b[a-z_]\w*(?=\s*:(?!:))/i,
            lookbehind: true
        },
        'class-name': [
            {
                pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
                greedy: true
            },
            {
                pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
                alias: 'class-name-fully-qualified',
                greedy: true,
                lookbehind: true,
                inside: {
                    'punctuation': /\\/
                }
            },
            {
                pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
                alias: 'class-name-fully-qualified',
                greedy: true,
                inside: {
                    'punctuation': /\\/
                }
            },
            {
                pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                alias: 'class-name-fully-qualified',
                greedy: true,
                lookbehind: true,
                inside: {
                    'punctuation': /\\/
                }
            },
            {
                pattern: /\b[a-z_]\w*(?=\s*\$)/i,
                alias: 'type-declaration',
                greedy: true
            },
            {
                pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                alias: [
                    'class-name-fully-qualified',
                    'type-declaration'
                ],
                greedy: true,
                inside: {
                    'punctuation': /\\/
                }
            },
            {
                pattern: /\b[a-z_]\w*(?=\s*::)/i,
                alias: 'static-context',
                greedy: true
            },
            {
                pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
                alias: [
                    'class-name-fully-qualified',
                    'static-context'
                ],
                greedy: true,
                inside: {
                    'punctuation': /\\/
                }
            },
            {
                pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
                alias: 'type-hint',
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
                alias: [
                    'class-name-fully-qualified',
                    'type-hint'
                ],
                greedy: true,
                lookbehind: true,
                inside: {
                    'punctuation': /\\/
                }
            },
            {
                pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
                alias: 'return-type',
                greedy: true,
                lookbehind: true
            },
            {
                pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
                alias: [
                    'class-name-fully-qualified',
                    'return-type'
                ],
                greedy: true,
                lookbehind: true,
                inside: {
                    'punctuation': /\\/
                }
            }
        ],
        'constant': constant,
        'function': {
            pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
            lookbehind: true,
            inside: {
                'punctuation': /\\/
            }
        },
        'property': {
            pattern: /(->\s*)\w+/,
            lookbehind: true
        },
        'number': number,
        'operator': operator,
        'punctuation': punctuation
    };
    var string_interpolation = {
        pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
        lookbehind: true,
        inside: Prism1.languages.php
    };
    var string = [
        {
            pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
            alias: 'nowdoc-string',
            greedy: true,
            inside: {
                'delimiter': {
                    pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
                    alias: 'symbol',
                    inside: {
                        'punctuation': /^<<<'?|[';]$/
                    }
                }
            }
        },
        {
            pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
            alias: 'heredoc-string',
            greedy: true,
            inside: {
                'delimiter': {
                    pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
                    alias: 'symbol',
                    inside: {
                        'punctuation': /^<<<"?|[";]$/
                    }
                },
                'interpolation': string_interpolation
            }
        },
        {
            pattern: /`(?:\\[\s\S]|[^\\`])*`/,
            alias: 'backtick-quoted-string',
            greedy: true
        },
        {
            pattern: /'(?:\\[\s\S]|[^\\'])*'/,
            alias: 'single-quoted-string',
            greedy: true
        },
        {
            pattern: /"(?:\\[\s\S]|[^\\"])*"/,
            alias: 'double-quoted-string',
            greedy: true,
            inside: {
                'interpolation': string_interpolation
            }
        }
    ];
    Prism1.languages.insertBefore('php', 'variable', {
        'string': string,
        'attribute': {
            pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
            greedy: true,
            inside: {
                'attribute-content': {
                    pattern: /^(#\[)[\s\S]+(?=\]$)/,
                    lookbehind: true,
                    // inside can appear subset of php
                    inside: {
                        'comment': comment,
                        'string': string,
                        'attribute-class-name': [
                            {
                                pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                                alias: 'class-name',
                                greedy: true,
                                lookbehind: true
                            },
                            {
                                pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                                alias: [
                                    'class-name',
                                    'class-name-fully-qualified'
                                ],
                                greedy: true,
                                lookbehind: true,
                                inside: {
                                    'punctuation': /\\/
                                }
                            }
                        ],
                        'constant': constant,
                        'number': number,
                        'operator': operator,
                        'punctuation': punctuation
                    }
                },
                'delimiter': {
                    pattern: /^#\[|\]$/,
                    alias: 'punctuation'
                }
            }
        }
    });
    Prism1.hooks.add('before-tokenize', function(env) {
        if (!/<\?/.test(env.code)) return;
        var phpPattern = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
        Prism1.languages['markup-templating'].buildPlaceholders(env, 'php', phpPattern);
    });
    Prism1.hooks.add('after-tokenize', function(env) {
        Prism1.languages['markup-templating'].tokenizePlaceholders(env, 'php');
    });
})(Prism);

});

parcelRegister("8svz5", function(module, exports) {
Prism.languages.python = {
    'comment': {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        greedy: true
    },
    'string-interpolation': {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: true,
        inside: {
            'interpolation': {
                // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
                pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                lookbehind: true,
                inside: {
                    'format-spec': {
                        pattern: /(:)[^:(){}]+(?=\}$)/,
                        lookbehind: true
                    },
                    'conversion-option': {
                        pattern: /![sra](?=[:}]$)/,
                        alias: 'punctuation'
                    },
                    rest: null
                }
            },
            'string': /[\s\S]+/
        }
    },
    'triple-quoted-string': {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: true,
        alias: 'string'
    },
    'string': {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: true
    },
    'function': {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: true
    },
    'class-name': {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: true
    },
    'decorator': {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: true,
        alias: [
            'annotation',
            'punctuation'
        ],
        inside: {
            'punctuation': /\./
        }
    },
    'keyword': /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    'builtin': /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    'boolean': /\b(?:False|None|True)\b/,
    'number': /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    'operator': /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    'punctuation': /[{}[\];(),.:]/
};
Prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.python;
Prism.languages.py = Prism.languages.python;

});

parcelRegister("eVptw", function(module, exports) {
Prism.languages.q = {
    'string': /"(?:\\.|[^"\\\r\n])*"/,
    'comment': [
        // From http://code.kx.com/wiki/Reference/Slash:
        // When / is following a space (or a right parenthesis, bracket, or brace), it is ignored with the rest of the line.
        {
            pattern: /([\t )\]}])\/.*/,
            lookbehind: true,
            greedy: true
        },
        // From http://code.kx.com/wiki/Reference/Slash:
        // A line which has / as its first character and contains at least one other non-whitespace character is a whole-line comment and is ignored entirely.
        // A / on a line by itself begins a multiline comment which is terminated by the next \ on a line by itself.
        // If a / is not matched by a \, the multiline comment is unterminated and continues to end of file.
        // The / and \ must be the first char on the line, but may be followed by any amount of whitespace.
        {
            pattern: /(^|\r?\n|\r)\/[\t ]*(?:(?:\r?\n|\r)(?:.*(?:\r?\n|\r(?!\n)))*?(?:\\(?=[\t ]*(?:\r?\n|\r))|$)|\S.*)/,
            lookbehind: true,
            greedy: true
        },
        // From http://code.kx.com/wiki/Reference/Slash:
        // A \ on a line by itself with no preceding matching / will comment to end of file.
        {
            pattern: /^\\[\t ]*(?:\r?\n|\r)[\s\S]+/m,
            greedy: true
        },
        {
            pattern: /^#!.+/m,
            greedy: true
        }
    ],
    'symbol': /`(?::\S+|[\w.]*)/,
    'datetime': {
        pattern: /0N[mdzuvt]|0W[dtz]|\d{4}\.\d\d(?:m|\.\d\d(?:T(?:\d\d(?::\d\d(?::\d\d(?:[.:]\d\d\d)?)?)?)?)?[dz]?)|\d\d:\d\d(?::\d\d(?:[.:]\d\d\d)?)?[uvt]?/,
        alias: 'number'
    },
    // The negative look-ahead prevents bad highlighting
    // of verbs 0: and 1:
    'number': /\b(?![01]:)(?:0N[hje]?|0W[hj]?|0[wn]|0x[\da-fA-F]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?[hjfeb]?)/,
    'keyword': /\\\w+\b|\b(?:abs|acos|aj0?|all|and|any|asc|asin|asof|atan|attr|avgs?|binr?|by|ceiling|cols|cor|cos|count|cov|cross|csv|cut|delete|deltas|desc|dev|differ|distinct|div|do|dsave|ej|enlist|eval|except|exec|exit|exp|fby|fills|first|fkeys|flip|floor|from|get|getenv|group|gtime|hclose|hcount|hdel|hopen|hsym|iasc|identity|idesc|if|ij|in|insert|inter|inv|keys?|last|like|list|ljf?|load|log|lower|lsq|ltime|ltrim|mavg|maxs?|mcount|md5|mdev|med|meta|mins?|mmax|mmin|mmu|mod|msum|neg|next|not|null|or|over|parse|peach|pj|plist|prds?|prev|prior|rand|rank|ratios|raze|read0|read1|reciprocal|reval|reverse|rload|rotate|rsave|rtrim|save|scan|scov|sdev|select|set|setenv|show|signum|sin|sqrt|ssr?|string|sublist|sums?|sv|svar|system|tables|tan|til|trim|txf|type|uj|ungroup|union|update|upper|upsert|value|var|views?|vs|wavg|where|while|within|wj1?|wsum|ww|xasc|xbar|xcols?|xdesc|xexp|xgroup|xkey|xlog|xprev|xrank)\b/,
    'adverb': {
        pattern: /['\/\\]:?|\beach\b/,
        alias: 'function'
    },
    'verb': {
        pattern: /(?:\B\.\B|\b[01]:|<[=>]?|>=?|[:+\-*%,!?~=|$&#@^]):?|\b_\b:?/,
        alias: 'operator'
    },
    'punctuation': /[(){}\[\];.]/
};

});

parcelRegister("ia73J", function(module, exports) {
/**
 * Original by Samuel Flores
 *
 * Adds the following new token classes:
 *     constant, builtin, variable, symbol, regex
 */ (function(Prism1) {
    Prism1.languages.ruby = Prism1.languages.extend('clike', {
        'comment': {
            pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
            lookbehind: true,
            inside: {
                'punctuation': /[.\\]/
            }
        },
        'keyword': /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
        'operator': /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
        'punctuation': /[(){}[\].,;]/
    });
    Prism1.languages.insertBefore('ruby', 'operator', {
        'double-colon': {
            pattern: /::/,
            alias: 'punctuation'
        }
    });
    var interpolation = {
        pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
        lookbehind: true,
        inside: {
            'content': {
                pattern: /^(#\{)[\s\S]+(?=\}$)/,
                lookbehind: true,
                inside: Prism1.languages.ruby
            },
            'delimiter': {
                pattern: /^#\{|\}$/,
                alias: 'punctuation'
            }
        }
    };
    delete Prism1.languages.ruby.function;
    var percentExpression = '(?:' + [
        /([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
        /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source,
        /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source,
        /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source,
        /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source
    ].join('|') + ')';
    var symbolName = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
    Prism1.languages.insertBefore('ruby', 'keyword', {
        'regex-literal': [
            {
                pattern: RegExp(/%r/.source + percentExpression + /[egimnosux]{0,6}/.source),
                greedy: true,
                inside: {
                    'interpolation': interpolation,
                    'regex': /[\s\S]+/
                }
            },
            {
                pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
                lookbehind: true,
                greedy: true,
                inside: {
                    'interpolation': interpolation,
                    'regex': /[\s\S]+/
                }
            }
        ],
        'variable': /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
        'symbol': [
            {
                pattern: RegExp(/(^|[^:]):/.source + symbolName),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: RegExp(/([\r\n{(,][ \t]*)/.source + symbolName + /(?=:(?!:))/.source),
                lookbehind: true,
                greedy: true
            }
        ],
        'method-definition': {
            pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
            lookbehind: true,
            inside: {
                'function': /\b\w+$/,
                'keyword': /^self\b/,
                'class-name': /^\w+/,
                'punctuation': /\./
            }
        }
    });
    Prism1.languages.insertBefore('ruby', 'string', {
        'string-literal': [
            {
                pattern: RegExp(/%[qQiIwWs]?/.source + percentExpression),
                greedy: true,
                inside: {
                    'interpolation': interpolation,
                    'string': /[\s\S]+/
                }
            },
            {
                pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
                greedy: true,
                inside: {
                    'interpolation': interpolation,
                    'string': /[\s\S]+/
                }
            },
            {
                pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                alias: 'heredoc-string',
                greedy: true,
                inside: {
                    'delimiter': {
                        pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
                        inside: {
                            'symbol': /\b\w+/,
                            'punctuation': /^<<[-~]?/
                        }
                    },
                    'interpolation': interpolation,
                    'string': /[\s\S]+/
                }
            },
            {
                pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
                alias: 'heredoc-string',
                greedy: true,
                inside: {
                    'delimiter': {
                        pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
                        inside: {
                            'symbol': /\b\w+/,
                            'punctuation': /^<<[-~]?'|'$/
                        }
                    },
                    'string': /[\s\S]+/
                }
            }
        ],
        'command-literal': [
            {
                pattern: RegExp(/%x/.source + percentExpression),
                greedy: true,
                inside: {
                    'interpolation': interpolation,
                    'command': {
                        pattern: /[\s\S]+/,
                        alias: 'string'
                    }
                }
            },
            {
                pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
                greedy: true,
                inside: {
                    'interpolation': interpolation,
                    'command': {
                        pattern: /[\s\S]+/,
                        alias: 'string'
                    }
                }
            }
        ]
    });
    delete Prism1.languages.ruby.string;
    Prism1.languages.insertBefore('ruby', 'number', {
        'builtin': /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
        'constant': /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
    });
    Prism1.languages.rb = Prism1.languages.ruby;
})(Prism);

});

parcelRegister("dy4Fz", function(module, exports) {
Prism.languages.scala = Prism.languages.extend('java', {
    'triple-quoted-string': {
        pattern: /"""[\s\S]*?"""/,
        greedy: true,
        alias: 'string'
    },
    'string': {
        pattern: /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'keyword': /<-|=>|\b(?:abstract|case|catch|class|def|derives|do|else|enum|extends|extension|final|finally|for|forSome|given|if|implicit|import|infix|inline|lazy|match|new|null|object|opaque|open|override|package|private|protected|return|sealed|self|super|this|throw|trait|transparent|try|type|using|val|var|while|with|yield)\b/,
    'number': /\b0x(?:[\da-f]*\.)?[\da-f]+|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e\d+)?[dfl]?/i,
    'builtin': /\b(?:Any|AnyRef|AnyVal|Boolean|Byte|Char|Double|Float|Int|Long|Nothing|Short|String|Unit)\b/,
    'symbol': /'[^\d\s\\]\w*/
});
Prism.languages.insertBefore('scala', 'triple-quoted-string', {
    'string-interpolation': {
        pattern: /\b[a-z]\w*(?:"""(?:[^$]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*?"""|"(?:[^$"\r\n]|\$(?:[^{]|\{(?:[^{}]|\{[^{}]*\})*\}))*")/i,
        greedy: true,
        inside: {
            'id': {
                pattern: /^\w+/,
                greedy: true,
                alias: 'function'
            },
            'escape': {
                pattern: /\\\$"|\$[$"]/,
                greedy: true,
                alias: 'symbol'
            },
            'interpolation': {
                pattern: /\$(?:\w+|\{(?:[^{}]|\{[^{}]*\})*\})/,
                greedy: true,
                inside: {
                    'punctuation': /^\$\{?|\}$/,
                    'expression': {
                        pattern: /[\s\S]+/,
                        inside: Prism.languages.scala
                    }
                }
            },
            'string': /[\s\S]+/
        }
    }
});
delete Prism.languages.scala['class-name'];
delete Prism.languages.scala['function'];
delete Prism.languages.scala['constant'];

});

parcelRegister("lfCKT", function(module, exports) {
Prism.languages.sql = {
    'comment': {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: true
    },
    'variable': [
        {
            pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
            greedy: true
        },
        /@[\w.$]+/
    ],
    'string': {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: true,
        lookbehind: true
    },
    'identifier': {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: true,
        lookbehind: true,
        inside: {
            'punctuation': /^`|`$/
        }
    },
    'function': /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    'keyword': /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    'boolean': /\b(?:FALSE|NULL|TRUE)\b/i,
    'number': /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    'operator': /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    'punctuation': /[;[\]()`,.]/
};

});

parcelRegister("lsL9j", function(module, exports) {
Prism.languages.swift = {
    'comment': {
        // Nested comments are supported up to 2 levels
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: true,
        greedy: true
    },
    'string-literal': [
        // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
        {
            pattern: RegExp(/(^|[^"#])/.source + '(?:' + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + '|' + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ')' + /(?!["#])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                'interpolation': {
                    pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null // see below
                },
                'interpolation-punctuation': {
                    pattern: /^\)|\\\($/,
                    alias: 'punctuation'
                },
                'punctuation': /\\(?=[\r\n])/,
                'string': /[\s\S]+/
            }
        },
        {
            pattern: RegExp(/(^|[^"#])(#+)/.source + '(?:' + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + '|' + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ')' + '\\2'),
            lookbehind: true,
            greedy: true,
            inside: {
                'interpolation': {
                    pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null // see below
                },
                'interpolation-punctuation': {
                    pattern: /^\)|\\#+\($/,
                    alias: 'punctuation'
                },
                'string': /[\s\S]+/
            }
        }
    ],
    'directive': {
        // directives with conditions
        pattern: RegExp(/#/.source + '(?:' + (/(?:elseif|if)\b/.source + '(?:[ \t]*' + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ')+') + '|' + /(?:else|endif)\b/.source + ')'),
        alias: 'property',
        inside: {
            'directive-name': /^#\w+/,
            'boolean': /\b(?:false|true)\b/,
            'number': /\b\d+(?:\.\d+)*\b/,
            'operator': /!|&&|\|\||[<>]=?/,
            'punctuation': /[(),]/
        }
    },
    'literal': {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: 'constant'
    },
    'other-directive': {
        pattern: /#\w+\b/,
        alias: 'property'
    },
    'attribute': {
        pattern: /@\w+/,
        alias: 'atrule'
    },
    'function-definition': {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: true,
        alias: 'function'
    },
    'label': {
        // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: true,
        alias: 'important'
    },
    'keyword': /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    'boolean': /\b(?:false|true)\b/,
    'nil': {
        pattern: /\bnil\b/,
        alias: 'constant'
    },
    'short-argument': /\$\d+\b/,
    'omit': {
        pattern: /\b_\b/,
        alias: 'keyword'
    },
    'number': /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
    'class-name': /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    'function': /\b[a-z_]\w*(?=\s*\()/i,
    'constant': /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
    // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
    // This regex only supports ASCII operators.
    'operator': /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    'punctuation': /[{}[\]();,.:\\]/
};
Prism.languages.swift['string-literal'].forEach(function(rule) {
    rule.inside['interpolation'].inside = Prism.languages.swift;
});

});

parcelRegister("5PzEK", function(module, exports) {
(function(Prism1) {
    // https://yaml.org/spec/1.2/spec.html#c-ns-anchor-property
    // https://yaml.org/spec/1.2/spec.html#c-ns-alias-node
    var anchorOrAlias = /[*&][^\s[\]{},]+/;
    // https://yaml.org/spec/1.2/spec.html#c-ns-tag-property
    var tag = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/;
    // https://yaml.org/spec/1.2/spec.html#c-ns-properties(n,c)
    var properties = '(?:' + tag.source + '(?:[ \t]+' + anchorOrAlias.source + ')?|' + anchorOrAlias.source + '(?:[ \t]+' + tag.source + ')?)';
    // https://yaml.org/spec/1.2/spec.html#ns-plain(n,c)
    // This is a simplified version that doesn't support "#" and multiline keys
    // All these long scarry character classes are simplified versions of YAML's characters
    var plainKey = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
        return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
    });
    var string = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
    /**
	 *
	 * @param {string} value
	 * @param {string} [flags]
	 * @returns {RegExp}
	 */ function createValuePattern(value, flags) {
        flags = (flags || '').replace(/m/g, '') + 'm'; // add m flag
        var pattern = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
            return properties;
        }).replace(/<<value>>/g, function() {
            return value;
        });
        return RegExp(pattern, flags);
    }
    Prism1.languages.yaml = {
        'scalar': {
            pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                return properties;
            })),
            lookbehind: true,
            alias: 'string'
        },
        'comment': /#.*/,
        'key': {
            pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                return properties;
            }).replace(/<<key>>/g, function() {
                return '(?:' + plainKey + '|' + string + ')';
            })),
            lookbehind: true,
            greedy: true,
            alias: 'atrule'
        },
        'directive': {
            pattern: /(^[ \t]*)%.+/m,
            lookbehind: true,
            alias: 'important'
        },
        'datetime': {
            pattern: createValuePattern(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
            lookbehind: true,
            alias: 'number'
        },
        'boolean': {
            pattern: createValuePattern(/false|true/.source, 'i'),
            lookbehind: true,
            alias: 'important'
        },
        'null': {
            pattern: createValuePattern(/null|~/.source, 'i'),
            lookbehind: true,
            alias: 'important'
        },
        'string': {
            pattern: createValuePattern(string),
            lookbehind: true,
            greedy: true
        },
        'number': {
            pattern: createValuePattern(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, 'i'),
            lookbehind: true
        },
        'tag': tag,
        'important': anchorOrAlias,
        'punctuation': /---|[:[\]{}\-,|>?]|\.\.\./
    };
    Prism1.languages.yml = Prism1.languages.yaml;
})(Prism);

});

parcelRegister("4KDOF", function(module, exports) {
// https://tools.ietf.org/html/rfc4180
Prism.languages.csv = {
    'value': /[^\r\n,"]+|"(?:[^"]|"")*"(?!")/,
    'punctuation': /,/
};

});

parcelRegister("05jCj", function(module, exports) {
/*!***************************************************
* mark.js v8.11.1
* https://markjs.io/
* Copyright (c) 2014–2018, Julian Kühnel
* Released under the MIT license https://git.io/vwTVl
*****************************************************/ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var classCallCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var DOMIterator = function() {
        function DOMIterator(ctx) {
            var iframes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var exclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var iframesTimeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5000;
            classCallCheck(this, DOMIterator);
            this.ctx = ctx;
            this.iframes = iframes;
            this.exclude = exclude;
            this.iframesTimeout = iframesTimeout;
        }
        createClass(DOMIterator, [
            {
                key: 'getContexts',
                value: function getContexts() {
                    var ctx = void 0, filteredCtx = [];
                    if (typeof this.ctx === 'undefined' || !this.ctx) ctx = [];
                    else if (NodeList.prototype.isPrototypeOf(this.ctx)) ctx = Array.prototype.slice.call(this.ctx);
                    else if (Array.isArray(this.ctx)) ctx = this.ctx;
                    else if (typeof this.ctx === 'string') ctx = Array.prototype.slice.call(document.querySelectorAll(this.ctx));
                    else ctx = [
                        this.ctx
                    ];
                    ctx.forEach(function(ctx) {
                        var isDescendant = filteredCtx.filter(function(contexts) {
                            return contexts.contains(ctx);
                        }).length > 0;
                        if (filteredCtx.indexOf(ctx) === -1 && !isDescendant) filteredCtx.push(ctx);
                    });
                    return filteredCtx;
                }
            },
            {
                key: 'getIframeContents',
                value: function getIframeContents(ifr, successFn) {
                    var errorFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {};
                    var doc = void 0;
                    try {
                        var ifrWin = ifr.contentWindow;
                        doc = ifrWin.document;
                        if (!ifrWin || !doc) throw new Error('iframe inaccessible');
                    } catch (e) {
                        errorFn();
                    }
                    if (doc) successFn(doc);
                }
            },
            {
                key: 'isIframeBlank',
                value: function isIframeBlank(ifr) {
                    var bl = 'about:blank', src = ifr.getAttribute('src').trim(), href = ifr.contentWindow.location.href;
                    return href === bl && src !== bl && src;
                }
            },
            {
                key: 'observeIframeLoad',
                value: function observeIframeLoad(ifr, successFn, errorFn) {
                    var _this = this;
                    var called = false, tout = null;
                    var listener = function listener() {
                        if (called) return;
                        called = true;
                        clearTimeout(tout);
                        try {
                            if (!_this.isIframeBlank(ifr)) {
                                ifr.removeEventListener('load', listener);
                                _this.getIframeContents(ifr, successFn, errorFn);
                            }
                        } catch (e) {
                            errorFn();
                        }
                    };
                    ifr.addEventListener('load', listener);
                    tout = setTimeout(listener, this.iframesTimeout);
                }
            },
            {
                key: 'onIframeReady',
                value: function onIframeReady(ifr, successFn, errorFn) {
                    try {
                        if (ifr.contentWindow.document.readyState === 'complete') {
                            if (this.isIframeBlank(ifr)) this.observeIframeLoad(ifr, successFn, errorFn);
                            else this.getIframeContents(ifr, successFn, errorFn);
                        } else this.observeIframeLoad(ifr, successFn, errorFn);
                    } catch (e) {
                        errorFn();
                    }
                }
            },
            {
                key: 'waitForIframes',
                value: function waitForIframes(ctx, done) {
                    var _this2 = this;
                    var eachCalled = 0;
                    this.forEachIframe(ctx, function() {
                        return true;
                    }, function(ifr) {
                        eachCalled++;
                        _this2.waitForIframes(ifr.querySelector('html'), function() {
                            if (!--eachCalled) done();
                        });
                    }, function(handled) {
                        if (!handled) done();
                    });
                }
            },
            {
                key: 'forEachIframe',
                value: function forEachIframe(ctx, filter, each) {
                    var _this3 = this;
                    var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function() {};
                    var ifr = ctx.querySelectorAll('iframe'), open = ifr.length, handled = 0;
                    ifr = Array.prototype.slice.call(ifr);
                    var checkEnd = function checkEnd() {
                        if (--open <= 0) end(handled);
                    };
                    if (!open) checkEnd();
                    ifr.forEach(function(ifr) {
                        if (DOMIterator.matches(ifr, _this3.exclude)) checkEnd();
                        else _this3.onIframeReady(ifr, function(con) {
                            if (filter(ifr)) {
                                handled++;
                                each(con);
                            }
                            checkEnd();
                        }, checkEnd);
                    });
                }
            },
            {
                key: 'createIterator',
                value: function createIterator(ctx, whatToShow, filter) {
                    return document.createNodeIterator(ctx, whatToShow, filter, false);
                }
            },
            {
                key: 'createInstanceOnIframe',
                value: function createInstanceOnIframe(contents) {
                    return new DOMIterator(contents.querySelector('html'), this.iframes);
                }
            },
            {
                key: 'compareNodeIframe',
                value: function compareNodeIframe(node, prevNode, ifr) {
                    var compCurr = node.compareDocumentPosition(ifr), prev = Node.DOCUMENT_POSITION_PRECEDING;
                    if (compCurr & prev) {
                        if (prevNode !== null) {
                            var compPrev = prevNode.compareDocumentPosition(ifr), after = Node.DOCUMENT_POSITION_FOLLOWING;
                            if (compPrev & after) return true;
                        } else return true;
                    }
                    return false;
                }
            },
            {
                key: 'getIteratorNode',
                value: function getIteratorNode(itr) {
                    var prevNode = itr.previousNode();
                    var node = void 0;
                    if (prevNode === null) node = itr.nextNode();
                    else node = itr.nextNode() && itr.nextNode();
                    return {
                        prevNode: prevNode,
                        node: node
                    };
                }
            },
            {
                key: 'checkIframeFilter',
                value: function checkIframeFilter(node, prevNode, currIfr, ifr) {
                    var key = false, handled = false;
                    ifr.forEach(function(ifrDict, i) {
                        if (ifrDict.val === currIfr) {
                            key = i;
                            handled = ifrDict.handled;
                        }
                    });
                    if (this.compareNodeIframe(node, prevNode, currIfr)) {
                        if (key === false && !handled) ifr.push({
                            val: currIfr,
                            handled: true
                        });
                        else if (key !== false && !handled) ifr[key].handled = true;
                        return true;
                    }
                    if (key === false) ifr.push({
                        val: currIfr,
                        handled: false
                    });
                    return false;
                }
            },
            {
                key: 'handleOpenIframes',
                value: function handleOpenIframes(ifr, whatToShow, eCb, fCb) {
                    var _this4 = this;
                    ifr.forEach(function(ifrDict) {
                        if (!ifrDict.handled) _this4.getIframeContents(ifrDict.val, function(con) {
                            _this4.createInstanceOnIframe(con).forEachNode(whatToShow, eCb, fCb);
                        });
                    });
                }
            },
            {
                key: 'iterateThroughNodes',
                value: function iterateThroughNodes(whatToShow, ctx, eachCb, filterCb, doneCb) {
                    var _this5 = this;
                    var itr = this.createIterator(ctx, whatToShow, filterCb);
                    var ifr = [], elements = [], node = void 0, prevNode = void 0, retrieveNodes = function retrieveNodes() {
                        var _getIteratorNode = _this5.getIteratorNode(itr);
                        prevNode = _getIteratorNode.prevNode;
                        node = _getIteratorNode.node;
                        return node;
                    };
                    while(retrieveNodes()){
                        if (this.iframes) this.forEachIframe(ctx, function(currIfr) {
                            return _this5.checkIframeFilter(node, prevNode, currIfr, ifr);
                        }, function(con) {
                            _this5.createInstanceOnIframe(con).forEachNode(whatToShow, function(ifrNode) {
                                return elements.push(ifrNode);
                            }, filterCb);
                        });
                        elements.push(node);
                    }
                    elements.forEach(function(node) {
                        eachCb(node);
                    });
                    if (this.iframes) this.handleOpenIframes(ifr, whatToShow, eachCb, filterCb);
                    doneCb();
                }
            },
            {
                key: 'forEachNode',
                value: function forEachNode(whatToShow, each, filter) {
                    var _this6 = this;
                    var done = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function() {};
                    var contexts = this.getContexts();
                    var open = contexts.length;
                    if (!open) done();
                    contexts.forEach(function(ctx) {
                        var ready = function ready() {
                            _this6.iterateThroughNodes(whatToShow, ctx, each, filter, function() {
                                if (--open <= 0) done();
                            });
                        };
                        if (_this6.iframes) _this6.waitForIframes(ctx, ready);
                        else ready();
                    });
                }
            }
        ], [
            {
                key: 'matches',
                value: function matches(element, selector) {
                    var selectors = typeof selector === 'string' ? [
                        selector
                    ] : selector, fn = element.matches || element.matchesSelector || element.msMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.webkitMatchesSelector;
                    if (fn) {
                        var match = false;
                        selectors.every(function(sel) {
                            if (fn.call(element, sel)) {
                                match = true;
                                return false;
                            }
                            return true;
                        });
                        return match;
                    } else return false;
                }
            }
        ]);
        return DOMIterator;
    }();
    var Mark$1 = function() {
        function Mark(ctx) {
            classCallCheck(this, Mark);
            this.ctx = ctx;
            this.ie = false;
            var ua = window.navigator.userAgent;
            if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1) this.ie = true;
        }
        createClass(Mark, [
            {
                key: 'log',
                value: function log(msg) {
                    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'debug';
                    var log = this.opt.log;
                    if (!this.opt.debug) return;
                    if ((typeof log === 'undefined' ? 'undefined' : _typeof(log)) === 'object' && typeof log[level] === 'function') log[level]('mark.js: ' + msg);
                }
            },
            {
                key: 'escapeStr',
                value: function escapeStr(str) {
                    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
                }
            },
            {
                key: 'createRegExp',
                value: function createRegExp(str) {
                    if (this.opt.wildcards !== 'disabled') str = this.setupWildcardsRegExp(str);
                    str = this.escapeStr(str);
                    if (Object.keys(this.opt.synonyms).length) str = this.createSynonymsRegExp(str);
                    if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) str = this.setupIgnoreJoinersRegExp(str);
                    if (this.opt.diacritics) str = this.createDiacriticsRegExp(str);
                    str = this.createMergedBlanksRegExp(str);
                    if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) str = this.createJoinersRegExp(str);
                    if (this.opt.wildcards !== 'disabled') str = this.createWildcardsRegExp(str);
                    str = this.createAccuracyRegExp(str);
                    return str;
                }
            },
            {
                key: 'createSynonymsRegExp',
                value: function createSynonymsRegExp(str) {
                    var syn = this.opt.synonyms, sens = this.opt.caseSensitive ? '' : 'i', joinerPlaceholder = this.opt.ignoreJoiners || this.opt.ignorePunctuation.length ? '\0' : '';
                    for(var index in syn)if (syn.hasOwnProperty(index)) {
                        var value = syn[index], k1 = this.opt.wildcards !== 'disabled' ? this.setupWildcardsRegExp(index) : this.escapeStr(index), k2 = this.opt.wildcards !== 'disabled' ? this.setupWildcardsRegExp(value) : this.escapeStr(value);
                        if (k1 !== '' && k2 !== '') str = str.replace(new RegExp('(' + this.escapeStr(k1) + '|' + this.escapeStr(k2) + ')', 'gm' + sens), joinerPlaceholder + ('(' + this.processSynomyms(k1) + '|') + (this.processSynomyms(k2) + ')') + joinerPlaceholder);
                    }
                    return str;
                }
            },
            {
                key: 'processSynomyms',
                value: function processSynomyms(str) {
                    if (this.opt.ignoreJoiners || this.opt.ignorePunctuation.length) str = this.setupIgnoreJoinersRegExp(str);
                    return str;
                }
            },
            {
                key: 'setupWildcardsRegExp',
                value: function setupWildcardsRegExp(str) {
                    str = str.replace(/(?:\\)*\?/g, function(val) {
                        return val.charAt(0) === '\\' ? '?' : '\x01';
                    });
                    return str.replace(/(?:\\)*\*/g, function(val) {
                        return val.charAt(0) === '\\' ? '*' : '\x02';
                    });
                }
            },
            {
                key: 'createWildcardsRegExp',
                value: function createWildcardsRegExp(str) {
                    var spaces = this.opt.wildcards === 'withSpaces';
                    return str.replace(/\u0001/g, spaces ? '[\\S\\s]?' : '\\S?').replace(/\u0002/g, spaces ? '[\\S\\s]*?' : '\\S*');
                }
            },
            {
                key: 'setupIgnoreJoinersRegExp',
                value: function setupIgnoreJoinersRegExp(str) {
                    return str.replace(/[^(|)\\]/g, function(val, indx, original) {
                        var nextChar = original.charAt(indx + 1);
                        if (/[(|)\\]/.test(nextChar) || nextChar === '') return val;
                        else return val + '\0';
                    });
                }
            },
            {
                key: 'createJoinersRegExp',
                value: function createJoinersRegExp(str) {
                    var joiner = [];
                    var ignorePunctuation = this.opt.ignorePunctuation;
                    if (Array.isArray(ignorePunctuation) && ignorePunctuation.length) joiner.push(this.escapeStr(ignorePunctuation.join('')));
                    if (this.opt.ignoreJoiners) joiner.push('\\u00ad\\u200b\\u200c\\u200d');
                    return joiner.length ? str.split(/\u0000+/).join('[' + joiner.join('') + ']*') : str;
                }
            },
            {
                key: 'createDiacriticsRegExp',
                value: function createDiacriticsRegExp(str) {
                    var sens = this.opt.caseSensitive ? '' : 'i', dct = this.opt.caseSensitive ? [
                        "a\xe0\xe1\u1EA3\xe3\u1EA1\u0103\u1EB1\u1EAF\u1EB3\u1EB5\u1EB7\xe2\u1EA7\u1EA5\u1EA9\u1EAB\u1EAD\xe4\xe5\u0101\u0105",
                        "A\xc0\xc1\u1EA2\xc3\u1EA0\u0102\u1EB0\u1EAE\u1EB2\u1EB4\u1EB6\xc2\u1EA6\u1EA4\u1EA8\u1EAA\u1EAC\xc4\xc5\u0100\u0104",
                        "c\xe7\u0107\u010D",
                        "C\xc7\u0106\u010C",
                        "d\u0111\u010F",
                        "D\u0110\u010E",
                        "e\xe8\xe9\u1EBB\u1EBD\u1EB9\xea\u1EC1\u1EBF\u1EC3\u1EC5\u1EC7\xeb\u011B\u0113\u0119",
                        "E\xc8\xc9\u1EBA\u1EBC\u1EB8\xca\u1EC0\u1EBE\u1EC2\u1EC4\u1EC6\xcb\u011A\u0112\u0118",
                        "i\xec\xed\u1EC9\u0129\u1ECB\xee\xef\u012B",
                        "I\xcc\xcd\u1EC8\u0128\u1ECA\xce\xcf\u012A",
                        "l\u0142",
                        "L\u0141",
                        "n\xf1\u0148\u0144",
                        "N\xd1\u0147\u0143",
                        "o\xf2\xf3\u1ECF\xf5\u1ECD\xf4\u1ED3\u1ED1\u1ED5\u1ED7\u1ED9\u01A1\u1EDF\u1EE1\u1EDB\u1EDD\u1EE3\xf6\xf8\u014D",
                        "O\xd2\xd3\u1ECE\xd5\u1ECC\xd4\u1ED2\u1ED0\u1ED4\u1ED6\u1ED8\u01A0\u1EDE\u1EE0\u1EDA\u1EDC\u1EE2\xd6\xd8\u014C",
                        "r\u0159",
                        "R\u0158",
                        "s\u0161\u015B\u0219\u015F",
                        "S\u0160\u015A\u0218\u015E",
                        "t\u0165\u021B\u0163",
                        "T\u0164\u021A\u0162",
                        "u\xf9\xfa\u1EE7\u0169\u1EE5\u01B0\u1EEB\u1EE9\u1EED\u1EEF\u1EF1\xfb\xfc\u016F\u016B",
                        "U\xd9\xda\u1EE6\u0168\u1EE4\u01AF\u1EEA\u1EE8\u1EEC\u1EEE\u1EF0\xdb\xdc\u016E\u016A",
                        "y\xfd\u1EF3\u1EF7\u1EF9\u1EF5\xff",
                        "Y\xdd\u1EF2\u1EF6\u1EF8\u1EF4\u0178",
                        "z\u017E\u017C\u017A",
                        "Z\u017D\u017B\u0179"
                    ] : [
                        "a\xe0\xe1\u1EA3\xe3\u1EA1\u0103\u1EB1\u1EAF\u1EB3\u1EB5\u1EB7\xe2\u1EA7\u1EA5\u1EA9\u1EAB\u1EAD\xe4\xe5\u0101\u0105A\xc0\xc1\u1EA2\xc3\u1EA0\u0102\u1EB0\u1EAE\u1EB2\u1EB4\u1EB6\xc2\u1EA6\u1EA4\u1EA8\u1EAA\u1EAC\xc4\xc5\u0100\u0104",
                        "c\xe7\u0107\u010DC\xc7\u0106\u010C",
                        "d\u0111\u010FD\u0110\u010E",
                        "e\xe8\xe9\u1EBB\u1EBD\u1EB9\xea\u1EC1\u1EBF\u1EC3\u1EC5\u1EC7\xeb\u011B\u0113\u0119E\xc8\xc9\u1EBA\u1EBC\u1EB8\xca\u1EC0\u1EBE\u1EC2\u1EC4\u1EC6\xcb\u011A\u0112\u0118",
                        "i\xec\xed\u1EC9\u0129\u1ECB\xee\xef\u012BI\xcc\xcd\u1EC8\u0128\u1ECA\xce\xcf\u012A",
                        "l\u0142L\u0141",
                        "n\xf1\u0148\u0144N\xd1\u0147\u0143",
                        "o\xf2\xf3\u1ECF\xf5\u1ECD\xf4\u1ED3\u1ED1\u1ED5\u1ED7\u1ED9\u01A1\u1EDF\u1EE1\u1EDB\u1EDD\u1EE3\xf6\xf8\u014DO\xd2\xd3\u1ECE\xd5\u1ECC\xd4\u1ED2\u1ED0\u1ED4\u1ED6\u1ED8\u01A0\u1EDE\u1EE0\u1EDA\u1EDC\u1EE2\xd6\xd8\u014C",
                        "r\u0159R\u0158",
                        "s\u0161\u015B\u0219\u015FS\u0160\u015A\u0218\u015E",
                        "t\u0165\u021B\u0163T\u0164\u021A\u0162",
                        "u\xf9\xfa\u1EE7\u0169\u1EE5\u01B0\u1EEB\u1EE9\u1EED\u1EEF\u1EF1\xfb\xfc\u016F\u016BU\xd9\xda\u1EE6\u0168\u1EE4\u01AF\u1EEA\u1EE8\u1EEC\u1EEE\u1EF0\xdb\xdc\u016E\u016A",
                        "y\xfd\u1EF3\u1EF7\u1EF9\u1EF5\xffY\xdd\u1EF2\u1EF6\u1EF8\u1EF4\u0178",
                        "z\u017E\u017C\u017AZ\u017D\u017B\u0179"
                    ];
                    var handled = [];
                    str.split('').forEach(function(ch) {
                        dct.every(function(dct) {
                            if (dct.indexOf(ch) !== -1) {
                                if (handled.indexOf(dct) > -1) return false;
                                str = str.replace(new RegExp('[' + dct + ']', 'gm' + sens), '[' + dct + ']');
                                handled.push(dct);
                            }
                            return true;
                        });
                    });
                    return str;
                }
            },
            {
                key: 'createMergedBlanksRegExp',
                value: function createMergedBlanksRegExp(str) {
                    return str.replace(/[\s]+/gmi, '[\\s]+');
                }
            },
            {
                key: 'createAccuracyRegExp',
                value: function createAccuracyRegExp(str) {
                    var _this = this;
                    var chars = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~\xa1\xbf";
                    var acc = this.opt.accuracy, val = typeof acc === 'string' ? acc : acc.value, ls = typeof acc === 'string' ? [] : acc.limiters, lsJoin = '';
                    ls.forEach(function(limiter) {
                        lsJoin += '|' + _this.escapeStr(limiter);
                    });
                    switch(val){
                        case 'partially':
                        default:
                            return '()(' + str + ')';
                        case 'complementary':
                            lsJoin = '\\s' + (lsJoin ? lsJoin : this.escapeStr(chars));
                            return '()([^' + lsJoin + ']*' + str + '[^' + lsJoin + ']*)';
                        case 'exactly':
                            return '(^|\\s' + lsJoin + ')(' + str + ')(?=$|\\s' + lsJoin + ')';
                    }
                }
            },
            {
                key: 'getSeparatedKeywords',
                value: function getSeparatedKeywords(sv) {
                    var _this2 = this;
                    var stack = [];
                    sv.forEach(function(kw) {
                        if (!_this2.opt.separateWordSearch) {
                            if (kw.trim() && stack.indexOf(kw) === -1) stack.push(kw);
                        } else kw.split(' ').forEach(function(kwSplitted) {
                            if (kwSplitted.trim() && stack.indexOf(kwSplitted) === -1) stack.push(kwSplitted);
                        });
                    });
                    return {
                        'keywords': stack.sort(function(a, b) {
                            return b.length - a.length;
                        }),
                        'length': stack.length
                    };
                }
            },
            {
                key: 'isNumeric',
                value: function isNumeric(value) {
                    return Number(parseFloat(value)) == value;
                }
            },
            {
                key: 'checkRanges',
                value: function checkRanges(array) {
                    var _this3 = this;
                    if (!Array.isArray(array) || Object.prototype.toString.call(array[0]) !== '[object Object]') {
                        this.log('markRanges() will only accept an array of objects');
                        this.opt.noMatch(array);
                        return [];
                    }
                    var stack = [];
                    var last = 0;
                    array.sort(function(a, b) {
                        return a.start - b.start;
                    }).forEach(function(item) {
                        var _callNoMatchOnInvalid = _this3.callNoMatchOnInvalidRanges(item, last), start = _callNoMatchOnInvalid.start, end = _callNoMatchOnInvalid.end, valid = _callNoMatchOnInvalid.valid;
                        if (valid) {
                            item.start = start;
                            item.length = end - start;
                            stack.push(item);
                            last = end;
                        }
                    });
                    return stack;
                }
            },
            {
                key: 'callNoMatchOnInvalidRanges',
                value: function callNoMatchOnInvalidRanges(range, last) {
                    var start = void 0, end = void 0, valid = false;
                    if (range && typeof range.start !== 'undefined') {
                        start = parseInt(range.start, 10);
                        end = start + parseInt(range.length, 10);
                        if (this.isNumeric(range.start) && this.isNumeric(range.length) && end - last > 0 && end - start > 0) valid = true;
                        else {
                            this.log('Ignoring invalid or overlapping range: ' + ('' + JSON.stringify(range)));
                            this.opt.noMatch(range);
                        }
                    } else {
                        this.log('Ignoring invalid range: ' + JSON.stringify(range));
                        this.opt.noMatch(range);
                    }
                    return {
                        start: start,
                        end: end,
                        valid: valid
                    };
                }
            },
            {
                key: 'checkWhitespaceRanges',
                value: function checkWhitespaceRanges(range, originalLength, string) {
                    var end = void 0, valid = true, max = string.length, offset = originalLength - max, start = parseInt(range.start, 10) - offset;
                    start = start > max ? max : start;
                    end = start + parseInt(range.length, 10);
                    if (end > max) {
                        end = max;
                        this.log('End range automatically set to the max value of ' + max);
                    }
                    if (start < 0 || end - start < 0 || start > max || end > max) {
                        valid = false;
                        this.log('Invalid range: ' + JSON.stringify(range));
                        this.opt.noMatch(range);
                    } else if (string.substring(start, end).replace(/\s+/g, '') === '') {
                        valid = false;
                        this.log('Skipping whitespace only range: ' + JSON.stringify(range));
                        this.opt.noMatch(range);
                    }
                    return {
                        start: start,
                        end: end,
                        valid: valid
                    };
                }
            },
            {
                key: 'getTextNodes',
                value: function getTextNodes(cb) {
                    var _this4 = this;
                    var val = '', nodes = [];
                    this.iterator.forEachNode(NodeFilter.SHOW_TEXT, function(node) {
                        nodes.push({
                            start: val.length,
                            end: (val += node.textContent).length,
                            node: node
                        });
                    }, function(node) {
                        if (_this4.matchesExclude(node.parentNode)) return NodeFilter.FILTER_REJECT;
                        else return NodeFilter.FILTER_ACCEPT;
                    }, function() {
                        cb({
                            value: val,
                            nodes: nodes
                        });
                    });
                }
            },
            {
                key: 'matchesExclude',
                value: function matchesExclude(el) {
                    return DOMIterator.matches(el, this.opt.exclude.concat([
                        'script',
                        'style',
                        'title',
                        'head',
                        'html'
                    ]));
                }
            },
            {
                key: 'wrapRangeInTextNode',
                value: function wrapRangeInTextNode(node, start, end) {
                    var hEl = !this.opt.element ? 'mark' : this.opt.element, startNode = node.splitText(start), ret = startNode.splitText(end - start);
                    var repl = document.createElement(hEl);
                    repl.setAttribute('data-markjs', 'true');
                    if (this.opt.className) repl.setAttribute('class', this.opt.className);
                    repl.textContent = startNode.textContent;
                    startNode.parentNode.replaceChild(repl, startNode);
                    return ret;
                }
            },
            {
                key: 'wrapRangeInMappedTextNode',
                value: function wrapRangeInMappedTextNode(dict, start, end, filterCb, eachCb) {
                    var _this5 = this;
                    dict.nodes.every(function(n, i) {
                        var sibl = dict.nodes[i + 1];
                        if (typeof sibl === 'undefined' || sibl.start > start) {
                            if (!filterCb(n.node)) return false;
                            var s = start - n.start, e = (end > n.end ? n.end : end) - n.start, startStr = dict.value.substr(0, n.start), endStr = dict.value.substr(e + n.start);
                            n.node = _this5.wrapRangeInTextNode(n.node, s, e);
                            dict.value = startStr + endStr;
                            dict.nodes.forEach(function(k, j) {
                                if (j >= i) {
                                    if (dict.nodes[j].start > 0 && j !== i) dict.nodes[j].start -= e;
                                    dict.nodes[j].end -= e;
                                }
                            });
                            end -= e;
                            eachCb(n.node.previousSibling, n.start);
                            if (end > n.end) start = n.end;
                            else return false;
                        }
                        return true;
                    });
                }
            },
            {
                key: 'wrapMatches',
                value: function wrapMatches(regex, ignoreGroups, filterCb, eachCb, endCb) {
                    var _this6 = this;
                    var matchIdx = ignoreGroups === 0 ? 0 : ignoreGroups + 1;
                    this.getTextNodes(function(dict) {
                        dict.nodes.forEach(function(node) {
                            node = node.node;
                            var match = void 0;
                            while((match = regex.exec(node.textContent)) !== null && match[matchIdx] !== ''){
                                if (!filterCb(match[matchIdx], node)) continue;
                                var pos = match.index;
                                if (matchIdx !== 0) for(var i = 1; i < matchIdx; i++)pos += match[i].length;
                                node = _this6.wrapRangeInTextNode(node, pos, pos + match[matchIdx].length);
                                eachCb(node.previousSibling);
                                regex.lastIndex = 0;
                            }
                        });
                        endCb();
                    });
                }
            },
            {
                key: 'wrapMatchesAcrossElements',
                value: function wrapMatchesAcrossElements(regex, ignoreGroups, filterCb, eachCb, endCb) {
                    var _this7 = this;
                    var matchIdx = ignoreGroups === 0 ? 0 : ignoreGroups + 1;
                    this.getTextNodes(function(dict) {
                        var match = void 0;
                        while((match = regex.exec(dict.value)) !== null && match[matchIdx] !== ''){
                            var start = match.index;
                            if (matchIdx !== 0) for(var i = 1; i < matchIdx; i++)start += match[i].length;
                            var end = start + match[matchIdx].length;
                            _this7.wrapRangeInMappedTextNode(dict, start, end, function(node) {
                                return filterCb(match[matchIdx], node);
                            }, function(node, lastIndex) {
                                regex.lastIndex = lastIndex;
                                eachCb(node);
                            });
                        }
                        endCb();
                    });
                }
            },
            {
                key: 'wrapRangeFromIndex',
                value: function wrapRangeFromIndex(ranges, filterCb, eachCb, endCb) {
                    var _this8 = this;
                    this.getTextNodes(function(dict) {
                        var originalLength = dict.value.length;
                        ranges.forEach(function(range, counter) {
                            var _checkWhitespaceRange = _this8.checkWhitespaceRanges(range, originalLength, dict.value), start = _checkWhitespaceRange.start, end = _checkWhitespaceRange.end, valid = _checkWhitespaceRange.valid;
                            if (valid) _this8.wrapRangeInMappedTextNode(dict, start, end, function(node) {
                                return filterCb(node, range, dict.value.substring(start, end), counter);
                            }, function(node) {
                                eachCb(node, range);
                            });
                        });
                        endCb();
                    });
                }
            },
            {
                key: 'unwrapMatches',
                value: function unwrapMatches(node) {
                    var parent = node.parentNode;
                    var docFrag = document.createDocumentFragment();
                    while(node.firstChild)docFrag.appendChild(node.removeChild(node.firstChild));
                    parent.replaceChild(docFrag, node);
                    if (!this.ie) parent.normalize();
                    else this.normalizeTextNode(parent);
                }
            },
            {
                key: 'normalizeTextNode',
                value: function normalizeTextNode(node) {
                    if (!node) return;
                    if (node.nodeType === 3) while(node.nextSibling && node.nextSibling.nodeType === 3){
                        node.nodeValue += node.nextSibling.nodeValue;
                        node.parentNode.removeChild(node.nextSibling);
                    }
                    else this.normalizeTextNode(node.firstChild);
                    this.normalizeTextNode(node.nextSibling);
                }
            },
            {
                key: 'markRegExp',
                value: function markRegExp(regexp, opt) {
                    var _this9 = this;
                    this.opt = opt;
                    this.log('Searching with expression "' + regexp + '"');
                    var totalMatches = 0, fn = 'wrapMatches';
                    var eachCb = function eachCb(element) {
                        totalMatches++;
                        _this9.opt.each(element);
                    };
                    if (this.opt.acrossElements) fn = 'wrapMatchesAcrossElements';
                    this[fn](regexp, this.opt.ignoreGroups, function(match, node) {
                        return _this9.opt.filter(node, match, totalMatches);
                    }, eachCb, function() {
                        if (totalMatches === 0) _this9.opt.noMatch(regexp);
                        _this9.opt.done(totalMatches);
                    });
                }
            },
            {
                key: 'mark',
                value: function mark(sv, opt) {
                    var _this10 = this;
                    this.opt = opt;
                    var totalMatches = 0, fn = 'wrapMatches';
                    var _getSeparatedKeywords = this.getSeparatedKeywords(typeof sv === 'string' ? [
                        sv
                    ] : sv), kwArr = _getSeparatedKeywords.keywords, kwArrLen = _getSeparatedKeywords.length, sens = this.opt.caseSensitive ? '' : 'i', handler = function handler(kw) {
                        var regex = new RegExp(_this10.createRegExp(kw), 'gm' + sens), matches = 0;
                        _this10.log('Searching with expression "' + regex + '"');
                        _this10[fn](regex, 1, function(term, node) {
                            return _this10.opt.filter(node, kw, totalMatches, matches);
                        }, function(element) {
                            matches++;
                            totalMatches++;
                            _this10.opt.each(element);
                        }, function() {
                            if (matches === 0) _this10.opt.noMatch(kw);
                            if (kwArr[kwArrLen - 1] === kw) _this10.opt.done(totalMatches);
                            else handler(kwArr[kwArr.indexOf(kw) + 1]);
                        });
                    };
                    if (this.opt.acrossElements) fn = 'wrapMatchesAcrossElements';
                    if (kwArrLen === 0) this.opt.done(totalMatches);
                    else handler(kwArr[0]);
                }
            },
            {
                key: 'markRanges',
                value: function markRanges(rawRanges, opt) {
                    var _this11 = this;
                    this.opt = opt;
                    var totalMatches = 0, ranges = this.checkRanges(rawRanges);
                    if (ranges && ranges.length) {
                        this.log('Starting to mark with the following ranges: ' + JSON.stringify(ranges));
                        this.wrapRangeFromIndex(ranges, function(node, range, match, counter) {
                            return _this11.opt.filter(node, range, match, counter);
                        }, function(element, range) {
                            totalMatches++;
                            _this11.opt.each(element, range);
                        }, function() {
                            _this11.opt.done(totalMatches);
                        });
                    } else this.opt.done(totalMatches);
                }
            },
            {
                key: 'unmark',
                value: function unmark(opt) {
                    var _this12 = this;
                    this.opt = opt;
                    var sel = this.opt.element ? this.opt.element : '*';
                    sel += '[data-markjs]';
                    if (this.opt.className) sel += '.' + this.opt.className;
                    this.log('Removal selector "' + sel + '"');
                    this.iterator.forEachNode(NodeFilter.SHOW_ELEMENT, function(node) {
                        _this12.unwrapMatches(node);
                    }, function(node) {
                        var matchesSel = DOMIterator.matches(node, sel), matchesExclude = _this12.matchesExclude(node);
                        if (!matchesSel || matchesExclude) return NodeFilter.FILTER_REJECT;
                        else return NodeFilter.FILTER_ACCEPT;
                    }, this.opt.done);
                }
            },
            {
                key: 'opt',
                set: function set$$1(val) {
                    this._opt = _extends({}, {
                        'element': '',
                        'className': '',
                        'exclude': [],
                        'iframes': false,
                        'iframesTimeout': 5000,
                        'separateWordSearch': true,
                        'diacritics': true,
                        'synonyms': {},
                        'accuracy': 'partially',
                        'acrossElements': false,
                        'caseSensitive': false,
                        'ignoreJoiners': false,
                        'ignoreGroups': 0,
                        'ignorePunctuation': [],
                        'wildcards': 'disabled',
                        'each': function each() {},
                        'noMatch': function noMatch() {},
                        'filter': function filter() {
                            return true;
                        },
                        'done': function done() {},
                        'debug': false,
                        'log': window.console
                    }, val);
                },
                get: function get$$1() {
                    return this._opt;
                }
            },
            {
                key: 'iterator',
                get: function get$$1() {
                    return new DOMIterator(this.ctx, this.opt.iframes, this.opt.exclude, this.opt.iframesTimeout);
                }
            }
        ]);
        return Mark;
    }();
    function Mark(ctx) {
        var _this = this;
        var instance = new Mark$1(ctx);
        this.mark = function(sv, opt) {
            instance.mark(sv, opt);
            return _this;
        };
        this.markRegExp = function(sv, opt) {
            instance.markRegExp(sv, opt);
            return _this;
        };
        this.markRanges = function(sv, opt) {
            instance.markRanges(sv, opt);
            return _this;
        };
        this.unmark = function(opt) {
            instance.unmark(opt);
            return _this;
        };
        return this;
    }
    return Mark;
});

});

parcelRegister("cSkKB", function(module, exports) {

$parcel$export(module.exports, "_samplers", () => $95fa9fd532f60536$export$8f55d179934d00f9);
$parcel$export(module.exports, "sample", () => $95fa9fd532f60536$export$4812e460280c6ef2);
$parcel$export(module.exports, "_registerSampler", () => $95fa9fd532f60536$export$38f33c28b79c82af);
$parcel$export(module.exports, "inferType", () => (parcelRequire("kFHAI")).inferType);

var $6yHxM = parcelRequire("6yHxM");
parcelRequire("dKB4A");
var $eoqXW = parcelRequire("eoqXW");
var $fzPb5 = parcelRequire("fzPb5");
var $aVT3W = parcelRequire("aVT3W");
var $8nFC9 = parcelRequire("8nFC9");
var $arslT = parcelRequire("arslT");

var $3JI82 = parcelRequire("3JI82");

var $kFHAI = parcelRequire("kFHAI");
var $95fa9fd532f60536$export$8f55d179934d00f9 = {};
const $95fa9fd532f60536$var$defaults = {
    skipReadOnly: false,
    maxSampleDepth: 15
};
function $95fa9fd532f60536$var$convertJsonToXml(obj, schema) {
    if (!obj) throw new Error('Unknown format output for building XML.');
    if (Array.isArray(obj) || Object.keys(obj).length > 1) obj = {
        [schema?.xml?.name || 'root']: obj
    }; // XML document must contain one root element
    const builder = new (0, $3JI82.XMLBuilder)({
        ignoreAttributes: false,
        format: true,
        attributeNamePrefix: '$',
        textNodeName: '#text'
    });
    return builder.build(obj);
}
function $95fa9fd532f60536$export$4812e460280c6ef2(schema, options, spec) {
    let opts = Object.assign({}, $95fa9fd532f60536$var$defaults, options);
    (0, $6yHxM.clearCache)();
    let result = (0, $6yHxM.traverse)(schema, opts, spec).value;
    if (opts?.format === 'xml') return $95fa9fd532f60536$var$convertJsonToXml(result, schema);
    return result;
}
function $95fa9fd532f60536$export$38f33c28b79c82af(type, sampler) {
    $95fa9fd532f60536$export$8f55d179934d00f9[type] = sampler;
}
$95fa9fd532f60536$export$38f33c28b79c82af('array', (0, $eoqXW.sampleArray));
$95fa9fd532f60536$export$38f33c28b79c82af('boolean', (0, $fzPb5.sampleBoolean));
$95fa9fd532f60536$export$38f33c28b79c82af('integer', (0, $aVT3W.sampleNumber));
$95fa9fd532f60536$export$38f33c28b79c82af('number', (0, $aVT3W.sampleNumber));
$95fa9fd532f60536$export$38f33c28b79c82af('object', (0, $8nFC9.sampleObject));
$95fa9fd532f60536$export$38f33c28b79c82af('string', (0, $arslT.sampleString));

});
parcelRegister("6yHxM", function(module, exports) {

$parcel$export(module.exports, "clearCache", () => $4c67b1eea4f96eb1$export$d2adf65b87e47523);
$parcel$export(module.exports, "traverse", () => $4c67b1eea4f96eb1$export$df3f009e3d155b20);

var $cSkKB = parcelRequire("cSkKB");

var $gOL1T = parcelRequire("gOL1T");

var $kFHAI = parcelRequire("kFHAI");

var $etOhm = parcelRequire("etOhm");

var $jAmc6 = parcelRequire("jAmc6");
let $4c67b1eea4f96eb1$var$$refCache = {};
// for circular JS references we use additional array and not object as we need to compare entire schemas and not strings
let $4c67b1eea4f96eb1$var$seenSchemasStack = [];
function $4c67b1eea4f96eb1$export$d2adf65b87e47523() {
    $4c67b1eea4f96eb1$var$$refCache = {};
    $4c67b1eea4f96eb1$var$seenSchemasStack = [];
}
function $4c67b1eea4f96eb1$var$inferExample(schema) {
    let example;
    if (schema.const !== undefined) example = schema.const;
    else if (schema.examples !== undefined && schema.examples.length) example = schema.examples[0];
    else if (schema.enum !== undefined && schema.enum.length) example = schema.enum[0];
    else if (schema.default !== undefined) example = schema.default;
    return example;
}
function $4c67b1eea4f96eb1$var$tryInferExample(schema) {
    const example = $4c67b1eea4f96eb1$var$inferExample(schema);
    // case when we don't infer example from schema but take from `const`, `examples`, `default` or `enum` keywords
    if (example !== undefined) return {
        value: example,
        readOnly: schema.readOnly,
        writeOnly: schema.writeOnly,
        type: null
    };
    return;
}
function $4c67b1eea4f96eb1$export$df3f009e3d155b20(schema, options, spec, context) {
    // checking circular JS references by checking context
    // because context is passed only when traversing through nested objects happens
    if (context) {
        if ($4c67b1eea4f96eb1$var$seenSchemasStack.includes(schema)) return (0, $etOhm.getResultForCircular)((0, $kFHAI.inferType)(schema));
        $4c67b1eea4f96eb1$var$seenSchemasStack.push(schema);
    }
    if (context && context.depth > options.maxSampleDepth) {
        (0, $etOhm.popSchemaStack)($4c67b1eea4f96eb1$var$seenSchemasStack, context);
        return (0, $etOhm.getResultForCircular)((0, $kFHAI.inferType)(schema));
    }
    if (schema.$ref) {
        if (!spec) throw new Error('Your schema contains $ref. You must provide full specification in the third parameter.');
        let ref = decodeURIComponent(schema.$ref);
        if (ref.startsWith('#')) ref = ref.substring(1);
        const referenced = (0, (/*@__PURE__*/$parcel$interopDefault($jAmc6))).get(spec, ref);
        let result;
        if ($4c67b1eea4f96eb1$var$$refCache[ref] !== true) {
            $4c67b1eea4f96eb1$var$$refCache[ref] = true;
            const traverseResult = $4c67b1eea4f96eb1$export$df3f009e3d155b20(referenced, options, spec, context);
            if (options.format === 'xml') {
                const { propertyName: propertyName, value: value } = (0, $etOhm.applyXMLAttributes)(traverseResult, referenced, context);
                result = {
                    ...traverseResult,
                    value: {
                        [propertyName || 'root']: value
                    }
                };
            } else result = traverseResult;
            $4c67b1eea4f96eb1$var$$refCache[ref] = false;
        } else {
            const referencedType = (0, $kFHAI.inferType)(referenced);
            result = (0, $etOhm.getResultForCircular)(referencedType);
        }
        (0, $etOhm.popSchemaStack)($4c67b1eea4f96eb1$var$seenSchemasStack, context);
        return result;
    }
    if (schema.example !== undefined) {
        (0, $etOhm.popSchemaStack)($4c67b1eea4f96eb1$var$seenSchemasStack, context);
        return {
            value: schema.example,
            readOnly: schema.readOnly,
            writeOnly: schema.writeOnly,
            type: schema.type
        };
    }
    if (schema.allOf !== undefined) {
        (0, $etOhm.popSchemaStack)($4c67b1eea4f96eb1$var$seenSchemasStack, context);
        return $4c67b1eea4f96eb1$var$tryInferExample(schema) || (0, $gOL1T.allOfSample)({
            ...schema,
            allOf: undefined
        }, schema.allOf, options, spec, context);
    }
    if (schema.oneOf && schema.oneOf.length) {
        if (schema.anyOf) {
            if (!options.quiet) console.warn('oneOf and anyOf are not supported on the same level. Skipping anyOf');
        }
        (0, $etOhm.popSchemaStack)($4c67b1eea4f96eb1$var$seenSchemasStack, context);
        // Make sure to pass down readOnly and writeOnly annotations from the parent
        const firstOneOf = Object.assign({
            readOnly: schema.readOnly,
            writeOnly: schema.writeOnly
        }, schema.oneOf[0]);
        return traverseOneOrAnyOf(schema, firstOneOf);
    }
    if (schema.anyOf && schema.anyOf.length) {
        (0, $etOhm.popSchemaStack)($4c67b1eea4f96eb1$var$seenSchemasStack, context);
        // Make sure to pass down readOnly and writeOnly annotations from the parent
        const firstAnyOf = Object.assign({
            readOnly: schema.readOnly,
            writeOnly: schema.writeOnly
        }, schema.anyOf[0]);
        return traverseOneOrAnyOf(schema, firstAnyOf);
    }
    if (schema.if && schema.then) {
        (0, $etOhm.popSchemaStack)($4c67b1eea4f96eb1$var$seenSchemasStack, context);
        const { if: ifSchema, then: then, ...rest } = schema;
        return $4c67b1eea4f96eb1$export$df3f009e3d155b20((0, $etOhm.mergeDeep)(rest, ifSchema, then), options, spec, context);
    }
    let example = $4c67b1eea4f96eb1$var$inferExample(schema);
    let type = null;
    if (example === undefined) {
        example = null;
        type = schema.type;
        if (Array.isArray(type) && schema.type.length > 0) type = schema.type[0];
        if (!type) type = (0, $kFHAI.inferType)(schema);
        let sampler = (0, $cSkKB._samplers)[type];
        if (sampler) example = sampler(schema, options, spec, context);
    }
    (0, $etOhm.popSchemaStack)($4c67b1eea4f96eb1$var$seenSchemasStack, context);
    return {
        value: example,
        readOnly: schema.readOnly,
        writeOnly: schema.writeOnly,
        type: type
    };
    function traverseOneOrAnyOf(schema, selectedSubSchema) {
        const inferred = $4c67b1eea4f96eb1$var$tryInferExample(schema);
        if (inferred !== undefined) return inferred;
        const localExample = $4c67b1eea4f96eb1$export$df3f009e3d155b20({
            ...schema,
            oneOf: undefined,
            anyOf: undefined
        }, options, spec, context);
        const subSchemaExample = $4c67b1eea4f96eb1$export$df3f009e3d155b20(selectedSubSchema, options, spec, context);
        if (typeof localExample.value === 'object' && typeof subSchemaExample.value === 'object') {
            const mergedExample = (0, $etOhm.mergeDeep)(localExample.value, subSchemaExample.value);
            return {
                ...subSchemaExample,
                value: mergedExample
            };
        }
        return subSchemaExample;
    }
}

});
parcelRegister("gOL1T", function(module, exports) {

$parcel$export(module.exports, "allOfSample", () => $c3e5cbebe205eb10$export$baffc289e1ccdd8a);

var $6yHxM = parcelRequire("6yHxM");

var $etOhm = parcelRequire("etOhm");
function $c3e5cbebe205eb10$export$baffc289e1ccdd8a(into, children, options, spec, context) {
    let res = (0, $6yHxM.traverse)(into, options, spec);
    const subSamples = [];
    for (let subSchema of children){
        const { type: type, readOnly: readOnly, writeOnly: writeOnly, value: value } = (0, $6yHxM.traverse)({
            type: res.type,
            ...subSchema
        }, options, spec, {
            ...context,
            isAllOfChild: true
        });
        if (res.type && type && type !== res.type) {
            console.warn('allOf: schemas with different types can\'t be merged');
            res.type = type;
        }
        res.type = res.type || type;
        res.readOnly = res.readOnly || readOnly;
        res.writeOnly = res.writeOnly || writeOnly;
        if (value != null) subSamples.push(value);
    }
    if (res.type === 'object') {
        res.value = (0, $etOhm.mergeDeep)(res.value || {}, ...subSamples.filter((sample)=>typeof sample === 'object'));
        for(const key in res.value)if (res.value[key] === (0, $etOhm.SKIP_SYMBOL)) delete res.value[key];
        return res;
    } else {
        if (res.type === 'array') // TODO: implement arrays
        {
            if (!options.quiet) console.warn('OpenAPI Sampler: found allOf with "array" type. Result may be incorrect');
        }
        const lastSample = subSamples[subSamples.length - 1];
        res.value = lastSample != null ? lastSample : res.value;
        return res;
    }
}

});
parcelRegister("etOhm", function(module, exports) {

$parcel$export(module.exports, "SKIP_SYMBOL", () => $a8aac680a3cdb4b9$export$657f9ecc0979c885);
$parcel$export(module.exports, "toRFCDateTime", () => $a8aac680a3cdb4b9$export$e25fc87cdc7c5822);
$parcel$export(module.exports, "ensureMinLength", () => $a8aac680a3cdb4b9$export$d6bdd11fb8806985);
$parcel$export(module.exports, "mergeDeep", () => $a8aac680a3cdb4b9$export$dd702b3c8240390c);
$parcel$export(module.exports, "uuid", () => $a8aac680a3cdb4b9$export$31b40729666a4ae0);
$parcel$export(module.exports, "getResultForCircular", () => $a8aac680a3cdb4b9$export$3f6cbbf5e1ada279);
$parcel$export(module.exports, "popSchemaStack", () => $a8aac680a3cdb4b9$export$40cd910b5802f234);
$parcel$export(module.exports, "applyXMLAttributes", () => $a8aac680a3cdb4b9$export$f4d6411c5e800357);
'use strict';
const $a8aac680a3cdb4b9$export$657f9ecc0979c885 = Symbol('skip');
function $a8aac680a3cdb4b9$var$pad(number) {
    if (number < 10) return '0' + number;
    return number;
}
function $a8aac680a3cdb4b9$export$e25fc87cdc7c5822(date, omitTime, omitDate, milliseconds) {
    var res = omitDate ? '' : date.getUTCFullYear() + '-' + $a8aac680a3cdb4b9$var$pad(date.getUTCMonth() + 1) + '-' + $a8aac680a3cdb4b9$var$pad(date.getUTCDate());
    if (!omitTime) res += 'T' + $a8aac680a3cdb4b9$var$pad(date.getUTCHours()) + ':' + $a8aac680a3cdb4b9$var$pad(date.getUTCMinutes()) + ':' + $a8aac680a3cdb4b9$var$pad(date.getUTCSeconds()) + (milliseconds ? '.' + (date.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) : '') + 'Z';
    return res;
}
function $a8aac680a3cdb4b9$export$d6bdd11fb8806985(sample, min) {
    if (min > sample.length) return sample.repeat(Math.trunc(min / sample.length) + 1).substring(0, min);
    return sample;
}
function $a8aac680a3cdb4b9$export$dd702b3c8240390c(...objects) {
    const isObject = (obj)=>obj && typeof obj === 'object';
    return objects.reduce((prev, obj)=>{
        Object.keys(obj || {}).forEach((key)=>{
            const pVal = prev[key];
            const oVal = obj[key];
            if (isObject(pVal) && isObject(oVal)) prev[key] = $a8aac680a3cdb4b9$export$dd702b3c8240390c(pVal, oVal);
            else prev[key] = oVal;
        });
        return prev;
    }, Array.isArray(objects[objects.length - 1]) ? [] : {});
}
function $a8aac680a3cdb4b9$export$31b40729666a4ae0(str) {
    var hash = $a8aac680a3cdb4b9$var$hashCode(str);
    var random = $a8aac680a3cdb4b9$var$jsf32(hash, hash, hash, hash);
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        var r = random() * 16 % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
    return uuid;
}
function $a8aac680a3cdb4b9$export$3f6cbbf5e1ada279(type) {
    return {
        value: type === 'object' ? {} : type === 'array' ? [] : undefined
    };
}
function $a8aac680a3cdb4b9$export$40cd910b5802f234(seenSchemasStack, context) {
    if (context) seenSchemasStack.pop();
}
function $a8aac680a3cdb4b9$export$7aad55eb26cdfd03(schema) {
    return {
        name: schema?.xml?.name || '',
        prefix: schema?.xml?.prefix || '',
        namespace: schema?.xml?.namespace || null,
        attribute: schema?.xml?.attribute ?? false,
        wrapped: schema?.xml?.wrapped ?? false
    };
}
function $a8aac680a3cdb4b9$export$f4d6411c5e800357(result, schema = {}, context = {}) {
    const { value: oldValue } = result;
    const { propertyName: oldPropertyName } = context;
    const { name: name, prefix: prefix, namespace: namespace, attribute: attribute, wrapped: wrapped } = $a8aac680a3cdb4b9$export$7aad55eb26cdfd03(schema);
    let propertyName = name || oldPropertyName ? `${prefix ? prefix + ':' : ''}${name || oldPropertyName}` : null;
    let value = typeof oldValue === 'object' ? Array.isArray(oldValue) ? [
        ...oldValue
    ] : {
        ...oldValue
    } : oldValue;
    if (attribute && propertyName) propertyName = `$${propertyName}`;
    if (namespace) {
        if (typeof value === 'object') value[`$xmlns${prefix ? ':' + prefix : ''}`] = namespace;
        else value = {
            [`$xmlns${prefix ? ':' + prefix : ''}`]: namespace,
            ['#text']: value
        };
    }
    if (schema.type === 'array') {
        if (wrapped && Array.isArray(value)) value = {
            [propertyName]: [
                ...value
            ]
        };
        if (!wrapped) propertyName = null;
        if (schema.example !== undefined && !wrapped) propertyName = schema.items?.xml?.name || propertyName;
    }
    if (schema.oneOf || schema.anyOf || schema.allOf || schema.$ref) propertyName = null;
    return {
        propertyName: propertyName,
        value: value
    };
}
function $a8aac680a3cdb4b9$var$hashCode(str) {
    var hash = 0;
    if (str.length == 0) return hash;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    return hash;
}
function $a8aac680a3cdb4b9$var$jsf32(a, b, c, d) {
    return function() {
        a |= 0;
        b |= 0;
        c |= 0;
        d |= 0;
        var t = a - (b << 27 | b >>> 5) | 0;
        a = b ^ (c << 17 | c >>> 15);
        b = c + d | 0;
        c = d + t | 0;
        d = a + t | 0;
        return (d >>> 0) / 4294967296;
    };
}

});


parcelRegister("kFHAI", function(module, exports) {

$parcel$export(module.exports, "inferType", () => $f0c97348aead4d7b$export$8af023fe1de7a979);
const $f0c97348aead4d7b$var$schemaKeywordTypes = {
    multipleOf: 'number',
    maximum: 'number',
    exclusiveMaximum: 'number',
    minimum: 'number',
    exclusiveMinimum: 'number',
    maxLength: 'string',
    minLength: 'string',
    pattern: 'string',
    items: 'array',
    maxItems: 'array',
    minItems: 'array',
    uniqueItems: 'array',
    additionalItems: 'array',
    maxProperties: 'object',
    minProperties: 'object',
    required: 'object',
    additionalProperties: 'object',
    properties: 'object',
    patternProperties: 'object',
    dependencies: 'object'
};
function $f0c97348aead4d7b$export$8af023fe1de7a979(schema) {
    if (schema.type !== undefined) return Array.isArray(schema.type) ? schema.type.length === 0 ? null : schema.type[0] : schema.type;
    const keywords = Object.keys($f0c97348aead4d7b$var$schemaKeywordTypes);
    for(var i = 0; i < keywords.length; i++){
        let keyword = keywords[i];
        let type = $f0c97348aead4d7b$var$schemaKeywordTypes[keyword];
        if (schema[keyword] !== undefined) return type;
    }
    return null;
}

});


parcelRegister("dKB4A", function(module, exports) {

$parcel$export(module.exports, "sampleArray", () => (parcelRequire("eoqXW")).sampleArray);
$parcel$export(module.exports, "sampleBoolean", () => (parcelRequire("fzPb5")).sampleBoolean);
$parcel$export(module.exports, "sampleNumber", () => (parcelRequire("aVT3W")).sampleNumber);
$parcel$export(module.exports, "sampleObject", () => (parcelRequire("8nFC9")).sampleObject);
$parcel$export(module.exports, "sampleString", () => (parcelRequire("arslT")).sampleString);

var $eoqXW = parcelRequire("eoqXW");

var $fzPb5 = parcelRequire("fzPb5");

var $aVT3W = parcelRequire("aVT3W");

var $8nFC9 = parcelRequire("8nFC9");

var $arslT = parcelRequire("arslT");

});
parcelRegister("eoqXW", function(module, exports) {

$parcel$export(module.exports, "sampleArray", () => $a7a8396eec024bf7$export$ef3962dc08b457ea);

var $6yHxM = parcelRequire("6yHxM");

var $etOhm = parcelRequire("etOhm");
function $a7a8396eec024bf7$export$ef3962dc08b457ea(schema, options = {}, spec, context) {
    const depth = context && context.depth || 1;
    let arrayLength = Math.min(schema.maxItems != undefined ? schema.maxItems : Infinity, schema.minItems || 1);
    // for the sake of simplicity, we're treating `contains` in a similar way to `items`
    const items = schema.prefixItems || schema.items || schema.contains;
    if (Array.isArray(items)) arrayLength = Math.max(arrayLength, items.length);
    let itemSchemaGetter = (itemNumber)=>{
        if (Array.isArray(items)) return items[itemNumber] || {};
        return items || {};
    };
    let res = [];
    if (!items) return res;
    for(let i = 0; i < arrayLength; i++){
        let itemSchema = itemSchemaGetter(i);
        let { value: sample } = (0, $6yHxM.traverse)(itemSchema, options, spec, {
            depth: depth + 1
        });
        if (options?.format === 'xml') {
            const { value: value, propertyName: propertyName } = (0, $etOhm.applyXMLAttributes)({
                value: sample
            }, itemSchema, context);
            if (propertyName) {
                if (!res?.[propertyName]) res = {
                    ...res,
                    [propertyName]: []
                };
                res[propertyName].push(value);
            } else res = {
                ...res,
                ...value
            };
        } else res.push(sample);
    }
    if (options?.format === 'xml' && depth === 1) {
        const { value: value, propertyName: propertyName } = (0, $etOhm.applyXMLAttributes)({
            value: null
        }, schema, context);
        if (propertyName) {
            if (value) res = Array.isArray(res) ? {
                [propertyName]: {
                    ...value,
                    ...res.map((item)=>({
                            ['#text']: {
                                ...item
                            }
                        }))
                }
            } : {
                [propertyName]: {
                    ...res,
                    ...value
                }
            };
            else res = {
                [propertyName]: res
            };
        }
    }
    return res;
}

});

parcelRegister("fzPb5", function(module, exports) {

$parcel$export(module.exports, "sampleBoolean", () => $b571d2c58186858f$export$702242802954108);
function $b571d2c58186858f$export$702242802954108(schema) {
    return true; // let be optimistic :)
}

});

parcelRegister("aVT3W", function(module, exports) {

$parcel$export(module.exports, "sampleNumber", () => $7f59f08f0f274eb5$export$dda3274d649921c8);
function $7f59f08f0f274eb5$export$dda3274d649921c8(schema) {
    let res = 0;
    if (schema.type === 'number' && (schema.format === 'float' || schema.format === 'double')) res = 0.1;
    if (typeof schema.exclusiveMinimum === 'boolean' || typeof schema.exclusiveMaximum === 'boolean') {
        if (schema.maximum && schema.minimum) {
            res = schema.exclusiveMinimum ? Math.floor(schema.minimum) + 1 : schema.minimum;
            if (schema.exclusiveMaximum && res >= schema.maximum || !schema.exclusiveMaximum && res > schema.maximum) res = (schema.maximum + schema.minimum) / 2;
            return res;
        }
        if (schema.minimum) {
            if (schema.exclusiveMinimum) return Math.floor(schema.minimum) + 1;
            else return schema.minimum;
        }
        if (schema.maximum) {
            if (schema.exclusiveMaximum) return schema.maximum > 0 ? 0 : Math.floor(schema.maximum) - 1;
            else return schema.maximum > 0 ? 0 : schema.maximum;
        }
    } else {
        if (schema.minimum) return schema.minimum;
        if (schema.exclusiveMinimum) {
            res = Math.floor(schema.exclusiveMinimum) + 1;
            if (res === schema.exclusiveMaximum) res = (res + Math.floor(schema.exclusiveMaximum) - 1) / 2;
        } else if (schema.exclusiveMaximum) res = Math.floor(schema.exclusiveMaximum) - 1;
        else if (schema.maximum) res = schema.maximum;
    }
    return res;
}

});

parcelRegister("8nFC9", function(module, exports) {

$parcel$export(module.exports, "sampleObject", () => $61a0c07590a82730$export$72fd1f43d47d8905);

var $6yHxM = parcelRequire("6yHxM");

var $etOhm = parcelRequire("etOhm");
function $61a0c07590a82730$export$72fd1f43d47d8905(schema, options = {}, spec, context) {
    let res = {};
    const depth = context && context.depth || 1;
    if (schema && typeof schema.properties === 'object') {
        // Prepare for skipNonRequired option
        const requiredProperties = Array.isArray(schema.required) ? schema.required : [];
        const requiredPropertiesMap = {};
        for (const requiredProperty of requiredProperties)requiredPropertiesMap[requiredProperty] = true;
        Object.keys(schema.properties).forEach((propertyName)=>{
            // skip before traverse that could be costly
            if (options.skipNonRequired && !requiredPropertiesMap.hasOwnProperty(propertyName)) return;
            const sample = (0, $6yHxM.traverse)(schema.properties[propertyName], options, spec, {
                propertyName: propertyName,
                depth: depth + 1
            });
            if (options.skipReadOnly && sample.readOnly) {
                if (context?.isAllOfChild) res[propertyName] = (0, $etOhm.SKIP_SYMBOL);
                return;
            }
            if (options.skipWriteOnly && sample.writeOnly) {
                if (context?.isAllOfChild) res[propertyName] = (0, $etOhm.SKIP_SYMBOL);
                return;
            }
            if (options?.format === 'xml') {
                const { propertyName: newPropertyName, value: value } = (0, $etOhm.applyXMLAttributes)(sample, schema.properties[propertyName], {
                    propertyName: propertyName
                });
                if (newPropertyName) res[newPropertyName] = value;
                else res = {
                    ...res,
                    ...value
                };
            } else res[propertyName] = sample.value;
        });
    }
    if (schema && typeof schema.additionalProperties === 'object') {
        const propertyName = schema.additionalProperties['x-additionalPropertiesName'] || 'property';
        res[`${String(propertyName)}1`] = (0, $6yHxM.traverse)(schema.additionalProperties, options, spec, {
            depth: depth + 1
        }).value;
        res[`${String(propertyName)}2`] = (0, $6yHxM.traverse)(schema.additionalProperties, options, spec, {
            depth: depth + 1
        }).value;
    }
    // Strictly enforce maxProperties constraint
    if (schema && typeof schema.properties === 'object' && schema.maxProperties !== undefined && Object.keys(res).length > schema.maxProperties) {
        const filteredResult = {};
        let propertiesAdded = 0;
        // Always include required properties first, if present
        const requiredProperties = Array.isArray(schema.required) ? schema.required : [];
        requiredProperties.forEach((propName)=>{
            if (res[propName] !== undefined) {
                filteredResult[propName] = res[propName];
                propertiesAdded++;
            }
        });
        // Add other properties until maxProperties is reached
        Object.keys(res).forEach((propName)=>{
            if (propertiesAdded < schema.maxProperties && !filteredResult.hasOwnProperty(propName)) {
                filteredResult[propName] = res[propName];
                propertiesAdded++;
            }
        });
        res = filteredResult;
    }
    return res;
}

});

parcelRegister("arslT", function(module, exports) {

$parcel$export(module.exports, "sampleString", () => $79a26b2587bdb840$export$c857f38e9fa70f);

var $etOhm = parcelRequire("etOhm");

var $bhWB3 = parcelRequire("bhWB3");
'use strict';
const $79a26b2587bdb840$var$passwordSymbols = 'qwerty!@#$%^123456';
function $79a26b2587bdb840$var$emailSample() {
    return 'user@example.com';
}
function $79a26b2587bdb840$var$idnEmailSample() {
    return "\u043F\u043E\u0448\u0442\u0430@\u0443\u043A\u0440.\u043D\u0435\u0442";
}
function $79a26b2587bdb840$var$passwordSample(min, max) {
    let res = 'pa$$word';
    if (min > res.length) {
        res += '_';
        res += (0, $etOhm.ensureMinLength)($79a26b2587bdb840$var$passwordSymbols, min - res.length).substring(0, min - res.length);
    }
    return res;
}
function $79a26b2587bdb840$var$commonDateTimeSample({ min: min, max: max, omitTime: omitTime, omitDate: omitDate }) {
    let res = (0, $etOhm.toRFCDateTime)(new Date('2019-08-24T14:15:22.123Z'), omitTime, omitDate, false);
    if (res.length < min) console.warn(`Using minLength = ${min} is incorrect with format "date-time"`);
    if (max && res.length > max) console.warn(`Using maxLength = ${max} is incorrect with format "date-time"`);
    return res;
}
function $79a26b2587bdb840$var$dateTimeSample(min, max) {
    return $79a26b2587bdb840$var$commonDateTimeSample({
        min: min,
        max: max,
        omitTime: false,
        omitDate: false
    });
}
function $79a26b2587bdb840$var$dateSample(min, max) {
    return $79a26b2587bdb840$var$commonDateTimeSample({
        min: min,
        max: max,
        omitTime: true,
        omitDate: false
    });
}
function $79a26b2587bdb840$var$timeSample(min, max) {
    return $79a26b2587bdb840$var$commonDateTimeSample({
        min: min,
        max: max,
        omitTime: false,
        omitDate: true
    }).slice(1);
}
function $79a26b2587bdb840$var$defaultSample(min, max, _propertyName, pattern, enablePatterns = false) {
    if (pattern && enablePatterns) return $bhWB3.regexSample(pattern);
    let res = (0, $etOhm.ensureMinLength)('string', min);
    if (max && res.length > max) res = res.substring(0, max);
    return res;
}
function $79a26b2587bdb840$var$ipv4Sample() {
    return '192.168.0.1';
}
function $79a26b2587bdb840$var$ipv6Sample() {
    return '2001:0db8:85a3:0000:0000:8a2e:0370:7334';
}
function $79a26b2587bdb840$var$hostnameSample() {
    return 'example.com';
}
function $79a26b2587bdb840$var$idnHostnameSample() {
    return "\u043F\u0440\u0438\u043A\u043B\u0430\u0434.\u0443\u043A\u0440";
}
function $79a26b2587bdb840$var$uriSample() {
    return 'http://example.com';
}
function $79a26b2587bdb840$var$uriReferenceSample() {
    return '../dictionary';
}
function $79a26b2587bdb840$var$uriTemplateSample() {
    return 'http://example.com/{endpoint}';
}
function $79a26b2587bdb840$var$iriSample() {
    return 'http://example.com/entity/1';
}
function $79a26b2587bdb840$var$iriReferenceSample() {
    return '/entity/1';
}
function $79a26b2587bdb840$var$uuidSample(_min, _max, propertyName) {
    return (0, $etOhm.uuid)(propertyName || 'id');
}
function $79a26b2587bdb840$var$jsonPointerSample() {
    return '/json/pointer';
}
function $79a26b2587bdb840$var$relativeJsonPointerSample() {
    return '1/relative/json/pointer';
}
function $79a26b2587bdb840$var$regexSample() {
    return '/regex/';
}
const $79a26b2587bdb840$var$stringFormats = {
    'email': $79a26b2587bdb840$var$emailSample,
    'idn-email': $79a26b2587bdb840$var$idnEmailSample,
    'password': $79a26b2587bdb840$var$passwordSample,
    'date-time': $79a26b2587bdb840$var$dateTimeSample,
    'date': $79a26b2587bdb840$var$dateSample,
    'time': $79a26b2587bdb840$var$timeSample,
    'ipv4': $79a26b2587bdb840$var$ipv4Sample,
    'ipv6': $79a26b2587bdb840$var$ipv6Sample,
    'hostname': $79a26b2587bdb840$var$hostnameSample,
    'idn-hostname': $79a26b2587bdb840$var$idnHostnameSample,
    'iri': $79a26b2587bdb840$var$iriSample,
    'iri-reference': $79a26b2587bdb840$var$iriReferenceSample,
    'uri': $79a26b2587bdb840$var$uriSample,
    'uri-reference': $79a26b2587bdb840$var$uriReferenceSample,
    'uri-template': $79a26b2587bdb840$var$uriTemplateSample,
    'uuid': $79a26b2587bdb840$var$uuidSample,
    'default': $79a26b2587bdb840$var$defaultSample,
    'json-pointer': $79a26b2587bdb840$var$jsonPointerSample,
    'relative-json-pointer': $79a26b2587bdb840$var$relativeJsonPointerSample,
    'regex': $79a26b2587bdb840$var$regexSample
};
function $79a26b2587bdb840$export$c857f38e9fa70f(schema, options, spec, context) {
    let format = schema.format || 'default';
    let sampler = $79a26b2587bdb840$var$stringFormats[format] || $79a26b2587bdb840$var$defaultSample;
    let propertyName = context && context.propertyName;
    return sampler(schema.minLength || 0, schema.maxLength, propertyName, schema.pattern, options?.enablePatterns);
}

});
parcelRegister("bhWB3", function(module, exports) {

$parcel$export(module.exports, "regexSample", () => $837ebc4eff3c344a$export$1a9b3ae48d37807e);
/**
Faker - Copyright (c) 2022-2023

This software consists of voluntary contributions made by many individuals.
For exact contribution history, see the revision history
available at https://github.com/faker-js/faker

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

===

From: https://github.com/faker-js/faker/commit/a9f98046c7d5eeaabe12fc587024c06d683800b8
To: https://github.com/faker-js/faker/commit/29234378807c4141588861f69421bf20b5ac635e

Based on faker.js, copyright Marak Squires and contributor, what follows below is the original license.

===

faker.js - Copyright (c) 2020
Marak Squires
http://github.com/marak/faker.js/

faker.js was inspired by and has used data definitions from:

 * https://github.com/stympy/faker/ - Copyright (c) 2007-2010 Benjamin Curtis
 * http://search.cpan.org/~jasonk/Data-Faker-0.07/ - Copyright 2004-2005 by Jason Kohles

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ /** @returns {boolean} */ function $837ebc4eff3c344a$var$boolSample() {
    return true;
}
/**
 * @param {number} min - inclusive
 * @param {number} _max - inclusive
 * @returns {number}
 */ function $837ebc4eff3c344a$var$intSample(min, _max) {
    return min;
}
/**
 * Returns a number based on given RegEx-based quantifier symbol or quantifier values.
 *
 * @param {string} quantifierSymbol Quantifier symbols can be either of these: `?`, `*`, `+`.
 * @param {string} quantifierMin Quantifier minimum value. If given without a maximum, this will be used as the quantifier value.
 * @param {string} quantifierMax Quantifier maximum value. Will randomly get a value between the minimum and maximum if both are provided.
 *
 * @returns {number} a random number based on the given quantifier parameters.
 *
 * @example
 * getRepetitionsBasedOnQuantifierParameters('*', null, null) // 3
 * getRepetitionsBasedOnQuantifierParameters(null, 10, null) // 10
 * getRepetitionsBasedOnQuantifierParameters(null, 5, 8) // 6
 *
 * @since 8.0.0
 */ function $837ebc4eff3c344a$var$getRepetitionsBasedOnQuantifierParameters(quantifierSymbol, quantifierMin, quantifierMax) {
    let repetitions = 1;
    if (quantifierSymbol) switch(quantifierSymbol){
        case '?':
            repetitions = $837ebc4eff3c344a$var$boolSample() ? 0 : 1;
            break;
        case '*':
            {
                const limit = 8;
                repetitions = $837ebc4eff3c344a$var$intSample(0, limit);
                break;
            }
        case '+':
            {
                const limit = 8;
                repetitions = $837ebc4eff3c344a$var$intSample(1, limit);
                break;
            }
        default:
            throw new Error('Unknown quantifier symbol provided.');
    }
    else if (quantifierMin != null && quantifierMax != null) repetitions = $837ebc4eff3c344a$var$intSample(parseInt(quantifierMin), parseInt(quantifierMax));
    else if (quantifierMin != null && quantifierMax == null) repetitions = parseInt(quantifierMin);
    return repetitions;
}
function $837ebc4eff3c344a$export$1a9b3ae48d37807e(pattern) {
    let isCaseInsensitive = false;
    if (pattern instanceof RegExp) {
        isCaseInsensitive = pattern.flags.includes('i');
        pattern = pattern.toString();
        pattern = pattern.match(/\/(.+?)\//)?.[1] ?? ''; // Remove frontslash from front and back of RegExp
    }
    pattern = pattern.replace(/^(\^)?(.*?)(\$)?$/, '$2'); // Remove anchors if present
    let min;
    let max;
    let repetitions;
    // Deal with single wildcards
    const SINGLE_CHAR_REG = /([.A-Za-z0-9])(?:\{(\d+)(?:\,(\d+)|)\}|(\?|\*|\+))(?![^[]*]|[^{]*})/;
    let token = pattern.match(SINGLE_CHAR_REG);
    while(token != null){
        const quantifierMin = token[2];
        const quantifierMax = token[3];
        const quantifierSymbol = token[4];
        repetitions = $837ebc4eff3c344a$var$getRepetitionsBasedOnQuantifierParameters(quantifierSymbol, quantifierMin, quantifierMax);
        pattern = pattern.slice(0, token.index) + token[1].repeat(repetitions) + pattern.slice(token.index + token[0].length);
        token = pattern.match(SINGLE_CHAR_REG);
    }
    const SINGLE_RANGE_REG = /(\d-\d|\w-\w|\d|\w|[-!@#$&()`.+,/"])/;
    const RANGE_ALPHANUMEMRIC_REG = /\[(\^|)(-|)(.+?)\](?:\{(\d+)(?:\,(\d+)|)\}|(\?|\*|\+)|)/;
    // Deal with character classes with quantifiers `[a-z0-9]{min[, max]}`
    token = pattern.match(RANGE_ALPHANUMEMRIC_REG);
    while(token != null){
        const isNegated = token[1] === '^';
        const includesDash = token[2] === '-';
        const quantifierMin = token[4];
        const quantifierMax = token[5];
        const quantifierSymbol = token[6];
        const rangeCodes = [];
        let ranges = token[3];
        let range = ranges.match(SINGLE_RANGE_REG);
        if (includesDash) // 45 is the ascii code for '-'
        rangeCodes.push(45);
        while(range != null){
            if (range[0].indexOf('-') === -1) {
                // handle non-ranges
                if (isCaseInsensitive && isNaN(Number(range[0]))) {
                    rangeCodes.push(range[0].toUpperCase().charCodeAt(0));
                    rangeCodes.push(range[0].toLowerCase().charCodeAt(0));
                } else rangeCodes.push(range[0].charCodeAt(0));
            } else {
                // handle ranges
                const rangeMinMax = range[0].split('-').map((x)=>x.charCodeAt(0));
                min = rangeMinMax[0];
                max = rangeMinMax[1];
                // throw error if min larger than max
                if (min > max) throw new Error('Character range provided is out of order.');
                for(let i = min; i <= max; i++)if (isCaseInsensitive && isNaN(Number(String.fromCharCode(i)))) {
                    const ch = String.fromCharCode(i);
                    rangeCodes.push(ch.toUpperCase().charCodeAt(0));
                    rangeCodes.push(ch.toLowerCase().charCodeAt(0));
                } else rangeCodes.push(i);
            }
            ranges = ranges.substring(range[0].length);
            range = ranges.match(SINGLE_RANGE_REG);
        }
        repetitions = $837ebc4eff3c344a$var$getRepetitionsBasedOnQuantifierParameters(quantifierSymbol, quantifierMin, quantifierMax);
        if (isNegated) {
            let index = -1;
            // 0-9
            for(let i = 48; i <= 57; i++){
                index = rangeCodes.indexOf(i);
                if (index > -1) {
                    rangeCodes.splice(index, 1);
                    continue;
                }
                rangeCodes.push(i);
            }
            // A-Z
            for(let i = 65; i <= 90; i++){
                index = rangeCodes.indexOf(i);
                if (index > -1) {
                    rangeCodes.splice(index, 1);
                    continue;
                }
                rangeCodes.push(i);
            }
            // a-z
            for(let i = 97; i <= 122; i++){
                index = rangeCodes.indexOf(i);
                if (index > -1) {
                    rangeCodes.splice(index, 1);
                    continue;
                }
                rangeCodes.push(i);
            }
        }
        const generatedString = Array.from({
            length: repetitions
        }, ()=>String.fromCharCode(rangeCodes[$837ebc4eff3c344a$var$intSample(0, rangeCodes.length - 1)])).join('');
        pattern = pattern.slice(0, token.index) + generatedString + pattern.slice(token.index + token[0].length);
        token = pattern.match(RANGE_ALPHANUMEMRIC_REG);
    }
    const RANGE_REP_REG = /(.)\{(\d+)\,(\d+)\}/;
    // Deal with quantifier ranges `{min,max}`
    token = pattern.match(RANGE_REP_REG);
    while(token != null){
        min = parseInt(token[2]);
        max = parseInt(token[3]);
        // throw error if min larger than max
        if (min > max) throw new Error('Numbers out of order in {} quantifier.');
        repetitions = $837ebc4eff3c344a$var$intSample(min, max);
        pattern = pattern.slice(0, token.index) + token[1].repeat(repetitions) + pattern.slice(token.index + token[0].length);
        token = pattern.match(RANGE_REP_REG);
    }
    const REP_REG = /(.)\{(\d+)\}/;
    // Deal with repeat `{num}`
    token = pattern.match(REP_REG);
    while(token != null){
        repetitions = parseInt(token[2]);
        pattern = pattern.slice(0, token.index) + token[1].repeat(repetitions) + pattern.slice(token.index + token[0].length);
        token = pattern.match(REP_REG);
    }
    return pattern;
}

});



parcelRegister("3JI82", function(module, exports) {
'use strict';

var $jMtEa = parcelRequire("jMtEa");

var $lDJJ5 = parcelRequire("lDJJ5");

var $kE74N = parcelRequire("kE74N");
module.exports = {
    XMLParser: $lDJJ5,
    XMLValidator: $jMtEa,
    XMLBuilder: $kE74N
};

});
parcelRegister("jMtEa", function(module, exports) {

$parcel$export(module.exports, "validate", () => $e6697f46f4a0942a$export$a22775fa5e2eebd9, (v) => $e6697f46f4a0942a$export$a22775fa5e2eebd9 = v);
//const tagsPattern = new RegExp("<\\/?([\\w:\\-_\.]+)\\s*\/?>","g");
var $e6697f46f4a0942a$export$a22775fa5e2eebd9;
'use strict';

var $l8rQG = parcelRequire("l8rQG");
const $e6697f46f4a0942a$var$defaultOptions = {
    allowBooleanAttributes: false,
    unpairedTags: []
};
$e6697f46f4a0942a$export$a22775fa5e2eebd9 = function(xmlData, options) {
    options = Object.assign({}, $e6697f46f4a0942a$var$defaultOptions, options);
    //xmlData = xmlData.replace(/(\r\n|\n|\r)/gm,"");//make it single line
    //xmlData = xmlData.replace(/(^\s*<\?xml.*?\?>)/g,"");//Remove XML starting tag
    //xmlData = xmlData.replace(/(<!DOCTYPE[\s\w\"\.\/\-\:]+(\[.*\])*\s*>)/g,"");//Remove DOCTYPE
    const tags = [];
    let tagFound = false;
    //indicates that the root tag has been closed (aka. depth 0 has been reached)
    let reachedRoot = false;
    if (xmlData[0] === '\ufeff') // check for byte order mark (BOM)
    xmlData = xmlData.substr(1);
    for(let i = 0; i < xmlData.length; i++){
        if (xmlData[i] === '<' && xmlData[i + 1] === '?') {
            i += 2;
            i = $e6697f46f4a0942a$var$readPI(xmlData, i);
            if (i.err) return i;
        } else if (xmlData[i] === '<') {
            //starting of tag
            //read until you reach to '>' avoiding any '>' in attribute value
            let tagStartPos = i;
            i++;
            if (xmlData[i] === '!') {
                i = $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i);
                continue;
            } else {
                let closingTag = false;
                if (xmlData[i] === '/') {
                    //closing tag
                    closingTag = true;
                    i++;
                }
                //read tagname
                let tagName = '';
                for(; i < xmlData.length && xmlData[i] !== '>' && xmlData[i] !== ' ' && xmlData[i] !== '\t' && xmlData[i] !== '\n' && xmlData[i] !== '\r'; i++)tagName += xmlData[i];
                tagName = tagName.trim();
                //console.log(tagName);
                if (tagName[tagName.length - 1] === '/') {
                    //self closing tag without attributes
                    tagName = tagName.substring(0, tagName.length - 1);
                    //continue;
                    i--;
                }
                if (!$e6697f46f4a0942a$var$validateTagName(tagName)) {
                    let msg;
                    if (tagName.trim().length === 0) msg = "Invalid space after '<'.";
                    else msg = "Tag '" + tagName + "' is an invalid name.";
                    return $e6697f46f4a0942a$var$getErrorObject('InvalidTag', msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                }
                const result = $e6697f46f4a0942a$var$readAttributeStr(xmlData, i);
                if (result === false) return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "Attributes for '" + tagName + "' have open quote.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                let attrStr = result.value;
                i = result.index;
                if (attrStr[attrStr.length - 1] === '/') {
                    //self closing tag
                    const attrStrStart = i - attrStr.length;
                    attrStr = attrStr.substring(0, attrStr.length - 1);
                    const isValid = $e6697f46f4a0942a$var$validateAttributeString(attrStr, options);
                    if (isValid === true) tagFound = true;
                    else //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $e6697f46f4a0942a$var$getErrorObject(isValid.err.code, isValid.err.msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, attrStrStart + isValid.err.line));
                } else if (closingTag) {
                    if (!result.tagClosed) return $e6697f46f4a0942a$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' doesn't have proper closing.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                    else if (attrStr.trim().length > 0) return $e6697f46f4a0942a$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' can't have attributes or invalid starting.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else if (tags.length === 0) return $e6697f46f4a0942a$var$getErrorObject('InvalidTag', "Closing tag '" + tagName + "' has not been opened.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, tagStartPos));
                    else {
                        const otg = tags.pop();
                        if (tagName !== otg.tagName) {
                            let openPos = $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, otg.tagStartPos);
                            return $e6697f46f4a0942a$var$getErrorObject('InvalidTag', "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, tagStartPos));
                        }
                        //when there are no more tags, we reached the root level.
                        if (tags.length == 0) reachedRoot = true;
                    }
                } else {
                    const isValid = $e6697f46f4a0942a$var$validateAttributeString(attrStr, options);
                    if (isValid !== true) //the result from the nested function returns the position of the error within the attribute
                    //in order to get the 'true' error line, we need to calculate the position where the attribute begins (i - attrStr.length) and then add the position within the attribute
                    //this gives us the absolute index in the entire xml, which we can use to find the line at last
                    return $e6697f46f4a0942a$var$getErrorObject(isValid.err.code, isValid.err.msg, $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i - attrStr.length + isValid.err.line));
                    //if the root level has been reached before ...
                    if (reachedRoot === true) return $e6697f46f4a0942a$var$getErrorObject('InvalidXml', 'Multiple possible root nodes found.', $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                    else if (options.unpairedTags.indexOf(tagName) !== -1) ;
                    else tags.push({
                        tagName: tagName,
                        tagStartPos: tagStartPos
                    });
                    tagFound = true;
                }
                //skip tag text value
                //It may include comments and CDATA value
                for(i++; i < xmlData.length; i++){
                    if (xmlData[i] === '<') {
                        if (xmlData[i + 1] === '!') {
                            //comment or CADATA
                            i++;
                            i = $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i);
                            continue;
                        } else if (xmlData[i + 1] === '?') {
                            i = $e6697f46f4a0942a$var$readPI(xmlData, ++i);
                            if (i.err) return i;
                        } else break;
                    } else if (xmlData[i] === '&') {
                        const afterAmp = $e6697f46f4a0942a$var$validateAmpersand(xmlData, i);
                        if (afterAmp == -1) return $e6697f46f4a0942a$var$getErrorObject('InvalidChar', "char '&' is not expected.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                        i = afterAmp;
                    } else {
                        if (reachedRoot === true && !$e6697f46f4a0942a$var$isWhiteSpace(xmlData[i])) return $e6697f46f4a0942a$var$getErrorObject('InvalidXml', "Extra text at the end", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
                    }
                } //end of reading tag text value
                if (xmlData[i] === '<') i--;
            }
        } else {
            if ($e6697f46f4a0942a$var$isWhiteSpace(xmlData[i])) continue;
            return $e6697f46f4a0942a$var$getErrorObject('InvalidChar', "char '" + xmlData[i] + "' is not expected.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
        }
    }
    if (!tagFound) return $e6697f46f4a0942a$var$getErrorObject('InvalidXml', 'Start tag expected.', 1);
    else if (tags.length == 1) return $e6697f46f4a0942a$var$getErrorObject('InvalidTag', "Unclosed tag '" + tags[0].tagName + "'.", $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, tags[0].tagStartPos));
    else if (tags.length > 0) return $e6697f46f4a0942a$var$getErrorObject('InvalidXml', "Invalid '" + JSON.stringify(tags.map((t)=>t.tagName), null, 4).replace(/\r?\n/g, '') + "' found.", {
        line: 1,
        col: 1
    });
    return true;
};
function $e6697f46f4a0942a$var$isWhiteSpace(char) {
    return char === ' ' || char === '\t' || char === '\n' || char === '\r';
}
/**
 * Read Processing insstructions and skip
 * @param {*} xmlData
 * @param {*} i
 */ function $e6697f46f4a0942a$var$readPI(xmlData, i) {
    const start = i;
    for(; i < xmlData.length; i++)if (xmlData[i] == '?' || xmlData[i] == ' ') {
        //tagname
        const tagname = xmlData.substr(start, i - start);
        if (i > 5 && tagname === 'xml') return $e6697f46f4a0942a$var$getErrorObject('InvalidXml', 'XML declaration allowed only at the start of the document.', $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, i));
        else if (xmlData[i] == '?' && xmlData[i + 1] == '>') {
            //check if valid attribut string
            i++;
            break;
        } else continue;
    }
    return i;
}
function $e6697f46f4a0942a$var$readCommentAndCDATA(xmlData, i) {
    if (xmlData.length > i + 5 && xmlData[i + 1] === '-' && xmlData[i + 2] === '-') {
        //comment
        for(i += 3; i < xmlData.length; i++)if (xmlData[i] === '-' && xmlData[i + 1] === '-' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    } else if (xmlData.length > i + 8 && xmlData[i + 1] === 'D' && xmlData[i + 2] === 'O' && xmlData[i + 3] === 'C' && xmlData[i + 4] === 'T' && xmlData[i + 5] === 'Y' && xmlData[i + 6] === 'P' && xmlData[i + 7] === 'E') {
        let angleBracketsCount = 1;
        for(i += 8; i < xmlData.length; i++){
            if (xmlData[i] === '<') angleBracketsCount++;
            else if (xmlData[i] === '>') {
                angleBracketsCount--;
                if (angleBracketsCount === 0) break;
            }
        }
    } else if (xmlData.length > i + 9 && xmlData[i + 1] === '[' && xmlData[i + 2] === 'C' && xmlData[i + 3] === 'D' && xmlData[i + 4] === 'A' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'A' && xmlData[i + 7] === '[') {
        for(i += 8; i < xmlData.length; i++)if (xmlData[i] === ']' && xmlData[i + 1] === ']' && xmlData[i + 2] === '>') {
            i += 2;
            break;
        }
    }
    return i;
}
const $e6697f46f4a0942a$var$doubleQuote = '"';
const $e6697f46f4a0942a$var$singleQuote = "'";
/**
 * Keep reading xmlData until '<' is found outside the attribute value.
 * @param {string} xmlData
 * @param {number} i
 */ function $e6697f46f4a0942a$var$readAttributeStr(xmlData, i) {
    let attrStr = '';
    let startChar = '';
    let tagClosed = false;
    for(; i < xmlData.length; i++){
        if (xmlData[i] === $e6697f46f4a0942a$var$doubleQuote || xmlData[i] === $e6697f46f4a0942a$var$singleQuote) {
            if (startChar === '') startChar = xmlData[i];
            else if (startChar !== xmlData[i]) ;
            else startChar = '';
        } else if (xmlData[i] === '>') {
            if (startChar === '') {
                tagClosed = true;
                break;
            }
        }
        attrStr += xmlData[i];
    }
    if (startChar !== '') return false;
    return {
        value: attrStr,
        index: i,
        tagClosed: tagClosed
    };
}
/**
 * Select all the attributes whether valid or invalid.
 */ const $e6697f46f4a0942a$var$validAttrStrRegxp = new RegExp('(\\s*)([^\\s=]+)(\\s*=)?(\\s*([\'"])(([\\s\\S])*?)\\5)?', 'g');
//attr, ="sd", a="amit's", a="sd"b="saf", ab  cd=""
function $e6697f46f4a0942a$var$validateAttributeString(attrStr, options) {
    //console.log("start:"+attrStr+":end");
    //if(attrStr.trim().length === 0) return true; //empty string
    const matches = $l8rQG.getAllMatches(attrStr, $e6697f46f4a0942a$var$validAttrStrRegxp);
    const attrNames = {};
    for(let i = 0; i < matches.length; i++){
        if (matches[i][1].length === 0) //nospace before attribute name: a="sd"b="saf"
        return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' has no space in starting.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] !== undefined && matches[i][4] === undefined) return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "Attribute '" + matches[i][2] + "' is without value.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
        else if (matches[i][3] === undefined && !options.allowBooleanAttributes) //independent attribute: ab
        return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "boolean attribute '" + matches[i][2] + "' is not allowed.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
        /* else if(matches[i][6] === undefined){//attribute without value: ab=
                    return { err: { code:"InvalidAttr",msg:"attribute " + matches[i][2] + " has no value assigned."}};
                } */ const attrName = matches[i][2];
        if (!$e6697f46f4a0942a$var$validateAttrName(attrName)) return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is an invalid name.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
        if (!attrNames.hasOwnProperty(attrName)) //check for duplicate attribute.
        attrNames[attrName] = 1;
        else return $e6697f46f4a0942a$var$getErrorObject('InvalidAttr', "Attribute '" + attrName + "' is repeated.", $e6697f46f4a0942a$var$getPositionFromMatch(matches[i]));
    }
    return true;
}
function $e6697f46f4a0942a$var$validateNumberAmpersand(xmlData, i) {
    let re = /\d/;
    if (xmlData[i] === 'x') {
        i++;
        re = /[\da-fA-F]/;
    }
    for(; i < xmlData.length; i++){
        if (xmlData[i] === ';') return i;
        if (!xmlData[i].match(re)) break;
    }
    return -1;
}
function $e6697f46f4a0942a$var$validateAmpersand(xmlData, i) {
    // https://www.w3.org/TR/xml/#dt-charref
    i++;
    if (xmlData[i] === ';') return -1;
    if (xmlData[i] === '#') {
        i++;
        return $e6697f46f4a0942a$var$validateNumberAmpersand(xmlData, i);
    }
    let count = 0;
    for(; i < xmlData.length; i++, count++){
        if (xmlData[i].match(/\w/) && count < 20) continue;
        if (xmlData[i] === ';') break;
        return -1;
    }
    return i;
}
function $e6697f46f4a0942a$var$getErrorObject(code, message, lineNumber) {
    return {
        err: {
            code: code,
            msg: message,
            line: lineNumber.line || lineNumber,
            col: lineNumber.col
        }
    };
}
function $e6697f46f4a0942a$var$validateAttrName(attrName) {
    return $l8rQG.isName(attrName);
}
// const startsWithXML = /^xml/i;
function $e6697f46f4a0942a$var$validateTagName(tagname) {
    return $l8rQG.isName(tagname) /* && !tagname.match(startsWithXML) */ ;
}
//this function returns the line number for the character at the given index
function $e6697f46f4a0942a$var$getLineNumberForPosition(xmlData, index) {
    const lines = xmlData.substring(0, index).split(/\r?\n/);
    return {
        line: lines.length,
        // column number is last line's length + 1, because column numbering starts at 1:
        col: lines[lines.length - 1].length + 1
    };
}
//this function returns the position of the first character of match within attrStr
function $e6697f46f4a0942a$var$getPositionFromMatch(match) {
    return match.startIndex + match[1].length;
}

});
parcelRegister("l8rQG", function(module, exports) {

$parcel$export(module.exports, "isExist", () => $f62ff286a4f745fa$export$a5edf3f35b6dd392, (v) => $f62ff286a4f745fa$export$a5edf3f35b6dd392 = v);
$parcel$export(module.exports, "isName", () => $f62ff286a4f745fa$export$998d7ff9801e90bb, (v) => $f62ff286a4f745fa$export$998d7ff9801e90bb = v);
$parcel$export(module.exports, "getAllMatches", () => $f62ff286a4f745fa$export$aaa9734c55cb7a19, (v) => $f62ff286a4f745fa$export$aaa9734c55cb7a19 = v);
$parcel$export(module.exports, "DANGEROUS_PROPERTY_NAMES", () => $f62ff286a4f745fa$export$a992756d162cd0c0, (v) => $f62ff286a4f745fa$export$a992756d162cd0c0 = v);
$parcel$export(module.exports, "criticalProperties", () => $f62ff286a4f745fa$export$deb3cacd0e79cda8, (v) => $f62ff286a4f745fa$export$deb3cacd0e79cda8 = v);
var $f62ff286a4f745fa$export$a5edf3f35b6dd392;
var $f62ff286a4f745fa$export$83b788b1a3698c03;
/**
 * Copy all the properties of a into b.
 * @param {*} target
 * @param {*} a
 */ var $f62ff286a4f745fa$export$4950aa0f605343fb;
/* exports.merge =function (b,a){
  return Object.assign(b,a);
} */ var $f62ff286a4f745fa$export$bf7199a9ebcb84a9;
var $f62ff286a4f745fa$export$998d7ff9801e90bb;
var $f62ff286a4f745fa$export$aaa9734c55cb7a19;
var $f62ff286a4f745fa$export$e8f2644f7085b4b1;
var $f62ff286a4f745fa$export$a992756d162cd0c0;
var $f62ff286a4f745fa$export$deb3cacd0e79cda8;
'use strict';
const $f62ff286a4f745fa$var$nameStartChar = ':A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
const $f62ff286a4f745fa$var$nameChar = $f62ff286a4f745fa$var$nameStartChar + '\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
const $f62ff286a4f745fa$var$nameRegexp = '[' + $f62ff286a4f745fa$var$nameStartChar + '][' + $f62ff286a4f745fa$var$nameChar + ']*';
const $f62ff286a4f745fa$var$regexName = new RegExp('^' + $f62ff286a4f745fa$var$nameRegexp + '$');
const $f62ff286a4f745fa$var$getAllMatches = function(string, regex) {
    const matches = [];
    let match = regex.exec(string);
    while(match){
        const allmatches = [];
        allmatches.startIndex = regex.lastIndex - match[0].length;
        const len = match.length;
        for(let index = 0; index < len; index++)allmatches.push(match[index]);
        matches.push(allmatches);
        match = regex.exec(string);
    }
    return matches;
};
const $f62ff286a4f745fa$var$isName = function(string) {
    const match = $f62ff286a4f745fa$var$regexName.exec(string);
    return !(match === null || typeof match === 'undefined');
};
$f62ff286a4f745fa$export$a5edf3f35b6dd392 = function(v) {
    return typeof v !== 'undefined';
};
$f62ff286a4f745fa$export$83b788b1a3698c03 = function(obj) {
    return Object.keys(obj).length === 0;
};
$f62ff286a4f745fa$export$4950aa0f605343fb = function(target, a, arrayMode) {
    if (a) {
        const keys = Object.keys(a); // will return an array of own properties
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++)if (arrayMode === 'strict') target[keys[i]] = [
            a[keys[i]]
        ];
        else target[keys[i]] = a[keys[i]];
    }
};
$f62ff286a4f745fa$export$bf7199a9ebcb84a9 = function(v) {
    if ($f62ff286a4f745fa$export$a5edf3f35b6dd392(v)) return v;
    else return '';
};
/**
 * Dangerous property names that could lead to prototype pollution or security issues
 */ const $f62ff286a4f745fa$var$DANGEROUS_PROPERTY_NAMES = [
    // '__proto__',
    // 'constructor',
    // 'prototype',
    'hasOwnProperty',
    'toString',
    'valueOf',
    '__defineGetter__',
    '__defineSetter__',
    '__lookupGetter__',
    '__lookupSetter__'
];
const $f62ff286a4f745fa$var$criticalProperties = [
    "__proto__",
    "constructor",
    "prototype"
];
$f62ff286a4f745fa$export$998d7ff9801e90bb = $f62ff286a4f745fa$var$isName;
$f62ff286a4f745fa$export$aaa9734c55cb7a19 = $f62ff286a4f745fa$var$getAllMatches;
$f62ff286a4f745fa$export$e8f2644f7085b4b1 = $f62ff286a4f745fa$var$nameRegexp;
$f62ff286a4f745fa$export$a992756d162cd0c0 = $f62ff286a4f745fa$var$DANGEROUS_PROPERTY_NAMES;
$f62ff286a4f745fa$export$deb3cacd0e79cda8 = $f62ff286a4f745fa$var$criticalProperties;

});


parcelRegister("lDJJ5", function(module, exports) {

var $eFqVV = parcelRequire("eFqVV");
var $fc10b5bda729ad87$require$buildOptions = $eFqVV.buildOptions;

var $lY6qq = parcelRequire("lY6qq");

var $bG4eT = parcelRequire("bG4eT");
var $fc10b5bda729ad87$require$prettify = $bG4eT.prettify;

var $jMtEa = parcelRequire("jMtEa");
class $fc10b5bda729ad87$var$XMLParser {
    constructor(options){
        this.externalEntities = {};
        this.options = $fc10b5bda729ad87$require$buildOptions(options);
    }
    /**
     * Parse XML dats to JS object 
     * @param {string|Buffer} xmlData 
     * @param {boolean|Object} validationOption 
     */ parse(xmlData, validationOption) {
        if (typeof xmlData === "string") ;
        else if (xmlData.toString) xmlData = xmlData.toString();
        else throw new Error("XML data is accepted in String or Bytes[] form.");
        if (validationOption) {
            if (validationOption === true) validationOption = {}; //validate with default options
            const result = $jMtEa.validate(xmlData, validationOption);
            if (result !== true) throw Error(`${result.err.msg}:${result.err.line}:${result.err.col}`);
        }
        const orderedObjParser = new $lY6qq(this.options);
        orderedObjParser.addExternalEntities(this.externalEntities);
        const orderedResult = orderedObjParser.parseXml(xmlData);
        if (this.options.preserveOrder || orderedResult === undefined) return orderedResult;
        else return $fc10b5bda729ad87$require$prettify(orderedResult, this.options);
    }
    /**
     * Add Entity which is not by default supported by this library
     * @param {string} key 
     * @param {string} value 
     */ addEntity(key, value) {
        if (value.indexOf("&") !== -1) throw new Error("Entity value can't have '&'");
        else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
        else if (value === "&") throw new Error("An entity with value '&' is not permitted");
        else this.externalEntities[key] = value;
    }
}
module.exports = $fc10b5bda729ad87$var$XMLParser;

});
parcelRegister("eFqVV", function(module, exports) {

$parcel$export(module.exports, "buildOptions", () => $aad9c96aff038f10$export$ecbd7d678ac4909b, (v) => $aad9c96aff038f10$export$ecbd7d678ac4909b = v);
var $aad9c96aff038f10$export$ecbd7d678ac4909b;
var $aad9c96aff038f10$export$ba43bf67f3d48107;

var $l8rQG = parcelRequire("l8rQG");
var $aad9c96aff038f10$require$DANGEROUS_PROPERTY_NAMES = $l8rQG.DANGEROUS_PROPERTY_NAMES;
var $aad9c96aff038f10$require$criticalProperties = $l8rQG.criticalProperties;
const $aad9c96aff038f10$var$defaultOnDangerousProperty = (name)=>{
    if ($aad9c96aff038f10$require$DANGEROUS_PROPERTY_NAMES.includes(name)) return "__" + name;
    return name;
};
const $aad9c96aff038f10$var$defaultOptions = {
    preserveOrder: false,
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    removeNSPrefix: false,
    allowBooleanAttributes: false,
    //ignoreRootElement : false,
    parseTagValue: true,
    parseAttributeValue: false,
    trimValues: true,
    cdataPropName: false,
    numberParseOptions: {
        hex: true,
        leadingZeros: true,
        eNotation: true
    },
    tagValueProcessor: function(tagName, val) {
        return val;
    },
    attributeValueProcessor: function(attrName, val) {
        return val;
    },
    stopNodes: [],
    alwaysCreateTextNode: false,
    isArray: ()=>false,
    commentPropName: false,
    unpairedTags: [],
    processEntities: true,
    htmlEntities: false,
    ignoreDeclaration: false,
    ignorePiTags: false,
    transformTagName: false,
    transformAttributeName: false,
    updateTag: function(tagName, jPath, attrs) {
        return tagName;
    },
    // skipEmptyListItem: false
    captureMetaData: false,
    maxNestedTags: 100,
    strictReservedNames: true,
    onDangerousProperty: $aad9c96aff038f10$var$defaultOnDangerousProperty
};
/**
 * Validates that a property name is safe to use
 * @param {string} propertyName - The property name to validate
 * @param {string} optionName - The option field name (for error message)
 * @throws {Error} If property name is dangerous
 */ function $aad9c96aff038f10$var$validatePropertyName(propertyName, optionName) {
    if (typeof propertyName !== 'string') return; // Only validate string property names
    const normalized = propertyName.toLowerCase();
    if ($aad9c96aff038f10$require$DANGEROUS_PROPERTY_NAMES.some((dangerous)=>normalized === dangerous.toLowerCase())) throw new Error(`[SECURITY] Invalid ${optionName}: "${propertyName}" is a reserved JavaScript keyword that could cause prototype pollution`);
    if ($aad9c96aff038f10$require$criticalProperties.some((dangerous)=>normalized === dangerous.toLowerCase())) throw new Error(`[SECURITY] Invalid ${optionName}: "${propertyName}" is a reserved JavaScript keyword that could cause prototype pollution`);
}
/**
 * Normalizes processEntities option for backward compatibility
 * @param {boolean|object} value 
 * @returns {object} Always returns normalized object
 */ function $aad9c96aff038f10$var$normalizeProcessEntities(value) {
    // Boolean backward compatibility
    if (typeof value === 'boolean') return {
        enabled: value,
        maxEntitySize: 10000,
        maxExpansionDepth: 10,
        maxTotalExpansions: 1000,
        maxExpandedLength: 100000,
        allowedTags: null,
        tagFilter: null
    };
    // Object config - merge with defaults
    if (typeof value === 'object' && value !== null) return {
        enabled: value.enabled !== false,
        maxEntitySize: Math.max(1, value.maxEntitySize ?? 10000),
        maxExpansionDepth: Math.max(1, value.maxExpansionDepth ?? 10000),
        maxTotalExpansions: Math.max(1, value.maxTotalExpansions ?? Infinity),
        maxExpandedLength: Math.max(1, value.maxExpandedLength ?? 100000),
        maxEntityCount: Math.max(1, value.maxEntityCount ?? 1000),
        allowedTags: value.allowedTags ?? null,
        tagFilter: value.tagFilter ?? null
    };
    // Default to enabled with limits
    return $aad9c96aff038f10$var$normalizeProcessEntities(true);
}
const $aad9c96aff038f10$var$buildOptions = function(options) {
    const built = Object.assign({}, $aad9c96aff038f10$var$defaultOptions, options);
    // Validate property names to prevent prototype pollution
    const propertyNameOptions = [
        {
            value: built.attributeNamePrefix,
            name: 'attributeNamePrefix'
        },
        {
            value: built.attributesGroupName,
            name: 'attributesGroupName'
        },
        {
            value: built.textNodeName,
            name: 'textNodeName'
        },
        {
            value: built.cdataPropName,
            name: 'cdataPropName'
        },
        {
            value: built.commentPropName,
            name: 'commentPropName'
        }
    ];
    for (const { value: value, name: name } of propertyNameOptions)if (value) $aad9c96aff038f10$var$validatePropertyName(value, name);
    if (built.onDangerousProperty === null) built.onDangerousProperty = $aad9c96aff038f10$var$defaultOnDangerousProperty;
    // Always normalize processEntities for backward compatibility and validation
    built.processEntities = $aad9c96aff038f10$var$normalizeProcessEntities(built.processEntities);
    //console.debug(built.processEntities)
    return built;
};
$aad9c96aff038f10$export$ecbd7d678ac4909b = $aad9c96aff038f10$var$buildOptions;
$aad9c96aff038f10$export$ba43bf67f3d48107 = $aad9c96aff038f10$var$defaultOptions;

});

parcelRegister("lY6qq", function(module, exports) {
'use strict';

var $l8rQG = parcelRequire("l8rQG");

var $fQFwH = parcelRequire("fQFwH");

var $kPrSK = parcelRequire("kPrSK");

var $fLtYL = parcelRequire("fLtYL");

var $1DUme = parcelRequire("1DUme");
// const regx =
//   '<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)'
//   .replace(/NAME/g, util.nameRegexp);
//const tagsRegx = new RegExp("<(\\/?[\\w:\\-\._]+)([^>]*)>(\\s*"+cdataRegx+")*([^<]+)?","g");
//const tagsRegx = new RegExp("<(\\/?)((\\w*:)?([\\w:\\-\._]+))([^>]*)>([^<]*)("+cdataRegx+"([^<]*))*([^<]+)?","g");
class $ffe42f7d6492ea5b$var$OrderedObjParser {
    constructor(options){
        this.options = options;
        this.currentNode = null;
        this.tagsNodeStack = [];
        this.docTypeEntities = {};
        this.lastEntities = {
            "apos": {
                regex: /&(apos|#39|#x27);/g,
                val: "'"
            },
            "gt": {
                regex: /&(gt|#62|#x3E);/g,
                val: ">"
            },
            "lt": {
                regex: /&(lt|#60|#x3C);/g,
                val: "<"
            },
            "quot": {
                regex: /&(quot|#34|#x22);/g,
                val: "\""
            }
        };
        this.ampEntity = {
            regex: /&(amp|#38|#x26);/g,
            val: "&"
        };
        this.htmlEntities = {
            "space": {
                regex: /&(nbsp|#160);/g,
                val: " "
            },
            // "lt" : { regex: /&(lt|#60);/g, val: "<" },
            // "gt" : { regex: /&(gt|#62);/g, val: ">" },
            // "amp" : { regex: /&(amp|#38);/g, val: "&" },
            // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
            // "apos" : { regex: /&(apos|#39);/g, val: "'" },
            "cent": {
                regex: /&(cent|#162);/g,
                val: "\xa2"
            },
            "pound": {
                regex: /&(pound|#163);/g,
                val: "\xa3"
            },
            "yen": {
                regex: /&(yen|#165);/g,
                val: "\xa5"
            },
            "euro": {
                regex: /&(euro|#8364);/g,
                val: "\u20AC"
            },
            "copyright": {
                regex: /&(copy|#169);/g,
                val: "\xa9"
            },
            "reg": {
                regex: /&(reg|#174);/g,
                val: "\xae"
            },
            "inr": {
                regex: /&(inr|#8377);/g,
                val: "\u20B9"
            },
            "num_dec": {
                regex: /&#([0-9]{1,7});/g,
                val: (_, str)=>$ffe42f7d6492ea5b$var$fromCodePoint(str, 10, "&#")
            },
            "num_hex": {
                regex: /&#x([0-9a-fA-F]{1,6});/g,
                val: (_, str)=>$ffe42f7d6492ea5b$var$fromCodePoint(str, 16, "&#x")
            }
        };
        this.addExternalEntities = $ffe42f7d6492ea5b$var$addExternalEntities;
        this.parseXml = $ffe42f7d6492ea5b$var$parseXml;
        this.parseTextData = $ffe42f7d6492ea5b$var$parseTextData;
        this.resolveNameSpace = $ffe42f7d6492ea5b$var$resolveNameSpace;
        this.buildAttributesMap = $ffe42f7d6492ea5b$var$buildAttributesMap;
        this.isItStopNode = $ffe42f7d6492ea5b$var$isItStopNode;
        this.replaceEntitiesValue = $ffe42f7d6492ea5b$var$replaceEntitiesValue;
        this.readStopNodeData = $ffe42f7d6492ea5b$var$readStopNodeData;
        this.saveTextToParentTag = $ffe42f7d6492ea5b$var$saveTextToParentTag;
        this.addChild = $ffe42f7d6492ea5b$var$addChild;
        this.ignoreAttributesFn = $1DUme(this.options.ignoreAttributes);
        this.entityExpansionCount = 0;
        this.currentExpandedLength = 0;
        if (this.options.stopNodes && this.options.stopNodes.length > 0) {
            this.stopNodesExact = new Set();
            this.stopNodesWildcard = new Set();
            for(let i = 0; i < this.options.stopNodes.length; i++){
                const stopNodeExp = this.options.stopNodes[i];
                if (typeof stopNodeExp !== 'string') continue;
                if (stopNodeExp.startsWith("*.")) this.stopNodesWildcard.add(stopNodeExp.substring(2));
                else this.stopNodesExact.add(stopNodeExp);
            }
        }
    }
}
function $ffe42f7d6492ea5b$var$addExternalEntities(externalEntities) {
    const entKeys = Object.keys(externalEntities);
    for(let i = 0; i < entKeys.length; i++){
        const ent = entKeys[i];
        const escaped = ent.replace(/[.\-+*:]/g, '\\.');
        this.lastEntities[ent] = {
            regex: new RegExp("&" + escaped + ";", "g"),
            val: externalEntities[ent]
        };
    }
}
/**
 * @param {string} val
 * @param {string} tagName
 * @param {string} jPath
 * @param {boolean} dontTrim
 * @param {boolean} hasAttributes
 * @param {boolean} isLeafNode
 * @param {boolean} escapeEntities
 */ function $ffe42f7d6492ea5b$var$parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
    if (val !== undefined) {
        if (this.options.trimValues && !dontTrim) val = val.trim();
        if (val.length > 0) {
            if (!escapeEntities) val = this.replaceEntitiesValue(val, tagName, jPath);
            const newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);
            if (newval === null || newval === undefined) //don't parse
            return val;
            else if (typeof newval !== typeof val || newval !== val) //overwrite
            return newval;
            else if (this.options.trimValues) return $ffe42f7d6492ea5b$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
            else {
                const trimmedVal = val.trim();
                if (trimmedVal === val) return $ffe42f7d6492ea5b$var$parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
                else return val;
            }
        }
    }
}
function $ffe42f7d6492ea5b$var$resolveNameSpace(tagname) {
    if (this.options.removeNSPrefix) {
        const tags = tagname.split(':');
        const prefix = tagname.charAt(0) === '/' ? '/' : '';
        if (tags[0] === 'xmlns') return '';
        if (tags.length === 2) tagname = prefix + tags[1];
    }
    return tagname;
}
//TODO: change regex to capture NS
//const attrsRegx = new RegExp("([\\w\\-\\.\\:]+)\\s*=\\s*(['\"])((.|\n)*?)\\2","gm");
const $ffe42f7d6492ea5b$var$attrsRegx = new RegExp('([^\\s=]+)\\s*(=\\s*([\'"])([\\s\\S]*?)\\3)?', 'gm');
function $ffe42f7d6492ea5b$var$buildAttributesMap(attrStr, jPath, tagName) {
    if (this.options.ignoreAttributes !== true && typeof attrStr === 'string') {
        // attrStr = attrStr.replace(/\r?\n/g, ' ');
        //attrStr = attrStr || attrStr.trim();
        const matches = $l8rQG.getAllMatches(attrStr, $ffe42f7d6492ea5b$var$attrsRegx);
        const len = matches.length; //don't make it inline
        const attrs = {};
        for(let i = 0; i < len; i++){
            const attrName = this.resolveNameSpace(matches[i][1]);
            if (this.ignoreAttributesFn(attrName, jPath)) continue;
            let oldVal = matches[i][4];
            let aName = this.options.attributeNamePrefix + attrName;
            if (attrName.length) {
                if (this.options.transformAttributeName) aName = this.options.transformAttributeName(aName);
                aName = $ffe42f7d6492ea5b$var$sanitizeName(aName, this.options);
                if (oldVal !== undefined) {
                    if (this.options.trimValues) oldVal = oldVal.trim();
                    oldVal = this.replaceEntitiesValue(oldVal, tagName, jPath);
                    const newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
                    if (newVal === null || newVal === undefined) //don't parse
                    attrs[aName] = oldVal;
                    else if (typeof newVal !== typeof oldVal || newVal !== oldVal) //overwrite
                    attrs[aName] = newVal;
                    else //parse
                    attrs[aName] = $ffe42f7d6492ea5b$var$parseValue(oldVal, this.options.parseAttributeValue, this.options.numberParseOptions);
                } else if (this.options.allowBooleanAttributes) attrs[aName] = true;
            }
        }
        if (!Object.keys(attrs).length) return;
        if (this.options.attributesGroupName) {
            const attrCollection = {};
            attrCollection[this.options.attributesGroupName] = attrs;
            return attrCollection;
        }
        return attrs;
    }
}
const $ffe42f7d6492ea5b$var$parseXml = function(xmlData) {
    xmlData = xmlData.replace(/\r\n?/g, "\n"); //TODO: remove this line
    const xmlObj = new $fQFwH('!xml');
    let currentNode = xmlObj;
    let textData = "";
    let jPath = "";
    // Reset entity expansion counters for this document
    this.entityExpansionCount = 0;
    this.currentExpandedLength = 0;
    const docTypeReader = new $kPrSK(this.options.processEntities);
    for(let i = 0; i < xmlData.length; i++){
        const ch = xmlData[i];
        if (ch === '<') {
            // const nextIndex = i+1;
            // const _2ndChar = xmlData[nextIndex];
            if (xmlData[i + 1] === '/') {
                const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, ">", i, "Closing Tag is not closed.");
                let tagName = xmlData.substring(i + 2, closeIndex).trim();
                if (this.options.removeNSPrefix) {
                    const colonIndex = tagName.indexOf(":");
                    if (colonIndex !== -1) tagName = tagName.substr(colonIndex + 1);
                }
                if (this.options.transformTagName) tagName = this.options.transformTagName(tagName);
                if (currentNode) textData = this.saveTextToParentTag(textData, currentNode, jPath);
                //check if last tag of nested tag was unpaired tag
                const lastTagName = jPath.substring(jPath.lastIndexOf(".") + 1);
                if (tagName && this.options.unpairedTags.indexOf(tagName) !== -1) throw new Error(`Unpaired tag can not be used as closing tag: </${tagName}>`);
                let propIndex = 0;
                if (lastTagName && this.options.unpairedTags.indexOf(lastTagName) !== -1) {
                    propIndex = jPath.lastIndexOf('.', jPath.lastIndexOf('.') - 1);
                    this.tagsNodeStack.pop();
                } else propIndex = jPath.lastIndexOf(".");
                jPath = jPath.substring(0, propIndex);
                currentNode = this.tagsNodeStack.pop(); //avoid recursion, set the parent tag scope
                textData = "";
                i = closeIndex;
            } else if (xmlData[i + 1] === '?') {
                let tagData = $ffe42f7d6492ea5b$var$readTagExp(xmlData, i, false, "?>");
                if (!tagData) throw new Error("Pi Tag is not closed.");
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                if (this.options.ignoreDeclaration && tagData.tagName === "?xml" || this.options.ignorePiTags) ;
                else {
                    const childNode = new $fQFwH(tagData.tagName);
                    childNode.add(this.options.textNodeName, "");
                    if (tagData.tagName !== tagData.tagExp && tagData.attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath, tagData.tagName);
                    this.addChild(currentNode, childNode, jPath, i);
                }
                i = tagData.closeIndex + 1;
            } else if (xmlData.substr(i + 1, 3) === '!--') {
                const endIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, "-->", i + 4, "Comment is not closed.");
                if (this.options.commentPropName) {
                    const comment = xmlData.substring(i + 4, endIndex - 2);
                    textData = this.saveTextToParentTag(textData, currentNode, jPath);
                    currentNode.add(this.options.commentPropName, [
                        {
                            [this.options.textNodeName]: comment
                        }
                    ]);
                }
                i = endIndex;
            } else if (xmlData.substr(i + 1, 2) === '!D') {
                const result = docTypeReader.readDocType(xmlData, i);
                this.docTypeEntities = result.entities;
                i = result.i;
            } else if (xmlData.substr(i + 1, 2) === '![') {
                const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, "]]>", i, "CDATA is not closed.") - 2;
                const tagExp = xmlData.substring(i + 9, closeIndex);
                textData = this.saveTextToParentTag(textData, currentNode, jPath);
                let val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true, true);
                if (val == undefined) val = "";
                //cdata should be set even if it is 0 length string
                if (this.options.cdataPropName) currentNode.add(this.options.cdataPropName, [
                    {
                        [this.options.textNodeName]: tagExp
                    }
                ]);
                else currentNode.add(this.options.textNodeName, val);
                i = closeIndex + 2;
            } else {
                let result = $ffe42f7d6492ea5b$var$readTagExp(xmlData, i, this.options.removeNSPrefix);
                let tagName = result.tagName;
                const rawTagName = result.rawTagName;
                let tagExp = result.tagExp;
                let attrExpPresent = result.attrExpPresent;
                let closeIndex = result.closeIndex;
                if (this.options.transformTagName) {
                    //console.log(tagExp, tagName)
                    const newTagName = this.options.transformTagName(tagName);
                    if (tagExp === tagName) tagExp = newTagName;
                    tagName = newTagName;
                }
                if (this.options.strictReservedNames && (tagName === this.options.commentPropName || tagName === this.options.cdataPropName || tagName === this.options.textNodeName || tagName === this.options.attributesGroupName)) throw new Error(`Invalid tag name: ${tagName}`);
                //save text as child node
                if (currentNode && textData) {
                    if (currentNode.tagname !== '!xml') //when nested tag is found
                    textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
                }
                //check if last tag was unpaired tag
                const lastTag = currentNode;
                if (lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1) {
                    currentNode = this.tagsNodeStack.pop();
                    jPath = jPath.substring(0, jPath.lastIndexOf("."));
                }
                if (tagName !== xmlObj.tagname) jPath += jPath ? "." + tagName : tagName;
                const startIndex = i;
                if (this.isItStopNode(this.stopNodesExact, this.stopNodesWildcard, jPath, tagName)) {
                    let tagContent = "";
                    //self-closing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                        if (tagName[tagName.length - 1] === "/") {
                            tagName = tagName.substr(0, tagName.length - 1);
                            jPath = jPath.substr(0, jPath.length - 1);
                            tagExp = tagName;
                        } else tagExp = tagExp.substr(0, tagExp.length - 1);
                        i = result.closeIndex;
                    } else if (this.options.unpairedTags.indexOf(tagName) !== -1) i = result.closeIndex;
                    else {
                        //read until closing tag is found
                        const result = this.readStopNodeData(xmlData, rawTagName, closeIndex + 1);
                        if (!result) throw new Error(`Unexpected end of ${rawTagName}`);
                        i = result.i;
                        tagContent = result.tagContent;
                    }
                    const childNode = new $fQFwH(tagName);
                    if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                    if (tagContent) tagContent = this.parseTextData(tagContent, tagName, jPath, true, attrExpPresent, true, true);
                    jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    childNode.add(this.options.textNodeName, tagContent);
                    this.addChild(currentNode, childNode, jPath, startIndex);
                } else {
                    //selfClosing tag
                    if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
                        if (tagName[tagName.length - 1] === "/") {
                            tagName = tagName.substr(0, tagName.length - 1);
                            jPath = jPath.substr(0, jPath.length - 1);
                            tagExp = tagName;
                        } else tagExp = tagExp.substr(0, tagExp.length - 1);
                        if (this.options.transformTagName) {
                            const newTagName = this.options.transformTagName(tagName);
                            if (tagExp === tagName) tagExp = newTagName;
                            tagName = newTagName;
                        }
                        const childNode = new $fQFwH(tagName);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath, startIndex);
                        jPath = jPath.substr(0, jPath.lastIndexOf("."));
                    } else if (this.options.unpairedTags.indexOf(tagName) !== -1) {
                        const childNode = new $fQFwH(tagName);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath);
                        this.addChild(currentNode, childNode, jPath, startIndex);
                        jPath = jPath.substr(0, jPath.lastIndexOf("."));
                        i = result.closeIndex;
                        continue;
                    } else {
                        const childNode = new $fQFwH(tagName);
                        if (this.tagsNodeStack.length > this.options.maxNestedTags) throw new Error("Maximum nested tags exceeded");
                        this.tagsNodeStack.push(currentNode);
                        if (tagName !== tagExp && attrExpPresent) childNode[":@"] = this.buildAttributesMap(tagExp, jPath, tagName);
                        this.addChild(currentNode, childNode, jPath);
                        currentNode = childNode;
                    }
                    textData = "";
                    i = closeIndex;
                }
            }
        } else textData += xmlData[i];
    }
    return xmlObj.child;
};
function $ffe42f7d6492ea5b$var$addChild(currentNode, childNode, jPath, startIndex) {
    // unset startIndex if not requested
    if (!this.options.captureMetaData) startIndex = undefined;
    const result = this.options.updateTag(childNode.tagname, jPath, childNode[":@"]);
    if (result === false) ;
    else if (typeof result === "string") {
        childNode.tagname = result;
        currentNode.addChild(childNode, startIndex);
    } else currentNode.addChild(childNode, startIndex);
}
const $ffe42f7d6492ea5b$var$replaceEntitiesValue = function(val, tagName, jPath) {
    // Performance optimization: Early return if no entities to replace
    if (val.indexOf('&') === -1) return val;
    const entityConfig = this.options.processEntities;
    if (!entityConfig.enabled) return val;
    // Check tag-specific filtering
    if (entityConfig.allowedTags) {
        if (!entityConfig.allowedTags.includes(tagName)) return val; // Skip entity replacement for current tag as not set
    }
    if (entityConfig.tagFilter) {
        if (!entityConfig.tagFilter(tagName, jPath)) return val; // Skip based on custom filter
    }
    // Replace DOCTYPE entities
    for(let entityName in this.docTypeEntities){
        const entity = this.docTypeEntities[entityName];
        const matches = val.match(entity.regx);
        if (matches) {
            // Track expansions
            this.entityExpansionCount += matches.length;
            // Check expansion limit
            if (entityConfig.maxTotalExpansions && this.entityExpansionCount > entityConfig.maxTotalExpansions) throw new Error(`Entity expansion limit exceeded: ${this.entityExpansionCount} > ${entityConfig.maxTotalExpansions}`);
            // Store length before replacement
            const lengthBefore = val.length;
            val = val.replace(entity.regx, entity.val);
            // Check expanded length immediately after replacement
            if (entityConfig.maxExpandedLength) {
                this.currentExpandedLength += val.length - lengthBefore;
                if (this.currentExpandedLength > entityConfig.maxExpandedLength) throw new Error(`Total expanded content size exceeded: ${this.currentExpandedLength} > ${entityConfig.maxExpandedLength}`);
            }
        }
    }
    if (val.indexOf('&') === -1) return val; // Early exit
    // Replace standard entities
    for (const entityName of Object.keys(this.lastEntities)){
        const entity = this.lastEntities[entityName];
        const matches = val.match(entity.regex);
        if (matches) {
            this.entityExpansionCount += matches.length;
            if (entityConfig.maxTotalExpansions && this.entityExpansionCount > entityConfig.maxTotalExpansions) throw new Error(`Entity expansion limit exceeded: ${this.entityExpansionCount} > ${entityConfig.maxTotalExpansions}`);
        }
        val = val.replace(entity.regex, entity.val);
    }
    if (val.indexOf('&') === -1) return val; // Early exit
    // Replace HTML entities if enabled
    if (this.options.htmlEntities) for (const entityName of Object.keys(this.htmlEntities)){
        const entity = this.htmlEntities[entityName];
        const matches = val.match(entity.regex);
        if (matches) {
            //console.log(matches);
            this.entityExpansionCount += matches.length;
            if (entityConfig.maxTotalExpansions && this.entityExpansionCount > entityConfig.maxTotalExpansions) throw new Error(`Entity expansion limit exceeded: ${this.entityExpansionCount} > ${entityConfig.maxTotalExpansions}`);
        }
        val = val.replace(entity.regex, entity.val);
    }
    // Replace ampersand entity last
    val = val.replace(this.ampEntity.regex, this.ampEntity.val);
    return val;
};
function $ffe42f7d6492ea5b$var$saveTextToParentTag(textData, parentNode, jPath, isLeafNode) {
    if (textData) {
        if (isLeafNode === undefined) isLeafNode = parentNode.child.length === 0;
        textData = this.parseTextData(textData, parentNode.tagname, jPath, false, parentNode[":@"] ? Object.keys(parentNode[":@"]).length !== 0 : false, isLeafNode);
        if (textData !== undefined && textData !== "") parentNode.add(this.options.textNodeName, textData);
        textData = "";
    }
    return textData;
}
//TODO: use jPath to simplify the logic
/**
 * @param {Set} stopNodesExact
 * @param {Set} stopNodesWildcard
 * @param {string} jPath
 * @param {string} currentTagName
 */ function $ffe42f7d6492ea5b$var$isItStopNode(stopNodesExact, stopNodesWildcard, jPath, currentTagName) {
    if (stopNodesWildcard && stopNodesWildcard.has(currentTagName)) return true;
    if (stopNodesExact && stopNodesExact.has(jPath)) return true;
    return false;
}
/**
 * Returns the tag Expression and where it is ending handling single-double quotes situation
 * @param {string} xmlData 
 * @param {number} i starting index
 * @returns 
 */ function $ffe42f7d6492ea5b$var$tagExpWithClosingIndex(xmlData, i, closingChar = ">") {
    let attrBoundary;
    let tagExp = "";
    for(let index = i; index < xmlData.length; index++){
        let ch = xmlData[index];
        if (attrBoundary) {
            if (ch === attrBoundary) attrBoundary = ""; //reset
        } else if (ch === '"' || ch === "'") attrBoundary = ch;
        else if (ch === closingChar[0]) {
            if (closingChar[1]) {
                if (xmlData[index + 1] === closingChar[1]) return {
                    data: tagExp,
                    index: index
                };
            } else return {
                data: tagExp,
                index: index
            };
        } else if (ch === '\t') ch = " ";
        tagExp += ch;
    }
}
function $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, str, i, errMsg) {
    const closingIndex = xmlData.indexOf(str, i);
    if (closingIndex === -1) throw new Error(errMsg);
    else return closingIndex + str.length - 1;
}
function $ffe42f7d6492ea5b$var$readTagExp(xmlData, i, removeNSPrefix, closingChar = ">") {
    const result = $ffe42f7d6492ea5b$var$tagExpWithClosingIndex(xmlData, i + 1, closingChar);
    if (!result) return;
    let tagExp = result.data;
    const closeIndex = result.index;
    const separatorIndex = tagExp.search(/\s/);
    let tagName = tagExp;
    let attrExpPresent = true;
    if (separatorIndex !== -1) {
        tagName = tagExp.substring(0, separatorIndex);
        tagExp = tagExp.substring(separatorIndex + 1).trimStart();
    }
    const rawTagName = tagName;
    if (removeNSPrefix) {
        const colonIndex = tagName.indexOf(":");
        if (colonIndex !== -1) {
            tagName = tagName.substr(colonIndex + 1);
            attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
        }
    }
    return {
        tagName: tagName,
        tagExp: tagExp,
        closeIndex: closeIndex,
        attrExpPresent: attrExpPresent,
        rawTagName: rawTagName
    };
}
/**
 * find paired tag for a stop node
 * @param {string} xmlData 
 * @param {string} tagName 
 * @param {number} i 
 */ function $ffe42f7d6492ea5b$var$readStopNodeData(xmlData, tagName, i) {
    const startIndex = i;
    // Starting at 1 since we already have an open tag
    let openTagCount = 1;
    for(; i < xmlData.length; i++)if (xmlData[i] === "<") {
        if (xmlData[i + 1] === "/") {
            const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, ">", i, `${tagName} is not closed`);
            let closeTagName = xmlData.substring(i + 2, closeIndex).trim();
            if (closeTagName === tagName) {
                openTagCount--;
                if (openTagCount === 0) return {
                    tagContent: xmlData.substring(startIndex, i),
                    i: closeIndex
                };
            }
            i = closeIndex;
        } else if (xmlData[i + 1] === '?') {
            const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, "?>", i + 1, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 3) === '!--') {
            const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, "-->", i + 3, "StopNode is not closed.");
            i = closeIndex;
        } else if (xmlData.substr(i + 1, 2) === '![') {
            const closeIndex = $ffe42f7d6492ea5b$var$findClosingIndex(xmlData, "]]>", i, "StopNode is not closed.") - 2;
            i = closeIndex;
        } else {
            const tagData = $ffe42f7d6492ea5b$var$readTagExp(xmlData, i, '>');
            if (tagData) {
                const openTagName = tagData && tagData.tagName;
                if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length - 1] !== "/") openTagCount++;
                i = tagData.closeIndex;
            }
        }
    }
     //end for loop
}
function $ffe42f7d6492ea5b$var$parseValue(val, shouldParse, options) {
    if (shouldParse && typeof val === 'string') {
        //console.log(options)
        const newval = val.trim();
        if (newval === 'true') return true;
        else if (newval === 'false') return false;
        else return $fLtYL(val, options);
    } else {
        if ($l8rQG.isExist(val)) return val;
        else return '';
    }
}
function $ffe42f7d6492ea5b$var$fromCodePoint(str, base, prefix) {
    const codePoint = Number.parseInt(str, base);
    if (codePoint >= 0 && codePoint <= 0x10FFFF) return String.fromCodePoint(codePoint);
    else return prefix + str + ";";
}
function $ffe42f7d6492ea5b$var$sanitizeName(name, options) {
    if ($l8rQG.criticalProperties.includes(name)) throw new Error(`[SECURITY] Invalid name: "${name}" is a reserved JavaScript keyword that could cause prototype pollution`);
    else if ($l8rQG.DANGEROUS_PROPERTY_NAMES.includes(name)) return options.onDangerousProperty(name);
    return name;
}
module.exports = $ffe42f7d6492ea5b$var$OrderedObjParser;

});
parcelRegister("fQFwH", function(module, exports) {
'use strict';
class $b89beca15b40c3b5$var$XmlNode {
    constructor(tagname){
        this.tagname = tagname;
        this.child = []; //nested tags, text, cdata, comments in order
        this[":@"] = {}; //attributes map
    }
    add(key, val) {
        // this.child.push( {name : key, val: val, isCdata: isCdata });
        if (key === "__proto__") key = "#__proto__";
        this.child.push({
            [key]: val
        });
    }
    addChild(node) {
        if (node.tagname === "__proto__") node.tagname = "#__proto__";
        if (node[":@"] && Object.keys(node[":@"]).length > 0) this.child.push({
            [node.tagname]: node.child,
            [":@"]: node[":@"]
        });
        else this.child.push({
            [node.tagname]: node.child
        });
    }
}
module.exports = $b89beca15b40c3b5$var$XmlNode;

});

parcelRegister("kPrSK", function(module, exports) {

var $l8rQG = parcelRequire("l8rQG");
class $f29e32ddf0f58f56$var$DocTypeReader {
    constructor(options){
        this.suppressValidationErr = !options;
        this.options = options || {};
    }
    readDocType(xmlData, i) {
        const entities = Object.create(null);
        let entityCount = 0;
        if (xmlData[i + 3] === 'O' && xmlData[i + 4] === 'C' && xmlData[i + 5] === 'T' && xmlData[i + 6] === 'Y' && xmlData[i + 7] === 'P' && xmlData[i + 8] === 'E') {
            i = i + 9;
            let angleBracketsCount = 1;
            let hasBody = false, comment = false;
            let exp = "";
            for(; i < xmlData.length; i++){
                if (xmlData[i] === '<' && !comment) {
                    if (hasBody && $f29e32ddf0f58f56$var$hasSeq(xmlData, "!ENTITY", i)) {
                        i += 7;
                        let entityName, val;
                        [entityName, val, i] = this.readEntityExp(xmlData, i + 1, this.suppressValidationErr);
                        if (val.indexOf("&") === -1) {
                            if (this.options.enabled !== false && this.options.maxEntityCount != null && entityCount >= this.options.maxEntityCount) throw new Error(`Entity count (${entityCount + 1}) exceeds maximum allowed (${this.options.maxEntityCount})`);
                            //const escaped = entityName.replace(/[.\-+*:]/g, '\\.');
                            const escaped = entityName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                            entities[entityName] = {
                                regx: RegExp(`&${escaped};`, "g"),
                                val: val
                            };
                            entityCount++;
                        }
                    } else if (hasBody && $f29e32ddf0f58f56$var$hasSeq(xmlData, "!ELEMENT", i)) {
                        i += 8; //Not supported
                        const { index: index } = this.readElementExp(xmlData, i + 1);
                        i = index;
                    } else if (hasBody && $f29e32ddf0f58f56$var$hasSeq(xmlData, "!ATTLIST", i)) i += 8; //Not supported
                    else if (hasBody && $f29e32ddf0f58f56$var$hasSeq(xmlData, "!NOTATION", i)) {
                        i += 9; //Not supported
                        const { index: index } = this.readNotationExp(xmlData, i + 1, this.suppressValidationErr);
                        i = index;
                    } else if ($f29e32ddf0f58f56$var$hasSeq(xmlData, "!--", i)) comment = true;
                    else throw new Error(`Invalid DOCTYPE`);
                    angleBracketsCount++;
                    exp = "";
                } else if (xmlData[i] === '>') {
                    if (comment) {
                        if (xmlData[i - 1] === "-" && xmlData[i - 2] === "-") {
                            comment = false;
                            angleBracketsCount--;
                        }
                    } else angleBracketsCount--;
                    if (angleBracketsCount === 0) break;
                } else if (xmlData[i] === '[') hasBody = true;
                else exp += xmlData[i];
            }
            if (angleBracketsCount !== 0) throw new Error(`Unclosed DOCTYPE`);
        } else throw new Error(`Invalid Tag instead of DOCTYPE`);
        return {
            entities: entities,
            i: i
        };
    }
    readEntityExp(xmlData, i) {
        //External entities are not supported
        //    <!ENTITY ext SYSTEM "http://normal-website.com" >
        //Parameter entities are not supported
        //    <!ENTITY entityname "&anotherElement;">
        //Internal entities are supported
        //    <!ENTITY entityname "replacement text">
        // Skip leading whitespace after <!ENTITY
        i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
        // Read entity name
        let entityName = "";
        while(i < xmlData.length && !/\s/.test(xmlData[i]) && xmlData[i] !== '"' && xmlData[i] !== "'"){
            entityName += xmlData[i];
            i++;
        }
        $f29e32ddf0f58f56$var$validateEntityName(entityName);
        // Skip whitespace after entity name
        i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
        // Check for unsupported constructs (external entities or parameter entities)
        if (!this.suppressValidationErr) {
            if (xmlData.substring(i, i + 6).toUpperCase() === "SYSTEM") throw new Error("External entities are not supported");
            else if (xmlData[i] === "%") throw new Error("Parameter entities are not supported");
        }
        // Read entity value (internal entity)
        let entityValue = "";
        [i, entityValue] = this.readIdentifierVal(xmlData, i, "entity");
        // Validate entity size
        if (this.options.enabled !== false && this.options.maxEntitySize != null && entityValue.length > this.options.maxEntitySize) throw new Error(`Entity "${entityName}" size (${entityValue.length}) exceeds maximum allowed size (${this.options.maxEntitySize})`);
        i--;
        return [
            entityName,
            entityValue,
            i
        ];
    }
    readNotationExp(xmlData, i) {
        // Skip leading whitespace after <!NOTATION
        i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
        // Read notation name
        let notationName = "";
        while(i < xmlData.length && !/\s/.test(xmlData[i])){
            notationName += xmlData[i];
            i++;
        }
        !this.suppressValidationErr && $f29e32ddf0f58f56$var$validateEntityName(notationName);
        // Skip whitespace after notation name
        i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
        // Check identifier type (SYSTEM or PUBLIC)
        const identifierType = xmlData.substring(i, i + 6).toUpperCase();
        if (!this.suppressValidationErr && identifierType !== "SYSTEM" && identifierType !== "PUBLIC") throw new Error(`Expected SYSTEM or PUBLIC, found "${identifierType}"`);
        i += identifierType.length;
        // Skip whitespace after identifier type
        i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
        // Read public identifier (if PUBLIC)
        let publicIdentifier = null;
        let systemIdentifier = null;
        if (identifierType === "PUBLIC") {
            [i, publicIdentifier] = this.readIdentifierVal(xmlData, i, "publicIdentifier");
            // Skip whitespace after public identifier
            i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
            // Optionally read system identifier
            if (xmlData[i] === '"' || xmlData[i] === "'") [i, systemIdentifier] = this.readIdentifierVal(xmlData, i, "systemIdentifier");
        } else if (identifierType === "SYSTEM") {
            // Read system identifier (mandatory for SYSTEM)
            [i, systemIdentifier] = this.readIdentifierVal(xmlData, i, "systemIdentifier");
            if (!this.suppressValidationErr && !systemIdentifier) throw new Error("Missing mandatory system identifier for SYSTEM notation");
        }
        return {
            notationName: notationName,
            publicIdentifier: publicIdentifier,
            systemIdentifier: systemIdentifier,
            index: --i
        };
    }
    readIdentifierVal(xmlData, i, type) {
        let identifierVal = "";
        const startChar = xmlData[i];
        if (startChar !== '"' && startChar !== "'") throw new Error(`Expected quoted string, found "${startChar}"`);
        i++;
        while(i < xmlData.length && xmlData[i] !== startChar){
            identifierVal += xmlData[i];
            i++;
        }
        if (xmlData[i] !== startChar) throw new Error(`Unterminated ${type} value`);
        i++;
        return [
            i,
            identifierVal
        ];
    }
    readElementExp(xmlData, i) {
        // <!ELEMENT br EMPTY>
        // <!ELEMENT div ANY>
        // <!ELEMENT title (#PCDATA)>
        // <!ELEMENT book (title, author+)>
        // <!ELEMENT name (content-model)>
        // Skip leading whitespace after <!ELEMENT
        i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
        // Read element name
        let elementName = "";
        while(i < xmlData.length && !/\s/.test(xmlData[i])){
            elementName += xmlData[i];
            i++;
        }
        // Validate element name
        if (!this.suppressValidationErr && !$l8rQG.isName(elementName)) throw new Error(`Invalid element name: "${elementName}"`);
        // Skip whitespace after element name
        i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
        let contentModel = "";
        // Expect '(' to start content model
        if (xmlData[i] === "E" && $f29e32ddf0f58f56$var$hasSeq(xmlData, "MPTY", i)) i += 4;
        else if (xmlData[i] === "A" && $f29e32ddf0f58f56$var$hasSeq(xmlData, "NY", i)) i += 2;
        else if (xmlData[i] === "(") {
            i++; // Move past '('
            // Read content model
            while(i < xmlData.length && xmlData[i] !== ")"){
                contentModel += xmlData[i];
                i++;
            }
            if (xmlData[i] !== ")") throw new Error("Unterminated content model");
        } else if (!this.suppressValidationErr) throw new Error(`Invalid Element Expression, found "${xmlData[i]}"`);
        return {
            elementName: elementName,
            contentModel: contentModel.trim(),
            index: i
        };
    }
    readAttlistExp(xmlData, i) {
        // Skip leading whitespace after <!ATTLIST
        i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
        // Read element name
        let elementName = "";
        while(i < xmlData.length && !/\s/.test(xmlData[i])){
            elementName += xmlData[i];
            i++;
        }
        // Validate element name
        $f29e32ddf0f58f56$var$validateEntityName(elementName);
        // Skip whitespace after element name
        i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
        // Read attribute name
        let attributeName = "";
        while(i < xmlData.length && !/\s/.test(xmlData[i])){
            attributeName += xmlData[i];
            i++;
        }
        // Validate attribute name
        if (!$f29e32ddf0f58f56$var$validateEntityName(attributeName)) throw new Error(`Invalid attribute name: "${attributeName}"`);
        // Skip whitespace after attribute name
        i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
        // Read attribute type
        let attributeType = "";
        if (xmlData.substring(i, i + 8).toUpperCase() === "NOTATION") {
            attributeType = "NOTATION";
            i += 8; // Move past "NOTATION"
            // Skip whitespace after "NOTATION"
            i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
            // Expect '(' to start the list of notations
            if (xmlData[i] !== "(") throw new Error(`Expected '(', found "${xmlData[i]}"`);
            i++; // Move past '('
            // Read the list of allowed notations
            let allowedNotations = [];
            while(i < xmlData.length && xmlData[i] !== ")"){
                let notation = "";
                while(i < xmlData.length && xmlData[i] !== "|" && xmlData[i] !== ")"){
                    notation += xmlData[i];
                    i++;
                }
                // Validate notation name
                notation = notation.trim();
                if (!$f29e32ddf0f58f56$var$validateEntityName(notation)) throw new Error(`Invalid notation name: "${notation}"`);
                allowedNotations.push(notation);
                // Skip '|' separator or exit loop
                if (xmlData[i] === "|") {
                    i++; // Move past '|'
                    i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i); // Skip optional whitespace after '|'
                }
            }
            if (xmlData[i] !== ")") throw new Error("Unterminated list of notations");
            i++; // Move past ')'
            // Store the allowed notations as part of the attribute type
            attributeType += " (" + allowedNotations.join("|") + ")";
        } else {
            // Handle simple types (e.g., CDATA, ID, IDREF, etc.)
            while(i < xmlData.length && !/\s/.test(xmlData[i])){
                attributeType += xmlData[i];
                i++;
            }
            // Validate simple attribute type
            const validTypes = [
                "CDATA",
                "ID",
                "IDREF",
                "IDREFS",
                "ENTITY",
                "ENTITIES",
                "NMTOKEN",
                "NMTOKENS"
            ];
            if (!this.suppressValidationErr && !validTypes.includes(attributeType.toUpperCase())) throw new Error(`Invalid attribute type: "${attributeType}"`);
        }
        // Skip whitespace after attribute type
        i = $f29e32ddf0f58f56$var$skipWhitespace(xmlData, i);
        // Read default value
        let defaultValue = "";
        if (xmlData.substring(i, i + 8).toUpperCase() === "#REQUIRED") {
            defaultValue = "#REQUIRED";
            i += 8;
        } else if (xmlData.substring(i, i + 7).toUpperCase() === "#IMPLIED") {
            defaultValue = "#IMPLIED";
            i += 7;
        } else [i, defaultValue] = this.readIdentifierVal(xmlData, i, "ATTLIST");
        return {
            elementName: elementName,
            attributeName: attributeName,
            attributeType: attributeType,
            defaultValue: defaultValue,
            index: i
        };
    }
}
// Helper functions
const $f29e32ddf0f58f56$var$skipWhitespace = (data, index)=>{
    while(index < data.length && /\s/.test(data[index]))index++;
    return index;
};
function $f29e32ddf0f58f56$var$hasSeq(data, seq, i) {
    for(let j = 0; j < seq.length; j++){
        if (seq[j] !== data[i + j + 1]) return false;
    }
    return true;
}
function $f29e32ddf0f58f56$var$validateEntityName(name) {
    if ($l8rQG.isName(name)) return name;
    else throw new Error(`Invalid entity name ${name}`);
}
module.exports = $f29e32ddf0f58f56$var$DocTypeReader;

});

parcelRegister("fLtYL", function(module, exports) {
const $b7a28001cd116d9a$var$hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const $b7a28001cd116d9a$var$numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
// const octRegex = /0x[a-z0-9]+/;
// const binRegex = /0x[a-z0-9]+/;
//polyfill
if (!Number.parseInt && window.parseInt) Number.parseInt = window.parseInt;
if (!Number.parseFloat && window.parseFloat) Number.parseFloat = window.parseFloat;
const $b7a28001cd116d9a$var$consider = {
    hex: true,
    leadingZeros: true,
    decimalPoint: "\.",
    eNotation: true
};
function $b7a28001cd116d9a$var$toNumber(str, options = {}) {
    // const options = Object.assign({}, consider);
    // if(opt.leadingZeros === false){
    //     options.leadingZeros = false;
    // }else if(opt.hex === false){
    //     options.hex = false;
    // }
    options = Object.assign({}, $b7a28001cd116d9a$var$consider, options);
    if (!str || typeof str !== "string") return str;
    let trimmedStr = str.trim();
    // if(trimmedStr === "0.0") return 0;
    // else if(trimmedStr === "+0.0") return 0;
    // else if(trimmedStr === "-0.0") return -0;
    if (options.skipLike !== undefined && options.skipLike.test(trimmedStr)) return str;
    else if (options.hex && $b7a28001cd116d9a$var$hexRegex.test(trimmedStr)) return Number.parseInt(trimmedStr, 16);
    else {
        //separate negative sign, leading zeros, and rest number
        const match = $b7a28001cd116d9a$var$numRegex.exec(trimmedStr);
        if (match) {
            const sign = match[1];
            const leadingZeros = match[2];
            let numTrimmedByZeros = $b7a28001cd116d9a$var$trimZeros(match[3]); //complete num without leading zeros
            //trim ending zeros for floating number
            const eNotation = match[4] || match[6];
            if (!options.leadingZeros && leadingZeros.length > 0 && sign && trimmedStr[2] !== ".") return str; //-0123
            else if (!options.leadingZeros && leadingZeros.length > 0 && !sign && trimmedStr[1] !== ".") return str; //0123
            else {
                const num = Number(trimmedStr);
                const numStr = "" + num;
                if (numStr.search(/[eE]/) !== -1) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (eNotation) {
                    if (options.eNotation) return num;
                    else return str;
                } else if (trimmedStr.indexOf(".") !== -1) {
                    // const decimalPart = match[5].substr(1);
                    // const intPart = trimmedStr.substr(0,trimmedStr.indexOf("."));
                    // const p = numStr.indexOf(".");
                    // const givenIntPart = numStr.substr(0,p);
                    // const givenDecPart = numStr.substr(p+1);
                    if (numStr === "0" && numTrimmedByZeros === "") return num; //0.0
                    else if (numStr === numTrimmedByZeros) return num; //0.456. 0.79000
                    else if (sign && numStr === "-" + numTrimmedByZeros) return num;
                    else return str;
                }
                if (leadingZeros) {
                    // if(numTrimmedByZeros === numStr){
                    //     if(options.leadingZeros) return num;
                    //     else return str;
                    // }else return str;
                    if (numTrimmedByZeros === numStr) return num;
                    else if (sign + numTrimmedByZeros === numStr) return num;
                    else return str;
                }
                if (trimmedStr === numStr) return num;
                else if (trimmedStr === sign + numStr) return num;
                // else{
                //     //number with +/- sign
                //     trimmedStr.test(/[-+][0-9]);
                // }
                return str;
            }
        // else if(!eNotation && trimmedStr && trimmedStr !== Number(trimmedStr) ) return str;
        } else return str;
    }
}
/**
 * 
 * @param {string} numStr without leading zeros
 * @returns 
 */ function $b7a28001cd116d9a$var$trimZeros(numStr) {
    if (numStr && numStr.indexOf(".") !== -1) {
        numStr = numStr.replace(/0+$/, ""); //remove ending zeros
        if (numStr === ".") numStr = "0";
        else if (numStr[0] === ".") numStr = "0" + numStr;
        else if (numStr[numStr.length - 1] === ".") numStr = numStr.substr(0, numStr.length - 1);
        return numStr;
    }
    return numStr;
}
module.exports = $b7a28001cd116d9a$var$toNumber;

});

parcelRegister("1DUme", function(module, exports) {
function $1325266c04d28893$var$getIgnoreAttributesFn(ignoreAttributes) {
    if (typeof ignoreAttributes === 'function') return ignoreAttributes;
    if (Array.isArray(ignoreAttributes)) return (attrName)=>{
        for (const pattern of ignoreAttributes){
            if (typeof pattern === 'string' && attrName === pattern) return true;
            if (pattern instanceof RegExp && pattern.test(attrName)) return true;
        }
    };
    return ()=>false;
}
module.exports = $1325266c04d28893$var$getIgnoreAttributesFn;

});


parcelRegister("bG4eT", function(module, exports) {

$parcel$export(module.exports, "prettify", () => $8806e7cb340781c4$export$1b80ed980367b7c1, (v) => $8806e7cb340781c4$export$1b80ed980367b7c1 = v);
var $8806e7cb340781c4$export$1b80ed980367b7c1;
'use strict';
/**
 * 
 * @param {array} node 
 * @param {any} options 
 * @returns 
 */ function $8806e7cb340781c4$var$prettify(node, options) {
    return $8806e7cb340781c4$var$compress(node, options);
}
/**
 * 
 * @param {array} arr 
 * @param {object} options 
 * @param {string} jPath 
 * @returns object
 */ function $8806e7cb340781c4$var$compress(arr, options, jPath) {
    let text;
    const compressedObj = {};
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const property = $8806e7cb340781c4$var$propName(tagObj);
        let newJpath = "";
        if (jPath === undefined) newJpath = property;
        else newJpath = jPath + "." + property;
        if (property === options.textNodeName) {
            if (text === undefined) text = tagObj[property];
            else text += "" + tagObj[property];
        } else if (property === undefined) continue;
        else if (tagObj[property]) {
            let val = $8806e7cb340781c4$var$compress(tagObj[property], options, newJpath);
            const isLeaf = $8806e7cb340781c4$var$isLeafTag(val, options);
            if (tagObj[":@"]) $8806e7cb340781c4$var$assignAttributes(val, tagObj[":@"], newJpath, options);
            else if (Object.keys(val).length === 1 && val[options.textNodeName] !== undefined && !options.alwaysCreateTextNode) val = val[options.textNodeName];
            else if (Object.keys(val).length === 0) {
                if (options.alwaysCreateTextNode) val[options.textNodeName] = "";
                else val = "";
            }
            if (compressedObj[property] !== undefined && compressedObj.hasOwnProperty(property)) {
                if (!Array.isArray(compressedObj[property])) compressedObj[property] = [
                    compressedObj[property]
                ];
                compressedObj[property].push(val);
            } else //TODO: if a node is not an array, then check if it should be an array
            //also determine if it is a leaf node
            if (options.isArray(property, newJpath, isLeaf)) compressedObj[property] = [
                val
            ];
            else compressedObj[property] = val;
        }
    }
    // if(text && text.length > 0) compressedObj[options.textNodeName] = text;
    if (typeof text === "string") {
        if (text.length > 0) compressedObj[options.textNodeName] = text;
    } else if (text !== undefined) compressedObj[options.textNodeName] = text;
    return compressedObj;
}
function $8806e7cb340781c4$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (key !== ":@") return key;
    }
}
function $8806e7cb340781c4$var$assignAttributes(obj, attrMap, jpath, options) {
    if (attrMap) {
        const keys = Object.keys(attrMap);
        const len = keys.length; //don't make it inline
        for(let i = 0; i < len; i++){
            const atrrName = keys[i];
            if (options.isArray(atrrName, jpath + "." + atrrName, true, true)) obj[atrrName] = [
                attrMap[atrrName]
            ];
            else obj[atrrName] = attrMap[atrrName];
        }
    }
}
function $8806e7cb340781c4$var$isLeafTag(obj, options) {
    const { textNodeName: textNodeName } = options;
    const propCount = Object.keys(obj).length;
    if (propCount === 0) return true;
    if (propCount === 1 && (obj[textNodeName] || typeof obj[textNodeName] === "boolean" || obj[textNodeName] === 0)) return true;
    return false;
}
$8806e7cb340781c4$export$1b80ed980367b7c1 = $8806e7cb340781c4$var$prettify;

});


parcelRegister("kE74N", function(module, exports) {
'use strict';

var $awGub = parcelRequire("awGub");

var $1DUme = parcelRequire("1DUme");
const $f07d0849a7dcedd5$var$defaultOptions = {
    attributeNamePrefix: '@_',
    attributesGroupName: false,
    textNodeName: '#text',
    ignoreAttributes: true,
    cdataPropName: false,
    format: false,
    indentBy: '  ',
    suppressEmptyNode: false,
    suppressUnpairedNode: true,
    suppressBooleanAttributes: true,
    tagValueProcessor: function(key, a) {
        return a;
    },
    attributeValueProcessor: function(attrName, a) {
        return a;
    },
    preserveOrder: false,
    commentPropName: false,
    unpairedTags: [],
    entities: [
        {
            regex: new RegExp("&", "g"),
            val: "&amp;"
        },
        {
            regex: new RegExp(">", "g"),
            val: "&gt;"
        },
        {
            regex: new RegExp("<", "g"),
            val: "&lt;"
        },
        {
            regex: new RegExp("\'", "g"),
            val: "&apos;"
        },
        {
            regex: new RegExp("\"", "g"),
            val: "&quot;"
        }
    ],
    processEntities: true,
    stopNodes: [],
    // transformTagName: false,
    // transformAttributeName: false,
    oneListGroup: false
};
function $f07d0849a7dcedd5$var$Builder(options) {
    this.options = Object.assign({}, $f07d0849a7dcedd5$var$defaultOptions, options);
    if (this.options.ignoreAttributes === true || this.options.attributesGroupName) this.isAttribute = function() {
        return false;
    };
    else {
        this.ignoreAttributesFn = $1DUme(this.options.ignoreAttributes);
        this.attrPrefixLen = this.options.attributeNamePrefix.length;
        this.isAttribute = $f07d0849a7dcedd5$var$isAttribute;
    }
    this.processTextOrObjNode = $f07d0849a7dcedd5$var$processTextOrObjNode;
    if (this.options.format) {
        this.indentate = $f07d0849a7dcedd5$var$indentate;
        this.tagEndChar = '>\n';
        this.newLine = '\n';
    } else {
        this.indentate = function() {
            return '';
        };
        this.tagEndChar = '>';
        this.newLine = '';
    }
}
$f07d0849a7dcedd5$var$Builder.prototype.build = function(jObj) {
    if (this.options.preserveOrder) return $awGub(jObj, this.options);
    else {
        if (Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1) jObj = {
            [this.options.arrayNodeName]: jObj
        };
        return this.j2x(jObj, 0, []).val;
    }
};
$f07d0849a7dcedd5$var$Builder.prototype.j2x = function(jObj, level, ajPath) {
    let attrStr = '';
    let val = '';
    const jPath = ajPath.join('.');
    for(let key in jObj){
        if (!Object.prototype.hasOwnProperty.call(jObj, key)) continue;
        if (typeof jObj[key] === 'undefined') // supress undefined node only if it is not an attribute
        {
            if (this.isAttribute(key)) val += '';
        } else if (jObj[key] === null) {
            // null attribute should be ignored by the attribute list, but should not cause the tag closing
            if (this.isAttribute(key)) val += '';
            else if (key === this.options.cdataPropName) val += '';
            else if (key[0] === '?') val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
            else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        // val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
        } else if (jObj[key] instanceof Date) val += this.buildTextValNode(jObj[key], key, '', level);
        else if (typeof jObj[key] !== 'object') {
            //premitive type
            const attr = this.isAttribute(key);
            if (attr && !this.ignoreAttributesFn(attr, jPath)) attrStr += this.buildAttrPairStr(attr, '' + jObj[key]);
            else if (!attr) {
                //tag value
                if (key === this.options.textNodeName) {
                    let newval = this.options.tagValueProcessor(key, '' + jObj[key]);
                    val += this.replaceEntitiesValue(newval);
                } else val += this.buildTextValNode(jObj[key], key, '', level);
            }
        } else if (Array.isArray(jObj[key])) {
            //repeated nodes
            const arrLen = jObj[key].length;
            let listTagVal = "";
            let listTagAttr = "";
            for(let j = 0; j < arrLen; j++){
                const item = jObj[key][j];
                if (typeof item === 'undefined') ;
                else if (item === null) {
                    if (key[0] === "?") val += this.indentate(level) + '<' + key + '?' + this.tagEndChar;
                    else val += this.indentate(level) + '<' + key + '/' + this.tagEndChar;
                } else if (typeof item === 'object') {
                    if (this.options.oneListGroup) {
                        const result = this.j2x(item, level + 1, ajPath.concat(key));
                        listTagVal += result.val;
                        if (this.options.attributesGroupName && item.hasOwnProperty(this.options.attributesGroupName)) listTagAttr += result.attrStr;
                    } else listTagVal += this.processTextOrObjNode(item, key, level, ajPath);
                } else if (this.options.oneListGroup) {
                    let textValue = this.options.tagValueProcessor(key, item);
                    textValue = this.replaceEntitiesValue(textValue);
                    listTagVal += textValue;
                } else listTagVal += this.buildTextValNode(item, key, '', level);
            }
            if (this.options.oneListGroup) listTagVal = this.buildObjectNode(listTagVal, key, listTagAttr, level);
            val += listTagVal;
        } else //nested node
        if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
            const Ks = Object.keys(jObj[key]);
            const L = Ks.length;
            for(let j = 0; j < L; j++)attrStr += this.buildAttrPairStr(Ks[j], '' + jObj[key][Ks[j]]);
        } else val += this.processTextOrObjNode(jObj[key], key, level, ajPath);
    }
    return {
        attrStr: attrStr,
        val: val
    };
};
$f07d0849a7dcedd5$var$Builder.prototype.buildAttrPairStr = function(attrName, val) {
    val = this.options.attributeValueProcessor(attrName, '' + val);
    val = this.replaceEntitiesValue(val);
    if (this.options.suppressBooleanAttributes && val === "true") return ' ' + attrName;
    else return ' ' + attrName + '="' + val + '"';
};
function $f07d0849a7dcedd5$var$processTextOrObjNode(object, key, level, ajPath) {
    const result = this.j2x(object, level + 1, ajPath.concat(key));
    if (object[this.options.textNodeName] !== undefined && Object.keys(object).length === 1) return this.buildTextValNode(object[this.options.textNodeName], key, result.attrStr, level);
    else return this.buildObjectNode(result.val, key, result.attrStr, level);
}
$f07d0849a7dcedd5$var$Builder.prototype.buildObjectNode = function(val, key, attrStr, level) {
    if (val === "") {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
    } else {
        let tagEndExp = '</' + key + this.tagEndChar;
        let piClosingChar = "";
        if (key[0] === "?") {
            piClosingChar = "?";
            tagEndExp = "";
        }
        // attrStr is an empty string in case the attribute came as undefined or null
        if ((attrStr || attrStr === '') && val.indexOf('<') === -1) return this.indentate(level) + '<' + key + attrStr + piClosingChar + '>' + val + tagEndExp;
        else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) return this.indentate(level) + `<!--${val}-->` + this.newLine;
        else return this.indentate(level) + '<' + key + attrStr + piClosingChar + this.tagEndChar + val + this.indentate(level) + tagEndExp;
    }
};
$f07d0849a7dcedd5$var$Builder.prototype.closeTag = function(key) {
    let closeTag = "";
    if (this.options.unpairedTags.indexOf(key) !== -1) {
        if (!this.options.suppressUnpairedNode) closeTag = "/";
    } else if (this.options.suppressEmptyNode) closeTag = "/";
    else closeTag = `></${key}`;
    return closeTag;
};
function $f07d0849a7dcedd5$var$buildEmptyObjNode(val, key, attrStr, level) {
    if (val !== '') return this.buildObjectNode(val, key, attrStr, level);
    else {
        if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '/' + this.tagEndChar;
    }
}
$f07d0849a7dcedd5$var$Builder.prototype.buildTextValNode = function(val, key, attrStr, level) {
    if (this.options.cdataPropName !== false && key === this.options.cdataPropName) return this.indentate(level) + `<![CDATA[${val}]]>` + this.newLine;
    else if (this.options.commentPropName !== false && key === this.options.commentPropName) return this.indentate(level) + `<!--${val}-->` + this.newLine;
    else if (key[0] === "?") return this.indentate(level) + '<' + key + attrStr + '?' + this.tagEndChar;
    else {
        let textValue = this.options.tagValueProcessor(key, val);
        textValue = this.replaceEntitiesValue(textValue);
        if (textValue === '') return this.indentate(level) + '<' + key + attrStr + this.closeTag(key) + this.tagEndChar;
        else return this.indentate(level) + '<' + key + attrStr + '>' + textValue + '</' + key + this.tagEndChar;
    }
};
$f07d0849a7dcedd5$var$Builder.prototype.replaceEntitiesValue = function(textValue) {
    if (textValue && textValue.length > 0 && this.options.processEntities) for(let i = 0; i < this.options.entities.length; i++){
        const entity = this.options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
};
function $f07d0849a7dcedd5$var$indentate(level) {
    return this.options.indentBy.repeat(level);
}
function $f07d0849a7dcedd5$var$isAttribute(name /*, options*/ ) {
    if (name.startsWith(this.options.attributeNamePrefix) && name !== this.options.textNodeName) return name.substr(this.attrPrefixLen);
    else return false;
}
module.exports = $f07d0849a7dcedd5$var$Builder;

});
parcelRegister("awGub", function(module, exports) {
const $7a9dd9537815f4b0$var$EOL = "\n";
/**
 * 
 * @param {array} jArray 
 * @param {any} options 
 * @returns 
 */ function $7a9dd9537815f4b0$var$toXml(jArray, options) {
    let indentation = "";
    if (options.format && options.indentBy.length > 0) indentation = $7a9dd9537815f4b0$var$EOL;
    return $7a9dd9537815f4b0$var$arrToStr(jArray, options, "", indentation);
}
function $7a9dd9537815f4b0$var$arrToStr(arr, options, jPath, indentation) {
    let xmlStr = "";
    let isPreviousElementTag = false;
    if (!Array.isArray(arr)) {
        // Non-array values (e.g. string tag values) should be treated as text content
        if (arr !== undefined && arr !== null) {
            let text = arr.toString();
            text = $7a9dd9537815f4b0$var$replaceEntitiesValue(text, options);
            return text;
        }
        return "";
    }
    for(let i = 0; i < arr.length; i++){
        const tagObj = arr[i];
        const tagName = $7a9dd9537815f4b0$var$propName(tagObj);
        if (tagName === undefined) continue;
        let newJPath = "";
        if (jPath.length === 0) newJPath = tagName;
        else newJPath = `${jPath}.${tagName}`;
        if (tagName === options.textNodeName) {
            let tagText = tagObj[tagName];
            if (!$7a9dd9537815f4b0$var$isStopNode(newJPath, options)) {
                tagText = options.tagValueProcessor(tagName, tagText);
                tagText = $7a9dd9537815f4b0$var$replaceEntitiesValue(tagText, options);
            }
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += tagText;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.cdataPropName) {
            if (isPreviousElementTag) xmlStr += indentation;
            xmlStr += `<![CDATA[${tagObj[tagName][0][options.textNodeName]}]]>`;
            isPreviousElementTag = false;
            continue;
        } else if (tagName === options.commentPropName) {
            xmlStr += indentation + `<!--${tagObj[tagName][0][options.textNodeName]}-->`;
            isPreviousElementTag = true;
            continue;
        } else if (tagName[0] === "?") {
            const attStr = $7a9dd9537815f4b0$var$attr_to_str(tagObj[":@"], options);
            const tempInd = tagName === "?xml" ? "" : indentation;
            let piTextNodeName = tagObj[tagName][0][options.textNodeName];
            piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : ""; //remove extra spacing
            xmlStr += tempInd + `<${tagName}${piTextNodeName}${attStr}?>`;
            isPreviousElementTag = true;
            continue;
        }
        let newIdentation = indentation;
        if (newIdentation !== "") newIdentation += options.indentBy;
        const attStr = $7a9dd9537815f4b0$var$attr_to_str(tagObj[":@"], options);
        const tagStart = indentation + `<${tagName}${attStr}`;
        const tagValue = $7a9dd9537815f4b0$var$arrToStr(tagObj[tagName], options, newJPath, newIdentation);
        if (options.unpairedTags.indexOf(tagName) !== -1) {
            if (options.suppressUnpairedNode) xmlStr += tagStart + ">";
            else xmlStr += tagStart + "/>";
        } else if ((!tagValue || tagValue.length === 0) && options.suppressEmptyNode) xmlStr += tagStart + "/>";
        else if (tagValue && tagValue.endsWith(">")) xmlStr += tagStart + `>${tagValue}${indentation}</${tagName}>`;
        else {
            xmlStr += tagStart + ">";
            if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) xmlStr += indentation + options.indentBy + tagValue + indentation;
            else xmlStr += tagValue;
            xmlStr += `</${tagName}>`;
        }
        isPreviousElementTag = true;
    }
    return xmlStr;
}
function $7a9dd9537815f4b0$var$propName(obj) {
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
        if (key !== ":@") return key;
    }
}
function $7a9dd9537815f4b0$var$attr_to_str(attrMap, options) {
    let attrStr = "";
    if (attrMap && !options.ignoreAttributes) for(let attr in attrMap){
        if (!Object.prototype.hasOwnProperty.call(attrMap, attr)) continue;
        let attrVal = options.attributeValueProcessor(attr, attrMap[attr]);
        attrVal = $7a9dd9537815f4b0$var$replaceEntitiesValue(attrVal, options);
        if (attrVal === true && options.suppressBooleanAttributes) attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}`;
        else attrStr += ` ${attr.substr(options.attributeNamePrefix.length)}="${attrVal}"`;
    }
    return attrStr;
}
function $7a9dd9537815f4b0$var$isStopNode(jPath, options) {
    jPath = jPath.substr(0, jPath.length - options.textNodeName.length - 1);
    let tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
    for(let index in options.stopNodes){
        if (options.stopNodes[index] === jPath || options.stopNodes[index] === "*." + tagName) return true;
    }
    return false;
}
function $7a9dd9537815f4b0$var$replaceEntitiesValue(textValue, options) {
    if (textValue && textValue.length > 0 && options.processEntities) for(let i = 0; i < options.entities.length; i++){
        const entity = options.entities[i];
        textValue = textValue.replace(entity.regex, entity.val);
    }
    return textValue;
}
module.exports = $7a9dd9537815f4b0$var$toXml;

});




parcelRegister("k9Dec", function(module, exports) {

$parcel$export(module.exports, "Tabs", () => (parcelRequire("7HSQl")).default);
$parcel$export(module.exports, "TabList", () => (parcelRequire("g0jCF")).default);
$parcel$export(module.exports, "Tab", () => (parcelRequire("4Nk1L")).default);
$parcel$export(module.exports, "TabPanel", () => (parcelRequire("kTsK8")).default);

var $7HSQl = parcelRequire("7HSQl");

var $g0jCF = parcelRequire("g0jCF");

var $4Nk1L = parcelRequire("4Nk1L");

var $kTsK8 = parcelRequire("kTsK8");

});
parcelRegister("7HSQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c7174e5124d54a$export$2e2bcd8739ae039);

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $43DQN = parcelRequire("43DQN");

var $3CMaC = parcelRequire("3CMaC");

var $3gyeX = parcelRequire("3gyeX");
const $59c7174e5124d54a$var$_excluded = [
    "children",
    "defaultFocus",
    "defaultIndex",
    "focusTabOnClick",
    "onSelect"
];
function $59c7174e5124d54a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $59c7174e5124d54a$var$MODE_CONTROLLED = 0;
const $59c7174e5124d54a$var$MODE_UNCONTROLLED = 1;
const $59c7174e5124d54a$var$propTypes = {
    children: (0, $43DQN.childrenPropType),
    onSelect: (0, $43DQN.onSelectPropType),
    selectedIndex: (0, $43DQN.selectedIndexPropType)
};
const $59c7174e5124d54a$var$defaultProps = {
    defaultFocus: false,
    focusTabOnClick: true,
    forceRenderTabPanel: false,
    selectedIndex: null,
    defaultIndex: null,
    environment: null,
    disableUpDownKeys: false,
    disableLeftRightKeys: false
};
const $59c7174e5124d54a$var$getModeFromProps = (props)=>{
    return props.selectedIndex === null ? $59c7174e5124d54a$var$MODE_UNCONTROLLED : $59c7174e5124d54a$var$MODE_CONTROLLED;
};
const $59c7174e5124d54a$var$checkForIllegalModeChange = (props, mode)=>{};
const $59c7174e5124d54a$var$Tabs = (props)=>{
    (0, $c9Z8w.checkPropTypes)($59c7174e5124d54a$var$propTypes, props, "prop", "Tabs");
    const _defaultProps$props = Object.assign({}, $59c7174e5124d54a$var$defaultProps, props), { children: children, defaultFocus: defaultFocus, defaultIndex: defaultIndex, focusTabOnClick: focusTabOnClick, onSelect: onSelect } = _defaultProps$props, attributes = $59c7174e5124d54a$var$_objectWithoutPropertiesLoose(_defaultProps$props, $59c7174e5124d54a$var$_excluded);
    const [focus, setFocus] = (0, $acw62.useState)(defaultFocus);
    const [mode] = (0, $acw62.useState)($59c7174e5124d54a$var$getModeFromProps(attributes));
    const [selectedIndex, setSelectedIndex] = (0, $acw62.useState)(mode === $59c7174e5124d54a$var$MODE_UNCONTROLLED ? defaultIndex || 0 : null);
    (0, $acw62.useEffect)(()=>{
        setFocus(false);
    }, []);
    if (mode === $59c7174e5124d54a$var$MODE_UNCONTROLLED) {
        const tabsCount = (0, $3gyeX.getTabsCount)(children);
        (0, $acw62.useEffect)(()=>{
            if (selectedIndex != null) {
                const maxTabIndex = Math.max(0, tabsCount - 1);
                setSelectedIndex(Math.min(selectedIndex, maxTabIndex));
            }
        }, [
            tabsCount
        ]);
    }
    $59c7174e5124d54a$var$checkForIllegalModeChange(attributes, mode);
    const handleSelected = (index, last, event)=>{
        if (typeof onSelect === "function") {
            if (onSelect(index, last, event) === false) return;
        }
        if (focusTabOnClick) setFocus(true);
        if (mode === $59c7174e5124d54a$var$MODE_UNCONTROLLED) setSelectedIndex(index);
    };
    let subProps = Object.assign({}, props, attributes);
    subProps.focus = focus;
    subProps.onSelect = handleSelected;
    if (selectedIndex != null) subProps.selectedIndex = selectedIndex;
    delete subProps.defaultFocus;
    delete subProps.defaultIndex;
    delete subProps.focusTabOnClick;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3CMaC.default), subProps, children);
};
$59c7174e5124d54a$var$Tabs.tabsRole = "Tabs";
var $59c7174e5124d54a$export$2e2bcd8739ae039 = $59c7174e5124d54a$var$Tabs;

});
parcelRegister("43DQN", function(module, exports) {

$parcel$export(module.exports, "childrenPropType", () => $2f465ab92873898a$export$3cf85bc178307212);
$parcel$export(module.exports, "onSelectPropType", () => $2f465ab92873898a$export$34b1d66fd6b9b91a);
$parcel$export(module.exports, "selectedIndexPropType", () => $2f465ab92873898a$export$7293c2cd8d9ce46);

var $aqVqB = parcelRequire("aqVqB");

var $a04Os = parcelRequire("a04Os");
function $2f465ab92873898a$export$3cf85bc178307212(props, propName, componentName) {
    let error;
    let tabsCount = 0;
    let panelsCount = 0;
    let tabListFound = false;
    const listTabs = [];
    const children = props[propName];
    (0, $aqVqB.deepForEach)(children, (child)=>{
        if ((0, $a04Os.isTabList)(child)) {
            if (child.props && child.props.children && typeof child.props.children === "object") (0, $aqVqB.deepForEach)(child.props.children, (listChild)=>listTabs.push(listChild));
            if (tabListFound) error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
            tabListFound = true;
        }
        if ((0, $a04Os.isTab)(child)) {
            if (!tabListFound || listTabs.indexOf(child) === -1) error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components have to be inside the 'TabList' component.");
            tabsCount++;
        } else if ((0, $a04Os.isTabPanel)(child)) panelsCount++;
    });
    if (!error && tabsCount !== panelsCount) error = new Error(`There should be an equal number of 'Tab' and 'TabPanel' in \`${componentName}\`. ` + `Received ${tabsCount} 'Tab' and ${panelsCount} 'TabPanel'.`);
    return error;
}
function $2f465ab92873898a$export$34b1d66fd6b9b91a(props, propName, componentName, location, propFullName) {
    const prop = props[propName];
    const name = propFullName || propName;
    let error = null;
    if (prop && typeof prop !== "function") error = new Error(`Invalid ${location} \`${name}\` of type \`${typeof prop}\` supplied ` + `to \`${componentName}\`, expected \`function\`.`);
    else if (props.selectedIndex != null && prop == null) error = new Error(`The ${location} \`${name}\` is marked as required in \`${componentName}\`, but ` + `its value is \`undefined\` or \`null\`.\n` + `\`onSelect\` is required when \`selectedIndex\` is also set. Not doing so will ` + `make the tabs not do anything, as \`selectedIndex\` indicates that you want to ` + `handle the selected tab yourself.\n` + `If you only want to set the inital tab replace \`selectedIndex\` with \`defaultIndex\`.`);
    return error;
}
function $2f465ab92873898a$export$7293c2cd8d9ce46(props, propName, componentName, location, propFullName) {
    const prop = props[propName];
    const name = propFullName || propName;
    let error = null;
    if (prop != null && typeof prop !== "number") error = new Error(`Invalid ${location} \`${name}\` of type \`${typeof prop}\` supplied to ` + `\`${componentName}\`, expected \`number\`.`);
    else if (props.defaultIndex != null && prop != null) return new Error(`The ${location} \`${name}\` cannot be used together with \`defaultIndex\` ` + `in \`${componentName}\`.\n` + `Either remove \`${name}\` to let \`${componentName}\` handle the selected ` + `tab internally or remove \`defaultIndex\` to handle it yourself.`);
    return error;
}

});
parcelRegister("aqVqB", function(module, exports) {

$parcel$export(module.exports, "deepMap", () => $7988e11e19ff601b$export$ce7eaaed37329a1b);
$parcel$export(module.exports, "deepForEach", () => $7988e11e19ff601b$export$519ada94592b97fc);

var $acw62 = parcelRequire("acw62");

var $a04Os = parcelRequire("a04Os");
function $7988e11e19ff601b$var$isTabChild(child) {
    return (0, $a04Os.isTab)(child) || (0, $a04Os.isTabList)(child) || (0, $a04Os.isTabPanel)(child);
}
function $7988e11e19ff601b$export$ce7eaaed37329a1b(children, callback) {
    return (0, $acw62.Children).map(children, (child)=>{
        if (child === null) return null;
        if ($7988e11e19ff601b$var$isTabChild(child)) return callback(child);
        if (child.props && child.props.children && typeof child.props.children === "object") return (0, $acw62.cloneElement)(child, Object.assign({}, child.props, {
            children: $7988e11e19ff601b$export$ce7eaaed37329a1b(child.props.children, callback)
        }));
        return child;
    });
}
function $7988e11e19ff601b$export$519ada94592b97fc(children, callback) {
    return (0, $acw62.Children).forEach(children, (child)=>{
        if (child === null) return;
        if ((0, $a04Os.isTab)(child) || (0, $a04Os.isTabPanel)(child)) callback(child);
        else if (child.props && child.props.children && typeof child.props.children === "object") {
            if ((0, $a04Os.isTabList)(child)) callback(child);
            $7988e11e19ff601b$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}

});
parcelRegister("a04Os", function(module, exports) {

$parcel$export(module.exports, "isTab", () => $747da32dfd5fcdce$export$bdc9792d96913679);
$parcel$export(module.exports, "isTabList", () => $747da32dfd5fcdce$export$9c326233b9ae5588);
$parcel$export(module.exports, "isTabPanel", () => $747da32dfd5fcdce$export$9e12445c79db89b);
function $747da32dfd5fcdce$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $747da32dfd5fcdce$export$bdc9792d96913679 = $747da32dfd5fcdce$var$makeTypeChecker("Tab");
const $747da32dfd5fcdce$export$9c326233b9ae5588 = $747da32dfd5fcdce$var$makeTypeChecker("TabList");
const $747da32dfd5fcdce$export$9e12445c79db89b = $747da32dfd5fcdce$var$makeTypeChecker("TabPanel");

});



parcelRegister("3CMaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a3a494f516d55d2$export$2e2bcd8739ae039);

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $43DQN = parcelRequire("43DQN");

var $3gyeX = parcelRequire("3gyeX");

var $aqVqB = parcelRequire("aqVqB");

var $a04Os = parcelRequire("a04Os");
const $2a3a494f516d55d2$var$_excluded = [
    "children",
    "className",
    "disabledTabClassName",
    "domRef",
    "focus",
    "forceRenderTabPanel",
    "onSelect",
    "selectedIndex",
    "selectedTabClassName",
    "selectedTabPanelClassName",
    "environment",
    "disableUpDownKeys",
    "disableLeftRightKeys"
];
function $2a3a494f516d55d2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $2a3a494f516d55d2$var$isNode(node) {
    return node && "getAttribute" in node;
}
function $2a3a494f516d55d2$var$isTabNode(node) {
    return $2a3a494f516d55d2$var$isNode(node) && node.getAttribute("data-rttab");
}
function $2a3a494f516d55d2$var$isTabDisabled(node) {
    return $2a3a494f516d55d2$var$isNode(node) && node.getAttribute("aria-disabled") === "true";
}
let $2a3a494f516d55d2$var$canUseActiveElement;
function $2a3a494f516d55d2$var$determineCanUseActiveElement(environment) {
    const env = environment || (typeof window !== "undefined" ? window : undefined);
    try {
        $2a3a494f516d55d2$var$canUseActiveElement = !!(typeof env !== "undefined" && env.document && env.document.activeElement);
    } catch (e) {
        $2a3a494f516d55d2$var$canUseActiveElement = false;
    }
}
const $2a3a494f516d55d2$var$defaultProps = {
    className: "react-tabs",
    focus: false
};
const $2a3a494f516d55d2$var$propTypes = {
    children: (0, $43DQN.childrenPropType)
};
const $2a3a494f516d55d2$var$UncontrolledTabs = (props)=>{
    (0, $c9Z8w.checkPropTypes)($2a3a494f516d55d2$var$propTypes, props, "prop", "UncontrolledTabs");
    let tabNodes = (0, $acw62.useRef)([]);
    let tabIds = (0, $acw62.useRef)([]);
    const ref = (0, $acw62.useRef)();
    function setSelected(index, event) {
        if (index < 0 || index >= getTabsCount()) return;
        const { onSelect: onSelect, selectedIndex: selectedIndex } = props;
        onSelect(index, selectedIndex, event);
    }
    function getNextTab(index) {
        const count = getTabsCount();
        for(let i = index + 1; i < count; i++){
            if (!$2a3a494f516d55d2$var$isTabDisabled(getTab(i))) return i;
        }
        for(let i = 0; i < index; i++){
            if (!$2a3a494f516d55d2$var$isTabDisabled(getTab(i))) return i;
        }
        return index;
    }
    function getPrevTab(index) {
        let i = index;
        while(i--){
            if (!$2a3a494f516d55d2$var$isTabDisabled(getTab(i))) return i;
        }
        i = getTabsCount();
        while(i-- > index){
            if (!$2a3a494f516d55d2$var$isTabDisabled(getTab(i))) return i;
        }
        return index;
    }
    function getFirstTab() {
        const count = getTabsCount();
        for(let i = 0; i < count; i++){
            if (!$2a3a494f516d55d2$var$isTabDisabled(getTab(i))) return i;
        }
        return null;
    }
    function getLastTab() {
        let i = getTabsCount();
        while(i--){
            if (!$2a3a494f516d55d2$var$isTabDisabled(getTab(i))) return i;
        }
        return null;
    }
    function getTabsCount() {
        const { children: children } = props;
        return (0, $3gyeX.getTabsCount)(children);
    }
    function getTab(index) {
        return tabNodes.current[`tabs-${index}`];
    }
    function getChildren() {
        let index = 0;
        const { children: children, disabledTabClassName: disabledTabClassName, focus: focus, forceRenderTabPanel: forceRenderTabPanel, selectedIndex: selectedIndex, selectedTabClassName: selectedTabClassName, selectedTabPanelClassName: selectedTabPanelClassName, environment: environment } = props;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - getTabsCount();
        const id = (0, $acw62.useId)();
        while(diff++ < 0)tabIds.current.push(`${id}${tabIds.current.length}`);
        return (0, $aqVqB.deepMap)(children, (child)=>{
            let result = child;
            if ((0, $a04Os.isTabList)(child)) {
                let listIndex = 0;
                let wasTabFocused = false;
                if ($2a3a494f516d55d2$var$canUseActiveElement == null) $2a3a494f516d55d2$var$determineCanUseActiveElement(environment);
                const env = environment || (typeof window !== "undefined" ? window : undefined);
                if ($2a3a494f516d55d2$var$canUseActiveElement && env) wasTabFocused = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(child.props.children).filter((0, $a04Os.isTab)).some((tab, i)=>env.document.activeElement === getTab(i));
                result = (0, $acw62.cloneElement)(child, {
                    children: (0, $aqVqB.deepMap)(child.props.children, (tab)=>{
                        const key = `tabs-${listIndex}`;
                        const selected = selectedIndex === listIndex;
                        const props = {
                            tabRef: (node)=>{
                                tabNodes.current[key] = node;
                            },
                            id: tabIds.current[listIndex],
                            selected: selected,
                            focus: selected && (focus || wasTabFocused)
                        };
                        if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
                        if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
                        listIndex++;
                        return (0, $acw62.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $a04Os.isTabPanel)(child)) {
                const props = {
                    id: tabIds.current[index],
                    selected: selectedIndex === index
                };
                if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
                if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
                index++;
                result = (0, $acw62.cloneElement)(child, props);
            }
            return result;
        });
    }
    function handleKeyDown(e) {
        const { direction: direction, disableUpDownKeys: disableUpDownKeys, disableLeftRightKeys: disableLeftRightKeys } = props;
        if (isTabFromContainer(e.target)) {
            let { selectedIndex: index } = props;
            let preventDefault = false;
            let useSelectedIndex = false;
            if (e.code === "Space" || e.keyCode === 32 || e.code === "Enter" || e.keyCode === 13) {
                preventDefault = true;
                useSelectedIndex = false;
                handleClick(e);
            }
            if (!disableLeftRightKeys && (e.keyCode === 37 || e.code === "ArrowLeft") || !disableUpDownKeys && (e.keyCode === 38 || e.code === "ArrowUp")) {
                if (direction === "rtl") index = getNextTab(index);
                else index = getPrevTab(index);
                preventDefault = true;
                useSelectedIndex = true;
            } else if (!disableLeftRightKeys && (e.keyCode === 39 || e.code === "ArrowRight") || !disableUpDownKeys && (e.keyCode === 40 || e.code === "ArrowDown")) {
                if (direction === "rtl") index = getPrevTab(index);
                else index = getNextTab(index);
                preventDefault = true;
                useSelectedIndex = true;
            } else if (e.keyCode === 35 || e.code === "End") {
                index = getLastTab();
                preventDefault = true;
                useSelectedIndex = true;
            } else if (e.keyCode === 36 || e.code === "Home") {
                index = getFirstTab();
                preventDefault = true;
                useSelectedIndex = true;
            }
            if (preventDefault) e.preventDefault();
            if (useSelectedIndex) setSelected(index, e);
        }
    }
    function handleClick(e) {
        let node = e.target;
        do if (isTabFromContainer(node)) {
            if ($2a3a494f516d55d2$var$isTabDisabled(node)) return;
            const index = [].slice.call(node.parentNode.children).filter($2a3a494f516d55d2$var$isTabNode).indexOf(node);
            setSelected(index, e);
            return;
        }
        while ((node = node.parentNode) != null);
    }
    function isTabFromContainer(node) {
        if (!$2a3a494f516d55d2$var$isTabNode(node)) return false;
        let nodeAncestor = node.parentElement;
        do {
            if (nodeAncestor === ref.current) return true;
            if (nodeAncestor.getAttribute("data-rttabs")) break;
            nodeAncestor = nodeAncestor.parentElement;
        }while (nodeAncestor);
        return false;
    }
    const _defaultProps$props = Object.assign({}, $2a3a494f516d55d2$var$defaultProps, props), { className: className, domRef: domRef } = _defaultProps$props, attributes = $2a3a494f516d55d2$var$_objectWithoutPropertiesLoose(_defaultProps$props, $2a3a494f516d55d2$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, attributes, {
        className: (0, $9QePP.default)(className),
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        ref: (node)=>{
            ref.current = node;
            if (domRef) domRef(node);
        },
        "data-rttabs": true
    }), getChildren());
};
var $2a3a494f516d55d2$export$2e2bcd8739ae039 = $2a3a494f516d55d2$var$UncontrolledTabs;

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("3gyeX", function(module, exports) {

$parcel$export(module.exports, "getTabsCount", () => $260d6d24eab671ca$export$1cb810e64a236e12);

var $aqVqB = parcelRequire("aqVqB");

var $a04Os = parcelRequire("a04Os");
function $260d6d24eab671ca$export$1cb810e64a236e12(children) {
    let tabCount = 0;
    (0, $aqVqB.deepForEach)(children, (child)=>{
        if ((0, $a04Os.isTab)(child)) tabCount++;
    });
    return tabCount;
}

});



parcelRegister("g0jCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6bde131fb68233$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $ba6bde131fb68233$var$_excluded = [
    "children",
    "className"
];
function $ba6bde131fb68233$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $ba6bde131fb68233$var$defaultProps = {
    className: "react-tabs__tab-list"
};
const $ba6bde131fb68233$var$TabList = (props)=>{
    const _defaultProps$props = Object.assign({}, $ba6bde131fb68233$var$defaultProps, props), { children: children, className: className } = _defaultProps$props, attributes = $ba6bde131fb68233$var$_objectWithoutPropertiesLoose(_defaultProps$props, $ba6bde131fb68233$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({}, attributes, {
        className: (0, $9QePP.default)(className),
        role: "tablist"
    }), children);
};
$ba6bde131fb68233$var$TabList.tabsRole = "TabList";
var $ba6bde131fb68233$export$2e2bcd8739ae039 = $ba6bde131fb68233$var$TabList;

});

parcelRegister("4Nk1L", function(module, exports) {

$parcel$export(module.exports, "default", () => $37db4610a914d550$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $37db4610a914d550$var$_excluded = [
    "children",
    "className",
    "disabled",
    "disabledClassName",
    "focus",
    "id",
    "selected",
    "selectedClassName",
    "tabIndex",
    "tabRef"
];
function $37db4610a914d550$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $37db4610a914d550$var$DEFAULT_CLASS = "react-tabs__tab";
const $37db4610a914d550$var$defaultProps = {
    className: $37db4610a914d550$var$DEFAULT_CLASS,
    disabledClassName: `${$37db4610a914d550$var$DEFAULT_CLASS}--disabled`,
    focus: false,
    id: null,
    selected: false,
    selectedClassName: `${$37db4610a914d550$var$DEFAULT_CLASS}--selected`
};
const $37db4610a914d550$var$Tab = (props)=>{
    let nodeRef = (0, $acw62.useRef)();
    const _defaultProps$props = Object.assign({}, $37db4610a914d550$var$defaultProps, props), { children: children, className: className, disabled: disabled, disabledClassName: disabledClassName, focus: focus, id: id, selected: selected, selectedClassName: selectedClassName, tabIndex: tabIndex, tabRef: tabRef } = _defaultProps$props, attributes = $37db4610a914d550$var$_objectWithoutPropertiesLoose(_defaultProps$props, $37db4610a914d550$var$_excluded);
    (0, $acw62.useEffect)(()=>{
        if (selected && focus) nodeRef.current.focus();
    }, [
        selected,
        focus
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", Object.assign({}, attributes, {
        className: (0, $9QePP.default)(className, {
            [selectedClassName]: selected,
            [disabledClassName]: disabled
        }),
        ref: (node)=>{
            nodeRef.current = node;
            if (tabRef) tabRef(node);
        },
        role: "tab",
        id: `tab${id}`,
        "aria-selected": selected ? "true" : "false",
        "aria-disabled": disabled ? "true" : "false",
        "aria-controls": `panel${id}`,
        tabIndex: tabIndex || (selected ? "0" : null),
        "data-rttab": true
    }), children);
};
$37db4610a914d550$var$Tab.tabsRole = "Tab";
var $37db4610a914d550$export$2e2bcd8739ae039 = $37db4610a914d550$var$Tab;

});

parcelRegister("kTsK8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f35f3d80a5fe0277$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");
const $f35f3d80a5fe0277$var$_excluded = [
    "children",
    "className",
    "forceRender",
    "id",
    "selected",
    "selectedClassName"
];
function $f35f3d80a5fe0277$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $f35f3d80a5fe0277$var$DEFAULT_CLASS = "react-tabs__tab-panel";
const $f35f3d80a5fe0277$var$defaultProps = {
    className: $f35f3d80a5fe0277$var$DEFAULT_CLASS,
    forceRender: false,
    selectedClassName: `${$f35f3d80a5fe0277$var$DEFAULT_CLASS}--selected`
};
const $f35f3d80a5fe0277$var$TabPanel = (props)=>{
    const _defaultProps$props = Object.assign({}, $f35f3d80a5fe0277$var$defaultProps, props), { children: children, className: className, forceRender: forceRender, id: id, selected: selected, selectedClassName: selectedClassName } = _defaultProps$props, attributes = $f35f3d80a5fe0277$var$_objectWithoutPropertiesLoose(_defaultProps$props, $f35f3d80a5fe0277$var$_excluded);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, attributes, {
        className: (0, $9QePP.default)(className, {
            [selectedClassName]: selected
        }),
        role: "tabpanel",
        id: `panel${id}`,
        "aria-labelledby": `tab${id}`
    }), forceRender || selected ? children : null);
};
$f35f3d80a5fe0277$var$TabPanel.tabsRole = "TabPanel";
var $f35f3d80a5fe0277$export$2e2bcd8739ae039 = $f35f3d80a5fe0277$var$TabPanel;

});


parcelRegister("78e7k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $53143b210d847066$export$2e2bcd8739ae039);
/*!
 * perfect-scrollbar v1.5.6
 * Copyright 2024 Hyunje Jun, MDBootstrap and Contributors
 * Licensed under MIT
 */ function $53143b210d847066$var$get(element) {
    return getComputedStyle(element);
}
function $53143b210d847066$var$set(element, obj) {
    for(var key in obj){
        var val = obj[key];
        if (typeof val === 'number') val = val + "px";
        element.style[key] = val;
    }
    return element;
}
function $53143b210d847066$var$div(className) {
    var div = document.createElement('div');
    div.className = className;
    return div;
}
var $53143b210d847066$var$elMatches = typeof Element !== 'undefined' && (Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector);
function $53143b210d847066$var$matches(element, query) {
    if (!$53143b210d847066$var$elMatches) throw new Error('No element matching method supported');
    return $53143b210d847066$var$elMatches.call(element, query);
}
function $53143b210d847066$var$remove(element) {
    if (element.remove) element.remove();
    else if (element.parentNode) element.parentNode.removeChild(element);
}
function $53143b210d847066$var$queryChildren(element, selector) {
    return Array.prototype.filter.call(element.children, function(child) {
        return $53143b210d847066$var$matches(child, selector);
    });
}
var $53143b210d847066$var$cls = {
    main: 'ps',
    rtl: 'ps__rtl',
    element: {
        thumb: function(x) {
            return "ps__thumb-" + x;
        },
        rail: function(x) {
            return "ps__rail-" + x;
        },
        consuming: 'ps__child--consume'
    },
    state: {
        focus: 'ps--focus',
        clicking: 'ps--clicking',
        active: function(x) {
            return "ps--active-" + x;
        },
        scrolling: function(x) {
            return "ps--scrolling-" + x;
        }
    }
};
/*
 * Helper methods
 */ var $53143b210d847066$var$scrollingClassTimeout = {
    x: null,
    y: null
};
function $53143b210d847066$var$addScrollingClass(i, x) {
    var classList = i.element.classList;
    var className = $53143b210d847066$var$cls.state.scrolling(x);
    if (classList.contains(className)) clearTimeout($53143b210d847066$var$scrollingClassTimeout[x]);
    else classList.add(className);
}
function $53143b210d847066$var$removeScrollingClass(i, x) {
    $53143b210d847066$var$scrollingClassTimeout[x] = setTimeout(function() {
        return i.isAlive && i.element.classList.remove($53143b210d847066$var$cls.state.scrolling(x));
    }, i.settings.scrollingThreshold);
}
function $53143b210d847066$var$setScrollingClassInstantly(i, x) {
    $53143b210d847066$var$addScrollingClass(i, x);
    $53143b210d847066$var$removeScrollingClass(i, x);
}
var $53143b210d847066$var$EventElement = function EventElement(element) {
    this.element = element;
    this.handlers = {};
};
var $53143b210d847066$var$prototypeAccessors = {
    isEmpty: {
        configurable: true
    }
};
$53143b210d847066$var$EventElement.prototype.bind = function bind(eventName, handler) {
    if (typeof this.handlers[eventName] === 'undefined') this.handlers[eventName] = [];
    this.handlers[eventName].push(handler);
    this.element.addEventListener(eventName, handler, false);
};
$53143b210d847066$var$EventElement.prototype.unbind = function unbind(eventName, target) {
    var this$1 = this;
    this.handlers[eventName] = this.handlers[eventName].filter(function(handler) {
        if (target && handler !== target) return true;
        this$1.element.removeEventListener(eventName, handler, false);
        return false;
    });
};
$53143b210d847066$var$EventElement.prototype.unbindAll = function unbindAll() {
    for(var name in this.handlers)this.unbind(name);
};
$53143b210d847066$var$prototypeAccessors.isEmpty.get = function() {
    var this$1 = this;
    return Object.keys(this.handlers).every(function(key) {
        return this$1.handlers[key].length === 0;
    });
};
Object.defineProperties($53143b210d847066$var$EventElement.prototype, $53143b210d847066$var$prototypeAccessors);
var $53143b210d847066$var$EventManager = function EventManager() {
    this.eventElements = [];
};
$53143b210d847066$var$EventManager.prototype.eventElement = function eventElement(element) {
    var ee = this.eventElements.filter(function(ee) {
        return ee.element === element;
    })[0];
    if (!ee) {
        ee = new $53143b210d847066$var$EventElement(element);
        this.eventElements.push(ee);
    }
    return ee;
};
$53143b210d847066$var$EventManager.prototype.bind = function bind(element, eventName, handler) {
    this.eventElement(element).bind(eventName, handler);
};
$53143b210d847066$var$EventManager.prototype.unbind = function unbind(element, eventName, handler) {
    var ee = this.eventElement(element);
    ee.unbind(eventName, handler);
    if (ee.isEmpty) // remove
    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
};
$53143b210d847066$var$EventManager.prototype.unbindAll = function unbindAll() {
    this.eventElements.forEach(function(e) {
        return e.unbindAll();
    });
    this.eventElements = [];
};
$53143b210d847066$var$EventManager.prototype.once = function once(element, eventName, handler) {
    var ee = this.eventElement(element);
    var onceHandler = function(evt) {
        ee.unbind(eventName, onceHandler);
        handler(evt);
    };
    ee.bind(eventName, onceHandler);
};
function $53143b210d847066$var$createEvent(name) {
    if (typeof window.CustomEvent === 'function') return new CustomEvent(name);
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, false, false, undefined);
    return evt;
}
function $53143b210d847066$var$processScrollDiff(i, axis, diff, useScrollingClass, forceFireReachEvent) {
    if (useScrollingClass === void 0) useScrollingClass = true;
    if (forceFireReachEvent === void 0) forceFireReachEvent = false;
    var fields;
    if (axis === 'top') fields = [
        'contentHeight',
        'containerHeight',
        'scrollTop',
        'y',
        'up',
        'down'
    ];
    else if (axis === 'left') fields = [
        'contentWidth',
        'containerWidth',
        'scrollLeft',
        'x',
        'left',
        'right'
    ];
    else throw new Error('A proper axis should be provided');
    $53143b210d847066$var$processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
}
function $53143b210d847066$var$processScrollDiff$1(i, diff, ref, useScrollingClass, forceFireReachEvent) {
    var contentHeight = ref[0];
    var containerHeight = ref[1];
    var scrollTop = ref[2];
    var y = ref[3];
    var up = ref[4];
    var down = ref[5];
    if (useScrollingClass === void 0) useScrollingClass = true;
    if (forceFireReachEvent === void 0) forceFireReachEvent = false;
    var element = i.element;
    // reset reach
    i.reach[y] = null;
    // 1 for subpixel rounding
    if (element[scrollTop] < 1) i.reach[y] = 'start';
    // 1 for subpixel rounding
    if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) i.reach[y] = 'end';
    if (diff) {
        element.dispatchEvent($53143b210d847066$var$createEvent("ps-scroll-" + y));
        if (diff < 0) element.dispatchEvent($53143b210d847066$var$createEvent("ps-scroll-" + up));
        else if (diff > 0) element.dispatchEvent($53143b210d847066$var$createEvent("ps-scroll-" + down));
        if (useScrollingClass) $53143b210d847066$var$setScrollingClassInstantly(i, y);
    }
    if (i.reach[y] && (diff || forceFireReachEvent)) element.dispatchEvent($53143b210d847066$var$createEvent("ps-" + y + "-reach-" + i.reach[y]));
}
function $53143b210d847066$var$toInt(x) {
    return parseInt(x, 10) || 0;
}
function $53143b210d847066$var$isEditable(el) {
    return $53143b210d847066$var$matches(el, 'input,[contenteditable]') || $53143b210d847066$var$matches(el, 'select,[contenteditable]') || $53143b210d847066$var$matches(el, 'textarea,[contenteditable]') || $53143b210d847066$var$matches(el, 'button,[contenteditable]');
}
function $53143b210d847066$var$outerWidth(element) {
    var styles = $53143b210d847066$var$get(element);
    return $53143b210d847066$var$toInt(styles.width) + $53143b210d847066$var$toInt(styles.paddingLeft) + $53143b210d847066$var$toInt(styles.paddingRight) + $53143b210d847066$var$toInt(styles.borderLeftWidth) + $53143b210d847066$var$toInt(styles.borderRightWidth);
}
var $53143b210d847066$var$env = {
    isWebKit: typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style,
    supportsTouch: typeof window !== 'undefined' && ('ontouchstart' in window || 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints > 0 || window.DocumentTouch && document instanceof window.DocumentTouch),
    supportsIePointer: typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
    isChrome: typeof navigator !== 'undefined' && /Chrome/i.test(navigator && navigator.userAgent)
};
/* eslint-disable no-lonely-if */ function $53143b210d847066$var$updateGeometry(i) {
    var element = i.element;
    var roundedScrollTop = Math.floor(element.scrollTop);
    var rect = element.getBoundingClientRect();
    i.containerWidth = Math.floor(rect.width);
    i.containerHeight = Math.floor(rect.height);
    i.contentWidth = element.scrollWidth;
    i.contentHeight = element.scrollHeight;
    if (!element.contains(i.scrollbarXRail)) {
        // clean up and append
        $53143b210d847066$var$queryChildren(element, $53143b210d847066$var$cls.element.rail('x')).forEach(function(el) {
            return $53143b210d847066$var$remove(el);
        });
        element.appendChild(i.scrollbarXRail);
    }
    if (!element.contains(i.scrollbarYRail)) {
        // clean up and append
        $53143b210d847066$var$queryChildren(element, $53143b210d847066$var$cls.element.rail('y')).forEach(function(el) {
            return $53143b210d847066$var$remove(el);
        });
        element.appendChild(i.scrollbarYRail);
    }
    if (!i.settings.suppressScrollX && i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth) {
        i.scrollbarXActive = true;
        i.railXWidth = i.containerWidth - i.railXMarginWidth;
        i.railXRatio = i.containerWidth / i.railXWidth;
        i.scrollbarXWidth = $53143b210d847066$var$getThumbSize(i, $53143b210d847066$var$toInt(i.railXWidth * i.containerWidth / i.contentWidth));
        i.scrollbarXLeft = $53143b210d847066$var$toInt((i.negativeScrollAdjustment + element.scrollLeft) * (i.railXWidth - i.scrollbarXWidth) / (i.contentWidth - i.containerWidth));
    } else i.scrollbarXActive = false;
    if (!i.settings.suppressScrollY && i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight) {
        i.scrollbarYActive = true;
        i.railYHeight = i.containerHeight - i.railYMarginHeight;
        i.railYRatio = i.containerHeight / i.railYHeight;
        i.scrollbarYHeight = $53143b210d847066$var$getThumbSize(i, $53143b210d847066$var$toInt(i.railYHeight * i.containerHeight / i.contentHeight));
        i.scrollbarYTop = $53143b210d847066$var$toInt(roundedScrollTop * (i.railYHeight - i.scrollbarYHeight) / (i.contentHeight - i.containerHeight));
    } else i.scrollbarYActive = false;
    if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
    if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
    $53143b210d847066$var$updateCss(element, i);
    if (i.scrollbarXActive) element.classList.add($53143b210d847066$var$cls.state.active('x'));
    else {
        element.classList.remove($53143b210d847066$var$cls.state.active('x'));
        i.scrollbarXWidth = 0;
        i.scrollbarXLeft = 0;
        element.scrollLeft = i.isRtl === true ? i.contentWidth : 0;
    }
    if (i.scrollbarYActive) element.classList.add($53143b210d847066$var$cls.state.active('y'));
    else {
        element.classList.remove($53143b210d847066$var$cls.state.active('y'));
        i.scrollbarYHeight = 0;
        i.scrollbarYTop = 0;
        element.scrollTop = 0;
    }
}
function $53143b210d847066$var$getThumbSize(i, thumbSize) {
    if (i.settings.minScrollbarLength) thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
    if (i.settings.maxScrollbarLength) thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
    return thumbSize;
}
function $53143b210d847066$var$updateCss(element, i) {
    var xRailOffset = {
        width: i.railXWidth
    };
    var roundedScrollTop = Math.floor(element.scrollTop);
    if (i.isRtl) xRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth - i.contentWidth;
    else xRailOffset.left = element.scrollLeft;
    if (i.isScrollbarXUsingBottom) xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
    else xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
    $53143b210d847066$var$set(i.scrollbarXRail, xRailOffset);
    var yRailOffset = {
        top: roundedScrollTop,
        height: i.railYHeight
    };
    if (i.isScrollbarYUsingRight) {
        if (i.isRtl) yRailOffset.right = i.contentWidth - (i.negativeScrollAdjustment + element.scrollLeft) - i.scrollbarYRight - i.scrollbarYOuterWidth - 9;
        else yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    } else if (i.isRtl) yRailOffset.left = i.negativeScrollAdjustment + element.scrollLeft + i.containerWidth * 2 - i.contentWidth - i.scrollbarYLeft - i.scrollbarYOuterWidth;
    else yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    $53143b210d847066$var$set(i.scrollbarYRail, yRailOffset);
    $53143b210d847066$var$set(i.scrollbarX, {
        left: i.scrollbarXLeft,
        width: i.scrollbarXWidth - i.railBorderXWidth
    });
    $53143b210d847066$var$set(i.scrollbarY, {
        top: i.scrollbarYTop,
        height: i.scrollbarYHeight - i.railBorderYWidth
    });
}
/* eslint-disable */ function $53143b210d847066$var$clickRail(i) {
    // const element = i.element;
    i.event.bind(i.scrollbarY, 'mousedown', function(e) {
        return e.stopPropagation();
    });
    i.event.bind(i.scrollbarYRail, 'mousedown', function(e) {
        var positionTop = e.pageY - window.pageYOffset - i.scrollbarYRail.getBoundingClientRect().top;
        var direction = positionTop > i.scrollbarYTop ? 1 : -1;
        i.element.scrollTop += direction * i.containerHeight;
        $53143b210d847066$var$updateGeometry(i);
        e.stopPropagation();
    });
    i.event.bind(i.scrollbarX, 'mousedown', function(e) {
        return e.stopPropagation();
    });
    i.event.bind(i.scrollbarXRail, 'mousedown', function(e) {
        var positionLeft = e.pageX - window.pageXOffset - i.scrollbarXRail.getBoundingClientRect().left;
        var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;
        i.element.scrollLeft += direction * i.containerWidth;
        $53143b210d847066$var$updateGeometry(i);
        e.stopPropagation();
    });
}
var $53143b210d847066$var$activeSlider = null; // Variable to track the currently active slider
function $53143b210d847066$var$setupScrollHandlers(i) {
    $53143b210d847066$var$bindMouseScrollHandler(i, [
        'containerHeight',
        'contentHeight',
        'pageY',
        'railYHeight',
        'scrollbarY',
        'scrollbarYHeight',
        'scrollTop',
        'y',
        'scrollbarYRail'
    ]);
    $53143b210d847066$var$bindMouseScrollHandler(i, [
        'containerWidth',
        'contentWidth',
        'pageX',
        'railXWidth',
        'scrollbarX',
        'scrollbarXWidth',
        'scrollLeft',
        'x',
        'scrollbarXRail'
    ]);
}
function $53143b210d847066$var$bindMouseScrollHandler(i, ref) {
    var containerDimension = ref[0];
    var contentDimension = ref[1];
    var pageAxis = ref[2];
    var railDimension = ref[3];
    var scrollbarAxis = ref[4];
    var scrollbarDimension = ref[5];
    var scrollAxis = ref[6];
    var axis = ref[7];
    var scrollbarRail = ref[8];
    var element = i.element;
    var startingScrollPosition = null;
    var startingMousePagePosition = null;
    var scrollBy = null;
    function moveHandler(e) {
        if (e.touches && e.touches[0]) e[pageAxis] = e.touches[0]["page" + axis.toUpperCase()];
        // Only move if the active slider is the one we started with
        if ($53143b210d847066$var$activeSlider === scrollbarAxis) {
            element[scrollAxis] = startingScrollPosition + scrollBy * (e[pageAxis] - startingMousePagePosition);
            $53143b210d847066$var$addScrollingClass(i, axis);
            $53143b210d847066$var$updateGeometry(i);
            e.stopPropagation();
            e.preventDefault();
        }
    }
    function endHandler() {
        $53143b210d847066$var$removeScrollingClass(i, axis);
        i[scrollbarRail].classList.remove($53143b210d847066$var$cls.state.clicking);
        document.removeEventListener('mousemove', moveHandler);
        document.removeEventListener('mouseup', endHandler);
        document.removeEventListener('touchmove', moveHandler);
        document.removeEventListener('touchend', endHandler);
        $53143b210d847066$var$activeSlider = null; // Reset active slider when interaction ends
    }
    function bindMoves(e) {
        if ($53143b210d847066$var$activeSlider === null) {
            // Only bind if no slider is currently active
            $53143b210d847066$var$activeSlider = scrollbarAxis; // Set current slider as active
            startingScrollPosition = element[scrollAxis];
            if (e.touches) e[pageAxis] = e.touches[0]["page" + axis.toUpperCase()];
            startingMousePagePosition = e[pageAxis];
            scrollBy = (i[contentDimension] - i[containerDimension]) / (i[railDimension] - i[scrollbarDimension]);
            if (!e.touches) {
                document.addEventListener('mousemove', moveHandler);
                document.addEventListener('mouseup', endHandler);
            } else {
                document.addEventListener('touchmove', moveHandler, {
                    passive: false
                });
                document.addEventListener('touchend', endHandler);
            }
            i[scrollbarRail].classList.add($53143b210d847066$var$cls.state.clicking);
        }
        e.stopPropagation();
        if (e.cancelable) e.preventDefault();
    }
    i[scrollbarAxis].addEventListener('mousedown', bindMoves);
    i[scrollbarAxis].addEventListener('touchstart', bindMoves);
}
/* eslint-disable */ function $53143b210d847066$var$keyboard(i) {
    var element = i.element;
    var elementHovered = function() {
        return $53143b210d847066$var$matches(element, ':hover');
    };
    var scrollbarFocused = function() {
        return $53143b210d847066$var$matches(i.scrollbarX, ':focus') || $53143b210d847066$var$matches(i.scrollbarY, ':focus');
    };
    function shouldPreventDefault(deltaX, deltaY) {
        var scrollTop = Math.floor(element.scrollTop);
        if (deltaX === 0) {
            if (!i.scrollbarYActive) return false;
            if (scrollTop === 0 && deltaY > 0 || scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0) return !i.settings.wheelPropagation;
        }
        var scrollLeft = element.scrollLeft;
        if (deltaY === 0) {
            if (!i.scrollbarXActive) return false;
            if (scrollLeft === 0 && deltaX < 0 || scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0) return !i.settings.wheelPropagation;
        }
        return true;
    }
    i.event.bind(i.ownerDocument, 'keydown', function(e) {
        if (e.isDefaultPrevented && e.isDefaultPrevented() || e.defaultPrevented) return;
        if (!elementHovered() && !scrollbarFocused()) return;
        var activeElement = document.activeElement ? document.activeElement : i.ownerDocument.activeElement;
        if (activeElement) {
            if (activeElement.tagName === 'IFRAME') activeElement = activeElement.contentDocument.activeElement;
            else // go deeper if element is a webcomponent
            while(activeElement.shadowRoot)activeElement = activeElement.shadowRoot.activeElement;
            if ($53143b210d847066$var$isEditable(activeElement)) return;
        }
        var deltaX = 0;
        var deltaY = 0;
        switch(e.which){
            case 37:
                if (e.metaKey) deltaX = -i.contentWidth;
                else if (e.altKey) deltaX = -i.containerWidth;
                else deltaX = -30;
                break;
            case 38:
                if (e.metaKey) deltaY = i.contentHeight;
                else if (e.altKey) deltaY = i.containerHeight;
                else deltaY = 30;
                break;
            case 39:
                if (e.metaKey) deltaX = i.contentWidth;
                else if (e.altKey) deltaX = i.containerWidth;
                else deltaX = 30;
                break;
            case 40:
                if (e.metaKey) deltaY = -i.contentHeight;
                else if (e.altKey) deltaY = -i.containerHeight;
                else deltaY = -30;
                break;
            case 32:
                if (e.shiftKey) deltaY = i.containerHeight;
                else deltaY = -i.containerHeight;
                break;
            case 33:
                deltaY = i.containerHeight;
                break;
            case 34:
                deltaY = -i.containerHeight;
                break;
            case 36:
                deltaY = i.contentHeight;
                break;
            case 35:
                deltaY = -i.contentHeight;
                break;
            default:
                return;
        }
        if (i.settings.suppressScrollX && deltaX !== 0) return;
        if (i.settings.suppressScrollY && deltaY !== 0) return;
        element.scrollTop -= deltaY;
        element.scrollLeft += deltaX;
        $53143b210d847066$var$updateGeometry(i);
        if (shouldPreventDefault(deltaX, deltaY)) e.preventDefault();
    });
}
/* eslint-disable */ function $53143b210d847066$var$wheel(i) {
    var element = i.element;
    function shouldPreventDefault(deltaX, deltaY) {
        var roundedScrollTop = Math.floor(element.scrollTop);
        var isTop = element.scrollTop === 0;
        var isBottom = roundedScrollTop + element.offsetHeight === element.scrollHeight;
        var isLeft = element.scrollLeft === 0;
        var isRight = element.scrollLeft + element.offsetWidth === element.scrollWidth;
        var hitsBound;
        // pick axis with primary direction
        if (Math.abs(deltaY) > Math.abs(deltaX)) hitsBound = isTop || isBottom;
        else hitsBound = isLeft || isRight;
        return hitsBound ? !i.settings.wheelPropagation : true;
    }
    function getDeltaFromEvent(e) {
        var deltaX = e.deltaX;
        var deltaY = -1 * e.deltaY;
        if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
            // OS X Safari
            deltaX = -1 * e.wheelDeltaX / 6;
            deltaY = e.wheelDeltaY / 6;
        }
        if (e.deltaMode && e.deltaMode === 1) {
            // Firefox in deltaMode 1: Line scrolling
            deltaX *= 10;
            deltaY *= 10;
        }
        if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */ ) {
            // IE in some mouse drivers
            deltaX = 0;
            deltaY = e.wheelDelta;
        }
        if (e.shiftKey) // reverse axis with shift key
        return [
            -deltaY,
            -deltaX
        ];
        return [
            deltaX,
            deltaY
        ];
    }
    function shouldBeConsumedByChild(target, deltaX, deltaY) {
        // FIXME: this is a workaround for <select> issue in FF and IE #571
        if (!$53143b210d847066$var$env.isWebKit && element.querySelector('select:focus')) return true;
        if (!element.contains(target)) return false;
        var cursor = target;
        while(cursor && cursor !== element){
            if (cursor.classList.contains($53143b210d847066$var$cls.element.consuming)) return true;
            var style = $53143b210d847066$var$get(cursor);
            // if deltaY && vertical scrollable
            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                if (maxScrollTop > 0) {
                    if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) return true;
                }
            }
            // if deltaX && horizontal scrollable
            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                if (maxScrollLeft > 0) {
                    if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) return true;
                }
            }
            cursor = cursor.parentNode;
        }
        return false;
    }
    function mousewheelHandler(e) {
        var ref = getDeltaFromEvent(e);
        var deltaX = ref[0];
        var deltaY = ref[1];
        if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) return;
        var shouldPrevent = false;
        if (!i.settings.useBothWheelAxes) {
            // deltaX will only be used for horizontal scrolling and deltaY will
            // only be used for vertical scrolling - this is the default
            element.scrollTop -= deltaY * i.settings.wheelSpeed;
            element.scrollLeft += deltaX * i.settings.wheelSpeed;
        } else if (i.scrollbarYActive && !i.scrollbarXActive) {
            // only vertical scrollbar is active and useBothWheelAxes option is
            // active, so let's scroll vertical bar using both mouse wheel axes
            if (deltaY) element.scrollTop -= deltaY * i.settings.wheelSpeed;
            else element.scrollTop += deltaX * i.settings.wheelSpeed;
            shouldPrevent = true;
        } else if (i.scrollbarXActive && !i.scrollbarYActive) {
            // useBothWheelAxes and only horizontal bar is active, so use both
            // wheel axes for horizontal bar
            if (deltaX) element.scrollLeft += deltaX * i.settings.wheelSpeed;
            else element.scrollLeft -= deltaY * i.settings.wheelSpeed;
            shouldPrevent = true;
        }
        $53143b210d847066$var$updateGeometry(i);
        shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
        if (shouldPrevent && !e.ctrlKey) {
            e.stopPropagation();
            e.preventDefault();
        }
    }
    if (typeof window.onwheel !== 'undefined') i.event.bind(element, 'wheel', mousewheelHandler);
    else if (typeof window.onmousewheel !== 'undefined') i.event.bind(element, 'mousewheel', mousewheelHandler);
}
function $53143b210d847066$var$touch(i) {
    if (!$53143b210d847066$var$env.supportsTouch && !$53143b210d847066$var$env.supportsIePointer) return;
    var element = i.element;
    var state = {
        startOffset: {},
        startTime: 0,
        speed: {},
        easingLoop: null
    };
    function shouldPrevent(deltaX, deltaY) {
        var scrollTop = Math.floor(element.scrollTop);
        var scrollLeft = element.scrollLeft;
        var magnitudeX = Math.abs(deltaX);
        var magnitudeY = Math.abs(deltaY);
        if (magnitudeY > magnitudeX) {
            // user is perhaps trying to swipe up/down the page
            if (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight || deltaY > 0 && scrollTop === 0) // set prevent for mobile Chrome refresh
            return window.scrollY === 0 && deltaY > 0 && $53143b210d847066$var$env.isChrome;
        } else if (magnitudeX > magnitudeY) {
            // user is perhaps trying to swipe left/right across the page
            if (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth || deltaX > 0 && scrollLeft === 0) return true;
        }
        return true;
    }
    function applyTouchMove(differenceX, differenceY) {
        element.scrollTop -= differenceY;
        element.scrollLeft -= differenceX;
        $53143b210d847066$var$updateGeometry(i);
    }
    function getTouch(e) {
        if (e.targetTouches) return e.targetTouches[0];
        // Maybe IE pointer
        return e;
    }
    function shouldHandle(e) {
        if (e.target === i.scrollbarX || e.target === i.scrollbarY) return false;
        if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) return false;
        if (e.targetTouches && e.targetTouches.length === 1) return true;
        if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) return true;
        return false;
    }
    function touchStart(e) {
        if (!shouldHandle(e)) return;
        var touch = getTouch(e);
        state.startOffset.pageX = touch.pageX;
        state.startOffset.pageY = touch.pageY;
        state.startTime = new Date().getTime();
        if (state.easingLoop !== null) clearInterval(state.easingLoop);
    }
    function shouldBeConsumedByChild(target, deltaX, deltaY) {
        if (!element.contains(target)) return false;
        var cursor = target;
        while(cursor && cursor !== element){
            if (cursor.classList.contains($53143b210d847066$var$cls.element.consuming)) return true;
            var style = $53143b210d847066$var$get(cursor);
            // if deltaY && vertical scrollable
            if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
                var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
                if (maxScrollTop > 0) {
                    if (cursor.scrollTop > 0 && deltaY < 0 || cursor.scrollTop < maxScrollTop && deltaY > 0) return true;
                }
            }
            // if deltaX && horizontal scrollable
            if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
                var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
                if (maxScrollLeft > 0) {
                    if (cursor.scrollLeft > 0 && deltaX < 0 || cursor.scrollLeft < maxScrollLeft && deltaX > 0) return true;
                }
            }
            cursor = cursor.parentNode;
        }
        return false;
    }
    function touchMove(e) {
        if (shouldHandle(e)) {
            var touch = getTouch(e);
            var currentOffset = {
                pageX: touch.pageX,
                pageY: touch.pageY
            };
            var differenceX = currentOffset.pageX - state.startOffset.pageX;
            var differenceY = currentOffset.pageY - state.startOffset.pageY;
            if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) return;
            applyTouchMove(differenceX, differenceY);
            state.startOffset = currentOffset;
            var currentTime = new Date().getTime();
            var timeGap = currentTime - state.startTime;
            if (timeGap > 0) {
                state.speed.x = differenceX / timeGap;
                state.speed.y = differenceY / timeGap;
                state.startTime = currentTime;
            }
            if (shouldPrevent(differenceX, differenceY)) // Prevent the default behavior if the event is cancelable
            {
                if (e.cancelable) e.preventDefault();
            }
        }
    }
    function touchEnd() {
        if (i.settings.swipeEasing) {
            clearInterval(state.easingLoop);
            state.easingLoop = setInterval(function() {
                if (i.isInitialized) {
                    clearInterval(state.easingLoop);
                    return;
                }
                if (!state.speed.x && !state.speed.y) {
                    clearInterval(state.easingLoop);
                    return;
                }
                if (Math.abs(state.speed.x) < 0.01 && Math.abs(state.speed.y) < 0.01) {
                    clearInterval(state.easingLoop);
                    return;
                }
                applyTouchMove(state.speed.x * 30, state.speed.y * 30);
                state.speed.x *= 0.8;
                state.speed.y *= 0.8;
            }, 10);
        }
    }
    if ($53143b210d847066$var$env.supportsTouch) {
        i.event.bind(element, 'touchstart', touchStart);
        i.event.bind(element, 'touchmove', touchMove);
        i.event.bind(element, 'touchend', touchEnd);
    } else if ($53143b210d847066$var$env.supportsIePointer) {
        if (window.PointerEvent) {
            i.event.bind(element, 'pointerdown', touchStart);
            i.event.bind(element, 'pointermove', touchMove);
            i.event.bind(element, 'pointerup', touchEnd);
        } else if (window.MSPointerEvent) {
            i.event.bind(element, 'MSPointerDown', touchStart);
            i.event.bind(element, 'MSPointerMove', touchMove);
            i.event.bind(element, 'MSPointerUp', touchEnd);
        }
    }
}
/* eslint-disable */ var $53143b210d847066$var$defaultSettings = function() {
    return {
        handlers: [
            'click-rail',
            'drag-thumb',
            'keyboard',
            'wheel',
            'touch'
        ],
        maxScrollbarLength: null,
        minScrollbarLength: null,
        scrollingThreshold: 1000,
        scrollXMarginOffset: 0,
        scrollYMarginOffset: 0,
        suppressScrollX: false,
        suppressScrollY: false,
        swipeEasing: true,
        useBothWheelAxes: false,
        wheelPropagation: true,
        wheelSpeed: 1
    };
};
var $53143b210d847066$var$handlers = {
    'click-rail': $53143b210d847066$var$clickRail,
    'drag-thumb': $53143b210d847066$var$setupScrollHandlers,
    keyboard: $53143b210d847066$var$keyboard,
    wheel: $53143b210d847066$var$wheel,
    touch: $53143b210d847066$var$touch
};
var $53143b210d847066$var$PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
    var this$1 = this;
    if (userSettings === void 0) userSettings = {};
    if (typeof element === 'string') element = document.querySelector(element);
    if (!element || !element.nodeName) throw new Error('no element is specified to initialize PerfectScrollbar');
    this.element = element;
    element.classList.add($53143b210d847066$var$cls.main);
    this.settings = $53143b210d847066$var$defaultSettings();
    for(var key in userSettings)this.settings[key] = userSettings[key];
    this.containerWidth = null;
    this.containerHeight = null;
    this.contentWidth = null;
    this.contentHeight = null;
    var focus = function() {
        return element.classList.add($53143b210d847066$var$cls.state.focus);
    };
    var blur = function() {
        return element.classList.remove($53143b210d847066$var$cls.state.focus);
    };
    this.isRtl = $53143b210d847066$var$get(element).direction === 'rtl';
    if (this.isRtl === true) element.classList.add($53143b210d847066$var$cls.rtl);
    this.isNegativeScroll = function() {
        var originalScrollLeft = element.scrollLeft;
        var result = null;
        element.scrollLeft = -1;
        result = element.scrollLeft < 0;
        element.scrollLeft = originalScrollLeft;
        return result;
    }();
    this.negativeScrollAdjustment = this.isNegativeScroll ? element.scrollWidth - element.clientWidth : 0;
    this.event = new $53143b210d847066$var$EventManager();
    this.ownerDocument = element.ownerDocument || document;
    this.scrollbarXRail = $53143b210d847066$var$div($53143b210d847066$var$cls.element.rail('x'));
    element.appendChild(this.scrollbarXRail);
    this.scrollbarX = $53143b210d847066$var$div($53143b210d847066$var$cls.element.thumb('x'));
    this.scrollbarXRail.appendChild(this.scrollbarX);
    this.scrollbarX.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarX, 'focus', focus);
    this.event.bind(this.scrollbarX, 'blur', blur);
    this.scrollbarXActive = null;
    this.scrollbarXWidth = null;
    this.scrollbarXLeft = null;
    var railXStyle = $53143b210d847066$var$get(this.scrollbarXRail);
    this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
    if (isNaN(this.scrollbarXBottom)) {
        this.isScrollbarXUsingBottom = false;
        this.scrollbarXTop = $53143b210d847066$var$toInt(railXStyle.top);
    } else this.isScrollbarXUsingBottom = true;
    this.railBorderXWidth = $53143b210d847066$var$toInt(railXStyle.borderLeftWidth) + $53143b210d847066$var$toInt(railXStyle.borderRightWidth);
    // Set rail to display:block to calculate margins
    $53143b210d847066$var$set(this.scrollbarXRail, {
        display: 'block'
    });
    this.railXMarginWidth = $53143b210d847066$var$toInt(railXStyle.marginLeft) + $53143b210d847066$var$toInt(railXStyle.marginRight);
    $53143b210d847066$var$set(this.scrollbarXRail, {
        display: ''
    });
    this.railXWidth = null;
    this.railXRatio = null;
    this.scrollbarYRail = $53143b210d847066$var$div($53143b210d847066$var$cls.element.rail('y'));
    element.appendChild(this.scrollbarYRail);
    this.scrollbarY = $53143b210d847066$var$div($53143b210d847066$var$cls.element.thumb('y'));
    this.scrollbarYRail.appendChild(this.scrollbarY);
    this.scrollbarY.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarY, 'focus', focus);
    this.event.bind(this.scrollbarY, 'blur', blur);
    this.scrollbarYActive = null;
    this.scrollbarYHeight = null;
    this.scrollbarYTop = null;
    var railYStyle = $53143b210d847066$var$get(this.scrollbarYRail);
    this.scrollbarYRight = parseInt(railYStyle.right, 10);
    if (isNaN(this.scrollbarYRight)) {
        this.isScrollbarYUsingRight = false;
        this.scrollbarYLeft = $53143b210d847066$var$toInt(railYStyle.left);
    } else this.isScrollbarYUsingRight = true;
    this.scrollbarYOuterWidth = this.isRtl ? $53143b210d847066$var$outerWidth(this.scrollbarY) : null;
    this.railBorderYWidth = $53143b210d847066$var$toInt(railYStyle.borderTopWidth) + $53143b210d847066$var$toInt(railYStyle.borderBottomWidth);
    $53143b210d847066$var$set(this.scrollbarYRail, {
        display: 'block'
    });
    this.railYMarginHeight = $53143b210d847066$var$toInt(railYStyle.marginTop) + $53143b210d847066$var$toInt(railYStyle.marginBottom);
    $53143b210d847066$var$set(this.scrollbarYRail, {
        display: ''
    });
    this.railYHeight = null;
    this.railYRatio = null;
    this.reach = {
        x: element.scrollLeft <= 0 ? 'start' : element.scrollLeft >= this.contentWidth - this.containerWidth ? 'end' : null,
        y: element.scrollTop <= 0 ? 'start' : element.scrollTop >= this.contentHeight - this.containerHeight ? 'end' : null
    };
    this.isAlive = true;
    this.settings.handlers.forEach(function(handlerName) {
        return $53143b210d847066$var$handlers[handlerName](this$1);
    });
    this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
    this.lastScrollLeft = element.scrollLeft; // for onScroll only
    this.event.bind(this.element, 'scroll', function(e) {
        return this$1.onScroll(e);
    });
    $53143b210d847066$var$updateGeometry(this);
};
$53143b210d847066$var$PerfectScrollbar.prototype.update = function update() {
    if (!this.isAlive) return;
    // Recalcuate negative scrollLeft adjustment
    this.negativeScrollAdjustment = this.isNegativeScroll ? this.element.scrollWidth - this.element.clientWidth : 0;
    // Recalculate rail margins
    $53143b210d847066$var$set(this.scrollbarXRail, {
        display: 'block'
    });
    $53143b210d847066$var$set(this.scrollbarYRail, {
        display: 'block'
    });
    this.railXMarginWidth = $53143b210d847066$var$toInt($53143b210d847066$var$get(this.scrollbarXRail).marginLeft) + $53143b210d847066$var$toInt($53143b210d847066$var$get(this.scrollbarXRail).marginRight);
    this.railYMarginHeight = $53143b210d847066$var$toInt($53143b210d847066$var$get(this.scrollbarYRail).marginTop) + $53143b210d847066$var$toInt($53143b210d847066$var$get(this.scrollbarYRail).marginBottom);
    // Hide scrollbars not to affect scrollWidth and scrollHeight
    $53143b210d847066$var$set(this.scrollbarXRail, {
        display: 'none'
    });
    $53143b210d847066$var$set(this.scrollbarYRail, {
        display: 'none'
    });
    $53143b210d847066$var$updateGeometry(this);
    $53143b210d847066$var$processScrollDiff(this, 'top', 0, false, true);
    $53143b210d847066$var$processScrollDiff(this, 'left', 0, false, true);
    $53143b210d847066$var$set(this.scrollbarXRail, {
        display: ''
    });
    $53143b210d847066$var$set(this.scrollbarYRail, {
        display: ''
    });
};
$53143b210d847066$var$PerfectScrollbar.prototype.onScroll = function onScroll(e) {
    if (!this.isAlive) return;
    $53143b210d847066$var$updateGeometry(this);
    $53143b210d847066$var$processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
    $53143b210d847066$var$processScrollDiff(this, 'left', this.element.scrollLeft - this.lastScrollLeft);
    this.lastScrollTop = Math.floor(this.element.scrollTop);
    this.lastScrollLeft = this.element.scrollLeft;
};
$53143b210d847066$var$PerfectScrollbar.prototype.destroy = function destroy() {
    if (!this.isAlive) return;
    this.event.unbindAll();
    $53143b210d847066$var$remove(this.scrollbarX);
    $53143b210d847066$var$remove(this.scrollbarY);
    $53143b210d847066$var$remove(this.scrollbarXRail);
    $53143b210d847066$var$remove(this.scrollbarYRail);
    this.removePsClasses();
    // unset elements
    this.element = null;
    this.scrollbarX = null;
    this.scrollbarY = null;
    this.scrollbarXRail = null;
    this.scrollbarYRail = null;
    this.isAlive = false;
};
$53143b210d847066$var$PerfectScrollbar.prototype.removePsClasses = function removePsClasses() {
    this.element.className = this.element.className.split(' ').filter(function(name) {
        return !name.match(/^ps([-_].+|)$/);
    }).join(' ');
};
var $53143b210d847066$export$2e2bcd8739ae039 = $53143b210d847066$var$PerfectScrollbar;

});

parcelRegister("i8Fxz", function(module, exports) {
/*! @license DOMPurify 3.4.17 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.17/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _OverloadYield(e, d) {
        this.v = e, this.k = d;
    }
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    function AsyncGenerator(e) {
        var t, n;
        function resume(t, n) {
            try {
                var r = e[t](n), o = r.value, u = o instanceof _OverloadYield;
                Promise.resolve(u ? o.v : o).then(function(n) {
                    if (u) {
                        var i = "return" === t && o.k ? t : "next";
                        if (!o.k || n.done) return resume(i, n);
                        n = e[i](n).value;
                    }
                    settle(!!r.done, n);
                }, function(e) {
                    resume("throw", e);
                });
            } catch (e) {
                settle(2, e);
            }
        }
        function settle(e, r) {
            2 === e ? t.reject(r) : t.resolve({
                value: r,
                done: e
            }), (t = t.next) ? resume(t.key, t.arg) : n = null;
        }
        this._invoke = function(e, r) {
            return new Promise(function(o, u) {
                var i = {
                    key: e,
                    arg: r,
                    resolve: o,
                    reject: u,
                    next: null
                };
                n ? n = n.next = i : (t = n = i, resume(e, r));
            });
        }, "function" != typeof e.return && (this.return = void 0);
    }
    AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
        return this;
    }, AsyncGenerator.prototype.next = function(e) {
        return this._invoke("next", e);
    }, AsyncGenerator.prototype.throw = function(e) {
        return this._invoke("throw", e);
    }, AsyncGenerator.prototype.return = function(e) {
        return this._invoke("return", e);
    };
    const entries = Object.entries;
    const setPrototypeOf = Object.setPrototypeOf;
    const isFrozen = Object.isFrozen;
    const getPrototypeOf = Object.getPrototypeOf;
    const getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    let freeze = Object.freeze;
    let seal = Object.seal;
    let create = Object.create;
    let _ref = typeof Reflect !== "undefined" && Reflect;
    let apply = _ref.apply;
    let construct = _ref.construct;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    Array.prototype.indexOf;
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySlice = unapply(Array.prototype.slice);
    const arraySplice = unapply(Array.prototype.splice);
    const arrayIsArray = Array.isArray;
    const setCreate = unconstruct(Set);
    const setAdd = unapply(Set.prototype.add);
    const setHas = unapply(Set.prototype.has);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const numberToString = unapply(Number.prototype.toString);
    const booleanToString = unapply(Boolean.prototype.toString);
    const bigintToString = typeof BigInt === "undefined" ? null : unapply(BigInt.prototype.toString);
    const symbolToString = typeof Symbol === "undefined" ? null : unapply(Symbol.prototype.toString);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const objectToString = unapply(Object.prototype.toString);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
	* Creates a new function that calls the given function with a specified thisArg and arguments.
	*
	* @param func - The function to be wrapped and called.
	* @returns A new function that calls the given function with a specified thisArg and arguments.
	*/ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
	* Creates a new function that constructs an instance of the given constructor function with the provided arguments.
	*
	* @param func - The constructor function to be wrapped and called.
	* @returns A new function that constructs an instance of the given constructor function with the provided arguments.
	*/ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
	* Add properties to a lookup table
	*
	* @param set - The set to which elements will be added.
	* @param array - The array containing elements to be added to the set.
	* @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
	* @returns The modified set with added elements.
	*/ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) setPrototypeOf(set, null);
        if (!arrayIsArray(array)) return set;
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === "string") {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
	* Clean up an array to harden against CSPP
	*
	* @param array - The array to be cleaned.
	* @returns The cleaned version of the array
	*/ function cleanArray(array) {
        for(let index = 0; index < array.length; index++)if (!objectHasOwnProperty(array, index)) array[index] = null;
        return array;
    }
    /**
	* Shallow clone an object
	*
	* @param object - The object to be cloned.
	* @returns A new object that copies the original.
	*/ function clone(object) {
        const newObject = create(null);
        for (const _ref2 of entries(object)){
            var _ref3 = _slicedToArray(_ref2, 2);
            const property = _ref3[0];
            const value = _ref3[1];
            if (objectHasOwnProperty(object, property)) {
                if (arrayIsArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === "object" && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
	* Convert non-node values into strings without depending on direct property access.
	*
	* @param value - The value to stringify.
	* @returns A string representation of the provided value.
	*/ function stringifyValue(value) {
        switch(typeof value){
            case "string":
                return value;
            case "number":
                return numberToString(value);
            case "boolean":
                return booleanToString(value);
            case "bigint":
                return bigintToString ? bigintToString(value) : "0";
            case "symbol":
                return symbolToString ? symbolToString(value) : "Symbol()";
            case "undefined":
                return objectToString(value);
            case "function":
            case "object":
                {
                    if (value === null) return objectToString(value);
                    const valueAsRecord = value;
                    const valueToString = lookupGetter(valueAsRecord, "toString");
                    if (typeof valueToString === "function") {
                        const stringified = valueToString(valueAsRecord);
                        return typeof stringified === "string" ? stringified : objectToString(stringified);
                    }
                    return objectToString(value);
                }
            default:
                return objectToString(value);
        }
    }
    /**
	* This method automatically checks if the prop is function or getter and behaves accordingly.
	*
	* @param object - The object to look up the getter function in its prototype chain.
	* @param prop - The property name for which to find the getter function.
	* @returns The getter function found in the prototype chain or a fallback function.
	*/ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    /**
	* Like lookupGetter, but for accessor properties only, and returns null
	* instead of a null-returning fallback when no getter exists on the chain.
	* Lets a caller fall back to a direct property read in environments that
	* lack the getter, where a fallback returning null would be indistinguishable
	* from a legitimate null value (e.g. namespaceURI of a no-namespace element).
	*
	* @param object - The object (usually a prototype) to start the lookup at.
	* @param prop - The accessor property name.
	* @returns The unapplied getter, or null if none was found.
	*/ function lookupAccessor(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) return desc.get ? unapply(desc.get) : null;
            object = getPrototypeOf(object);
        }
        return null;
    }
    function isRegex(value) {
        try {
            regExpTest(value, "");
            return true;
        } catch (_unused) {
            return false;
        }
    }
    const html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "search",
        "section",
        "select",
        "shadow",
        "slot",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    const svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "enterkeyhint",
        "exportparts",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "inputmode",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "part",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    const svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feDropShadow",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    const svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    const mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover",
        "mprescripts"
    ]);
    const mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    const text = freeze([
        "#text"
    ]);
    const html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "command",
        "commandfor",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "exportparts",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inert",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "part",
        "pattern",
        "placeholder",
        "playsinline",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "slot",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "wrap",
        "xmlns"
    ]);
    const svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "amplitude",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dominant-baseline",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "exponent",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "intercept",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "mask-type",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "pointer-events",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "slope",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "tablevalues",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-orientation",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "vector-effect",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    const mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnalign",
        "columnlines",
        "columnspacing",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lquote",
        "lspace",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    const xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    const MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
    const ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
    const TMPLIT_EXPR = seal(/\${[\w\W]*/g);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/);
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/);
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    const ELEMENT_MARKUP_PROBE = seal(/<[/\w!]/g);
    const COMMENT_MARKUP_PROBE = seal(/<[/\w]/g);
    const FALLBACK_TAG_CLOSE = seal(/<\/no(script|embed|frames)/i);
    const SELF_CLOSING_TAG = seal(/\/>/i);
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        entityNode: 6,
        processingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12
    };
    const LITERAL_TEXT_ELEMENTS = freeze(addToSet({}, [
        "style",
        "script",
        "xmp",
        "iframe",
        "noembed",
        "noframes",
        "plaintext",
        "noscript"
    ]));
    const getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
	* Creates a no-op policy for internal use only.
	* Don't export this function outside this module!
	* @param trustedTypes The policy factory.
	* @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
	* @return The policy created (or null, if Trusted Types
	* are not supported or creating the policy failed).
	*/ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        let suffix = null;
        const ATTR_NAME = "data-tt-policy-suffix";
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    /**
	* Resolve a set-valued configuration option: a fresh set built from
	* cfg[key] when it is an own array property (seeded with a clone of
	* options.base when given, case-normalized via options.transform),
	* the fallback set otherwise.
	*
	* @param cfg the cloned, prototype-free configuration object
	* @param key the configuration property to read
	* @param fallback the set to use when the option is absent or not an array
	* @param options transform and optional base set to merge into
	* @returns the resolved set
	*/ const _resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
        return objectHasOwnProperty(cfg, key) && arrayIsArray(cfg[key]) ? addToSet(options.base ? clone(options.base) : {}, cfg[key], options.transform) : fallback;
    };
    /**
	* Resolve an object-valued configuration option: a prototype-free clone
	* of cfg[key] when it is an own, truthy object property, else a fresh
	* fallback built by makeFallback (fresh on every parse, so a previous
	* parse can never leak state into the next one).
	*
	* @param cfg the cloned, prototype-free configuration object
	* @param key the configuration property to read
	* @param makeFallback builds the fallback value when the option is absent
	* @returns the resolved object
	*/ const _resolveObjectOption = function _resolveObjectOption(cfg, key, makeFallback) {
        const value = objectHasOwnProperty(cfg, key) ? cfg[key] : void 0;
        return value && typeof value === "object" ? clone(value) : makeFallback();
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = "3.4.17";
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let document = window1.document;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        window1.DocumentFragment;
        const HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter;
        window1.NamedNodeMap === void 0 && (window1.NamedNodeMap || window1.MozNamedAttrMap);
        window1.HTMLFormElement;
        const DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        const remove = lookupGetter(ElementPrototype, "remove");
        const removeAttributeNode = lookupGetter(ElementPrototype, "removeAttributeNode");
        const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        const getParentNode = lookupGetter(ElementPrototype, "parentNode");
        const getShadowRoot = lookupGetter(ElementPrototype, "shadowRoot");
        const getAttributes = lookupGetter(ElementPrototype, "attributes");
        const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeType") : null;
        const getNodeName = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeName") : null;
        const getOwnerDocument = Node && Node.prototype ? lookupGetter(Node.prototype, "ownerDocument") : null;
        const _readNodeType = function _readNodeType(node) {
            return getNodeType ? getNodeType(node) : node.nodeType;
        };
        const _readNodeName = function _readNodeName(node) {
            return getNodeName ? getNodeName(node) : node.nodeName;
        };
        const getNamespaceURI = lookupAccessor(ElementPrototype, "namespaceURI");
        const _readNamespaceURI = function _readNamespaceURI(element) {
            return getNamespaceURI ? getNamespaceURI(element) : element.namespaceURI;
        };
        if (typeof HTMLTemplateElement === "function") {
            const template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = "";
        let defaultTrustedTypesPolicy;
        let defaultTrustedTypesPolicyResolved = false;
        let IN_TRUSTED_TYPES_POLICY = 0;
        const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
            if (IN_TRUSTED_TYPES_POLICY > 0) throw typeErrorCreate("A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the \"DOMPurify and Trusted Types\" section of the README.");
        };
        const _createTrustedHTML = function _createTrustedHTML(html) {
            _assertNotInTrustedTypesPolicy();
            IN_TRUSTED_TYPES_POLICY++;
            try {
                return trustedTypesPolicy.createHTML(html);
            } finally{
                IN_TRUSTED_TYPES_POLICY--;
            }
        };
        const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
            _assertNotInTrustedTypesPolicy();
            IN_TRUSTED_TYPES_POLICY++;
            try {
                return trustedTypesPolicy.createScriptURL(scriptUrl);
            } finally{
                IN_TRUSTED_TYPES_POLICY--;
            }
        };
        const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
            if (!defaultTrustedTypesPolicyResolved) {
                defaultTrustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                defaultTrustedTypesPolicyResolved = true;
            }
            return defaultTrustedTypesPolicy;
        };
        const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        const importNode = originalDocument.importNode;
        let hooks = _createHooksMap();
        /**
		* Expose whether this browser supports running the full DOMPurify.
		*/ DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== void 0;
        const MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
		* We consider the elements and attributes below to be safe. Ideally
		* don't add any new ones but feel free to remove unwanted ones.
		*/ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        let FORBID_TAGS = null;
        let FORBID_ATTR = null;
        const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        let ALLOW_ARIA_ATTR = true;
        let ALLOW_DATA_ATTR = true;
        let ALLOW_UNKNOWN_PROTOCOLS = false;
        let ALLOW_SELF_CLOSE_IN_ATTR = true;
        let SAFE_FOR_TEMPLATES = false;
        let SAFE_FOR_XML = true;
        let WHOLE_DOCUMENT = false;
        let SET_CONFIG = false;
        let SET_CONFIG_ALLOWED_TAGS = null;
        let SET_CONFIG_ALLOWED_ATTR = null;
        let FORCE_BODY = false;
        let RETURN_DOM = false;
        let RETURN_DOM_FRAGMENT = false;
        let RETURN_TRUSTED_TYPE = false;
        let SANITIZE_DOM = true;
        let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        let KEEP_CONTENT = true;
        let IN_PLACE = false;
        let IN_PLACE_VISITED = null;
        let USE_PROFILES = {};
        let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "selectedcontent",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = freeze([
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
        const DEFAULT_HTML_INTEGRATION_POINTS = freeze([
            "annotation-xml"
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        let transformCaseFunc = null;
        let CONFIG = null;
        const formElement = document.createElement("form");
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
		* _parseConfig
		*
		* @param cfg optional config literal
		*/ const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            if (!cfg || typeof cfg !== "object") cfg = {};
            cfg = clone(cfg);
            PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            ALLOWED_TAGS = _resolveSetOption(cfg, "ALLOWED_TAGS", DEFAULT_ALLOWED_TAGS, {
                transform: transformCaseFunc
            });
            ALLOWED_ATTR = _resolveSetOption(cfg, "ALLOWED_ATTR", DEFAULT_ALLOWED_ATTR, {
                transform: transformCaseFunc
            });
            ALLOWED_NAMESPACES = _resolveSetOption(cfg, "ALLOWED_NAMESPACES", DEFAULT_ALLOWED_NAMESPACES, {
                transform: stringToString
            });
            URI_SAFE_ATTRIBUTES = _resolveSetOption(cfg, "ADD_URI_SAFE_ATTR", DEFAULT_URI_SAFE_ATTRIBUTES, {
                transform: transformCaseFunc,
                base: DEFAULT_URI_SAFE_ATTRIBUTES
            });
            DATA_URI_TAGS = _resolveSetOption(cfg, "ADD_DATA_URI_TAGS", DEFAULT_DATA_URI_TAGS, {
                transform: transformCaseFunc,
                base: DEFAULT_DATA_URI_TAGS
            });
            FORBID_CONTENTS = _resolveSetOption(cfg, "FORBID_CONTENTS", DEFAULT_FORBID_CONTENTS, {
                transform: transformCaseFunc
            });
            FORBID_TAGS = _resolveSetOption(cfg, "FORBID_TAGS", clone({}), {
                transform: transformCaseFunc
            });
            FORBID_ATTR = _resolveSetOption(cfg, "FORBID_ATTR", clone({}), {
                transform: transformCaseFunc
            });
            USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === "object" ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
            RETURN_DOM = cfg.RETURN_DOM || false;
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
            FORCE_BODY = cfg.FORCE_BODY || false;
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
            IN_PLACE = cfg.IN_PLACE || false;
            IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI;
            NAMESPACE = typeof cfg.NAMESPACE === "string" ? cfg.NAMESPACE : HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = _resolveObjectOption(cfg, "MATHML_TEXT_INTEGRATION_POINTS", ()=>addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS));
            HTML_INTEGRATION_POINTS = _resolveObjectOption(cfg, "HTML_INTEGRATION_POINTS", ()=>addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS));
            const customElementHandling = _resolveObjectOption(cfg, "CUSTOM_ELEMENT_HANDLING", ()=>create(null));
            CUSTOM_ELEMENT_HANDLING = create(null);
            if (objectHasOwnProperty(customElementHandling, "tagNameCheck") && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck;
            if (objectHasOwnProperty(customElementHandling, "attributeNameCheck") && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck;
            if (objectHasOwnProperty(customElementHandling, "allowCustomizedBuiltInElements") && typeof customElementHandling.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements;
            seal(CUSTOM_ELEMENT_HANDLING);
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = create(null);
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            EXTRA_ELEMENT_HANDLING.tagCheck = null;
            EXTRA_ELEMENT_HANDLING.attributeCheck = null;
            if (objectHasOwnProperty(cfg, "ADD_TAGS")) {
                if (typeof cfg.ADD_TAGS === "function") EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else if (arrayIsArray(cfg.ADD_TAGS)) {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, "ADD_ATTR")) {
                if (typeof cfg.ADD_ATTR === "function") EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else if (arrayIsArray(cfg.ADD_ATTR)) {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, "ADD_FORBID_CONTENTS") && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
                const previousTrustedTypesPolicy = trustedTypesPolicy;
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                try {
                    emptyHTML = _createTrustedHTML("");
                } catch (error) {
                    trustedTypesPolicy = previousTrustedTypesPolicy;
                    throw error;
                }
            } else if (cfg.TRUSTED_TYPES_POLICY === null) {
                trustedTypesPolicy = void 0;
                emptyHTML = "";
            } else {
                if (trustedTypesPolicy === void 0) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
                if (trustedTypesPolicy && typeof emptyHTML === "string") emptyHTML = _createTrustedHTML("");
            }
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
		* Namespace rules for an element in the SVG namespace.
		*
		* @param tagName the element's lowercase tag name
		* @param parent the (possibly simulated) parent node
		* @param parentTagName the parent's lowercase tag name
		* @returns true if a spec-compliant parser could produce this element
		*/ const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
            if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
            return Boolean(ALL_SVG_TAGS[tagName]);
        };
        /**
		* Namespace rules for an element in the MathML namespace.
		*
		* @param tagName the element's lowercase tag name
		* @param parent the (possibly simulated) parent node
		* @param parentTagName the parent's lowercase tag name
		* @returns true if a spec-compliant parser could produce this element
		*/ const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
            if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
            return Boolean(ALL_MATHML_TAGS[tagName]);
        };
        /**
		* Namespace rules for an element in the HTML namespace.
		*
		* @param tagName the element's lowercase tag name
		* @param parent the (possibly simulated) parent node
		* @param parentTagName the parent's lowercase tag name
		* @returns true if a spec-compliant parser could produce this element
		*/ const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        };
        /**
		* @param element a DOM element whose namespace is being checked
		* @returns Return false if the element has a
		*  namespace that a spec-compliant parser would never
		*  return. Return true otherwise.
		*/ const _checkValidNamespace = function _checkValidNamespace(element) {
            const elementNamespace = _readNamespaceURI(element);
            const tagName = stringToLowerCase(_readNodeName(element));
            const parentNode = getParentNode(element);
            let parent;
            let parentTagName;
            if (parentNode && _readNodeType(parentNode) === NODE_TYPE.element) {
                parent = {
                    namespaceURI: _readNamespaceURI(parentNode)
                };
                parentTagName = stringToLowerCase(_readNodeName(parentNode));
            } else {
                parent = {
                    namespaceURI: NAMESPACE
                };
                parentTagName = "template";
            }
            if (!ALLOWED_NAMESPACES[elementNamespace]) return false;
            if (elementNamespace === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
            if (elementNamespace === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
            if (elementNamespace === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[elementNamespace]) return true;
            return false;
        };
        /**
		* _forceRemove
		*
		* @param node a DOM node
		*/ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
                if (!getParentNode(node)) throw typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
            }
        };
        /**
		* _stripAttributeNode
		*
		* Remove a single Attr node case/namespace-exactly on an attribute-teardown
		* path. Name-based removeAttribute() ASCII-lowercases its lookup key for an
		* HTML element in an HTML document and so silently misses a case-preserved
		* handler (e.g. `ONERROR` off an XML/XHTML import) - the same defect
		* _removeAttribute() was fixed for, which a name-based call would reintroduce
		* on these IN_PLACE teardown paths. Unlike _removeAttribute this does not
		* record into DOMPurify.removed: the neutralize passes intentionally do not
		* book-keep. A clobbered/detached node falls back to best-effort name-based
		* removal.
		*
		* @param element the element to strip the attribute from
		* @param attribute the Attr node to remove
		* @param name the attribute's name, for the fallback path
		*/ const _stripAttributeNode = function _stripAttributeNode(element, attribute, name) {
            try {
                removeAttributeNode(element, attribute);
            } catch (_) {
                try {
                    element.removeAttribute(name);
                } catch (_) {}
            }
        };
        /**
		* Fail-closed teardown of an in-place root: strip every disallowed attribute
		* in the subtree first, so nothing armed is left behind, then remove all
		* children and the root's own attributes.
		*
		* @param root the in-place root to empty
		*/ const _neutralizeRoot = function _neutralizeRoot(root) {
            _neutralizeSubtree(root);
            const childNodes = getChildNodes(root);
            if (childNodes) arrayForEach(arraySlice(childNodes), (child)=>{
                try {
                    remove(child);
                } catch (_) {}
            });
            const attributes = _readNodeType(root) === NODE_TYPE.element ? getAttributes(root) : null;
            if (attributes) for(let i = attributes.length - 1; i >= 0; --i){
                const attribute = attributes[i];
                const name = attribute && attribute.name;
                if (typeof name === "string") _stripAttributeNode(root, attribute, name);
            }
        };
        /**
		* Removes an attribute, preferably as its exact Attr node: name-based
		* removal lowercases the name in HTML documents and misses case-preserved
		* names, e.g. from imported XHTML.
		*
		* @param name an Attribute name
		* @param element a DOM node
		* @param attr the exact Attr node to remove, when the caller has it
		*/ const _removeAttribute = function _removeAttribute(name, element, attr) {
            if (!attr) try {
                attr = element.getAttributeNode(name);
            } catch (_) {
                attr = null;
            }
            arrayPush(DOMPurify.removed, {
                attribute: attr || null,
                from: element
            });
            try {
                if (attr) removeAttributeNode(element, attr);
                else element.removeAttribute(name);
            } catch (_) {
                try {
                    element.removeAttribute(name);
                } catch (_) {}
            }
            if (name === "is") {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
		* Removes every attribute the configuration does not allow. Used to
		* neutralize nodes discarded from an in-place tree.
		*
		* @param element the element to strip
		*/ const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
            const attributes = getAttributes(element);
            if (!attributes) return;
            for(let i = attributes.length - 1; i >= 0; --i){
                const attribute = attributes[i];
                const name = attribute && attribute.name;
                if (typeof name !== "string" || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
                _stripAttributeNode(element, attribute, name);
            }
        };
        /**
		* Iterative depth-first walk, so deep trees cannot overflow the call stack,
		* reading through the cached getters, so clobbering cannot hide children.
		* When `visit` returns false, the node's children are skipped. With
		* `intoShadow`, open shadow roots are walked after their host's children.
		*
		* @param root where to start
		* @param visit called for every node
		* @param intoShadow whether to enter open shadow roots
		*/ const _walkTree = function _walkTree(root, visit) {
            let intoShadow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            const stack = [
                root
            ];
            while(stack.length > 0){
                const node = stack.pop();
                if (visit(node) === false) continue;
                if (intoShadow && _readNodeType(node) === NODE_TYPE.element) {
                    const shadowRoot = getShadowRoot(node);
                    if (_isDocumentFragment(shadowRoot)) stack.push(shadowRoot);
                }
                const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push(childNodes[i]);
            }
        };
        /**
		* Strips disallowed attributes from every element of a discarded subtree,
		* so a handler that is already queued (a loading image) cannot fire.
		*
		* @param root the root of a removed subtree
		*/ const _neutralizeSubtree = function _neutralizeSubtree(root) {
            _walkTree(root, (node)=>{
                if (_readNodeType(node) === NODE_TYPE.element) _stripDisallowedAttributes(node);
            });
        };
        /**
		* All nodes under `root`, root first, including open shadow roots. Template
		* content is not entered, it is inert.
		*
		* @param root the in-place root
		* @return the nodes
		*/ const _collectLiveNodes = function _collectLiveNodes(root) {
            const nodes = [];
            _walkTree(root, (node)=>{
                nodes.push(node);
            }, true);
            return nodes;
        };
        /**
		* Strips disallowed attributes from every element that was under the
		* in-place root when the call started and no longer is, whatever removed
		* or moved it.
		*
		* @param root the in-place root
		* @param before the root's nodes, collected before the walk
		*/ const _neutralizeEscapedElements = function _neutralizeEscapedElements(root, before) {
            const reachable = setCreate();
            arrayForEach(_collectLiveNodes(root), (node)=>{
                if (_readNodeType(node) === NODE_TYPE.element) setAdd(reachable, node);
            });
            arrayForEach(before, (node)=>{
                if (_readNodeType(node) === NODE_TYPE.element && !setHas(reachable, node)) _stripDisallowedAttributes(node);
            });
        };
        /**
		* Neutralizes everything that left the in-place tree during the call: what
		* DOMPurify removed, and what hooks or custom elements removed or moved out.
		*
		* @param root the in-place root
		* @param before the root's nodes, collected before the walk
		* @return true if the root itself was removed
		*/ const _neutralizeDiscarded = function _neutralizeDiscarded(root, before) {
            let rootRemoved = false;
            arrayForEach(DOMPurify.removed, (entry)=>{
                if (entry.element) {
                    rootRemoved = rootRemoved || entry.element === root;
                    _neutralizeSubtree(entry.element);
                }
            });
            _neutralizeEscapedElements(root, before);
            return rootRemoved;
        };
        const MAX_UNVISITED_ROUNDS = 8;
        /**
		* The walk only moves forward, so a node moved to a position it already
		* passed is never visited. Give every original node that is still in the
		* tree but unvisited the normal treatment, hooks included. Nodes created
		* during the call are left alone. Fails closed if the tree keeps changing.
		*
		* @param root the in-place root
		* @param before the root's nodes, collected before the walk
		*/ const _sanitizeUnvisitedNodes = function _sanitizeUnvisitedNodes(root, before) {
            const visited = IN_PLACE_VISITED;
            let original = null;
            const getOriginal = ()=>{
                if (!original) {
                    original = setCreate();
                    arrayForEach(before, (beforeNode)=>{
                        setAdd(original, beforeNode);
                    });
                }
                return original;
            };
            for(let round = 0;; round++){
                const live = _collectLiveNodes(root);
                const containers = [
                    root
                ];
                let pending = false;
                arrayForEach(live, (node)=>{
                    if (_readNodeType(node) === NODE_TYPE.documentFragment) arrayPush(containers, node);
                    else if (!pending && !setHas(visited, node)) pending = setHas(getOriginal(), node);
                });
                if (!pending) return;
                if (round >= MAX_UNVISITED_ROUNDS) throw typeErrorCreate("the tree kept changing during in-place sanitization; refusing to return it");
                arrayForEach(containers, (container, index)=>{
                    _sanitizeUnvisitedIn(container, index > 0, root, getOriginal());
                });
            }
        };
        /**
		* One _sanitizeUnvisitedNodes pass over the root or an open shadow root.
		*
		* @param container the root or an open shadow root
		* @param inShadow whether container is a shadow root
		* @param root the in-place root
		* @param original the root's nodes collected before the walk, as a set
		*/ const _sanitizeUnvisitedIn = function _sanitizeUnvisitedIn(container, inShadow, root, original) {
            const iterator = _createNodeIterator(container);
            let node;
            while(node = iterator.nextNode()){
                if (!setHas(original, node) || setHas(IN_PLACE_VISITED, node)) continue;
                if (inShadow) _executeHooks(hooks.uponSanitizeShadowNode, node, null);
                _sanitizeElements(node, root);
                _sanitizeAttributes(node, root);
                if (_isDocumentFragment(node.content)) _sanitizeShadowDOM2(node.content);
            }
        };
        /**
		* Records that _sanitizeElements processed `node`. No-op outside IN_PLACE.
		*
		* @param node the node being processed
		*/ const _markVisited = function _markVisited(node) {
            if (IN_PLACE_VISITED) setAdd(IN_PLACE_VISITED, node);
        };
        /**
		* Patch-linkage attributes (declarative partial updates): `patchsrc`
		* always, `for` everywhere except on <label> and <output>. Gated on
		* SAFE_FOR_XML. Shared by the IN_PLACE pre-pass and _isValidAttribute.
		*
		* @param lcName the transformCaseFunc'd attribute name
		* @param lcTag the transformCaseFunc'd tag name of the carrying element
		* @return true if the attribute is patch linkage and must be dropped
		*/ const _isPatchLinkageAttribute = function _isPatchLinkageAttribute(lcName, lcTag) {
            if (!SAFE_FOR_XML) return false;
            if (lcName === "patchsrc") return true;
            return lcName === "for" && lcTag !== "label" && lcTag !== "output";
        };
        /**
		* IN_PLACE pre-pass: sever all patch linkage before the walk, so no patch
		* can fire mid-walk into a part of the tree the walker already passed.
		* Removes range markers (processing instructions, comments with markup)
		* and strips linkage attributes. It cannot undo a patch that already fired.
		*
		* TODO: if the shipped feature can patch through `for` on <label>/<output>,
		* drop that pair here too (see test/declarative-patch-probe.html).
		*
		* @param root the in-place root to sweep
		*/ const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
            if (!SAFE_FOR_XML) return;
            _walkTree(root, (node)=>{
                const nodeType = _readNodeType(node);
                if (nodeType === NODE_TYPE.processingInstruction || nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, node.data)) {
                    try {
                        remove(node);
                    } catch (_) {}
                    return false;
                }
                if (nodeType === NODE_TYPE.element) {
                    const element = node;
                    const lcTag = transformCaseFunc(_readNodeName(node));
                    try {
                        if (element.hasAttribute && element.hasAttribute("patchsrc")) element.removeAttribute("patchsrc");
                        if (element.hasAttribute && element.hasAttribute("for") && _isPatchLinkageAttribute("for", lcTag)) element.removeAttribute("for");
                    } catch (_) {}
                }
                return true;
            });
        };
        /**
		* _initDocument
		*
		* @param dirty - a string of dirty markup
		* @return a DOM, filled with the dirty markup
		*/ const _initDocument = function _initDocument(dirty) {
            let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) dirty = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + dirty + "</body></html>";
            const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
            if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {}
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
		* Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
		*
		* @param root The root element or node to start traversing on.
		* @return The created NodeIterator
		*/ const _createNodeIterator = function _createNodeIterator(root) {
            const doc = getOwnerDocument ? getOwnerDocument(root) : root.ownerDocument;
            return createNodeIterator.call(doc || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
		* Replace template expression syntax (mustache, ERB, template
		* literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
		* sites. Order matters: mustache, then ERB, then template literal.
		*
		* @param value the string to scrub
		* @returns the scrubbed string
		*/ const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
            value = stringReplace(value, MUSTACHE_EXPR$1, " ");
            value = stringReplace(value, ERB_EXPR$1, " ");
            value = stringReplace(value, TMPLIT_EXPR$1, " ");
            return value;
        };
        /**
		* Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
		* character data of an element subtree. Used as the final safety net for
		* SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
		* which only form after text-node normalization (e.g. fragments split across
		* stripped elements) cannot survive into a template-evaluating framework.
		*
		* Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
		* in place rather than round-tripping through innerHTML. This preserves
		* descendant node references (important for IN_PLACE callers), avoids a
		* serialize/reparse cycle, and reads literal character data — which means
		* `<%...%>` in text content matches the ERB regex against its real bytes
		* instead of the HTML-entity-escaped form innerHTML would produce.
		*
		* Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
		* attributes is performed during the per-node `_sanitizeAttributes` pass.
		*
		* @param node The root element whose character data should be scrubbed.
		*/ const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
            var _node$querySelectorAl;
            _scrubOwnCharacterData(node);
            const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, "template");
            if (templates) arrayForEach(templates, (tmpl)=>{
                if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
            });
        };
        /**
		* _scrubOwnCharacterData
		*
		* Non-recursive core of _scrubTemplateExpressions: normalize `node` and
		* strip template expressions from its own character data only. Does not
		* enter <template>.content or attached shadow roots (NodeIterator never
		* does). Used by _sanitizeShadowDOM, where every nested template content
		* and shadow root is already walked - and therefore scrubbed - by its own
		* recursive _sanitizeShadowDOM call; recursing here as well would rescrub
		* each nested fragment once per ancestor, which is quadratic in nesting
		* depth.
		*
		* @param node The root whose own character data should be scrubbed.
		*/ const _scrubOwnCharacterData = function _scrubOwnCharacterData(node) {
            node.normalize();
            const doc = getOwnerDocument ? getOwnerDocument(node) : node.ownerDocument;
            const walker = createNodeIterator.call(doc || node, node, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
            let currentNode = walker.nextNode();
            while(currentNode){
                currentNode.data = _stripTemplateExpressions(currentNode.data);
                currentNode = walker.nextNode();
            }
        };
        /**
		* _isClobbered
		*
		* Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
		* interface with [LegacyOverrideBuiltIns]; a descendant element with a
		* `name` attribute matching a prototype property shadows that property
		* on direct reads. We use this check at the IN_PLACE entry-point and
		* during attribute sanitization to refuse clobbered forms.
		*
		* @param element element to check for clobbering attacks
		* @return true if clobbered, false if safe
		*/ const _isClobbered = function _isClobbered(element) {
            const realTagName = getNodeName ? getNodeName(element) : null;
            if (typeof realTagName !== "string") return false;
            if (transformCaseFunc(realTagName) !== "form") return false;
            return typeof element.nodeName !== "string" || typeof element.textContent !== "string" || typeof element.removeChild !== "function" || element.attributes !== getAttributes(element) || typeof element.removeAttribute !== "function" || typeof element.removeAttributeNode !== "function" || typeof element.getAttributeNode !== "function" || typeof element.setAttribute !== "function" || typeof element.namespaceURI !== "string" || typeof element.insertBefore !== "function" || typeof element.hasChildNodes !== "function" || element.nodeType !== getNodeType(element) || element.childNodes !== getChildNodes(element);
        };
        /**
		* Checks whether the given value is a DocumentFragment from any realm.
		*
		* The realm-independent replacement reads `nodeType` through the cached
		* Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
		* constant (11). nodeType is a numeric value resolved from the node's
		* internal slot, identical across realms for the same kind of node.
		*
		* @param value object to check
		* @return true if value is a DocumentFragment-shaped node from any realm
		*/ const _isDocumentFragment = function _isDocumentFragment(value) {
            if (!getNodeType || typeof value !== "object" || value === null) return false;
            try {
                return getNodeType(value) === NODE_TYPE.documentFragment;
            } catch (_) {
                return false;
            }
        };
        /**
		* Checks whether the given object is a DOM node, including nodes that
		* originate from a different window/realm (e.g. an iframe's
		* contentDocument). The previous `value instanceof Node` check was
		* realm-bound: nodes from a different window failed it, causing
		* sanitize() to silently stringify them and reset IN_PLACE to false,
		* returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
		*
		* @param value object to check whether it's a DOM node
		* @return true if value is a DOM node from any realm
		*/ const _isNode = function _isNode(value) {
            if (!getNodeType || typeof value !== "object" || value === null) return false;
            try {
                return typeof getNodeType(value) === "number";
            } catch (_) {
                return false;
            }
        };
        function _executeHooks(hooks, currentNode, data) {
            if (hooks.length === 0) return;
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
		* Structural-threat checks that condemn a node regardless of the
		* allowlists: mXSS via namespace confusion, risky CSS construction,
		* processing instructions, markup-bearing comments. Pure predicate;
		* the caller removes. Check order is load-bearing.
		*
		* @param currentNode the node to inspect
		* @param tagName the node's transformCaseFunc'd tag name
		* @return true if the node must be removed
		*/ const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
            if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
            if (SAFE_FOR_XML && LITERAL_TEXT_ELEMENTS[tagName] && _readNodeType(currentNode) === NODE_TYPE.element && _readNamespaceURI(currentNode) === HTML_NAMESPACE && (_isNode(currentNode.firstElementChild) || typeof currentNode.textContent === "string" && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent))) return true;
            if (currentNode.nodeType === NODE_TYPE.processingInstruction) return true;
            if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, currentNode.data)) return true;
            return false;
        };
        /**
		* Evaluate a CUSTOM_ELEMENT_HANDLING check (a RegExp or a predicate
		* function, per the validation in _parseConfig) against a name.
		* Additional arguments are forwarded to predicate functions - the
		* attributeNameCheck predicate receives the tag name as its second
		* argument. A null/absent check never matches.
		*
		* @param check the configured tagNameCheck / attributeNameCheck value
		* @param name the name to test
		* @param args extra arguments forwarded to a predicate function
		* @return true if the check matches the name
		*/ const _matchesNameCheck = function _matchesNameCheck(check, name) {
            if (check instanceof RegExp) return regExpTest(check, name);
            if (check instanceof Function) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                return Boolean(check(name, ...args));
            }
            return false;
        };
        /**
		* Handle a node whose tag is forbidden or not allowlisted: keep
		* allowed custom elements (false return exits _sanitizeElements
		* early - the namespace and fallback-tag removal checks are
		* intentionally skipped for kept custom elements), else hoist
		* content per KEEP_CONTENT and remove.
		*
		* A kept custom element is the ONLY case in which this function
		* returns false, so the caller uses that return value to run the
		* afterSanitizeElements hook on the kept element and keep the
		* element-hook lifecycle consistent with normal allowlisted
		* elements (GHSA-c2j3-45gr-mqc4).
		*
		* @param currentNode the disallowed node
		* @param tagName the node's transformCaseFunc'd tag name
		* @return true if the node was removed, false if kept
		*/ const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName, root) {
            if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
            if (KEEP_CONTENT && !FORBID_CONTENTS[tagName] && !FORBID_CONTENTS[stringToLowerCase(tagName)]) {
                const parentNode = getParentNode(currentNode);
                const childNodes = getChildNodes(currentNode);
                if (childNodes && parentNode) {
                    const childCount = childNodes.length;
                    for(let i = childCount - 1; i >= 0; --i){
                        const hoisted = currentNode === root ? cloneNode(childNodes[i], true) : childNodes[i];
                        parentNode.insertBefore(hoisted, getNextSibling(currentNode));
                    }
                }
            }
            _forceRemove(currentNode);
            return true;
        };
        /**
		* Fork a hook-mutable allowlist off its shared binding the first time a
		* (possibly lazily-installed) uponSanitize* hook is about to see it, so the
		* hook cannot widen the per-instance default or the setConfig binding by
		* reference and leak past the call. Returns the set unchanged once it is
		* already call-local, so repeated calls across elements are idempotent.
		*
		* @param hookList the uponSanitize* hook array for this event
		* @param set the current ALLOWED_TAGS / ALLOWED_ATTR binding
		* @param defaultSet the per-instance DEFAULT_ALLOWED_* constant
		* @param setConfigSet the captured setConfig() binding, or null
		* @return a call-local clone if a hook is present and set is still shared,
		*   else set unchanged
		*/ const _forkSharedAllowlist = function _forkSharedAllowlist(hookList, set, defaultSet, setConfigSet) {
            if (hookList.length === 0) return set;
            return set === defaultSet || set === setConfigSet ? clone(set) : set;
        };
        /**
		* A hook may have detached the node it was called for. If so, treat it as
		* removed and stop processing it; the walk root is exempt. On the IN_PLACE
		* path the detached subtree is neutralized right away.
		*
		* @param currentNode the node a hook may have detached
		* @param root the current walk root
		* @return true if the node was detached
		*/ const _handleHookDetachedNode = function _handleHookDetachedNode(currentNode, root) {
            if (currentNode === root || getParentNode(currentNode) !== null) return false;
            if (IN_PLACE) _neutralizeSubtree(currentNode);
            return true;
        };
        /**
		* _sanitizeElements
		*
		* @protect nodeName
		* @protect textContent
		* @protect removeChild
		* @param currentNode to check for permission to exist
		* @return true if node was killed, false if left alive
		*/ const _sanitizeElements = function _sanitizeElements(currentNode, root) {
            _markVisited(currentNode);
            _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            if (_handleHookDetachedNode(currentNode, root)) return true;
            if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            const tagName = transformCaseFunc(_readNodeName(currentNode));
            ALLOWED_TAGS = _forkSharedAllowlist(hooks.uponSanitizeElement, ALLOWED_TAGS, DEFAULT_ALLOWED_TAGS, SET_CONFIG_ALLOWED_TAGS);
            _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            if (_handleHookDetachedNode(currentNode, root)) return true;
            if (_isUnsafeNode(currentNode, tagName)) {
                _forceRemove(currentNode);
                return true;
            }
            if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
                const removed = _sanitizeDisallowedNode(currentNode, tagName, root);
                if (removed === false) {
                    _executeHooks(hooks.afterSanitizeElements, currentNode, null);
                    if (_handleHookDetachedNode(currentNode, root)) return true;
                }
                return removed;
            }
            if (_readNodeType(currentNode) === NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                const content = _stripTemplateExpressions(currentNode.textContent);
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return _handleHookDetachedNode(currentNode, root);
        };
        /**
		* _isValidAttribute
		*
		* @param lcTag Lowercase tag name of containing element.
		* @param lcName Lowercase attribute name.
		* @param value Attribute value.
		* @return Returns true if `value` is valid, otherwise false.
		*/ const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            if (FORBID_ATTR[lcName]) return false;
            if (_isPatchLinkageAttribute(lcName, lcTag)) return false;
            if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
            if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$1, lcName)) return true;
            if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) return true;
            if (!nameIsPermitted) return _isBasicCustomElement(lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName, lcTag) || lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value);
            if (URI_SAFE_ATTRIBUTES[lcName]) return true;
            if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
            if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) return true;
            if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
            return !value;
        };
        const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, [
            "annotation-xml",
            "color-profile",
            "font-face",
            "font-face-format",
            "font-face-name",
            "font-face-src",
            "font-face-uri",
            "missing-glyph"
        ]);
        /**
		* _isBasicCustomElement
		* checks if at least one dash is included in tagName, and it's not the first char
		* for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
		*
		* @param tagName name of the tag of the node to sanitize
		* @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
		*/ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
        };
        /**
		* Wrap an attribute value in the matching Trusted Types object when
		* the active policy requires it. Namespaced attributes pass through
		* unchanged (no TT support yet, see
		* https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
		*
		* @param lcTag lowercase tag name of the containing element
		* @param lcName lowercase attribute name
		* @param namespaceURI the attribute's namespace, if any
		* @param value the attribute value to wrap
		* @return the value, wrapped when Trusted Types demand it
		*/ const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
            if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function" && !namespaceURI) switch(trustedTypes.getAttributeType(lcTag, lcName)){
                case "TrustedHTML":
                    return _createTrustedHTML(value);
                case "TrustedScriptURL":
                    return _createTrustedScriptURL(value);
            }
            return value;
        };
        /**
		* Write a modified attribute value back onto the element. On
		* success, re-probe for clobbering introduced by the new value and
		* remove the element when found; otherwise, when this writeback is the
		* recreate half of the SANITIZE_NAMED_PROPS remove-and-recreate, pop the
		* removal entry that path recorded so it does not show as removed. On
		* failure, remove the attribute instead.
		*
		* Returns true only on a clean write (the value was set and the new value
		* introduced no clobbering). The caller uses that, together with its own
		* knowledge of whether this attribute pushed a DOMPurify.removed record, to
		* decide whether to pop that record. The pop must happen ONLY for the
		* named-prop remove-and-recreate; popping on any other value change (trim,
		* template scrubbing, Trusted Types) would consume an unrelated _forceRemove
		* subtree-cleanup record and let that detached subtree keep a live event
		* handler through the IN_PLACE neutralization pass (SO-001).
		*
		* @param currentNode the element carrying the attribute
		* @param name the attribute name as present on the element
		* @param namespaceURI the attribute's namespace, if any
		* @param value the new attribute value
		* @return true if the value was written without introducing clobbering
		*/ const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
            try {
                if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                else currentNode.setAttribute(name, value);
                if (_isClobbered(currentNode)) {
                    _forceRemove(currentNode);
                    return false;
                }
                return true;
            } catch (_) {
                _removeAttribute(name, currentNode);
                return false;
            }
        };
        /**
		* _isUnsafeAttributeValue
		*
		* Value-based attribute checks that the attribute walk applies before any
		* hook can force-keep an attribute, shared with the public
		* isValidAttribute() so that it never approves a value sanitize() would
		* strip.
		*
		* @param name the attribute name as found on the node (case preserved)
		* @param value the attribute value
		* @returns true if the attribute must be removed because of its value
		*/ const _isUnsafeAttributeValue = function _isUnsafeAttributeValue(name, value) {
            if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) return true;
            return stringToLowerCase(name) === "attributename" && stringMatch(value, "href") !== null;
        };
        /**
		* _sanitizeAttributes
		*
		* @protect attributes
		* @protect nodeName
		* @protect removeAttribute
		* @protect setAttribute
		*
		* @param currentNode to sanitize
		* @param root the current walk root
		*/ const _sanitizeAttributes = function _sanitizeAttributes(currentNode, root) {
            _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            if (_handleHookDetachedNode(currentNode, root)) return;
            const attributes = currentNode.attributes;
            if (!attributes || _isClobbered(currentNode)) return;
            ALLOWED_ATTR = _forkSharedAllowlist(hooks.uponSanitizeAttribute, ALLOWED_ATTR, DEFAULT_ALLOWED_ATTR, SET_CONFIG_ALLOWED_ATTR);
            const hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: void 0
            };
            let l = attributes.length;
            const lcTag = transformCaseFunc(currentNode.nodeName);
            while(l--){
                const attr = attributes[l];
                const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === "value" ? initValue : stringTrim(initValue);
                let recreatedNamedProp = false;
                hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = void 0;
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name") && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                    _removeAttribute(name, currentNode, attr);
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                    recreatedNamedProp = true;
                }
                if (_isUnsafeAttributeValue(name, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                if (hookEvent.forceKeepAttr) continue;
                if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode, attr);
                    continue;
                }
                value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
                if (value !== initValue) {
                    if (_setAttributeValue(currentNode, name, namespaceURI, value) && recreatedNamedProp) arrayPop(DOMPurify.removed);
                }
            }
            _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
            _handleHookDetachedNode(currentNode, root);
        };
        /**
		* _sanitizeShadowDOM
		*
		* @param fragment to iterate over recursively
		*/ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                _sanitizeElements(shadowNode, fragment);
                _sanitizeAttributes(shadowNode, fragment);
                if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
                if (_readNodeType(shadowNode) === NODE_TYPE.element) {
                    const innerSr = getShadowRoot(shadowNode);
                    if (_isDocumentFragment(innerSr)) {
                        _sanitizeAttachedShadowRoots(innerSr);
                        _sanitizeShadowDOM2(innerSr);
                    }
                }
            }
            if (SAFE_FOR_TEMPLATES) _scrubOwnCharacterData(fragment);
            _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        /**
		* Sanitizes every attached shadow root under `root`, since the node
		* iterator does not enter shadow trees. Needed for IN_PLACE input and for
		* DOM input whose clonable shadow roots were copied by importNode().
		*
		* @param root the subtree root to walk for attached shadow roots
		*/ const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
            const stack = [
                {
                    node: root,
                    shadow: null
                }
            ];
            while(stack.length > 0){
                const item = stack.pop();
                if (item.shadow) {
                    _sanitizeShadowDOM2(item.shadow);
                    continue;
                }
                const node = item.node;
                const isElement = _readNodeType(node) === NODE_TYPE.element;
                const childNodes = getChildNodes(node);
                if (childNodes) for(let i = childNodes.length - 1; i >= 0; --i)stack.push({
                    node: childNodes[i],
                    shadow: null
                });
                if (isElement) {
                    const rootName = getNodeName ? getNodeName(node) : null;
                    if (typeof rootName === "string" && transformCaseFunc(rootName) === "template") {
                        const content = node.content;
                        if (_isDocumentFragment(content)) stack.push({
                            node: content,
                            shadow: null
                        });
                    }
                }
                if (isElement) {
                    const sr = getShadowRoot(node);
                    if (_isDocumentFragment(sr)) stack.push({
                        node: null,
                        shadow: sr
                    }, {
                        node: sr,
                        shadow: null
                    });
                }
            }
        };
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            if (typeof dirty !== "string" && !_isNode(dirty)) {
                dirty = stringifyValue(dirty);
                if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
            }
            if (!DOMPurify.isSupported) return dirty;
            if (SET_CONFIG) {
                ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
                ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
            } else _parseConfig(cfg);
            if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = clone(ALLOWED_TAGS);
            if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = clone(ALLOWED_ATTR);
            DOMPurify.removed = [];
            const inPlace = IN_PLACE && typeof dirty !== "string" && _isNode(dirty);
            let inPlaceNodes = [];
            const outerVisited = IN_PLACE_VISITED;
            if (inPlace) {
                _neutralizePatchLinkage(dirty);
                const nn = _readNodeName(dirty);
                if (typeof nn === "string") {
                    const tagName = transformCaseFunc(nn);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                        _neutralizeRoot(dirty);
                        throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                    }
                }
                if (_isClobbered(dirty)) {
                    _neutralizeRoot(dirty);
                    throw typeErrorCreate("root node is clobbered and cannot be sanitized in-place");
                }
                inPlaceNodes = _collectLiveNodes(dirty);
                IN_PLACE_VISITED = setCreate();
            } else if (_isNode(dirty)) {
                body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else body.appendChild(importedNode);
                _sanitizeAttachedShadowRoots(body);
            } else {
                if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
                body = _initDocument(dirty);
                if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            if (body && FORCE_BODY) _forceRemove(body.firstChild);
            const walkRoot = inPlace ? dirty : body;
            try {
                if (inPlace) _sanitizeAttachedShadowRoots(dirty);
                const nodeIterator = _createNodeIterator(walkRoot);
                while(currentNode = nodeIterator.nextNode()){
                    _sanitizeElements(currentNode, walkRoot);
                    _sanitizeAttributes(currentNode, walkRoot);
                    if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
                }
                if (inPlace) _sanitizeUnvisitedNodes(dirty, inPlaceNodes);
            } catch (error) {
                if (inPlace) {
                    _neutralizeRoot(dirty);
                    _neutralizeDiscarded(dirty, inPlaceNodes);
                }
                throw error;
            } finally{
                IN_PLACE_VISITED = outerVisited;
            }
            if (inPlace) {
                if (_neutralizeDiscarded(dirty, inPlaceNodes)) throw typeErrorCreate("a node selected for removal could not be safely returned; refusing to sanitize in place");
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
                return dirty;
            }
            if (RETURN_DOM) {
                if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
            SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
            SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
            SET_CONFIG_ALLOWED_TAGS = null;
            SET_CONFIG_ALLOWED_ATTR = null;
            trustedTypesPolicy = defaultTrustedTypesPolicy;
            emptyHTML = "";
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            if (typeof value === "string" && (_isUnsafeAttributeValue(attr, value) || !ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value))) return false;
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            if (!objectHasOwnProperty(hooks, entryPoint)) return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (!objectHasOwnProperty(hooks, entryPoint)) return;
            if (hookFunction !== void 0) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? void 0 : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            if (!objectHasOwnProperty(hooks, entryPoint)) return;
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    return createDOMPurify();
});

});

parcelRegister("eOZ0o", function(module, exports) {

$parcel$export(module.exports, "observer", () => $aca50e9407ba89c9$export$b6ae1bc530f4c149);
$parcel$export(module.exports, "MobXProviderContext", () => $aca50e9407ba89c9$export$f07786cea590ef31);
$parcel$export(module.exports, "Provider", () => $aca50e9407ba89c9$export$2881499e37b75b9a);
$parcel$export(module.exports, "inject", () => $aca50e9407ba89c9$export$a976684a0efeb93f);
$parcel$export(module.exports, "disposeOnUnmount", () => $aca50e9407ba89c9$export$4e749cb731da87a9);
$parcel$export(module.exports, "PropTypes", () => $aca50e9407ba89c9$export$e0c95a451cd220b7);
$parcel$export(module.exports, "Observer", () => (parcelRequire("ipOq8")).Observer);
$parcel$export(module.exports, "enableStaticRendering", () => (parcelRequire("5zkk0")).enableStaticRendering);
$parcel$export(module.exports, "isUsingStaticRendering", () => (parcelRequire("5zkk0")).isUsingStaticRendering);
$parcel$export(module.exports, "observerBatching", () => (parcelRequire("ddwuv")).observerBatching);
$parcel$export(module.exports, "useAsObservableSource", () => (parcelRequire("7hEbR")).useAsObservableSource);
$parcel$export(module.exports, "useLocalObservable", () => (parcelRequire("6aR1a")).useLocalObservable);
$parcel$export(module.exports, "useLocalStore", () => (parcelRequire("jkSCC")).useLocalStore);
$parcel$export(module.exports, "useObserver", () => (parcelRequire("iKNJK")).useObserver);
$parcel$export(module.exports, "useStaticRendering", () => (parcelRequire("iKNJK")).useStaticRendering);

var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");
parcelRequire("iKNJK");
var $70wxd = parcelRequire("70wxd");
var $5zkk0 = parcelRequire("5zkk0");
var $3bVk6 = parcelRequire("3bVk6");
var $ipOq8 = parcelRequire("ipOq8");
var $ddwuv = parcelRequire("ddwuv");
var $7hEbR = parcelRequire("7hEbR");
var $6aR1a = parcelRequire("6aR1a");
var $jkSCC = parcelRequire("jkSCC");
var $iKNJK = parcelRequire("iKNJK");
function $aca50e9407ba89c9$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($aca50e9407ba89c9$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$aca50e9407ba89c9$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $aca50e9407ba89c9$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $aca50e9407ba89c9$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $aca50e9407ba89c9$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$aca50e9407ba89c9$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $aca50e9407ba89c9$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
var $aca50e9407ba89c9$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $aca50e9407ba89c9$var$getMixins(target, methodName) {
    var mixins = target[$aca50e9407ba89c9$var$mobxMixins] = target[$aca50e9407ba89c9$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $aca50e9407ba89c9$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $aca50e9407ba89c9$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $aca50e9407ba89c9$var$wrapper.call.apply($aca50e9407ba89c9$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $aca50e9407ba89c9$var$patch(target, methodName, mixinMethod) {
    var mixins = $aca50e9407ba89c9$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$aca50e9407ba89c9$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $aca50e9407ba89c9$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $aca50e9407ba89c9$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $aca50e9407ba89c9$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$aca50e9407ba89c9$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $aca50e9407ba89c9$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $aca50e9407ba89c9$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $aca50e9407ba89c9$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
var $aca50e9407ba89c9$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
var $aca50e9407ba89c9$var$observablePropDescriptors;
function $aca50e9407ba89c9$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$aca50e9407ba89c9$var$administrationSymbol]) != null ? _component$administra : component[$aca50e9407ba89c9$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $aca50e9407ba89c9$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $aca50e9407ba89c9$var$makeClassComponentObserver(componentClass) {
    var prototype = componentClass.prototype;
    if (componentClass[$aca50e9407ba89c9$var$isMobXReactObserverSymbol]) {
        var displayName = $aca50e9407ba89c9$var$getDisplayName(componentClass);
        throw new Error("The provided component class (" + displayName + ") has already been declared as an observer component.");
    } else componentClass[$aca50e9407ba89c9$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $acw62.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $aca50e9407ba89c9$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $aca50e9407ba89c9$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    var originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        var _displayName = $aca50e9407ba89c9$var$getDisplayName(componentClass);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $5zkk0.isUsingStaticRendering)() ? originalRender : $aca50e9407ba89c9$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    var originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        var _this = this;
        var _displayName2;
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        var admin = $aca50e9407ba89c9$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $70wxd.observerFinalizationRegistry).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = function() {
            return _this.forceUpdate();
        };
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $aca50e9407ba89c9$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $5zkk0.isUsingStaticRendering)()) return;
        var admin = $aca50e9407ba89c9$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $aca50e9407ba89c9$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $aca50e9407ba89c9$var$createReactiveRender(originalRender) {
    var boundOriginalRender = originalRender.bind(this);
    var admin = $aca50e9407ba89c9$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $aca50e9407ba89c9$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $70wxd.observerFinalizationRegistry).register(this, admin, this);
        }
        var error = undefined;
        var renderResult = undefined;
        admin.reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $4f362._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $aca50e9407ba89c9$var$createReaction(admin) {
    return new (0, $4f362.Reaction)(admin.name + ".render()", function() {
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $aca50e9407ba89c9$var$observerSCU(nextProps, nextState) {
    if ((0, $5zkk0.isUsingStaticRendering)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$aca50e9407ba89c9$var$shallowEqual(this.props, nextProps);
}
function $aca50e9407ba89c9$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get: function get() {
            var admin = $aca50e9407ba89c9$var$getAdministration(this);
            var derivation = (0, $4f362._getGlobalState)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error("[mobx-react] Cannot read \"" + admin.name + "." + key + "\" in a reactive context, as it isn't observable.\n                    Please use component lifecycle method to copy the value into a local observable first.\n                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations");
            return admin[key];
        },
        set: function set(value) {
            $aca50e9407ba89c9$var$getAdministration(this)[key] = value;
        }
    };
}
function $aca50e9407ba89c9$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $acw62.Component), component) || Object.prototype.isPrototypeOf.call((0, $acw62.PureComponent), component)) // Class component
    return $aca50e9407ba89c9$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $3bVk6.observer)(component);
}
function $aca50e9407ba89c9$var$_extends() {
    return $aca50e9407ba89c9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $aca50e9407ba89c9$var$_extends.apply(null, arguments);
}
function $aca50e9407ba89c9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $aca50e9407ba89c9$var$_excluded = [
    "children"
];
var $aca50e9407ba89c9$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
function $aca50e9407ba89c9$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $aca50e9407ba89c9$var$_objectWithoutPropertiesLoose(props, $aca50e9407ba89c9$var$_excluded);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($aca50e9407ba89c9$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef($aca50e9407ba89c9$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($aca50e9407ba89c9$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$aca50e9407ba89c9$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $aca50e9407ba89c9$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
        var newProps = $aca50e9407ba89c9$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($aca50e9407ba89c9$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $aca50e9407ba89c9$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $aca50e9407ba89c9$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $aca50e9407ba89c9$var$getInjectName(component, injectNames);
    return Injector;
}
function $aca50e9407ba89c9$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $aca50e9407ba89c9$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $aca50e9407ba89c9$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $aca50e9407ba89c9$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $aca50e9407ba89c9$var$createStoreInjector($aca50e9407ba89c9$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $aca50e9407ba89c9$var$reactMajorVersion = /*#__PURE__*/ Number.parseInt(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).version.split(".")[0]);
var $aca50e9407ba89c9$var$warnedAboutDisposeOnUnmountDeprecated = false;
var $aca50e9407ba89c9$var$protoStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountProto");
var $aca50e9407ba89c9$var$instStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountInst");
function $aca50e9407ba89c9$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$aca50e9407ba89c9$var$protoStoreKey] || [], this[$aca50e9407ba89c9$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
/**
 * @deprecated `disposeOnUnmount` is not compatible with React 18 and higher.
 */ function $aca50e9407ba89c9$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $aca50e9407ba89c9$export$4e749cb731da87a9(target, fn);
    });
    if (!$aca50e9407ba89c9$var$warnedAboutDisposeOnUnmountDeprecated) {
        if ($aca50e9407ba89c9$var$reactMajorVersion >= 18) console.error("[mobx-react] disposeOnUnmount is not compatible with React 18 and higher. Don't use it.");
        else console.warn("[mobx-react] disposeOnUnmount is deprecated. It won't work correctly with React 18 and higher.");
        $aca50e9407ba89c9$var$warnedAboutDisposeOnUnmountDeprecated = true;
    }
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor);
    // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
    // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string";
    // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$aca50e9407ba89c9$var$protoStoreKey] || !!target[$aca50e9407ba89c9$var$instStoreKey];
    var store = isDecorator ? // decorators are added to the prototype store
    target[$aca50e9407ba89c9$var$protoStoreKey] || (target[$aca50e9407ba89c9$var$protoStoreKey] = []) : // functions are added to the instance store
    target[$aca50e9407ba89c9$var$instStoreKey] || (target[$aca50e9407ba89c9$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction);
    // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $aca50e9407ba89c9$var$patch(target, "componentWillUnmount", $aca50e9407ba89c9$var$runDisposersOnWillUnmount);
    // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
// Copied from React.PropTypes
function $aca50e9407ba89c9$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $4f362.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false);
    // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
// Copied from React.PropTypes
function $aca50e9407ba89c9$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
}
// Copied from React.PropTypes
function $aca50e9407ba89c9$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($aca50e9407ba89c9$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
}
// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $aca50e9407ba89c9$var$getPreciseType(propValue) {
    var propType = $aca50e9407ba89c9$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $aca50e9407ba89c9$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $4f362.untracked)(function() {
            if (allowNativeType) {
                if ($aca50e9407ba89c9$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $4f362.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $4f362.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $4f362.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $aca50e9407ba89c9$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $aca50e9407ba89c9$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $aca50e9407ba89c9$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $4f362.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $aca50e9407ba89c9$var$observableArray = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(false, "Array");
var $aca50e9407ba89c9$var$observableArrayOf = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableArrayOfTypeChecker.bind(null, false);
var $aca50e9407ba89c9$var$observableMap = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(false, "Map");
var $aca50e9407ba89c9$var$observableObject = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(false, "Object");
var $aca50e9407ba89c9$var$arrayOrObservableArray = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(true, "Array");
var $aca50e9407ba89c9$var$arrayOrObservableArrayOf = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableArrayOfTypeChecker.bind(null, true);
var $aca50e9407ba89c9$var$objectOrObservableObject = /*#__PURE__*/ $aca50e9407ba89c9$var$createObservableTypeCheckerCreator(true, "Object");
var $aca50e9407ba89c9$export$e0c95a451cd220b7 = {
    observableArray: $aca50e9407ba89c9$var$observableArray,
    observableArrayOf: $aca50e9407ba89c9$var$observableArrayOf,
    observableMap: $aca50e9407ba89c9$var$observableMap,
    observableObject: $aca50e9407ba89c9$var$observableObject,
    arrayOrObservableArray: $aca50e9407ba89c9$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $aca50e9407ba89c9$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $aca50e9407ba89c9$var$objectOrObservableObject
};
if (!(0, $acw62.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $4f362.observable)) throw new Error("mobx-react requires mobx to be available");

});
parcelRegister("iKNJK", function(module, exports) {

$parcel$export(module.exports, "useObserver", () => $da731a93076ee9dc$export$b9c7ecd090a87b14);
$parcel$export(module.exports, "useStaticRendering", () => $da731a93076ee9dc$export$7613124ee4202834);
$parcel$export(module.exports, "isUsingStaticRendering", () => (parcelRequire("5zkk0")).isUsingStaticRendering);
$parcel$export(module.exports, "enableStaticRendering", () => (parcelRequire("5zkk0")).enableStaticRendering);
$parcel$export(module.exports, "observer", () => (parcelRequire("3bVk6")).observer);
$parcel$export(module.exports, "Observer", () => (parcelRequire("ipOq8")).Observer);
$parcel$export(module.exports, "useLocalObservable", () => (parcelRequire("6aR1a")).useLocalObservable);
$parcel$export(module.exports, "useLocalStore", () => (parcelRequire("jkSCC")).useLocalStore);
$parcel$export(module.exports, "useAsObservableSource", () => (parcelRequire("7hEbR")).useAsObservableSource);
$parcel$export(module.exports, "_observerFinalizationRegistry", () => (parcelRequire("70wxd")).observerFinalizationRegistry);
$parcel$export(module.exports, "observerBatching", () => (parcelRequire("ddwuv")).observerBatching);
parcelRequire("kRJul");
parcelRequire("dxF9f");
var $1u0KT = parcelRequire("1u0KT");

var $ddwuv = parcelRequire("ddwuv");
parcelRequire("fBKuS");

var $5N4iJ = parcelRequire("5N4iJ");

var $5zkk0 = parcelRequire("5zkk0");

var $70wxd = parcelRequire("70wxd");

var $3bVk6 = parcelRequire("3bVk6");

var $ipOq8 = parcelRequire("ipOq8");

var $6aR1a = parcelRequire("6aR1a");

var $jkSCC = parcelRequire("jkSCC");

var $7hEbR = parcelRequire("7hEbR");
var $da731a93076ee9dc$var$_a;
(0, $ddwuv.observerBatching)((0, $1u0KT.unstable_batchedUpdates));
var $da731a93076ee9dc$export$469d51fb8d268227 = ($da731a93076ee9dc$var$_a = (0, $70wxd.observerFinalizationRegistry)["finalizeAllImmediately"]) !== null && $da731a93076ee9dc$var$_a !== void 0 ? $da731a93076ee9dc$var$_a : function() {};
function $da731a93076ee9dc$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $5N4iJ.useObserver)(fn, baseComponentName);
}
function $da731a93076ee9dc$export$7613124ee4202834(enable) {
    (0, $5zkk0.enableStaticRendering)(enable);
}

});
parcelRegister("kRJul", function(module, exports) {

var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");
if (!(0, $acw62.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $4f362.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");

});

parcelRegister("dxF9f", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("1u0KT")).unstable_batchedUpdates);

var $1u0KT = parcelRequire("1u0KT");

});

parcelRegister("ddwuv", function(module, exports) {

$parcel$export(module.exports, "observerBatching", () => $99f5b14b61d7fc1b$export$294943bbc3c74f4f);

var $4f362 = parcelRequire("4f362");
function $99f5b14b61d7fc1b$export$fb2daceae6f5097a(callback) {
    callback();
}
function $99f5b14b61d7fc1b$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $99f5b14b61d7fc1b$export$fb2daceae6f5097a;
    (0, $4f362.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $99f5b14b61d7fc1b$export$13ce1459b9a04b51 = function() {
    return true;
};

});

parcelRegister("fBKuS", function(module, exports) {
var $b5ce610bb01e19a7$var$deprecatedMessages = [];
function $b5ce610bb01e19a7$export$be38475be17599d(msg) {
    if (!$b5ce610bb01e19a7$var$deprecatedMessages.includes(msg)) {
        $b5ce610bb01e19a7$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}

});

parcelRegister("5N4iJ", function(module, exports) {

$parcel$export(module.exports, "useObserver", () => $4374dd72d08982f1$export$b9c7ecd090a87b14);

var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");

var $aMKeG = parcelRequire("aMKeG");

var $5zkk0 = parcelRequire("5zkk0");

var $70wxd = parcelRequire("70wxd");

var $hfliI = parcelRequire("hfliI");
function $4374dd72d08982f1$var$createReaction(adm) {
    adm.reaction = new (0, $4f362.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $4374dd72d08982f1$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $5zkk0.isUsingStaticRendering)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $70wxd.observerFinalizationRegistry).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $4374dd72d08982f1$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $4374dd72d08982f1$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $70wxd.observerFinalizationRegistry).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useDebugValue(adm.reaction, (0, $aMKeG.printDebugValue));
    (0, $hfliI.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}

});
parcelRegister("aMKeG", function(module, exports) {

$parcel$export(module.exports, "printDebugValue", () => $7da2408ee6acaa23$export$ef795f1f307682c7);

var $4f362 = parcelRequire("4f362");
function $7da2408ee6acaa23$export$ef795f1f307682c7(v) {
    return (0, $4f362.getDependencyTree)(v);
}

});

parcelRegister("5zkk0", function(module, exports) {

$parcel$export(module.exports, "enableStaticRendering", () => $40dffc1f1e2603e1$export$5d52eaa7c0f24c9e);
$parcel$export(module.exports, "isUsingStaticRendering", () => $40dffc1f1e2603e1$export$55979271896d643e);
var $40dffc1f1e2603e1$var$globalIsUsingStaticRendering = false;
function $40dffc1f1e2603e1$export$5d52eaa7c0f24c9e(enable) {
    $40dffc1f1e2603e1$var$globalIsUsingStaticRendering = enable;
}
function $40dffc1f1e2603e1$export$55979271896d643e() {
    return $40dffc1f1e2603e1$var$globalIsUsingStaticRendering;
}

});

parcelRegister("70wxd", function(module, exports) {

$parcel$export(module.exports, "observerFinalizationRegistry", () => $51a1c53254be4238$export$10e8a12fbfd8583c);

var $81Uec = parcelRequire("81Uec");
var $51a1c53254be4238$export$10e8a12fbfd8583c = new (0, $81Uec.UniversalFinalizationRegistry)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});

});
parcelRegister("81Uec", function(module, exports) {

$parcel$export(module.exports, "UniversalFinalizationRegistry", () => $5d8a086ace365ebf$export$da5d55a244964b51);
var $5d8a086ace365ebf$export$e901ba0ffe10ba41 = 10000;
var $5d8a086ace365ebf$export$1ae22ce5a82f26b6 = 10000;
var $5d8a086ace365ebf$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $5d8a086ace365ebf$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $5d8a086ace365ebf$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $5d8a086ace365ebf$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $5d8a086ace365ebf$export$b7a00d372cedeedd;

});


parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkKGc"));

});
parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});



parcelRegister("3bVk6", function(module, exports) {

$parcel$export(module.exports, "observer", () => $252edd5f5fc562a7$export$b6ae1bc530f4c149);

var $acw62 = parcelRequire("acw62");

var $5zkk0 = parcelRequire("5zkk0");

var $5N4iJ = parcelRequire("5N4iJ");
var $252edd5f5fc562a7$var$_a, $252edd5f5fc562a7$var$_b;
var $252edd5f5fc562a7$var$warnObserverOptionsDeprecated = true;
var $252edd5f5fc562a7$var$warnLegacyContextTypes = true;
var $252edd5f5fc562a7$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $252edd5f5fc562a7$var$isFunctionNameConfigurable = ($252edd5f5fc562a7$var$_b = ($252edd5f5fc562a7$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $252edd5f5fc562a7$var$_a === void 0 ? void 0 : $252edd5f5fc562a7$var$_a.configurable) !== null && $252edd5f5fc562a7$var$_b !== void 0 ? $252edd5f5fc562a7$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $252edd5f5fc562a7$var$ReactForwardRefSymbol = $252edd5f5fc562a7$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $acw62.forwardRef) === "function" && (0, $acw62.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $252edd5f5fc562a7$var$ReactMemoSymbol = $252edd5f5fc562a7$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $acw62.memo) === "function" && (0, $acw62.memo)(function(props) {
    return null;
})["$$typeof"];
function $252edd5f5fc562a7$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($252edd5f5fc562a7$var$ReactMemoSymbol && baseComponent["$$typeof"] === $252edd5f5fc562a7$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $5zkk0.isUsingStaticRendering)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($252edd5f5fc562a7$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $252edd5f5fc562a7$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $5N4iJ.useObserver)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($252edd5f5fc562a7$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $acw62.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $acw62.memo)(observerComponent);
    $252edd5f5fc562a7$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $252edd5f5fc562a7$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $252edd5f5fc562a7$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$252edd5f5fc562a7$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}

});

parcelRegister("ipOq8", function(module, exports) {

$parcel$export(module.exports, "Observer", () => $d681ac3da181f0df$export$c1cbdee04e18ea8b);

var $5N4iJ = parcelRequire("5N4iJ");
function $d681ac3da181f0df$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $5N4iJ.useObserver)(component);
}
$d681ac3da181f0df$export$c1cbdee04e18ea8b.displayName = "Observer";
function $d681ac3da181f0df$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}

});

parcelRegister("6aR1a", function(module, exports) {

$parcel$export(module.exports, "useLocalObservable", () => $47eccd77986d48be$export$aa207039f277c5f);

var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");
function $47eccd77986d48be$export$aa207039f277c5f(initializer, annotations) {
    return (0, $acw62.useState)(function() {
        return (0, $4f362.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}

});

parcelRegister("jkSCC", function(module, exports) {

$parcel$export(module.exports, "useLocalStore", () => $e13a4158639bc20c$export$f5b97ae82d1eeaf3);

var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");
parcelRequire("fBKuS");

var $7hEbR = parcelRequire("7hEbR");
function $e13a4158639bc20c$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $7hEbR.useAsObservableSource)(current);
    return (0, $acw62.useState)(function() {
        return (0, $4f362.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}

});
parcelRegister("7hEbR", function(module, exports) {

$parcel$export(module.exports, "useAsObservableSource", () => $54d94be3a43cbdf6$export$e0ded3646391939c);
parcelRequire("fBKuS");

var $4f362 = parcelRequire("4f362");

var $acw62 = parcelRequire("acw62");
function $54d94be3a43cbdf6$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $acw62.useState)(function() {
        return (0, $4f362.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $4f362.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}

});




parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


var $21e9d612693fb6b8$exports = {};
/*! For license information please see redoc.browser.lib.js.LICENSE.txt */ 
var $hPtJY = parcelRequire("hPtJY");
















































!function(e, t) {
    $21e9d612693fb6b8$exports = t();
}($21e9d612693fb6b8$exports, function() {
    return function() {
        var e = {
            303: function(e, t, r) {
                var n = r(224), o = [
                    "add",
                    "done",
                    "toJS",
                    "fromExternalJS",
                    "load",
                    "dispose",
                    "search",
                    "Worker"
                ];
                e.exports = function() {
                    var e = new Worker(URL.createObjectURL(new Blob([
                        '/*! For license information please see d87bcbdbea8f8f5aa26f.worker.js.LICENSE.txt */\n!function(){var e={291:function(e,t,r){var n,i;!function(){var s,o,a,u,l,c,h,d,f,p,y,m,g,x,v,w,Q,k,S,E,L,P,b,T,O,I,R,F,C,N,j=function(e){var t=new j.Builder;return t.pipeline.add(j.trimmer,j.stopWordFilter,j.stemmer),t.searchPipeline.add(j.stemmer),e.call(t,t),t.build()};j.version="2.3.9",j.utils={},j.utils.warn=(s=this,function(e){s.console&&console.warn&&console.warn(e)}),j.utils.asString=function(e){return null==e?"":e.toString()},j.utils.clone=function(e){if(null==e)return e;for(var t=Object.create(null),r=Object.keys(e),n=0;n<r.length;n++){var i=r[n],s=e[i];if(Array.isArray(s))t[i]=s.slice();else{if("string"!=typeof s&&"number"!=typeof s&&"boolean"!=typeof s)throw new TypeError("clone is not deep and does not support nested objects");t[i]=s}}return t},j.FieldRef=function(e,t,r){this.docRef=e,this.fieldName=t,this._stringValue=r},j.FieldRef.joiner="/",j.FieldRef.fromString=function(e){var t=e.indexOf(j.FieldRef.joiner);if(-1===t)throw"malformed field ref string";var r=e.slice(0,t),n=e.slice(t+1);return new j.FieldRef(n,r,e)},j.FieldRef.prototype.toString=function(){return null==this._stringValue&&(this._stringValue=this.fieldName+j.FieldRef.joiner+this.docRef),this._stringValue},j.Set=function(e){if(this.elements=Object.create(null),e){this.length=e.length;for(var t=0;t<this.length;t++)this.elements[e[t]]=!0}else this.length=0},j.Set.complete={intersect:function(e){return e},union:function(){return this},contains:function(){return!0}},j.Set.empty={intersect:function(){return this},union:function(e){return e},contains:function(){return!1}},j.Set.prototype.contains=function(e){return!!this.elements[e]},j.Set.prototype.intersect=function(e){var t,r,n,i=[];if(e===j.Set.complete)return this;if(e===j.Set.empty)return e;this.length<e.length?(t=this,r=e):(t=e,r=this),n=Object.keys(t.elements);for(var s=0;s<n.length;s++){var o=n[s];o in r.elements&&i.push(o)}return new j.Set(i)},j.Set.prototype.union=function(e){return e===j.Set.complete?j.Set.complete:e===j.Set.empty?this:new j.Set(Object.keys(this.elements).concat(Object.keys(e.elements)))},j.idf=function(e,t){var r=0;for(var n in e)"_index"!=n&&(r+=Object.keys(e[n]).length);var i=(t-r+.5)/(r+.5);return Math.log(1+Math.abs(i))},j.Token=function(e,t){this.str=e||"",this.metadata=t||{}},j.Token.prototype.toString=function(){return this.str},j.Token.prototype.update=function(e){return this.str=e(this.str,this.metadata),this},j.Token.prototype.clone=function(e){return e=e||function(e){return e},new j.Token(e(this.str,this.metadata),this.metadata)},j.tokenizer=function(e,t){if(null==e||null==e)return[];if(Array.isArray(e))return e.map(function(e){return new j.Token(j.utils.asString(e).toLowerCase(),j.utils.clone(t))});for(var r=e.toString().toLowerCase(),n=r.length,i=[],s=0,o=0;s<=n;s++){var a=s-o;if(r.charAt(s).match(j.tokenizer.separator)||s==n){if(a>0){var u=j.utils.clone(t)||{};u.position=[o,a],u.index=i.length,i.push(new j.Token(r.slice(o,s),u))}o=s+1}}return i},j.tokenizer.separator=/[\\s\\-]+/,j.Pipeline=function(){this._stack=[]},j.Pipeline.registeredFunctions=Object.create(null),j.Pipeline.registerFunction=function(e,t){t in this.registeredFunctions&&j.utils.warn("Overwriting existing registered function: "+t),e.label=t,j.Pipeline.registeredFunctions[e.label]=e},j.Pipeline.warnIfFunctionNotRegistered=function(e){e.label&&e.label in this.registeredFunctions||j.utils.warn("Function is not registered with pipeline. This may cause problems when serialising the index.\\n",e)},j.Pipeline.load=function(e){var t=new j.Pipeline;return e.forEach(function(e){var r=j.Pipeline.registeredFunctions[e];if(!r)throw new Error("Cannot load unregistered function: "+e);t.add(r)}),t},j.Pipeline.prototype.add=function(){Array.prototype.slice.call(arguments).forEach(function(e){j.Pipeline.warnIfFunctionNotRegistered(e),this._stack.push(e)},this)},j.Pipeline.prototype.after=function(e,t){j.Pipeline.warnIfFunctionNotRegistered(t);var r=this._stack.indexOf(e);if(-1==r)throw new Error("Cannot find existingFn");r+=1,this._stack.splice(r,0,t)},j.Pipeline.prototype.before=function(e,t){j.Pipeline.warnIfFunctionNotRegistered(t);var r=this._stack.indexOf(e);if(-1==r)throw new Error("Cannot find existingFn");this._stack.splice(r,0,t)},j.Pipeline.prototype.remove=function(e){var t=this._stack.indexOf(e);-1!=t&&this._stack.splice(t,1)},j.Pipeline.prototype.run=function(e){for(var t=this._stack.length,r=0;r<t;r++){for(var n=this._stack[r],i=[],s=0;s<e.length;s++){var o=n(e[s],s,e);if(null!=o&&""!==o)if(Array.isArray(o))for(var a=0;a<o.length;a++)i.push(o[a]);else i.push(o)}e=i}return e},j.Pipeline.prototype.runString=function(e,t){var r=new j.Token(e,t);return this.run([r]).map(function(e){return e.toString()})},j.Pipeline.prototype.reset=function(){this._stack=[]},j.Pipeline.prototype.toJSON=function(){return this._stack.map(function(e){return j.Pipeline.warnIfFunctionNotRegistered(e),e.label})},j.Vector=function(e){this._magnitude=0,this.elements=e||[]},j.Vector.prototype.positionForIndex=function(e){if(0==this.elements.length)return 0;for(var t=0,r=this.elements.length/2,n=r-t,i=Math.floor(n/2),s=this.elements[2*i];n>1&&(s<e&&(t=i),s>e&&(r=i),s!=e);)n=r-t,i=t+Math.floor(n/2),s=this.elements[2*i];return s==e||s>e?2*i:s<e?2*(i+1):void 0},j.Vector.prototype.insert=function(e,t){this.upsert(e,t,function(){throw"duplicate index"})},j.Vector.prototype.upsert=function(e,t,r){this._magnitude=0;var n=this.positionForIndex(e);this.elements[n]==e?this.elements[n+1]=r(this.elements[n+1],t):this.elements.splice(n,0,e,t)},j.Vector.prototype.magnitude=function(){if(this._magnitude)return this._magnitude;for(var e=0,t=this.elements.length,r=1;r<t;r+=2){var n=this.elements[r];e+=n*n}return this._magnitude=Math.sqrt(e)},j.Vector.prototype.dot=function(e){for(var t=0,r=this.elements,n=e.elements,i=r.length,s=n.length,o=0,a=0,u=0,l=0;u<i&&l<s;)(o=r[u])<(a=n[l])?u+=2:o>a?l+=2:o==a&&(t+=r[u+1]*n[l+1],u+=2,l+=2);return t},j.Vector.prototype.similarity=function(e){return this.dot(e)/this.magnitude()||0},j.Vector.prototype.toArray=function(){for(var e=new Array(this.elements.length/2),t=1,r=0;t<this.elements.length;t+=2,r++)e[r]=this.elements[t];return e},j.Vector.prototype.toJSON=function(){return this.elements},j.stemmer=(o={ational:"ate",tional:"tion",enci:"ence",anci:"ance",izer:"ize",bli:"ble",alli:"al",entli:"ent",eli:"e",ousli:"ous",ization:"ize",ation:"ate",ator:"ate",alism:"al",iveness:"ive",fulness:"ful",ousness:"ous",aliti:"al",iviti:"ive",biliti:"ble",logi:"log"},a={icate:"ic",ative:"",alize:"al",iciti:"ic",ical:"ic",ful:"",ness:""},h="^("+(l="[^aeiou][^aeiouy]*")+")?"+(c=(u="[aeiouy]")+"[aeiou]*")+l+"("+c+")?$",d="^("+l+")?"+c+l+c+l,f="^("+l+")?"+u,p=new RegExp("^("+l+")?"+c+l),y=new RegExp(d),m=new RegExp(h),g=new RegExp(f),x=/^(.+?)(ss|i)es$/,v=/^(.+?)([^s])s$/,w=/^(.+?)eed$/,Q=/^(.+?)(ed|ing)$/,k=/.$/,S=/(at|bl|iz)$/,E=new RegExp("([^aeiouylsz])\\\\1$"),L=new RegExp("^"+l+u+"[^aeiouwxy]$"),P=/^(.+?[^aeiou])y$/,b=/^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/,T=/^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/,O=/^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/,I=/^(.+?)(s|t)(ion)$/,R=/^(.+?)e$/,F=/ll$/,C=new RegExp("^"+l+u+"[^aeiouwxy]$"),N=function(e){var t,r,n,i,s,u,l;if(e.length<3)return e;if("y"==(n=e.substr(0,1))&&(e=n.toUpperCase()+e.substr(1)),s=v,(i=x).test(e)?e=e.replace(i,"$1$2"):s.test(e)&&(e=e.replace(s,"$1$2")),s=Q,(i=w).test(e)){var c=i.exec(e);(i=p).test(c[1])&&(i=k,e=e.replace(i,""))}else s.test(e)&&(t=(c=s.exec(e))[1],(s=g).test(t)&&(u=E,l=L,(s=S).test(e=t)?e+="e":u.test(e)?(i=k,e=e.replace(i,"")):l.test(e)&&(e+="e")));return(i=P).test(e)&&(e=(t=(c=i.exec(e))[1])+"i"),(i=b).test(e)&&(t=(c=i.exec(e))[1],r=c[2],(i=p).test(t)&&(e=t+o[r])),(i=T).test(e)&&(t=(c=i.exec(e))[1],r=c[2],(i=p).test(t)&&(e=t+a[r])),s=I,(i=O).test(e)?(t=(c=i.exec(e))[1],(i=y).test(t)&&(e=t)):s.test(e)&&(t=(c=s.exec(e))[1]+c[2],(s=y).test(t)&&(e=t)),(i=R).test(e)&&(t=(c=i.exec(e))[1],s=m,u=C,((i=y).test(t)||s.test(t)&&!u.test(t))&&(e=t)),s=y,(i=F).test(e)&&s.test(e)&&(i=k,e=e.replace(i,"")),"y"==n&&(e=n.toLowerCase()+e.substr(1)),e},function(e){return e.update(N)}),j.Pipeline.registerFunction(j.stemmer,"stemmer"),j.generateStopWordFilter=function(e){var t=e.reduce(function(e,t){return e[t]=t,e},{});return function(e){if(e&&t[e.toString()]!==e.toString())return e}},j.stopWordFilter=j.generateStopWordFilter(["a","able","about","across","after","all","almost","also","am","among","an","and","any","are","as","at","be","because","been","but","by","can","cannot","could","dear","did","do","does","either","else","ever","every","for","from","get","got","had","has","have","he","her","hers","him","his","how","however","i","if","in","into","is","it","its","just","least","let","like","likely","may","me","might","most","must","my","neither","no","nor","not","of","off","often","on","only","or","other","our","own","rather","said","say","says","she","should","since","so","some","than","that","the","their","them","then","there","these","they","this","tis","to","too","twas","us","wants","was","we","were","what","when","where","which","while","who","whom","why","will","with","would","yet","you","your"]),j.Pipeline.registerFunction(j.stopWordFilter,"stopWordFilter"),j.trimmer=function(e){return e.update(function(e){return e.replace(/^\\W+/,"").replace(/\\W+$/,"")})},j.Pipeline.registerFunction(j.trimmer,"trimmer"),j.TokenSet=function(){this.final=!1,this.edges={},this.id=j.TokenSet._nextId,j.TokenSet._nextId+=1},j.TokenSet._nextId=1,j.TokenSet.fromArray=function(e){for(var t=new j.TokenSet.Builder,r=0,n=e.length;r<n;r++)t.insert(e[r]);return t.finish(),t.root},j.TokenSet.fromClause=function(e){return"editDistance"in e?j.TokenSet.fromFuzzyString(e.term,e.editDistance):j.TokenSet.fromString(e.term)},j.TokenSet.fromFuzzyString=function(e,t){for(var r=new j.TokenSet,n=[{node:r,editsRemaining:t,str:e}];n.length;){var i=n.pop();if(i.str.length>0){var s,o=i.str.charAt(0);o in i.node.edges?s=i.node.edges[o]:(s=new j.TokenSet,i.node.edges[o]=s),1==i.str.length&&(s.final=!0),n.push({node:s,editsRemaining:i.editsRemaining,str:i.str.slice(1)})}if(0!=i.editsRemaining){if("*"in i.node.edges)var a=i.node.edges["*"];else a=new j.TokenSet,i.node.edges["*"]=a;if(0==i.str.length&&(a.final=!0),n.push({node:a,editsRemaining:i.editsRemaining-1,str:i.str}),i.str.length>1&&n.push({node:i.node,editsRemaining:i.editsRemaining-1,str:i.str.slice(1)}),1==i.str.length&&(i.node.final=!0),i.str.length>=1){if("*"in i.node.edges)var u=i.node.edges["*"];else u=new j.TokenSet,i.node.edges["*"]=u;1==i.str.length&&(u.final=!0),n.push({node:u,editsRemaining:i.editsRemaining-1,str:i.str.slice(1)})}if(i.str.length>1){var l,c=i.str.charAt(0),h=i.str.charAt(1);h in i.node.edges?l=i.node.edges[h]:(l=new j.TokenSet,i.node.edges[h]=l),1==i.str.length&&(l.final=!0),n.push({node:l,editsRemaining:i.editsRemaining-1,str:c+i.str.slice(2)})}}}return r},j.TokenSet.fromString=function(e){for(var t=new j.TokenSet,r=t,n=0,i=e.length;n<i;n++){var s=e[n],o=n==i-1;if("*"==s)t.edges[s]=t,t.final=o;else{var a=new j.TokenSet;a.final=o,t.edges[s]=a,t=a}}return r},j.TokenSet.prototype.toArray=function(){for(var e=[],t=[{prefix:"",node:this}];t.length;){var r=t.pop(),n=Object.keys(r.node.edges),i=n.length;r.node.final&&(r.prefix.charAt(0),e.push(r.prefix));for(var s=0;s<i;s++){var o=n[s];t.push({prefix:r.prefix.concat(o),node:r.node.edges[o]})}}return e},j.TokenSet.prototype.toString=function(){if(this._str)return this._str;for(var e=this.final?"1":"0",t=Object.keys(this.edges).sort(),r=t.length,n=0;n<r;n++){var i=t[n];e=e+i+this.edges[i].id}return e},j.TokenSet.prototype.intersect=function(e){for(var t=new j.TokenSet,r=void 0,n=[{qNode:e,output:t,node:this}];n.length;){r=n.pop();for(var i=Object.keys(r.qNode.edges),s=i.length,o=Object.keys(r.node.edges),a=o.length,u=0;u<s;u++)for(var l=i[u],c=0;c<a;c++){var h=o[c];if(h==l||"*"==l){var d=r.node.edges[h],f=r.qNode.edges[l],p=d.final&&f.final,y=void 0;h in r.output.edges?(y=r.output.edges[h]).final=y.final||p:((y=new j.TokenSet).final=p,r.output.edges[h]=y),n.push({qNode:f,output:y,node:d})}}}return t},j.TokenSet.Builder=function(){this.previousWord="",this.root=new j.TokenSet,this.uncheckedNodes=[],this.minimizedNodes={}},j.TokenSet.Builder.prototype.insert=function(e){var t,r=0;if(e<this.previousWord)throw new Error("Out of order word insertion");for(var n=0;n<e.length&&n<this.previousWord.length&&e[n]==this.previousWord[n];n++)r++;for(this.minimize(r),t=0==this.uncheckedNodes.length?this.root:this.uncheckedNodes[this.uncheckedNodes.length-1].child,n=r;n<e.length;n++){var i=new j.TokenSet,s=e[n];t.edges[s]=i,this.uncheckedNodes.push({parent:t,char:s,child:i}),t=i}t.final=!0,this.previousWord=e},j.TokenSet.Builder.prototype.finish=function(){this.minimize(0)},j.TokenSet.Builder.prototype.minimize=function(e){for(var t=this.uncheckedNodes.length-1;t>=e;t--){var r=this.uncheckedNodes[t],n=r.child.toString();n in this.minimizedNodes?r.parent.edges[r.char]=this.minimizedNodes[n]:(r.child._str=n,this.minimizedNodes[n]=r.child),this.uncheckedNodes.pop()}},j.Index=function(e){this.invertedIndex=e.invertedIndex,this.fieldVectors=e.fieldVectors,this.tokenSet=e.tokenSet,this.fields=e.fields,this.pipeline=e.pipeline},j.Index.prototype.search=function(e){return this.query(function(t){new j.QueryParser(e,t).parse()})},j.Index.prototype.query=function(e){for(var t=new j.Query(this.fields),r=Object.create(null),n=Object.create(null),i=Object.create(null),s=Object.create(null),o=Object.create(null),a=0;a<this.fields.length;a++)n[this.fields[a]]=new j.Vector;for(e.call(t,t),a=0;a<t.clauses.length;a++){var u,l=t.clauses[a],c=j.Set.empty;u=l.usePipeline?this.pipeline.runString(l.term,{fields:l.fields}):[l.term];for(var h=0;h<u.length;h++){var d=u[h];l.term=d;var f=j.TokenSet.fromClause(l),p=this.tokenSet.intersect(f).toArray();if(0===p.length&&l.presence===j.Query.presence.REQUIRED){for(var y=0;y<l.fields.length;y++)s[R=l.fields[y]]=j.Set.empty;break}for(var m=0;m<p.length;m++){var g=p[m],x=this.invertedIndex[g],v=x._index;for(y=0;y<l.fields.length;y++){var w=x[R=l.fields[y]],Q=Object.keys(w),k=g+"/"+R,S=new j.Set(Q);if(l.presence==j.Query.presence.REQUIRED&&(c=c.union(S),void 0===s[R]&&(s[R]=j.Set.complete)),l.presence!=j.Query.presence.PROHIBITED){if(n[R].upsert(v,l.boost,function(e,t){return e+t}),!i[k]){for(var E=0;E<Q.length;E++){var L,P=Q[E],b=new j.FieldRef(P,R),T=w[P];void 0===(L=r[b])?r[b]=new j.MatchData(g,R,T):L.add(g,R,T)}i[k]=!0}}else void 0===o[R]&&(o[R]=j.Set.empty),o[R]=o[R].union(S)}}}if(l.presence===j.Query.presence.REQUIRED)for(y=0;y<l.fields.length;y++)s[R=l.fields[y]]=s[R].intersect(c)}var O=j.Set.complete,I=j.Set.empty;for(a=0;a<this.fields.length;a++){var R;s[R=this.fields[a]]&&(O=O.intersect(s[R])),o[R]&&(I=I.union(o[R]))}var F=Object.keys(r),C=[],N=Object.create(null);if(t.isNegated())for(F=Object.keys(this.fieldVectors),a=0;a<F.length;a++){b=F[a];var _=j.FieldRef.fromString(b);r[b]=new j.MatchData}for(a=0;a<F.length;a++){var D=(_=j.FieldRef.fromString(F[a])).docRef;if(O.contains(D)&&!I.contains(D)){var A,B=this.fieldVectors[_],z=n[_.fieldName].similarity(B);if(void 0!==(A=N[D]))A.score+=z,A.matchData.combine(r[_]);else{var V={ref:D,score:z,matchData:r[_]};N[D]=V,C.push(V)}}}return C.sort(function(e,t){return t.score-e.score})},j.Index.prototype.toJSON=function(){var e=Object.keys(this.invertedIndex).sort().map(function(e){return[e,this.invertedIndex[e]]},this),t=Object.keys(this.fieldVectors).map(function(e){return[e,this.fieldVectors[e].toJSON()]},this);return{version:j.version,fields:this.fields,fieldVectors:t,invertedIndex:e,pipeline:this.pipeline.toJSON()}},j.Index.load=function(e){var t={},r={},n=e.fieldVectors,i=Object.create(null),s=e.invertedIndex,o=new j.TokenSet.Builder,a=j.Pipeline.load(e.pipeline);e.version!=j.version&&j.utils.warn("Version mismatch when loading serialised index. Current version of lunr \'"+j.version+"\' does not match serialized index \'"+e.version+"\'");for(var u=0;u<n.length;u++){var l=(h=n[u])[0],c=h[1];r[l]=new j.Vector(c)}for(u=0;u<s.length;u++){var h,d=(h=s[u])[0],f=h[1];o.insert(d),i[d]=f}return o.finish(),t.fields=e.fields,t.fieldVectors=r,t.invertedIndex=i,t.tokenSet=o.root,t.pipeline=a,new j.Index(t)},j.Builder=function(){this._ref="id",this._fields=Object.create(null),this._documents=Object.create(null),this.invertedIndex=Object.create(null),this.fieldTermFrequencies={},this.fieldLengths={},this.tokenizer=j.tokenizer,this.pipeline=new j.Pipeline,this.searchPipeline=new j.Pipeline,this.documentCount=0,this._b=.75,this._k1=1.2,this.termIndex=0,this.metadataWhitelist=[]},j.Builder.prototype.ref=function(e){this._ref=e},j.Builder.prototype.field=function(e,t){if(/\\//.test(e))throw new RangeError("Field \'"+e+"\' contains illegal character \'/\'");this._fields[e]=t||{}},j.Builder.prototype.b=function(e){this._b=e<0?0:e>1?1:e},j.Builder.prototype.k1=function(e){this._k1=e},j.Builder.prototype.add=function(e,t){var r=e[this._ref],n=Object.keys(this._fields);this._documents[r]=t||{},this.documentCount+=1;for(var i=0;i<n.length;i++){var s=n[i],o=this._fields[s].extractor,a=o?o(e):e[s],u=this.tokenizer(a,{fields:[s]}),l=this.pipeline.run(u),c=new j.FieldRef(r,s),h=Object.create(null);this.fieldTermFrequencies[c]=h,this.fieldLengths[c]=0,this.fieldLengths[c]+=l.length;for(var d=0;d<l.length;d++){var f=l[d];if(null==h[f]&&(h[f]=0),h[f]+=1,null==this.invertedIndex[f]){var p=Object.create(null);p._index=this.termIndex,this.termIndex+=1;for(var y=0;y<n.length;y++)p[n[y]]=Object.create(null);this.invertedIndex[f]=p}null==this.invertedIndex[f][s][r]&&(this.invertedIndex[f][s][r]=Object.create(null));for(var m=0;m<this.metadataWhitelist.length;m++){var g=this.metadataWhitelist[m],x=f.metadata[g];null==this.invertedIndex[f][s][r][g]&&(this.invertedIndex[f][s][r][g]=[]),this.invertedIndex[f][s][r][g].push(x)}}}},j.Builder.prototype.calculateAverageFieldLengths=function(){for(var e=Object.keys(this.fieldLengths),t=e.length,r={},n={},i=0;i<t;i++){var s=j.FieldRef.fromString(e[i]),o=s.fieldName;n[o]||(n[o]=0),n[o]+=1,r[o]||(r[o]=0),r[o]+=this.fieldLengths[s]}var a=Object.keys(this._fields);for(i=0;i<a.length;i++){var u=a[i];r[u]=r[u]/n[u]}this.averageFieldLength=r},j.Builder.prototype.createFieldVectors=function(){for(var e={},t=Object.keys(this.fieldTermFrequencies),r=t.length,n=Object.create(null),i=0;i<r;i++){for(var s=j.FieldRef.fromString(t[i]),o=s.fieldName,a=this.fieldLengths[s],u=new j.Vector,l=this.fieldTermFrequencies[s],c=Object.keys(l),h=c.length,d=this._fields[o].boost||1,f=this._documents[s.docRef].boost||1,p=0;p<h;p++){var y,m,g,x=c[p],v=l[x],w=this.invertedIndex[x]._index;void 0===n[x]?(y=j.idf(this.invertedIndex[x],this.documentCount),n[x]=y):y=n[x],m=y*((this._k1+1)*v)/(this._k1*(1-this._b+this._b*(a/this.averageFieldLength[o]))+v),m*=d,m*=f,g=Math.round(1e3*m)/1e3,u.insert(w,g)}e[s]=u}this.fieldVectors=e},j.Builder.prototype.createTokenSet=function(){this.tokenSet=j.TokenSet.fromArray(Object.keys(this.invertedIndex).sort())},j.Builder.prototype.build=function(){return this.calculateAverageFieldLengths(),this.createFieldVectors(),this.createTokenSet(),new j.Index({invertedIndex:this.invertedIndex,fieldVectors:this.fieldVectors,tokenSet:this.tokenSet,fields:Object.keys(this._fields),pipeline:this.searchPipeline})},j.Builder.prototype.use=function(e){var t=Array.prototype.slice.call(arguments,1);t.unshift(this),e.apply(this,t)},j.MatchData=function(e,t,r){for(var n=Object.create(null),i=Object.keys(r||{}),s=0;s<i.length;s++){var o=i[s];n[o]=r[o].slice()}this.metadata=Object.create(null),void 0!==e&&(this.metadata[e]=Object.create(null),this.metadata[e][t]=n)},j.MatchData.prototype.combine=function(e){for(var t=Object.keys(e.metadata),r=0;r<t.length;r++){var n=t[r],i=Object.keys(e.metadata[n]);null==this.metadata[n]&&(this.metadata[n]=Object.create(null));for(var s=0;s<i.length;s++){var o=i[s],a=Object.keys(e.metadata[n][o]);null==this.metadata[n][o]&&(this.metadata[n][o]=Object.create(null));for(var u=0;u<a.length;u++){var l=a[u];null==this.metadata[n][o][l]?this.metadata[n][o][l]=e.metadata[n][o][l]:this.metadata[n][o][l]=this.metadata[n][o][l].concat(e.metadata[n][o][l])}}}},j.MatchData.prototype.add=function(e,t,r){if(!(e in this.metadata))return this.metadata[e]=Object.create(null),void(this.metadata[e][t]=r);if(t in this.metadata[e])for(var n=Object.keys(r),i=0;i<n.length;i++){var s=n[i];s in this.metadata[e][t]?this.metadata[e][t][s]=this.metadata[e][t][s].concat(r[s]):this.metadata[e][t][s]=r[s]}else this.metadata[e][t]=r},j.Query=function(e){this.clauses=[],this.allFields=e},j.Query.wildcard=new String("*"),j.Query.wildcard.NONE=0,j.Query.wildcard.LEADING=1,j.Query.wildcard.TRAILING=2,j.Query.presence={OPTIONAL:1,REQUIRED:2,PROHIBITED:3},j.Query.prototype.clause=function(e){return"fields"in e||(e.fields=this.allFields),"boost"in e||(e.boost=1),"usePipeline"in e||(e.usePipeline=!0),"wildcard"in e||(e.wildcard=j.Query.wildcard.NONE),e.wildcard&j.Query.wildcard.LEADING&&e.term.charAt(0)!=j.Query.wildcard&&(e.term="*"+e.term),e.wildcard&j.Query.wildcard.TRAILING&&e.term.slice(-1)!=j.Query.wildcard&&(e.term=e.term+"*"),"presence"in e||(e.presence=j.Query.presence.OPTIONAL),this.clauses.push(e),this},j.Query.prototype.isNegated=function(){for(var e=0;e<this.clauses.length;e++)if(this.clauses[e].presence!=j.Query.presence.PROHIBITED)return!1;return!0},j.Query.prototype.term=function(e,t){if(Array.isArray(e))return e.forEach(function(e){this.term(e,j.utils.clone(t))},this),this;var r=t||{};return r.term=e.toString(),this.clause(r),this},j.QueryParseError=function(e,t,r){this.name="QueryParseError",this.message=e,this.start=t,this.end=r},j.QueryParseError.prototype=new Error,j.QueryLexer=function(e){this.lexemes=[],this.str=e,this.length=e.length,this.pos=0,this.start=0,this.escapeCharPositions=[]},j.QueryLexer.prototype.run=function(){for(var e=j.QueryLexer.lexText;e;)e=e(this)},j.QueryLexer.prototype.sliceString=function(){for(var e=[],t=this.start,r=this.pos,n=0;n<this.escapeCharPositions.length;n++)r=this.escapeCharPositions[n],e.push(this.str.slice(t,r)),t=r+1;return e.push(this.str.slice(t,this.pos)),this.escapeCharPositions.length=0,e.join("")},j.QueryLexer.prototype.emit=function(e){this.lexemes.push({type:e,str:this.sliceString(),start:this.start,end:this.pos}),this.start=this.pos},j.QueryLexer.prototype.escapeCharacter=function(){this.escapeCharPositions.push(this.pos-1),this.pos+=1},j.QueryLexer.prototype.next=function(){if(this.pos>=this.length)return j.QueryLexer.EOS;var e=this.str.charAt(this.pos);return this.pos+=1,e},j.QueryLexer.prototype.width=function(){return this.pos-this.start},j.QueryLexer.prototype.ignore=function(){this.start==this.pos&&(this.pos+=1),this.start=this.pos},j.QueryLexer.prototype.backup=function(){this.pos-=1},j.QueryLexer.prototype.acceptDigitRun=function(){var e,t;do{t=(e=this.next()).charCodeAt(0)}while(t>47&&t<58);e!=j.QueryLexer.EOS&&this.backup()},j.QueryLexer.prototype.more=function(){return this.pos<this.length},j.QueryLexer.EOS="EOS",j.QueryLexer.FIELD="FIELD",j.QueryLexer.TERM="TERM",j.QueryLexer.EDIT_DISTANCE="EDIT_DISTANCE",j.QueryLexer.BOOST="BOOST",j.QueryLexer.PRESENCE="PRESENCE",j.QueryLexer.lexField=function(e){return e.backup(),e.emit(j.QueryLexer.FIELD),e.ignore(),j.QueryLexer.lexText},j.QueryLexer.lexTerm=function(e){if(e.width()>1&&(e.backup(),e.emit(j.QueryLexer.TERM)),e.ignore(),e.more())return j.QueryLexer.lexText},j.QueryLexer.lexEditDistance=function(e){return e.ignore(),e.acceptDigitRun(),e.emit(j.QueryLexer.EDIT_DISTANCE),j.QueryLexer.lexText},j.QueryLexer.lexBoost=function(e){return e.ignore(),e.acceptDigitRun(),e.emit(j.QueryLexer.BOOST),j.QueryLexer.lexText},j.QueryLexer.lexEOS=function(e){e.width()>0&&e.emit(j.QueryLexer.TERM)},j.QueryLexer.termSeparator=j.tokenizer.separator,j.QueryLexer.lexText=function(e){for(;;){var t=e.next();if(t==j.QueryLexer.EOS)return j.QueryLexer.lexEOS;if(92!=t.charCodeAt(0)){if(":"==t)return j.QueryLexer.lexField;if("~"==t)return e.backup(),e.width()>0&&e.emit(j.QueryLexer.TERM),j.QueryLexer.lexEditDistance;if("^"==t)return e.backup(),e.width()>0&&e.emit(j.QueryLexer.TERM),j.QueryLexer.lexBoost;if("+"==t&&1===e.width())return e.emit(j.QueryLexer.PRESENCE),j.QueryLexer.lexText;if("-"==t&&1===e.width())return e.emit(j.QueryLexer.PRESENCE),j.QueryLexer.lexText;if(t.match(j.QueryLexer.termSeparator))return j.QueryLexer.lexTerm}else e.escapeCharacter()}},j.QueryParser=function(e,t){this.lexer=new j.QueryLexer(e),this.query=t,this.currentClause={},this.lexemeIdx=0},j.QueryParser.prototype.parse=function(){this.lexer.run(),this.lexemes=this.lexer.lexemes;for(var e=j.QueryParser.parseClause;e;)e=e(this);return this.query},j.QueryParser.prototype.peekLexeme=function(){return this.lexemes[this.lexemeIdx]},j.QueryParser.prototype.consumeLexeme=function(){var e=this.peekLexeme();return this.lexemeIdx+=1,e},j.QueryParser.prototype.nextClause=function(){var e=this.currentClause;this.query.clause(e),this.currentClause={}},j.QueryParser.parseClause=function(e){var t=e.peekLexeme();if(null!=t)switch(t.type){case j.QueryLexer.PRESENCE:return j.QueryParser.parsePresence;case j.QueryLexer.FIELD:return j.QueryParser.parseField;case j.QueryLexer.TERM:return j.QueryParser.parseTerm;default:var r="expected either a field or a term, found "+t.type;throw t.str.length>=1&&(r+=" with value \'"+t.str+"\'"),new j.QueryParseError(r,t.start,t.end)}},j.QueryParser.parsePresence=function(e){var t=e.consumeLexeme();if(null!=t){switch(t.str){case"-":e.currentClause.presence=j.Query.presence.PROHIBITED;break;case"+":e.currentClause.presence=j.Query.presence.REQUIRED;break;default:var r="unrecognised presence operator\'"+t.str+"\'";throw new j.QueryParseError(r,t.start,t.end)}var n=e.peekLexeme();if(null==n)throw r="expecting term or field, found nothing",new j.QueryParseError(r,t.start,t.end);switch(n.type){case j.QueryLexer.FIELD:return j.QueryParser.parseField;case j.QueryLexer.TERM:return j.QueryParser.parseTerm;default:throw r="expecting term or field, found \'"+n.type+"\'",new j.QueryParseError(r,n.start,n.end)}}},j.QueryParser.parseField=function(e){var t=e.consumeLexeme();if(null!=t){if(-1==e.query.allFields.indexOf(t.str)){var r=e.query.allFields.map(function(e){return"\'"+e+"\'"}).join(", "),n="unrecognised field \'"+t.str+"\', possible fields: "+r;throw new j.QueryParseError(n,t.start,t.end)}e.currentClause.fields=[t.str];var i=e.peekLexeme();if(null==i)throw n="expecting term, found nothing",new j.QueryParseError(n,t.start,t.end);if(i.type===j.QueryLexer.TERM)return j.QueryParser.parseTerm;throw n="expecting term, found \'"+i.type+"\'",new j.QueryParseError(n,i.start,i.end)}},j.QueryParser.parseTerm=function(e){var t=e.consumeLexeme();if(null!=t){e.currentClause.term=t.str.toLowerCase(),-1!=t.str.indexOf("*")&&(e.currentClause.usePipeline=!1);var r=e.peekLexeme();if(null!=r)switch(r.type){case j.QueryLexer.TERM:return e.nextClause(),j.QueryParser.parseTerm;case j.QueryLexer.FIELD:return e.nextClause(),j.QueryParser.parseField;case j.QueryLexer.EDIT_DISTANCE:return j.QueryParser.parseEditDistance;case j.QueryLexer.BOOST:return j.QueryParser.parseBoost;case j.QueryLexer.PRESENCE:return e.nextClause(),j.QueryParser.parsePresence;default:var n="Unexpected lexeme type \'"+r.type+"\'";throw new j.QueryParseError(n,r.start,r.end)}else e.nextClause()}},j.QueryParser.parseEditDistance=function(e){var t=e.consumeLexeme();if(null!=t){var r=parseInt(t.str,10);if(isNaN(r)){var n="edit distance must be numeric";throw new j.QueryParseError(n,t.start,t.end)}e.currentClause.editDistance=r;var i=e.peekLexeme();if(null!=i)switch(i.type){case j.QueryLexer.TERM:return e.nextClause(),j.QueryParser.parseTerm;case j.QueryLexer.FIELD:return e.nextClause(),j.QueryParser.parseField;case j.QueryLexer.EDIT_DISTANCE:return j.QueryParser.parseEditDistance;case j.QueryLexer.BOOST:return j.QueryParser.parseBoost;case j.QueryLexer.PRESENCE:return e.nextClause(),j.QueryParser.parsePresence;default:throw n="Unexpected lexeme type \'"+i.type+"\'",new j.QueryParseError(n,i.start,i.end)}else e.nextClause()}},j.QueryParser.parseBoost=function(e){var t=e.consumeLexeme();if(null!=t){var r=parseInt(t.str,10);if(isNaN(r)){var n="boost must be numeric";throw new j.QueryParseError(n,t.start,t.end)}e.currentClause.boost=r;var i=e.peekLexeme();if(null!=i)switch(i.type){case j.QueryLexer.TERM:return e.nextClause(),j.QueryParser.parseTerm;case j.QueryLexer.FIELD:return e.nextClause(),j.QueryParser.parseField;case j.QueryLexer.EDIT_DISTANCE:return j.QueryParser.parseEditDistance;case j.QueryLexer.BOOST:return j.QueryParser.parseBoost;case j.QueryLexer.PRESENCE:return e.nextClause(),j.QueryParser.parsePresence;default:throw n="Unexpected lexeme type \'"+i.type+"\'",new j.QueryParseError(n,i.start,i.end)}else e.nextClause()}},void 0===(i="function"==typeof(n=function(){return j})?n.call(t,r,t,e):n)||(e.exports=i)}()}},t={};function r(n){var i=t[n];if(void 0!==i)return i.exports;var s=t[n]={exports:{}};return e[n](s,s.exports,r),s.exports}r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,{a:t}),t},r.d=function(e,t){for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)};var n={};!function(){"use strict";r.d(n,{add:function(){return c},dispose:function(){return y},done:function(){return h},fromExternalJS:function(){return f},load:function(){return p},search:function(){return m},toJS:function(){return d}});var e=r(291),t=(e,t,r)=>new Promise((n,i)=>{var s=e=>{try{a(r.next(e))}catch(e){i(e)}},o=e=>{try{a(r.throw(e))}catch(e){i(e)}},a=e=>e.done?n(e.value):Promise.resolve(e.value).then(s,o);a((r=r.apply(e,t)).next())});let i,s,o,a=[];function u(){i=new e.Builder,i.field("title"),i.field("description"),i.ref("ref"),i.pipeline.add(e.trimmer,e.stopWordFilter,e.stemmer),o=new Promise(e=>{s=e})}e.tokenizer.separator=/\\s+/,u();const l=t=>{const r=e.trimmer(new e.Token(t,{}));return"*"+e.stemmer(r)+"*"};function c(e,t,r){const n=a.push(r)-1,s={title:e.toLowerCase(),description:t.toLowerCase(),ref:n};i.add(s)}function h(){return t(this,null,function*(){s(i.build())})}function d(){return t(this,null,function*(){return{store:a,index:(yield o).toJSON()}})}function f(e,r){return t(this,null,function*(){try{if(importScripts(e),!self[r])throw new Error("Broken index file format");p(self[r])}catch(e){console.error("Failed to load search index: "+e.message)}})}function p(r){return t(this,null,function*(){a=r.store,s(e.Index.load(r.index))})}function y(){return t(this,null,function*(){a=[],u()})}function m(e,r=0){return t(this,null,function*(){if(0===e.trim().length)return[];let t=(yield o).query(t=>{e.trim().toLowerCase().split(/\\s+/).forEach(e=>{if(1===e.length)return;const r=l(e);t.term(r,{})})});return r>0&&(t=t.slice(0,r)),t.map(e=>({meta:a[e.ref],score:e.score}))})}addEventListener("message",function(e){var t,r=e.data,i=r.type,s=r.method,o=r.id,a=r.params;"RPC"===i&&s&&((t=n[s])?Promise.resolve().then(function(){return t.apply(n,a)}):Promise.reject("No such method")).then(function(e){postMessage({type:"RPC",id:o,result:e})}).catch(function(e){var t={message:e};e.stack&&(t.message=e.message,t.stack=e.stack,t.name=e.name),postMessage({type:"RPC",id:o,error:t})})}),postMessage({type:"RPC",method:"ready"})}()}();\n//# sourceMappingURL=d87bcbdbea8f8f5aa26f.worker.js.map'
                    ])), {
                        name: "[fullhash].worker.js"
                    });
                    return n(e, o), e;
                };
            },
            224: function(e) {
                e.exports = function(e, t) {
                    var r = 0, n = {};
                    e.addEventListener("message", function(t) {
                        var r = t.data;
                        if ("RPC" === r.type) {
                            if (r.id) {
                                var o = n[r.id];
                                o && (delete n[r.id], r.error ? o[1](Object.assign(Error(r.error.message), r.error)) : o[0](r.result));
                            } else {
                                var i = document.createEvent("Event");
                                i.initEvent(r.method, !1, !1), i.data = r.params, e.dispatchEvent(i);
                            }
                        }
                    }), t.forEach(function(t) {
                        e[t] = function() {
                            var o = arguments;
                            return new Promise(function(i, s) {
                                var a = ++r;
                                n[a] = [
                                    i,
                                    s
                                ], e.postMessage({
                                    type: "RPC",
                                    id: a,
                                    method: t,
                                    params: [].slice.call(o)
                                });
                            });
                        };
                    });
                };
            },
            997: function(e, t, r) {
                "use strict";
                var n = r(991), o = r.n(n), i = r(314), s = r.n(i)()(o());
                s.push([
                    e.id,
                    ".ps{overflow:hidden!important;overflow-anchor:none;-ms-overflow-style:none;touch-action:auto;-ms-touch-action:auto}.ps__rail-x{display:none;opacity:0;transition:background-color .2s linear,opacity .2s linear;-webkit-transition:background-color .2s linear,opacity .2s linear;height:15px;bottom:0;position:absolute}.ps__rail-y{display:none;opacity:0;transition:background-color .2s linear,opacity .2s linear;-webkit-transition:background-color .2s linear,opacity .2s linear;width:15px;right:0;position:absolute}.ps--active-x>.ps__rail-x,.ps--active-y>.ps__rail-y{display:block;background-color:transparent}.ps:hover>.ps__rail-x,.ps:hover>.ps__rail-y,.ps--focus>.ps__rail-x,.ps--focus>.ps__rail-y,.ps--scrolling-x>.ps__rail-x,.ps--scrolling-y>.ps__rail-y{opacity:.6}.ps .ps__rail-x:hover,.ps .ps__rail-y:hover,.ps .ps__rail-x:focus,.ps .ps__rail-y:focus,.ps .ps__rail-x.ps--clicking,.ps .ps__rail-y.ps--clicking{background-color:#eee;opacity:.9}.ps__thumb-x{background-color:#aaa;border-radius:6px;transition:background-color .2s linear,height .2s ease-in-out;-webkit-transition:background-color .2s linear,height .2s ease-in-out;height:6px;bottom:2px;position:absolute}.ps__thumb-y{background-color:#aaa;border-radius:6px;transition:background-color .2s linear,width .2s ease-in-out;-webkit-transition:background-color .2s linear,width .2s ease-in-out;width:6px;right:2px;position:absolute}.ps__rail-x:hover>.ps__thumb-x,.ps__rail-x:focus>.ps__thumb-x,.ps__rail-x.ps--clicking .ps__thumb-x{background-color:#999;height:11px}.ps__rail-y:hover>.ps__thumb-y,.ps__rail-y:focus>.ps__thumb-y,.ps__rail-y.ps--clicking .ps__thumb-y{background-color:#999;width:11px}@supports (-ms-overflow-style: none){.ps{overflow:auto!important}}@media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){.ps{overflow:auto!important}}\n",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/perfect-scrollbar/css/perfect-scrollbar.css"
                        ],
                        names: [],
                        mappings: "AAGA,IACE,yBAAU,CACV,oBAAiB,CACjB,uBAAoB,CACpB,iBAAc,CACd,qBACF,CAKA,YACE,YAAS,CACT,SAAS,CACT,yDAAqD,CACrD,iEAA6D,CAC7D,WAAQ,CAER,QAAQ,CAER,iBACF,CAEA,YACE,YAAS,CACT,SAAS,CACT,yDAAqD,CACrD,iEAA6D,CAC7D,UAAO,CAEP,OAAO,CAEP,iBACF,CAEA,oDAEE,aAAS,CACT,4BACF,CAEA,oJAME,UACF,CAEA,kJAME,qBAAkB,CAClB,UACF,CAKA,aACE,qBAAkB,CAnEpB,iBAoEiB,CACf,6DAAoD,CACpD,qEAA4D,CAC5D,UAAQ,CAER,UAAQ,CAER,iBACF,CAEA,aACE,qBAAkB,CA/EpB,iBAgFiB,CACf,4DAAmD,CACnD,oEAA2D,CAC3D,SAAO,CAEP,SAAO,CAEP,iBACF,CAEA,oGAGE,qBAAkB,CAClB,WACF,CAEA,oGAGE,qBAAkB,CAClB,UACF,CAGA,qCACE,IACE,uBACF,CACF,CAEA,wEACE,IACE,uBACF,CACF",
                        sourcesContent: [
                            "/*\n * Container style\n */\n.ps {\n  overflow: hidden !important;\n  overflow-anchor: none;\n  -ms-overflow-style: none;\n  touch-action: auto;\n  -ms-touch-action: auto;\n}\n\n/*\n * Scrollbar rail styles\n */\n.ps__rail-x {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  height: 15px;\n  /* there must be 'bottom' or 'top' for ps__rail-x */\n  bottom: 0px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-y {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\n  width: 15px;\n  /* there must be 'right' or 'left' for ps__rail-y */\n  right: 0;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 0.6;\n}\n\n.ps .ps__rail-x:hover,\n.ps .ps__rail-y:hover,\n.ps .ps__rail-x:focus,\n.ps .ps__rail-y:focus,\n.ps .ps__rail-x.ps--clicking,\n.ps .ps__rail-y.ps--clicking {\n  background-color: #eee;\n  opacity: 0.9;\n}\n\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, height .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, height .2s ease-in-out;\n  height: 6px;\n  /* there must be 'bottom' for ps__thumb-x */\n  bottom: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__thumb-y {\n  background-color: #aaa;\n  border-radius: 6px;\n  transition: background-color .2s linear, width .2s ease-in-out;\n  -webkit-transition: background-color .2s linear, width .2s ease-in-out;\n  width: 6px;\n  /* there must be 'right' for ps__thumb-y */\n  right: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x,\n.ps__rail-x.ps--clicking .ps__thumb-x {\n  background-color: #999;\n  height: 11px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n  background-color: #999;\n  width: 11px;\n}\n\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]), t.A = s;
            },
            314: function(e) {
                "use strict";
                e.exports = function(e) {
                    var t = [];
                    return t.toString = function() {
                        return this.map(function(t) {
                            var r = e(t);
                            return t[2] ? "@media ".concat(t[2], " {").concat(r, "}") : r;
                        }).join("");
                    }, t.i = function(e, r, n) {
                        "string" == typeof e && (e = [
                            [
                                null,
                                e,
                                ""
                            ]
                        ]);
                        var o = {};
                        if (n) for(var i = 0; i < this.length; i++){
                            var s = this[i][0];
                            null != s && (o[s] = !0);
                        }
                        for(var a = 0; a < e.length; a++){
                            var l = [].concat(e[a]);
                            n && o[l[0]] || (r && (l[2] ? l[2] = "".concat(r, " and ").concat(l[2]) : l[2] = r), t.push(l));
                        }
                    }, t;
                };
            },
            991: function(e) {
                "use strict";
                function t(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                    return n;
                }
                e.exports = function(e) {
                    var r, n, o = (n = 4, function(e) {
                        if (Array.isArray(e)) return e;
                    }(r = e) || function(e, t) {
                        var r = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);
                        if (null != r) {
                            var n, o, i = [], s = !0, a = !1;
                            try {
                                for(r = r.call(e); !(s = (n = r.next()).done) && (i.push(n.value), !t || i.length !== t); s = !0);
                            } catch (e) {
                                a = !0, o = e;
                            } finally{
                                try {
                                    s || null == r.return || r.return();
                                } finally{
                                    if (a) throw o;
                                }
                            }
                            return i;
                        }
                    }(r, n) || function(e, r) {
                        if (e) {
                            if ("string" == typeof e) return t(e, r);
                            var n = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? t(e, r) : void 0;
                        }
                    }(r, n) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }()), i = o[1], s = o[3];
                    if ("function" == typeof btoa) {
                        var a = btoa(unescape(encodeURIComponent(JSON.stringify(s)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a), c = "/*# ".concat(l, " */"), p = s.sources.map(function(e) {
                            return "/*# sourceURL=".concat(s.sourceRoot || "").concat(e, " */");
                        });
                        return [
                            i
                        ].concat(p).concat([
                            c
                        ]).join("\n");
                    }
                    return [
                        i
                    ].join("\n");
                };
            },
            364: function(e) {
                e.exports = {};
            },
            353: function(e, t, r) {
                "use strict";
                r.d(t, {
                    Ay: function() {
                        return i;
                    }
                });
                var n = (parcelRequire("l0hT7")), o = (e, t, r)=>new Promise((n, o)=>{
                        var i = (e)=>{
                            try {
                                a(r.next(e));
                            } catch (e) {
                                o(e);
                            }
                        }, s = (e)=>{
                            try {
                                a(r.throw(e));
                            } catch (e) {
                                o(e);
                            }
                        }, a = (e)=>e.done ? n(e.value) : Promise.resolve(e.value).then(i, s);
                        a((r = r.apply(e, t)).next());
                    });
                class i {
                    constructor(){
                        this.add = d, this.done = h, this.search = b, this.toJS = m, this.load = g, this.dispose = y, this.fromExternalJS = f;
                    }
                }
                let s, a, l, c = [];
                function p() {
                    s = new n.Builder, s.field("title"), s.field("description"), s.ref("ref"), s.pipeline.add(n.trimmer, n.stopWordFilter, n.stemmer), l = new Promise((e)=>{
                        a = e;
                    });
                }
                n.tokenizer.separator = /\s+/, p();
                const u = (e)=>{
                    const t = n.trimmer(new n.Token(e, {}));
                    return "*" + n.stemmer(t) + "*";
                };
                function d(e, t, r) {
                    const n = c.push(r) - 1, o = {
                        title: e.toLowerCase(),
                        description: t.toLowerCase(),
                        ref: n
                    };
                    s.add(o);
                }
                function h() {
                    return o(this, null, function*() {
                        a(s.build());
                    });
                }
                function m() {
                    return o(this, null, function*() {
                        return {
                            store: c,
                            index: (yield l).toJSON()
                        };
                    });
                }
                function f(e, t) {
                    return o(this, null, function*() {
                        try {
                            if (importScripts(e), !self[t]) throw new Error("Broken index file format");
                            g(self[t]);
                        } catch (e) {
                            console.error("Failed to load search index: " + e.message);
                        }
                    });
                }
                function g(e) {
                    return o(this, null, function*() {
                        c = e.store, a(n.Index.load(e.index));
                    });
                }
                function y() {
                    return o(this, null, function*() {
                        c = [], p();
                    });
                }
                function b(e, t = 0) {
                    return o(this, null, function*() {
                        if (0 === e.trim().length) return [];
                        let r = (yield l).query((t)=>{
                            e.trim().toLowerCase().split(/\s+/).forEach((e)=>{
                                if (1 === e.length) return;
                                const r = u(e);
                                t.term(r, {});
                            });
                        });
                        return t > 0 && (r = r.slice(0, t)), r.map((e)=>({
                                meta: c[e.ref],
                                score: e.score
                            }));
                    });
                }
            },
            435: function(e, t, r) {
                "use strict";
                const n = r(648), o = {}.NODE_DISABLE_COLORS ? {
                    red: "",
                    yellow: "",
                    green: "",
                    normal: ""
                } : {
                    red: "[31m",
                    yellow: "[33;1m",
                    green: "[32m",
                    normal: "[0m"
                };
                function i(e, t) {
                    function r(e, t) {
                        return n.stringify(e) === n.stringify(Object.assign({}, e, t));
                    }
                    return r(e, t) && r(t, e);
                }
                function s(e) {
                    let t = (e = e.replace("[]", "Array")).split("/");
                    return t[0] = t[0].replace(/[^A-Za-z0-9_\-\.]+|\s+/gm, "_"), t.join("/");
                }
                String.prototype.toCamelCase = function() {
                    return this.toLowerCase().replace(/[-_ \/\.](.)/g, function(e, t) {
                        return t.toUpperCase();
                    });
                }, e.exports = {
                    colour: o,
                    uniqueOnly: function(e, t, r) {
                        return r.indexOf(e) === t;
                    },
                    hasDuplicates: function(e) {
                        return new Set(e).size !== e.length;
                    },
                    allSame: function(e) {
                        return new Set(e).size <= 1;
                    },
                    distinctArray: function(e) {
                        return e.length === function(e) {
                            let t = [];
                            for (let r of e)t.find(function(e, t, n) {
                                return i(e, r);
                            }) || t.push(r);
                            return t;
                        }(e).length;
                    },
                    firstDupe: function(e) {
                        return e.find(function(t, r, n) {
                            return e.indexOf(t) < r;
                        });
                    },
                    hash: function(e) {
                        let t, r = 0;
                        if (0 === e.length) return r;
                        for(let n = 0; n < e.length; n++)t = e.charCodeAt(n), r = (r << 5) - r + t, r |= 0;
                        return r;
                    },
                    parameterTypeProperties: [
                        "format",
                        "minimum",
                        "maximum",
                        "exclusiveMinimum",
                        "exclusiveMaximum",
                        "minLength",
                        "maxLength",
                        "multipleOf",
                        "minItems",
                        "maxItems",
                        "uniqueItems",
                        "minProperties",
                        "maxProperties",
                        "additionalProperties",
                        "pattern",
                        "enum",
                        "default"
                    ],
                    arrayProperties: [
                        "items",
                        "minItems",
                        "maxItems",
                        "uniqueItems"
                    ],
                    httpMethods: [
                        "get",
                        "post",
                        "put",
                        "delete",
                        "patch",
                        "head",
                        "options",
                        "trace"
                    ],
                    sanitise: s,
                    sanitiseAll: function(e) {
                        return s(e.split("/").join("_"));
                    }
                };
            },
            751: function(e, t, r) {
                "use strict";
                const n = r(364), o = r(975), i = r(725), s = r(725), a = r(115), l = r(33).jptr, c = r(880).recurse, p = r(920).clone, u = r(737).dereference, d = r(264).isRef, h = r(435);
                function m(e, t, r, n, o, s) {
                    let a = s.externalRefs[r + n].paths[0], u = i.parse(o), m = {}, f = 1;
                    for(; f;)f = 0, c(e, {
                        identityDetection: !0
                    }, function(e, r, n) {
                        if (d(e, r)) {
                            if (e[r].startsWith("#")) {
                                if (m[e[r]] || e.$fixed) {
                                    if (!e.$fixed) {
                                        let t = (a + "/" + m[e[r]]).split("/#/").join("/");
                                        n.parent[n.pkey] = {
                                            $ref: t,
                                            "x-miro": e[r],
                                            $fixed: !0
                                        }, s.verbose > 1 && console.warn("Replacing with", t), f++;
                                    }
                                } else {
                                    let o = p(l(t, e[r]));
                                    if (s.verbose > 1 && console.warn((!1 === o ? h.colour.red : h.colour.green) + "Fragment resolution", e[r], h.colour.normal), !1 === o) {
                                        if (n.parent[n.pkey] = {}, s.fatal) {
                                            let t = new Error("Fragment $ref resolution failed " + e[r]);
                                            if (!s.promise) throw t;
                                            s.promise.reject(t);
                                        }
                                    } else f++, n.parent[n.pkey] = o, m[e[r]] = n.path.replace("/%24ref", "");
                                }
                            } else if (u.protocol) {
                                let t = i.resolve(o, e[r]).toString();
                                s.verbose > 1 && console.warn(h.colour.yellow + "Rewriting external url ref", e[r], "as", t, h.colour.normal), e["x-miro"] = e[r], s.externalRefs[e[r]] && (s.externalRefs[t] || (s.externalRefs[t] = s.externalRefs[e[r]]), s.externalRefs[t].failed = s.externalRefs[e[r]].failed), e[r] = t;
                            } else if (!e["x-miro"]) {
                                let t = i.resolve(o, e[r]).toString(), n = !1;
                                s.externalRefs[e[r]] && (n = s.externalRefs[e[r]].failed), n || (s.verbose > 1 && console.warn(h.colour.yellow + "Rewriting external ref", e[r], "as", t, h.colour.normal), e["x-miro"] = e[r], e[r] = t);
                            }
                        }
                    });
                    return c(e, {}, function(e, t, r) {
                        d(e, t) && void 0 !== e.$fixed && delete e.$fixed;
                    }), s.verbose > 1 && console.warn("Finished fragment resolution"), e;
                }
                function f(e, t) {
                    if (!t.filters || !t.filters.length) return e;
                    for (let r of t.filters)e = r(e, t);
                    return e;
                }
                function g(e, t, r, s) {
                    var c = i.parse(r.source), u = r.source.split("\\").join("/").split("/");
                    u.pop() || u.pop();
                    let d = "", h = t.split("#");
                    h.length > 1 && (d = "#" + h[1], t = h[0]), u = u.join("/");
                    let g = (y = i.parse(t).protocol, b = c.protocol, y && y.length > 2 ? y : b && b.length > 2 ? b : "file:");
                    var y, b;
                    let x;
                    if (x = "file:" === g ? o.resolve(u ? u + "/" : "", t) : i.resolve(u ? u + "/" : "", t), r.cache[x]) {
                        r.verbose && console.warn("CACHED", x, d);
                        let e = p(r.cache[x]), n = r.externalRef = e;
                        if (d && (n = l(n, d), !1 === n && (n = {}, r.fatal))) {
                            let e = new Error("Cached $ref resolution failed " + x + d);
                            if (!r.promise) throw e;
                            r.promise.reject(e);
                        }
                        return n = m(n, e, t, d, x, r), n = f(n, r), s(p(n), x, r), Promise.resolve(n);
                    }
                    if (r.verbose && console.warn("GET", x, d), r.handlers && r.handlers[g]) return r.handlers[g](u, t, d, r).then(function(e) {
                        return r.externalRef = e, e = f(e, r), r.cache[x] = e, s(e, x, r), e;
                    }).catch(function(e) {
                        throw r.verbose && console.warn(e), e;
                    });
                    if (g && g.startsWith("http")) {
                        const e = Object.assign({}, r.fetchOptions, {
                            agent: r.agent
                        });
                        return r.fetch(x, e).then(function(e) {
                            if (200 !== e.status) {
                                if (r.ignoreIOErrors) return r.verbose && console.warn("FAILED", t), r.externalRefs[t].failed = !0, '{"$ref":"' + t + '"}';
                                throw new Error(`Received status code ${e.status}: ${x}`);
                            }
                            return e.text();
                        }).then(function(e) {
                            try {
                                let n = a.parse(e, {
                                    schema: "core",
                                    prettyErrors: !0
                                });
                                if (e = r.externalRef = n, r.cache[x] = p(e), d && !1 === (e = l(e, d)) && (e = {}, r.fatal)) {
                                    let e = new Error("Remote $ref resolution failed " + x + d);
                                    if (!r.promise) throw e;
                                    r.promise.reject(e);
                                }
                                e = f(e = m(e, n, t, d, x, r), r);
                            } catch (e) {
                                if (r.verbose && console.warn(e), !r.promise || !r.fatal) throw e;
                                r.promise.reject(e);
                            }
                            return s(e, x, r), e;
                        }).catch(function(e) {
                            if (r.verbose && console.warn(e), r.cache[x] = {}, !r.promise || !r.fatal) throw e;
                            r.promise.reject(e);
                        });
                    }
                    {
                        const e = '{"$ref":"' + t + '"}';
                        return (function(e, t, r, o, i) {
                            return new Promise(function(s, a) {
                                n.readFile(e, t, function(e, t) {
                                    e ? r.ignoreIOErrors && i ? (r.verbose && console.warn("FAILED", o), r.externalRefs[o].failed = !0, s(i)) : a(e) : s(t);
                                });
                            });
                        })(x, r.encoding || "utf8", r, t, e).then(function(e) {
                            try {
                                let n = a.parse(e, {
                                    schema: "core",
                                    prettyErrors: !0
                                });
                                if (e = r.externalRef = n, r.cache[x] = p(e), d && !1 === (e = l(e, d)) && (e = {}, r.fatal)) {
                                    let e = new Error("File $ref resolution failed " + x + d);
                                    if (!r.promise) throw e;
                                    r.promise.reject(e);
                                }
                                e = f(e = m(e, n, t, d, x, r), r);
                            } catch (e) {
                                if (r.verbose && console.warn(e), !r.promise || !r.fatal) throw e;
                                r.promise.reject(e);
                            }
                            return s(e, x, r), e;
                        }).catch(function(e) {
                            if (r.verbose && console.warn(e), !r.promise || !r.fatal) throw e;
                            r.promise.reject(e);
                        });
                    }
                }
                function y(e) {
                    return new Promise(function(t, r) {
                        (function(e) {
                            return new Promise(function(t, r) {
                                function n(t, r, n) {
                                    if (t[r] && d(t[r], "$ref")) {
                                        let i = t[r].$ref;
                                        if (!i.startsWith("#")) {
                                            let s = "";
                                            if (!o[i]) {
                                                let t = Object.keys(o).find(function(e, t, r) {
                                                    return i.startsWith(e + "/");
                                                });
                                                t && (e.verbose && console.warn("Found potential subschema at", t), s = "/" + (i.split("#")[1] || "").replace(t.split("#")[1] || ""), s = s.split("/undefined").join(""), i = t);
                                            }
                                            if (o[i] || (o[i] = {
                                                resolved: !1,
                                                paths: [],
                                                extras: {},
                                                description: t[r].description
                                            }), o[i].resolved) {
                                                if (o[i].failed) ;
                                                else if (e.rewriteRefs) {
                                                    let n = o[i].resolvedAt;
                                                    e.verbose > 1 && console.warn("Rewriting ref", i, n), t[r]["x-miro"] = i, t[r].$ref = n + s;
                                                } else t[r] = p(o[i].data);
                                            } else o[i].paths.push(n.path), o[i].extras[n.path] = s;
                                        }
                                    }
                                }
                                let o = e.externalRefs;
                                if (e.resolver.depth > 0 && e.source === e.resolver.base) return t(o);
                                c(e.openapi.definitions, {
                                    identityDetection: !0,
                                    path: "#/definitions"
                                }, n), c(e.openapi.components, {
                                    identityDetection: !0,
                                    path: "#/components"
                                }, n), c(e.openapi, {
                                    identityDetection: !0
                                }, n), t(o);
                            });
                        })(e).then(function(t) {
                            for(let r in t)if (!t[r].resolved) {
                                let n = e.resolver.depth;
                                n > 0 && n++, e.resolver.actions[n].push(function() {
                                    return g(e.openapi, r, e, function(e, n, o) {
                                        if (!t[r].resolved) {
                                            let i = {};
                                            i.context = t[r], i.$ref = r, i.original = p(e), i.updated = e, i.source = n, o.externals.push(i), t[r].resolved = !0;
                                        }
                                        let i = Object.assign({}, o, {
                                            source: "",
                                            resolver: {
                                                actions: o.resolver.actions,
                                                depth: o.resolver.actions.length - 1,
                                                base: o.resolver.base
                                            }
                                        });
                                        o.patch && t[r].description && !e.description && "object" == typeof e && (e.description = t[r].description), t[r].data = e;
                                        let s = (a = t[r].paths, [
                                            ...new Set(a)
                                        ]);
                                        var a;
                                        s = s.sort(function(e, t) {
                                            const r = e.startsWith("#/components/") || e.startsWith("#/definitions/"), n = t.startsWith("#/components/") || t.startsWith("#/definitions/");
                                            return r && !n ? -1 : n && !r ? 1 : 0;
                                        });
                                        for (let n of s)if (t[r].resolvedAt && n !== t[r].resolvedAt && n.indexOf("x-ms-examples/") < 0) o.verbose > 1 && console.warn("Creating pointer to data at", n), l(o.openapi, n, {
                                            $ref: t[r].resolvedAt + t[r].extras[n],
                                            "x-miro": r + t[r].extras[n]
                                        });
                                        else {
                                            t[r].resolvedAt ? o.verbose > 1 && console.warn("Avoiding circular reference") : (t[r].resolvedAt = n, o.verbose > 1 && console.warn("Creating initial clone of data at", n));
                                            let i = p(e);
                                            l(o.openapi, n, i);
                                        }
                                        0 === o.resolver.actions[i.resolver.depth].length && o.resolver.actions[i.resolver.depth].push(function() {
                                            return y(i);
                                        });
                                    });
                                });
                            }
                        }).catch(function(t) {
                            e.verbose && console.warn(t), r(t);
                        });
                        let n = {
                            options: e
                        };
                        n.actions = e.resolver.actions[e.resolver.depth], t(n);
                    });
                }
                function b(e, t, r) {
                    e.resolver.actions.push([]), y(e).then(function(n) {
                        var o;
                        (o = n.actions, o.reduce((e, t)=>e.then((e)=>t().then(Array.prototype.concat.bind(e))), Promise.resolve([]))).then(function() {
                            if (e.resolver.depth >= e.resolver.actions.length) return console.warn("Ran off the end of resolver actions"), t(!0);
                            e.resolver.depth++, e.resolver.actions[e.resolver.depth].length ? setTimeout(function() {
                                b(n.options, t, r);
                            }, 0) : (e.verbose > 1 && console.warn(h.colour.yellow + "Finished external resolution!", h.colour.normal), e.resolveInternal && (e.verbose > 1 && console.warn(h.colour.yellow + "Starting internal resolution!", h.colour.normal), e.openapi = u(e.openapi, e.original, {
                                verbose: e.verbose - 1
                            }), e.verbose > 1 && console.warn(h.colour.yellow + "Finished internal resolution!", h.colour.normal)), c(e.openapi, {}, function(t, r, n) {
                                d(t, r) && (e.preserveMiro || delete t["x-miro"]);
                            }), t(e));
                        }).catch(function(t) {
                            e.verbose && console.warn(t), r(t);
                        });
                    }).catch(function(t) {
                        e.verbose && console.warn(t), r(t);
                    });
                }
                function x(e) {
                    if (e.cache || (e.cache = {}), e.fetch || (e.fetch = s), e.source) {
                        let t = i.parse(e.source);
                        (!t.protocol || t.protocol.length <= 2) && (e.source = o.resolve(e.source));
                    }
                    e.externals = [], e.externalRefs = {}, e.rewriteRefs = !0, e.resolver = {}, e.resolver.depth = 0, e.resolver.base = e.source, e.resolver.actions = [
                        []
                    ];
                }
                e.exports = {
                    optionalResolve: function(e) {
                        return x(e), new Promise(function(t, r) {
                            e.resolve ? b(e, t, r) : t(e);
                        });
                    },
                    resolve: function(e, t, r) {
                        return r || (r = {}), r.openapi = e, r.source = t, r.resolve = !0, x(r), new Promise(function(e, t) {
                            b(r, e, t);
                        });
                    }
                };
            },
            319: function(e) {
                "use strict";
                function t() {
                    return {
                        depth: 0,
                        seen: new WeakMap,
                        top: !0,
                        combine: !1,
                        allowRefSiblings: !1
                    };
                }
                e.exports = {
                    getDefaultState: t,
                    walkSchema: function e(r, n, o, i) {
                        if (void 0 === o.depth && (o = t()), null == r) return r;
                        if (void 0 !== r.$ref) {
                            let e = {
                                $ref: r.$ref
                            };
                            return o.allowRefSiblings && r.description && (e.description = r.description), i(e, n, o), e;
                        }
                        if (o.combine && (r.allOf && Array.isArray(r.allOf) && 1 === r.allOf.length && delete (r = Object.assign({}, r.allOf[0], r)).allOf, r.anyOf && Array.isArray(r.anyOf) && 1 === r.anyOf.length && delete (r = Object.assign({}, r.anyOf[0], r)).anyOf, r.oneOf && Array.isArray(r.oneOf) && 1 === r.oneOf.length && delete (r = Object.assign({}, r.oneOf[0], r)).oneOf), i(r, n, o), o.seen.has(r)) return r;
                        if ("object" == typeof r && null !== r && o.seen.set(r, !0), o.top = !1, o.depth++, void 0 !== r.items && (o.property = "items", e(r.items, r, o, i)), r.additionalItems && "object" == typeof r.additionalItems && (o.property = "additionalItems", e(r.additionalItems, r, o, i)), r.additionalProperties && "object" == typeof r.additionalProperties && (o.property = "additionalProperties", e(r.additionalProperties, r, o, i)), r.properties) for(let t in r.properties){
                            let n = r.properties[t];
                            o.property = "properties/" + t, e(n, r, o, i);
                        }
                        if (r.patternProperties) for(let t in r.patternProperties){
                            let n = r.patternProperties[t];
                            o.property = "patternProperties/" + t, e(n, r, o, i);
                        }
                        if (r.allOf) for(let t in r.allOf){
                            let n = r.allOf[t];
                            o.property = "allOf/" + t, e(n, r, o, i);
                        }
                        if (r.anyOf) for(let t in r.anyOf){
                            let n = r.anyOf[t];
                            o.property = "anyOf/" + t, e(n, r, o, i);
                        }
                        if (r.oneOf) for(let t in r.oneOf){
                            let n = r.oneOf[t];
                            o.property = "oneOf/" + t, e(n, r, o, i);
                        }
                        return r.not && (o.property = "not", e(r.not, r, o, i)), o.depth--, r;
                    }
                };
            },
            975: function(e) {
                "use strict";
                function t(e) {
                    if ("string" != typeof e) throw new TypeError("Path must be a string. Received " + JSON.stringify(e));
                }
                function r(e, t) {
                    for(var r, n = "", o = 0, i = -1, s = 0, a = 0; a <= e.length; ++a){
                        if (a < e.length) r = e.charCodeAt(a);
                        else {
                            if (47 === r) break;
                            r = 47;
                        }
                        if (47 === r) {
                            if (i === a - 1 || 1 === s) ;
                            else if (i !== a - 1 && 2 === s) {
                                if (n.length < 2 || 2 !== o || 46 !== n.charCodeAt(n.length - 1) || 46 !== n.charCodeAt(n.length - 2)) {
                                    if (n.length > 2) {
                                        var l = n.lastIndexOf("/");
                                        if (l !== n.length - 1) {
                                            -1 === l ? (n = "", o = 0) : o = (n = n.slice(0, l)).length - 1 - n.lastIndexOf("/"), i = a, s = 0;
                                            continue;
                                        }
                                    } else if (2 === n.length || 1 === n.length) {
                                        n = "", o = 0, i = a, s = 0;
                                        continue;
                                    }
                                }
                                t && (n.length > 0 ? n += "/.." : n = "..", o = 2);
                            } else n.length > 0 ? n += "/" + e.slice(i + 1, a) : n = e.slice(i + 1, a), o = a - i - 1;
                            i = a, s = 0;
                        } else 46 === r && -1 !== s ? ++s : s = -1;
                    }
                    return n;
                }
                var n = {
                    resolve: function() {
                        for(var e, n = "", o = !1, i = arguments.length - 1; i >= -1 && !o; i--){
                            var s;
                            i >= 0 ? s = arguments[i] : (void 0 === e && (e = $hPtJY.cwd()), s = e), t(s), 0 !== s.length && (n = s + "/" + n, o = 47 === s.charCodeAt(0));
                        }
                        return n = r(n, !o), o ? n.length > 0 ? "/" + n : "/" : n.length > 0 ? n : ".";
                    },
                    normalize: function(e) {
                        if (t(e), 0 === e.length) return ".";
                        var n = 47 === e.charCodeAt(0), o = 47 === e.charCodeAt(e.length - 1);
                        return 0 !== (e = r(e, !n)).length || n || (e = "."), e.length > 0 && o && (e += "/"), n ? "/" + e : e;
                    },
                    isAbsolute: function(e) {
                        return t(e), e.length > 0 && 47 === e.charCodeAt(0);
                    },
                    join: function() {
                        if (0 === arguments.length) return ".";
                        for(var e, r = 0; r < arguments.length; ++r){
                            var o = arguments[r];
                            t(o), o.length > 0 && (void 0 === e ? e = o : e += "/" + o);
                        }
                        return void 0 === e ? "." : n.normalize(e);
                    },
                    relative: function(e, r) {
                        if (t(e), t(r), e === r) return "";
                        if ((e = n.resolve(e)) === (r = n.resolve(r))) return "";
                        for(var o = 1; o < e.length && 47 === e.charCodeAt(o); ++o);
                        for(var i = e.length, s = i - o, a = 1; a < r.length && 47 === r.charCodeAt(a); ++a);
                        for(var l = r.length - a, c = s < l ? s : l, p = -1, u = 0; u <= c; ++u){
                            if (u === c) {
                                if (l > c) {
                                    if (47 === r.charCodeAt(a + u)) return r.slice(a + u + 1);
                                    if (0 === u) return r.slice(a + u);
                                } else s > c && (47 === e.charCodeAt(o + u) ? p = u : 0 === u && (p = 0));
                                break;
                            }
                            var d = e.charCodeAt(o + u);
                            if (d !== r.charCodeAt(a + u)) break;
                            47 === d && (p = u);
                        }
                        var h = "";
                        for(u = o + p + 1; u <= i; ++u)u !== i && 47 !== e.charCodeAt(u) || (0 === h.length ? h += ".." : h += "/..");
                        return h.length > 0 ? h + r.slice(a + p) : (a += p, 47 === r.charCodeAt(a) && ++a, r.slice(a));
                    },
                    _makeLong: function(e) {
                        return e;
                    },
                    dirname: function(e) {
                        if (t(e), 0 === e.length) return ".";
                        for(var r = e.charCodeAt(0), n = 47 === r, o = -1, i = !0, s = e.length - 1; s >= 1; --s)if (47 === (r = e.charCodeAt(s))) {
                            if (!i) {
                                o = s;
                                break;
                            }
                        } else i = !1;
                        return -1 === o ? n ? "/" : "." : n && 1 === o ? "//" : e.slice(0, o);
                    },
                    basename: function(e, r) {
                        if (void 0 !== r && "string" != typeof r) throw new TypeError('"ext" argument must be a string');
                        t(e);
                        var n, o = 0, i = -1, s = !0;
                        if (void 0 !== r && r.length > 0 && r.length <= e.length) {
                            if (r.length === e.length && r === e) return "";
                            var a = r.length - 1, l = -1;
                            for(n = e.length - 1; n >= 0; --n){
                                var c = e.charCodeAt(n);
                                if (47 === c) {
                                    if (!s) {
                                        o = n + 1;
                                        break;
                                    }
                                } else -1 === l && (s = !1, l = n + 1), a >= 0 && (c === r.charCodeAt(a) ? -1 === --a && (i = n) : (a = -1, i = l));
                            }
                            return o === i ? i = l : -1 === i && (i = e.length), e.slice(o, i);
                        }
                        for(n = e.length - 1; n >= 0; --n)if (47 === e.charCodeAt(n)) {
                            if (!s) {
                                o = n + 1;
                                break;
                            }
                        } else -1 === i && (s = !1, i = n + 1);
                        return -1 === i ? "" : e.slice(o, i);
                    },
                    extname: function(e) {
                        t(e);
                        for(var r = -1, n = 0, o = -1, i = !0, s = 0, a = e.length - 1; a >= 0; --a){
                            var l = e.charCodeAt(a);
                            if (47 !== l) -1 === o && (i = !1, o = a + 1), 46 === l ? -1 === r ? r = a : 1 !== s && (s = 1) : -1 !== r && (s = -1);
                            else if (!i) {
                                n = a + 1;
                                break;
                            }
                        }
                        return -1 === r || -1 === o || 0 === s || 1 === s && r === o - 1 && r === n + 1 ? "" : e.slice(r, o);
                    },
                    format: function(e) {
                        if (null === e || "object" != typeof e) throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof e);
                        return function(e, t) {
                            var r = t.dir || t.root, n = t.base || (t.name || "") + (t.ext || "");
                            return r ? r === t.root ? r + n : r + "/" + n : n;
                        }(0, e);
                    },
                    parse: function(e) {
                        t(e);
                        var r = {
                            root: "",
                            dir: "",
                            base: "",
                            ext: "",
                            name: ""
                        };
                        if (0 === e.length) return r;
                        var n, o = e.charCodeAt(0), i = 47 === o;
                        i ? (r.root = "/", n = 1) : n = 0;
                        for(var s = -1, a = 0, l = -1, c = !0, p = e.length - 1, u = 0; p >= n; --p)if (47 !== (o = e.charCodeAt(p))) -1 === l && (c = !1, l = p + 1), 46 === o ? -1 === s ? s = p : 1 !== u && (u = 1) : -1 !== s && (u = -1);
                        else if (!c) {
                            a = p + 1;
                            break;
                        }
                        return -1 === s || -1 === l || 0 === u || 1 === u && s === l - 1 && s === a + 1 ? -1 !== l && (r.base = r.name = 0 === a && i ? e.slice(1, l) : e.slice(a, l)) : (0 === a && i ? (r.name = e.slice(1, s), r.base = e.slice(1, l)) : (r.name = e.slice(a, s), r.base = e.slice(a, l)), r.ext = e.slice(s, l)), a > 0 ? r.dir = e.slice(0, a - 1) : i && (r.dir = "/"), r;
                    },
                    sep: "/",
                    delimiter: ":",
                    win32: null,
                    posix: null
                };
                n.posix = n, e.exports = n;
            },
            920: function(e) {
                "use strict";
                e.exports = {
                    nop: function(e) {
                        return e;
                    },
                    clone: function(e) {
                        return JSON.parse(JSON.stringify(e));
                    },
                    shallowClone: function(e) {
                        let t = {};
                        for(let r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
                        return t;
                    },
                    deepClone: function e(t) {
                        let r = Array.isArray(t) ? [] : {};
                        for(let n in t)(t.hasOwnProperty(n) || Array.isArray(t)) && (r[n] = "object" == typeof t[n] ? e(t[n]) : t[n]);
                        return r;
                    },
                    fastClone: function(e) {
                        return Object.assign({}, e);
                    },
                    circularClone: function e(t, r) {
                        if (r || (r = new WeakMap), Object(t) !== t || t instanceof Function) return t;
                        if (r.has(t)) return r.get(t);
                        try {
                            var n = new t.constructor;
                        } catch (e) {
                            n = Object.create(Object.getPrototypeOf(t));
                        }
                        return r.set(t, n), Object.assign(n, ...Object.keys(t).map((n)=>({
                                [n]: e(t[n], r)
                            })));
                    }
                };
            },
            737: function(e, t, r) {
                "use strict";
                const n = r(880).recurse, o = r(920).shallowClone, i = r(33).jptr, s = r(264).isRef;
                e.exports = {
                    dereference: function e(t, r, a) {
                        a || (a = {}), a.cache || (a.cache = {}), a.state || (a.state = {}), a.state.identityDetection = !0, a.depth = a.depth ? a.depth + 1 : 1;
                        let l = a.depth > 1 ? t : o(t), c = {
                            data: l
                        }, p = a.depth > 1 ? r : o(r);
                        a.master || (a.master = l);
                        let u = function(e) {
                            return e && e.verbose ? {
                                warn: function() {
                                    var e = Array.prototype.slice.call(arguments);
                                    console.warn.apply(console, e);
                                }
                            } : {
                                warn: function() {}
                            };
                        }(a), d = 1;
                        for(; d > 0;)d = 0, n(c, a.state, function(t, r, n) {
                            if (s(t, r)) {
                                let o = t[r];
                                if (d++, a.cache[o]) {
                                    let e = a.cache[o];
                                    if (e.resolved) u.warn("Patching %s for %s", o, e.path), n.parent[n.pkey] = e.data, a.$ref && "object" == typeof n.parent[n.pkey] && null !== n.parent[n.pkey] && (n.parent[n.pkey][a.$ref] = o);
                                    else {
                                        if (o === e.path) throw new Error(`Tight circle at ${e.path}`);
                                        u.warn("Unresolved ref"), n.parent[n.pkey] = i(e.source, e.path), !1 === n.parent[n.pkey] && (n.parent[n.pkey] = i(e.source, e.key)), a.$ref && "object" == typeof n.parent[n.pkey] && null !== n.parent[n.pkey] && (n.parent[a.$ref] = o);
                                    }
                                } else {
                                    let t = {};
                                    t.path = n.path.split("/$ref")[0], t.key = o, u.warn("Dereffing %s at %s", o, t.path), t.source = p, t.data = i(t.source, t.key), !1 === t.data && (t.data = i(a.master, t.key), t.source = a.master), !1 === t.data && u.warn("Missing $ref target", t.key), a.cache[o] = t, t.data = n.parent[n.pkey] = e(i(t.source, t.key), t.source, a), a.$ref && "object" == typeof n.parent[n.pkey] && null !== n.parent[n.pkey] && (n.parent[n.pkey][a.$ref] = o), t.resolved = !0;
                                }
                            }
                        });
                        return c.data;
                    }
                };
            },
            264: function(e) {
                "use strict";
                e.exports = {
                    isRef: function(e, t) {
                        return "$ref" === t && !!e && "string" == typeof e[t];
                    }
                };
            },
            33: function(e) {
                "use strict";
                function t(e) {
                    return e.replace(/\~1/g, "/").replace(/~0/g, "~");
                }
                e.exports = {
                    jptr: function(e, r, n) {
                        if (void 0 === e) return !1;
                        if (!r || "string" != typeof r || "#" === r) return void 0 !== n ? n : e;
                        if (r.indexOf("#") >= 0) {
                            let e = r.split("#");
                            if (e[0]) return !1;
                            r = e[1], r = decodeURIComponent(r.slice(1).split("+").join(" "));
                        }
                        r.startsWith("/") && (r = r.slice(1));
                        let o = r.split("/");
                        for(let r = 0; r < o.length; r++){
                            o[r] = t(o[r]);
                            let i = void 0 !== n && r == o.length - 1, s = parseInt(o[r], 10);
                            if (!Array.isArray(e) || isNaN(s) || s.toString() !== o[r] ? s = Array.isArray(e) && "-" === o[r] ? -2 : -1 : o[r] = r > 0 ? o[r - 1] : "", -1 != s || e && e.hasOwnProperty(o[r])) {
                                if (s >= 0) i && (e[s] = n), e = e[s];
                                else {
                                    if (-2 === s) return i ? (Array.isArray(e) && e.push(n), n) : void 0;
                                    i && (e[o[r]] = n), e = e[o[r]];
                                }
                            } else {
                                if (void 0 === n || "object" != typeof e || Array.isArray(e)) return !1;
                                e[o[r]] = i ? n : "0" === o[r + 1] || "-" === o[r + 1] ? [] : {}, e = e[o[r]];
                            }
                        }
                        return e;
                    },
                    jpescape: function(e) {
                        return e.replace(/\~/g, "~0").replace(/\//g, "~1");
                    },
                    jpunescape: t
                };
            },
            880: function(e, t, r) {
                "use strict";
                const n = r(33).jpescape;
                e.exports = {
                    recurse: function e(t, r, o) {
                        if (r || (r = {
                            depth: 0
                        }), r.depth || (r = Object.assign({}, {
                            path: "#",
                            depth: 0,
                            pkey: "",
                            parent: {},
                            payload: {},
                            seen: new WeakMap,
                            identity: !1,
                            identityDetection: !1
                        }, r)), "object" != typeof t) return;
                        let i = r.path;
                        for(let s in t){
                            if (r.key = s, r.path = r.path + "/" + encodeURIComponent(n(s)), r.identityPath = r.seen.get(t[s]), r.identity = void 0 !== r.identityPath, t.hasOwnProperty(s) && o(t, s, r), "object" == typeof t[s] && !r.identity) {
                                r.identityDetection && !Array.isArray(t[s]) && null !== t[s] && r.seen.set(t[s], r.path);
                                let n = {};
                                n.parent = t, n.path = r.path, n.depth = r.depth ? r.depth + 1 : 1, n.pkey = s, n.payload = r.payload, n.seen = r.seen, n.identity = !1, n.identityDetection = r.identityDetection, e(t[s], n, o);
                            }
                            r.path = i;
                        }
                    }
                };
            },
            494: function(e, t, r) {
                "use strict";
                r.r(t);
                var n = r(72), o = r.n(n), i = r(825), s = r.n(i), a = r(659), l = r.n(a), c = r(56), p = r.n(c), u = r(540), d = r.n(u), h = r(113), m = r.n(h), f = r(997), g = {};
                g.styleTagTransform = m(), g.setAttributes = p(), g.insert = l().bind(null, "head"), g.domAPI = s(), g.insertStyleElement = d(), o()(f.A, g), t.default = f.A && f.A.locals ? f.A.locals : void 0;
            },
            72: function(e) {
                "use strict";
                var t = [];
                function r(e) {
                    for(var r = -1, n = 0; n < t.length; n++)if (t[n].identifier === e) {
                        r = n;
                        break;
                    }
                    return r;
                }
                function n(e, n) {
                    for(var i = {}, s = [], a = 0; a < e.length; a++){
                        var l = e[a], c = n.base ? l[0] + n.base : l[0], p = i[c] || 0, u = "".concat(c, " ").concat(p);
                        i[c] = p + 1;
                        var d = r(u), h = {
                            css: l[1],
                            media: l[2],
                            sourceMap: l[3],
                            supports: l[4],
                            layer: l[5]
                        };
                        if (-1 !== d) t[d].references++, t[d].updater(h);
                        else {
                            var m = o(h, n);
                            n.byIndex = a, t.splice(a, 0, {
                                identifier: u,
                                updater: m,
                                references: 1
                            });
                        }
                        s.push(u);
                    }
                    return s;
                }
                function o(e, t) {
                    var r = t.domAPI(t);
                    return r.update(e), function(t) {
                        if (t) {
                            if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
                            r.update(e = t);
                        } else r.remove();
                    };
                }
                e.exports = function(e, o) {
                    var i = n(e = e || [], o = o || {});
                    return function(e) {
                        e = e || [];
                        for(var s = 0; s < i.length; s++){
                            var a = r(i[s]);
                            t[a].references--;
                        }
                        for(var l = n(e, o), c = 0; c < i.length; c++){
                            var p = r(i[c]);
                            0 === t[p].references && (t[p].updater(), t.splice(p, 1));
                        }
                        i = l;
                    };
                };
            },
            659: function(e) {
                "use strict";
                var t = {};
                e.exports = function(e, r) {
                    var n = function(e) {
                        if (void 0 === t[e]) {
                            var r = document.querySelector(e);
                            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                                r = r.contentDocument.head;
                            } catch (e) {
                                r = null;
                            }
                            t[e] = r;
                        }
                        return t[e];
                    }(e);
                    if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                    n.appendChild(r);
                };
            },
            540: function(e) {
                "use strict";
                e.exports = function(e) {
                    var t = document.createElement("style");
                    return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
                };
            },
            56: function(e, t, r) {
                "use strict";
                e.exports = function(e) {
                    var t = r.nc;
                    t && e.setAttribute("nonce", t);
                };
            },
            825: function(e) {
                "use strict";
                e.exports = function(e) {
                    var t = e.insertStyleElement(e);
                    return {
                        update: function(r) {
                            !function(e, t, r) {
                                var n = "";
                                r.supports && (n += "@supports (".concat(r.supports, ") {")), r.media && (n += "@media ".concat(r.media, " {"));
                                var o = void 0 !== r.layer;
                                o && (n += "@layer".concat(r.layer.length > 0 ? " ".concat(r.layer) : "", " {")), n += r.css, o && (n += "}"), r.media && (n += "}"), r.supports && (n += "}");
                                var i = r.sourceMap;
                                i && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i)))), " */")), t.styleTagTransform(n, e, t.options);
                            }(t, e, r);
                        },
                        remove: function() {
                            !function(e) {
                                if (null === e.parentNode) return !1;
                                e.parentNode.removeChild(e);
                            }(t);
                        }
                    };
                };
            },
            113: function(e) {
                "use strict";
                e.exports = function(e, t) {
                    if (t.styleSheet) t.styleSheet.cssText = e;
                    else {
                        for(; t.firstChild;)t.removeChild(t.firstChild);
                        t.appendChild(document.createTextNode(e));
                    }
                };
            },
            65: function(e, t, r) {
                "use strict";
                const n = r(364), o = r(725), i = (r(975), r(884)), s = r(725), a = r(115), l = r(33), c = l.jptr, p = r(264).isRef, u = r(920).clone, d = r(920).circularClone, h = r(880).recurse, m = r(751), f = r(319), g = r(435), y = r(665).statusCodes, b = r(430).rE, x = "3.0.0";
                let v;
                class w extends Error {
                    constructor(e){
                        super(e), this.name = "S2OError";
                    }
                }
                function k(e, t) {
                    let r = new w(e);
                    if (r.options = t, !t.promise) throw r;
                    t.promise.reject(r);
                }
                function E(e, t, r) {
                    r.warnOnly ? t[r.warnProperty || "x-s2o-warning"] = e : k(e, r);
                }
                function O(e, t) {
                    f.walkSchema(e, {}, {}, function(e, r, n) {
                        !function(e) {
                            if (e["x-required"] && Array.isArray(e["x-required"]) && (e.required || (e.required = []), e.required = e.required.concat(e["x-required"]), delete e["x-required"]), e["x-anyOf"] && (e.anyOf = e["x-anyOf"], delete e["x-anyOf"]), e["x-oneOf"] && (e.oneOf = e["x-oneOf"], delete e["x-oneOf"]), e["x-not"] && (e.not = e["x-not"], delete e["x-not"]), "boolean" == typeof e["x-nullable"] && (e.nullable = e["x-nullable"], delete e["x-nullable"]), "object" == typeof e["x-discriminator"] && "string" == typeof e["x-discriminator"].propertyName) {
                                e.discriminator = e["x-discriminator"], delete e["x-discriminator"];
                                for(let t in e.discriminator.mapping){
                                    let r = e.discriminator.mapping[t];
                                    r.startsWith("#/definitions/") && (e.discriminator.mapping[t] = r.replace("#/definitions/", "#/components/schemas/"));
                                }
                            }
                        }(e), function(e, t, r) {
                            if (e.nullable && r.patches++, e.discriminator && "string" == typeof e.discriminator && (e.discriminator = {
                                propertyName: e.discriminator
                            }), e.items && Array.isArray(e.items) && (0 === e.items.length ? e.items = {} : 1 === e.items.length ? e.items = e.items[0] : e.items = {
                                anyOf: e.items
                            }), e.type && Array.isArray(e.type)) {
                                if (r.patch) {
                                    if (r.patches++, 0 === e.type.length) delete e.type;
                                    else {
                                        e.oneOf || (e.oneOf = []);
                                        for (let t of e.type){
                                            let r = {};
                                            if ("null" === t) e.nullable = !0;
                                            else {
                                                r.type = t;
                                                for (let t of g.arrayProperties)void 0 !== e.prop && (r[t] = e[t], delete e[t]);
                                            }
                                            r.type && e.oneOf.push(r);
                                        }
                                        delete e.type, 0 === e.oneOf.length ? delete e.oneOf : e.oneOf.length < 2 && (e.type = e.oneOf[0].type, Object.keys(e.oneOf[0]).length > 1 && E("Lost properties from oneOf", e, r), delete e.oneOf);
                                    }
                                    e.type && Array.isArray(e.type) && 1 === e.type.length && (e.type = e.type[0]);
                                } else k("(Patchable) schema type must not be an array", r);
                            }
                            e.type && "null" === e.type && (delete e.type, e.nullable = !0), "array" !== e.type || e.items || (e.items = {}), "file" === e.type && (e.type = "string", e.format = "binary"), "boolean" == typeof e.required && (e.required && e.name && (void 0 === t.required && (t.required = []), Array.isArray(t.required) && t.required.push(e.name)), delete e.required), e.xml && "string" == typeof e.xml.namespace && (e.xml.namespace || delete e.xml.namespace), void 0 !== e.allowEmptyValue && (r.patches++, delete e.allowEmptyValue);
                        }(e, r, t);
                    });
                }
                function j(e, t, r) {
                    let n = r.payload.options;
                    if (p(e, t)) {
                        if (e[t].startsWith("#/components/")) ;
                        else if ("#/consumes" === e[t]) delete e[t], r.parent[r.pkey] = u(n.openapi.consumes);
                        else if ("#/produces" === e[t]) delete e[t], r.parent[r.pkey] = u(n.openapi.produces);
                        else if (e[t].startsWith("#/definitions/")) {
                            let r = e[t].replace("#/definitions/", "").split("/");
                            const o = l.jpunescape(r[0]);
                            let i = v.schemas[decodeURIComponent(o)];
                            i ? r[0] = i : E("Could not resolve reference " + e[t], e, n), e[t] = "#/components/schemas/" + r.join("/");
                        } else if (e[t].startsWith("#/parameters/")) e[t] = "#/components/parameters/" + g.sanitise(e[t].replace("#/parameters/", ""));
                        else if (e[t].startsWith("#/responses/")) e[t] = "#/components/responses/" + g.sanitise(e[t].replace("#/responses/", ""));
                        else if (e[t].startsWith("#")) {
                            let r = u(l.jptr(n.openapi, e[t]));
                            if (!1 === r) E("direct $ref not found " + e[t], e, n);
                            else if (n.refmap[e[t]]) e[t] = n.refmap[e[t]];
                            else {
                                let i = e[t];
                                i = i.replace("/properties/headers/", ""), i = i.replace("/properties/responses/", ""), i = i.replace("/properties/parameters/", ""), i = i.replace("/properties/schemas/", "");
                                let s = "schemas", a = i.lastIndexOf("/schema");
                                if (s = i.indexOf("/headers/") > a ? "headers" : i.indexOf("/responses/") > a ? "responses" : i.indexOf("/example") > a ? "examples" : i.indexOf("/x-") > a ? "extensions" : i.indexOf("/parameters/") > a ? "parameters" : "schemas", "schemas" === s && O(r, n), "responses" !== s && "extensions" !== s) {
                                    let i = s.substr(0, s.length - 1);
                                    "parameter" === i && r.name && r.name === g.sanitise(r.name) && (i = encodeURIComponent(r.name));
                                    let a = 1;
                                    for(e["x-miro"] && (o = (o = e["x-miro"]).indexOf("#") >= 0 ? o.split("#")[1].split("/").pop() : o.split("/").pop().split(".")[0], i = encodeURIComponent(g.sanitise(o)), a = ""); l.jptr(n.openapi, "#/components/" + s + "/" + i + a);)a = "" === a ? 2 : ++a;
                                    let c = "#/components/" + s + "/" + i + a, p = "";
                                    "examples" === s && (r = {
                                        value: r
                                    }, p = "/value"), l.jptr(n.openapi, c, r), n.refmap[e[t]] = c + p, e[t] = c + p;
                                }
                            }
                        }
                        if (delete e["x-miro"], Object.keys(e).length > 1) {
                            const o = e[t], i = r.path.indexOf("/schema") >= 0;
                            "preserve" === n.refSiblings || (i && "allOf" === n.refSiblings ? (delete e.$ref, r.parent[r.pkey] = {
                                allOf: [
                                    {
                                        $ref: o
                                    },
                                    e
                                ]
                            }) : r.parent[r.pkey] = {
                                $ref: o
                            });
                        }
                    }
                    var o;
                    if ("x-ms-odata" === t && "string" == typeof e[t] && e[t].startsWith("#/")) {
                        let r = e[t].replace("#/definitions/", "").replace("#/components/schemas/", "").split("/"), o = v.schemas[decodeURIComponent(r[0])];
                        o ? r[0] = o : E("Could not resolve reference " + e[t], e, n), e[t] = "#/components/schemas/" + r.join("/");
                    }
                }
                function $(e) {
                    for(let t in e)for(let r in e[t]){
                        let n = g.sanitise(r);
                        r !== n && (e[t][n] = e[t][r], delete e[t][r]);
                    }
                }
                function S(e, t) {
                    if ("basic" === e.type && (e.type = "http", e.scheme = "basic"), "oauth2" === e.type) {
                        let r = {}, n = e.flow;
                        "application" === e.flow && (n = "clientCredentials"), "accessCode" === e.flow && (n = "authorizationCode"), void 0 !== e.authorizationUrl && (r.authorizationUrl = e.authorizationUrl.split("?")[0].trim() || "/"), "string" == typeof e.tokenUrl && (r.tokenUrl = e.tokenUrl.split("?")[0].trim() || "/"), r.scopes = e.scopes || {}, e.flows = {}, e.flows[n] = r, delete e.flow, delete e.authorizationUrl, delete e.tokenUrl, delete e.scopes, void 0 !== e.name && (t.patch ? (t.patches++, delete e.name) : k("(Patchable) oauth2 securitySchemes should not have name property", t));
                    }
                }
                function C(e) {
                    return e && !e["x-s2o-delete"];
                }
                function P(e, t) {
                    if (e.$ref) e.$ref = e.$ref.replace("#/responses/", "#/components/responses/");
                    else {
                        e.type && !e.schema && (e.schema = {}), e.type && (e.schema.type = e.type), e.items && "array" !== e.items.type && (e.items.collectionFormat !== e.collectionFormat && E("Nested collectionFormats are not supported", e, t), delete e.items.collectionFormat), "array" === e.type ? ("ssv" === e.collectionFormat ? E("collectionFormat:ssv is no longer supported for headers", e, t) : "pipes" === e.collectionFormat ? E("collectionFormat:pipes is no longer supported for headers", e, t) : "multi" === e.collectionFormat ? e.explode = !0 : "tsv" === e.collectionFormat ? (E("collectionFormat:tsv is no longer supported", e, t), e["x-collectionFormat"] = "tsv") : e.style = "simple", delete e.collectionFormat) : e.collectionFormat && (t.patch ? (t.patches++, delete e.collectionFormat) : k("(Patchable) collectionFormat is only applicable to header.type array", t)), delete e.type;
                        for (let t of g.parameterTypeProperties)void 0 !== e[t] && (e.schema[t] = e[t], delete e[t]);
                        for (let t of g.arrayProperties)void 0 !== e[t] && (e.schema[t] = e[t], delete e[t]);
                    }
                }
                function I(e, t) {
                    if (e.$ref.indexOf("#/parameters/") >= 0) {
                        let t = e.$ref.split("#/parameters/");
                        e.$ref = t[0] + "#/components/parameters/" + g.sanitise(t[1]);
                    }
                    e.$ref.indexOf("#/definitions/") >= 0 && E("Definition used as parameter", e, t);
                }
                function A(e, t, r, n, o, i, s) {
                    let a, l = {}, p = !0;
                    if (t && t.consumes && "string" == typeof t.consumes) {
                        if (!s.patch) return k("(Patchable) operation.consumes must be an array", s);
                        s.patches++, t.consumes = [
                            t.consumes
                        ];
                    }
                    Array.isArray(i.consumes) || delete i.consumes;
                    let d = ((t ? t.consumes : null) || i.consumes || []).filter(g.uniqueOnly);
                    if (e && e.$ref && "string" == typeof e.$ref) {
                        I(e, s);
                        let t = decodeURIComponent(e.$ref.replace("#/components/parameters/", "")), r = !1, n = i.components.parameters[t];
                        if (n && !n["x-s2o-delete"] || !e.$ref.startsWith("#/") || (e["x-s2o-delete"] = !0, r = !0), r) {
                            let t = e.$ref, r = c(i, e.$ref);
                            !r && t.startsWith("#/") ? E("Could not resolve reference " + t, e, s) : r && (e = r);
                        }
                    }
                    if (e && (e.name || e.in)) {
                        "boolean" == typeof e["x-deprecated"] && (e.deprecated = e["x-deprecated"], delete e["x-deprecated"]), void 0 !== e["x-example"] && (e.example = e["x-example"], delete e["x-example"]), "body" === e.in || e.type || (s.patch ? (s.patches++, e.type = "string") : k("(Patchable) parameter.type is mandatory for non-body parameters", s)), e.type && "object" == typeof e.type && e.type.$ref && (e.type = c(i, e.type.$ref)), "file" === e.type && (e["x-s2o-originalType"] = e.type, a = e.type), e.description && "object" == typeof e.description && e.description.$ref && (e.description = c(i, e.description.$ref)), null === e.description && delete e.description;
                        let t = e.collectionFormat;
                        if ("array" !== e.type || t || (t = "csv"), t && ("array" !== e.type && (s.patch ? (s.patches++, delete e.collectionFormat) : k("(Patchable) collectionFormat is only applicable to param.type array", s)), "csv" !== t || "query" !== e.in && "cookie" !== e.in || (e.style = "form", e.explode = !1), "csv" !== t || "path" !== e.in && "header" !== e.in || (e.style = "simple"), "ssv" === t && ("query" === e.in ? e.style = "spaceDelimited" : E("collectionFormat:ssv is no longer supported except for in:query parameters", e, s)), "pipes" === t && ("query" === e.in ? e.style = "pipeDelimited" : E("collectionFormat:pipes is no longer supported except for in:query parameters", e, s)), "multi" === t && (e.explode = !0), "tsv" === t && (E("collectionFormat:tsv is no longer supported", e, s), e["x-collectionFormat"] = "tsv"), delete e.collectionFormat), e.type && "body" !== e.type && "formData" !== e.in) {
                            if (e.items && e.schema) E("parameter has array,items and schema", e, s);
                            else {
                                e.schema && s.patches++, e.schema && "object" == typeof e.schema || (e.schema = {}), e.schema.type = e.type, e.items && (e.schema.items = e.items, delete e.items, h(e.schema.items, null, function(r, n, o) {
                                    "collectionFormat" === n && "string" == typeof r[n] && (t && r[n] !== t && E("Nested collectionFormats are not supported", e, s), delete r[n]);
                                }));
                                for (let t of g.parameterTypeProperties)void 0 !== e[t] && (e.schema[t] = e[t]), delete e[t];
                            }
                        }
                        e.schema && O(e.schema, s), e["x-ms-skip-url-encoding"] && "query" === e.in && (e.allowReserved = !0, delete e["x-ms-skip-url-encoding"]);
                    }
                    if (e && "formData" === e.in) {
                        p = !1, l.content = {};
                        let t = "application/x-www-form-urlencoded";
                        if (d.length && d.indexOf("multipart/form-data") >= 0 && (t = "multipart/form-data"), l.content[t] = {}, e.schema) l.content[t].schema = e.schema, e.schema.$ref && (l["x-s2o-name"] = decodeURIComponent(e.schema.$ref.replace("#/components/schemas/", "")));
                        else {
                            l.content[t].schema = {}, l.content[t].schema.type = "object", l.content[t].schema.properties = {}, l.content[t].schema.properties[e.name] = {};
                            let r = l.content[t].schema, n = l.content[t].schema.properties[e.name];
                            e.description && (n.description = e.description), e.example && (n.example = e.example), e.type && (n.type = e.type);
                            for (let t of g.parameterTypeProperties)void 0 !== e[t] && (n[t] = e[t]);
                            !0 === e.required && (r.required || (r.required = []), r.required.push(e.name), l.required = !0), void 0 !== e.default && (n.default = e.default), n.properties && (n.properties = e.properties), e.allOf && (n.allOf = e.allOf), "array" === e.type && e.items && (n.items = e.items, n.items.collectionFormat && delete n.items.collectionFormat), "file" !== a && "file" !== e["x-s2o-originalType"] || (n.type = "string", n.format = "binary"), T(e, n);
                        }
                    } else e && "file" === e.type && (e.required && (l.required = e.required), l.content = {}, l.content["application/octet-stream"] = {}, l.content["application/octet-stream"].schema = {}, l.content["application/octet-stream"].schema.type = "string", l.content["application/octet-stream"].schema.format = "binary", T(e, l));
                    if (e && "body" === e.in) {
                        l.content = {}, e.name && (l["x-s2o-name"] = (t && t.operationId ? g.sanitiseAll(t.operationId) : "") + ("_" + e.name).toCamelCase()), e.description && (l.description = e.description), e.required && (l.required = e.required), t && s.rbname && e.name && (t[s.rbname] = e.name), e.schema && e.schema.$ref ? l["x-s2o-name"] = decodeURIComponent(e.schema.$ref.replace("#/components/schemas/", "")) : e.schema && "array" === e.schema.type && e.schema.items && e.schema.items.$ref && (l["x-s2o-name"] = decodeURIComponent(e.schema.items.$ref.replace("#/components/schemas/", "")) + "Array"), d.length || d.push("application/json");
                        for (let t of d)l.content[t] = {}, l.content[t].schema = u(e.schema || {}), O(l.content[t].schema, s);
                        T(e, l);
                    }
                    if (Object.keys(l).length > 0 && (e["x-s2o-delete"] = !0, t) && (t.requestBody && p ? (t.requestBody["x-s2o-overloaded"] = !0, E("Operation " + (t.operationId || o) + " has multiple requestBodies", t, s)) : (t.requestBody || (t = r[n] = function(e, t) {
                        let r = {};
                        for (let n of Object.keys(e))r[n] = e[n], "parameters" === n && (r.requestBody = {}, t.rbname && (r[t.rbname] = ""));
                        return r.requestBody = {}, r;
                    }(t, s)), t.requestBody.content && t.requestBody.content["multipart/form-data"] && t.requestBody.content["multipart/form-data"].schema && t.requestBody.content["multipart/form-data"].schema.properties && l.content["multipart/form-data"] && l.content["multipart/form-data"].schema && l.content["multipart/form-data"].schema.properties ? (t.requestBody.content["multipart/form-data"].schema.properties = Object.assign(t.requestBody.content["multipart/form-data"].schema.properties, l.content["multipart/form-data"].schema.properties), t.requestBody.content["multipart/form-data"].schema.required = (t.requestBody.content["multipart/form-data"].schema.required || []).concat(l.content["multipart/form-data"].schema.required || []), t.requestBody.content["multipart/form-data"].schema.required.length || delete t.requestBody.content["multipart/form-data"].schema.required) : t.requestBody.content && t.requestBody.content["application/x-www-form-urlencoded"] && t.requestBody.content["application/x-www-form-urlencoded"].schema && t.requestBody.content["application/x-www-form-urlencoded"].schema.properties && l.content["application/x-www-form-urlencoded"] && l.content["application/x-www-form-urlencoded"].schema && l.content["application/x-www-form-urlencoded"].schema.properties ? (t.requestBody.content["application/x-www-form-urlencoded"].schema.properties = Object.assign(t.requestBody.content["application/x-www-form-urlencoded"].schema.properties, l.content["application/x-www-form-urlencoded"].schema.properties), t.requestBody.content["application/x-www-form-urlencoded"].schema.required = (t.requestBody.content["application/x-www-form-urlencoded"].schema.required || []).concat(l.content["application/x-www-form-urlencoded"].schema.required || []), t.requestBody.content["application/x-www-form-urlencoded"].schema.required.length || delete t.requestBody.content["application/x-www-form-urlencoded"].schema.required) : (t.requestBody = Object.assign(t.requestBody, l), t.requestBody["x-s2o-name"] || (t.requestBody.schema && t.requestBody.schema.$ref ? t.requestBody["x-s2o-name"] = decodeURIComponent(t.requestBody.schema.$ref.replace("#/components/schemas/", "")).split("/").join("") : t.operationId && (t.requestBody["x-s2o-name"] = g.sanitiseAll(t.operationId)))))), e && !e["x-s2o-delete"]) {
                        delete e.type;
                        for (let t of g.parameterTypeProperties)delete e[t];
                        "path" !== e.in || void 0 !== e.required && !0 === e.required || (s.patch ? (s.patches++, e.required = !0) : k("(Patchable) path parameters must be required:true [" + e.name + " in " + o + "]", s));
                    }
                    return t;
                }
                function T(e, t) {
                    for(let r in e)r.startsWith("x-") && !r.startsWith("x-s2o") && (t[r] = e[r]);
                }
                function _(e, t, r, n, o) {
                    if (!e) return !1;
                    if (e.$ref && "string" == typeof e.$ref) e.$ref.indexOf("#/definitions/") >= 0 ? E("definition used as response: " + e.$ref, e, o) : e.$ref.startsWith("#/responses/") && (e.$ref = "#/components/responses/" + g.sanitise(decodeURIComponent(e.$ref.replace("#/responses/", ""))));
                    else {
                        if ((void 0 === e.description || null === e.description || "" === e.description && o.patch) && (o.patch ? "object" != typeof e || Array.isArray(e) || (o.patches++, e.description = y[e] || "") : k("(Patchable) response.description is mandatory", o)), void 0 !== e.schema) {
                            if (O(e.schema, o), e.schema.$ref && "string" == typeof e.schema.$ref && e.schema.$ref.startsWith("#/responses/") && (e.schema.$ref = "#/components/responses/" + g.sanitise(decodeURIComponent(e.schema.$ref.replace("#/responses/", "")))), r && r.produces && "string" == typeof r.produces) {
                                if (!o.patch) return k("(Patchable) operation.produces must be an array", o);
                                o.patches++, r.produces = [
                                    r.produces
                                ];
                            }
                            n.produces && !Array.isArray(n.produces) && delete n.produces;
                            let t = ((r ? r.produces : null) || n.produces || []).filter(g.uniqueOnly);
                            t.length || t.push("*/*"), e.content = {};
                            for (let r of t){
                                if (e.content[r] = {}, e.content[r].schema = u(e.schema), e.examples && e.examples[r]) {
                                    let t = {};
                                    t.value = e.examples[r], e.content[r].examples = {}, e.content[r].examples.response = t, delete e.examples[r];
                                }
                                "file" === e.content[r].schema.type && (e.content[r].schema = {
                                    type: "string",
                                    format: "binary"
                                });
                            }
                            delete e.schema;
                        }
                        for(let t in e.examples)e.content || (e.content = {}), e.content[t] || (e.content[t] = {}), e.content[t].examples = {}, e.content[t].examples.response = {}, e.content[t].examples.response.value = e.examples[t];
                        if (delete e.examples, e.headers) for(let t in e.headers)"status code" === t.toLowerCase() ? o.patch ? (o.patches++, delete e.headers[t]) : k('(Patchable) "Status Code" is not a valid header', o) : P(e.headers[t], o);
                    }
                }
                function R(e, t, r, n, i) {
                    for(let s in e){
                        let a = e[s];
                        a && a["x-trace"] && "object" == typeof a["x-trace"] && (a.trace = a["x-trace"], delete a["x-trace"]), a && a["x-summary"] && "string" == typeof a["x-summary"] && (a.summary = a["x-summary"], delete a["x-summary"]), a && a["x-description"] && "string" == typeof a["x-description"] && (a.description = a["x-description"], delete a["x-description"]), a && a["x-servers"] && Array.isArray(a["x-servers"]) && (a.servers = a["x-servers"], delete a["x-servers"]);
                        for(let e in a)if (g.httpMethods.indexOf(e) >= 0 || "x-amazon-apigateway-any-method" === e) {
                            let p = a[e];
                            if (p && p.parameters && Array.isArray(p.parameters)) {
                                if (a.parameters) for (let t of a.parameters)"string" == typeof t.$ref && (I(t, r), t = c(i, t.$ref)), p.parameters.find(function(e, r, n) {
                                    return e.name === t.name && e.in === t.in;
                                }) || "formData" !== t.in && "body" !== t.in && "file" !== t.type || (p = A(t, p, a, e, s, i, r), r.rbname && "" === p[r.rbname] && delete p[r.rbname]);
                                for (let t of p.parameters)p = A(t, p, a, e, e + ":" + s, i, r);
                                r.rbname && "" === p[r.rbname] && delete p[r.rbname], r.debug || p.parameters && (p.parameters = p.parameters.filter(C));
                            }
                            if (p && p.security && $(p.security), "object" == typeof p) {
                                if (!p.responses) {
                                    let e = {
                                        description: "Default response"
                                    };
                                    p.responses = {
                                        default: e
                                    };
                                }
                                for(let e in p.responses)_(p.responses[e], 0, p, i, r);
                            }
                            if (p && p["x-servers"] && Array.isArray(p["x-servers"])) p.servers = p["x-servers"], delete p["x-servers"];
                            else if (p && p.schemes && p.schemes.length) {
                                for (let e of p.schemes)if ((!i.schemes || i.schemes.indexOf(e) < 0) && (p.servers || (p.servers = []), Array.isArray(i.servers))) for (let t of i.servers){
                                    let r = u(t), n = o.parse(r.url);
                                    n.protocol = e, r.url = n.format(), p.servers.push(r);
                                }
                            }
                            if (r.debug && (p["x-s2o-consumes"] = p.consumes || [], p["x-s2o-produces"] = p.produces || []), p) {
                                if (delete p.consumes, delete p.produces, delete p.schemes, p["x-ms-examples"]) {
                                    for(let e in p["x-ms-examples"]){
                                        let t = p["x-ms-examples"][e], r = g.sanitiseAll(e);
                                        if (t.parameters) for(let r in t.parameters){
                                            let n = t.parameters[r];
                                            for (let t of (p.parameters || []).concat(a.parameters || []))t.$ref && (t = l.jptr(i, t.$ref)), t.name !== r || t.example || (t.examples || (t.examples = {}), t.examples[e] = {
                                                value: n
                                            });
                                        }
                                        if (t.responses) for(let n in t.responses){
                                            if (t.responses[n].headers) for(let e in t.responses[n].headers){
                                                let r = t.responses[n].headers[e];
                                                for(let t in p.responses[n].headers)t === e && (p.responses[n].headers[t].example = r);
                                            }
                                            if (t.responses[n].body && (i.components.examples[r] = {
                                                value: u(t.responses[n].body)
                                            }, p.responses[n] && p.responses[n].content)) for(let t in p.responses[n].content){
                                                let o = p.responses[n].content[t];
                                                o.examples || (o.examples = {}), o.examples[e] = {
                                                    $ref: "#/components/examples/" + r
                                                };
                                            }
                                        }
                                    }
                                    delete p["x-ms-examples"];
                                }
                                if (p.parameters && 0 === p.parameters.length && delete p.parameters, p.requestBody) {
                                    let r = p.operationId ? g.sanitiseAll(p.operationId) : g.sanitiseAll(e + s).toCamelCase(), o = g.sanitise(p.requestBody["x-s2o-name"] || r || "");
                                    delete p.requestBody["x-s2o-name"];
                                    let i = JSON.stringify(p.requestBody), a = g.hash(i);
                                    if (!n[a]) {
                                        let e = {};
                                        e.name = o, e.body = p.requestBody, e.refs = [], n[a] = e;
                                    }
                                    let c = "#/" + t + "/" + encodeURIComponent(l.jpescape(s)) + "/" + e + "/requestBody";
                                    n[a].refs.push(c);
                                }
                            }
                        }
                        if (a && a.parameters) {
                            for(let e in a.parameters)A(a.parameters[e], null, a, null, s, i, r);
                            !r.debug && Array.isArray(a.parameters) && (a.parameters = a.parameters.filter(C));
                        }
                    }
                }
                function D(e) {
                    return e && e.url && "string" == typeof e.url ? (e.url = e.url.split("{{").join("{"), e.url = e.url.split("}}").join("}"), e.url.replace(/\{(.+?)\}/g, function(t, r) {
                        e.variables || (e.variables = {}), e.variables[r] = {
                            default: "unknown"
                        };
                    }), e) : e;
                }
                function z(e, t, r) {
                    if (void 0 === e.info || null === e.info) {
                        if (!t.patch) return r(new w("(Patchable) info object is mandatory"));
                        t.patches++, e.info = {
                            version: "",
                            title: ""
                        };
                    }
                    if ("object" != typeof e.info || Array.isArray(e.info)) return r(new w("info must be an object"));
                    if (void 0 === e.info.title || null === e.info.title) {
                        if (!t.patch) return r(new w("(Patchable) info.title cannot be null"));
                        t.patches++, e.info.title = "";
                    }
                    if (void 0 === e.info.version || null === e.info.version) {
                        if (!t.patch) return r(new w("(Patchable) info.version cannot be null"));
                        t.patches++, e.info.version = "";
                    }
                    if ("string" != typeof e.info.version) {
                        if (!t.patch) return r(new w("(Patchable) info.version must be a string"));
                        t.patches++, e.info.version = e.info.version.toString();
                    }
                    if (void 0 !== e.info.logo) {
                        if (!t.patch) return r(new w("(Patchable) info should not have logo property"));
                        t.patches++, e.info["x-logo"] = e.info.logo, delete e.info.logo;
                    }
                    if (void 0 !== e.info.termsOfService) {
                        if (null === e.info.termsOfService) {
                            if (!t.patch) return r(new w("(Patchable) info.termsOfService cannot be null"));
                            t.patches++, e.info.termsOfService = "";
                        }
                        try {
                            new URL(e.info.termsOfService);
                        } catch (n) {
                            if (!t.patch) return r(new w("(Patchable) info.termsOfService must be a URL"));
                            t.patches++, delete e.info.termsOfService;
                        }
                    }
                }
                function L(e, t, r) {
                    if (void 0 === e.paths) {
                        if (!t.patch) return r(new w("(Patchable) paths object is mandatory"));
                        t.patches++, e.paths = {};
                    }
                }
                function N(e, t, r) {
                    return i(r, new Promise(function(r, n) {
                        if (e || (e = {}), t.original = e, t.text || (t.text = a.stringify(e)), t.externals = [], t.externalRefs = {}, t.rewriteRefs = !0, t.preserveMiro = !0, t.promise = {}, t.promise.resolve = r, t.promise.reject = n, t.patches = 0, t.cache || (t.cache = {}), t.source && (t.cache[t.source] = t.original), function(e, t) {
                            const r = new WeakSet;
                            h(e, {
                                identityDetection: !0
                            }, function(e, n, o) {
                                "object" == typeof e[n] && null !== e[n] && (r.has(e[n]) ? t.anchors ? e[n] = u(e[n]) : k("YAML anchor or merge key at " + o.path, t) : r.add(e[n]));
                            });
                        }(e, t), e.openapi && "string" == typeof e.openapi && e.openapi.startsWith("3.")) return t.openapi = d(e), z(t.openapi, t, n), L(t.openapi, t, n), void m.optionalResolve(t).then(function() {
                            return t.direct ? r(t.openapi) : r(t);
                        }).catch(function(e) {
                            console.warn(e), n(e);
                        });
                        if (!e.swagger || "2.0" != e.swagger) return n(new w("Unsupported swagger/OpenAPI version: " + (e.openapi ? e.openapi : e.swagger)));
                        let o = t.openapi = {};
                        if (o.openapi = "string" == typeof t.targetVersion && t.targetVersion.startsWith("3.") ? t.targetVersion : x, t.origin) {
                            o["x-origin"] || (o["x-origin"] = []);
                            let r = {};
                            r.url = t.source || t.origin, r.format = "swagger", r.version = e.swagger, r.converter = {}, r.converter.url = "https://github.com/mermade/oas-kit", r.converter.version = b, o["x-origin"].push(r);
                        }
                        if (o = Object.assign(o, d(e)), delete o.swagger, h(o, {}, function(e, t, r) {
                            null === e[t] && !t.startsWith("x-") && "default" !== t && r.path.indexOf("/example") < 0 && delete e[t];
                        }), e.host) for (let t of Array.isArray(e.schemes) ? e.schemes : [
                            ""
                        ]){
                            let r = {}, n = (e.basePath || "").replace(/\/$/, "");
                            r.url = (t ? t + ":" : "") + "//" + e.host + n, D(r), o.servers || (o.servers = []), o.servers.push(r);
                        }
                        else if (e.basePath) {
                            let t = {};
                            t.url = e.basePath, D(t), o.servers || (o.servers = []), o.servers.push(t);
                        }
                        if (delete o.host, delete o.basePath, o["x-servers"] && Array.isArray(o["x-servers"]) && (o.servers = o["x-servers"], delete o["x-servers"]), e["x-ms-parameterized-host"]) {
                            let t = e["x-ms-parameterized-host"], r = {};
                            r.url = t.hostTemplate + (e.basePath ? e.basePath : ""), r.variables = {};
                            const n = r.url.match(/\{\w+\}/g);
                            for(let e in t.parameters){
                                let i = t.parameters[e];
                                i.$ref && (i = u(c(o, i.$ref))), e.startsWith("x-") || (delete i.required, delete i.type, delete i.in, void 0 === i.default && (i.enum ? i.default = i.enum[0] : i.default = "none"), i.name || (i.name = n[e].replace("{", "").replace("}", "")), r.variables[i.name] = i, delete i.name);
                            }
                            o.servers || (o.servers = []), !1 === t.useSchemePrefix ? o.servers.push(r) : e.schemes.forEach((e)=>{
                                o.servers.push(Object.assign({}, r, {
                                    url: e + "://" + r.url
                                }));
                            }), delete o["x-ms-parameterized-host"];
                        }
                        z(o, t, n), L(o, t, n), "string" == typeof o.consumes && (o.consumes = [
                            o.consumes
                        ]), "string" == typeof o.produces && (o.produces = [
                            o.produces
                        ]), o.components = {}, o["x-callbacks"] && (o.components.callbacks = o["x-callbacks"], delete o["x-callbacks"]), o.components.examples = {}, o.components.headers = {}, o["x-links"] && (o.components.links = o["x-links"], delete o["x-links"]), o.components.parameters = o.parameters || {}, o.components.responses = o.responses || {}, o.components.requestBodies = {}, o.components.securitySchemes = o.securityDefinitions || {}, o.components.schemas = o.definitions || {}, delete o.definitions, delete o.responses, delete o.parameters, delete o.securityDefinitions, m.optionalResolve(t).then(function() {
                            (function(e, t) {
                                let r = {};
                                v = {
                                    schemas: {}
                                }, e.security && $(e.security);
                                for(let r in e.components.securitySchemes){
                                    let n = g.sanitise(r);
                                    r !== n && (e.components.securitySchemes[n] && k("Duplicate sanitised securityScheme name " + n, t), e.components.securitySchemes[n] = e.components.securitySchemes[r], delete e.components.securitySchemes[r]), S(e.components.securitySchemes[n], t);
                                }
                                for(let r in e.components.schemas){
                                    let n = g.sanitiseAll(r), o = "";
                                    if (r !== n) {
                                        for(; e.components.schemas[n + o];)o = o ? ++o : 2;
                                        e.components.schemas[n + o] = e.components.schemas[r], delete e.components.schemas[r];
                                    }
                                    v.schemas[r] = n + o, O(e.components.schemas[n + o], t);
                                }
                                t.refmap = {}, h(e, {
                                    payload: {
                                        options: t
                                    }
                                }, j), function(e, t) {
                                    for(let r in t.refmap)l.jptr(e, r, {
                                        $ref: t.refmap[r]
                                    });
                                }(e, t);
                                for(let r in e.components.parameters){
                                    let n = g.sanitise(r);
                                    r !== n && (e.components.parameters[n] && k("Duplicate sanitised parameter name " + n, t), e.components.parameters[n] = e.components.parameters[r], delete e.components.parameters[r]), A(e.components.parameters[n], null, null, null, n, e, t);
                                }
                                for(let r in e.components.responses){
                                    let n = g.sanitise(r);
                                    r !== n && (e.components.responses[n] && k("Duplicate sanitised response name " + n, t), e.components.responses[n] = e.components.responses[r], delete e.components.responses[r]);
                                    let o = e.components.responses[n];
                                    if (_(o, 0, null, e, t), o.headers) for(let e in o.headers)"status code" === e.toLowerCase() ? t.patch ? (t.patches++, delete o.headers[e]) : k('(Patchable) "Status Code" is not a valid header', t) : P(o.headers[e], t);
                                }
                                for(let t in e.components.requestBodies){
                                    let n = e.components.requestBodies[t], o = JSON.stringify(n), i = g.hash(o), s = {};
                                    s.name = t, s.body = n, s.refs = [], r[i] = s;
                                }
                                if (R(e.paths, "paths", t, r, e), e["x-ms-paths"] && R(e["x-ms-paths"], "x-ms-paths", t, r, e), !t.debug) for(let t in e.components.parameters)e.components.parameters[t]["x-s2o-delete"] && delete e.components.parameters[t];
                                t.debug && (e["x-s2o-consumes"] = e.consumes || [], e["x-s2o-produces"] = e.produces || []), delete e.consumes, delete e.produces, delete e.schemes;
                                let n = [];
                                if (e.components.requestBodies = {}, !t.resolveInternal) {
                                    let t = 1;
                                    for(let o in r){
                                        let i = r[o];
                                        if (i.refs.length > 1) {
                                            let r = "";
                                            for(i.name || (i.name = "requestBody", r = t++); n.indexOf(i.name + r) >= 0;)r = r ? ++r : 2;
                                            i.name = i.name + r, n.push(i.name), e.components.requestBodies[i.name] = u(i.body);
                                            for(let t in i.refs){
                                                let r = {};
                                                r.$ref = "#/components/requestBodies/" + i.name, l.jptr(e, i.refs[t], r);
                                            }
                                        }
                                    }
                                }
                                e.components.responses && 0 === Object.keys(e.components.responses).length && delete e.components.responses, e.components.parameters && 0 === Object.keys(e.components.parameters).length && delete e.components.parameters, e.components.examples && 0 === Object.keys(e.components.examples).length && delete e.components.examples, e.components.requestBodies && 0 === Object.keys(e.components.requestBodies).length && delete e.components.requestBodies, e.components.securitySchemes && 0 === Object.keys(e.components.securitySchemes).length && delete e.components.securitySchemes, e.components.headers && 0 === Object.keys(e.components.headers).length && delete e.components.headers, e.components.schemas && 0 === Object.keys(e.components.schemas).length && delete e.components.schemas, e.components && 0 === Object.keys(e.components).length && delete e.components;
                            })(t.openapi, t), t.direct ? r(t.openapi) : r(t);
                        }).catch(function(e) {
                            console.warn(e), n(e);
                        });
                    }));
                }
                function M(e, t, r) {
                    return i(r, new Promise(function(r, n) {
                        let o = null, i = null;
                        try {
                            o = JSON.parse(e), t.text = JSON.stringify(o, null, 2);
                        } catch (r) {
                            i = r;
                            try {
                                o = a.parse(e, {
                                    schema: "core",
                                    prettyErrors: !0
                                }), t.sourceYaml = !0, t.text = e;
                            } catch (e) {
                                i = e;
                            }
                        }
                        o ? N(o, t).then((e)=>r(e)).catch((e)=>n(e)) : n(new w(i ? i.message : "Could not parse string"));
                    }));
                }
                e.exports = {
                    S2OError: w,
                    targetVersion: x,
                    convert: N,
                    convertObj: N,
                    convertUrl: function(e, t, r) {
                        return i(r, new Promise(function(r, n) {
                            t.origin = !0, t.source || (t.source = e), t.verbose && console.warn("GET " + e), t.fetch || (t.fetch = s);
                            const o = Object.assign({}, t.fetchOptions, {
                                agent: t.agent
                            });
                            t.fetch(e, o).then(function(t) {
                                if (200 !== t.status) throw new w(`Received status code ${t.status}: ${e}`);
                                return t.text();
                            }).then(function(e) {
                                M(e, t).then((e)=>r(e)).catch((e)=>n(e));
                            }).catch(function(e) {
                                n(e);
                            });
                        }));
                    },
                    convertStr: M,
                    convertFile: function(e, t, r) {
                        return i(r, new Promise(function(r, o) {
                            n.readFile(e, t.encoding || "utf8", function(n, i) {
                                n ? o(n) : (t.sourceFile = e, M(i, t).then((e)=>r(e)).catch((e)=>o(e)));
                            });
                        }));
                    },
                    convertStream: function(e, t, r) {
                        return i(r, new Promise(function(r, n) {
                            let o = "";
                            e.on("data", function(e) {
                                o += e;
                            }).on("end", function() {
                                M(o, t).then((e)=>r(e)).catch((e)=>n(e));
                            });
                        }));
                    }
                };
            },
            665: function(e, t, r) {
                "use strict";
                const n = r(375);
                e.exports = {
                    statusCodes: Object.assign({}, {
                        default: "Default response",
                        "1XX": "Informational",
                        103: "Early hints",
                        "2XX": "Successful",
                        "3XX": "Redirection",
                        "4XX": "Client Error",
                        "5XX": "Server Error",
                        "7XX": "Developer Error"
                    }, n.STATUS_CODES)
                };
            },
            884: function(e) {
                "use strict";
                e.exports = (parcelRequire("exLvJ"));
            },
            648: function(e) {
                "use strict";
                e.exports = (parcelRequire("hgGe6"));
            },
            230: function(e) {
                "use strict";
                e.exports = (parcelRequire("i6sfg"));
            },
            115: function(e) {
                "use strict";
                e.exports = (parcelRequire("2sxTc"));
            },
            725: function(e) {
                "use strict";
                e.exports = void 0;
            },
            375: function() {},
            430: function(e) {
                "use strict";
                e.exports = {
                    rE: "7.0.8"
                };
            }
        }, t = {};
        function r(n) {
            var o = t[n];
            if (void 0 !== o) return o.exports;
            var i = t[n] = {
                id: n,
                exports: {}
            };
            return e[n](i, i.exports, r), i.exports;
        }
        r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, {
                a: t
            }), t;
        }, r.d = function(e, t) {
            for(var n in t)r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.nc = void 0;
        var n = {};
        return function() {
            "use strict";
            r.r(n), r.d(n, {
                AUTH_TYPES: function() {
                    return dc;
                },
                ApiContentWrap: function() {
                    return Ku;
                },
                ApiInfo: function() {
                    return Ec;
                },
                ApiInfoModel: function() {
                    return Hr;
                },
                ApiLogo: function() {
                    return Sc;
                },
                AppStore: function() {
                    return gc;
                },
                ArraySchema: function() {
                    return xl;
                },
                BackgroundStub: function() {
                    return ed;
                },
                BodyContent: function() {
                    return gp;
                },
                COMPONENT_REGEXP: function() {
                    return Qr;
                },
                CallbackModel: function() {
                    return mn;
                },
                ClipboardService: function() {
                    return Hs;
                },
                ContentItem: function() {
                    return Cu;
                },
                ContentItems: function() {
                    return Su;
                },
                DiscriminatorDropdown: function() {
                    return al;
                },
                Dropdown: function() {
                    return fs;
                },
                DropdownLabel: function() {
                    return da;
                },
                DropdownOrLabel: function() {
                    return Os;
                },
                DropdownWrapper: function() {
                    return ha;
                },
                ErrorBoundary: function() {
                    return ne;
                },
                Example: function() {
                    return ca;
                },
                ExampleModel: function() {
                    return Un;
                },
                ExternalExample: function() {
                    return pa;
                },
                FieldModel: function() {
                    return Yn;
                },
                GROUP_DEPTH: function() {
                    return Xo;
                },
                GroupModel: function() {
                    return Bo;
                },
                HistoryService: function() {
                    return Ut;
                },
                IS_BROWSER: function() {
                    return s;
                },
                InvertedSimpleDropdown: function() {
                    return ma;
                },
                JsonPointer: function() {
                    return Ee;
                },
                JsonViewer: function() {
                    return oa;
                },
                LEGACY_REGEXP: function() {
                    return Fr;
                },
                Loading: function() {
                    return ae;
                },
                MDX_COMPONENT_REGEXP: function() {
                    return Br;
                },
                Markdown: function() {
                    return Ms;
                },
                MarkdownRenderer: function() {
                    return Wr;
                },
                MarkerService: function() {
                    return Ht;
                },
                MediaContentModel: function() {
                    return to;
                },
                MediaTypeModel: function() {
                    return Zn;
                },
                MediaTypesSwitch: function() {
                    return ip;
                },
                MenuBuilder: function() {
                    return Ko;
                },
                MenuItem: function() {
                    return Mu;
                },
                MenuItemLabel: function() {
                    return Fc;
                },
                MenuItemLi: function() {
                    return Mc;
                },
                MenuItemTitle: function() {
                    return Bc;
                },
                MenuItemUl: function() {
                    return Nc;
                },
                MenuItems: function() {
                    return Fu;
                },
                MenuStore: function() {
                    return oi;
                },
                MiddlePanel: function() {
                    return pi;
                },
                MimeLabel: function() {
                    return ua;
                },
                NoSampleLabel: function() {
                    return fa;
                },
                OLD_SECURITY_DEFINITIONS_JSX_NAME: function() {
                    return ht;
                },
                ObjectSchema: function() {
                    return ll;
                },
                OneOfButton: function() {
                    return Pl;
                },
                OneOfSchema: function() {
                    return Il;
                },
                OpenAPIParser: function() {
                    return Sn;
                },
                Operation: function() {
                    return xu;
                },
                OperationBadge: function() {
                    return zc;
                },
                OperationItem: function() {
                    return Au;
                },
                OperationMenuItemContent: function() {
                    return qu;
                },
                OperationModel: function() {
                    return xo;
                },
                OptionsConsumer: function() {
                    return ue;
                },
                OptionsContext: function() {
                    return ce;
                },
                OptionsProvider: function() {
                    return pe;
                },
                Parameters: function() {
                    return mp;
                },
                PayloadSamples: function() {
                    return Kp;
                },
                Redoc: function() {
                    return cd;
                },
                RedocAttribution: function() {
                    return Qc;
                },
                RedocNormalizedOptions: function() {
                    return W;
                },
                RedocStandalone: function() {
                    return gd;
                },
                RedocWrap: function() {
                    return Xu;
                },
                RequestBodyModel: function() {
                    return ro;
                },
                ResponseDetails: function() {
                    return Ap;
                },
                ResponseHeaders: function() {
                    return jp;
                },
                ResponseModel: function() {
                    return ho;
                },
                ResponseSamples: function() {
                    return du;
                },
                ResponseTitle: function() {
                    return vp;
                },
                ResponseView: function() {
                    return Tp;
                },
                ResponsesList: function() {
                    return Rp;
                },
                RightPanel: function() {
                    return di;
                },
                Row: function() {
                    return mi;
                },
                SCHEMA_DEFINITION_JSX_NAME: function() {
                    return mt;
                },
                SECTION_ATTR: function() {
                    return ni;
                },
                SECURITY_DEFINITIONS_JSX_NAME: function() {
                    return dt;
                },
                SECURITY_SCHEMES_SECTION_PREFIX: function() {
                    return ft;
                },
                Schema: function() {
                    return Fl;
                },
                SchemaDefinition: function() {
                    return Yl;
                },
                SchemaModel: function() {
                    return qn;
                },
                ScrollService: function() {
                    return li;
                },
                SearchBox: function() {
                    return ld;
                },
                SearchStore: function() {
                    return ci;
                },
                Section: function() {
                    return ui;
                },
                SectionItem: function() {
                    return Iu;
                },
                SecurityDefs: function() {
                    return hc;
                },
                SecuritySchemeModel: function() {
                    return Io;
                },
                SecuritySchemesModel: function() {
                    return Ao;
                },
                SideMenu: function() {
                    return Qu;
                },
                SideNavStyleEnum: function() {
                    return R;
                },
                SimpleDropdown: function() {
                    return gs;
                },
                SourceCode: function() {
                    return ia;
                },
                SourceCodeWithCopy: function() {
                    return sa;
                },
                SpecStore: function() {
                    return No;
                },
                StickyResponsiveSidebar: function() {
                    return Zu;
                },
                StoreBuilder: function() {
                    return $i;
                },
                StoreConsumer: function() {
                    return ji;
                },
                StoreContext: function() {
                    return Ei;
                },
                StoreProvider: function() {
                    return Oi;
                },
                StyledMarkdownBlock: function() {
                    return Cs;
                },
                ThemeProvider: function() {
                    return X;
                },
                Throttle: function() {
                    return $t;
                },
                alphabeticallyByProp: function() {
                    return qt;
                },
                appendToMdHeading: function() {
                    return y;
                },
                argValueToBoolean: function() {
                    return Q;
                },
                buildComponentComment: function() {
                    return Ur;
                },
                concatRefStacks: function() {
                    return $n;
                },
                convertSwagger2OpenAPI: function() {
                    return be;
                },
                createGlobalStyle: function() {
                    return G;
                },
                createStore: function() {
                    return fc;
                },
                css: function() {
                    return Y;
                },
                debugTime: function() {
                    return St;
                },
                debugTimeEnd: function() {
                    return Ct;
                },
                detectType: function() {
                    return Be;
                },
                escapeHTMLAttrChars: function() {
                    return C;
                },
                expandDefaultServerVariables: function() {
                    return pt;
                },
                extensionsHook: function() {
                    return te;
                },
                extractExtensions: function() {
                    return xt;
                },
                flattenByProp: function() {
                    return m;
                },
                getBasePath: function() {
                    return O;
                },
                getContentWithLegacyExamples: function() {
                    return wt;
                },
                getDefinitionName: function() {
                    return rt;
                },
                getOperationSummary: function() {
                    return qe;
                },
                getSerializedValue: function() {
                    return Xe;
                },
                getStatusCodeType: function() {
                    return Le;
                },
                highlight: function() {
                    return jt;
                },
                history: function() {
                    return Wt;
                },
                html2Str: function() {
                    return l;
                },
                humanizeConstraints: function() {
                    return it;
                },
                humanizeNumberRange: function() {
                    return ot;
                },
                isAbsoluteUrl: function() {
                    return k;
                },
                isArray: function() {
                    return I;
                },
                isBoolean: function() {
                    return A;
                },
                isFormUrlEncoded: function() {
                    return We;
                },
                isJsonLike: function() {
                    return Ue;
                },
                isNamedDefinition: function() {
                    return tt;
                },
                isNumeric: function() {
                    return g;
                },
                isObject: function() {
                    return x;
                },
                isOperationName: function() {
                    return Me;
                },
                isPayloadSample: function() {
                    return yo;
                },
                isPrimitiveType: function() {
                    return Qe;
                },
                isRedocExtension: function() {
                    return bt;
                },
                isStatusCode: function() {
                    return ze;
                },
                keyframes: function() {
                    return Z;
                },
                langFromMime: function() {
                    return Ke;
                },
                loadAndBundleSpec: function() {
                    return ye;
                },
                mapLang: function() {
                    return Ot;
                },
                mapValues: function() {
                    return h;
                },
                mapWithLast: function() {
                    return d;
                },
                media: function() {
                    return K;
                },
                memoize: function() {
                    return Mt;
                },
                menuItemDepth: function() {
                    return qc;
                },
                mergeObjects: function() {
                    return b;
                },
                mergeParams: function() {
                    return lt;
                },
                mergeSimilarMediaTypes: function() {
                    return ct;
                },
                normalizeServers: function() {
                    return ut;
                },
                pluralizeType: function() {
                    return vt;
                },
                pushRef: function() {
                    return jn;
                },
                querySelector: function() {
                    return a;
                },
                removeQueryStringAndHash: function() {
                    return $;
                },
                resolveUrl: function() {
                    return E;
                },
                safeSlugify: function() {
                    return w;
                },
                scrollIntoViewIfNeeded: function() {
                    return c;
                },
                serializeParameterValue: function() {
                    return Ze;
                },
                serializeParameterValueWithMime: function() {
                    return Ge;
                },
                setSecuritySchemePrefix: function() {
                    return gt;
                },
                shortenHTTPVerb: function() {
                    return yt;
                },
                sortByField: function() {
                    return at;
                },
                sortByRequired: function() {
                    return st;
                },
                stripTrailingSlash: function() {
                    return f;
                },
                styled: function() {
                    return ee;
                },
                titleize: function() {
                    return j;
                },
                unescapeHTMLChars: function() {
                    return P;
                },
                urlFormEncodePayload: function() {
                    return Ye;
                },
                useStore: function() {
                    return Si;
                }
            });
            var e = (parcelRequire("acw62")), t = (parcelRequire("gUqIv"));
            const o = {
                spacing: {
                    unit: 5,
                    sectionHorizontal: ({ spacing: e })=>8 * e.unit,
                    sectionVertical: ({ spacing: e })=>8 * e.unit
                },
                breakpoints: {
                    small: "50rem",
                    medium: "75rem",
                    large: "105rem"
                },
                colors: {
                    tonalOffset: .2,
                    primary: {
                        main: "#32329f",
                        light: ({ colors: e })=>(0, t.lighten)(e.tonalOffset, e.primary.main),
                        dark: ({ colors: e })=>(0, t.darken)(e.tonalOffset, e.primary.main),
                        contrastText: ({ colors: e })=>(0, t.readableColor)(e.primary.main)
                    },
                    success: {
                        main: "#1d8127",
                        light: ({ colors: e })=>(0, t.lighten)(2 * e.tonalOffset, e.success.main),
                        dark: ({ colors: e })=>(0, t.darken)(e.tonalOffset, e.success.main),
                        contrastText: ({ colors: e })=>(0, t.readableColor)(e.success.main)
                    },
                    warning: {
                        main: "#ffa500",
                        light: ({ colors: e })=>(0, t.lighten)(e.tonalOffset, e.warning.main),
                        dark: ({ colors: e })=>(0, t.darken)(e.tonalOffset, e.warning.main),
                        contrastText: ({ colors: e })=>(0, t.readableColor)(e.warning.main)
                    },
                    error: {
                        main: "#d41f1c",
                        light: ({ colors: e })=>(0, t.lighten)(e.tonalOffset, e.error.main),
                        dark: ({ colors: e })=>(0, t.darken)(e.tonalOffset, e.error.main),
                        contrastText: ({ colors: e })=>(0, t.readableColor)(e.error.main)
                    },
                    gray: {
                        50: "#FAFAFA",
                        100: "#F5F5F5"
                    },
                    text: {
                        primary: "#333333",
                        secondary: ({ colors: e })=>(0, t.lighten)(e.tonalOffset, e.text.primary)
                    },
                    border: {
                        dark: "rgba(0,0,0, 0.1)",
                        light: "#ffffff"
                    },
                    responses: {
                        success: {
                            color: ({ colors: e })=>e.success.main,
                            backgroundColor: ({ colors: e })=>(0, t.transparentize)(.93, e.success.main),
                            tabTextColor: ({ colors: e })=>(0, t.lighten)(e.tonalOffset, e.responses.success.color)
                        },
                        error: {
                            color: ({ colors: e })=>e.error.main,
                            backgroundColor: ({ colors: e })=>(0, t.transparentize)(.93, e.error.main),
                            tabTextColor: ({ colors: e })=>(0, t.lighten)(e.tonalOffset, e.responses.error.color)
                        },
                        redirect: {
                            color: ({ colors: e })=>e.warning.dark,
                            backgroundColor: ({ colors: e })=>(0, t.transparentize)(.93, e.responses.redirect.color),
                            tabTextColor: ({ colors: e })=>(0, t.lighten)(e.tonalOffset, e.responses.redirect.color)
                        },
                        info: {
                            color: "#186c8e",
                            backgroundColor: ({ colors: e })=>(0, t.transparentize)(.93, e.responses.info.color),
                            tabTextColor: ({ colors: e })=>(0, t.lighten)(e.tonalOffset, e.responses.info.color)
                        }
                    },
                    http: {
                        get: "#2F8132",
                        post: "#186FAF",
                        put: "#95507c",
                        options: "#947014",
                        patch: "#bf581d",
                        delete: "#cc3333",
                        basic: "#707070",
                        link: "#07818F",
                        head: "#A23DAD"
                    }
                },
                schema: {
                    linesColor: (e)=>(0, t.lighten)(e.colors.tonalOffset, (0, t.desaturate)(e.colors.tonalOffset, e.colors.primary.main)),
                    defaultDetailsWidth: "75%",
                    typeNameColor: (e)=>e.colors.text.secondary,
                    typeTitleColor: (e)=>e.schema.typeNameColor,
                    requireLabelColor: (e)=>e.colors.error.main,
                    labelsTextSize: "0.9em",
                    nestingSpacing: "1em",
                    nestedBackground: "#fafafa",
                    arrow: {
                        size: "1.1em",
                        color: (e)=>e.colors.text.secondary
                    }
                },
                typography: {
                    fontSize: "14px",
                    lineHeight: "1.5em",
                    fontWeightRegular: "400",
                    fontWeightBold: "600",
                    fontWeightLight: "300",
                    fontFamily: "Roboto, sans-serif",
                    smoothing: "antialiased",
                    optimizeSpeed: !0,
                    headings: {
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "400",
                        lineHeight: "1.6em"
                    },
                    code: {
                        fontSize: "13px",
                        fontFamily: "Courier, monospace",
                        lineHeight: ({ typography: e })=>e.lineHeight,
                        fontWeight: ({ typography: e })=>e.fontWeightRegular,
                        color: "#c62828",
                        backgroundColor: "rgba(38, 50, 56, 0.05)",
                        wrap: !1
                    },
                    links: {
                        color: ({ colors: e })=>e.primary.main,
                        visited: ({ typography: e })=>e.links.color,
                        hover: ({ typography: e })=>(0, t.lighten)(.2, e.links.color),
                        textDecoration: "underline",
                        hoverTextDecoration: "underline"
                    }
                },
                sidebar: {
                    width: "260px",
                    backgroundColor: "#fafafa",
                    textColor: "#333333",
                    activeTextColor: (e)=>e.sidebar.textColor !== o.sidebar.textColor ? e.sidebar.textColor : e.colors.primary.main,
                    groupItems: {
                        activeBackgroundColor: (e)=>(0, t.darken)(.1, e.sidebar.backgroundColor),
                        activeTextColor: (e)=>e.sidebar.activeTextColor,
                        textTransform: "uppercase"
                    },
                    level1Items: {
                        activeBackgroundColor: (e)=>(0, t.darken)(.05, e.sidebar.backgroundColor),
                        activeTextColor: (e)=>e.sidebar.activeTextColor,
                        textTransform: "none"
                    },
                    arrow: {
                        size: "1.5em",
                        color: (e)=>e.sidebar.textColor
                    }
                },
                logo: {
                    maxHeight: ({ sidebar: e })=>e.width,
                    maxWidth: ({ sidebar: e })=>e.width,
                    gutter: "2px"
                },
                rightPanel: {
                    backgroundColor: "#263238",
                    width: "40%",
                    textColor: "#ffffff",
                    servers: {
                        overlay: {
                            backgroundColor: "#fafafa",
                            textColor: "#263238"
                        },
                        url: {
                            backgroundColor: "#fff"
                        }
                    }
                },
                codeBlock: {
                    backgroundColor: ({ rightPanel: e })=>(0, t.darken)(.1, e.backgroundColor)
                },
                fab: {
                    backgroundColor: "#f2f2f2",
                    color: "#0065FB"
                }
            };
            var i = o;
            const s = "undefined" != typeof window && "HTMLElement" in window;
            function a(e) {
                return "undefined" != typeof document ? document.querySelector(e) : null;
            }
            function l(e) {
                return e.split(/<[^>]+>/).map((e)=>e.trim()).filter((e)=>e.length > 0).join(" ");
            }
            function c(e, t = !0) {
                const r = e.parentNode;
                if (!r) return;
                const n = window.getComputedStyle(r, void 0), o = parseInt(n.getPropertyValue("border-top-width"), 10), i = parseInt(n.getPropertyValue("border-left-width"), 10), s = e.offsetTop - r.offsetTop < r.scrollTop, a = e.offsetTop - r.offsetTop + e.clientHeight - o > r.scrollTop + r.clientHeight, l = e.offsetLeft - r.offsetLeft < r.scrollLeft, c1 = e.offsetLeft - r.offsetLeft + e.clientWidth - i > r.scrollLeft + r.clientWidth, p = s && !a;
                (s || a) && t && (r.scrollTop = e.offsetTop - r.offsetTop - r.clientHeight / 2 - o + e.clientHeight / 2), (l || c1) && t && (r.scrollLeft = e.offsetLeft - r.offsetLeft - r.clientWidth / 2 - i + e.clientWidth / 2), (s || a || l || c1) && !t && e.scrollIntoView(p);
            }
            var p = (parcelRequire("1Df9f")), u = r.n(p);
            function d(e, t) {
                const r = [];
                for(let n = 0; n < e.length - 1; n++)r.push(t(e[n], !1));
                return 0 !== e.length && r.push(t(e[e.length - 1], !0)), r;
            }
            function h(e, t) {
                const r = {};
                for(const n in e)e.hasOwnProperty(n) && (r[n] = t(e[n], n, e));
                return r;
            }
            function m(e, t) {
                const r = [], n = (e)=>{
                    for (const o of e)r.push(o), o[t] && n(o[t]);
                };
                return n(e), r;
            }
            function f(e) {
                return e.endsWith("/") ? e.substring(0, e.length - 1) : e;
            }
            function g(e) {
                return !isNaN(parseFloat(e)) && isFinite(e);
            }
            function y(e, t, r) {
                const n = new RegExp(`(^|\\n)#\\s?${t}\\s*\\n`, "i"), o = new RegExp(`((\\n|^)#\\s*${t}\\s*(\\n|$)(?:.|\\n)*?)(\\n#|$)`, "i");
                if (n.test(e)) return e.replace(o, `$1\n\n${r}\n$4`);
                {
                    const n = "" === e || e.endsWith("\n\n") ? "" : e.endsWith("\n") ? "\n" : "\n\n";
                    return `${e}${n}# ${t}\n\n${r}`;
                }
            }
            const b = (e, ...t)=>{
                if (!t.length) return e;
                const r = t.shift();
                return void 0 === r ? e : (v(e) && v(r) && Object.keys(r).forEach((t)=>{
                    Object.prototype.hasOwnProperty.call(r, t) && "__proto__" !== t && (v(r[t]) ? (e[t] || (e[t] = {}), b(e[t], r[t])) : e[t] = r[t]);
                }), b(e, ...t));
            }, x = (e)=>null !== e && "object" == typeof e, v = (e)=>x(e) && !I(e);
            function w(e) {
                return u()(e) || e.toString().toLowerCase().replace(/\s+/g, "-").replace(/&/g, "-and-").replace(/\--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
            }
            function k(e) {
                return /(?:^[a-z][a-z0-9+.-]*:|\/\/)/i.test(e);
            }
            function E(e, t) {
                let r;
                if (t.startsWith("//")) try {
                    r = `${new URL(e).protocol || "https:"}${t}`;
                } catch (e) {
                    r = `https:${t}`;
                }
                else if (k(t)) r = t;
                else if (t.startsWith("/")) try {
                    const n = new URL(e);
                    n.pathname = t, r = n.href;
                } catch (e) {
                    r = t;
                }
                else r = f(e) + "/" + t;
                return f(r);
            }
            function O(e) {
                try {
                    return S(e).pathname;
                } catch (t) {
                    return e;
                }
            }
            function j(e) {
                return e.charAt(0).toUpperCase() + e.slice(1);
            }
            function $(e) {
                try {
                    const t = S(e);
                    return t.search = "", t.hash = "", t.toString();
                } catch (t) {
                    return e;
                }
            }
            function S(e) {
                return "undefined" == typeof URL ? new (r(725)).URL(e) : new URL(e);
            }
            function C(e) {
                return e.replace(/["\\]/g, "\\$&");
            }
            function P(e) {
                return e.replace(/&#(\d+);/g, (e, t)=>String.fromCharCode(parseInt(t, 10))).replace(/&amp;/g, "&").replace(/&quot;/g, '"');
            }
            function I(e) {
                return Array.isArray(e);
            }
            function A(e) {
                return "boolean" == typeof e;
            }
            const T = {
                enum: "Enum",
                enumSingleValue: "Value",
                enumArray: "Items",
                default: "Default",
                deprecated: "Deprecated",
                example: "Example",
                examples: "Examples",
                recursive: "Recursive",
                arrayOf: "Array of ",
                webhook: "Event",
                const: "Value",
                noResultsFound: "No results found",
                download: "Download",
                downloadSpecification: "Download OpenAPI specification",
                responses: "Responses",
                callbackResponses: "Callback responses",
                requestSamples: "Request samples",
                responseSamples: "Response samples"
            };
            function _(e, t) {
                const r = T[e];
                return void 0 !== t ? r[t] : r;
            }
            var R = ((e)=>(e.SummaryOnly = "summary-only", e.PathOnly = "path-only", e.IdOnly = "id-only", e))(R || {}), D = Object.defineProperty, z = Object.defineProperties, L = Object.getOwnPropertyDescriptors, N = Object.getOwnPropertySymbols, M = Object.prototype.hasOwnProperty, q = Object.prototype.propertyIsEnumerable, F = (e, t, r)=>t in e ? D(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, B = (e, t)=>{
                for(var r in t || (t = {}))M.call(t, r) && F(e, r, t[r]);
                if (N) for (var r of N(t))q.call(t, r) && F(e, r, t[r]);
                return e;
            };
            function Q(e, t) {
                return void 0 === e ? t || !1 : "string" == typeof e ? "false" !== e : e;
            }
            function U(e) {
                return "string" == typeof e ? parseInt(e, 10) : "number" == typeof e ? e : void 0;
            }
            class W {
                static normalizeExpandResponses(e) {
                    if ("all" === e) return "all";
                    if ("string" == typeof e) {
                        const t = {};
                        return e.split(",").forEach((e)=>{
                            t[e.trim()] = !0;
                        }), t;
                    }
                    return void 0 !== e && console.warn(`expandResponses must be a string but received value "${e}" of type ${typeof e}`), {};
                }
                static normalizeHideHostname(e) {
                    return !!e;
                }
                static normalizeScrollYOffset(e) {
                    if ("string" == typeof e && !g(e)) {
                        const t = a(e);
                        t || console.warn("scrollYOffset value is a selector to non-existing element. Using offset 0 by default");
                        const r = t && t.getBoundingClientRect().bottom || 0;
                        return ()=>r;
                    }
                    return "number" == typeof e || g(e) ? ()=>"number" == typeof e ? e : parseFloat(e) : "function" == typeof e ? ()=>{
                        const t = e();
                        return "number" != typeof t && console.warn(`scrollYOffset should return number but returned value "${t}" of type ${typeof t}`), t;
                    } : (void 0 !== e && console.warn("Wrong value for scrollYOffset ReDoc option: should be string, number or function"), ()=>0);
                }
                static normalizeShowExtensions(e) {
                    if (void 0 === e) return !1;
                    if ("" === e) return !0;
                    if ("string" != typeof e) return e;
                    switch(e){
                        case "true":
                            return !0;
                        case "false":
                            return !1;
                        default:
                            return e.split(",").map((e)=>e.trim());
                    }
                }
                static normalizeSideNavStyle(e) {
                    const t = R.SummaryOnly;
                    if ("string" != typeof e) return t;
                    switch(e){
                        case t:
                            return e;
                        case R.PathOnly:
                            return R.PathOnly;
                        case R.IdOnly:
                            return R.IdOnly;
                        default:
                            return t;
                    }
                }
                static normalizePayloadSampleIdx(e) {
                    return "number" == typeof e ? Math.max(0, e) : "string" == typeof e && isFinite(e) ? parseInt(e, 10) : 0;
                }
                static normalizeJsonSampleExpandLevel(e) {
                    return "all" === e ? 1 / 0 : isNaN(Number(e)) ? 2 : Math.ceil(Number(e));
                }
                static normalizeGeneratedPayloadSamplesMaxDepth(e) {
                    return isNaN(Number(e)) ? 10 : Math.max(0, Number(e));
                }
                constructor(e, t = {}){
                    var r, n, o, s, a;
                    const l = (e = B(B({}, t), e)).theme && e.theme.extensionsHook;
                    var c, p;
                    (null == (r = e.theme) ? void 0 : r.menu) && !(null == (n = e.theme) ? void 0 : n.sidebar) && (console.warn('Theme setting "menu" is deprecated. Rename to "sidebar"'), e.theme.sidebar = e.theme.menu), (null == (o = e.theme) ? void 0 : o.codeSample) && !(null == (s = e.theme) ? void 0 : s.codeBlock) && (console.warn('Theme setting "codeSample" is deprecated. Rename to "codeBlock"'), e.theme.codeBlock = e.theme.codeSample), this.theme = function(e) {
                        const t = {};
                        let r = 0;
                        const n = (o, i)=>{
                            Object.keys(o).forEach((s)=>{
                                const a = (i ? i + "." : "") + s, l = o[s];
                                "function" == typeof l ? Object.defineProperty(o, s, {
                                    get () {
                                        if (!t[a]) {
                                            if (r++, r > 1e3) throw new Error(`Theme probably contains circular dependency at ${a}: ${l.toString()}`);
                                            t[a] = l(e);
                                        }
                                        return t[a];
                                    },
                                    enumerable: !0
                                }) : "object" == typeof l && n(l, a);
                            });
                        };
                        return n(e, ""), JSON.parse(JSON.stringify(e));
                    }(b({}, i, (c = B({}, e.theme), z(c, L({
                        extensionsHook: void 0
                    }))))), this.theme.extensionsHook = l, p = e.labels, Object.assign(T, p), this.scrollYOffset = W.normalizeScrollYOffset(e.scrollYOffset), this.hideHostname = W.normalizeHideHostname(e.hideHostname), this.expandResponses = W.normalizeExpandResponses(e.expandResponses), this.sortRequiredPropsFirst = Q(e.sortRequiredPropsFirst || e.requiredPropsFirst), this.sortPropsAlphabetically = Q(e.sortPropsAlphabetically), this.sortEnumValuesAlphabetically = Q(e.sortEnumValuesAlphabetically), this.sortOperationsAlphabetically = Q(e.sortOperationsAlphabetically), this.sortTagsAlphabetically = Q(e.sortTagsAlphabetically), this.nativeScrollbars = Q(e.nativeScrollbars), this.pathInMiddlePanel = Q(e.pathInMiddlePanel), this.sanitize = Q(e.sanitize || e.untrustedSpec), this.hideDownloadButtons = Q(e.hideDownloadButtons || e.hideDownloadButton), this.downloadFileName = e.downloadFileName, this.downloadDefinitionUrl = e.downloadDefinitionUrl, this.downloadUrls = e.downloadUrls, this.disableSearch = Q(e.disableSearch), this.onlyRequiredInSamples = Q(e.onlyRequiredInSamples), this.showExtensions = W.normalizeShowExtensions(e.showExtensions), this.sideNavStyle = W.normalizeSideNavStyle(e.sideNavStyle), this.hideSingleRequestSampleTab = Q(e.hideSingleRequestSampleTab), this.hideRequestPayloadSample = Q(e.hideRequestPayloadSample), this.menuToggle = Q(e.menuToggle, !0), this.jsonSamplesExpandLevel = W.normalizeJsonSampleExpandLevel(e.jsonSamplesExpandLevel || e.jsonSampleExpandLevel), this.enumSkipQuotes = Q(e.enumSkipQuotes), this.hideSchemaTitles = Q(e.hideSchemaTitles), this.simpleOneOfTypeLabel = Q(e.simpleOneOfTypeLabel), this.payloadSampleIdx = W.normalizePayloadSampleIdx(e.payloadSampleIdx), this.expandSingleSchemaField = Q(e.expandSingleSchemaField), this.schemasExpansionLevel = function(e, t = 0) {
                        return "all" === e ? 1 / 0 : U(e) || t;
                    }(e.schemasExpansionLevel || e.schemaExpansionLevel), this.schemaDefinitionsTagName = e.schemaDefinitionsTagName, this.showObjectSchemaExamples = Q(e.showObjectSchemaExamples), this.showSecuritySchemeType = Q(e.showSecuritySchemeType), this.hideSecuritySection = Q(e.hideSecuritySection), this.unstable_ignoreMimeParameters = Q(e.unstable_ignoreMimeParameters), this.allowedMdComponents = e.allowedMdComponents || {}, this.expandDefaultServerVariables = Q(e.expandDefaultServerVariables), this.maxDisplayedEnumValues = U(e.maxDisplayedEnumValues);
                    const u = I(e.ignoreNamedSchemas) ? e.ignoreNamedSchemas : null == (a = e.ignoreNamedSchemas) ? void 0 : a.split(",").map((e)=>e.trim());
                    this.ignoreNamedSchemas = new Set(u), this.hideSchemaPattern = Q(e.hideSchemaPattern), this.generatedSamplesMaxDepth = W.normalizeGeneratedPayloadSamplesMaxDepth(e.generatedSamplesMaxDepth || e.generatedPayloadSamplesMaxDepth), this.nonce = e.nonce, this.hideFab = Q(e.hideFab), this.minCharacterLengthToInitSearch = U(e.minCharacterLengthToInitSearch) || 3, this.showWebhookVerb = Q(e.showWebhookVerb), this.hidePropertiesPrefix = Q(e.hidePropertiesPrefix, !0);
                }
            }
            var V = (parcelRequire("lmFrL")), H = r.n(V);
            const { default: J, css: Y, createGlobalStyle: G, keyframes: Z, ThemeProvider: X } = V, K = {
                lessThan (e, t, r) {
                    return (...n)=>Y`
      @media ${t ? "print, " : ""} screen and (max-width: ${(t)=>t.theme.breakpoints[e]}) ${r || ""} {
        ${Y(...n)};
      }
    `;
                },
                greaterThan (e) {
                    return (...t)=>Y`
      @media (min-width: ${(t)=>t.theme.breakpoints[e]}) {
        ${Y(...t)};
      }
    `;
                },
                between (e, t) {
                    return (...r)=>Y`
      @media (min-width: ${(t)=>t.theme.breakpoints[e]}) and (max-width: ${(e)=>e.theme.breakpoints[t]}) {
        ${Y(...r)};
      }
    `;
                }
            };
            var ee = J;
            function te(e) {
                return (t)=>{
                    if (t.theme.extensionsHook) return t.theme.extensionsHook(e, t);
                };
            }
            const re = ee.div`
  padding: 20px;
  color: red;
`;
            class ne extends e.Component {
                constructor(e){
                    super(e), this.state = {
                        error: void 0
                    };
                }
                componentDidCatch(e) {
                    return this.setState({
                        error: e
                    }), !1;
                }
                render() {
                    return this.state.error ? e.createElement(re, null, e.createElement("h1", null, "Something went wrong..."), e.createElement("small", null, " ", this.state.error.message, " "), e.createElement("p", null, e.createElement("details", null, e.createElement("summary", null, "Stack trace"), e.createElement("pre", null, this.state.error.stack))), e.createElement("small", null, " ReDoc Version: ", "2.5.4"), " ", e.createElement("br", null), e.createElement("small", null, " Commit: ", "7a9ec49")) : e.createElement(e.Fragment, null, e.Children.only(this.props.children));
                }
            }
            const oe = Z`
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg);
  }
`, ie = ee((t)=>e.createElement("svg", {
                    className: t.className,
                    version: "1.1",
                    width: "512",
                    height: "512",
                    viewBox: "0 0 512 512"
                }, e.createElement("path", {
                    d: "M275.682 147.999c0 10.864-8.837 19.661-19.682 19.661v0c-10.875 0-19.681-8.796-19.681-19.661v-96.635c0-10.885 8.806-19.661 19.681-19.661v0c10.844 0 19.682 8.776 19.682 19.661v96.635z"
                }), e.createElement("path", {
                    d: "M275.682 460.615c0 10.865-8.837 19.682-19.682 19.682v0c-10.875 0-19.681-8.817-19.681-19.682v-96.604c0-10.885 8.806-19.681 19.681-19.681v0c10.844 0 19.682 8.796 19.682 19.682v96.604z"
                }), e.createElement("path", {
                    d: "M147.978 236.339c10.885 0 19.681 8.755 19.681 19.641v0c0 10.885-8.796 19.702-19.681 19.702h-96.624c-10.864 0-19.661-8.817-19.661-19.702v0c0-10.885 8.796-19.641 19.661-19.641h96.624z"
                }), e.createElement("path", {
                    d: "M460.615 236.339c10.865 0 19.682 8.755 19.682 19.641v0c0 10.885-8.817 19.702-19.682 19.702h-96.584c-10.885 0-19.722-8.817-19.722-19.702v0c0-10.885 8.837-19.641 19.722-19.641h96.584z"
                }), e.createElement("path", {
                    d: "M193.546 165.703c7.69 7.66 7.68 20.142 0 27.822v0c-7.701 7.701-20.162 7.701-27.853 0.020l-68.311-68.322c-7.68-7.701-7.68-20.142 0-27.863v0c7.68-7.68 20.121-7.68 27.822 0l68.342 68.342z"
                }), e.createElement("path", {
                    d: "M414.597 386.775c7.7 7.68 7.7 20.163 0.021 27.863v0c-7.7 7.659-20.142 7.659-27.843-0.062l-68.311-68.26c-7.68-7.7-7.68-20.204 0-27.863v0c7.68-7.7 20.163-7.7 27.842 0l68.291 68.322z"
                }), e.createElement("path", {
                    d: "M165.694 318.464c7.69-7.7 20.153-7.7 27.853 0v0c7.68 7.659 7.69 20.163 0 27.863l-68.342 68.322c-7.67 7.659-20.142 7.659-27.822-0.062v0c-7.68-7.68-7.68-20.122 0-27.801l68.311-68.322z"
                }), e.createElement("path", {
                    d: "M386.775 97.362c7.7-7.68 20.142-7.68 27.822 0v0c7.7 7.68 7.7 20.183 0.021 27.863l-68.322 68.311c-7.68 7.68-20.163 7.68-27.843-0.020v0c-7.68-7.68-7.68-20.162 0-27.822l68.322-68.332z"
                })))`
  animation: 2s ${oe} linear infinite;
  width: 50px;
  height: 50px;
  content: '';
  display: inline-block;
  margin-left: -25px;

  path {
    fill: ${(e)=>e.color};
  }
`, se = ee.div`
  font-family: helvetica, sans;
  width: 100%;
  text-align: center;
  font-size: 25px;
  margin: 30px 0 20px 0;
  color: ${(e)=>e.color};
`;
            class ae extends e.PureComponent {
                render() {
                    return e.createElement("div", {
                        style: {
                            textAlign: "center"
                        }
                    }, e.createElement(se, {
                        color: this.props.color
                    }, "Loading ..."), e.createElement(ie, {
                        color: this.props.color
                    }));
                }
            }
            var le = (parcelRequire("c9Z8w"));
            const ce = e.createContext(new W({})), pe = ce.Provider, ue = ce.Consumer;
            var de = (parcelRequire("4f362")), he = (parcelRequire("2oNQQ")), me = (parcelRequire("jVI1J")), fe = r(65), ge = (e, t, r)=>new Promise((n, o)=>{
                    var i = (e)=>{
                        try {
                            a(r.next(e));
                        } catch (e) {
                            o(e);
                        }
                    }, s = (e)=>{
                        try {
                            a(r.throw(e));
                        } catch (e) {
                            o(e);
                        }
                    }, a = (e)=>e.done ? n(e.value) : Promise.resolve(e.value).then(i, s);
                    a((r = r.apply(e, t)).next());
                });
            function ye(e) {
                return ge(this, null, function*() {
                    const t = new me.Config({}), n = {
                        config: t,
                        base: s ? window.location.href : $hPtJY.cwd()
                    };
                    s && (t.resolve.http.customFetch = r.g.fetch), "object" == typeof e && null !== e ? n.doc = {
                        source: {
                            absoluteRef: ""
                        },
                        parsed: e
                    } : n.ref = e;
                    const { bundle: { parsed: o } } = yield (0, he.bundle)(n);
                    return void 0 !== o.swagger ? be(o) : o;
                });
            }
            function be(e) {
                return console.warn("[ReDoc Compatibility mode]: Converting OpenAPI 2.0 to OpenAPI 3.0"), new Promise((t, r)=>(0, fe.convertObj)(e, {
                        patch: !0,
                        warnOnly: !0,
                        text: "{}",
                        anchors: !0
                    }, (e, n)=>{
                        if (e) return r(e);
                        t(n && n.openapi);
                    }));
            }
            var xe = (parcelRequire("8oJhk")), ve = (parcelRequire("3vRz3")), we = (parcelRequire("jAmc6"));
            const ke = we.parse;
            class Ee {
                static baseName(e, t = 1) {
                    const r = Ee.parse(e);
                    return r[r.length - t];
                }
                static dirName(e, t = 1) {
                    const r = Ee.parse(e);
                    return we.compile(r.slice(0, r.length - t));
                }
                static relative(e, t) {
                    const r = Ee.parse(e);
                    return Ee.parse(t).slice(r.length);
                }
                static parse(e) {
                    let t = e;
                    return "#" === t.charAt(0) && (t = t.substring(1)), ke(t);
                }
                static join(e, t) {
                    const r = Ee.parse(e).concat(t);
                    return we.compile(r);
                }
                static get(e, t) {
                    return we.get(e, t);
                }
                static compile(e) {
                    return we.compile(e);
                }
                static escape(e) {
                    return we.escape(e);
                }
            }
            we.parse = Ee.parse, Object.assign(Ee, we);
            var Oe = r(975), je = (parcelRequire("7GGYV")), $e = Object.defineProperty, Se = Object.defineProperties, Ce = Object.getOwnPropertyDescriptors, Pe = Object.getOwnPropertySymbols, Ie = Object.prototype.hasOwnProperty, Ae = Object.prototype.propertyIsEnumerable, Te = (e, t, r)=>t in e ? $e(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, _e = (e, t)=>{
                for(var r in t || (t = {}))Ie.call(t, r) && Te(e, r, t[r]);
                if (Pe) for (var r of Pe(t))Ae.call(t, r) && Te(e, r, t[r]);
                return e;
            }, Re = (e, t)=>Se(e, Ce(t));
            function De(e) {
                return "string" == typeof e && /\dxx/i.test(e);
            }
            function ze(e) {
                return "default" === e || g(e) || De(e);
            }
            function Le(e, t = !1) {
                if ("default" === e) return t ? "error" : "success";
                let r = "string" == typeof e ? parseInt(e, 10) : e;
                if (De(e) && (r *= 100), r < 100 || r > 599) throw new Error("invalid HTTP code");
                let n = "success";
                return r >= 300 && r < 400 ? n = "redirect" : r >= 400 ? n = "error" : r < 200 && (n = "info"), n;
            }
            const Ne = {
                get: !0,
                post: !0,
                put: !0,
                head: !0,
                patch: !0,
                delete: !0,
                options: !0,
                $ref: !0
            };
            function Me(e) {
                return e in Ne;
            }
            function qe(e) {
                return e.summary || e.operationId || e.description && e.description.substring(0, 50) || e.pathName || "<no summary>";
            }
            const Fe = {
                multipleOf: "number",
                maximum: "number",
                exclusiveMaximum: "number",
                minimum: "number",
                exclusiveMinimum: "number",
                maxLength: "string",
                minLength: "string",
                pattern: "string",
                contentEncoding: "string",
                contentMediaType: "string",
                items: "array",
                maxItems: "array",
                minItems: "array",
                uniqueItems: "array",
                maxProperties: "object",
                minProperties: "object",
                required: "object",
                additionalProperties: "object",
                unevaluatedProperties: "object",
                properties: "object",
                patternProperties: "object"
            };
            function Be(e) {
                if (void 0 !== e.type && !I(e.type)) return e.type;
                const t = Object.keys(Fe);
                for (const r of t){
                    const t = Fe[r];
                    if (void 0 !== e[r]) return t;
                }
                return "any";
            }
            function Qe(e, t = e.type) {
                if (e["x-circular-ref"]) return !0;
                if (void 0 !== e.oneOf || void 0 !== e.anyOf) return !1;
                if (e.if && e.then || e.if && e.else) return !1;
                let r = !0;
                const n = I(t);
                return ("object" === t || n && (null == t ? void 0 : t.includes("object"))) && (r = void 0 !== e.properties ? 0 === Object.keys(e.properties).length : void 0 === e.additionalProperties && void 0 === e.unevaluatedProperties && void 0 === e.patternProperties), !I(e.items) && !I(e.prefixItems) && (void 0 !== e.items && !A(e.items) && ("array" === t || n && (null == t ? void 0 : t.includes("array"))) && (r = Qe(e.items, e.items.type)), r);
            }
            function Ue(e) {
                return -1 !== e.search(/json/i);
            }
            function We(e) {
                return "application/x-www-form-urlencoded" === e;
            }
            function Ve(e, t, r) {
                return I(e) ? e.map((e)=>e.toString()).join(r) : "object" == typeof e ? Object.keys(e).map((t)=>`${t}${r}${e[t]}`).join(r) : t + "=" + e.toString();
            }
            function He(e, t) {
                return I(e) ? (console.warn("deepObject style cannot be used with array value:" + e.toString()), "") : "object" == typeof e ? Object.keys(e).map((r)=>`${t}[${r}]=${e[r]}`).join("&") : (console.warn("deepObject style cannot be used with non-object value:" + e.toString()), "");
            }
            function Je(e, t, r) {
                const n = "__redoc_param_name__", o = t ? "*" : "";
                return je.parse(`{?${n}${o}}`).expand({
                    [n]: r
                }).substring(1).replace(/__redoc_param_name__/g, e);
            }
            function Ye(e, t = {}) {
                if (I(e)) throw new Error("Payload must have fields: " + e.toString());
                return Object.keys(e).map((r)=>{
                    const n = e[r], { style: o = "form", explode: i = !0 } = t[r] || {};
                    switch(o){
                        case "form":
                            return Je(r, i, n);
                        case "spaceDelimited":
                            return Ve(n, r, "%20");
                        case "pipeDelimited":
                            return Ve(n, r, "|");
                        case "deepObject":
                            return He(n, r);
                        default:
                            return console.warn("Incorrect or unsupported encoding style: " + o), "";
                    }
                }).join("&");
            }
            function Ge(e, t) {
                return Ue(t) ? JSON.stringify(e) : (console.warn(`Parameter serialization as ${t} is not supported`), "");
            }
            function Ze(e, t) {
                const { name: r, style: n, explode: o = !1, serializationMime: i } = e;
                if (i) switch(e.in){
                    case "path":
                    case "header":
                        return Ge(t, i);
                    case "cookie":
                    case "query":
                        return `${r}=${Ge(t, i)}`;
                    default:
                        return console.warn("Unexpected parameter location: " + e.in), "";
                }
                if (!n) return console.warn(`Missing style attribute or content for parameter ${r}`), "";
                switch(e.in){
                    case "path":
                        return function(e, t, r, n) {
                            const o = r ? "*" : "";
                            let i = "";
                            "label" === t ? i = "." : "matrix" === t && (i = ";");
                            const s = "__redoc_param_name__";
                            return je.parse(`{${i}${s}${o}}`).expand({
                                [s]: n
                            }).replace(/__redoc_param_name__/g, e);
                        }(r, n, o, t);
                    case "query":
                        return function(e, t, r, n) {
                            switch(t){
                                case "form":
                                    return Je(e, r, n);
                                case "spaceDelimited":
                                    return I(n) ? r ? Je(e, r, n) : `${e}=${n.join("%20")}` : (console.warn("The style spaceDelimited is only applicable to arrays"), "");
                                case "pipeDelimited":
                                    return I(n) ? r ? Je(e, r, n) : `${e}=${n.join("|")}` : (console.warn("The style pipeDelimited is only applicable to arrays"), "");
                                case "deepObject":
                                    return !r || I(n) || "object" != typeof n ? (console.warn("The style deepObject is only applicable for objects with explode=true"), "") : He(n, e);
                                default:
                                    return console.warn("Unexpected style for query: " + t), "";
                            }
                        }(r, n, o, t);
                    case "header":
                        return function(e, t, r) {
                            if ("simple" === e) {
                                const e = t ? "*" : "", n = "__redoc_param_name__", o = je.parse(`{${n}${e}}`);
                                return decodeURIComponent(o.expand({
                                    [n]: r
                                }));
                            }
                            return console.warn("Unexpected style for header: " + e), "";
                        }(n, o, t);
                    case "cookie":
                        return function(e, t, r, n) {
                            return "form" === t ? Je(e, r, n) : (console.warn("Unexpected style for cookie: " + t), "");
                        }(r, n, o, t);
                    default:
                        return console.warn("Unexpected parameter location: " + e.in), "";
                }
            }
            function Xe(e, t) {
                return e.in ? decodeURIComponent(Ze(e, t)) : "object" == typeof t ? t : String(t);
            }
            function Ke(e) {
                return -1 !== e.search(/xml/i) ? "xml" : -1 !== e.search(/csv/i) ? "csv" : -1 !== e.search(/plain/i) ? "tex" : "clike";
            }
            const et = /^#\/components\/(schemas|pathItems)\/([^/]+)$/;
            function tt(e) {
                return et.test(e || "");
            }
            function rt(e) {
                var t;
                const [r] = (null == (t = null == e ? void 0 : e.match(et)) ? void 0 : t.reverse()) || [];
                return r;
            }
            function nt(e, t, r) {
                let n;
                return void 0 !== t && void 0 !== r ? n = t === r ? `= ${t} ${e}` : `[ ${t} .. ${r} ] ${e}` : void 0 !== r ? n = `<= ${r} ${e}` : void 0 !== t && (n = 1 === t ? "non-empty" : `>= ${t} ${e}`), n;
            }
            function ot(e) {
                var t, r;
                const n = "number" == typeof e.exclusiveMinimum ? Math.min(e.exclusiveMinimum, null != (t = e.minimum) ? t : 1 / 0) : e.minimum, o = "number" == typeof e.exclusiveMaximum ? Math.max(e.exclusiveMaximum, null != (r = e.maximum) ? r : -1 / 0) : e.maximum, i = "number" == typeof e.exclusiveMinimum || e.exclusiveMinimum, s = "number" == typeof e.exclusiveMaximum || e.exclusiveMaximum;
                return void 0 !== n && void 0 !== o ? `${i ? "( " : "[ "}${n} .. ${o}${s ? " )" : " ]"}` : void 0 !== o ? `${s ? "< " : "<= "}${o}` : void 0 !== n ? `${i ? "> " : ">= "}${n}` : void 0;
            }
            function it(e) {
                const t = [], r = nt("characters", e.minLength, e.maxLength);
                void 0 !== r && t.push(r);
                const n = nt("items", e.minItems, e.maxItems);
                void 0 !== n && t.push(n);
                const o = nt("properties", e.minProperties, e.maxProperties);
                void 0 !== o && t.push(o);
                const i = function(e) {
                    if (void 0 === e) return;
                    const t = e.toString(10);
                    return /^0\.0*1$/.test(t) ? `decimal places <= ${t.split(".")[1].length}` : `multiple of ${t}`;
                }(e.multipleOf);
                void 0 !== i && t.push(i);
                const s = ot(e);
                return void 0 !== s && t.push(s), e.uniqueItems && t.push("unique"), t;
            }
            function st(e, t = []) {
                const r = [], n = [], o = [];
                return e.forEach((e)=>{
                    e.required ? t.includes(e.name) ? n.push(e) : o.push(e) : r.push(e);
                }), n.sort((e, r)=>t.indexOf(e.name) - t.indexOf(r.name)), [
                    ...n,
                    ...o,
                    ...r
                ];
            }
            function at(e, t) {
                return [
                    ...e
                ].sort((e, r)=>e[t].localeCompare(r[t]));
            }
            function lt(e, t = [], r = []) {
                const n = {};
                return r.forEach((t)=>{
                    ({ resolved: t } = e.deref(t)), n[t.name + "_" + t.in] = !0;
                }), (t = t.filter((t)=>({ resolved: t } = e.deref(t), !n[t.name + "_" + t.in]))).concat(r);
            }
            function ct(e) {
                const t = {};
                return Object.keys(e).forEach((r)=>{
                    const n = e[r], o = r.split(";")[0].trim();
                    t[o] ? t[o] = _e(_e({}, t[o]), n) : t[o] = n;
                }), t;
            }
            function pt(e, t = {}) {
                return e.replace(/(?:{)([\w-.]+)(?:})/g, (e, r)=>t[r] && t[r].default || e);
            }
            function ut(e, t) {
                const r = void 0 === e ? $((()=>{
                    if (!s) return "";
                    const e = window.location.href;
                    return e.endsWith(".html") ? (0, Oe.dirname)(e) : e;
                })()) : (0, Oe.dirname)(e);
                return 0 === t.length && (t = [
                    {
                        url: "/"
                    }
                ]), t.map((e)=>{
                    var t;
                    return Re(_e({}, e), {
                        url: (t = e.url, E(r, t)),
                        description: e.description || ""
                    });
                });
            }
            const dt = "SecurityDefinitions", ht = "security-definitions", mt = "SchemaDefinition";
            let ft = "section/Authentication/";
            function gt(e) {
                ft = e;
            }
            const yt = (e)=>({
                    delete: "del",
                    options: "opts"
                })[e] || e;
            function bt(e) {
                return e in {
                    "x-circular-ref": !0,
                    "x-parentRefs": !0,
                    "x-refsStack": !0,
                    "x-code-samples": !0,
                    "x-codeSamples": !0,
                    "x-displayName": !0,
                    "x-examples": !0,
                    "x-enumDescriptions": !0,
                    "x-logo": !0,
                    "x-nullable": !0,
                    "x-servers": !0,
                    "x-tagGroups": !0,
                    "x-traitTag": !0,
                    "x-badges": !0,
                    "x-additionalPropertiesName": !0,
                    "x-explicitMappingOnly": !0
                };
            }
            function xt(e, t) {
                return Object.keys(e).filter((e)=>!0 === t ? e.startsWith("x-") && !bt(e) : e.startsWith("x-") && t.indexOf(e) > -1).reduce((t, r)=>(t[r] = e[r], t), {});
            }
            function vt(e) {
                return e.split(" or ").map((e)=>e.replace(/^(string|object|number|integer|array|boolean)s?( ?.*)/, "$1s$2")).join(" or ");
            }
            function wt(e) {
                let t = e.content;
                const r = e["x-examples"], n = e["x-example"];
                if (r) {
                    t = _e({}, t);
                    for (const e of Object.keys(r)){
                        const n = r[e];
                        t[e] = Re(_e({}, t[e]), {
                            examples: n
                        });
                    }
                } else if (n) {
                    t = _e({}, t);
                    for (const e of Object.keys(n)){
                        const r = n[e];
                        t[e] = Re(_e({}, t[e]), {
                            example: r
                        });
                    }
                }
                return t;
            }
            var kt = (parcelRequire("bqaFX"));
            !(parcelRequire("6cZMx")), !(parcelRequire("a2hnG")), !(parcelRequire("dXjg4")), !(parcelRequire("2fy1s")), !(parcelRequire("knNrc")), !(parcelRequire("yEjrf")), !(parcelRequire("d8UrQ")), !(parcelRequire("iTqxp")), !(parcelRequire("75LZA")), !(parcelRequire("jXEdh")), !(parcelRequire("5V3YG")), !(parcelRequire("fwhHX")), !(parcelRequire("ggqdh")), !(parcelRequire("cTYpt")), !(parcelRequire("lO7mf")), !(parcelRequire("8svz5")), !(parcelRequire("eVptw")), !(parcelRequire("ia73J")), !(parcelRequire("dy4Fz")), !(parcelRequire("lfCKT")), !(parcelRequire("lsL9j")), !(parcelRequire("5PzEK")), (parcelRequire("4KDOF"));
            const Et = "clike";
            function Ot(e) {
                return ({
                    json: "js",
                    "c++": "cpp",
                    "c#": "csharp",
                    "objective-c": "objectivec",
                    shell: "bash",
                    viml: "vim"
                })[e] || Et;
            }
            function jt(e, t = Et) {
                t = t.toLowerCase();
                let r = kt.languages[t];
                return r || (r = kt.languages[Ot(t)]), kt.highlight(e.toString(), r, t);
            }
            function $t(e) {
                return (t, r, n)=>{
                    n.value = function(e, t) {
                        let r, n, o, i = null, s = 0;
                        const a = ()=>{
                            s = (new Date).getTime(), i = null, o = e.apply(r, n), i || (r = n = null);
                        };
                        return function() {
                            const l = (new Date).getTime(), c = t - (l - s);
                            return r = this, n = arguments, c <= 0 || c > t ? (i && (clearTimeout(i), i = null), s = l, o = e.apply(r, n), i || (r = n = null)) : i || (i = setTimeout(a, c)), o;
                        };
                    }(n.value, e);
                };
            }
            function St(e) {}
            function Ct(e) {}
            kt.languages.insertBefore("javascript", "string", {
                "property string": {
                    pattern: /([{,]\s*)"(?:\\.|[^\\"\r\n])*"(?=\s*:)/i,
                    lookbehind: !0
                }
            }, void 0), kt.languages.insertBefore("javascript", "punctuation", {
                property: {
                    pattern: /([{,]\s*)[a-z]\w*(?=\s*:)/i,
                    lookbehind: !0
                }
            }, void 0);
            var Pt = Object.defineProperty, It = Object.defineProperties, At = Object.getOwnPropertyDescriptors, Tt = Object.getOwnPropertySymbols, _t = Object.prototype.hasOwnProperty, Rt = Object.prototype.propertyIsEnumerable, Dt = (e, t, r)=>t in e ? Pt(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, zt = (e, t)=>{
                for(var r in t || (t = {}))_t.call(t, r) && Dt(e, r, t[r]);
                if (Tt) for (var r of Tt(t))Rt.call(t, r) && Dt(e, r, t[r]);
                return e;
            }, Lt = (e, t)=>It(e, At(t));
            const Nt = {};
            function Mt(e, t, r) {
                if ("function" == typeof r.value) return function(e, t, r) {
                    if (!r.value || r.value.length > 0) throw new Error("@memoize decorator can only be applied to methods of zero arguments");
                    const n = `_memoized_${t}`, o = r.value;
                    return e[n] = Nt, Lt(zt({}, r), {
                        value () {
                            return this[n] === Nt && (this[n] = o.call(this)), this[n];
                        }
                    });
                }(e, t, r);
                if ("function" == typeof r.get) return function(e, t, r) {
                    const n = `_memoized_${t}`, o = r.get;
                    return e[n] = Nt, Lt(zt({}, r), {
                        get () {
                            return this[n] === Nt && (this[n] = o.call(this)), this[n];
                        }
                    });
                }(e, t, r);
                throw new Error("@memoize decorator can be applied to methods or getters, got " + String(r.value) + " instead");
            }
            function qt(e) {
                let t = 1;
                return "-" === e[0] && (t = -1, e = e.substr(1)), (r, n)=>-1 == t ? n[e].localeCompare(r[e]) : r[e].localeCompare(n[e]);
            }
            var Ft = Object.defineProperty, Bt = Object.getOwnPropertyDescriptor;
            const Qt = "hashchange";
            class Ut {
                constructor(){
                    this.emit = ()=>{
                        this._emiter.emit(Qt, this.currentId);
                    }, this._emiter = new ve.EventEmitter, this.bind();
                }
                get currentId() {
                    return s ? decodeURIComponent(window.location.hash.substring(1)) : "";
                }
                linkForId(e) {
                    return e ? "#" + e : "";
                }
                subscribe(e) {
                    const t = this._emiter.addListener(Qt, e);
                    return ()=>t.removeListener(Qt, e);
                }
                bind() {
                    s && window.addEventListener("hashchange", this.emit, !1);
                }
                dispose() {
                    s && window.removeEventListener("hashchange", this.emit);
                }
                replace(e, t = !1) {
                    s && null != e && e !== this.currentId && (t ? window.history.replaceState(null, "", window.location.href.split("#")[0] + this.linkForId(e)) : (window.history.pushState(null, "", window.location.href.split("#")[0] + this.linkForId(e)), this.emit()));
                }
            }
            ((e, t, r)=>{
                for(var n, o = Bt(t, r), i = e.length - 1; i >= 0; i--)(n = e[i]) && (o = n(t, r, o) || o);
                o && Ft(t, r, o);
            })([
                xe.bind,
                xe.debounce
            ], Ut.prototype, "replace");
            const Wt = new Ut;
            var Vt = (parcelRequire("05jCj"));
            class Ht {
                constructor(){
                    this.map = new Map, this.prevTerm = "";
                }
                add(e) {
                    this.map.set(e, new Vt(e));
                }
                delete(e) {
                    this.map.delete(e);
                }
                addOnly(e) {
                    this.map.forEach((t, r)=>{
                        -1 === e.indexOf(r) && (t.unmark(), this.map.delete(r));
                    });
                    for (const t of e)this.map.has(t) || this.map.set(t, new Vt(t));
                }
                clearAll() {
                    this.unmark(), this.map.clear();
                }
                mark(e) {
                    (e || this.prevTerm) && (this.map.forEach((t)=>{
                        t.unmark(), t.mark(e || this.prevTerm);
                    }), this.prevTerm = e || this.prevTerm);
                }
                unmark() {
                    this.map.forEach((e)=>e.unmark()), this.prevTerm = "";
                }
            }
            let Jt = {
                async: !1,
                baseUrl: null,
                breaks: !1,
                extensions: null,
                gfm: !0,
                headerIds: !0,
                headerPrefix: "",
                highlight: null,
                hooks: null,
                langPrefix: "language-",
                mangle: !0,
                pedantic: !1,
                renderer: null,
                sanitize: !1,
                sanitizer: null,
                silent: !1,
                smartypants: !1,
                tokenizer: null,
                walkTokens: null,
                xhtml: !1
            };
            const Yt = /[&<>"']/, Gt = new RegExp(Yt.source, "g"), Zt = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, Xt = new RegExp(Zt.source, "g"), Kt = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;"
            }, er = (e)=>Kt[e];
            function tr(e, t) {
                if (t) {
                    if (Yt.test(e)) return e.replace(Gt, er);
                } else if (Zt.test(e)) return e.replace(Xt, er);
                return e;
            }
            const rr = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/gi;
            function nr(e) {
                return e.replace(rr, (e, t)=>"colon" === (t = t.toLowerCase()) ? ":" : "#" === t.charAt(0) ? "x" === t.charAt(1) ? String.fromCharCode(parseInt(t.substring(2), 16)) : String.fromCharCode(+t.substring(1)) : "");
            }
            const or = /(^|[^\[])\^/g;
            function ir(e, t) {
                e = "string" == typeof e ? e : e.source, t = t || "";
                const r = {
                    replace: (t, n)=>(n = (n = n.source || n).replace(or, "$1"), e = e.replace(t, n), r),
                    getRegex: ()=>new RegExp(e, t)
                };
                return r;
            }
            const sr = /[^\w:]/g, ar = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
            function lr(e, t, r) {
                if (e) {
                    let e;
                    try {
                        e = decodeURIComponent(nr(r)).replace(sr, "").toLowerCase();
                    } catch (e) {
                        return null;
                    }
                    if (0 === e.indexOf("javascript:") || 0 === e.indexOf("vbscript:") || 0 === e.indexOf("data:")) return null;
                }
                t && !ar.test(r) && (r = function(e, t) {
                    cr[" " + e] || (pr.test(e) ? cr[" " + e] = e + "/" : cr[" " + e] = fr(e, "/", !0));
                    const r = -1 === (e = cr[" " + e]).indexOf(":");
                    return "//" === t.substring(0, 2) ? r ? t : e.replace(ur, "$1") + t : "/" === t.charAt(0) ? r ? t : e.replace(dr, "$1") + t : e + t;
                }(t, r));
                try {
                    r = encodeURI(r).replace(/%25/g, "%");
                } catch (e) {
                    return null;
                }
                return r;
            }
            const cr = {}, pr = /^[^:]+:\/*[^/]*$/, ur = /^([^:]+:)[\s\S]*$/, dr = /^([^:]+:\/*[^/]*)[\s\S]*$/, hr = {
                exec: function() {}
            };
            function mr(e, t) {
                const r = e.replace(/\|/g, (e, t, r)=>{
                    let n = !1, o = t;
                    for(; --o >= 0 && "\\" === r[o];)n = !n;
                    return n ? "|" : " |";
                }).split(/ \|/);
                let n = 0;
                if (r[0].trim() || r.shift(), r.length > 0 && !r[r.length - 1].trim() && r.pop(), r.length > t) r.splice(t);
                else for(; r.length < t;)r.push("");
                for(; n < r.length; n++)r[n] = r[n].trim().replace(/\\\|/g, "|");
                return r;
            }
            function fr(e, t, r) {
                const n = e.length;
                if (0 === n) return "";
                let o = 0;
                for(; o < n;){
                    const i = e.charAt(n - o - 1);
                    if (i !== t || r) {
                        if (i === t || !r) break;
                        o++;
                    } else o++;
                }
                return e.slice(0, n - o);
            }
            function gr(e, t) {
                if (t < 1) return "";
                let r = "";
                for(; t > 1;)1 & t && (r += e), t >>= 1, e += e;
                return r + e;
            }
            function yr(e, t, r, n) {
                const o = t.href, i = t.title ? tr(t.title) : null, s = e[1].replace(/\\([\[\]])/g, "$1");
                if ("!" !== e[0].charAt(0)) {
                    n.state.inLink = !0;
                    const e = {
                        type: "link",
                        raw: r,
                        href: o,
                        title: i,
                        text: s,
                        tokens: n.inlineTokens(s)
                    };
                    return n.state.inLink = !1, e;
                }
                return {
                    type: "image",
                    raw: r,
                    href: o,
                    title: i,
                    text: tr(s)
                };
            }
            class br {
                constructor(e){
                    this.options = e || Jt;
                }
                space(e) {
                    const t = this.rules.block.newline.exec(e);
                    if (t && t[0].length > 0) return {
                        type: "space",
                        raw: t[0]
                    };
                }
                code(e) {
                    const t = this.rules.block.code.exec(e);
                    if (t) {
                        const e = t[0].replace(/^ {1,4}/gm, "");
                        return {
                            type: "code",
                            raw: t[0],
                            codeBlockStyle: "indented",
                            text: this.options.pedantic ? e : fr(e, "\n")
                        };
                    }
                }
                fences(e) {
                    const t = this.rules.block.fences.exec(e);
                    if (t) {
                        const e = t[0], r = function(e, t) {
                            const r = e.match(/^(\s+)(?:```)/);
                            if (null === r) return t;
                            const n = r[1];
                            return t.split("\n").map((e)=>{
                                const t = e.match(/^\s+/);
                                if (null === t) return e;
                                const [r] = t;
                                return r.length >= n.length ? e.slice(n.length) : e;
                            }).join("\n");
                        }(e, t[3] || "");
                        return {
                            type: "code",
                            raw: e,
                            lang: t[2] ? t[2].trim().replace(this.rules.inline._escapes, "$1") : t[2],
                            text: r
                        };
                    }
                }
                heading(e) {
                    const t = this.rules.block.heading.exec(e);
                    if (t) {
                        let e = t[2].trim();
                        if (/#$/.test(e)) {
                            const t = fr(e, "#");
                            this.options.pedantic ? e = t.trim() : t && !/ $/.test(t) || (e = t.trim());
                        }
                        return {
                            type: "heading",
                            raw: t[0],
                            depth: t[1].length,
                            text: e,
                            tokens: this.lexer.inline(e)
                        };
                    }
                }
                hr(e) {
                    const t = this.rules.block.hr.exec(e);
                    if (t) return {
                        type: "hr",
                        raw: t[0]
                    };
                }
                blockquote(e) {
                    const t = this.rules.block.blockquote.exec(e);
                    if (t) {
                        const e = t[0].replace(/^ *>[ \t]?/gm, ""), r = this.lexer.state.top;
                        this.lexer.state.top = !0;
                        const n = this.lexer.blockTokens(e);
                        return this.lexer.state.top = r, {
                            type: "blockquote",
                            raw: t[0],
                            tokens: n,
                            text: e
                        };
                    }
                }
                list(e) {
                    let t = this.rules.block.list.exec(e);
                    if (t) {
                        let r, n, o, i, s, a, l, c, p, u, d, h, m = t[1].trim();
                        const f = m.length > 1, g = {
                            type: "list",
                            raw: "",
                            ordered: f,
                            start: f ? +m.slice(0, -1) : "",
                            loose: !1,
                            items: []
                        };
                        m = f ? `\\d{1,9}\\${m.slice(-1)}` : `\\${m}`, this.options.pedantic && (m = f ? m : "[*+-]");
                        const y = new RegExp(`^( {0,3}${m})((?:[\t ][^\\n]*)?(?:\\n|$))`);
                        for(; e && (h = !1, t = y.exec(e)) && !this.rules.block.hr.test(e);){
                            if (r = t[0], e = e.substring(r.length), c = t[2].split("\n", 1)[0].replace(/^\t+/, (e)=>" ".repeat(3 * e.length)), p = e.split("\n", 1)[0], this.options.pedantic ? (i = 2, d = c.trimLeft()) : (i = t[2].search(/[^ ]/), i = i > 4 ? 1 : i, d = c.slice(i), i += t[1].length), a = !1, !c && /^ *$/.test(p) && (r += p + "\n", e = e.substring(p.length + 1), h = !0), !h) {
                                const t = new RegExp(`^ {0,${Math.min(3, i - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`), n = new RegExp(`^ {0,${Math.min(3, i - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), o = new RegExp(`^ {0,${Math.min(3, i - 1)}}(?:\`\`\`|~~~)`), s = new RegExp(`^ {0,${Math.min(3, i - 1)}}#`);
                                for(; e && (u = e.split("\n", 1)[0], p = u, this.options.pedantic && (p = p.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !o.test(p)) && !s.test(p) && !t.test(p) && !n.test(e);){
                                    if (p.search(/[^ ]/) >= i || !p.trim()) d += "\n" + p.slice(i);
                                    else {
                                        if (a) break;
                                        if (c.search(/[^ ]/) >= 4) break;
                                        if (o.test(c)) break;
                                        if (s.test(c)) break;
                                        if (n.test(c)) break;
                                        d += "\n" + p;
                                    }
                                    a || p.trim() || (a = !0), r += u + "\n", e = e.substring(u.length + 1), c = p.slice(i);
                                }
                            }
                            g.loose || (l ? g.loose = !0 : /\n *\n *$/.test(r) && (l = !0)), this.options.gfm && (n = /^\[[ xX]\] /.exec(d), n && (o = "[ ] " !== n[0], d = d.replace(/^\[[ xX]\] +/, ""))), g.items.push({
                                type: "list_item",
                                raw: r,
                                task: !!n,
                                checked: o,
                                loose: !1,
                                text: d
                            }), g.raw += r;
                        }
                        g.items[g.items.length - 1].raw = r.trimRight(), g.items[g.items.length - 1].text = d.trimRight(), g.raw = g.raw.trimRight();
                        const b = g.items.length;
                        for(s = 0; s < b; s++)if (this.lexer.state.top = !1, g.items[s].tokens = this.lexer.blockTokens(g.items[s].text, []), !g.loose) {
                            const e = g.items[s].tokens.filter((e)=>"space" === e.type), t = e.length > 0 && e.some((e)=>/\n.*\n/.test(e.raw));
                            g.loose = t;
                        }
                        if (g.loose) for(s = 0; s < b; s++)g.items[s].loose = !0;
                        return g;
                    }
                }
                html(e) {
                    const t = this.rules.block.html.exec(e);
                    if (t) {
                        const e = {
                            type: "html",
                            raw: t[0],
                            pre: !this.options.sanitizer && ("pre" === t[1] || "script" === t[1] || "style" === t[1]),
                            text: t[0]
                        };
                        if (this.options.sanitize) {
                            const r = this.options.sanitizer ? this.options.sanitizer(t[0]) : tr(t[0]);
                            e.type = "paragraph", e.text = r, e.tokens = this.lexer.inline(r);
                        }
                        return e;
                    }
                }
                def(e) {
                    const t = this.rules.block.def.exec(e);
                    if (t) {
                        const e = t[1].toLowerCase().replace(/\s+/g, " "), r = t[2] ? t[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "", n = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline._escapes, "$1") : t[3];
                        return {
                            type: "def",
                            tag: e,
                            raw: t[0],
                            href: r,
                            title: n
                        };
                    }
                }
                table(e) {
                    const t = this.rules.block.table.exec(e);
                    if (t) {
                        const e = {
                            type: "table",
                            header: mr(t[1]).map((e)=>({
                                    text: e
                                })),
                            align: t[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                            rows: t[3] && t[3].trim() ? t[3].replace(/\n[ \t]*$/, "").split("\n") : []
                        };
                        if (e.header.length === e.align.length) {
                            e.raw = t[0];
                            let r, n, o, i, s = e.align.length;
                            for(r = 0; r < s; r++)/^ *-+: *$/.test(e.align[r]) ? e.align[r] = "right" : /^ *:-+: *$/.test(e.align[r]) ? e.align[r] = "center" : /^ *:-+ *$/.test(e.align[r]) ? e.align[r] = "left" : e.align[r] = null;
                            for(s = e.rows.length, r = 0; r < s; r++)e.rows[r] = mr(e.rows[r], e.header.length).map((e)=>({
                                    text: e
                                }));
                            for(s = e.header.length, n = 0; n < s; n++)e.header[n].tokens = this.lexer.inline(e.header[n].text);
                            for(s = e.rows.length, n = 0; n < s; n++)for(i = e.rows[n], o = 0; o < i.length; o++)i[o].tokens = this.lexer.inline(i[o].text);
                            return e;
                        }
                    }
                }
                lheading(e) {
                    const t = this.rules.block.lheading.exec(e);
                    if (t) return {
                        type: "heading",
                        raw: t[0],
                        depth: "=" === t[2].charAt(0) ? 1 : 2,
                        text: t[1],
                        tokens: this.lexer.inline(t[1])
                    };
                }
                paragraph(e) {
                    const t = this.rules.block.paragraph.exec(e);
                    if (t) {
                        const e = "\n" === t[1].charAt(t[1].length - 1) ? t[1].slice(0, -1) : t[1];
                        return {
                            type: "paragraph",
                            raw: t[0],
                            text: e,
                            tokens: this.lexer.inline(e)
                        };
                    }
                }
                text(e) {
                    const t = this.rules.block.text.exec(e);
                    if (t) return {
                        type: "text",
                        raw: t[0],
                        text: t[0],
                        tokens: this.lexer.inline(t[0])
                    };
                }
                escape(e) {
                    const t = this.rules.inline.escape.exec(e);
                    if (t) return {
                        type: "escape",
                        raw: t[0],
                        text: tr(t[1])
                    };
                }
                tag(e) {
                    const t = this.rules.inline.tag.exec(e);
                    if (t) return !this.lexer.state.inLink && /^<a /i.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
                        type: this.options.sanitize ? "text" : "html",
                        raw: t[0],
                        inLink: this.lexer.state.inLink,
                        inRawBlock: this.lexer.state.inRawBlock,
                        text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(t[0]) : tr(t[0]) : t[0]
                    };
                }
                link(e) {
                    const t = this.rules.inline.link.exec(e);
                    if (t) {
                        const e = t[2].trim();
                        if (!this.options.pedantic && /^</.test(e)) {
                            if (!/>$/.test(e)) return;
                            const t = fr(e.slice(0, -1), "\\");
                            if ((e.length - t.length) % 2 == 0) return;
                        } else {
                            const e = function(e, t) {
                                if (-1 === e.indexOf(t[1])) return -1;
                                const r = e.length;
                                let n = 0, o = 0;
                                for(; o < r; o++)if ("\\" === e[o]) o++;
                                else if (e[o] === t[0]) n++;
                                else if (e[o] === t[1] && (n--, n < 0)) return o;
                                return -1;
                            }(t[2], "()");
                            if (e > -1) {
                                const r = (0 === t[0].indexOf("!") ? 5 : 4) + t[1].length + e;
                                t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, r).trim(), t[3] = "";
                            }
                        }
                        let r = t[2], n = "";
                        if (this.options.pedantic) {
                            const e = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(r);
                            e && (r = e[1], n = e[3]);
                        } else n = t[3] ? t[3].slice(1, -1) : "";
                        return r = r.trim(), /^</.test(r) && (r = this.options.pedantic && !/>$/.test(e) ? r.slice(1) : r.slice(1, -1)), yr(t, {
                            href: r ? r.replace(this.rules.inline._escapes, "$1") : r,
                            title: n ? n.replace(this.rules.inline._escapes, "$1") : n
                        }, t[0], this.lexer);
                    }
                }
                reflink(e, t) {
                    let r;
                    if ((r = this.rules.inline.reflink.exec(e)) || (r = this.rules.inline.nolink.exec(e))) {
                        let e = (r[2] || r[1]).replace(/\s+/g, " ");
                        if (e = t[e.toLowerCase()], !e) {
                            const e = r[0].charAt(0);
                            return {
                                type: "text",
                                raw: e,
                                text: e
                            };
                        }
                        return yr(r, e, r[0], this.lexer);
                    }
                }
                emStrong(e, t, r = "") {
                    let n = this.rules.inline.emStrong.lDelim.exec(e);
                    if (!n) return;
                    if (n[3] && r.match(/[\p{L}\p{N}]/u)) return;
                    const o = n[1] || n[2] || "";
                    if (!o || o && ("" === r || this.rules.inline.punctuation.exec(r))) {
                        const r = n[0].length - 1;
                        let o, i, s = r, a = 0;
                        const l = "*" === n[0][0] ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
                        for(l.lastIndex = 0, t = t.slice(-1 * e.length + r); null != (n = l.exec(t));){
                            if (o = n[1] || n[2] || n[3] || n[4] || n[5] || n[6], !o) continue;
                            if (i = o.length, n[3] || n[4]) {
                                s += i;
                                continue;
                            }
                            if ((n[5] || n[6]) && r % 3 && !((r + i) % 3)) {
                                a += i;
                                continue;
                            }
                            if (s -= i, s > 0) continue;
                            i = Math.min(i, i + s + a);
                            const t = e.slice(0, r + n.index + (n[0].length - o.length) + i);
                            if (Math.min(r, i) % 2) {
                                const e = t.slice(1, -1);
                                return {
                                    type: "em",
                                    raw: t,
                                    text: e,
                                    tokens: this.lexer.inlineTokens(e)
                                };
                            }
                            const l = t.slice(2, -2);
                            return {
                                type: "strong",
                                raw: t,
                                text: l,
                                tokens: this.lexer.inlineTokens(l)
                            };
                        }
                    }
                }
                codespan(e) {
                    const t = this.rules.inline.code.exec(e);
                    if (t) {
                        let e = t[2].replace(/\n/g, " ");
                        const r = /[^ ]/.test(e), n = /^ /.test(e) && / $/.test(e);
                        return r && n && (e = e.substring(1, e.length - 1)), e = tr(e, !0), {
                            type: "codespan",
                            raw: t[0],
                            text: e
                        };
                    }
                }
                br(e) {
                    const t = this.rules.inline.br.exec(e);
                    if (t) return {
                        type: "br",
                        raw: t[0]
                    };
                }
                del(e) {
                    const t = this.rules.inline.del.exec(e);
                    if (t) return {
                        type: "del",
                        raw: t[0],
                        text: t[2],
                        tokens: this.lexer.inlineTokens(t[2])
                    };
                }
                autolink(e, t) {
                    const r = this.rules.inline.autolink.exec(e);
                    if (r) {
                        let e, n;
                        return "@" === r[2] ? (e = tr(this.options.mangle ? t(r[1]) : r[1]), n = "mailto:" + e) : (e = tr(r[1]), n = e), {
                            type: "link",
                            raw: r[0],
                            text: e,
                            href: n,
                            tokens: [
                                {
                                    type: "text",
                                    raw: e,
                                    text: e
                                }
                            ]
                        };
                    }
                }
                url(e, t) {
                    let r;
                    if (r = this.rules.inline.url.exec(e)) {
                        let e, n;
                        if ("@" === r[2]) e = tr(this.options.mangle ? t(r[0]) : r[0]), n = "mailto:" + e;
                        else {
                            let t;
                            do t = r[0], r[0] = this.rules.inline._backpedal.exec(r[0])[0];
                            while (t !== r[0]);
                            e = tr(r[0]), n = "www." === r[1] ? "http://" + r[0] : r[0];
                        }
                        return {
                            type: "link",
                            raw: r[0],
                            text: e,
                            href: n,
                            tokens: [
                                {
                                    type: "text",
                                    raw: e,
                                    text: e
                                }
                            ]
                        };
                    }
                }
                inlineText(e, t) {
                    const r = this.rules.inline.text.exec(e);
                    if (r) {
                        let e;
                        return e = this.lexer.state.inRawBlock ? this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(r[0]) : tr(r[0]) : r[0] : tr(this.options.smartypants ? t(r[0]) : r[0]), {
                            type: "text",
                            raw: r[0],
                            text: e
                        };
                    }
                }
            }
            const xr = {
                newline: /^(?: *(?:\n|$))+/,
                code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
                fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
                hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
                heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
                blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
                list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
                html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
                def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
                table: hr,
                lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
                _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
                text: /^[^\n]+/,
                _label: /(?!\s*\])(?:\\.|[^\[\]\\])+/,
                _title: /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/
            };
            xr.def = ir(xr.def).replace("label", xr._label).replace("title", xr._title).getRegex(), xr.bullet = /(?:[*+-]|\d{1,9}[.)])/, xr.listItemStart = ir(/^( *)(bull) */).replace("bull", xr.bullet).getRegex(), xr.list = ir(xr.list).replace(/bull/g, xr.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + xr.def.source + ")").getRegex(), xr._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", xr._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/, xr.html = ir(xr.html, "i").replace("comment", xr._comment).replace("tag", xr._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), xr.paragraph = ir(xr._paragraph).replace("hr", xr.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", xr._tag).getRegex(), xr.blockquote = ir(xr.blockquote).replace("paragraph", xr.paragraph).getRegex(), xr.normal = {
                ...xr
            }, xr.gfm = {
                ...xr.normal,
                table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
            }, xr.gfm.table = ir(xr.gfm.table).replace("hr", xr.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", xr._tag).getRegex(), xr.gfm.paragraph = ir(xr._paragraph).replace("hr", xr.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", xr.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", xr._tag).getRegex(), xr.pedantic = {
                ...xr.normal,
                html: ir("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", xr._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
                def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
                heading: /^(#{1,6})(.*)(?:\n+|$)/,
                fences: hr,
                lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
                paragraph: ir(xr.normal._paragraph).replace("hr", xr.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", xr.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
            };
            const vr = {
                escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
                autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
                url: hr,
                tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
                link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
                reflink: /^!?\[(label)\]\[(ref)\]/,
                nolink: /^!?\[(ref)\](?:\[\])?/,
                reflinkSearch: "reflink|nolink(?!\\()",
                emStrong: {
                    lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
                    rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
                    rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
                },
                code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
                br: /^( {2,}|\\)\n(?!\s*$)/,
                del: hr,
                text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
                punctuation: /^([\spunctuation])/
            };
            function wr(e) {
                return e.replace(/---/g, "\u2014").replace(/--/g, "\u2013").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018").replace(/'/g, "\u2019").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C").replace(/"/g, "\u201D").replace(/\.{3}/g, "\u2026");
            }
            function kr(e) {
                let t, r, n = "";
                const o = e.length;
                for(t = 0; t < o; t++)r = e.charCodeAt(t), Math.random() > .5 && (r = "x" + r.toString(16)), n += "&#" + r + ";";
                return n;
            }
            vr._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~", vr.punctuation = ir(vr.punctuation).replace(/punctuation/g, vr._punctuation).getRegex(), vr.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g, vr.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g, vr._comment = ir(xr._comment).replace("(?:--\x3e|$)", "--\x3e").getRegex(), vr.emStrong.lDelim = ir(vr.emStrong.lDelim).replace(/punct/g, vr._punctuation).getRegex(), vr.emStrong.rDelimAst = ir(vr.emStrong.rDelimAst, "g").replace(/punct/g, vr._punctuation).getRegex(), vr.emStrong.rDelimUnd = ir(vr.emStrong.rDelimUnd, "g").replace(/punct/g, vr._punctuation).getRegex(), vr._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g, vr._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/, vr._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/, vr.autolink = ir(vr.autolink).replace("scheme", vr._scheme).replace("email", vr._email).getRegex(), vr._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/, vr.tag = ir(vr.tag).replace("comment", vr._comment).replace("attribute", vr._attribute).getRegex(), vr._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, vr._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/, vr._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/, vr.link = ir(vr.link).replace("label", vr._label).replace("href", vr._href).replace("title", vr._title).getRegex(), vr.reflink = ir(vr.reflink).replace("label", vr._label).replace("ref", xr._label).getRegex(), vr.nolink = ir(vr.nolink).replace("ref", xr._label).getRegex(), vr.reflinkSearch = ir(vr.reflinkSearch, "g").replace("reflink", vr.reflink).replace("nolink", vr.nolink).getRegex(), vr.normal = {
                ...vr
            }, vr.pedantic = {
                ...vr.normal,
                strong: {
                    start: /^__|\*\*/,
                    middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
                    endAst: /\*\*(?!\*)/g,
                    endUnd: /__(?!_)/g
                },
                em: {
                    start: /^_|\*/,
                    middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
                    endAst: /\*(?!\*)/g,
                    endUnd: /_(?!_)/g
                },
                link: ir(/^!?\[(label)\]\((.*?)\)/).replace("label", vr._label).getRegex(),
                reflink: ir(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", vr._label).getRegex()
            }, vr.gfm = {
                ...vr.normal,
                escape: ir(vr.escape).replace("])", "~|])").getRegex(),
                _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
                url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
                _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
                del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
                text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
            }, vr.gfm.url = ir(vr.gfm.url, "i").replace("email", vr.gfm._extended_email).getRegex(), vr.breaks = {
                ...vr.gfm,
                br: ir(vr.br).replace("{2,}", "*").getRegex(),
                text: ir(vr.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
            };
            class Er {
                constructor(e){
                    this.tokens = [], this.tokens.links = Object.create(null), this.options = e || Jt, this.options.tokenizer = this.options.tokenizer || new br, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
                        inLink: !1,
                        inRawBlock: !1,
                        top: !0
                    };
                    const t = {
                        block: xr.normal,
                        inline: vr.normal
                    };
                    this.options.pedantic ? (t.block = xr.pedantic, t.inline = vr.pedantic) : this.options.gfm && (t.block = xr.gfm, this.options.breaks ? t.inline = vr.breaks : t.inline = vr.gfm), this.tokenizer.rules = t;
                }
                static get rules() {
                    return {
                        block: xr,
                        inline: vr
                    };
                }
                static lex(e, t) {
                    return new Er(t).lex(e);
                }
                static lexInline(e, t) {
                    return new Er(t).inlineTokens(e);
                }
                lex(e) {
                    let t;
                    for(e = e.replace(/\r\n|\r/g, "\n"), this.blockTokens(e, this.tokens); t = this.inlineQueue.shift();)this.inlineTokens(t.src, t.tokens);
                    return this.tokens;
                }
                blockTokens(e, t = []) {
                    let r, n, o, i;
                    for(e = this.options.pedantic ? e.replace(/\t/g, "    ").replace(/^ +$/gm, "") : e.replace(/^( *)(\t+)/gm, (e, t, r)=>t + "    ".repeat(r.length)); e;)if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((n)=>!!(r = n.call({
                            lexer: this
                        }, e, t)) && (e = e.substring(r.raw.length), t.push(r), !0)))) {
                        if (r = this.tokenizer.space(e)) e = e.substring(r.raw.length), 1 === r.raw.length && t.length > 0 ? t[t.length - 1].raw += "\n" : t.push(r);
                        else if (r = this.tokenizer.code(e)) e = e.substring(r.raw.length), n = t[t.length - 1], !n || "paragraph" !== n.type && "text" !== n.type ? t.push(r) : (n.raw += "\n" + r.raw, n.text += "\n" + r.text, this.inlineQueue[this.inlineQueue.length - 1].src = n.text);
                        else if (r = this.tokenizer.fences(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.heading(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.hr(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.blockquote(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.list(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.html(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.def(e)) e = e.substring(r.raw.length), n = t[t.length - 1], !n || "paragraph" !== n.type && "text" !== n.type ? this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                            href: r.href,
                            title: r.title
                        }) : (n.raw += "\n" + r.raw, n.text += "\n" + r.raw, this.inlineQueue[this.inlineQueue.length - 1].src = n.text);
                        else if (r = this.tokenizer.table(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.lheading(e)) e = e.substring(r.raw.length), t.push(r);
                        else {
                            if (o = e, this.options.extensions && this.options.extensions.startBlock) {
                                let t = 1 / 0;
                                const r = e.slice(1);
                                let n;
                                this.options.extensions.startBlock.forEach(function(e) {
                                    n = e.call({
                                        lexer: this
                                    }, r), "number" == typeof n && n >= 0 && (t = Math.min(t, n));
                                }), t < 1 / 0 && t >= 0 && (o = e.substring(0, t + 1));
                            }
                            if (this.state.top && (r = this.tokenizer.paragraph(o))) n = t[t.length - 1], i && "paragraph" === n.type ? (n.raw += "\n" + r.raw, n.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : t.push(r), i = o.length !== e.length, e = e.substring(r.raw.length);
                            else if (r = this.tokenizer.text(e)) e = e.substring(r.raw.length), n = t[t.length - 1], n && "text" === n.type ? (n.raw += "\n" + r.raw, n.text += "\n" + r.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : t.push(r);
                            else if (e) {
                                const t = "Infinite loop on byte: " + e.charCodeAt(0);
                                if (this.options.silent) {
                                    console.error(t);
                                    break;
                                }
                                throw new Error(t);
                            }
                        }
                    }
                    return this.state.top = !0, t;
                }
                inline(e, t = []) {
                    return this.inlineQueue.push({
                        src: e,
                        tokens: t
                    }), t;
                }
                inlineTokens(e, t = []) {
                    let r, n, o, i, s, a, l = e;
                    if (this.tokens.links) {
                        const e = Object.keys(this.tokens.links);
                        if (e.length > 0) for(; null != (i = this.tokenizer.rules.inline.reflinkSearch.exec(l));)e.includes(i[0].slice(i[0].lastIndexOf("[") + 1, -1)) && (l = l.slice(0, i.index) + "[" + gr("a", i[0].length - 2) + "]" + l.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
                    }
                    for(; null != (i = this.tokenizer.rules.inline.blockSkip.exec(l));)l = l.slice(0, i.index) + "[" + gr("a", i[0].length - 2) + "]" + l.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
                    for(; null != (i = this.tokenizer.rules.inline.escapedEmSt.exec(l));)l = l.slice(0, i.index + i[0].length - 2) + "++" + l.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex), this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
                    for(; e;)if (s || (a = ""), s = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((n)=>!!(r = n.call({
                            lexer: this
                        }, e, t)) && (e = e.substring(r.raw.length), t.push(r), !0)))) {
                        if (r = this.tokenizer.escape(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.tag(e)) e = e.substring(r.raw.length), n = t[t.length - 1], n && "text" === r.type && "text" === n.type ? (n.raw += r.raw, n.text += r.text) : t.push(r);
                        else if (r = this.tokenizer.link(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.reflink(e, this.tokens.links)) e = e.substring(r.raw.length), n = t[t.length - 1], n && "text" === r.type && "text" === n.type ? (n.raw += r.raw, n.text += r.text) : t.push(r);
                        else if (r = this.tokenizer.emStrong(e, l, a)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.codespan(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.br(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.del(e)) e = e.substring(r.raw.length), t.push(r);
                        else if (r = this.tokenizer.autolink(e, kr)) e = e.substring(r.raw.length), t.push(r);
                        else if (this.state.inLink || !(r = this.tokenizer.url(e, kr))) {
                            if (o = e, this.options.extensions && this.options.extensions.startInline) {
                                let t = 1 / 0;
                                const r = e.slice(1);
                                let n;
                                this.options.extensions.startInline.forEach(function(e) {
                                    n = e.call({
                                        lexer: this
                                    }, r), "number" == typeof n && n >= 0 && (t = Math.min(t, n));
                                }), t < 1 / 0 && t >= 0 && (o = e.substring(0, t + 1));
                            }
                            if (r = this.tokenizer.inlineText(o, wr)) e = e.substring(r.raw.length), "_" !== r.raw.slice(-1) && (a = r.raw.slice(-1)), s = !0, n = t[t.length - 1], n && "text" === n.type ? (n.raw += r.raw, n.text += r.text) : t.push(r);
                            else if (e) {
                                const t = "Infinite loop on byte: " + e.charCodeAt(0);
                                if (this.options.silent) {
                                    console.error(t);
                                    break;
                                }
                                throw new Error(t);
                            }
                        } else e = e.substring(r.raw.length), t.push(r);
                    }
                    return t;
                }
            }
            class Or {
                constructor(e){
                    this.options = e || Jt;
                }
                code(e, t, r) {
                    const n = (t || "").match(/\S*/)[0];
                    if (this.options.highlight) {
                        const t = this.options.highlight(e, n);
                        null != t && t !== e && (r = !0, e = t);
                    }
                    return e = e.replace(/\n$/, "") + "\n", n ? '<pre><code class="' + this.options.langPrefix + tr(n) + '">' + (r ? e : tr(e, !0)) + "</code></pre>\n" : "<pre><code>" + (r ? e : tr(e, !0)) + "</code></pre>\n";
                }
                blockquote(e) {
                    return `<blockquote>\n${e}</blockquote>\n`;
                }
                html(e) {
                    return e;
                }
                heading(e, t, r, n) {
                    return this.options.headerIds ? `<h${t} id="${this.options.headerPrefix + n.slug(r)}">${e}</h${t}>\n` : `<h${t}>${e}</h${t}>\n`;
                }
                hr() {
                    return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
                }
                list(e, t, r) {
                    const n = t ? "ol" : "ul";
                    return "<" + n + (t && 1 !== r ? ' start="' + r + '"' : "") + ">\n" + e + "</" + n + ">\n";
                }
                listitem(e) {
                    return `<li>${e}</li>\n`;
                }
                checkbox(e) {
                    return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
                }
                paragraph(e) {
                    return `<p>${e}</p>\n`;
                }
                table(e, t) {
                    return t && (t = `<tbody>${t}</tbody>`), "<table>\n<thead>\n" + e + "</thead>\n" + t + "</table>\n";
                }
                tablerow(e) {
                    return `<tr>\n${e}</tr>\n`;
                }
                tablecell(e, t) {
                    const r = t.header ? "th" : "td";
                    return (t.align ? `<${r} align="${t.align}">` : `<${r}>`) + e + `</${r}>\n`;
                }
                strong(e) {
                    return `<strong>${e}</strong>`;
                }
                em(e) {
                    return `<em>${e}</em>`;
                }
                codespan(e) {
                    return `<code>${e}</code>`;
                }
                br() {
                    return this.options.xhtml ? "<br/>" : "<br>";
                }
                del(e) {
                    return `<del>${e}</del>`;
                }
                link(e, t, r) {
                    if (null === (e = lr(this.options.sanitize, this.options.baseUrl, e))) return r;
                    let n = '<a href="' + e + '"';
                    return t && (n += ' title="' + t + '"'), n += ">" + r + "</a>", n;
                }
                image(e, t, r) {
                    if (null === (e = lr(this.options.sanitize, this.options.baseUrl, e))) return r;
                    let n = `<img src="${e}" alt="${r}"`;
                    return t && (n += ` title="${t}"`), n += this.options.xhtml ? "/>" : ">", n;
                }
                text(e) {
                    return e;
                }
            }
            class jr {
                strong(e) {
                    return e;
                }
                em(e) {
                    return e;
                }
                codespan(e) {
                    return e;
                }
                del(e) {
                    return e;
                }
                html(e) {
                    return e;
                }
                text(e) {
                    return e;
                }
                link(e, t, r) {
                    return "" + r;
                }
                image(e, t, r) {
                    return "" + r;
                }
                br() {
                    return "";
                }
            }
            class $r {
                constructor(){
                    this.seen = {};
                }
                serialize(e) {
                    return e.toLowerCase().trim().replace(/<[!\/a-z].*?>/gi, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
                }
                getNextSafeSlug(e, t) {
                    let r = e, n = 0;
                    if (this.seen.hasOwnProperty(r)) {
                        n = this.seen[e];
                        do n++, r = e + "-" + n;
                        while (this.seen.hasOwnProperty(r));
                    }
                    return t || (this.seen[e] = n, this.seen[r] = 0), r;
                }
                slug(e, t = {}) {
                    const r = this.serialize(e);
                    return this.getNextSafeSlug(r, t.dryrun);
                }
            }
            class Sr {
                constructor(e){
                    this.options = e || Jt, this.options.renderer = this.options.renderer || new Or, this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new jr, this.slugger = new $r;
                }
                static parse(e, t) {
                    return new Sr(t).parse(e);
                }
                static parseInline(e, t) {
                    return new Sr(t).parseInline(e);
                }
                parse(e, t = !0) {
                    let r, n, o, i, s, a, l, c, p, u, d, h, m, f, g, y, b, x, v, w = "";
                    const k = e.length;
                    for(r = 0; r < k; r++)if (u = e[r], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[u.type] && (v = this.options.extensions.renderers[u.type].call({
                        parser: this
                    }, u), !1 !== v || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(u.type))) w += v || "";
                    else switch(u.type){
                        case "space":
                            continue;
                        case "hr":
                            w += this.renderer.hr();
                            continue;
                        case "heading":
                            w += this.renderer.heading(this.parseInline(u.tokens), u.depth, nr(this.parseInline(u.tokens, this.textRenderer)), this.slugger);
                            continue;
                        case "code":
                            w += this.renderer.code(u.text, u.lang, u.escaped);
                            continue;
                        case "table":
                            for(c = "", l = "", i = u.header.length, n = 0; n < i; n++)l += this.renderer.tablecell(this.parseInline(u.header[n].tokens), {
                                header: !0,
                                align: u.align[n]
                            });
                            for(c += this.renderer.tablerow(l), p = "", i = u.rows.length, n = 0; n < i; n++){
                                for(a = u.rows[n], l = "", s = a.length, o = 0; o < s; o++)l += this.renderer.tablecell(this.parseInline(a[o].tokens), {
                                    header: !1,
                                    align: u.align[o]
                                });
                                p += this.renderer.tablerow(l);
                            }
                            w += this.renderer.table(c, p);
                            continue;
                        case "blockquote":
                            p = this.parse(u.tokens), w += this.renderer.blockquote(p);
                            continue;
                        case "list":
                            for(d = u.ordered, h = u.start, m = u.loose, i = u.items.length, p = "", n = 0; n < i; n++)g = u.items[n], y = g.checked, b = g.task, f = "", g.task && (x = this.renderer.checkbox(y), m ? g.tokens.length > 0 && "paragraph" === g.tokens[0].type ? (g.tokens[0].text = x + " " + g.tokens[0].text, g.tokens[0].tokens && g.tokens[0].tokens.length > 0 && "text" === g.tokens[0].tokens[0].type && (g.tokens[0].tokens[0].text = x + " " + g.tokens[0].tokens[0].text)) : g.tokens.unshift({
                                type: "text",
                                text: x
                            }) : f += x), f += this.parse(g.tokens, m), p += this.renderer.listitem(f, b, y);
                            w += this.renderer.list(p, d, h);
                            continue;
                        case "html":
                            w += this.renderer.html(u.text);
                            continue;
                        case "paragraph":
                            w += this.renderer.paragraph(this.parseInline(u.tokens));
                            continue;
                        case "text":
                            for(p = u.tokens ? this.parseInline(u.tokens) : u.text; r + 1 < k && "text" === e[r + 1].type;)u = e[++r], p += "\n" + (u.tokens ? this.parseInline(u.tokens) : u.text);
                            w += t ? this.renderer.paragraph(p) : p;
                            continue;
                        default:
                            {
                                const e = 'Token with "' + u.type + '" type was not found.';
                                if (this.options.silent) return void console.error(e);
                                throw new Error(e);
                            }
                    }
                    return w;
                }
                parseInline(e, t) {
                    t = t || this.renderer;
                    let r, n, o, i = "";
                    const s = e.length;
                    for(r = 0; r < s; r++)if (n = e[r], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[n.type] && (o = this.options.extensions.renderers[n.type].call({
                        parser: this
                    }, n), !1 !== o || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(n.type))) i += o || "";
                    else switch(n.type){
                        case "escape":
                        case "text":
                            i += t.text(n.text);
                            break;
                        case "html":
                            i += t.html(n.text);
                            break;
                        case "link":
                            i += t.link(n.href, n.title, this.parseInline(n.tokens, t));
                            break;
                        case "image":
                            i += t.image(n.href, n.title, n.text);
                            break;
                        case "strong":
                            i += t.strong(this.parseInline(n.tokens, t));
                            break;
                        case "em":
                            i += t.em(this.parseInline(n.tokens, t));
                            break;
                        case "codespan":
                            i += t.codespan(n.text);
                            break;
                        case "br":
                            i += t.br();
                            break;
                        case "del":
                            i += t.del(this.parseInline(n.tokens, t));
                            break;
                        default:
                            {
                                const e = 'Token with "' + n.type + '" type was not found.';
                                if (this.options.silent) return void console.error(e);
                                throw new Error(e);
                            }
                    }
                    return i;
                }
            }
            class Cr {
                constructor(e){
                    this.options = e || Jt;
                }
                static passThroughHooks = new Set([
                    "preprocess",
                    "postprocess"
                ]);
                preprocess(e) {
                    return e;
                }
                postprocess(e) {
                    return e;
                }
            }
            function Pr(e, t) {
                return (r, n, o)=>{
                    "function" == typeof n && (o = n, n = null);
                    const i = {
                        ...n
                    }, s = function(e, t, r) {
                        return (n)=>{
                            if (n.message += "\nPlease report this to https://github.com/markedjs/marked.", e) {
                                const e = "<p>An error occurred:</p><pre>" + tr(n.message + "", !0) + "</pre>";
                                return t ? Promise.resolve(e) : r ? void r(null, e) : e;
                            }
                            if (t) return Promise.reject(n);
                            if (!r) throw n;
                            r(n);
                        };
                    }((n = {
                        ...Ir.defaults,
                        ...i
                    }).silent, n.async, o);
                    if (null == r) return s(new Error("marked(): input parameter is undefined or null"));
                    if ("string" != typeof r) return s(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(r) + ", string expected"));
                    if (function(e) {
                        e && e.sanitize && !e.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
                    }(n), n.hooks && (n.hooks.options = n), o) {
                        const i = n.highlight;
                        let a;
                        try {
                            n.hooks && (r = n.hooks.preprocess(r)), a = e(r, n);
                        } catch (e) {
                            return s(e);
                        }
                        const l = function(e) {
                            let r;
                            if (!e) try {
                                n.walkTokens && Ir.walkTokens(a, n.walkTokens), r = t(a, n), n.hooks && (r = n.hooks.postprocess(r));
                            } catch (t) {
                                e = t;
                            }
                            return n.highlight = i, e ? s(e) : o(null, r);
                        };
                        if (!i || i.length < 3) return l();
                        if (delete n.highlight, !a.length) return l();
                        let c = 0;
                        return Ir.walkTokens(a, function(e) {
                            "code" === e.type && (c++, setTimeout(()=>{
                                i(e.text, e.lang, function(t, r) {
                                    if (t) return l(t);
                                    null != r && r !== e.text && (e.text = r, e.escaped = !0), c--, 0 === c && l();
                                });
                            }, 0));
                        }), void (0 === c && l());
                    }
                    if (n.async) return Promise.resolve(n.hooks ? n.hooks.preprocess(r) : r).then((t)=>e(t, n)).then((e)=>n.walkTokens ? Promise.all(Ir.walkTokens(e, n.walkTokens)).then(()=>e) : e).then((e)=>t(e, n)).then((e)=>n.hooks ? n.hooks.postprocess(e) : e).catch(s);
                    try {
                        n.hooks && (r = n.hooks.preprocess(r));
                        const o = e(r, n);
                        n.walkTokens && Ir.walkTokens(o, n.walkTokens);
                        let i = t(o, n);
                        return n.hooks && (i = n.hooks.postprocess(i)), i;
                    } catch (e) {
                        return s(e);
                    }
                };
            }
            function Ir(e, t, r) {
                return Pr(Er.lex, Sr.parse)(e, t, r);
            }
            Ir.options = Ir.setOptions = function(e) {
                var t;
                return Ir.defaults = {
                    ...Ir.defaults,
                    ...e
                }, t = Ir.defaults, Jt = t, Ir;
            }, Ir.getDefaults = function() {
                return {
                    async: !1,
                    baseUrl: null,
                    breaks: !1,
                    extensions: null,
                    gfm: !0,
                    headerIds: !0,
                    headerPrefix: "",
                    highlight: null,
                    hooks: null,
                    langPrefix: "language-",
                    mangle: !0,
                    pedantic: !1,
                    renderer: null,
                    sanitize: !1,
                    sanitizer: null,
                    silent: !1,
                    smartypants: !1,
                    tokenizer: null,
                    walkTokens: null,
                    xhtml: !1
                };
            }, Ir.defaults = Jt, Ir.use = function(...e) {
                const t = Ir.defaults.extensions || {
                    renderers: {},
                    childTokens: {}
                };
                e.forEach((e)=>{
                    const r = {
                        ...e
                    };
                    if (r.async = Ir.defaults.async || r.async || !1, e.extensions && (e.extensions.forEach((e)=>{
                        if (!e.name) throw new Error("extension name required");
                        if (e.renderer) {
                            const r = t.renderers[e.name];
                            t.renderers[e.name] = r ? function(...t) {
                                let n = e.renderer.apply(this, t);
                                return !1 === n && (n = r.apply(this, t)), n;
                            } : e.renderer;
                        }
                        if (e.tokenizer) {
                            if (!e.level || "block" !== e.level && "inline" !== e.level) throw new Error("extension level must be 'block' or 'inline'");
                            t[e.level] ? t[e.level].unshift(e.tokenizer) : t[e.level] = [
                                e.tokenizer
                            ], e.start && ("block" === e.level ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [
                                e.start
                            ] : "inline" === e.level && (t.startInline ? t.startInline.push(e.start) : t.startInline = [
                                e.start
                            ]));
                        }
                        e.childTokens && (t.childTokens[e.name] = e.childTokens);
                    }), r.extensions = t), e.renderer) {
                        const t = Ir.defaults.renderer || new Or;
                        for(const r in e.renderer){
                            const n = t[r];
                            t[r] = (...o)=>{
                                let i = e.renderer[r].apply(t, o);
                                return !1 === i && (i = n.apply(t, o)), i;
                            };
                        }
                        r.renderer = t;
                    }
                    if (e.tokenizer) {
                        const t = Ir.defaults.tokenizer || new br;
                        for(const r in e.tokenizer){
                            const n = t[r];
                            t[r] = (...o)=>{
                                let i = e.tokenizer[r].apply(t, o);
                                return !1 === i && (i = n.apply(t, o)), i;
                            };
                        }
                        r.tokenizer = t;
                    }
                    if (e.hooks) {
                        const t = Ir.defaults.hooks || new Cr;
                        for(const r in e.hooks){
                            const n = t[r];
                            Cr.passThroughHooks.has(r) ? t[r] = (o)=>{
                                if (Ir.defaults.async) return Promise.resolve(e.hooks[r].call(t, o)).then((e)=>n.call(t, e));
                                const i = e.hooks[r].call(t, o);
                                return n.call(t, i);
                            } : t[r] = (...o)=>{
                                let i = e.hooks[r].apply(t, o);
                                return !1 === i && (i = n.apply(t, o)), i;
                            };
                        }
                        r.hooks = t;
                    }
                    if (e.walkTokens) {
                        const t = Ir.defaults.walkTokens;
                        r.walkTokens = function(r) {
                            let n = [];
                            return n.push(e.walkTokens.call(this, r)), t && (n = n.concat(t.call(this, r))), n;
                        };
                    }
                    Ir.setOptions(r);
                });
            }, Ir.walkTokens = function(e, t) {
                let r = [];
                for (const n of e)switch(r = r.concat(t.call(Ir, n)), n.type){
                    case "table":
                        for (const e of n.header)r = r.concat(Ir.walkTokens(e.tokens, t));
                        for (const e of n.rows)for (const n of e)r = r.concat(Ir.walkTokens(n.tokens, t));
                        break;
                    case "list":
                        r = r.concat(Ir.walkTokens(n.items, t));
                        break;
                    default:
                        Ir.defaults.extensions && Ir.defaults.extensions.childTokens && Ir.defaults.extensions.childTokens[n.type] ? Ir.defaults.extensions.childTokens[n.type].forEach(function(e) {
                            r = r.concat(Ir.walkTokens(n[e], t));
                        }) : n.tokens && (r = r.concat(Ir.walkTokens(n.tokens, t)));
                }
                return r;
            }, Ir.parseInline = Pr(Er.lexInline, Sr.parseInline), Ir.Parser = Sr, Ir.parser = Sr.parse, Ir.Renderer = Or, Ir.TextRenderer = jr, Ir.Lexer = Er, Ir.lexer = Er.lex, Ir.Tokenizer = br, Ir.Slugger = $r, Ir.Hooks = Cr, Ir.parse = Ir, Ir.options, Ir.setOptions, Ir.use, Ir.walkTokens, Ir.parseInline;
            var Ar = Object.defineProperty, Tr = Object.defineProperties, _r = Object.getOwnPropertyDescriptors, Rr = Object.getOwnPropertySymbols, Dr = Object.prototype.hasOwnProperty, zr = Object.prototype.propertyIsEnumerable, Lr = (e, t, r)=>t in e ? Ar(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, Nr = (e, t)=>{
                for(var r in t || (t = {}))Dr.call(t, r) && Lr(e, r, t[r]);
                if (Rr) for (var r of Rr(t))zr.call(t, r) && Lr(e, r, t[r]);
                return e;
            }, Mr = (e, t)=>Tr(e, _r(t));
            const qr = new Ir.Renderer;
            Ir.setOptions({
                renderer: qr,
                highlight: (e, t)=>jt(e, t)
            });
            const Fr = "^ {0,3}\x3c!-- ReDoc-Inject:\\s+?<({component}).*?/?>\\s+?--\x3e\\s*$", Br = "(?:^ {0,3}<({component})([\\s\\S]*?)>([\\s\\S]*?)</\\2>|^ {0,3}<({component})([\\s\\S]*?)(?:/>|\\n{2,}))", Qr = "(?:" + Fr + "|" + Br + ")";
            function Ur(e) {
                return `\x3c!-- ReDoc-Inject: <${e}> --\x3e`;
            }
            class Wr {
                constructor(e, t){
                    this.options = e, this.parentId = t, this.headings = [], this.headingRule = (e, t, r, n)=>(1 === t ? this.currentTopHeading = this.saveHeading(e, t) : 2 === t && this.saveHeading(e, t, this.currentTopHeading && this.currentTopHeading.items, this.currentTopHeading && this.currentTopHeading.id), this.originalHeadingRule(e, t, r, n)), this.parentId = t, this.parser = new Ir.Parser, this.headingEnhanceRenderer = new Ir.Renderer, this.originalHeadingRule = this.headingEnhanceRenderer.heading.bind(this.headingEnhanceRenderer), this.headingEnhanceRenderer.heading = this.headingRule;
                }
                static containsComponent(e, t) {
                    return new RegExp(Qr.replace(/{component}/g, t), "gmi").test(e);
                }
                static getTextBeforeHading(e, t) {
                    const r = e.search(new RegExp(`^##?\\s+${t}`, "m"));
                    return r > -1 ? e.substring(0, r) : e;
                }
                saveHeading(e, t, r = this.headings, n) {
                    e = P(e);
                    const o = {
                        id: n ? `${n}/${w(e)}` : `${this.parentId || "section"}/${w(e)}`,
                        name: e,
                        level: t,
                        items: []
                    };
                    return r.push(o), o;
                }
                flattenHeadings(e) {
                    if (void 0 === e) return [];
                    const t = [];
                    for (const r of e)t.push(r), t.push(...this.flattenHeadings(r.items));
                    return t;
                }
                attachHeadingsDescriptions(e) {
                    const t = (e)=>new RegExp(`##?\\s+${e.name.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")}s*(\n|\r\n|$|s*)`), r = this.flattenHeadings(this.headings);
                    if (r.length < 1) return;
                    let n = r[0], o = t(n), i = e.search(o);
                    for(let s = 1; s < r.length; s++){
                        const a = r[s], l = t(a), c = e.substr(i + 1).search(l) + i + 1;
                        n.description = e.substring(i, c).replace(o, "").trim(), n = a, o = l, i = c;
                    }
                    n.description = e.substring(i).replace(o, "").trim();
                }
                renderMd(e, t = !1) {
                    const r = t ? {
                        renderer: this.headingEnhanceRenderer
                    } : void 0;
                    return Ir(e.toString(), r);
                }
                extractHeadings(e) {
                    this.renderMd(e, !0), this.attachHeadingsDescriptions(e);
                    const t = this.headings;
                    return this.headings = [], t;
                }
                renderMdWithComponents(e) {
                    const t = this.options && this.options.allowedMdComponents;
                    if (!t || 0 === Object.keys(t).length) return [
                        this.renderMd(e)
                    ];
                    const r = Object.keys(t).join("|"), n = new RegExp(Qr.replace(/{component}/g, r), "mig"), o = [], i = [];
                    let s = n.exec(e), a = 0;
                    for(; s;){
                        o.push(e.substring(a, s.index)), a = n.lastIndex;
                        const r = t[s[1] || s[2] || s[5]], l = s[3] || s[6], c = s[4];
                        r && i.push({
                            component: r.component,
                            propsSelector: r.propsSelector,
                            props: Mr(Nr(Nr({}, Vr(l)), r.props), {
                                children: c
                            })
                        }), s = n.exec(e);
                    }
                    o.push(e.substring(a));
                    const l = [];
                    for(let e = 0; e < o.length; e++){
                        const t = o[e];
                        t && l.push(this.renderMd(t)), i[e] && l.push(i[e]);
                    }
                    return l;
                }
            }
            function Vr(e) {
                if (!e) return {};
                const t = /([\w-]+)\s*=\s*(?:{([^}]+?)}|"([^"]+?)")/gim, r = {};
                let n;
                for(; null !== (n = t.exec(e));)if (n[3]) r[n[1]] = n[3];
                else if (n[2]) {
                    let e;
                    try {
                        e = JSON.parse(n[2]);
                    } catch (e) {}
                    r[n[1]] = e;
                }
                return r;
            }
            class Hr {
                constructor(e, t = new W({})){
                    this.parser = e, this.options = t, Object.assign(this, e.spec.info), this.description = e.spec.info.description || "", this.summary = e.spec.info.summary || "";
                    const r = this.description.search(/^\s*##?\s+/m);
                    r > -1 && (this.description = this.description.substring(0, r)), this.downloadUrls = this.getDownloadUrls(), this.downloadFileName = this.getDownloadFileName();
                }
                getDownloadUrls() {
                    return (this.options.downloadUrls ? this.options.downloadUrls.map(({ title: e, url: t })=>({
                            title: e || _("download"),
                            url: this.getDownloadLink(t)
                        })) : [
                        {
                            title: _("download"),
                            url: this.getDownloadLink(this.options.downloadDefinitionUrl)
                        }
                    ]).filter(({ title: e, url: t })=>e && t);
                }
                getDownloadLink(e) {
                    if (e) return e;
                    if (this.parser.specUrl) return this.parser.specUrl;
                    if (s && window.Blob && window.URL && window.URL.createObjectURL) {
                        const e = new Blob([
                            JSON.stringify(this.parser.spec, null, 2)
                        ], {
                            type: "application/json"
                        });
                        return window.URL.createObjectURL(e);
                    }
                }
                getDownloadFileName() {
                    return this.parser.specUrl || this.options.downloadDefinitionUrl ? this.options.downloadFileName : this.options.downloadFileName || "openapi.json";
                }
            }
            var Jr = Object.defineProperty, Yr = Object.defineProperties, Gr = Object.getOwnPropertyDescriptors, Zr = Object.getOwnPropertySymbols, Xr = Object.prototype.hasOwnProperty, Kr = Object.prototype.propertyIsEnumerable, en = (e, t, r)=>t in e ? Jr(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r;
            class tn {
                constructor(e, t){
                    const r = t.spec.components && t.spec.components.securitySchemes || {};
                    this.schemes = Object.keys(e || {}).map((n)=>{
                        const { resolved: o } = t.deref(r[n]), i = e[n] || [];
                        if (!o) return void console.warn(`Non existing security scheme referenced: ${n}. Skipping`);
                        const s = o["x-displayName"] || n;
                        var a;
                        return a = ((e, t)=>{
                            for(var r in t || (t = {}))Xr.call(t, r) && en(e, r, t[r]);
                            if (Zr) for (var r of Zr(t))Kr.call(t, r) && en(e, r, t[r]);
                            return e;
                        })({}, o), Yr(a, Gr({
                            id: n,
                            sectionId: n,
                            displayName: s,
                            scopes: i
                        }));
                    }).filter((e)=>void 0 !== e);
                }
            }
            var rn = Object.defineProperty, nn = Object.defineProperties, on = Object.getOwnPropertyDescriptor, sn = Object.getOwnPropertyDescriptors, an = Object.getOwnPropertySymbols, ln = Object.prototype.hasOwnProperty, cn = Object.prototype.propertyIsEnumerable, pn = (e, t, r)=>t in e ? rn(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, un = (e, t)=>{
                for(var r in t || (t = {}))ln.call(t, r) && pn(e, r, t[r]);
                if (an) for (var r of an(t))cn.call(t, r) && pn(e, r, t[r]);
                return e;
            }, dn = (e, t)=>nn(e, sn(t)), hn = (e, t, r, n)=>{
                for(var o, i = n > 1 ? void 0 : n ? on(t, r) : t, s = e.length - 1; s >= 0; s--)(o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
                return n && i && rn(t, r, i), i;
            };
            class mn {
                constructor(e, t, r, n, o){
                    this.expanded = !1, this.operations = [], (0, de.makeObservable)(this), this.name = t;
                    const { resolved: i } = e.deref(r);
                    for (const r of Object.keys(i)){
                        const s = i[r], a = Object.keys(s).filter(Me);
                        for (const i of a){
                            const a = s[i], l = new xo(e, dn(un({}, a), {
                                pathName: r,
                                pointer: Ee.compile([
                                    n,
                                    t,
                                    r,
                                    i
                                ]),
                                httpVerb: i,
                                pathParameters: s.parameters || [],
                                pathServers: s.servers
                            }), void 0, o, !0);
                            this.operations.push(l);
                        }
                    }
                }
                toggle() {
                    this.expanded = !this.expanded;
                }
            }
            hn([
                de.observable
            ], mn.prototype, "expanded", 2), hn([
                de.action
            ], mn.prototype, "toggle", 1);
            var fn = Object.defineProperty, gn = Object.defineProperties, yn = Object.getOwnPropertyDescriptors, bn = Object.getOwnPropertySymbols, xn = Object.prototype.hasOwnProperty, vn = Object.prototype.propertyIsEnumerable, wn = (e, t, r)=>t in e ? fn(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, kn = (e, t)=>{
                for(var r in t || (t = {}))xn.call(t, r) && wn(e, r, t[r]);
                if (bn) for (var r of bn(t))vn.call(t, r) && wn(e, r, t[r]);
                return e;
            }, En = (e, t)=>gn(e, yn(t)), On = (e, t)=>{
                var r = {};
                for(var n in e)xn.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                if (null != e && bn) for (var n of bn(e))t.indexOf(n) < 0 && vn.call(e, n) && (r[n] = e[n]);
                return r;
            };
            function jn(e, t) {
                return t && e[e.length - 1] !== t ? [
                    ...e,
                    t
                ] : e;
            }
            function $n(e, t) {
                return t ? e.concat(t) : e;
            }
            class Sn {
                constructor(e, t, r = new W({})){
                    this.options = r, this.allowMergeRefs = !1, this.byRef = (e)=>{
                        let t;
                        if (this.spec) {
                            "#" !== e.charAt(0) && (e = "#" + e), e = decodeURIComponent(e);
                            try {
                                t = Ee.get(this.spec, e);
                            } catch (e) {}
                            return t || {};
                        }
                    }, this.validate(e), this.spec = e, this.allowMergeRefs = e.openapi.startsWith("3.1");
                    const n = s ? window.location.href : "";
                    "string" == typeof t && (this.specUrl = n ? new URL(t, n).href : t);
                }
                validate(e) {
                    if (void 0 === e.openapi) throw new Error("Document must be valid OpenAPI 3.0.0 definition");
                }
                isRef(e) {
                    return !!e && void 0 !== e.$ref && null !== e.$ref;
                }
                deref(e, t = [], r = !1) {
                    const n = null == e ? void 0 : e["x-refsStack"];
                    if (t = $n(t, n), this.isRef(e)) {
                        const n = rt(e.$ref);
                        if (n && this.options.ignoreNamedSchemas.has(n)) return {
                            resolved: {
                                type: "object",
                                title: n
                            },
                            refsStack: t
                        };
                        let o = this.byRef(e.$ref);
                        if (!o) throw new Error(`Failed to resolve $ref "${e.$ref}"`);
                        let i = t;
                        if (t.includes(e.$ref) || t.length > 999) o = Object.assign({}, o, {
                            "x-circular-ref": !0
                        });
                        else if (this.isRef(o)) {
                            const e = this.deref(o, t, r);
                            i = e.refsStack, o = e.resolved;
                        }
                        return i = jn(t, e.$ref), o = this.allowMergeRefs ? this.mergeRefs(e, o, r) : o, {
                            resolved: o,
                            refsStack: i
                        };
                    }
                    return {
                        resolved: e,
                        refsStack: $n(t, n)
                    };
                }
                mergeRefs(e, t, r) {
                    const n = e, { $ref: o } = n, i = On(n, [
                        "$ref"
                    ]), s = Object.keys(i);
                    if (0 === s.length) return t;
                    if (r && s.some((e)=>![
                            "description",
                            "title",
                            "externalDocs",
                            "x-refsStack",
                            "x-parentRefs",
                            "readOnly",
                            "writeOnly"
                        ].includes(e))) {
                        const e = i, { description: r, title: n, readOnly: o, writeOnly: s } = e;
                        return {
                            allOf: [
                                {
                                    description: r,
                                    title: n,
                                    readOnly: o,
                                    writeOnly: s
                                },
                                t,
                                On(e, [
                                    "description",
                                    "title",
                                    "readOnly",
                                    "writeOnly"
                                ])
                            ]
                        };
                    }
                    return kn(kn({}, t), i);
                }
                mergeAllOf(e, t, r) {
                    var n;
                    if (e["x-circular-ref"]) return e;
                    if (void 0 === (e = this.hoistOneOfs(e, r)).allOf) return e;
                    let o = En(kn({}, e), {
                        "x-parentRefs": [],
                        allOf: void 0,
                        title: e.title || rt(t)
                    });
                    void 0 !== o.properties && "object" == typeof o.properties && (o.properties = kn({}, o.properties)), void 0 !== o.items && "object" == typeof o.items && (o.items = kn({}, o.items));
                    const i = function(e) {
                        const t = new Set;
                        return e.filter((e)=>{
                            const r = e.$ref;
                            return !r || r && !t.has(r) && t.add(r);
                        });
                    }(e.allOf.map((e)=>{
                        var t;
                        const { resolved: n, refsStack: i } = this.deref(e, r, !0), s = e.$ref || void 0, a = this.mergeAllOf(n, s, i);
                        if (!a["x-circular-ref"] || !a.allOf) return s && (null == (t = o["x-parentRefs"]) || t.push(...a["x-parentRefs"] || [], s)), {
                            $ref: s,
                            refsStack: jn(i, s),
                            schema: a
                        };
                    }).filter((e)=>void 0 !== e));
                    for (const { schema: e, refsStack: r } of i){
                        const i = e, { type: s, enum: a, properties: l, items: c, required: p, title: u, description: d, readOnly: h, writeOnly: m, oneOf: f, anyOf: g, "x-circular-ref": y } = i, b = On(i, [
                            "type",
                            "enum",
                            "properties",
                            "items",
                            "required",
                            "title",
                            "description",
                            "readOnly",
                            "writeOnly",
                            "oneOf",
                            "anyOf",
                            "x-circular-ref"
                        ]);
                        if (o.type !== s && void 0 !== o.type && void 0 !== s && console.warn(`Incompatible types in allOf at "${t}": "${o.type}" and "${s}"`), void 0 !== s && (Array.isArray(s) && Array.isArray(o.type) ? o.type = [
                            ...s,
                            ...o.type
                        ] : o.type = s), void 0 !== a && (Array.isArray(a) && Array.isArray(o.enum) ? o.enum = Array.from(new Set([
                            ...a,
                            ...o.enum
                        ])) : o.enum = a), void 0 !== l && "object" == typeof l) {
                            o.properties = o.properties || {};
                            for(const e in l){
                                const i = $n(r, null == (n = l[e]) ? void 0 : n["x-refsStack"]);
                                if (o.properties[e]) {
                                    if (!y) {
                                        const r = this.mergeAllOf({
                                            allOf: [
                                                o.properties[e],
                                                En(kn({}, l[e]), {
                                                    "x-refsStack": i
                                                })
                                            ],
                                            "x-refsStack": i
                                        }, t + "/properties/" + e, i);
                                        o.properties[e] = r;
                                    }
                                } else o.properties[e] = En(kn({}, l[e]), {
                                    "x-refsStack": i
                                });
                            }
                        }
                        if (void 0 !== c && !y) {
                            const n = "boolean" == typeof o.items ? {} : Object.assign({}, o.items), i = "boolean" == typeof e.items ? {} : Object.assign({}, e.items);
                            o.items = this.mergeAllOf({
                                allOf: [
                                    n,
                                    i
                                ]
                            }, t + "/items", r);
                        }
                        void 0 !== f && (o.oneOf = f), void 0 !== g && (o.anyOf = g), void 0 !== p && (o.required = [
                            ...o.required || [],
                            ...p
                        ]), o = kn(En(kn({}, o), {
                            title: o.title || u,
                            description: o.description || d,
                            readOnly: void 0 !== o.readOnly ? o.readOnly : h,
                            writeOnly: void 0 !== o.writeOnly ? o.writeOnly : m,
                            "x-circular-ref": o["x-circular-ref"] || y
                        }), b);
                    }
                    return o;
                }
                findDerived(e) {
                    const t = {}, r = this.spec.components && this.spec.components.schemas || {};
                    for(const n in r){
                        const { resolved: o } = this.deref(r[n]);
                        void 0 !== o.allOf && o.allOf.find((t)=>void 0 !== t.$ref && e.indexOf(t.$ref) > -1) && (t["#/components/schemas/" + n] = [
                            o["x-discriminator-value"] || n
                        ]);
                    }
                    return t;
                }
                hoistOneOfs(e, t) {
                    if (void 0 === e.allOf) return e;
                    const r = e.allOf;
                    for(let e = 0; e < r.length; e++){
                        const n = r[e], { oneOf: o } = n, i = On(n, [
                            "oneOf"
                        ]);
                        if (o && Array.isArray(o)) {
                            const n = r.slice(0, e), s = r.slice(e + 1), a = Object.keys(i).length > 0 ? [
                                i
                            ] : [];
                            return {
                                oneOf: o.map((e)=>({
                                        allOf: [
                                            ...n,
                                            ...a,
                                            e,
                                            ...s
                                        ],
                                        "x-refsStack": t
                                    }))
                            };
                        }
                    }
                    return e;
                }
            }
            var Cn = Object.defineProperty, Pn = Object.defineProperties, In = Object.getOwnPropertyDescriptor, An = Object.getOwnPropertyDescriptors, Tn = Object.getOwnPropertySymbols, _n = Object.prototype.hasOwnProperty, Rn = Object.prototype.propertyIsEnumerable, Dn = (e, t, r)=>t in e ? Cn(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, zn = (e, t)=>{
                for(var r in t || (t = {}))_n.call(t, r) && Dn(e, r, t[r]);
                if (Tn) for (var r of Tn(t))Rn.call(t, r) && Dn(e, r, t[r]);
                return e;
            }, Ln = (e, t)=>Pn(e, An(t)), Nn = (e, t, r, n)=>{
                for(var o, i = n > 1 ? void 0 : n ? In(t, r) : t, s = e.length - 1; s >= 0; s--)(o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
                return n && i && Cn(t, r, i), i;
            };
            const Mn = class e {
                constructor(e, t, r, n, o = !1, i = []){
                    this.options = n, this.refsStack = i, this.typePrefix = "", this.isCircular = !1, this.activeOneOf = 0, (0, de.makeObservable)(this), this.pointer = t.$ref || r || "";
                    const { resolved: s, refsStack: a } = e.deref(t, i, !0);
                    this.refsStack = jn(a, this.pointer), this.rawSchema = s, this.schema = e.mergeAllOf(this.rawSchema, this.pointer, this.refsStack), this.init(e, o), n.showExtensions && (this.extensions = xt(this.schema, n.showExtensions));
                }
                activateOneOf(e) {
                    this.activeOneOf = e;
                }
                hasType(e) {
                    return this.type === e || I(this.type) && this.type.includes(e);
                }
                init(t, r) {
                    var n, o, i, s, a, l, c, p;
                    const u = this.schema;
                    if (this.isCircular = !!u["x-circular-ref"], this.title = u.title || tt(this.pointer) && Ee.baseName(this.pointer) || "", this.description = u.description || "", this.type = u.type || Be(u), this.format = u.format, this.enum = u.enum || [], this["x-enumDescriptions"] = u["x-enumDescriptions"], this.example = u.example, this.examples = u.examples, this.deprecated = !!u.deprecated, this.pattern = u.pattern, this.externalDocs = u.externalDocs, this.constraints = it(u), this.displayFormat = this.format, this.isPrimitive = Qe(u, this.type), this.default = u.default, this.readOnly = !!u.readOnly, this.writeOnly = !!u.writeOnly, this.const = u.const || "", this.contentEncoding = u.contentEncoding, this.contentMediaType = u.contentMediaType, this.minItems = u.minItems, this.maxItems = u.maxItems, (u.nullable || u["x-nullable"]) && (I(this.type) && !this.type.some((e)=>null === e || "null" === e) ? this.type = [
                        ...this.type,
                        "null"
                    ] : I(this.type) || null === this.type && "null" === this.type || (this.type = [
                        this.type,
                        "null"
                    ])), this.displayType = I(this.type) ? this.type.map((e)=>null === e ? "null" : e).join(" or ") : this.type, !this.isCircular) {
                        if (u.if && u.then || u.if && u.else) this.initConditionalOperators(u, t);
                        else if (r || void 0 === Bn(u)) {
                            if (r && I(u.oneOf) && u.oneOf.find((e)=>e.$ref === this.pointer) && delete u.oneOf, void 0 !== u.oneOf) return this.initOneOf(u.oneOf, t), this.oneOfType = "One of", void (void 0 !== u.anyOf && console.warn(`oneOf and anyOf are not supported on the same level. Skipping anyOf at ${this.pointer}`));
                            if (void 0 !== u.anyOf) return this.initOneOf(u.anyOf, t), void (this.oneOfType = "Any of");
                            if (this.hasType("object")) this.fields = Fn(t, u, this.pointer, this.options, this.refsStack);
                            else if (this.hasType("array") && (I(u.items) || I(u.prefixItems) ? this.fields = Fn(t, u, this.pointer, this.options, this.refsStack) : u.items && (this.items = new e(t, u.items, this.pointer + "/items", this.options, !1, this.refsStack)), this.displayType = u.prefixItems || I(u.items) ? "items" : vt((null == (n = this.items) ? void 0 : n.displayType) || this.displayType), this.displayFormat = (null == (o = this.items) ? void 0 : o.format) || "", this.typePrefix = (null == (i = this.items) ? void 0 : i.typePrefix) || "" + _("arrayOf"), this.title = this.title || (null == (s = this.items) ? void 0 : s.title) || "", this.isPrimitive = void 0 !== (null == (a = this.items) ? void 0 : a.isPrimitive) ? null == (l = this.items) ? void 0 : l.isPrimitive : this.isPrimitive, void 0 === this.example && void 0 !== (null == (c = this.items) ? void 0 : c.example) && (this.example = [
                                this.items.example
                            ]), (null == (p = this.items) ? void 0 : p.isPrimitive) && (this.enum = this.items.enum, this["x-enumDescriptions"] = this.items["x-enumDescriptions"]), I(this.type))) {
                                const e = this.type.filter((e)=>"array" !== e);
                                e.length && (this.displayType += ` or ${e.join(" or ")}`);
                            }
                            this.enum.length && this.options.sortEnumValuesAlphabetically && this.enum.sort();
                        } else this.initDiscriminator(u, t);
                    }
                }
                initOneOf(t, r) {
                    if (this.oneOf = t.map((t, n)=>{
                        const { resolved: o, refsStack: i } = r.deref(t, this.refsStack, !0), s = r.mergeAllOf(o, this.pointer + "/oneOf/" + n, i), a = tt(t.$ref) && !s.title ? Ee.baseName(t.$ref) : `${s.title || ""}${void 0 !== s.const && JSON.stringify(s.const) || ""}`;
                        return new e(r, Ln(zn({}, s), {
                            title: a,
                            allOf: [
                                Ln(zn({}, this.schema), {
                                    oneOf: void 0,
                                    anyOf: void 0
                                })
                            ],
                            discriminator: o.allOf ? void 0 : s.discriminator
                        }), t.$ref || this.pointer + "/oneOf/" + n, this.options, !1, i);
                    }), this.options.simpleOneOfTypeLabel) {
                        const e = function(e) {
                            const t = new Set;
                            return function e(r) {
                                for (const n of r.oneOf || [])n.oneOf ? e(n) : n.type && t.add(n.type);
                            }(e), Array.from(t.values());
                        }(this);
                        this.displayType = e.join(" or ");
                    } else this.displayType = this.oneOf.map((e)=>{
                        let t = e.typePrefix + (e.title ? `${e.title} (${e.displayType})` : e.displayType);
                        return t.indexOf(" or ") > -1 && (t = `(${t})`), t;
                    }).join(" or ");
                }
                initDiscriminator(t, r) {
                    const n = Bn(t);
                    this.discriminatorProp = n.propertyName;
                    const o = r.findDerived([
                        ...this.schema["x-parentRefs"] || [],
                        this.pointer
                    ]);
                    if (t.oneOf) for (const e of t.oneOf){
                        if (void 0 === e.$ref) continue;
                        const t = Ee.baseName(e.$ref);
                        o[e.$ref] = t;
                    }
                    const i = n.mapping || {};
                    let s = n["x-explicitMappingOnly"] || !1;
                    0 === Object.keys(i).length && (s = !1);
                    const a = {};
                    for(const e in i){
                        const t = i[e];
                        I(a[t]) ? a[t].push(e) : a[t] = [
                            e
                        ];
                    }
                    const l = zn(s ? {} : zn({}, o), a);
                    let c = [];
                    for (const e of Object.keys(l)){
                        const t = l[e];
                        if (I(t)) for (const r of t)c.push({
                            $ref: e,
                            name: r
                        });
                        else c.push({
                            $ref: e,
                            name: t
                        });
                    }
                    const p = Object.keys(i);
                    0 !== p.length && (c = c.sort((e, t)=>{
                        const r = p.indexOf(e.name), n = p.indexOf(t.name);
                        return r < 0 && n < 0 ? e.name.localeCompare(t.name) : r < 0 ? 1 : n < 0 ? -1 : r - n;
                    })), this.oneOf = c.map(({ $ref: t, name: n })=>{
                        const o = new e(r, {
                            $ref: t
                        }, t, this.options, !0, this.refsStack.slice(0, -1));
                        return o.title = n, o;
                    });
                }
                initConditionalOperators(t, r) {
                    const n = t, { if: o, else: i = {}, then: s = {} } = n, a = ((e, t)=>{
                        var r = {};
                        for(var n in e)_n.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                        if (null != e && Tn) for (var n of Tn(e))t.indexOf(n) < 0 && Rn.call(e, n) && (r[n] = e[n]);
                        return r;
                    })(n, [
                        "if",
                        "else",
                        "then"
                    ]), l = [
                        {
                            allOf: [
                                a,
                                s,
                                o
                            ],
                            title: o && o["x-displayName"] || (null == o ? void 0 : o.title) || "case 1"
                        },
                        {
                            allOf: [
                                a,
                                i
                            ],
                            title: i && i["x-displayName"] || (null == i ? void 0 : i.title) || "case 2"
                        }
                    ];
                    this.oneOf = l.map((t, n)=>new e(r, zn({}, t), this.pointer + "/oneOf/" + n, this.options, !1, this.refsStack)), this.oneOfType = "One of";
                }
            };
            Nn([
                de.observable
            ], Mn.prototype, "activeOneOf", 2), Nn([
                de.action
            ], Mn.prototype, "activateOneOf", 1);
            let qn = Mn;
            function Fn(e, t, r, n, o) {
                const i = t.properties || t.prefixItems || t.items || {}, s = t.patternProperties || {}, a = t.additionalProperties || t.unevaluatedProperties, l = t.prefixItems ? t.items : t.additionalItems, c = t.default;
                let p = Object.keys(i || []).map((s)=>{
                    let a = i[s];
                    a || (console.warn(`Field "${s}" is invalid, skipping.\n Field must be an object but got ${typeof a} at "${r}"`), a = {});
                    const l = void 0 !== t.required && t.required.indexOf(s) > -1;
                    return new Yn(e, {
                        name: t.properties ? s : `[${s}]`,
                        required: l,
                        schema: Ln(zn({}, a), {
                            default: void 0 === a.default && c ? c[s] : a.default
                        })
                    }, r + "/properties/" + s, n, o);
                });
                return n.sortPropsAlphabetically && (p = at(p, "name")), n.sortRequiredPropsFirst && (p = st(p, n.sortPropsAlphabetically ? void 0 : t.required)), p.push(...Object.keys(s).map((t)=>{
                    let i = s[t];
                    return i || (console.warn(`Field "${t}" is invalid, skipping.\n Field must be an object but got ${typeof i} at "${r}"`), i = {}), new Yn(e, {
                        name: t,
                        required: !1,
                        schema: i,
                        kind: "patternProperties"
                    }, `${r}/patternProperties/${t}`, n, o);
                })), "object" != typeof a && !0 !== a || p.push(new Yn(e, {
                    name: ("object" == typeof a && a["x-additionalPropertiesName"] || "property name").concat("*"),
                    required: !1,
                    schema: !0 === a ? {} : a,
                    kind: "additionalProperties"
                }, r + "/additionalProperties", n, o)), p.push(...function({ parser: e, schema: t = !1, fieldsCount: r, $ref: n, options: o, refsStack: i }) {
                    return A(t) ? t ? [
                        new Yn(e, {
                            name: `[${r}...]`,
                            schema: {}
                        }, `${n}/additionalItems`, o, i)
                    ] : [] : I(t) ? [
                        ...t.map((t, s)=>new Yn(e, {
                                name: `[${r + s}]`,
                                schema: t
                            }, `${n}/additionalItems`, o, i))
                    ] : x(t) ? [
                        new Yn(e, {
                            name: `[${r}...]`,
                            schema: t
                        }, `${n}/additionalItems`, o, i)
                    ] : [];
                }({
                    parser: e,
                    schema: l,
                    fieldsCount: p.length,
                    $ref: r,
                    options: n,
                    refsStack: o
                })), p;
            }
            function Bn(e) {
                return e.discriminator || e["x-discriminator"];
            }
            const Qn = {};
            class Un {
                constructor(e, t, r, n){
                    this.mime = r;
                    const { resolved: o } = e.deref(t);
                    this.value = o.value, this.summary = o.summary, this.description = o.description, o.externalValue && (this.externalValueUrl = new URL(o.externalValue, e.specUrl).href), We(r) && this.value && "object" == typeof this.value && (this.value = Ye(this.value, n));
                }
                getExternalValue(e) {
                    return this.externalValueUrl ? (this.externalValueUrl in Qn || (Qn[this.externalValueUrl] = fetch(this.externalValueUrl).then((t)=>t.text().then((r)=>{
                            if (!t.ok) return Promise.reject(new Error(r));
                            if (!Ue(e)) return r;
                            try {
                                return JSON.parse(r);
                            } catch (e) {
                                return r;
                            }
                        }))), Qn[this.externalValueUrl]) : Promise.resolve(void 0);
                }
            }
            var Wn = Object.defineProperty, Vn = Object.getOwnPropertyDescriptor, Hn = (e, t, r, n)=>{
                for(var o, i = n > 1 ? void 0 : n ? Vn(t, r) : t, s = e.length - 1; s >= 0; s--)(o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
                return n && i && Wn(t, r, i), i;
            };
            const Jn = {
                path: {
                    style: "simple",
                    explode: !1
                },
                query: {
                    style: "form",
                    explode: !0
                },
                header: {
                    style: "simple",
                    explode: !1
                },
                cookie: {
                    style: "form",
                    explode: !0
                }
            };
            class Yn {
                constructor(e, t, r, n, o){
                    var i, s, a, l, c;
                    this.expanded = void 0, (0, de.makeObservable)(this);
                    const { resolved: p } = e.deref(t);
                    this.kind = t.kind || "field", this.name = t.name || p.name, this.in = p.in, this.required = !!p.required;
                    let u = p.schema, d = "";
                    if (!u && p.in && p.content && (d = Object.keys(p.content)[0], u = p.content[d] && p.content[d].schema), this.schema = new qn(e, u || {}, r, n, !1, o), this.description = void 0 === p.description ? this.schema.description || "" : p.description, this.example = p.example || this.schema.example, void 0 !== p.examples || void 0 !== this.schema.examples) {
                        const t = p.examples || this.schema.examples;
                        this.examples = I(t) ? t : h(t, (t, r)=>new Un(e, t, r, p.encoding));
                    }
                    d ? this.serializationMime = d : p.style ? this.style = p.style : this.in && (this.style = null != (s = null == (i = Jn[this.in]) ? void 0 : i.style) ? s : "form"), void 0 === p.explode && this.in ? this.explode = null == (l = null == (a = Jn[this.in]) ? void 0 : a.explode) || l : this.explode = !!p.explode, this.deprecated = void 0 === p.deprecated ? !!this.schema.deprecated : p.deprecated, n.showExtensions && (this.extensions = xt(p, n.showExtensions)), this.const = (null == (c = this.schema) ? void 0 : c.const) || (null == p ? void 0 : p.const) || "";
                }
                toggle() {
                    this.expanded = !this.expanded;
                }
                collapse() {
                    this.expanded = !1;
                }
                expand() {
                    this.expanded = !0;
                }
            }
            Hn([
                de.observable
            ], Yn.prototype, "expanded", 2), Hn([
                de.action
            ], Yn.prototype, "toggle", 1), Hn([
                de.action
            ], Yn.prototype, "collapse", 1), Hn([
                de.action
            ], Yn.prototype, "expand", 1);
            var Gn = (parcelRequire("cSkKB"));
            class Zn {
                constructor(e, t, r, n, o){
                    this.name = t, this.isRequestType = r, this.schema = n.schema && new qn(e, n.schema, "", o), this.onlyRequiredInSamples = o.onlyRequiredInSamples, this.generatedSamplesMaxDepth = o.generatedSamplesMaxDepth, void 0 !== n.examples ? this.examples = h(n.examples, (r)=>new Un(e, r, t, n.encoding)) : void 0 !== n.example ? this.examples = {
                        default: new Un(e, {
                            value: e.deref(n.example).resolved
                        }, t, n.encoding)
                    } : Ue(t) && this.generateExample(e, n);
                }
                generateExample(e, t) {
                    const r = {
                        skipReadOnly: this.isRequestType,
                        skipWriteOnly: !this.isRequestType,
                        skipNonRequired: this.isRequestType && this.onlyRequiredInSamples,
                        maxSampleDepth: this.generatedSamplesMaxDepth
                    };
                    if (this.schema && this.schema.oneOf) {
                        this.examples = {};
                        for (const n of this.schema.oneOf){
                            const o = Gn.sample(n.rawSchema, r, e.spec);
                            this.schema.discriminatorProp && "object" == typeof o && o && (o[this.schema.discriminatorProp] = n.title), this.examples[n.title] = new Un(e, {
                                value: o
                            }, this.name, t.encoding);
                        }
                    } else this.schema && (this.examples = {
                        default: new Un(e, {
                            value: Gn.sample(t.schema, r, e.spec)
                        }, this.name, t.encoding)
                    });
                }
            }
            var Xn = Object.defineProperty, Kn = Object.getOwnPropertyDescriptor, eo = (e, t, r, n)=>{
                for(var o, i = n > 1 ? void 0 : n ? Kn(t, r) : t, s = e.length - 1; s >= 0; s--)(o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
                return n && i && Xn(t, r, i), i;
            };
            class to {
                constructor(e, t, r, n){
                    this.isRequestType = r, this.activeMimeIdx = 0, (0, de.makeObservable)(this), n.unstable_ignoreMimeParameters && (t = ct(t)), this.mediaTypes = Object.keys(t).map((o)=>{
                        const i = t[o];
                        return new Zn(e, o, r, i, n);
                    });
                }
                activate(e) {
                    this.activeMimeIdx = e;
                }
                get active() {
                    return this.mediaTypes[this.activeMimeIdx];
                }
                get hasSample() {
                    return this.mediaTypes.filter((e)=>!!e.examples).length > 0;
                }
            }
            eo([
                de.observable
            ], to.prototype, "activeMimeIdx", 2), eo([
                de.action
            ], to.prototype, "activate", 1), eo([
                de.computed
            ], to.prototype, "active", 1);
            class ro {
                constructor({ parser: e, infoOrRef: t, options: r, isEvent: n }){
                    const o = !n, { resolved: i } = e.deref(t);
                    this.description = i.description || "", this.required = i.required;
                    const s = wt(i);
                    void 0 !== s && (this.content = new to(e, s, o, r));
                }
            }
            var no = Object.defineProperty, oo = Object.defineProperties, io = Object.getOwnPropertyDescriptor, so = Object.getOwnPropertyDescriptors, ao = Object.getOwnPropertySymbols, lo = Object.prototype.hasOwnProperty, co = Object.prototype.propertyIsEnumerable, po = (e, t, r)=>t in e ? no(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, uo = (e, t, r, n)=>{
                for(var o, i = n > 1 ? void 0 : n ? io(t, r) : t, s = e.length - 1; s >= 0; s--)(o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
                return n && i && no(t, r, i), i;
            };
            class ho {
                constructor({ parser: e, code: t, defaultAsError: r, infoOrRef: n, options: o, isEvent: i }){
                    this.expanded = !1, this.headers = [], (0, de.makeObservable)(this), this.expanded = "all" === o.expandResponses || o.expandResponses[t];
                    const { resolved: s } = e.deref(n);
                    this.code = t, void 0 !== s.content && (this.content = new to(e, s.content, i, o)), void 0 !== s["x-summary"] ? (this.summary = s["x-summary"], this.description = s.description || "") : (this.summary = s.description || "", this.description = ""), this.type = Le(t, r);
                    const a = s.headers;
                    void 0 !== a && (this.headers = Object.keys(a).map((t)=>{
                        const r = a[t];
                        var n;
                        return new Yn(e, (n = ((e, t)=>{
                            for(var r in t || (t = {}))lo.call(t, r) && po(e, r, t[r]);
                            if (ao) for (var r of ao(t))co.call(t, r) && po(e, r, t[r]);
                            return e;
                        })({}, r), oo(n, so({
                            name: t
                        }))), "", o);
                    })), o.showExtensions && (this.extensions = xt(s, o.showExtensions));
                }
                toggle() {
                    this.expanded = !this.expanded;
                }
            }
            uo([
                de.observable
            ], ho.prototype, "expanded", 2), uo([
                de.action
            ], ho.prototype, "toggle", 1);
            var mo = Object.defineProperty, fo = Object.getOwnPropertyDescriptor, go = (e, t, r, n)=>{
                for(var o, i = n > 1 ? void 0 : n ? fo(t, r) : t, s = e.length - 1; s >= 0; s--)(o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
                return n && i && mo(t, r, i), i;
            };
            function yo(e) {
                return "payload" === e.lang && e.requestBodyContent;
            }
            let bo = !1;
            class xo {
                constructor(e, t, r, n, o = !1){
                    var i;
                    this.parser = e, this.operationSpec = t, this.options = n, this.type = "operation", this.items = [], this.ready = !0, this.active = !1, this.expanded = !1, (0, de.makeObservable)(this), this.pointer = t.pointer, this.description = t.description, this.parent = r, this.externalDocs = t.externalDocs, this.deprecated = !!t.deprecated, this.httpVerb = t.httpVerb, this.deprecated = !!t.deprecated, this.operationId = t.operationId, this.path = t.pathName, this.isCallback = o, this.isWebhook = t.isWebhook, this.isEvent = this.isCallback || this.isWebhook, this.name = qe(t), this.sidebarLabel = n.sideNavStyle === R.IdOnly ? this.operationId || this.path : n.sideNavStyle === R.PathOnly ? this.path : this.name, this.badges = (null == (i = t["x-badges"]) ? void 0 : i.map(({ name: e, color: t, position: r })=>({
                            name: e,
                            color: t,
                            position: r || "after"
                        }))) || [], this.isCallback ? (this.security = (t.security || []).map((t)=>new tn(t, e)), this.servers = ut("", t.servers || t.pathServers || [])) : (this.operationHash = t.operationId && "operation/" + t.operationId, this.id = void 0 !== t.operationId ? (r ? r.id + "/" : "") + this.operationHash : void 0 !== r ? r.id + this.pointer : this.pointer, this.security = (t.security || e.spec.security || []).map((t)=>new tn(t, e)), this.servers = ut(e.specUrl, t.servers || t.pathServers || e.spec.servers || [])), n.showExtensions && (this.extensions = xt(t, n.showExtensions));
                }
                activate() {
                    this.active = !0;
                }
                deactivate() {
                    this.active = !1;
                }
                toggle() {
                    this.expanded = !this.expanded;
                }
                expand() {
                    this.parent && this.parent.expand();
                }
                collapse() {}
                get requestBody() {
                    return this.operationSpec.requestBody && new ro({
                        parser: this.parser,
                        infoOrRef: this.operationSpec.requestBody,
                        options: this.options,
                        isEvent: this.isEvent
                    });
                }
                get codeSamples() {
                    const { payloadSampleIdx: e, hideRequestPayloadSample: t } = this.options;
                    let r = this.operationSpec["x-codeSamples"] || this.operationSpec["x-code-samples"] || [];
                    this.operationSpec["x-code-samples"] && !bo && (bo = !0, console.warn('"x-code-samples" is deprecated. Use "x-codeSamples" instead'));
                    const n = this.requestBody && this.requestBody.content;
                    if (n && n.hasSample && !t) {
                        const t = Math.min(r.length, e);
                        r = [
                            ...r.slice(0, t),
                            {
                                lang: "payload",
                                label: "Payload",
                                source: "",
                                requestBodyContent: n
                            },
                            ...r.slice(t)
                        ];
                    }
                    return r;
                }
                get parameters() {
                    const e = lt(this.parser, this.operationSpec.pathParameters, this.operationSpec.parameters).map((e)=>new Yn(this.parser, e, this.pointer, this.options));
                    return this.options.sortPropsAlphabetically ? at(e, "name") : this.options.sortRequiredPropsFirst ? st(e) : e;
                }
                get responses() {
                    let e = !1;
                    return Object.keys(this.operationSpec.responses || []).filter((t)=>"default" === t || ("success" === Le(t) && (e = !0), ze(t))).map((t)=>new ho({
                            parser: this.parser,
                            code: t,
                            defaultAsError: e,
                            infoOrRef: this.operationSpec.responses[t],
                            options: this.options,
                            isEvent: this.isEvent
                        }));
                }
                get callbacks() {
                    return Object.keys(this.operationSpec.callbacks || []).map((e)=>new mn(this.parser, e, this.operationSpec.callbacks[e], this.pointer, this.options));
                }
            }
            go([
                de.observable
            ], xo.prototype, "ready", 2), go([
                de.observable
            ], xo.prototype, "active", 2), go([
                de.observable
            ], xo.prototype, "expanded", 2), go([
                de.action
            ], xo.prototype, "activate", 1), go([
                de.action
            ], xo.prototype, "deactivate", 1), go([
                de.action
            ], xo.prototype, "toggle", 1), go([
                Mt
            ], xo.prototype, "requestBody", 1), go([
                Mt
            ], xo.prototype, "codeSamples", 1), go([
                Mt
            ], xo.prototype, "parameters", 1), go([
                Mt
            ], xo.prototype, "responses", 1), go([
                Mt
            ], xo.prototype, "callbacks", 1);
            var vo = Object.defineProperty, wo = Object.defineProperties, ko = Object.getOwnPropertyDescriptors, Eo = Object.getOwnPropertySymbols, Oo = Object.prototype.hasOwnProperty, jo = Object.prototype.propertyIsEnumerable, $o = (e, t, r)=>t in e ? vo(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, So = (e, t)=>{
                for(var r in t || (t = {}))Oo.call(t, r) && $o(e, r, t[r]);
                if (Eo) for (var r of Eo(t))jo.call(t, r) && $o(e, r, t[r]);
                return e;
            }, Co = (e, t)=>wo(e, ko(t));
            class Po {
                constructor(e, t, r){
                    this.operations = [];
                    const { resolved: n } = e.deref(r || {});
                    this.initWebhooks(e, n, t);
                }
                initWebhooks(e, t, r) {
                    for (const n of Object.keys(t)){
                        const o = t[n], i = Object.keys(o).filter(Me);
                        for (const t of i){
                            const n = o[t];
                            if (o.$ref) {
                                const n = e.deref(o || {});
                                this.initWebhooks(e, {
                                    [t]: n
                                }, r);
                            }
                            if (!n) continue;
                            const i = new xo(e, Co(So({}, n), {
                                httpVerb: t
                            }), void 0, r, !1);
                            this.operations.push(i);
                        }
                    }
                }
            }
            class Io {
                constructor(e, t, r){
                    const { resolved: n } = e.deref(r);
                    this.id = t, this.sectionId = ft + t, this.type = n.type, this.displayName = n["x-displayName"] || t, this.description = n.description || "", "apiKey" === n.type && (this.apiKey = {
                        name: n.name,
                        in: n.in
                    }), "http" === n.type && (this.http = {
                        scheme: n.scheme,
                        bearerFormat: n.bearerFormat
                    }), "openIdConnect" === n.type && (this.openId = {
                        connectUrl: n.openIdConnectUrl
                    }), "oauth2" === n.type && n.flows && (this.flows = n.flows);
                }
            }
            class Ao {
                constructor(e){
                    const t = e.spec.components && e.spec.components.securitySchemes || {};
                    this.schemes = Object.keys(t).map((r)=>new Io(e, r, t[r]));
                }
            }
            var To = Object.defineProperty, _o = Object.getOwnPropertySymbols, Ro = Object.prototype.hasOwnProperty, Do = Object.prototype.propertyIsEnumerable, zo = (e, t, r)=>t in e ? To(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, Lo = (e, t)=>{
                for(var r in t || (t = {}))Ro.call(t, r) && zo(e, r, t[r]);
                if (_o) for (var r of _o(t))Do.call(t, r) && zo(e, r, t[r]);
                return e;
            };
            class No {
                constructor(e, t, r){
                    var n, o, i;
                    this.options = r, this.parser = new Sn(e, t, r), this.info = new Hr(this.parser, this.options), this.externalDocs = this.parser.spec.externalDocs, this.contentItems = Ko.buildStructure(this.parser, this.options), this.securitySchemes = new Ao(this.parser);
                    const s = Lo(Lo({}, null == (o = null == (n = this.parser) ? void 0 : n.spec) ? void 0 : o["x-webhooks"]), null == (i = this.parser) ? void 0 : i.spec.webhooks);
                    this.webhooks = new Po(this.parser, r, s);
                }
            }
            var Mo = Object.defineProperty, qo = Object.getOwnPropertyDescriptor, Fo = (e, t, r, n)=>{
                for(var o, i = n > 1 ? void 0 : n ? qo(t, r) : t, s = e.length - 1; s >= 0; s--)(o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
                return n && i && Mo(t, r, i), i;
            };
            class Bo {
                constructor(e, t, r){
                    this.items = [], this.active = !1, this.expanded = !1, (0, de.makeObservable)(this), this.id = t.id || e + "/" + w(t.name), this.type = e, this.name = t["x-displayName"] || t.name, this.level = t.level || 1, this.sidebarLabel = this.name, this.description = t.description || "";
                    const n = t.items;
                    n && n.length && (this.description = Wr.getTextBeforeHading(this.description, n[0].name)), this.parent = r, this.externalDocs = t.externalDocs, "group" === this.type && (this.expanded = !0);
                }
                activate() {
                    this.active = !0;
                }
                expand() {
                    this.parent && this.parent.expand(), this.expanded = !0;
                }
                collapse() {
                    "group" !== this.type && (this.expanded = !1);
                }
                deactivate() {
                    this.active = !1;
                }
            }
            Fo([
                de.observable
            ], Bo.prototype, "active", 2), Fo([
                de.observable
            ], Bo.prototype, "expanded", 2), Fo([
                de.action
            ], Bo.prototype, "activate", 1), Fo([
                de.action
            ], Bo.prototype, "expand", 1), Fo([
                de.action
            ], Bo.prototype, "collapse", 1), Fo([
                de.action
            ], Bo.prototype, "deactivate", 1);
            var Qo = Object.defineProperty, Uo = Object.defineProperties, Wo = Object.getOwnPropertyDescriptors, Vo = Object.getOwnPropertySymbols, Ho = Object.prototype.hasOwnProperty, Jo = Object.prototype.propertyIsEnumerable, Yo = (e, t, r)=>t in e ? Qo(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, Go = (e, t)=>{
                for(var r in t || (t = {}))Ho.call(t, r) && Yo(e, r, t[r]);
                if (Vo) for (var r of Vo(t))Jo.call(t, r) && Yo(e, r, t[r]);
                return e;
            }, Zo = (e, t)=>Uo(e, Wo(t));
            const Xo = 0;
            class Ko {
                static buildStructure(e, t) {
                    const r = e.spec, { schemaDefinitionsTagName: n } = t, o = [], i = [
                        ...r.tags || []
                    ];
                    !i.find((e)=>(null == e ? void 0 : e.name) === n) && n && i.push({
                        name: n
                    });
                    const s = Ko.getTagsWithOperations(e, i);
                    return o.push(...Ko.addMarkdownItems(r.info.description || "", void 0, 1, t)), r["x-tagGroups"] && r["x-tagGroups"].length > 0 ? o.push(...Ko.getTagGroupsItems(e, void 0, r["x-tagGroups"], s, t)) : o.push(...Ko.getTagsItems(e, s, void 0, void 0, t)), o;
                }
                static addMarkdownItems(e, t, r, n) {
                    const o = new Wr(n, null == t ? void 0 : t.id).extractHeadings(e || "");
                    o.length && t && t.description && (t.description = Wr.getTextBeforeHading(t.description, o[0].name));
                    const i = (e, t, r = 1)=>t.map((t)=>{
                            const n = new Bo("section", t, e);
                            return n.depth = r, t.items && (n.items = i(n, t.items, r + 1)), n;
                        });
                    return i(t, o, r);
                }
                static getTagGroupsItems(e, t, r, n, o) {
                    const i = [];
                    for (const s of r){
                        const r = new Bo("group", s, t);
                        r.depth = Xo, r.items = Ko.getTagsItems(e, n, r, s, o), i.push(r);
                    }
                    return i;
                }
                static getTagsItems(e, t, r, n, o) {
                    let i;
                    i = void 0 === n ? Object.keys(t) : n.tags;
                    const s = i.map((e)=>t[e] ? (t[e].used = !0, t[e]) : (console.warn(`Non-existing tag "${e}" is added to the group "${n.name}"`), null)), a = [];
                    for (const t of s){
                        if (!t) continue;
                        const n = new Bo("tag", t, r);
                        if (n.depth = Xo + 1, "" === t.name) {
                            const r = [
                                ...Ko.addMarkdownItems(t.description || "", n, n.depth + 1, o),
                                ...this.getOperationsItems(e, void 0, t, n.depth + 1, o)
                            ];
                            a.push(...r);
                            continue;
                        }
                        const i = this.getTagRelatedSchema({
                            parser: e,
                            tag: t,
                            parent: n,
                            schemaDefinitionsTagName: o.schemaDefinitionsTagName
                        });
                        n.items = [
                            ...i,
                            ...Ko.addMarkdownItems(t.description || "", n, n.depth + 1, o),
                            ...this.getOperationsItems(e, n, t, n.depth + 1, o)
                        ], a.push(n);
                    }
                    return o.sortTagsAlphabetically && a.sort(qt("name")), a;
                }
                static getOperationsItems(e, t, r, n, o) {
                    if (0 === r.operations.length) return [];
                    const i = [];
                    for (const s of r.operations){
                        const r = new xo(e, s, t, o);
                        r.depth = n, i.push(r);
                    }
                    return o.sortOperationsAlphabetically && i.sort(qt("name")), i;
                }
                static getTagsWithOperations(e, t) {
                    const { spec: r } = e, n = {}, o = r["x-webhooks"] || r.webhooks;
                    for (const e of t || [])n[e.name] = Zo(Go({}, e), {
                        operations: []
                    });
                    function i(e, t, r) {
                        for (const o of Object.keys(t)){
                            const s = t[o], a = Object.keys(s).filter(Me);
                            for (const t of a){
                                const a = s[t];
                                if (s.$ref) {
                                    const { resolved: t } = e.deref(s);
                                    i(e, {
                                        [o]: t
                                    }, r);
                                    continue;
                                }
                                let l = null == a ? void 0 : a.tags;
                                l && l.length || (l = [
                                    ""
                                ]);
                                for (const e of l){
                                    let i = n[e];
                                    void 0 === i && (i = {
                                        name: e,
                                        operations: []
                                    }, n[e] = i), i["x-traitTag"] || i.operations.push(Zo(Go({}, a), {
                                        pathName: o,
                                        pointer: Ee.compile([
                                            "paths",
                                            o,
                                            t
                                        ]),
                                        httpVerb: t,
                                        pathParameters: s.parameters || [],
                                        pathServers: s.servers,
                                        isWebhook: !!r
                                    }));
                                }
                            }
                        }
                    }
                    return o && i(e, o, !0), r.paths && i(e, r.paths), n;
                }
                static getTagRelatedSchema({ parser: e, tag: t, parent: r, schemaDefinitionsTagName: n }) {
                    var o;
                    const i = n ? [
                        n
                    ] : [];
                    return Object.entries((null == (o = e.spec.components) ? void 0 : o.schemas) || {}).map(([e, n])=>{
                        const o = n["x-tags"] || i;
                        if (!(null == o ? void 0 : o.includes(t.name))) return null;
                        const s = new Bo("schema", {
                            name: e,
                            "x-displayName": `${n.title || e}`,
                            description: `<SchemaDefinition showWriteOnly={true} schemaRef="#/components/schemas/${e}" />`
                        }, r);
                        return s.depth = r.depth + 1, s;
                    }).filter(Boolean);
                }
            }
            var ei = Object.defineProperty, ti = Object.getOwnPropertyDescriptor, ri = (e, t, r, n)=>{
                for(var o, i = n > 1 ? void 0 : n ? ti(t, r) : t, s = e.length - 1; s >= 0; s--)(o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
                return n && i && ei(t, r, i), i;
            };
            const ni = "data-section-id";
            class oi {
                constructor(e, t, r){
                    this.scroll = t, this.history = r, this.activeItemIdx = -1, this.sideBarOpened = !1, this.updateOnScroll = (e)=>{
                        const t = e ? 1 : -1;
                        let r = this.activeItemIdx;
                        for(; (-1 !== r || e) && !(r >= this.flatItems.length - 1 && e);){
                            if (e) {
                                const e = this.getElementAtOrFirstChild(r + 1);
                                if (this.scroll.isElementBellow(e)) break;
                            } else {
                                const e = this.getElementAt(r);
                                if (this.scroll.isElementAbove(e)) break;
                            }
                            r += t;
                        }
                        this.activate(this.flatItems[r], !0, !0);
                    }, this.updateOnHistory = (e = this.history.currentId)=>{
                        if (!e) return;
                        let t;
                        t = this.flatItems.find((t)=>t.id === e), t ? this.activateAndScroll(t, !1) : (e.startsWith(ft) && (t = this.flatItems.find((e)=>ft.startsWith(e.id)), this.activateAndScroll(t, !1)), this.scroll.scrollIntoViewBySelector(`[${ni}="${C(e)}"]`));
                    }, this.getItemById = (e)=>this.flatItems.find((t)=>t.id === e), (0, de.makeObservable)(this), this.items = e.contentItems, this.flatItems = m(this.items || [], "items"), this.flatItems.forEach((e, t)=>e.absoluteIdx = t), this.subscribe();
                }
                static updateOnHistory(e = Wt.currentId, t) {
                    e && t.scrollIntoViewBySelector(`[${ni}="${C(e)}"]`);
                }
                subscribe() {
                    this._unsubscribe = this.scroll.subscribe(this.updateOnScroll), this._hashUnsubscribe = this.history.subscribe(this.updateOnHistory);
                }
                toggleSidebar() {
                    this.sideBarOpened = !this.sideBarOpened;
                }
                closeSidebar() {
                    this.sideBarOpened = !1;
                }
                getElementAt(e) {
                    const t = this.flatItems[e];
                    return t && a(`[${ni}="${C(t.id)}"]`) || null;
                }
                getElementAtOrFirstChild(e) {
                    let t = this.flatItems[e];
                    return t && "group" === t.type && (t = t.items[0]), t && a(`[${ni}="${C(t.id)}"]`) || null;
                }
                get activeItem() {
                    return this.flatItems[this.activeItemIdx] || void 0;
                }
                activate(e, t = !0, r = !1) {
                    if ((this.activeItem && this.activeItem.id) !== (e && e.id) && (!e || "group" !== e.type)) {
                        if (this.deactivate(this.activeItem), !e) return this.activeItemIdx = -1, void this.history.replace("", r);
                        e.depth <= Xo || (this.activeItemIdx = e.absoluteIdx, t && this.history.replace(encodeURI(e.id), r), e.activate(), e.expand());
                    }
                }
                deactivate(e) {
                    if (void 0 !== e) for(e.deactivate(); void 0 !== e;)e.collapse(), e = e.parent;
                }
                activateAndScroll(e, t, r) {
                    const n = e && this.getItemById(e.id) || e;
                    this.activate(n, t, r), this.scrollToActive(), n && n.items.length || this.closeSidebar();
                }
                scrollToActive() {
                    this.scroll.scrollIntoView(this.getElementAt(this.activeItemIdx));
                }
                dispose() {
                    this._unsubscribe(), this._hashUnsubscribe();
                }
            }
            ri([
                de.observable
            ], oi.prototype, "activeItemIdx", 2), ri([
                de.observable
            ], oi.prototype, "sideBarOpened", 2), ri([
                de.action
            ], oi.prototype, "toggleSidebar", 1), ri([
                de.action
            ], oi.prototype, "closeSidebar", 1), ri([
                de.action
            ], oi.prototype, "activate", 1), ri([
                de.action.bound
            ], oi.prototype, "activateAndScroll", 1);
            var ii = Object.defineProperty, si = Object.getOwnPropertyDescriptor;
            const ai = "scroll";
            class li {
                constructor(e){
                    this.options = e, this._prevOffsetY = 0, this._scrollParent = s ? window : void 0, this._emiter = new ve.EventEmitter, this.bind();
                }
                bind() {
                    this._prevOffsetY = this.scrollY(), this._scrollParent && this._scrollParent.addEventListener("scroll", this.handleScroll);
                }
                dispose() {
                    this._scrollParent && this._scrollParent.removeEventListener("scroll", this.handleScroll), this._emiter.removeAllListeners(ai);
                }
                scrollY() {
                    return "undefined" != typeof HTMLElement && this._scrollParent instanceof HTMLElement ? this._scrollParent.scrollTop : void 0 !== this._scrollParent ? this._scrollParent.pageYOffset : 0;
                }
                isElementBellow(e) {
                    if (null !== e) return e.getBoundingClientRect().top > this.options.scrollYOffset();
                }
                isElementAbove(e) {
                    if (null === e) return;
                    const t = e.getBoundingClientRect().top;
                    return (t > 0 ? Math.floor(t) : Math.ceil(t)) <= this.options.scrollYOffset();
                }
                subscribe(e) {
                    const t = this._emiter.addListener(ai, e);
                    return ()=>t.removeListener(ai, e);
                }
                scrollIntoView(e) {
                    null !== e && (e.scrollIntoView(), this._scrollParent && this._scrollParent.scrollBy && this._scrollParent.scrollBy(0, 1 - this.options.scrollYOffset()));
                }
                scrollIntoViewBySelector(e) {
                    const t = a(e);
                    this.scrollIntoView(t);
                }
                handleScroll() {
                    const e = this.scrollY() - this._prevOffsetY > 0;
                    this._prevOffsetY = this.scrollY(), this._emiter.emit(ai, e);
                }
            }
            ((e, t, r)=>{
                for(var n, o = si(t, r), i = e.length - 1; i >= 0; i--)(n = e[i]) && (o = n(t, r, o) || o);
                o && ii(t, r, o);
            })([
                xe.bind,
                $t(100)
            ], li.prototype, "handleScroll");
            class ci {
                constructor(){
                    this.searchWorker = function() {
                        let e;
                        if (s) try {
                            e = r(303);
                        } catch (t) {
                            e = r(353).Ay;
                        }
                        else e = r(353).Ay;
                        return new e;
                    }();
                }
                indexItems(e) {
                    const t = (e)=>{
                        e.forEach((e)=>{
                            "group" !== e.type && this.add(e.name, (e.description || "").concat(" ", e.path || ""), e.id), t(e.items);
                        });
                    };
                    t(e), this.searchWorker.done();
                }
                add(e, t, r) {
                    this.searchWorker.add(e, t, r);
                }
                dispose() {
                    this.searchWorker.terminate(), this.searchWorker.dispose();
                }
                search(e) {
                    return this.searchWorker.search(e);
                }
                toJS() {
                    var e, t;
                    return e = this, t = function*() {
                        return this.searchWorker.toJS();
                    }, new Promise((r, n)=>{
                        var o = (e)=>{
                            try {
                                s(t.next(e));
                            } catch (e) {
                                n(e);
                            }
                        }, i = (e)=>{
                            try {
                                s(t.throw(e));
                            } catch (e) {
                                n(e);
                            }
                        }, s = (e)=>e.done ? r(e.value) : Promise.resolve(e.value).then(o, i);
                        s((t = t.apply(e, null)).next());
                    });
                }
                load(e) {
                    this.searchWorker.load(e);
                }
                fromExternalJS(e, t) {
                    e && t && this.searchWorker.fromExternalJS(e, t);
                }
            }
            const pi = ee.div`
  width: calc(100% - ${(e)=>e.theme.rightPanel.width});
  padding: 0 ${(e)=>e.theme.spacing.sectionHorizontal}px;

  ${({ $compact: e, theme: t })=>K.lessThan("medium", !0)`
    width: 100%;
    padding: ${`${e ? 0 : t.spacing.sectionVertical}px ${t.spacing.sectionHorizontal}px`};
  `};
`, ui = ee.div.attrs((e)=>({
                    [ni]: e.id
                }))`
  padding: ${(e)=>e.theme.spacing.sectionVertical}px 0;

  &:last-child {
    min-height: calc(100vh + 1px);
  }

  & > &:last-child {
    min-height: initial;
  }

  ${K.lessThan("medium", !0)`
    padding: 0;
  `}
  ${({ $underlined: e })=>e ? "\n    position: relative;\n\n    &:not(:last-of-type):after {\n      position: absolute;\n      bottom: 0;\n      width: 100%;\n      display: block;\n      content: '';\n      border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n    }\n  " : ""}
`, di = ee.div`
  width: ${(e)=>e.theme.rightPanel.width};
  color: ${({ theme: e })=>e.rightPanel.textColor};
  background-color: ${(e)=>e.theme.rightPanel.backgroundColor};
  padding: 0 ${(e)=>e.theme.spacing.sectionHorizontal}px;

  ${K.lessThan("medium", !0)`
    width: 100%;
    padding: ${(e)=>`${e.theme.spacing.sectionVertical}px ${e.theme.spacing.sectionHorizontal}px`};
  `};
`, hi = ee(di)`
  background-color: ${(e)=>e.theme.rightPanel.backgroundColor};
`, mi = ee.div`
  display: flex;
  width: 100%;
  padding: 0;

  ${K.lessThan("medium", !0)`
    flex-direction: column;
  `};
`, fi = {
                1: "1.85714em",
                2: "1.57143em",
                3: "1.27em"
            }, gi = (e)=>Y`
  font-family: ${({ theme: e })=>e.typography.headings.fontFamily};
  font-weight: ${({ theme: e })=>e.typography.headings.fontWeight};
  font-size: ${fi[e]};
  line-height: ${({ theme: e })=>e.typography.headings.lineHeight};
`, yi = ee.h1`
  ${gi(1)};
  color: ${({ theme: e })=>e.colors.text.primary};

  ${te("H1")};
`, bi = ee.h2`
  ${gi(2)};
  color: ${({ theme: e })=>e.colors.text.primary};
  margin: 0 0 20px;

  ${te("H2")};
`, xi = ee.h2`
  ${gi(3)};
  color: ${({ theme: e })=>e.colors.text.primary};

  ${te("H3")};
`, vi = ee.h3`
  color: ${({ theme: e })=>e.rightPanel.textColor};

  ${te("RightPanelHeader")};
`, wi = ee.h5`
  border-bottom: 1px solid rgba(38, 50, 56, 0.3);
  margin: 1em 0 1em 0;
  color: rgba(38, 50, 56, 0.7);
  font-weight: normal;
  text-transform: uppercase;
  font-size: 0.929em;
  line-height: 20px;

  ${te("UnderlinedHeader")};
`;
            var ki = (e, t, r)=>new Promise((n, o)=>{
                    var i = (e)=>{
                        try {
                            a(r.next(e));
                        } catch (e) {
                            o(e);
                        }
                    }, s = (e)=>{
                        try {
                            a(r.throw(e));
                        } catch (e) {
                            o(e);
                        }
                    }, a = (e)=>e.done ? n(e.value) : Promise.resolve(e.value).then(i, s);
                    a((r = r.apply(e, t)).next());
                });
            const Ei = (0, e.createContext)(void 0), { Provider: Oi, Consumer: ji } = Ei;
            function $i(t) {
                const { spec: r, specUrl: n, options: o, onLoaded: i, children: s } = t, [a, l] = e.useState(null), [c, p] = e.useState(null);
                if (c) throw c;
                e.useEffect(()=>{
                    !function() {
                        ki(this, null, function*() {
                            if (r || n) {
                                l(null);
                                try {
                                    const e = yield ye(r || n);
                                    l(e);
                                } catch (e) {
                                    throw i && i(e), p(e), e;
                                }
                            }
                        });
                    }();
                }, [
                    r,
                    n
                ]);
                const u = e.useMemo(()=>{
                    if (!a) return null;
                    try {
                        return new gc(a, n, o);
                    } catch (e) {
                        throw i && i(e), e;
                    }
                }, [
                    a,
                    n,
                    o
                ]);
                return e.useEffect(()=>{
                    u && i && i();
                }, [
                    u,
                    i
                ]), s({
                    loading: !u,
                    store: u
                });
            }
            function Si() {
                return (0, e.useContext)(Ei);
            }
            const Ci = (e)=>Y`
  ${e} {
    cursor: pointer;
    margin-left: -20px;
    padding: 0;
    line-height: 1;
    width: 20px;
    display: inline-block;
    outline: 0;
  }
  ${e}:before {
    content: '';
    width: 15px;
    height: 15px;
    background-size: contain;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeD0iMCIgeT0iMCIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MTIgNTEyIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBmaWxsPSIjMDEwMTAxIiBkPSJNNDU5LjcgMjMzLjRsLTkwLjUgOTAuNWMtNTAgNTAtMTMxIDUwLTE4MSAwIC03LjktNy44LTE0LTE2LjctMTkuNC0yNS44bDQyLjEtNDIuMWMyLTIgNC41LTMuMiA2LjgtNC41IDIuOSA5LjkgOCAxOS4zIDE1LjggMjcuMiAyNSAyNSA2NS42IDI0LjkgOTAuNSAwbDkwLjUtOTAuNWMyNS0yNSAyNS02NS42IDAtOTAuNSAtMjQuOS0yNS02NS41LTI1LTkwLjUgMGwtMzIuMiAzMi4yYy0yNi4xLTEwLjItNTQuMi0xMi45LTgxLjYtOC45bDY4LjYtNjguNmM1MC01MCAxMzEtNTAgMTgxIDBDNTA5LjYgMTAyLjMgNTA5LjYgMTgzLjQgNDU5LjcgMjMzLjR6TTIyMC4zIDM4Mi4ybC0zMi4yIDMyLjJjLTI1IDI0LjktNjUuNiAyNC45LTkwLjUgMCAtMjUtMjUtMjUtNjUuNiAwLTkwLjVsOTAuNS05MC41YzI1LTI1IDY1LjUtMjUgOTAuNSAwIDcuOCA3LjggMTIuOSAxNy4yIDE1LjggMjcuMSAyLjQtMS40IDQuOC0yLjUgNi44LTQuNWw0Mi4xLTQyYy01LjQtOS4yLTExLjYtMTgtMTkuNC0yNS44IC01MC01MC0xMzEtNTAtMTgxIDBsLTkwLjUgOTAuNWMtNTAgNTAtNTAgMTMxIDAgMTgxIDUwIDUwIDEzMSA1MCAxODEgMGw2OC42LTY4LjZDMjc0LjYgMzk1LjEgMjQ2LjQgMzkyLjMgMjIwLjMgMzgyLjJ6Ii8+PC9zdmc+Cg==');
    opacity: 0.5;
    visibility: hidden;
    display: inline-block;
    vertical-align: middle;
  }

  h1:hover > ${e}::before, h2:hover > ${e}::before, ${e}:hover::before {
    visibility: visible;
  }
`, Pi = ee(function(t) {
                const r = e.useContext(Ei), n = e.useCallback((e)=>{
                    r && function(e, t, r) {
                        t.defaultPrevented || 0 !== t.button || ((e)=>!!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey))(t) || (t.preventDefault(), e.replace(encodeURI(r)));
                    }(r.menu.history, e, t.to);
                }, [
                    r,
                    t.to
                ]);
                return r ? e.createElement("a", {
                    className: t.className,
                    href: r.menu.history.linkForId(t.to),
                    onClick: n,
                    "aria-label": t.to
                }, t.children) : null;
            })`
  ${Ci("&")};
`;
            function Ii(t) {
                return e.createElement(Pi, {
                    to: t.to
                });
            }
            const Ai = {
                left: "90deg",
                right: "-90deg",
                up: "-180deg",
                down: "0"
            }, Ti = ee((t)=>e.createElement("svg", {
                    className: t.className,
                    style: t.style,
                    version: "1.1",
                    viewBox: "0 0 24 24",
                    x: "0",
                    xmlns: "http://www.w3.org/2000/svg",
                    y: "0",
                    "aria-hidden": "true"
                }, e.createElement("polygon", {
                    points: "17.3 8.3 12 13.6 6.7 8.3 5.3 9.7 12 16.4 18.7 9.7 "
                })))`
  height: ${(e)=>e.size || "18px"};
  width: ${(e)=>e.size || "18px"};
  min-width: ${(e)=>e.size || "18px"};
  vertical-align: middle;
  float: ${(e)=>e.float || ""};
  transition: transform 0.2s ease-out;
  transform: rotateZ(${(e)=>Ai[e.direction || "down"]});

  polygon {
    fill: ${({ color: e, theme: t })=>e && t.colors.responses[e] && t.colors.responses[e].color || e};
  }
`, _i = ee.span`
  display: inline-block;
  padding: 2px 8px;
  margin: 0;
  background-color: ${(e)=>e.color || e.theme.colors[e.type].main};
  color: ${(e)=>e.theme.colors[e.type].contrastText};
  font-size: ${(e)=>e.theme.typography.code.fontSize};
  vertical-align: middle;
  line-height: 1.6;
  border-radius: 4px;
  font-weight: ${({ theme: e })=>e.typography.fontWeightBold};
  font-size: 12px;
  + span[type] {
    margin-left: 4px;
  }
`, Ri = Y`
  text-decoration: line-through;
  color: #707070;
`, Di = ee.caption`
  text-align: right;
  font-size: 0.9em;
  font-weight: normal;
  color: ${(e)=>e.theme.colors.text.secondary};
`, zi = ee.td`
  border-left: 1px solid ${(e)=>e.theme.schema.linesColor};
  box-sizing: border-box;
  position: relative;
  padding: 10px 10px 10px 0;

  ${K.lessThan("small")`
    display: block;
    overflow: hidden;
  `}

  tr:first-of-type > &,
  tr.last > & {
    border-left-width: 0;
    background-position: top left;
    background-repeat: no-repeat;
    background-size: 1px 100%;
  }

  tr:first-of-type > & {
    background-image: linear-gradient(
      to bottom,
      transparent 0%,
      transparent 22px,
      ${(e)=>e.theme.schema.linesColor} 22px,
      ${(e)=>e.theme.schema.linesColor} 100%
    );
  }

  tr.last > & {
    background-image: linear-gradient(
      to bottom,
      ${(e)=>e.theme.schema.linesColor} 0%,
      ${(e)=>e.theme.schema.linesColor} 22px,
      transparent 22px,
      transparent 100%
    );
  }

  tr.last + tr > & {
    border-left-color: transparent;
  }

  tr.last:first-child > & {
    background: none;
    border-left-color: transparent;
  }
`, Li = ee(zi)`
  padding: 0;
`, Ni = ee(zi)`
  vertical-align: top;
  line-height: 20px;
  white-space: nowrap;
  font-size: 13px;
  font-family: ${(e)=>e.theme.typography.code.fontFamily};

  &.deprecated {
    ${Ri};
  }

  ${({ kind: e })=>"patternProperties" === e && Y`
      > span.property-name {
        display: inline-table;
        white-space: break-spaces;
        margin-right: 20px;

        ::before,
        ::after {
          content: '/';
          filter: opacity(0.2);
        }
      }
    `}

  ${({ kind: e = "" })=>[
                    "field",
                    "additionalProperties",
                    "patternProperties"
                ].includes(e) ? "" : "font-style: italic"};

  ${te("PropertyNameCell")};
`, Mi = ee.td`
  border-bottom: 1px solid #9fb4be;
  padding: 10px 0;
  width: ${(e)=>e.theme.schema.defaultDetailsWidth};
  box-sizing: border-box;

  tr.expanded & {
    border-bottom: none;
  }

  ${K.lessThan("small")`
    padding: 0 20px;
    border-bottom: none;
    border-left: 1px solid ${(e)=>e.theme.schema.linesColor};

    tr.last > & {
      border-left: none;
    }
  `}

  ${te("PropertyDetailsCell")};
`, qi = ee.span`
  color: ${(e)=>e.theme.schema.linesColor};
  font-family: ${(e)=>e.theme.typography.code.fontFamily};
  margin-right: 10px;

  &::before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 10px;
    height: 1px;
    background: ${(e)=>e.theme.schema.linesColor};
  }

  &::after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 1px;
    background: ${(e)=>e.theme.schema.linesColor};
    height: 7px;
  }
`, Fi = ee.div`
  padding: ${({ theme: e })=>e.schema.nestingSpacing};
`, Bi = ee.table`
  border-collapse: separate;
  border-radius: 3px;
  font-size: ${(e)=>e.theme.typography.fontSize};

  border-spacing: 0;
  width: 100%;

  > tr {
    vertical-align: middle;
  }

  ${K.lessThan("small")`
    display: block;
    > tr, > tbody > tr {
      display: block;
    }
  `}

  ${K.lessThan("small", !1, " and (-ms-high-contrast:none)")`
    td {
      float: left;
      width: 100%;
    }
  `}

  &
    ${Fi},
    &
    ${Fi}
    ${Fi}
    ${Fi},
    &
    ${Fi}
    ${Fi}
    ${Fi}
    ${Fi}
    ${Fi} {
    margin: ${({ theme: e })=>e.schema.nestingSpacing};
    margin-right: 0;
    background: ${({ theme: e })=>e.schema.nestedBackground};
  }

  &
    ${Fi}
    ${Fi},
    &
    ${Fi}
    ${Fi}
    ${Fi}
    ${Fi},
    &
    ${Fi}
    ${Fi}
    ${Fi}
    ${Fi}
    ${Fi}
    ${Fi} {
    background: #ffffff;
  }
`, Qi = ee.div`
  margin: 0 0 3px 0;
  display: inline-block;
`, Ui = ee.span`
  font-size: 0.9em;
  margin-right: 10px;
  color: ${(e)=>e.theme.colors.primary.main};
  font-family: ${(e)=>e.theme.typography.headings.fontFamily};
}
`, Wi = ee.button`
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 5px;
  font-size: 0.8em;
  cursor: pointer;
  border: 1px solid ${(e)=>e.theme.colors.primary.main};
  padding: 2px 10px;
  line-height: 1.5em;
  outline: none;
  &:focus {
    box-shadow: 0 0 0 1px ${(e)=>e.theme.colors.primary.main};
  }

  ${({ $deprecated: e })=>e && Ri || ""};

  ${(e)=>e.$active ? `\n      color: white;\n      background-color: ${e.theme.colors.primary.main};\n      &:focus {\n        box-shadow: none;\n        background-color: ${(0, t.darken)(.15, e.theme.colors.primary.main)};\n      }\n      ` : `\n        color: ${e.theme.colors.primary.main};\n        background-color: white;\n      `}
`, Vi = ee.div`
  font-size: 0.9em;
  font-family: ${(e)=>e.theme.typography.code.fontFamily};
  &::after {
    content: ' [';
  }
`, Hi = ee.div`
  font-size: 0.9em;
  font-family: ${(e)=>e.theme.typography.code.fontFamily};
  &::after {
    content: ']';
  }
`;
            var Ji = (parcelRequire("k9Dec"));
            const Yi = ee(Ji.Tabs)`
  > ul {
    list-style: none;
    padding: 0;
    margin: 0;
    margin: 0 -5px;

    > li {
      padding: 5px 10px;
      display: inline-block;

      background-color: ${({ theme: e })=>e.codeBlock.backgroundColor};
      border-bottom: 1px solid rgba(0, 0, 0, 0.5);
      cursor: pointer;
      text-align: center;
      outline: none;
      color: ${({ theme: e })=>(0, t.darken)(e.colors.tonalOffset, e.rightPanel.textColor)};
      margin: 0
        ${({ theme: e })=>`${e.spacing.unit}px ${e.spacing.unit}px ${e.spacing.unit}px`};
      border: 1px solid ${({ theme: e })=>(0, t.darken)(.05, e.codeBlock.backgroundColor)};
      border-radius: 5px;
      min-width: 60px;
      font-size: 0.9em;
      font-weight: bold;

      &.react-tabs__tab--selected {
        color: ${(e)=>e.theme.colors.text.primary};
        background: ${({ theme: e })=>e.rightPanel.textColor};
        &:focus {
          outline: auto;
        }
      }

      &:only-child {
        flex: none;
        min-width: 100px;
      }

      &.tab-success {
        color: ${(e)=>e.theme.colors.responses.success.tabTextColor};
        &.react-tabs__tab--selected {
          color: ${(e)=>e.theme.colors.responses.success.color};
        }
      }

      &.tab-redirect {
        color: ${(e)=>e.theme.colors.responses.redirect.tabTextColor};
        &.react-tabs__tab--selected {
          color: ${(e)=>e.theme.colors.responses.redirect.color};
        }
      }

      &.tab-info {
        color: ${(e)=>e.theme.colors.responses.info.tabTextColor};
        &.react-tabs__tab--selected {
          color: ${(e)=>e.theme.colors.responses.info.color};
        }
      }

      &.tab-error {
        color: ${(e)=>e.theme.colors.responses.error.tabTextColor};
        &.react-tabs__tab--selected {
          color: ${(e)=>e.theme.colors.responses.error.color};
        }
      }
    }
  }
  > .react-tabs__tab-panel {
    background: ${({ theme: e })=>e.codeBlock.backgroundColor};
    & > div,
    & > pre {
      padding: ${(e)=>4 * e.theme.spacing.unit}px;
      margin: 0;
    }

    & > div > pre {
      padding: 0;
    }
  }
`, Gi = (ee(Yi)`
  > ul {
    display: block;
    > li {
      padding: 2px 5px;
      min-width: auto;
      margin: 0 15px 0 0;
      font-size: 13px;
      font-weight: normal;
      border-bottom: 1px dashed;
      color: ${({ theme: e })=>(0, t.darken)(e.colors.tonalOffset, e.rightPanel.textColor)};
      border-radius: 0;
      background: none;

      &:last-child {
        margin-right: 0;
      }

      &.react-tabs__tab--selected {
        color: ${({ theme: e })=>e.rightPanel.textColor};
        background: none;
      }
    }
  }
  > .react-tabs__tab-panel {
    & > div,
    & > pre {
      padding: ${(e)=>2 * e.theme.spacing.unit}px 0;
    }
  }
`, ee.div`
  /**
  * Based on prism-dark.css
  */

  code[class*='language-'],
  pre[class*='language-'] {
    /* color: white;
    background: none; */
    text-shadow: 0 -0.1em 0.2em black;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    word-wrap: normal;
    line-height: 1.5;

    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;

    -webkit-hyphens: none;
    -moz-hyphens: none;
    -ms-hyphens: none;
    hyphens: none;
  }

  @media print {
    code[class*='language-'],
    pre[class*='language-'] {
      text-shadow: none;
    }
  }

  /* Code blocks */
  pre[class*='language-'] {
    padding: 1em;
    margin: 0.5em 0;
    overflow: auto;
  }

  .token.comment,
  .token.prolog,
  .token.doctype,
  .token.cdata {
    color: hsl(30, 20%, 50%);
  }

  .token.punctuation {
    opacity: 0.7;
  }

  .namespace {
    opacity: 0.7;
  }

  .token.property,
  .token.tag,
  .token.number,
  .token.constant,
  .token.symbol {
    color: #4a8bb3;
  }

  .token.boolean {
    color: #e64441;
  }

  .token.selector,
  .token.attr-name,
  .token.string,
  .token.char,
  .token.builtin,
  .token.inserted {
    color: #a0fbaa;
    & + a,
    & + a:visited {
      color: #4ed2ba;
      text-decoration: underline;
    }
  }

  .token.property.string {
    color: white;
  }

  .token.operator,
  .token.entity,
  .token.url,
  .token.variable {
    color: hsl(40, 90%, 60%);
  }

  .token.atrule,
  .token.attr-value,
  .token.keyword {
    color: hsl(350, 40%, 70%);
  }

  .token.regex,
  .token.important {
    color: #e90;
  }

  .token.important,
  .token.bold {
    font-weight: bold;
  }
  .token.italic {
    font-style: italic;
  }

  .token.entity {
    cursor: help;
  }

  .token.deleted {
    color: red;
  }

  ${te("Prism")};
`), Zi = ee.div`
  opacity: 0.7;
  transition: opacity 0.3s ease;
  text-align: right;
  &:focus-within {
    opacity: 1;
  }
  > button {
    background-color: transparent;
    border: 0;
    color: inherit;
    padding: 2px 10px;
    font-family: ${({ theme: e })=>e.typography.fontFamily};
    font-size: ${({ theme: e })=>e.typography.fontSize};
    line-height: ${({ theme: e })=>e.typography.lineHeight};
    cursor: pointer;
    outline: 0;

    :hover,
    :focus {
      background: rgba(255, 255, 255, 0.1);
    }
  }
`, Xi = ee.div`
  &:hover ${Zi} {
    opacity: 1;
  }
`, Ki = ee(Gi).attrs({
                as: "pre"
            })`
  font-family: ${(e)=>e.theme.typography.code.fontFamily};
  font-size: ${(e)=>e.theme.typography.code.fontSize};
  overflow-x: auto;
  margin: 0;

  white-space: ${({ theme: e })=>e.typography.code.wrap ? "pre-wrap" : "pre"};
`;
            var es = (parcelRequire("78e7k")), ts = r.n(es), rs = Object.defineProperty, ns = Object.getOwnPropertySymbols, os = Object.prototype.hasOwnProperty, is = Object.prototype.propertyIsEnumerable, ss = (e, t, r)=>t in e ? rs(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r;
            const as = ts() || es;
            let ls = "";
            s && (ls = r(494), ls = "function" == typeof ls.toString && ls.toString() || "", ls = "[object Object]" === ls ? "" : ls);
            const cs = G`${ls}`, ps = ee.div`
  position: relative;
`;
            class us extends e.Component {
                constructor(){
                    super(...arguments), this.handleRef = (e)=>{
                        this._container = e;
                    };
                }
                componentDidMount() {
                    const e = this._container.parentElement && this._container.parentElement.scrollTop || 0;
                    this.inst = new as(this._container, this.props.options || {}), this._container.scrollTo && this._container.scrollTo(0, e);
                }
                componentDidUpdate() {
                    this.inst.update();
                }
                componentWillUnmount() {
                    this.inst.destroy();
                }
                render() {
                    const { children: t, className: r, updateFn: n } = this.props;
                    return n && n(this.componentDidUpdate.bind(this)), e.createElement(e.Fragment, null, ls && e.createElement(cs, null), e.createElement(ps, {
                        className: `scrollbar-container ${r}`,
                        ref: this.handleRef
                    }, t));
                }
            }
            function ds(t) {
                return e.createElement(ce.Consumer, null, (r)=>r.nativeScrollbars ? e.createElement("div", {
                        style: {
                            overflow: "auto",
                            overscrollBehavior: "contain",
                            msOverflowStyle: "-ms-autohiding-scrollbar"
                        }
                    }, t.children) : e.createElement(us, ((e, t)=>{
                        for(var r in t || (t = {}))os.call(t, r) && ss(e, r, t[r]);
                        if (ns) for (var r of ns(t))is.call(t, r) && ss(e, r, t[r]);
                        return e;
                    })({}, t), t.children));
            }
            const hs = ee(({ className: t, style: r })=>e.createElement("svg", {
                    className: t,
                    style: r,
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }, e.createElement("polyline", {
                    points: "6 9 12 15 18 9"
                })))`
  position: absolute;
  pointer-events: none;
  z-index: 1;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 8px;
  margin: auto;
  text-align: center;
  polyline {
    color: ${(e)=>"dark" === e.variant && "white"};
  }
`, ms = e.memo((t)=>{
                const { options: r, onChange: n, placeholder: o, value: i = "", variant: s, className: a, ariaLabel: l } = t;
                return e.createElement("div", {
                    className: a
                }, e.createElement(hs, {
                    variant: s
                }), e.createElement("select", {
                    onChange: (e)=>{
                        const { selectedIndex: t } = e.target;
                        n(r[o ? t - 1 : t]);
                    },
                    value: i,
                    className: "dropdown-select",
                    "aria-label": l
                }, o && e.createElement("option", {
                    disabled: !0,
                    hidden: !0,
                    value: o
                }, o), r.map(({ idx: t, value: r, title: n }, o)=>e.createElement("option", {
                        key: t || r + o,
                        value: r
                    }, n || r))), e.createElement("label", null, i));
            }), fs = H()(ms)`
  label {
    box-sizing: border-box;
    min-width: 100px;
    outline: none;
    display: inline-block;
    font-family: ${(e)=>e.theme.typography.headings.fontFamily};
    color: ${({ theme: e })=>e.colors.text.primary};
    vertical-align: bottom;
    width: ${({ fullWidth: e })=>e ? "100%" : "auto"};
    text-transform: none;
    padding: 0 22px 0 4px;

    font-size: 0.929em;
    line-height: 1.5em;
    font-family: inherit;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .dropdown-select {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    border: none;
    appearance: none;
    cursor: pointer;

    color: ${({ theme: e })=>e.colors.text.primary};
    line-height: inherit;
    font-family: inherit;
  }
  box-sizing: border-box;
  min-width: 100px;
  outline: none;
  display: inline-block;
  border-radius: 2px;
  border: 1px solid rgba(38, 50, 56, 0.5);
  vertical-align: bottom;
  padding: 2px 0px 2px 6px;
  position: relative;
  width: auto;
  background: white;
  color: #263238;
  font-family: ${(e)=>e.theme.typography.headings.fontFamily};
  font-size: 0.929em;
  line-height: 1.5em;
  cursor: pointer;
  transition: border 0.25s ease, color 0.25s ease, box-shadow 0.25s ease;

  &:hover,
  &:focus-within {
    border: 1px solid ${(e)=>e.theme.colors.primary.main};
    color: ${(e)=>e.theme.colors.primary.main};
    box-shadow: 0px 0px 0px 1px ${(e)=>e.theme.colors.primary.main};
  }
`, gs = H()(fs)`
  margin-left: 10px;
  text-transform: none;
  font-size: 0.969em;

  font-size: 1em;
  border: none;
  padding: 0 1.2em 0 0;
  background: transparent;

  &:hover,
  &:focus-within {
    border: none;
    box-shadow: none;
    label {
      color: ${(e)=>e.theme.colors.primary.main};
      text-shadow: 0px 0px 0px ${(e)=>e.theme.colors.primary.main};
    }
  }
`, ys = H().span`
  margin-left: 10px;
  text-transform: none;
  font-size: 0.929em;
  color: black;
`;
            var bs = Object.defineProperty, xs = Object.getOwnPropertySymbols, vs = Object.prototype.hasOwnProperty, ws = Object.prototype.propertyIsEnumerable, ks = (e, t, r)=>t in e ? bs(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, Es = (e, t)=>{
                for(var r in t || (t = {}))vs.call(t, r) && ks(e, r, t[r]);
                if (xs) for (var r of xs(t))ws.call(t, r) && ks(e, r, t[r]);
                return e;
            };
            function Os(t) {
                const { Label: r = ys, Dropdown: n = gs } = t;
                return 1 === t.options.length ? e.createElement(r, null, t.options[0].value) : e.createElement(n, Es({}, t));
            }
            var js = (parcelRequire("i8Fxz")), $s = r.n(js);
            const Ss = Y`
  a {
    text-decoration: ${(e)=>e.theme.typography.links.textDecoration};
    color: ${(e)=>e.theme.typography.links.color};

    &:visited {
      color: ${(e)=>e.theme.typography.links.visited};
    }

    &:hover {
      color: ${(e)=>e.theme.typography.links.hover};
      text-decoration: ${(e)=>e.theme.typography.links.hoverTextDecoration};
    }
  }
`, Cs = ee(Gi)`
  font-family: ${(e)=>e.theme.typography.fontFamily};
  font-weight: ${(e)=>e.theme.typography.fontWeightRegular};
  line-height: ${(e)=>e.theme.typography.lineHeight};

  p {
    &:last-child {
      margin-bottom: 0;
    }
  }

  ${({ $compact: e })=>e && "\n    p:first-child {\n      margin-top: 0;\n    }\n    p:last-child {\n      margin-bottom: 0;\n    }\n  "}

  ${({ $inline: e })=>e && " p {\n    display: inline-block;\n  }"}

  h1 {
    ${gi(1)};
    color: ${(e)=>e.theme.colors.primary.main};
    margin-top: 0;
  }

  h2 {
    ${gi(2)};
    color: ${(e)=>e.theme.colors.text.primary};
  }

  code {
    color: ${({ theme: e })=>e.typography.code.color};
    background-color: ${({ theme: e })=>e.typography.code.backgroundColor};

    font-family: ${(e)=>e.theme.typography.code.fontFamily};
    border-radius: 2px;
    border: 1px solid rgba(38, 50, 56, 0.1);
    padding: 0 ${({ theme: e })=>e.spacing.unit}px;
    font-size: ${(e)=>e.theme.typography.code.fontSize};
    font-weight: ${({ theme: e })=>e.typography.code.fontWeight};

    word-break: break-word;
  }

  pre {
    font-family: ${(e)=>e.theme.typography.code.fontFamily};
    white-space: ${({ theme: e })=>e.typography.code.wrap ? "pre-wrap" : "pre"};
    background-color: ${({ theme: e })=>e.codeBlock.backgroundColor};
    color: white;
    padding: ${(e)=>4 * e.theme.spacing.unit}px;
    overflow-x: auto;
    line-height: normal;
    border-radius: 0;
    border: 1px solid rgba(38, 50, 56, 0.1);

    code {
      background-color: transparent;
      color: white;
      padding: 0;

      &:before,
      &:after {
        content: none;
      }
    }
  }

  blockquote {
    margin: 0;
    margin-bottom: 1em;
    padding: 0 15px;
    color: #777;
    border-left: 4px solid #ddd;
  }

  img {
    max-width: 100%;
    box-sizing: content-box;
  }

  ul,
  ol {
    padding-left: 2em;
    margin: 0;
    margin-bottom: 1em;

    ul,
    ol {
      margin-bottom: 0;
      margin-top: 0;
    }
  }

  table {
    display: block;
    width: 100%;
    overflow: auto;
    word-break: normal;
    word-break: keep-all;
    border-collapse: collapse;
    border-spacing: 0;
    margin-top: 1.5em;
    margin-bottom: 1.5em;
  }

  table tr {
    background-color: #fff;
    border-top: 1px solid #ccc;

    &:nth-child(2n) {
      background-color: ${({ theme: e })=>e.schema.nestedBackground};
    }
  }

  table th,
  table td {
    padding: 6px 13px;
    border: 1px solid #ddd;
  }

  table th {
    text-align: left;
    font-weight: bold;
  }

  ${Ci(".share-link")};

  ${Ss}

  ${te("Markdown")};
`;
            var Ps = Object.defineProperty, Is = Object.defineProperties, As = Object.getOwnPropertyDescriptors, Ts = Object.getOwnPropertySymbols, _s = Object.prototype.hasOwnProperty, Rs = Object.prototype.propertyIsEnumerable, Ds = (e, t, r)=>t in e ? Ps(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r;
            const zs = $s(), Ls = H()(Cs)`
  display: inline;
`;
            function Ns(t) {
                var r = t, { inline: n, compact: o } = r, i = ((e, t)=>{
                    var r = {};
                    for(var n in e)_s.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                    if (null != e && Ts) for (var n of Ts(e))t.indexOf(n) < 0 && Rs.call(e, n) && (r[n] = e[n]);
                    return r;
                })(r, [
                    "inline",
                    "compact"
                ]);
                const s = n ? Ls : Cs;
                return e.createElement(ue, null, (t)=>{
                    var r, a, l;
                    return e.createElement(s, (r = ((e, t)=>{
                        for(var r in t || (t = {}))_s.call(t, r) && Ds(e, r, t[r]);
                        if (Ts) for (var r of Ts(t))Rs.call(t, r) && Ds(e, r, t[r]);
                        return e;
                    })({
                        className: "redoc-markdown " + (i.className || ""),
                        dangerouslySetInnerHTML: {
                            __html: (a = t.sanitize, l = i.html, a ? zs.sanitize(l) : l)
                        },
                        "data-role": i["data-role"]
                    }, i), Is(r, As({
                        $inline: n,
                        $compact: o
                    }))));
                });
            }
            class Ms extends e.Component {
                render() {
                    const { source: t, inline: r, compact: n, className: o, "data-role": i } = this.props, s = new Wr;
                    return e.createElement(Ns, {
                        html: s.renderMd(t),
                        inline: r,
                        compact: n,
                        className: o,
                        "data-role": i
                    });
                }
            }
            const qs = ee.div`
  position: relative;
`, Fs = ee.div`
  position: absolute;
  min-width: 80px;
  max-width: 500px;
  background: #fff;
  bottom: 100%;
  left: 50%;
  margin-bottom: 10px;
  transform: translateX(-50%);

  border-radius: 4px;
  padding: 0.3em 0.6em;
  text-align: center;
  box-shadow: 0px 0px 5px 0px rgba(204, 204, 204, 1);
`, Bs = ee.div`
  background: #fff;
  color: #000;
  display: inline;
  font-size: 0.85em;
  white-space: nowrap;
`, Qs = ee.div`
  position: absolute;
  width: 0;
  height: 0;
  bottom: -5px;
  left: 50%;
  margin-left: -5px;
  border-left: solid transparent 5px;
  border-right: solid transparent 5px;
  border-top: solid #fff 5px;
`, Us = ee.div`
  position: absolute;
  width: 100%;
  height: 20px;
  bottom: -20px;
`;
            class Ws extends e.Component {
                render() {
                    const { open: t, title: r, children: n } = this.props;
                    return e.createElement(qs, null, n, t && e.createElement(Fs, null, e.createElement(Bs, null, r), e.createElement(Qs, null), e.createElement(Us, null)));
                }
            }
            const Vs = "undefined" != typeof document && document.queryCommandSupported && document.queryCommandSupported("copy");
            class Hs {
                static isSupported() {
                    return Vs;
                }
                static selectElement(e) {
                    let t, r;
                    document.body.createTextRange ? (t = document.body.createTextRange(), t.moveToElementText(e), t.select()) : document.createRange && window.getSelection && (r = window.getSelection(), t = document.createRange(), t.selectNodeContents(e), r.removeAllRanges(), r.addRange(t));
                }
                static deselect() {
                    if (document.selection) document.selection.empty();
                    else if (window.getSelection) {
                        const e = window.getSelection();
                        e && e.removeAllRanges();
                    }
                }
                static copySelected() {
                    let e;
                    try {
                        e = document.execCommand("copy");
                    } catch (t) {
                        e = !1;
                    }
                    return e;
                }
                static copyElement(e) {
                    Hs.selectElement(e);
                    const t = Hs.copySelected();
                    return t && Hs.deselect(), t;
                }
                static copyCustom(e) {
                    const t = document.createElement("textarea");
                    t.style.position = "fixed", t.style.top = "0", t.style.left = "0", t.style.width = "2em", t.style.height = "2em", t.style.padding = "0", t.style.border = "none", t.style.outline = "none", t.style.boxShadow = "none", t.style.background = "transparent", t.value = e, document.body.appendChild(t), t.select();
                    const r = Hs.copySelected();
                    return document.body.removeChild(t), r;
                }
            }
            const Js = (t)=>{
                const [r, n] = e.useState(!1), o = ()=>{
                    const e = "string" == typeof t.data ? t.data : JSON.stringify(t.data, null, 2);
                    Hs.copyCustom(e), i();
                }, i = ()=>{
                    n(!0), setTimeout(()=>{
                        n(!1);
                    }, 1500);
                };
                return t.children({
                    renderCopyButton: ()=>e.createElement("button", {
                            onClick: o
                        }, e.createElement(Ws, {
                            title: Hs.isSupported() ? "Copied" : "Not supported in your browser",
                            open: r
                        }, "Copy"))
                });
            };
            let Ys = 1;
            function Gs(e, t) {
                Ys = 1;
                let r = "";
                return r += '<div class="redoc-json">', r += "<code>", r += ta(e, t), r += "</code>", r += "</div>", r;
            }
            function Zs(e) {
                return void 0 !== e ? e.toString().replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;") : "";
            }
            function Xs(e) {
                return JSON.stringify(e).slice(1, -1);
            }
            function Ks(e, t) {
                return '<span class="' + t + '">' + Zs(e) + "</span>";
            }
            function ea(e) {
                return '<span class="token punctuation">' + e + "</span>";
            }
            function ta(e, t) {
                const r = typeof e;
                let n = "";
                return null == e ? n += Ks("null", "token keyword") : e && e.constructor === Array ? (Ys++, n += function(e, t) {
                    const r = Ys > t ? "collapsed" : "";
                    let n = `<button class="collapser" aria-label="${Ys > t + 1 ? "expand" : "collapse"}"></button>${ea("[")}<span class="ellipsis"></span><ul class="array collapsible">`, o = !1;
                    const i = e.length;
                    for(let s = 0; s < i; s++)o = !0, n += '<li><div class="hoverable ' + r + '">', n += ta(e[s], t), s < i - 1 && (n += ","), n += "</div></li>";
                    return n += `</ul>${ea("]")}`, o || (n = ea("[ ]")), n;
                }(e, t), Ys--) : e && e.constructor === Date ? n += Ks('"' + e.toISOString() + '"', "token string") : "object" === r ? (Ys++, n += function(e, t) {
                    const r = Ys > t ? "collapsed" : "", n = Object.keys(e), o = n.length;
                    let i = `<button class="collapser" aria-label="${Ys > t + 1 ? "expand" : "collapse"}"></button>${ea("{")}<span class="ellipsis"></span><ul class="obj collapsible">`, s = !1;
                    for(let a = 0; a < o; a++){
                        const l = n[a];
                        s = !0, i += '<li><div class="hoverable ' + r + '">', i += '<span class="property token string">"' + Zs(l) + '"</span>: ', i += ta(e[l], t), a < o - 1 && (i += ea(",")), i += "</div></li>";
                    }
                    return i += `</ul>${ea("}")}`, s || (i = ea("{ }")), i;
                }(e, t), Ys--) : "number" === r ? n += Ks(e, "token number") : "string" === r ? /^(http|https):\/\/[^\s]+$/.test(e) ? n += Ks('"', "token string") + '<a href="' + encodeURI(e) + '">' + Zs(Xs(e)) + "</a>" + Ks('"', "token string") : n += Ks('"' + Xs(e) + '"', "token string") : "boolean" === r && (n += Ks(e, "token boolean")), n;
            }
            const ra = Y`
  .redoc-json code > .collapser {
    display: none;
    pointer-events: none;
  }

  font-family: ${(e)=>e.theme.typography.code.fontFamily};
  font-size: ${(e)=>e.theme.typography.code.fontSize};

  white-space: ${({ theme: e })=>e.typography.code.wrap ? "pre-wrap" : "pre"};
  contain: content;
  overflow-x: auto;

  .callback-function {
    color: gray;
  }

  .collapser:after {
    content: '-';
    cursor: pointer;
  }

  .collapsed > .collapser:after {
    content: '+';
    cursor: pointer;
  }

  .ellipsis:after {
    content: ' … ';
  }

  .collapsible {
    margin-left: 2em;
  }

  .hoverable {
    padding-top: 1px;
    padding-bottom: 1px;
    padding-left: 2px;
    padding-right: 2px;
    border-radius: 2px;
  }

  .hovered {
    background-color: rgba(235, 238, 249, 1);
  }

  .collapser {
    background-color: transparent;
    border: 0;
    color: #fff;
    font-family: ${(e)=>e.theme.typography.code.fontFamily};
    font-size: ${(e)=>e.theme.typography.code.fontSize};
    padding-right: 6px;
    padding-left: 6px;
    padding-top: 0;
    padding-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15px;
    height: 15px;
    position: absolute;
    top: 4px;
    left: -1.5em;
    cursor: default;
    user-select: none;
    -webkit-user-select: none;
    padding: 2px;
    &:focus {
      outline-color: #fff;
      outline-style: dotted;
      outline-width: 1px;
    }
  }

  ul {
    list-style-type: none;
    padding: 0px;
    margin: 0px 0px 0px 26px;
  }

  li {
    position: relative;
    display: block;
  }

  .hoverable {
    display: inline-block;
  }

  .selected {
    outline-style: solid;
    outline-width: 1px;
    outline-style: dotted;
  }

  .collapsed > .collapsible {
    display: none;
  }

  .ellipsis {
    display: none;
  }

  .collapsed > .ellipsis {
    display: inherit;
  }
`, na = ee.div`
  &:hover > ${Zi} {
    opacity: 1;
  }
`, oa = ee((t)=>{
                const [r, n] = e.useState(), o = ({ renderCopyButton: r })=>{
                    const o = t.data && Object.values(t.data).some((e)=>"object" == typeof e && null !== e);
                    return e.createElement(na, null, e.createElement(Zi, null, r(), o && e.createElement(e.Fragment, null, e.createElement("button", {
                        onClick: i
                    }, " Expand all "), e.createElement("button", {
                        onClick: s
                    }, " Collapse all "))), e.createElement(ce.Consumer, null, (r)=>e.createElement(Gi, {
                            tabIndex: 0,
                            className: t.className,
                            ref: (e)=>n(e),
                            dangerouslySetInnerHTML: {
                                __html: Gs(t.data, r.jsonSamplesExpandLevel)
                            }
                        })));
                }, i = ()=>{
                    const e = null == r ? void 0 : r.getElementsByClassName("collapsible");
                    for (const t of Array.prototype.slice.call(e)){
                        const e = t.parentNode;
                        e.classList.remove("collapsed"), e.querySelector(".collapser").setAttribute("aria-label", "collapse");
                    }
                }, s = ()=>{
                    const e = null == r ? void 0 : r.getElementsByClassName("collapsible"), t = Array.prototype.slice.call(e, 1);
                    for (const e of t){
                        const t = e.parentNode;
                        t.classList.add("collapsed"), t.querySelector(".collapser").setAttribute("aria-label", "expand");
                    }
                }, a = (e)=>{
                    let t;
                    "collapser" === e.className && (t = e.parentElement.getElementsByClassName("collapsible")[0], t.parentElement.classList.contains("collapsed") ? (t.parentElement.classList.remove("collapsed"), e.setAttribute("aria-label", "collapse")) : (t.parentElement.classList.add("collapsed"), e.setAttribute("aria-label", "expand")));
                }, l = e.useCallback((e)=>{
                    a(e.target);
                }, []), c = e.useCallback((e)=>{
                    "Enter" === e.key && a(e.target);
                }, []);
                return e.useEffect(()=>(null == r || r.addEventListener("click", l), null == r || r.addEventListener("focus", c), ()=>{
                        null == r || r.removeEventListener("click", l), null == r || r.removeEventListener("focus", c);
                    }), [
                    l,
                    c,
                    r
                ]), e.createElement(Js, {
                    data: t.data
                }, o);
            })`
  ${ra};
`, ia = (t)=>{
                const { source: r, lang: n } = t;
                return e.createElement(Ki, {
                    dangerouslySetInnerHTML: {
                        __html: jt(r, n)
                    }
                });
            }, sa = (t)=>{
                const { source: r, lang: n } = t;
                return e.createElement(Js, {
                    data: r
                }, ({ renderCopyButton: t })=>e.createElement(Xi, null, e.createElement(Zi, null, t()), e.createElement(ia, {
                        lang: n,
                        source: r
                    })));
            };
            function aa({ value: t, mimeType: r }) {
                return Ue(r) ? e.createElement(oa, {
                    data: t
                }) : ("object" == typeof t && (t = JSON.stringify(t, null, 2)), e.createElement(sa, {
                    lang: Ke(r),
                    source: t
                }));
            }
            var la = (e, t, r)=>new Promise((n, o)=>{
                    var i = (e)=>{
                        try {
                            a(r.next(e));
                        } catch (e) {
                            o(e);
                        }
                    }, s = (e)=>{
                        try {
                            a(r.throw(e));
                        } catch (e) {
                            o(e);
                        }
                    }, a = (e)=>e.done ? n(e.value) : Promise.resolve(e.value).then(i, s);
                    a((r = r.apply(e, t)).next());
                });
            function ca({ example: t, mimeType: r }) {
                return void 0 === t.value && t.externalValueUrl ? e.createElement(pa, {
                    example: t,
                    mimeType: r
                }) : e.createElement(aa, {
                    value: t.value,
                    mimeType: r
                });
            }
            function pa({ example: t, mimeType: r }) {
                const n = function(t, r) {
                    const [, n] = (0, e.useState)(!0), o = (0, e.useRef)(void 0), i = (0, e.useRef)(void 0);
                    return i.current !== t && (o.current = void 0), i.current = t, (0, e.useEffect)(()=>{
                        (()=>{
                            la(this, null, function*() {
                                n(!0);
                                try {
                                    o.current = yield t.getExternalValue(r);
                                } catch (e) {
                                    o.current = e;
                                }
                                n(!1);
                            });
                        })();
                    }, [
                        t,
                        r
                    ]), o.current;
                }(t, r);
                return void 0 === n ? e.createElement("span", null, "Loading...") : n instanceof Error ? e.createElement(Ki, null, "Error loading external example: ", e.createElement("br", null), e.createElement("a", {
                    className: "token string",
                    href: t.externalValueUrl,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, t.externalValueUrl)) : e.createElement(aa, {
                    value: n,
                    mimeType: r
                });
            }
            const ua = ee.div`
  padding: 0.9em;
  background-color: ${({ theme: e })=>(0, t.transparentize)(.6, e.rightPanel.backgroundColor)};
  margin: 0 0 10px 0;
  display: block;
  font-family: ${({ theme: e })=>e.typography.headings.fontFamily};
  font-size: 0.929em;
  line-height: 1.5em;
`, da = ee.span`
  font-family: ${({ theme: e })=>e.typography.headings.fontFamily};
  font-size: 12px;
  position: absolute;
  z-index: 1;
  top: -11px;
  left: 12px;
  font-weight: ${({ theme: e })=>e.typography.fontWeightBold};
  color: ${({ theme: e })=>(0, t.transparentize)(.3, e.rightPanel.textColor)};
`, ha = ee.div`
  position: relative;
`, ma = ee(fs)`
  label {
    color: ${({ theme: e })=>e.rightPanel.textColor};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 1em;
    text-transform: none;
    border: none;
  }
  margin: 0 0 10px 0;
  display: block;
  background-color: ${({ theme: e })=>(0, t.transparentize)(.6, e.rightPanel.backgroundColor)};
  border: none;
  padding: 0.9em 1.6em 0.9em 0.9em;
  box-shadow: none;
  &:hover,
  &:focus-within {
    border: none;
    box-shadow: none;
    background-color: ${({ theme: e })=>(0, t.transparentize)(.3, e.rightPanel.backgroundColor)};
  }
`, fa = ee.div`
  font-family: ${(e)=>e.theme.typography.code.fontFamily};
  font-size: 12px;
  color: #ee807f;
`;
            class ga extends e.Component {
                constructor(){
                    super(...arguments), this.state = {
                        activeIdx: 0
                    }, this.switchMedia = ({ idx: e })=>{
                        void 0 !== e && this.setState({
                            activeIdx: e
                        });
                    };
                }
                render() {
                    const { activeIdx: t } = this.state, r = this.props.mediaType.examples || {}, n = this.props.mediaType.name, o = e.createElement(fa, null, "No sample"), i = Object.keys(r);
                    if (0 === i.length) return o;
                    if (i.length > 1) {
                        const o = i.map((e, t)=>({
                                value: r[e].summary || e,
                                idx: t
                            })), s = r[i[t]], a = s.description;
                        return e.createElement(ya, null, e.createElement(ha, null, e.createElement(da, null, "Example"), this.props.renderDropdown({
                            value: o[t].value,
                            options: o,
                            onChange: this.switchMedia,
                            ariaLabel: "Example"
                        })), e.createElement("div", null, a && e.createElement(Ms, {
                            source: a
                        }), e.createElement(ca, {
                            example: s,
                            mimeType: n
                        })));
                    }
                    {
                        const t = r[i[0]];
                        return e.createElement(ya, null, t.description && e.createElement(Ms, {
                            source: t.description
                        }), e.createElement(ca, {
                            example: t,
                            mimeType: n
                        }));
                    }
                }
            }
            const ya = ee.div`
  margin-top: 15px;
`;
            var ba = (parcelRequire("eOZ0o"));
            const xa = ee(Ni)`
  &.deprecated {
    span.property-name {
      ${Ri}
    }
  }

  button {
    background-color: transparent;
    border: 0;
    outline: 0;
    font-size: 13px;
    font-family: ${(e)=>e.theme.typography.code.fontFamily};
    cursor: pointer;
    padding: 0;
    color: ${(e)=>e.theme.colors.text.primary};
    &:focus {
      font-weight: ${({ theme: e })=>e.typography.fontWeightBold};
    }
    ${({ kind: e })=>"patternProperties" === e && Y`
        display: inline-flex;
        margin-right: 20px;

        > span.property-name {
          white-space: break-spaces;
          text-align: left;

          ::before,
          ::after {
            content: '/';
            filter: opacity(0.2);
          }
        }

        > svg {
          align-self: center;
        }
      `}
  }
  ${Ti} {
    height: ${({ theme: e })=>e.schema.arrow.size};
    width: ${({ theme: e })=>e.schema.arrow.size};
    polygon {
      fill: ${({ theme: e })=>e.schema.arrow.color};
    }
  }
`, va = ee.span`
  vertical-align: middle;
  font-size: ${({ theme: e })=>e.typography.code.fontSize};
  line-height: 20px;
`, wa = ee(va)`
  color: ${(e)=>(0, t.transparentize)(.1, e.theme.schema.typeNameColor)};
`, ka = ee(va)`
  color: ${(e)=>e.theme.schema.typeNameColor};
`, Ea = ee(va)`
  color: ${(e)=>e.theme.schema.typeTitleColor};
  word-break: break-word;
`, Oa = ka, ja = ee(va).attrs({
                as: "div"
            })`
  color: ${(e)=>e.theme.schema.requireLabelColor};
  font-size: ${(e)=>e.theme.schema.labelsTextSize};
  font-weight: normal;
  margin-left: 20px;
  line-height: 1;
`, $a = ee(ja)`
  color: ${(e)=>e.theme.colors.primary.light};
`, Sa = ee(va)`
  color: ${({ theme: e })=>e.colors.warning.dark};
  font-size: 13px;
`, Ca = ee(va)`
  color: #0e7c86;
  font-family: ${(e)=>e.theme.typography.code.fontFamily};
  font-size: 12px;
  &::before,
  &::after {
    content: ' ';
  }
`, Pa = ee(va)`
  border-radius: 2px;
  word-break: break-word;
  ${({ theme: e })=>`\n    background-color: ${(0, t.transparentize)(.95, e.colors.text.primary)};\n    color: ${(0, t.transparentize)(.1, e.colors.text.primary)};\n\n    padding: 0 ${e.spacing.unit}px;\n    border: 1px solid ${(0, t.transparentize)(.9, e.colors.text.primary)};\n    font-family: ${e.typography.code.fontFamily};\n}`};
  & + & {
    margin-left: 0;
  }
  ${te("ExampleValue")};
`, Ia = ee(Pa)``, Aa = ee(va)`
  border-radius: 2px;
  ${({ theme: e })=>`\n    background-color: ${(0, t.transparentize)(.95, e.colors.primary.light)};\n    color: ${(0, t.transparentize)(.1, e.colors.primary.main)};\n\n    margin: 0 ${e.spacing.unit}px;\n    padding: 0 ${e.spacing.unit}px;\n    border: 1px solid ${(0, t.transparentize)(.9, e.colors.primary.main)};\n}`};
  & + & {
    margin-left: 0;
  }
  ${te("ConstraintItem")};
`, Ta = ee.button`
  background-color: transparent;
  border: 0;
  color: ${({ theme: e })=>e.colors.text.secondary};
  margin-left: ${({ theme: e })=>e.spacing.unit}px;
  border-radius: 2px;
  cursor: pointer;
  outline-color: ${({ theme: e })=>e.colors.text.secondary};
  font-size: 12px;
`;
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            const _a = ee.div`
  ${Ss};
  ${({ $compact: e })=>e ? "" : "margin: 1em 0"}
`;
            let Ra = class extends e.Component {
                render() {
                    const { externalDocs: t } = this.props;
                    return t && t.url ? e.createElement(_a, {
                        $compact: this.props.compact
                    }, e.createElement("a", {
                        href: t.url
                    }, t.description || t.url)) : null;
                }
            };
            Ra = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], Ra);
            const Da = ee(Cs)`
  table {
    margin-bottom: 0.2em;
  }
`;
            class za extends e.PureComponent {
                constructor(e){
                    super(e), this.state = {
                        collapsed: !0
                    }, this.toggle = this.toggle.bind(this);
                }
                toggle() {
                    this.setState({
                        collapsed: !this.state.collapsed
                    });
                }
                render() {
                    const { values: t, type: r } = this.props, { collapsed: n } = this.state, o = !Array.isArray(t), i = Array.isArray(t) && t || Object.entries(t || {}).map(([e, t])=>({
                            value: e,
                            description: t
                        })), { enumSkipQuotes: s, maxDisplayedEnumValues: a } = this.context;
                    if (!i.length) return null;
                    const l = this.state.collapsed && a ? i.slice(0, a) : i, c = !!a && i.length > a, p = a ? n ? `\u{2026} ${i.length - a} more` : "Hide" : "";
                    return e.createElement("div", null, o ? e.createElement(e.Fragment, null, e.createElement(Da, null, e.createElement("table", null, e.createElement("thead", null, e.createElement("tr", null, e.createElement("th", null, e.createElement(va, null, "array" === r ? _("enumArray") : "", " ", 1 === i.length ? _("enumSingleValue") : _("enum")), " "), e.createElement("th", null, e.createElement("strong", null, "Description")))), e.createElement("tbody", null, l.map(({ description: t, value: r })=>e.createElement("tr", {
                            key: r
                        }, e.createElement("td", null, r), e.createElement("td", null, e.createElement(Ms, {
                            source: t,
                            compact: !0,
                            inline: !0
                        }))))))), c ? e.createElement(La, {
                        onClick: this.toggle
                    }, p) : null) : e.createElement(e.Fragment, null, e.createElement(va, null, "array" === r ? _("enumArray") : "", " ", 1 === t.length ? _("enumSingleValue") : _("enum"), ":"), " ", l.map((t, r)=>{
                        const n = s ? String(t) : JSON.stringify(t);
                        return e.createElement(e.Fragment, {
                            key: r
                        }, e.createElement(Pa, null, n), " ");
                    }), c ? e.createElement(La, {
                        onClick: this.toggle
                    }, p) : null));
                }
            }
            za.contextType = ce;
            const La = ee.span`
  color: ${(e)=>e.theme.colors.primary.main};
  vertical-align: middle;
  font-size: 13px;
  line-height: 20px;
  padding: 0 5px;
  cursor: pointer;
`, Na = ee(Cs)`
  margin: 2px 0;
`;
            class Ma extends e.PureComponent {
                render() {
                    const t = this.props.extensions;
                    return e.createElement(ce.Consumer, null, (r)=>e.createElement(e.Fragment, null, r.showExtensions && Object.keys(t).map((r)=>e.createElement(Na, {
                                key: r
                            }, e.createElement(va, null, " ", r.substring(2), ": "), " ", e.createElement(Ia, null, "string" == typeof t[r] ? t[r] : JSON.stringify(t[r]))))));
                }
            }
            function qa({ field: t }) {
                return t.examples ? e.createElement(e.Fragment, null, e.createElement(va, null, " ", _("examples"), ": "), I(t.examples) ? t.examples.map((r, n)=>{
                    const o = Xe(t, r), i = t.in ? String(o) : JSON.stringify(o);
                    return e.createElement(e.Fragment, {
                        key: n
                    }, e.createElement(Pa, null, i), " ");
                }) : e.createElement(Fa, null, Object.values(t.examples).map((r, n)=>e.createElement("li", {
                        key: n + r.value
                    }, e.createElement(Pa, null, Xe(t, r.value)), " -", " ", r.summary || r.description)))) : null;
            }
            const Fa = ee.ul`
  margin-top: 1em;
  list-style-position: outside;
`;
            class Ba extends e.PureComponent {
                render() {
                    return 0 === this.props.constraints.length ? null : e.createElement("span", null, " ", this.props.constraints.map((t)=>e.createElement(Aa, {
                            key: t
                        }, " ", t, " ")));
                }
            }
            const Qa = e.memo(function({ value: t, label: r, raw: n }) {
                if (void 0 === t) return null;
                const o = n ? String(t) : JSON.stringify(t);
                return e.createElement("div", null, e.createElement(va, null, " ", r, " "), " ", e.createElement(Pa, null, o));
            });
            function Ua(t) {
                const r = t.schema.pattern, { hideSchemaPattern: n } = e.useContext(ce), [o, i] = e.useState(!1), s = e.useCallback(()=>i(!o), [
                    o
                ]);
                return !r || n ? null : e.createElement(e.Fragment, null, e.createElement(Ca, null, o || r.length < 45 ? r : `${r.substr(0, 45)}...`), r.length > 45 && e.createElement(Ta, {
                    onClick: s
                }, o ? "Hide pattern" : "Show pattern"));
            }
            function Wa({ schema: t }) {
                var r;
                const { hideSchemaPattern: n } = e.useContext(ce);
                return t && ((null == t ? void 0 : t.pattern) && !n || t.items || t.displayFormat || (null == (r = t.constraints) ? void 0 : r.length)) ? e.createElement(Va, null, "[ items", t.displayFormat && e.createElement(Oa, null, " <", t.displayFormat, " >"), e.createElement(Ba, {
                    constraints: t.constraints
                }), e.createElement(Ua, {
                    schema: t
                }), t.items && e.createElement(Wa, {
                    schema: t.items
                }), " ]") : null;
            }
            const Va = ee(wa)`
  margin: 0 5px;
  vertical-align: text-top;
`;
            var Ha = Object.defineProperty, Ja = Object.getOwnPropertySymbols, Ya = Object.prototype.hasOwnProperty, Ga = Object.prototype.propertyIsEnumerable, Za = (e, t, r)=>t in e ? Ha(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, Xa = (e, t)=>{
                for(var r in t || (t = {}))Ya.call(t, r) && Za(e, r, t[r]);
                if (Ja) for (var r of Ja(t))Ga.call(t, r) && Za(e, r, t[r]);
                return e;
            };
            const Ka = (0, ba.observer)((t)=>{
                const { enumSkipQuotes: r, hideSchemaTitles: n } = e.useContext(ce), { showExamples: o, field: i, renderDiscriminatorSwitch: s } = t, { schema: a, description: l, deprecated: c, extensions: p, in: u, const: d } = i, h = "array" === a.type || I(a.type) && a.type.includes("array"), m = r || "header" === u, f = e.useMemo(()=>!o || void 0 === i.example && void 0 === i.examples ? null : void 0 !== i.examples ? e.createElement(qa, {
                        field: i
                    }) : e.createElement(Qa, {
                        label: _("example") + ":",
                        value: Xe(i, i.example),
                        raw: Boolean(i.in)
                    }), [
                    i,
                    o
                ]), g = x(a.default) && i.in ? Xe(i, a.default).replace(`${i.name}=`, "") : a.default;
                return e.createElement("div", null, e.createElement("div", null, e.createElement(wa, null, a.typePrefix), e.createElement(ka, null, a.displayType), a.displayFormat && e.createElement(Oa, null, " ", "<", a.displayFormat, ">", " "), a.contentEncoding && e.createElement(Oa, null, " ", "<", a.contentEncoding, ">", " "), a.contentMediaType && e.createElement(Oa, null, " ", "<", a.contentMediaType, ">", " "), a.title && !n && e.createElement(Ea, null, " (", a.title, ") "), e.createElement(Ba, {
                    constraints: a.constraints
                }), e.createElement(Ua, {
                    schema: a
                }), a.isCircular && e.createElement(Sa, null, " ", _("recursive"), " "), h && a.items && e.createElement(Wa, {
                    schema: a.items
                })), c && e.createElement("div", null, e.createElement(_i, {
                    type: "warning"
                }, " ", _("deprecated"), " ")), e.createElement(Qa, {
                    raw: m,
                    label: _("default") + ":",
                    value: g
                }), !s && e.createElement(za, {
                    type: a.type,
                    values: a["x-enumDescriptions"] || a.enum
                }), " ", f, e.createElement(Ma, {
                    extensions: Xa(Xa({}, p), a.extensions)
                }), e.createElement("div", null, e.createElement(Ms, {
                    compact: !0,
                    source: l
                })), a.externalDocs && e.createElement(Ra, {
                    externalDocs: a.externalDocs,
                    compact: !0
                }), s && s(t) || null, d && e.createElement(Qa, {
                    label: _("const") + ":",
                    value: d
                }) || null);
            }), el = e.memo(Ka);
            var tl = Object.defineProperty, rl = (Object.getOwnPropertyDescriptor, Object.getOwnPropertySymbols), nl = Object.prototype.hasOwnProperty, ol = Object.prototype.propertyIsEnumerable, il = (e, t, r)=>t in e ? tl(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r;
            let sl = class extends e.Component {
                constructor(){
                    super(...arguments), this.toggle = ()=>{
                        void 0 === this.props.field.expanded && this.props.expandByDefault ? this.props.field.collapse() : this.props.field.toggle();
                    }, this.handleKeyPress = (e)=>{
                        "Enter" === e.key && (e.preventDefault(), this.toggle());
                    };
                }
                render() {
                    const { hidePropertiesPrefix: t } = this.context, { className: r = "", field: n, isLast: o, expandByDefault: i, fieldParentsName: s = [] } = this.props, { name: a, deprecated: l, required: c, kind: p } = n, u = !n.schema.isPrimitive && !n.schema.isCircular, d = void 0 === n.expanded ? i : n.expanded, h = e.createElement(e.Fragment, null, "additionalProperties" === p && e.createElement($a, null, "additional property"), "patternProperties" === p && e.createElement($a, null, "pattern property"), c && e.createElement(ja, null, "required")), m = u ? e.createElement(xa, {
                        className: l ? "deprecated" : "",
                        kind: p,
                        title: a
                    }, e.createElement(qi, null), e.createElement("button", {
                        onClick: this.toggle,
                        onKeyPress: this.handleKeyPress,
                        "aria-label": `expand ${a}`
                    }, !t && s.map((e)=>e + ".\u200B"), e.createElement("span", {
                        className: "property-name"
                    }, a), e.createElement(Ti, {
                        direction: d ? "down" : "right"
                    })), h) : e.createElement(Ni, {
                        className: l ? "deprecated" : void 0,
                        kind: p,
                        title: a
                    }, e.createElement(qi, null), !t && s.map((e)=>e + ".\u200B"), e.createElement("span", {
                        className: "property-name"
                    }, a), h);
                    return e.createElement(e.Fragment, null, e.createElement("tr", {
                        className: o ? "last " + r : r
                    }, m, e.createElement(Mi, null, e.createElement(el, ((e, t)=>{
                        for(var r in t || (t = {}))nl.call(t, r) && il(e, r, t[r]);
                        if (rl) for (var r of rl(t))ol.call(t, r) && il(e, r, t[r]);
                        return e;
                    })({}, this.props)))), d && u && e.createElement("tr", {
                        key: n.name + "inner"
                    }, e.createElement(Li, {
                        colSpan: 2
                    }, e.createElement(Fi, null, e.createElement(Fl, {
                        schema: n.schema,
                        fieldParentsName: [
                            ...s || [],
                            n.name
                        ],
                        skipReadOnly: this.props.skipReadOnly,
                        skipWriteOnly: this.props.skipWriteOnly,
                        showTitle: this.props.showTitle,
                        level: this.props.level
                    })))));
                }
            };
            sl.contextType = ce, sl = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], sl);
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let al = class extends e.Component {
                constructor(){
                    super(...arguments), this.changeActiveChild = (e)=>{
                        void 0 !== e.idx && this.props.parent.activateOneOf(e.idx);
                    };
                }
                sortOptions(e, t) {
                    if (0 === t.length) return;
                    const r = {};
                    t.forEach((e, t)=>{
                        r[e] = t;
                    }), e.sort((e, t)=>r[e.value] > r[t.value] ? 1 : -1);
                }
                render() {
                    const { parent: t, enumValues: r } = this.props;
                    if (void 0 === t.oneOf) return null;
                    const n = t.oneOf.map((e, t)=>({
                            value: e.title,
                            idx: t
                        })), o = n[t.activeOneOf].value;
                    return this.sortOptions(n, r), e.createElement(fs, {
                        value: o,
                        options: n,
                        onChange: this.changeActiveChild,
                        ariaLabel: t.discriminatorProp
                    });
                }
            };
            al = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], al);
            const ll = (0, ba.observer)(({ schema: { fields: t = [], title: r }, showTitle: n, discriminator: o, skipReadOnly: i, skipWriteOnly: s, level: a, fieldParentsName: l })=>{
                const { expandSingleSchemaField: c, showObjectSchemaExamples: p, schemasExpansionLevel: u } = e.useContext(ce), h = e.useMemo(()=>i || s ? t.filter((e)=>!(i && e.schema.readOnly || s && e.schema.writeOnly)) : t, [
                    i,
                    s,
                    t
                ]), m = c && 1 === h.length || u >= a;
                return e.createElement(Bi, null, n && e.createElement(Di, null, r), e.createElement("tbody", null, d(h, (t, r)=>e.createElement(sl, {
                        key: t.name,
                        isLast: r,
                        field: t,
                        expandByDefault: m,
                        fieldParentsName: Number(a) > 1 ? l : [],
                        renderDiscriminatorSwitch: (null == o ? void 0 : o.fieldName) === t.name ? ()=>e.createElement(al, {
                                parent: o.parentSchema,
                                enumValues: t.schema.enum
                            }) : void 0,
                        className: t.expanded ? "expanded" : void 0,
                        showExamples: p,
                        skipReadOnly: i,
                        skipWriteOnly: s,
                        showTitle: n,
                        level: a
                    }))));
            });
            var cl = Object.defineProperty, pl = Object.defineProperties, ul = Object.getOwnPropertyDescriptors, dl = Object.getOwnPropertySymbols, hl = Object.prototype.hasOwnProperty, ml = Object.prototype.propertyIsEnumerable, fl = (e, t, r)=>t in e ? cl(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, gl = (e, t)=>{
                for(var r in t || (t = {}))hl.call(t, r) && fl(e, r, t[r]);
                if (dl) for (var r of dl(t))ml.call(t, r) && fl(e, r, t[r]);
                return e;
            }, yl = (e, t)=>pl(e, ul(t));
            const bl = ee.div`
  padding-left: ${({ theme: e })=>2 * e.spacing.unit}px;
`;
            class xl extends e.PureComponent {
                render() {
                    const t = this.props.schema, r = t.items, n = this.props.fieldParentsName, o = void 0 === t.minItems && void 0 === t.maxItems ? "" : `(${it(t)})`, i = n ? [
                        ...n.slice(0, -1),
                        n[n.length - 1] + "[]"
                    ] : n;
                    return t.fields ? e.createElement(ll, yl(gl({}, this.props), {
                        level: this.props.level,
                        fieldParentsName: i
                    })) : !t.displayType || r || o.length ? e.createElement("div", null, e.createElement(Vi, null, " Array ", o), e.createElement(bl, null, e.createElement(Fl, yl(gl({}, this.props), {
                        schema: r,
                        fieldParentsName: i
                    }))), e.createElement(Hi, null)) : e.createElement("div", null, e.createElement(ka, null, t.displayType));
                }
            }
            var vl = Object.defineProperty, wl = Object.defineProperties, kl = Object.getOwnPropertyDescriptor, El = Object.getOwnPropertyDescriptors, Ol = Object.getOwnPropertySymbols, jl = Object.prototype.hasOwnProperty, $l = Object.prototype.propertyIsEnumerable, Sl = (e, t, r)=>t in e ? vl(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, Cl = (e, t, r, n)=>{
                for(var o, i = n > 1 ? void 0 : n ? kl(t, r) : t, s = e.length - 1; s >= 0; s--)(o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
                return n && i && vl(t, r, i), i;
            };
            let Pl = class extends e.Component {
                constructor(){
                    super(...arguments), this.activateOneOf = ()=>{
                        this.props.schema.activateOneOf(this.props.idx);
                    };
                }
                render() {
                    const { idx: t, schema: r, subSchema: n } = this.props;
                    return e.createElement(Wi, {
                        $deprecated: n.deprecated,
                        $active: t === r.activeOneOf,
                        onClick: this.activateOneOf
                    }, n.title || n.typePrefix + n.displayType);
                }
            };
            Pl = Cl([
                ba.observer
            ], Pl);
            let Il = class extends e.Component {
                render() {
                    const { schema: { oneOf: t }, schema: r } = this.props;
                    if (void 0 === t) return null;
                    const n = t[r.activeOneOf];
                    var o;
                    return e.createElement("div", null, e.createElement(Ui, null, " ", r.oneOfType, " "), e.createElement(Qi, null, t.map((t, n)=>e.createElement(Pl, {
                            key: t.pointer,
                            schema: r,
                            subSchema: t,
                            idx: n
                        }))), e.createElement("div", null, t[r.activeOneOf].deprecated && e.createElement(_i, {
                        type: "warning"
                    }, "Deprecated")), e.createElement(Ba, {
                        constraints: n.constraints
                    }), e.createElement(Fl, (o = ((e, t)=>{
                        for(var r in t || (t = {}))jl.call(t, r) && Sl(e, r, t[r]);
                        if (Ol) for (var r of Ol(t))$l.call(t, r) && Sl(e, r, t[r]);
                        return e;
                    })({}, this.props), wl(o, El({
                        schema: n
                    })))));
                }
            };
            Il = Cl([
                ba.observer
            ], Il);
            const Al = (0, ba.observer)(({ schema: t })=>e.createElement("div", null, e.createElement(ka, null, t.displayType), t.title && e.createElement(Ea, null, " ", t.title, " "), e.createElement(Sa, null, " ", _("recursive"), " ")));
            var Tl = Object.defineProperty, _l = Object.defineProperties, Rl = (Object.getOwnPropertyDescriptor, Object.getOwnPropertyDescriptors), Dl = Object.getOwnPropertySymbols, zl = Object.prototype.hasOwnProperty, Ll = Object.prototype.propertyIsEnumerable, Nl = (e, t, r)=>t in e ? Tl(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, Ml = (e, t)=>{
                for(var r in t || (t = {}))zl.call(t, r) && Nl(e, r, t[r]);
                if (Dl) for (var r of Dl(t))Ll.call(t, r) && Nl(e, r, t[r]);
                return e;
            }, ql = (e, t)=>_l(e, Rl(t));
            let Fl = class extends e.Component {
                render() {
                    var t;
                    const r = this.props, { schema: n } = r, o = ((e, t)=>{
                        var r = {};
                        for(var n in e)zl.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                        if (null != e && Dl) for (var n of Dl(e))t.indexOf(n) < 0 && Ll.call(e, n) && (r[n] = e[n]);
                        return r;
                    })(r, [
                        "schema"
                    ]), i = (o.level || 0) + 1;
                    if (!n) return e.createElement("em", null, " Schema not provided ");
                    const { type: s, oneOf: a, discriminatorProp: l, isCircular: c } = n;
                    if (c) return e.createElement(Al, {
                        schema: n
                    });
                    if (void 0 !== l) {
                        if (!a || !a.length) return console.warn(`Looks like you are using discriminator wrong: you don't have any definition inherited from the ${n.title}`), null;
                        const t = a[n.activeOneOf];
                        return t.isCircular ? e.createElement(Al, {
                            schema: t
                        }) : e.createElement(ll, ql(Ml({}, o), {
                            level: i,
                            schema: t,
                            discriminator: {
                                fieldName: l,
                                parentSchema: n
                            }
                        }));
                    }
                    if (void 0 !== a) return e.createElement(Il, Ml({
                        schema: n
                    }, o));
                    const p = I(s) ? s : [
                        s
                    ];
                    if (p.includes("object")) {
                        if (null == (t = n.fields) ? void 0 : t.length) return e.createElement(ll, ql(Ml({}, this.props), {
                            level: i
                        }));
                    } else if (p.includes("array")) return e.createElement(xl, ql(Ml({}, this.props), {
                        level: i
                    }));
                    const u = {
                        schema: n,
                        name: "",
                        required: !1,
                        description: n.description,
                        externalDocs: n.externalDocs,
                        deprecated: !1,
                        toggle: ()=>null,
                        expanded: !1
                    };
                    return e.createElement("div", null, e.createElement(el, {
                        field: u
                    }));
                }
            };
            Fl = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], Fl);
            var Bl = Object.defineProperty, Ql = Object.defineProperties, Ul = Object.getOwnPropertyDescriptors, Wl = Object.getOwnPropertySymbols, Vl = Object.prototype.hasOwnProperty, Hl = Object.prototype.propertyIsEnumerable, Jl = (e, t, r)=>t in e ? Bl(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r;
            class Yl extends e.PureComponent {
                constructor(){
                    super(...arguments), this.renderDropdown = (t)=>{
                        var r;
                        return e.createElement(Os, (r = ((e, t)=>{
                            for(var r in t || (t = {}))Vl.call(t, r) && Jl(e, r, t[r]);
                            if (Wl) for (var r of Wl(t))Hl.call(t, r) && Jl(e, r, t[r]);
                            return e;
                        })({
                            Label: ys,
                            Dropdown: ma
                        }, t), Ql(r, Ul({
                            variant: "dark"
                        }))));
                    };
                }
                static getMediaType(e, t) {
                    if (!e) return {};
                    const r = {
                        schema: {
                            $ref: e
                        }
                    };
                    return t && (r.examples = {
                        example: {
                            $ref: t
                        }
                    }), r;
                }
                get mediaModel() {
                    const { parser: e, schemaRef: t, exampleRef: r, options: n } = this.props;
                    return this._mediaModel || (this._mediaModel = new Zn(e, "json", !1, Yl.getMediaType(t, r), n)), this._mediaModel;
                }
                render() {
                    const { showReadOnly: t = !0, showWriteOnly: r = !1, showExample: n = !0 } = this.props;
                    return e.createElement(ui, null, e.createElement(mi, null, e.createElement(pi, null, e.createElement(Fl, {
                        skipWriteOnly: !r,
                        skipReadOnly: !t,
                        schema: this.mediaModel.schema
                    })), n && e.createElement(hi, null, e.createElement(Gl, null, e.createElement(ga, {
                        renderDropdown: this.renderDropdown,
                        mediaType: this.mediaModel
                    })))));
                }
            }
            const Gl = ee.div`
  background: ${({ theme: e })=>e.codeBlock.backgroundColor};
  & > div,
  & > pre {
    padding: ${(e)=>4 * e.theme.spacing.unit}px;
    margin: 0;
  }

  & > div > pre {
    padding: 0;
  }
`, Zl = (H().div`
  background-color: #e4e7eb;
`, H().ul`
  display: inline;
  list-style: none;
  padding: 0;

  li {
    display: inherit;

    &:after {
      content: ',';
    }
    &:last-child:after {
      content: none;
    }
  }
`, H().code`
  font-size: ${(e)=>e.theme.typography.code.fontSize};
  font-family: ${(e)=>e.theme.typography.code.fontFamily};
  margin: 0 3px;
  padding: 0.2em;
  display: inline-block;
  line-height: 1;

  &:after {
    content: ',';
    font-weight: normal;
  }

  &:last-child:after {
    content: none;
  }
`), Xl = H().span`
  &:after {
    content: ' and ';
    font-weight: normal;
  }

  &:last-child:after {
    content: none;
  }

  ${Ss};
`, Kl = H().span`
  ${(e)=>!e.$expanded && "white-space: nowrap;"}
  &:after {
    content: ' or ';
    ${(e)=>e.$expanded && "content: ' or \\a';"}
    white-space: pre;
  }

  &:last-child:after,
  &:only-child:after {
    content: none;
  }

  ${Ss};
`, ec = H().div`
  flex: 1 1 auto;
  cursor: pointer;
`, tc = H().div`
  width: ${(e)=>e.theme.schema.defaultDetailsWidth};
  text-overflow: ellipsis;
  border-radius: 4px;
  overflow: hidden;
  ${(e)=>e.$expanded && `background: ${e.theme.colors.gray[100]};\n     padding: 8px 9.6px;\n     margin: 20px 0;\n     width: 100%;\n    `};
  ${K.lessThan("small")`
    margin-top: 10px;
  `}
`, rc = H()(wi)`
  display: inline-block;
  margin: 0;
`, nc = H().div`
  width: 100%;
  display: flex;
  margin: 1em 0;
  flex-direction: ${(e)=>e.$expanded ? "column" : "row"};
  ${K.lessThan("small")`
    flex-direction: column;
  `}
`, oc = H().div`
  margin: 0.5em 0;
`, ic = H().div`
  border-bottom: 1px solid ${({ theme: e })=>e.colors.border.dark};
  margin-bottom: 1.5em;
  padding-bottom: 0.7em;

  h5 {
    line-height: 1em;
    margin: 0 0 0.6em;
    font-size: ${({ theme: e })=>e.typography.fontSize};
  }

  .redoc-markdown p:first-child {
    display: inline;
  }
`;
            function sc({ children: t, height: r }) {
                const n = e.createRef(), [o, i] = e.useState(!1), [s, a] = e.useState(!1);
                return e.useEffect(()=>{
                    n.current && n.current.clientHeight + 20 < n.current.scrollHeight && a(!0);
                }, [
                    n
                ]), e.createElement(e.Fragment, null, e.createElement(ac, {
                    ref: n,
                    className: o ? "" : "container",
                    style: {
                        height: o ? "auto" : r
                    }
                }, t), e.createElement(lc, {
                    $dimmed: !o
                }, s && e.createElement(cc, {
                    onClick: ()=>{
                        i(!o);
                    }
                }, o ? "See less" : "See more")));
            }
            const ac = H().div`
  overflow-y: hidden;
`, lc = H().div`
  text-align: center;
  line-height: 1.5em;
  ${({ $dimmed: e })=>e && "background-image: linear-gradient(to bottom, transparent,rgb(255 255 255));\n     position: relative;\n     top: -0.5em;\n     padding-top: 0.5em;\n     background-position-y: -1em;\n    "}
`, cc = H().a`
  cursor: pointer;
`, pc = e.memo(function(t) {
                const { type: r, flow: n, RequiredScopes: o } = t, i = Object.keys((null == n ? void 0 : n.scopes) || {});
                return e.createElement(e.Fragment, null, e.createElement(oc, null, e.createElement("b", null, "Flow type: "), e.createElement("code", null, r, " ")), ("implicit" === r || "authorizationCode" === r) && e.createElement(oc, null, e.createElement("strong", null, " Authorization URL: "), e.createElement("code", null, e.createElement("a", {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: n.authorizationUrl
                }, n.authorizationUrl))), ("password" === r || "clientCredentials" === r || "authorizationCode" === r) && e.createElement(oc, null, e.createElement("b", null, " Token URL: "), e.createElement("code", null, n.tokenUrl)), n.refreshUrl && e.createElement(oc, null, e.createElement("strong", null, " Refresh URL: "), e.createElement("code", null, n.refreshUrl)), !!i.length && e.createElement(e.Fragment, null, o || null, e.createElement(oc, null, e.createElement("b", null, " Scopes: ")), e.createElement(sc, {
                    height: "4em"
                }, e.createElement("ul", null, i.map((t)=>e.createElement("li", {
                        key: t
                    }, e.createElement("code", null, t), " -", " ", e.createElement(Ms, {
                        className: "redoc-markdown",
                        inline: !0,
                        source: n.scopes[t] || ""
                    })))))));
            });
            function uc(t) {
                const { RequiredScopes: r, scheme: n } = t;
                return e.createElement(Cs, null, n.apiKey ? e.createElement(e.Fragment, null, e.createElement(oc, null, e.createElement("b", null, j(n.apiKey.in || ""), " parameter name: "), e.createElement("code", null, n.apiKey.name)), r) : n.http ? e.createElement(e.Fragment, null, e.createElement(oc, null, e.createElement("b", null, "HTTP Authorization Scheme: "), e.createElement("code", null, n.http.scheme)), e.createElement(oc, null, "bearer" === n.http.scheme && n.http.bearerFormat && e.createElement(e.Fragment, null, e.createElement("b", null, "Bearer format: "), e.createElement("code", null, n.http.bearerFormat))), r) : n.openId ? e.createElement(e.Fragment, null, e.createElement(oc, null, e.createElement("b", null, "Connect URL: "), e.createElement("code", null, e.createElement("a", {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: n.openId.connectUrl
                }, n.openId.connectUrl))), r) : n.flows ? Object.keys(n.flows).map((t)=>e.createElement(pc, {
                        key: t,
                        type: t,
                        RequiredScopes: r,
                        flow: n.flows[t]
                    })) : null);
            }
            const dc = {
                oauth2: "OAuth2",
                apiKey: "API Key",
                http: "HTTP",
                openIdConnect: "OpenID Connect"
            };
            class hc extends e.PureComponent {
                render() {
                    return this.props.securitySchemes.schemes.map((t)=>e.createElement(ui, {
                            id: t.sectionId,
                            key: t.id
                        }, e.createElement(mi, null, e.createElement(pi, null, e.createElement(bi, null, e.createElement(Ii, {
                            to: t.sectionId
                        }), t.displayName), e.createElement(Ms, {
                            source: t.description || ""
                        }), e.createElement(ic, null, e.createElement(oc, null, e.createElement("b", null, "Security Scheme Type: "), e.createElement("span", null, dc[t.type] || t.type)), e.createElement(uc, {
                            scheme: t
                        }))))));
                }
            }
            var mc = (e, t, r)=>new Promise((n, o)=>{
                    var i = (e)=>{
                        try {
                            a(r.next(e));
                        } catch (e) {
                            o(e);
                        }
                    }, s = (e)=>{
                        try {
                            a(r.throw(e));
                        } catch (e) {
                            o(e);
                        }
                    }, a = (e)=>e.done ? n(e.value) : Promise.resolve(e.value).then(i, s);
                    a((r = r.apply(e, t)).next());
                });
            function fc(e, t) {
                return mc(this, arguments, function*(e, t, r = {}) {
                    const n = yield ye(e || t);
                    return new gc(n, t, r);
                });
            }
            class gc {
                constructor(e, t, r = {}, n = !0){
                    this.marker = new Ht, this.disposer = null, this.rawOptions = r, this.options = new W(r, yc), this.scroll = new li(this.options), oi.updateOnHistory(Wt.currentId, this.scroll), this.spec = new No(e, t, this.options), this.menu = new oi(this.spec, this.scroll, Wt), this.options.disableSearch || (this.search = new ci, n && this.search.indexItems(this.menu.items), this.disposer = (0, de.observe)(this.menu, "activeItemIdx", (e)=>{
                        this.updateMarkOnMenu(e.newValue);
                    }));
                }
                static fromJS(e) {
                    const t = new gc(e.spec.data, e.spec.url, e.options, !1);
                    return t.menu.activeItemIdx = e.menu.activeItemIdx || 0, t.menu.activate(t.menu.flatItems[t.menu.activeItemIdx]), t.options.disableSearch || t.search.load(e.searchIndex), t;
                }
                onDidMount() {
                    this.menu.updateOnHistory(), this.updateMarkOnMenu(this.menu.activeItemIdx);
                }
                dispose() {
                    this.scroll.dispose(), this.menu.dispose(), this.search && this.search.dispose(), null != this.disposer && this.disposer();
                }
                toJS() {
                    return mc(this, null, function*() {
                        return {
                            menu: {
                                activeItemIdx: this.menu.activeItemIdx
                            },
                            spec: {
                                url: this.spec.parser.specUrl,
                                data: this.spec.parser.spec
                            },
                            searchIndex: this.search ? yield this.search.toJS() : void 0,
                            options: this.rawOptions
                        };
                    });
                }
                updateMarkOnMenu(e) {
                    const t = Math.max(0, e), r = Math.min(this.menu.flatItems.length, t + 5), n = [];
                    for(let e = t; e < r; e++){
                        const t = this.menu.getElementAt(e);
                        t && n.push(t);
                    }
                    if (-1 === e && s) {
                        const e = document.querySelector('[data-role="redoc-description"]'), t = document.querySelector('[data-role="redoc-summary"]');
                        e && n.push(e), t && n.push(t);
                    }
                    this.marker.addOnly(n), this.marker.mark();
                }
            }
            const yc = {
                allowedMdComponents: {
                    [dt]: {
                        component: hc,
                        propsSelector: (e)=>({
                                securitySchemes: e.spec.securitySchemes
                            })
                    },
                    [ht]: {
                        component: hc,
                        propsSelector: (e)=>({
                                securitySchemes: e.spec.securitySchemes
                            })
                    },
                    [mt]: {
                        component: Yl,
                        propsSelector: (e)=>({
                                parser: e.spec.parser,
                                options: e.options
                            })
                    }
                }
            }, bc = ee(yi)`
  margin-top: 0;
  margin-bottom: 0.5em;

  ${te("ApiHeader")};
`, xc = ee.a`
  border: 1px solid ${(e)=>e.theme.colors.primary.main};
  color: ${(e)=>e.theme.colors.primary.main};
  font-weight: normal;
  margin-left: 0.5em;
  padding: 4px 8px 4px;
  display: inline-block;
  text-decoration: none;
  cursor: pointer;

  ${te("DownloadButton")};
`, vc = ee.span`
  &::before {
    content: '|';
    display: inline-block;
    opacity: 0.5;
    width: ${15}px;
    text-align: center;
  }

  &:last-child::after {
    display: none;
  }
`, wc = ee.div`
  overflow: hidden;
`, kc = ee.div`
  display: flex;
  flex-wrap: wrap;
  // hide separator on new lines: idea from https://stackoverflow.com/a/31732902/1749888
  margin-left: -${15}px;
`;
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let Ec = class extends e.Component {
                render() {
                    const { store: t } = this.props, { info: r, externalDocs: n } = t.spec, o = t.options.hideDownloadButtons, i = r.downloadUrls, s = r.downloadFileName, a = r.license && e.createElement(vc, null, "License:", " ", r.license.identifier ? r.license.identifier : e.createElement("a", {
                        href: r.license.url
                    }, r.license.name)) || null, l = r.contact && r.contact.url && e.createElement(vc, null, "URL: ", e.createElement("a", {
                        href: r.contact.url
                    }, r.contact.url)) || null, c = r.contact && r.contact.email && e.createElement(vc, null, r.contact.name || "E-mail", ":", " ", e.createElement("a", {
                        href: "mailto:" + r.contact.email
                    }, r.contact.email)) || null, p = r.termsOfService && e.createElement(vc, null, e.createElement("a", {
                        href: r.termsOfService
                    }, "Terms of Service")) || null, u = r.version && e.createElement("span", null, "(", r.version, ")") || null;
                    return e.createElement(ui, null, e.createElement(mi, null, e.createElement(pi, {
                        className: "api-info"
                    }, e.createElement(bc, null, r.title, " ", u), !o && e.createElement("p", null, _("downloadSpecification"), ":", null == i ? void 0 : i.map(({ title: t, url: r })=>e.createElement(xc, {
                            download: s || !0,
                            target: "_blank",
                            href: r,
                            rel: "noreferrer",
                            key: r
                        }, t))), e.createElement(Cs, null, (r.license || r.contact || r.termsOfService) && e.createElement(wc, null, e.createElement(kc, null, c, " ", l, " ", a, " ", p)) || null), e.createElement(Ms, {
                        source: t.spec.info.summary,
                        "data-role": "redoc-summary"
                    }), e.createElement(Ms, {
                        source: t.spec.info.description,
                        "data-role": "redoc-description"
                    }), n && e.createElement(Ra, {
                        externalDocs: n
                    }))));
                }
            };
            Ec = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], Ec);
            const Oc = ee.img`
  max-height: ${(e)=>e.theme.logo.maxHeight};
  max-width: ${(e)=>e.theme.logo.maxWidth};
  padding: ${(e)=>e.theme.logo.gutter};
  width: 100%;
  display: block;
`, jc = ee.div`
  text-align: center;
`, $c = ee.a`
  display: inline-block;
`;
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let Sc = class extends e.Component {
                render() {
                    const { info: t } = this.props, r = t["x-logo"];
                    if (!r || !r.url) return null;
                    const n = r.href || t.contact && t.contact.url, o = r.altText ? r.altText : "logo", i = e.createElement(Oc, {
                        src: r.url,
                        alt: o
                    });
                    var s;
                    return e.createElement(jc, {
                        style: {
                            backgroundColor: r.backgroundColor
                        }
                    }, n ? (s = n, (t)=>e.createElement($c, {
                            href: s
                        }, t))(i) : i);
                }
            };
            Sc = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], Sc);
            var Cc = Object.defineProperty, Pc = Object.getOwnPropertySymbols, Ic = Object.prototype.hasOwnProperty, Ac = Object.prototype.propertyIsEnumerable, Tc = (e, t, r)=>t in e ? Cc(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, _c = (e, t)=>{
                for(var r in t || (t = {}))Ic.call(t, r) && Tc(e, r, t[r]);
                if (Pc) for (var r of Pc(t))Ac.call(t, r) && Tc(e, r, t[r]);
                return e;
            };
            class Rc extends e.Component {
                render() {
                    return e.createElement(ue, null, (t)=>e.createElement(ji, null, (e)=>this.renderWithOptionsAndStore(t, e)));
                }
                renderWithOptionsAndStore(t, r) {
                    const { source: n, htmlWrap: o = (e)=>e } = this.props;
                    if (!r) throw new Error("When using components in markdown, store prop must be provided");
                    const i = new Wr(t, this.props.parentId).renderMdWithComponents(n);
                    return i.length ? i.map((t, n)=>{
                        if ("string" == typeof t) return e.cloneElement(o(e.createElement(Ns, {
                            html: t,
                            inline: !1,
                            compact: !1
                        })), {
                            key: n
                        });
                        const i = t.component;
                        return e.createElement(i, _c({
                            key: n
                        }, _c(_c({}, t.props), t.propsSelector(r))));
                    }) : null;
                }
            }
            var Dc = (parcelRequire("8g1PZ"));
            const zc = ee.span.attrs((e)=>({
                    className: `operation-type ${e.type}`
                }))`
  width: 9ex;
  display: inline-block;
  height: ${(e)=>e.theme.typography.code.fontSize};
  line-height: ${(e)=>e.theme.typography.code.fontSize};
  background-color: ${(e)=>e.color || "#333"};
  border-radius: 3px;
  background-repeat: no-repeat;
  background-position: 6px 4px;
  font-size: 7px;
  font-family: Verdana, sans-serif; // web-safe
  color: white;
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
  vertical-align: middle;
  margin-right: 6px;
  margin-top: 2px;

  &.get {
    background-color: ${({ theme: e })=>e.colors.http.get};
  }

  &.post {
    background-color: ${({ theme: e })=>e.colors.http.post};
  }

  &.put {
    background-color: ${({ theme: e })=>e.colors.http.put};
  }

  &.options {
    background-color: ${({ theme: e })=>e.colors.http.options};
  }

  &.patch {
    background-color: ${({ theme: e })=>e.colors.http.patch};
  }

  &.delete {
    background-color: ${({ theme: e })=>e.colors.http.delete};
  }

  &.basic {
    background-color: ${({ theme: e })=>e.colors.http.basic};
  }

  &.link {
    background-color: ${({ theme: e })=>e.colors.http.link};
  }

  &.head {
    background-color: ${({ theme: e })=>e.colors.http.head};
  }

  &.hook {
    background-color: ${({ theme: e })=>e.colors.primary.main};
  }

  &.schema {
    background-color: ${({ theme: e })=>e.colors.http.basic};
  }
`;
            function Lc(e, { theme: t }, r) {
                return e > 1 ? t.sidebar.level1Items[r] : 1 === e ? t.sidebar.groupItems[r] : "";
            }
            const Nc = ee.ul`
  margin: 0;
  padding: 0;

  &:first-child {
    padding-bottom: 32px;
  }

  & & {
    font-size: 0.929em;
  }

  ${(e)=>e.$expanded ? "" : "display: none;"};
`, Mc = ee.li`
  list-style: none inside none;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0;
  ${(e)=>0 === e.depth ? "margin-top: 15px" : ""};
`, qc = {
                0: Y`
    opacity: 0.7;
    text-transform: ${({ theme: e })=>e.sidebar.groupItems.textTransform};
    font-size: 0.8em;
    padding-bottom: 0;
    cursor: default;
  `,
                1: Y`
    font-size: 0.929em;
    text-transform: ${({ theme: e })=>e.sidebar.level1Items.textTransform};
  `
            }, Fc = ee.label.attrs((e)=>({
                    className: Dc("-depth" + e.$depth, {
                        active: e.$active
                    })
                }))`
  cursor: pointer;
  color: ${(e)=>e.$active ? Lc(e.$depth, e, "activeTextColor") : e.theme.sidebar.textColor};
  margin: 0;
  padding: 12.5px ${(e)=>4 * e.theme.spacing.unit}px;
  ${({ $depth: e, $type: t, theme: r })=>"section" === t && e > 1 && "padding-left: " + 8 * r.spacing.unit + "px;" || ""}
  display: flex;
  justify-content: space-between;
  font-family: ${(e)=>e.theme.typography.headings.fontFamily};
  ${(e)=>qc[e.$depth]};
  background-color: ${(e)=>e.$active ? Lc(e.$depth, e, "activeBackgroundColor") : e.theme.sidebar.backgroundColor};

  ${(e)=>e.$deprecated && Ri || ""};

  &:hover {
    color: ${(e)=>Lc(e.$depth, e, "activeTextColor")};
    background-color: ${(e)=>Lc(e.$depth, e, "activeBackgroundColor")};
  }

  ${Ti} {
    height: ${({ theme: e })=>e.sidebar.arrow.size};
    width: ${({ theme: e })=>e.sidebar.arrow.size};
    polygon {
      fill: ${({ theme: e })=>e.sidebar.arrow.color};
    }
  }
`, Bc = ee.span`
  display: inline-block;
  vertical-align: middle;
  width: ${(e)=>e.width ? e.width : "auto"};
  overflow: hidden;
  text-overflow: ellipsis;
`, Qc = ee.div`
  ${({ theme: e })=>Y`
    font-size: 0.8em;
    margin-top: ${2 * e.spacing.unit}px;
    text-align: center;
    position: fixed;
    width: ${e.sidebar.width};
    bottom: 0;
    background: ${e.sidebar.backgroundColor};

    a,
    a:visited,
    a:hover {
      color: ${e.sidebar.textColor} !important;
      padding: ${e.spacing.unit}px 0;
      border-top: 1px solid ${(0, t.darken)(.1, e.sidebar.backgroundColor)};
      text-decoration: none;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `};
  img {
    width: 15px;
    margin-right: 5px;
  }

  ${K.lessThan("small")`
    width: 100%;
  `};
`, Uc = ee.button`
  border: 0;
  width: 100%;
  text-align: left;
  & > * {
    vertical-align: middle;
  }

  ${Ti} {
    polygon {
      fill: ${({ theme: e })=>(0, t.darken)(e.colors.tonalOffset, e.colors.gray[100])};
    }
  }
`, Wc = ee.span`
  text-decoration: ${(e)=>e.$deprecated ? "line-through" : "none"};
  margin-right: 8px;
`, Vc = ee(zc)`
  margin: 0 5px 0 0;
`, Hc = ee((t)=>{
                const { name: r, opened: n, className: o, onClick: i, httpVerb: s, deprecated: a } = t;
                return e.createElement(Uc, {
                    className: o,
                    onClick: i || void 0
                }, e.createElement(Vc, {
                    type: s
                }, yt(s)), e.createElement(Ti, {
                    size: "1.5em",
                    direction: n ? "down" : "right",
                    float: "left"
                }), e.createElement(Wc, {
                    $deprecated: a
                }, r), a ? e.createElement(_i, {
                    type: "warning"
                }, " ", _("deprecated"), " ") : null);
            })`
  padding: 10px;
  border-radius: 2px;
  margin-bottom: 4px;
  line-height: 1.5em;
  background-color: ${({ theme: e })=>e.colors.gray[100]};
  cursor: pointer;
  outline-color: ${({ theme: e })=>(0, t.darken)(e.colors.tonalOffset, e.colors.gray[100])};
`, Jc = ee.div`
  padding: 10px 25px;
  background-color: ${({ theme: e })=>e.colors.gray[50]};
  margin-bottom: 5px;
  margin-top: 5px;
`;
            class Yc extends e.PureComponent {
                constructor(){
                    super(...arguments), this.selectElement = ()=>{
                        Hs.selectElement(this.child);
                    };
                }
                render() {
                    const { children: t } = this.props;
                    return e.createElement("div", {
                        ref: (e)=>this.child = e,
                        onClick: this.selectElement,
                        onFocus: this.selectElement,
                        tabIndex: 0,
                        role: "button"
                    }, t);
                }
            }
            const Gc = ee.div`
  cursor: pointer;
  position: relative;
  margin-bottom: 5px;
`, Zc = ee.span`
  font-family: ${(e)=>e.theme.typography.code.fontFamily};
  margin-left: 10px;
  flex: 1;
  overflow-x: hidden;
  text-overflow: ellipsis;
`, Xc = ee.button`
  outline: 0;
  color: inherit;
  width: 100%;
  text-align: left;
  cursor: pointer;
  padding: 10px 30px 10px ${(e)=>e.$inverted ? "10px" : "20px"};
  border-radius: ${(e)=>e.$inverted ? "0" : "4px 4px 0 0"};
  background-color: ${(e)=>e.$inverted ? "transparent" : e.theme.codeBlock.backgroundColor};
  display: flex;
  white-space: nowrap;
  align-items: center;
  border: ${(e)=>e.$inverted ? "0" : "1px solid transparent"};
  border-bottom: ${(e)=>e.$inverted ? "1px solid #ccc" : "0"};
  transition: border-color 0.25s ease;

  ${(e)=>e.$expanded && !e.$inverted && `border-color: ${e.theme.colors.border.dark};` || ""}

  .${Zc} {
    color: ${(e)=>e.$inverted ? e.theme.colors.text.primary : "#ffffff"};
  }
  &:focus {
    box-shadow: inset 0 2px 2px rgba(0, 0, 0, 0.45), 0 2px 0 rgba(128, 128, 128, 0.25);
  }
`, Kc = ee.span.attrs((e)=>({
                    className: `http-verb ${e.type}`
                }))`
  font-size: ${(e)=>e.$compact ? "0.8em" : "0.929em"};
  line-height: ${(e)=>e.$compact ? "18px" : "20px"};
  background-color: ${(e)=>e.theme.colors.http[e.type] || "#999999"};
  color: #ffffff;
  padding: ${(e)=>e.$compact ? "2px 8px" : "3px 10px"};
  text-transform: uppercase;
  font-family: ${(e)=>e.theme.typography.headings.fontFamily};
  margin: 0;
`, ep = ee.div`
  position: absolute;
  width: 100%;
  z-index: 100;
  background: ${(e)=>e.theme.rightPanel.servers.overlay.backgroundColor};
  color: ${(e)=>e.theme.rightPanel.servers.overlay.textColor};
  box-sizing: border-box;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.33);
  overflow: hidden;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  transition: all 0.25s ease;
  visibility: hidden;
  ${(e)=>e.$expanded ? "visibility: visible;" : "transform: translateY(-50%) scaleY(0);"}
`, tp = ee.div`
  padding: 10px;
`, rp = ee.div`
  padding: 5px;
  border: 1px solid #ccc;
  background: ${(e)=>e.theme.rightPanel.servers.url.backgroundColor};
  word-break: break-all;
  color: ${(e)=>e.theme.colors.primary.main};
  > span {
    color: ${(e)=>e.theme.colors.text.primary};
  }
`;
            class np extends e.Component {
                constructor(e){
                    super(e), this.toggle = ()=>{
                        this.setState({
                            expanded: !this.state.expanded
                        });
                    }, this.state = {
                        expanded: !1
                    };
                }
                render() {
                    const { operation: t, inverted: r, hideHostname: n } = this.props, { expanded: o } = this.state;
                    return e.createElement(ce.Consumer, null, (i)=>e.createElement(Gc, null, e.createElement(Xc, {
                            onClick: this.toggle,
                            $expanded: o,
                            $inverted: r
                        }, e.createElement(Kc, {
                            type: t.httpVerb,
                            $compact: this.props.compact
                        }, t.httpVerb), e.createElement(Zc, null, t.path), e.createElement(Ti, {
                            float: "right",
                            color: r ? "black" : "white",
                            size: "20px",
                            direction: o ? "up" : "down",
                            style: {
                                marginRight: "-25px"
                            }
                        })), e.createElement(ep, {
                            $expanded: o,
                            "aria-hidden": !o
                        }, t.servers.map((r)=>{
                            const o = i.expandDefaultServerVariables ? pt(r.url, r.variables) : r.url, s = O(o);
                            return e.createElement(tp, {
                                key: o
                            }, e.createElement(Ms, {
                                source: r.description || "",
                                compact: !0
                            }), e.createElement(Yc, null, e.createElement(rp, null, e.createElement("span", null, n || i.hideHostname ? "/" === s ? "" : s : o), t.path)));
                        }))));
                }
            }
            class op extends e.PureComponent {
                render() {
                    const { place: t, parameters: r } = this.props;
                    return r && r.length ? e.createElement("div", {
                        key: t
                    }, e.createElement(wi, null, t, " Parameters"), e.createElement(Bi, null, e.createElement("tbody", null, d(r, (t, r)=>e.createElement(sl, {
                            key: t.name,
                            isLast: r,
                            field: t,
                            showExamples: !0
                        }))))) : null;
                }
            }
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let ip = class extends e.Component {
                constructor(){
                    super(...arguments), this.switchMedia = ({ idx: e })=>{
                        this.props.content && void 0 !== e && this.props.content.activate(e);
                    };
                }
                render() {
                    const { content: t } = this.props;
                    if (!t || !t.mediaTypes || !t.mediaTypes.length) return null;
                    const r = t.activeMimeIdx, n = t.mediaTypes.map((e, t)=>({
                            value: e.name,
                            idx: t
                        })), o = ({ children: t })=>this.props.withLabel ? e.createElement(ha, null, e.createElement(da, null, "Content type"), t) : t;
                    return e.createElement(e.Fragment, null, e.createElement(o, null, this.props.renderDropdown({
                        value: n[r].value,
                        options: n,
                        onChange: this.switchMedia,
                        ariaLabel: "Content type"
                    })), this.props.children(t.active));
                }
            };
            ip = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], ip);
            var sp = Object.defineProperty, ap = Object.getOwnPropertySymbols, lp = Object.prototype.hasOwnProperty, cp = Object.prototype.propertyIsEnumerable, pp = (e, t, r)=>t in e ? sp(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, up = (e, t)=>{
                for(var r in t || (t = {}))lp.call(t, r) && pp(e, r, t[r]);
                if (ap) for (var r of ap(t))cp.call(t, r) && pp(e, r, t[r]);
                return e;
            }, dp = (e, t)=>{
                var r = {};
                for(var n in e)lp.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                if (null != e && ap) for (var n of ap(e))t.indexOf(n) < 0 && cp.call(e, n) && (r[n] = e[n]);
                return r;
            };
            const hp = [
                "path",
                "query",
                "cookie",
                "header"
            ];
            class mp extends e.PureComponent {
                orderParams(e) {
                    const t = {};
                    return e.forEach((e)=>{
                        var r, n, o;
                        o = e, (r = t)[n = e.in] || (r[n] = []), r[n].push(o);
                    }), t;
                }
                render() {
                    const { body: t, parameters: r = [] } = this.props;
                    if (void 0 === t && void 0 === r) return null;
                    const n = this.orderParams(r), o = r.length > 0 ? hp : [], i = t && t.content, s = t && t.description, a = t && t.required;
                    return e.createElement(e.Fragment, null, o.map((t)=>e.createElement(op, {
                            key: t,
                            place: t,
                            parameters: n[t]
                        })), i && e.createElement(gp, {
                        content: i,
                        description: s,
                        bodyRequired: a
                    }));
                }
            }
            function fp(t) {
                var r = t, { bodyRequired: n } = r, o = dp(r, [
                    "bodyRequired"
                ]);
                const i = "boolean" == typeof n && !!n, s = "boolean" == typeof n && !n;
                return e.createElement(wi, {
                    key: "header"
                }, "Request Body schema: ", e.createElement(Os, up({}, o)), i && e.createElement(bp, null, "required"), s && e.createElement(xp, null, "optional"));
            }
            function gp(t) {
                const { content: r, description: n, bodyRequired: o } = t, { isRequestType: i } = r;
                return e.createElement(ip, {
                    content: r,
                    renderDropdown: (t)=>e.createElement(fp, up({
                            bodyRequired: o
                        }, t))
                }, ({ schema: t })=>e.createElement(e.Fragment, null, void 0 !== n && e.createElement(Ms, {
                        source: n
                    }), "object" === (null == t ? void 0 : t.type) && e.createElement(Ba, {
                        constraints: (null == t ? void 0 : t.constraints) || []
                    }), e.createElement(Fl, {
                        skipReadOnly: i,
                        skipWriteOnly: !i,
                        key: "schema",
                        schema: t
                    })));
            }
            const yp = "\n  text-transform: lowercase;\n  margin-left: 0;\n  line-height: 1.5em;\n", bp = ee(ja)`
  ${yp}
`, xp = ee("div")`
  ${yp}
  color: ${({ theme: e })=>e.colors.text.secondary};
  font-size: ${(e)=>e.theme.schema.labelsTextSize};
`, vp = e.memo(function({ title: t, type: r, empty: n, code: o, opened: i, className: s, onClick: a }) {
                return e.createElement("button", {
                    className: s,
                    onClick: !n && a || void 0,
                    "aria-expanded": i,
                    disabled: n
                }, !n && e.createElement(Ti, {
                    size: "1.5em",
                    color: r,
                    direction: i ? "down" : "right",
                    float: "left"
                }), e.createElement(Op, null, o, " "), e.createElement(Ms, {
                    compact: !0,
                    inline: !0,
                    source: t
                }));
            }), wp = ee(vp)`
  display: block;
  border: 0;
  width: 100%;
  text-align: left;
  padding: 10px;
  border-radius: 2px;
  margin-bottom: 4px;
  line-height: 1.5em;
  cursor: pointer;

  color: ${(e)=>e.theme.colors.responses[e.type].color};
  background-color: ${(e)=>e.theme.colors.responses[e.type].backgroundColor};
  &:focus {
    outline: auto ${(e)=>e.theme.colors.responses[e.type].color};
  }
  ${(e)=>e.empty ? '\ncursor: default;\n&::before {\n  content: "\u2014";\n  font-weight: bold;\n  width: 1.5em;\n  text-align: center;\n  display: inline-block;\n  vertical-align: top;\n}\n&:focus {\n  outline: 0;\n}\n' : ""};
`, kp = ee.div`
  padding: 10px;
`, Ep = ee(wi).attrs({
                as: "caption"
            })`
  text-align: left;
  margin-top: 1em;
  caption-side: top;
`, Op = ee.strong`
  vertical-align: top;
`;
            class jp extends e.PureComponent {
                render() {
                    const { headers: t } = this.props;
                    return void 0 === t || 0 === t.length ? null : e.createElement(Bi, null, e.createElement(Ep, null, " Response Headers "), e.createElement("tbody", null, d(t, (t, r)=>e.createElement(sl, {
                            isLast: r,
                            key: t.name,
                            field: t,
                            showExamples: !0
                        }))));
                }
            }
            var $p = Object.defineProperty, Sp = Object.getOwnPropertySymbols, Cp = Object.prototype.hasOwnProperty, Pp = Object.prototype.propertyIsEnumerable, Ip = (e, t, r)=>t in e ? $p(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r;
            class Ap extends e.PureComponent {
                constructor(){
                    super(...arguments), this.renderDropdown = (t)=>e.createElement(wi, {
                            key: "header"
                        }, "Response Schema: ", e.createElement(Os, ((e, t)=>{
                            for(var r in t || (t = {}))Cp.call(t, r) && Ip(e, r, t[r]);
                            if (Sp) for (var r of Sp(t))Pp.call(t, r) && Ip(e, r, t[r]);
                            return e;
                        })({}, t)));
                }
                render() {
                    const { description: t, extensions: r, headers: n, content: o } = this.props.response;
                    return e.createElement(e.Fragment, null, t && e.createElement(Ms, {
                        source: t
                    }), e.createElement(Ma, {
                        extensions: r
                    }), e.createElement(jp, {
                        headers: n
                    }), e.createElement(ip, {
                        content: o,
                        renderDropdown: this.renderDropdown
                    }, ({ schema: t })=>e.createElement(e.Fragment, null, "object" === (null == t ? void 0 : t.type) && e.createElement(Ba, {
                            constraints: (null == t ? void 0 : t.constraints) || []
                        }), e.createElement(Fl, {
                            skipWriteOnly: !0,
                            key: "schema",
                            schema: t
                        }))));
                }
            }
            const Tp = (0, ba.observer)(({ response: t })=>{
                const { extensions: r, headers: n, type: o, summary: i, description: s, code: a, expanded: l, content: c } = t, p = e.useMemo(()=>void 0 === c ? [] : c.mediaTypes.filter((e)=>void 0 !== e.schema), [
                    c
                ]), u = e.useMemo(()=>!(r && 0 !== Object.keys(r).length || 0 !== n.length || 0 !== p.length || s), [
                    r,
                    n,
                    p,
                    s
                ]);
                return e.createElement("div", null, e.createElement(wp, {
                    onClick: ()=>t.toggle(),
                    type: o,
                    empty: u,
                    title: i || "",
                    code: a,
                    opened: l
                }), l && !u && e.createElement(kp, null, e.createElement(Ap, {
                    response: t
                })));
            }), _p = ee.h3`
  font-size: 1.3em;
  padding: 0.2em 0;
  margin: 3em 0 1.1em;
  color: ${({ theme: e })=>e.colors.text.primary};
  font-weight: normal;
`;
            class Rp extends e.PureComponent {
                render() {
                    const { responses: t, isCallback: r } = this.props;
                    return t && 0 !== t.length ? e.createElement("div", null, e.createElement(_p, null, _(r ? "callbackResponses" : "responses")), t.map((t)=>e.createElement(Tp, {
                            key: t.code,
                            response: t
                        }))) : null;
                }
            }
            function Dp(t) {
                const { security: r, showSecuritySchemeType: n, expanded: o } = t, i = r.schemes.length > 1;
                return 0 === r.schemes.length ? e.createElement(Kl, {
                    $expanded: o
                }, "None") : e.createElement(Kl, {
                    $expanded: o
                }, i && "(", r.schemes.map((t)=>e.createElement(Xl, {
                        key: t.id
                    }, n && `${dc[t.type] || t.type}: `, e.createElement("i", null, t.displayName), o && t.scopes.length ? [
                        " (",
                        t.scopes.map((t)=>e.createElement(Zl, {
                                key: t
                            }, t)),
                        ") "
                    ] : null)), i && ") ");
            }
            const zp = ({ scopes: t })=>t.length ? e.createElement("div", null, e.createElement("b", null, "Required scopes: "), t.map((t, r)=>e.createElement(e.Fragment, {
                        key: r
                    }, e.createElement("code", null, t), " "))) : null;
            function Lp(t) {
                const r = Si(), n = null == r ? void 0 : r.options.showSecuritySchemeType, [o, i] = (0, e.useState)(!1), { securities: s } = t;
                if (!(null == s ? void 0 : s.length) || (null == r ? void 0 : r.options.hideSecuritySection)) return null;
                const a = null == r ? void 0 : r.spec.securitySchemes.schemes.filter(({ id: e })=>s.find((t)=>t.schemes.find((t)=>t.id === e)));
                return e.createElement(e.Fragment, null, e.createElement(nc, {
                    $expanded: o
                }, e.createElement(ec, {
                    onClick: ()=>i(!o)
                }, e.createElement(rc, null, "Authorizations:"), e.createElement(Ti, {
                    size: "1.3em",
                    direction: o ? "down" : "right"
                })), e.createElement(tc, {
                    $expanded: o
                }, s.map((t, r)=>e.createElement(Dp, {
                        key: r,
                        expanded: o,
                        showSecuritySchemeType: n,
                        security: t
                    })))), o && !!(null == a ? void 0 : a.length) && a.map((t, r)=>e.createElement(ic, {
                        key: r
                    }, e.createElement("h5", null, e.createElement(Np, null), " ", dc[t.type] || t.type, ": ", t.id), e.createElement(Ms, {
                        source: t.description || ""
                    }), e.createElement(uc, {
                        key: t.id,
                        scheme: t,
                        RequiredScopes: e.createElement(zp, {
                            scopes: Mp(t.id, s)
                        })
                    }))));
            }
            const Np = ()=>e.createElement("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    width: "11",
                    height: "11"
                }, e.createElement("path", {
                    fill: "currentColor",
                    d: "M18 10V6A6 6 0 0 0 6 6v4H3v14h18V10h-3zM8 6c0-2.206 1.794-4 4-4s4 1.794 4 4v4H8V6zm11 16H5V12h14v10z"
                }));
            function Mp(e, t) {
                const r = [];
                let n = t.length;
                for(; n--;){
                    const o = t[n];
                    let i = o.schemes.length;
                    for(; i--;){
                        const t = o.schemes[i];
                        t.id === e && Array.isArray(t.scopes) && r.push(...t.scopes);
                    }
                }
                return Array.from(new Set(r));
            }
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let qp = class extends e.Component {
                render() {
                    const { operation: t } = this.props, { description: r, externalDocs: n } = t, o = !(!r && !n);
                    return e.createElement(Jc, null, o && e.createElement(Fp, null, void 0 !== r && e.createElement(Ms, {
                        source: r
                    }), n && e.createElement(Ra, {
                        externalDocs: n
                    })), e.createElement(np, {
                        operation: this.props.operation,
                        inverted: !0,
                        compact: !0
                    }), e.createElement(Ma, {
                        extensions: t.extensions
                    }), e.createElement(Lp, {
                        securities: t.security
                    }), e.createElement(mp, {
                        parameters: t.parameters,
                        body: t.requestBody
                    }), e.createElement(Rp, {
                        responses: t.responses,
                        isCallback: t.isCallback
                    }));
                }
            };
            qp = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], qp);
            const Fp = ee.div`
  margin-bottom: ${({ theme: e })=>3 * e.spacing.unit}px;
`;
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let Bp = class extends e.Component {
                constructor(){
                    super(...arguments), this.toggle = ()=>{
                        this.props.callbackOperation.toggle();
                    };
                }
                render() {
                    const { name: t, expanded: r, httpVerb: n, deprecated: o } = this.props.callbackOperation;
                    return e.createElement(e.Fragment, null, e.createElement(Hc, {
                        onClick: this.toggle,
                        name: t,
                        opened: r,
                        httpVerb: n,
                        deprecated: o
                    }), r && e.createElement(qp, {
                        operation: this.props.callbackOperation
                    }));
                }
            };
            Bp = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], Bp);
            class Qp extends e.PureComponent {
                render() {
                    const { callbacks: t } = this.props;
                    return t && 0 !== t.length ? e.createElement("div", null, e.createElement(Up, null, " Callbacks "), t.map((t)=>t.operations.map((r, n)=>e.createElement(Bp, {
                                key: `${t.name}_${n}`,
                                callbackOperation: r
                            })))) : null;
                }
            }
            const Up = ee.h3`
  font-size: 1.3em;
  padding: 0.2em 0;
  margin: 3em 0 1.1em;
  color: ${({ theme: e })=>e.colors.text.primary};
  font-weight: normal;
`;
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let Wp = class extends e.Component {
                constructor(e){
                    super(e), this.switchItem = ({ idx: e })=>{
                        this.props.items && void 0 !== e && this.setState({
                            activeItemIdx: e
                        });
                    }, this.state = {
                        activeItemIdx: 0
                    };
                }
                render() {
                    const { items: t } = this.props;
                    if (!t || !t.length) return null;
                    const r = ({ children: t })=>this.props.label ? e.createElement(ha, null, e.createElement(da, null, this.props.label), t) : t;
                    return e.createElement(e.Fragment, null, e.createElement(r, null, this.props.renderDropdown({
                        value: this.props.options[this.state.activeItemIdx].value,
                        options: this.props.options,
                        onChange: this.switchItem,
                        ariaLabel: this.props.label || "Callback"
                    })), this.props.children(t[this.state.activeItemIdx]));
                }
            };
            Wp = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], Wp);
            var Vp = Object.defineProperty, Hp = Object.defineProperties, Jp = (Object.getOwnPropertyDescriptor, Object.getOwnPropertyDescriptors), Yp = Object.getOwnPropertySymbols, Gp = Object.prototype.hasOwnProperty, Zp = Object.prototype.propertyIsEnumerable, Xp = (e, t, r)=>t in e ? Vp(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r;
            let Kp = class extends e.Component {
                constructor(){
                    super(...arguments), this.renderDropdown = (t)=>{
                        var r;
                        return e.createElement(Os, (r = ((e, t)=>{
                            for(var r in t || (t = {}))Gp.call(t, r) && Xp(e, r, t[r]);
                            if (Yp) for (var r of Yp(t))Zp.call(t, r) && Xp(e, r, t[r]);
                            return e;
                        })({
                            Label: ua,
                            Dropdown: ma
                        }, t), Hp(r, Jp({
                            variant: "dark"
                        }))));
                    };
                }
                render() {
                    const t = this.props.content;
                    return void 0 === t ? null : e.createElement(ip, {
                        content: t,
                        renderDropdown: this.renderDropdown,
                        withLabel: !0
                    }, (t)=>e.createElement(ga, {
                            key: "samples",
                            mediaType: t,
                            renderDropdown: this.renderDropdown
                        }));
                }
            };
            Kp = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], Kp);
            class eu extends e.Component {
                render() {
                    const t = this.props.callback.codeSamples.find((e)=>yo(e));
                    return t ? e.createElement(tu, null, e.createElement(Kp, {
                        content: t.requestBodyContent
                    })) : null;
                }
            }
            const tu = ee.div`
  margin-top: 15px;
`;
            var ru = Object.defineProperty, nu = Object.defineProperties, ou = (Object.getOwnPropertyDescriptor, Object.getOwnPropertyDescriptors), iu = Object.getOwnPropertySymbols, su = Object.prototype.hasOwnProperty, au = Object.prototype.propertyIsEnumerable, lu = (e, t, r)=>t in e ? ru(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r;
            let cu = class extends e.Component {
                constructor(){
                    super(...arguments), this.renderDropdown = (t)=>{
                        var r;
                        return e.createElement(Os, (r = ((e, t)=>{
                            for(var r in t || (t = {}))su.call(t, r) && lu(e, r, t[r]);
                            if (iu) for (var r of iu(t))au.call(t, r) && lu(e, r, t[r]);
                            return e;
                        })({
                            Label: ua,
                            Dropdown: ma
                        }, t), nu(r, ou({
                            variant: "dark"
                        }))));
                    };
                }
                render() {
                    const { callbacks: t } = this.props;
                    if (!t || 0 === t.length) return null;
                    const r = t.map((e)=>e.operations.map((e)=>e)).reduce((e, t)=>e.concat(t), []);
                    if (!r.some((e)=>e.codeSamples.length > 0)) return null;
                    const n = r.map((e, t)=>({
                            value: `${e.httpVerb.toUpperCase()}: ${e.name}`,
                            idx: t
                        }));
                    return e.createElement("div", null, e.createElement(vi, null, " Callback payload samples "), e.createElement(pu, null, e.createElement(Wp, {
                        items: r,
                        renderDropdown: this.renderDropdown,
                        label: "Callback",
                        options: n
                    }, (t)=>e.createElement(eu, {
                            key: "callbackPayloadSample",
                            callback: t,
                            renderDropdown: this.renderDropdown
                        }))));
                }
            };
            cu.contextType = ce, cu = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], cu);
            const pu = ee.div`
  background: ${({ theme: e })=>e.codeBlock.backgroundColor};
  padding: ${(e)=>4 * e.theme.spacing.unit}px;
`;
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let uu = class extends e.Component {
                render() {
                    const { operation: t } = this.props, r = t.codeSamples, n = r.length > 0, o = 1 === r.length && this.context.hideSingleRequestSampleTab;
                    return n && e.createElement("div", null, e.createElement(vi, null, " ", _("requestSamples"), " "), e.createElement(Yi, {
                        defaultIndex: 0
                    }, e.createElement(Ji.TabList, {
                        hidden: o
                    }, r.map((t)=>e.createElement(Ji.Tab, {
                            key: t.lang + "_" + (t.label || "")
                        }, void 0 !== t.label ? t.label : t.lang))), r.map((t)=>e.createElement(Ji.TabPanel, {
                            key: t.lang + "_" + (t.label || "")
                        }, yo(t) ? e.createElement("div", null, e.createElement(Kp, {
                            content: t.requestBodyContent
                        })) : e.createElement(sa, {
                            lang: t.lang,
                            source: t.source
                        }))))) || null;
                }
            };
            uu.contextType = ce, uu = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], uu);
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let du = class extends e.Component {
                render() {
                    const { operation: t } = this.props, r = t.responses.filter((e)=>e.content && e.content.hasSample);
                    return r.length > 0 && e.createElement("div", null, e.createElement(vi, null, " ", _("responseSamples"), " "), e.createElement(Yi, {
                        defaultIndex: 0
                    }, e.createElement(Ji.TabList, null, r.map((t)=>e.createElement(Ji.Tab, {
                            className: "tab-" + t.type,
                            key: t.code
                        }, t.code))), r.map((t)=>e.createElement(Ji.TabPanel, {
                            key: t.code
                        }, e.createElement("div", null, e.createElement(Kp, {
                            content: t.content
                        })))))) || null;
                }
            };
            du = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], du);
            var hu = Object.defineProperty, mu = Object.getOwnPropertySymbols, fu = Object.prototype.hasOwnProperty, gu = Object.prototype.propertyIsEnumerable, yu = (e, t, r)=>t in e ? hu(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r;
            const bu = ee.div`
  margin-bottom: ${({ theme: e })=>6 * e.spacing.unit}px;
`, xu = (0, ba.observer)(({ operation: t })=>{
                const { name: r, description: n, deprecated: o, externalDocs: i, isWebhook: s, httpVerb: a, badges: l } = t, c = !(!n && !i), { showWebhookVerb: p } = e.useContext(ce), u = l.filter(({ position: e })=>"before" === e), d = l.filter(({ position: e })=>"after" === e), h = t.operationHash && t.operationHash !== t.id ? {
                    [ni]: t.operationHash,
                    id: t.operationHash
                } : {};
                return e.createElement(ce.Consumer, null, (l)=>e.createElement(mi, ((e, t)=>{
                        for(var r in t || (t = {}))fu.call(t, r) && yu(e, r, t[r]);
                        if (mu) for (var r of mu(t))gu.call(t, r) && yu(e, r, t[r]);
                        return e;
                    })({}, h), e.createElement(pi, null, e.createElement(bi, null, e.createElement(Ii, {
                        to: t.id
                    }), u.map(({ name: t, color: r })=>e.createElement(_i, {
                            type: "primary",
                            key: t,
                            color: r
                        }, t)), r, " ", o && e.createElement(_i, {
                        type: "warning"
                    }, " Deprecated "), s && e.createElement(_i, {
                        type: "primary"
                    }, " ", "Webhook ", p && a && "| " + a.toUpperCase()), d.map(({ name: t, color: r })=>e.createElement(_i, {
                            type: "primary",
                            key: t,
                            color: r
                        }, t))), l.pathInMiddlePanel && !s && e.createElement(np, {
                        operation: t,
                        inverted: !0
                    }), c && e.createElement(bu, null, void 0 !== n && e.createElement(Ms, {
                        source: n
                    }), i && e.createElement(Ra, {
                        externalDocs: i
                    })), e.createElement(Ma, {
                        extensions: t.extensions
                    }), e.createElement(Lp, {
                        securities: t.security
                    }), e.createElement(mp, {
                        parameters: t.parameters,
                        body: t.requestBody
                    }), e.createElement(Rp, {
                        responses: t.responses
                    }), e.createElement(Qp, {
                        callbacks: t.callbacks
                    })), e.createElement(hi, null, !l.pathInMiddlePanel && !s && e.createElement(np, {
                        operation: t
                    }), e.createElement(uu, {
                        operation: t
                    }), e.createElement(du, {
                        operation: t
                    }), e.createElement(cu, {
                        callbacks: t.callbacks
                    }))));
            });
            var vu = Object.defineProperty, wu = Object.getOwnPropertyDescriptor, ku = Object.getOwnPropertySymbols, Eu = Object.prototype.hasOwnProperty, Ou = Object.prototype.propertyIsEnumerable, ju = (e, t, r)=>t in e ? vu(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, $u = (e, t, r, n)=>{
                for(var o, i = n > 1 ? void 0 : n ? wu(t, r) : t, s = e.length - 1; s >= 0; s--)(o = e[s]) && (i = (n ? o(t, r, i) : o(i)) || i);
                return n && i && vu(t, r, i), i;
            };
            let Su = class extends e.Component {
                render() {
                    const t = this.props.items;
                    return 0 === t.length ? null : t.map((t)=>e.createElement(Cu, {
                            key: t.id,
                            item: t
                        }));
                }
            };
            Su = $u([
                ba.observer
            ], Su);
            let Cu = class extends e.Component {
                render() {
                    const t = this.props.item;
                    let r;
                    const { type: n } = t;
                    switch(n){
                        case "group":
                            r = null;
                            break;
                        case "tag":
                        case "section":
                        default:
                            r = e.createElement(Iu, ((e, t)=>{
                                for(var r in t || (t = {}))Eu.call(t, r) && ju(e, r, t[r]);
                                if (ku) for (var r of ku(t))Ou.call(t, r) && ju(e, r, t[r]);
                                return e;
                            })({}, this.props));
                            break;
                        case "operation":
                            r = e.createElement(Au, {
                                item: t
                            });
                    }
                    return e.createElement(e.Fragment, null, r && e.createElement(ui, {
                        id: t.id,
                        $underlined: "operation" === t.type
                    }, r), t.items && e.createElement(Su, {
                        items: t.items
                    }));
                }
            };
            Cu = $u([
                ba.observer
            ], Cu);
            const Pu = (t)=>e.createElement(pi, {
                    $compact: !0
                }, t);
            let Iu = class extends e.Component {
                render() {
                    const { name: t, description: r, externalDocs: n, level: o } = this.props.item, i = 2 === o ? xi : bi;
                    return e.createElement(e.Fragment, null, e.createElement(mi, null, e.createElement(pi, {
                        $compact: !1
                    }, e.createElement(i, null, e.createElement(Ii, {
                        to: this.props.item.id
                    }), t))), e.createElement(Rc, {
                        parentId: this.props.item.id,
                        source: r || "",
                        htmlWrap: Pu
                    }), n && e.createElement(mi, null, e.createElement(pi, null, e.createElement(Ra, {
                        externalDocs: n
                    }))));
                }
            };
            Iu = $u([
                ba.observer
            ], Iu);
            let Au = class extends e.Component {
                render() {
                    return e.createElement(xu, {
                        operation: this.props.item
                    });
                }
            };
            Au = $u([
                ba.observer
            ], Au);
            var Tu = Object.defineProperty, _u = Object.defineProperties, Ru = (Object.getOwnPropertyDescriptor, Object.getOwnPropertyDescriptors), Du = Object.getOwnPropertySymbols, zu = Object.prototype.hasOwnProperty, Lu = Object.prototype.propertyIsEnumerable, Nu = (e, t, r)=>t in e ? Tu(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r;
            let Mu = class extends e.Component {
                constructor(){
                    super(...arguments), this.ref = e.createRef(), this.activate = (e)=>{
                        this.props.onActivate(this.props.item), e.stopPropagation();
                    };
                }
                componentDidMount() {
                    this.scrollIntoViewIfActive();
                }
                componentDidUpdate() {
                    this.scrollIntoViewIfActive();
                }
                scrollIntoViewIfActive() {
                    this.props.item.active && this.ref.current && c(this.ref.current);
                }
                render() {
                    const { item: t, withoutChildren: r } = this.props;
                    var n;
                    return e.createElement(Mc, {
                        tabIndex: 0,
                        onClick: this.activate,
                        onKeyDown: (e)=>{
                            "Enter" !== e.key && " " !== e.key || (this.props.onActivate(this.props.item), e.stopPropagation());
                        },
                        depth: t.depth,
                        "data-item-id": t.id,
                        role: "menuitem",
                        "aria-label": t.sidebarLabel,
                        "aria-expanded": t.expanded
                    }, "operation" === t.type ? e.createElement(qu, (n = ((e, t)=>{
                        for(var r in t || (t = {}))zu.call(t, r) && Nu(e, r, t[r]);
                        if (Du) for (var r of Du(t))Lu.call(t, r) && Nu(e, r, t[r]);
                        return e;
                    })({}, this.props), _u(n, Ru({
                        item: t
                    })))) : e.createElement(Fc, {
                        $depth: t.depth,
                        $active: t.active,
                        $type: t.type,
                        ref: this.ref
                    }, "schema" === t.type && e.createElement(zc, {
                        type: "schema"
                    }, "schema"), e.createElement(Bc, {
                        width: "calc(100% - 38px)",
                        title: t.sidebarLabel
                    }, t.sidebarLabel, this.props.children), t.depth > 0 && t.items.length > 0 && e.createElement(Ti, {
                        float: "right",
                        direction: t.expanded ? "down" : "right"
                    }) || null), !r && t.items && t.items.length > 0 && e.createElement(Fu, {
                        expanded: t.expanded,
                        items: t.items,
                        onActivate: this.props.onActivate
                    }));
                }
            };
            Mu = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], Mu);
            const qu = (0, ba.observer)((t)=>{
                var r;
                const { item: n } = t, o = e.createRef(), { showWebhookVerb: i } = e.useContext(ce);
                return e.useEffect(()=>{
                    t.item.active && o.current && c(o.current);
                }, [
                    t.item.active,
                    o
                ]), e.createElement(Fc, {
                    $depth: n.depth,
                    $active: n.active,
                    $deprecated: n.deprecated,
                    ref: o
                }, n.badges && (null == (r = n.badges) ? void 0 : r.map(({ name: t, color: r })=>e.createElement(zc, {
                        type: "badge",
                        color: r,
                        key: t
                    }, t))), n.isWebhook ? e.createElement(zc, {
                    type: "hook"
                }, i ? n.httpVerb : _("webhook")) : e.createElement(zc, {
                    type: n.httpVerb
                }, yt(n.httpVerb)), e.createElement(Bc, {
                    tabIndex: 0,
                    width: "calc(100% - 38px)"
                }, n.sidebarLabel, t.children));
            });
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let Fu = class extends e.Component {
                render() {
                    const { items: t, className: r } = this.props, n = null == this.props.expanded || this.props.expanded;
                    return e.createElement(Nc, {
                        className: r,
                        style: this.props.style,
                        $expanded: n,
                        role: "menu"
                    }, t.map((t, r)=>e.createElement(Mu, {
                            key: r,
                            item: t,
                            onActivate: this.props.onActivate
                        })));
                }
            };
            function Bu() {
                const [t, r] = (0, e.useState)(!1);
                return (0, e.useEffect)(()=>{
                    r(!0);
                }, []), t ? e.createElement("img", {
                    alt: "redocly logo",
                    onError: ()=>r(!1),
                    src: "https://cdn.redoc.ly/redoc/logo-mini.svg"
                }) : null;
            }
            Fu = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], Fu);
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let Qu = class extends e.Component {
                constructor(){
                    super(...arguments), this.activate = (e)=>{
                        if (e && e.active && this.context.menuToggle) return e.expanded ? e.collapse() : e.expand();
                        this.props.menu.activateAndScroll(e, !0), setTimeout(()=>{
                            this._updateScroll && this._updateScroll();
                        });
                    }, this.saveScrollUpdate = (e)=>{
                        this._updateScroll = e;
                    };
                }
                render() {
                    const t = this.props.menu;
                    return e.createElement(ds, {
                        updateFn: this.saveScrollUpdate,
                        className: this.props.className,
                        options: {
                            wheelPropagation: !1
                        }
                    }, e.createElement(Fu, {
                        items: t.items,
                        onActivate: this.activate,
                        root: !0
                    }), e.createElement(Qc, null, e.createElement("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: "https://redocly.com/redoc/"
                    }, e.createElement(Bu, null), "API docs by Redocly")));
                }
            };
            Qu.contextType = ce, Qu = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], Qu);
            const Uu = ({ open: t })=>{
                const r = t ? 8 : -4;
                return e.createElement(Vu, null, e.createElement(Wu, {
                    size: 15,
                    style: {
                        transform: `translate(2px, ${r}px) rotate(180deg)`,
                        transition: "transform 0.2s ease"
                    }
                }), e.createElement(Wu, {
                    size: 15,
                    style: {
                        transform: `translate(2px, ${0 - r}px)`,
                        transition: "transform 0.2s ease"
                    }
                }));
            }, Wu = ({ size: t = 10, className: r = "", style: n })=>e.createElement("svg", {
                    className: r,
                    style: n || {},
                    viewBox: "0 0 926.23699 573.74994",
                    version: "1.1",
                    x: "0px",
                    y: "0px",
                    width: t,
                    height: t
                }, e.createElement("g", {
                    transform: "translate(904.92214,-879.1482)"
                }, e.createElement("path", {
                    d: "\n          m -673.67664,1221.6502 -231.2455,-231.24803 55.6165,\n          -55.627 c 30.5891,-30.59485 56.1806,-55.627 56.8701,-55.627 0.6894,\n          0 79.8637,78.60862 175.9427,174.68583 l 174.6892,174.6858 174.6892,\n          -174.6858 c 96.079,-96.07721 175.253196,-174.68583 175.942696,\n          -174.68583 0.6895,0 26.281,25.03215 56.8701,\n          55.627 l 55.6165,55.627 -231.245496,231.24803 c -127.185,127.1864\n          -231.5279,231.248 -231.873,231.248 -0.3451,0 -104.688,\n          -104.0616 -231.873,-231.248 z\n        ",
                    fill: "currentColor"
                }))), Vu = ee.div`
  user-select: none;
  width: 20px;
  height: 20px;
  align-self: center;
  display: flex;
  flex-direction: column;
  color: ${(e)=>e.theme.colors.primary.main};
`;
            Object.defineProperty, Object.getOwnPropertyDescriptor;
            let Hu;
            s && (Hu = r(230));
            const Ju = Hu && Hu(), Yu = ee.div`
  width: ${(e)=>e.theme.sidebar.width};
  background-color: ${(e)=>e.theme.sidebar.backgroundColor};
  overflow: hidden;
  display: flex;
  flex-direction: column;

  backface-visibility: hidden;
  /* contain: strict; TODO: breaks layout since Chrome 80*/

  height: 100vh;
  position: sticky;
  position: -webkit-sticky;
  top: 0;

  ${K.lessThan("small")`
    position: fixed;
    z-index: 20;
    width: 100%;
    background: ${({ theme: e })=>e.sidebar.backgroundColor};
    display: ${(e)=>e.$open ? "flex" : "none"};
  `};

  @media print {
    display: none;
  }
`, Gu = ee.div`
  outline: none;
  user-select: none;
  background-color: ${({ theme: e })=>e.fab.backgroundColor};
  color: ${(e)=>e.theme.colors.primary.main};
  display: none;
  cursor: pointer;
  position: fixed;
  right: 20px;
  z-index: 100;
  border-radius: 50%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  ${K.lessThan("small")`
    display: flex;
  `};

  bottom: 44px;

  width: 60px;
  height: 60px;
  padding: 0 20px;
  svg {
    color: ${({ theme: e })=>e.fab.color};
  }

  @media print {
    display: none;
  }
`;
            let Zu = class extends e.Component {
                constructor(){
                    super(...arguments), this.state = {
                        offsetTop: "0px"
                    }, this.toggleNavMenu = ()=>{
                        this.props.menu.toggleSidebar();
                    };
                }
                componentDidMount() {
                    Ju && Ju.add(this.stickyElement), this.setState({
                        offsetTop: this.getScrollYOffset(this.context)
                    });
                }
                componentWillUnmount() {
                    Ju && Ju.remove(this.stickyElement);
                }
                getScrollYOffset(e) {
                    let t;
                    return t = void 0 !== this.props.scrollYOffset ? W.normalizeScrollYOffset(this.props.scrollYOffset)() : e.scrollYOffset(), t + "px";
                }
                render() {
                    const t = this.props.menu.sideBarOpened, r = this.state.offsetTop;
                    return e.createElement(e.Fragment, null, e.createElement(Yu, {
                        $open: t,
                        className: this.props.className,
                        style: {
                            top: r,
                            height: `calc(100vh - ${r})`
                        },
                        ref: (e)=>{
                            this.stickyElement = e;
                        }
                    }, this.props.children), !this.context.hideFab && e.createElement(Gu, {
                        onClick: this.toggleNavMenu
                    }, e.createElement(Uu, {
                        open: t
                    })));
                }
            };
            Zu.contextType = ce, Zu = ((e, t)=>{
                for(var r, n = t, o = e.length - 1; o >= 0; o--)(r = e[o]) && (n = r(n) || n);
                return n;
            })([
                ba.observer
            ], Zu);
            const Xu = ee.div`
  ${({ theme: e })=>`\n  font-family: ${e.typography.fontFamily};\n  font-size: ${e.typography.fontSize};\n  font-weight: ${e.typography.fontWeightRegular};\n  line-height: ${e.typography.lineHeight};\n  color: ${e.colors.text.primary};\n  display: flex;\n  position: relative;\n  text-align: left;\n\n  -webkit-font-smoothing: ${e.typography.smoothing};\n  font-smoothing: ${e.typography.smoothing};\n  ${e.typography.optimizeSpeed ? "text-rendering: optimizeSpeed !important" : ""};\n\n  tap-highlight-color: rgba(0, 0, 0, 0);\n  text-size-adjust: 100%;\n\n  * {\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n  }\n`};
`, Ku = ee.div`
  z-index: 1;
  position: relative;
  overflow: hidden;
  width: calc(100% - ${(e)=>e.theme.sidebar.width});
  ${K.lessThan("small", !0)`
    width: 100%;
  `};

  contain: layout;
`, ed = ee.div`
  background: ${({ theme: e })=>e.rightPanel.backgroundColor};
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: ${({ theme: e })=>{
                if (e.rightPanel.width.endsWith("%")) {
                    const t = parseInt(e.rightPanel.width, 10);
                    return `calc((100% - ${e.sidebar.width}) * ${t / 100})`;
                }
                return e.rightPanel.width;
            }};
  ${K.lessThan("medium", !0)`
    display: none;
  `};
`, td = ee.div`
  padding: 5px 0;
`, rd = ee.input.attrs(()=>({
                    className: "search-input"
                }))`
  width: calc(100% - ${(e)=>8 * e.theme.spacing.unit}px);
  box-sizing: border-box;
  margin: 0 ${(e)=>4 * e.theme.spacing.unit}px;
  padding: 5px ${(e)=>2 * e.theme.spacing.unit}px 5px
    ${(e)=>4 * e.theme.spacing.unit}px;
  border: 0;
  border-bottom: 1px solid
    ${({ theme: e })=>((0, t.getLuminance)(e.sidebar.backgroundColor) > .5 ? t.darken : t.lighten)(.1, e.sidebar.backgroundColor)};
  font-family: ${({ theme: e })=>e.typography.fontFamily};
  font-weight: bold;
  font-size: 13px;
  color: ${(e)=>e.theme.sidebar.textColor};
  background-color: transparent;
  outline: none;
`, nd = ee((t)=>e.createElement("svg", {
                    className: t.className,
                    version: "1.1",
                    viewBox: "0 0 1000 1000",
                    x: "0px",
                    xmlns: "http://www.w3.org/2000/svg",
                    y: "0px"
                }, e.createElement("path", {
                    d: "M968.2,849.4L667.3,549c83.9-136.5,66.7-317.4-51.7-435.6C477.1-25,252.5-25,113.9,113.4c-138.5,138.3-138.5,362.6,0,501C219.2,730.1,413.2,743,547.6,666.5l301.9,301.4c43.6,43.6,76.9,14.9,104.2-12.4C981,928.3,1011.8,893,968.2,849.4z M524.5,522c-88.9,88.7-233,88.7-321.8,0c-88.9-88.7-88.9-232.6,0-321.3c88.9-88.7,233-88.7,321.8,0C613.4,289.4,613.4,433.3,524.5,522z"
                }))).attrs({
                className: "search-icon"
            })`
  position: absolute;
  left: ${(e)=>4 * e.theme.spacing.unit}px;
  height: 1.8em;
  width: 0.9em;

  path {
    fill: ${(e)=>e.theme.sidebar.textColor};
  }
`, od = ee.div`
  padding: ${(e)=>e.theme.spacing.unit}px 0;
  background-color: ${({ theme: e })=>(0, t.darken)(.05, e.sidebar.backgroundColor)}};
  color: ${(e)=>e.theme.sidebar.textColor};
  min-height: 150px;
  max-height: 250px;
  border-top: ${({ theme: e })=>(0, t.darken)(.1, e.sidebar.backgroundColor)}};
  border-bottom: ${({ theme: e })=>(0, t.darken)(.1, e.sidebar.backgroundColor)}};
  margin: 10px 0 0;
  line-height: 1.4;
  font-size: 0.9em;
  list-style: none;

  li {
    background-color: inherit;
  }

  ${Fc} {
    padding-top: 6px;
    padding-bottom: 6px;

    &:hover,
    &.active {
      background-color: ${({ theme: e })=>(0, t.darken)(.1, e.sidebar.backgroundColor)};
    }

    > svg {
      display: none;
    }
  }
`, id = ee.i`
  position: absolute;
  display: inline-block;
  width: ${(e)=>2 * e.theme.spacing.unit}px;
  text-align: center;
  right: ${(e)=>4 * e.theme.spacing.unit}px;
  line-height: 2em;
  vertical-align: middle;
  margin-right: 2px;
  cursor: pointer;
  font-style: normal;
  color: '#666';
`;
            var sd = Object.defineProperty, ad = Object.getOwnPropertyDescriptor;
            class ld extends e.PureComponent {
                constructor(e){
                    super(e), this.activeItemRef = null, this.clear = ()=>{
                        this.setState({
                            results: [],
                            noResults: !1,
                            term: "",
                            activeItemIdx: -1
                        }), this.props.marker.unmark();
                    }, this.handleKeyDown = (e)=>{
                        if (27 === e.keyCode && this.clear(), 40 === e.keyCode && (this.setState({
                            activeItemIdx: Math.min(this.state.activeItemIdx + 1, this.state.results.length - 1)
                        }), e.preventDefault()), 38 === e.keyCode && (this.setState({
                            activeItemIdx: Math.max(0, this.state.activeItemIdx - 1)
                        }), e.preventDefault()), 13 === e.keyCode) {
                            const e = this.state.results[this.state.activeItemIdx];
                            if (e) {
                                const t = this.props.getItemById(e.meta);
                                t && this.props.onActivate(t);
                            }
                        }
                    }, this.search = (e)=>{
                        const { minCharacterLengthToInitSearch: t } = this.context, r = e.target.value;
                        r.length < t ? this.clearResults(r) : this.setState({
                            term: r
                        }, ()=>this.searchCallback(this.state.term));
                    }, this.state = {
                        results: [],
                        noResults: !1,
                        term: "",
                        activeItemIdx: -1
                    };
                }
                clearResults(e) {
                    this.setState({
                        results: [],
                        noResults: !1,
                        term: e
                    }), this.props.marker.unmark();
                }
                setResults(e, t) {
                    this.setState({
                        results: e,
                        noResults: 0 === e.length
                    }), this.props.marker.mark(t);
                }
                searchCallback(e) {
                    this.props.search.search(e).then((t)=>{
                        this.setResults(t, e);
                    });
                }
                render() {
                    const { activeItemIdx: t } = this.state, r = this.state.results.filter((e)=>this.props.getItemById(e.meta)).map((e)=>({
                            item: this.props.getItemById(e.meta),
                            score: e.score
                        })).sort((e, t)=>t.score - e.score);
                    return e.createElement(td, {
                        role: "search"
                    }, this.state.term && e.createElement(id, {
                        onClick: this.clear
                    }, "\xd7"), e.createElement(nd, null), e.createElement(rd, {
                        value: this.state.term,
                        onKeyDown: this.handleKeyDown,
                        placeholder: "Search...",
                        "aria-label": "Search",
                        type: "text",
                        onChange: this.search
                    }), r.length > 0 && e.createElement(ds, {
                        options: {
                            wheelPropagation: !1
                        }
                    }, e.createElement(od, {
                        as: "ul",
                        role: "menu",
                        "data-role": "search:results"
                    }, r.map((r, n)=>e.createElement(Mu, {
                            item: Object.create(r.item, {
                                active: {
                                    value: n === t
                                }
                            }),
                            onActivate: this.props.onActivate,
                            withoutChildren: !0,
                            key: r.item.id,
                            "data-role": "search:result"
                        })))), this.state.term && this.state.noResults ? e.createElement(od, {
                        "data-role": "search:results"
                    }, _("noResultsFound")) : null);
                }
            }
            ld.contextType = ce, ((e, t, r)=>{
                for(var n, o = ad(t, r), i = e.length - 1; i >= 0; i--)(n = e[i]) && (o = n(t, r, o) || o);
                o && sd(t, r, o);
            })([
                xe.bind,
                (0, xe.debounce)(400)
            ], ld.prototype, "searchCallback");
            class cd extends e.Component {
                componentDidMount() {
                    this.props.store.onDidMount();
                }
                componentWillUnmount() {
                    this.props.store.dispose();
                }
                render() {
                    const { store: { spec: t, menu: r, options: n, search: o, marker: i } } = this.props, s = this.props.store;
                    return e.createElement(X, {
                        theme: n.theme
                    }, e.createElement(Oi, {
                        value: s
                    }, e.createElement(pe, {
                        value: n
                    }, e.createElement(Xu, {
                        className: "redoc-wrap"
                    }, e.createElement(Zu, {
                        menu: r,
                        className: "menu-content"
                    }, e.createElement(Sc, {
                        info: t.info
                    }), !n.disableSearch && e.createElement(ld, {
                        search: o,
                        marker: i,
                        getItemById: r.getItemById,
                        onActivate: r.activateAndScroll
                    }) || null, e.createElement(Qu, {
                        menu: r
                    })), e.createElement(Ku, {
                        className: "api-content"
                    }, e.createElement(Ec, {
                        store: s
                    }), e.createElement(Su, {
                        items: r.items
                    })), e.createElement(ed, null)))));
                }
            }
            cd.propTypes = {
                store: le.instanceOf(gc).isRequired
            };
            var pd = Object.defineProperty, ud = Object.getOwnPropertySymbols, dd = Object.prototype.hasOwnProperty, hd = Object.prototype.propertyIsEnumerable, md = (e, t, r)=>t in e ? pd(e, t, {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: r
                }) : e[t] = r, fd = (e, t)=>{
                for(var r in t || (t = {}))dd.call(t, r) && md(e, r, t[r]);
                if (ud) for (var r of ud(t))hd.call(t, r) && md(e, r, t[r]);
                return e;
            };
            const gd = function(t) {
                const { spec: n, specUrl: o, options: i = {}, onLoaded: s } = t, a = Q(i.hideLoading, !1), l = new W(i);
                if (void 0 !== l.nonce) try {
                    r.nc = l.nonce;
                } catch (e) {}
                return e.createElement(ne, null, e.createElement($i, {
                    spec: n ? fd({}, n) : void 0,
                    specUrl: o,
                    options: i,
                    onLoaded: s
                }, ({ loading: t, store: r })=>t ? a ? null : e.createElement(ae, {
                        color: l.theme.colors.primary.main
                    }) : e.createElement(cd, {
                        store: r
                    })));
            };
        }(), n;
    }();
});


const $b7a0146a50c23ba7$export$257224358692d0e0 = [
    {
        url: 'https://docs.dashboard-api.dev.eonhome.eu/swagger.json',
        name: 'Dashboard API (DEV)'
    },
    {
        url: 'https://docs.dashboard-api.qa.eonhome.eu/swagger.json',
        name: 'Dashboard API (QA)'
    },
    {
        url: 'https://docs.dashboard-api.qa.eonhome.eu/swagger.json',
        name: 'Dashboard API (PROD)'
    },
    {
        url: 'https://docs.sse-api.dev.eonhome.eu/swagger.json',
        name: 'SSE API (DEV)'
    },
    {
        url: 'https://docs.sse-api.qa.eonhome.eu/swagger.json',
        name: 'SSE API (QA)'
    },
    {
        url: 'https://docs.sse-api.qa.eonhome.eu/swagger.json',
        name: 'SSE API (PROD)'
    },
    {
        url: 'https://docs.admin-api.dev.eonhome.eu/swagger.json',
        name: 'Admin API (DEV)'
    },
    {
        url: 'https://docs.admin-api.qa.eonhome.eu/swagger.json',
        name: 'Admin API (QA)'
    },
    {
        url: 'https://docs.admin-api.qa.eonhome.eu/swagger.json',
        name: 'Admin API (PROD)'
    }
];


const $a676e5add8ccb9f2$var$App = ()=>{
    const [spec, setSpec] = $acw62.useState({});
    const [index, setIndex] = $acw62.useState(0);
    const [loading, setLoading] = $acw62.useState(true);
    $acw62.useEffect(()=>{
        setLoading(true);
        fetch(`/api/data?index=${index}`).then((r)=>r.text()).then((data)=>{
            if (data.startsWith('<')) return;
            setSpec(JSON.parse(data.replace('/docs/Eon.png', 'https://app.home.eon.com/brand/assets/icons/logo.svg')));
        }).finally(()=>setLoading(false));
    }, [
        index
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
                onChange: (e)=>setIndex(Number(e.target.value)),
                defaultValue: index,
                className: "spec-select",
                children: (0, $b7a0146a50c23ba7$export$257224358692d0e0).map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                        value: index,
                        children: option.name
                    }, index))
            }),
            loading ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21e9d612693fb6b8$exports.RedocStandalone), {
                spec: spec
            })
        ]
    });
};
const $a676e5add8ccb9f2$var$root = (0, $7e96a608cb33bf79$exports.createRoot)(document.getElementById('root') || document.createElement('div'));
$a676e5add8ccb9f2$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a676e5add8ccb9f2$var$App, {}));


//# sourceMappingURL=app.f8d24db9.js.map
